/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 596);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(605);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(615)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export propTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return propTypes; });
/* unused harmony export onError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return observer; });
/* unused harmony export Observer */
/* unused harmony export renderReporter */
/* unused harmony export componentByNodeRegistery */
/* unused harmony export componentByNodeRegistry */
/* unused harmony export trackComponents */
/* unused harmony export useStaticRendering */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
    module.exports = factory();
}(commonjsGlobal, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableObject"];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableMap"];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

var mobxAdminProperty = __WEBPACK_IMPORTED_MODULE_0_mobx__["$mobx"] || "$mobx";

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function createSymbol(name) {
    if (typeof Symbol === "function") {
        return Symbol(name);
    }
    return "$mobxReactProp$" + name + Math.random();
}

var skipRenderKey = createSymbol("skipRender");
var isForcingUpdateKey = createSymbol("isForcingUpdate");

/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */
function setHiddenProp(target, prop, value) {
    if (!Object.hasOwnProperty(target, prop)) {
        Object.defineProperty(target, prop, {
            enumerable: false,
            configurable: true,
            writeable: true,
            value: value
        });
    } else {
        target[prop] = value;
    }
}

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

function makeComponentReactive(render) {
    var _this2 = this;

    if (isUsingStaticRendering === true) return render.call(this);

    function reactiveRender() {
        var _this = this;

        isRenderingPending = false;
        var exception = undefined;
        var rendering = undefined;
        reaction.track(function () {
            if (isDevtoolsEnabled) {
                _this.__$mobRenderStart = Date.now();
            }
            try {
                rendering = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["_allowStateChanges"])(false, baseRender);
            } catch (e) {
                exception = e;
            }
            if (isDevtoolsEnabled) {
                _this.__$mobRenderEnd = Date.now();
            }
        });
        if (exception) {
            errorsReporter.emit(exception);
            throw exception;
        }
        return rendering;
    }

    // Generate friendly name for debugging
    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
    /**
     * If props are shallowly modified, react will render anyway,
     * so atom.reportChanged() should not result in yet another re-render
     */
    setHiddenProp(this, skipRenderKey, false);
    /**
     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
     * so detect these changes
     */
    setHiddenProp(this, isForcingUpdateKey, false);

    // wire up reactive render
    var baseRender = render.bind(this);
    var isRenderingPending = false;

    var reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Reaction"](initialName + "#" + rootNodeID + ".render()", function () {
        if (!isRenderingPending) {
            // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
            // This unidiomatic React usage but React will correctly warn about this so we continue as usual
            // See #85 / Pull #44
            isRenderingPending = true;
            if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?
            if (_this2.__$mobxIsUnmounted !== true) {
                // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                // However, people also claim this migth happen during unit tests..
                var hasError = true;
                try {
                    setHiddenProp(_this2, isForcingUpdateKey, true);
                    if (!_this2[skipRenderKey]) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this2);
                    hasError = false;
                } finally {
                    setHiddenProp(_this2, isForcingUpdateKey, false);
                    if (hasError) reaction.dispose();
                }
            }
        }
    });
    reaction.reactComponent = this;
    reactiveRender[mobxAdminProperty] = reaction;
    this.render = reactiveRender;
    return reactiveRender.call(this);
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistry) {
                componentByNodeRegistry.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }
};

function makeObservableProp(target, propName) {
    var valueHolderKey = createSymbol(propName + " value holder");
    var atomHolderKey = createSymbol(propName + " atom holder");
    function getAtom() {
        if (!this[atomHolderKey]) {
            setHiddenProp(this, atomHolderKey, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["createAtom"])("reactive " + propName));
        }
        return this[atomHolderKey];
    }
    Object.defineProperty(target, propName, {
        configurable: true,
        enumerable: true,
        get: function get$$1() {
            getAtom.call(this).reportObserved();
            return this[valueHolderKey];
        },
        set: function set$$1(v) {
            if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
                setHiddenProp(this, valueHolderKey, v);
                setHiddenProp(this, skipRenderKey, true);
                getAtom.call(this).reportChanged();
                setHiddenProp(this, skipRenderKey, false);
            } else {
                setHiddenProp(this, valueHolderKey, v);
            }
        }
    });
}

/**
 * Observer function / decorator
 */
function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // TODO: remove in next major
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }
    if (componentClass.__proto__ === __WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]) {
        console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        var observerComponent = observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
        hoistNonReactStatics(observerComponent, componentClass);
        return observerComponent;
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    makeObservableProp(target, "props");
    makeObservableProp(target, "state");
    var baseRender = target.render;
    target.render = function () {
        return makeComponentReactive.call(this, baseRender);
    };
    return componentClass;
}

function mixinLifecycleEvents(target) {
    ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    } else {
        if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
            // TODO: make throw in next major
            console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
        }
    }
}

var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    // TODO: remove in next major
    console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
    var InjectComponent = inject(observerInject)(component);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(nextProps, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component$$1;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component$$1.displayName || Component$$1.name;
    var newApiName =
      typeof Component$$1.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component$$1;
}

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider(props, context) {
        classCallCheck(this, Provider);

        var _this = possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props, context));

        _this.state = props || {};
        return _this;
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.state) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (!nextProps) return null;
            if (!prevState) return nextProps;

            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(prevState).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }return nextProps;
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

// TODO: kill in next major

polyfill(Provider);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["spy"]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["configure"])({ reactionScheduler: __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] });else if (typeof unstable_batchedUpdates$1 === "function") Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["configure"])({ reactionScheduler: unstable_batchedUpdates$1 });

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["spy"], extras: { getDebugName: __WEBPACK_IMPORTED_MODULE_0_mobx__["getDebugName"] } };
    var mobxReact = {
        renderReporter: renderReporter,
        componentByNodeRegistry: componentByNodeRegistry,
        componentByNodeRegistery: componentByNodeRegistry,
        trackComponents: trackComponents
    };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modelOf; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainableTypeChecker__ = __webpack_require__(701);
function createModelOfTypeChecker(type){function validate(props,propName,componentName,location,propFullName){// Check based on https://github.com/mobxjs/mobx-state-tree/issues/365#issuecomment-327385021
if(!Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["j" /* isStateTreeNode */])(props[propName])||!type.is||!type.is(props[propName])){return new Error('Invalid '+location+' "'+propFullName+'" of type "'+type+'" supplied to "'+componentName+'", expected MST model of type "'+type.name+'".');}return null;}return Object(__WEBPACK_IMPORTED_MODULE_1__createChainableTypeChecker__["a" /* default */])(validate);}var modelOf=createModelOfTypeChecker;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return types; });
/* unused harmony export typecheck */
/* unused harmony export escapeJsonPath */
/* unused harmony export unescapeJsonPath */
/* unused harmony export joinJsonPath */
/* unused harmony export splitJsonPath */
/* unused harmony export decorate */
/* unused harmony export addMiddleware */
/* unused harmony export process */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isStateTreeNode$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flow; });
/* unused harmony export applyAction */
/* unused harmony export onAction */
/* unused harmony export recordActions */
/* unused harmony export createActionTrackingMiddleware */
/* unused harmony export setLivelynessChecking */
/* unused harmony export TypeFlags */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getType$$1; });
/* unused harmony export getChildType */
/* unused harmony export onPatch */
/* unused harmony export onSnapshot */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyPatch$$1; });
/* unused harmony export recordPatches */
/* unused harmony export protect */
/* unused harmony export unprotect */
/* unused harmony export isProtected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return applySnapshot$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSnapshot$$1; });
/* unused harmony export hasParent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getParent$$1; });
/* unused harmony export hasParentOfType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getParentOfType$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getRoot$$1; });
/* unused harmony export getPath */
/* unused harmony export getPathParts */
/* unused harmony export isRoot */
/* unused harmony export resolvePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resolveIdentifier$$1; });
/* unused harmony export getIdentifier */
/* unused harmony export tryResolve */
/* unused harmony export getRelativePath */
/* unused harmony export clone */
/* unused harmony export detach */
/* unused harmony export destroy */
/* unused harmony export isAlive */
/* unused harmony export addDisposer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getEnv$$1; });
/* unused harmony export walk */
/* unused harmony export getMembers */
/* unused harmony export cast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(59);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

/**
 * Returns the _actual_ type of the given tree node. (Or throws)
 *
 * @export
 * @param {IStateTreeNode} object
 * @returns {IAnyType}
 */
function getType$$1(object) {
    return getStateTreeNode$$1(object).type;
}
/**
 * Returns the _declared_ type of the given sub property of an object, array or map.
 *
 * @example
 * const Box = types.model({ x: 0, y: 0 })
 * const box = Box.create()
 *
 * console.log(getChildType(box, "x").name) // 'number'
 *
 * @export
 * @param {IStateTreeNode} object
 * @param {string} child
 * @returns {IAnyType}
 */
function getChildType$$1(object, child) {
    return getStateTreeNode$$1(object).getChildType(child);
}
/**
 * Registers a function that will be invoked for each mutation that is applied to the provided model instance, or to any of its children.
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details. onPatch events are emitted immediately and will not await the end of a transaction.
 * Patches can be used to deep observe a model tree.
 *
 * @export
 * @param {Object} target the model instance from which to receive patches
 * @param {(patch: IJsonPatch, reversePatch) => void} callback the callback that is invoked for each patch. The reversePatch is a patch that would actually undo the emitted patch
 * @returns {IDisposer} function to remove the listener
 */
function onPatch$$1(target, callback) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof callback !== "function")
            fail("expected second argument to be a function, got " + callback + " instead");
    }
    return getStateTreeNode$$1(target).onPatch(callback);
}
/**
 * Registers a function that is invoked whenever a new snapshot for the given model instance is available.
 * The listener will only be fire at the and of the current MobX (trans)action.
 * See [snapshots](https://github.com/mobxjs/mobx-state-tree#snapshots) for more details.
 *
 * @export
 * @param {Object} target
 * @param {(snapshot: any) => void} callback
 * @returns {IDisposer}
 */
function onSnapshot$$1(target, callback) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof callback !== "function")
            fail("expected second argument to be a function, got " + callback + " instead");
    }
    return getStateTreeNode$$1(target).onSnapshot(callback);
}
/**
 * Applies a JSON-patch to the given model instance or bails out if the patch couldn't be applied
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details.
 *
 * Can apply a single past, or an array of patches.
 *
 * @export
 * @param {Object} target
 * @param {IJsonPatch} patch
 * @returns
 */
function applyPatch$$1(target, patch) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof patch !== "object")
            fail("expected second argument to be an object or array, got " + patch + " instead");
    }
    getStateTreeNode$$1(target).applyPatches(asArray(patch));
}
/**
 * Small abstraction around `onPatch` and `applyPatch`, attaches a patch listener to a tree and records all the patches.
 * Returns an recorder object with the following signature:
 *
 * @example
 * export interface IPatchRecorder {
 *      // the recorded patches
 *      patches: IJsonPatch[]
 *      // the inverse of the recorded patches
 *      inversePatches: IJsonPatch[]
 *      // stop recording patches
 *      stop(target?: IStateTreeNode): any
 *      // resume recording patches
 *      resume()
 *      // apply all the recorded patches on the given target (the original subject if omitted)
 *      replay(target?: IStateTreeNode): any
 *      // reverse apply the recorded patches on the given target  (the original subject if omitted)
 *      // stops the recorder if not already stopped
 *      undo(): void
 * }
 *
 * @export
 * @param {IStateTreeNode} subject
 * @returns {IPatchRecorder}
 */
function recordPatches$$1(subject) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(subject))
            fail("expected first argument to be a mobx-state-tree node, got " + subject + " instead");
    }
    var disposer = null;
    function resume() {
        if (disposer)
            return;
        disposer = onPatch$$1(subject, function (patch, inversePatch) {
            recorder.rawPatches.push([patch, inversePatch]);
        });
    }
    var recorder = {
        rawPatches: [],
        get patches() {
            return this.rawPatches.map(function (_a) {
                var a = _a[0];
                return a;
            });
        },
        get inversePatches() {
            return this.rawPatches.map(function (_a) {
                var _ = _a[0], b = _a[1];
                return b;
            });
        },
        stop: function () {
            if (disposer)
                disposer();
            disposer = null;
        },
        resume: resume,
        replay: function (target) {
            applyPatch$$1(target || subject, recorder.patches);
        },
        undo: function (target) {
            applyPatch$$1(target || subject, recorder.inversePatches.slice().reverse());
        }
    };
    resume();
    return recorder;
}
/**
 * The inverse of `unprotect`
 *
 * @export
 * @param {IStateTreeNode} target
 *
 */
function protect$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    if (!node.isRoot)
        fail("`protect` can only be invoked on root nodes");
    node.isProtectionEnabled = true;
}
/**
 * By default it is not allowed to directly modify a model. Models can only be modified through actions.
 * However, in some cases you don't care about the advantages (like replayability, traceability, etc) this yields.
 * For example because you are building a PoC or don't have any middleware attached to your tree.
 *
 * In that case you can disable this protection by calling `unprotect` on the root of your tree.
 *
 * @example
 * const Todo = types.model({
 *     done: false
 * }).actions(self => ({
 *     toggle() {
 *         self.done = !self.done
 *     }
 * }))
 *
 * const todo = Todo.create()
 * todo.done = true // throws!
 * todo.toggle() // OK
 * unprotect(todo)
 * todo.done = false // OK
 */
function unprotect$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    if (!node.isRoot)
        fail("`unprotect` can only be invoked on root nodes");
    node.isProtectionEnabled = false;
}
/**
 * Returns true if the object is in protected mode, @see protect
 */
function isProtected$$1(target) {
    return getStateTreeNode$$1(target).isProtected;
}
/**
 * Applies a snapshot to a given model instances. Patch and snapshot listeners will be invoked as usual.
 *
 * @export
 * @param {Object} target
 * @param {Object} snapshot
 * @returns
 */
function applySnapshot$$1(target, snapshot) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).applySnapshot(snapshot);
}
/**
 * Calculates a snapshot from the given model instance. The snapshot will always reflect the latest state but use
 * structural sharing where possible. Doesn't require MobX transactions to be completed.
 *
 * @export
 * @param {Object} target
 * @param {boolean} applyPostProcess = true, by default the postProcessSnapshot gets applied
 * @returns {*}
 */
function getSnapshot$$1(target, applyPostProcess) {
    if (applyPostProcess === void 0) { applyPostProcess = true; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    if (applyPostProcess)
        return node.snapshot;
    return freeze(node.type.getSnapshot(node, false));
}
/**
 * Given a model instance, returns `true` if the object has a parent, that is, is part of another object, map or array
 *
 * @export
 * @param {Object} target
 * @param {number} depth = 1, how far should we look upward?
 * @returns {boolean}
 */
function hasParent$$1(target, depth) {
    if (depth === void 0) { depth = 1; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof depth !== "number")
            fail("expected second argument to be a number, got " + depth + " instead");
        if (depth < 0)
            fail("Invalid depth: " + depth + ", should be >= 1");
    }
    var parent = getStateTreeNode$$1(target).parent;
    while (parent) {
        if (--depth === 0)
            return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the immediate parent of this object, or throws.
 *
 * Note that the immediate parent can be either an object, map or array, and
 * doesn't necessarily refer to the parent model
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 *
 * @export
 * @param {Object} target
 * @param {number} depth = 1, how far should we look upward?
 * @returns {*}
 */
function getParent$$1(target, depth) {
    if (depth === void 0) { depth = 1; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof depth !== "number")
            fail("expected second argument to be a number, got " + depth + " instead");
        if (depth < 0)
            fail("Invalid depth: " + depth + ", should be >= 1");
    }
    var d = depth;
    var parent = getStateTreeNode$$1(target).parent;
    while (parent) {
        if (--d === 0)
            return parent.storedValue;
        parent = parent.parent;
    }
    return fail("Failed to find the parent of " + getStateTreeNode$$1(target) + " at depth " + depth);
}
/**
 * Given a model instance, returns `true` if the object has a parent of given type, that is, is part of another object, map or array
 *
 * @export
 * @param {Object} target
 * @param {IAnyType} type
 * @returns {boolean}
 */
function hasParentOfType$$1(target, type) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (!isType$$1(type))
            fail("expected second argument to be a mobx-state-tree type, got " + type + " instead");
    }
    var parent = getStateTreeNode$$1(target).parent;
    while (parent) {
        if (type.is(parent.storedValue))
            return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the target's parent of a given type, or throws.
 *
 *
 * @export
 * @param {IStateTreeNode} target
 * @param {IType<any, any, T>} type
 * @returns {T}
 */
function getParentOfType$$1(target, type) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (!isType$$1(type))
            fail("expected second argument to be a mobx-state-tree type, got " + type + " instead");
    }
    var parent = getStateTreeNode$$1(target).parent;
    while (parent) {
        if (type.is(parent.storedValue))
            return parent.storedValue;
        parent = parent.parent;
    }
    return fail("Failed to find the parent of " + getStateTreeNode$$1(target) + " of a given type");
}
/**
 * Given an object in a model tree, returns the root object of that tree
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 * @export
 * @param {Object} target
 * @returns {*}
 */
function getRoot$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).root.storedValue;
}
/**
 * Returns the path of the given object in the model tree
 *
 * @export
 * @param {Object} target
 * @returns {string}
 */
function getPath$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).path;
}
/**
 * Returns the path of the given object as unescaped string array
 *
 * @export
 * @param {Object} target
 * @returns {string[]}
 */
function getPathParts$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return splitJsonPath$$1(getStateTreeNode$$1(target).path);
}
/**
 * Returns true if the given object is the root of a model tree
 *
 * @export
 * @param {Object} target
 * @returns {boolean}
 */
function isRoot$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).isRoot;
}
/**
 * Resolves a path relatively to a given object.
 * Returns undefined if no value can be found.
 *
 * @export
 * @param {Object} target
 * @param {string} path - escaped json path
 * @returns {*}
 */
function resolvePath$$1(target, path) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof path !== "string")
            fail("expected second argument to be a number, got " + path + " instead");
    }
    var node = resolveNodeByPath$$1(getStateTreeNode$$1(target), path);
    return node ? node.value : undefined;
}
/**
 * Resolves a model instance given a root target, the type and the identifier you are searching for.
 * Returns undefined if no value can be found.
 *
 * @export
 * @param {IAnyType} type
 * @param {IStateTreeNode} target
 * @param {(string | number)} identifier
 * @returns {*}
 */
function resolveIdentifier$$1(type, target, identifier$$1) {
    // check all arguments
    if (false) {
        if (!isType$$1(type))
            fail("expected first argument to be a mobx-state-tree type, got " + type + " instead");
        if (!isStateTreeNode$$1(target))
            fail("expected second argument to be a mobx-state-tree node, got " + target + " instead");
        if (!(typeof identifier$$1 === "string" || typeof identifier$$1 === "number"))
            fail("expected third argument to be a string or number, got " + identifier$$1 + " instead");
    }
    var node = getStateTreeNode$$1(target).root.identifierCache.resolve(type, "" + identifier$$1);
    return node ? node.value : undefined;
}
/**
 * Returns the identifier of the target node.
 * This is the *string normalized* identifier, which might not match the type of the identifier attribute
 *
 * @export
 * @param {IStateTreeNode} target
 * @returns {(string | null)}
 */
function getIdentifier$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).identifier;
}
/**
 *
 *
 * @export
 * @param {Object} target
 * @param {string} path
 * @returns {*}
 */
function tryResolve$$1(target, path) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof path !== "string")
            fail("expected second argument to be a string, got " + path + " instead");
    }
    var node = resolveNodeByPath$$1(getStateTreeNode$$1(target), path, false);
    if (node === undefined)
        return undefined;
    try {
        return node.value;
    }
    catch (e) {
        // For what ever reason not resolvable (e.g. totally not existing path, or value that cannot be fetched)
        // see test / issue: 'try resolve doesn't work #686'
        return undefined;
    }
}
/**
 * Given two state tree nodes that are part of the same tree,
 * returns the shortest jsonpath needed to navigate from the one to the other
 *
 * @export
 * @param {IStateTreeNode} base
 * @param {IStateTreeNode} target
 * @returns {string}
 */
function getRelativePath$$1(base, target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected second argument to be a mobx-state-tree node, got " + target + " instead");
        if (!isStateTreeNode$$1(base))
            fail("expected first argument to be a mobx-state-tree node, got " + base + " instead");
    }
    return getRelativePathBetweenNodes$$1(getStateTreeNode$$1(base), getStateTreeNode$$1(target));
}
/**
 * Returns a deep copy of the given state tree node as new tree.
 * Short hand for `snapshot(x) = getType(x).create(getSnapshot(x))`
 *
 * _Tip: clone will create a literal copy, including the same identifiers. To modify identifiers etc during cloning, don't use clone but take a snapshot of the tree, modify it, and create new instance_
 *
 * @export
 * @template T
 * @param {T} source
 * @param {boolean | any} keepEnvironment indicates whether the clone should inherit the same environment (`true`, the default), or not have an environment (`false`). If an object is passed in as second argument, that will act as the environment for the cloned tree.
 * @returns {T}
 */
function clone$$1(source, keepEnvironment) {
    if (keepEnvironment === void 0) { keepEnvironment = true; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(source))
            fail("expected first argument to be a mobx-state-tree node, got " + source + " instead");
    }
    var node = getStateTreeNode$$1(source);
    return node.type.create(node.snapshot, keepEnvironment === true
        ? node.root._environment
        : keepEnvironment === false
            ? undefined
            : keepEnvironment); // it's an object or something else
}
/**
 * Removes a model element from the state tree, and let it live on as a new state tree
 */
function detach$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    getStateTreeNode$$1(target).detach();
    return target;
}
/**
 * Removes a model element from the state tree, and mark it as end-of-life; the element should not be used anymore
 */
function destroy$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    if (node.isRoot)
        node.die();
    else
        node.parent.removeChild(node.subpath);
}
/**
 * Returns true if the given state tree node is not killed yet.
 * This means that the node is still a part of a tree, and that `destroy`
 * has not been called. If a node is not alive anymore, the only thing one can do with it
 * is requesting it's last path and snapshot
 *
 * @export
 * @param {IStateTreeNode} target
 * @returns {boolean}
 */
function isAlive$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).isAlive;
}
/**
 * Use this utility to register a function that should be called whenever the
 * targeted state tree node is destroyed. This is a useful alternative to managing
 * cleanup methods yourself using the `beforeDestroy` hook.
 *
 * @example
 * const Todo = types.model({
 *   title: types.string
 * }).actions(self => ({
 *   afterCreate() {
 *     const autoSaveDisposer = reaction(
 *       () => getSnapshot(self),
 *       snapshot => sendSnapshotToServerSomehow(snapshot)
 *     )
 *     // stop sending updates to server if this
 *     // instance is destroyed
 *     addDisposer(self, autoSaveDisposer)
 *   }
 * }))
 *
 * @export
 * @param {IStateTreeNode} target
 * @param {() => void} disposer
 */
function addDisposer$$1(target, disposer) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof disposer !== "function")
            fail("expected second argument to be a function, got " + disposer + " instead");
    }
    getStateTreeNode$$1(target).addDisposer(disposer);
}
/**
 * Returns the environment of the current state tree. For more info on environments,
 * see [Dependency injection](https://github.com/mobxjs/mobx-state-tree#dependency-injection)
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 * Returns an empty environment if the tree wasn't initialized with an environment
 *
 * @export
 * @param {IStateTreeNode} target
 * @returns {*}
 */
function getEnv$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    var env = node.root._environment;
    if (!!!env)
        return EMPTY_OBJECT;
    return env;
}
/**
 * Performs a depth first walk through a tree
 */
function walk$$1(target, processor) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof processor !== "function")
            fail("expected second argument to be a function, got " + processor + " instead");
    }
    var node = getStateTreeNode$$1(target);
    // tslint:disable-next-line:no_unused-variable
    node.getChildren().forEach(function (child) {
        if (isStateTreeNode$$1(child.storedValue))
            walk$$1(child.storedValue, processor);
    });
    processor(node.storedValue);
}
/**
 * Returns a reflection of the node
 *
 * @export
 * @param {IStateTreeNode} target
 * @returns {IModelReflectionData}
 */
function getMembers$$1(target) {
    // check all arguments
    if (false) {
        var node2 = getStateTreeNode$$1(target);
        if (!(node2.type instanceof ModelType$$1))
            fail("expected the node's type to be of the type: model" +
                target +
                " instead. It's likely you passed an array or a map.");
    }
    var node = getStateTreeNode$$1(target);
    var type = node.type;
    var props = Object.getOwnPropertyNames(target);
    var reflected = {
        name: type.name,
        properties: __assign({}, type.properties),
        actions: [],
        volatile: [],
        views: []
    };
    props.forEach(function (key) {
        if (key in reflected.properties)
            return;
        var descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["isComputedProp"])(target, key))
                reflected.views.push(key);
            else
                reflected.volatile.push(key);
            return;
        }
        if (descriptor.value._isMSTAction === true)
            reflected.actions.push(key);
        else if (Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableProp"])(target, key))
            reflected.volatile.push(key);
        else
            reflected.views.push(key);
    });
    return reflected;
}
/**
 * Casts a node snapshot or instance type to an instance type so it can be assigned to a type instance.
 * Alternatively also casts a node snapshot or instance to an snapshot type so it can be assigned to a type snapshot.
 * Note that this is just a cast for the type system, this is, it won't actually convert a snapshot to an instance
 * (or vice-versa), but just fool typescript into thinking so.
 * Casting only works on assignation operations, it won't work (compile) stand-alone.
 *
 * @example
 * const ModelA = types.model({
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   innerModel: ModelA
 * }).actions(self => ({
 *   someAction() {
 *     // this will allow the compiler to assign an snapshot to the property
 *     self.innerModel = cast({ a: 5 })
 *   }
 * }))
 *
 * @export
 * @param {CastedType<T>} snapshotOrInstance
 * @returns {T}
 */
function cast$$1(snapshotOrInstance) {
    return snapshotOrInstance;
}

var ScalarNode$$1 = /** @class */ (function () {
    function ScalarNode$$1(type, parent, subpath, environment, initialSnapshot) {
        this.parent = null;
        this.subpath = "";
        this.state = NodeLifeCycle$$1.INITIALIZING;
        this._environment = undefined;
        this._initialSnapshot = initialSnapshot;
        this.type = type;
        this.parent = parent;
        this.subpath = subpath;
        var sawException = true;
        try {
            this.storedValue = type.createNewInstance(this, {}, initialSnapshot);
            this.state = NodeLifeCycle$$1.CREATED;
            sawException = false;
        }
        finally {
            if (sawException) {
                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
                this.state = NodeLifeCycle$$1.DEAD;
            }
        }
    }
    Object.defineProperty(ScalarNode$$1.prototype, "path", {
        /*
         * Returnes (escaped) path representation as string
         */
        get: function () {
            if (!this.parent)
                return "";
            return this.parent.path + "/" + escapeJsonPath$$1(this.subpath);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScalarNode$$1.prototype, "isRoot", {
        get: function () {
            return this.parent === null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScalarNode$$1.prototype, "root", {
        get: function () {
            // future optimization: store root ref in the node and maintain it
            if (!this.parent)
                return fail("This scalar node is not part of a tree");
            return this.parent.root;
        },
        enumerable: true,
        configurable: true
    });
    ScalarNode$$1.prototype.setParent = function (newParent, subpath) {
        if (subpath === void 0) { subpath = null; }
        if (this.parent === newParent && this.subpath === subpath)
            return;
        if (this.parent && !newParent) {
            this.die();
        }
        else {
            var newPath = subpath === null ? "" : subpath;
            if (this.subpath !== newPath) {
                this.subpath = newPath;
            }
            if (newParent && newParent !== this.parent) {
                this.parent = newParent;
            }
        }
    };
    Object.defineProperty(ScalarNode$$1.prototype, "value", {
        get: function () {
            return this.type.getValue(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScalarNode$$1.prototype, "snapshot", {
        get: function () {
            var snapshot = this.getSnapshot();
            // avoid any external modification in dev mode
            return freeze(snapshot);
        },
        enumerable: true,
        configurable: true
    });
    ScalarNode$$1.prototype.getSnapshot = function () {
        return this.type.getSnapshot(this);
    };
    Object.defineProperty(ScalarNode$$1.prototype, "isAlive", {
        get: function () {
            return this.state !== NodeLifeCycle$$1.DEAD;
        },
        enumerable: true,
        configurable: true
    });
    ScalarNode$$1.prototype.toString = function () {
        return this.type.name + "@" + (this.path || "<root>") + (this.isAlive ? "" : "[dead]");
    };
    ScalarNode$$1.prototype.die = function () {
        this.state = NodeLifeCycle$$1.DEAD;
    };
    return ScalarNode$$1;
}());

var nextNodeId = 1;
var livelynessChecking = "warn";
/**
 *  Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use te `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * Possible values: `"warn"`, `"error"` and `"ignore"`
 *
 * @export
 * @param {LivelynessMode} mode
 */
function setLivelynessChecking$$1(mode) {
    livelynessChecking = mode;
}
var snapshotReactionOptions = {
    onError: function (e) {
        throw e;
    }
};
var ObjectNode$$1 = /** @class */ (function () {
    function ObjectNode$$1(type, parent, subpath, environment, initialSnapshot) {
        this.nodeId = ++nextNodeId;
        this.subpathAtom = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["createAtom"])("path");
        this.subpath = "";
        this.parent = null;
        this.state = NodeLifeCycle$$1.INITIALIZING;
        this.isProtectionEnabled = true;
        this.middlewares = null;
        this._autoUnbox = true; // unboxing is disabled when reading child nodes
        this._environment = undefined;
        this._isRunningAction = false; // only relevant for root
        this._hasSnapshotReaction = false;
        this._disposers = null;
        this._patchSubscribers = null;
        this._snapshotSubscribers = null;
        this._observableInstanceCreated = false;
        this._cachedInitialSnapshot = null;
        this._environment = environment;
        this._initialSnapshot = freeze(initialSnapshot);
        this.type = type;
        this.parent = parent;
        this.subpath = subpath;
        this.escapedSubpath = escapeJsonPath$$1(this.subpath);
        this.identifierAttribute = type.identifierAttribute;
        // identifier can not be changed during lifecycle of a node
        // so we safely can read it from initial snapshot
        this.identifier =
            this.identifierAttribute && this._initialSnapshot
                ? "" + this._initialSnapshot[this.identifierAttribute] // normalize internal identifier to string
                : null;
        if (!parent) {
            this.identifierCache = new IdentifierCache$$1();
        }
        this._childNodes = type.initializeChildNodes(this, this._initialSnapshot);
        if (!parent) {
            this.identifierCache.addNodeToCache(this);
        }
        else {
            parent.root.identifierCache.addNodeToCache(this);
        }
    }
    ObjectNode$$1.prototype.applyPatches = function (patches) {
        if (!this._observableInstanceCreated)
            this._createObservableInstance();
        this.applyPatches(patches);
    };
    ObjectNode$$1.prototype.applySnapshot = function (snapshot) {
        if (!this._observableInstanceCreated)
            this._createObservableInstance();
        this.applySnapshot(snapshot);
    };
    ObjectNode$$1.prototype._createObservableInstance = function () {
        var type = this.type;
        this.storedValue = type.createNewInstance(this, this._childNodes, this._initialSnapshot);
        this.preboot();
        var sawException = true;
        this._observableInstanceCreated = true;
        try {
            this._isRunningAction = true;
            type.finalizeNewInstance(this, this.storedValue);
            this._isRunningAction = false;
            this.fireHook("afterCreate");
            this.state = NodeLifeCycle$$1.CREATED;
            sawException = false;
        }
        finally {
            if (sawException) {
                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
                this.state = NodeLifeCycle$$1.DEAD;
            }
        }
        // NOTE: we need to touch snapshot, because non-observable
        // "observableInstanceCreated" field was touched
        invalidateComputed(this, "snapshot");
        if (this.isRoot)
            this._addSnapshotReaction();
        this.finalizeCreation();
        this._childNodes = EMPTY_OBJECT;
    };
    Object.defineProperty(ObjectNode$$1.prototype, "path", {
        /*
         * Returnes (escaped) path representation as string
         */
        get: function () {
            this.subpathAtom.reportObserved();
            if (!this.parent)
                return "";
            return this.parent.path + "/" + this.escapedSubpath;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectNode$$1.prototype, "root", {
        get: function () {
            var parent = this.parent;
            return parent ? parent.root : this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectNode$$1.prototype, "isRoot", {
        get: function () {
            return this.parent === null;
        },
        enumerable: true,
        configurable: true
    });
    ObjectNode$$1.prototype.setParent = function (newParent, subpath) {
        if (subpath === void 0) { subpath = null; }
        if (this.parent === newParent && this.subpath === subpath)
            return;
        if (newParent && "production" !== "production") {
            if (this.parent && newParent !== this.parent) {
                fail("A node cannot exists twice in the state tree. Failed to add " + this + " to path '" + newParent.path + "/" + subpath + "'.");
            }
            if (!this.parent && newParent.root === this) {
                fail("A state tree is not allowed to contain itself. Cannot assign " + this + " to path '" + newParent.path + "/" + subpath + "'");
            }
            if (!this.parent &&
                !!this.root._environment &&
                this.root._environment !== newParent.root._environment) {
                fail("A state tree cannot be made part of another state tree as long as their environments are different.");
            }
        }
        if (this.parent && !newParent) {
            this.die();
        }
        else {
            var newPath = subpath === null ? "" : subpath;
            if (this.subpath !== newPath) {
                this.subpath = newPath;
                this.escapedSubpath = escapeJsonPath$$1(this.subpath);
                this.subpathAtom.reportChanged();
            }
            if (newParent && newParent !== this.parent) {
                newParent.root.identifierCache.mergeCache(this);
                this.parent = newParent;
                this.subpathAtom.reportChanged();
                this.fireHook("afterAttach");
            }
        }
    };
    ObjectNode$$1.prototype.fireHook = function (name) {
        var fn = this.storedValue && typeof this.storedValue === "object" && this.storedValue[name];
        if (typeof fn === "function")
            fn.apply(this.storedValue);
    };
    Object.defineProperty(ObjectNode$$1.prototype, "value", {
        get: function () {
            if (!this._observableInstanceCreated)
                this._createObservableInstance();
            if (!this.isAlive)
                return undefined;
            return this.type.getValue(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectNode$$1.prototype, "snapshot", {
        // advantage of using computed for a snapshot is that nicely respects transactions etc.
        get: function () {
            if (!this.isAlive)
                return undefined;
            return freeze(this.getSnapshot());
        },
        enumerable: true,
        configurable: true
    });
    // NOTE: we use this method to get snapshot without creating @computed overhead
    ObjectNode$$1.prototype.getSnapshot = function () {
        if (!this.isAlive)
            return undefined;
        return this._observableInstanceCreated
            ? this._getActualSnapshot()
            : this._getInitialSnapshot();
    };
    ObjectNode$$1.prototype._getActualSnapshot = function () {
        return this.type.getSnapshot(this);
    };
    ObjectNode$$1.prototype._getInitialSnapshot = function () {
        if (!this.isAlive)
            return undefined;
        if (!this._initialSnapshot)
            return this._initialSnapshot;
        if (this._cachedInitialSnapshot)
            return this._cachedInitialSnapshot;
        var type = this.type;
        var childNodes = this._childNodes;
        var snapshot = this._initialSnapshot;
        this._cachedInitialSnapshot = type.processInitialSnapshot(childNodes, snapshot);
        return this._cachedInitialSnapshot;
    };
    ObjectNode$$1.prototype.isRunningAction = function () {
        if (this._isRunningAction)
            return true;
        if (this.isRoot)
            return false;
        return this.parent.isRunningAction();
    };
    Object.defineProperty(ObjectNode$$1.prototype, "isAlive", {
        get: function () {
            return this.state !== NodeLifeCycle$$1.DEAD;
        },
        enumerable: true,
        configurable: true
    });
    ObjectNode$$1.prototype.assertAlive = function () {
        if (!this.isAlive) {
            var baseMsg = "[mobx-state-tree][error] You are trying to read or write to an object that is no longer part of a state tree. (Object type was '" + this.type.name + "'). Either detach nodes first, or don't use objects after removing / replacing them in the tree.";
            switch (livelynessChecking) {
                case "error":
                    throw new Error(baseMsg);
                case "warn":
                    console.warn(baseMsg +
                        ' Use setLivelynessChecking("error") to simplify debugging this error.');
            }
        }
    };
    ObjectNode$$1.prototype.getChildNode = function (subpath) {
        this.assertAlive();
        this._autoUnbox = false;
        try {
            return this._observableInstanceCreated
                ? this.type.getChildNode(this, subpath)
                : this._childNodes[subpath];
        }
        finally {
            this._autoUnbox = true;
        }
    };
    ObjectNode$$1.prototype.getChildren = function () {
        this.assertAlive();
        this._autoUnbox = false;
        try {
            return this._observableInstanceCreated
                ? this.type.getChildren(this)
                : convertChildNodesToArray$$1(this._childNodes);
        }
        finally {
            this._autoUnbox = true;
        }
    };
    ObjectNode$$1.prototype.getChildType = function (key) {
        return this.type.getChildType(key);
    };
    Object.defineProperty(ObjectNode$$1.prototype, "isProtected", {
        get: function () {
            return this.root.isProtectionEnabled;
        },
        enumerable: true,
        configurable: true
    });
    ObjectNode$$1.prototype.assertWritable = function () {
        this.assertAlive();
        if (!this.isRunningAction() && this.isProtected) {
            fail("Cannot modify '" + this + "', the object is protected and can only be modified by using an action.");
        }
    };
    ObjectNode$$1.prototype.removeChild = function (subpath) {
        this.type.removeChild(this, subpath);
    };
    ObjectNode$$1.prototype.unbox = function (childNode) {
        if (childNode && childNode.parent)
            childNode.parent.assertAlive();
        if (childNode && childNode.parent && childNode.parent._autoUnbox)
            return childNode.value;
        return childNode;
    };
    ObjectNode$$1.prototype.toString = function () {
        var identifier$$1 = this.identifier ? "(id: " + this.identifier + ")" : "";
        return this.type.name + "@" + (this.path || "<root>") + identifier$$1 + (this.isAlive ? "" : "[dead]");
    };
    ObjectNode$$1.prototype.finalizeCreation = function () {
        // goal: afterCreate hooks runs depth-first. After attach runs parent first, so on afterAttach the parent has completed already
        if (this.state === NodeLifeCycle$$1.CREATED) {
            if (this.parent) {
                if (this.parent.state !== NodeLifeCycle$$1.FINALIZED) {
                    // parent not ready yet, postpone
                    return;
                }
                this.fireHook("afterAttach");
            }
            this.state = NodeLifeCycle$$1.FINALIZED;
            for (var _i = 0, _a = this.getChildren(); _i < _a.length; _i++) {
                var child = _a[_i];
                if (child instanceof ObjectNode$$1)
                    child.finalizeCreation();
            }
        }
    };
    ObjectNode$$1.prototype.detach = function () {
        if (!this.isAlive)
            fail("Error while detaching, node is not alive.");
        if (this.isRoot)
            return;
        else {
            this.fireHook("beforeDetach");
            this._environment = this.root._environment; // make backup of environment
            this.state = NodeLifeCycle$$1.DETACHING;
            this.identifierCache = this.root.identifierCache.splitCache(this);
            this.parent.removeChild(this.subpath);
            this.parent = null;
            this.subpath = this.escapedSubpath = "";
            this.subpathAtom.reportChanged();
            this.state = NodeLifeCycle$$1.FINALIZED;
        }
    };
    ObjectNode$$1.prototype.preboot = function () {
        var self = this;
        this.applyPatches = createActionInvoker$$1(this.storedValue, "@APPLY_PATCHES", function (patches) {
            patches.forEach(function (patch) {
                var parts = splitJsonPath$$1(patch.path);
                var node = resolveNodeByPathParts$$1(self, parts.slice(0, -1));
                node.applyPatchLocally(parts[parts.length - 1], patch);
            });
        });
        this.applySnapshot = createActionInvoker$$1(this.storedValue, "@APPLY_SNAPSHOT", function (snapshot) {
            // if the snapshot is the same as the current one, avoid performing a reconcile
            if (snapshot === self.snapshot)
                return;
            // else, apply it by calling the type logic
            return self.type.applySnapshot(self, snapshot);
        });
        addHiddenFinalProp(this.storedValue, "$treenode", this);
        addHiddenFinalProp(this.storedValue, "toJSON", toJSON$$1);
    };
    ObjectNode$$1.prototype.die = function () {
        if (this.state === NodeLifeCycle$$1.DETACHING)
            return;
        if (isStateTreeNode$$1(this.storedValue)) {
            // optimization: don't use walk, but getChildNodes for more efficiency
            walk$$1(this.storedValue, function (child) {
                var node = getStateTreeNode$$1(child);
                if (node instanceof ObjectNode$$1)
                    node.aboutToDie();
            });
            walk$$1(this.storedValue, function (child) {
                var node = getStateTreeNode$$1(child);
                if (node instanceof ObjectNode$$1)
                    node.finalizeDeath();
            });
        }
    };
    ObjectNode$$1.prototype.aboutToDie = function () {
        if (this._disposers) {
            this._disposers.forEach(function (f) { return f(); });
            this._disposers = null;
        }
        this.fireHook("beforeDestroy");
    };
    ObjectNode$$1.prototype.finalizeDeath = function () {
        // invariant: not called directly but from "die"
        this.root.identifierCache.notifyDied(this);
        addReadOnlyProp(this, "snapshot", this.snapshot); // kill the computed prop and just store the last snapshot
        if (this._patchSubscribers)
            this._patchSubscribers = null;
        if (this._snapshotSubscribers)
            this._snapshotSubscribers = null;
        this.state = NodeLifeCycle$$1.DEAD;
        this.subpath = this.escapedSubpath = "";
        this.parent = null;
        this.subpathAtom.reportChanged();
    };
    ObjectNode$$1.prototype.onSnapshot = function (onChange) {
        this._addSnapshotReaction();
        if (!this._snapshotSubscribers)
            this._snapshotSubscribers = [];
        return registerEventHandler(this._snapshotSubscribers, onChange);
    };
    ObjectNode$$1.prototype.emitSnapshot = function (snapshot) {
        if (this._snapshotSubscribers)
            this._snapshotSubscribers.forEach(function (f) { return f(snapshot); });
    };
    ObjectNode$$1.prototype.onPatch = function (handler) {
        if (!this._patchSubscribers)
            this._patchSubscribers = [];
        return registerEventHandler(this._patchSubscribers, handler);
    };
    ObjectNode$$1.prototype.emitPatch = function (basePatch, source) {
        var patchSubscribers = this._patchSubscribers;
        if (patchSubscribers && patchSubscribers.length) {
            var localizedPatch = extend({}, basePatch, {
                path: source.path.substr(this.path.length) + "/" + basePatch.path // calculate the relative path of the patch
            });
            var _a = splitPatch$$1(localizedPatch), patch_1 = _a[0], reversePatch_1 = _a[1];
            patchSubscribers.forEach(function (f) { return f(patch_1, reversePatch_1); });
        }
        if (this.parent)
            this.parent.emitPatch(basePatch, source);
    };
    ObjectNode$$1.prototype.addDisposer = function (disposer) {
        if (!this._disposers)
            this._disposers = [disposer];
        else
            this._disposers.unshift(disposer);
    };
    ObjectNode$$1.prototype.removeMiddleware = function (handler) {
        if (this.middlewares)
            this.middlewares = this.middlewares.filter(function (middleware) { return middleware.handler !== handler; });
    };
    ObjectNode$$1.prototype.addMiddleWare = function (handler, includeHooks) {
        var _this = this;
        if (includeHooks === void 0) { includeHooks = true; }
        if (!this.middlewares)
            this.middlewares = [{ handler: handler, includeHooks: includeHooks }];
        else
            this.middlewares.push({ handler: handler, includeHooks: includeHooks });
        return function () {
            _this.removeMiddleware(handler);
        };
    };
    ObjectNode$$1.prototype.applyPatchLocally = function (subpath, patch) {
        this.assertWritable();
        if (!this._observableInstanceCreated)
            this._createObservableInstance();
        this.type.applyPatchLocally(this, subpath, patch);
    };
    ObjectNode$$1.prototype._addSnapshotReaction = function () {
        var _this = this;
        if (!this._hasSnapshotReaction) {
            var snapshotDisposer = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["reaction"])(function () { return _this.snapshot; }, function (snapshot) { return _this.emitSnapshot(snapshot); }, snapshotReactionOptions);
            this.addDisposer(snapshotDisposer);
            this._hasSnapshotReaction = true;
        }
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ObjectNode$$1.prototype, "_createObservableInstance", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], ObjectNode$$1.prototype, "snapshot", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ObjectNode$$1.prototype, "detach", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ObjectNode$$1.prototype, "die", null);
    return ObjectNode$$1;
}());

var TypeFlags;
(function (TypeFlags$$1) {
    TypeFlags$$1[TypeFlags$$1["String"] = 1] = "String";
    TypeFlags$$1[TypeFlags$$1["Number"] = 2] = "Number";
    TypeFlags$$1[TypeFlags$$1["Boolean"] = 4] = "Boolean";
    TypeFlags$$1[TypeFlags$$1["Date"] = 8] = "Date";
    TypeFlags$$1[TypeFlags$$1["Literal"] = 16] = "Literal";
    TypeFlags$$1[TypeFlags$$1["Array"] = 32] = "Array";
    TypeFlags$$1[TypeFlags$$1["Map"] = 64] = "Map";
    TypeFlags$$1[TypeFlags$$1["Object"] = 128] = "Object";
    TypeFlags$$1[TypeFlags$$1["Frozen"] = 256] = "Frozen";
    TypeFlags$$1[TypeFlags$$1["Optional"] = 512] = "Optional";
    TypeFlags$$1[TypeFlags$$1["Reference"] = 1024] = "Reference";
    TypeFlags$$1[TypeFlags$$1["Identifier"] = 2048] = "Identifier";
    TypeFlags$$1[TypeFlags$$1["Late"] = 4096] = "Late";
    TypeFlags$$1[TypeFlags$$1["Refinement"] = 8192] = "Refinement";
    TypeFlags$$1[TypeFlags$$1["Union"] = 16384] = "Union";
    TypeFlags$$1[TypeFlags$$1["Null"] = 32768] = "Null";
    TypeFlags$$1[TypeFlags$$1["Undefined"] = 65536] = "Undefined";
    TypeFlags$$1[TypeFlags$$1["Integer"] = 131072] = "Integer";
})(TypeFlags || (TypeFlags = {}));
/*
 * A complex type produces a MST node (Node in the state tree)
 */
var ComplexType$$1 = /** @class */ (function () {
    function ComplexType$$1(name) {
        this.isType = true;
        this.name = name;
    }
    ComplexType$$1.prototype.create = function (snapshot, environment) {
        if (snapshot === void 0) { snapshot = this.getDefaultSnapshot(); }
        typecheck$$1(this, snapshot);
        return this.instantiate(null, "", environment, snapshot).value;
    };
    ComplexType$$1.prototype.initializeChildNodes = function (node, snapshot) {
        return {};
    };
    ComplexType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return snapshot;
    };
    ComplexType$$1.prototype.finalizeNewInstance = function (node, instance) { };
    ComplexType$$1.prototype.processInitialSnapshot = function (childNodes, snapshot) {
        return snapshot;
    };
    ComplexType$$1.prototype.isAssignableFrom = function (type) {
        return type === this;
    };
    ComplexType$$1.prototype.validate = function (value, context) {
        if (isStateTreeNode$$1(value)) {
            return getType$$1(value) === this || this.isAssignableFrom(getType$$1(value))
                ? typeCheckSuccess$$1()
                : typeCheckFailure$$1(context, value);
            // it is tempting to compare snapshots, but in that case we should always clone on assignments...
        }
        return this.isValidSnapshot(value, context);
    };
    ComplexType$$1.prototype.is = function (value) {
        return this.validate(value, [{ path: "", type: this }]).length === 0;
    };
    ComplexType$$1.prototype.reconcile = function (current, newValue) {
        if (current.snapshot === newValue)
            // newValue is the current snapshot of the node, noop
            return current;
        if (isStateTreeNode$$1(newValue) && getStateTreeNode$$1(newValue) === current)
            // the current node is the same as the new one
            return current;
        if (current.type === this &&
            isMutable(newValue) &&
            !isStateTreeNode$$1(newValue) &&
            (!current.identifierAttribute ||
                current.identifier === "" + newValue[current.identifierAttribute])) {
            // the newValue has no node, so can be treated like a snapshot
            // we can reconcile
            current.applySnapshot(newValue);
            return current;
        }
        // current node cannot be recycled in any way
        var parent = current.parent, subpath = current.subpath;
        current.die();
        // attempt to reuse the new one
        if (isStateTreeNode$$1(newValue) && this.isAssignableFrom(getType$$1(newValue))) {
            // newValue is a Node as well, move it here..
            var newNode = getStateTreeNode$$1(newValue);
            newNode.setParent(parent, subpath);
            return newNode;
        }
        // nothing to do, we have to create a new node
        return this.instantiate(parent, subpath, current._environment, newValue);
    };
    Object.defineProperty(ComplexType$$1.prototype, "Type", {
        get: function () {
            return fail("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComplexType$$1.prototype, "SnapshotType", {
        get: function () {
            return fail("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComplexType$$1.prototype, "CreationType", {
        get: function () {
            return fail("Factory.CreationType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.CreationType`");
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ComplexType$$1.prototype, "create", null);
    return ComplexType$$1;
}());
var Type$$1 = /** @class */ (function (_super) {
    __extends(Type$$1, _super);
    function Type$$1(name) {
        return _super.call(this, name) || this;
    }
    Type$$1.prototype.getValue = function (node) {
        return node.storedValue;
    };
    Type$$1.prototype.getSnapshot = function (node) {
        return node.storedValue;
    };
    Type$$1.prototype.getDefaultSnapshot = function () {
        return undefined;
    };
    Type$$1.prototype.applySnapshot = function (node, snapshot) {
        fail("Immutable types do not support applying snapshots");
    };
    Type$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
        fail("Immutable types do not support applying patches");
    };
    Type$$1.prototype.getChildren = function (node) {
        return EMPTY_ARRAY;
    };
    Type$$1.prototype.getChildNode = function (node, key) {
        return fail("No child '" + key + "' available in type: " + this.name);
    };
    Type$$1.prototype.getChildType = function (key) {
        return fail("No child '" + key + "' available in type: " + this.name);
    };
    Type$$1.prototype.reconcile = function (current, newValue) {
        // reconcile only if type and value are still the same
        if (current.type === this && current.storedValue === newValue)
            return current;
        var res = this.instantiate(current.parent, current.subpath, current._environment, newValue);
        current.die();
        return res;
    };
    Type$$1.prototype.removeChild = function (node, subpath) {
        return fail("No child '" + subpath + "' available in type: " + this.name);
    };
    return Type$$1;
}(ComplexType$$1));
function isType$$1(value) {
    return typeof value === "object" && value && value.isType === true;
}

var runningActions = new Map();
/**
 * Convenience utility to create action based middleware that supports async processes more easily.
 * All hooks are called for both synchronous and asynchronous actions. Except that either `onSuccess` or `onFail` is called
 *
 * The create middleware tracks the process of an action (assuming it passes the `filter`).
 * `onResume` can return any value, which will be passed as second argument to any other hook. This makes it possible to keep state during a process.
 *
 * See the `atomic` middleware for an example
 *
 * @export
 * @template T
 * @template any
 * @param {{
 *     filter?: (call: IMiddlewareEvent) => boolean
 *     onStart: (call: IMiddlewareEvent) => T
 *     onResume: (call: IMiddlewareEvent, context: T) => void
 *     onSuspend: (call: IMiddlewareEvent, context: T) => void
 *     onSuccess: (call: IMiddlewareEvent, context: T, result: any) => void
 *     onFail: (call: IMiddlewareEvent, context: T, error: any) => void
 * }} hooks
 * @returns {IMiddlewareHandler}
 */
function createActionTrackingMiddleware(hooks) {
    return function actionTrackingMiddleware(call, next, abort) {
        switch (call.type) {
            case "action": {
                if (!hooks.filter || hooks.filter(call) === true) {
                    var context = hooks.onStart(call);
                    hooks.onResume(call, context);
                    runningActions.set(call.id, {
                        call: call,
                        context: context,
                        async: false
                    });
                    try {
                        var res = next(call);
                        hooks.onSuspend(call, context);
                        if (runningActions.get(call.id).async === false) {
                            runningActions.delete(call.id);
                            hooks.onSuccess(call, context, res);
                        }
                        return res;
                    }
                    catch (e) {
                        runningActions.delete(call.id);
                        hooks.onFail(call, context, e);
                        throw e;
                    }
                }
                else {
                    return next(call);
                }
            }
            case "flow_spawn": {
                var root = runningActions.get(call.rootId);
                root.async = true;
                return next(call);
            }
            case "flow_resume":
            case "flow_resume_error": {
                var root = runningActions.get(call.rootId);
                hooks.onResume(call, root.context);
                try {
                    return next(call);
                }
                finally {
                    hooks.onSuspend(call, root.context);
                }
            }
            case "flow_throw": {
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.id);
                hooks.onFail(call, root.context, call.args[0]);
                return next(call);
            }
            case "flow_return": {
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.id);
                hooks.onSuccess(call, root.context, call.args[0]);
                return next(call);
            }
        }
    };
}

function serializeArgument(node, actionName, index, arg) {
    if (arg instanceof Date)
        return { $MST_DATE: arg.getTime() };
    if (isPrimitive(arg))
        return arg;
    // We should not serialize MST nodes, even if we can, because we don't know if the receiving party can handle a raw snapshot instead of an
    // MST type instance. So if one wants to serialize a MST node that was pass in, either explitly pass: 1: an id, 2: a (relative) path, 3: a snapshot
    if (isStateTreeNode$$1(arg))
        return serializeTheUnserializable("[MSTNode: " + getType$$1(arg).name + "]");
    if (typeof arg === "function")
        return serializeTheUnserializable("[function]");
    if (typeof arg === "object" && !isPlainObject(arg) && !isArray(arg))
        return serializeTheUnserializable("[object " + ((arg && arg.constructor && arg.constructor.name) || "Complex Object") + "]");
    try {
        // Check if serializable, cycle free etc...
        // MWE: there must be a better way....
        JSON.stringify(arg); // or throws
        return arg;
    }
    catch (e) {
        return serializeTheUnserializable("" + e);
    }
}
function deserializeArgument(adm, value) {
    if (value && typeof value === "object" && "$MST_DATE" in value)
        return new Date(value["$MST_DATE"]);
    return value;
}
function serializeTheUnserializable(baseType) {
    return {
        $MST_UNSERIALIZABLE: true,
        type: baseType
    };
}
/**
 * Applies an action or a series of actions in a single MobX transaction.
 * Does not return any value
 * Takes an action description as produced by the `onAction` middleware.
 *
 * @export
 * @param {Object} target
 * @param {IActionCall[]} actions
 */
function applyAction$$1(target, actions) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof actions !== "object")
            fail("expected second argument to be an object or array, got " + actions + " instead");
    }
    Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["runInAction"])(function () {
        asArray(actions).forEach(function (action$$1) { return baseApplyAction(target, action$$1); });
    });
}
function baseApplyAction(target, action$$1) {
    var resolvedTarget = tryResolve$$1(target, action$$1.path || "");
    if (!resolvedTarget)
        return fail("Invalid action path: " + (action$$1.path || ""));
    var node = getStateTreeNode$$1(resolvedTarget);
    // Reserved functions
    if (action$$1.name === "@APPLY_PATCHES") {
        return applyPatch$$1.call(null, resolvedTarget, action$$1.args[0]);
    }
    if (action$$1.name === "@APPLY_SNAPSHOT") {
        return applySnapshot$$1.call(null, resolvedTarget, action$$1.args[0]);
    }
    if (!(typeof resolvedTarget[action$$1.name] === "function"))
        fail("Action '" + action$$1.name + "' does not exist in '" + node.path + "'");
    return resolvedTarget[action$$1.name].apply(resolvedTarget, action$$1.args ? action$$1.args.map(function (v) { return deserializeArgument(node, v); }) : []);
}
/**
 * Small abstraction around `onAction` and `applyAction`, attaches an action listener to a tree and records all the actions emitted.
 * Returns an recorder object with the following signature:
 *
 * @example
 * export interface IActionRecorder {
 *      // the recorded actions
 *      actions: ISerializedActionCall[]
 *      // stop recording actions
 *      stop(): any
 *      // apply all the recorded actions on the given object
 *      replay(target: IStateTreeNode): any
 * }
 *
 * @export
 * @param {IStateTreeNode} subject
 * @returns {IPatchRecorder}
 */
function recordActions$$1(subject) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(subject))
            fail("expected first argument to be a mobx-state-tree node, got " + subject + " instead");
    }
    var recorder = {
        actions: [],
        stop: function () { return disposer(); },
        replay: function (target) {
            applyAction$$1(target, recorder.actions);
        }
    };
    var disposer = onAction$$1(subject, recorder.actions.push.bind(recorder.actions));
    return recorder;
}
/**
 * Registers a function that will be invoked for each action that is called on the provided model instance, or to any of its children.
 * See [actions](https://github.com/mobxjs/mobx-state-tree#actions) for more details. onAction events are emitted only for the outermost called action in the stack.
 * Action can also be intercepted by middleware using addMiddleware to change the function call before it will be run.
 *
 * Not all action arguments might be serializable. For unserializable arguments, a struct like `{ $MST_UNSERIALIZABLE: true, type: "someType" }` will be generated.
 * MST Nodes are considered non-serializable as well (they could be serialized as there snapshot, but it is uncertain whether an replaying party will be able to handle such a non-instantiated snapshot).
 * Rather, when using `onAction` middleware, one should consider in passing arguments which are 1: an id, 2: a (relative) path, or 3: a snapshot. Instead of a real MST node.
 *
 * @example
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * }).actions(self => ({
 *   add(todo) {
 *     self.todos.push(todo);
 *   }
 * }))
 *
 * const s = TodoStore.create({ todos: [] })
 *
 * let disposer = onAction(s, (call) => {
 *   console.log(call);
 * })
 *
 * s.add({ task: "Grab a coffee" })
 * // Logs: { name: "add", path: "", args: [{ task: "Grab a coffee" }] }
 *
 * @export
 * @param {IStateTreeNode} target
 * @param {(call: ISerializedActionCall) => void} listener
 * @param attachAfter {boolean} (default false) fires the listener *after* the action has executed instead of before.
 * @returns {IDisposer}
 */
function onAction$$1(target, listener, attachAfter) {
    if (attachAfter === void 0) { attachAfter = false; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (!isRoot$$1(target))
            console.warn("[mobx-state-tree] Warning: Attaching onAction listeners to non root nodes is dangerous: No events will be emitted for actions initiated higher up in the tree.");
        if (!isProtected$$1(target))
            console.warn("[mobx-state-tree] Warning: Attaching onAction listeners to non protected nodes is dangerous: No events will be emitted for direct modifications without action.");
    }
    return addMiddleware$$1(target, function handler(rawCall, next) {
        if (rawCall.type === "action" && rawCall.id === rawCall.rootId) {
            var sourceNode_1 = getStateTreeNode$$1(rawCall.context);
            var info = {
                name: rawCall.name,
                path: getRelativePathBetweenNodes$$1(getStateTreeNode$$1(target), sourceNode_1),
                args: rawCall.args.map(function (arg, index) {
                    return serializeArgument(sourceNode_1, rawCall.name, index, arg);
                })
            };
            if (attachAfter) {
                var res = next(rawCall);
                listener(info);
                return res;
            }
            else {
                listener(info);
                return next(rawCall);
            }
        }
        else {
            return next(rawCall);
        }
    });
}

var nextActionId = 1;
var currentActionContext = null;
function getNextActionId$$1() {
    return nextActionId++;
}
// TODO: optimize away entire action context if there is no middleware in tree?
function runWithActionContext$$1(context, fn) {
    var node = getStateTreeNode$$1(context.context);
    var baseIsRunningAction = node._isRunningAction;
    var prevContext = currentActionContext;
    if (context.type === "action") {
        node.assertAlive();
    }
    node._isRunningAction = true;
    currentActionContext = context;
    try {
        return runMiddleWares(node, context, fn);
    }
    finally {
        currentActionContext = prevContext;
        node._isRunningAction = baseIsRunningAction;
    }
}
function getActionContext$$1() {
    if (!currentActionContext)
        return fail("Not running an action!");
    return currentActionContext;
}
function createActionInvoker$$1(target, name, fn) {
    var res = function () {
        var id = getNextActionId$$1();
        return runWithActionContext$$1({
            type: "action",
            name: name,
            id: id,
            args: argsToArray(arguments),
            context: target,
            tree: getRoot$$1(target),
            rootId: currentActionContext ? currentActionContext.rootId : id,
            parentId: currentActionContext ? currentActionContext.id : 0
        }, fn);
    };
    res._isMSTAction = true;
    return res;
}
/**
 * Middleware can be used to intercept any action is invoked on the subtree where it is attached.
 * If a tree is protected (by default), this means that any mutation of the tree will pass through your middleware.
 *
 * For more details, see the [middleware docs](docs/middleware.md)
 *
 * @export
 * @param {IStateTreeNode} target
 * @param {(action: IRawActionCall, next: (call: IRawActionCall) => any) => any} middleware
 * @returns {IDisposer}
 */
function addMiddleware$$1(target, handler, includeHooks) {
    if (includeHooks === void 0) { includeHooks = true; }
    var node = getStateTreeNode$$1(target);
    if (false) {
        if (!node.isProtectionEnabled)
            console.warn("It is recommended to protect the state tree before attaching action middleware, as otherwise it cannot be guaranteed that all changes are passed through middleware. See `protect`");
    }
    return node.addMiddleWare(handler, includeHooks);
}
/**
 * Binds middleware to a specific action
 *
 * @example
 * type.actions(self => {
 *   function takeA____() {
 *       self.toilet.donate()
 *       self.wipe()
 *       self.wipe()
 *       self.toilet.flush()
 *   }
 *   return {
 *     takeA____: decorate(atomic, takeA____)
 *   }
 * })
 *
 * @export
 * @template T
 * @param {IMiddlewareHandler} handler
 * @param Function} fn
 * @returns the original function
 */
function decorate$$1(handler, fn) {
    var middleware = { handler: handler, includeHooks: true };
    if (fn.$mst_middleware)
        fn.$mst_middleware.push(middleware);
    else
        fn.$mst_middleware = [middleware];
    return fn;
}
function collectMiddlewares(node, baseCall, fn) {
    var middlewares = fn.$mst_middleware || EMPTY_ARRAY;
    var n = node;
    // Find all middlewares. Optimization: cache this?
    while (n) {
        if (n.middlewares)
            middlewares = middlewares.concat(n.middlewares);
        n = n.parent;
    }
    return middlewares;
}
function runMiddleWares(node, baseCall, originalFn) {
    var middlewares = collectMiddlewares(node, baseCall, originalFn);
    // Short circuit
    if (!middlewares.length)
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(originalFn).apply(null, baseCall.args);
    var index = 0;
    var result = null;
    function runNextMiddleware(call) {
        var middleware = middlewares[index++];
        var handler = middleware && middleware.handler;
        var nextInvoked = false;
        var abortInvoked = false;
        function next(call2, callback) {
            nextInvoked = true;
            // the result can contain
            // - the non manipulated return value from an action
            // - the non manipulated abort value
            // - one of the above but manipulated through the callback function
            if (callback) {
                result = callback(runNextMiddleware(call2) || result);
            }
            else {
                result = runNextMiddleware(call2);
            }
        }
        function abort(value) {
            abortInvoked = true;
            // overwrite the result
            // can be manipulated through middlewares earlier in the queue using the callback fn
            result = value;
        }
        var invokeHandler = function () {
            handler(call, next, abort);
            if (false) {
                if (!nextInvoked && !abortInvoked) {
                    var node2 = getStateTreeNode$$1(call.tree);
                    fail("Neither the next() nor the abort() callback within the middleware " + handler.name + " for the action: \"" + call.name + "\" on the node: " + node2.type.name + " was invoked.");
                }
                if (nextInvoked && abortInvoked) {
                    var node2 = getStateTreeNode$$1(call.tree);
                    fail("The next() and abort() callback within the middleware " + handler.name + " for the action: \"" + call.name + "\" on the node: " + node2.type.name + " were invoked.");
                }
            }
            return result;
        };
        if (handler && middleware.includeHooks) {
            return invokeHandler();
        }
        else if (handler && !middleware.includeHooks) {
            if (HookNames$$1[call.name])
                return runNextMiddleware(call);
            return invokeHandler();
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(originalFn).apply(null, call.args);
        }
    }
    return runNextMiddleware(baseCall);
}

function safeStringify(value) {
    try {
        return JSON.stringify(value);
    }
    catch (e) {
        return "<Unserializable: " + e + ">";
    }
}
function prettyPrintValue$$1(value) {
    return typeof value === "function"
        ? "<function" + (value.name ? " " + value.name : "") + ">"
        : isStateTreeNode$$1(value)
            ? "<" + value + ">"
            : "`" + safeStringify(value) + "`";
}
function shortenPrintValue(valueInString) {
    return valueInString.length < 280
        ? valueInString
        : valueInString.substring(0, 272) + "......" + valueInString.substring(valueInString.length - 8);
}
function toErrorString(error) {
    var value = error.value;
    var type = error.context[error.context.length - 1].type;
    var fullPath = error.context
        .map(function (_a) {
        var path = _a.path;
        return path;
    })
        .filter(function (path) { return path.length > 0; })
        .join("/");
    var pathPrefix = fullPath.length > 0 ? "at path \"/" + fullPath + "\" " : "";
    var currentTypename = isStateTreeNode$$1(value)
        ? "value of type " + getStateTreeNode$$1(value).type.name + ":"
        : isPrimitive(value)
            ? "value"
            : "snapshot";
    var isSnapshotCompatible = type && isStateTreeNode$$1(value) && type.is(getStateTreeNode$$1(value).snapshot);
    return ("" + pathPrefix + currentTypename + " " + prettyPrintValue$$1(value) + " is not assignable " + (type ? "to type: `" + type.name + "`" : "") +
        (error.message ? " (" + error.message + ")" : "") +
        (type
            ? isPrimitiveType$$1(type) || isPrimitive(value)
                ? "."
                : ", expected an instance of `" + type.name + "` or a snapshot like `" + type.describe() + "` instead." +
                    (isSnapshotCompatible
                        ? " (Note that a snapshot of the provided value is compatible with the targeted type)"
                        : "")
            : "."));
}
function getContextForPath$$1(context, path, type) {
    return context.concat([{ path: path, type: type }]);
}
function typeCheckSuccess$$1() {
    return EMPTY_ARRAY;
}
function typeCheckFailure$$1(context, value, message) {
    return [{ context: context, value: value, message: message }];
}
function flattenTypeErrors$$1(errors) {
    return errors.reduce(function (a, i) { return a.concat(i); }, []);
}
// TODO; doublecheck: typecheck should only needed to be invoked from: type.create and array / map / value.property will change
function typecheck$$1(type, value) {
    // if not in dev-mode, do not even try to run typecheck. Everything is developer fault!
    if (true)
        return;
    typecheckPublic$$1(type, value);
}
/**
 * Run's the typechecker on the given type.
 * Throws if the given value is not according the provided type specification.
 * Use this if you need typechecks even in a production build (by default all automatic runtime type checks will be skipped in production builds)
 *
 * @alias typecheck
 * @export
 * @param {IAnyType} type
 * @param {*} value
 */
function typecheckPublic$$1(type, value) {
    var errors = type.validate(value, [{ path: "", type: type }]);
    if (errors.length > 0) {
        fail("Error while converting " + shortenPrintValue(prettyPrintValue$$1(value)) + " to `" + type.name + "`:\n\n    " + errors.map(toErrorString).join("\n    "));
    }
}

var IdentifierCache$$1 = /** @class */ (function () {
    function IdentifierCache$$1() {
        // n.b. in cache all identifiers are normalized to strings
        this.cache = __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].map();
    }
    IdentifierCache$$1.prototype.addNodeToCache = function (node) {
        if (node.identifierAttribute) {
            var identifier$$1 = node.identifier;
            if (!this.cache.has(identifier$$1)) {
                this.cache.set(identifier$$1, __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].array([], mobxShallow));
            }
            var set$$1 = this.cache.get(identifier$$1);
            if (set$$1.indexOf(node) !== -1)
                fail("Already registered");
            set$$1.push(node);
        }
        return this;
    };
    IdentifierCache$$1.prototype.mergeCache = function (node) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["values"])(node.identifierCache.cache).forEach(function (nodes) {
            return nodes.forEach(function (child) {
                _this.addNodeToCache(child);
            });
        });
    };
    IdentifierCache$$1.prototype.notifyDied = function (node) {
        if (node.identifierAttribute) {
            var set$$1 = this.cache.get(node.identifier);
            if (set$$1)
                set$$1.remove(node);
        }
    };
    IdentifierCache$$1.prototype.splitCache = function (node) {
        var res = new IdentifierCache$$1();
        var basePath = node.path;
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["values"])(this.cache).forEach(function (nodes) {
            for (var i = nodes.length - 1; i >= 0; i--) {
                if (nodes[i].path.indexOf(basePath) === 0) {
                    res.addNodeToCache(nodes[i]);
                    nodes.splice(i, 1);
                }
            }
        });
        return res;
    };
    IdentifierCache$$1.prototype.resolve = function (type, identifier$$1) {
        var set$$1 = this.cache.get("" + identifier$$1);
        if (!set$$1)
            return null;
        var matches = set$$1.filter(function (candidate) { return type.isAssignableFrom(candidate.type); });
        switch (matches.length) {
            case 0:
                return null;
            case 1:
                return matches[0];
            default:
                return fail("Cannot resolve a reference to type '" + type.name + "' with id: '" + identifier$$1 + "' unambigously, there are multiple candidates: " + matches
                    .map(function (n) { return n.path; })
                    .join(", "));
        }
    };
    return IdentifierCache$$1;
}());

function createNode$$1(type, parent, subpath, environment, initialValue) {
    var existingNode = getStateTreeNodeSafe$$1(initialValue);
    if (existingNode) {
        if (existingNode.isRoot) {
            existingNode.setParent(parent, subpath);
            return existingNode;
        }
        fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + (parent ? parent.path : "") + "/" + subpath + "', but it lives already at '" + existingNode.path + "'");
    }
    var Node = type.shouldAttachNode ? ObjectNode$$1 : ScalarNode$$1;
    return new Node(type, parent, subpath, environment, initialValue);
}
function isNode$$1(value) {
    return value instanceof ScalarNode$$1 || value instanceof ObjectNode$$1;
}

var NodeLifeCycle$$1;
(function (NodeLifeCycle$$1) {
    NodeLifeCycle$$1[NodeLifeCycle$$1["INITIALIZING"] = 0] = "INITIALIZING";
    NodeLifeCycle$$1[NodeLifeCycle$$1["CREATED"] = 1] = "CREATED";
    NodeLifeCycle$$1[NodeLifeCycle$$1["FINALIZED"] = 2] = "FINALIZED";
    NodeLifeCycle$$1[NodeLifeCycle$$1["DETACHING"] = 3] = "DETACHING";
    NodeLifeCycle$$1[NodeLifeCycle$$1["DEAD"] = 4] = "DEAD"; // no coming back from this one
})(NodeLifeCycle$$1 || (NodeLifeCycle$$1 = {}));
/**
 * Returns true if the given value is a node in a state tree.
 * More precisely, that is, if the value is an instance of a
 * `types.model`, `types.array` or `types.map`.
 *
 * @export
 * @param {*} value
 * @returns {value is IStateTreeNode}
 */
function isStateTreeNode$$1(value) {
    return !!(value && value.$treenode);
}
function getStateTreeNode$$1(value) {
    if (isStateTreeNode$$1(value))
        return value.$treenode;
    else
        return fail("Value " + value + " is no MST Node");
}
function getStateTreeNodeSafe$$1(value) {
    return (value && value.$treenode) || null;
}
function toJSON$$1() {
    return getStateTreeNode$$1(this).snapshot;
}
var doubleDot = function (_) { return ".."; };
function getRelativePathBetweenNodes$$1(base, target) {
    // PRE condition target is (a child of) base!
    if (base.root !== target.root)
        fail("Cannot calculate relative path: objects '" + base + "' and '" + target + "' are not part of the same object tree");
    var baseParts = splitJsonPath$$1(base.path);
    var targetParts = splitJsonPath$$1(target.path);
    var common = 0;
    for (; common < baseParts.length; common++) {
        if (baseParts[common] !== targetParts[common])
            break;
    }
    // TODO: assert that no targetParts paths are "..", "." or ""!
    return (baseParts
        .slice(common)
        .map(doubleDot)
        .join("/") + joinJsonPath$$1(targetParts.slice(common)));
}
function resolveNodeByPath$$1(base, path, failIfResolveFails) {
    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
    return resolveNodeByPathParts$$1(base, splitJsonPath$$1(path), failIfResolveFails);
}
function resolveNodeByPathParts$$1(base, pathParts, failIfResolveFails) {
    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
    // counter part of getRelativePath
    // note that `../` is not part of the JSON pointer spec, which is actually a prefix format
    // in json pointer: "" = current, "/a", attribute a, "/" is attribute "" etc...
    // so we treat leading ../ apart...
    var current = base;
    for (var i = 0; i < pathParts.length; i++) {
        var part = pathParts[i];
        if (part === "") {
            current = current.root;
            continue;
        }
        else if (part === "..") {
            current = current.parent;
            if (current)
                continue; // not everything has a parent
        }
        else if (part === "." || part === "") {
            // '/bla' or 'a//b' splits to empty strings
            continue;
        }
        else if (current) {
            if (current instanceof ScalarNode$$1) {
                // check if the value of a scalar resolves to a state tree node (e.g. references)
                // then we can continue resolving...
                try {
                    var value = current.value;
                    if (isStateTreeNode$$1(value)) {
                        current = getStateTreeNode$$1(value);
                        // fall through
                    }
                }
                catch (e) {
                    if (!failIfResolveFails) {
                        return undefined;
                    }
                    throw e;
                }
            }
            if (current instanceof ObjectNode$$1) {
                var subType = current.getChildType(part);
                if (subType) {
                    current = current.getChildNode(part);
                    if (current)
                        continue;
                }
            }
        }
        if (failIfResolveFails)
            return fail("Could not resolve '" + part + "' in path '" + (joinJsonPath$$1(pathParts.slice(0, i)) ||
                "/") + "' while resolving '" + joinJsonPath$$1(pathParts) + "'");
        else
            return undefined;
    }
    return current;
}
function convertChildNodesToArray$$1(childNodes) {
    if (!childNodes)
        return EMPTY_ARRAY;
    var keys = Object.keys(childNodes);
    if (!keys.length)
        return EMPTY_ARRAY;
    var result = new Array(keys.length);
    keys.forEach(function (key, index) {
        result[index] = childNodes[key];
    });
    return result;
}

// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
/*
    All contents of this file are deprecated.

    The term `process` has been replaced with `flow` to avoid conflicts with the
    global `process` object.

    Refer to `flow.ts` for any further changes to this implementation.
*/
var DEPRECATION_MESSAGE = "See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information. " +
    "Note that the middleware event types starting with `process` now start with `flow`.";
/**
 * @deprecated has been renamed to `flow()`.
 * See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information.
 * Note that the middleware event types starting with `process` now start with `flow`.
 *
 * @export
 * @alias process
 * @returns {Promise}
 */
function process$$1(asyncAction) {
    deprecated("process", "`process()` has been renamed to `flow()`. " + DEPRECATION_MESSAGE);
    return flow(asyncAction);
}

var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});
var mobxShallow = typeof __WEBPACK_IMPORTED_MODULE_0_mobx__["$mobx"] === "string" ? { deep: false } : { deep: false, proxy: false };
Object.freeze(mobxShallow);
function fail(message) {
    if (message === void 0) { message = "Illegal state"; }
    throw new Error("[mobx-state-tree] " + message);
}
function identity(_) {
    return _;
}
// pollyfill (for IE) suggested in MDN:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
var isInteger = Number.isInteger ||
    function (value) {
        return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
    };
function isArray(val) {
    return !!(Array.isArray(val) || Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"])(val));
}
function asArray(val) {
    if (!val)
        return EMPTY_ARRAY;
    if (isArray(val))
        return val;
    return [val];
}
function extend(a) {
    var b = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        b[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < b.length; i++) {
        var current = b[i];
        for (var key in current)
            a[key] = current[key];
    }
    return a;
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function isMutable(value) {
    return (value !== null &&
        typeof value === "object" &&
        !(value instanceof Date) &&
        !(value instanceof RegExp));
}
function isPrimitive(value) {
    if (value === null || value === undefined)
        return true;
    if (typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        value instanceof Date)
        return true;
    return false;
}
/*
 * Freeze a value and return it (if not in production)
 */
function freeze(value) {
    if (true)
        return value;
    return isPrimitive(value) || Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"])(value) ? value : Object.freeze(value);
}
/*
 * Recursively freeze a value (if not in production)
 */
function deepFreeze(value) {
    if (true)
        return value;
    freeze(value);
    if (isPlainObject(value)) {
        Object.keys(value).forEach(function (propKey) {
            if (!isPrimitive(value[propKey]) &&
                !Object.isFrozen(value[propKey])) {
                deepFreeze(value[propKey]);
            }
        });
    }
    return value;
}
function isSerializable(value) {
    return typeof value !== "function";
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function addHiddenWritableProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addReadOnlyProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: true,
        writable: false,
        configurable: true,
        value: value
    });
}
function remove(collection, item) {
    var idx = collection.indexOf(item);
    if (idx !== -1)
        collection.splice(idx, 1);
}
function registerEventHandler(handlers, handler) {
    handlers.push(handler);
    return function () {
        remove(handlers, handler);
    };
}
function argsToArray(args) {
    var res = new Array(args.length);
    for (var i = 0; i < args.length; i++)
        res[i] = args[i];
    return res;
}
function invalidateComputed(target, propName) {
    var atom = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["getAtom"])(target, propName);
    atom.trackAndCompute();
}
var deprecated = function () { };
deprecated = function (id, message) {
    // skip if running production
    if (true)
        return;
    // warn if hasn't been warned before
    if (deprecated.ids && !deprecated.ids.hasOwnProperty(id)) {
        console.warn("[mobx-state-tree] Deprecation warning: " + message);
    }
    // mark as warned to avoid duplicate warn message
    if (deprecated.ids)
        deprecated.ids[id] = true;
};
deprecated.ids = {};

// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
/**
 * See [asynchronous actions](https://github.com/mobxjs/mobx-state-tree/blob/master/docs/async-actions.md).
 *
 * @export
 * @alias flow
 * @returns {Promise}
 */
function flow(asyncAction) {
    return createFlowSpawner(asyncAction.name, asyncAction);
}
function createFlowSpawner(name, generator) {
    var spawner = function flowSpawner() {
        // Implementation based on https://github.com/tj/co/blob/master/index.js
        var runId = getNextActionId$$1();
        var baseContext = getActionContext$$1();
        var args = arguments;
        function wrap(fn, type, arg) {
            fn.$mst_middleware = spawner.$mst_middleware; // pick up any middleware attached to the flow
            runWithActionContext$$1({
                name: name,
                type: type,
                id: runId,
                args: [arg],
                tree: baseContext.tree,
                context: baseContext.context,
                parentId: baseContext.id,
                rootId: baseContext.rootId
            }, fn);
        }
        return new Promise(function (resolve, reject) {
            var gen;
            var init = function asyncActionInit() {
                gen = generator.apply(null, arguments);
                onFulfilled(undefined); // kick off the flow
            };
            init.$mst_middleware = spawner.$mst_middleware;
            runWithActionContext$$1({
                name: name,
                type: "flow_spawn",
                id: runId,
                args: argsToArray(args),
                tree: baseContext.tree,
                context: baseContext.context,
                parentId: baseContext.id,
                rootId: baseContext.rootId
            }, init);
            function onFulfilled(res) {
                var ret;
                try {
                    // prettier-ignore
                    wrap(function (r) { ret = gen.next(r); }, "flow_resume", res);
                }
                catch (e) {
                    // prettier-ignore
                    setImmediate(function () {
                        wrap(function (r) { reject(e); }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
                return;
            }
            function onRejected(err) {
                var ret;
                try {
                    // prettier-ignore
                    wrap(function (r) { ret = gen.throw(r); }, "flow_resume_error", err); // or yieldError?
                }
                catch (e) {
                    // prettier-ignore
                    setImmediate(function () {
                        wrap(function (r) { reject(e); }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
            }
            function next(ret) {
                if (ret.done) {
                    // prettier-ignore
                    setImmediate(function () {
                        wrap(function (r) { resolve(r); }, "flow_return", ret.value);
                    });
                    return;
                }
                // TODO: support more type of values? See https://github.com/tj/co/blob/249bbdc72da24ae44076afd716349d2089b31c4c/index.js#L100
                if (!ret.value || typeof ret.value.then !== "function")
                    fail("Only promises can be yielded to `async`, got: " + ret);
                return ret.value.then(onFulfilled, onRejected);
            }
        });
    };
    return spawner;
}

function splitPatch$$1(patch) {
    if (!("oldValue" in patch))
        fail("Patches without `oldValue` field cannot be inversed");
    return [stripPatch$$1(patch), invertPatch(patch)];
}
function stripPatch$$1(patch) {
    // strips `oldvalue` information from the patch, so that it becomes a patch conform the json-patch spec
    // this removes the ability to undo the patch
    switch (patch.op) {
        case "add":
            return { op: "add", path: patch.path, value: patch.value };
        case "remove":
            return { op: "remove", path: patch.path };
        case "replace":
            return { op: "replace", path: patch.path, value: patch.value };
    }
}
function invertPatch(patch) {
    switch (patch.op) {
        case "add":
            return {
                op: "remove",
                path: patch.path
            };
        case "remove":
            return {
                op: "add",
                path: patch.path,
                value: patch.oldValue
            };
        case "replace":
            return {
                op: "replace",
                path: patch.path,
                value: patch.oldValue
            };
    }
}
// simple simple simple check
function isNumber(x) {
    return typeof x === "number";
}
/**
 * escape slashes and backslashes
 * http://tools.ietf.org/html/rfc6901
 */
function escapeJsonPath$$1(str) {
    if (isNumber(str) === true) {
        return "" + str;
    }
    return str.replace(/~/g, "~1").replace(/\//g, "~0");
}
/**
 * unescape slashes and backslashes
 */
function unescapeJsonPath$$1(str) {
    return str.replace(/~0/g, "/").replace(/~1/g, "~");
}
/**
 * Generates a json-path compliant json path from path parts
 *
 * @export
 * @param {string[]} path
 * @returns {string}
 */
function joinJsonPath$$1(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    if (path.length === 0)
        return "";
    return "/" + path.map(escapeJsonPath$$1).join("/");
}
/**
 * Splits and decodes a json path into several parts
 *
 * @export
 * @param {string} path
 * @returns {string[]}
 */
function splitJsonPath$$1(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    var parts = path.split("/").map(unescapeJsonPath$$1);
    // path '/a/b/c' -> a b c
    // path '../../b/c -> .. .. b c
    return parts[0] === "" ? parts.slice(1) : parts;
}

var needsIdentifierError = "Map.put can only be used to store complex values that have an identifier type attribute";
function tryCollectModelTypes(type, modelTypes) {
    if (type instanceof ModelType$$1) {
        modelTypes.push(type);
    }
    else if (type instanceof OptionalValue$$1) {
        if (!tryCollectModelTypes(type.type, modelTypes))
            return false;
    }
    else if (type instanceof Union$$1) {
        for (var i = 0; i < type.types.length; i++) {
            var uType = type.types[i];
            if (!tryCollectModelTypes(uType, modelTypes))
                return false;
        }
    }
    else if (type instanceof Late$$1) {
        var t = type.getSubType(false);
        if (!t)
            return false;
        tryCollectModelTypes(t, modelTypes);
    }
    return true;
}
var MapIdentifierMode$$1;
(function (MapIdentifierMode$$1) {
    MapIdentifierMode$$1[MapIdentifierMode$$1["UNKNOWN"] = 0] = "UNKNOWN";
    MapIdentifierMode$$1[MapIdentifierMode$$1["YES"] = 1] = "YES";
    MapIdentifierMode$$1[MapIdentifierMode$$1["NO"] = 2] = "NO";
})(MapIdentifierMode$$1 || (MapIdentifierMode$$1 = {}));
var MSTMap = /** @class */ (function (_super) {
    __extends(MSTMap, _super);
    function MSTMap(initialData) {
        return _super.call(this, initialData, __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].ref.enhancer) || this;
    }
    MSTMap.prototype.get = function (key) {
        // maybe this is over-enthousiastic? normalize numeric keys to strings
        return _super.prototype.get.call(this, "" + key);
    };
    MSTMap.prototype.has = function (key) {
        return _super.prototype.has.call(this, "" + key);
    };
    MSTMap.prototype.delete = function (key) {
        return _super.prototype.delete.call(this, "" + key);
    };
    MSTMap.prototype.set = function (key, value) {
        return _super.prototype.set.call(this, "" + key, value);
    };
    MSTMap.prototype.put = function (value) {
        if (!!!value)
            fail("Map.put cannot be used to set empty values");
        if (isStateTreeNode$$1(value)) {
            var node = getStateTreeNode$$1(value);
            if (false) {
                if (!node.identifierAttribute)
                    return fail(needsIdentifierError);
            }
            var key = node.identifier;
            this.set(key, node.value);
            return node.value;
        }
        else if (!isMutable(value)) {
            return fail("Map.put can only be used to store complex values");
        }
        else {
            var key = void 0;
            var mapType = getStateTreeNode$$1(this).type;
            if (mapType.identifierMode === MapIdentifierMode$$1.NO)
                return fail(needsIdentifierError);
            if (mapType.identifierMode === MapIdentifierMode$$1.YES) {
                key = "" + value[mapType.identifierAttribute];
                this.set(key, value);
                return this.get(key);
            }
            return fail(needsIdentifierError);
        }
    };
    return MSTMap;
}(__WEBPACK_IMPORTED_MODULE_0_mobx__["ObservableMap"]));
var MapType$$1 = /** @class */ (function (_super) {
    __extends(MapType$$1, _super);
    function MapType$$1(name, subType) {
        var _this = _super.call(this, name) || this;
        _this.shouldAttachNode = true;
        _this.identifierMode = MapIdentifierMode$$1.UNKNOWN;
        _this.identifierAttribute = undefined;
        _this.flags = TypeFlags.Map;
        _this.subType = subType;
        _this._determineIdentifierMode();
        return _this;
    }
    MapType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        if (this.identifierMode === MapIdentifierMode$$1.UNKNOWN) {
            this._determineIdentifierMode();
        }
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    MapType$$1.prototype._determineIdentifierMode = function () {
        var modelTypes = [];
        if (tryCollectModelTypes(this.subType, modelTypes)) {
            var identifierAttribute_1 = undefined;
            modelTypes.forEach(function (type) {
                if (type.identifierAttribute) {
                    if (identifierAttribute_1 && identifierAttribute_1 !== type.identifierAttribute) {
                        fail("The objects in a map should all have the same identifier attribute, expected '" + identifierAttribute_1 + "', but child of type '" + type.name + "' declared attribute '" + type.identifierAttribute + "' as identifier");
                    }
                    identifierAttribute_1 = type.identifierAttribute;
                }
            });
            if (identifierAttribute_1) {
                this.identifierMode = MapIdentifierMode$$1.YES;
                this.identifierAttribute = identifierAttribute_1;
            }
            else {
                this.identifierMode = MapIdentifierMode$$1.NO;
            }
        }
    };
    MapType$$1.prototype.initializeChildNodes = function (objNode, initialSnapshot) {
        if (initialSnapshot === void 0) { initialSnapshot = {}; }
        var subType = objNode.type.subType;
        var environment = objNode._environment;
        var result = {};
        Object.keys(initialSnapshot).forEach(function (name) {
            result[name] = subType.instantiate(objNode, name, environment, initialSnapshot[name]);
        });
        return result;
    };
    MapType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return new MSTMap(childNodes);
    };
    MapType$$1.prototype.finalizeNewInstance = function (node, instance) {
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["_interceptReads"])(instance, node.unbox);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["intercept"])(instance, this.willChange);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["observe"])(instance, this.didChange);
    };
    MapType$$1.prototype.describe = function () {
        return "Map<string, " + this.subType.describe() + ">";
    };
    MapType$$1.prototype.getChildren = function (node) {
        // return (node.storedValue as ObservableMap<any>).values()
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["values"])(node.storedValue);
    };
    MapType$$1.prototype.getChildNode = function (node, key) {
        var childNode = node.storedValue.get("" + key);
        if (!childNode)
            fail("Not a child " + key);
        return childNode;
    };
    MapType$$1.prototype.willChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        var key = change.name;
        node.assertWritable();
        var mapType = node.type;
        var subType = mapType.subType;
        switch (change.type) {
            case "update":
                {
                    var newValue = change.newValue;
                    var oldValue = change.object.get(key);
                    if (newValue === oldValue)
                        return null;
                    typecheck$$1(subType, newValue);
                    change.newValue = subType.reconcile(node.getChildNode(key), change.newValue);
                    mapType.processIdentifier(key, change.newValue);
                }
                break;
            case "add":
                {
                    typecheck$$1(subType, change.newValue);
                    change.newValue = subType.instantiate(node, key, undefined, change.newValue);
                    mapType.processIdentifier(key, change.newValue);
                }
                break;
        }
        return change;
    };
    MapType$$1.prototype.processIdentifier = function (expected, node) {
        if (this.identifierMode === MapIdentifierMode$$1.YES && node instanceof ObjectNode$$1) {
            var identifier$$1 = node.identifier;
            if (identifier$$1 !== expected)
                fail("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '" + identifier$$1 + "', but expected: '" + expected + "'");
        }
    };
    MapType$$1.prototype.getValue = function (node) {
        return node.storedValue;
    };
    MapType$$1.prototype.getSnapshot = function (node) {
        var res = {};
        node.getChildren().forEach(function (childNode) {
            res[childNode.subpath] = childNode.snapshot;
        });
        return res;
    };
    MapType$$1.prototype.processInitialSnapshot = function (childNodes, snapshot) {
        var processed = {};
        Object.keys(childNodes).forEach(function (key) {
            processed[key] = childNodes[key].getSnapshot();
        });
        return processed;
    };
    MapType$$1.prototype.didChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        switch (change.type) {
            case "update":
                return void node.emitPatch({
                    op: "replace",
                    path: escapeJsonPath$$1(change.name),
                    value: change.newValue.snapshot,
                    oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                }, node);
            case "add":
                return void node.emitPatch({
                    op: "add",
                    path: escapeJsonPath$$1(change.name),
                    value: change.newValue.snapshot,
                    oldValue: undefined
                }, node);
            case "delete":
                // a node got deleted, get the old snapshot and make the node die
                var oldSnapshot = change.oldValue.snapshot;
                change.oldValue.die();
                // emit the patch
                return void node.emitPatch({ op: "remove", path: escapeJsonPath$$1(change.name), oldValue: oldSnapshot }, node);
        }
    };
    MapType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
        var target = node.storedValue;
        switch (patch.op) {
            case "add":
            case "replace":
                target.set(subpath, patch.value);
                break;
            case "remove":
                target.delete(subpath);
                break;
        }
    };
    MapType$$1.prototype.applySnapshot = function (node, snapshot) {
        typecheck$$1(this, snapshot);
        var target = node.storedValue;
        var currentKeys = {};
        Array.from(target.keys()).forEach(function (key) {
            currentKeys[key] = false;
        });
        // Don't use target.replace, as it will throw all existing items first
        for (var key in snapshot) {
            target.set(key, snapshot[key]);
            currentKeys["" + key] = true;
        }
        Object.keys(currentKeys).forEach(function (key) {
            if (currentKeys[key] === false)
                target.delete(key);
        });
    };
    MapType$$1.prototype.getChildType = function (key) {
        return this.subType;
    };
    MapType$$1.prototype.isValidSnapshot = function (value, context) {
        var _this = this;
        if (!isPlainObject(value)) {
            return typeCheckFailure$$1(context, value, "Value is not a plain object");
        }
        return flattenTypeErrors$$1(Object.keys(value).map(function (path) {
            return _this.subType.validate(value[path], getContextForPath$$1(context, path, _this.subType));
        }));
    };
    MapType$$1.prototype.getDefaultSnapshot = function () {
        return {};
    };
    MapType$$1.prototype.removeChild = function (node, subpath) {
        node.storedValue.delete(subpath);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapType$$1.prototype, "applySnapshot", null);
    return MapType$$1;
}(ComplexType$$1));
/**
 * Creates a key based collection type who's children are all of a uniform declared type.
 * If the type stored in a map has an identifier, it is mandatory to store the child under that identifier in the map.
 *
 * This type will always produce [observable maps](https://mobx.js.org/refguide/map.html)
 *
 * @example
 * const Todo = types.model({
 *   id: types.identifier,
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.map(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: {} })
 * unprotect(s)
 * s.todos.set(17, { task: "Grab coffee", id: 17 })
 * s.todos.put({ task: "Grab cookie", id: 18 }) // put will infer key from the identifier
 * console.log(s.todos.get(17).task) // prints: "Grab coffee"
 *
 * @export
 * @alias types.map
 * @param {IType<S, T>} subtype
 * @returns {IComplexType<S[], IObservableArray<T>>}
 */
function map$$1(subtype) {
    var ret = new MapType$$1("map<string, " + subtype.name + ">", subtype);
    return ret;
}

var ArrayType$$1 = /** @class */ (function (_super) {
    __extends(ArrayType$$1, _super);
    function ArrayType$$1(name, subType) {
        var _this = _super.call(this, name) || this;
        _this.shouldAttachNode = true;
        _this.flags = TypeFlags.Array;
        _this.subType = subType;
        return _this;
    }
    ArrayType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    ArrayType$$1.prototype.initializeChildNodes = function (objNode, snapshot) {
        if (snapshot === void 0) { snapshot = []; }
        var subType = objNode.type.subType;
        var environment = objNode._environment;
        var result = {};
        snapshot.forEach(function (item, index) {
            var subpath = "" + index;
            result[subpath] = subType.instantiate(objNode, subpath, environment, item);
        });
        return result;
    };
    ArrayType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].array(convertChildNodesToArray$$1(childNodes), mobxShallow);
    };
    ArrayType$$1.prototype.finalizeNewInstance = function (node, instance) {
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["_getAdministration"])(instance).dehancer = node.unbox;
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["intercept"])(instance, this.willChange);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["observe"])(instance, this.didChange);
    };
    ArrayType$$1.prototype.describe = function () {
        return this.subType.describe() + "[]";
    };
    ArrayType$$1.prototype.getChildren = function (node) {
        return node.storedValue.slice();
    };
    ArrayType$$1.prototype.getChildNode = function (node, key) {
        var index = parseInt(key, 10);
        if (index < node.storedValue.length)
            return node.storedValue[index];
        return fail("Not a child: " + key);
    };
    ArrayType$$1.prototype.willChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        node.assertWritable();
        var subType = node.type.subType;
        var childNodes = node.getChildren();
        var nodes = null;
        switch (change.type) {
            case "update":
                if (change.newValue === change.object[change.index])
                    return null;
                nodes = reconcileArrayChildren(node, subType, [childNodes[change.index]], [change.newValue], [change.index]);
                if (!nodes) {
                    return null;
                }
                change.newValue = nodes[0];
                break;
            case "splice":
                var index_1 = change.index, removedCount = change.removedCount, added = change.added;
                nodes = reconcileArrayChildren(node, subType, childNodes.slice(index_1, index_1 + removedCount), added, added.map(function (_, i) { return index_1 + i; }));
                if (!nodes) {
                    return null;
                }
                change.added = nodes;
                // update paths of remaining items
                for (var i = index_1 + removedCount; i < childNodes.length; i++) {
                    childNodes[i].setParent(node, "" + (i + added.length - removedCount));
                }
                break;
        }
        return change;
    };
    ArrayType$$1.prototype.getValue = function (node) {
        return node.storedValue;
    };
    ArrayType$$1.prototype.getSnapshot = function (node) {
        return node.getChildren().map(function (childNode) { return childNode.snapshot; });
    };
    ArrayType$$1.prototype.processInitialSnapshot = function (childNodes, snapshot) {
        var processed = [];
        Object.keys(childNodes).forEach(function (key) {
            processed.push(childNodes[key].getSnapshot());
        });
        return processed;
    };
    ArrayType$$1.prototype.didChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        switch (change.type) {
            case "update":
                return void node.emitPatch({
                    op: "replace",
                    path: "" + change.index,
                    value: change.newValue.snapshot,
                    oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                }, node);
            case "splice":
                for (var i = change.removedCount - 1; i >= 0; i--)
                    node.emitPatch({
                        op: "remove",
                        path: "" + (change.index + i),
                        oldValue: change.removed[i].snapshot
                    }, node);
                for (var i = 0; i < change.addedCount; i++)
                    node.emitPatch({
                        op: "add",
                        path: "" + (change.index + i),
                        value: node.getChildNode("" + (change.index + i)).snapshot,
                        oldValue: undefined
                    }, node);
                return;
        }
    };
    ArrayType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
        var target = node.storedValue;
        var index = subpath === "-" ? target.length : parseInt(subpath);
        switch (patch.op) {
            case "replace":
                target[index] = patch.value;
                break;
            case "add":
                target.splice(index, 0, patch.value);
                break;
            case "remove":
                target.splice(index, 1);
                break;
        }
    };
    ArrayType$$1.prototype.applySnapshot = function (node, snapshot) {
        typecheck$$1(this, snapshot);
        var target = node.storedValue;
        target.replace(snapshot);
    };
    ArrayType$$1.prototype.getChildType = function (key) {
        return this.subType;
    };
    ArrayType$$1.prototype.isValidSnapshot = function (value, context) {
        var _this = this;
        if (!isArray(value)) {
            return typeCheckFailure$$1(context, value, "Value is not an array");
        }
        return flattenTypeErrors$$1(value.map(function (item, index) {
            return _this.subType.validate(item, getContextForPath$$1(context, "" + index, _this.subType));
        }));
    };
    ArrayType$$1.prototype.getDefaultSnapshot = function () {
        return EMPTY_ARRAY;
    };
    ArrayType$$1.prototype.removeChild = function (node, subpath) {
        node.storedValue.splice(parseInt(subpath, 10), 1);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ArrayType$$1.prototype, "applySnapshot", null);
    return ArrayType$$1;
}(ComplexType$$1));
/**
 * Creates an index based collection type who's children are all of a uniform declared type.
 *
 * This type will always produce [observable arrays](https://mobx.js.org/refguide/array.html)
 *
 * @example
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: [] })
 * unprotect(s) // needed to allow modifying outside of an action
 * s.todos.push({ task: "Grab coffee" })
 * console.log(s.todos[0]) // prints: "Grab coffee"
 *
 * @export
 * @alias types.array
 * @param {IType<S, T>} subtype
 * @returns {IComplexType<S[], IObservableArray<T>>}
 */
function array$$1(subtype) {
    if (false) {
        if (!isType$$1(subtype))
            fail("expected a mobx-state-tree type as first argument, got " + subtype + " instead");
    }
    var ret = new ArrayType$$1(subtype.name + "[]", subtype);
    return ret;
}
function reconcileArrayChildren(parent, childType, oldNodes, newValues, newPaths) {
    var oldNode, newValue, hasNewNode = false, oldMatch = undefined, nothingChanged = true;
    for (var i = 0;; i++) {
        hasNewNode = i <= newValues.length - 1;
        oldNode = oldNodes[i];
        newValue = hasNewNode ? newValues[i] : undefined;
        // for some reason, instead of newValue we got a node, fallback to the storedValue
        // TODO: https://github.com/mobxjs/mobx-state-tree/issues/340#issuecomment-325581681
        if (isNode$$1(newValue))
            newValue = newValue.storedValue;
        // both are empty, end
        if (!oldNode && !hasNewNode) {
            break;
            // new one does not exists, old one dies
        }
        else if (!hasNewNode) {
            oldNode.die();
            oldNodes.splice(i, 1);
            i--;
            nothingChanged = false;
            // there is no old node, create it
        }
        else if (!oldNode) {
            // check if already belongs to the same parent. if so, avoid pushing item in. only swapping can occur.
            if (isStateTreeNode$$1(newValue) && getStateTreeNode$$1(newValue).parent === parent) {
                // this node is owned by this parent, but not in the reconcilable set, so it must be double
                fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + parent.path + "/" + newPaths[i] + "', but it lives already at '" + getStateTreeNode$$1(newValue).path + "'");
            }
            oldNodes.splice(i, 0, valueAsNode(childType, parent, "" + newPaths[i], newValue));
            nothingChanged = false;
            // both are the same, reconcile
        }
        else if (areSame(oldNode, newValue)) {
            oldNodes[i] = valueAsNode(childType, parent, "" + newPaths[i], newValue, oldNode);
            // nothing to do, try to reorder
        }
        else {
            oldMatch = undefined;
            // find a possible candidate to reuse
            for (var j = i; j < oldNodes.length; j++) {
                if (areSame(oldNodes[j], newValue)) {
                    oldMatch = oldNodes.splice(j, 1)[0];
                    break;
                }
            }
            oldNodes.splice(i, 0, valueAsNode(childType, parent, "" + newPaths[i], newValue, oldMatch));
            nothingChanged = false;
        }
    }
    return nothingChanged ? null : oldNodes;
}
// convert a value to a node at given parent and subpath. attempts to reuse old node if possible and given
function valueAsNode(childType, parent, subpath, newValue, oldNode) {
    // ensure the value is valid-ish
    typecheck$$1(childType, newValue);
    // the new value has a MST node
    if (isStateTreeNode$$1(newValue)) {
        var childNode = getStateTreeNode$$1(newValue);
        childNode.assertAlive();
        // the node lives here
        if (childNode.parent !== null && childNode.parent === parent) {
            childNode.setParent(parent, subpath);
            if (oldNode && oldNode !== childNode)
                oldNode.die();
            return childNode;
        }
    }
    // there is old node and new one is a value/snapshot
    if (oldNode) {
        var childNode = childType.reconcile(oldNode, newValue);
        childNode.setParent(parent, subpath);
        return childNode;
    }
    // nothing to do, create from scratch
    return childType.instantiate(parent, subpath, parent._environment, newValue);
}
// given a value
function areSame(oldNode, newValue) {
    // the new value has the same node
    if (isStateTreeNode$$1(newValue)) {
        return getStateTreeNode$$1(newValue) === oldNode;
    }
    // the provided value is the snapshot of the old node
    if (oldNode.snapshot === newValue)
        return true;
    // new value is a snapshot with the correct identifier
    if (oldNode instanceof ObjectNode$$1 &&
        oldNode.identifier !== null &&
        oldNode.identifierAttribute &&
        isPlainObject(newValue) &&
        oldNode.identifier === "" + newValue[oldNode.identifierAttribute])
        return true;
    return false;
}

var PRE_PROCESS_SNAPSHOT = "preProcessSnapshot";
var POST_PROCESS_SNAPSHOT = "postProcessSnapshot";
var HookNames$$1;
(function (HookNames$$1) {
    HookNames$$1["afterCreate"] = "afterCreate";
    HookNames$$1["afterAttach"] = "afterAttach";
    HookNames$$1["beforeDetach"] = "beforeDetach";
    HookNames$$1["beforeDestroy"] = "beforeDestroy";
})(HookNames$$1 || (HookNames$$1 = {}));
function objectTypeToString() {
    return getStateTreeNode$$1(this).toString();
}
var defaultObjectOptions = {
    name: "AnonymousModel",
    properties: {},
    initializers: EMPTY_ARRAY
};
function toPropertiesObject(declaredProps) {
    // loop through properties and ensures that all items are types
    return Object.keys(declaredProps).reduce(function (props, key) {
        var _a, _b, _c;
        // warn if user intended a HOOK
        if (key in HookNames$$1)
            return fail("Hook '" + key + "' was defined as property. Hooks should be defined as part of the actions");
        // the user intended to use a view
        var descriptor = Object.getOwnPropertyDescriptor(props, key);
        if ("get" in descriptor) {
            fail("Getters are not supported as properties. Please use views instead");
        }
        // undefined and null are not valid
        var value = descriptor.value;
        if (value === null || value === undefined) {
            fail("The default value of an attribute cannot be null or undefined as the type cannot be inferred. Did you mean `types.maybe(someType)`?");
            // its a primitive, convert to its type
        }
        else if (isPrimitive(value)) {
            return Object.assign({}, props, (_a = {},
                _a[key] = optional$$1(getPrimitiveFactoryFromValue$$1(value), value),
                _a));
            // map defaults to empty object automatically for models
        }
        else if (value instanceof MapType$$1) {
            return Object.assign({}, props, (_b = {},
                _b[key] = optional$$1(value, {}),
                _b));
        }
        else if (value instanceof ArrayType$$1) {
            return Object.assign({}, props, (_c = {}, _c[key] = optional$$1(value, []), _c));
            // its already a type
        }
        else if (isType$$1(value)) {
            return props;
            // its a function, maybe the user wanted a view?
        }
        else if (false) {
            fail("Invalid type definition for property '" + key + "', it looks like you passed a function. Did you forget to invoke it, or did you intend to declare a view / action?");
            // no other complex values
        }
        else if (false) {
            fail("Invalid type definition for property '" + key + "', it looks like you passed an object. Try passing another model type or a types.frozen.");
            // WTF did you pass in mate?
        }
        else {
            fail("Invalid type definition for property '" + key + "', cannot infer a type from a value like '" + value + "' (" + typeof value + ")");
        }
    }, declaredProps);
}
var ModelType$$1 = /** @class */ (function (_super) {
    __extends(ModelType$$1, _super);
    function ModelType$$1(opts) {
        var _this = _super.call(this, opts.name || defaultObjectOptions.name) || this;
        _this.flags = TypeFlags.Object;
        _this.shouldAttachNode = true;
        var name = opts.name || defaultObjectOptions.name;
        // TODO: this test still needed?
        if (!/^\w[\w\d_]*$/.test(name))
            fail("Typename should be a valid identifier: " + name);
        Object.assign(_this, defaultObjectOptions, opts);
        // ensures that any default value gets converted to its related type
        _this.properties = toPropertiesObject(_this.properties);
        freeze(_this.properties); // make sure nobody messes with it
        _this.propertyNames = Object.keys(_this.properties);
        _this.identifierAttribute = _this._getIdentifierAttribute();
        return _this;
    }
    ModelType$$1.prototype._getIdentifierAttribute = function () {
        var identifierAttribute = undefined;
        this.forAllProps(function (propName, propType) {
            if (propType.flags & TypeFlags.Identifier) {
                if (identifierAttribute)
                    fail("Cannot define property '" + propName + "' as object identifier, property '" + identifierAttribute + "' is already defined as identifier property");
                identifierAttribute = propName;
            }
        });
        return identifierAttribute;
    };
    ModelType$$1.prototype.cloneAndEnhance = function (opts) {
        return new ModelType$$1({
            name: opts.name || this.name,
            properties: Object.assign({}, this.properties, opts.properties),
            initializers: this.initializers.concat(opts.initializers || []),
            preProcessor: opts.preProcessor || this.preProcessor,
            postProcessor: opts.postProcessor || this.postProcessor
        });
    };
    ModelType$$1.prototype.actions = function (fn) {
        var _this = this;
        var actionInitializer = function (self) {
            _this.instantiateActions(self, fn(self));
            return self;
        };
        return this.cloneAndEnhance({ initializers: [actionInitializer] });
    };
    ModelType$$1.prototype.instantiateActions = function (self, actions) {
        // check if return is correct
        if (!isPlainObject(actions))
            fail("actions initializer should return a plain object containing actions");
        // bind actions to the object created
        Object.keys(actions).forEach(function (name) {
            // warn if preprocessor was given
            if (name === PRE_PROCESS_SNAPSHOT)
                fail("Cannot define action '" + PRE_PROCESS_SNAPSHOT + "', it should be defined using 'type.preProcessSnapshot(fn)' instead");
            // warn if postprocessor was given
            if (name === POST_PROCESS_SNAPSHOT)
                fail("Cannot define action '" + POST_PROCESS_SNAPSHOT + "', it should be defined using 'type.postProcessSnapshot(fn)' instead");
            // apply hook composition
            var action2 = actions[name];
            var baseAction = self[name];
            if (name in HookNames$$1 && baseAction) {
                var specializedAction_1 = action2;
                action2 = function () {
                    baseAction.apply(null, arguments);
                    specializedAction_1.apply(null, arguments);
                };
            }
            ( true ? addHiddenFinalProp : addHiddenWritableProp)(self, name, createActionInvoker$$1(self, name, action2));
        });
    };
    ModelType$$1.prototype.named = function (name) {
        return this.cloneAndEnhance({ name: name });
    };
    ModelType$$1.prototype.props = function (properties) {
        return this.cloneAndEnhance({ properties: properties });
    };
    ModelType$$1.prototype.volatile = function (fn) {
        var _this = this;
        var stateInitializer = function (self) {
            _this.instantiateVolatileState(self, fn(self));
            return self;
        };
        return this.cloneAndEnhance({ initializers: [stateInitializer] });
    };
    ModelType$$1.prototype.instantiateVolatileState = function (self, state) {
        // check views return
        if (!isPlainObject(state))
            fail("volatile state initializer should return a plain object containing state");
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["set"])(self, state);
    };
    ModelType$$1.prototype.extend = function (fn) {
        var _this = this;
        var initializer = function (self) {
            var _a = fn(self), actions = _a.actions, views = _a.views, state = _a.state, rest = __rest(_a, ["actions", "views", "state"]);
            for (var key in rest)
                fail("The `extend` function should return an object with a subset of the fields 'actions', 'views' and 'state'. Found invalid key '" + key + "'");
            if (state)
                _this.instantiateVolatileState(self, state);
            if (views)
                _this.instantiateViews(self, views);
            if (actions)
                _this.instantiateActions(self, actions);
            return self;
        };
        return this.cloneAndEnhance({ initializers: [initializer] });
    };
    ModelType$$1.prototype.views = function (fn) {
        var _this = this;
        var viewInitializer = function (self) {
            _this.instantiateViews(self, fn(self));
            return self;
        };
        return this.cloneAndEnhance({ initializers: [viewInitializer] });
    };
    ModelType$$1.prototype.instantiateViews = function (self, views) {
        // check views return
        if (!isPlainObject(views))
            fail("views initializer should return a plain object containing views");
        Object.keys(views).forEach(function (key) {
            // is this a computed property?
            var descriptor = Object.getOwnPropertyDescriptor(views, key);
            var value = descriptor.value;
            if ("get" in descriptor) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["isComputedProp"])(self, key)) {
                    var computedValue = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["_getAdministration"])(self, key);
                    // TODO: mobx currently does not allow redefining computes yet, pending #1121
                    // FIXME: this binds to the internals of mobx!
                    computedValue.derivation = descriptor.get;
                    computedValue.scope = self;
                    if (descriptor.set)
                        computedValue.setter = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(computedValue.name + "-setter", descriptor.set);
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["computed"])(self, key, descriptor, true);
                }
            }
            else if (typeof value === "function") {
                ( true
                    ? addHiddenFinalProp
                    : addHiddenWritableProp)(self, key, value);
            }
            else {
                fail("A view member should either be a function or getter based property");
            }
        });
    };
    ModelType$$1.prototype.preProcessSnapshot = function (preProcessor) {
        var currentPreprocessor = this.preProcessor;
        if (!currentPreprocessor)
            return this.cloneAndEnhance({ preProcessor: preProcessor });
        else
            return this.cloneAndEnhance({
                preProcessor: function (snapshot) { return currentPreprocessor(preProcessor(snapshot)); }
            });
    };
    ModelType$$1.prototype.postProcessSnapshot = function (postProcessor) {
        var currentPostprocessor = this.postProcessor;
        if (!currentPostprocessor)
            return this.cloneAndEnhance({ postProcessor: postProcessor });
        else
            return this.cloneAndEnhance({
                postProcessor: function (snapshot) { return postProcessor(currentPostprocessor(snapshot)); }
            });
    };
    ModelType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        var initialValue = isStateTreeNode$$1(snapshot)
            ? snapshot
            : this.applySnapshotPreProcessor(snapshot);
        return createNode$$1(this, parent, subpath, environment, initialValue);
        // Optimization: record all prop- view- and action names after first construction, and generate an optimal base class
        // that pre-reserves all these fields for fast object-member lookups
    };
    ModelType$$1.prototype.initializeChildNodes = function (objNode, initialSnapshot) {
        if (initialSnapshot === void 0) { initialSnapshot = {}; }
        var type = objNode.type;
        var result = {};
        type.forAllProps(function (name, childType) {
            result[name] = childType.instantiate(objNode, name, objNode._environment, initialSnapshot[name]);
        });
        return result;
    };
    ModelType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].object(childNodes, EMPTY_OBJECT, mobxShallow);
    };
    ModelType$$1.prototype.finalizeNewInstance = function (node, instance) {
        addHiddenFinalProp(instance, "toString", objectTypeToString);
        this.forAllProps(function (name) {
            Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["_interceptReads"])(instance, name, node.unbox);
        });
        this.initializers.reduce(function (self, fn) { return fn(self); }, instance);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["intercept"])(instance, this.willChange);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["observe"])(instance, this.didChange);
    };
    ModelType$$1.prototype.willChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        node.assertWritable();
        var type = node.type.properties[change.name];
        // only properties are typed, state are stored as-is references
        if (type) {
            typecheck$$1(type, change.newValue);
            change.newValue = type.reconcile(node.getChildNode(change.name), change.newValue);
        }
        return change;
    };
    ModelType$$1.prototype.didChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        var type = node.type.properties[change.name];
        if (!type) {
            // don't emit patches for volatile state
            return;
        }
        var oldValue = change.oldValue ? change.oldValue.snapshot : undefined;
        node.emitPatch({
            op: "replace",
            path: escapeJsonPath$$1(change.name),
            value: change.newValue.snapshot,
            oldValue: oldValue
        }, node);
    };
    ModelType$$1.prototype.getChildren = function (node) {
        var _this = this;
        var res = [];
        this.forAllProps(function (name, type) {
            res.push(_this.getChildNode(node, name));
        });
        return res;
    };
    ModelType$$1.prototype.getChildNode = function (node, key) {
        if (!(key in this.properties))
            return fail("Not a value property: " + key);
        var childNode = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["_getAdministration"])(node.storedValue, key).value; // TODO: blegh!
        if (!childNode)
            return fail("Node not available for property " + key);
        return childNode;
    };
    ModelType$$1.prototype.getValue = function (node) {
        return node.storedValue;
    };
    ModelType$$1.prototype.getSnapshot = function (node, applyPostProcess) {
        var _this = this;
        if (applyPostProcess === void 0) { applyPostProcess = true; }
        var res = {};
        this.forAllProps(function (name, type) {
            Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["getAtom"])(node.storedValue, name).reportObserved();
            res[name] = _this.getChildNode(node, name).snapshot;
        });
        if (applyPostProcess) {
            return this.applySnapshotPostProcessor(res);
        }
        return res;
    };
    ModelType$$1.prototype.processInitialSnapshot = function (childNodes, snapshot) {
        var processed = {};
        Object.keys(childNodes).forEach(function (key) {
            processed[key] = childNodes[key].getSnapshot();
        });
        return this.applySnapshotPostProcessor(this.applyOptionalValuesToSnapshot(processed));
    };
    ModelType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
        if (!(patch.op === "replace" || patch.op === "add"))
            fail("object does not support operation " + patch.op);
        node.storedValue[subpath] = patch.value;
    };
    ModelType$$1.prototype.applySnapshot = function (node, snapshot) {
        var s = this.applySnapshotPreProcessor(snapshot);
        typecheck$$1(this, s);
        this.forAllProps(function (name, type) {
            node.storedValue[name] = s[name];
        });
    };
    ModelType$$1.prototype.applySnapshotPreProcessor = function (snapshot) {
        var processor = this.preProcessor;
        return processor ? processor.call(null, snapshot) : snapshot;
    };
    ModelType$$1.prototype.applyOptionalValuesToSnapshot = function (snapshot) {
        if (snapshot) {
            snapshot = Object.assign({}, snapshot);
            this.forAllProps(function (name, type) {
                if (!(name in snapshot)) {
                    var optional2 = tryGetOptional(type);
                    if (optional2) {
                        snapshot[name] = optional2.getDefaultValueSnapshot();
                    }
                }
            });
        }
        return snapshot;
    };
    ModelType$$1.prototype.applySnapshotPostProcessor = function (snapshot) {
        var postProcessor = this.postProcessor;
        if (postProcessor)
            return postProcessor.call(null, snapshot);
        return snapshot;
    };
    ModelType$$1.prototype.getChildType = function (key) {
        return this.properties[key];
    };
    ModelType$$1.prototype.isValidSnapshot = function (value, context) {
        var _this = this;
        var snapshot = this.applySnapshotPreProcessor(value);
        if (!isPlainObject(snapshot)) {
            return typeCheckFailure$$1(context, snapshot, "Value is not a plain object");
        }
        return flattenTypeErrors$$1(this.propertyNames.map(function (key) {
            return _this.properties[key].validate(snapshot[key], getContextForPath$$1(context, key, _this.properties[key]));
        }));
    };
    ModelType$$1.prototype.forAllProps = function (fn) {
        var _this = this;
        this.propertyNames.forEach(function (key) { return fn(key, _this.properties[key]); });
    };
    ModelType$$1.prototype.describe = function () {
        var _this = this;
        // optimization: cache
        return ("{ " +
            this.propertyNames.map(function (key) { return key + ": " + _this.properties[key].describe(); }).join("; ") +
            " }");
    };
    ModelType$$1.prototype.getDefaultSnapshot = function () {
        return {};
    };
    ModelType$$1.prototype.removeChild = function (node, subpath) {
        node.storedValue[subpath] = null;
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ModelType$$1.prototype, "applySnapshot", null);
    return ModelType$$1;
}(ComplexType$$1));
/**
 * Creates a new model type by providing a name, properties, volatile state and actions.
 *
 * See the [model type](https://github.com/mobxjs/mobx-state-tree#creating-models) description or the [getting started](https://github.com/mobxjs/mobx-state-tree/blob/master/docs/getting-started.md#getting-started-1) tutorial.
 *
 * @export
 * @alias types.model
 */
function model$$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var name = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
    var properties = args.shift() || {};
    return new ModelType$$1({ name: name, properties: properties });
}
/**
 * Composes a new model from one or more existing model types.
 * This method can be invoked in two forms:
 * Given 2 or more model types, the types are composed into a new Type.
 * Given first parameter as a string and 2 or more model types,
 * the types are composed into a new Type with the given name
 *
 * @export
 * @alias types.compose
 */
function compose$$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // TODO: just join the base type names if no name is provided
    var typeName = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
    // check all parameters
    if (false) {
        args.forEach(function (type) {
            if (!isType$$1(type))
                fail("expected a mobx-state-tree type, got " + type + " instead");
        });
    }
    return args
        .reduce(function (prev, cur) {
        return prev.cloneAndEnhance({
            name: prev.name + "_" + cur.name,
            properties: cur.properties,
            initializers: cur.initializers
        });
    })
        .named(typeName);
}
function tryGetOptional(type) {
    if (!type)
        return undefined;
    // we need to check for type.types since an optional union doesn't have direct subtypes
    if (type.flags & TypeFlags.Union && type.types)
        return type.types.find(tryGetOptional);
    if (type.flags & TypeFlags.Late && type.getSubType && type.getSubType(false))
        return tryGetOptional(type.subType);
    if (type.flags & TypeFlags.Optional)
        return type;
    return undefined;
}

// TODO: implement CoreType using types.custom ?
var CoreType$$1 = /** @class */ (function (_super) {
    __extends(CoreType$$1, _super);
    function CoreType$$1(name, flags, checker, initializer) {
        if (initializer === void 0) { initializer = identity; }
        var _this = _super.call(this, name) || this;
        _this.shouldAttachNode = false;
        _this.flags = flags;
        _this.checker = checker;
        _this.initializer = initializer;
        return _this;
    }
    CoreType$$1.prototype.describe = function () {
        return this.name;
    };
    CoreType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    CoreType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return this.initializer(snapshot);
    };
    CoreType$$1.prototype.isValidSnapshot = function (value, context) {
        if (isPrimitive(value) && this.checker(value)) {
            return typeCheckSuccess$$1();
        }
        var typeName = this.name === "Date" ? "Date or a unix milliseconds timestamp" : this.name;
        return typeCheckFailure$$1(context, value, "Value is not a " + typeName);
    };
    return CoreType$$1;
}(Type$$1));
/**
 * Creates a type that can only contain a string value.
 * This type is used for string values by default
 *
 * @export
 * @alias types.string
 * @example
 * const Person = types.model({
 *   firstName: types.string,
 *   lastName: "Doe"
 * })
 */
// tslint:disable-next-line:variable-name
var string$$1 = new CoreType$$1("string", TypeFlags.String, function (v) { return typeof v === "string"; });
/**
 * Creates a type that can only contain a numeric value.
 * This type is used for numeric values by default
 *
 * @export
 * @alias types.number
 * @example
 * const Vector = types.model({
 *   x: types.number,
 *   y: 1.5
 * })
 */
// tslint:disable-next-line:variable-name
var number$$1 = new CoreType$$1("number", TypeFlags.Number, function (v) { return typeof v === "number"; });
/**
 * Creates a type that can only contain an integer value.
 * This type is used for integer values by default
 *
 * @export
 * @alias types.integer
 * @example
 * const Size = types.model({
 *   width: types.integer,
 *   height: 10
 * })
 */
// tslint:disable-next-line:variable-name
var integer$$1 = new CoreType$$1("integer", TypeFlags.Integer, function (v) { return isInteger(v); });
/**
 * Creates a type that can only contain a boolean value.
 * This type is used for boolean values by default
 *
 * @export
 * @alias types.boolean
 * @example
 * const Thing = types.model({
 *   isCool: types.boolean,
 *   isAwesome: false
 * })
 */
// tslint:disable-next-line:variable-name
var boolean$$1 = new CoreType$$1("boolean", TypeFlags.Boolean, function (v) { return typeof v === "boolean"; });
/**
 * The type of the value `null`
 *
 * @export
 * @alias types.null
 */
var nullType$$1 = new CoreType$$1("null", TypeFlags.Null, function (v) { return v === null; });
/**
 * The type of the value `undefined`
 *
 * @export
 * @alias types.undefined
 */
var undefinedType$$1 = new CoreType$$1("undefined", TypeFlags.Undefined, function (v) { return v === undefined; });
/**
 * Creates a type that can only contain a javascript Date value.
 *
 * @export
 * @alias types.Date
 * @example
 * const LogLine = types.model({
 *   timestamp: types.Date,
 * })
 *
 * LogLine.create({ timestamp: new Date() })
 */
// tslint:disable-next-line:variable-name
var DatePrimitive$$1 = new CoreType$$1("Date", TypeFlags.Date, function (v) { return typeof v === "number" || v instanceof Date; }, function (v) { return (v instanceof Date ? v : new Date(v)); });
DatePrimitive$$1.getSnapshot = function (node) {
    return node.storedValue.getTime();
};
function getPrimitiveFactoryFromValue$$1(value) {
    switch (typeof value) {
        case "string":
            return string$$1;
        case "number":
            return number$$1; // In the future, isInteger(value) ? integer : number would be interesting, but would be too breaking for now
        case "boolean":
            return boolean$$1;
        case "object":
            if (value instanceof Date)
                return DatePrimitive$$1;
    }
    return fail("Cannot determine primitive type from value " + value);
}
function isPrimitiveType$$1(type) {
    return (isType$$1(type) &&
        (type.flags &
            (TypeFlags.String |
                TypeFlags.Number |
                TypeFlags.Integer |
                TypeFlags.Boolean |
                TypeFlags.Date)) >
            0);
}

var Literal$$1 = /** @class */ (function (_super) {
    __extends(Literal$$1, _super);
    function Literal$$1(value) {
        var _this = _super.call(this, JSON.stringify(value)) || this;
        _this.shouldAttachNode = false;
        _this.flags = TypeFlags.Literal;
        _this.value = value;
        return _this;
    }
    Literal$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    Literal$$1.prototype.describe = function () {
        return JSON.stringify(this.value);
    };
    Literal$$1.prototype.isValidSnapshot = function (value, context) {
        if (isPrimitive(value) && value === this.value) {
            return typeCheckSuccess$$1();
        }
        return typeCheckFailure$$1(context, value, "Value is not a literal " + JSON.stringify(this.value));
    };
    return Literal$$1;
}(Type$$1));
/**
 * The literal type will return a type that will match only the exact given type.
 * The given value must be a primitive, in order to be serialized to a snapshot correctly.
 * You can use literal to match exact strings for example the exact male or female string.
 *
 * @example
 * const Person = types.model({
 *     name: types.string,
 *     gender: types.union(types.literal('male'), types.literal('female'))
 * })
 *
 * @export
 * @alias types.literal
 * @template S
 * @param {S} value The value to use in the strict equal check
 * @returns {ISimpleType<S>}
 */
function literal$$1(value) {
    // check that the given value is a primitive
    if (false) {
        if (!isPrimitive(value))
            fail("Literal types can be built only on top of primitives");
    }
    return new Literal$$1(value);
}

var Refinement$$1 = /** @class */ (function (_super) {
    __extends(Refinement$$1, _super);
    function Refinement$$1(name, type, predicate, message) {
        var _this = _super.call(this, name) || this;
        _this.type = type;
        _this.predicate = predicate;
        _this.message = message;
        return _this;
    }
    Object.defineProperty(Refinement$$1.prototype, "flags", {
        get: function () {
            return this.type.flags | TypeFlags.Refinement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Refinement$$1.prototype, "shouldAttachNode", {
        get: function () {
            return this.type.shouldAttachNode;
        },
        enumerable: true,
        configurable: true
    });
    Refinement$$1.prototype.describe = function () {
        return this.name;
    };
    Refinement$$1.prototype.instantiate = function (parent, subpath, environment, value) {
        // create the child type
        var inst = this.type.instantiate(parent, subpath, environment, value);
        return inst;
    };
    Refinement$$1.prototype.isAssignableFrom = function (type) {
        return this.type.isAssignableFrom(type);
    };
    Refinement$$1.prototype.isValidSnapshot = function (value, context) {
        var subtypeErrors = this.type.validate(value, context);
        if (subtypeErrors.length > 0)
            return subtypeErrors;
        var snapshot = isStateTreeNode$$1(value) ? getStateTreeNode$$1(value).snapshot : value;
        if (!this.predicate(snapshot)) {
            return typeCheckFailure$$1(context, value, this.message(value));
        }
        return typeCheckSuccess$$1();
    };
    return Refinement$$1;
}(Type$$1));
/**
 * `types.refinement(baseType, (snapshot) => boolean)` creates a type that is more specific than the base type, e.g. `types.refinement(types.string, value => value.length > 5)` to create a type of strings that can only be longer then 5.
 *
 * @export
 * @alias types.refinement
 * @template T
 * @param {string} name
 * @param {IType<T, T>} type
 * @param {(snapshot: T) => boolean} predicate
 * @returns {IType<T, T>}
 */
function refinement$$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var name = typeof args[0] === "string" ? args.shift() : isType$$1(args[0]) ? args[0].name : null;
    var type = args[0];
    var predicate = args[1];
    var message = args[2]
        ? args[2]
        : function (v) { return "Value does not respect the refinement predicate"; };
    // ensures all parameters are correct
    if (false) {
        if (typeof name !== "string")
            fail("expected a string as first argument, got " + name + " instead");
        if (!isType$$1(type))
            fail("expected a mobx-state-tree type as first or second argument, got " +
                type +
                " instead");
        if (typeof predicate !== "function")
            fail("expected a function as third argument, got " + predicate + " instead");
        if (typeof message !== "function")
            fail("expected a function as fourth argument, got " + message + " instead");
    }
    return new Refinement$$1(name, type, predicate, message);
}

/**
 * Can be used to create an string based enumeration.
 * (note: this methods is just sugar for a union of string literals)
 *
 * @example
 * const TrafficLight = types.model({
 *   color: types.enumeration("Color", ["Red", "Orange", "Green"])
 * })
 *
 * @export
 * @alias types.enumeration
 * @param {string} name descriptive name of the enumeration (optional)
 * @param {string[]} options possible values this enumeration can have
 * @returns {ISimpleType<string>}
 */
function enumeration$$1(name, options) {
    var realOptions = typeof name === "string" ? options : name;
    // check all options
    if (false) {
        realOptions.forEach(function (option) {
            if (typeof option !== "string")
                fail("expected all options to be string, got " + type + " instead");
        });
    }
    var type = union$$1.apply(void 0, realOptions.map(function (option) { return literal$$1("" + option); }));
    if (typeof name === "string")
        type.name = name;
    return type;
}

var Union$$1 = /** @class */ (function (_super) {
    __extends(Union$$1, _super);
    function Union$$1(name, types, options) {
        var _this = _super.call(this, name) || this;
        _this.eager = true;
        _this.dispatcher = options && options.dispatcher;
        if (options && !options.eager)
            _this.eager = false;
        _this.types = types;
        return _this;
    }
    Object.defineProperty(Union$$1.prototype, "flags", {
        get: function () {
            var result = TypeFlags.Union;
            this.types.forEach(function (type) {
                result |= type.flags;
            });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Union$$1.prototype, "shouldAttachNode", {
        get: function () {
            return this.types.some(function (type) { return type.shouldAttachNode; });
        },
        enumerable: true,
        configurable: true
    });
    Union$$1.prototype.isAssignableFrom = function (type) {
        return this.types.some(function (subType) { return subType.isAssignableFrom(type); });
    };
    Union$$1.prototype.describe = function () {
        return "(" + this.types.map(function (factory) { return factory.describe(); }).join(" | ") + ")";
    };
    Union$$1.prototype.instantiate = function (parent, subpath, environment, value) {
        var type = this.determineType(value);
        if (!type)
            return fail("No matching type for union " + this.describe()); // can happen in prod builds
        return type.instantiate(parent, subpath, environment, value);
    };
    Union$$1.prototype.reconcile = function (current, newValue) {
        var type = this.determineType(newValue);
        if (!type)
            return fail("No matching type for union " + this.describe()); // can happen in prod builds
        return type.reconcile(current, newValue);
    };
    Union$$1.prototype.determineType = function (value) {
        // try the dispatcher, if defined
        if (this.dispatcher) {
            return this.dispatcher(value);
        }
        // find the most accomodating type
        return this.types.find(function (type) { return type.is(value); });
    };
    Union$$1.prototype.isValidSnapshot = function (value, context) {
        if (this.dispatcher) {
            return this.dispatcher(value).validate(value, context);
        }
        var allErrors = [];
        var applicableTypes = 0;
        for (var i = 0; i < this.types.length; i++) {
            var type = this.types[i];
            var errors = type.validate(value, context);
            if (errors.length === 0) {
                if (this.eager)
                    return typeCheckSuccess$$1();
                else
                    applicableTypes++;
            }
            else {
                allErrors.push(errors);
            }
        }
        if (applicableTypes === 1)
            return typeCheckSuccess$$1();
        return typeCheckFailure$$1(context, value, "No type is applicable for the union").concat(flattenTypeErrors$$1(allErrors));
    };
    return Union$$1;
}(Type$$1));
/**
 * types.union(dispatcher?, types...) create a union of multiple types. If the correct type cannot be inferred unambiguously from a snapshot, provide a dispatcher function of the form (snapshot) => Type.
 *
 * @export
 * @alias types.union
 * @param {(ITypeDispatcher | IAnyType)} optionsOrType
 * @param {...IAnyType[]} otherTypes
 * @returns {IAnyType}
 */
function union$$1(optionsOrType) {
    var otherTypes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherTypes[_i - 1] = arguments[_i];
    }
    var options = isType$$1(optionsOrType) ? undefined : optionsOrType;
    var types = isType$$1(optionsOrType) ? [optionsOrType].concat(otherTypes) : otherTypes;
    var name = "(" + types.map(function (type) { return type.name; }).join(" | ") + ")";
    // check all options
    if (false) {
        if (!isType$$1(optionsOrType) && !isPlainObject(optionsOrType))
            fail("First argument to types.union should either be a type, or an objects object of the form: { eager?: boolean, dispatcher?: Function }");
        types.forEach(function (type) {
            if (!isType$$1(type))
                fail("expected all possible types to be a mobx-state-tree type, got " +
                    type +
                    " instead");
        });
    }
    return new Union$$1(name, types, options);
}

var OptionalValue$$1 = /** @class */ (function (_super) {
    __extends(OptionalValue$$1, _super);
    function OptionalValue$$1(type, defaultValue) {
        var _this = _super.call(this, type.name) || this;
        _this.type = type;
        _this.defaultValue = defaultValue;
        return _this;
    }
    Object.defineProperty(OptionalValue$$1.prototype, "flags", {
        get: function () {
            return this.type.flags | TypeFlags.Optional;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OptionalValue$$1.prototype, "shouldAttachNode", {
        get: function () {
            return this.type.shouldAttachNode;
        },
        enumerable: true,
        configurable: true
    });
    OptionalValue$$1.prototype.describe = function () {
        return this.type.describe() + "?";
    };
    OptionalValue$$1.prototype.instantiate = function (parent, subpath, environment, value) {
        if (typeof value === "undefined") {
            var defaultSnapshot = this.getDefaultValueSnapshot();
            return this.type.instantiate(parent, subpath, environment, defaultSnapshot);
        }
        return this.type.instantiate(parent, subpath, environment, value);
    };
    OptionalValue$$1.prototype.reconcile = function (current, newValue) {
        return this.type.reconcile(current, this.type.is(newValue) && newValue !== undefined ? newValue : this.getDefaultValue());
    };
    OptionalValue$$1.prototype.getDefaultValue = function () {
        var defaultValue = typeof this.defaultValue === "function" ? this.defaultValue() : this.defaultValue;
        if (typeof this.defaultValue === "function")
            typecheck$$1(this, defaultValue);
        return defaultValue;
    };
    OptionalValue$$1.prototype.getDefaultValueSnapshot = function () {
        var defaultValue = this.getDefaultValue();
        return isStateTreeNode$$1(defaultValue)
            ? getStateTreeNode$$1(defaultValue).snapshot
            : defaultValue;
    };
    OptionalValue$$1.prototype.isValidSnapshot = function (value, context) {
        // defaulted values can be skipped
        if (value === undefined) {
            return typeCheckSuccess$$1();
        }
        // bounce validation to the sub-type
        return this.type.validate(value, context);
    };
    OptionalValue$$1.prototype.isAssignableFrom = function (type) {
        return this.type.isAssignableFrom(type);
    };
    return OptionalValue$$1;
}(Type$$1));
/**
 * `types.optional` can be used to create a property with a default value.
 * If the given value is not provided in the snapshot, it will default to the provided `defaultValue`.
 * If `defaultValue` is a function, the function will be invoked for every new instance.
 * Applying a snapshot in which the optional value is _not_ present, causes the value to be reset
 *
 * @example
 * const Todo = types.model({
 *   title: types.optional(types.string, "Test"),
 *   done: types.optional(types.boolean, false),
 *   created: types.optional(types.Date, () => new Date())
 * })
 *
 * // it is now okay to omit 'created' and 'done'. created will get a freshly generated timestamp
 * const todo = Todo.create({ title: "Get coffee "})
 *
 * @export
 * @alias types.optional
 */
function optional$$1(type, defaultValueOrFunction) {
    if (false) {
        if (!isType$$1(type))
            fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
        var defaultValue = typeof defaultValueOrFunction === "function"
            ? defaultValueOrFunction()
            : defaultValueOrFunction;
        var defaultSnapshot = isStateTreeNode$$1(defaultValue)
            ? getStateTreeNode$$1(defaultValue).snapshot
            : defaultValue;
        typecheck$$1(type, defaultSnapshot);
    }
    return new OptionalValue$$1(type, defaultValueOrFunction);
}

var optionalUndefinedType = optional$$1(undefinedType$$1, undefined);
var optionalNullType = optional$$1(nullType$$1, null);
/**
 * Maybe will make a type nullable, and also optional.
 * The value `undefined` will be used to represent nullability.
 *
 * @export
 * @alias types.maybe
 * @template C
 * @template S
 * @template T
 * @param {IType<C, S, M>} type The type to make nullable
 * @returns {(IType<C | undefined, S | undefined, T | undefined>)}
 */
function maybe$$1(type) {
    if (false)
        fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
    return union$$1(type, optionalUndefinedType);
}
/**
 * Maybe will make a type nullable, and also optional.
 * The value `null` will be used to represent no value.
 *
 * @export
 * @alias types.maybeNull
 * @template C
 * @template S
 * @template T
 * @param {IType<C, S, M>} type The type to make nullable
 * @returns {(IType<C | null | undefined, S | null, T | null>)}
 */
function maybeNull$$1(type) {
    if (false)
        fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
    return union$$1(type, optionalNullType);
}

var Late$$1 = /** @class */ (function (_super) {
    __extends(Late$$1, _super);
    function Late$$1(name, definition) {
        var _this = _super.call(this, name) || this;
        _this._subType = null;
        _this.definition = definition;
        return _this;
    }
    Object.defineProperty(Late$$1.prototype, "flags", {
        get: function () {
            return (this._subType ? this._subType.flags : 0) | TypeFlags.Late;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Late$$1.prototype, "shouldAttachNode", {
        get: function () {
            return this.getSubType(true).shouldAttachNode;
        },
        enumerable: true,
        configurable: true
    });
    Late$$1.prototype.getSubType = function (mustSucceed) {
        if (this._subType === null) {
            var t = undefined;
            try {
                t = this.definition();
            }
            catch (e) {
                if (e instanceof ReferenceError)
                    // can happen in strict ES5 code when a definition is self refering
                    t = undefined;
                else
                    throw e;
            }
            if (mustSucceed && t === undefined)
                fail("Late type seems to be used too early, the definition (still) returns undefined");
            if (t) {
                if (false)
                    fail("Failed to determine subtype, make sure types.late returns a type definition.");
                this._subType = t;
                return t;
            }
        }
        return this._subType;
    };
    Late$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return this.getSubType(true).instantiate(parent, subpath, environment, snapshot);
    };
    Late$$1.prototype.reconcile = function (current, newValue) {
        return this.getSubType(true).reconcile(current, newValue);
    };
    Late$$1.prototype.describe = function () {
        var t = this.getSubType(false);
        return t ? t.name : "<uknown late type>";
    };
    Late$$1.prototype.isValidSnapshot = function (value, context) {
        var t = this.getSubType(false);
        if (!t) {
            // See #916; the variable the definition closure is pointing to wasn't defined yet, so can't be evaluted yet here
            return typeCheckSuccess$$1();
        }
        return t.validate(value, context);
    };
    Late$$1.prototype.isAssignableFrom = function (type) {
        var t = this.getSubType(false);
        return t ? t.isAssignableFrom(type) : false;
    };
    return Late$$1;
}(Type$$1));
/**
 * Defines a type that gets implemented later. This is useful when you have to deal with circular dependencies.
 * Please notice that when defining circular dependencies TypeScript isn't smart enough to inference them.
 * You need to declare an interface to explicit the return type of the late parameter function.
 *
 * @example
 *  interface INode {
 *       childs: INode[]
 *  }
 *
 *   // TypeScript is'nt smart enough to infer self referencing types.
 *  const Node = types.model({
 *       childs: types.optional(types.array(types.late<any, INode>(() => Node)), [])
 *  })
 *
 * @export
 * @alias types.late
 * @template S
 * @template T
 * @param {string} [name] The name to use for the type that will be returned.
 * @param {ILateType<S, T>} type A function that returns the type that will be defined.
 * @returns {IType<S, T>}
 */
function late$$1(nameOrType, maybeType) {
    var name = typeof nameOrType === "string" ? nameOrType : "late(" + nameOrType.toString() + ")";
    var type = typeof nameOrType === "string" ? maybeType : nameOrType;
    // checks that the type is actually a late type
    if (false) {
        if (!(typeof type === "function" && type.length === 0))
            fail("Invalid late type, expected a function with zero arguments that returns a type, got: " +
                type);
    }
    return new Late$$1(name, type);
}

var Frozen$$1 = /** @class */ (function (_super) {
    __extends(Frozen$$1, _super);
    function Frozen$$1(subType) {
        var _this = _super.call(this, subType ? "frozen(" + subType.name + ")" : "frozen") || this;
        _this.subType = subType;
        _this.shouldAttachNode = false;
        _this.flags = TypeFlags.Frozen;
        return _this;
    }
    Frozen$$1.prototype.describe = function () {
        return "<any immutable value>";
    };
    Frozen$$1.prototype.instantiate = function (parent, subpath, environment, value) {
        // create the node
        return createNode$$1(this, parent, subpath, environment, deepFreeze(value));
    };
    Frozen$$1.prototype.isValidSnapshot = function (value, context) {
        if (!isSerializable(value)) {
            return typeCheckFailure$$1(context, value, "Value is not serializable and cannot be frozen");
        }
        if (this.subType)
            return this.subType.validate(value, context);
        return typeCheckSuccess$$1();
    };
    return Frozen$$1;
}(Type$$1));
var untypedFrozenInstance = new Frozen$$1();
/**
 * Frozen can be used to store any value that is serializable in itself (that is valid JSON).
 * Frozen values need to be immutable or treated as if immutable. They need be serializable as well.
 * Values stored in frozen will snapshotted as-is by MST, and internal changes will not be tracked.
 *
 * This is useful to store complex, but immutable values like vectors etc. It can form a powerful bridge to parts of your application that should be immutable, or that assume data to be immutable.
 *
 * Note: if you want to store free-form state that is mutable, or not serializeable, consider using volatile state instead.
 *
 * Frozen properties can be defined in three different ways
 * 1. `types.frozen(SubType)` - provide a valid MST type and frozen will check if the provided data conforms the snapshot for that type
 * 2. `types.frozen({ someDefaultValue: true})` - provide a primitive value, object or array, and MST will infer the type from that object, and also make it the default value for the field
 * 3. `types.frozen<TypeScriptType>()` - provide a typescript type, to help in strongly typing the field (design time only)
 *
 * @example
 * const GameCharacter = types.model({
 *   name: string,
 *   location: types.frozen({ x: 0, y: 0})
 * })
 *
 * const hero = GameCharacter.create({
 *   name: "Mario",
 *   location: { x: 7, y: 4 }
 * })
 *
 * hero.location = { x: 10, y: 2 } // OK
 * hero.location.x = 7 // Not ok!
 *
 * @example
 * type Point = { x: number, y: number }
 *    const Mouse = types.model({
 *         loc: types.frozen<Point>()
 *    })
 *
 * @alias types.frozen
 * @param {Type|value} defaultValueOrType
 * @returns {Type}
 */
function frozen$$1(arg) {
    if (arguments.length === 0)
        return untypedFrozenInstance;
    else if (isType$$1(arg))
        return new Frozen$$1(arg);
    else
        return optional$$1(untypedFrozenInstance, arg);
}

var StoredReference = /** @class */ (function () {
    function StoredReference(mode, value, targetType) {
        this.mode = mode;
        this.value = value;
        this.targetType = targetType;
        if (mode === "object") {
            if (!isStateTreeNode$$1(value))
                return fail("Can only store references to tree nodes, got: '" + value + "'");
            var targetNode = getStateTreeNode$$1(value);
            if (!targetNode.identifierAttribute)
                return fail("Can only store references with a defined identifier attribute.");
        }
    }
    Object.defineProperty(StoredReference.prototype, "resolvedValue", {
        get: function () {
            // reference was initialized with the identifier of the target
            var _a = this, node = _a.node, targetType = _a.targetType;
            var target = node.root.identifierCache.resolve(targetType, this.value);
            if (!target)
                return fail("Failed to resolve reference '" + this.value + "' to type '" + this.targetType.name + "' (from node: " + node.path + ")");
            return target.value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], StoredReference.prototype, "resolvedValue", null);
    return StoredReference;
}());
var BaseReferenceType$$1 = /** @class */ (function (_super) {
    __extends(BaseReferenceType$$1, _super);
    function BaseReferenceType$$1(targetType) {
        var _this = _super.call(this, "reference(" + targetType.name + ")") || this;
        _this.targetType = targetType;
        _this.shouldAttachNode = false;
        _this.flags = TypeFlags.Reference;
        return _this;
    }
    BaseReferenceType$$1.prototype.describe = function () {
        return this.name;
    };
    BaseReferenceType$$1.prototype.isAssignableFrom = function (type) {
        return this.targetType.isAssignableFrom(type);
    };
    BaseReferenceType$$1.prototype.isValidSnapshot = function (value, context) {
        return typeof value === "string" || typeof value === "number"
            ? typeCheckSuccess$$1()
            : typeCheckFailure$$1(context, value, "Value is not a valid identifier, which is a string or a number");
    };
    return BaseReferenceType$$1;
}(Type$$1));
var IdentifierReferenceType$$1 = /** @class */ (function (_super) {
    __extends(IdentifierReferenceType$$1, _super);
    function IdentifierReferenceType$$1(targetType) {
        return _super.call(this, targetType) || this;
    }
    IdentifierReferenceType$$1.prototype.getValue = function (node) {
        if (!node.isAlive)
            return undefined;
        var ref = node.storedValue;
        // id already resolved, return
        if (ref.mode === "object")
            return ref.value;
        return ref.resolvedValue;
    };
    IdentifierReferenceType$$1.prototype.getSnapshot = function (node) {
        var ref = node.storedValue;
        switch (ref.mode) {
            case "identifier":
                return ref.value;
            case "object":
                return ref.value[getStateTreeNode$$1(ref.value).identifierAttribute];
        }
    };
    IdentifierReferenceType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        var mode = isStateTreeNode$$1(snapshot) ? "object" : "identifier";
        var r;
        var node = createNode$$1(this, parent, subpath, environment, (r = new StoredReference(mode, snapshot, this.targetType)));
        r.node = node;
        return node;
    };
    IdentifierReferenceType$$1.prototype.reconcile = function (current, newValue) {
        if (current.type === this) {
            var targetMode = isStateTreeNode$$1(newValue) ? "object" : "identifier";
            var ref = current.storedValue;
            if (targetMode === ref.mode && ref.value === newValue)
                return current;
        }
        var newNode = this.instantiate(current.parent, current.subpath, current._environment, newValue);
        current.die();
        return newNode;
    };
    return IdentifierReferenceType$$1;
}(BaseReferenceType$$1));
var CustomReferenceType$$1 = /** @class */ (function (_super) {
    __extends(CustomReferenceType$$1, _super);
    function CustomReferenceType$$1(targetType, options) {
        var _this = _super.call(this, targetType) || this;
        _this.options = options;
        return _this;
    }
    CustomReferenceType$$1.prototype.getValue = function (node) {
        if (!node.isAlive)
            return undefined;
        return this.options.get(node.storedValue, node.parent ? node.parent.storedValue : null);
    };
    CustomReferenceType$$1.prototype.getSnapshot = function (node) {
        return node.storedValue;
    };
    CustomReferenceType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        var identifier$$1 = isStateTreeNode$$1(snapshot)
            ? this.options.set(snapshot, parent ? parent.storedValue : null)
            : snapshot;
        return createNode$$1(this, parent, subpath, environment, identifier$$1);
    };
    CustomReferenceType$$1.prototype.reconcile = function (current, snapshot) {
        var newIdentifier = isStateTreeNode$$1(snapshot)
            ? this.options.set(snapshot, current ? current.storedValue : null)
            : snapshot;
        if (current.type === this) {
            if (current.storedValue === newIdentifier)
                return current;
        }
        var newNode = this.instantiate(current.parent, current.subpath, current._environment, newIdentifier);
        current.die();
        return newNode;
    };
    return CustomReferenceType$$1;
}(BaseReferenceType$$1));
/**
 * Creates a reference to another type, which should have defined an identifier.
 * See also the [reference and identifiers](https://github.com/mobxjs/mobx-state-tree#references-and-identifiers) section.
 *
 * @export
 * @alias types.reference
 */
function reference$$1(subType, options) {
    // check that a type is given
    if (false) {
        if (!isType$$1(subType))
            fail("expected a mobx-state-tree type as first argument, got " + subType + " instead");
        if (arguments.length === 2 && typeof arguments[1] === "string")
            fail("References with base path are no longer supported. Please remove the base path.");
    }
    // as any because getValue might actually return undefined if the node is not alive
    if (options)
        return new CustomReferenceType$$1(subType, options);
    else
        return new IdentifierReferenceType$$1(subType);
}

var IdentifierType$$1 = /** @class */ (function (_super) {
    __extends(IdentifierType$$1, _super);
    function IdentifierType$$1() {
        var _this = _super.call(this, "identifier") || this;
        _this.shouldAttachNode = false;
        _this.flags = TypeFlags.Identifier;
        return _this;
    }
    IdentifierType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        if (!parent || !(parent.type instanceof ModelType$$1))
            fail("Identifier types can only be instantiated as direct child of a model type");
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    IdentifierType$$1.prototype.reconcile = function (current, newValue) {
        if (current.storedValue !== newValue)
            return fail("Tried to change identifier from '" + current.storedValue + "' to '" + newValue + "'. Changing identifiers is not allowed.");
        return current;
    };
    IdentifierType$$1.prototype.describe = function () {
        return "identifier";
    };
    IdentifierType$$1.prototype.isValidSnapshot = function (value, context) {
        if (typeof value !== "string") {
            return typeCheckFailure$$1(context, value, "Value is not a valid identifier, expected a string");
        }
        return typeCheckSuccess$$1();
    };
    return IdentifierType$$1;
}(Type$$1));
var IdentifierNumberType$$1 = /** @class */ (function (_super) {
    __extends(IdentifierNumberType$$1, _super);
    function IdentifierNumberType$$1() {
        var _this = _super.call(this) || this;
        _this.name = "identifierNumber";
        return _this;
    }
    IdentifierNumberType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return _super.prototype.instantiate.call(this, parent, subpath, environment, snapshot);
    };
    IdentifierNumberType$$1.prototype.isValidSnapshot = function (value, context) {
        if (typeof value === "number") {
            return typeCheckSuccess$$1();
        }
        return typeCheckFailure$$1(context, value, "Value is not a valid identifierNumber, expected a number");
    };
    IdentifierNumberType$$1.prototype.reconcile = function (current, newValue) {
        return _super.prototype.reconcile.call(this, current, newValue);
    };
    IdentifierNumberType$$1.prototype.getSnapshot = function (node) {
        return node.storedValue;
    };
    IdentifierNumberType$$1.prototype.describe = function () {
        return "identifierNumber";
    };
    return IdentifierNumberType$$1;
}(IdentifierType$$1));
/**
 * Identifiers are used to make references, lifecycle events and reconciling works.
 * Inside a state tree, for each type can exist only one instance for each given identifier.
 * For example there couldn't be 2 instances of user with id 1. If you need more, consider using references.
 * Identifier can be used only as type property of a model.
 * This type accepts as parameter the value type of the identifier field that can be either string or number.
 *
 * @example
 *  const Todo = types.model("Todo", {
 *      id: types.identifier,
 *      title: types.string
 *  })
 *
 * @export
 * @alias types.identifier
 * @template T
 * @returns {IType<T, T>}
 */
var identifier$$1 = new IdentifierType$$1();
/**
 * Similar to `types.identifier`, but `identifierNumber` will serialize from / to a number when applying snapshots
 *
 * @example
 *  const Todo = types.model("Todo", {
 *      id: types.identifierNumber,
 *      title: types.string
 *  })
 *
 * @export
 * @alias types.identifierNumber
 * @template T
 * @returns {IType<T, T>}
 */
var identifierNumber$$1 = new IdentifierNumberType$$1();

/**
 * Creates a custom type. Custom types can be used for arbitrary immutable values, that have a serializable representation. For example, to create your own Date representation, Decimal type etc.
 *
 * The signature of the options is:
 *
 * ```javascript
 * export interface CustomTypeOptions<S, T> {
 *     // Friendly name
 *     name: string
 *     // given a serialized value, how to turn it into the target type
 *     fromSnapshot(snapshot: S): T
 *     // return the serialization of the current value
 *     toSnapshot(value: T): S
 *     // if true, this is a converted value, if false, it's a snapshot
 *     isTargetType(value: T | S): boolean
 *     // a non empty string is assumed to be a validation error
 *     getValidationMessage?(snapshot: S): string
 * }
 * ```
 *
 * @export
 * @alias types.custom
 *
 * @example
 * const DecimalPrimitive = types.custom<string, Decimal>({
 *     name: "Decimal",
 *     fromSnapshot(value: string) {
 *         return new Decimal(value)
 *     },
 *     toSnapshot(value: Decimal) {
 *         return value.toString()
 *     },
 *     isTargetType(value: string | Decimal): boolean {
 *         return value instanceof Decimal
 *     },
 *     getValidationMessage(value: string): string {
 *         if (/^-?\d+\.\d+$/.test(value)) return "" // OK
 *         return `'${value}' doesn't look like a valid decimal number`
 *     }
 * })
 *
 * const Wallet = types.model({
 *     balance: DecimalPrimitive
 * })
 */
function custom$$1(options) {
    return new CustomType$$1(options);
}
var CustomType$$1 = /** @class */ (function (_super) {
    __extends(CustomType$$1, _super);
    function CustomType$$1(options) {
        var _this = _super.call(this, options.name) || this;
        _this.options = options;
        _this.flags = TypeFlags.Reference;
        _this.shouldAttachNode = false;
        return _this;
    }
    CustomType$$1.prototype.describe = function () {
        return this.name;
    };
    CustomType$$1.prototype.isAssignableFrom = function (type) {
        return type === this;
    };
    CustomType$$1.prototype.isValidSnapshot = function (value, context) {
        if (this.options.isTargetType(value))
            return typeCheckSuccess$$1();
        var typeError = this.options.getValidationMessage(value);
        if (typeError) {
            return typeCheckFailure$$1(context, value, "Invalid value for type '" + this.name + "': " + typeError);
        }
        return typeCheckSuccess$$1();
    };
    CustomType$$1.prototype.getValue = function (node) {
        if (!node.isAlive)
            return undefined;
        return node.storedValue;
    };
    CustomType$$1.prototype.getSnapshot = function (node) {
        return this.options.toSnapshot(node.storedValue);
    };
    CustomType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        var valueToStore = this.options.isTargetType(snapshot)
            ? snapshot
            : this.options.fromSnapshot(snapshot);
        return createNode$$1(this, parent, subpath, environment, valueToStore);
    };
    CustomType$$1.prototype.reconcile = function (current, value) {
        var isSnapshot = !this.options.isTargetType(value);
        var unchanged = current.type === this &&
            (isSnapshot ? value === current.snapshot : value === current.storedValue);
        if (unchanged)
            return current;
        var valueToStore = isSnapshot ? this.options.fromSnapshot(value) : value;
        var newNode = this.instantiate(current.parent, current.subpath, current._environment, valueToStore);
        current.die();
        return newNode;
    };
    return CustomType$$1;
}(Type$$1));

/*
 * All imports / exports should be proxied through this file.
 * Why? It gives us full control over the module load order, preventing circular dependency isses
 */

/* all code is initially loaded through internal, to avoid circular dep issues */
var types = {
    enumeration: enumeration$$1,
    model: model$$1,
    compose: compose$$1,
    custom: custom$$1,
    reference: reference$$1,
    union: union$$1,
    optional: optional$$1,
    literal: literal$$1,
    maybe: maybe$$1,
    maybeNull: maybeNull$$1,
    refinement: refinement$$1,
    string: string$$1,
    boolean: boolean$$1,
    number: number$$1,
    integer: integer$$1,
    Date: DatePrimitive$$1,
    map: map$$1,
    array: array$$1,
    frozen: frozen$$1,
    identifier: identifier$$1,
    identifierNumber: identifierNumber$$1,
    late: late$$1,
    undefined: undefinedType$$1,
    null: nullType$$1
};



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(277).setImmediate))

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Col; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return Navbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return NavbarBrand; });
/* unused harmony export NavbarToggler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return Nav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return NavItem; });
/* unused harmony export NavDropdown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return NavLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Breadcrumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BreadcrumbItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ButtonGroup; });
/* unused harmony export ButtonToolbar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Dropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DropdownItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DropdownToggle; });
/* unused harmony export Fade */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Badge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Card; });
/* unused harmony export CardLink */
/* unused harmony export CardGroup */
/* unused harmony export CardDeck */
/* unused harmony export CardColumns */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CardBody; });
/* unused harmony export CardBlock */
/* unused harmony export CardFooter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CardHeader; });
/* unused harmony export CardImg */
/* unused harmony export CardImgOverlay */
/* unused harmony export Carousel */
/* unused harmony export UncontrolledCarousel */
/* unused harmony export CarouselControl */
/* unused harmony export CarouselItem */
/* unused harmony export CarouselIndicators */
/* unused harmony export CarouselCaption */
/* unused harmony export CardSubtitle */
/* unused harmony export CardText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CardTitle; });
/* unused harmony export Popover */
/* unused harmony export PopoverContent */
/* unused harmony export PopoverBody */
/* unused harmony export PopoverTitle */
/* unused harmony export PopoverHeader */
/* unused harmony export Progress */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return ModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ModalFooter; });
/* unused harmony export PopperContent */
/* unused harmony export PopperTargetHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return Tooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return Table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ListGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FormFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FormGroup; });
/* unused harmony export FormText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return InputGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return InputGroupAddon; });
/* unused harmony export InputGroupButton */
/* unused harmony export InputGroupButtonDropdown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return InputGroupText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return Label; });
/* unused harmony export CustomInput */
/* unused harmony export Media */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return Pagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PaginationItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PaginationLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return TabContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return TabPane; });
/* unused harmony export Jumbotron */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Collapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ListGroupItem; });
/* unused harmony export ListGroupItemText */
/* unused harmony export ListGroupItemHeading */
/* unused harmony export UncontrolledAlert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return UncontrolledButtonDropdown; });
/* unused harmony export UncontrolledCollapse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return UncontrolledDropdown; });
/* unused harmony export UncontrolledNavDropdown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return UncontrolledTooltip; });
/* unused harmony export Util */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(399);










// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);

  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

var globalCssModule = void 0;

function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}

function mapToCssModules() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cssModule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalCssModule;

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key = void 0;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }
    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
    }

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(undefined, [props, propName, componentName].concat(rest));
  };
}

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150, // $transition-fade
  Collapse: 350, // $transition-collapse
  Modal: 300, // $modal-transition
  Carousel: 600 // $carousel-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40
};

var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function findDOMElements(target) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(target)) {
    return target();
  }
  if (typeof target === 'string' && canUseDOM) {
    var selection = document.querySelectorAll(target);
    if (!selection.length) {
      selection = document.querySelectorAll('#' + target);
    }
    if (!selection.length) {
      throw new Error('The target \'' + target + '\' could not be identified in the dom, tip: check spelling');
    }
    return selection;
  }
  return target;
}

function isArrayOrNodeList(els) {
  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}

function getTarget(target) {
  var els = findDOMElements(target);
  if (isArrayOrNodeList(els)) {
    return els[0];
  }
  return els;
}

var defaultToggleEvents = ['touchstart', 'click'];

function addMultipleEventListeners(_els, handler, _events) {
  var els = _els;
  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  var events = _events;
  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error('\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ');
  }
  events.forEach(function (event) {
    els.forEach(function (el) {
      el.addEventListener(event, handler);
    });
  });
  return function removeEvents() {
    events.forEach(function (event) {
      els.forEach(function (el) {
        el.removeEventListener(event, handler);
      });
    });
  };
}

var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];

var utils = Object.freeze({
	getScrollbarWidth: getScrollbarWidth,
	setScrollbarWidth: setScrollbarWidth,
	isBodyOverflowing: isBodyOverflowing,
	getOriginalBodyPadding: getOriginalBodyPadding,
	conditionallyUpdateScrollbar: conditionallyUpdateScrollbar,
	setGlobalCssModule: setGlobalCssModule,
	mapToCssModules: mapToCssModules,
	omit: omit,
	pick: pick,
	warnOnce: warnOnce,
	deprecated: deprecated,
	DOMElement: DOMElement,
	TransitionTimeouts: TransitionTimeouts,
	TransitionPropTypeKeys: TransitionPropTypeKeys,
	TransitionStatuses: TransitionStatuses,
	keyCodes: keyCodes,
	PopperPlacements: PopperPlacements,
	canUseDOM: canUseDOM,
	findDOMElements: findDOMElements,
	isArrayOrNodeList: isArrayOrNodeList,
	getTarget: getTarget,
	defaultToggleEvents: defaultToggleEvents,
	addMultipleEventListeners: addMultipleEventListeners,
	focusableElements: focusableElements
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + expand;
};

// To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.
var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'expand', 'className', 'cssModule', 'light', 'dark', 'inverse', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: mapToCssModules('navbar-toggler-icon', cssModule) })
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return 'flex-' + vertical + '-column';
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'horizontal', 'justified', 'fill', 'navbar', 'card', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? 'justify-content-' + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$8 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "direction" with the value "up".'),
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']),
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setActiveFromChild: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$8 = {
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false,
  setActiveFromChild: false
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen,
        direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
        inNavbar: this.props.inNavbar
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();

      if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }

      this.toggle(e);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if (keyCodes.tab === e.which || /button/i.test(e.target.tagName) && e.which === keyCodes.space || /input|textarea/i.test(e.target.tagName)) {
        return;
      }

      e.preventDefault();
      if (this.props.disabled) return;

      var container = this.getContainer();

      if (e.which === keyCodes.space && this.props.isOpen && container !== e.target) {
        e.target.click();
      }

      if (e.which === keyCodes.esc || !this.props.isOpen) {
        this.toggle(e);
        container.querySelector('[aria-expanded]').focus();
        return;
      }

      var menuClass = mapToCssModules('dropdown-menu', this.props.cssModule);
      var itemClass = mapToCssModules('dropdown-item', this.props.cssModule);
      var disabledClass = mapToCssModules('disabled', this.props.cssModule);

      var items = container.querySelectorAll('.' + menuClass + ' .' + itemClass + ':not(.' + disabledClass + ')');
      if (!items.length) return;

      var index = -1;

      var charPressed = String.fromCharCode(e.which).toLowerCase();

      for (var i = 0; i < items.length; i += 1) {
        var firstLetter = items[i].textContent && items[i].textContent[0].toLowerCase();
        if (firstLetter === charPressed || items[i] === e.target) {
          index = i;
          break;
        }
      }

      if (e.which === keyCodes.up && index > 0) {
        index -= 1;
      }

      if (e.which === keyCodes.down && index < items.length - 1) {
        index += 1;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'direction']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          isOpen = _omit.isOpen,
          group = _omit.group,
          size = _omit.size,
          nav = _omit.nav,
          setActiveFromChild = _omit.setActiveFromChild,
          active = _omit.active,
          addonType = _omit.addonType,
          attrs = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'isOpen', 'group', 'size', 'nav', 'setActiveFromChild', 'active', 'addonType']);

      var direction = this.props.direction === 'down' && dropup ? 'up' : this.props.direction;

      attrs.tag = attrs.tag || (nav ? 'li' : 'div');

      var subItemIsActive = false;
      if (setActiveFromChild) {
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children[1].props.children, function (dropdownItem) {
          if (dropdownItem.props.active) subItemIsActive = true;
        });
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, direction !== 'down' && 'drop' + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, defineProperty(_classNames, 'input-group-' + addonType, addonType), defineProperty(_classNames, 'btn-group', group), defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group && !addonType), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'nav-item', nav), _classNames)), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["b" /* Manager */], _extends({}, attrs, { className: classes, onKeyDown: this.handleKeyDown }));
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$8;
Dropdown.defaultProps = defaultProps$8;
Dropdown.childContextTypes = childContextTypes;

function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ nav: true }, props));
}

var propTypes$9 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$9 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$9;
NavLink.defaultProps = defaultProps$9;

var propTypes$10 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  listTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$10 = {
  tag: 'nav',
  listTag: 'ol',
  'aria-label': 'breadcrumb'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = objectWithoutProperties(props, ['className', 'listClassName', 'cssModule', 'children', 'tag', 'listTag', 'aria-label']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className), cssModule);

  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('breadcrumb', listClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes, 'aria-label': label }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ListTag,
      { className: listClasses },
      children
    )
  );
};

Breadcrumb.propTypes = propTypes$10;
Breadcrumb.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, 'aria-current': active ? 'page' : undefined }));
};

BreadcrumbItem.propTypes = propTypes$11;
BreadcrumbItem.defaultProps = defaultProps$11;

var propTypes$12 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$12 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['active', 'block', 'className', 'cssModule', 'color', 'outline', 'size', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn', 'btn' + (outline ? '-outline' : '') + '-' + color, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: innerRef,
        onClick: this.onClick
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$12;
Button.defaultProps = defaultProps$12;

var propTypes$13 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$13 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$14;
ButtonGroup.defaultProps = defaultProps$13;

var propTypes$15 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$14 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$15;
ButtonToolbar.defaultProps = defaultProps$14;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$15 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle(e);
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$16;
DropdownItem.defaultProps = defaultProps$15;
DropdownItem.contextTypes = contextTypes;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  persist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$16 = {
  tag: 'div',
  flip: true
};

var contextTypes$1 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var noFlipModifier = { flip: { enabled: false } };

var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      modifiers = props.modifiers,
      persist = props.persist,
      attrs = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag', 'flip', 'modifiers', 'persist']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);

  var Tag = tag;

  if (persist || context.isOpen && !context.inNavbar) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["c" /* Popper */];

    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + '-' + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? _extends({}, modifiers, noFlipModifier) : modifiers;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    tabIndex: '-1',
    role: 'menu'
  }, attrs, {
    'aria-hidden': !context.isOpen,
    className: classes,
    'x-placement': attrs.placement
  }));
};

DropdownMenu.propTypes = propTypes$17;
DropdownMenu.defaultProps = defaultProps$16;
DropdownMenu.contextTypes = contextTypes$1;

var propTypes$18 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$17 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      if (this.context.inNavbar) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, props, {
          className: classes,
          onClick: this.onClick,
          'aria-expanded': this.context.isOpen,
          children: children
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["d" /* Target */], _extends({}, props, {
        className: classes,
        component: Tag,
        onClick: this.onClick,
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$18;
DropdownToggle.defaultProps = defaultProps$17;
DropdownToggle.contextTypes = contextTypes$2;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var PropTypes$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;

    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterDone: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitDone: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })]);
});

unwrapExports(PropTypes$1);

var Transition_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

  var PropTypes$$1 = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

  var _reactDom2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
  var EXITED = exports.EXITED = 'exited';
  var ENTERING = exports.ENTERING = 'entering';
  var ENTERED = exports.ENTERED = 'entered';
  var EXITING = exports.EXITING = 'exiting';

  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the components.
   * It's up to you to give meaning and effect to those states. For example we can
   * add styles to a component when it enters or exits:
   *
   * ```jsx
   * import Transition from 'react-transition-group/Transition';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {(state) => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm a fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
   * What it does do is track transition states over time so you can update the
   * component (such as by adding styles or classes) when it changes states.
   *
   * There are 4 main states a Transition can be in:
   *  - `'entering'`
   *  - `'entered'`
   *  - `'exiting'`
   *  - `'exited'`
   *
   * Transition state is toggled via the `in` prop. When `true` the component begins the
   * "Enter" stage. During this stage, the component will shift from its current transition state,
   * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
   * it's complete. Let's take the following example:
   *
   * ```jsx
   * state = { in: false };
   *
   * toggleEnterState = () => {
   *   this.setState({ in: true });
   * }
   *
   * render() {
   *   return (
   *     <div>
   *       <Transition in={this.state.in} timeout={500} />
   *       <button onClick={this.toggleEnterState}>Click to Enter</button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state and
   * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
   *
   * ## Timing
   *
   * Timing is often the trickiest part of animation, mistakes can result in slight delays
   * that are hard to pin down. A common example is when you want to add an exit transition,
   * you should set the desired final styles when the state is `'exiting'`. That's when the
   * transition to those styles will start and, if you matched the `timeout` prop with the
   * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
   *
   * > **Note**: For simpler transitions the `Transition` component might be enough, but
   * > take into account that it's platform-agnostic, while the `CSSTransition` component
   * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
   * > in order to make more complex transitions more predictable. For example, even though
   * > classes `example-enter` and `example-enter-active` are applied immediately one after
   * > another, you can still transition from one to the other because of the forced reflow
   * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
   * > for more info). Take this into account when choosing between `Transition` and
   * > `CSSTransition`.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   */

  var Transition = function (_React$Component) {
    _inherits(Transition, _React$Component);

    function Transition(props, context) {
      _classCallCheck(this, Transition);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      var parentGroup = context.transitionGroup;
      // In the context of a TransitionGroup all enters are really appears
      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

      var initialStatus = void 0;
      _this.nextStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.nextStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = { status: initialStatus };

      _this.nextCallback = null;
      return _this;
    }

    Transition.prototype.getChildContext = function getChildContext() {
      return { transitionGroup: null }; // allows for nested Transitions
    };

    Transition.prototype.componentDidMount = function componentDidMount() {
      this.updateStatus(true);
    };

    Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _ref = this.pendingState || this.state,
          status = _ref.status;

      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    };

    Transition.prototype.componentDidUpdate = function componentDidUpdate() {
      this.updateStatus();
    };

    Transition.prototype.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    Transition.prototype.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;

      var exit = void 0,
          enter = void 0,
          appear = void 0;

      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter;
        appear = timeout.appear;
      }
      return { exit: exit, enter: enter, appear: appear };
    };

    Transition.prototype.updateStatus = function updateStatus() {
      var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var nextStatus = this.nextStatus;

      if (nextStatus !== null) {
        this.nextStatus = null;
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    };

    Transition.prototype.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;

      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

      var timeouts = this.getTimeouts();

      // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set
      if (!mounting && !enter) {
        this.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node, appearing);

        // FIXME: appear timeout?
        _this2.onTransitionEnd(node, timeouts.enter, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    Transition.prototype.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;

      var timeouts = this.getTimeouts();

      // no exit animation skip right to EXITED
      if (!exit) {
        this.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    Transition.prototype.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
      var _this4 = this;

      // We need to track pending updates for instances where a cWRP fires quickly
      // after cDM and before the state flushes, which would double trigger a
      // transition
      this.pendingState = nextState;

      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        _this4.pendingState = null;
        callback();
      });
    };

    Transition.prototype.setNextCallback = function setNextCallback(callback) {
      var _this5 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this5.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (this.props.addEndListener) {
          this.props.addEndListener(node, this.nextCallback);
        }
        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      } else {
        setTimeout(this.nextCallback, 0);
      }
    };

    Transition.prototype.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          childProps = _objectWithoutProperties(_props, ['children']);
      // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react2.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };

  Transition.propTypes =  false ? {
    /**
     * A `function` child can be used instead of a React element.
     * This function is called with the current transition status
     * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
     * to apply context specific props to a component.
     *
     * ```jsx
     * <Transition timeout={150}>
     *   {(status) => (
     *     <MyComponent className={`fade fade-${status}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEndListener` is provided
     *
     * You may specify a single timeout for all transitions like: `timeout={500}`,
     * or individually like:
     *
     * ```jsx
     * timeout={{
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * @type {number | { enter?: number, exit?: number }}
     */
    timeout: function timeout(props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var pt = PropTypes$1.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;
      return pt.apply(undefined, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func
  } : {};

  // Name the function so it is clearer in the documentation
  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,

    onEnter: noop,
    onEntering: noop,
    onEntered: noop,

    onExit: noop,
    onExiting: noop,
    onExited: noop
  };

  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  exports.default = Transition;
});

var Transition = unwrapExports(Transition_1);

var propTypes$19 = _extends({}, Transition.propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
});

var defaultProps$18 = _extends({}, Transition.defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      innerRef = props.innerRef,
      otherProps = objectWithoutProperties(props, ['tag', 'baseClass', 'baseClassActive', 'className', 'cssModule', 'children', 'innerRef']);

  // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
  // empty object "{}". This is the result of the `react-transition-group` babel
  // configuration settings. Therefore, to ensure that production builds work without
  // error, we can either explicitly define keys or use the Transition.defaultProps.
  // Using the Transition.defaultProps excludes any required props. Thus, the best
  // solution is to explicitly define required props in our utilities and reference these.
  // This also gives us more flexibility in the future to remove the prop-types
  // dependency in distribution builds (Similar to how `react-transition-group` does).
  // Note: Without omitting the `react-transition-group` props, the resulting child
  // Tag component would inherit the Transition properties as attributes for the HTML
  // element which results in errors/warnings for non-valid attributes.

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Transition,
    transitionProps,
    function (status) {
      var isActive = status === 'entered';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ className: classes }, childProps, { ref: innerRef }),
        children
      );
    }
  );
}

Fade.propTypes = propTypes$19;
Fade.defaultProps = defaultProps$18;

var propTypes$20 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$19 = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$20;
Badge.defaultProps = defaultProps$19;

var propTypes$21 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var defaultProps$20 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'body', 'inverse', 'outline', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, ref: innerRef }));
};

Card.propTypes = propTypes$21;
Card.defaultProps = defaultProps$20;

var propTypes$22 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$22;
CardGroup.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$23;
CardDeck.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$24;
CardColumns.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBody.propTypes = propTypes$25;
CardBody.defaultProps = defaultProps$24;

function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody, props);
}

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

CardLink.propTypes = propTypes$26;
CardLink.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$27;
CardFooter.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$28;
CardHeader.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$29;
CardImg.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$30;
CardImgOverlay.defaultProps = defaultProps$29;

var CarouselItem = function (_React$Component) {
  inherits(CarouselItem, _React$Component);

  function CarouselItem(props) {
    classCallCheck(this, CarouselItem);

    var _this = possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this, props));

    _this.state = {
      startAnimation: false
    };

    _this.onEnter = _this.onEnter.bind(_this);
    _this.onEntering = _this.onEntering.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(CarouselItem, [{
    key: 'onEnter',
    value: function onEnter(node, isAppearing) {
      this.setState({ startAnimation: false });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({ startAnimation: true });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ startAnimation: false });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      this.setState({ startAnimation: true });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isIn = _props.in,
          children = _props.children,
          cssModule = _props.cssModule,
          slide = _props.slide,
          Tag = _props.tag,
          className = _props.className,
          transitionProps = objectWithoutProperties(_props, ['in', 'children', 'cssModule', 'slide', 'tag', 'className']);


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          enter: slide,
          exit: slide,
          'in': isIn,
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var direction = _this2.context.direction;

          var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
          var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
          var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
          var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            { className: itemClasses },
            children
          );
        }
      );
    }
  }]);
  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarouselItem.propTypes = _extends({}, Transition.propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

CarouselItem.defaultProps = _extends({}, Transition.defaultProps, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});

CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Carousel = function (_React$Component) {
  inherits(Carousel, _React$Component);

  function Carousel(props) {
    classCallCheck(this, Carousel);

    var _this = possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.renderItems = _this.renderItems.bind(_this);
    _this.hoverStart = _this.hoverStart.bind(_this);
    _this.hoverEnd = _this.hoverEnd.bind(_this);
    _this.state = {
      direction: 'right',
      indicatorClicked: false
    };
    return _this;
  }

  createClass(Carousel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { direction: this.state.direction };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInterval(nextProps);
      // Calculate the direction to turn
      if (this.props.activeIndex + 1 === nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      } else if (this.props.activeIndex > nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'left' : 'right' });
      } else if (this.props.activeIndex !== nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'right' : 'left' });
      }
      this.setState({ indicatorClicked: false });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'setInterval',
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (props.interval) {
        this.cycleInterval = setInterval(function () {
          props.next();
        }, parseInt(props.interval, 10));
      }
    })
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: 'hoverStart',
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _props;

        (_props = this.props).mouseEnter.apply(_props, arguments);
      }
    }
  }, {
    key: 'hoverEnd',
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _props2;

        (_props2 = this.props).mouseLeave.apply(_props2, arguments);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems(carouselItems, className) {
      var _this2 = this;

      var slide = this.props.slide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { role: 'listbox', className: className },
        carouselItems.map(function (item, index) {
          var isIn = index === _this2.props.activeIndex;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, {
            in: isIn,
            slide: slide
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          cssModule = _props3.cssModule,
          slide = _props3.slide,
          className = _props3.className;

      var outerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);

      var innerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-inner'), cssModule);

      // filter out booleans, null, or undefined
      var children = this.props.children.filter(function (child) {
        return child !== null && child !== undefined && typeof child !== 'boolean';
      });

      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem;
      });

      // Rendering only slides
      if (slidesOnly) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(children, innerClasses)
        );
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(_carouselItems, innerClasses),
          _controlLeft,
          _controlRight
        );
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var wrappedOnClick = function wrappedOnClick(e) {
        if (typeof indicators.props.onClickHandler === 'function') {
          _this3.setState({ indicatorClicked: true }, function () {
            return indicators.props.onClickHandler(e);
          });
        }
      };
      var wrappedIndicators = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(indicators, { onClickHandler: wrappedOnClick });
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
        wrappedIndicators,
        this.renderItems(carouselItems, innerClasses),
        controlLeft,
        controlRight
      );
    }
  }]);
  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};

Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;


  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-control-' + direction), cssModule);

  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-control-' + direction + '-icon'), cssModule);

  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: anchorClasses,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: iconClasses, 'aria-hidden': 'true' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: screenReaderClasses },
      directionText || direction
    )
  );
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;


  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({ active: activeIndex === idx }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
      key: '' + (item.key || item.src) + item.caption + item.altText,
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ol',
    { className: listClasses },
    indicators
  );
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      captionHeader
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      captionText
    )
  );
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var propTypes$31 = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var UncontrolledCarousel = function (_Component) {
  inherits(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    classCallCheck(this, UncontrolledCarousel);

    var _this = possibleConstructorReturn(this, (UncontrolledCarousel.__proto__ || Object.getPrototypeOf(UncontrolledCarousel)).call(this, props));

    _this.animating = false;
    _this.state = { activeIndex: 0 };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(UncontrolledCarousel, [{
    key: 'onExiting',
    value: function onExiting() {
      this.animating = true;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      this.animating = false;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex(newIndex) {
      if (this.animating) return;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoPlay = _props.autoPlay,
          indicators = _props.indicators,
          controls = _props.controls,
          items = _props.items,
          goToIndex = _props.goToIndex,
          props = objectWithoutProperties(_props, ['autoPlay', 'indicators', 'controls', 'items', 'goToIndex']);
      var activeIndex = this.state.activeIndex;


      var slides = items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CarouselItem,
          {
            onExiting: _this2.onExiting,
            onExited: _this2.onExited,
            key: item.src
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'd-block w-100', src: item.src, alt: item.altText }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.header || item.caption })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Carousel,
        _extends({
          activeIndex: activeIndex,
          next: this.next,
          previous: this.previous,
          ride: autoPlay ? 'carousel' : undefined
        }, props),
        indicators && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselIndicators, {
          items: items,
          activeIndex: props.activeIndex || activeIndex,
          onClickHandler: goToIndex || this.goToIndex
        }),
        slides,
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'prev',
          directionText: 'Previous',
          onClickHandler: props.previous || this.previous
        }),
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'next',
          directionText: 'Next',
          onClickHandler: props.next || this.next
        })
      );
    }
  }]);
  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes$31;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$32;
CardSubtitle.defaultProps = defaultProps$30;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$33;
CardText.defaultProps = defaultProps$31;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h5'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$34;
CardTitle.defaultProps = defaultProps$32;

var propTypes$35 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

function CustomInput(props) {
  var className = props.className,
      label = props.label,
      inline = props.inline,
      valid = props.valid,
      invalid = props.invalid,
      cssModule = props.cssModule,
      children = props.children,
      bsSize = props.bsSize,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'label', 'inline', 'valid', 'invalid', 'cssModule', 'children', 'bsSize', 'innerRef']);


  var type = attributes.type;

  var customClass = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'custom-' + type, bsSize ? 'custom-' + type + '-' + bsSize : false), cssModule);

  var validationClassNames = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(invalid && 'is-invalid', valid && 'is-valid'), cssModule);

  if (type === 'select') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'select',
      _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, customClass) }),
      children
    );
  }

  if (type === 'file') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: customClass },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, mapToCssModules('custom-file-input', cssModule)) })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { className: mapToCssModules('custom-file-label', cssModule), htmlFor: attributes.id },
        label || 'Choose file'
      )
    );
  }

  if (type !== 'checkbox' && type !== 'radio') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, customClass) }));
  }

  var wrapperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(customClass, mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('custom-control', { 'custom-control-inline': inline }), cssModule));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: wrapperClasses },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, mapToCssModules('custom-control-input', cssModule))
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { className: mapToCssModules('custom-control-label', cssModule), htmlFor: attributes.id },
      label
    ),
    children
  );
}

CustomInput.propTypes = propTypes$35;

var propTypes$36 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$33 = {
  boundariesElement: 'scrollParent',
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};

var childContextTypes$1 = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var PopperContent = function (_React$Component) {
  inherits(PopperContent, _React$Component);

  function PopperContent(props) {
    classCallCheck(this, PopperContent);

    var _this = possibleConstructorReturn(this, (PopperContent.__proto__ || Object.getPrototypeOf(PopperContent)).call(this, props));

    _this.handlePlacementChange = _this.handlePlacementChange.bind(_this);
    _this.setTargetNode = _this.setTargetNode.bind(_this);
    _this.getTargetNode = _this.getTargetNode.bind(_this);
    _this.state = {};
    return _this;
  }

  createClass(PopperContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this.setTargetNode,
          getTargetNode: this.getTargetNode
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'setTargetNode',
    value: function setTargetNode(node) {
      this.targetNode = node;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode() {
      return this.targetNode;
    }
  }, {
    key: 'getContainerNode',
    value: function getContainerNode() {
      return getTarget(this.props.container);
    }
  }, {
    key: 'handlePlacementChange',
    value: function handlePlacementChange(data) {
      if (this.state.placement !== data.placement) {
        this.setState({ placement: data.placement });
      }
      return data;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.container !== 'inline') {
        if (this.props.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this._element) {
        this.getContainerNode().removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this._element = document.createElement('div');
      this.getContainerNode().appendChild(this._element);
      this.renderIntoSubtree();
      if (this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
        this._element.childNodes[0].focus();
      }
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          cssModule = _props.cssModule,
          children = _props.children,
          isOpen = _props.isOpen,
          flip = _props.flip,
          target = _props.target,
          offset = _props.offset,
          fallbackPlacement = _props.fallbackPlacement,
          placementPrefix = _props.placementPrefix,
          _arrowClassName = _props.arrowClassName,
          hideArrow = _props.hideArrow,
          className = _props.className,
          tag = _props.tag,
          container = _props.container,
          modifiers = _props.modifiers,
          boundariesElement = _props.boundariesElement,
          attrs = objectWithoutProperties(_props, ['cssModule', 'children', 'isOpen', 'flip', 'target', 'offset', 'fallbackPlacement', 'placementPrefix', 'arrowClassName', 'hideArrow', 'className', 'tag', 'container', 'modifiers', 'boundariesElement']);

      var arrowClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('arrow', _arrowClassName), cssModule);
      var placement = (this.state.placement || attrs.placement).split('-')[0];
      var popperClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, placementPrefix ? placementPrefix + '-' + placement : placement), this.props.cssModule);

      var extendedModifiers = _extends({
        offset: { offset: offset },
        flip: { enabled: flip, behavior: fallbackPlacement },
        preventOverflow: { boundariesElement: boundariesElement },
        update: {
          enabled: true,
          order: 950,
          fn: this.handlePlacementChange
        }
      }, modifiers);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_popper__["c" /* Popper */],
        _extends({ modifiers: extendedModifiers }, attrs, { component: tag, className: popperClassName, 'x-placement': this.state.placement || attrs.placement }),
        children,
        !hideArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["a" /* Arrow */], { className: arrowClassName })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.setTargetNode(getTarget(this.props.target));

      if (this.props.container === 'inline') {
        return this.props.isOpen ? this.renderChildren() : null;
      }

      return null;
    }
  }]);
  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperContent.propTypes = propTypes$36;
PopperContent.defaultProps = defaultProps$33;
PopperContent.childContextTypes = childContextTypes$1;

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var propTypes$37 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  boundariesElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 0
};

var defaultProps$34 = {
  isOpen: false,
  hideArrow: false,
  placement: 'right',
  placementPrefix: 'bs-popover',
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {}
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleProps();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'getRef',
    value: function getRef(ref) {
      this._popover = ref;
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.clearHideTimeout();
      this.addTargetEvents();
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this._showTimeout = setTimeout(this.toggle, this.getDelay('show'));
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.clearShowTimeout();
      this.removeTargetEvents();
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this._hideTimeout = setTimeout(this.toggle, this.getDelay('hide'));
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target !== this._target && !this._target.contains(e.target) && e.target !== this._popover && !(this._popover && this._popover.contains(e.target))) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (this.props.isOpen) {
          this.toggle(e);
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$37));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers,
          offset: this.props.offset,
          boundariesElement: this.props.boundariesElement
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes, ref: this.getRef }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$37;
Popover.defaultProps = defaultProps$34;

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$35 = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverHeader.propTypes = propTypes$38;
PopoverHeader.defaultProps = defaultProps$35;

function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader, props);
}

var propTypes$39 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverBody.propTypes = propTypes$39;
PopoverBody.defaultProps = defaultProps$36;

function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody, props);
}

var propTypes$40 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$40;
Progress.defaultProps = defaultProps$37;

var propTypes$42 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var Portal = function (_React$Component) {
  inherits(Portal, _React$Component);

  function Portal() {
    classCallCheck(this, Portal);
    return possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = propTypes$42;

function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes);

var propTypes$41 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  centered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var propsToOmit = Object.keys(propTypes$41);

var defaultProps$38 = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  }
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this._element = null;
    _this._originalBodyPadding = null;
    _this.getFocusableChildren = _this.getFocusableChildren.bind(_this);
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.handleTab = _this.handleTab.bind(_this);
    _this.onOpened = _this.onOpened.bind(_this);
    _this.onClosed = _this.onClosed.bind(_this);

    _this.state = {
      isOpen: props.isOpen
    };

    if (props.isOpen) {
      _this.init();
    }
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onEnter) {
        this.props.onEnter();
      }

      if (this.state.isOpen && this.props.autoFocus) {
        this.setFocus();
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen && !this.props.isOpen) {
        this.setState({ isOpen: nextProps.isOpen });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isOpen && !this.state.isOpen) {
        this.init();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
        this.setFocus();
      }

      if (this._element && prevProps.zIndex !== this.props.zIndex) {
        this._element.style.zIndex = this.props.zIndex;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onExit) {
        this.props.onExit();
      }

      if (this.state.isOpen) {
        this.destroy();
      }

      this._isMounted = false;
    }
  }, {
    key: 'onOpened',
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: 'onClosed',
    value: function onClosed(node) {
      // so all methods get called before it is unmounted
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop)(node);
      this.destroy();

      if (this._isMounted) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'setFocus',
    value: function setFocus() {
      if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
        this._dialog.parentNode.focus();
      }
    }
  }, {
    key: 'getFocusableChildren',
    value: function getFocusableChildren() {
      return this._element.querySelectorAll(focusableElements.join(', '));
    }
  }, {
    key: 'getFocusedChild',
    value: function getFocusedChild() {
      var currentFocus = void 0;
      var focusableChildren = this.getFocusableChildren();

      try {
        currentFocus = document.activeElement;
      } catch (err) {
        currentFocus = focusableChildren[0];
      }
      return currentFocus;
    }

    // not mouseUp because scrollbar fires it, shouldn't close when user scrolls

  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick(e) {
      if (e.target === this._mouseDownElement) {
        e.stopPropagation();
        if (!this.props.isOpen || this.props.backdrop !== true) return;

        var container = this._dialog;

        if (e.target && !container.contains(e.target) && this.props.toggle) {
          this.props.toggle(e);
        }
      }
    }
  }, {
    key: 'handleTab',
    value: function handleTab(e) {
      if (e.which !== 9) return;

      var focusableChildren = this.getFocusableChildren();
      var totalFocusable = focusableChildren.length;
      var currentFocus = this.getFocusedChild();

      var focusedIndex = 0;

      for (var i = 0; i < totalFocusable; i += 1) {
        if (focusableChildren[i] === currentFocus) {
          focusedIndex = i;
          break;
        }
      }

      if (e.shiftKey && focusedIndex === 0) {
        e.preventDefault();
        focusableChildren[totalFocusable - 1].focus();
      } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
        e.preventDefault();
        focusableChildren[0].focus();
      }
    }
  }, {
    key: 'handleBackdropMouseDown',
    value: function handleBackdropMouseDown(e) {
      this._mouseDownElement = e.target;
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }, {
    key: 'init',
    value: function init() {
      try {
        this._triggeringElement = document.activeElement;
      } catch (err) {
        this._triggeringElement = null;
      }
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);
      if (!this.bodyClassAdded) {
        document.body.className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
        this.bodyClassAdded = true;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        document.body.removeChild(this._element);
        this._element = null;
      }

      if (this._triggeringElement) {
        this._triggeringElement.focus();
        this._triggeringElement = null;
      }

      if (this.bodyClassAdded) {
        var modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule);
        // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
        var modalOpenClassNameRegex = new RegExp('(^| )' + modalOpenClassName + '( |$)');
        document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
        this.bodyClassAdded = false;
      }

      setScrollbarWidth(this._originalBodyPadding);
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _classNames,
          _this2 = this;

      var attributes = omit(this.props, propsToOmit);
      var dialogBaseClass = 'modal-dialog';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, attributes, {
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(dialogBaseClass, this.props.className, (_classNames = {}, defineProperty(_classNames, 'modal-' + this.props.size, this.props.size), defineProperty(_classNames, dialogBaseClass + '-centered', this.props.centered), _classNames)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            _this2._dialog = c;
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.isOpen) {
        var _props = this.props,
            wrapClassName = _props.wrapClassName,
            modalClassName = _props.modalClassName,
            backdropClassName = _props.backdropClassName,
            cssModule = _props.cssModule,
            isOpen = _props.isOpen,
            backdrop = _props.backdrop,
            role = _props.role,
            labelledBy = _props.labelledBy,
            external = _props.external,
            innerRef = _props.innerRef;


        var modalAttributes = {
          onClick: this.handleBackdropClick,
          onMouseDown: this.handleBackdropMouseDown,
          onKeyUp: this.handleEscape,
          onKeyDown: this.handleTab,
          style: { display: 'block' },
          'aria-labelledby': labelledBy,
          role: role,
          tabIndex: '-1'
        };

        var hasTransition = this.props.fade;
        var modalTransition = _extends({}, Fade.defaultProps, this.props.modalTransition, {
          baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
          timeout: hasTransition ? this.props.modalTransition.timeout : 0
        });
        var backdropTransition = _extends({}, Fade.defaultProps, this.props.backdropTransition, {
          baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
          timeout: hasTransition ? this.props.backdropTransition.timeout : 0
        });

        var Backdrop = hasTransition ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({}, backdropTransition, {
          'in': isOpen && !!backdrop,
          cssModule: cssModule,
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
        })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', 'show', backdropClassName), cssModule) });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Portal,
          { node: this._element },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: mapToCssModules(wrapClassName) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              _extends({}, modalAttributes, modalTransition, {
                'in': isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule),
                innerRef: innerRef
              }),
              external,
              this.renderModalDialog()
            ),
            Backdrop
          )
        );
      }

      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$41;
Modal.defaultProps = defaultProps$38;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  charCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var defaultProps$39 = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close',
  charCode: 215
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      charCode = props.charCode,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag', 'closeAriaLabel', 'charCode']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (toggle) {
    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: mapToCssModules('close', cssModule), 'aria-label': closeAriaLabel },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        closeIcon
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    closeButton
  );
};

ModalHeader.propTypes = propTypes$43;
ModalHeader.defaultProps = defaultProps$39;

var propTypes$44 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$40 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$44;
ModalBody.defaultProps = defaultProps$40;

var propTypes$45 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$45;
ModalFooter.defaultProps = defaultProps$41;

var propTypes$46 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var DEFAULT_DELAYS$1 = {
  show: 0,
  hide: 250
};

var defaultProps$42 = {
  isOpen: false,
  hideArrow: false,
  placement: 'top',
  placementPrefix: 'bs-tooltip',
  delay: DEFAULT_DELAYS$1,
  autohide: true,
  toggle: function toggle() {}
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this.onEscKeyDown = _this.onEscKeyDown.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip(e) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip(e) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent(e) {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  }, {
    key: 'onEscKeyDown',
    value: function onEscKeyDown(e) {
      if (e.key === 'Escape') {
        this.hide(e);
      }
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'show',
    value: function show(e) {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle(e);
      }
    }
  }, {
    key: 'hide',
    value: function hide(e) {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle(e);
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target === this._target || this._target.contains(e.target)) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle(e);
        }
      } else if (this.props.isOpen && e.target.getAttribute('role') !== 'tooltip') {
        if (this._showTimeout) {
          this.clearShowTimeout();
        }
        this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      if (this.props.trigger) {
        var triggers = this.props.trigger.split(' ');
        if (triggers.indexOf('manual') === -1) {
          if (triggers.indexOf('click') > -1) {
            ['click', 'touchstart'].forEach(function (event) {
              return document.addEventListener(event, _this2.handleDocumentClick, true);
            });
          }
          if (triggers.indexOf('hover') > -1) {
            this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
            this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
          }
          if (triggers.indexOf('focus') > -1) {
            this._target.addEventListener('focusin', this.show, true);
            this._target.addEventListener('focusout', this.hide, true);
          }
          this._target.addEventListener('keydown', this.onEscKeyDown, true);
        }
      } else {
        this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
        this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
        this._target.addEventListener('keydown', this.onEscKeyDown, true);
        this._target.addEventListener('focusin', this.show, true);
        this._target.addEventListener('focusout', this.hide, true);
        ['click', 'touchstart'].forEach(function (event) {
          return document.addEventListener(event, _this2.handleDocumentClick, true);
        });
      }
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
      this._target.addEventListener('keydown', this.onEscKeyDown, true);
      this._target.addEventListener('focusin', this.show, true);
      this._target.addEventListener('focusout', this.hide, true);

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$46));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          boundariesElement: this.props.boundariesElement,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          arrowClassName: this.props.arrowClassName,
          container: this.props.container,
          modifiers: this.props.modifiers,
          offset: this.props.offset,
          cssModule: this.props.cssModule
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          ref: this.props.innerRef,
          className: classes,
          role: 'tooltip',
          'aria-hidden': this.props.isOpen,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent,
          onKeyDown: this.onEscKeyDown
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$46;
Tooltip.defaultProps = defaultProps$42;

var propTypes$47 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  borderless: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$43 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      borderless = props.borderless,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'borderless', 'striped', 'inverse', 'dark', 'hover', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : 'table-responsive-' + responsive;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: responsiveClassName },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$47;
Table.defaultProps = defaultProps$43;

var propTypes$48 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$44 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$48;
ListGroup.defaultProps = defaultProps$44;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'form'
};

var Form = function (_Component) {
  inherits(Form, _Component);

  function Form(props) {
    classCallCheck(this, Form);

    var _this = possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.getRef = _this.getRef.bind(_this);
    _this.submit = _this.submit.bind(_this);
    return _this;
  }

  createClass(Form, [{
    key: 'getRef',
    value: function getRef(ref) {
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
      this.ref = ref;
    }
  }, {
    key: 'submit',
    value: function submit() {
      if (this.ref) {
        this.ref.submit();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          inline = _props.inline,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'inline', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = propTypes$49;
Form.defaultProps = defaultProps$45;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$46 = {
  tag: 'div',
  valid: undefined
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      valid = props.valid,
      tooltip = props.tooltip,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'valid', 'tooltip', 'tag']);


  var validMode = tooltip ? 'tooltip' : 'feedback';

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, valid ? 'valid-' + validMode : 'invalid-' + validMode), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$50;
FormFeedback.defaultProps = defaultProps$46;

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'check', 'inline', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'position-relative', row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$51;
FormGroup.defaultProps = defaultProps$47;

var propTypes$52 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$52;
FormText.defaultProps = defaultProps$48;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$53 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input(props) {
    classCallCheck(this, Input);

    var _this = possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.getRef = _this.getRef.bind(_this);
    _this.focus = _this.focus.bind(_this);
    return _this;
  }

  createClass(Input, [{
    key: 'getRef',
    value: function getRef(ref) {
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
      this.ref = ref;
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.ref) {
        this.ref.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          bsSize = _props.bsSize,
          state = _props.state,
          valid = _props.valid,
          invalid = _props.invalid,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          plaintext = _props.plaintext,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'bsSize', 'state', 'valid', 'invalid', 'tag', 'addon', 'static', 'plaintext', 'innerRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = new RegExp('\\D', 'g');

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = tag || (selectInput || textareaInput ? type : 'input');

      var formControlClass = 'form-control';

      if (plaintext || staticInput) {
        formControlClass = formControlClass + '-plaintext';
        Tag = tag || 'p';
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      if (state && typeof valid === 'undefined' && typeof invalid === 'undefined') {
        if (state === 'danger') {
          invalid = true;
        } else if (state === 'success') {
          valid = true;
        }
      }

      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? 'form-control-' + bsSize : false, formControlClass), cssModule);

      if (Tag === 'input' || tag && typeof tag === 'function') {
        attributes.type = type;
      }

      if (attributes.children && !(plaintext || staticInput || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
        warnOnce('Input with a type of "' + type + '" cannot have children. Please use "value"/"defaultValue" instead.');
        delete attributes.children;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$53;
Input.defaultProps = defaultProps$49;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$54;
InputGroup.defaultProps = defaultProps$50;

var propTypes$56 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'span'
};

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupText.propTypes = propTypes$56;
InputGroupText.defaultProps = defaultProps$52;

var propTypes$55 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'addonType', 'children']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-' + addonType), cssModule);

  // Convenience to assist with transition
  if (typeof children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, attributes, { className: classes }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupText, { children: children })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupAddon.propTypes = propTypes$55;
InputGroupAddon.defaultProps = defaultProps$51;

var propTypes$57 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var InputGroupButton = function InputGroupButton(props) {
  warnOnce('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = objectWithoutProperties(props, ['children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = objectWithoutProperties(propsWithoutGroup, ['cssModule', 'tag', 'addonType']);


    var allGroupAttributes = _extends({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InputGroupAddon,
      _extends({}, allGroupAttributes, { className: groupClassName }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { children: children }))
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupAddon, _extends({}, props, { children: children }));
};

InputGroupButton.propTypes = propTypes$57;

var propTypes$58 = {
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, props);
};

InputGroupButtonDropdown.propTypes = propTypes$58;

var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$59 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$53 = {
  tag: 'label',
  widths: colWidths$1
};

var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'size', 'for']);


  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$59;
Label.defaultProps = defaultProps$53;

var propTypes$60 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (attributes.href) {
    defaultTag = 'a';
  } else if (attributes.src || object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$60;

var propTypes$61 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  listTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$54 = {
  tag: 'nav',
  listTag: 'ul',
  'aria-label': 'pagination'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = objectWithoutProperties(props, ['className', 'listClassName', 'cssModule', 'size', 'tag', 'listTag', 'aria-label']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className), cssModule);

  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(listClassName, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    { className: classes, 'aria-label': label },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListTag, _extends({}, attributes, { className: listClasses }))
  );
};

Pagination.propTypes = propTypes$61;
Pagination.defaultProps = defaultProps$54;

var propTypes$62 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$62;
PaginationItem.defaultProps = defaultProps$55;

var propTypes$63 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (!attributes.href && Tag === 'a') {
    Tag = 'button';
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$63;
PaginationLink.defaultProps = defaultProps$56;

var propTypes$64 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$57 = {
  tag: 'div'
};

var childContextTypes$2 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);
  createClass(TabContent, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.activeTab !== nextProps.activeTab) {
        return {
          activeTab: nextProps.activeTab
        };
      }
      return null;
    }
  }]);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$64));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(TabContent);
TabContent.propTypes = propTypes$64;
TabContent.defaultProps = defaultProps$57;
TabContent.childContextTypes = childContextTypes$2;

var propTypes$65 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$58 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$65;
TabPane.defaultProps = defaultProps$58;
TabPane.contextTypes = contextTypes$3;

var propTypes$66 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$59 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$66;
Jumbotron.defaultProps = defaultProps$59;

var propTypes$67 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var defaultProps$60 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  transition: _extends({}, Fade.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      fade = props.fade,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'closeAriaLabel', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transition', 'fade', 'innerRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  var alertTransition = _extends({}, Fade.defaultProps, transition, {
    baseClass: fade ? transition.baseClass : '',
    timeout: fade ? transition.timeout : 0
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Fade,
    _extends({}, attributes, alertTransition, { tag: Tag, className: classes, 'in': isOpen, role: 'alert', innerRef: innerRef }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': closeAriaLabel, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );
}

Alert.propTypes = propTypes$67;
Alert.defaultProps = defaultProps$60;

var _transitionStatusToCl;

var propTypes$68 = _extends({}, Transition.propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
});

var defaultProps$61 = _extends({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      height: null
    };

    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
    return _this;
  }

  createClass(Collapse, [{
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      this.setState({ height: getHeight(node) });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: 'onEntered',
    value: function onEntered(node, isAppearing) {
      this.setState({ height: null });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ height: getHeight(node) });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
      this.setState({ height: 0 });
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      this.setState({ height: null });
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Tag = _props.tag,
          isOpen = _props.isOpen,
          className = _props.className,
          navbar = _props.navbar,
          cssModule = _props.cssModule,
          children = _props.children,
          innerRef = _props.innerRef,
          otherProps = objectWithoutProperties(_props, ['tag', 'isOpen', 'className', 'navbar', 'cssModule', 'children', 'innerRef']);
      var height = this.state.height;

      // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
      // empty object "{}". This is the result of the `react-transition-group` babel
      // configuration settings. Therefore, to ensure that production builds work without
      // error, we can either explicitly define keys or use the Transition.defaultProps.
      // Using the Transition.defaultProps excludes any required props. Thus, the best
      // solution is to explicitly define required props in our utilities and reference these.
      // This also gives us more flexibility in the future to remove the prop-types
      // dependency in distribution builds (Similar to how `react-transition-group` does).
      // Note: Without omitting the `react-transition-group` props, the resulting child
      // Tag component would inherit the Transition properties as attributes for the HTML
      // element which results in errors/warnings for non-valid attributes.

      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          'in': isOpen,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var collapseClass = getTransitionClass(status);
          var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
          var style = height === null ? null : { height: height };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            _extends({}, childProps, {
              style: _extends({}, childProps.style, style),
              className: classes,
              ref: _this2.props.innerRef
            }),
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$68;
Collapse.defaultProps = defaultProps$61;

var propTypes$69 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$62 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item'), cssModule);

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$69;
ListGroupItem.defaultProps = defaultProps$62;

var propTypes$70 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$63 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$70;
ListGroupItemHeading.defaultProps = defaultProps$63;

var propTypes$71 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$64 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$71;
ListGroupItemText.defaultProps = defaultProps$64;

var UncontrolledAlert = function (_Component) {
  inherits(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    classCallCheck(this, UncontrolledAlert);

    var _this = possibleConstructorReturn(this, (UncontrolledAlert.__proto__ || Object.getPrototypeOf(UncontrolledAlert)).call(this, props));

    _this.state = { isOpen: true };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledAlert, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Alert, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledButtonDropdown = function (_Component) {
  inherits(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    classCallCheck(this, UncontrolledButtonDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledButtonDropdown.__proto__ || Object.getPrototypeOf(UncontrolledButtonDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledButtonDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonDropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledButtonDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var propTypes$72 = {
  toggler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  toggleEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};

var defaultProps$65 = {
  toggleEvents: defaultToggleEvents
};

var UncontrolledCollapse = function (_Component) {
  inherits(UncontrolledCollapse, _Component);

  function UncontrolledCollapse(props) {
    classCallCheck(this, UncontrolledCollapse);

    var _this = possibleConstructorReturn(this, (UncontrolledCollapse.__proto__ || Object.getPrototypeOf(UncontrolledCollapse)).call(this, props));

    _this.togglers = null;
    _this.removeEventListeners = null;
    _this.toggle = _this.toggle.bind(_this);

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  createClass(UncontrolledCollapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.togglers = findDOMElements(this.props.toggler);
      if (this.togglers.length) {
        this.removeEventListeners = addMultipleEventListeners(this.togglers, this.toggle, this.props.toggleEvents);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.togglers.length && this.removeEventListeners) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      this.setState(function (_ref) {
        var isOpen = _ref.isOpen;
        return { isOpen: !isOpen };
      });
      e.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          toggleEvents = _props.toggleEvents,
          rest = objectWithoutProperties(_props, ['toggleEvents']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Collapse, _extends({ isOpen: this.state.isOpen }, rest));
    }
  }]);
  return UncontrolledCollapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCollapse.propTypes = propTypes$72;
UncontrolledCollapse.defaultProps = defaultProps$65;

var UncontrolledDropdown = function (_Component) {
  inherits(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    classCallCheck(this, UncontrolledDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledDropdown.__proto__ || Object.getPrototypeOf(UncontrolledDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledNavDropdown = function UncontrolledNavDropdown(props) {
  warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UncontrolledDropdown, _extends({ nav: true }, props));
};

var UncontrolledTooltip = function (_Component) {
  inherits(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    classCallCheck(this, UncontrolledTooltip);

    var _this = possibleConstructorReturn(this, (UncontrolledTooltip.__proto__ || Object.getPrototypeOf(UncontrolledTooltip)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledTooltip, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tooltip, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(4);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* defineMessages */])({acceptTitle:{'id':'global.acceptTitle','defaultMessage':'Accept'},accountChangeClientSentence:{'id':'global.accountChangeClientSentence','defaultMessage':'Log in as a client'},accountCreateSentence:{'id':'global.accountCreateSentence','defaultMessage':'Create an account'},accountLogOutSentence:{'id':'global.accountLogOutSentence','defaultMessage':'Log out'},additionalLinksTitle:{'id':'global.additionalLinksTitle','defaultMessage':'Quick links'},additionalServicesTitle:{'id':'global.additionalServicesTitle','defaultMessage':'Additional Services'},addNewAddressTitle:{'id':'global.addNewAddressTitle','defaultMessage':'Add New Address'},addNewUserTitle:{'id':'global.addNewUserTitle','defaultMessage':'Add New User'},addressBookTitle:{'id':'global.addressBookTitle','defaultMessage':'Address Book'},addToCartButton:{'id':'global.addToCartButton','defaultMessage':'Add to Cart'},allowPartialDeliverySentence:{'id':'global.allowPartialDeliverySentence','defaultMessage':'Allow delivery even though not every product is available'},allowShippingChangeSentence:{'id':'recurringOrder.allowShippingChangeSentence','defaultMessage':'Allow automatic change of shipping method when current method is not possible. (Might change shipping costs)'},allowUserCreateAddressLabel:{'id':'global.allowUserCreateAddressLabel','defaultMessage':'Allow user to create addresses'},balanceUserPageTitle:{'id':'global.balanceUserPageTitle','defaultMessage':'Balance'},balanceUser:{'id':'global.balanceUser','defaultMessage':'Client account'},balanceUserNameTitle:{'id':'global.balanceUserNameTitle','defaultMessage':'User\'s Name'},balanceUserAccountInfo:{'id':'global.balanceUserAccountInfo','defaultMessage':'Client information'},balanceUserAccountBalanceInfo:{'id':'global.balanceUserAccountBalanceInfo','defaultMessage':'Balance orders'},balanceUserAccountStatus:{'id':'global.balanceUserAccountStatus','defaultMessage':'Status'},balanceUserAccountPaymentWidgetError:{'id':'global.balanceUserAccountPaymentWidgetError','defaultMessage':'Sorry, an error occurred with your payment.Try refreshing the page and try again.If the problem persists, please contact our customer service.'},balanceUserCurrentBalance:{'id':'global.balanceUserCurrentBalance','defaultMessage':'Balance'},balanceUserPaymentHistoryOrderNumber:{'id':'global.balanceUserPaymentHistoryOrderNumber','defaultMessage':'Order number'},balanceUserNewBalance:{'id':'global.balanceUserNewBalance','defaultMessage':'Add balance'},balanceUserBalanceValidationError:{'id':'global.balanceUserBalanceValidationError','defaultMessage':'Only even numbers are accepted.'},balanceUserNoBalancePurchases:{'id':'global.balanceUserNoBalancePurchases','defaultMessage':'No balance purchases'},balanceUserPaymentTotal:{'id':'global.balanceUserPaymentTotal','defaultMessage':'Total'},balanceUserPaymentHistoryOrderDate:{'id':'global.balanceUserPaymentHistoryOrderDate','defaultMessage':'Date'},brandsTitle:{'id':'global.brandsTitle','defaultMessage':'Brands'},businessIdTitle:{'id':'global.businessIdTitle','defaultMessage':'Business ID'},businessIdHelp:{'id':'global.businessIdHelp','defaultMessage':'If you have forgotten your Business ID, you can find it by clicking {link}'},buttonInfo:{'id':'global.buttonInfo','defaultMessage':'You can also reserve and pick up the product from our store'},campaignBoxTitle:{'id':'global.campaignBoxTitle','defaultMessage':'Enter the code here'},cancelTitle:{'id':'global.cancelTitle','defaultMessage':'Cancel'},categoriesTitle:{'id':'global.categoriesTitle','defaultMessage':'Categories'},checkTitle:{'id':'global.checkTitle','defaultMessage':'Search'},checkedTitle:{'id':'global.checkedTitle','defaultMessage':'Searched'},checkoutTitle:{'id':'global.checkout','defaultMessage':'Checkout'},chooseTitle:{'id':'global.chooseTitle','defaultMessage':'Choose'},cityTitle:{'id':'global.cityTitle','defaultMessage':'City'},cloneOrder:{'id':'global.cloneOrder','defaultMessage':'Repeat order'},closeTitle:{'id':'global.closeTitle','defaultMessage':'Close'},clearTitle:{'id':'global.clearTitle','defaultMessage':'Clear'},cartEmptySentence:{'id':'global.cartEmptySentence','defaultMessage':'Your cart is empty'},companyTitle:{'id':'global.companyTitle','defaultMessage':'Company'},confirmPasswordTitle:{'id':'global.confirmPasswordTitle','defaultMessage':'Confirm Password'},contactPersonFirstNameTitle:{'id':'global.contactPersonFirstNameTitle','defaultMessage':'Contact Person First Name'},contactPersonLastNameTitle:{'id':'global.contactPersonLastNameTitle','defaultMessage':'Contact Person Last Name'},confirmAddToCartTitle:{'id':'global.confirmAddToCartTitle','defaultMessage':'Do you want to add products to the cart?'},continueShopping:{'id':'global.continueShopping','defaultMessage':'Continue Shopping'},continueTitle:{'id':'global.continue','defaultMessage':'Continue'},confirmRemoveTitle:{'id':'global.confirmRemoveTitle','defaultMessage':'Are you sure?'},countryTitle:{'id':'global.countryTitle','defaultMessage':'Country / area'},couponFreeShippingSentence:{'id':'global.couponFreeShippingSentence','defaultMessage':'Receive free delivery!'},couponDiscountOfferSentence:{'id':'global.couponDiscountOfferSentence','defaultMessage':'Receive a {offer} discount coupon!'},couponLoginOfferSentence:{'id':'global.couponLoginOfferSentence','defaultMessage':'Join as a registered customer now or sign in and you will instantly receive a {offer} coupon.'},couponLoginFreeDeliverySentence:{'id':'global.couponLoginFreeDeliverySentence','defaultMessage':'Join as a registered customer now or sign in and you will instantly receive a coupon for free shipping of your purchase.'},couponMinimumOrderSentence:{'id':'global.couponMinimumOrderSentence','defaultMessage':'Minimum order {minimumOrder}.'},couponRegisterOfferSentence:{'id':'global.couponRegisterOfferSentence','defaultMessage':'Register as our customer now and get a {offer} discount coupon.'},couponRegisterFreeDeliverySentence:{'id':'global.couponRegisterFreeDeliverySentence','defaultMessage':'Register as our customer now and get a discount coupon. The coupon can be used for free delivery.'},couponReviewValueSentence:{'id':'global.couponReviewValueSentence','defaultMessage':'Value: {value}'},couponValidUntilSentence:{'id':'global.couponValidUntilSentence','defaultMessage':'Offer valid until {offerExpiry}.'},creditAccountTitle:{'id':'global.creditAccountTitle','defaultMessage':'Credit account'},currencyLabel:{'id':'global.currencyLabel','defaultMessage':'Currency: {currency}'},currentPasswordTitle:{'id':'global.currentPasswordTitle','defaultMessage':'Current Password'},customerProductsTitle:{'id':'global.customerProductsTitle','defaultMessage':'Contract Products'},dateUpdatedTitle:{'id':'global.dateUpdatedTitle','defaultMessage':'Last updated'},deliveryCountryLabel:{'id':'global.deliveryCountryLabel','defaultMessage':'Delivery to: {country}'},deliveryStartingSentence:{'id':'global.deliveryStartingSentence','defaultMessage':'Delivery costs starting from {price}'},deliveryStartingAbridged:{'id':'global.deliveryStartingAbridged','defaultMessage':'Shipping starting from'},eanLabel:{'id':'global.eanLabel','defaultMessage':'EAN: {ean}'},editTitle:{'id':'global.editTitle','defaultMessage':'Edit'},emailTitle:{'id':'global.emailTitle','defaultMessage':'Email'},emailOrUsernameTitle:{'id':'global.emailOrUsernameTitle','defaultMessage':'Username or Email'},endDateTitle:{'id':'global.endDateTitle','defaultMessage':'End date'},errorContent:{'id':'global.errorContent','defaultMessage':'Please refresh the page. If the problem continues please try again later.'},errorContentFront:{'id':'global.errorContentFront','defaultMessage':'Please refresh the page. If the problem continues please go to frontpage.'},errorFrontpage:{'id':'global.errorFrontpage','defaultMessage':'To frontpage'},errorHeader:{'id':'global.errorHeader','defaultMessage':'We\'re sorry - something\'s gone wrong'},errorRefresh:{'id':'global.errorRefresh','defaultMessage':'Refresh page'},errorReport:{'id':'global.errorReport','defaultMessage':'Send report'},exceptionalAvailability:{'id':'global.exceptionalAvailability','defaultMessage':'(Exceptional availability)'},extraIdLabel:{'id':'global.extraIdLabel','defaultMessage':'Extra ID: {extraId}'},fileTitle:{'id':'global.fileTitle','defaultMessage':'File'},firstNameTitle:{'id':'global.firstNameTitle','defaultMessage':'First Name'},formattedMonths:{'id':'global.formattedMonths','defaultMessage':'{months, plural, one {# month} other {# months}}'},formattedYears:{'id':'global.formattedYears','defaultMessage':'{years, plural, one {# year} other {# years}}'},freeDeliverySentence:{'id':'global.freeDeliverySentence','defaultMessage':'Free delivery'},freeQuantity:{'id':'global.freeQuantity','defaultMessage':'Free Quantity: {freeQuantity} {stockUnit}'},fullNameTitle:{'id':'global.fullNameTitle','defaultMessage':'Name'},hasStartingPriceSentence:{'id':'global.hasStartingPriceSentence','defaultMessage':'Final shipping costs will be calculated in the checkout'},hereSentence:{'id':'global.here','defaultMessage':'here'},homeTitle:{'id':'global.homeTitle','defaultMessage':'Home'},infoCallPhone:{'id':'global.infoCallPhone','defaultMessage':'Call {phone}'},infoSendEmail:{'id':'global.infoSendEmail','defaultMessage':'Send email'},infoTitle:{'id':'global.infoTitle','defaultMessage':'Info'},isActiveLabel:{'id':'global.isActiveLabel','defaultMessage':'Active username'},isCorporateCustomerSentence:{'id':'global.isCorporateCustomerSentence','defaultMessage':'I am a corporate customer'},itemCount:{'id':'global.itemCount','defaultMessage':'{count, plural, one {# product} other {# products}}'},klarnaExpressCheckout:{'id':'global.klarnaExpressCheckout','defaultMessage':'Klarna. Express Checkout'},languageLabel:{'id':'global.languageLabel','defaultMessage':'Language: {language}'},lastNameTitle:{'id':'global.lastNameTitle','defaultMessage':'Last Name'},loading:{'id':'global.loading','defaultMessage':'Loading...'},logInSentence:{'id':'global.logInSentence','defaultMessage':'Log in'},loginInformationTitle:{'id':'global.loginInformationTitle','defaultMessage':'Login Information'},lowOrderFeeNoTaxSentence:{'id':'global.lowOrderFeeNoTaxSentence','defaultMessage':'Low order fee of {amount} for orders less than {limit}'},lowOrderFeeSentence:{'id':'global.lowOrderFeeSentence','defaultMessage':'Low order fee of {amount} ({amountWithoutTax}) for orders less than {limit} ({limitwithoutTax} without VAT)'},manufacturerCodeLabel:{'id':'global.manufacturerCodeLabel','defaultMessage':'Manufacturer part number: {manufacturerCode}'},mostPopularTitle:{'id':'global.mostPopularTitle','defaultMessage':'Most Popular'},messageTitle:{'id':'global.messageTitle','defaultMessage':'Message'},modifyOrderNotify:{'id':'global.modifyOrderNotify','defaultMessage':'Modifying existing orders may change shipping costs.'},myAccount:{'id':'global.myAccount','defaultMessage':'Overview'},myAccountChangePassword:{'id':'global.myAccountChangePassword','defaultMessage':'Change password'},myAccountInfo:{'id':'global.myAccountInfo','defaultMessage':'Personal information'},myAccountNoOrders:{'id':'global.myAccountNoOrders','defaultMessage':'You have not ordered anything yet.'},myAccountNoPurchases:{'id':'global.myAccountNoPurchases','defaultMessage':'No purchases found.'},myAccountTitle:{'id':'global.myAccountTitle','defaultMessage':'My Account'},myAccountUserTitle:{'id':'global.myAccountUserTitle','defaultMessage':'My Account: {user}'},myCustomerAccountTitle:{'id':'global.myCustomerAccountTitle','defaultMessage':'My Customer Account'},myOrderHistoryTitle:{'id':'global.myOrderHistoryTitle','defaultMessage':'Order History'},newPasswordTitle:{'id':'global.newPasswordTitle','defaultMessage':'New Password'},newsletterSubscriptionSentence:{'id':'global.newsletterSubscriptionSentence','defaultMessage':'Subscribe to our newsletter'},newsletterSuccessSentence:{'id':'global.newsletterSuccessSentence','defaultMessage':'You have been added to the mailing list successfully.'},newTitle:{'id':'global.newTitle','defaultMessage':'New'},newProductsTitle:{'id':'global.newProductsTitle','defaultMessage':'New Products'},nicknameTitle:{'id':'global.nicknameTitle','defaultMessage':'Nickname'},noProductsFoundSentence:{'id':'global.noProductsFoundSentence','defaultMessage':'No products found.'},notifyUserLabel:{'id':'global.notifyUserLabel','defaultMessage':'Automatically send username to email.'},noTitle:{'id':'global.noTitle','defaultMessage':'No'},notFoundTitle:{'id':'global.notFoundTitle','defaultMessage':'Not found'},ok:{'id':'global.ok','defaultMessage':'OK'},onSaleTitle:{'id':'global.onSaleTitle','defaultMessage':'On Sale'},orderDate:{'id':'global.orderDate','defaultMessage':'Order date'},orderInfoHeader:{'id':'global.orderInfoHeader','defaultMessage':'Order information'},orderListingWeb:{'id':'global.orderListingWeb','defaultMessage':'Webstore order'},orderNumber:{'id':'global.orderNumber','defaultMessage':'Order number'},passwordTitle:{'id':'global.passwordTitle','defaultMessage':'Password'},paymentMethod:{'id':'global.paymentMethod','defaultMessage':'Payment method'},paymentTokensTitle:{'id':'global.paymentTokensTitle','defaultMessage':'Payment cards'},paymentTokensNewTitle:{'id':'global.paymentTokensNewTitle','defaultMessage':'Add new payment card'},popularSearchesTitle:{'id':'global.popularSearchesTitle','defaultMessage':'Popular searches'},ourBrandsTitle:{'id':'global.ourBrandsTitle','defaultMessage':'Our Brands'},pickupPointTitle:{'id':'global.pickupPointTitle','defaultMessage':'Pickup Point'},privacyStatementAcceptSentence:{'id':'global.privacyStatementAcceptSentence','defaultMessage':'I authorize the processing of my personal data according to the Privacy statement'},privacyStatementMustApproveSentence:{'id':'global.privacyStatementMustApproveSentence','defaultMessage':'Approval of Privacy statement is required.'},priceFrom:{'id':'global.priceFrom','defaultMessage':'from'},priceTitle:{'id':'global.priceTitle','defaultMessage':'Price'},proceedToCheckoutSentence:{'id':'global.proceedToCheckoutSentence','defaultMessage':'Proceed to checkout'},proceedToCartSentence:{'id':'global.proceedToCartSentence','defaultMessage':'Shopping cart'},productBundleAddedToCartSentence:{'id':'global.productBundleAddedToCartSentence','defaultMessage':'Product bundle added to cart'},productBundlesTitle:{'id':'global.productBundlesTitle','defaultMessage':'Product Bundles'},productCount:{'id':'global.productCount','defaultMessage':'{count, plural, one {# product} other {# products}}'},productEnquiryTitle:{'id':'global.productEnquiryTitle','defaultMessage':'Ask about the product'},productEnquiryProposalTitle:{'id':'global.productEnquiryProposalTitle','defaultMessage':'Ask for a proposal'},productOffer:{'id':'global.productOffer','defaultMessage':'Product offer'},productAddedToCartSentence:{'id':'global.productAddedToCartSentence','defaultMessage':'{quantity, plural, one {# product} other {# products}} added to cart'},productsTitle:{'id':'global.productsTitle','defaultMessage':'Products'},productTitle:{'id':'global.productTitle','defaultMessage':'Product'},propertyChooseTitle:{'id':'global.propertyChooseTitle','defaultMessage':'Choose {property}'},purchaseOrderCountHeader:{'id':'global.purchaseOrderCountHeader','defaultMessage':'Order count'},purchaseUserHeader:{'id':'global.purchaseUserHeader','defaultMessage':'User'},purchaseWithVatHeader:{'id':'global.purchaseWithVatHeader','defaultMessage':'With VAT'},purchaseWithoutVatHeader:{'id':'global.purchaseWithoutVatHeader','defaultMessage':'Without VAT'},purchasesListTitle:{'id':'global.purchasesListTitle','defaultMessage':'User purchases'},quantityDecrementTitle:{'id':'global.quantityDecrementTitle','defaultMessage':'Decrement quantity'},quantityIncrementTitle:{'id':'global.quantityIncrementTitle','defaultMessage':'Increment quantity'},quantityTitle:{'id':'global.quantityTitle','defaultMessage':'Quantity'},readAboutRecurring:{'id':'global.readAboutRecurring','defaultMessage':'Subscription is a recurring and automatically sent order. You can decide the products and how often you need a delivery.'},readMoreSentence:{'id':'global.readMoreSentence','defaultMessage':'Read more'},recommendedProductsTitle:{'id':'global.recommendedProductsTitle','defaultMessage':'Recommended Products'},recurringOrdersTitle:{'id':'global.recurringOrdersTitle','defaultMessage':'Subscriptions'},relatedProductsTitle:{'id':'global.relatedProductsTitle','defaultMessage':'Related Products'},regionalSettingsTitle:{'id':'global.regionalSettingsTitle','defaultMessage':'Regional settings'},registerTitle:{'id':'global.registerTitle','defaultMessage':'Register'},removeTitle:{'id':'global.removeTitle','defaultMessage':'Remove'},retailerTitle:{'id':'global.retailerTitle','defaultMessage':'Retailer'},reviewCount:{'id':'global.reviewCount','defaultMessage':'{count, plural, one {# review} other {# reviews}}'},reviewCountCompact:{'id':'global.reviewCountCompact','defaultMessage':'({count})'},reviewProductRatingTitle:{'id':'global.reviewProductRatingTitle','defaultMessage':'Product'},reviewServiceRatingTitle:{'id':'global.reviewServiceRatingTitle','defaultMessage':'Service and delivery'},reviewTitle:{'id':'global.reviewTitle','defaultMessage':'Review'},reviewsTitle:{'id':'global.reviewsTitle','defaultMessage':'Reviews'},saveTitle:{'id':'global.saveTitle','defaultMessage':'Save'},showAllProductsSentence:{'id':'global.showAllProductsSentence','defaultMessage':'Show all products'},selectTitle:{'id':'global.selectTitle','defaultMessage':'Select'},selectedTitle:{'id':'global.selectedTitle','defaultMessage':'Selected'},selectedTitleWithValue:{'id':'global.selectedTitleWithValue','defaultMessage':'Selected: {value}'},search:{'id':'global.search','defaultMessage':'Search'},searchHistoryTitle:{'id':'global.searchHistoryTitle','defaultMessage':'Recent searches'},searchNoResultsSentence:{'id':'global.searchNoResults','defaultMessage':'No results found'},searchResultsTitle:{'id':'global.searchResultsTitle','defaultMessage':'Search Results'},searchResultsForTitle:{'id':'global.searchResultsForTitle','defaultMessage':'Search Results for {term}'},searchResultsForTermTitle:{'id':'global.searchResultsForTermTitle','defaultMessage':'Results for the Search Term "{term}"'},searchTryAnotherSentence:{'id':'global.searchTryAnotherSentence','defaultMessage':'Try another search'},seeCategoriesNavi:{'id':'global.seeCategoriesNavi','defaultMessage':'See categories and infopages'},sendTitle:{'id':'global.sendTitle','defaultMessage':'Send'},shippingTitle:{'id':'global.shipping','defaultMessage':'Shipping'},shippingAddressTitle:{'id':'global.shippingAddressTitle','defaultMessage':'Shipping address'},shippingCostsTitle:{'id':'global.shippingCostsTitle','defaultMessage':'Shipping costs'},shippingMethod:{'id':'global.shippingMethod','defaultMessage':'Shipping method'},shoppingCenterAcceptableTerms:{'id':'global.shoppingCenterAcceptableTerms','defaultMessage':'By clicking "{continuePurchase}" I confirm I\'ve read {storeName} {termsOfUse} and {privacyStatement}, and merchant\'s {merchantName} {deliveryAndPaymentTerms} and {merchantPrivacyStatement}'},shoppingCenterDeliveryAndPaymentTerms:{'id':'global.shoppingCenterProductMerchantDeliveryAndPaymentTerms','defaultMessage':'delivery and payment terms'},shoppingCenterPrivacyStatement:{'id':'global.shoppingCenterProductMerchantPrivacy','defaultMessage':'privacy statement'},showLessText:{'id':'global.showLessText','defaultMessage':'Show less'},showMoreText:{'id':'global.showMoreText','defaultMessage':'Show more'},sizeGuideSentence:{'id':'global.sizeGuideSentence','defaultMessage':'Size guide'},soldProductsTitle:{'id':'global.soldProductsTitle','defaultMessage':'Sold Products'},startDateTitle:{'id':'global.startDateTitle','defaultMessage':'Start date'},statusTitle:{'id':'global.statusTitle','defaultMessage':'Status'},stockTemporarilyOutOfSentence:{'id':'global.stockTemporarilyOutOfSentence','defaultMessage':'Product temporarily out of stock'},streetAddressTitle:{'id':'global.streetAddressTitle','defaultMessage':'Street Address'},submitSurvey:{'id':'global.submitSurvey','defaultMessage':'Submit'},surveySubmitError:{'id':'global.surveySubmitError','defaultMessage':'Error submitting form. Please try again.'},suggestionsTitle:{'id':'global.suggestionsTitle','defaultMessage':'Suggestions'},sumWithVat:{'id':'global.sumWithVat','defaultMessage':'Total with VAT'},sumWithoutVat:{'id':'global.sumWithoutVat','defaultMessage':'Total without VAT'},taxExcluded:{'id':'global.taxExcluded','defaultMessage':'(tax excl.)'},taxIncluded:{'id':'global.taxIncluded','defaultMessage':'(tax incl.)'},telephoneTitle:{'id':'global.telephoneTitle','defaultMessage':'Telephone'},termFilterPlaceholder:{'id':'global.termFilterPlaceholder','defaultMessage':'Search'},toOrder:{'id':'global.toOrder','defaultMessage':'See info'},totalPriceSentence:{'id':'global.totalPriceSentence','defaultMessage':'Total'},unitPriceTitle:{'id':'global.unitPriceTitle','defaultMessage':'Unit price'},update:{'id':'global.update','defaultMessage':'Update'},uploadFileTitle:{'id':'global.uploadFileTitle','defaultMessage':'Upload file'},userListTitle:{'id':'global.userListTitle','defaultMessage':'Users for account'},validationMessageInvalidQuantity:{'id':'global.validationMessageInvalidQuantity','defaultMessage':'The quantity must be between {min} and {max}.'},validationMessageInvalidFloor:{'id':'global.validationMessageInvalidFloor','defaultMessage':'The quantity must be divisible with the package product count {size}.'},validUntilFurtherNotice:{'id':'global.validUntilFurtherNotice','defaultMessage':'Valid until further notice.'},warrantyLabel:{'id':'global.warrantyLabel','defaultMessage':'Warranty: {warranty}'},weightTitle:{'id':'global.weightTitle','defaultMessage':'Weight'},weRecommendTitle:{'id':'global.weRecommendTitle','defaultMessage':'We Recommend'},writeNewReview:{'id':'global.writeNewReview','defaultMessage':'Write a review'},yesTitle:{'id':'global.yesTitle','defaultMessage':'Yes'},yourReferenceTitle:{'id':'global.yourReferenceTitle','defaultMessage':'Reference'},yourEmailSentence:{'id':'global.yourEmail','defaultMessage':'Your email'},youSaveSentence:{'id':'global.youSaveSentence','defaultMessage':'You save {savings}'},zipCodeTitle:{'id':'global.zipCodeTitle','defaultMessage':'Zip Code'},wishListTitle:{'id':'global.wishListPageTitle','defaultMessage':'Wishlist'},vehiclePartSearchTitle:{'id':'global.vehiclePartSearchTitle','defaultMessage':'Vehicle part search'}}));

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_GlobalConfig__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Site__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_ProductListStyle__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Site__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_StoreThemeLayoutTypes__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_Paths__ = __webpack_require__(14);
var LOCAL_STORAGE_IN_STOCK_PRODUCTS_ONLY_KEY='inStockProductsOnly';var LOCAL_STORAGE_PRODUCT_LIST_STYLE='productListStyle';var ConfigStore=__WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__["a" /* default */].named('ConfigStore').props({globalConfig:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_3__models_GlobalConfig__["a" /* default */]),storedInStockProductsOnly:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string),storedProductListStyle:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string),site:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_5__models_Site__["a" /* default */])}).preProcessSnapshot(function(snapshot){return Object.assign({},snapshot,{storedInStockProductsOnly:window.localStorage.getItem(LOCAL_STORAGE_IN_STOCK_PRODUCTS_ONLY_KEY),storedProductListStyle:window.localStorage.getItem(LOCAL_STORAGE_PRODUCT_LIST_STYLE)});}).views(function(self){return{get account(){return{enableMyAccount:self.globalConfig.ENABLE_MY_ACCOUNT,isMoneyTransfer:self.globalConfig.ENABLE_MONEY_TRANSFER_ACCOUNT,showCustomerGroupName:self.globalConfig.SHOW_CUSTOMER_GROUP_NAME};},get activeConfig(){var _getRoot=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self),sectionStore=_getRoot.sectionStore;var defaultConfig=self.globalConfig||{};return sectionStore&&sectionStore.activeSection?Object.assign({},defaultConfig,sectionStore.activeSection.configurations):defaultConfig;},get activateSections(){var _getRoot2=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self),sectionStore=_getRoot2.sectionStore;var hasSections=sectionStore&&sectionStore.sections.length>0;return self.activeConfig.ACTIVATE_SECTIONS&&hasSections;},get activateSpotmore(){return{enabled:self.activeConfig.ACTIVATE_SPOTMORE};},get advancedSearch(){var advancedSearch=self.globalConfig.PRODUCT_SEARCH_PLAN==='1';return{enabled:advancedSearch,popularSuggestions:advancedSearch&&self.globalConfig.PRODUCT_SEARCH_POPULAR_SEARCHES,recentSearches:advancedSearch&&self.globalConfig.PRODUCT_SEARCH_RECENT_SEARCHES};},get cartModal(){return{productListImages:self.activeConfig.CART_SHOW_ADDED_PRODUCT_IMAGES};},get checkout(){return{checkoutPath:self.globalConfig.ENABLE_LITE_CHECKOUT?__WEBPACK_IMPORTED_MODULE_9__types_Paths__["a" /* default */].LiteCheckout:__WEBPACK_IMPORTED_MODULE_9__types_Paths__["a" /* default */].Checkout};},get configurationTexts(){return self.globalConfig.CONFIGURATION_TEXTS;},get contactUs(){return{enableAddress:self.globalConfig.CONTACT_ENTRY_ADDRESS,requireAddress:self.globalConfig.CONTACT_FORM_ADDRESS_NEEDED,requirePhone:self.globalConfig.CONTACT_ENTRY_PHONE,enableCaptcha:self.globalConfig.CAPTCHA_ENABLE_CONTACT_US};},get cookieNotice(){return{enabled:self.globalConfig.SHOW_COOKIE_USAGE_NOTICE,infoPageId:self.globalConfig.COOKIE_PRIVACY_INFO_PAGE_ID};},get copyright(){return self.globalConfig.SYSTEM_COPYRIGHT_CONTENTS;},get criteo(){return{enabled:self.globalConfig.ENABLE_CRITEO_INTEGRATION,containerId:self.globalConfig.CRITEO_MERCHANT_ID};},get customerService(){return{phone:self.activeConfig.INVOICE_TELEPHONE,open:self.activeConfig.CUSTOMER_SERVICE_OPEN,callCost:self.activeConfig.CUSTOMER_SERVICE_PRICE,email:self.activeConfig.STORE_OWNER_EMAIL_ADDRESS};},get denyRobots(){return self.activeConfig.DENY_ROBOTS;},get defaultLocale(){return self.activeConfig.DEFAULT_LANGUAGE;},get defaultSection(){if(!self.site&&self.site.section_id){return null;}return self.site.section_id;},get facebookPixel(){return{enabled:self.globalConfig.ENABLE_FACEBOOK_TRACKING,id:self.globalConfig.FACEBOOK_PIXEL_ID};},get facebookVerification(){return self.globalConfig.FACEBOOK_VERIFICATION_CONTENT;},get footer(){return{showManufacturers:self.activeConfig.SHOW_FOOTER_MANUFACTURERS};},get formValidation(){return{city:{minLength:Number(self.globalConfig.ENTRY_CITY_MIN_LENGTH)},email:{minLength:Number(self.globalConfig.ENTRY_EMAIL_ADDRESS_MIN_LENGTH)},firstName:{minLength:Number(self.globalConfig.ENTRY_FIRST_NAME_MIN_LENGTH)},lastName:{minLength:Number(self.globalConfig.ENTRY_LAST_NAME_MIN_LENGTH)},username:{minLength:Number(self.globalConfig.ENTRY_LOGIN_NAME_MIN_LENGTH)},password:{minLength:Number(self.globalConfig.ENTRY_PASSWORD_MIN_LENGTH)},postalCode:{minLength:Number(self.globalConfig.ENTRY_POSTCODE_MIN_LENGTH)},streetAddress:{minLength:Number(self.globalConfig.ENTRY_STREET_ADDRESS_MIN_LENGTH)},telephone:{minLength:Number(self.globalConfig.ENTRY_TELEPHONE_MIN_LENGTH)}};},get frontpageTabOrder(){return self.activeConfig.FRONTPAGE_TABS_ORDER;},get frontpageText(){return self.globalConfig.FRONTPAGE_TEXT;},get frontpageTabMaxProducts(){return Number(self.activeConfig.FRONTPAGE_TABS_MAX_PRODUCTS);},get gclid(){return{enabled:self.activeConfig.ENABLE_EXTERNAL_CAMPAIGN_VISIT_TRACKING,expirationSeconds:Number(self.globalConfig.EXTERNAL_CAMPAIGNS_EXPIRY_TIME)};},get giosg(){return{enabled:self.globalConfig.USE_GIOSG,merchantId:self.globalConfig.GIOSG_CUSTOMER_ID};},get gtm(){return{enabled:self.globalConfig.USE_GTM,containerId:self.globalConfig.GTM_CUSTOMERS_ID};},get integrations(){return{postAffiliate:{accountId:self.globalConfig.POSTAFFILIATE_ACCOUNT_ID,isEnabled:self.globalConfig.ENABLE_POSTAFFILIATE_INTEGRATION,url:self.globalConfig.POSTAFFILIATE_MERCHANT_URL},swogo:{isEnabled:self.globalConfig.ENABLE_SWOGO_INTEGRATION},arinet:{isEnabled:self.globalConfig.ENABLE_ARINET_INTEGRATION}};},get klarnaSupportedLocaleCurrencies(){return self.globalConfig.KLARNA_SUPPORTED_LOCALE_CURRENCIES;},get languageTexts(){return self.globalConfig.LANGUAGE_TEXTS;},get layoutStoreThemeSelection(){var storeDefault='';switch(self.globalConfig.LAYOUT_STORE_THEME_SELECTION){case'0':storeDefault=__WEBPACK_IMPORTED_MODULE_8__types_StoreThemeLayoutTypes__["a" /* default */].SOFTLY_ROUNDED_CORNERS;break;case'1':storeDefault=__WEBPACK_IMPORTED_MODULE_8__types_StoreThemeLayoutTypes__["a" /* default */].FULLY_ROUNDED_EDGES;break;case'2':storeDefault=__WEBPACK_IMPORTED_MODULE_8__types_StoreThemeLayoutTypes__["a" /* default */].BOX;break;default:storeDefault=__WEBPACK_IMPORTED_MODULE_8__types_StoreThemeLayoutTypes__["a" /* default */].SOFTLY_ROUNDED_CORNERS;break;}return storeDefault;},get productImageAspectRatio(){return self.activeConfig.PRODUCT_IMAGE_ASPECT_RATIO;},get useImageDescriptionAsAlt(){return self.activeConfig.USE_IMAGE_DESCRIPTION_ALT_TEXT;},get mainBanner(){return{fullWidth:self.activeConfig.MAIN_BANNER_FULL_WIDTH,withinContent:self.activeConfig.MAIN_BANNER_WITHIN_CONTENT};},get megaMenu(){return{groupAdditionalLinks:self.globalConfig.MEGAMENU_GROUP_ADDITIONAL_LINKS,twoLayerMegamenuEnabled:this.mainNavigation.useMegamenu&&self.globalConfig.NAVIGATION_MENU_STYLE==='2'?true:false,showManufacturers:self.globalConfig.SHOW_MEGAMENU_MANUFACTURERS,forceTwoSubCategoryColumns:self.globalConfig.MEGAMENU_FORCE_TWO_PRODUCT_CATEGORY_COLUMNS,maximumSubCategoryCount:self.globalConfig.MEGAMENU_TWO_COLUMN_MAX_COUNT};},get mobileSettings(){return{showStoreLogo:self.globalConfig.SHOW_STORE_LOGO_ON_MOBILE,showAssistantMenu:self.globalConfig.SHOW_ASSISTANT_MENU_ON_MOBILE};},get newsletter(){return{enabled:self.activeConfig.ENABLE_NEWSLETTER_SUBSCRIPTION,requireName:self.activeConfig.CUSTOMER_NAME_NEEDED_ON_NEWSLETTER};},get product(){return{additionalProductTabsActive:self.activeConfig.ADDITIONAL_PRODUCT_TABS_ACTIVE,allowFileUploads:self.activeConfig.ALLOW_FILE_UPLOAD_FOR_CUSTOMERS,alwaysShowUnit:self.activeConfig.SHOW_ALWAYS_PRODUCT_PACKAGES,backorderLimit:Number(self.activeConfig.ORDER_ONLY_PRODUCT_ORDER_LIMIT),enableProductWatcher:self.activeConfig.ENABLE_PRODUCTS_WATCHER,enableEnquiry:self.activeConfig.ENABLE_PRODUCT_PAGE_PRODUCT_ENQUIRY,enquireForProposal:self.activeConfig.PRODUCTS_PRICE_ZERO_IS_VIEW_ONLY,hideMultiProductSelectionImage:self.activeConfig.HIDE_MULTIPRODUCT_SELECTION_IMAGE,isNewForSeconds:__WEBPACK_IMPORTED_MODULE_2_luxon__["Duration"].fromObject({days:Number(self.activeConfig.NEW_PRODUCTS_EXPIRARY_TIME)}).as('seconds'),multiproductAsDropdown:self.activeConfig.MULTIPRODUCT_AS_DROPDOWN,shortDescriptionTop:self.activeConfig.PRODUCT_PAGE_SHORT_DESCRIPTION_POSITION==='TOP',shortDescriptionBottom:self.activeConfig.PRODUCT_PAGE_SHORT_DESCRIPTION_POSITION==='BOTTOM',showModel:self.activeConfig.DISPLAY_PRODUCTS_MODEL,showSecondaryTaxPrice:self.activeConfig.PRODUCT_PAGE_SHOW_TAX_BREAKDOWN_FOR_CONSUMERS,showShortDescription:self.activeConfig.SHOW_PRODUCTS_SHORT_DESCRIPTION,showStoreAvailability:self.activeConfig.ENABLE_STORAGE_INFO,useSeoDescriptionForShort:self.activeConfig.USE_PRODUCT_LONG_DESCRIPTION_AS_SHORT_DESCRIPTION};},get productPage(){return{depositInPrice:self.activeConfig.ADD_BOTTLE_DEPOSIT_TO_PRICE,enableAdditionalServicesModal:self.activeConfig.PRODUCT_PAGE_ENABLE_ADDITIONAL_SERVICE_MODAL,shippingOnlyProduct:self.activeConfig.PRODUCT_PAGE_SHIPPING_OPTIONS_CALCULATION_TYPE==='1',showEanCode:self.activeConfig.PRODUCT_PAGE_SHOW_EAN_CODE,showExtraId:self.activeConfig.PRODUCT_PAGE_SHOW_EXTRA_ID,showManufacturersCode:self.activeConfig.PRODUCT_PAGE_SHOW_MANUFACTURERS_CODE,showProductCode:self.activeConfig.PRODUCT_PAGE_SHOW_PRODUCT_CODE,showModelName:self.activeConfig.DISPLAY_MULTI_PRODUCTS_MODEL,showAdditionalProductCode:self.activeConfig.PRODUCT_PAGE_SHOW_ADDITIONAL_PRODUCT_ID,showWarranty:self.activeConfig.PRODUCT_PAGE_SHOW_WARRANTY,showWeight:self.activeConfig.PRODUCT_PAGE_SHOW_WEIGHT,validateForCartQuery:self.activeConfig.PRODUCT_PAGE_VALIDATE_FOR_CART};},get productCard(){return{showAddToCart:self.activeConfig.PRODUCT_LIST_CART_BUTTON,showEanCode:self.activeConfig.PRODUCT_LIST_EAN,showExtraId:self.activeConfig.PRODUCT_LIST_EXTRA_ID,showDescription:self.activeConfig.PRODUCT_LIST_DESCRIPTION,showProperties:self.activeConfig.SHOW_COLORS_AND_SIZES_ON_LISTING,showProductCode:self.activeConfig.PRODUCT_LIST_CODE,showQuantitySelection:self.activeConfig.PRODUCT_LIST_QUANTITY,showSingularPrice:self.activeConfig.PRODUCT_LIST_SINGULAR_PRICE,showManufacturersCode:self.activeConfig.PRODUCT_LIST_MANUFACTURERS_CODE};},get productList(){return{defaultSortOption:self.activeConfig.DEFAULT_CATEGORY_PRODUCT_SORT_OPTION,productListSortSelectors:self.activeConfig.PRODUCT_LIST_SORT_SELECTORS};},get productListFilter(){return{enabled:self.activeConfig.PRODUCT_LIST_FILTER_BY_SEARCH_PHRASE};},get productSuggestions(){return{enabled:self.globalConfig.ENABLE_PRODUCT_SEARCH_SUGGESTIONS,count:self.globalConfig.ENABLE_PRODUCT_SEARCH_SUGGESTIONS&&self.globalConfig.PRODUCT_SEARCH_SUGGESTIONS_COUNT};},get mainCategoryPage(){return{showMainProductList:self.activeConfig.SHOW_ALL_PRODUCTS_FROM_TOP,showProductTabs:self.activeConfig.PAGE_SUBCATEGORY_ENABLE_TABS,showCategoryGrid:self.activeConfig.SHOW_SUBCATEGORIES_ON_MAINCAT};},get manufacturerBox(){return{style:self.activeConfig.BOX_MANUFACTURERS_STYLE,limitByActiveSection:self.activeConfig.BOX_MANUFACTURERS_LIMIT_TO_SECTION};},get manufacturerListPage(){// TODO Needs a setting to backend. 0=original, 1=Only name, 2 = only logo
return{style:self.site.type===__WEBPACK_IMPORTED_MODULE_7__types_Site__["b" /* default */].SHOPPING_CENTER?'1':'0'};},get seo(){return{indexedParameters:self.globalConfig.PREVENT_NOINDEX_BY_PARAMETER};},get store(){return{loginRequired:self.globalConfig.REQUIRE_LOGIN_FOR_ENTRY,name:self.globalConfig.STORE_NAME};},get recaptcha(){return{sitekey:self.globalConfig.CAPTCHA_SITE_KEY};},get registration(){return{enabled:self.globalConfig.ENABLE_CUSTOMER_REGISTRATION,enableCaptcha:self.globalConfig.CAPTCHA_ENABLE_REGISTRATION,isCompanyDefault:self.globalConfig.DEFAULT_CUSTOMER_TYPE,companyEnabled:self.globalConfig.ACCOUNT_COMPANY,requireBusinessId:self.globalConfig.SHOW_CUSTOMERS_VAT_NUMBER,quickRegistrationEnabled:self.globalConfig.ENABLE_QUICK_REGISTERATION,quickRegistrationRequirePhone:self.globalConfig.QUICK_REGISTERATION_PHONE_NEEDED};},get recurringOrder(){return{enabled:self.activeConfig.ENABLE_RECURRING_ORDERS,infoPage:self.activeConfig.RECURRING_ORDERS_INFO_PAGE_ID};},get reviews(){return{enabled:self.activeConfig.ALLOW_PRODUCT_REVIEWS,approvalRequired:self.activeConfig.PRODUCT_REVIEWS_REQUIRE_APPROVAL,allowedForVisitors:self.activeConfig.PRODUCT_REVIEWS_ALLOW_FOR_VISITORS,anonymous:self.activeConfig.PRODUCT_REVIEWS_ANONYMOUS};},get mainNavigation(){return{useSidebar:self.activeConfig.SHOW_LEFT_COLUMN,useMegamenu:self.activeConfig.NAVIGATION_MENU_STYLE!=='0'};},get topNavigation(){return{addToCartRow:{desktop:self.activeConfig.NAVIGATION_ADD_TO_CART_ROW==='1'||self.activeConfig.NAVIGATION_ADD_TO_CART_ROW==='3',mobile:self.activeConfig.NAVIGATION_ADD_TO_CART_ROW==='2'||self.activeConfig.NAVIGATION_ADD_TO_CART_ROW==='3'},headerMobileSearchbarVisibility:self.globalConfig.HEADER_MOBILE_SEARCHBAR_VISIBILITY,center:self.globalConfig.HEADER_CENTER,centerShopLogo:self.globalConfig.HEADER_SEARCH_BAR_MOVE_TOP_NAVIGATION&&self.globalConfig.HEADER_SHOPPING_CART_MOVE_LOGIN_RIGHT_SIDE&&self.globalConfig.HEADER_CENTER_SHOP_LOGO,hideCheckout:self.globalConfig.HEADER_HIDE_CHECKOUT,hideHeaderOnScrollingDown:self.globalConfig.HEADER_HIDE_STICKY_HEADER_ON_SCROLLING_DOWN,moveSearchbarTopNavigation:self.globalConfig.HEADER_SEARCH_BAR_MOVE_TOP_NAVIGATION,moveShoppingCartLoginRight:self.globalConfig.HEADER_SHOPPING_CART_MOVE_LOGIN_RIGHT_SIDE,useStickyHeaderOnStartup:self.globalConfig.HEADER_SHOW_STICKY_HEADER_ON_STARTUP};},get paymentModule(){return{klarna:{kreditorEid:self.globalConfig.MODULE_PAYMENT_KREDITOR_EID,kcoEid:self.globalConfig.MODULE_PAYMENT_KCO_EID}};},get privacyStatement(){return{infoPageId:self.globalConfig.PRIVACY_STATEMENT_PAGE_ID};},get termsOfUseStatement(){return{infoPageId:self.globalConfig.DELIVERYTERMS_PAGE_ID};},get infoPages(){return{productPurchaseGuide:self.globalConfig.SHOPPING_CENTER_BUYING_GUIDE_PAGE_ID,customerBenefits:self.globalConfig.VIP_CUSTOMER_BENEFITS_INFOPAGE_ID,entryLogin:self.globalConfig.ENTRY_LOGIN_INFO_PAGE_ID,cartErroModal:self.globalConfig.CART_ERROR_INFO_PAGE_ID};},get hideProductWithZeroQuantity(){return!self.globalConfig.PRODUCT_LIST_FILTER_BY_STOCK;},get sidebar(){return{showOnSale:self.globalConfig.SHOW_MAIN_LINK_SPECIAL_PRODUCTS,showNewProducts:self.globalConfig.SHOW_MAIN_LINK_NEW_PRODUCTS,showSoldProducts:self.globalConfig.SHOW_MAIN_LINK_SOLD_PRODUCTS,showMostSold:self.globalConfig.SHOW_MAIN_LINK_MOST_SOLD,showRecommended:self.globalConfig.SHOW_MAIN_LINK_RECOMMENDED,showFullWidthPageContent:self.activeConfig.SHOW_PAGES_100_PERCENT_WIDE};},get sectionPage(){return{useProductList:self.activeConfig.SECTIONPAGE_USE_PRODUCT_LIST,singleRowTabs:self.activeConfig.SECTION_PAGE_SINGLE_ROW_TABS};},get inStockProductsOnly(){if(self.hideProductWithZeroQuantity){return self.activeConfig.PRODUCT_LIST_FILTER_BY_STOCK_DEFAULT_STATE;}return self.storedInStockProductsOnly===null?self.activeConfig.PRODUCT_LIST_FILTER_BY_STOCK_DEFAULT_STATE:self.storedInStockProductsOnly==='true';},get productListStyle(){return __WEBPACK_IMPORTED_MODULE_6__types_ProductListStyle__["a" /* default */][self.storedProductListStyle]||(self.globalConfig.PRODUCT_LIST_CARD_DEFAULT_STYLE==='1'?'CARD_LARGE':'CARD');},get productAddedToCardModalType(){return self.globalConfig.PRODUCT_ADDED_TO_CART_MODAL_STYLE==='0'?'MODAL':'POPOVER';},get reserveInStore(){return{enabled:self.globalConfig.ENABLE_RESERVE_IN_STORE,excludePropertyId:Number(self.globalConfig.RESERVE_IN_STORE_EXCLUDE_PROPERTY_ID),enableCaptcha:self.globalConfig.RESERVE_IN_STORE_USE_CAPTCHA,expireTimeHours:self.globalConfig.RESERVE_IN_STORE_RESERVATION_EXPIRY_TIME};},get siteConfig(){return{siteSectionId:self.site.section_id,siteType:self.site.type,isShoppingCenter:self.site.type===__WEBPACK_IMPORTED_MODULE_7__types_Site__["b" /* default */].SHOPPING_CENTER,isWebStore:self.site.type===__WEBPACK_IMPORTED_MODULE_7__types_Site__["b" /* default */].WEB_STORE,isStore:self.site.type===__WEBPACK_IMPORTED_MODULE_7__types_Site__["b" /* default */].WEB_STORE||self.site.type===__WEBPACK_IMPORTED_MODULE_7__types_Site__["b" /* default */].SHOPPING_CENTER,isHomePage:self.site.type===__WEBPACK_IMPORTED_MODULE_7__types_Site__["b" /* default */].HOME_PAGE};},get storeInfoPageId(){return Number(self.globalConfig.STORE_INFO_PAGE_ID);},get suitableProducts(){return{enabledOnCategories:self.globalConfig.FIND_FROM_ACCESSORIES_CATEGORIES.map(Number)};},get shopAlike(){return{enabled:self.globalConfig.USE_SHOPALIKE_SERVICE,id:self.globalConfig.SHOPALIKE_TRACKING_ID};},get zoovu(){return{enabled:self.globalConfig.ENABLE_ZOOVU_INTEGRATION};},get vehiclePartSearch(){return{enabled:self.globalConfig.ACTIVE_VEHICLE_PART_SEARCH_INTEGRATION==='1'};},get wishlist(){return{enabled:self.globalConfig.SHOW_WISHLIST,enableEmailShare:self.globalConfig.ENABLE_WISHLIST_EMAIL_SHARE};},get soldProductsPage(){return{showProductCards:self.globalConfig.SOLD_PRODUCTS_SHOW_PRODUCT_CARD};},get witView(){return{apiUrl:self.globalConfig.WITVIEW_API_URL,customerId:self.globalConfig.WITVIEW_CUSTOMER_ID,enabled:self.globalConfig.ENABLE_WITVIEW_INTEGRATION};},get yotpo(){return{appKey:self.globalConfig.YOTPO_APP_KEY,enabled:self.globalConfig.ENABLE_YOTPO_INTEGRATION&&self.globalConfig.YOTPO_APP_KEY.length>0};}};}).actions(function(self){return{setup:function setup(globalConfig,site){self.globalConfig=globalConfig;self.site=site;self.setLoading(false);},loadGlobalConfig:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadGlobalConfig(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadGlobalConfig$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('config/global');case 4:self.globalConfig=_context.sent;_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 11:self.setLoading(false);case 12:case'end':return _context.stop();}}},loadGlobalConfig,this,[[1,7]]);})),setInStockProductsOnly:function setInStockProductsOnly(inStockProductsOnly){var storedValue=String(inStockProductsOnly);// Persist the configuration
window.localStorage.setItem(LOCAL_STORAGE_IN_STOCK_PRODUCTS_ONLY_KEY,storedValue);self.storedInStockProductsOnly=storedValue;},setProductListStyle:function setProductListStyle(productListStyle){var storedValue=String(productListStyle);// Persist the configuration
window.localStorage.setItem(LOCAL_STORAGE_PRODUCT_LIST_STYLE,storedValue);self.storedProductListStyle=storedValue;}};});/* harmony default export */ __webpack_exports__["a"] = (ConfigStore);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestStateType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var RequestState={LOADING:'LOADING',LOADED:'LOADED',NONE:'NONE',ERROR:'ERROR'};/* harmony default export */ __webpack_exports__["b"] = (RequestState);var RequestStateType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('State',Object.values(RequestState));

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Icon=function(_Component){_inherits(Icon,_Component);function Icon(){_classCallCheck(this,Icon);return _possibleConstructorReturn(this,(Icon.__proto__||Object.getPrototypeOf(Icon)).apply(this,arguments));}_createClass(Icon,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('Icon','fa','fa-'+this.props.name,'icon','icon-'+this.props.name,this.props.className,{'fa-spin':this.props.spin})});}}]);return Icon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Icon.propTypes={name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,spin:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};Icon.defaultProps={className:'',spin:false};/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var RouteService=function(){function RouteService(sectionStore,languageStore,configStore,categoryStore){_classCallCheck(this,RouteService);this.sectionStore=sectionStore;this.languageStore=languageStore;this.configStore=configStore;this.categoryStore=categoryStore;}_createClass(RouteService,[{key:'findCanonicalSectionForCategory',value:function findCanonicalSectionForCategory(category){if(category){// Return first section that includes this category
return this.sectionStore.sections.find(function(section){return section.includesCategory(category);});}return null;}},{key:'findCanonicalSection',value:function findCanonicalSection(sectionIds){var _this=this;// Get the first section ID that has a matching section
// In a multi-domain store there might be section IDs that do not match.
var defaultSectionId=sectionIds.find(function(sectionId){return _this.sectionStore.findSectionById(sectionId);});return defaultSectionId&&this.sectionStore.findSectionById(defaultSectionId);}},{key:'transformBreadCrumbs',value:function transformBreadCrumbs(breadcrumbs){var _this2=this;var transformedBreadcrumbs=[];if(this.sectionStore.activeSection){transformedBreadcrumbs.push({text:this.sectionStore.activeSection.display_name,url:this.getPath(this.sectionStore.activeSection.path)});}return transformedBreadcrumbs.concat(breadcrumbs.map(function(breadcrumb){var url=breadcrumb.url&&_this2.getPath(breadcrumb.url,_this2.sectionStore.activeSection);return Object.assign({},breadcrumb,{url:url});}));}},{key:'getCategoryPath',value:function getCategoryPath(category,path){var section=void 0;if(this.sectionStore.activeSection&&this.sectionStore.activeSection.includesCategory(category)){section=this.sectionStore.activeSection;}else{section=this.findCanonicalSectionForCategory(category);}return this.getPath(path||category.path,section);}},{key:'getCanonicalCategoryPath',value:function getCanonicalCategoryPath(category,path){var section=this.findCanonicalSectionForCategory(category);return this.getPath(path||category.path,section);}},{key:'getCanonicalProductPath',value:function getCanonicalProductPath(product){var hasCategory=!!product.canonicalCategoryId;var canonicalSection=null;if(hasCategory){var category=this.categoryStore.findCategoryById(product.canonicalCategoryId);canonicalSection=this.findCanonicalSectionForCategory(category);}return this.getPath(product.path,canonicalSection);}},{key:'getProductPath',value:function getProductPath(product,path){var section=void 0;if(this.sectionStore.activeSection&&product.belongsToSection(this.sectionStore.activeSection.id)){section=this.sectionStore.activeSection;}else{section=this.findCanonicalSection(product.section_ids);}return this.getPath(path||product.path,section);}},{key:'getPath',value:function getPath(path,section,locale){var languagePrefix='';if(this.languageStore.languages.length>1){var routeLocale=locale||this.languageStore.activeLocale;languagePrefix='/'+routeLocale;}var sectionPrefix='';if(section&&this.configStore.activateSections){sectionPrefix='/'+section.slug;}return languagePrefix+sectionPrefix+path;}}]);return RouteService;}();/* harmony default export */ __webpack_exports__["a"] = (RouteService);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_User__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_session__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_AccountModal__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Session__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_StatefulStore__ = __webpack_require__(25);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AccountStore=__WEBPACK_IMPORTED_MODULE_8__models_StatefulStore__["a" /* default */].named('AccountStore').props({customerId:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].number),account:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_4__models_User__["a" /* default */]),accountModal:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6__models_AccountModal__["a" /* default */],{}),session:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_7__models_Session__["a" /* default */]),default_language_code:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string),loggedInStatus:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].boolean)}).views(function(self){return{get loggedIn(){if(!self.account){return false;}return self.account.is_logged?self.account.is_logged===self.loggedInStatus:false;},get isRetailer(){return self.account&&self.account.is_retailer?self.account.is_retailer:false;},get showPricesWithTax(){return self.account?self.account.show_prices_with_tax:true;},get isViewOnly(){return self.account?self.account.view_only:false;},get isBalanceBuyer(){// Can buy balance for subusers
return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore?Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore.account.isMoneyTransfer:false;},get isBalanceUser(){// Can use balance
var configValue=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore?Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore.account.isMoneyTransfer:false;return configValue&&self.account&&self.account.is_customer_user&&!!self.account.user_id;},get getUserId(){return self.account&&self.account.user_id;},get isCustomerUser(){return self.account&&self.account.is_customer_user;},get isClientLoginEnabled(){return self.account&&self.account.is_client_login_enabled;},get isClient(){return self.account&&self.account.is_logged_as_client;},get name(){var company=self.account.personal_info.company;var name=self.account.personal_info.firstname+' '+self.account.personal_info.lastname;return company.length>0?company:name;},get showCartMatrix(){return self.account&&self.account.show_cart_matrix;},get isUserAllowedAddressModification(){return self.account&&self.account.allow_address_modifications;},get getCustomerGroupId(){return self.account?self.account.customer_group_id:null;}};}).actions(function(self){var source=void 0;return{setup:function setup(account){self.setAccount(account);self.setLoading(false);},setAccount:function setAccount(account){self.account=account.user;self.customerId=account.user.customer_id;self.session=account.session;self.default_language_code=account.default_language_code;self.setLoggedInStatus(account.user.is_logged);Object(__WEBPACK_IMPORTED_MODULE_5__util_session__["b" /* storeSessionId */])(account.session_id);},setLoggedInStatus:function setLoggedInStatus(status){self.loggedInStatus=status;},setInfo:function setInfo(info){self.customerId=info.customer_id;self.account.personal_info.telephone=info.personal_info.telephone;self.account.personal_info.company=info.personal_info.company;},setClients:function setClients(clients){self.account.clients=clients;},loadAccount:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAccount(){var accountResponse,infoResponse,_ref,_ref2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAccount$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);accountResponse=void 0,infoResponse=void 0;_context.prev=2;_context.next=5;return Promise.all([Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('account'),Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('my-account/info')]);case 5:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);accountResponse=_ref2[0];infoResponse=_ref2[1];_context.next=20;break;case 11:_context.prev=11;_context.t0=_context['catch'](2);if(!(_context.t0.accountResponse&&_context.t0.accountResponse.status===401)){_context.next=17;break;}accountResponse=_context.t0.accountResponse.data;_context.next=19;break;case 17:self.setError(_context.t0);throw _context.t0;case 19:throw _context.t0;case 20:self.setAccount(accountResponse);self.setInfo(infoResponse);self.setLoading(false);case 23:case'end':return _context.stop();}}},loadAccount,this,[[2,11]]);})),loadClients:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadClients(text){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadClients$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('account/clients',{params:{q:text}});case 4:request=_context2.sent;self.setClients(request);_context2.next=12;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 12:self.setLoading(false);case 13:case'end':return _context2.stop();}}},loadClients,this,[[1,8]]);})),loginClient:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loginClient(selectedClient){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loginClient$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('account/client-login',{selectedClient:selectedClient});case 3:response=_context3.sent;self.account=response.data.user;__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove('customer_hash');return _context3.abrupt('return',response.data);case 9:_context3.prev=9;_context3.t0=_context3['catch'](0);if(!(_context3.t0.response&&_context3.t0.response.status===401)){_context3.next=15;break;}return _context3.abrupt('return',_context3.t0.response.data);case 15:throw _context3.t0;case 16:case'end':return _context3.stop();}}},loginClient,this,[[0,9]]);})),login:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function login(username,password,productListProducts){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function login$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('account/login',{username:username,password:password,productListProducts:productListProducts});case 3:response=_context4.sent;self.account=response.data.user;__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove('customer_hash');return _context4.abrupt('return',response.data);case 9:_context4.prev=9;_context4.t0=_context4['catch'](0);if(!(_context4.t0.response&&_context4.t0.response.status===401)){_context4.next=15;break;}return _context4.abrupt('return',_context4.t0.response.data);case 15:throw _context4.t0;case 16:case'end':return _context4.stop();}}},login,this,[[0,9]]);})),loginCheck:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loginCheck(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loginCheck$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:// If we already have a query running, cancel it.
if(source){source.cancel();}source=__WEBPACK_IMPORTED_MODULE_3_axios__["CancelToken"].source();_context5.prev=2;_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('account/login-check',{cancelToken:source.token});case 5:response=_context5.sent;self.setLoggedInStatus(response.is_logged);_context5.next=12;break;case 9:_context5.prev=9;_context5.t0=_context5['catch'](2);throw _context5.t0;case 12:case'end':return _context5.stop();}}},loginCheck,this,[[2,9]]);})),logout:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function logout(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function logout$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('account/logout');case 2:response=_context6.sent;self.account=null;// Reload in order to refresh everything
// When logout_url is defined it will be assigned
if(response.data.logout_url&&response.data.logout_url.length>0){window.location.assign(response.data.logout_url);}else{window.location.reload();}case 5:case'end':return _context6.stop();}}},logout,this);})),refreshCoupons:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAccount(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAccount$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('account/refresh-coupons');case 2:response=_context7.sent;self.session.addCoupons(response.activated_coupons);case 4:case'end':return _context7.stop();}}},loadAccount,this);})),updateSessionParams:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function updateSessionParams(params){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateSessionParams$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('account/session',{params:params});case 3:response=_context8.sent;self.setAccount(response);_context8.next=14;break;case 7:_context8.prev=7;_context8.t0=_context8['catch'](0);if(!(_context8.t0.response&&_context8.t0.response.status===401)){_context8.next=13;break;}// logged out user, request should still be successful
self.setAccount(_context8.t0.response.data);_context8.next=14;break;case 13:throw _context8.t0;case 14:case'end':return _context8.stop();}}},updateSessionParams,this,[[0,7]]);})),register:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(userData,productListProducts){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:userData['productListProducts']=productListProducts;_context9.prev=1;_context9.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('account/register',userData);case 4:response=_context9.sent;__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove('customer_hash');return _context9.abrupt('return',response);case 9:_context9.prev=9;_context9.t0=_context9['catch'](1);throw _context9.t0;case 12:case'end':return _context9.stop();}}},_callee,this,[[1,9]]);})),resetPassword:function resetPassword(email){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('account/reset-password',{email:email});},setPasswordWithToken:function setPasswordWithToken(renewToken,password,confirmPassword){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().put('account/set-new-password',{renewToken:renewToken,password:password,password_confirmation:confirmPassword});}};});/* harmony default export */ __webpack_exports__["a"] = (AccountStore);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Paths={FrontPage:'/',AdvancedSearch:'/s/search/',Checkout:'/kauppa/kassa/81/',LiteCheckout:'/lite-checkout/',InfoPage:'/i/:slug/:id/',Product:'/:slug/p/:id/:activeProductId?/',OnSale:'/s/sale/',NewProducts:'/s/new/',PopularProducts:'/s/popular/',RecommendedProducts:'/s/recommended/',ManufacturerList:'/s/brands/',Manufacturer:'/b/:slug/:id/',Section:'/:section/',Category:'/:rootProductGroup/:productGroup?/:subProductGroup?/c/:id/',MainProductGroup:'/:rootProductGroup/c/:id/',ProductGroup:'/:rootProductGroup/:productGroup/c/:id/',SoldProducts:'/s/sold-products/',SubProductGroup:'/:rootProductGroup/:productGroup/:subProductGroup/c/:id/',MyAccount:'/s/my-account/',MyAccountAddressList:'/s/my-account/addresses/',MyAccountAddress:'/s/my-account/addresses/:id/',MyAccountAddressNew:'/s/my-account/addresses/new/',MyAccountBalanceUser:'/s/my-account/money-transfer/payment/',MyAccountBalanceUserAccountInfo:'/s/my-account/money-transfer/info/',MyAccountBalanceUserPaymentHistory:'/s/my-account/money-transfer/payment/history/',MyAccountBalanceSubUser:'/s/my-account/money-transfer/usage/',MyAccountChangePassword:'/s/my-account/change-password/',MyAccountCreditAccount:'/s/my-account/credit/',MyAccountInfo:'/s/my-account/info/',MyAccountOrderList:'/s/my-account/orders/',MyAccountOrder:'/s/my-account/orders/:id/',MyAccountPaymentTokenList:'/s/my-account/card-tokenization/',MyAccountPurchasesList:'/s/my-account/purchases/',MyAccountRecurringOrder:'/s/my-account/recurring-orders/:id/',MyAccountRecurringOrderList:'/s/my-account/recurring-orders/',MyAccountUserList:'/s/my-account/users/',MyAccountUser:'/s/my-account/users/:id/',MyAccountUserNew:'/s/my-account/users/new/',SetNewPassword:'/s/set-new-password/:token/',ThankYouPage:'/s/checkout/thank-you/',MyAccountThankYouPage:'/s/my-account/money-transfer/success/',KlarnaInstantShoppingThankYouPage:'/s/instant-shopping/success/:orderId/:trackingCode/',NotFoundPage:'/not-found/',CustomerProducts:'/s/customer-prices/',WishList:'/s/wishlist/',WishListProductList:'/s/wishlist/:accessToken',VehiclePartSearch:'/s/vehicle-part-search/'};/* harmony default export */ __webpack_exports__["a"] = (Paths);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_MobileNavigation__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_MegaMenu__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Modal__ = __webpack_require__(140);
var UIStore=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('UIStore',{activeBreakpoint:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["b" /* ViewBreakpointType */],__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].LG),additionalServicesModal:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_4__models_Modal__["a" /* default */].named('AdditionalServicesModal'),{isOpen:false}),addToCartRowIsVisible:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),currentPage:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),documentScrollTop:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,0),headerHeight:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,0),lastPathname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),megaMenu:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__models_MegaMenu__["a" /* default */],{isOpen:false}),mobileNavigation:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__models_MobileNavigation__["a" /* default */],{}),mobileRegionalSettingsModal:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_4__models_Modal__["a" /* default */].named('MobileRegionalSettingsModal'),{}),popoverActive:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),scrollingDown:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),searchIsActive:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false)}).views(function(self){return{get isSmallest(){return[__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XS].includes(self.activeBreakpoint);},get isSmall(){return[__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].SM].includes(self.activeBreakpoint);},get isHD(){return[__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].LG].includes(self.activeBreakpoint);},get isExtraLarge(){return[__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XL].includes(self.activeBreakpoint);},get isLargest(){return[__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XXL].includes(self.activeBreakpoint);},get isMobile(){return[__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XS,__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].SM].includes(self.activeBreakpoint);},get isTablet(){return[__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].MD].includes(self.activeBreakpoint);},get isDesktop(){return[__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].LG,__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XL,__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XXL].includes(self.activeBreakpoint);},get isLandscape(){return window.matchMedia('(orientation:landscape)').matches;},get isPortrait(){return window.matchMedia('(orientation:portrait)').matches;}};}).actions(function(self){return{setCurrentPage:function setCurrentPage(pageName){self.currentPage=pageName;},setDocumentScrollTop:function setDocumentScrollTop(scrollTop){self.scrollingDown=self.documentScrollTop<scrollTop;self.documentScrollTop=scrollTop;},setHeaderHeight:function setHeaderHeight(height){self.headerHeight=height;},setLastPathname:function setLastPathname(pathname){self.lastPathname=pathname;},setViewActiveBreakpoint:function setViewActiveBreakpoint(px){var breakpoint=__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XXL;if(px<__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */][__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].SM]){breakpoint=__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XS;}else if(px<__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */][__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].MD]){breakpoint=__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].SM;}else if(px<__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */][__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].LG]){breakpoint=__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].MD;}else if(px<__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */][__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XL]){breakpoint=__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].LG;}else if(px<__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */][__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XXL]){breakpoint=__WEBPACK_IMPORTED_MODULE_1__types_ViewBreakpoint__["c" /* default */].XL;}self.activeBreakpoint=breakpoint;},toggleAddToCartRow:function toggleAddToCartRow(active){self.addToCartRowIsVisible=active;},togglePopover:function togglePopover(active){self.popoverActive=active;},toggleSearch:function toggleSearch(active){self.searchIsActive=active;}};});/* harmony default export */ __webpack_exports__["a"] = (UIStore);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(387);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(389);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(206);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(392);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.route = exports.match = exports.history = exports.location = undefined;

var _propTypes = __webpack_require__(643);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var location = exports.location = _propTypes2.default.shape({
  hash: _propTypes2.default.string.isRequired,
  key: _propTypes2.default.string, // only in createBrowserHistory and createMemoryHistory
  pathname: _propTypes2.default.string.isRequired,
  search: _propTypes2.default.string.isRequired,
  state: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string]) // only in createBrowserHistory and createMemoryHistory
});

var history = exports.history = _propTypes2.default.shape({
  action: _propTypes2.default.oneOf(['PUSH', 'REPLACE', 'POP']).isRequired,
  block: _propTypes2.default.func.isRequired,
  canGo: _propTypes2.default.func, // only in createMemoryHistory
  createHref: _propTypes2.default.func.isRequired,
  entries: _propTypes2.default.arrayOf(location), // only in createMemoryHistory
  go: _propTypes2.default.func.isRequired,
  goBack: _propTypes2.default.func.isRequired,
  goForward: _propTypes2.default.func.isRequired,
  index: _propTypes2.default.number, // only in createMemoryHistory
  length: _propTypes2.default.number.isRequired,
  listen: _propTypes2.default.func.isRequired,
  location: location.isRequired,
  push: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired
});

var match = exports.match = _propTypes2.default.shape({
  isExact: _propTypes2.default.bool,
  params: _propTypes2.default.object.isRequired,
  path: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired
});

var childRoute = _propTypes2.default.shape({
  path: _propTypes2.default.string.isRequired,
  exact: _propTypes2.default.bool,
  component: _propTypes2.default.element.isRequired,
  routes: _propTypes2.default.arrayOf(childRoute)
});

var route = exports.route = _propTypes2.default.shape({
  component: _propTypes2.default.element,
  routes: _propTypes2.default.arrayOf(childRoute)
});

exports.default = {
  location: location,
  history: history,
  match: match,
  route: route
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_every__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_head__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Manufacturer__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductFile__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProductMatrix__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductMulti__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_ProductAvailabilityType__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Category__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Stock__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ProductExtraProperty__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ProductFeature__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ProductFreeTextField__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Review__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ProductSeason__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__BundleProductInfo__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ProductAdditionalTab__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__QuantityDiscount__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ShippingDetails__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SizeGuide__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AdditionalService__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__PropertyImage__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__StartaxInfo__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__RelatedProduct__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ExternalReview__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ProductMerchantInfo__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__types_ProductLicenceType__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__types_ProductRecurringOrderType__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Price__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__RecurringOrders__ = __webpack_require__(983);
var Product=__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].model('Product',{additionalServices:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_31__AdditionalService__["a" /* default */]),[]),additionalServicesState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),additionalTabs:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_26__ProductAdditionalTab__["a" /* default */]),[]),additionalTabsState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),all_category_ids:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number),allow_file_upload:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].boolean),alsoPurchasedIds:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),alsoPurchasedState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),availability_html:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,availability_html_for_listing:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),availability_type:__WEBPACK_IMPORTED_MODULE_13__types_ProductAvailabilityType__["a" /* ProductAvailabilityTypeType */],available_in_store:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].boolean,available_online:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].boolean,available_somewhere:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].boolean,bottle_deposit:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_40__Price__["a" /* default */]),bundleProductInfos:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_25__BundleProductInfo__["a" /* default */]),[]),bundleProductInfosStateInternal:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),can_be_ordered_out_of_stock:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].boolean,class:__WEBPACK_IMPORTED_MODULE_12__types_ProductClass__["a" /* ProductClassType */],collection:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_10__ProductMatrix__["a" /* default */]),cross_selling_id:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,customer_group_visibilities:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number)),date_added:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,date_available:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,description_long:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,description_short:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,''),display_weight:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),ean:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,external_reviews:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_35__ExternalReview__["a" /* default */])),extra_id:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),extra_properties:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_19__ProductExtraProperty__["a" /* default */]),features:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_20__ProductFeature__["a" /* default */]),files:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_9__ProductFile__["a" /* default */]),free_quantity:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number,free_text_fields:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_22__ProductFreeTextField__["a" /* default */]),has_required_services:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].boolean),id:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].identifier,images:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_8__ProductImage__["a" /* default */]),[]),labels:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_32__PropertyImage__["b" /* default */]),[]),main_category_id:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number),manufacturer_id:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),manufacturer_product_id:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),merchant_info:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_36__ProductMerchantInfo__["a" /* default */]),min_order_quantity:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number),model:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,multi:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_11__ProductMulti__["a" /* default */]),multiproduct_id:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,multiproduct_title:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),name:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,package_size:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number),package_unit_name:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),price_info:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_14__ProductPriceInfo__["a" /* default */]),quantityDiscounts:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_27__QuantityDiscount__["a" /* default */]),[]),quantityDiscountsState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),recommended_with_ids:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),[]),recurringOrders:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_41__RecurringOrders__["a" /* default */],{}),recurringOrdersState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),recurring_order_price:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_40__Price__["a" /* default */]),recurring_order_type:__WEBPACK_IMPORTED_MODULE_39__types_ProductRecurringOrderType__["a" /* ProductRecurringOrderTypeType */],required_license:__WEBPACK_IMPORTED_MODULE_38__types_ProductLicenceType__["a" /* ProductLicenceTypeType */],relatedProducts:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_34__RelatedProduct__["a" /* default */],{}),relatedProductsState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),reviews:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_23__Review__["a" /* default */]),[]),reviews_average:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number,reviews_count:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number,reviewsState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),rotating_images:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),rotatingImagesList:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string)),{}),rotatingImagesListStates:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE)),{}),season:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_24__ProductSeason__["a" /* default */]),section_ids:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number),seo_description:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),shipping_html:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybe(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),shippingDetails:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_29__ShippingDetails__["a" /* default */]),{}),shippingStates:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */]),{}),singular_price_divider:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number),singular_price_unit:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),sizeGuides:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_30__SizeGuide__["a" /* default */]),[]),sizeGuidesState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE),slug:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,sold_out:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].boolean),startaxInfo:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_33__StartaxInfo__["a" /* default */]),stock_unit:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string,stocks:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_18__Stock__["a" /* default */])),{}),stockStates:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */]),{}),validatedServices:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_31__AdditionalService__["a" /* default */])),{}),validatedServicesState:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE)),{}),suitability_description:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].string),warranty:__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["l" /* types */].number)}).actions(function(self){var getLang=function getLang(){return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["g" /* getRoot */])(self).languageStore.activeLanguage.code;};var ifShoppingCenter=function ifShoppingCenter(){return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["g" /* getRoot */])(self).configStore.siteConfig.isShoppingCenter;};var baseApi=function baseApi(endpoint){return ifShoppingCenter()?'shopping-center/'+endpoint:''+endpoint;};var productsApiEndpoint=function productsApiEndpoint(api,productId){var ifProductId=productId?productId:self.id;return ifShoppingCenter()?'shopping-center/products/'+ifProductId+'/'+api:'products/'+ifProductId+'/'+api;};var getAdditionalServices=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getAdditionalServices(params){var additionalServicesApi;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAdditionalServices$(_context){while(1){switch(_context.prev=_context.next){case 0:additionalServicesApi=productsApiEndpoint('additional-services');_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+additionalServicesApi,{params:params},{active_section:null});case 3:return _context.abrupt('return',_context.sent);case 4:case'end':return _context.stop();}}},getAdditionalServices,this);});return{loadStocks:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadStocks(extendedId){var storageStocks;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadStocks$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.stockStates.set(extendedId,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(baseApi('stocks')+'/'+extendedId,{},{active_section:null});case 4:storageStocks=_context2.sent;self.setStocks(extendedId,storageStocks);self.stockStates.set(extendedId,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED);_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);self.stockStates.set(extendedId,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR);throw _context2.t0;case 13:case'end':return _context2.stop();}}},loadStocks,this,[[1,9]]);})),setStocks:function setStocks(extendedId,stocks){self.stocks.set(extendedId,stocks);},loadShippingDetails:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadShippingDetails(activeId){var shippingApi,shippingDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadShippingDetails$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(self.isNotAvailable()){_context3.next=15;break;}self.shippingStates.set(activeId,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING);shippingApi=productsApiEndpoint('shipping',activeId);_context3.prev=3;_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+shippingApi,{},{active_section:null});case 6:shippingDetails=_context3.sent;self.setShippingDetails(activeId,shippingDetails);self.shippingStates.set(activeId,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED);_context3.next=15;break;case 11:_context3.prev=11;_context3.t0=_context3['catch'](3);self.shippingStates.set(activeId,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR);throw _context3.t0;case 15:case'end':return _context3.stop();}}},loadShippingDetails,this,[[3,11]]);})),setShippingDetails:function setShippingDetails(activeId,shippingDetails){self.shippingDetails.set(activeId,shippingDetails);},loadPropertyImages:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadPropertyImages(){var propertyImagesApi,propertyImages;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadPropertyImages$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(self.isNotAvailable()){_context4.next=15;break;}self.propertyImagesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;propertyImagesApi=productsApiEndpoint('property-images');_context4.prev=3;_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+propertyImagesApi);case 6:propertyImages=_context4.sent;self.setPropertyImages(propertyImages);self.propertyImagesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context4.next=15;break;case 11:_context4.prev=11;_context4.t0=_context4['catch'](3);self.propertyImagesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context4.t0;case 15:case'end':return _context4.stop();}}},loadPropertyImages,this,[[3,11]]);})),setPropertyImages:function setPropertyImages(propertyImages){self.propertyImages=propertyImages;},loadReviews:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadReviews(){var reviewsApi,reviews;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadReviews$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(self.reviews_count>0)){_context5.next=17;break;}self.reviewsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;reviewsApi=productsApiEndpoint('reviews');_context5.prev=3;_context5.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+reviewsApi,{},{active_section:null});case 6:reviews=_context5.sent;self.setReviews(reviews);self.reviewsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context5.next=15;break;case 11:_context5.prev=11;_context5.t0=_context5['catch'](3);self.reviewsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context5.t0;case 15:_context5.next=18;break;case 17:// No need to load reviews, so set state to loaded.
self.reviewsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;case 18:case'end':return _context5.stop();}}},loadReviews,this,[[3,11]]);})),setReviews:function setReviews(reviews){self.reviews=reviews;},loadAlsoPurchased:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAlsoPurchased(productId){var alsoPurchasedApi,alsoPurchasedIds;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAlsoPurchased$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:self.alsoPurchasedState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;alsoPurchasedApi=productsApiEndpoint('also-purchased',productId);_context6.prev=2;_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+alsoPurchasedApi,{},{active_section:null});case 5:alsoPurchasedIds=_context6.sent;self.setAlsoPurchased(alsoPurchasedIds);self.alsoPurchasedState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context6.next=14;break;case 10:_context6.prev=10;_context6.t0=_context6['catch'](2);self.alsoPurchasedState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context6.t0;case 14:case'end':return _context6.stop();}}},loadAlsoPurchased,this,[[2,10]]);})),setAlsoPurchased:function setAlsoPurchased(alsoPurchasedIds){self.alsoPurchasedIds=alsoPurchasedIds;},loadBundleProductInfos:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadBundleProductInfos(){var bundleProductInfosApi,bundleProductInfos;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadBundleProductInfos$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:self.bundleProductInfosStateInternal=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;bundleProductInfosApi=productsApiEndpoint('bundle-products');_context7.prev=2;_context7.next=5;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+bundleProductInfosApi,{},{active_section:null});case 5:bundleProductInfos=_context7.sent;self.setBundleProductInfos(bundleProductInfos);self.bundleProductInfosStateInternal=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context7.next=14;break;case 10:_context7.prev=10;_context7.t0=_context7['catch'](2);self.bundleProductInfosStateInternal=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context7.t0;case 14:case'end':return _context7.stop();}}},loadBundleProductInfos,this,[[2,10]]);})),setBundleProductInfos:function setBundleProductInfos(bundleProductInfos){self.bundleProductInfos=bundleProductInfos;},loadAdditionalTabs:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAdditionalTabs(){var additionalTabsApi,additionalTabs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAdditionalTabs$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:self.additionalTabsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;additionalTabsApi=productsApiEndpoint('additional-tabs');_context8.prev=2;_context8.next=5;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+additionalTabsApi,{},{active_section:null});case 5:additionalTabs=_context8.sent;self.setAdditionalTabs(additionalTabs);self.additionalTabsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context8.next=14;break;case 10:_context8.prev=10;_context8.t0=_context8['catch'](2);self.additionalTabsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context8.t0;case 14:case'end':return _context8.stop();}}},loadAdditionalTabs,this,[[2,10]]);})),setAdditionalTabs:function setAdditionalTabs(additionalTabs){self.additionalTabs=additionalTabs;},loadQuantityDiscounts:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadQuantityDiscounts(){var quantityDiscountsApi,quantityDiscounts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadQuantityDiscounts$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(self.isNotAvailable()){_context9.next=15;break;}self.quantityDiscountsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;quantityDiscountsApi=productsApiEndpoint('quantity-discounts');_context9.prev=3;_context9.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+quantityDiscountsApi,{},{active_section:null});case 6:quantityDiscounts=_context9.sent;self.setQuantityDiscounts(quantityDiscounts);self.quantityDiscountsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context9.next=15;break;case 11:_context9.prev=11;_context9.t0=_context9['catch'](3);self.quantityDiscountsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context9.t0;case 15:case'end':return _context9.stop();}}},loadQuantityDiscounts,this,[[3,11]]);})),setQuantityDiscounts:function setQuantityDiscounts(discounts){self.quantityDiscounts=discounts;},loadRotatingImagesList:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadRotatingImagesList(filePath){var rotatingImagesListApi,rotatingImagesList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadRotatingImagesList$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:self.rotatingImagesListStates.set(filePath,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING);rotatingImagesListApi=productsApiEndpoint('rotating-images?'+Object(__WEBPACK_IMPORTED_MODULE_28__util_queryString__["c" /* stringify */])({filePath:filePath}));_context10.prev=2;_context10.next=5;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+rotatingImagesListApi,{},{active_section:null});case 5:rotatingImagesList=_context10.sent;self.setRotatingImagesList(filePath,rotatingImagesList);self.rotatingImagesListStates.set(filePath,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED);_context10.next=14;break;case 10:_context10.prev=10;_context10.t0=_context10['catch'](2);self.rotatingImagesListStates.set(filePath,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR);throw _context10.t0;case 14:case'end':return _context10.stop();}}},loadRotatingImagesList,this,[[2,10]]);})),setRotatingImagesList:function setRotatingImagesList(filePath,rotatingImagesList){self.rotatingImagesList.set(filePath,rotatingImagesList);},loadAdditionalServices:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAdditionalServices(category){var additionalServices;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAdditionalServices$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:if(!(category&&!self.isNotAvailable())){_context11.next=12;break;}self.additionalServicesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;_context11.prev=2;return _context11.delegateYield(getAdditionalServices({category:category}),'t0',4);case 4:additionalServices=_context11.t0;self.setAdditionalServices(additionalServices);_context11.next=12;break;case 8:_context11.prev=8;_context11.t1=_context11['catch'](2);self.additionalServicesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context11.t1;case 12:case'end':return _context11.stop();}}},loadAdditionalServices,this,[[2,8]]);})),setAdditionalServices:function setAdditionalServices(additionalServices){self.additionalServices=additionalServices;self.additionalServicesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;},validateAdditionalServices:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAdditionalServices(_ref){var category=_ref.category,postalCode=_ref.postalCode;var additionalServices;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAdditionalServices$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:if(!(category&&postalCode&&!self.isNotAvailable())){_context12.next=12;break;}self.validatedServicesState.set(self.id+'--'+postalCode,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING);_context12.prev=2;return _context12.delegateYield(getAdditionalServices({category:category,postalCode:postalCode}),'t0',4);case 4:additionalServices=_context12.t0;self.setValidatedServices(additionalServices,postalCode);_context12.next=12;break;case 8:_context12.prev=8;_context12.t1=_context12['catch'](2);self.validatedServicesState.set(self.id+'--'+postalCode,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR);throw _context12.t1;case 12:case'end':return _context12.stop();}}},loadAdditionalServices,this,[[2,8]]);})),setValidatedServices:function setValidatedServices(additionalServices,postalCode){self.validatedServices.set(self.id+'--'+postalCode,additionalServices);self.validatedServicesState.set(self.id+'--'+postalCode,__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED);},submitReview:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function submitReview(review){var reviewsApi;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function submitReview$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:reviewsApi=productsApiEndpoint('reviews');_context13.next=3;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post(''+reviewsApi,review);case 3:return _context13.abrupt('return',_context13.sent);case 4:case'end':return _context13.stop();}}},submitReview,this);})),uploadFile:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function uploadFile(file){var formData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function uploadFile$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:formData=new FormData();formData.append('file',file);_context14.next=4;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post(baseApi('product-file-uploads')+'/'+self.id,formData);case 4:case'end':return _context14.stop();}}},uploadFile,this);})),deleteFile:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function deleteFile(fileName){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteFile$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete(baseApi('product-file-uploads')+'/'+self.id,{data:{fileName:fileName}});case 2:case'end':return _context15.stop();}}},deleteFile,this);})),loadSizeGuides:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadSizeGuides(params){var sizeGuidesApi,sizeGuides;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadSizeGuides$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:if(self.isNotAvailable()){_context16.next=15;break;}self.sizeGuidesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;sizeGuidesApi=productsApiEndpoint('size-guides');_context16.prev=3;_context16.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+sizeGuidesApi,{params:params},{active_section:null});case 6:sizeGuides=_context16.sent;self.setSizeGuides(sizeGuides);self.sizeGuidesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context16.next=15;break;case 11:_context16.prev=11;_context16.t0=_context16['catch'](3);self.sizeGuidesState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context16.t0;case 15:case'end':return _context16.stop();}}},loadSizeGuides,this,[[3,11]]);})),setSizeGuides:function setSizeGuides(guides){self.sizeGuides=guides;},loadRelatedProducts:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadRelatedProducts(){var relatedProducts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadRelatedProducts$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:self.relatedProductsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;_context17.prev=1;_context17.next=4;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('products/'+self.id+'/related-products?'+getLang());case 4:relatedProducts=_context17.sent;self.setRelatedProducts(relatedProducts);self.relatedProductsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context17.next=13;break;case 9:_context17.prev=9;_context17.t0=_context17['catch'](1);self.relatedProductsState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context17.t0;case 13:case'end':return _context17.stop();}}},loadRelatedProducts,this,[[1,9]]);})),setRelatedProducts:function setRelatedProducts(relatedProducts){self.relatedProducts=relatedProducts;},loadRecurringOrders:Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadRecurringOrders(){var recurringOrders;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadRecurringOrders$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:self.recurringOrdersState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;_context18.prev=1;_context18.next=4;return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('products/'+self.id+'/recurring-orders');case 4:recurringOrders=_context18.sent;self.setRecurringOrders(recurringOrders);self.recurringOrdersState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;_context18.next=13;break;case 9:_context18.prev=9;_context18.t0=_context18['catch'](1);self.recurringOrdersState=__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR;throw _context18.t0;case 13:case'end':return _context18.stop();}}},loadRecurringOrders,this,[[1,9]]);})),setRecurringOrders:function setRecurringOrders(recurringOrders){self.recurringOrders=recurringOrders;},sortProductImages:function sortProductImages(key){self.images=self.images&&__WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default()(self.images,[key]);}};}).views(function(self){var getActiveCurrencyPrecision=function getActiveCurrencyPrecision(){return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["g" /* getRoot */])(self).currencyStore.activeCurrency.precision;};// Assigning the function as a reference so we would create less new Math-functions every time it's being used.
var roundWithPrecisionRef=__WEBPACK_IMPORTED_MODULE_37__util_number__["e" /* roundWithPrecision */];return{belongsToSomeSection:function belongsToSomeSection(sectionIds){return self.section_ids.some(function(sectionId){return sectionIds.indexOf(sectionId)!==-1;});},belongsToSection:function belongsToSection(sectionId){return self.section_ids.indexOf(sectionId)!==-1;},belongsToCategory:function belongsToCategory(categoryId){if(self.allCategories){return __WEBPACK_IMPORTED_MODULE_4_lodash_some___default()(self.allCategories,function(category){return category.hierarchy.findIndex(function(category){return category.id===categoryId;})!==-1;});}},breadcrumbsForCategory:function breadcrumbsForCategory(category){var breadcrumbItems=[];if(category){breadcrumbItems=breadcrumbItems.concat(category.breadcrumbs);}breadcrumbItems.push({text:self.name,url:self.path});return breadcrumbItems;},canBeOrdered:function canBeOrdered(activeProductId){var actualProduct=self.getActualProduct(activeProductId);if(!actualProduct){return false;}if(actualProduct.availability_type===__WEBPACK_IMPORTED_MODULE_13__types_ProductAvailabilityType__["b" /* default */].ALLOW_BACKORDER){return true;}if(actualProduct.availability_type===__WEBPACK_IMPORTED_MODULE_13__types_ProductAvailabilityType__["b" /* default */].ONLY_IN_SHOP){return false;}if(actualProduct.season&&!actualProduct.season.isActive()){return false;}if(actualProduct.isTemporarilyUnavailable(activeProductId)){return false;}if(actualProduct.availability_type===__WEBPACK_IMPORTED_MODULE_13__types_ProductAvailabilityType__["b" /* default */].CLOSEOUT&&!actualProduct.hasEnoughStockAvailable(activeProductId)){return false;}return true;},findStorageStock:function findStorageStock(extendedId,storageId){return self.stocks.get(extendedId).find(function(stock){return stock.storage_id===storageId;});},getActualProduct:function getActualProduct(activeProductId){var actualProduct=self;if(self.class===__WEBPACK_IMPORTED_MODULE_12__types_ProductClass__["b" /* default */].MULTI){actualProduct=self.multi.findChild(activeProductId);}return actualProduct;},getFreeQuantity:function getFreeQuantity(activeProductId){var actualProduct=self.getActualProduct(activeProductId);if(!actualProduct){return 0;}var freeQuantity=actualProduct.free_quantity;if(actualProduct.class===__WEBPACK_IMPORTED_MODULE_12__types_ProductClass__["b" /* default */].COLLECTION){var collectionItem=actualProduct.collection.getItemWithProductId(activeProductId);freeQuantity=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(collectionItem,'product.free_quantity',0);}return freeQuantity;},getImage:function getImage(productId){return self.images&&self.images.find(function(image){return image.product_id===productId;});},getImagesBySize:function getImagesBySize(size){return self.images&&self.images.map(function(image){return image.sizes[size];});},getPackagePrice:function getPackagePrice(withTax,activeProductId){var product=self;if(activeProductId){product=self.getActualProduct(activeProductId)||product;}if(!product.package_size){return;}return roundWithPrecisionRef(product.package_size*roundWithPrecisionRef(product.getPrice(withTax,activeProductId),getActiveCurrencyPrecision()),getActiveCurrencyPrecision());},getPrice:function getPrice(withTax,activeProductId){var product=self;if(activeProductId){product=self.getActualProduct(activeProductId)||product;}return product.price_info?product.price_info.getPrice(withTax):0;},getPriceWithPrecision:function getPriceWithPrecision(withTax,activeProductId){var product=self;if(activeProductId){product=self.getActualProduct(activeProductId)||product;}return product.price_info?roundWithPrecisionRef(product.getPrice(withTax),getActiveCurrencyPrecision()):0;},getQuantityStep:function getQuantityStep(product){return product&&self.sellInPackage?self.package_size:1;},getValidatedServices:function getValidatedServices(_ref2){var productId=_ref2.productId,postalCode=_ref2.postalCode;return self.validatedServices.get(productId+'--'+postalCode);},getValidatedService:function getValidatedService(_ref3){var productId=_ref3.productId,postalCode=_ref3.postalCode,serviceId=_ref3.serviceId;var validatedServices=self.getValidatedServices({productId:productId,postalCode:postalCode});return self.ifValidatedServicesExists({productId:productId,postalCode:postalCode})&&validatedServices.find(function(service){return service.id===serviceId;}).valid_postal_code;},hasCustomerGroupVisibility:function hasCustomerGroupVisibility(customerGroupId){// Have to check if customer_group_visibilities doesn't exist because then backend response comes from cache and frontend cannot break.
if(!self.customer_group_visibilities){return true;}// When customer_group_visibilities is an empty list. It's hidden from everyone.
if(self.customer_group_visibilities&&self.customer_group_visibilities.length===0){return false;}return self.customer_group_visibilities.some(function(id){return id===customerGroupId;});},hasDeposit:function hasDeposit(activeProductId){var actualProduct=self.getActualProduct(activeProductId);return actualProduct&&actualProduct.bottle_deposit&&actualProduct.bottle_deposit.with_tax>0;},hasEnoughStockAvailable:function hasEnoughStockAvailable(activeProductId){var actualProduct=self.getActualProduct(activeProductId);var freeQuantity=actualProduct.getFreeQuantity(activeProductId);var requiredAmount=actualProduct.sellInPackage?actualProduct.package_size:1;return freeQuantity>=requiredAmount;},/**
       * Check if product has the given properties with the given element Id
       *
       * @param propertyElementMap An object with property ids as keys and element ids as values.
       * @returns {boolean}
       */hasProperties:function hasProperties(propertyElementMap){return __WEBPACK_IMPORTED_MODULE_2_lodash_every___default()(Object.keys(propertyElementMap),function(propertyId){var valueId=propertyElementMap[propertyId];return __WEBPACK_IMPORTED_MODULE_4_lodash_some___default()(self.extra_properties,function(extraProperty){return extraProperty.id===Number(propertyId)&&extraProperty.value_id===valueId;});});},hasOnlyRecurringOrder:function hasOnlyRecurringOrder(){return self.recurring_order_type===__WEBPACK_IMPORTED_MODULE_39__types_ProductRecurringOrderType__["b" /* default */].RECURRING_ORDERS_ONLY;},hasRecurringOrder:function hasRecurringOrder(){return self.recurring_order_type!==__WEBPACK_IMPORTED_MODULE_39__types_ProductRecurringOrderType__["b" /* default */].NOT_ALLOWED;},ifServiceIsRequiredAndRequiresPostalCodeValidation:function ifServiceIsRequiredAndRequiresPostalCodeValidation(){return self.additionalServices.some(function(service){return service.is_required&&service.requires_area_validation;});},ifServiceRequiresPostalCodeValidation:function ifServiceRequiresPostalCodeValidation(){return self.additionalServices.some(function(service){return service.requires_area_validation;});},ifValidServices:function ifValidServices(_ref4){var productId=_ref4.productId,postalCode=_ref4.postalCode;var validatedServices=self.ifValidatedServicesExists({productId:productId,postalCode:postalCode});if(!validatedServices){return;}var services=self.validatedServices.get(productId+'--'+postalCode);return services.some(function(service){return service.valid_postal_code;});},ifValidatedServicesExists:function ifValidatedServicesExists(_ref5){var productId=_ref5.productId,postalCode=_ref5.postalCode;var services=self.validatedServices.get(productId+'--'+postalCode);return services&&services.length>0;},isMulti:function isMulti(){return self.class===__WEBPACK_IMPORTED_MODULE_12__types_ProductClass__["b" /* default */].MULTI&&self.multi?true:false;},isProposalType:function isProposalType(activeProductId){var enquireForProposal=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var actualProduct=self.getActualProduct(activeProductId);var isProposalPrice=false;if(actualProduct){isProposalPrice=!actualProduct.price_info||actualProduct.price_info.getNormalPrice(true)<=0;}return enquireForProposal&&isProposalPrice;},isTemporarilyUnavailable:function isTemporarilyUnavailable(activeProductId){var actualProduct=self.getActualProduct(activeProductId);return actualProduct.availability_type===__WEBPACK_IMPORTED_MODULE_13__types_ProductAvailabilityType__["b" /* default */].NORMAL&&!actualProduct.hasEnoughStockAvailable(activeProductId)&&!actualProduct.can_be_ordered_out_of_stock;},pathWithActiveProductId:function pathWithActiveProductId(activeProductId){return''+this.path+activeProductId+'/';},get allCategories(){if(self.all_category_ids){return self.all_category_ids.map(function(categoryId){return Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_15__Category__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["g" /* getRoot */])(self),categoryId);}).filter(function(category){return!!category;});}},get bundleProductInfosState(){var cannotHaveAnyBundleProducts=self.recommended_with_ids.length===0;if(cannotHaveAnyBundleProducts){return __WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED;}return self.bundleProductInfosStateInternal;},get canBeOrderedOutOfStock(){return self.availability_type===__WEBPACK_IMPORTED_MODULE_13__types_ProductAvailabilityType__["b" /* default */].ALLOW_BACKORDER||self.can_be_ordered_out_of_stock;},get canonicalCategoryId(){if(self.main_category_id){return self.main_category_id;}return self.all_category_ids.length>0?self.all_category_ids[0]:null;},get sellInPackage(){return self.package_size&&self.package_size>0&&self.package_size!==1;},get manufacturer(){return self.manufacturer_id&&Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_7__Manufacturer__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["g" /* getRoot */])(self),self.manufacturer_id);},get mainCategory(){return self.main_category_id?Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_15__Category__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["g" /* getRoot */])(self),self.main_category_id):null;},get merchantInfo(){return self.merchant_info;},get merchantId(){return self.merchant_info&&self.merchant_info.id&&self.merchant_info.id;},get merchantSiteUrl(){return self.merchant_info&&self.merchant_info.site_url&&self.merchant_info.site_url;},get path(){var id=self.multiproduct_id||self.id;// Fix the multi product ID in case of case differences
if(self.multi&&self.multiproduct_id&&!Object.keys(self.multi.children).includes(id)){var actualMultiItem=Object.values(self.multi.children).find(function(multiChild){return multiChild.id.toUpperCase()===self.multiproduct_id.toUpperCase();});id=actualMultiItem?actualMultiItem.id:self.id;}var slug=self.slug||id;return Object(__WEBPACK_IMPORTED_MODULE_16__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_17__types_Paths__["a" /* default */].Product,{slug:slug,id:id});},get breadcrumbs(){return self.breadcrumbsForCategory(self.mainCategory);},get seoTitle(){var modelInSeoTitle=self.class!==__WEBPACK_IMPORTED_MODULE_12__types_ProductClass__["b" /* default */].MULTI&&self.model;var nameTitle=self.multiproduct_title!==null?self.multiproduct_title:self.name;return modelInSeoTitle?nameTitle+' '+self.model:nameTitle;},get seoDescription(){return self.seo_description;},isBlockedFromStoreReservation:function isBlockedFromStoreReservation(excludePropertyId){return excludePropertyId&&(!!self.extra_properties.some(function(property){return property.id===excludePropertyId;})||!!self.features.some(function(property){return property.id===excludePropertyId;}));},getMainImage:function getMainImage(activeProductId){return self.images.find(function(image){return image.product_id===activeProductId;})||__WEBPACK_IMPORTED_MODULE_5_lodash_head___default()(self.images);},get unitName(){return self.sellInPackage?self.package_unit_name:self.stock_unit;},get uploadedFiles(){var productFiles=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_state_tree__["g" /* getRoot */])(self).productStore.uploadedFiles.find(function(entry){return entry.id===self.id;});return productFiles?productFiles.files:[];},get listingAvailability(){return self.availability_html_for_listing||self.availability_html;},isNotAvailable:function isNotAvailable(){return self.availability_type===__WEBPACK_IMPORTED_MODULE_13__types_ProductAvailabilityType__["b" /* default */].CLOSEOUT&&self.sold_out;},get alternativeIds(){return self.relatedProducts&&self.relatedProducts.alternative_ids&&self.relatedProducts.alternative_ids;},get recommendedIds(){return self.relatedProducts&&self.relatedProducts.recommended_ids&&self.relatedProducts.recommended_ids;}};});/* harmony default export */ __webpack_exports__["a"] = (Product);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BlockSpinner__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Error__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ErrorHandler__ = __webpack_require__(91);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentForState=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ContentForState,_Component);function ContentForState(){_classCallCheck(this,ContentForState);return _possibleConstructorReturn(this,(ContentForState.__proto__||Object.getPrototypeOf(ContentForState)).apply(this,arguments));}_createClass(ContentForState,[{key:'render',value:function render(){var _props=this.props,state=_props.state,forLoaded=_props.forLoaded,error=_props.error,ErrorHandler=_props.errorHandler;var content=void 0;switch(state){case __WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED:content=forLoaded&&forLoaded();break;case __WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BlockSpinner__["a" /* default */],null);break;case __WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorHandler,{error:error});break;default:content=null;}return content;}}]);return ContentForState;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ContentForState.propTypes={state:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,forLoaded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_Error__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),errorHandler:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};ContentForState.defaultProps={errorHandler:__WEBPACK_IMPORTED_MODULE_7__ErrorHandler__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = (ContentForState);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createFormField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_FieldType__ = __webpack_require__(303);
/*
 * A FormField
 */var FormField=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('FormField',{// The value of the field
value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].union(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean)),type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1__types_FieldType__["a" /* FieldTypeType */],__WEBPACK_IMPORTED_MODULE_1__types_FieldType__["b" /* default */].NORMAL),// If true, the "valid" and "error" properties will change every time the
// value changes.
shouldValidate:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false)}).extend(function(self){var validators=void 0,_isActive=void 0;return{views:{get errors(){var errors=[];if(self.shouldValidate&&validators){validators.forEach(function(validator){var error=validator(self.value);if(error){errors.push(error);}});}return errors;},get valid(){return self.shouldValidate?self.errors.length===0:null;},get active(){return self.isActive();},isActive:function isActive(){return _isActive?_isActive():true;}},actions:{setValue:function setValue(value){self.value=value;},setShouldValidate:function setShouldValidate(value){self.shouldValidate=value;},setActive:function setActive(value){self.active=value;},/**
         * @param {function[]} newValidators
         */setValidators:function setValidators(newValidators){validators=newValidators;},hasValidators:function hasValidators(){return Array.isArray(validators)&&validators.length>0;},/**
         * @param {function} newIsActive
         */setIsActive:function setIsActive(newIsActive){_isActive=newIsActive;}}};});/* harmony default export */ __webpack_exports__["b"] = (FormField);function createFormField(){var field=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var validators=arguments[1];var isActive=arguments[2];var fieldModel=FormField.create(field);if(validators){fieldModel.setValidators(validators);}if(isActive){fieldModel.setIsActive(isActive);}return fieldModel;}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEOTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GenericMeta__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEOTitle=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SEOTitle,_Component);function SEOTitle(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SEOTitle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SEOTitle.__proto__||Object.getPrototypeOf(SEOTitle)).call.apply(_ref,[this].concat(args))),_this),_this.outputTitle=function(title){var shouldTranslate=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var _this$props=_this.props,configStore=_this$props.configStore,noSuffix=_this$props.noSuffix;var fullTitle=noSuffix?title:title+' - '+configStore.store.name+' '+configStore.languageTexts.TEXT_SEO_STORE_NAME_ADD;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,!shouldTranslate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GenericMeta__["a" /* default */],{name:'twitter:title',property:'og:title',content:fullTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,fullTitle)));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SEOTitle,[{key:'render',value:function render(){var title=this.props.title;var shouldTranslate=title&&title.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,shouldTranslate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],title,this.outputTitle):this.outputTitle(title,shouldTranslate));}}]);return SEOTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SEOTitle.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]).isRequired,noSuffix:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(SEOTitle));

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* TODO: make toggleable with a configuration setting? */var PageTitle=function(_Component){_inherits(PageTitle,_Component);function PageTitle(){_classCallCheck(this,PageTitle);return _possibleConstructorReturn(this,(PageTitle.__proto__||Object.getPrototypeOf(PageTitle)).apply(this,arguments));}_createClass(PageTitle,[{key:'render',value:function render(){var _props=this.props,children=_props.children,className=_props.className,rest=_objectWithoutProperties(_props,['children','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',Object.assign({className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('PageTitle',className)},rest),children);}}]);return PageTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PageTitle);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GoBackLink__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumbs__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_BreadcrumbPath__ = __webpack_require__(505);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HelperNavigation=function(_Component){_inherits(HelperNavigation,_Component);function HelperNavigation(){_classCallCheck(this,HelperNavigation);return _possibleConstructorReturn(this,(HelperNavigation.__proto__||Object.getPrototypeOf(HelperNavigation)).apply(this,arguments));}_createClass(HelperNavigation,[{key:'render',value:function render(){var _props=this.props,breadcrumbsPath=_props.breadcrumbsPath,withGoBackLink=_props.withGoBackLink,rightSide=_props.rightSide;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HelperNavigation'},rightSide,withGoBackLink&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GoBackLink__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Breadcrumbs__["a" /* default */],{path:breadcrumbsPath}));}}]);return HelperNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HelperNavigation.propTypes={breadcrumbsPath:__WEBPACK_IMPORTED_MODULE_4__types_BreadcrumbPath__["a" /* default */].isRequired,withGoBackLink:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,rightSide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (HelperNavigation);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stringify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addParametersToPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_endsWith__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_endsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_endsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
var stringify=function stringify(params,options){var stringifyParams={arrayFormat:'brackets'};return __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params,Object.assign({},stringifyParams,options));};var parse=function parse(params,options){var parseParams={ignoreQueryPrefix:true,arrayLimit:0};return __WEBPACK_IMPORTED_MODULE_1_qs___default.a.parse(params,Object.assign({},parseParams,options));};var addParametersToPath=function addParametersToPath(path,params){var pathToReturn=path;if(params&&Object.keys(params).length>0){if(!__WEBPACK_IMPORTED_MODULE_0_lodash_endsWith___default()(path,'?')){pathToReturn+='?';}pathToReturn+=stringify(params);}return pathToReturn;};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Error__ = __webpack_require__(120);
var StatefulStore=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('StatefulStore',{state:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_1__types_RequestState__["b" /* default */].NONE),lastError:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_3__Error__["a" /* default */])}).actions(function(self){return{setError:function setError(error){self.lastError=Object(__WEBPACK_IMPORTED_MODULE_2__util_error__["a" /* createErrorModel */])(error);self.state=__WEBPACK_IMPORTED_MODULE_1__types_RequestState__["b" /* default */].ERROR;},setLoading:function setLoading(loading){self.lastError=null;self.state=loading?__WEBPACK_IMPORTED_MODULE_1__types_RequestState__["b" /* default */].LOADING:__WEBPACK_IMPORTED_MODULE_1__types_RequestState__["b" /* default */].LOADED;}};});/* harmony default export */ __webpack_exports__["a"] = (StatefulStore);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(618);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(386);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(620);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(625);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(626);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(388);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(271);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(631);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(632);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(633);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(702);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Price */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Price=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Price,_Component);function Price(){_classCallCheck(this,Price);return _possibleConstructorReturn(this,(Price.__proto__||Object.getPrototypeOf(Price)).apply(this,arguments));}_createClass(Price,[{key:'render',value:function render(){var _props=this.props,price=_props.price,muted=_props.muted,discount=_props.discount,currencyStore=_props.currencyStore,className=_props.className,showTaxExcludedInfo=_props.showTaxExcludedInfo,showTaxIncludedInfo=_props.showTaxIncludedInfo,prefix=_props.prefix,suffix=_props.suffix,fontSize=_props.fontSize,isMultiProductPicker=_props.isMultiProductPicker;var cssClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('Price',className,{'Price--has-tax-excluded-info':showTaxExcludedInfo,'Price--discount':discount,'Price--muted':muted,'Price--price-wrapper':fontSize&&!muted,'Price--multiProductPicker':isMultiProductPicker});// @TODO Remove dangerouslySetInnerHTML once the API no longer serves currencies as HTML entitites.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:cssClasses},prefix&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Price__prefix'},prefix),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Price--amount-wrapper',dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_7__util_number__["d" /* formatPrice */])(price,currencyStore.activeCurrency)}}),suffix&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Price__suffix'},suffix),showTaxExcludedInfo&&!showTaxIncludedInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].taxExcluded,function(message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Price__tax-excluded-info'},message);}),showTaxIncludedInfo&&!showTaxExcludedInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].taxIncluded,function(message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Price__tax-included-info'},message);}));}}]);return Price;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;Price.propTypes={price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_CurrencyStore__["a" /* default */]).isRequired,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,suffix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,discount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,muted:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showTaxExcludedInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showTaxIncludedInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fontSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isMultiProductPicker:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Price.defaultProps={showTaxExcludedInfo:false,showTaxIncludedInfo:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('currencyStore')(Price));

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_FieldType__ = __webpack_require__(303);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/*
 * A Form is used to keep the data for a form in the UI that has multiple fields.
 * Each field should have its own FormField.
 */var Form=__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].model('Form',{fields:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_2__FormField__["b" /* default */]),{})}).views(function(self){return{get fieldsArray(){return Array.from(self.fields,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;});},get valid(){var valid=true;// We use lodash forEach instead of for ... of for IE 11 compatibility
__WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(self.fieldsArray,function(field){if(field.active&&field.valid===null){valid=null;return false;// break
}if(field.active&&field.valid===false){valid=false;return false;// break
}});return valid;}};}).actions(function(self){return{getFieldValues:function getFieldValues(){var values={};self.fields.forEach(function(field,key){// File fields only use the value for validation.
if(field.active&&field.type===__WEBPACK_IMPORTED_MODULE_3__types_FieldType__["b" /* default */].NORMAL){values[key]=field.value;}});return values;},setField:function setField(fieldName,field){self.fields.set(fieldName,field);},validateField:function validateField(fieldName){return self.fields.get(fieldName).setShouldValidate(true);},validate:function validate(){return self.fields.forEach(function(field){return field.setShouldValidate(true);});}};});/* unused harmony default export */ var _unused_webpack_default_export = (Form);function createForm(fields){var formModel=Form.create({});Object.keys(fields).forEach(function(fieldName){formModel.setField(fieldName,fields[fieldName]);});return formModel;}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Section__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_SectionStatusType__ = __webpack_require__(441);
var SectionStore=__WEBPACK_IMPORTED_MODULE_5__models_StatefulStore__["a" /* default */].named('SectionStore').props({sections:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__models_Section__["a" /* default */]),[]),activeSection:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_4__models_Section__["a" /* default */])),singleState:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED)}).views(function(self){return{get sectionIds(){return self.sections.map(function(section){return section.id;});},get activeSections(){return self.sections.filter(function(section){return section.status!==__WEBPACK_IMPORTED_MODULE_7__types_SectionStatusType__["b" /* default */].TEST_MODE&&section.slug.length>0;});}};}).actions(function(self){return{afterAttach:function afterAttach(){// Update API wrapper sectionId every time it changes
Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["autorun"])(function(){var sectionId=self.activeSection?self.activeSection.id:null;Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.setSectionId(sectionId);});},setup:function setup(sections){self.sections=sections;self.setLoading(false);},loadSection:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadSection(id){var section,sectionModel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadSection$(_context){while(1){switch(_context.prev=_context.next){case 0:self.singleState=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING;_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('sections/'+id);case 4:section=_context.sent;sectionModel=self.findSectionById(section.id);Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["b" /* applySnapshot */])(sectionModel,section);_context.next=14;break;case 9:_context.prev=9;_context.t0=_context['catch'](1);self.singleState=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR;self.lastError=Object(__WEBPACK_IMPORTED_MODULE_6__util_error__["a" /* createErrorModel */])(_context.t0);throw _context.t0;case 14:self.singleState=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED;case 15:case'end':return _context.stop();}}},loadSection,this,[[1,9]]);})),loadSections:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadSections(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadSections$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('sections');case 4:self.sections=_context2.sent;_context2.next=11;break;case 7:_context2.prev=7;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 11:self.setLoading(false);case 12:case'end':return _context2.stop();}}},loadSections,this,[[1,7]]);})),setActiveSection:function setActiveSection(section){if(self.activeSection!==section){self.activeSection=section;}},getSectionDataForLanguage:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getSectionDataForLanguage(id,lang){var sectionData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSectionDataForLanguage$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:sectionData=null;_context3.prev=1;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('sections/'+id,{params:{lang:lang}});case 4:sectionData=_context3.sent;_context3.next=10;break;case 7:_context3.prev=7;_context3.t0=_context3['catch'](1);throw _context3.t0;case 10:return _context3.abrupt('return',sectionData);case 11:case'end':return _context3.stop();}}},getSectionDataForLanguage,this,[[1,7]]);})),findSectionById:function findSectionById(sectionId){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_4__models_Section__["a" /* default */],self.sections,sectionId);}};});/* harmony default export */ __webpack_exports__["a"] = (SectionStore);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(222);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allowEmpty;
/* harmony export (immutable) */ __webpack_exports__["g"] = notBlank;
/* harmony export (immutable) */ __webpack_exports__["e"] = minLength;
/* unused harmony export maxLength */
/* harmony export (immutable) */ __webpack_exports__["d"] = isEmail;
/* harmony export (immutable) */ __webpack_exports__["f"] = mustMatch;
/* harmony export (immutable) */ __webpack_exports__["b"] = finnishBusinessId;
/* harmony export (immutable) */ __webpack_exports__["h"] = numberBetween;
/* harmony export (immutable) */ __webpack_exports__["c"] = isDate;
/* harmony export (immutable) */ __webpack_exports__["j"] = quantityValid;
/* harmony export (immutable) */ __webpack_exports__["i"] = productCountValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__number__ = __webpack_require__(69);
function allowEmpty(actualValidator){return function(value){return!!value?actualValidator(value):null;};}function notBlank(field){return function(value){return!value||!String(value).trim()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'validation.required',defaultMessage:'{field} cannot be blank.',values:{field:field},key:'notBlank-'+field}):null;};}function minLength(field,minLength){return function(value){return!value||value.trim().length<minLength?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'validation.minLength',defaultMessage:'{field} must have at least {minLength} characters.',values:{field:field,minLength:minLength},key:'minLength-'+field}):null;};}function maxLength(field,maxLength){return function(value){return!value||value.trim().length>maxLength?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'validation.maxLength',defaultMessage:'{field} must not have more than {maxLength} characters.',values:{field:field,maxLength:maxLength},key:'maxLength-'+field}):null;};}function isEmail(field){return function(value){return!value||!value.match(/.+@.+\..+/)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'validation.isEmail',defaultMessage:'{field} must be a valid email address.',values:{field:field},key:'isEmail-'+field}):null;};}function mustMatch(getMatch){return function(value){return value!==getMatch()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'validation.mustMatch',defaultMessage:'Field does not match.',key:'mustMatch'}):null;};}function calculateBusinessIdChecksum(idNumbers){var multipliers=[7,9,10,5,8,4,2];var sum=0;for(var i=0;i<idNumbers.length;i++){sum+=parseInt(idNumbers[i],10)*multipliers[i];}var remainder=sum%11;if(remainder>1){remainder=11-remainder;}return remainder;}function isValidBusinessId(businessId){if(!/^\d{7}-\d$/.test(businessId)){return false;}var givenChecksum=parseInt(businessId.substring(8,9),10);var idNumbers=businessId.substring(0,7);var calculatedChecksum=calculateBusinessIdChecksum(idNumbers);return calculatedChecksum===givenChecksum;}function finnishBusinessId(){return function(value){return!isValidBusinessId(value)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'validation.finnishBusinessId',defaultMessage:'Please check the business ID format.',key:'finnishBusinessId'}):null;};}function numberBetween(field,min,max){return function(value){return!value||typeof value!=='number'||value<min||value>max?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'validation.numberBetween',defaultMessage:'{field} must be a number between {min} and {max}.',values:{field:field,min:min,max:max},key:'numberBetween-'+field}):null;};}function isDate(field){var allowNull=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return function(value){if(allowNull){return null;}return!value||typeof value!=='string'||!/^\d{4}-\d{1,2}-\d{1,2}$/.test(value)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'validation.isDate',defaultMessage:'{field} format is not allowed.',values:{field:field},key:'isDate-'+field}):null;};}function quantityValid(maxQuantity,step){return function(value){var numValue=Number(value);var maxValue=maxQuantity;return numValue<step||numValue>maxValue?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_2__i18n_globalTranslations__["a" /* default */].validationMessageInvalidQuantity,{values:{min:String(step),max:String(maxValue)}})):null;};}function productCountValid(step,validationMessage){var validationError=validationMessage?validationMessage:__WEBPACK_IMPORTED_MODULE_2__i18n_globalTranslations__["a" /* default */].validationMessageInvalidFloor;return function(value){var factor=100;var precisionValue=Object(__WEBPACK_IMPORTED_MODULE_3__number__["e" /* roundWithPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_3__number__["e" /* roundWithPrecision */])(Number(value),2)*factor,0);var precisionStep=Object(__WEBPACK_IMPORTED_MODULE_3__number__["e" /* roundWithPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_3__number__["e" /* roundWithPrecision */])(step,2)*factor,0);return Math.floor(precisionValue/precisionStep)*precisionStep!==precisionValue?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],Object.assign({},validationError,{values:{size:String(precisionStep/factor)}})):null;};}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelmetProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Provider = __webpack_require__(395);

Object.defineProperty(exports, 'HelmetProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Provider).default;
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deepEqual = __webpack_require__(636);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _invariant = __webpack_require__(67);

var _invariant2 = _interopRequireDefault(_invariant);

var _Dispatcher = __webpack_require__(639);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _constants = __webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this */

var Helmet = function (_Component) {
  _inherits(Helmet, _Component);

  function Helmet() {
    _classCallCheck(this, Helmet);

    return _possibleConstructorReturn(this, (Helmet.__proto__ || Object.getPrototypeOf(Helmet)).apply(this, arguments));
  }

  _createClass(Helmet, [{
    key: 'shouldComponentUpdate',

    /**
     * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
     * @param {Object} bodyAttributes: {"className": "root"}
     * @param {String} defaultTitle: "Default Title"
     * @param {Boolean} defer: true
     * @param {Boolean} encodeSpecialCharacters: true
     * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
     * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
     * @param {Array} meta: [{"name": "description", "content": "Test description"}]
     * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
     * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
     * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
     * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
     * @param {String} title: "Title"
     * @param {Object} titleAttributes: {"itemprop": "name"}
     * @param {String} titleTemplate: "MySite.com - %s"
     */
    /* eslint-disable react/prop-types, react/forbid-prop-types, react/require-default-props */
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _deepEqual2.default)(this.props, nextProps);
    }
    /* eslint-enable react/prop-types, react/forbid-prop-types, react/require-default-props */

  }, {
    key: 'mapNestedChildrenToProps',
    value: function mapNestedChildrenToProps(child, nestedChildren) {
      if (!nestedChildren) {
        return null;
      }

      switch (child.type) {
        case _constants.TAG_NAMES.SCRIPT:
        case _constants.TAG_NAMES.NOSCRIPT:
          return {
            innerHTML: nestedChildren
          };

        case _constants.TAG_NAMES.STYLE:
          return {
            cssText: nestedChildren
          };
        default:
          throw new Error('<' + child.type + ' /> elements are self-closing and can not contain children. Refer to our API for more information.');
      }
    }
  }, {
    key: 'flattenArrayTypeChildren',
    value: function flattenArrayTypeChildren(_ref) {
      var child = _ref.child,
          arrayTypeChildren = _ref.arrayTypeChildren,
          newChildProps = _ref.newChildProps,
          nestedChildren = _ref.nestedChildren;

      return _extends({}, arrayTypeChildren, _defineProperty({}, child.type, [].concat(_toConsumableArray(arrayTypeChildren[child.type] || []), [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))])));
    }
  }, {
    key: 'mapObjectTypeChildren',
    value: function mapObjectTypeChildren(_ref2) {
      var _extends3;

      var child = _ref2.child,
          newProps = _ref2.newProps,
          newChildProps = _ref2.newChildProps,
          nestedChildren = _ref2.nestedChildren;

      switch (child.type) {
        case _constants.TAG_NAMES.TITLE:
          return _extends({}, newProps, (_extends3 = {}, _defineProperty(_extends3, child.type, nestedChildren), _defineProperty(_extends3, 'titleAttributes', _extends({}, newChildProps)), _extends3));

        case _constants.TAG_NAMES.BODY:
          return _extends({}, newProps, {
            bodyAttributes: _extends({}, newChildProps)
          });

        case _constants.TAG_NAMES.HTML:
          return _extends({}, newProps, {
            htmlAttributes: _extends({}, newChildProps)
          });
        default:
          return _extends({}, newProps, _defineProperty({}, child.type, _extends({}, newChildProps)));
      }
    }
  }, {
    key: 'mapArrayTypeChildrenToProps',
    value: function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
      var newFlattenedProps = _extends({}, newProps);

      Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
        newFlattenedProps = _extends({}, newFlattenedProps, _defineProperty({}, arrayChildName, arrayTypeChildren[arrayChildName]));
      });

      return newFlattenedProps;
    }
  }, {
    key: 'warnOnInvalidChildren',
    value: function warnOnInvalidChildren(child, nestedChildren) {
      (0, _invariant2.default)(_constants.VALID_TAG_NAMES.some(function (name) {
        return child.type === name;
      }), typeof child.type === 'function' ? 'You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.' : 'Only elements types ' + _constants.VALID_TAG_NAMES.join(', ') + ' are allowed. Helmet does not support rendering <' + child.type + '> elements. Refer to our API for more information.');

      (0, _invariant2.default)(!nestedChildren || typeof nestedChildren === 'string' || Array.isArray(nestedChildren) && !nestedChildren.some(function (nestedChild) {
        return typeof nestedChild !== 'string';
      }), 'Helmet expects a string as a child of <' + child.type + '>. Did you forget to wrap your children in braces? ( <' + child.type + '>{``}</' + child.type + '> ) Refer to our API for more information.');

      return true;
    }
  }, {
    key: 'mapChildrenToProps',
    value: function mapChildrenToProps(children, newProps) {
      var _this2 = this;

      var arrayTypeChildren = {};

      _react2.default.Children.forEach(children, function (child) {
        if (!child || !child.props) {
          return;
        }

        var _child$props = child.props,
            nestedChildren = _child$props.children,
            childProps = _objectWithoutProperties(_child$props, ['children']);
        // convert React props to HTML attributes


        var newChildProps = Object.keys(childProps).reduce(function (obj, key) {
          obj[_constants.HTML_TAG_MAP[key] || key] = childProps[key];
          return obj;
        }, {});

        _this2.warnOnInvalidChildren(child, nestedChildren);

        switch (child.type) {
          case _constants.TAG_NAMES.LINK:
          case _constants.TAG_NAMES.META:
          case _constants.TAG_NAMES.NOSCRIPT:
          case _constants.TAG_NAMES.SCRIPT:
          case _constants.TAG_NAMES.STYLE:
            arrayTypeChildren = _this2.flattenArrayTypeChildren({
              child: child,
              arrayTypeChildren: arrayTypeChildren,
              newChildProps: newChildProps,
              nestedChildren: nestedChildren
            });
            break;

          default:
            newProps = _this2.mapObjectTypeChildren({
              child: child,
              newProps: newProps,
              newChildProps: newChildProps,
              nestedChildren: nestedChildren
            });
            break;
        }
      });

      return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      var newProps = _extends({}, props);

      if (children) {
        newProps = this.mapChildrenToProps(children, newProps);
      }

      return _react2.default.createElement(_Dispatcher2.default, newProps);
    }
  }]);

  return Helmet;
}(_react.Component);

Helmet.propTypes = {
  base: _propTypes2.default.object,
  bodyAttributes: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  defaultTitle: _propTypes2.default.string,
  defer: _propTypes2.default.bool,
  encodeSpecialCharacters: _propTypes2.default.bool,
  htmlAttributes: _propTypes2.default.object,
  link: _propTypes2.default.arrayOf(_propTypes2.default.object),
  meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
  noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
  onChangeClientState: _propTypes2.default.func,
  script: _propTypes2.default.arrayOf(_propTypes2.default.object),
  style: _propTypes2.default.arrayOf(_propTypes2.default.object),
  title: _propTypes2.default.string,
  titleAttributes: _propTypes2.default.object,
  titleTemplate: _propTypes2.default.string
};
Helmet.defaultProps = {
  defer: true,
  encodeSpecialCharacters: true
};
exports.default = Helmet;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/

/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === 'undefined';
}

function isNumber(o) {
  return typeof o === 'number';
}

function isString(o) {
  return typeof o === 'string';
}

function isDate(o) {
  return Object.prototype.toString.call(o) === '[object Date]';
}

// CAPABILITIES

function hasIntl() {
  return typeof Intl !== 'undefined' && Intl.DateTimeFormat;
}

function hasFormatToParts() {
  return !isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}

function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce(function (best, next) {
    var pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare.apply(null, [best[0], pair[0]]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}

function pick(obj, keys) {
  return keys.reduce(function (a, k) {
    a[k] = obj[k];
    return a;
  }, {});
}

// NUMBERS AND STRINGS

function numberBetween(thing, bottom, top) {
  return isNumber(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}

function padStart(input) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (input.toString().length < n) {
    return ('0'.repeat(n) + input).slice(-n);
  } else {
    return input.toString();
  }
}

function parseMillis(fraction) {
  if (isUndefined(fraction)) {
    return NaN;
  } else {
    var f = parseFloat('0.' + fraction) * 1000;
    return Math.floor(f);
  }
}

function roundTo(number, digits) {
  var factor = Math.pow(10, digits);
  return Math.round(number * factor) / factor;
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}

function daysInMonth(year, month) {
  var modMonth = floorMod(month - 1, 12) + 1,
      modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

function weeksInWeekYear(weekYear) {
  var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7,
      last = weekYear - 1,
      p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
  return p1 === 4 || p2 === 3 ? 53 : 52;
}

function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > 60 ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale) {
  var timeZone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var date = new Date(ts),
      intlOpts = {
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  var modified = Object.assign({ timeZoneName: offsetFormat }, intlOpts),
      intl = hasIntl();

  if (intl && hasFormatToParts()) {
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
      return m.type.toLowerCase() === 'timezonename';
    });
    return parsed ? parsed.value : null;
  } else if (intl) {
    // this probably doesn't work for all locales
    var without = new Intl.DateTimeFormat(locale, intlOpts).format(date),
        included = new Intl.DateTimeFormat(locale, modified).format(date),
        diffed = included.substring(without.length),
        trimmed = diffed.replace(/^[, ]+/, '');
    return trimmed;
  } else {
    return null;
  }
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  var offHour = parseInt(offHourStr, 10) || 0,
      offMin = parseInt(offMinuteStr, 10) || 0,
      offMinSigned = offHour < 0 ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function normalizeObject(obj, normalizer) {
  var ignoreUnknown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var normalized = {};
  for (var u in obj) {
    if (obj.hasOwnProperty(u)) {
      var v = obj[u];
      if (v !== null && !isUndefined(v) && !Number.isNaN(v)) {
        var mapped = normalizer(u, ignoreUnknown);
        if (mapped) {
          normalized[mapped] = v;
        }
      }
    }
  }
  return normalized;
}

function timeObject(obj) {
  return pick(obj, ['hour', 'minute', 'second', 'millisecond']);
}

/**
 * @private
 */

var n = 'numeric',
    s = 'short',
    l = 'long',
    d2 = '2-digit';

var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};

var DATE_MED = {
  year: n,
  month: s,
  day: n
};

var DATE_FULL = {
  year: n,
  month: l,
  day: n
};

var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};

var TIME_SIMPLE = {
  hour: n,
  minute: d2
};

var TIME_WITH_SECONDS = {
  hour: n,
  minute: d2,
  second: d2
};

var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: d2,
  second: d2,
  timeZoneName: s
};

var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: d2,
  second: d2,
  timeZoneName: l
};

var TIME_24_SIMPLE = {
  hour: n,
  minute: d2,
  hour12: false
};

/**
 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
 */
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: d2,
  second: d2,
  hour12: false
};

/**
 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
 */
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: d2,
  second: d2,
  hour12: false,
  timeZoneName: s
};

/**
 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
 */
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: d2,
  second: d2,
  hour12: false,
  timeZoneName: l
};

/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
 */
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: d2
};

/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
 */
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: d2,
  second: d2
};

var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: d2
};

var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: d2,
  second: d2
};

var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: d2,
  timeZoneName: s
};

var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: d2,
  second: d2,
  timeZoneName: s
};

var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: d2,
  timeZoneName: l
};

var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: d2,
  second: d2,
  timeZoneName: l
};

function stringify(obj) {
  return JSON.stringify(obj, Object.keys(obj).sort());
}

/**
 * @private
 */

var monthsLong = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

var monthsNarrow = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];

function months(length) {
  switch (length) {
    case 'narrow':
      return monthsNarrow;
    case 'short':
      return monthsShort;
    case 'long':
      return monthsLong;
    case 'numeric':
      return ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    case '2-digit':
      return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    default:
      return null;
  }
}

var weekdaysLong = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

var weekdaysShort = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

var weekdaysNarrow = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

function weekdays(length) {
  switch (length) {
    case 'narrow':
      return weekdaysNarrow;
    case 'short':
      return weekdaysShort;
    case 'long':
      return weekdaysLong;
    case 'numeric':
      return ['1', '2', '3', '4', '5', '6', '7'];
    default:
      return null;
  }
}

var meridiems = ['AM', 'PM'];

var erasLong = ['Before Christ', 'Anno Domini'];

var erasShort = ['BC', 'AD'];

var erasNarrow = ['B', 'A'];

function eras(length) {
  switch (length) {
    case 'narrow':
      return erasNarrow;
    case 'short':
      return erasShort;
    case 'long':
      return erasLong;
    default:
      return null;
  }
}

function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}

function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}

function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}

function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}

function formatString(knownFormat) {
  // these all have the offsets removed because we don't have access to them
  // without all the intl stuff this is backfilling
  var filtered = pick(knownFormat, ['weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName', 'hour12']),
      key = stringify(filtered),
      dateTimeHuge = 'EEEE, LLLL d, yyyy, h:mm a';
  switch (key) {
    case stringify(DATE_SHORT):
      return 'M/d/yyyy';
    case stringify(DATE_MED):
      return 'LLL d, yyyy';
    case stringify(DATE_FULL):
      return 'LLLL d, yyyy';
    case stringify(DATE_HUGE):
      return 'EEEE, LLLL d, yyyy';
    case stringify(TIME_SIMPLE):
      return 'h:mm a';
    case stringify(TIME_WITH_SECONDS):
      return 'h:mm:ss a';
    case stringify(TIME_WITH_SHORT_OFFSET):
      return 'h:mm a';
    case stringify(TIME_WITH_LONG_OFFSET):
      return 'h:mm a';
    case stringify(TIME_24_SIMPLE):
      return 'HH:mm';
    case stringify(TIME_24_WITH_SECONDS):
      return 'HH:mm:ss';
    case stringify(TIME_24_WITH_SHORT_OFFSET):
      return 'HH:mm';
    case stringify(TIME_24_WITH_LONG_OFFSET):
      return 'HH:mm';
    case stringify(DATETIME_SHORT):
      return 'M/d/yyyy, h:mm a';
    case stringify(DATETIME_MED):
      return 'LLL d, yyyy, h:mm a';
    case stringify(DATETIME_FULL):
      return 'LLLL d, yyyy, h:mm a';
    case stringify(DATETIME_HUGE):
      return dateTimeHuge;
    case stringify(DATETIME_SHORT_WITH_SECONDS):
      return 'M/d/yyyy, h:mm:ss a';
    case stringify(DATETIME_MED_WITH_SECONDS):
      return 'LLL d, yyyy, h:mm:ss a';
    case stringify(DATETIME_FULL_WITH_SECONDS):
      return 'LLLL d, yyyy, h:mm:ss a';
    case stringify(DATETIME_HUGE_WITH_SECONDS):
      return 'EEEE, LLLL d, yyyy, h:mm:ss a';
    default:
      return dateTimeHuge;
  }
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
var LuxonError = function (_Error) {
  inherits(LuxonError, _Error);

  function LuxonError() {
    classCallCheck(this, LuxonError);
    return possibleConstructorReturn(this, _Error.apply(this, arguments));
  }

  return LuxonError;
}(Error);

/**
 * @private
 */


var InvalidDateTimeError = function (_LuxonError) {
  inherits(InvalidDateTimeError, _LuxonError);

  function InvalidDateTimeError(reason) {
    classCallCheck(this, InvalidDateTimeError);
    return possibleConstructorReturn(this, _LuxonError.call(this, 'Invalid DateTime: ' + reason));
  }

  return InvalidDateTimeError;
}(LuxonError);

/**
 * @private
 */
var InvalidIntervalError = function (_LuxonError2) {
  inherits(InvalidIntervalError, _LuxonError2);

  function InvalidIntervalError(reason) {
    classCallCheck(this, InvalidIntervalError);
    return possibleConstructorReturn(this, _LuxonError2.call(this, 'Invalid Interval: ' + reason));
  }

  return InvalidIntervalError;
}(LuxonError);

/**
 * @private
 */
var InvalidDurationError = function (_LuxonError3) {
  inherits(InvalidDurationError, _LuxonError3);

  function InvalidDurationError(reason) {
    classCallCheck(this, InvalidDurationError);
    return possibleConstructorReturn(this, _LuxonError3.call(this, 'Invalid Duration: ' + reason));
  }

  return InvalidDurationError;
}(LuxonError);

/**
 * @private
 */
var ConflictingSpecificationError = function (_LuxonError4) {
  inherits(ConflictingSpecificationError, _LuxonError4);

  function ConflictingSpecificationError() {
    classCallCheck(this, ConflictingSpecificationError);
    return possibleConstructorReturn(this, _LuxonError4.apply(this, arguments));
  }

  return ConflictingSpecificationError;
}(LuxonError);

/**
 * @private
 */
var InvalidUnitError = function (_LuxonError5) {
  inherits(InvalidUnitError, _LuxonError5);

  function InvalidUnitError(unit) {
    classCallCheck(this, InvalidUnitError);
    return possibleConstructorReturn(this, _LuxonError5.call(this, 'Invalid unit ' + unit));
  }

  return InvalidUnitError;
}(LuxonError);

/**
 * @private
 */
var InvalidArgumentError = function (_LuxonError6) {
  inherits(InvalidArgumentError, _LuxonError6);

  function InvalidArgumentError() {
    classCallCheck(this, InvalidArgumentError);
    return possibleConstructorReturn(this, _LuxonError6.apply(this, arguments));
  }

  return InvalidArgumentError;
}(LuxonError);

/**
 * @private
 */
var ZoneIsAbstractError = function (_LuxonError7) {
  inherits(ZoneIsAbstractError, _LuxonError7);

  function ZoneIsAbstractError() {
    classCallCheck(this, ZoneIsAbstractError);
    return possibleConstructorReturn(this, _LuxonError7.call(this, 'Zone is an abstract class'));
  }

  return ZoneIsAbstractError;
}(LuxonError);

/* eslint no-unused-vars: "off" */

/**
 * @interface
*/

var Zone = function () {
  function Zone() {
    classCallCheck(this, Zone);
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  Zone.prototype.offsetName = function offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  };

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */


  Zone.prototype.offset = function offset(ts) {
    throw new ZoneIsAbstractError();
  };

  /**
   * Return whether this Zone is equal to another zoner
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */


  Zone.prototype.equals = function equals(otherZone) {
    throw new ZoneIsAbstractError();
  };

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */


  createClass(Zone, [{
    key: 'type',

    /**
     * The type of zone
     * @abstract
     * @type {string}
     */
    get: function get$$1() {
      throw new ZoneIsAbstractError();
    }

    /**
     * The name of this zone.
     * @abstract
     * @type {string}
     */

  }, {
    key: 'name',
    get: function get$$1() {
      throw new ZoneIsAbstractError();
    }

    /**
     * Returns whether the offset is known to be fixed for the whole year.
     * @abstract
     * @type {boolean}
     */

  }, {
    key: 'universal',
    get: function get$$1() {
      throw new ZoneIsAbstractError();
    }
  }, {
    key: 'isValid',
    get: function get$$1() {
      throw new ZoneIsAbstractError();
    }
  }]);
  return Zone;
}();

var singleton = null;

var LocalZone = function (_Zone) {
  inherits(LocalZone, _Zone);

  function LocalZone() {
    classCallCheck(this, LocalZone);
    return possibleConstructorReturn(this, _Zone.apply(this, arguments));
  }

  LocalZone.prototype.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
        locale = _ref.locale;

    return parseZoneInfo(ts, format, locale);
  };

  LocalZone.prototype.offset = function offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  };

  LocalZone.prototype.equals = function equals(otherZone) {
    return otherZone.type === 'local';
  };

  createClass(LocalZone, [{
    key: 'type',
    get: function get$$1() {
      return 'local';
    }
  }, {
    key: 'name',
    get: function get$$1() {
      if (hasIntl()) {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else return 'local';
    }
  }, {
    key: 'universal',
    get: function get$$1() {
      return false;
    }
  }, {
    key: 'isValid',
    get: function get$$1() {
      return true;
    }
  }], [{
    key: 'instance',
    get: function get$$1() {
      if (singleton === null) {
        singleton = new LocalZone();
      }
      return singleton;
    }
  }]);
  return LocalZone;
}(Zone);

var dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: zone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }
  return dtfCache[zone];
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, ''),
      parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
      fMonth = parsed[1],
      fDay = parsed[2],
      fYear = parsed[3],
      fHour = parsed[4],
      fMinute = parsed[5],
      fSecond = parsed[6];

  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date),
      filled = [];
  for (var i = 0; i < formatted.length; i++) {
    var _formatted$i = formatted[i],
        type = _formatted$i.type,
        value = _formatted$i.value,
        pos = typeToPos[type];


    if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}

var IANAZone = function (_Zone) {
  inherits(IANAZone, _Zone);

  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
    return s && s.match(/^[a-z_+-]{1,256}\/[a-z_+-]{1,256}(\/[a-z_+-]{1,256})?$/i);
  };

  IANAZone.isValidZone = function isValidZone(zone) {
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  };

  // Etc/GMT+8 -> 480


  IANAZone.parseGMTOffset = function parseGMTOffset(specifier) {
    if (specifier) {
      var match = specifier.match(/^Etc\/GMT([+-]\d{1,2})$/i);
      if (match) {
        return 60 * parseInt(match[1]);
      }
    }
    return null;
  };

  function IANAZone(name) {
    classCallCheck(this, IANAZone);

    var _this = possibleConstructorReturn(this, _Zone.call(this));

    _this.zoneName = name;
    _this.valid = IANAZone.isValidZone(name);
    return _this;
  }

  IANAZone.prototype.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
        locale = _ref.locale;

    return parseZoneInfo(ts, format, locale, this.zoneName);
  };

  IANAZone.prototype.offset = function offset(ts) {
    var date = new Date(ts),
        dtf = makeDTF(this.zoneName),
        _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
        fYear = _ref2[0],
        fMonth = _ref2[1],
        fDay = _ref2[2],
        fHour = _ref2[3],
        fMinute = _ref2[4],
        fSecond = _ref2[5],
        asUTC = Date.UTC(fYear, fMonth - 1, fDay, fHour, fMinute, fSecond);

    var asTS = date.valueOf();
    asTS -= asTS % 1000;
    return (asUTC - asTS) / (60 * 1000);
  };

  IANAZone.prototype.equals = function equals(otherZone) {
    return otherZone.type === 'iana' && otherZone.zoneName === this.zoneName;
  };

  createClass(IANAZone, [{
    key: 'type',
    get: function get$$1() {
      return 'iana';
    }
  }, {
    key: 'name',
    get: function get$$1() {
      return this.zoneName;
    }
  }, {
    key: 'universal',
    get: function get$$1() {
      return false;
    }
  }, {
    key: 'isValid',
    get: function get$$1() {
      return this.valid;
    }
  }]);
  return IANAZone;
}(Zone);

var singleton$1 = null;

function hoursMinutesOffset(z) {
  var hours = Math.trunc(z.fixed / 60),
      minutes = Math.abs(z.fixed % 60),
      sign = hours > 0 ? '+' : '-',
      base = sign + Math.abs(hours);
  return minutes > 0 ? base + ':' + padStart(minutes, 2) : base;
}

var FixedOffsetZone = function (_Zone) {
  inherits(FixedOffsetZone, _Zone);

  FixedOffsetZone.instance = function instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  };

  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
    if (s) {
      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  };

  createClass(FixedOffsetZone, null, [{
    key: 'utcInstance',
    get: function get$$1() {
      if (singleton$1 === null) {
        singleton$1 = new FixedOffsetZone(0);
      }
      return singleton$1;
    }
  }]);

  function FixedOffsetZone(offset) {
    classCallCheck(this, FixedOffsetZone);

    var _this = possibleConstructorReturn(this, _Zone.call(this));

    _this.fixed = offset;
    return _this;
  }

  FixedOffsetZone.prototype.offsetName = function offsetName() {
    return this.name;
  };

  FixedOffsetZone.prototype.offset = function offset() {
    return this.fixed;
  };

  FixedOffsetZone.prototype.equals = function equals(otherZone) {
    return otherZone.type === 'fixed' && otherZone.fixed === this.fixed;
  };

  createClass(FixedOffsetZone, [{
    key: 'type',
    get: function get$$1() {
      return 'fixed';
    }
  }, {
    key: 'name',
    get: function get$$1() {
      return this.fixed === 0 ? 'UTC' : 'UTC' + hoursMinutesOffset(this);
    }
  }, {
    key: 'universal',
    get: function get$$1() {
      return true;
    }
  }, {
    key: 'isValid',
    get: function get$$1() {
      return true;
    }
  }]);
  return FixedOffsetZone;
}(Zone);

var singleton$2 = null;

var InvalidZone = function (_Zone) {
  inherits(InvalidZone, _Zone);

  function InvalidZone() {
    classCallCheck(this, InvalidZone);
    return possibleConstructorReturn(this, _Zone.apply(this, arguments));
  }

  InvalidZone.prototype.offsetName = function offsetName() {
    return null;
  };

  InvalidZone.prototype.offset = function offset() {
    return NaN;
  };

  InvalidZone.prototype.equals = function equals() {
    return false;
  };

  createClass(InvalidZone, [{
    key: 'type',
    get: function get$$1() {
      return 'invalid';
    }
  }, {
    key: 'name',
    get: function get$$1() {
      return null;
    }
  }, {
    key: 'universal',
    get: function get$$1() {
      return false;
    }
  }, {
    key: 'isValid',
    get: function get$$1() {
      return false;
    }
  }], [{
    key: 'instance',
    get: function get$$1() {
      if (singleton$2 === null) {
        singleton$2 = new InvalidZone();
      }
      return singleton$2;
    }
  }]);
  return InvalidZone;
}(Zone);

/**
 * @private
 */

function normalizeZone(input, defaultZone) {
  var offset = void 0;
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    var lowered = input.toLowerCase();
    if (lowered === 'local') return LocalZone.instance;else if (lowered === 'utc' || lowered === 'gmt') return FixedOffsetZone.utcInstance;else if ((offset = IANAZone.parseGMTOffset(input)) != null) {
      // handle Etc/GMT-4, which V8 chokes on
      return FixedOffsetZone.instance(offset);
    } else if (IANAZone.isValidSpecifier(lowered)) return new IANAZone(input);else return FixedOffsetZone.parseSpecifier(lowered) || InvalidZone.instance;
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input.offset) {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return InvalidZone.instance;
  }
}

var now = function now() {
  return new Date().valueOf();
},
    defaultZone = null,
    // not setting this directly to LocalZone.instance bc loading order issues
defaultLocale = null,
    defaultNumberingSystem = null,
    defaultOutputCalendar = null,
    throwOnInvalid = false;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */

var Settings = function () {
  function Settings() {
    classCallCheck(this, Settings);
  }

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  Settings.resetCaches = function resetCaches() {
    Locale.resetCache();
  };

  createClass(Settings, null, [{
    key: 'now',

    /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */
    get: function get$$1() {
      return now;
    }

    /**
     * Set the callback for returning the current timestamp.
     * @type {function}
     */
    ,
    set: function set$$1(n) {
      now = n;
    }

    /**
     * Get the default time zone to create DateTimes in.
     * @type {string}
     */

  }, {
    key: 'defaultZoneName',
    get: function get$$1() {
      return (defaultZone || LocalZone.instance).name;
    }

    /**
     * Set the default time zone to create DateTimes in. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set$$1(z) {
      if (!z) {
        defaultZone = null;
      } else {
        defaultZone = normalizeZone(z);
      }
    }

    /**
     * Get the default time zone object to create DateTimes in. Does not affect existing instances.
     * @type {Zone}
     */

  }, {
    key: 'defaultZone',
    get: function get$$1() {
      return defaultZone || LocalZone.instance;
    }

    /**
     * Get the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: 'defaultLocale',
    get: function get$$1() {
      return defaultLocale;
    }

    /**
     * Set the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set$$1(locale) {
      defaultLocale = locale;
    }

    /**
     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: 'defaultNumberingSystem',
    get: function get$$1() {
      return defaultNumberingSystem;
    }

    /**
     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set$$1(numberingSystem) {
      defaultNumberingSystem = numberingSystem;
    }

    /**
     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: 'defaultOutputCalendar',
    get: function get$$1() {
      return defaultOutputCalendar;
    }

    /**
     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set$$1(outputCalendar) {
      defaultOutputCalendar = outputCalendar;
    }

    /**
     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */

  }, {
    key: 'throwOnInvalid',
    get: function get$$1() {
      return throwOnInvalid;
    }

    /**
     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */
    ,
    set: function set$$1(t) {
      throwOnInvalid = t;
    }
  }]);
  return Settings;
}();

function stringifyTokens(splits, tokenToString) {
  var s = '';
  for (var _iterator = splits, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var token = _ref;

    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}

var tokenToObject = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};

/**
 * @private
 */

var Formatter = function () {
  Formatter.create = function create(locale) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var formatOpts = Object.assign({}, { round: true }, opts);
    return new Formatter(locale, formatOpts);
  };

  Formatter.parseFormat = function parseFormat(fmt) {
    var current = null,
        currentFull = '',
        bracketed = false;
    var splits = [];
    for (var i = 0; i < fmt.length; i++) {
      var c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed, val: currentFull });
        }
        current = null;
        currentFull = '';
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: false, val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({ literal: bracketed, val: currentFull });
    }

    return splits;
  };

  function Formatter(locale, formatOpts) {
    classCallCheck(this, Formatter);

    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  Formatter.prototype.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.format();
  };

  Formatter.prototype.formatDateTime = function formatDateTime(dt) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.format();
  };

  Formatter.prototype.formatDateTimeParts = function formatDateTimeParts(dt) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.formatToParts();
  };

  Formatter.prototype.resolvedOptions = function resolvedOptions(dt) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.resolvedOptions();
  };

  Formatter.prototype.num = function num(n) {
    var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }

    var opts = Object.assign({}, this.opts);

    if (p > 0) {
      opts.padTo = p;
    }

    return this.loc.numberFormatter(opts).format(n);
  };

  Formatter.prototype.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
    var _this = this;

    var knownEnglish = this.loc.listingMode() === 'en';
    var string = function string(opts, extract) {
      return _this.loc.extract(dt, opts, extract);
    },
        formatOffset = function formatOffset(opts) {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return 'Z';
      }

      var hours = Math.trunc(dt.offset / 60),
          minutes = Math.abs(dt.offset % 60),
          sign = hours >= 0 ? '+' : '-',
          base = '' + sign + Math.abs(hours);

      switch (opts.format) {
        case 'short':
          return '' + sign + _this.num(Math.abs(hours), 2) + ':' + _this.num(minutes, 2);
        case 'narrow':
          return minutes > 0 ? base + ':' + minutes : base;
        case 'techie':
          return '' + sign + _this.num(Math.abs(hours), 2) + _this.num(minutes, 2);
        default:
          throw new RangeError('Value format ' + opts.format + ' is out of range for property format');
      }
    },
        meridiem = function meridiem() {
      return knownEnglish ? meridiemForDateTime(dt) : string({ hour: 'numeric', hour12: true }, 'dayperiod');
    },
        month = function month(length, standalone) {
      return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? { month: length } : { month: length, day: 'numeric' }, 'month');
    },
        weekday = function weekday(length, standalone) {
      return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? { weekday: length } : { weekday: length, month: 'long', day: 'numeric' }, 'weekday');
    },
        maybeMacro = function maybeMacro(token) {
      var macro = tokenToObject[token];
      if (macro) {
        return _this.formatWithSystemDefault(dt, macro);
      } else {
        return token;
      }
    },
        era = function era(length) {
      return knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, 'era');
    },
        tokenToString = function tokenToString(token) {
      var outputCal = _this.loc.outputCalendar;

      // Where possible: http://cldr.unicode.org/translation/date-time#TOC-Stand-Alone-vs.-Format-Styles
      switch (token) {
        // ms
        case 'S':
          return _this.num(dt.millisecond);
        case 'u':
        // falls through
        case 'SSS':
          return _this.num(dt.millisecond, 3);
        // seconds
        case 's':
          return _this.num(dt.second);
        case 'ss':
          return _this.num(dt.second, 2);
        // minutes
        case 'm':
          return _this.num(dt.minute);
        case 'mm':
          return _this.num(dt.minute, 2);
        // hours
        case 'h':
          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case 'hh':
          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case 'H':
          return _this.num(dt.hour);
        case 'HH':
          return _this.num(dt.hour, 2);
        // offset
        case 'Z':
          // like +6
          return formatOffset({ format: 'narrow', allowZ: _this.opts.allowZ });
        case 'ZZ':
          // like +06:00
          return formatOffset({ format: 'short', allowZ: _this.opts.allowZ });
        case 'ZZZ':
          // like +0600
          return formatOffset({ format: 'techie', allowZ: false });
        case 'ZZZZ':
          // like EST
          return dt.offsetNameShort;
        case 'ZZZZZ':
          // like Eastern Standard Time
          return dt.offsetNameLong;
        // zone
        case 'z':
          // like America/New_York
          return dt.zoneName;
        // meridiems
        case 'a':
          return meridiem();
        // dates
        case 'd':
          return outputCal ? string({ day: 'numeric' }, 'day') : _this.num(dt.day);
        case 'dd':
          return outputCal ? string({ day: '2-digit' }, 'day') : _this.num(dt.day, 2);
        // weekdays - standalone
        case 'c':
          // like 1
          return _this.num(dt.weekday);
        case 'ccc':
          // like 'Tues'
          return weekday('short', true);
        case 'cccc':
          // like 'Tuesday'
          return weekday('long', true);
        case 'ccccc':
          // like 'T'
          return weekday('narrow', true);
        // weekdays - format
        case 'E':
          // like 1
          return _this.num(dt.weekday);
        case 'EEE':
          // like 'Tues'
          return weekday('short', false);
        case 'EEEE':
          // like 'Tuesday'
          return weekday('long', false);
        case 'EEEEE':
          // like 'T'
          return weekday('narrow', false);
        // months - standalone
        case 'L':
          // like 1
          return outputCal ? string({ month: 'numeric', day: 'numeric' }, 'month') : _this.num(dt.month);
        case 'LL':
          // like 01, doesn't seem to work
          return outputCal ? string({ month: '2-digit', day: 'numeric' }, 'month') : _this.num(dt.month, 2);
        case 'LLL':
          // like Jan
          return month('short', true);
        case 'LLLL':
          // like January
          return month('long', true);
        case 'LLLLL':
          // like J
          return month('narrow', true);
        // months - format
        case 'M':
          // like 1
          return outputCal ? string({ month: 'numeric' }, 'month') : _this.num(dt.month);
        case 'MM':
          // like 01
          return outputCal ? string({ month: '2-digit' }, 'month') : _this.num(dt.month, 2);
        case 'MMM':
          // like Jan
          return month('short', false);
        case 'MMMM':
          // like January
          return month('long', false);
        case 'MMMMM':
          // like J
          return month('narrow', false);
        // years
        case 'y':
          // like 2014
          return outputCal ? string({ year: 'numeric' }, 'year') : _this.num(dt.year);
        case 'yy':
          // like 14
          return outputCal ? string({ year: '2-digit' }, 'year') : _this.num(dt.year.toString().slice(-2), 2);
        case 'yyyy':
          // like 0012
          return outputCal ? string({ year: 'numeric' }, 'year') : _this.num(dt.year, 4);
        case 'yyyyyy':
          // like 000012
          return outputCal ? string({ year: 'numeric' }, 'year') : _this.num(dt.year, 6);
        // eras
        case 'G':
          // like AD
          return era('short');
        case 'GG':
          // like Anno Domini
          return era('long');
        case 'GGGGG':
          return era('narrow');
        case 'kk':
          return _this.num(dt.weekYear.toString().slice(-2), 2);
        case 'kkkk':
          return _this.num(dt.weekYear, 4);
        case 'W':
          return _this.num(dt.weekNumber);
        case 'WW':
          return _this.num(dt.weekNumber, 2);
        case 'o':
          return _this.num(dt.ordinal);
        case 'ooo':
          return _this.num(dt.ordinal, 3);
        case 'q':
          // like 1
          return _this.num(dt.quarter);
        case 'qq':
          // like 01
          return _this.num(dt.quarter, 2);
        default:
          return maybeMacro(token);
      }
    };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  };

  Formatter.prototype.formatDurationFromString = function formatDurationFromString(dur, fmt) {
    var _this2 = this;

    var tokenToField = function tokenToField(token) {
      switch (token[0]) {
        case 'S':
          return 'millisecond';
        case 's':
          return 'second';
        case 'm':
          return 'minute';
        case 'h':
          return 'hour';
        case 'd':
          return 'day';
        case 'M':
          return 'month';
        case 'y':
          return 'year';
        default:
          return null;
      }
    },
        tokenToString = function tokenToString(lildur) {
      return function (token) {
        var mapped = tokenToField(token);
        if (mapped) {
          return _this2.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      };
    },
        tokens = Formatter.parseFormat(fmt),
        realTokens = tokens.reduce(function (found, _ref2) {
      var literal = _ref2.literal,
          val = _ref2.val;
      return literal ? found : found.concat(val);
    }, []),
        collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
      return t;
    }));
    return stringifyTokens(tokens, tokenToString(collapsed));
  };

  return Formatter;
}();

var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else if (hasIntl()) {
    var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale;
    // node sometimes defaults to "und". Override that because that is dumb
    sysLocaleCache = computedSys === 'und' ? 'en-US' : computedSys;
    return sysLocaleCache;
  } else {
    sysLocaleCache = 'en-US';
    return sysLocaleCache;
  }
}

function intlConfigString(locale, numberingSystem, outputCalendar) {
  if (hasIntl()) {
    locale = Array.isArray(locale) ? locale : [locale];

    if (outputCalendar || numberingSystem) {
      locale = locale.map(function (l) {
        l += '-u';

        if (outputCalendar) {
          l += '-ca-' + outputCalendar;
        }

        if (numberingSystem) {
          l += '-nu-' + numberingSystem;
        }
        return l;
      });
    }
    return locale;
  } else {
    return [];
  }
}

function mapMonths(f) {
  var ms = [];
  for (var i = 1; i <= 12; i++) {
    var dt = DateTime.utc(2016, i, 1);
    ms.push(f(dt));
  }
  return ms;
}

function mapWeekdays(f) {
  var ms = [];
  for (var i = 1; i <= 7; i++) {
    var dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}

function listStuff(loc, length, defaultOK, englishFn, intlFn) {
  var mode = loc.listingMode(defaultOK);

  if (mode === 'error') {
    return null;
  } else if (mode === 'en') {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== 'latn') {
    return false;
  } else {
    return loc.numberingSystem === 'latn' || !loc.locale || loc.locale.startsWith('en') || hasIntl() && Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === 'latn';
  }
}

/**
 * @private
 */

var SimpleNumberFormatter = function () {
  function SimpleNumberFormatter(opts) {
    classCallCheck(this, SimpleNumberFormatter);

    this.padTo = opts.padTo || 0;
    this.round = opts.round || false;
  }

  SimpleNumberFormatter.prototype.format = function format(i) {
    // to match the browser's numberformatter defaults
    var digits = this.round ? 0 : 3,
        rounded = roundTo(i, digits);
    return padStart(rounded, this.padTo);
  };

  return SimpleNumberFormatter;
}();

/**
 * @private
 */

var PolyDateFormatter = function () {
  function PolyDateFormatter(dt, intl, opts) {
    classCallCheck(this, PolyDateFormatter);

    this.opts = opts;
    this.hasIntl = hasIntl();

    var z = void 0;
    if (dt.zone.universal && this.hasIntl) {
      // Chromium doesn't support fixed-offset zones like Etc/GMT+8 in its formatter,
      // See https://bugs.chromium.org/p/chromium/issues/detail?id=364374.
      // So we have to make do. Two cases:
      // 1. The format options tell us to show the zone. We can't do that, so the best
      // we can do is format the date in UTC.
      // 2. The format options don't tell us to show the zone. Then we can adjust them
      // the time and tell the formatter to show it to us in UTC, so that the time is right
      // and the bad zone doesn't show up.
      // We can clean all this up when Chrome fixes this.
      z = 'UTC';
      if (opts.timeZoneName) {
        this.dt = dt;
      } else {
        this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
      }
    } else if (dt.zone.type === 'local') {
      this.dt = dt;
    } else {
      this.dt = dt;
      z = dt.zone.name;
    }

    if (this.hasIntl) {
      var realIntlOpts = Object.assign({}, this.opts);
      if (z) {
        realIntlOpts.timeZone = z;
      }
      this.dtf = new Intl.DateTimeFormat(intl, realIntlOpts);
    }
  }

  PolyDateFormatter.prototype.format = function format() {
    if (this.hasIntl) {
      return this.dtf.format(this.dt.toJSDate());
    } else {
      var tokenFormat = formatString(this.opts),
          loc = Locale.create('en-US');
      return Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
    }
  };

  PolyDateFormatter.prototype.formatToParts = function formatToParts() {
    if (this.hasIntl && hasFormatToParts()) {
      return this.dtf.formatToParts(this.dt.toJSDate());
    } else {
      // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
      // and IMO it's too weird to have an uncanny valley like that
      return [];
    }
  };

  PolyDateFormatter.prototype.resolvedOptions = function resolvedOptions() {
    if (this.hasIntl) {
      return this.dtf.resolvedOptions();
    } else {
      return {
        locale: 'en-US',
        numberingSystem: 'latn',
        outputCalendar: 'gregory'
      };
    }
  };

  return PolyDateFormatter;
}();

/**
 * @private
 */

var Locale = function () {
  Locale.fromOpts = function fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
  };

  Locale.create = function create(locale, numberingSystem, outputCalendar) {
    var defaultToEN = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var specifiedLocale = locale || Settings.defaultLocale,

    // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
    localeR = specifiedLocale || (defaultToEN ? 'en-US' : systemLocale()),
        numberingSystemR = numberingSystem || Settings.defaultNumberingSystem,
        outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
  };

  Locale.resetCache = function resetCache() {
    sysLocaleCache = null;
  };

  Locale.fromObject = function fromObject() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        locale = _ref.locale,
        numberingSystem = _ref.numberingSystem,
        outputCalendar = _ref.outputCalendar;

    return Locale.create(locale, numberingSystem, outputCalendar);
  };

  function Locale(locale, numbering, outputCalendar, specifiedLocale) {
    classCallCheck(this, Locale);

    this.locale = locale;
    this.numberingSystem = numbering;
    this.outputCalendar = outputCalendar;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);

    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};

    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  // todo: cache me
  Locale.prototype.listingMode = function listingMode() {
    var defaultOK = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var intl = hasIntl(),
        hasFTP = intl && hasFormatToParts(),
        isActuallyEn = this.locale === 'en' || this.locale.toLowerCase() === 'en-us' || intl && Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith('en-us'),
        hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === 'latn') && (this.outputCalendar === null || this.outputCalendar === 'gregory');

    if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) {
      return 'error';
    } else if (!hasFTP || isActuallyEn && hasNoWeirdness) {
      return 'en';
    } else {
      return 'intl';
    }
  };

  Locale.prototype.clone = function clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    }
  };

  Locale.prototype.redefaultToEN = function redefaultToEN() {
    var alts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return this.clone(Object.assign({}, alts, { defaultToEN: true }));
  };

  Locale.prototype.redefaultToSystem = function redefaultToSystem() {
    var alts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return this.clone(Object.assign({}, alts, { defaultToEN: false }));
  };

  Locale.prototype.months = function months$$1(length) {
    var _this = this;

    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var defaultOK = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return listStuff(this, length, defaultOK, months, function () {
      var intl = format ? { month: length, day: 'numeric' } : { month: length },
          formatStr = format ? 'format' : 'standalone';
      if (!_this.monthsCache[formatStr][length]) {
        _this.monthsCache[formatStr][length] = mapMonths(function (dt) {
          return _this.extract(dt, intl, 'month');
        });
      }
      return _this.monthsCache[formatStr][length];
    });
  };

  Locale.prototype.weekdays = function weekdays$$1(length) {
    var _this2 = this;

    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var defaultOK = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return listStuff(this, length, defaultOK, weekdays, function () {
      var intl = format ? { weekday: length, year: 'numeric', month: 'long', day: 'numeric' } : { weekday: length },
          formatStr = format ? 'format' : 'standalone';
      if (!_this2.weekdaysCache[formatStr][length]) {
        _this2.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
          return _this2.extract(dt, intl, 'weekday');
        });
      }
      return _this2.weekdaysCache[formatStr][length];
    });
  };

  Locale.prototype.meridiems = function meridiems$$1() {
    var _this3 = this;

    var defaultOK = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return listStuff(this, undefined, defaultOK, function () {
      return meridiems;
    }, function () {
      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
      if (!_this3.meridiemCache) {
        var intl = { hour: 'numeric', hour12: true };
        _this3.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
          return _this3.extract(dt, intl, 'dayperiod');
        });
      }

      return _this3.meridiemCache;
    });
  };

  Locale.prototype.eras = function eras$$1(length) {
    var _this4 = this;

    var defaultOK = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return listStuff(this, length, defaultOK, eras, function () {
      var intl = { era: length };

      // This is utter bullshit. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!_this4.eraCache[length]) {
        _this4.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
          return _this4.extract(dt, intl, 'era');
        });
      }

      return _this4.eraCache[length];
    });
  };

  Locale.prototype.extract = function extract(dt, intlOpts, field) {
    var df = this.dtFormatter(dt, intlOpts),
        results = df.formatToParts(),
        matching = results.find(function (m) {
      return m.type.toLowerCase() === field;
    });

    return matching ? matching.value : null;
  };

  Locale.prototype.numberFormatter = function numberFormatter() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // this option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the || is used heavily)
    if (opts.forceSimple || this.fastNumbers) {
      return new SimpleNumberFormatter(opts);
    } else if (hasIntl()) {
      var intlOpts = { useGrouping: false };

      if (opts.padTo > 0) {
        intlOpts.minimumIntegerDigits = opts.padTo;
      }

      if (opts.round) {
        intlOpts.maximumFractionDigits = 0;
      }

      return new Intl.NumberFormat(this.intl, intlOpts);
    } else {
      return new SimpleNumberFormatter(opts);
    }
  };

  Locale.prototype.dtFormatter = function dtFormatter(dt) {
    var intlOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new PolyDateFormatter(dt, this.intl, intlOpts);
  };

  Locale.prototype.equals = function equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  };

  createClass(Locale, [{
    key: 'fastNumbers',
    get: function get$$1() {
      if (this.fastNumbersCached !== null) {
        this.fastNumbersCached = supportsFastNumbers(this);
      }

      return this.fastNumbersCached;
    }
  }]);
  return Locale;
}();

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

function combineRegexes() {
  for (var _len = arguments.length, regexes = Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }

  var full = regexes.reduce(function (f, r) {
    return f + r.source;
  }, '');
  return RegExp('^' + full + '$');
}

function combineExtractors() {
  for (var _len2 = arguments.length, extractors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    extractors[_key2] = arguments[_key2];
  }

  return function (m) {
    return extractors.reduce(function (_ref, ex) {
      var mergedVals = _ref[0],
          mergedZone = _ref[1],
          cursor = _ref[2];

      var _ex = ex(m, cursor),
          val = _ex[0],
          zone = _ex[1],
          next = _ex[2];

      return [Object.assign(mergedVals, val), mergedZone || zone, next];
    }, [{}, null, 1]).slice(0, 2);
  };
}

function parse(s) {
  if (s == null) {
    return [null, null];
  }

  for (var _len3 = arguments.length, patterns = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    patterns[_key3 - 1] = arguments[_key3];
  }

  for (var _iterator = patterns, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref3 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref3 = _i.value;
    }

    var _ref2 = _ref3;
    var regex = _ref2[0];
    var extractor = _ref2[1];

    var m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}

function simpleParse() {
  for (var _len4 = arguments.length, keys = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    keys[_key4] = arguments[_key4];
  }

  return function (match, cursor) {
    var ret = {};
    var i = void 0;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInt(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
    isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,9}))?)?)?/,
    isoTimeRegex = RegExp('' + isoTimeBaseRegex.source + offsetRegex.source + '?'),
    isoTimeExtensionRegex = RegExp('(?:T' + isoTimeRegex.source + ')?'),
    isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
    isoWeekRegex = /(\d{4})-?W(\d\d)-?(\d)/,
    isoOrdinalRegex = /(\d{4})-?(\d{3})/,
    extractISOWeekData = simpleParse('weekYear', 'weekNumber', 'weekDay'),
    extractISOOrdinalData = simpleParse('year', 'ordinal'),
    sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
    // dumbed-down version of the ISO one
sqlTimeRegex = RegExp(isoTimeBaseRegex.source + ' ?(?:' + offsetRegex.source + '|([a-zA-Z_]{1,256}/[a-zA-Z_]{1,256}))?'),
    sqlTimeExtensionRegex = RegExp('(?: ' + sqlTimeRegex.source + ')?');

function extractISOYmd(match, cursor) {
  var item = {
    year: parseInt(match[cursor]),
    month: parseInt(match[cursor + 1]) || 1,
    day: parseInt(match[cursor + 2]) || 1
  };

  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  var item = {
    hour: parseInt(match[cursor]) || 0,
    minute: parseInt(match[cursor + 1]) || 0,
    second: parseInt(match[cursor + 2]) || 0,
    millisecond: parseMillis(match[cursor + 3])
  };

  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  var local = !match[cursor] && !match[cursor + 1],
      fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
      zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  var zone = match[cursor] ? new IANAZone(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO duration parsing

var isoDuration = /^P(?:(?:(\d{1,9})Y)?(?:(\d{1,9})M)?(?:(\d{1,9})D)?(?:T(?:(\d{1,9})H)?(?:(\d{1,9})M)?(?:(\d{1,9})(?:[.,](\d{1,9}))?S)?)?|(\d{1,9})W)$/;

function extractISODuration(match) {
  var yearStr = match[1],
      monthStr = match[2],
      dayStr = match[3],
      hourStr = match[4],
      minuteStr = match[5],
      secondStr = match[6],
      millisecondsStr = match[7],
      weekStr = match[8];


  return [{
    years: parseInt(yearStr),
    months: parseInt(monthStr),
    weeks: parseInt(weekStr),
    days: parseInt(dayStr),
    hours: parseInt(hourStr),
    minutes: parseInt(minuteStr),
    seconds: parseInt(secondStr),
    milliseconds: parseMillis(millisecondsStr)
  }];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = {
    year: yearStr.length === 2 ? untruncateYear(parseInt(yearStr)) : parseInt(yearStr),
    month: monthStr.length === 2 ? parseInt(monthStr, 10) : monthsShort.indexOf(monthStr) + 1,
    day: parseInt(dayStr),
    hour: parseInt(hourStr),
    minute: parseInt(minuteStr)
  };

  if (secondStr) result.second = parseInt(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
}

// RFC 2822/5322
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  var weekdayStr = match[1],
      dayStr = match[2],
      monthStr = match[3],
      yearStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      obsOffset = match[8],
      milOffset = match[9],
      offHourStr = match[10],
      offMinuteStr = match[11],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);


  var offset = void 0;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

// http date

var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
    rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
    ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  var weekdayStr = match[1],
      dayStr = match[2],
      monthStr = match[3],
      yearStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  var weekdayStr = match[1],
      monthStr = match[2],
      dayStr = match[3],
      hourStr = match[4],
      minuteStr = match[5],
      secondStr = match[6],
      yearStr = match[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  return [result, FixedOffsetZone.utcInstance];
}

/**
 * @private
 */

function parseISODate(s) {
  return parse(s, [combineRegexes(isoYmdRegex, isoTimeExtensionRegex), combineExtractors(extractISOYmd, extractISOTime, extractISOOffset)], [combineRegexes(isoWeekRegex, isoTimeExtensionRegex), combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset)], [combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex), combineExtractors(extractISOOrdinalData, extractISOTime)], [combineRegexes(isoTimeRegex), combineExtractors(extractISOTime, extractISOOffset)]);
}

function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}

function parseHTTPDate(s) {
  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}

function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}

function parseSQL(s) {
  return parse(s, [combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex), combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone)], [combineRegexes(sqlTimeRegex), combineExtractors(extractISOTime, extractISOOffset, extractIANAZone)]);
}

var INVALID = 'Invalid Duration',
    UNPARSABLE = 'unparsable';

// unit conversion constants
var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1000
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1000
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1000 },
  minutes: { seconds: 60, milliseconds: 60 * 1000 },
  seconds: { milliseconds: 1000 }
},
    casualMatrix = Object.assign({
  years: {
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1000
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix),
    daysInYearAccurate = 146097.0 / 400,
    daysInMonthAccurate = 146097.0 / 4800,
    accurateMatrix = Object.assign({
  years: {
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix);

// units ordered by size
var orderedUnits = ['years', 'quarters', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds', 'milliseconds'];

var reverseUnits = orderedUnits.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone(dur, alts) {
  var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // deep merge for vals
  var conf = {
    values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
  };
  return new Duration(conf);
}

// some functions really care about the absolute value of a duration, so combined with
// normalize() this tells us whether this duration is positive or negative
function isHighOrderNegative(obj) {
  // only rule is that the highest-order part must be non-negative
  for (var _iterator = orderedUnits, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var k = _ref;

    if (obj[k]) return obj[k] < 0;
  }
  return false;
}

// NB: mutates parameters
function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
  var conv = matrix[toUnit][fromUnit],
      added = Math.floor(fromMap[fromUnit] / conv);
  toMap[toUnit] += added;
  fromMap[fromUnit] -= added * conv;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  reverseUnits.reduce(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        convert(matrix, vals, previous, vals, current);
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

/**
 * @private
 */
function friendlyDuration(duration) {
  if (isNumber(duration)) {
    return Duration.fromMillis(duration);
  } else if (duration instanceof Duration) {
    return duration;
  } else if (duration instanceof Object) {
    return Duration.fromObject(duration);
  } else {
    throw new InvalidArgumentError('Unknown duration argument');
  }
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link years}, {@link months}, {@link weeks}, {@link days}, {@link hours}, {@link minutes}, {@link seconds}, {@link milliseconds} accessors.
 * * **Configuration** See  {@link locale} and {@link numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link plus}, {@link minus}, {@link normalize}, {@link set}, {@link reconfigure}, {@link shiftTo}, and {@link negate}.
 * * **Output** To convert the Duration into other representations, see {@link as}, {@link toISO}, {@link toFormat}, and {@link toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */

var Duration = function () {
  /**
   * @private
   */
  function Duration(config) {
    classCallCheck(this, Duration);

    var accurate = config.conversionAccuracy === 'longterm' || false;
    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? 'longterm' : 'casual';
    /**
     * @access private
     */
    this.invalid = config.invalidReason || null;
    /**
     * @access private
     */
    this.matrix = accurate ? accurateMatrix : casualMatrix;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */


  Duration.fromMillis = function fromMillis(count, opts) {
    return Duration.fromObject(Object.assign({ milliseconds: count }, opts));
  };

  /**
   * Create an Duration from a Javascript object with keys like 'years' and 'hours'.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {string} [obj.locale='en-US'] - the locale to use
   * @param {string} obj.numberingSystem - the numbering system to use
   * @param {string} [obj.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */


  Duration.fromObject = function fromObject(obj) {
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit, true),
      loc: Locale.fromObject(obj),
      conversionAccuracy: obj.conversionAccuracy
    });
  };

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M4DT12H30M5S').toObject() //=> { years: 3, months: 6, day: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */


  Duration.fromISO = function fromISO(text, opts) {
    var _parseISODuration = parseISODuration(text),
        parsed = _parseISODuration[0];

    if (parsed) {
      var obj = Object.assign(parsed, opts);
      return Duration.fromObject(obj);
    } else {
      return Duration.invalid(UNPARSABLE);
    }
  };

  /**
   * Create an invalid Duration.
   * @param {string} reason - reason this is invalid
   * @return {Duration}
   */


  Duration.invalid = function invalid(reason) {
    if (!reason) {
      throw new InvalidArgumentError('need to specify a reason the Duration is invalid');
    }
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(reason);
    } else {
      return new Duration({ invalidReason: reason });
    }
  };

  /**
   * @private
   */


  Duration.normalizeUnit = function normalizeUnit(unit) {
    var ignoreUnknown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var normalized = {
      year: 'years',
      years: 'years',
      quarter: 'quarters',
      quarters: 'quarters',
      month: 'months',
      months: 'months',
      week: 'weeks',
      weeks: 'weeks',
      day: 'days',
      days: 'days',
      hour: 'hours',
      hours: 'hours',
      minute: 'minutes',
      minutes: 'minutes',
      second: 'seconds',
      seconds: 'seconds',
      millisecond: 'milliseconds',
      milliseconds: 'milliseconds'
    }[unit ? unit.toLowerCase() : unit];

    if (!ignoreUnknown && !normalized) throw new InvalidUnitError(unit);

    return normalized;
  };

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */


  /**
   * Returns a string representation of this Duration formatted according to the specified format string.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} opts.round - round numerical values
   * @return {string}
   */
  Duration.prototype.toFormat = function toFormat(fmt) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return this.isValid ? Formatter.create(this.loc, opts).formatDurationFromString(this, fmt) : INVALID;
  };

  /**
   * Returns a Javascript object with this Duration's values.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */


  Duration.prototype.toObject = function toObject() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!this.isValid) return {};

    var base = Object.assign({}, this.values);

    if (opts.includeConfig) {
      base.conversionAccuracy = this.conversionAccuracy;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  };

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @return {string}
   */


  Duration.prototype.toISO = function toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;

    var s = 'P',
        norm = this.normalize();

    // ISO durations are always positive, so take the absolute value
    norm = isHighOrderNegative(norm.values) ? norm.negate() : norm;

    if (norm.years > 0) s += norm.years + 'Y';
    if (norm.months > 0 || norm.quarters > 0) s += norm.months + norm.quarters * 3 + 'M';
    if (norm.days > 0 || norm.weeks > 0) s += norm.days + norm.weeks * 7 + 'D';
    if (norm.hours > 0 || norm.minutes > 0 || norm.seconds > 0 || norm.milliseconds > 0) s += 'T';
    if (norm.hours > 0) s += norm.hours + 'H';
    if (norm.minutes > 0) s += norm.minutes + 'M';
    if (norm.seconds > 0) s += norm.seconds + 'S';
    return s;
  };

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */


  Duration.prototype.toJSON = function toJSON() {
    return this.toISO();
  };

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */


  Duration.prototype.toString = function toString() {
    return this.toISO();
  };

  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */


  Duration.prototype.inspect = function inspect() {
    if (this.isValid) {
      var valsInspect = JSON.stringify(this.toObject());
      return 'Duration {\n  values: ' + valsInspect + ',\n  locale: ' + this.locale + ',\n  conversionAccuracy: ' + this.conversionAccuracy + ' }';
    } else {
      return 'Duration { Invalid, reason: ' + this.invalidReason + ' }';
    }
  };

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */


  Duration.prototype.plus = function plus(duration) {
    if (!this.isValid) return this;

    var dur = friendlyDuration(duration),
        result = {};

    for (var _iterator2 = orderedUnits, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var k = _ref2;

      var val = dur.get(k) + this.get(k);
      if (val !== 0) {
        result[k] = val;
      }
    }

    return clone(this, { values: result }, true);
  };

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */


  Duration.prototype.minus = function minus(duration) {
    if (!this.isValid) return this;

    var dur = friendlyDuration(duration);
    return this.plus(dur.negate());
  };

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).years //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).months //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).days //=> 3
   * @return {number}
   */


  Duration.prototype.get = function get$$1(unit) {
    return this[Duration.normalizeUnit(unit)];
  };

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */


  Duration.prototype.set = function set$$1(values) {
    var mixed = Object.assign(this.values, normalizeObject(values, Duration.normalizeUnit));
    return clone(this, { values: mixed });
  };

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */


  Duration.prototype.reconfigure = function reconfigure() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        locale = _ref3.locale,
        numberingSystem = _ref3.numberingSystem,
        conversionAccuracy = _ref3.conversionAccuracy;

    var loc = this.loc.clone({ locale: locale, numberingSystem: numberingSystem }),
        opts = { loc: loc };

    if (conversionAccuracy) {
      opts.conversionAccuracy = conversionAccuracy;
    }

    return clone(this, opts);
  };

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */


  Duration.prototype.as = function as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  };

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */


  Duration.prototype.normalize = function normalize() {
    if (!this.isValid) return this;

    var neg = isHighOrderNegative(this.values),
        vals = (neg ? this.negate() : this).toObject();
    normalizeValues(this.matrix, vals);
    var dur = Duration.fromObject(vals);
    return neg ? dur.negate() : dur;
  };

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */


  Duration.prototype.shiftTo = function shiftTo() {
    for (var _len = arguments.length, units = Array(_len), _key = 0; _key < _len; _key++) {
      units[_key] = arguments[_key];
    }

    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map(function (u) {
      return Duration.normalizeUnit(u);
    });

    var built = {},
        accumulated = {},
        vals = this.toObject();
    var lastUnit = void 0;

    normalizeValues(this.matrix, vals);

    for (var _iterator3 = orderedUnits, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref4 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref4 = _i3.value;
      }

      var k = _ref4;

      if (units.indexOf(k) >= 0) {
        lastUnit = k;

        var own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (var ak in accumulated) {
          if (accumulated.hasOwnProperty(ak)) {
            own += this.matrix[ak][k] * accumulated[ak];
            accumulated[ak] = 0;
          }
        }

        // plus anything that's already in this unit
        if (isNumber(vals[k])) {
          own += vals[k];
        }

        var i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = own - i;

        // plus anything further down the chain that should be rolled up in to this
        for (var down in vals) {
          if (orderedUnits.indexOf(down) > orderedUnits.indexOf(k)) {
            convert(this.matrix, vals, down, built, k);
          }
        }
        // otherwise, keep it in the wings to boil it later
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    if (lastUnit) {
      for (var key in accumulated) {
        if (accumulated.hasOwnProperty(key)) {
          if (accumulated[key] > 0) {
            built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
          }
        }
      }
    }
    return clone(this, { values: built }, true);
  };

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */


  Duration.prototype.negate = function negate() {
    if (!this.isValid) return this;
    var negated = {};
    for (var _iterator4 = Object.keys(this.values), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref5 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref5 = _i4.value;
      }

      var k = _ref5;

      negated[k] = -this.values[k];
    }
    return clone(this, { values: negated }, true);
  };

  /**
   * Get the years.
   * @type {number}
   */


  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  Duration.prototype.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    for (var _iterator5 = orderedUnits, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref6;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref6 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref6 = _i5.value;
      }

      var u = _ref6;

      if (this.values[u] !== other.values[u]) {
        return false;
      }
    }
    return true;
  };

  createClass(Duration, [{
    key: 'locale',
    get: function get$$1() {
      return this.isValid ? this.loc.locale : null;
    }

    /**
     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
     *
     * @type {string}
     */

  }, {
    key: 'numberingSystem',
    get: function get$$1() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
  }, {
    key: 'years',
    get: function get$$1() {
      return this.isValid ? this.values.years || 0 : NaN;
    }

    /**
     * Get the quarters.
     * @type {number}
     */

  }, {
    key: 'quarters',
    get: function get$$1() {
      return this.isValid ? this.values.quarters || 0 : NaN;
    }

    /**
     * Get the months.
     * @type {number}
     */

  }, {
    key: 'months',
    get: function get$$1() {
      return this.isValid ? this.values.months || 0 : NaN;
    }

    /**
     * Get the weeks
     * @type {number}
     */

  }, {
    key: 'weeks',
    get: function get$$1() {
      return this.isValid ? this.values.weeks || 0 : NaN;
    }

    /**
     * Get the days.
     * @type {number}
     */

  }, {
    key: 'days',
    get: function get$$1() {
      return this.isValid ? this.values.days || 0 : NaN;
    }

    /**
     * Get the hours.
     * @type {number}
     */

  }, {
    key: 'hours',
    get: function get$$1() {
      return this.isValid ? this.values.hours || 0 : NaN;
    }

    /**
     * Get the minutes.
     * @type {number}
     */

  }, {
    key: 'minutes',
    get: function get$$1() {
      return this.isValid ? this.values.minutes || 0 : NaN;
    }

    /**
     * Get the seconds.
     * @return {number}
     */

  }, {
    key: 'seconds',
    get: function get$$1() {
      return this.isValid ? this.values.seconds || 0 : NaN;
    }

    /**
     * Get the milliseconds.
     * @return {number}
     */

  }, {
    key: 'milliseconds',
    get: function get$$1() {
      return this.isValid ? this.values.milliseconds || 0 : NaN;
    }

    /**
     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
     * on invalid DateTimes or Intervals.
     * @return {boolean}
     */

  }, {
    key: 'isValid',
    get: function get$$1() {
      return this.invalidReason === null;
    }

    /**
     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
     * @return {string}
     */

  }, {
    key: 'invalidReason',
    get: function get$$1() {
      return this.invalid;
    }
  }]);
  return Duration;
}();

var INVALID$1 = 'Invalid Interval';

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  return !!start && !!end && start.isValid && end.isValid && start <= end;
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}
 * * **Output*** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toFormat}, and {@link toDuration}.
 */

var Interval = function () {
  /**
   * @private
   */
  function Interval(config) {
    classCallCheck(this, Interval);

    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalidReason || null;
  }

  /**
   * Create an invalid Interval.
   * @return {Interval}
   */


  Interval.invalid = function invalid(reason) {
    if (!reason) {
      throw new InvalidArgumentError('need to specify a reason the DateTime is invalid');
    }
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(reason);
    } else {
      return new Interval({ invalidReason: reason });
    }
  };

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */


  Interval.fromDateTimes = function fromDateTimes(start, end) {
    var builtStart = friendlyDateTime(start),
        builtEnd = friendlyDateTime(end);

    return new Interval({
      start: builtStart,
      end: builtEnd,
      invalidReason: validateStartEnd(builtStart, builtEnd) ? null : 'invalid endpoints'
    });
  };

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */


  Interval.after = function after(start, duration) {
    var dur = friendlyDuration(duration),
        dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  };

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */


  Interval.before = function before(end, duration) {
    var dur = friendlyDuration(duration),
        dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  };

  /**
   * Create an Interval from an ISO 8601 string
   * @param {string} string - the ISO string to parse
   * @param {Object} opts - options to pass {@see DateTime.fromISO}
   * @return {Interval}
   */


  Interval.fromISO = function fromISO(string, opts) {
    if (string) {
      var _string$split = string.split(/\//),
          s = _string$split[0],
          e = _string$split[1];

      if (s && e) {
        return Interval.fromDateTimes(DateTime.fromISO(s, opts), DateTime.fromISO(e, opts));
      }
    }
    return Interval.invalid('invalid ISO format');
  };

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */


  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  Interval.prototype.length = function length() {
    var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'milliseconds';

    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
  };

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */


  Interval.prototype.count = function count() {
    var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'milliseconds';

    if (!this.isValid) return NaN;
    var start = this.start.startOf(unit),
        end = this.end.startOf(unit);
    return Math.floor(end.diff(start, unit).get(unit)) + 1;
  };

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */


  Interval.prototype.hasSame = function hasSame(unit) {
    return this.isValid ? this.e.minus(1).hasSame(this.s, unit) : false;
  };

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */


  Interval.prototype.isEmpty = function isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  };

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */


  Interval.prototype.isAfter = function isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  };

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */


  Interval.prototype.isBefore = function isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  };

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */


  Interval.prototype.contains = function contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  };

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */


  Interval.prototype.set = function set$$1() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        start = _ref.start,
        end = _ref.end;

    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  };

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...[DateTime]} dateTimes - the unit of time to count.
   * @return {[Interval]}
   */


  Interval.prototype.splitAt = function splitAt() {
    if (!this.isValid) return [];

    for (var _len = arguments.length, dateTimes = Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }

    var sorted = dateTimes.map(friendlyDateTime).sort(),
        results = [];
    var s = this.s,
        i = 0;


    while (s < this.e) {
      var added = sorted[i] || this.e,
          next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  };

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {[Interval]}
   */


  Interval.prototype.splitBy = function splitBy(duration) {
    if (!this.isValid) return [];
    var dur = friendlyDuration(duration),
        results = [];
    var s = this.s,
        added = void 0,
        next = void 0;


    while (s < this.e) {
      added = s.plus(dur);
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
    }

    return results;
  };

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {[Interval]}
   */


  Interval.prototype.divideEqually = function divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  };

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */


  Interval.prototype.overlaps = function overlaps(other) {
    return this.e > other.s && this.s < other.e;
  };

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */


  Interval.prototype.abutsStart = function abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  };

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */


  Interval.prototype.abutsEnd = function abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  };

  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */


  Interval.prototype.engulfs = function engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  };

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */


  Interval.prototype.equals = function equals(other) {
    return this.s.equals(other.s) && this.e.equals(other.e);
  };

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, i.e., the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */


  Interval.prototype.intersection = function intersection(other) {
    if (!this.isValid) return this;
    var s = this.s > other.s ? this.s : other.s,
        e = this.e < other.e ? this.e : other.e;

    if (s > e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  };

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */


  Interval.prototype.union = function union(other) {
    if (!this.isValid) return this;
    var s = this.s < other.s ? this.s : other.s,
        e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  };

  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {[Interval]} intervals
   * @return {[Interval]}
   */


  Interval.merge = function merge(intervals) {
    var _intervals$sort$reduc = intervals.sort(function (a, b) {
      return a.s - b.s;
    }).reduce(function (_ref2, item) {
      var sofar = _ref2[0],
          current = _ref2[1];

      if (!current) {
        return [sofar, item];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [sofar, current.union(item)];
      } else {
        return [sofar.concat([current]), item];
      }
    }, [[], null]),
        found = _intervals$sort$reduc[0],
        final = _intervals$sort$reduc[1];

    if (final) {
      found.push(final);
    }
    return found;
  };

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {[Interval]} intervals
   * @return {[Interval]}
   */


  Interval.xor = function xor(intervals) {
    var _Array$prototype;

    var start = null,
        currentCount = 0;
    var results = [],
        ends = intervals.map(function (i) {
      return [{ time: i.s, type: 's' }, { time: i.e, type: 'e' }];
    }),
        flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
        arr = flattened.sort(function (a, b) {
      return a.time - b.time;
    });

    for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref3 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref3 = _i.value;
      }

      var i = _ref3;

      currentCount += i.type === 's' ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  };

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {[Interval]}
   */


  Interval.prototype.difference = function difference() {
    var _this = this;

    for (var _len2 = arguments.length, intervals = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      intervals[_key2] = arguments[_key2];
    }

    return Interval.xor([this].concat(intervals)).map(function (i) {
      return _this.intersection(i);
    }).filter(function (i) {
      return i && !i.isEmpty();
    });
  };

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */


  Interval.prototype.toString = function toString() {
    if (!this.isValid) return INVALID$1;
    return '[' + this.s.toISO() + ' \u2013 ' + this.e.toISO() + ')';
  };

  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */


  Interval.prototype.inspect = function inspect() {
    if (this.isValid) {
      return 'Interval {\n  start: ' + this.start.toISO() + ',\n  end: ' + this.end.toISO() + ',\n  zone:   ' + this.start.zone.name + ',\n  locale:   ' + this.start.locale + ' }';
    } else {
      return 'Interval { Invalid, reason: ' + this.invalidReason + ' }';
    }
  };

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime.toISO}
   * @return {string}
   */


  Interval.prototype.toISO = function toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISO(opts) + '/' + this.e.toISO(opts);
  };

  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime.toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */


  Interval.prototype.toFormat = function toFormat(dateFormat) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$separator = _ref4.separator,
        separator = _ref4$separator === undefined ? ' – ' : _ref4$separator;

    if (!this.isValid) return INVALID$1;
    return '' + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
  };

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */


  Interval.prototype.toDuration = function toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  };

  createClass(Interval, [{
    key: 'start',
    get: function get$$1() {
      return this.isValid ? this.s : null;
    }

    /**
     * Returns the end of the Interval
     * @type {DateTime}
     */

  }, {
    key: 'end',
    get: function get$$1() {
      return this.isValid ? this.e : null;
    }

    /**
     * Returns whether this Interval's end is at least its start, i.e. that the Interval isn't 'backwards'.
     * @type {boolean}
     */

  }, {
    key: 'isValid',
    get: function get$$1() {
      return this.invalidReason === null;
    }

    /**
     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: 'invalidReason',
    get: function get$$1() {
      return this.invalid;
    }
  }]);
  return Interval;
}();

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */

var Info = function () {
  function Info() {
    classCallCheck(this, Info);
  }

  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  Info.hasDST = function hasDST() {
    var zone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Settings.defaultZone;

    var proto = DateTime.local().setZone(zone).set({ month: 12 });

    return !zone.universal && proto.offset !== proto.set({ month: 6 }).offset;
  };

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */


  Info.isValidIANAZone = function isValidIANAZone(zone) {
    return !!IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
  };

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {[string]}
   */


  Info.months = function months() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'long';

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$locale = _ref.locale,
        locale = _ref$locale === undefined ? null : _ref$locale,
        _ref$numberingSystem = _ref.numberingSystem,
        numberingSystem = _ref$numberingSystem === undefined ? null : _ref$numberingSystem,
        _ref$outputCalendar = _ref.outputCalendar,
        outputCalendar = _ref$outputCalendar === undefined ? 'gregory' : _ref$outputCalendar;

    return Locale.create(locale, numberingSystem, outputCalendar).months(length);
  };

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {[string]}
   */


  Info.monthsFormat = function monthsFormat() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'long';

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$locale = _ref2.locale,
        locale = _ref2$locale === undefined ? null : _ref2$locale,
        _ref2$numberingSystem = _ref2.numberingSystem,
        numberingSystem = _ref2$numberingSystem === undefined ? null : _ref2$numberingSystem,
        _ref2$outputCalendar = _ref2.outputCalendar,
        outputCalendar = _ref2$outputCalendar === undefined ? 'gregory' : _ref2$outputCalendar;

    return Locale.create(locale, numberingSystem, outputCalendar).months(length, true);
  };

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {[string]}
   */


  Info.weekdays = function weekdays() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'long';

    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$locale = _ref3.locale,
        locale = _ref3$locale === undefined ? null : _ref3$locale,
        _ref3$numberingSystem = _ref3.numberingSystem,
        numberingSystem = _ref3$numberingSystem === undefined ? null : _ref3$numberingSystem;

    return Locale.create(locale, numberingSystem, null).weekdays(length);
  };

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @return {[string]}
   */


  Info.weekdaysFormat = function weekdaysFormat() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'long';

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$locale = _ref4.locale,
        locale = _ref4$locale === undefined ? null : _ref4$locale,
        _ref4$numberingSystem = _ref4.numberingSystem,
        numberingSystem = _ref4$numberingSystem === undefined ? null : _ref4$numberingSystem;

    return Locale.create(locale, numberingSystem, null).weekdays(length, true);
  };

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'de' }) //=> [ 'vorm.', 'nachm.' ]
   * @return {[string]}
   */


  Info.meridiems = function meridiems() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$locale = _ref5.locale,
        locale = _ref5$locale === undefined ? null : _ref5$locale;

    return Locale.create(locale).meridiems();
  };

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {[string]}
   */


  Info.eras = function eras() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'short';

    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$locale = _ref6.locale,
        locale = _ref6$locale === undefined ? null : _ref6$locale;

    return Locale.create(locale, null, 'gregory').eras(length);
  };

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, timezone support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `zones`: whether this environment supports IANA timezones
   * * `intlTokens`: whether this environment supports internationalized token-based formatting/parsing
   * * `intl`: whether this environment supports general internationalization
   * @example Info.features() //=> { intl: true, intlTokens: false, zones: true }
   * @return {Object}
   */


  Info.features = function features() {
    var intl = false,
        intlTokens = false,
        zones = false;

    if (hasIntl()) {
      intl = true;
      intlTokens = hasFormatToParts();

      try {
        zones = new Intl.DateTimeFormat('en', { timeZone: 'America/New_York' }).resolvedOptions().timeZone === 'America/New_York';
      } catch (e) {
        zones = false;
      }
    }

    return { intl: intl, intlTokens: intlTokens, zones: zones };
  };

  return Info;
}();

function dayDiff(earlier, later) {
  var utcDayStart = function utcDayStart(dt) {
    return dt.toUTC(0, { keepLocalTime: true }).startOf('day').valueOf();
  },
      ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as('days'));
}

function highOrderDiffs(cursor, later, units) {
  var differs = [['years', function (a, b) {
    return b.year - a.year;
  }], ['months', function (a, b) {
    return b.month - a.month + (b.year - a.year) * 12;
  }], ['weeks', function (a, b) {
    var days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ['days', dayDiff]];

  var results = {};
  var lowestOrder = void 0,
      highWater = void 0;

  for (var _iterator = differs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var _ref = _ref2;
    var unit = _ref[0];
    var differ = _ref[1];

    if (units.indexOf(unit) >= 0) {
      var _cursor$plus;

      lowestOrder = unit;

      var delta = differ(cursor, later);

      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));

      if (highWater > later) {
        var _highWater$minus;

        cursor = highWater.minus((_highWater$minus = {}, _highWater$minus[unit] = 1, _highWater$minus));
        delta -= 1;
      } else {
        cursor = highWater;
      }

      if (delta > 0) {
        results[unit] = delta;
      }
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

function _diff (earlier, later, units, opts) {
  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
      cursor = _highOrderDiffs[0],
      results = _highOrderDiffs[1],
      highWater = _highOrderDiffs[2],
      lowestOrder = _highOrderDiffs[3];

  var remainingMillis = later - cursor;

  var lowerOrderUnits = units.filter(function (u) {
    return ['hours', 'minutes', 'seconds', 'milliseconds'].indexOf(u) >= 0;
  });

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      var _cursor$plus2;

      highWater = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[lowestOrder] = 1, _cursor$plus2));
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  var duration = Duration.fromObject(Object.assign(results, opts));

  if (lowerOrderUnits.length > 0) {
    var _Duration$fromMillis;

    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}

var MISSING_FTP = 'missing Intl.DateTimeFormat.formatToParts support';

function intUnit(regex) {
  var post = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
    return i;
  };

  return { regex: regex, deser: function deser(_ref) {
      var s = _ref[0];
      return post(parseInt(s));
    } };
}

function fixListRegex(s) {
  // make dots optional and also make them literal
  return s.replace(/\./, '\\.?');
}

function stripInsensitivities(s) {
  return s.replace(/\./, '').toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join('|')),
      deser: function deser(_ref2) {
        var s = _ref2[0];
        return strings.findIndex(function (i) {
          return stripInsensitivities(s) === stripInsensitivities(i);
        }) + startIndex;
      }
    };
  }
}

function offset(regex, groups) {
  return { regex: regex, deser: function deser(_ref3) {
      var h = _ref3[1],
          m = _ref3[2];
      return signedOffset(h, m);
    }, groups: groups };
}

function simple(regex) {
  return { regex: regex, deser: function deser(_ref4) {
      var s = _ref4[0];
      return s;
    } };
}

function unitForToken(token, loc) {
  var one = /\d/,
      two = /\d{2}/,
      three = /\d{3}/,
      four = /\d{4}/,
      oneOrTwo = /\d{1,2}/,
      oneToThree = /\d{1,3}/,
      twoToFour = /\d{2,4}/,
      literal = function literal(t) {
    return { regex: RegExp(t.val), deser: function deser(_ref5) {
        var s = _ref5[0];
        return s;
      }, literal: true };
  },
      unitate = function unitate(t) {
    if (token.literal) {
      return literal(t);
    }
    switch (t.val) {
      // era
      case 'G':
        return oneOf(loc.eras('short', false), 0);
      case 'GG':
        return oneOf(loc.eras('long', false), 0);
      // years
      case 'y':
        return intUnit(/\d{1,6}/);
      case 'yy':
        return intUnit(twoToFour, untruncateYear);
      case 'yyyy':
        return intUnit(four);
      case 'yyyyy':
        return intUnit(/\d{4,6}/);
      case 'yyyyyy':
        return intUnit(/\d{6}/);
      // months
      case 'M':
        return intUnit(oneOrTwo);
      case 'MM':
        return intUnit(two);
      case 'MMM':
        return oneOf(loc.months('short', false, false), 1);
      case 'MMMM':
        return oneOf(loc.months('long', false, false), 1);
      case 'L':
        return intUnit(oneOrTwo);
      case 'LL':
        return intUnit(two);
      case 'LLL':
        return oneOf(loc.months('short', true, false), 1);
      case 'LLLL':
        return oneOf(loc.months('long', true, false), 1);
      // dates
      case 'd':
        return intUnit(oneOrTwo);
      case 'dd':
        return intUnit(two);
      // ordinals
      case 'o':
        return intUnit(oneToThree);
      case 'ooo':
        return intUnit(three);
      // time
      case 'HH':
        return intUnit(two);
      case 'H':
        return intUnit(oneOrTwo);
      case 'hh':
        return intUnit(two);
      case 'h':
        return intUnit(oneOrTwo);
      case 'mm':
        return intUnit(two);
      case 'm':
        return intUnit(oneOrTwo);
      case 's':
        return intUnit(oneOrTwo);
      case 'ss':
        return intUnit(two);
      case 'S':
        return intUnit(oneToThree);
      case 'SSS':
        return intUnit(three);
      case 'u':
        return simple(/\d{1,9}/);
      // meridiem
      case 'a':
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)
      case 'kkkk':
        return intUnit(four);
      case 'kk':
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)
      case 'W':
        return intUnit(oneOrTwo);
      case 'WW':
        return intUnit(two);
      // weekdays
      case 'E':
      case 'c':
        return intUnit(one);
      case 'EEE':
        return oneOf(loc.weekdays('short', false, false), 1);
      case 'EEEE':
        return oneOf(loc.weekdays('long', false, false), 1);
      case 'ccc':
        return oneOf(loc.weekdays('short', true, false), 1);
      case 'cccc':
        return oneOf(loc.weekdays('long', true, false), 1);
      // offset/zone
      case 'Z':
      case 'ZZ':
        return offset(/([+-]\d{1,2})(?::(\d{2}))?/, 2);
      case 'ZZZ':
        return offset(/([+-]\d{1,2})(\d{2})?/, 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case 'z':
        return simple(/[A-Za-z_]{1,256}\/[A-Za-z_]{1,256}/);
      default:
        return literal(t);
    }
  };

  var unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };

  unit.token = token;

  return unit;
}

function buildRegex(units) {
  var re = units.map(function (u) {
    return u.regex;
  }).reduce(function (f, r) {
    return f + '(' + r.source + ')';
  }, '');
  return ['^' + re + '$', units];
}

function match(input, regex, handlers) {
  var matches = input.match(regex);

  if (matches) {
    var all = {};
    var matchIndex = 1;
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        var h = handlers[i],
            groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  var toField = function toField(token) {
    switch (token) {
      case 'S':
        return 'millisecond';
      case 's':
        return 'second';
      case 'm':
        return 'minute';
      case 'h':
      case 'H':
        return 'hour';
      case 'd':
        return 'day';
      case 'o':
        return 'ordinal';
      case 'L':
      case 'M':
        return 'month';
      case 'y':
        return 'year';
      case 'E':
      case 'c':
        return 'weekday';
      case 'W':
        return 'weekNumber';
      case 'k':
        return 'weekYear';
      default:
        return null;
    }
  };

  var zone = void 0;
  if (!isUndefined(matches.Z)) {
    zone = new FixedOffsetZone(matches.Z);
  } else if (!isUndefined(matches.z)) {
    zone = new IANAZone(matches.z);
  } else {
    zone = null;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  var vals = Object.keys(matches).reduce(function (r, k) {
    var f = toField(k);
    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});

  return [vals, zone];
}

/**
 * @private
 */

function explainFromTokens(locale, input, format) {
  var tokens = Formatter.parseFormat(format),
      units = tokens.map(function (t) {
    return unitForToken(t, locale);
  }),
      disqualifyingUnit = units.find(function (t) {
    return t.invalidReason;
  });

  if (disqualifyingUnit) {
    return { input: input, tokens: tokens, invalidReason: disqualifyingUnit.invalidReason };
  } else {
    var _buildRegex = buildRegex(units),
        regexString = _buildRegex[0],
        handlers = _buildRegex[1],
        regex = RegExp(regexString, 'i'),
        _match = match(input, regex, handlers),
        rawMatches = _match[0],
        matches = _match[1],
        _ref6 = matches ? dateTimeFromMatches(matches) : [null, null],
        result = _ref6[0],
        zone = _ref6[1];

    return { input: input, tokens: tokens, regex: regex, rawMatches: rawMatches, matches: matches, result: result, zone: zone };
  }
}

function parseFromTokens(locale, input, format) {
  var _explainFromTokens = explainFromTokens(locale, input, format),
      result = _explainFromTokens.result,
      zone = _explainFromTokens.zone,
      invalidReason = _explainFromTokens.invalidReason;

  return [result, zone, invalidReason];
}

var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
    leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function dayOfWeek(year, month, day) {
  var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
      month0 = table.findIndex(function (i) {
    return i < ordinal;
  }),
      day = ordinal - table[month0];
  return { month: month0 + 1, day: day };
}

/**
 * @private
 */

function gregorianToWeek(gregObj) {
  var year = gregObj.year,
      month = gregObj.month,
      day = gregObj.day,
      ordinal = computeOrdinal(year, month, day),
      weekday = dayOfWeek(year, month, day);


  var weekNumber = Math.floor((ordinal - weekday + 10) / 7),
      weekYear = void 0;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear);
  } else if (weekNumber > weeksInWeekYear(year)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return Object.assign({ weekYear: weekYear, weekNumber: weekNumber, weekday: weekday }, timeObject(gregObj));
}

function weekToGregorian(weekData) {
  var weekYear = weekData.weekYear,
      weekNumber = weekData.weekNumber,
      weekday = weekData.weekday,
      weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
      yearInDays = daysInYear(weekYear);

  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
      year = void 0;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(year);
  } else {
    year = weekYear;
  }

  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal.month,
      day = _uncomputeOrdinal.day;

  return Object.assign({ year: year, month: month, day: day }, timeObject(weekData));
}

function gregorianToOrdinal(gregData) {
  var year = gregData.year,
      month = gregData.month,
      day = gregData.day,
      ordinal = computeOrdinal(year, month, day);


  return Object.assign({ year: year, ordinal: ordinal }, timeObject(gregData));
}

function ordinalToGregorian(ordinalData) {
  var year = ordinalData.year,
      ordinal = ordinalData.ordinal,
      _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal2.month,
      day = _uncomputeOrdinal2.day;

  return Object.assign({ year: year, month: month, day: day }, timeObject(ordinalData));
}

function hasInvalidWeekData(obj) {
  var validYear = isNumber(obj.weekYear),
      validWeek = numberBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
      validWeekday = numberBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return 'weekYear out of range';
  } else if (!validWeek) {
    return 'week out of range';
  } else if (!validWeekday) {
    return 'weekday out of range';
  } else return false;
}

function hasInvalidOrdinalData(obj) {
  var validYear = isNumber(obj.year),
      validOrdinal = numberBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return 'year out of range';
  } else if (!validOrdinal) {
    return 'ordinal out of range';
  } else return false;
}

function hasInvalidGregorianData(obj) {
  var validYear = isNumber(obj.year),
      validMonth = numberBetween(obj.month, 1, 12),
      validDay = numberBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return 'year out of range';
  } else if (!validMonth) {
    return 'month out of range';
  } else if (!validDay) {
    return 'day out of range';
  } else return false;
}

function hasInvalidTimeData(obj) {
  var validHour = numberBetween(obj.hour, 0, 23),
      validMinute = numberBetween(obj.minute, 0, 59),
      validSecond = numberBetween(obj.second, 0, 59),
      validMillisecond = numberBetween(obj.millisecond, 0, 999);

  if (!validHour) {
    return 'hour out of range';
  } else if (!validMinute) {
    return 'minute out of range';
  } else if (!validSecond) {
    return 'second out of range';
  } else if (!validMillisecond) {
    return 'millisecond out of range';
  } else return false;
}

var INVALID$2 = 'Invalid DateTime',
    INVALID_INPUT = 'invalid input',
    UNSUPPORTED_ZONE = 'unsupported zone',
    UNPARSABLE$1 = 'unparsable';

// we cache week data on the DT object and this intermediates the cache
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone$1(inst, alts) {
  var current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalidReason: inst.invalidReason
  };
  return new DateTime(Object.assign({}, current, alts, { old: current }));
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  var o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  var o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;

  var d = new Date(ts);

  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}

// covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);

  // javascript is stupid and i hate it
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year);
  }
  return +d;
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  var oPre = inst.o,
      year = inst.c.year + dur.years,
      month = inst.c.month + dur.months + dur.quarters * 3,
      c = Object.assign({}, inst.c, {
    year: year,
    month: month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + dur.days + dur.weeks * 7
  }),
      millisToAdd = Duration.fromObject({
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as('milliseconds'),
      localTS = objToLocalTS(c);

  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
      ts = _fixOffset[0],
      o = _fixOffset[1];

  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }

  return { ts: ts, o: o };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts) {
  var setZone = opts.setZone,
      zone = opts.zone;

  if (parsed && Object.keys(parsed).length !== 0) {
    var interpretationZone = parsedZone || zone,
        inst = DateTime.fromObject(Object.assign(parsed, opts, {
      zone: interpretationZone
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(UNPARSABLE$1);
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format) {
  return dt.isValid ? Formatter.create(Locale.create('en-US'), {
    allowZ: true,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}

// technical time formats (e.g. the time part of ISO 8601), take some options
// and this commonizes their handling
function toTechTimeFormat(dt, _ref) {
  var _ref$suppressSeconds = _ref.suppressSeconds,
      suppressSeconds = _ref$suppressSeconds === undefined ? false : _ref$suppressSeconds,
      _ref$suppressMillisec = _ref.suppressMilliseconds,
      suppressMilliseconds = _ref$suppressMillisec === undefined ? false : _ref$suppressMillisec,
      _ref$includeOffset = _ref.includeOffset,
      includeOffset = _ref$includeOffset === undefined ? true : _ref$includeOffset,
      _ref$includeZone = _ref.includeZone,
      includeZone = _ref$includeZone === undefined ? false : _ref$includeZone,
      _ref$spaceZone = _ref.spaceZone,
      spaceZone = _ref$spaceZone === undefined ? false : _ref$spaceZone;

  var fmt = 'HH:mm';

  if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
    fmt += ':ss';
    if (!suppressMilliseconds || dt.millisecond !== 0) {
      fmt += '.SSS';
    }
  }

  if ((includeZone || includeOffset) && spaceZone) {
    fmt += ' ';
  }

  if (includeZone) {
    fmt += 'z';
  } else if (includeOffset) {
    fmt += 'ZZ';
  }

  return toTechFormat(dt, fmt);
}

// defaults for unspecified units in the supported calendars
var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};

// Units in the supported calendars, sorted by bigness
var orderedUnits$1 = ['year', 'month', 'day', 'hour', 'minute', 'second', 'millisecond'],
    orderedWeekUnits = ['weekYear', 'weekNumber', 'weekday', 'hour', 'minute', 'second', 'millisecond'],
    orderedOrdinalUnits = ['year', 'ordinal', 'hour', 'minute', 'second', 'millisecond'];

// standardize case and plurality in units
function normalizeUnit(unit) {
  var ignoreUnknown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var normalized = {
    year: 'year',
    years: 'year',
    month: 'month',
    months: 'month',
    day: 'day',
    days: 'day',
    hour: 'hour',
    hours: 'hour',
    minute: 'minute',
    minutes: 'minute',
    second: 'second',
    seconds: 'second',
    millisecond: 'millisecond',
    milliseconds: 'millisecond',
    weekday: 'weekday',
    weekdays: 'weekday',
    weeknumber: 'weekNumber',
    weeksnumber: 'weekNumber',
    weeknumbers: 'weekNumber',
    weekyear: 'weekYear',
    weekyears: 'weekYear',
    ordinal: 'ordinal'
  }[unit ? unit.toLowerCase() : unit];

  if (!ignoreUnknown && !normalized) throw new InvalidUnitError(unit);

  return normalized;
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, zone) {
  // assume we have the higher-order units
  for (var _iterator = orderedUnits$1, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var u = _ref2;

    if (isUndefined(obj[u])) {
      obj[u] = defaultUnitValues[u];
    }
  }

  var invalidReason = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
  if (invalidReason) {
    return DateTime.invalid(invalidReason);
  }

  var tsNow = Settings.now(),
      offsetProvis = zone.offset(tsNow),
      _objToTS = objToTS(obj, offsetProvis, zone),
      ts = _objToTS[0],
      o = _objToTS[1];


  return new DateTime({
    ts: ts,
    zone: zone,
    o: o
  });
}

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link valueOf} and {@link toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */

var DateTime = function () {
  /**
   * @access private
   */
  function DateTime(config) {
    classCallCheck(this, DateTime);

    var zone = config.zone || Settings.defaultZone,
        invalidReason = config.invalidReason || (Number.isNaN(config.ts) ? INVALID_INPUT : null) || (!zone.isValid ? UNSUPPORTED_ZONE : null);
    /**
     * @access private
     */
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;

    var c = null,
        o = null;
    if (!invalidReason) {
      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      c = unchanged ? config.old.c : tsToObj(this.ts, zone.offset(this.ts));
      o = unchanged ? config.old.o : zone.offset(this.ts);
    }

    /**
     * @access private
     */
    this.zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.invalid = invalidReason;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
  }

  // CONSTRUCT

  /**
   * Create a local DateTime
   * @param {number} year - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, i.e. a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, i.e. a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, i.e. a number between 0 and 999
   * @example DateTime.local()                            //~> now
   * @example DateTime.local(2017)                        //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                     //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12)                 //~> 2017-03-12T00:00:00
   * @example DateTime.local(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */


  DateTime.local = function local(year, month, day, hour, minute, second, millisecond) {
    if (isUndefined(year)) {
      return new DateTime({ ts: Settings.now() });
    } else {
      return quickDT({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        millisecond: millisecond
      }, Settings.defaultZone);
    }
  };

  /**
   * Create a DateTime in UTC
   * @param {number} year - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, i.e. a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, i.e. a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, i.e. a number between 0 and 999
   * @example DateTime.utc()                            //~> now
   * @example DateTime.utc(2017)                        //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                     //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                 //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765Z
   * @return {DateTime}
   */


  DateTime.utc = function utc(year, month, day, hour, minute, second, millisecond) {
    if (isUndefined(year)) {
      return new DateTime({
        ts: Settings.now(),
        zone: FixedOffsetZone.utcInstance
      });
    } else {
      return quickDT({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        millisecond: millisecond
      }, FixedOffsetZone.utcInstance);
    }
  };

  /**
   * Create an DateTime from a Javascript Date object. Uses the default zone.
   * @param {Date} date - a Javascript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */


  DateTime.fromJSDate = function fromJSDate(date) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new DateTime({
      ts: isDate(date) ? date.valueOf() : NaN,
      zone: normalizeZone(options.zone, Settings.defaultZone),
      loc: Locale.fromObject(options)
    });
  };

  /**
   * Create an DateTime from a count of epoch milliseconds. Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */


  DateTime.fromMillis = function fromMillis(milliseconds) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new DateTime({
      ts: milliseconds,
      zone: normalizeZone(options.zone, Settings.defaultZone),
      loc: Locale.fromObject(options)
    });
  };

  /**
   * Create an DateTime from a Javascript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {string|Zone} [obj.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [obj.locale='en-US'] - a locale to set on the resulting DateTime instance
   * @param {string} obj.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} obj.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01T00'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */


  DateTime.fromObject = function fromObject(obj) {
    var zoneToUse = normalizeZone(obj.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(UNSUPPORTED_ZONE);
    }

    var tsNow = Settings.now(),
        offsetProvis = zoneToUse.offset(tsNow),
        normalized = normalizeObject(obj, normalizeUnit, true),
        containsOrdinal = !isUndefined(normalized.ordinal),
        containsGregorYear = !isUndefined(normalized.year),
        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
        containsGregor = containsGregorYear || containsGregorMD,
        definiteWeekDef = normalized.weekYear || normalized.weekNumber,
        loc = Locale.fromObject(obj);

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;

    // configure ourselves to deal with gregorian dates or week stuff
    var units = void 0,
        defaultValues = void 0,
        objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits$1;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    var foundFirst = false;
    for (var _iterator2 = units, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var u = _ref3;

      var v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
        invalidReason = higherOrderInvalid || hasInvalidTimeData(normalized);

    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    }

    // compute the actual time
    var gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
        _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
        tsFinal = _objToTS2[0],
        offsetFinal = _objToTS2[1],
        inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc: loc
    });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid('mismatched weekday');
    }

    return inst;
  };

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */


  DateTime.fromISO = function fromISO(text) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _parseISODate = parseISODate(text),
        vals = _parseISODate[0],
        parsedZone = _parseISODate[1];

    return parseDataToDateTime(vals, parsedZone, opts);
  };

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Tue, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */


  DateTime.fromRFC2822 = function fromRFC2822(text) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _parseRFC2822Date = parseRFC2822Date(text),
        vals = _parseRFC2822Date[0],
        parsedZone = _parseRFC2822Date[1];

    return parseDataToDateTime(vals, parsedZone, opts);
  };

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} options - options to affect the creation
   * @param {string|Zone} [options.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [options.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [options.locale='en-US'] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */


  DateTime.fromHTTP = function fromHTTP(text) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _parseHTTPDate = parseHTTPDate(text),
        vals = _parseHTTPDate[0],
        parsedZone = _parseHTTPDate[1];

    return parseDataToDateTime(vals, parsedZone, options);
  };

  /**
   * Create a DateTime from an input string and format string
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options to affect the creation
   * @param {string|Zone} [options.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [options.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [options.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} options.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */


  DateTime.fromFormat = function fromFormat(text, fmt) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError('fromFormat requires an input string and a format');
    }

    var _options$locale = options.locale,
        locale = _options$locale === undefined ? null : _options$locale,
        _options$numberingSys = options.numberingSystem,
        numberingSystem = _options$numberingSys === undefined ? null : _options$numberingSys,
        localeToUse = Locale.fromOpts({ locale: locale, numberingSystem: numberingSystem, defaultToEN: true }),
        _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
        vals = _parseFromTokens[0],
        parsedZone = _parseFromTokens[1],
        invalidReason = _parseFromTokens[2];

    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(vals, parsedZone, options);
    }
  };

  /**
   * @deprecated use fromFormat instead
   */


  DateTime.fromString = function fromString(text, fmt) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return DateTime.fromFormat(text, fmt, opts);
  };

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} options - options to affect the creation
   * @param {string|Zone} [options.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [options.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [options.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} options.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */


  DateTime.fromSQL = function fromSQL(text) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _parseSQL = parseSQL(text),
        vals = _parseSQL[0],
        parsedZone = _parseSQL[1];

    return parseDataToDateTime(vals, parsedZone, options);
  };

  /**
   * Create an invalid DateTime.
   * @return {DateTime}
   */


  DateTime.invalid = function invalid(reason) {
    if (!reason) {
      throw new InvalidArgumentError('need to specify a reason the DateTime is invalid');
    }
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(reason);
    } else {
      return new DateTime({ invalidReason: reason });
    }
  };

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */


  DateTime.prototype.get = function get$$1(unit) {
    return this[unit];
  };

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */


  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  DateTime.prototype.resolvedLocaleOpts = function resolvedLocaleOpts() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
        locale = _Formatter$create$res.locale,
        numberingSystem = _Formatter$create$res.numberingSystem,
        calendar = _Formatter$create$res.calendar;

    return { locale: locale, numberingSystem: numberingSystem, outputCalendar: calendar };
  };

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */


  DateTime.prototype.toUTC = function toUTC() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return this.setZone(FixedOffsetZone.instance(offset), opts);
  };

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */


  DateTime.prototype.toLocal = function toLocal() {
    return this.setZone(new LocalZone());
  };

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same UTC timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link plus}. You may wish to use {@link toLocal} and {@link toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'utc+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */


  DateTime.prototype.setZone = function setZone(zone) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$keepLocalTime = _ref4.keepLocalTime,
        keepLocalTime = _ref4$keepLocalTime === undefined ? false : _ref4$keepLocalTime,
        _ref4$keepCalendarTim = _ref4.keepCalendarTime,
        keepCalendarTime = _ref4$keepCalendarTim === undefined ? false : _ref4$keepCalendarTim;

    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(UNSUPPORTED_ZONE);
    } else {
      var newTS = keepLocalTime || keepCalendarTime // keepCalendarTime is the deprecated name for keepLocalTime
      ? this.ts + (this.o - zone.offset(this.ts)) * 60 * 1000 : this.ts;
      return clone$1(this, { ts: newTS, zone: zone });
    }
  };

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */


  DateTime.prototype.reconfigure = function reconfigure() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        locale = _ref5.locale,
        numberingSystem = _ref5.numberingSystem,
        outputCalendar = _ref5.outputCalendar;

    var loc = this.loc.clone({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar });
    return clone$1(this, { loc: loc });
  };

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */


  DateTime.prototype.setLocale = function setLocale(locale) {
    return this.reconfigure({ locale: locale });
  };

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link reconfigure} and {@link setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */


  DateTime.prototype.set = function set$$1(values) {
    if (!this.isValid) return this;

    var normalized = normalizeObject(values, normalizeUnit),
        settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday);

    var mixed = void 0;
    if (settingWeekStuff) {
      mixed = weekToGregorian(Object.assign(gregorianToWeek(this.c), normalized));
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(Object.assign(gregorianToOrdinal(this.c), normalized));
    } else {
      mixed = Object.assign(this.toObject(), normalized);

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }

    var _objToTS3 = objToTS(mixed, this.o, this.zone),
        ts = _objToTS3[0],
        o = _objToTS3[1];

    return clone$1(this, { ts: ts, o: o });
  };

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.local().plus(123) //~> in 123 milliseconds
   * @example DateTime.local().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.local().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.local().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.local().plus({ hours: 3, minutes: 13 }) //~> in 1 hr, 13 min
   * @example DateTime.local().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 1 hr, 13 min
   * @return {DateTime}
   */


  DateTime.prototype.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration);
    return clone$1(this, adjustTime(this, dur));
  };

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
  */


  DateTime.prototype.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration).negate();
    return clone$1(this, adjustTime(this, dur));
  };

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'month', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */


  DateTime.prototype.startOf = function startOf(unit) {
    if (!this.isValid) return this;
    var o = {},
        normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case 'years':
        o.month = 1;
      // falls through
      case 'quarters':
      case 'months':
        o.day = 1;
      // falls through
      case 'weeks':
      case 'days':
        o.hour = 0;
      // falls through
      case 'hours':
        o.minute = 0;
      // falls through
      case 'minutes':
        o.second = 0;
      // falls through
      case 'seconds':
        o.millisecond = 0;
        break;
      case 'milliseconds':
        break;
      default:
        throw new InvalidUnitError(unit);
    }

    if (normalizedUnit === 'weeks') {
      o.weekday = 1;
    }

    if (normalizedUnit === 'quarters') {
      var q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  };

  /**
   * "Set" this DateTime to the end (i.e. the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'month', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */


  DateTime.prototype.endOf = function endOf(unit) {
    var _startOf$plus;

    return this.isValid ? this.startOf(unit).plus((_startOf$plus = {}, _startOf$plus[unit] = 1, _startOf$plus)).minus(1) : this;
  };

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link toLocaleString} for a more flexible formatting tool. See the documentation for the specific format tokens supported.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} opts.round - round numerical values
   * @example DateTime.local().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.local().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.local().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */


  DateTime.prototype.toFormat = function toFormat(fmt) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return this.isValid ? Formatter.create(this.loc.redefaultToEN(), opts).formatDateTimeFromString(this, fmt) : INVALID$2;
  };

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation.
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param opts {Object} - Intl.DateTimeFormat constructor options
   * @example DateTime.local().toLocaleString(); //=> 4/20/2017
   * @example DateTime.local().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.local().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.local().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.local().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.local().toLocaleString({weekday: 'long', month: 'long', day: '2-digit'}); //=> 'Thu, Apr 20'
   * @example DateTime.local().toLocaleString({weekday: 'long', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit'}); //=> 'Thu, Apr 20, 11:27'
   * @example DateTime.local().toLocaleString({hour: '2-digit', minute: '2-digit'}); //=> '11:32'
   * @return {string}
   */


  DateTime.prototype.toLocaleString = function toLocaleString() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DATE_SHORT;

    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : INVALID$2;
  };

  /**
   * Returns an array of format "parts", i.e. individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.local().toLocaleString(); //=> [
   *                                    //=>   { type: 'day', value: '25' },
   *                                    //=>   { type: 'literal', value: '/' },
   *                                    //=>   { type: 'month', value: '05' },
   *                                    //=>   { type: 'literal', value: '/' },
   *                                    //=>   { type: 'year', value: '1982' }
   *                                    //=> ]
   */


  DateTime.prototype.toLocaleParts = function toLocaleParts() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  };

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.local().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.local().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @return {string}
   */


  DateTime.prototype.toISO = function toISO() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!this.isValid) {
      return null;
    }

    return this.toISODate() + 'T' + this.toISOTime(opts);
  };

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @return {string}
   */


  DateTime.prototype.toISODate = function toISODate() {
    return toTechFormat(this, 'yyyy-MM-dd');
  };

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */


  DateTime.prototype.toISOWeekDate = function toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  };

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc().hour(7).minute(34).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().hour(7).minute(34).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @return {string}
   */


  DateTime.prototype.toISOTime = function toISOTime() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref6$suppressMillise = _ref6.suppressMilliseconds,
        suppressMilliseconds = _ref6$suppressMillise === undefined ? false : _ref6$suppressMillise,
        _ref6$suppressSeconds = _ref6.suppressSeconds,
        suppressSeconds = _ref6$suppressSeconds === undefined ? false : _ref6$suppressSeconds,
        _ref6$includeOffset = _ref6.includeOffset,
        includeOffset = _ref6$includeOffset === undefined ? true : _ref6$includeOffset;

    return toTechTimeFormat(this, { suppressSeconds: suppressSeconds, suppressMilliseconds: suppressMilliseconds, includeOffset: includeOffset });
  };

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */


  DateTime.prototype.toRFC2822 = function toRFC2822() {
    return toTechFormat(this, 'EEE, dd LLL yyyy hh:mm:ss ZZZ');
  };

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */


  DateTime.prototype.toHTTP = function toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  };

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */


  DateTime.prototype.toSQLDate = function toSQLDate() {
    return toTechFormat(this, 'yyyy-MM-dd');
  };

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.local().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.local().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.local().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */


  DateTime.prototype.toSQLTime = function toSQLTime() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$includeOffset = _ref7.includeOffset,
        includeOffset = _ref7$includeOffset === undefined ? true : _ref7$includeOffset,
        _ref7$includeZone = _ref7.includeZone,
        includeZone = _ref7$includeZone === undefined ? false : _ref7$includeZone;

    return toTechTimeFormat(this, { includeOffset: includeOffset, includeZone: includeZone, spaceZone: true });
  };

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: false }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */


  DateTime.prototype.toSQL = function toSQL() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!this.isValid) {
      return null;
    }

    return this.toSQLDate() + ' ' + this.toSQLTime(opts);
  };

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */


  DateTime.prototype.toString = function toString() {
    return this.isValid ? this.toISO() : INVALID$2;
  };

  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */


  DateTime.prototype.inspect = function inspect() {
    if (this.isValid) {
      return 'DateTime {\n  ts: ' + this.toISO() + ',\n  zone: ' + this.zone.name + ',\n  locale: ' + this.locale + ' }';
    } else {
      return 'DateTime { Invalid, reason: ' + this.invalidReason + ' }';
    }
  };

  /**
   * Returns the epoch milliseconds of this DateTime
   * @return {number}
   */


  DateTime.prototype.valueOf = function valueOf() {
    return this.isValid ? this.ts : NaN;
  };

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link valueOf}
   * @return {number}
   */


  DateTime.prototype.toMillis = function toMillis() {
    return this.valueOf();
  };

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */


  DateTime.prototype.toJSON = function toJSON() {
    return this.toISO();
  };

  /**
   * Returns a Javascript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.local().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */


  DateTime.prototype.toObject = function toObject() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!this.isValid) return {};

    var base = Object.assign({}, this.c);

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  };

  /**
   * Returns a Javascript Date equivalent to this DateTime.
   * @return {Date}
   */


  DateTime.prototype.toJSDate = function toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  };

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */


  DateTime.prototype.diff = function diff(otherDateTime) {
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'milliseconds';
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!this.isValid || !otherDateTime.isValid) return Duration.invalid(this.invalidReason || otherDateTime.invalidReason);

    var units = maybeArray(unit).map(Duration.normalizeUnit),
        otherIsLater = otherDateTime.valueOf() > this.valueOf(),
        earlier = otherIsLater ? this : otherDateTime,
        later = otherIsLater ? otherDateTime : this,
        diffed = _diff(earlier, later, units, opts);

    return otherIsLater ? diffed.negate() : diffed;
  };

  /**
   * Return the difference between this DateTime and right now.
   * See {@link diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */


  DateTime.prototype.diffNow = function diffNow() {
    var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'milliseconds';
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return this.diff(DateTime.local(), unit, opts);
  };

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */


  DateTime.prototype.until = function until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  };

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.local().hasSame(otherDT, 'day'); //~> true if both the same calendar day
   * @return {boolean}
   */


  DateTime.prototype.hasSame = function hasSame(otherDateTime, unit) {
    if (!this.isValid) return false;
    if (unit === 'millisecond') {
      return this.valueOf() === otherDateTime.valueOf();
    } else {
      var inputMs = otherDateTime.valueOf();
      return this.startOf(unit) <= inputMs && inputMs <= this.endOf(unit);
    }
  };

  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */


  DateTime.prototype.equals = function equals(other) {
    return this.isValid && other.isValid ? this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc) : false;
  };

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */


  DateTime.min = function min() {
    for (var _len = arguments.length, dateTimes = Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }

    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.min);
  };

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */


  DateTime.max = function max() {
    for (var _len2 = arguments.length, dateTimes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      dateTimes[_key2] = arguments[_key2];
    }

    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.max);
  };

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */


  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$locale2 = options.locale,
        locale = _options$locale2 === undefined ? null : _options$locale2,
        _options$numberingSys2 = options.numberingSystem,
        numberingSystem = _options$numberingSys2 === undefined ? null : _options$numberingSys2,
        localeToUse = Locale.fromOpts({ locale: locale, numberingSystem: numberingSystem, defaultToEN: true });

    return explainFromTokens(localeToUse, text, fmt);
  };

  /**
   * @deprecated use fromFormatExplain instead
   */


  DateTime.fromStringExplain = function fromStringExplain(text, fmt) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return DateTime.fromFormatExplain(text, fmt, options);
  };

  // FORMAT PRESETS

  /**
   * {@link toLocaleString} format like 10/14/1983
   * @type {Object}
   */


  createClass(DateTime, [{
    key: 'isValid',
    get: function get$$1() {
      return this.invalidReason === null;
    }

    /**
     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: 'invalidReason',
    get: function get$$1() {
      return this.invalid;
    }

    /**
     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: 'locale',
    get: function get$$1() {
      return this.isValid ? this.loc.locale : null;
    }

    /**
     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: 'numberingSystem',
    get: function get$$1() {
      return this.isValid ? this.loc.numberingSystem : null;
    }

    /**
     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: 'outputCalendar',
    get: function get$$1() {
      return this.isValid ? this.loc.outputCalendar : null;
    }

    /**
     * Get the name of the time zone.
     * @type {string}
     */

  }, {
    key: 'zoneName',
    get: function get$$1() {
      return this.isValid ? this.zone.name : null;
    }

    /**
     * Get the year
     * @example DateTime.local(2017, 5, 25).year //=> 2017
     * @type {number}
     */

  }, {
    key: 'year',
    get: function get$$1() {
      return this.isValid ? this.c.year : NaN;
    }

    /**
     * Get the quarter
     * @example DateTime.local(2017, 5, 25).quarter //=> 2
     * @type {number}
     */

  }, {
    key: 'quarter',
    get: function get$$1() {
      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
     * Get the month (1-12).
     * @example DateTime.local(2017, 5, 25).month //=> 5
     * @type {number}
     */

  }, {
    key: 'month',
    get: function get$$1() {
      return this.isValid ? this.c.month : NaN;
    }

    /**
     * Get the day of the month (1-30ish).
     * @example DateTime.local(2017, 5, 25).day //=> 25
     * @type {number}
     */

  }, {
    key: 'day',
    get: function get$$1() {
      return this.isValid ? this.c.day : NaN;
    }

    /**
     * Get the hour of the day (0-23).
     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
     * @type {number}
     */

  }, {
    key: 'hour',
    get: function get$$1() {
      return this.isValid ? this.c.hour : NaN;
    }

    /**
     * Get the minute of the hour (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
     * @type {number}
     */

  }, {
    key: 'minute',
    get: function get$$1() {
      return this.isValid ? this.c.minute : NaN;
    }

    /**
     * Get the second of the minute (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
     * @type {number}
     */

  }, {
    key: 'second',
    get: function get$$1() {
      return this.isValid ? this.c.second : NaN;
    }

    /**
     * Get the millisecond of the second (0-999).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
     * @type {number}
     */

  }, {
    key: 'millisecond',
    get: function get$$1() {
      return this.isValid ? this.c.millisecond : NaN;
    }

    /**
     * Get the week year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekYear //=> 2015
     * @type {number}
     */

  }, {
    key: 'weekYear',
    get: function get$$1() {
      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }

    /**
     * Get the week number of the week year (1-52ish).
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
     * @type {number}
     */

  }, {
    key: 'weekNumber',
    get: function get$$1() {
      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }

    /**
     * Get the day of the week.
     * 1 is Monday and 7 is Sunday
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekday //=> 4
     * @type {number}
     */

  }, {
    key: 'weekday',
    get: function get$$1() {
      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }

    /**
     * Get the ordinal (i.e. the day of the year)
     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
     * @type {number|DateTime}
     */

  }, {
    key: 'ordinal',
    get: function get$$1() {
      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }

    /**
     * Get the human readable short month name, such as 'Oct'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
     * @type {string}
     */

  }, {
    key: 'monthShort',
    get: function get$$1() {
      return this.isValid ? Info.months('short', { locale: this.locale })[this.month - 1] : null;
    }

    /**
     * Get the human readable long month name, such as 'October'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthLong //=> October
     * @type {string}
     */

  }, {
    key: 'monthLong',
    get: function get$$1() {
      return this.isValid ? Info.months('long', { locale: this.locale })[this.month - 1] : null;
    }

    /**
     * Get the human readable short weekday, such as 'Mon'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
     * @type {string}
     */

  }, {
    key: 'weekdayShort',
    get: function get$$1() {
      return this.isValid ? Info.weekdays('short', { locale: this.locale })[this.weekday - 1] : null;
    }

    /**
     * Get the human readable long weekday, such as 'Monday'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
     * @type {string}
     */

  }, {
    key: 'weekdayLong',
    get: function get$$1() {
      return this.isValid ? Info.weekdays('long', { locale: this.locale })[this.weekday - 1] : null;
    }

    /**
     * Get the UTC offset of this DateTime in minutes
     * @example DateTime.local().offset //=> -240
     * @example DateTime.utc().offset //=> 0
     * @type {number}
     */

  }, {
    key: 'offset',
    get: function get$$1() {
      return this.isValid ? this.zone.offset(this.ts) : NaN;
    }

    /**
     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: 'offsetNameShort',
    get: function get$$1() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: 'short',
          locale: this.locale
        });
      } else {
        return null;
      }
    }

    /**
     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: 'offsetNameLong',
    get: function get$$1() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: 'long',
          locale: this.locale
        });
      } else {
        return null;
      }
    }

    /**
     * Get whether this zone's offset ever changes, as in a DST.
     * @type {boolean}
     */

  }, {
    key: 'isOffsetFixed',
    get: function get$$1() {
      return this.isValid ? this.zone.universal : null;
    }

    /**
     * Get whether the DateTime is in a DST.
     * @type {boolean}
     */

  }, {
    key: 'isInDST',
    get: function get$$1() {
      if (this.isOffsetFixed) {
        return false;
      } else {
        return this.offset > this.set({ month: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
      }
    }

    /**
     * Returns true if this DateTime is in a leap year, false otherwise
     * @example DateTime.local(2016).isInLeapYear //=> true
     * @example DateTime.local(2013).isInLeapYear //=> false
     * @type {boolean}
     */

  }, {
    key: 'isInLeapYear',
    get: function get$$1() {
      return isLeapYear(this.year);
    }

    /**
     * Returns the number of days in this DateTime's month
     * @example DateTime.local(2016, 2).daysInMonth //=> 29
     * @example DateTime.local(2016, 3).daysInMonth //=> 31
     * @type {number}
     */

  }, {
    key: 'daysInMonth',
    get: function get$$1() {
      return daysInMonth(this.year, this.month);
    }

    /**
     * Returns the number of days in this DateTime's year
     * @example DateTime.local(2016).daysInYear //=> 366
     * @example DateTime.local(2013).daysInYear //=> 365
     * @type {number}
     */

  }, {
    key: 'daysInYear',
    get: function get$$1() {
      return this.isValid ? daysInYear(this.year) : NaN;
    }

    /**
     * Returns the number of weeks in this DateTime's year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2004).weeksInWeekYear //=> 53
     * @example DateTime.local(2013).weeksInWeekYear //=> 52
     * @type {number}
     */

  }, {
    key: 'weeksInWeekYear',
    get: function get$$1() {
      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }
  }], [{
    key: 'DATE_SHORT',
    get: function get$$1() {
      return DATE_SHORT;
    }

    /**
     * {@link toLocaleString} format like 'Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: 'DATE_MED',
    get: function get$$1() {
      return DATE_MED;
    }

    /**
     * {@link toLocaleString} format like 'October 14, 1983'
     * @type {Object}
     */

  }, {
    key: 'DATE_FULL',
    get: function get$$1() {
      return DATE_FULL;
    }

    /**
     * {@link toLocaleString} format like 'Tuesday, October 14, 1983'
     * @type {Object}
     */

  }, {
    key: 'DATE_HUGE',
    get: function get$$1() {
      return DATE_HUGE;
    }

    /**
     * {@link toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'TIME_SIMPLE',
    get: function get$$1() {
      return TIME_SIMPLE;
    }

    /**
     * {@link toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'TIME_WITH_SECONDS',
    get: function get$$1() {
      return TIME_WITH_SECONDS;
    }

    /**
     * {@link toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'TIME_WITH_SHORT_OFFSET',
    get: function get$$1() {
      return TIME_WITH_SHORT_OFFSET;
    }

    /**
     * {@link toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'TIME_WITH_LONG_OFFSET',
    get: function get$$1() {
      return TIME_WITH_LONG_OFFSET;
    }

    /**
     * {@link toLocaleString} format like '09:30', always 24-hour.
     * @type {Object}
     */

  }, {
    key: 'TIME_24_SIMPLE',
    get: function get$$1() {
      return TIME_24_SIMPLE;
    }

    /**
     * {@link toLocaleString} format like '09:30:23', always 24-hour.
     * @type {Object}
     */

  }, {
    key: 'TIME_24_WITH_SECONDS',
    get: function get$$1() {
      return TIME_24_WITH_SECONDS;
    }

    /**
     * {@link toLocaleString} format like '09:30:23 EDT', always 24-hour.
     * @type {Object}
     */

  }, {
    key: 'TIME_24_WITH_SHORT_OFFSET',
    get: function get$$1() {
      return TIME_24_WITH_SHORT_OFFSET;
    }

    /**
     * {@link toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
     * @type {Object}
     */

  }, {
    key: 'TIME_24_WITH_LONG_OFFSET',
    get: function get$$1() {
      return TIME_24_WITH_LONG_OFFSET;
    }

    /**
     * {@link toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'DATETIME_SHORT',
    get: function get$$1() {
      return DATETIME_SHORT;
    }

    /**
     * {@link toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'DATETIME_SHORT_WITH_SECONDS',
    get: function get$$1() {
      return DATETIME_SHORT_WITH_SECONDS;
    }

    /**
     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'DATETIME_MED',
    get: function get$$1() {
      return DATETIME_MED;
    }

    /**
     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'DATETIME_MED_WITH_SECONDS',
    get: function get$$1() {
      return DATETIME_MED_WITH_SECONDS;
    }

    /**
     * {@link toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'DATETIME_FULL',
    get: function get$$1() {
      return DATETIME_FULL;
    }

    /**
     * {@link toLocaleString} format like 'October 14, 1983, 9:303 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'DATETIME_FULL_WITH_SECONDS',
    get: function get$$1() {
      return DATETIME_FULL_WITH_SECONDS;
    }

    /**
     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'DATETIME_HUGE',
    get: function get$$1() {
      return DATETIME_HUGE;
    }

    /**
     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: 'DATETIME_HUGE_WITH_SECONDS',
    get: function get$$1() {
      return DATETIME_HUGE_WITH_SECONDS;
    }
  }]);
  return DateTime;
}();
function friendlyDateTime(dateTimeish) {
  if (dateTimeish instanceof DateTime) {
    return dateTimeish;
  } else if (dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish instanceof Object) {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError('Unknown datetime argument');
  }
}

exports.DateTime = DateTime;
exports.Duration = Duration;
exports.Interval = Interval;
exports.Info = Info;
exports.Zone = Zone;
exports.FixedOffsetZone = FixedOffsetZone;
exports.IANAZone = IANAZone;
exports.LocalZone = LocalZone;
exports.Settings = Settings;
//# sourceMappingURL=luxon.js.map


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UnexpectedError=function(_Component){_inherits(UnexpectedError,_Component);function UnexpectedError(){_classCallCheck(this,UnexpectedError);return _possibleConstructorReturn(this,(UnexpectedError.__proto__||Object.getPrototypeOf(UnexpectedError)).apply(this,arguments));}_createClass(UnexpectedError,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{className:'UnexpectedError__alert',color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'state.unexpectedError',defaultMessage:'An unexpected error happened. Please try to reload the page. If the error persists try again later.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',className:'UnexpectedError__button',onClick:function onClick(){return window.location.reload();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'site.reloadPage',defaultMessage:'Reload page'})));}}]);return UnexpectedError;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UnexpectedError);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductClassType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductClass={SINGLE:'SINGLE',MULTI:'MULTI',COLLECTION:'COLLECTION',MULTI_CHILD:'MULTI_CHILD'};/* harmony default export */ __webpack_exports__["b"] = (ProductClass);var ProductClassType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductClass',Object.values(ProductClass));

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = parseLanguageCode;
/* harmony export (immutable) */ __webpack_exports__["f"] = parseHash;
/* harmony export (immutable) */ __webpack_exports__["e"] = isNotHandledByReactRouter;
/* harmony export (immutable) */ __webpack_exports__["i"] = stripHostIfMatches;
/* harmony export (immutable) */ __webpack_exports__["d"] = fixPercentDecodingForParam;
/* harmony export (immutable) */ __webpack_exports__["b"] = escapeUrlForPaginatorTemplate;
/* harmony export (immutable) */ __webpack_exports__["c"] = escapeUrlParametersForPaginatorTemplate;
/* harmony export (immutable) */ __webpack_exports__["h"] = pathFragmentMatchesLocation;
/* harmony export (immutable) */ __webpack_exports__["l"] = transformInternalLink;
/* harmony export (immutable) */ __webpack_exports__["k"] = transformExternalLink;
/* harmony export (immutable) */ __webpack_exports__["j"] = transformDomainToUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = domainMatchesUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_url__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_is_url__);
/**
 * Tries to parse the given path for a two letter language code.
 * Whitelists valid ISO-639-1 codes.
 *
 * @param path
 * @returns {null|string} 2 letters from the first part of the path, if exists.
 */function parseLanguageCode(path){var pathMatches=path.match(/^\/(ab|aa|af|ak|sq|am|ar|an|hy|as|av|ae|ay|az|bm|ba|eu|be|bn|bh|bi|bs|br|bg|my|ca|km|ch|ce|ny|zh|cu|cv|kw|co|cr|hr|cs|da|dv|nl|dz|en|eo|et|ee|fo|fj|fi|fr|ff|gd|gl|lg|ka|de|ki|el|kl|gn|gu|ht|ha|he|hz|hi|ho|hu|is|io|ig|id|ia|ie|iu|ik|ga|it|ja|jv|kn|kr|ks|kk|rw|kv|kg|ko|kj|ku|ky|lo|la|lv|lb|li|ln|lt|lu|mk|mg|ms|ml|mt|gv|mi|mr|mh|ro|mn|na|nv|nd|ng|ne|se|no|nb|nn|ii|oc|oj|or|om|os|pi|pa|ps|fa|pl|pt|qu|rm|rn|ru|sm|sg|sa|sc|sr|sn|sd|si|sk|sl|so|st|nr|es|su|sw|ss|sv|tl|ty|tg|ta|tt|te|th|bo|ti|to|ts|tn|tr|tk|tw|ug|uk|ur|uz|ve|vi|vo|wa|cy|fy|wo|xh|yi|yo|za|zu|)\/.*$/);return pathMatches&&pathMatches[1];}function parseHash(hash){if(hash.charAt(0)==='#'){// Hash includes the hashtag (#), strip it off.
return hash.substring(1);}return hash;}function isNotHandledByReactRouter(urlOrPath){if(!urlOrPath||!__WEBPACK_IMPORTED_MODULE_0_lodash_isString___default()(urlOrPath)){return false;}// Special protocols
if(/^(mailto|tel):/.test(urlOrPath)){return true;}// Checkout and My account use old Netstore URLs
if(/\/(kauppa|shop|butik)\/[^/]+\/\d+\/?/.test(urlOrPath)){return true;}var isUri=__WEBPACK_IMPORTED_MODULE_1_is_url___default()(urlOrPath);if(!isUri){// Paths to files (E.g. /path/to/file/name.json)
if(/.+\.[a-zA-Z]+(\?.*)?$/.test(urlOrPath)){return true;}}return isUri;}function stripHostIfMatches(url,host){return String(url).replace(new RegExp('(http|https)*:?\\/\\/'+host),'');}function fixPercentDecodingForParam(param){if(typeof param!=='string'){return param;}return param.replace(/%26/gi,'&').replace(/%3F/gi,'?').replace(/%23/gi,'#').replace(/%2B/gi,'+').replace(/%3B/gi,';').replace(/%2C/gi,',').replace(/%2F/gi,'/').replace(/%3A/gi,':').replace(/%40/gi,'@').replace(/%3D/gi,'=').replace(/%24/gi,'$');}function escapeUrlForPaginatorTemplate(url){// The slugs provided by the backend may contain special characters that need to be escaped
// so that they are handled correctly by the paginator template.
return url.replace(/\(/gi,'%28').replace(/\)/gi,'%29').replace(/\*/gi,'%2A').replace(/:/gi,'%3A');}function escapeUrlParametersForPaginatorTemplate(url){// The parameters provided by search engine bots may contain special characters that need to be escaped
// so that they are handled correctly by the paginator template.
return escapeUrlForPaginatorTemplate(url.replace(/\//gi,'%2F'));}function pathFragmentMatchesLocation(fragment,location){var decodedLocation='';try{// Test location for properly formatted URI.
// decodeURI() may return error "URI malformed" as the product data contains illegal characters.
// Return match in these cases.
decodedLocation=decodeURI(location);}catch(error){return true;}return decodedLocation.endsWith(decodeURI(fragment));}function transformInternalLink(path){return path.charAt(0)==='/'?path:'/'+path;}function transformExternalLink(path){if(/^https?:\/\//.test(path)||/^\/\//.test(path)){return path;}return'//'+path;}function transformDomainToUrl(domain){return domain.length>0?'https://'+domain+'/':'';}function domainMatchesUrl(domain,url){return url.includes(domain);}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_split__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniq__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_ProductSearchPaginator__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_createMSTPatch__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_Error__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_ProductSortOrderByMap__ = __webpack_require__(1024);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var LAST_VISITED_PRODUCTS_KEY='nh_last_visited_products';var ProductStore=__WEBPACK_IMPORTED_MODULE_13__models_StatefulStore__["a" /* default */].named('ProductStore').props({selectedProductColumn:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].string),selectedProductRow:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].string),productQueryResults:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_10__models_ProductSearchPaginator__["a" /* default */]),{}),productQueryStates:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["a" /* RequestStateType */]),{}),products:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]),{}),productStates:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["a" /* RequestStateType */]),{}),productSortOptions:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].frozen(__WEBPACK_IMPORTED_MODULE_16__types_ProductSortOrderByMap__["a" /* default */]),productVariationColumn:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].string),productVariationRow:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].string),uploadedFiles:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].model({id:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].string,files:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].string)})),[]),uploadedFilesError:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_14__models_Error__["a" /* default */]),uploadedFilesState:__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].NONE)}).actions(function(self){var baseApi=function baseApi(endpoint){return ifShoppingCenter()?'shopping-center/'+endpoint:''+endpoint;};var ifShoppingCenter=function ifShoppingCenter(){return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["g" /* getRoot */])(self).configStore.siteConfig.isShoppingCenter;};var activeProductSortOptions=function activeProductSortOptions(){return __WEBPACK_IMPORTED_MODULE_1_lodash_split___default()(Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["g" /* getRoot */])(self).configStore.productList.productListSortSelectors,',');};var customerGroupId=function customerGroupId(){return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["g" /* getRoot */])(self).accountStore.getCustomerGroupId;};var updateIndividualProducts=function updateIndividualProducts(products){products.forEach(function(product){var identifiersEqual=true;var oldProduct=self.products.get(product.id);if(oldProduct){updateOldProduct(product,oldProduct,identifiersEqual);}else{self.products.set(product.id,product);self.filterByCustomerGroupVisibility(product.id);}self.productStates.set(product.id,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADED);});};var updateOldProduct=function updateOldProduct(product,oldProduct,identifiersEqual){self.filterByCustomerGroupVisibility(oldProduct.id);if(oldProduct.multi&&product.multi&&product.multi.children){identifiersEqual=__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default()(oldProduct.multi.getChildIdentifiers(),product.multi.children.map(function(child){return child.id;}));}if(identifiersEqual){var patch=Object(__WEBPACK_IMPORTED_MODULE_12__util_createMSTPatch__["a" /* default */])(oldProduct,product);Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["a" /* applyPatch */])(oldProduct,patch);}};return{afterCreate:function afterCreate(){self.lastVisitedProducts=self.getLocalStorageLastVisitedIds();// Limit the amount of queries and products in memory.
// "Garbage collect" maximum every 5 seconds
Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["autorun"])(function(){var queryLimit=10;var productLimit=1000;if(self.productQueryResults.size>queryLimit){var queriesToDelete=[];// We use lodash forEach instead of for ... of for IE 11 compatibility
__WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()([].concat(_toConsumableArray(self.productQueryResults.keys())),function(queryKey){queriesToDelete.push(queryKey);var queriesLeft=self.productQueryResults.size-queriesToDelete.length;if(queriesLeft<=queryLimit){return false;//break
}});self.deleteQueries(queriesToDelete);}if(self.products.size>productLimit){var referencedProducts={};self.productQueryResults.forEach(function(productSearchPaginator){productSearchPaginator.data.forEach(function(product){referencedProducts[product.id]=1;});});var productsToDelete=[];// We use lodash forEach instead of for ... of for IE 11 compatibility
__WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()([].concat(_toConsumableArray(self.products.keys())),function(id){if(!referencedProducts[id]){productsToDelete.push(id);}var productsLeft=self.products.size-productsToDelete.length;if(productsLeft<=productLimit){return false;//break
}});self.deleteProducts(productsToDelete);}},{delay:5000});},activeProductSortList:function activeProductSortList(){var activeSortList=activeProductSortOptions();return activeSortList?self.productSortOptions.filter(function(ss){return activeSortList.indexOf(ss.sortIndex.toString())>-1;}):self.productSortOptions[0];},deleteQueries:function deleteQueries(keys){keys.forEach(function(key){self.productQueryResults.delete(key);self.productQueryStates.delete(key);});},deleteProducts:function deleteProducts(ids){ids.forEach(function(id){self.productStates.delete(id);self.products.delete(id);});},filterByCustomerGroupVisibility:function filterByCustomerGroupVisibility(productId){var product=self.products.get(productId);if(product&&product.isMulti()){var children=product.multi.children.filter(function(childProduct){return childProduct.hasCustomerGroupVisibility(customerGroupId());});product.multi.setChildren(children);}},getLocalStorageLastVisitedIds:function getLocalStorageLastVisitedIds(){return JSON.parse(window.localStorage.getItem(LAST_VISITED_PRODUCTS_KEY))||[];},insertLastVisitedProduct:function insertLastVisitedProduct(productId){var localStorageIds=self.getLocalStorageLastVisitedIds();localStorageIds.unshift(productId);var uniqueIds=__WEBPACK_IMPORTED_MODULE_3_lodash_uniq___default()(localStorageIds).slice(0,20);window.localStorage.setItem(LAST_VISITED_PRODUCTS_KEY,JSON.stringify(uniqueIds));self.lastVisitedProducts=uniqueIds;},loadProduct:Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadProduct(id){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var fixedId,product;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadProduct$(_context){while(1){switch(_context.prev=_context.next){case 0:// Backend is case insensitive
// and in case of mix of lowercase / uppercase it will return product with new id.
fixedId=id;self.setLoading(true);self.productStates.set(id,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADING);_context.prev=3;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(baseApi('products')+'/'+id+'?'+Object(__WEBPACK_IMPORTED_MODULE_9__util_queryString__["c" /* stringify */])(params));case 6:product=_context.sent;self.products.set(product.id,product);self.filterByCustomerGroupVisibility(product.id);if(!__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default()(product.id,id)){fixedId=product.id;}_context.next=17;break;case 12:_context.prev=12;_context.t0=_context['catch'](3);self.setError(_context.t0);self.productStates.set(id,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].ERROR);throw _context.t0;case 17:self.setLoading(false);self.productStates.set(fixedId,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADED);return _context.abrupt('return',fixedId);case 20:case'end':return _context.stop();}}},loadProduct,this,[[3,12]]);})),loadProducts:Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadProducts(searchParameters){var allSections=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var overrideUrl=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var queryIdentifier,url,productSearchPaginator,products;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadProducts$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:queryIdentifier=Object(__WEBPACK_IMPORTED_MODULE_11__util_query__["a" /* paramsToQueryIdentifier */])(searchParameters);url=overrideUrl?overrideUrl:baseApi('products');// Skip the API call if we already have the data
if(!self.productQueryStates.get(queryIdentifier)){_context2.next=4;break;}return _context2.abrupt('return');case 4:self.setLoading(true);self.productQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADING);_context2.prev=6;productSearchPaginator=void 0;if(!allSections){_context2.next=14;break;}_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(url+'?'+Object(__WEBPACK_IMPORTED_MODULE_9__util_queryString__["c" /* stringify */])(searchParameters),{},{active_section:null});case 11:productSearchPaginator=_context2.sent;_context2.next=17;break;case 14:_context2.next=16;return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(url+'?'+Object(__WEBPACK_IMPORTED_MODULE_9__util_queryString__["c" /* stringify */])(searchParameters));case 16:productSearchPaginator=_context2.sent;case 17:products=productSearchPaginator.data;// Update individual products and statuses
updateIndividualProducts(products);// Set current query results
self.productQueryResults.set(queryIdentifier,Object.assign({},productSearchPaginator,{data:products.map(function(product){return product.id;})}));_context2.next=27;break;case 22:_context2.prev=22;_context2.t0=_context2['catch'](6);self.setError(_context2.t0);self.productQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].ERROR);throw _context2.t0;case 27:self.setLoading(false);self.productQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADED);case 29:case'end':return _context2.stop();}}},loadProducts,this,[[6,22]]);})),updateProduct:function updateProduct(product){self.products.set(product.id,product);self.filterByCustomerGroupVisibility(product.id);self.productStates.set(product.id,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADED);},loadUploadedFiles:Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadUploadedFiles(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadUploadedFiles$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:self.uploadedFilesState=__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADING;_context3.prev=1;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('product-file-uploads',{},{active_section:null});case 4:self.uploadedFiles=_context3.sent;_context3.next=12;break;case 7:_context3.prev=7;_context3.t0=_context3['catch'](1);self.uploadedFilesError=Object(__WEBPACK_IMPORTED_MODULE_15__util_error__["a" /* createErrorModel */])(_context3.t0);self.uploadedFilesState=__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].ERROR;throw _context3.t0;case 12:self.uploadedFilesState=__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADED;case 13:case'end':return _context3.stop();}}},loadUploadedFiles,this,[[1,7]]);})),getProductList:function getProductList(){return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().get('product-lists/products');},getProductByAccessToken:function getProductByAccessToken(params){return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().get('product-lists/products',{params:params});},saveProduct:function saveProduct(product){return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('product-lists/add-product',product);},deleteProduct:function deleteProduct(params){return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete('product-lists/delete-product',{params:params});},sendProductListEmail:function sendProductListEmail(productListEmail){return Object(__WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('product-lists/send',productListEmail);},setProductVariationColumn:function setProductVariationColumn(column){self.productVariationColumn=column;},getProductVariationColumn:function getProductVariationColumn(){return self.productVariationColumn;},setProductVariationRow:function setProductVariationRow(row){self.productVariationRow=row;},getProductVariationRow:function getProductVariationRow(){return self.productVariationRow;},setSelectedColumn:function setSelectedColumn(column){self.selectedProductColumn=column;},setSelectedRow:function setSelectedRow(row){self.selectedProductRow=row;}};});/* harmony default export */ __webpack_exports__["a"] = (ProductStore);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = objectToGetParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* eslint-disable prefer-template */
function objectToGetParams(object) {
  return '?' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}
/* eslint-enable prefer-template */

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonPageType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CommonPage={ADVANCED_SEARCH:'ADVANCED_SEARCH',CATEGORY:'CATEGORY',CHECKOUT:'CHECKOUT',CHECKOUT_SUCCESS:'CHECKOUT_SUCCESS',CUSTOMER_PRODUCTS:'CUSTOMER_PRODUCTS',HOME:'HOME',INFO:'INFO',KLARNA_INSTANT_SHOPPING_THANK_YOU:'KLARNA_INSTANT_SHOPPING_THANK_YOU',MANUFACTURER:'MANUFACTURER',MANUFACTURER_LIST:'MANUFACTURER_LIST',MY_ACCOUNT:'MY_ACCOUNT',MY_ACCOUNT_THANK_YOU:'MY_ACCOUNT_THANK_YOU',NEW_PRODUCTS:'NEW_PRODUCTS',NOT_FOUND:'NOT_FOUND',ON_SALE:'ON_SALE',POPULAR_PRODUCTS:'POPULAR_PRODUCTS',PRODUCT:'PRODUCT',RECOMMENDED_PRODUCTS:'RECOMMENDED_PRODUCTS',SECTION:'SECTION',SET_NEW_PASSWORD:'SET_NEW_PASSWORD',SOLD_PRODUCTS:'SOLD_PRODUCTS',VEHICLE_PART_SEARCH:'VEHICLE_PART_SEARCH',WISH_LIST:'WISH_LIST'};/* harmony default export */ __webpack_exports__["b"] = (CommonPage);var CommonPageType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CommonPage',Object.values(CommonPage));

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_TrackingStore__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Page=function(_Component){_inherits(Page,_Component);function Page(props){_classCallCheck(this,Page);var _this=_possibleConstructorReturn(this,(Page.__proto__||Object.getPrototypeOf(Page)).call(this,props));_this.sendTrackingData=function(){var _this$props=_this.props,trackingStore=_this$props.trackingStore,onDefinedTrackingPage=_this$props.onDefinedTrackingPage,configStore=_this$props.configStore;if(!configStore.activateSpotmore.enabled||typeof document==='undefined'||onDefinedTrackingPage){return null;}if(configStore.activateSpotmore.enabled&&window.crmtracker){window.crmtracker.sendData();}trackingStore.setPageView({visitedUrl:window.location.href,refererUrl:document.referrer});trackingStore.postPageView();};_this.yotpoTimeout=null;return _this;}_createClass(Page,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,analytics=_props.analytics,configStore=_props.configStore,uiStore=_props.uiStore,name=_props.name;uiStore.setCurrentPage(name);analytics.setPage(name);this.sendTrackingData();if(configStore.yotpo.enabled&&window&&window.yotpo){this.yotpoTimeout=setTimeout(function(){window.yotpo.refreshWidgets();},800);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.location.pathname!==this.props.location.pathname){this.sendTrackingData();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.yotpoTimeout&&clearTimeout(this.yotpoTimeout);}},{key:'render',value:function render(){var _props2=this.props,className=_props2.className,children=_props2.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},children);}}]);return Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Page.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,trackingStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_TrackingStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_UIStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6__analytics_Analytics__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.location.isRequired,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,onDefinedTrackingPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('analytics','uiStore','trackingStore','configStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* withRouter */])(Page)));

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Analytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__ = __webpack_require__(177);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var notImplementedError=new Error('Analytics method not implemented');var Analytics=function(){function Analytics(currencyStore,accountStore,uiStore){_classCallCheck(this,Analytics);this.currencyStore=currencyStore;this.accountStore=accountStore;this.uiStore=uiStore;}/**
   * Dispatch analytics events for integrations to use.
   *
   * @param {string} name
   * @param {Object} payload
   */_createClass(Analytics,[{key:'dispatchEvent',value:function dispatchEvent(name,payload){var detail={detail:{name:name,payload:Object.assign({currencyCode:this.currencyStore.currencyCode},payload)}};// Dispatch a specific event for integrations that only need specific events.
var event=new CustomEvent('analytics:'+name,detail);document.dispatchEvent(event);// Dispatch a catch-all event for integrations that use all events.
var analyticsEvent=new CustomEvent('analytics',detail);document.dispatchEvent(analyticsEvent);}/**
   * @param {string} pageName
   */},{key:'setPage',value:function setPage(pageName){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].setPage,{pageName:pageName});}/**
   * @param {string} listName
   * @param {Array} productList An array with objects in the format { position, product }.
   */},{key:'productClick',value:function productClick(listName,productList){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].productClick,{listName:listName,productList:productList});}/**
   * @param {string} listName
   * @param {Array} productList An array with objects in the format { position, product }.
   */},{key:'productImpressions',value:function productImpressions(listName,productList){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].productImpressions,{listName:listName,productList:productList,pageName:this.uiStore.currentPage});}/**
   * @param {Array} productList An array with objects in the format { product }.
   */},{key:'productDetail',value:function productDetail(productList){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].productDetail,{productList:productList});}/**
   * @param {Array} productList An array with objects in the format { product, quantity, activeProductId, price }.
   */},{key:'addToCart',value:function addToCart(productList){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].addToCart,{productList:productList});}/**
   * @param {Array} productList An array with objects in the format { product, quantity, activeProductId, price }.
   */},{key:'removeFromCart',value:function removeFromCart(productList){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].removeFromCart,{productList:productList});}/**
   * Send all products from the cart.
   */},{key:'cartStatus',value:function cartStatus(cart){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].cartStatus,{cart:cart});}/**
   * Clear all products from the cart.
   */},{key:'clearCart',value:function clearCart(){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].clearCart,{});}/**
   * @param {Array} bannerList An array with objects in the format { bannerZone, banner }.
   */},{key:'promoView',value:function promoView(bannerList){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].promoView,{bannerList:bannerList});}/**
   * @param {Array} bannerList An array with objects in the format { bannerZone, banner }.
   */},{key:'promotionClick',value:function promotionClick(bannerList){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].promotionClick,{bannerList:bannerList});}/**
   * @param searchText
   * @param resultCounts
   */},{key:'quickSearch',value:function quickSearch(searchText,resultCounts){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].quickSearch,{searchText:searchText,resultCounts:resultCounts});}/**
   * When quick search suggestions are selected, the information is sent through this function.
   * Can be used to train suggestions.
   *
   * @param searchText
   * @param suggestionType
   * @param suggestionValue
   */},{key:'suggestionSelection',value:function suggestionSelection(searchText,suggestionType,suggestionValue){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].suggestionSelection,{searchText:searchText,suggestionType:suggestionType,suggestionValue:suggestionValue});}},{key:'checkout',value:function checkout(productList,actionField){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].checkout,{productList:productList,actionField:actionField});}},{key:'checkoutOption',value:function checkoutOption(){throw notImplementedError;}/**
   * @param {Order} order The entire order object.
   * @param {Product[]} products Real product objects representing the products included in the order.
   */},{key:'purchase',value:function purchase(order,products){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].purchase,{order:order,products:products});}},{key:'refund',value:function refund(){throw notImplementedError;}},{key:'updateDimension',value:function updateDimension(dimensionKey,dimensionValue){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].updateDimension,{dimensionKey:dimensionKey,dimensionValue:dimensionValue});}},{key:'reserveAndCollect',value:function reserveAndCollect(data){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].reserveAndCollect,data);}},{key:'pageNotFound',value:function pageNotFound(payload){this.dispatchEvent(__WEBPACK_IMPORTED_MODULE_0__AnalyticsEventNames__["a" /* default */].pageNotFound,payload);}}]);return Analytics;}();

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = paramsToQueryIdentifier;
function paramsToQueryIdentifier(params){return JSON.stringify(params);}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldError__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormGroupField=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FormGroupField,_Component);function FormGroupField(props){_classCallCheck(this,FormGroupField);// In the normal use cases, the form and field names don't change, and
// this only really affects the input/label binding, so not updating the id
// afterwards if props change should still be fine.
var _this=_possibleConstructorReturn(this,(FormGroupField.__proto__||Object.getPrototypeOf(FormGroupField)).call(this,props));_this.getTooltip=function(text){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'info',className:'tooltip-'+_this.id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["V" /* UncontrolledTooltip */],{target:'.tooltip-'+_this.id},text));};_this.id=__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(props.formName+'__'+props.fieldName+'--');return _this;}_createClass(FormGroupField,[{key:'render',value:function render(){var _props=this.props,label=_props.label,fieldName=_props.fieldName,field=_props.field,type=_props.type,hideLabel=_props.hideLabel,required=_props.required,tooltip=_props.tooltip,description=_props.description,formName=_props.formName,rest=_objectWithoutProperties(_props,['label','fieldName','field','type','hideLabel','required','tooltip','description','formName']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],{className:'FormGroupField'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{'for':this.id,hidden:hideLabel},label,required&&' * ',tooltip&&this.getTooltip(tooltip)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Field__["a" /* default */],Object.assign({component:__WEBPACK_IMPORTED_MODULE_4_reactstrap__["v" /* Input */],field:field,type:type,name:fieldName,id:this.id,required:required},rest)),description,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FieldError__["a" /* default */],{field:field}));}}]);return FormGroupField;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;FormGroupField.propTypes={field:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_FormField__["b" /* default */]).isRequired,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,formName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,fieldName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,hideLabel:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,tooltip:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,required:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,description:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node};FormGroupField.defaultProps={type:'text'};/* harmony default export */ __webpack_exports__["a"] = (FormGroupField);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);













var isPromise = function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};

var getBoxPositionOnWindowCenter = function getBoxPositionOnWindowCenter(width, height) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2
  };
};

var getBoxPositionOnScreenCenter = function getBoxPositionOnScreenCenter(width, height) {
  return {
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2
  };
};

function windowOpen(url, _ref, onClose) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? 400 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 550 : _ref$width,
      configRest = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['height', 'width']);

  var config = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
    height: height,
    width: width,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes'
  }, configRest);

  var shareDialog = window.open(url, '', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(config).map(function (key) {
    return key + '=' + config[key];
  }).join(', '));

  if (onClose) {
    var interval = window.setInterval(function () {
      try {
        if (shareDialog === null || shareDialog.closed) {
          window.clearInterval(interval);
          onClose(shareDialog);
        }
      } catch (e) {
        /* eslint-disable no-console */
        console.error(e);
        /* eslint-enable no-console */
      }
    }, 1000);
  }

  return shareDialog;
}

var ShareButton = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ShareButton, _PureComponent);

  function ShareButton() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = ShareButton.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ShareButton)).call.apply(_ref2, [this].concat(args))), _this), _this.onClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          openWindow = _this$props.openWindow,
          beforeOnClick = _this$props.beforeOnClick;


      if (disabled) {
        return;
      }

      e.preventDefault();

      var link = _this.link();

      var clickHandler = openWindow ? function () {
        return _this.openWindow(link);
      } : function () {
        return onClick(link);
      };

      if (beforeOnClick) {
        var returnVal = beforeOnClick();

        if (isPromise(returnVal)) {
          returnVal.then(clickHandler);
        } else {
          clickHandler();
        }
      } else {
        clickHandler();
      }
    }, _this.onKeyPress = function (e) {
      if (e.key === 'Enter' || e.key === 13 || e.key === ' ' || e.key === 32) {
        _this.onClick(e);
      }
    }, _this.openWindow = function (link) {
      var _this$props2 = _this.props,
          windowPosition = _this$props2.windowPosition,
          onShareWindowClose = _this$props2.onShareWindowClose,
          windowWidth = _this$props2.windowWidth,
          windowHeight = _this$props2.windowHeight;


      var windowConfig = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
        height: windowHeight,
        width: windowWidth
      }, windowPosition === 'windowCenter' ? getBoxPositionOnWindowCenter(windowWidth, windowHeight) : getBoxPositionOnScreenCenter(windowWidth, windowHeight));

      windowOpen(link, windowConfig, onShareWindowClose);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ShareButton, [{
    key: 'link',
    value: function link() {
      var _props = this.props,
          url = _props.url,
          opts = _props.opts,
          networkLink = _props.networkLink;

      return networkLink(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          additionalProps = _props2.additionalProps,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          disabledStyle = _props2.disabledStyle,
          network = _props2.network,
          role = _props2.role,
          style = _props2.style,
          tabIndex = _props2.tabIndex;


      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
        'SocialMediaShareButton--disabled': !!disabled,
        disabled: !!disabled
      }, className);

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
          'aria-label': network
        }, additionalProps, {
          role: role,
          tabIndex: tabIndex,
          onClick: this.onClick,
          onKeyPress: this.onKeyPress,
          className: classes,
          style: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, style, disabled ? disabledStyle : {}) }),
        children
      );
    }
  }]);

  return ShareButton;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

ShareButton.propTypes = {
  additionalProps: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  disabledStyle: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,
  network: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,
  networkLink: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  opts: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,
  openWindow: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  url: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,
  role: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,
  windowWidth: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number,
  windowHeight: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number,
  windowPosition: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['windowCenter', 'screenCenter']),
  beforeOnClick: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  onShareWindowClose: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number])
};
ShareButton.defaultProps = {
  disabledStyle: {
    opacity: 0.6
  },
  openWindow: true,
  role: 'button',
  windowPosition: 'windowCenter',
  tabIndex: '0'
};


function createShareButton(network, link) {
  var optsMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  var propTypes = arguments[3];
  var defaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var CreatedButton = __WEBPACK_IMPORTED_MODULE_9_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ShareButton, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      network: network,
      networkLink: link,
      opts: optsMap(props) }));
  });

  CreatedButton.propTypes = propTypes;
  CreatedButton.defaultProps = defaultProps;

  return CreatedButton;
}

/* harmony default export */ __webpack_exports__["a"] = (createShareButton);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export errors */
/* harmony export (immutable) */ __webpack_exports__["a"] = createErrorModel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(4);
var errors=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* defineMessages */])({networkError:{'id':'state.networkError','defaultMessage':'Connection failure. Please ensure you are connected to the Internet.'}});function createErrorModel(originalError){var publicMessage=null;// Handle network errors
if(originalError.request&&!originalError.response||originalError.message==='Network Error'){publicMessage=errors.networkError;}return{httpStatusCode:originalError.response&&originalError.response.status>=400?originalError.response.status:null,publicMessage:publicMessage};}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);
// Taken from https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/generatePath.js
var patternCache={};var cacheLimit=10000;var cacheCount=0;var compileGenerator=function compileGenerator(pattern){var cacheKey=pattern;var cache=patternCache[cacheKey]||(patternCache[cacheKey]={});if(cache[pattern])return cache[pattern];var compiledGenerator=__WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);if(cacheCount<cacheLimit){cache[pattern]=compiledGenerator;cacheCount++;}return compiledGenerator;};/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */var generatePath=function generatePath(){var pattern=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'/';var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(pattern==='/'){return pattern;}var generator=compileGenerator(pattern);return generator(params);};/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(108);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(1184);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iconFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function iconFactory(network, iconConfig) {
  var Icon = function Icon(props) {
    var className = props.className,
        iconBgStyle = props.iconBgStyle,
        logoFillColor = props.logoFillColor,
        borderRadius = props.borderRadius,
        round = props.round,
        size = props.size;


    var baseStyle = {
      width: size,
      height: size
    };

    var classes = 'social-icon social-icon--' + network + ' ' + className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: baseStyle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        {
          viewBox: '0 0 64 64',
          width: size,
          height: size,
          className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          !round ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
            width: '64',
            height: '64',
            rx: borderRadius,
            ry: borderRadius,
            fill: iconConfig.color,
            style: iconBgStyle }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', {
            cx: '32',
            cy: '32',
            r: '31',
            fill: iconConfig.color,
            style: iconBgStyle })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: iconConfig.icon, fill: logoFillColor })
        )
      )
    );
  };

  Icon.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    iconBgStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    logoFillColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    round: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    borderRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  };

  Icon.defaultProps = {
    className: '',
    iconBgStyle: {},
    logoFillColor: 'white',
    size: 64,
    borderRadius: 0
  };

  return Icon;
}

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_CustomerUser__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_CustomerUserPurchases__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_PurchaseProduct__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_CreditAccount__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_BalanceUser__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_BalancePaymentWidget__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_Error__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__models_BalancePaymentHistory__ = __webpack_require__(577);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CustomerUserStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named('CustomerUserStore').props({users:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_5__models_CustomerUser__["a" /* default */]),{}),userStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */]),{}),balancePayment:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_12__models_BalancePaymentWidget__["a" /* default */]),balancePaymentState:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].NONE),balanceUsers:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_11__models_BalanceUser__["a" /* default */]),{}),balanceUserStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */]),{}),balancePaymentHistory:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_15__models_BalancePaymentHistory__["a" /* default */],{}),balancePaymentHistoryState:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].NONE),paymentSuccess:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_12__models_BalancePaymentWidget__["a" /* default */]),paymentSuccessState:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].NONE),paymentSuccessError:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_14__models_Error__["a" /* default */]),purchaseQueryResults:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_8__models_CustomerUserPurchases__["a" /* default */]),{}),purchaseQueryStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */]),{}),productQueryResults:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_9__models_PurchaseProduct__["a" /* default */])),{}),productQueryStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */]),{}),creditAccount:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_10__models_CreditAccount__["a" /* default */],{}),creditAccountState:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED)}).views(function(self){return{get userArray(){return Array.from(self.users,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;});},get balanceUserArray(){return Array.from(self.balanceUsers,function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],value=_ref4[1];return value;});},get balancePaymentArray(){return Array.from(self.balanceUsers,function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],value=_ref6[1];return value;});}};}).actions(function(self){return{loadUser:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadUser(id){var user;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadUser$(_context){while(1){switch(_context.prev=_context.next){case 0:self.userStates.set(id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('customer-users/'+id);case 4:user=_context.sent;self.users.set(id,user);_context.next=13;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);self.setError(_context.t0);self.userStates.set(id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);throw _context.t0;case 13:self.userStates.set(id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);case 14:case'end':return _context.stop();}}},loadUser,this,[[1,8]]);})),loadUsers:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadUsers(){var users;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadUsers$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('customer-users');case 4:users=_context2.sent;self.users=__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(users,'id');self.userArray.forEach(function(user){self.userStates.set(user.id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);});_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 13:self.setLoading(false);case 14:case'end':return _context2.stop();}}},loadUsers,this,[[1,9]]);})),loadBalanceUser:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadBalanceUsers(id){var user;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadBalanceUsers$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:self.setLoading(true);_context3.prev=1;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('money-transfer/user/'+id);case 4:user=_context3.sent;self.balanceUsers.set(id,user);self.balanceUserStates.set(user.id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);_context3.next=13;break;case 9:_context3.prev=9;_context3.t0=_context3['catch'](1);self.setError(_context3.t0);throw _context3.t0;case 13:self.setLoading(false);case 14:case'end':return _context3.stop();}}},loadBalanceUsers,this,[[1,9]]);})),loadBalanceUsers:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadBalanceUsers(){var users;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadBalanceUsers$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:self.setLoading(true);_context4.prev=1;_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('money-transfer/user');case 4:users=_context4.sent;self.balanceUsers=__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(users,'id');self.balanceUserArray.forEach(function(user){self.balanceUserStates.set(user.id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);});_context4.next=13;break;case 9:_context4.prev=9;_context4.t0=_context4['catch'](1);self.setError(_context4.t0);throw _context4.t0;case 13:self.setLoading(false);case 14:case'end':return _context4.stop();}}},loadBalanceUsers,this,[[1,9]]);})),loadPurchases:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadPurchases(searchParameters){var queryIdentifier,purchases;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadPurchases$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:queryIdentifier=Object(__WEBPACK_IMPORTED_MODULE_7__util_query__["a" /* paramsToQueryIdentifier */])(searchParameters);// Skip the API call if we already have the data
if(!self.purchaseQueryStates.get(queryIdentifier)){_context5.next=3;break;}return _context5.abrupt('return');case 3:self.setLoading(true);self.purchaseQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING);_context5.prev=5;_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('customer-user-purchases?'+Object(__WEBPACK_IMPORTED_MODULE_6__util_queryString__["c" /* stringify */])(searchParameters));case 8:purchases=_context5.sent;self.setLoading(false);self.purchaseQueryResults.set(queryIdentifier,purchases);_context5.next=18;break;case 13:_context5.prev=13;_context5.t0=_context5['catch'](5);self.setError(_context5.t0);self.purchaseQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);throw _context5.t0;case 18:self.setLoading(false);self.purchaseQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);case 20:case'end':return _context5.stop();}}},loadPurchases,this,[[5,13]]);})),loadPurchaseProducts:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadPurchaseProducts(searchParameters){var queryIdentifier,purchaseProducts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadPurchaseProducts$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:queryIdentifier=Object(__WEBPACK_IMPORTED_MODULE_7__util_query__["a" /* paramsToQueryIdentifier */])(searchParameters);// Skip the API call if we already have the data
if(!self.productQueryStates.get(queryIdentifier)){_context6.next=3;break;}return _context6.abrupt('return');case 3:self.setLoading(true);self.productQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING);_context6.prev=5;_context6.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('customer-user-purchases/products?'+Object(__WEBPACK_IMPORTED_MODULE_6__util_queryString__["c" /* stringify */])(searchParameters));case 8:purchaseProducts=_context6.sent;self.setLoading(false);self.productQueryResults.set(queryIdentifier,purchaseProducts);_context6.next=18;break;case 13:_context6.prev=13;_context6.t0=_context6['catch'](5);self.setError(_context6.t0);self.productQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);throw _context6.t0;case 18:self.setLoading(false);self.productQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);case 20:case'end':return _context6.stop();}}},loadPurchaseProducts,this,[[5,13]]);})),removeUser:function removeUser(id){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete('customer-users/'+id);},saveUser:function saveUser(user){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('customer-users/',user);},updateUser:function updateUser(id,user){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().put('customer-users/'+id,user);},removeBalanceUser:function removeBalanceUser(id){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete('money-transfer/user/'+id);},saveBalanceUser:function saveBalanceUser(user){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('money-transfer/user',user);},updateBalanceUser:function updateBalanceUser(id,user){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().put('money-transfer/user/'+id,user);},makePayment:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function balancePayment(userPayments,lang){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function balancePayment$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:self.balancePaymentState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING;_context7.prev=1;_context7.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('money-transfer/payment?lang='+lang,{userPayments:userPayments});case 4:response=_context7.sent;self.balancePayment=response.data;self.balancePaymentState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED;_context7.next=13;break;case 9:_context7.prev=9;_context7.t0=_context7['catch'](1);self.balancePaymentState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR;throw _context7.t0;case 13:self.balancePaymentState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED;case 14:case'end':return _context7.stop();}}},balancePayment,this,[[1,9]]);})),convertPaymentAmountsIntoUserPayments:function convertPaymentAmountsIntoUserPayments(paymentAmounts){var userPayments=[];if(paymentAmounts.length>0){paymentAmounts.forEach(function(amount){userPayments.push({id:amount.id,amount_with_tax:amount.amount});});}return userPayments;},loadBalancePostPayment:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadBalancePostPayment(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadBalancePostPayment$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:self.balancePaymentState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING;_context8.prev=1;_context8.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('money-transfer/payment/success');case 4:self.paymentSuccess=_context8.sent;self.paymentSuccessState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED;_context8.next=13;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](1);self.paymentSuccessError=Object(__WEBPACK_IMPORTED_MODULE_13__util_error__["a" /* createErrorModel */])(_context8.t0);self.paymentSuccessState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR;throw _context8.t0;case 13:self.balancePaymentState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED;case 14:case'end':return _context8.stop();}}},loadBalancePostPayment,this,[[1,8]]);})),loadBalancePaymentHistory:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadBalancePaymentHistory(page){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadBalancePaymentHistory$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:self.balancePaymentHistoryState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING;_context9.prev=1;_context9.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('money-transfer/payment/history'+page);case 4:response=_context9.sent;self.balancePaymentHistory=response;_context9.next=13;break;case 8:_context9.prev=8;_context9.t0=_context9['catch'](1);self.setError(_context9.t0);self.balancePaymentHistoryState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR;throw _context9.t0;case 13:self.balancePaymentHistoryState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED;case 14:case'end':return _context9.stop();}}},loadBalancePaymentHistory,this,[[1,8]]);})),loadCreditAccount:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadCreditAccount(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCreditAccount$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:self.creditAccountState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING;_context10.prev=1;_context10.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('my-account/credit-account');case 4:self.creditAccount=_context10.sent;_context10.next=12;break;case 7:_context10.prev=7;_context10.t0=_context10['catch'](1);self.setError(_context10.t0);self.creditAccountState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR;throw _context10.t0;case 12:self.creditAccountState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED;case 13:case'end':return _context10.stop();}}},loadCreditAccount,this,[[1,7]]);}))};});/* harmony default export */ __webpack_exports__["a"] = (CustomerUserStore);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var lazyNavigationEntity=function lazyNavigationEntity(){return NavigationEntity;};var NavigationEntity=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]).isRequired,label:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]).isRequired,path:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,active:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(lazyNavigationEntity),className:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,customNavLinks:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object)});/* harmony default export */ __webpack_exports__["a"] = (NavigationEntity);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Cart__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Modal__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_ProductAddedToCartModalStyle__ = __webpack_require__(469);
var CartStore=__WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__["a" /* default */].named('CartStore').props({alsoPurchasedProductId:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string),cart:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2__models_Cart__["a" /* default */]),cartModal:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__models_Modal__["a" /* default */].named('CartModal').props({openedManually:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].boolean,true)}).actions(function(self){return{toggle:function toggle(){var wasOpenedManually=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;self.isOpen=!self.isOpen;// Only set the manual open state when the modal opens. If it is updated from
// automatic -> manual during the close toggle, the manual UI will flash quickly
// during the fade animation.
if(self.isOpen){self.openedManually=!!wasOpenedManually;}}};}),{}),cartErrorModal:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__models_Modal__["a" /* default */].named('CartErrorModal'),{}),popoverModal:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__models_Modal__["a" /* default */].named('PopoverModal').props({openedManually:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].boolean,true)}).actions(function(self){return{toggle:function toggle(){self.isOpen=!self.isOpen;}};}),{}),productQuantity:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].number,1)}).actions(function(self){var getCartConfiguration=function getCartConfiguration(){var modalType=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore.productAddedToCardModalType;var isRetailer=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).accountStore.account.is_retailer;return isRetailer||modalType===__WEBPACK_IMPORTED_MODULE_5__types_ProductAddedToCartModalStyle__["a" /* default */].POPOVER;};return{setup:function setup(cart){self.cart=cart;self.setLoading(false);},toggleModal:function toggleModal(){var enablePopover=getCartConfiguration();if(enablePopover){self.popoverModal.toggle(false);}else{self.cartModal.toggle(false);}},loadCart:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadCart(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCart$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('cart');case 4:self.cart=_context.sent;if(self.cart.ifRenderModal){self.toggleModal();}if(self.cart.ifRenderErrorModal){self.cartErrorModal.toggle();}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 13:self.setLoading(false);case 14:case'end':return _context.stop();}}},loadCart,this,[[1,9]]);})),setBasket:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setBasket(basketId){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setBasket$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('cart/set-basket',{basketId:basketId});case 4:request=_context2.sent;self.cart=request.data;_context2.next=12;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 12:self.setLoading(false);case 13:case'end':return _context2.stop();}}},setBasket,this,[[1,8]]);})),addToCart:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function addToCart(productId,quantity,bundleProductIds,additionalServices,recurringProduct){var includeActiveCategory=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;var categoryStore,activeCategory,recurringOrderCycleType,recurringOrderCustomCycle,payload,request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addToCart$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:self.setLoading(true);categoryStore=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).categoryStore;activeCategory=null;if(includeActiveCategory){activeCategory=categoryStore.activeCategory?categoryStore.activeCategory.id:null;}recurringOrderCycleType=recurringProduct&&recurringProduct.cycle?recurringProduct.cycle:null;recurringOrderCustomCycle=recurringProduct&&recurringProduct.days?recurringProduct.days:null;payload={id:productId,qty:quantity,bundleProductIds:bundleProductIds,additionalServices:additionalServices};// Add payload parameters conditionally.
if(activeCategory){payload.activeCategory=activeCategory;}if(recurringOrderCycleType){payload.recurringOrderCycleType=recurringOrderCycleType;}if(recurringOrderCustomCycle){payload.recurringOrderCustomCycle=recurringOrderCustomCycle;}_context3.prev=10;_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('cart/add',payload);case 13:request=_context3.sent;// Update last productId only when we re-enter modal somewhere in shop
// We want to keep the first product reference for also purchased listing
if(!self.cartModal.isOpen||!self.alsoPurchasedProductId){self.alsoPurchasedProductId=productId;}self.cart=request.data;_context3.next=22;break;case 18:_context3.prev=18;_context3.t0=_context3['catch'](10);self.setError(_context3.t0);throw _context3.t0;case 22:self.setLoading(false);/**
         * Don't close modal if it's open already.
         * This happens when user adds product via
         * AlsoPurchasedSlider within the modal.
         */if(!self.cartModal.isOpen){self.toggleModal(self.cartModal.isOpen);}case 24:case'end':return _context3.stop();}}},addToCart,this,[[10,18]]);})),addFromOrder:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function addFromOrder(orderId){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addFromOrder$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:self.setLoading(true);_context4.prev=1;_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('cart/add-from-order',{orderId:orderId});case 4:request=_context4.sent;self.cart=request.data;_context4.next=12;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);self.setError(_context4.t0);throw _context4.t0;case 12:self.setLoading(false);self.toggleModal();case 14:case'end':return _context4.stop();}}},addFromOrder,this,[[1,8]]);})),populate:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function populate(products){var showCartMatrix=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function populate$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:self.setLoading(true);_context5.prev=1;_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('cart/populate',{products:products});case 4:request=_context5.sent;self.cart=request.data;_context5.next=12;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);self.setError(_context5.t0);throw _context5.t0;case 12:self.setLoading(false);if(!self.cartModal.isOpen&&showCartMatrix){self.toggleModal(self.cartModal.isOpen);}case 14:case'end':return _context5.stop();}}},populate,this,[[1,8]]);})),updateProductQuantity:function updateProductQuantity(quantity){return self.productQuantity=quantity;}};});/* harmony default export */ __webpack_exports__["a"] = (CartStore);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SEOLink__ = __webpack_require__(528);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CanonicalLink=function(_Component){_inherits(CanonicalLink,_Component);function CanonicalLink(){_classCallCheck(this,CanonicalLink);return _possibleConstructorReturn(this,(CanonicalLink.__proto__||Object.getPrototypeOf(CanonicalLink)).apply(this,arguments));}_createClass(CanonicalLink,[{key:'render',value:function render(){var path=this.props.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SEOLink__["a" /* default */],{rel:'canonical',path:path,addOpenGraphTag:true});}}]);return CanonicalLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CanonicalLink.propTypes={path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CanonicalLink);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This is simple component that can be used to reset the scroll position.
 * Use the key to re-render the component. <ScrollReset key={resetScrollWhenThisChanges} />
 */var ScrollReset=function(_Component){_inherits(ScrollReset,_Component);function ScrollReset(){_classCallCheck(this,ScrollReset);return _possibleConstructorReturn(this,(ScrollReset.__proto__||Object.getPrototypeOf(ScrollReset)).apply(this,arguments));}_createClass(ScrollReset,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);}},{key:'render',value:function render(){return null;}}]);return ScrollReset;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ScrollReset);

/***/ }),
/* 57 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$mobx", function() { return $mobx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reaction", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untracked", function() { return untracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDerivationState", function() { return IDerivationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAtom", function() { return createAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spy", function() { return spy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comparer", function() { return comparer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableObject", function() { return isObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function() { return isObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableArray", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableMap", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableMap", function() { return isObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transaction", function() { return transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableProp", function() { return isObservableProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputed", function() { return isComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputedProp", function() { return isComputedProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendObservable", function() { return extendObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendShallowObservable", function() { return extendShallowObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intercept", function() { return intercept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorun", function() { return autorun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reaction", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "when", function() { return when; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAction", function() { return isAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runInAction", function() { return runInAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return keys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return entries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decorate", function() { return decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configure", function() { return configure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBecomeObserved", function() { return onBecomeObserved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBecomeUnobserved", function() { return onBecomeUnobserved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flow", function() { return flow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return trace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDependencyTree", function() { return getDependencyTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getObserverTree", function() { return getObserverTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_resetGlobalState", function() { return resetGlobalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getGlobalState", function() { return getGlobalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDebugName", function() { return getDebugName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtom", function() { return getAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getAdministration", function() { return getAdministration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_allowStateChanges", function() { return allowStateChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_isComputingDerivation", function() { return isComputingDerivation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onReactionError", function() { return onReactionError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_interceptReads", function() { return interceptReads; });
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

















function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance(target) {
    if (target.__mobxDidRunLazyInitializers === true)
        return;
    var decorators = target.__mobxDecorators;
    if (decorators) {
        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
        for (var key in decorators) {
            var d = decorators[key];
            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false)
                fail$1("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
                var inheritedDecorators = target.__mobxDecorators;
                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
            }
            target.__mobxDecorators[prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
        (args.length === 4 && args[3] === true));
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = __assign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(__assign({}, change, { spyReportEnd: true }));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
    });
}

function createAction(actionName, fn) {
    if (false) {
        invariant(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName)
            fail$1("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

function dontReassignFields() {
    fail$1("production" !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {
                return fail$1("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
    }
    else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    // TODO: deprecate?
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {
        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
        if (typeof actionName !== "string" || !actionName)
            fail$1("actions should have valid names, got: '" + actionName + "'");
    }
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys$$1 = Object.keys(a), key;
        length = keys$$1.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys$$1[length];
            if (!(has$$1(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isES6Map(a) || isObservableMap(a))
        return iteratorToArray(a.entries());
    return a;
}
function has$$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (false) {
        invariant(typeof view === "function", "Autorun expects a function as first argument");
        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed)
                        reaction.track(reactionRunner);
                });
            }
        }, opts.onError);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay ? function (f) { return setTimeout(f, opts.delay); } : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (typeof opts === "boolean") {
        opts = { fireImmediately: opts };
        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
    }
    if (false) {
        invariant(typeof expression === "function", "First argument to reaction should be a function");
        invariant(typeof opts === "object", "Third argument of reactions should be an object");
    }
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural
        ? comparer.structural
        : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effectAction(value, r);
        if (!firstTime && changed === true)
            effectAction(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        }
        catch (e) {
            errorHandler.call(this, e);
        }
    };
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        var _this = this;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        if (false)
            return fail$1("missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set)
            this.setter = createAction(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer.structural
                    : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        if (options.keepAlive === true) {
            // dangerous: never exposed, so this cmputed value should not depend on observables
            // that live globally, or it will never get disposed! (nor anything attached to it)
            autorun(function () { return _this.get(); });
        }
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () { };
    ComputedValue.prototype.onBecomeObserved = function () { };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        if (this.isComputing)
            fail$1("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.length === 0) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "production" !== "production" &&
                "[ComputedValue '" + this
                    .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        clearObserving(this);
        this.value = undefined; // don't hold on to computed value!
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (true)
            return;
        if (this.requiresReaction === true) {
            fail$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this
                .name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this
                .name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var UNCHANGED = {};
declareAtom();
var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(Atom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name, defaultEnhancer) {
        this.target = target;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.values = {};
    }
    ObservableObjectAdministration.prototype.read = function (owner, key) {
        if ("production" === "production" && this.target !== owner) {
            this.illegalAccess(owner, key);
            if (!this.values[key])
                return undefined;
        }
        return this.values[key].get();
    };
    ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
        var instance = this.target;
        if ("production" === "production" && instance !== owner) {
            this.illegalAccess(owner, key);
        }
        var observable = this.values[key];
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: instance,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values[key])
            return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldValue = this.values[key].get();
            if (this.keys)
                this.keys.remove(key);
            delete this.values[key];
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
        finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var _this = this;
        if (this.keys === undefined) {
            this.keys = new ObservableArray(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue; }), referenceEnhancer, "keys(" + this.name + ")", true);
        }
        return this.keys.slice();
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
    var adm = target.$mobx;
    if (adm)
        return adm;
    "production" !== "production" &&
        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservableProperty(target, propName, newValue, enhancer) {
    var adm = asObservableObject(target);
    assertPropertyConfigurable(target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
    if (adm.keys)
        adm.keys.push(propName);
    notifyPropertyAddition(adm, target, propName, newValue);
}
function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
propName, options) {
    var adm = asObservableObject(target);
    options.name = adm.name + "." + propName;
    options.context = target;
    adm.values[propName] = new ComputedValue(options);
    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.read(this, propName);
            },
            set: function (v) {
                this.$mobx.write(this, propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner.$mobx;
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner.$mobx;
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(this, propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(this, propName, v);
            }
        }));
}
function notifyPropertyAddition(adm, object, key, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: key,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(__assign({}, change, { name: adm.name, key: key }));
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

function createDecoratorForEnhancer(enhancer) {
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {
            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
        }
        var initialValue = descriptor
            ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value
            : undefined;
        defineObservableProperty(target, propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"/backend/api/v1/"}) && "production" !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (false)
            return fail$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}
function isObservable(value) {
    if (arguments.length !== 1)
        fail$1("production" !== "production" &&
            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string")
        return fail$1("production" !== "production" && "expected a property name as second argument");
    return _isObservable(value, propName);
}

function _isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1)
        return fail$1("production" !== "production" &&
            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string")
        return fail$1("production" !== "production" &&
            "isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    var options = decoratorArgs[0] || {};
    defineComputedProperty(instance, propertyName, __assign({ get: get, set: set }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {
        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

function extendShallowObservable(target, properties, decorators) {
    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
}
function extendObservable(target, properties, decorators, options) {
    if (false) {
        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators)
            for (var key in decorators)
                if (!(key in properties))
                    fail$1("Trying to declare a decorator for unspecified property '" + key + "'");
    }
    options = asCreateObservableOptions(options);
    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    startBatch();
    try {
        for (var key in properties) {
            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
            if (false) {
                if (Object.getOwnPropertyDescriptor(target, key))
                    fail$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
                if (isComputed(descriptor.value))
                    fail$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
            }
            var decorator = decorators && key in decorators
                ? decorators[key]
                : descriptor.get ? computedDecorator : defaultDecorator;
            if (false)
                return fail$1("Not a valid decorator for '" + key + "', got: " + decorator);
            var resultDescriptor = decorator(target, key, descriptor, true);
            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
            )
                Object.defineProperty(target, key, resultDescriptor);
        }
    }
    finally {
        endBatch();
    }
    return target;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
var shallowCreateObservableOptions = {
    deep: false,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze(defaultCreateObservableOptions);
Object.freeze(shallowCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|defaultDecorator)$/.test(key))
        fail$1("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions;
    if (typeof thing === "string")
        return { name: thing, deep: true };
    if (false) {
        if (typeof thing !== "object")
            return fail$1("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false ? referenceEnhancer : deepEnhancer;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v)
        ? observable.object(v, arg2, arg3)
        : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail$1("production" !== "production" &&
        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
        return observable.box(value, { name: name, deep: false });
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
        return observable.array(initialValues, { name: name, deep: false });
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
        return observable.map(initialValues, { name: name, deep: false });
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        return extendObservable({}, props, decorators, o);
    },
    shallowObject: function (props, name) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("shallowObject");
        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
        return observable.object(props, {}, { name: name, deep: false });
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail$1(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, { name: name });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name });
    if (isES6Map(v))
        return observable.map(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v))
        return observable.map(v, { name: name, deep: false });
    return fail$1("production" !== "production" &&
        "The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (false)
        throw "observable.struct should not be used with observable values";
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}

function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}
function makeIterable(iterator) {
    iterator[iteratorSymbol()] = self;
    return iterator;
}
function self() {
    return this;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        if (this._hasMap.has(key))
            return this._hasMap.get(key).get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
            this._hasMap.set(key, entry);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + key, false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keys.push(key);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return this._keys[iteratorSymbol()]();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var nextIndex = 0;
        return makeIterable({
            next: function () {
                return nextIndex < self._keys.length
                    ? { value: self.get(self._keys[nextIndex++]), done: false }
                    : { value: undefined, done: true };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var nextIndex = 0;
        return makeIterable({
            next: function () {
                if (nextIndex < self._keys.length) {
                    var key = self._keys[nextIndex++];
                    return {
                        value: [key, self.get(key)],
                        done: false
                    };
                }
                return { done: true };
            }
        });
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this._keys.forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail$1("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this._keys.slice().forEach(function (key) { return _this.delete(key); });
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this._keys;
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var _this = this;
        var res = {};
        this._keys.forEach(function (key) { return (res["" + key] = _this.get(key)); });
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = new Map();
        this._keys.forEach(function (key) { return res.set(key, _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this._keys.map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
addHiddenFinalProp(ObservableMap.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Map");
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined)
                fail$1("production" !== "production" &&
                    "It is not possible to get index atoms from arrays");
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable)
                fail$1("production" !== "production" &&
                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property)
                return fail$1("production" !== "production" && "please specify a property");
            var observable = thing.$mobx.values[property];
            if (!observable)
                fail$1("production" !== "production" &&
                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail$1("production" !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    if (!thing)
        fail$1("Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing.$mobx)
        return thing.$mobx;
    fail$1("production" !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg2 === "string" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg2 === "string" ? arg3 : arg2;
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail$1("production" !== "production" && "Not an atom that can be (un)observed");
    atom[hook] = function () {
        orig.call(this);
        cb.call(this);
    };
    return function () {
        atom[hook] = orig;
    };
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var Atom;
var isAtom;
function declareAtom() {
    if (Atom)
        return;
    Atom = /** @class */ (function () {
        /**
         * Create a new atom. For debugging purposes it is recommended to give it a name.
         * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
         */
        function AtomImpl(name) {
            if (name === void 0) { name = "Atom@" + getNextId(); }
            this.name = name;
            this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
            this.isBeingObserved = false;
            this.observers = [];
            this.observersIndexes = {};
            this.diffValue = 0;
            this.lastAccessedBy = 0;
            this.lowestObserverState = IDerivationState.NOT_TRACKING;
        }
        AtomImpl.prototype.onBecomeUnobserved = function () {
            // noop
        };
        AtomImpl.prototype.onBecomeObserved = function () {
            /* noop */
        };
        /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
        AtomImpl.prototype.reportObserved = function () {
            return reportObserved(this);
        };
        /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
        AtomImpl.prototype.reportChanged = function () {
            startBatch();
            propagateChanged(this);
            endBatch();
        };
        AtomImpl.prototype.toString = function () {
            return this.name;
        };
        return AtomImpl;
    }());
    isAtom = createInstanceofPredicate("Atom", Atom);
}
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
    var atom = new Atom(name);
    onBecomeObserved(atom, onBecomeObservedHandler);
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && this.values.length > 0)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems =
            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = __spread(oldItems.slice(0, toIndex), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    
    this.$mobx.atom.reportObserved();
    var self = this;
    var nextIndex = 0;
    return makeIterable({
        next: function () {
            return nextIndex < self.length
                ? { value: self[nextIndex++], done: false }
                : { done: true, value: undefined };
        }
    });
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    addHiddenProp(ObservableArray.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Array");
}
// Internet Explorer on desktop doesn't support this.....
// So, let's don't do this to avoid different semantics
// See #1395
// addHiddenProp(
//     ObservableArray.prototype,
//     typeof Symbol !== "undefined" ? Symbol.isConcatSpreadable as any : "@@isConcatSpreadable",
//     {
//         enumerable: false,
//         configurable: true,
//         value: true
//     }
// )
/**
 * Wrap function from prototype
 */

[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail$1(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (true)
        return false;
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}

function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    if (false)
        fail$1("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map) {
    if (isPlainObject(map))
        return Object.keys(map);
    if (Array.isArray(map))
        return map.map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key;
        });
    if (isES6Map(map) || isObservableMap(map))
        return iteratorToArray(map.keys());
    return fail$1("Cannot get keys from '" + map + "'");
}
// use Array.from in Mobx 5
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "disableErrorBoundaries",
    "runId"
];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var runInIsolationCalled = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!runInIsolationCalled) {
                fail$1("production" !== "production" &&
                    "There are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        }, 1);
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observabe of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable.observers.length === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd(prevUntracked);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail$1("production" !== "production" &&
            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers$$1 || globalState.enforceActions === "strict"))
        fail$1("production" !== "production" &&
            (globalState.enforceActions
                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
                atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail$1("production" !== "production" &&
            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate, errorHandler) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending && isSpyEnabled()) {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        console.error(message, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
        return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer.$mobx.isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError)
                    opts.onError(error);
                else
                    throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle)
                clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false)
        return fail$1("the options 'onError' and 'promise' cannot be combined");
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, __assign({}, opts, { onError: reject }));
        cancel = function () {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj.$mobx.getKeys();
    }
    if (isObservableMap(obj)) {
        return obj._keys.slice();
    }
    return fail$1("production" !== "production" &&
        "'keys()' can only be used on observable objects and maps");
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return obj[key]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return obj.get(key); });
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail$1("production" !== "production" &&
        "'values()' can only be used on observable objects, arrays and maps");
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return [key, obj[key]]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) { return [index, key]; });
    }
    return fail$1("production" !== "production" &&
        "'entries()' can only be used on observable objects, arrays and maps");
}
function set(obj, key, value) {
    if (arguments.length === 2) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1)
                set(obj, key_1, values_1[key_1]);
        }
        finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj.$mobx;
        var existingObservable = adm.values[key];
        if (existingObservable) {
            adm.write(obj, key, value);
        }
        else {
            defineObservableProperty(obj, key, value, adm.defaultEnhancer);
        }
    }
    else if (isObservableMap(obj)) {
        obj.set(key, value);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length)
            obj.length = key + 1;
        obj[key] = value;
        endBatch();
    }
    else {
        return fail$1("production" !== "production" &&
            "'set()' can only be used on observable objects, arrays and maps");
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        
        obj.$mobx.remove(key);
    }
    else if (isObservableMap(obj)) {
        obj.delete(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    }
    else {
        return fail$1("production" !== "production" &&
            "'remove()' can only be used on observable objects, arrays and maps");
    }
}
function has$1(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
        return adm.values[key] instanceof ObservableValue;
    }
    else if (isObservableMap(obj)) {
        return obj.has(key);
    }
    else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    }
    else {
        return fail$1("production" !== "production" &&
            "'has()' can only be used on observable objects, arrays and maps");
    }
}
function get(obj, key) {
    if (!has$1(obj, key))
        return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    }
    else if (isObservableMap(obj)) {
        return obj.get(key);
    }
    else if (isObservableArray(obj)) {
        return obj[key];
    }
    else {
        return fail$1("production" !== "production" &&
            "'get()' can only be used on observable objects, arrays and maps");
    }
}

function decorate(thing, decorators) {
    "production" !== "production" &&
        invariant(isPlainObject(decorators), "Decorators should be a key value map");
    var target = typeof thing === "function" ? thing.prototype : thing;
    for (var prop in decorators) {
        var decorator = decorators[prop];
        "production" !== "production" &&
            invariant(typeof decorator === "function", "Decorate: expected a decorator function for '" + prop + "'");
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = decorator(target, prop, descriptor);
        if (newDescriptor)
            Object.defineProperty(target, prop, newDescriptor);
    }
    return thing;
}

function configure(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler;
    if (enforceActions !== undefined) {
        if (typeof enforceActions !== "boolean" && enforceActions !== "strict")
            return fail("Invalid configuration for 'enforceActions': " + enforceActions);
        globalState.enforceActions = enforceActions;
        globalState.allowStateChanges =
            enforceActions === true || enforceActions === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (typeof arrayBuffer === "number") {
        reserveArrayBuffer(arrayBuffer);
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

var generatorId = 0;
function flow(generator) {
    if (arguments.length !== 1)
        fail$1("production" && "Flow expects one 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var res = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done)
                    return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise)
                    cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res_1 = gen.return();
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res_1.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new Error("FLOW_CANCELLED"));
            }
            catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return res;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function")
        promise.cancel();
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true
};
function cache(map, key, value, options) {
    if (options.detectCycles)
        map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!isObservable(source))
        return source;
    var detectCycles = options.detectCycles === true;
    if (detectCycles &&
        source !== null &&
        typeof source === "object" &&
        __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
        res.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++)
            res[i] = toAdd[i];
        return res;
    }
    if (isObservableObject(source)) {
        var res = cache(__alreadySeen, source, {}, options);
        keys(source); // make sure we track the keys of the object
        for (var key in source) {
            res[key] = toJSHelper(source[key], options, __alreadySeen);
        }
        return res;
    }
    if (isObservableMap(source)) {
        if (options.exportMapsAsObjects === false) {
            var res_1 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_1.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_1;
        }
        else {
            var res_2 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_2[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_2;
        }
    }
    if (isObservableValue(source))
        return toJSHelper(source.get(), options, __alreadySeen);
    return source;
}
function toJS(source, options) {
    if (!isObservable(source))
        return source;
    // backward compatibility
    if (typeof options === "boolean")
        options = { detectCycles: options };
    if (!options)
        options = defaultOptions;
    var detectCycles = options.detectCycles === true;
    var __alreadySeen;
    if (detectCycles)
        __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail$1("production" !== "production" &&
                "InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail$1("production" !== "production" &&
            "Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail$1("production" !== "production" && "An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "production";
}
catch (e) {
    var g = typeof window !== "undefined" ? window : global;
    if (typeof process === "undefined")
        g.process = {};
    g.process.env = {};
}

(function () {
    function testCodeMinification() { }
    if (testCodeMinification.name !== "testCodeMinification" &&
        "production" !== "production") {
        console.warn("[mobx] you are running a minified build, but 'process.env.NODE_ENV' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
// This line should come after all the imports as well, for the same reason
// as noted above. I will file a bug with rollupjs - @rossipedia
// Devtools support
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        }
    });
}
// TODO: remove in some future build
if (false) {
    var warnedAboutDefaultExport_1 = false;
    Object.defineProperty(module.exports, "default", {
        enumerable: false,
        get: function () {
            if (!warnedAboutDefaultExport_1) {
                warnedAboutDefaultExport_1 = true;
                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
            }
            return undefined;
        }
    });
    [
        "extras",
        "Atom",
        "BaseAtom",
        "asFlat",
        "asMap",
        "asReference",
        "asStructure",
        "autorunAsync",
        "createTranformer",
        "expr",
        "isModifierDescriptor",
        "isStrictModeEnabled",
        "map",
        "useStrict",
        "whyRun"
    ].forEach(function (prop) {
        Object.defineProperty(module.exports, prop, {
            enumerable: false,
            get: function () {
                fail$1("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
            },
            set: function () { }
        });
    });
}
// forward compatibility with mobx, so that packages can easily support mobx 4 & 5
var $mobx = "$mobx";



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(118), __webpack_require__(57)))

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Language__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_url__ = __webpack_require__(37);
var LanguageStore=__WEBPACK_IMPORTED_MODULE_5__models_StatefulStore__["a" /* default */].named('LanguageStore').props({languages:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__models_Language__["a" /* default */]),[]),locale:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string),hasBeenSetup:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].boolean,false)}).actions(function(self){var setupLocale=function setupLocale(newLocale){if(!newLocale){return;}self.locale=newLocale;self.hasBeenSetup=true;};var getRedirectedUrl=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getRedirectedUrl(newLocale){var actualLocale,_getRoot,sectionStore,currentSectionSlug,sectionSlug,otherLanguageSectionData,currentLanguageCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getRedirectedUrl$(_context){while(1){switch(_context.prev=_context.next){case 0:actualLocale=self.activeLocale!==self.locale?self.locale:self.activeLocale;if(!(actualLocale!==newLocale)){_context.next=21;break;}_getRoot=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self),sectionStore=_getRoot.sectionStore;currentSectionSlug='';sectionSlug='';if(!sectionStore.activeSection){_context.next=11;break;}currentSectionSlug=sectionStore.activeSection.slug;_context.next=9;return sectionStore.getSectionDataForLanguage(sectionStore.activeSection.id,newLocale);case 9:otherLanguageSectionData=_context.sent;sectionSlug=otherLanguageSectionData.slug;case 11:currentLanguageCode=Object(__WEBPACK_IMPORTED_MODULE_6__util_url__["g" /* parseLanguageCode */])(window.location.pathname);if(!currentLanguageCode){_context.next=16;break;}return _context.abrupt('return',window.location.pathname.replace('/'+currentLanguageCode+'/'+(currentSectionSlug?currentSectionSlug+'/':''),'/'+newLocale+'/'+(sectionSlug?sectionSlug+'/':''))+window.location.search+window.location.hash);case 16:if(!(self.languages.length>1)){_context.next=20;break;}return _context.abrupt('return','/'+newLocale+'/');case 20:return _context.abrupt('return',window.location);case 21:return _context.abrupt('return',window.location);case 22:case'end':return _context.stop();}}},getRedirectedUrl,this);}));var setup=function setup(languages){self.languages=languages;self.setLoading(false);};var loadLanguages=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadLanguages(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadLanguages$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('languages');case 4:self.languages=_context2.sent;_context2.next=11;break;case 7:_context2.prev=7;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 11:self.setLoading(false);case 12:case'end':return _context2.stop();}}},loadLanguages,this,[[1,7]]);}));return{setupLocale:setupLocale,getRedirectedUrl:getRedirectedUrl,setup:setup,loadLanguages:loadLanguages};}).views(function(self){return{afterAttach:function afterAttach(){function setLuxonDefaultLocale(){// Set locale for luxon
__WEBPACK_IMPORTED_MODULE_2_luxon__["Settings"].defaultLocale=self.activeLocale;}// Update Luxon locale every time it changes
Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["autorun"])(function(){setLuxonDefaultLocale();});setLuxonDefaultLocale();},get activeLocale(){if(!self.hasBeenSetup){return null;}var activeLocale=self.locale;if(!self.locale||self.languages.map(function(language){return language.code;}).indexOf(self.locale)===-1){activeLocale=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore.defaultLocale;}return activeLocale;},get activeLanguage(){return self.activeLocale&&self.findLanguage(self.activeLocale);},findLanguage:function findLanguage(locale){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_4__models_Language__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self.languages),locale);}};});/* harmony default export */ __webpack_exports__["a"] = (LanguageStore);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_magnify__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ImagePreload__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_TranslationStore__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_TranslatedImageType__ = __webpack_require__(212);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_MIN_RATIO=5/2;var DEFAULT_PADDING_FOR_WIDE_IMAGES=100;var defaultImagePath='/img/no_image_available.png';var ProductImage=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductImage,_Component);function ProductImage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductImage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductImage.__proto__||Object.getPrototypeOf(ProductImage)).call.apply(_ref,[this].concat(args))),_this),_this.imageElement=null,_this.state={fullImageLoaded:false,fullImageWidth:0,fullImageHeight:0,imagePadding:false},_this.createProductImageModel=function(imagePath){return __WEBPACK_IMPORTED_MODULE_6__models_ProductImage__["a" /* default */].create({id:1,product_id:'',sizes:{mini:imagePath,small:imagePath,medium:imagePath,large:imagePath,xlarge:imagePath,full:imagePath},description:''});},_this.onImagePreload=function(_ref2){var img=_ref2.target;_this.setState({fullImageLoaded:true,fullImageWidth:img.offsetWidth,fullImageHeight:img.offsetHeight,imagePadding:_this.needsPadding(img)});},_this.getImageAlt=function(){var _this$props=_this.props,product=_this$props.product,configStore=_this$props.configStore;var productImage=_this.getProductImage();var description=configStore.useImageDescriptionAsAlt?productImage.description||product.name:product.name;return[description,product&&product.mainCategory?product.mainCategory.name:'',product.id,productImage.id].join(' - ');},_this.getProductImage=function(){return _this.props.productImage||_this.getDefaultImage();},_this.getDefaultImage=function(){var translationStore=_this.props.translationStore;var defaultImage=translationStore.translatedImages.find(function(image){return image.image_key===__WEBPACK_IMPORTED_MODULE_10__types_TranslatedImageType__["b" /* default */].IMAGE_NOT_FOUND_NAME;});return defaultImage?_this.createProductImageModel(defaultImage.image_path):_this.createProductImageModel(defaultImagePath);},_this.handleImageLoadError=function(e){e.target.onerror=null;e.target.src=_this.getImageSrc(_this.createProductImageModel(defaultImagePath));},_this.getImageSrc=function(productImage){var size=_this.props.size;return productImage.sizes[size]?productImage.sizes[size]:productImage.sizes['full'];},_this.fullImageLargerThanElement=function(){return _this.imageElement&&(_this.imageElement.clientWidth<_this.state.fullImageWidth||_this.imageElement.clientHeight<_this.state.fullImageHeight);},_this.needsPadding=function(img){var configStore=_this.props.configStore;// Padding is added when its width is 2.5 times its height
if(_this.imageElement&&Number(configStore.productImageAspectRatio)>=100){return img.offsetWidth/img.offsetHeight>DEFAULT_MIN_RATIO;}return false;},_this.getModifiedAspectRatio=function(){var _this$props2=_this.props,configStore=_this$props2.configStore,overrideConfigStoreAspectRatio=_this$props2.overrideConfigStoreAspectRatio,customAspectRatio=_this$props2.customAspectRatio;if(_this.state.fullImageLoaded){var width=_this.state.fullImageWidth;var height=_this.state.fullImageHeight;if(width>=height){return DEFAULT_PADDING_FOR_WIDE_IMAGES;}}if(overrideConfigStoreAspectRatio){return customAspectRatio;}else{return configStore.productImageAspectRatio;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductImage,[{key:'render',value:function render(){var _this2=this;var _props=this.props,magnify=_props.magnify,forceAspectRatio=_props.forceAspectRatio,className=_props.className,wrapperClassName=_props.wrapperClassName,overlayIcon=_props.overlayIcon,lazyLoading=_props.lazyLoading;var productImage=this.getProductImage();var imageSrc=this.getImageSrc(productImage);var alt=this.getImageAlt();var imagePreload='';if(magnify){imagePreload=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_ImagePreload__["a" /* default */],{src:productImage.sizes['full'],onImageLoad:this.onImagePreload});}var lazyLoad=lazyLoading?'lazy':'';var image=void 0;if(magnify&&this.state.fullImageLoaded&&this.fullImageLargerThanElement()){image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_image_magnify__["a" /* default */],{fadeDurationInMs:150,hoverDelayInMs:0,className:'ProductImage__small-image-container',style:{width:'100%',height:'100%'},enlargedImageContainerClassName:'ProductImage__magnified-image-container',enlargedImagePosition:'over',smallImage:{alt:alt,isFluidWidth:true,src:imageSrc},largeImage:{alt:alt,src:productImage.sizes['full'],width:this.state.fullImageWidth,height:this.state.fullImageHeight}});}else if(imageSrc){image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imageSrc,alt:alt,onError:this.handleImageLoadError,loading:lazyLoad});}else{image=null;}var style=forceAspectRatio?{paddingBottom:this.getModifiedAspectRatio()+'%'}:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('ProductImage',className,{'ProductImage--force-aspect-ratio':forceAspectRatio}),style:style,ref:function ref(_ref3){return _this2.imageElement=_ref3;}},imagePreload,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('ProductImage__wrapper',wrapperClassName,{'ProductImage__wrapper-wide':this.state.imagePadding})},image),overlayIcon);}}]);return ProductImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductImage.propTypes={// Allows Product, ChildProduct and OrderProduct.
product:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,wrapperClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translationStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_TranslationStore__["a" /* default */]),productImage:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ProductImage__["a" /* default */]),configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]),magnify:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,forceAspectRatio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,overrideConfigStoreAspectRatio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,customAspectRatio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,overlayIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,lazyLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ProductImage.defaultProps={forceAspectRatio:true,lazyLoading:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','translationStore')(ProductImage));

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GenericLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_DefaultSidebar__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarLayout__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This layout is used on at least on HomePage, Manufacturer, OnSale and NewProducts pages
 * that do not have any specific layout requirements or sidebar content.
 */var GenericLayout=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(GenericLayout,_Component);function GenericLayout(){_classCallCheck(this,GenericLayout);return _possibleConstructorReturn(this,(GenericLayout.__proto__||Object.getPrototypeOf(GenericLayout)).apply(this,arguments));}_createClass(GenericLayout,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,content=_props.content;return configStore.mainNavigation.useSidebar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SidebarLayout__["a" /* default */],{className:'GenericLayout GenericLayout--with-sidebar',sidebar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__sidebar_DefaultSidebar__["a" /* default */],null),content:content}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'GenericLayout GenericLayout--full-width'},content);}}]);return GenericLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;GenericLayout.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__["a" /* default */]).isRequired,content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore')(GenericLayout));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Country__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
var CountryStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named('CountryStore').props({countries:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__models_Country__["a" /* default */]),[]),countryCode:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybe(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].number)}).actions(function(self){var setup=function setup(countries,countryCode){self.countries=countries;self.countryCode=countryCode;self.setLoading(false);};var loadCountries=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadCountries(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCountries$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('countries');case 4:self.countries=_context.sent;_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 11:self.setLoading(false);case 12:case'end':return _context.stop();}}},loadCountries,this,[[1,7]]);}));return{setup:setup,loadCountries:loadCountries};}).views(function(self){return{get activeCountry(){return self.countryCode?self.findCountry(self.countryCode):null;},findCountry:function findCountry(countryCode){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_2__models_Country__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self.countries),countryCode);},get countryCount(){return self.countries.length;}};});/* harmony default export */ __webpack_exports__["a"] = (CountryStore);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_flatMap__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Category__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_StatefulStore__ = __webpack_require__(25);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var flatMapWithChildren=function flatMapWithChildren(categories){return categories.length>0?__WEBPACK_IMPORTED_MODULE_1_lodash_flatMap___default()(categories,function(category){return[category].concat(_toConsumableArray(flatMapWithChildren(category.children)));}):[];};var CategoryStore=__WEBPACK_IMPORTED_MODULE_7__models_StatefulStore__["a" /* default */].named('CategoryStore').props({categories:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_5__models_Category__["a" /* default */]),[]),activeCategory:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_5__models_Category__["a" /* default */])),latestActiveCategory:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_5__models_Category__["a" /* default */])),singleState:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED)}).views(function(self){// Either a dedicated observer or a keepAlive computed property
// is required for the result to be actually properly cached
// instead of getting recalculated every time it is called.
// A MST view getter doesn't do this automatically.
var memoizedFlattenedCategories=Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["computed"])(function(){return flatMapWithChildren(self.categories);},{keepAlive:true});return{get flattenedCategories(){return memoizedFlattenedCategories.get();},isInActiveCategoryHierarchy:function isInActiveCategoryHierarchy(category){return self.activeCategory?self.activeCategory.hierarchy.indexOf(category)!==-1:false;}};}).actions(function(self){var ifShoppingCenter=function ifShoppingCenter(){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["g" /* getRoot */])(self).configStore.siteConfig.isShoppingCenter;};var categoriesApi=function categoriesApi(){return ifShoppingCenter()?'shopping-center/categories':'categories';};return{setup:function setup(categories){self.categories=categories;self.setLoading(false);},setSingleStateError:function setSingleStateError(error){self.lastError=Object(__WEBPACK_IMPORTED_MODULE_6__util_error__["a" /* createErrorModel */])(error);self.singleState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR;},loadCategory:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadCategory(id){var categories,category,categoryModel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCategory$(_context){while(1){switch(_context.prev=_context.next){case 0:categories=categoriesApi();self.singleState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING;_context.prev=2;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(categories+'/'+id);case 5:category=_context.sent;categoryModel=self.findCategoryById(category.id);category.children=categoryModel.children;Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["b" /* applySnapshot */])(categoryModel,category);_context.next=15;break;case 11:_context.prev=11;_context.t0=_context['catch'](2);self.setSingleStateError(_context.t0);throw _context.t0;case 15:self.singleState=__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED;case 16:case'end':return _context.stop();}}},loadCategory,this,[[2,11]]);})),findCategoryById:function findCategoryById(categoryId){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_5__models_Category__["a" /* default */],self.categories,categoryId);},setActiveCategory:function setActiveCategory(activeCategoryId){if(activeCategoryId){self.activeCategory=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_5__models_Category__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["g" /* getRoot */])(self),activeCategoryId);if(self.activeCategory){self.latestActiveCategory=self.activeCategory;}}else{self.activeCategory=null;}}};});/* harmony default export */ __webpack_exports__["a"] = (CategoryStore);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(606);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Currency__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
var CurrencyStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named('CurrencyStore').props({currencies:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__models_Currency__["a" /* default */]),[]),currencyCode:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string,'')}).actions(function(self){var setup=function setup(currencies,currencyCode){self.currencies=currencies;self.currencyCode=currencyCode;self.setLoading(false);};var loadCurrencies=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadCurrencies(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCurrencies$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('currencies');case 4:self.currencies=_context.sent;_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 11:self.setLoading(false);case 12:case'end':return _context.stop();}}},loadCurrencies,this,[[1,7]]);}));return{setup:setup,loadCurrencies:loadCurrencies};}).views(function(self){return{get activeCurrency(){return self.currencyCode?self.findCurrency(self.currencyCode):null;},findCurrency:function findCurrency(currencyCode){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_2__models_Currency__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self.currencies),currencyCode);}};});/* harmony default export */ __webpack_exports__["a"] = (CurrencyStore);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatNumber */
/* harmony export (immutable) */ __webpack_exports__["e"] = roundWithPrecision;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatPrice;
/* harmony export (immutable) */ __webpack_exports__["c"] = calculateTotal;
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateNearestProductQuantityWithQuantityStep;
/* harmony export (immutable) */ __webpack_exports__["b"] = calculateProductPackageSizeWithQuantity;
// Based on https://github.com/kvz/locutus/blob/master/src/php/strings/number_format.js
function toFixedFix(n,prec){var k=Math.pow(10,prec);return''+(Math.round(n*k)/k).toFixed(prec);}function formatNumber(number,decimals,decPoint,thousandsSep){number=(number+'').replace(/[^0-9+\-Ee.]/g,'');var n=!isFinite(+number)?0:+number;var prec=!isFinite(+decimals)?0:Math.abs(decimals);var sep=typeof thousandsSep==='undefined'?',':thousandsSep;var dec=typeof decPoint==='undefined'?'.':decPoint;var s=(prec?toFixedFix(n,prec):''+Math.round(n)).split('.');if(s[0].length>3){s[0]=s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g,sep);}if((s[1]||'').length<prec){s[1]=s[1]||'';s[1]+=new Array(prec-s[1].length+1).join('0');}return s.join(dec);}function roundWithPrecision(number,precision){var factor=Math.pow(10,precision);return Math.round(number*factor)/factor;}function formatPrice(price,currency){if(!currency){return'';}return currency.symbol_left+formatNumber(roundWithPrecision(price,currency.precision),currency.decimal_places,currency.decimal_point,currency.thousands_point)+currency.symbol_right;}function calculateTotal(prices,precision){return prices.reduce(function(sum,current){return sum+roundWithPrecision(current,precision);},0);}function calculateNearestProductQuantityWithQuantityStep(quantity,quantityStep){return roundWithPrecision(quantity/quantityStep,2);}function calculateProductPackageSizeWithQuantity(quantityStep,quantity){return Number((quantityStep*quantity).toFixed(1));}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_LinkType__ = __webpack_require__(76);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ButtonLink=function(_Component){_inherits(ButtonLink,_Component);function ButtonLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ButtonLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ButtonLink.__proto__||Object.getPrototypeOf(ButtonLink)).call.apply(_ref,[this].concat(args))),_this),_this.onClick=function(e){e.preventDefault();_this.props.onClick(e);},_this.onKeyPress=function(e){if(e.key===' '||e.key==='Enter'){_this.props.onClick(e);}},_this.getTarget=function(){var type=_this.props.type;if(!type){return;}if(type===__WEBPACK_IMPORTED_MODULE_2__types_LinkType__["b" /* default */].EXTERNAL_LINK){return'_blank';}return'_self';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ButtonLink,[{key:'render',value:function render(){var _props=this.props,className=_props.className,children=_props.children,onClick=_props.onClick,type=_props.type,rest=_objectWithoutProperties(_props,['className','children','onClick','type']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',Object.assign({tabIndex:'0',role:'button',className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('ButtonLink',className),onClick:this.onClick,onKeyPress:this.onKeyPress,target:this.getTarget()},rest),children);}}]);return ButtonLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ButtonLink);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_session__ = __webpack_require__(416);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ApiWrapper=function(){function ApiWrapper(baseURL){var _this=this;var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},hostName=_ref.hostName,userAgent=_ref.userAgent,gclid=_ref.gclid,cuad=_ref.cuad;_classCallCheck(this,ApiWrapper);this.apiAxios=function(){if(!_this.axiosInstance){var config={baseURL:_this.baseURL,headers:{}};if(_this.hostName){config.headers.Host=_this.hostName;}// We need to change user agent for SSR
if(_this.userAgent){config.headers['User-Agent']=_this.userAgent;}var token=Object(__WEBPACK_IMPORTED_MODULE_1__util_session__["a" /* getSessionId */])();if(token){config.headers.Authorization='Bearer '+token;}_this.axiosInstance=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(config);_this.axiosInstance.interceptors.response.use(function(response){return response;},function(error){// Catch all requests with maintenance mode set
if(error.response&&error.response.status===503&&_this.maintenanceCallBack){_this.maintenanceCallBack(true,error.response.data.message);}return Promise.reject(error);});}return _this.axiosInstance;};this.registerMaintenanceCallback=function(callback){_this.maintenanceCallBack=callback;};this.setLanguageCode=function(languageCode){if(languageCode){_this.languageCode=languageCode;}};this.hasLanguageCode=function(){return!!_this.languageCode;};this.setSectionId=function(sectionId){// Set the section ID unconditionally, as some pages (namely, NewProductsPage, OnSalePage and CustomerProductsPage) are implicitly inside
// no section and on them this is set to null. Having a non-null section ID on those pages causes unnecessary
// and misbehaving filtering of results.
_this.sectionId=sectionId;};this.languageCode=null;this.sectionId=null;this.maintenanceCallBack=null;this.baseURL=baseURL;this.hostName=hostName;this.userAgent=userAgent;this.gclid=gclid;this.cuad=cuad;}_createClass(ApiWrapper,[{key:'request',value:function request(url,options){var overrides=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _ref2=options||{},params=_ref2.params,other=_objectWithoutProperties(_ref2,['params']);params=Object.assign({lang:this.languageCode,active_section:overrides?overrides.active_section:this.sectionId,gclid:this.gclid,cuad:this.cuad},params);var config=Object.assign({url:url,params:params},other);return this.apiAxios()(config).then(function(response){return response.data;});}}]);return ApiWrapper;}();/* harmony default export */ __webpack_exports__["a"] = (ApiWrapper);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ORIGINAL_TEXT_KEY='textOriginal';var SWAP_TEXT_KEY='textSwap';var WysiwygContent=function(_Component){_inherits(WysiwygContent,_Component);function WysiwygContent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WysiwygContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WysiwygContent.__proto__||Object.getPrototypeOf(WysiwygContent)).call.apply(_ref,[this].concat(args))),_this),_this.key=0,_this.toggleCollapse=function(element){var collapseSelector=element.getAttribute('href');var collapseElement=_this.container.querySelector(collapseSelector);if(collapseElement){collapseElement.classList.toggle('show');// Save original text, if not set.
if(!element.dataset[ORIGINAL_TEXT_KEY]){element.dataset[ORIGINAL_TEXT_KEY]=element.innerHTML;}if(!element.dataset[SWAP_TEXT_KEY]){element.dataset[SWAP_TEXT_KEY]=element.dataset[ORIGINAL_TEXT_KEY];}element.innerHTML=element.innerHTML===element.dataset[ORIGINAL_TEXT_KEY]?element.dataset[SWAP_TEXT_KEY]:element.dataset[ORIGINAL_TEXT_KEY];}},_this.handleClick=function(e){// We need to support some old Bootstrap "data-toggle" attributes.
if(e.target.dataset&&e.target.dataset.toggle){e.preventDefault();switch(e.target.dataset.toggle){case'collapse':_this.toggleCollapse(e.target);break;default:}}},_this.getElementAttributes=function(element){var attributes={key:_this.key++};Array.from(element.attributes).forEach(function(attr){if(attr.name==='id'){return;}attributes[attr.name]=attr.value;});return attributes;},_this.getParsedScripts=function(){var html=_this.props.html;// Bail if we are in SSR.
if(typeof document==='undefined'){return null;}var doc=document.implementation.createHTMLDocument('');doc.body.innerHTML=html;return[].map.call(doc.getElementsByTagName('script'),function(el){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',_this.getElementAttributes(el),el.textContent);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WysiwygContent,[{key:'componentDidMount',value:function componentDidMount(){if(this.container){this.container.addEventListener('click',this.handleClick,true);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.container){this.container.removeEventListener('click',this.handleClick,true);}}/**
   * Handle elements with data-toggle="collapse"
   *
   * @param element
   */},{key:'render',value:function render(){var _this2=this;var html=this.props.html;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,this.getParsedScripts()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'WysiwygContent',ref:function ref(_ref2){return _this2.container=_ref2;},dangerouslySetInnerHTML:{__html:html}}));}}]);return WysiwygContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WysiwygContent.propTypes={html:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (WysiwygContent);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContentPopup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AdStore__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_AdZones__ = __webpack_require__(78);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var POPUP_COOKIE_NAME='nhcontentpop';var ContentPopup=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ContentPopup,_Component);function ContentPopup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContentPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContentPopup.__proto__||Object.getPrototypeOf(ContentPopup)).call.apply(_ref,[this].concat(args))),_this),_this.state={seenAds:[]},_this.checkSeenAds=function(){var seenAds=__WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.getJSON(POPUP_COOKIE_NAME)||[];_this.setState({seenAds:seenAds});},_this.loadAds=function(){var adStore=_this.props.adStore;adStore.loadAds(_this.getSearchParams());},_this.getSearchParams=function(){var searchParams=_this.props.searchParams;return Object.assign({},searchParams||{},{bannerZone:__WEBPACK_IMPORTED_MODULE_13__types_AdZones__["a" /* default */].POPUP_CONTENT});},_this.sendView=function(ad){var analytics=_this.props.analytics;if(!ad){return;}analytics.promoView([{bannerZone:__WEBPACK_IMPORTED_MODULE_13__types_AdZones__["a" /* default */].POPUP_CONTENT,banner:ad}]);},_this.getUnseenAds=function(){var adStore=_this.props.adStore;var ads=adStore.adQueries.get(Object(__WEBPACK_IMPORTED_MODULE_10__util_query__["a" /* paramsToQueryIdentifier */])(_this.getSearchParams()));if(!ads){return[];}return ads.filter(function(ad){return _this.state.seenAds.indexOf(ad.id)===-1;});},_this.setAdSeen=function(ad){var seenAds=_this.state.seenAds.concat([ad.id]);__WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.set(POPUP_COOKIE_NAME,seenAds);_this.setState({seenAds:seenAds});_this.sendView();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContentPopup,[{key:'componentDidMount',value:function componentDidMount(){this.checkSeenAds();this.loadAds();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.searchParams,this.props.searchParams)){this.loadAds();}}},{key:'render',value:function render(){var _this2=this;var className=this.props.className;var unseenAds=this.getUnseenAds();var firstAd=unseenAds[0];if(!firstAd||window.isSSR){return null;}var toggle=function toggle(){_this2.setAdSeen(firstAd);};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["C" /* Modal */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className,'ContentPopup','ContentPopup_'+firstAd.id),size:'lg',toggle:toggle,isOpen:true,backdrop:'static'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["F" /* ModalHeader */],{toggle:toggle}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:firstAd.content}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["E" /* ModalFooter */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'secondary',onClick:toggle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].closeTitle))));}}]);return ContentPopup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ContentPopup.propTypes={adStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AdStore__["a" /* default */]).isRequired,searchParams:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,analytics:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__analytics_Analytics__["a" /* default */]).isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};ContentPopup.defaultProps={searchParams:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('analytics','adStore')(ContentPopup));

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountModalTabType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var AccountModalTab={LOGIN:'LOGIN',REGISTER:'REGISTER',CHANGE_CLIENT:'CHANGE_CLIENT'};/* harmony default export */ __webpack_exports__["b"] = (AccountModalTab);var AccountModalTabType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('AccountModalTab',Object.values(AccountModalTab));

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MaybeExternalLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_url__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MaybeExternalLink=function(_Component){_inherits(MaybeExternalLink,_Component);function MaybeExternalLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MaybeExternalLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MaybeExternalLink.__proto__||Object.getPrototypeOf(MaybeExternalLink)).call.apply(_ref,[this].concat(args))),_this),_this.isExternal=function(){var type=_this.props.type;return type&&type===__WEBPACK_IMPORTED_MODULE_5__types_LinkType__["b" /* default */].EXTERNAL_LINK;},_this.isInternal=function(){var type=_this.props.type;return type&&(type===__WEBPACK_IMPORTED_MODULE_5__types_LinkType__["b" /* default */].PAGE_LINK||type===__WEBPACK_IMPORTED_MODULE_5__types_LinkType__["b" /* default */].INTERNAL_LINK);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MaybeExternalLink,[{key:'render',value:function render(){var _props=this.props,host=_props.host,to=_props.to,className=_props.className,active=_props.active,children=_props.children,type=_props.type,rest=_objectWithoutProperties(_props,['host','to','className','active','children','type']);var classNameString=__WEBPACK_IMPORTED_MODULE_3_classnames___default()('MaybeExternalLink',className,{active:active});if(this.isExternal()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',Object.assign({target:'_blank',rel:'noopener',href:Object(__WEBPACK_IMPORTED_MODULE_6__util_url__["k" /* transformExternalLink */])(to),className:classNameString},rest),this.props.children);}if(this.isInternal()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],Object.assign({to:type===__WEBPACK_IMPORTED_MODULE_5__types_LinkType__["b" /* default */].INTERNAL_LINK?Object(__WEBPACK_IMPORTED_MODULE_6__util_url__["l" /* transformInternalLink */])(to):Object(__WEBPACK_IMPORTED_MODULE_6__util_url__["i" /* stripHostIfMatches */])(to,host),exact:true,className:classNameString,isActive:function isActive(match){return typeof active==='boolean'?active:match;}},rest),children);}var url=Object(__WEBPACK_IMPORTED_MODULE_6__util_url__["i" /* stripHostIfMatches */])(to,host);var isNormalLink=Object(__WEBPACK_IMPORTED_MODULE_6__util_url__["e" /* isNotHandledByReactRouter */])(url);return isNormalLink?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',Object.assign({href:url,className:classNameString},rest),this.props.children):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],Object.assign({to:url,exact:true,className:classNameString,isActive:function isActive(match){return typeof active==='boolean'?active:match;}},rest),children);}}]);return MaybeExternalLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MaybeExternalLink.propTypes={to:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,host:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])(function(stores){return{host:stores.locationContext.host};})(MaybeExternalLink));

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var LinkType={EXTERNAL_LINK:'EXTERNAL_LINK',INTERNAL_LINK:'INTERNAL_LINK',PAGE_LINK:'PAGE_LINK'};/* harmony default export */ __webpack_exports__["b"] = (LinkType);var LinkTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('LinkType',Object.values(LinkType));

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_FormField__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldError=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FieldError,_Component);function FieldError(){_classCallCheck(this,FieldError);return _possibleConstructorReturn(this,(FieldError.__proto__||Object.getPrototypeOf(FieldError)).apply(this,arguments));}_createClass(FieldError,[{key:'render',value:function render(){var field=this.props.field;if(!field.errors||field.errors.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["t" /* FormFeedback */],{className:'FieldError'},field.errors[0]);}}]);return FieldError;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FieldError.propTypes={field:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_FormField__["b" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (FieldError);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AdZones={MAIN_BANNER:'MAIN_BANNER',MAIN_TEXT_CAROUSEL:'MAIN_TEXT_CAROUSEL',PRODUCT_PAGE_BANNER_1:'PRODUCT_PAGE_BANNER_1',PRODUCT_PAGE_BANNER_2:'PRODUCT_PAGE_BANNER_2',PRODUCT_PAGE_BANNER_3:'PRODUCT_PAGE_BANNER_3',PRODUCT_PAGE_BANNER_4:'PRODUCT_PAGE_BANNER_4',SIDEBAR_BANNER:'SIDEBAR_BANNER',FOOTER_BANNER:'FOOTER_BANNER',INFO_PAGE_BANNER:'INFO_PAGE_BANNER',POPUP_CONTENT:'POPUP_CONTENT',PRODUCT_PAGE_CONTENT_1:'PRODUCT_PAGE_CONTENT_1',PRODUCT_PAGE_CONTENT_2:'PRODUCT_PAGE_CONTENT_2',PRODUCT_PAGE_CONTENT_3:'PRODUCT_PAGE_CONTENT_3',PRODUCT_PAGE_CONTENT_4:'PRODUCT_PAGE_CONTENT_4',HEADER_CONTENT:'HEADER_CONTENT',ORDER_CONFIRMATION_CONTENT:'ORDER_CONFIRMATION_CONTENT',NOT_FOUND_CONTENT:'NOT_FOUND_CONTENT',MEGA_MENU_BANNER:'MEGA_MENU_BANNER'};/* harmony default export */ __webpack_exports__["a"] = (AdZones);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Price=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Price',{with_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,without_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number}).views(function(self){return{getPrice:function getPrice(withTax){return withTax?self.with_tax:self.without_tax;}};});/* harmony default export */ __webpack_exports__["a"] = (Price);

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(293);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isInViewport */
/* harmony export (immutable) */ __webpack_exports__["g"] = getElementRelativeTop;
/* harmony export (immutable) */ __webpack_exports__["f"] = getElementRelativeBottom;
/* harmony export (immutable) */ __webpack_exports__["e"] = getElementById;
/* harmony export (immutable) */ __webpack_exports__["c"] = countElementYOffsetFromDocumentTop;
/* harmony export (immutable) */ __webpack_exports__["i"] = scrollToElementById;
/* harmony export (immutable) */ __webpack_exports__["h"] = scrollToElement;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDocumentScrollTop;
/* harmony export (immutable) */ __webpack_exports__["b"] = blockScroll;
/* harmony export (immutable) */ __webpack_exports__["a"] = allowScroll;
function isInViewport(element){var topOffset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var top=getElementRelativeTop(element);return top>=topOffset&&top<=window.innerHeight;}function getElementRelativeTop(element){return element.getBoundingClientRect().top;}function getElementRelativeBottom(element){return element.getBoundingClientRect().bottom;}function getElementById(id){if(typeof document==='undefined'){return null;}return document.getElementById(id);}function countElementYOffsetFromDocumentTop(element){return window.pageYOffset+getElementRelativeTop(element);}function scrollToElementById(id,options,elementYFromDocumentTop){var element=getElementById(id);if(!element){return null;}if(!elementYFromDocumentTop){elementYFromDocumentTop=countElementYOffsetFromDocumentTop(element);}scrollToElement(element,options,elementYFromDocumentTop);}function scrollToElement(element,options,elementYFromDocumentTop){if(element){var supportsBehavior=element.style.scrollBehavior!==undefined;if(supportsBehavior){window.scroll(Object.assign({top:elementYFromDocumentTop,behavior:'smooth'},options));}else{window.scroll(0,elementYFromDocumentTop);}}}function getDocumentScrollTop(){if(typeof document==='undefined'){return null;}return window.pageYOffset||document.body.scrollTop||document.documentElement.scrollTop;}function blockScroll(){var _getSafeDocument2=_getSafeDocument(),safeDocument=_getSafeDocument2.safeDocument,html=_getSafeDocument2.html;var body=safeDocument.body;if(!body||!body.style){return;}var scrollBarWidth=window.innerWidth-html.clientWidth;var bodyPaddingRight=parseInt(window.getComputedStyle(body).getPropertyValue('padding-right'),10)||0;/**
   * 1. Fixes a bug in iOS and desktop Safari whereby setting
   *    `overflow: hidden` on the html/body does not prevent scrolling.
   * 2. Fixes a bug in desktop Safari where `overflowY` does not prevent
   *    scroll if an `overflow-x` style is also applied to the body.
   */html.style.position='relative';/* [1] */html.style.overflow='hidden';/* [2] */body.style.position='relative';/* [1] */body.style.overflow='hidden';/* [2] */body.style.paddingRight=bodyPaddingRight+scrollBarWidth+'px';}function allowScroll(){var _getSafeDocument3=_getSafeDocument(),safeDocument=_getSafeDocument3.safeDocument,html=_getSafeDocument3.html;var body=safeDocument.body;if(!body||!body.style){return;}html.style.position='';html.style.overflow='';body.style.position='';body.style.overflow='';body.style.paddingRight='';}var _getSafeDocument=function _getSafeDocument(){var safeDocument=typeof document!=='undefined'?document:{};var html=safeDocument.documentElement;return{safeDocument:safeDocument,html:html};};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(410);
var isBuffer = __webpack_require__(707);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(178),
    createAggregator = __webpack_require__(220);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(778),
    baseMatchesProperty = __webpack_require__(795),
    identity = __webpack_require__(149),
    isArray = __webpack_require__(47),
    property = __webpack_require__(798);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductImageSizes=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductImageSizes',{mini:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),small:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),medium:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),large:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),xlarge:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),full:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});var ProductImage=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductImage',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,sizes:ProductImageSizes,description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),for_color_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});/* harmony default export */ __webpack_exports__["a"] = (ProductImage);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProductSortOrderBy={BRAND:'MANUFACTURER',CAMPAIGN_DATE_ADDED:'CAMPAIGN_DATE_ADDED',CATEGORY:'CATEGORY',DATE_ADDED:'DATE_ADDED',DISCOUNT:'DISCOUNT',ID:'ID',NAME:'NAME',PRICE:'PRICE',RECOMMENDED_SORT_ORDER:'RECOMMENDED_SORT_ORDER',RELEVANCE:'RELEVANCE',REVIEWS_AVERAGE:'REVIEWS_AVERAGE',SALES:'SALES'};/* harmony default export */ __webpack_exports__["a"] = (ProductSortOrderBy);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANCHOR_ID; });
/* unused harmony export MainProductList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_partition__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_partition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_partition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_head__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_set__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_has__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_unset__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_unset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_unset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_setWith__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_setWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_setWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types_FilterType__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ProductList__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FilteringOptions__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ActiveFilterList__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ProductListTools__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_Paginator__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__anchor_ScrollableAnchor__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__BooleanFilter__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__NoProductsFound__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__head_SEOPagination__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__head_RobotsMeta__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ProductListFilter__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__types_ProductSortOrderBy__ = __webpack_require__(86);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSortParameters={ORDER_BY:'orderBy',ORDER:'order'};// set treats numeric keys as arrays, we use setWith to force objects
var setObject=function setObject(object,path,value){__WEBPACK_IMPORTED_MODULE_8_lodash_setWith___default()(object,path,value,Object);};var ANCHOR_ID='mainProductList';var IN_STOCK_FILTER_KEY='inStock';var MainProductList=Object(__WEBPACK_IMPORTED_MODULE_10_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(MainProductList,_Component);function MainProductList(props){_classCallCheck(this,MainProductList);var _this=_possibleConstructorReturn(this,(MainProductList.__proto__||Object.getPrototypeOf(MainProductList)).call(this,props));_initialiseProps.call(_this);_this.state={showAllFilters:false,searchTerm:''};_this.validateActiveSortParameters();_this.loadProducts();return _this;}_createClass(MainProductList,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(!__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default()(prevProps.fixedParams,this.props.fixedParams)||!__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default()(prevState.searchParameters,this.getSearchParameters())||prevState.searchTerm!==this.state.searchTerm){this.loadProducts();}this.validateFilters();}/**
   *  Check if current filters can all be found in the current search result.
   *  If not, remove them, because it means they are not longer valid.
   */},{key:'render',value:function render(){var _this2=this;var _props=this.props,configStore=_props.configStore,productStore=_props.productStore,fixedParams=_props.fixedParams,name=_props.name,showSort=_props.showSort,cardSettings=_props.cardSettings,redirectOnSingleMatch=_props.redirectOnSingleMatch,showCategoryFilter=_props.showCategoryFilter,productParams=_props.productParams,showCategoryHeaders=_props.showCategoryHeaders,advancedSearchPage=_props.advancedSearchPage;var showAllFilters=this.state.showAllFilters;if(!productStore||!fixedParams){return;}return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div',{className:'MainProductList'},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__anchor_ScrollableAnchor__["a" /* default */],{id:ANCHOR_ID}),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__loader_ContentForState__["a" /* default */],{state:this.getCurrentSearchState(),forLoaded:function forLoaded(){var searchResult=_this2.getCurrentSearchResult();var products=searchResult.data;var hasProducts=products&&products.length>0;var filters=searchResult&&searchResult.available_filters?searchResult.available_filters.filter(function(filter){if(filter.key==='cross_categories'){return showCategoryFilter;}return!__WEBPACK_IMPORTED_MODULE_3_lodash_has___default()(fixedParams,filter.key);}):[];var countOfProducts=searchResult?searchResult.total:0;var activeFilters=_this2.getActiveFilters();var shouldRedirectToProduct=redirectOnSingleMatch&&products.length===1&&countOfProducts===1&&activeFilters.length===0;if(shouldRedirectToProduct){return _this2.redirectToProduct(__WEBPACK_IMPORTED_MODULE_1_lodash_head___default()(products));}// In stock filter is shown separately
var _partition2=__WEBPACK_IMPORTED_MODULE_0_lodash_partition___default()(filters,['key',IN_STOCK_FILTER_KEY]),_partition3=_slicedToArray(_partition2,2),inStockFilters=_partition3[0],restOfFilters=_partition3[1];var inStockFilter=__WEBPACK_IMPORTED_MODULE_1_lodash_head___default()(inStockFilters);var restOfActiveFilters=activeFilters.filter(function(activeFilter){return activeFilter.key!==IN_STOCK_FILTER_KEY;});var doShowHeaders=showCategoryHeaders||_this2.getSelectedSortOrderBy()===__WEBPACK_IMPORTED_MODULE_37__types_ProductSortOrderBy__["a" /* default */].CATEGORY||!_this2.getSelectedSortOrderBy()&&!advancedSearchPage&&configStore.productList.defaultSortOption===__WEBPACK_IMPORTED_MODULE_37__types_ProductSortOrderBy__["a" /* default */].CATEGORY;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div',{className:'MainProductList__content'},activeFilters.length>0?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__head_RobotsMeta__["a" /* default */],{noindex:true}):_this2.getSEOPagination(),hasProducts&&__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__FilteringOptions__["a" /* default */],{filters:restOfFilters,activeFilters:restOfActiveFilters,onAcceptFilter:_this2.onAcceptFilter,toggleShowAll:_this2.toggleShowAll,showAllFilters:showAllFilters,inGrid:true}),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ActiveFilterList__["a" /* default */],{activeFilters:restOfActiveFilters,removeFilter:_this2.removeFilter,clearFilters:_this2.clearFilters,horizontal:true}),(hasProducts||_this2.state.searchTerm)&&_this2.renderProductListFilter(),!configStore.siteConfig.isHomePage&&__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div',{className:'MainProductList__active-filter-row'},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ProductListTools__["a" /* default */],{countOfProducts:countOfProducts,style:configStore.productListStyle,onStyleSelect:_this2.onStyleSelect,onSelectSort:_this2.onSelectSortOrder,selectedSortOrderBy:_this2.getSelectedSortOrderBy(),selectedSortOrder:_this2.getSelectedSortOrder(),showSort:showSort}),!configStore.hideProductWithZeroQuantity&&configStore.siteConfig.isWebStore&&__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__BooleanFilter__["a" /* default */],{onAccept:_this2.onInStockAccept,filter:inStockFilter,isSelected:configStore.inStockProductsOnly})),hasProducts?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ProductList__["a" /* default */],{products:products,name:name,style:configStore.productListStyle,cardSettings:cardSettings,productParams:productParams,showCategoryHeaders:doShowHeaders}):__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__NoProductsFound__["a" /* default */],null),hasProducts&&_this2.getPaginator());}}));}}],[{key:'transformParameters',/**
   * Transform "f "and "s" to "filter" and "sort".
   */value:function transformParameters(parameters){parameters.filters=parameters.f||{};delete parameters.f;parameters.sort=parameters.s||{};delete parameters.s;return parameters;}/**
   * Transform "filter" and "sort" to "f" and "f".
   */},{key:'transformParametersBeforeStringify',value:function transformParametersBeforeStringify(parameters){parameters.f=parameters.filters;delete parameters.filters;parameters.s=parameters.sort;delete parameters.sort;return parameters;}}]);return MainProductList;}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]),_class2.propsToSearchParameters=function(props){var search=props.location.search;var parsedSearchParameters=Object(__WEBPACK_IMPORTED_MODULE_17__util_queryString__["b" /* parse */])(search);return MainProductList.transformParameters(parsedSearchParameters);},_initialiseProps=function _initialiseProps(){var _this3=this;this.getSearchParameters=function(){return MainProductList.propsToSearchParameters(_this3.props);};this.validateFilters=function(){var searchParameters=_this3.getSearchParameters();var searchResult=_this3.getCurrentSearchResult();if(searchResult&&searchResult.available_filters){var validFilters={};searchResult.available_filters.forEach(function(filter){var currentValue=__WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(searchParameters.filters,filter.key);if(currentValue){setObject(validFilters,filter.key,currentValue);}});if(!__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default()(searchParameters.filters,validFilters)){_this3.setSearchParameters(Object.assign({},searchParameters,{filters:validFilters}));}}};this.validateActiveSortParameters=function(){var _props2=_this3.props,configStore=_props2.configStore,productStore=_props2.productStore;var productListSelectors=configStore.productList.productListSortSelectors;var searchParameters=_this3.getSearchParameters();if(!productListSelectors||!searchParameters.sort||!Object.keys(searchParameters.sort).length){return;}var activeProductSortSelectors=productStore.activeProductSortList();var validSortParameter=activeProductSortSelectors.find(function(ss){return ss.sortKey===searchParameters.sort.orderBy&&ss.sortOrder===searchParameters.sort.order;});if(!validSortParameter){searchParameters.sort={};_this3.setSearchParameters(searchParameters);}};this.getQueryIdentifier=function(){var productLoadParameters=_this3.getProductLoadParameters();productLoadParameters=_this3.addSearchtermToProductLoadParameters(productLoadParameters);return Object(__WEBPACK_IMPORTED_MODULE_29__util_query__["a" /* paramsToQueryIdentifier */])(productLoadParameters);};this.getCurrentSearchResult=function(){return _this3.props.productStore.productQueryResults.get(_this3.getQueryIdentifier());};this.getCurrentSearchState=function(){return _this3.props.productStore.productQueryStates.get(_this3.getQueryIdentifier());};this.setSearchParameters=function(parameters){var history=_this3.props.history;history.push({search:Object(__WEBPACK_IMPORTED_MODULE_17__util_queryString__["c" /* stringify */])(MainProductList.transformParametersBeforeStringify(Object.assign({},parameters,{// Always reset page to 1 when filtering changes
page:1})))});};this.getProductLoadParameters=function(){var _props3=_this3.props,fixedParams=_props3.fixedParams,configStore=_props3.configStore,showCategoryFilter=_props3.showCategoryFilter;var searchParameters=_this3.getSearchParameters();if(!searchParameters){return Object.assign({},fixedParams);}if(showCategoryFilter&&_this3.categoryFilterActive(searchParameters)&&fixedParams.cross_categories){delete fixedParams.cross_categories;return Object.assign({inStock:configStore.inStockProductsOnly?'1':'0',page:searchParameters.page},searchParameters.filters,searchParameters.sort,fixedParams);}return Object.assign({inStock:configStore.inStockProductsOnly?'1':'0',page:searchParameters.page},searchParameters.filters,searchParameters.sort,fixedParams);};this.categoryFilterActive=function(searchParameters){return searchParameters.filters.cross_categories&&searchParameters.filters.cross_categories.length>0;};this.loadProducts=function(){var _props4=_this3.props,productStore=_props4.productStore,allSections=_props4.allSections,urlOverride=_props4.urlOverride;var productLoadParameters=_this3.getProductLoadParameters();productLoadParameters=_this3.addSearchtermToProductLoadParameters(productLoadParameters);if(!_this3.getCurrentSearchResult()&&!_this3.getCurrentSearchState()){productStore.loadProducts(productLoadParameters,allSections,urlOverride);}};this.addSearchtermToProductLoadParameters=function(productLoadParameters){if(!_this3.props.configStore.productListFilter.enabled||!_this3.state.searchTerm){return productLoadParameters;}productLoadParameters.text=_this3.state.searchTerm;return productLoadParameters;};this.onAcceptFilter=function(filter,value){var searchParameters=__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this3.getSearchParameters());switch(filter.type){case __WEBPACK_IMPORTED_MODULE_18__types_FilterType__["b" /* default */].BOOLEAN:{if(value){setObject(searchParameters.filters,filter.key,1);}else{__WEBPACK_IMPORTED_MODULE_4_lodash_unset___default()(searchParameters.filters,filter.key);}break;}case __WEBPACK_IMPORTED_MODULE_18__types_FilterType__["b" /* default */].RANGE:{setObject(searchParameters.filters,filter.key,{min:Number(value[0]),max:Number(value[1])});break;}case __WEBPACK_IMPORTED_MODULE_18__types_FilterType__["b" /* default */].TERM:{setObject(searchParameters.filters,filter.key,value);break;}default:{console.error('Unknown filter type '+filter.type);}}_this3.setSearchParameters(searchParameters);};this.onInStockAccept=function(filter,inStockFilterValue){var configStore=_this3.props.configStore;if(configStore.inStockProductsOnly!==inStockFilterValue){configStore.setInStockProductsOnly(inStockFilterValue);}_this3.loadProducts();};this.onStyleSelect=function(style){var configStore=_this3.props.configStore;configStore.setProductListStyle(style);};this.getActiveFilters=function(){var searchResult=_this3.getCurrentSearchResult();if(!searchResult||!searchResult.available_filters){return[];}var searchParameters=__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this3.getSearchParameters());return searchResult.available_filters.reduce(function(activeFilters,filter){if(__WEBPACK_IMPORTED_MODULE_3_lodash_has___default()(searchParameters.filters,filter.key)){var filterValue=__WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(searchParameters.filters,filter.key);activeFilters.push({key:filter.key,filter:filter,name:filter.name,value:filterValue.min||filterValue.max?null:filterValue,min:filterValue.min?Number(filterValue.min):null,max:filterValue.max?Number(filterValue.max):null});}return activeFilters;},[]);};this.removeFilter=function(activeFilter,valueToRemove){var searchParameters=__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this3.getSearchParameters());switch(activeFilter.filter.type){case __WEBPACK_IMPORTED_MODULE_18__types_FilterType__["b" /* default */].TERM:{var values=__WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(searchParameters.filters,activeFilter.key);var indexToRemove=values.indexOf(valueToRemove);if(indexToRemove!==-1)values.splice(indexToRemove,1);break;}case __WEBPACK_IMPORTED_MODULE_18__types_FilterType__["b" /* default */].RANGE:{__WEBPACK_IMPORTED_MODULE_4_lodash_unset___default()(searchParameters.filters,activeFilter.key+'[min]');__WEBPACK_IMPORTED_MODULE_4_lodash_unset___default()(searchParameters.filters,activeFilter.key+'[max]');break;}default:{__WEBPACK_IMPORTED_MODULE_4_lodash_unset___default()(searchParameters.filters,activeFilter.key);}}_this3.setSearchParameters(searchParameters);};this.clearFilters=function(){_this3.setSearchParameters(Object.assign({},_this3.getSearchParameters(),{filters:[]}));};this.onSelectSortOrder=function(sortOrderKey,ascDesc){var searchParameters=__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this3.getSearchParameters());if(sortOrderKey){__WEBPACK_IMPORTED_MODULE_2_lodash_set___default()(searchParameters.sort,ProductSortParameters.ORDER_BY,sortOrderKey);}else{__WEBPACK_IMPORTED_MODULE_4_lodash_unset___default()(searchParameters.sort,ProductSortParameters.ORDER_BY);}if(ascDesc){__WEBPACK_IMPORTED_MODULE_2_lodash_set___default()(searchParameters.sort,ProductSortParameters.ORDER,ascDesc);}else{__WEBPACK_IMPORTED_MODULE_4_lodash_unset___default()(searchParameters.sort,ProductSortParameters.ORDER);}_this3.setSearchParameters(searchParameters);};this.getSelectedSortOrderBy=function(){var searchParameters=_this3.getSearchParameters();return __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(searchParameters.sort,ProductSortParameters.ORDER_BY);};this.getSelectedSortOrder=function(){var searchParameters=_this3.getSearchParameters();return __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(searchParameters.sort,ProductSortParameters.ORDER);};this.renderProductListFilter=function(){var disableQuickSearch=_this3.props.disableQuickSearch;if(disableQuickSearch){return null;}return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_reactstrap__["l" /* Col */],{lg:8,xl:6,className:'MainProductList__active-filter--quicksearch mr-lg-auto'},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__ProductListFilter__["a" /* default */],{onProductListFiltering:_this3.filterProductList,clearProductListFilter:_this3.clearProductListFilter,searchTerm:_this3.state.searchTerm})));};this.filterProductList=function(searchTerm){if(searchTerm){_this3.setState({searchTerm:searchTerm});}if(!searchTerm&&_this3.state.searchTerm){_this3.clearProductListFilter();}};this.clearProductListFilter=function(){if(_this3.state.searchTerm){_this3.setState({searchTerm:''});}};this.getSEOPagination=function(){var location=_this3.props.location;var _getCurrentSearchResu=_this3.getCurrentSearchResult(),lastPage=_getCurrentSearchResu.last_page,currentPage=_getCurrentSearchResu.current_page;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__head_SEOPagination__["a" /* default */],{currentPage:currentPage,lastPage:lastPage,path:location.pathname});};this.getPaginator=function(){var location=_this3.props.location;var _getCurrentSearchResu2=_this3.getCurrentSearchResult(),lastPage=_getCurrentSearchResu2.last_page,currentPage=_getCurrentSearchResu2.current_page;if(lastPage<2){return null;}var searchTemplate=void 0;var regex=/page=(\d+?)(?=(&|$))/;var pageParameter='page=:page';var urlEncodedParameters=Object(__WEBPACK_IMPORTED_MODULE_33__util_url__["c" /* escapeUrlParametersForPaginatorTemplate */])(location.search);if(location.search.charAt(0)!=='?'){searchTemplate=location.search+'?'+pageParameter;}else{searchTemplate=urlEncodedParameters.match(regex)?urlEncodedParameters.replace(regex,pageParameter):urlEncodedParameters+'&'+pageParameter;}var pathTemplate=Object(__WEBPACK_IMPORTED_MODULE_33__util_url__["b" /* escapeUrlForPaginatorTemplate */])(location.pathname)+searchTemplate;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Paginator__["a" /* default */],{pathTemplate:pathTemplate,currentPage:currentPage,lastPage:lastPage,pagesToShow:5,onClick:_this3.scrollToTop});};this.redirectToProduct=function(product){var routeService=_this3.props.routeService;var path=product.class===__WEBPACK_IMPORTED_MODULE_34__types_ProductClass__["b" /* default */].MULTI_CHILD?product.pathWithActiveProductId(product.id):product.path;var pathToNavigate=routeService.getProductPath(product,path);return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router__["a" /* Redirect */],{to:pathToNavigate});};this.scrollToTop=function(){Object(__WEBPACK_IMPORTED_MODULE_25__util_dom__["i" /* scrollToElementById */])(ANCHOR_ID,{behavior:'instant'});};this.toggleShowAll=function(){_this3.setState({showAllFilters:!_this3.state.showAllFilters});};},_temp))||_class;MainProductList.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_28__store_ConfigStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_ProductStore__["a" /* default */]).isRequired,fixedParams:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired,name:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,showSort:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,allSections:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,history:__WEBPACK_IMPORTED_MODULE_12_react_router_prop_types___default.a.history.isRequired,location:__WEBPACK_IMPORTED_MODULE_12_react_router_prop_types___default.a.location.isRequired,redirectOnSingleMatch:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,routeService:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_35__services_RouteService__["a" /* default */]).isRequired,showCategoryFilter:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,urlOverride:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,productListFilterTerm:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,clearProductListFilter:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,searchTerm:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,disableQuickSearch:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,showCategoryHeaders:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,advancedSearchPage:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool};MainProductList.defaultProps={showSort:true,allSections:false,redirectOnSingleMatch:false,urlOverride:null,disableQuickSearch:false,showCategoryHeaders:false,advancedSearchPage:false};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_10_mobx_react__["c" /* inject */])('configStore','productStore','routeService')(MainProductList)));

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(397);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_Paths__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorHandler=function(_Component){_inherits(ErrorHandler,_Component);function ErrorHandler(){_classCallCheck(this,ErrorHandler);return _possibleConstructorReturn(this,(ErrorHandler.__proto__||Object.getPrototypeOf(ErrorHandler)).apply(this,arguments));}_createClass(ErrorHandler,[{key:'render',value:function render(){var _props=this.props,error=_props.error,intl=_props.intl,routeService=_props.routeService;if(!error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UnexpectedError__["a" /* default */],null);}if(error.httpStatusCode===404){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_8__types_Paths__["a" /* default */].NotFoundPage)});}if(error.publicMessage){var text=void 0;if(error.publicMessage.id){text=intl.formatMessage(error.publicMessage);}else{text=error.publicMessage;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'danger'},text);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UnexpectedError__["a" /* default */],null);}}]);return ErrorHandler;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ErrorHandler.propTypes={error:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({httpStatusCode:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,publicMessage:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,defaultMessage:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string})])}),intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('routeService')(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(ErrorHandler)));

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_FormField__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Field=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Field,_Component);function Field(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Field);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Field.__proto__||Object.getPrototypeOf(Field)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(event){_this.props.field.setValue(event.target.value);},_this.handleBlur=function(){if(_this.props.field.value){_this.props.field.setShouldValidate(true);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Field,[{key:'render',value:function render(){var _props=this.props,Component=_props.component,field=_props.field,handleChange=_props.handleChange,value=_props.value,rest=_objectWithoutProperties(_props,['component','field','handleChange','value']);var fieldValue=void 0;if(['radio','checkbox'].indexOf(rest.type)===-1&&field.value!==undefined&&field.value!==null){fieldValue=field.value;}else if(value){fieldValue=value;}else{fieldValue='';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({valid:field.valid,invalid:field.errors.length>0,value:fieldValue,onChange:handleChange||this.handleChange,onBlur:this.handleBlur},rest));}}]);return Field;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;Field.propTypes={field:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_FormField__["b" /* default */]).isRequired,component:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Field);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
var ProductPriceInfo=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductPriceInfo',{price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */],normal_price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */],valid_until_html:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,valid_until:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),is_discount:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,discount_percentage:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)}).views(function(self){return{getSavings:function getSavings(withTax){return self.getNormalPrice(withTax)-self.getPrice(withTax);},getPrice:function getPrice(withTax){return self.price.getPrice(withTax);},getNormalPrice:function getNormalPrice(withTax){return self.normal_price.getPrice(withTax);}};});/* harmony default export */ __webpack_exports__["a"] = (ProductPriceInfo);

/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortOrder={ASC:'ASC',DESC:'DESC'};/* harmony default export */ __webpack_exports__["a"] = (SortOrder);

/***/ }),
/* 96 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MainBanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BannerSlider__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainBanner=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MainBanner,_Component);function MainBanner(){_classCallCheck(this,MainBanner);return _possibleConstructorReturn(this,(MainBanner.__proto__||Object.getPrototypeOf(MainBanner)).apply(this,arguments));}_createClass(MainBanner,[{key:'render',value:function render(){var _props=this.props,className=_props.className,searchParams=_props.searchParams,fullWidth=_props.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BannerSlider__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_4__types_AdZones__["a" /* default */].MAIN_BANNER},searchParams),className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('MainBanner',{'MainBanner--container-width':!fullWidth},className),aspectRatio:2.85,maximumCrossAxisSize:400});}}]);return MainBanner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MainBanner.propTypes={className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,searchParams:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])(function(stores){return{fullWidth:stores.configStore.mainBanner.fullWidth};})(MainBanner));

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigationEntityLink__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigationEntityTextItem__ = __webpack_require__(737);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationEntityItem=function(_Component){_inherits(NavigationEntityItem,_Component);function NavigationEntityItem(){_classCallCheck(this,NavigationEntityItem);return _possibleConstructorReturn(this,(NavigationEntityItem.__proto__||Object.getPrototypeOf(NavigationEntityItem)).apply(this,arguments));}_createClass(NavigationEntityItem,[{key:'render',value:function render(){var _props=this.props,entity=_props.entity,rest=_objectWithoutProperties(_props,['entity']);var path=entity.path;if(!entity){return null;}var Component=path?__WEBPACK_IMPORTED_MODULE_2__NavigationEntityLink__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_3__NavigationEntityTextItem__["a" /* default */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({entity:entity},rest));}}]);return NavigationEntityItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NavigationEntityItem.propTypes={entity:__WEBPACK_IMPORTED_MODULE_1__types_NavigationEntity__["a" /* default */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (NavigationEntityItem);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductTypeClass={PHYSICAL:'PHYSICAL',PAYMENT_COST:'PAYMENT_COST',SHIPPING_COST:'SHIPPING_COST',DISCOUNT:'DISCOUNT',SERVICE:'SERVICE',BOTTLE_DEPOSIT:'BOTTLE_DEPOSIT',LOW_ORDER_FEE:'LOW_ORDER_FEE'};/* harmony default export */ __webpack_exports__["b"] = (ProductTypeClass);var ProductType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductTypeClass',Object.values(ProductTypeClass));

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_RecurringOrdersPaginator__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_RecurringOrder__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_createMSTPatch__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_ShippingOption__ = __webpack_require__(190);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var RecurringOrderStore=__WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__["a" /* default */].named('RecurringOrderStore').props({orders:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_5__models_RecurringOrder__["a" /* default */]),{}),orderStates:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["a" /* RequestStateType */]),{}),shippingOptions:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_9__models_ShippingOption__["a" /* default */])),{}),shippingOptionStates:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["a" /* RequestStateType */]),{}),orderQueryResults:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__models_RecurringOrdersPaginator__["a" /* default */]),{}),orderQueryStates:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["a" /* RequestStateType */]),{})}).views(function(self){return{get ordersArray(){return Array.from(self.orders,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;});},get optionsArray(){return Array.from(self.shippingOptions,function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],value=_ref4[1];return value;});}};}).actions(function(self){return{loadOrders:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadOrders(searchParameters){var queryIdentifier,orderPaginator,recurringOrders;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadOrders$(_context){while(1){switch(_context.prev=_context.next){case 0:queryIdentifier=Object(__WEBPACK_IMPORTED_MODULE_6__util_query__["a" /* paramsToQueryIdentifier */])(searchParameters);self.setLoading(true);self.orderQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING);_context.prev=3;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('recurring-orders?'+Object(__WEBPACK_IMPORTED_MODULE_7__util_queryString__["c" /* stringify */])(searchParameters));case 6:orderPaginator=_context.sent;recurringOrders=orderPaginator.data;// Update individual orders and statuses
recurringOrders.forEach(function(order){var oldOrder=self.orders.get(order.id);if(oldOrder){var patch=Object(__WEBPACK_IMPORTED_MODULE_8__util_createMSTPatch__["a" /* default */])(oldOrder,order);Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["a" /* applyPatch */])(oldOrder,patch);}else{self.orders.set(order.id,order);}self.orderStates.set(order.id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED);});// Set current query results
self.orderQueryResults.set(queryIdentifier,Object.assign({},orderPaginator,{data:recurringOrders.map(function(order){return order.id;})}));_context.next=17;break;case 12:_context.prev=12;_context.t0=_context['catch'](3);self.setError(_context.t0);self.orderQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR);throw _context.t0;case 17:self.orderQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED);self.setLoading(false);case 19:case'end':return _context.stop();}}},loadOrders,this,[[3,12]]);})),loadOrder:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadOrder(id){var page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadOrder$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.orderStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('recurring-orders/'+id);case 4:page=_context2.sent;self.orders.set(id,page);_context2.next=13;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);self.orderStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR);throw _context2.t0;case 13:self.orderStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED);case 14:case'end':return _context2.stop();}}},loadOrder,this,[[1,8]]);})),loadOrderShippingOptions:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadOrderShippingOptions(id){var options;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadOrderShippingOptions$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:self.shippingOptionStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING);_context3.prev=1;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('recurring-orders/'+id+'/shipping-options');case 4:options=_context3.sent;self.shippingOptions.set(id,options);_context3.next=13;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);self.setError(_context3.t0);self.shippingOptionStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR);throw _context3.t0;case 13:self.shippingOptionStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED);case 14:case'end':return _context3.stop();}}},loadOrderShippingOptions,this,[[1,8]]);})),removeOrder:function removeOrder(id){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete('recurring-orders/'+id);},updateOrder:function updateOrder(orderId,order){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().put('recurring-orders/'+orderId,order);},addProduct:function addProduct(orderId,product){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('recurring-orders/'+orderId+'/product',product);},updateProduct:function updateProduct(orderId,params){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().put('recurring-orders/'+orderId+'/product',params);},removeProduct:function removeProduct(orderId,params){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete('recurring-orders/'+orderId+'/product',{params:params});}};});/* harmony default export */ __webpack_exports__["a"] = (RecurringOrderStore);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_formValidators__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var FormValidator=function(){function FormValidator(configStore){_classCallCheck(this,FormValidator);// We only need formValidation from configStore, but we pass in configStore to
// keep up with possible changes.
this.configStore=configStore;}_createClass(FormValidator,[{key:'config',value:function config(){return this.configStore.formValidation;}},{key:'firstName',value:function firstName(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().firstName.minLength)];}},{key:'lastName',value:function lastName(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().lastName.minLength)];}},{key:'fullName',value:function fullName(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().firstName.minLength)];}},{key:'email',value:function email(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().email.minLength),Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["d" /* isEmail */])(label)];}},{key:'telephone',value:function telephone(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().telephone.minLength)];}},{key:'streetAddress',value:function streetAddress(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().streetAddress.minLength)];}},{key:'postalCode',value:function postalCode(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().postalCode.minLength)];}},{key:'city',value:function city(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().city.minLength)];}},{key:'username',value:function username(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().username.minLength)];}},{key:'password',value:function password(label){return[Object(__WEBPACK_IMPORTED_MODULE_0__util_formValidators__["e" /* minLength */])(label,this.config().password.minLength)];}}]);return FormValidator;}();/* harmony default export */ __webpack_exports__["a"] = (FormValidator);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(1236);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(139),
    getRawTag = __webpack_require__(649),
    objectToString = __webpack_require__(650);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileNavigationTabType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var MobileNavigationTab={PRODUCTS:'PRODUCTS',INFO:'INFO',ACCOUNT:'ACCOUNT',WISHLIST:'WISHLIST'};/* harmony default export */ __webpack_exports__["b"] = (MobileNavigationTab);var MobileNavigationTabType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('MobileNavigationTab',Object.values(MobileNavigationTab));

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(286);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Coupon__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_CouponActivationType__ = __webpack_require__(297);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CouponStore=__WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__["a" /* default */].named('CouponStore').props({coupons:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_3__models_Coupon__["a" /* default */]),{})}).views(function(self){return{get couponsArray(){return Array.from(self.coupons,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;});},get timerCoupons(){return self.couponsArray.filter(function(coupon){return coupon.activation_type===__WEBPACK_IMPORTED_MODULE_4__types_CouponActivationType__["b" /* default */].VISIT_TIME;});},get loginCoupon(){return self.firstCouponOfActivationType(__WEBPACK_IMPORTED_MODULE_4__types_CouponActivationType__["b" /* default */].LOGIN);},get registrationCoupon(){return self.firstCouponOfActivationType(__WEBPACK_IMPORTED_MODULE_4__types_CouponActivationType__["b" /* default */].REGISTRATION);},get newsletterCoupon(){return self.firstCouponOfActivationType(__WEBPACK_IMPORTED_MODULE_4__types_CouponActivationType__["b" /* default */].NEWSLETTER_SUBSCRIPTION);},get reviewCoupon(){return self.firstCouponOfActivationType(__WEBPACK_IMPORTED_MODULE_4__types_CouponActivationType__["b" /* default */].PRODUCT_REVIEW);},firstCouponOfActivationType:function firstCouponOfActivationType(type){return self.couponsArray.find(function(coupon){return coupon.activation_type===type;});}};}).actions(function(self){return{setup:function setup(coupons){self.coupons=__WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default()(coupons,'id');self.setLoading(false);},activateCoupon:function activateCoupon(id){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('coupons/'+id+'/activate');},sendCoupon:function sendCoupon(email,couponCode){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('coupons/send',{email:email,couponCode:couponCode});},setCoupon:function setCoupon(couponCode){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('coupons/set',{couponCode:couponCode});},retrieveCoupon:function retrieveCoupon(couponId,activationId,email){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('coupons/retrieve',{couponId:couponId,activationId:activationId,email:email});}};});/* harmony default export */ __webpack_exports__["a"] = (CouponStore);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_CustomNavigationLink__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkParentType__ = __webpack_require__(182);
var CustomNavigationLinkStore=__WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__["a" /* default */].named('CustomNavigationLinkStore').props({customNavigationLinks:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__models_CustomNavigationLink__["a" /* default */]),[])}).views(function(self){return{filterByCategoryId:function filterByCategoryId(id){return self.customNavigationLinks.filter(function(link){return link.tree_type===__WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkParentType__["a" /* default */].CATEGORY&&link.parent_sibling_id===id;});},filterBySectionId:function filterBySectionId(id){return self.customNavigationLinks.filter(function(link){return link.tree_type===__WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkParentType__["a" /* default */].SECTION&&link.parent_sibling_id===id;});},findChildLinks:function findChildLinks(id){return self.customNavigationLinks.filter(function(link){return link.tree_type===__WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkParentType__["a" /* default */].CUSTOM_NAVIGATION_LINK&&link.parent_sibling_id===id;});}};}).actions(function(self){var setup=function setup(customNavigationLinks){self.customNavigationLinks=customNavigationLinks;self.setLoading(false);};return{setup:setup};});/* harmony default export */ __webpack_exports__["a"] = (CustomNavigationLinkStore);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Manufacturer__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_RequestState__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ManufacturerStore=__WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__["a" /* default */].named('ManufacturerStore').props({manufacturers:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_3__models_Manufacturer__["a" /* default */]),{}),manufacturerContentStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["a" /* RequestStateType */]),{}),loadedWithContent:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].boolean,false)}).views(function(self){return{get manufacturersArray(){return Array.from(self.manufacturers,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;}).sort(function(a,b){return a.name.localeCompare(b.name);});},get manufacturersWithProducts(){return self.manufacturersArray.filter(function(manufacturer){return manufacturer.has_products;});},get hasManufacturers(){return self.manufacturersArray.length>0;}};}).actions(function(self){var ifShoppingCenter=function ifShoppingCenter(){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["g" /* getRoot */])(self).configStore.siteConfig.isShoppingCenter;};var baseApi=function baseApi(endpoint){return ifShoppingCenter()?'shopping-center/'+endpoint:''+endpoint;};return{setup:function setup(manufacturers){self.manufacturers=__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(manufacturers,'id');self.setLoading(false);},loadManufacturer:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadManufacturer(id){var manufacturer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadManufacturer$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);self.manufacturerContentStates.set(id,__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADING);_context.prev=2;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(baseApi('manufacturers')+'/'+id);case 5:manufacturer=_context.sent;self.manufacturers.set(manufacturer.id,manufacturer);self.manufacturerContentStates.set(id,__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADED);_context.next=15;break;case 10:_context.prev=10;_context.t0=_context['catch'](2);self.setError(_context.t0);self.manufacturerContentStates.set(id,__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].ERROR);throw _context.t0;case 15:self.setLoading(false);case 16:case'end':return _context.stop();}}},loadManufacturer,this,[[2,10]]);})),loadManufacturers:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadManufacturers(){var excludeContent=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var manufacturers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadManufacturers$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(baseApi('manufacturers')+'?excludeContent='+Number(excludeContent));case 4:manufacturers=_context2.sent;self.manufacturers.merge(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(manufacturers,'id'));if(excludeContent===false){self.loadedWithContent=true;manufacturers.forEach(function(manufacturer){self.manufacturerContentStates.set(manufacturer.id,__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADED);});}_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 13:self.setLoading(false);case 14:case'end':return _context2.stop();}}},loadManufacturers,this,[[1,9]]);}))};});/* harmony default export */ __webpack_exports__["a"] = (ManufacturerStore);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderTotalType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var OrderTotalClass={TOTAL:'TOTAL',TAXLESS_TOTAL:'TAX_FREE_TOTAL',TAX_TOTAL:'TAX_TOTAL',EXTRA_TOTAL:'EXTRA_TOTAL',PRODUCTS_TOTAL:'PRODUCTS_TOTAL'};/* harmony default export */ __webpack_exports__["b"] = (OrderTotalClass);var OrderTotalType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('OrderTotalClass',Object.values(OrderTotalClass));

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_CheckboxFieldItem__ = __webpack_require__(1053);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckboxField=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CheckboxField,_Component);function CheckboxField(props){_classCallCheck(this,CheckboxField);// In the normal use cases, the form and field names don't change, and
// this only really affects the input/label binding, so not updating the id
// afterwards if props change should still be fine.
var _this=_possibleConstructorReturn(this,(CheckboxField.__proto__||Object.getPrototypeOf(CheckboxField)).call(this,props));_this.handleChange=function(event){var field=_this.props.field;var isChecked=event.target.checked;var value=String(event.target.value);if(_this.hasMultipleOptions()){if(isChecked){field.setValue([].concat(_toConsumableArray(field.value),[value]));}else{_this.removeValue(value);}}else{if(isChecked){field.setValue(value);}else{field.setValue(null);}}};_this.hasMultipleOptions=function(){var options=_this.props.options;return Array.isArray(options)||Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["isObservableArray"])(options);};_this.removeValue=function(value){var field=_this.props.field;var newValue=[].concat(_toConsumableArray(field.value));var valueIndex=newValue.findIndex(function(item){return item===value;});if(valueIndex!==-1){newValue.splice(valueIndex,1);}field.setValue(newValue);};_this.isChecked=function(value){var field=_this.props.field;if(!field.value){return false;}if(Array.isArray(field.value)||Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["isObservableArray"])(field.value)){return field.value.indexOf(String(value))!==-1;}return value===field.value;};_this.createUniqueKey=function(option,index){return __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(option+'--'+index);};_this.id=__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(props.formName+'__'+props.fieldName+'--');return _this;}_createClass(CheckboxField,[{key:'getOptionArray',value:function getOptionArray(){var options=this.props.options;if(this.hasMultipleOptions()){return options;}else{return[options];}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,fieldName=_props.fieldName,field=_props.field,required=_props.required,className=_props.className,options=_props.options,formName=_props.formName,rest=_objectWithoutProperties(_props,['label','fieldName','field','required','className','options','formName']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('CheckboxField',className),tag:'fieldset',id:this.id},label&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckboxField__label'},label,required&&' *'),this.getOptionArray().map(function(option,index){var optionId=_this2.id+'-'+index;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],{className:'CheckboxFieldSet__checkbox-field',check:true,key:_this2.createUniqueKey(option.value,index)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Field__["a" /* default */],Object.assign({component:__WEBPACK_IMPORTED_MODULE_4_reactstrap__["v" /* Input */],field:field,type:'checkbox',name:fieldName,id:optionId,checked:_this2.isChecked(option.value),value:option.value,handleChange:_this2.handleChange,invalid:field.errors.length>0,required:required},rest)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{'for':optionId,check:true},option.label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FieldError__["a" /* default */],{field:field}));}));}}]);return CheckboxField;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;CheckboxField.propTypes={field:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["b" /* default */]).isRequired,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,formName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,fieldName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,// Options should be:
// - An array(-like), if the field value is expected to be an array of
//   primitives, even with a single option
// - A bare checkbox field shape, if the field value is expected to be
//   a primitive
options:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_11__types_CheckboxFieldItem__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11__types_CheckboxFieldItem__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(__WEBPACK_IMPORTED_MODULE_11__types_CheckboxFieldItem__["a" /* default */])]).isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CheckboxField);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getStorageAndParse;
/* harmony export (immutable) */ __webpack_exports__["c"] = stringifyAndSetStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteStorageItem;
function getStorageAndParse(key){var storage=localStorage.getItem(key);return JSON.parse(storage);}function stringifyAndSetStorage(key,value){var storage=JSON.stringify(value);localStorage.setItem(key,storage);}function deleteStorageItem(key){localStorage.removeItem(key);}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AdPages={FRONT_PAGE:'FRONT_PAGE',NEW_PRODUCTS:'NEW_PRODUCTS',CAMPAIGN_PRODUCTS:'CAMPAIGN_PRODUCTS',CUSTOMER_PRODUCTS:'CUSTOMER_PRODUCTS',RECOMMENDED_PRODUCTS:'RECOMMENDED_PRODUCTS',POPULAR_PRODUCTS:'POPULAR_PRODUCTS',SOLD_PRODUCTS:'SOLD_PRODUCTS',NOT_FOUND_PAGE:'NOT_FOUND_PAGE'};/* harmony default export */ __webpack_exports__["a"] = (AdPages);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Order__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_OrdersPaginator__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_createMSTPatch__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_CurrentOrder__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_Error__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_error__ = __webpack_require__(46);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var OrderStore=__WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__["a" /* default */].named('OrderStore').props({orders:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_5__models_Order__["a" /* default */]),{}),orderStates:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["a" /* RequestStateType */]),{}),orderQueryResults:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_6__models_OrdersPaginator__["a" /* default */]),{}),orderQueryStates:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["a" /* RequestStateType */]),{}),currentOrder:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_9__models_CurrentOrder__["a" /* default */]),currentOrderState:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].NONE),lastCurrentOrderError:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_10__models_Error__["a" /* default */])}).views(function(self){return{get ordersArray(){return Array.from(self.orders,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;});}};}).actions(function(self){var getLang=function getLang(){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).languageStore.activeLanguage.code;};var ifShoppingCenter=function ifShoppingCenter(){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore.siteConfig.isShoppingCenter;};var baseApi=function baseApi(endpoint){return ifShoppingCenter()?'shopping-center/instant-shopping/order/'+endpoint:'current-order/'+endpoint;};return{loadOrder:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadOrder(id,hash){var order;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadOrder$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(self.orderStates.get(id)===__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED)){_context.next=2;break;}return _context.abrupt('return');case 2:self.orderStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING);_context.prev=3;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('my-account/order/'+id,{params:{hash:hash}});case 6:order=_context.sent;self.orders.set(id,order);_context.next=15;break;case 10:_context.prev=10;_context.t0=_context['catch'](3);self.setError(_context.t0);self.orderStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR);throw _context.t0;case 15:self.orderStates.set(id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED);case 16:case'end':return _context.stop();}}},loadOrder,this,[[3,10]]);})),loadOrders:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadOrders(searchParameters){var queryIdentifier,orderPaginator,orders;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadOrders$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:queryIdentifier=Object(__WEBPACK_IMPORTED_MODULE_7__util_query__["a" /* paramsToQueryIdentifier */])(searchParameters);self.setLoading(true);self.orderQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING);_context2.prev=3;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('my-account/orders?'+Object(__WEBPACK_IMPORTED_MODULE_4__util_queryString__["c" /* stringify */])(searchParameters));case 6:orderPaginator=_context2.sent;orders=orderPaginator.data;// Update individual orders and statuses
orders.forEach(function(order){var oldOrder=self.orders.get(order.id);if(oldOrder){var patch=Object(__WEBPACK_IMPORTED_MODULE_8__util_createMSTPatch__["a" /* default */])(oldOrder,order);Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["a" /* applyPatch */])(oldOrder,patch);}else{self.orders.set(order.id,order);}self.orderStates.set(order.id,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED);});// Set current query results
self.orderQueryResults.set(queryIdentifier,Object.assign({},orderPaginator,{data:orders.map(function(order){return order.id;})}));_context2.next=17;break;case 12:_context2.prev=12;_context2.t0=_context2['catch'](3);self.setError(_context2.t0);self.orderQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR);throw _context2.t0;case 17:self.orderQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED);self.setLoading(false);case 19:case'end':return _context2.stop();}}},loadOrders,this,[[3,12]]);})),loadCurrentOrderPostPurchase:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadCurrentOrder(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCurrentOrder$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:self.currentOrderState=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING;if(params){params.lang=getLang();}_context3.prev=2;_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+baseApi('success'),{params:params},{active_section:null});case 5:self.currentOrder=_context3.sent;_context3.next=13;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](2);self.lastCurrentOrderError=Object(__WEBPACK_IMPORTED_MODULE_11__util_error__["a" /* createErrorModel */])(_context3.t0);self.currentOrderState=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR;throw _context3.t0;case 13:self.currentOrderState=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED;case 14:case'end':return _context3.stop();}}},loadCurrentOrder,this,[[2,8]]);}))};});/* harmony default export */ __webpack_exports__["a"] = (OrderStore);

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    now = __webpack_require__(648),
    toNumber = __webpack_require__(398);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Error=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Error',{httpStatusCode:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),publicMessage:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].union(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,defaultMessage:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string})))});/* harmony default export */ __webpack_exports__["a"] = (Error);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ViewBreakpointType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewBreakpointMinWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var _ViewBreakpointMinWid;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ViewBreakpoint={XS:'XS',SM:'SM',MD:'MD',LG:'LG',XL:'XL',XXL:'XXL'};/* harmony default export */ __webpack_exports__["c"] = (ViewBreakpoint);var ViewBreakpointType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ViewBreakpoint',Object.values(ViewBreakpoint));var ViewBreakpointMinWidth=(_ViewBreakpointMinWid={},_defineProperty(_ViewBreakpointMinWid,ViewBreakpoint.XS,0),_defineProperty(_ViewBreakpointMinWid,ViewBreakpoint.SM,576),_defineProperty(_ViewBreakpointMinWid,ViewBreakpoint.MD,768),_defineProperty(_ViewBreakpointMinWid,ViewBreakpoint.LG,992),_defineProperty(_ViewBreakpointMinWid,ViewBreakpoint.XL,1200),_defineProperty(_ViewBreakpointMinWid,ViewBreakpoint.XXL,1400),_ViewBreakpointMinWid);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_LinkType__ = __webpack_require__(76);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var Category=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Category',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,name_in_navigation:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),slug:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,link_type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),parent_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),children:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].late(function(){return Category;})),[]),discount:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),is_new:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean),image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),description_html:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),SEO_title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),SEO_description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),footer_description_html:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),show_category_filter:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean)}).views(function(self){return{getNonBlockedChildren:function getNonBlockedChildren(blockedCategoriesDict){return self.children&&self.children.filter(function(category){return!blockedCategoriesDict[category.id];});},get hierarchy(){return[].concat(_toConsumableArray(self.ancestors),[self]);},get parentCategory(){if(self.parent_id!==null&&self.parent_id!==undefined){return Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["k" /* resolveIdentifier */])(Category,Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["g" /* getRoot */])(self),self.parent_id);}return null;},get ancestors(){var ancestors=[];var currentCategory=self;while(currentCategory.parentCategory){var parent=currentCategory.parentCategory;ancestors.push(parent);currentCategory=parent;}ancestors.reverse();return ancestors;},get mainCategory(){return self.hierarchy[0];},get path(){var categories=self.hierarchy;if(self.link_type===__WEBPACK_IMPORTED_MODULE_3__types_LinkType__["b" /* default */].EXTERNAL_LINK||self.link_type===__WEBPACK_IMPORTED_MODULE_3__types_LinkType__["b" /* default */].INTERNAL_LINK){return self.slug;}return Object(__WEBPACK_IMPORTED_MODULE_2__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__types_Paths__["a" /* default */].Category,{id:self.id,rootProductGroup:categories[0].slug,productGroup:categories[1]&&categories[1].slug,subProductGroup:categories[2]&&categories[2].slug});},get breadcrumbs(){var breadcrumbSections=self.ancestors.map(function(ancestor){return{text:ancestor.name,url:ancestor.path};});breadcrumbSections.push({text:self.name,url:self.path});return breadcrumbSections;},get navigationName(){return self.name_in_navigation&&self.name_in_navigation.length>0?self.name_in_navigation:self.name;}};});/* harmony default export */ __webpack_exports__["a"] = (Category);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(750),
    getValue = __webpack_require__(753);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(284),
    isLength = __webpack_require__(288);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_InfoPage__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Error__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_error__ = __webpack_require__(46);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var InfoPageStore=__WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__["a" /* default */].named('InfoPageStore').props({pages:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_3__models_InfoPage__["a" /* default */]),{}),pageStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["a" /* RequestStateType */]),{}),lastSinglePageError:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6__models_Error__["a" /* default */])}).views(function(self){return{get pagesArray(){return Array.from(self.pages,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;});}};}).actions(function(self){return{loadPage:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadPage(id){var page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadPage$(_context){while(1){switch(_context.prev=_context.next){case 0:self.pageStates.set(id,__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADING);self.lastSinglePageError=null;_context.prev=2;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('pages/'+id);case 5:page=_context.sent;self.pages.set(id,page);_context.next=15;break;case 9:_context.prev=9;_context.t0=_context['catch'](2);self.setError(_context.t0);self.lastSinglePageError=Object(__WEBPACK_IMPORTED_MODULE_7__util_error__["a" /* createErrorModel */])(_context.t0);self.pageStates.set(id,__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].ERROR);throw _context.t0;case 15:self.pageStates.set(id,__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADED);case 16:case'end':return _context.stop();}}},loadPage,this,[[2,9]]);})),loadPages:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadPages(){var pages;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadPages$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('pages');case 4:pages=_context2.sent;self.pages.merge(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(pages,'id'));_context2.next=12;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 12:self.setLoading(false);case 13:case'end':return _context2.stop();}}},loadPages,this,[[1,8]]);}))};});/* harmony default export */ __webpack_exports__["a"] = (InfoPageStore);

/***/ }),
/* 127 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationContextPropType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LocationContext=function(){function LocationContext(protocol,host,href){_classCallCheck(this,LocationContext);this._protocol=protocol;this._host=host;this._href=href;}_createClass(LocationContext,[{key:'callOrReturn',value:function callOrReturn(value){return __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(value)?value():value;}},{key:'protocol',get:function get(){return this.callOrReturn(this._protocol);}},{key:'host',get:function get(){return this.callOrReturn(this._host);}},{key:'href',get:function get(){return this.callOrReturn(this._href);}}]);return LocationContext;}();var LocationContextPropType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocol:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,host:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,href:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});/* harmony default export */ __webpack_exports__["b"] = (LocationContext);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScrollableAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollableAnchor=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ScrollableAnchor,_Component);function ScrollableAnchor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ScrollableAnchor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ScrollableAnchor.__proto__||Object.getPrototypeOf(ScrollableAnchor)).call.apply(_ref,[this].concat(args))),_this),_this.container=null,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ScrollableAnchor,[{key:'componentDidMount',value:function componentDidMount(){this.checkIfInHash();}},{key:'checkIfInHash',value:function checkIfInHash(){var _props=this.props,location=_props.location,id=_props.id,scrollIfInHash=_props.scrollIfInHash;if(scrollIfInHash&&location.hash){var idInHash=Object(__WEBPACK_IMPORTED_MODULE_7__util_url__["f" /* parseHash */])(location.hash);if(idInHash===id){Object(__WEBPACK_IMPORTED_MODULE_8__util_dom__["h" /* scrollToElement */])(this.container);}}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,id=_props2.id,uiStore=_props2.uiStore,offset=_props2.offset,className=_props2.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(_ref2){return _this2.container=_ref2;},className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ScrollableAnchor',className),id:id,style:{top:-(uiStore.headerHeight+offset)}});}}]);return ScrollableAnchor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ScrollableAnchor.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_UIStore__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.location.isRequired,id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,offset:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,scrollIfInHash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};ScrollableAnchor.defaultProps={offset:0,scrollIfInHash:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('uiStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* withRouter */])(ScrollableAnchor)));

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEODescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GenericMeta__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEODescription=function(_Component){_inherits(SEODescription,_Component);function SEODescription(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SEODescription);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SEODescription.__proto__||Object.getPrototypeOf(SEODescription)).call.apply(_ref,[this].concat(args))),_this),_this.outputTitle=function(description){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'description',content:description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GenericMeta__["a" /* default */],{name:'twitter:description',property:'og:description',content:description}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SEODescription,[{key:'render',value:function render(){var content=this.props.content;var shouldTranslate=content&&content.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,shouldTranslate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],content,this.outputTitle):this.outputTitle(content));}}]);return SEODescription;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SEODescription.propTypes={content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (SEODescription);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This is a custom column component that allows us to use an "xxl" breakpoint.
 * Cf. https://github.com/reactstrap/reactstrap/issues/297#issuecomment-273556116
 */var CustomCol=function(_Component){_inherits(CustomCol,_Component);function CustomCol(){_classCallCheck(this,CustomCol);return _possibleConstructorReturn(this,(CustomCol.__proto__||Object.getPrototypeOf(CustomCol)).apply(this,arguments));}_createClass(CustomCol,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],Object.assign({widths:['xs','sm','md','lg','xl','xxl','xxxl']},this.props));}}]);return CustomCol;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CustomCol);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(115);
var core = __webpack_require__(96);
var ctx = __webpack_require__(537);
var hide = __webpack_require__(167);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(197);
var IE8_DOM_DEFINE = __webpack_require__(538);
var toPrimitive = __webpack_require__(355);
var dP = Object.defineProperty;

exports.f = __webpack_require__(134) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(168)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 135 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RobotsMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RobotsMeta=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RobotsMeta,_Component);function RobotsMeta(){_classCallCheck(this,RobotsMeta);return _possibleConstructorReturn(this,(RobotsMeta.__proto__||Object.getPrototypeOf(RobotsMeta)).apply(this,arguments));}_createClass(RobotsMeta,[{key:'render',value:function render(){var _props=this.props,noindex=_props.noindex,nofollow=_props.nofollow;var tags=[];if(noindex){tags.push('noindex');}if(nofollow){tags.push('nofollow');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'robots',content:tags.join(', ')}));}}]);return RobotsMeta;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RobotsMeta.propTypes={noindex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,nofollow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (RobotsMeta);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isObjectLike = __webpack_require__(90);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(88);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Modal=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Modal',{isOpen:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false)}).actions(function(self){return{toggle:function toggle(){self.isOpen=!self.isOpen;}};});/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_TranslatedImage__ = __webpack_require__(729);
var TranslationStore=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('TranslationStore',{messages:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].frozen(),{}),translatedImages:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__models_TranslatedImage__["a" /* default */])}).actions(function(self){return{setup:function setup(messages,translatedImages){self.messages=messages;self.translatedImages=translatedImages;}};});/* harmony default export */ __webpack_exports__["a"] = (TranslationStore);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccountModalLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_AccountModalTab__ = __webpack_require__(74);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccountModalLink=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AccountModalLink,_Component);function AccountModalLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AccountModalLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AccountModalLink.__proto__||Object.getPrototypeOf(AccountModalLink)).call.apply(_ref,[this].concat(args))),_this),_this.toggle=function(){_this.props.accountStore.accountModal.setTab(_this.props.tab);_this.props.accountStore.accountModal.toggle();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AccountModalLink,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'AccountModalLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["I" /* NavLink */],{onClick:this.toggle,href:'#',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(this.props.className)},this.props.children));}}]);return AccountModalLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AccountModalLink.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_AccountStore__["a" /* default */]).isRequired,tab:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(Object.values(__WEBPACK_IMPORTED_MODULE_7__types_AccountModalTab__["b" /* default */])).isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore')(AccountModalLink));

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(47),
    isKey = __webpack_require__(282),
    stringToPath = __webpack_require__(744),
    toString = __webpack_require__(108);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(138);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(423),
    createBaseEach = __webpack_require__(777);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(424),
    baseKeys = __webpack_require__(426),
    isArrayLike = __webpack_require__(125);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(217),
    isArrayLike = __webpack_require__(125),
    isIndex = __webpack_require__(219),
    isObject = __webpack_require__(89);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CustomNavigationLinkLocationType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CustomNavigationLinkLocation={ABOVE:'ABOVE',BELOW:'BELOW'};/* harmony default export */ __webpack_exports__["a"] = (CustomNavigationLinkLocation);var CustomNavigationLinkLocationType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CustomNavigationLinkLocation',Object.values(CustomNavigationLinkLocation));

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BannerSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_resize_detector__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lazyload__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Banner__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Slider__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AdLoader__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_ViewBreakpoint__ = __webpack_require__(122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
When slider first time initializes, it's properties (e.g. css classes) cannot be changed from outside
without refreshing the slider by using slick-specific methods.
https://github.com/kenwheeler/slick#methods
*/var SLIDER_SETTINGS={arrows:true,autoplay:true,autoplaySpeed:5000,centerMode:true,draggable:true,infinite:true,// Responsive images refreshes the slider when they hit the breakpoint.
responsive:[{breakpoint:__WEBPACK_IMPORTED_MODULE_13__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].SM,settings:{slidesToShow:1}}],swipeToSlide:true,variableWidth:true};// Mobile Aspect ratio 1:1. e.g. 250x250px or as close as possible.
var MOBILE_ASPECT_RATIO=1;var BannerSlider=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BannerSlider,_Component);function BannerSlider(props){_classCallCheck(this,BannerSlider);var _this=_possibleConstructorReturn(this,(BannerSlider.__proto__||Object.getPrototypeOf(BannerSlider)).call(this,props));_this.getAds=function(){return function(ads){if(!ads||ads.length===0){return null;}var className=_this.props.className;var slides=_this.getSlides(ads);var cssClasses=__WEBPACK_IMPORTED_MODULE_5_classnames___default()('BannerSlider',className);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:cssClasses,id:_this.id,ref:_this.updateElement},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Slider__["a" /* default */],Object.assign({},_this.getSettings(ads.length),{sliderRef:function sliderRef(ref){return _this.bannerSliderRef=ref;}}),slides),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_resize_detector__["a" /* default */],{handleWidth:true,onResize:_this.handleResize,refreshMode:'throttle',refreshRate:1000}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style',null,_this.getCSS(ads)));};};_this.getSlides=function(ads){return ads.map(function(banner){var searchParams=_this.props.searchParams;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:banner.id,className:'BannerSlider__slide'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Banner__["a" /* default */],{banner:banner,bannerZone:searchParams.bannerZone,isMobileBanner:_this.props.uiStore.isSmallest}));});};_this.updateElement=function(element){// Ref is stored in state because we want to force a rerender (which will
// trigger a new call to getCss()) after the element is first created.
if(_this.state.element!==element){_this.setState(function(){return{element:element};});}};_this.getSettings=function(slideCount){var settingOverrides=_this.props.settingOverrides;var effectiveSettings=Object.assign({},SLIDER_SETTINGS,settingOverrides);if(effectiveSettings.vertical){effectiveSettings.slidesToShow=Math.min(slideCount,effectiveSettings.slidesToShow);}return effectiveSettings;};_this.handleResize=function(){var element=_this.state.element;if(!element){return null;}var elementWidth=element.clientWidth;if(_this.state.elementWidth!==elementWidth){_this.setState({elementWidth:elementWidth});}};_this.getCSS=function(ads){var elementWidth=_this.state.elementWidth;if(!_this.state.element||!elementWidth){return'';}var aspectRatio=_this.getAspectRatio(ads);var maximumCrossAxisSize=_this.getMaximumHeight(ads);var mainAxis=_this.getMainAxis();var crossAxis=_this.getCrossAxis();if(mainAxis==='width'){var mainAxisSize=_this.countMainAxisSize(elementWidth,aspectRatio);var crossAxisSize=_this.countMinCrossAxisSize(maximumCrossAxisSize,mainAxisSize);var mainAxisDefaultSize=_this.countMainAxisDefaultSize(crossAxisSize,aspectRatio);var _this$getBannerMobile=_this.getBannerMobileCssClasses(ads),bannerWrapper=_this$getBannerMobile.bannerWrapper,bannerBackgroundImage=_this$getBannerMobile.bannerBackgroundImage;return'\n        #'+_this.id+' .BannerSlider__slide '+bannerWrapper+',\n        #'+_this.id+' .BannerSlider__slide '+bannerBackgroundImage+' {\n          '+crossAxis+': '+crossAxisSize+'px\n        }\n        #'+_this.id+' .BannerSlider__slide {\n          max-'+mainAxis+': '+elementWidth+'px;\n        }\n        #'+_this.id+' .BannerSlider__slide .Banner--default-width {\n          '+mainAxis+': '+mainAxisDefaultSize+'px;\n        }\n        ';}else{var _crossAxisSize=_this.countMinCrossAxisSize(maximumCrossAxisSize,_this.getCrossAxisSize());var _mainAxisSize=_this.countMainAxisSize(_crossAxisSize,aspectRatio);return'\n        #'+_this.id+' .BannerSlider__slide img {\n          max-'+crossAxis+': '+_crossAxisSize+'px;\n        }\n        #'+_this.id+' .BannerSlider__slide {\n          '+mainAxis+': '+_mainAxisSize+'px;\n        }\n        ';}};_this.getBannerMobileCssClasses=function(ads){var ifMoreThanOneMobileImages=_this.filterVisibleMobileBanners(ads).length>=1;var bannerWrapper=ifMoreThanOneMobileImages?'.Banner__wrapper-mobile':'.Banner__wrapper';var bannerBackgroundImage=ifMoreThanOneMobileImages?'.Banner__background-mobile-image':'.Banner__background-image';return{bannerWrapper:bannerWrapper,bannerBackgroundImage:bannerBackgroundImage};};_this.getAspectRatio=function(ads){return _this.filterVisibleMobileBanners(ads).length>=1?MOBILE_ASPECT_RATIO:_this.props.aspectRatio;};_this.getMaximumHeight=function(ads){return _this.filterVisibleMobileBanners(ads).length>=1?_this.state.elementWidth:_this.props.maximumCrossAxisSize;};_this.getMainAxis=function(){return _this.getSettings().vertical?'height':'width';};_this.getCrossAxis=function(){return _this.getSettings().vertical?'width':'height';};_this.getCrossAxisSize=function(){return _this.state.element[__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default()('client '+_this.getCrossAxis())];};_this.countMainAxisSize=function(elementWidth,aspectRatio){return elementWidth/aspectRatio;};_this.countMinCrossAxisSize=function(maximumCrossAxisSize,axisSize){return Math.min(maximumCrossAxisSize,axisSize);};_this.countMainAxisDefaultSize=function(crossAxisSize,aspectRatio){return crossAxisSize*aspectRatio;};_this.filterVisibleMobileBanners=function(ads){var banners=ads&&ads.slice();return banners.filter(function(banner){return _this.props.uiStore.isSmallest&&banner.mobile_image;});};_this.id=__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default()('BannerSlider--');_this.bannerSliderRef=null;_this.state={element:null,elementWidth:null};return _this;}_createClass(BannerSlider,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.elementWidth!==this.state.elementWidth){this.bannerSliderRef&&this.bannerSliderRef.slickRefresh();}}/**
   * Generates a CSS style for the slider that restricts the maximum size
   * it may take at the current window size.
   *
   * The banner slider areas each have a preferred aspect ratio and a maximum
   * height/width (depending on the orientation). The general behavior is that
   * the slider area scales in the preferred aspect ratio until it hits the
   * maximum height or width, then only scales in the unrestricted direction
   * if it has more room. E.g. a horizontal banner slider with 2:1 aspect
   * ratio and 200 px maximum cross axis (height) size will behave as follows:
   *
   * Usable width -> Enforced size
   *    100 px    -> 100 px wide, 50 px tall (restricted by aspect ratio)
   *    400 px    -> 400 px wide, 200 px tall (restricted by aspect ratio)
   *    401 px    -> 401 px wide, 200 px tall (restricted by height)
   *    800 px    -> 800 px wide, 200 px tall (restricted by height)
   */},{key:'render',value:function render(){var _props=this.props,searchParams=_props.searchParams,maximumCrossAxisSize=_props.maximumCrossAxisSize;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_lazyload___default.a,{once:true,offset:50,height:maximumCrossAxisSize},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AdLoader__["a" /* default */],{searchParams:searchParams},this.getAds()));}}]);return BannerSlider;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;BannerSlider.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_UIStore__["a" /* default */]).isRequired,aspectRatio:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,className:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,settingOverrides:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,// Cross axis size here refers to either maximum height (if the slider is
// horizontal) or maximum width (if the slider is vertical).
maximumCrossAxisSize:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,onElementOffsetUpdate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};BannerSlider.defaultProps={settingOverrides:{},maximumCrossAxisSize:400};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('uiStore')(BannerSlider));

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductPrice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPrice=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductPrice,_Component);function ProductPrice(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductPrice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductPrice.__proto__||Object.getPrototypeOf(ProductPrice)).call.apply(_ref,[this].concat(args))),_this),_this.renderPriceWithDiscount=function(isDiscount,showUnit,showTaxExcludedInfo,showTaxIncludedInfo){var _this$props=_this.props,priceInfo=_this$props.priceInfo,withTax=_this$props.withTax,product=_this$props.product,hidePrice=_this$props.hidePrice,className=_this$props.className,isSecondaryPrice=_this$props.isSecondaryPrice,isMultiProductPicker=_this$props.isMultiProductPicker,depositInPrice=_this$props.depositInPrice;var deposit=depositInPrice?withTax?product.bottle_deposit.with_tax:product.bottle_deposit.without_tax:0;var productPrice=priceInfo.getPrice(withTax)+deposit;return!hidePrice&&priceInfo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Price__["a" /* default */],{price:productPrice,discount:isDiscount&&!isSecondaryPrice,showTaxExcludedInfo:showTaxExcludedInfo,showTaxIncludedInfo:showTaxIncludedInfo,fontSize:isSecondaryPrice,isMultiProductPicker:isMultiProductPicker,suffix:product&&showUnit&&!isSecondaryPrice&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'ProductPrice__stock-unit'},' ','/ ',product.stock_unit),className:className}));},_this.renderPriceNormal=function(isDiscount,showTaxExcludedInfo,showTaxIncludedInfo){var _this$props2=_this.props,activeProductId=_this$props2.activeProductId,product=_this$props2.product,productBundle=_this$props2.productBundle,priceInfo=_this$props2.priceInfo,withTax=_this$props2.withTax,hideDiscount=_this$props2.hideDiscount,className=_this$props2.className,isSecondaryPrice=_this$props2.isSecondaryPrice,isMultiProductPicker=_this$props2.isMultiProductPicker,depositInPrice=_this$props2.depositInPrice;var productPrice=productBundle&&product&&product.package_size?product.getPackagePrice(withTax,activeProductId):priceInfo.getNormalPrice(withTax);var deposit=depositInPrice?withTax?product.bottle_deposit.with_tax:product.bottle_deposit.without_tax:0;productPrice=productPrice+deposit;return!hideDiscount&&priceInfo&&isDiscount&&!isSecondaryPrice&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Price__["a" /* default */],{price:productPrice,muted:true,showTaxExcludedInfo:showTaxExcludedInfo,showTaxIncludedInfo:showTaxIncludedInfo,fontSize:isSecondaryPrice,isMultiProductPicker:isMultiProductPicker,prefix:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.RRP',defaultMessage:'RRP'}),' '),className:className}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductPrice,[{key:'render',value:function render(){var _props=this.props,priceInfo=_props.priceInfo,withTax=_props.withTax,forRetailer=_props.forRetailer,alwaysShowUnit=_props.alwaysShowUnit,product=_props.product,hideTaxExcludedInfo=_props.hideTaxExcludedInfo,showTaxIncludedInfo=_props.showTaxIncludedInfo;if(!priceInfo){return null;}var isDiscount=priceInfo&&priceInfo.is_discount;var showUnit=product&&product.sellInPackage||forRetailer||alwaysShowUnit;var showTaxExcludedInfo=!withTax&&!hideTaxExcludedInfo;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductPrice'},this.renderPriceWithDiscount(isDiscount,showUnit,showTaxExcludedInfo,showTaxIncludedInfo),this.renderPriceNormal(isDiscount,showTaxExcludedInfo,showTaxIncludedInfo));}}]);return ProductPrice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductPrice.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,alwaysShowUnit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,forRetailer:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,withTax:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,hideDiscount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,hidePrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,hideTaxExcludedInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isMultiProductPicker:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isSecondaryPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,priceInfo:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ProductPriceInfo__["a" /* default */]),// Both Products and ChildProducts are allowed.
product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,productBundle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showTaxIncludedInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,depositInPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};ProductPrice.defaultProps={hideTaxExcludedInfo:false,productBundle:false,depositInPrice:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])(function(stores,props){return{configStore:stores.configStore,accountStore:stores.accountStore,withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax,forRetailer:stores.accountStore.isRetailer,alwaysShowUnit:stores.configStore.product.alwaysShowUnit};})(ProductPrice));

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// "import" jQuery from global scope.
var $=window.$;var SLICK_EVENTS={afterChange:'afterChange',beforeChange:'beforeChange',breakpoint:'breakpoint',destroy:'destroy',edge:'edge',init:'init',reInit:'reInit',setPosition:'setPosition',swipe:'swipe',lazyLoaded:'lazyLoaded',lazyLoadError:'lazyLoadError'};var Slider=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Slider,_Component);function Slider(props){_classCallCheck(this,Slider);var _this=_possibleConstructorReturn(this,(Slider.__proto__||Object.getPrototypeOf(Slider)).call(this,props));_this.registerEventListeners=function(){var events=_this.props.events;if(_this.element&&events){Object.keys(events).forEach(function(eventName){if(SLICK_EVENTS[eventName]){$(_this.element).on(eventName,events[eventName]);}});}};_this.maybeSlickify=function(){if(!_this.element||_this.slickIsActive()){return;}_this.slickify();};_this.slickify=function(){var _this$props=_this.props,events=_this$props.events,rest=_objectWithoutProperties(_this$props,['events']);var settings=rest.dots?Object.assign({appendDots:_this.navElement,appendArrows:_this.navElement},rest):rest;$(_this.element).slick(settings);_this.makeSureDimensionsCorrectOnImageLoad();};_this.makeSureDimensionsCorrectOnImageLoad=function(){// If the images have not been loaded Slick might calculate dimensions wrong.
// We need to class resize on the slick element to force recalculate.
$(_this.element).find('img').off('load').on('load',function(){$(_this.element).resize();});};_this.unslick=function(){return _this.slickMethod('unslick');};_this.slickGoTo=function(index,dontAnimate){return _this.slickMethod('slickGoTo',index,dontAnimate);};_this.slickNext=function(){return _this.slickMethod('slickNext');};_this.slickPause=function(){return _this.slickMethod('slickPause');};_this.slickPlay=function(){return _this.slickMethod('slickPlay');};_this.slickPrev=function(){return _this.slickMethod('slickPrev');};_this.slickRefresh=function(){return _this.slickMethod('refresh');};_this.slickAdd=function(slide){return _this.slickMethod('slickAdd',slide);};_this.slickRemove=function(slide){return _this.slickMethod('slickRemove',slide);};_this.slickCurrentSlide=function(){return _this.slickMethod('slickCurrentSlide');};_this.slickMethod=function(method){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}if(_this.slickIsActive()){var _$;(_$=$(_this.element)).slick.apply(_$,[method].concat(args));}};_this.slickIsActive=function(){return _this.element&&_this.element.slick;};_this.element=null;return _this;}_createClass(Slider,[{key:'componentDidMount',value:function componentDidMount(){this.maybeSlickify();this.registerEventListeners();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// We have to exclude children, because it changes so often.
var excludeFromCompare=['children','className'];if(!__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_omit___default()(prevProps,excludeFromCompare),__WEBPACK_IMPORTED_MODULE_0_lodash_omit___default()(this.props,excludeFromCompare))){this.unslick();this.slickify();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this2=this;this.unslick();if(this.element){Object.values(SLICK_EVENTS).forEach(function(eventName){return $(_this2.element).off(eventName);});}}//Accepts html or DOM object, index, addBefore
//Accepts html or DOM object, index, addBefore
},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('Slider',{'Slider--with-dots':this.props.dots},this.props.className)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{ref:function ref(element){return _this3.element=element;}},this.props.children),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{ref:function ref(element){return _this3.navElement=element;},className:'Slider__nav'}));}}]);return Slider;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;// Sliders are forced to rerender completely if the number of slides changes,
// as React's element reuse algorithm doesn't cope well with slick also
// touching those same slide DOM elements.
var SliderWrapper=function SliderWrapper(_ref){var sliderRef=_ref.sliderRef,lazyLoad=_ref.lazyLoad,lazyLoadOptions=_ref.lazyLoadOptions,rest=_objectWithoutProperties(_ref,['sliderRef','lazyLoad','lazyLoadOptions']);var key=rest.children?rest.children.length+rest.children.filter(function(child){return child!==null;}).map(function(child){return child.key;}):'';var slider=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Slider,Object.assign({key:key,ref:sliderRef},rest));if(lazyLoad){var options=Object.assign({once:true,offset:50},lazyLoadOptions);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,options,slider);}else{return slider;}};SliderWrapper.propTypes={className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,events:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,sliderRef:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,lazyLoad:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,lazyLoadOptions:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (SliderWrapper);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Ad__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Error__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_RequestState__ = __webpack_require__(10);
var AdStore=__WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__["a" /* default */].named('AdStore').props({adQueries:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__models_Ad__["a" /* default */])),{}),adQueryStates:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["a" /* RequestStateType */]),{}),adQueryError:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_5__models_Error__["a" /* default */])}).actions(function(self){var loadAds=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAds(searchParameters){var queryIdentifier,ads;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAds$(_context){while(1){switch(_context.prev=_context.next){case 0:queryIdentifier=Object(__WEBPACK_IMPORTED_MODULE_3__util_query__["a" /* paramsToQueryIdentifier */])(searchParameters);// Skip the API call if we already have the data
if(!self.adQueries.get(queryIdentifier)){_context.next=3;break;}return _context.abrupt('return');case 3:self.setLoading(true);self.adQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADING);_context.prev=5;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('banners',{params:searchParameters},{active_section:null});case 8:ads=_context.sent;self.adQueries.set(queryIdentifier,ads);_context.next=18;break;case 12:_context.prev=12;_context.t0=_context['catch'](5);self.setError(_context.t0);self.adQueryError=Object(__WEBPACK_IMPORTED_MODULE_6__util_error__["a" /* createErrorModel */])(_context.t0);self.adQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].ERROR);throw _context.t0;case 18:self.setLoading(false);self.adQueryStates.set(queryIdentifier,__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADED);case 20:case'end':return _context.stop();}}},loadAds,this,[[5,12]]);}));return{loadAds:loadAds};}).views(function(self){return{getAdsBySearchParameters:function getAdsBySearchParameters(searchParameters){var queryIdentifier=Object(__WEBPACK_IMPORTED_MODULE_3__util_query__["a" /* paramsToQueryIdentifier */])(searchParameters);var ads=self.adQueries.get(queryIdentifier);return ads&&ads.length>0&&ads;},getAdQueryStateBySearchParameters:function getAdQueryStateBySearchParameters(searchParameters){var queryIdentifier=Object(__WEBPACK_IMPORTED_MODULE_3__util_query__["a" /* paramsToQueryIdentifier */])(searchParameters);return self.adQueryStates.get(queryIdentifier);}};});/* harmony default export */ __webpack_exports__["a"] = (AdStore);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPropertyTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductPropertyType={COLOR:'COLOR',OTHER:'OTHER',SIZE:'SIZE'};/* harmony default export */ __webpack_exports__["b"] = (ProductPropertyType);var ProductPropertyTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductProperty',Object.values(ProductPropertyType));

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductAvailabilityTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductAvailabilityType={NORMAL:'NORMAL',CLOSEOUT:'CLOSEOUT',ONLY_IN_SHOP:'ONLY_IN_SHOP',ALLOW_BACKORDER:'ALLOW_BACKORDER'};/* harmony default export */ __webpack_exports__["b"] = (ProductAvailabilityType);var ProductAvailabilityTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductAvailabilityType',Object.values(ProductAvailabilityType));

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderStatusType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var OrderStatusClass={UNFINISHED:'UNFINISHED',PENDING:'PENDING',PROCESSING:'PROCESSING',READY:'READY',CANCELED:'CANCELED',ACTIVE:'ACTIVE',DEACTIVATED:'DEACTIVATED',ON_HOLD:'ON_HOLD'};/* harmony default export */ __webpack_exports__["b"] = (OrderStatusClass);var OrderStatusType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('OrderStatusClass',Object.values(OrderStatusClass));

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_ProductCard__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Slider__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__product_ProductImpressions__ = __webpack_require__(348);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SLIDER_SETTINGS={draggable:true,arrows:true,infinite:true,slidesToShow:6,slidesToScroll:6,dots:true,lazyLoaded:true,responsive:[{breakpoint:__WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].XXL,settings:{slidesToShow:4,slidesToScroll:4}},{breakpoint:__WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].XL,settings:{slidesToShow:3,slidesToScroll:3}},{breakpoint:__WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].MD,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:__WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].SM,settings:{slidesToShow:2,slidesToScroll:2}}]};var ProductSlider=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductSlider,_Component);function ProductSlider(){_classCallCheck(this,ProductSlider);return _possibleConstructorReturn(this,(ProductSlider.__proto__||Object.getPrototypeOf(ProductSlider)).apply(this,arguments));}_createClass(ProductSlider,[{key:'render',value:function render(){var _props=this.props,products=_props.products,name=_props.name,settings=_props.settings,cardSettings=_props.cardSettings,rest=_objectWithoutProperties(_props,['products','name','settings','cardSettings']);var slides=products.map(function(product,index){var productCardSettings=Object.assign({product:product,productListView:true,position:index+1,listName:name,hideDescription:false,modelMargin:true,lazyLoading:false},cardSettings);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:product.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__product_ProductCard__["a" /* default */],productCardSettings));});var sliderSettings=settings?Object.assign({},SLIDER_SETTINGS,settings):SLIDER_SETTINGS;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductSlider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Slider__["a" /* default */],Object.assign({},sliderSettings,rest,{key:products.map(function(product){return product.id;}).join(',')}),slides),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__product_ProductImpressions__["a" /* default */],{listName:name,products:products.slice()}));}}]);return ProductSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductSlider.propTypes={products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_Product__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_Product__["a" /* default */]))]).isRequired,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,settings:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,cardSettings:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ProductSlider);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuantityFieldGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_number__ = __webpack_require__(69);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QUANTITY_FIELD_GROUP_UNIQUE_ID='QuantityFieldGroup--';var QuantityFieldGroup=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(QuantityFieldGroup,_Component);function QuantityFieldGroup(props){_classCallCheck(this,QuantityFieldGroup);var _this=_possibleConstructorReturn(this,(QuantityFieldGroup.__proto__||Object.getPrototypeOf(QuantityFieldGroup)).call(this,props));_this.uniqueId=__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(QUANTITY_FIELD_GROUP_UNIQUE_ID);_this.initializeValue=function(){var _this$props=_this.props,field=_this$props.field,defaultValue=_this$props.defaultValue;var step=_this.getStep();var newValue=void 0;if(step){newValue=step;}if(defaultValue||defaultValue===0){newValue=defaultValue;}field.setValue(String(newValue));};_this.getStep=function(){var _this$props2=_this.props,quantityStep=_this$props2.quantityStep,incrementStep=_this$props2.incrementStep;return incrementStep||quantityStep;};_this.incrementQuantity=function(){var _this$props3=_this.props,maxQuantity=_this$props3.maxQuantity,field=_this$props3.field;var factor=100;var step=_this.getStep();var precicionValue=Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(Number(field.value),2)*factor,0);var precicionStep=Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(step,2)*factor,0);var newValue=_this.mathFloor((precicionValue+precicionStep)/precicionStep)*precicionStep/factor;if(newValue<=maxQuantity){field.setValue(String(newValue));}_this.updateProductQuantity(Number(newValue));};_this.decrementQuantity=function(){var _this$props4=_this.props,maxQuantity=_this$props4.maxQuantity,field=_this$props4.field,balanceUserAccount=_this$props4.balanceUserAccount;var factor=100;var step=_this.getStep();var precicionValue=Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(Number(field.value),2)*factor,0);var precicionStep=Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(step,2)*factor,0);var precicionMax=Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(maxQuantity,2)*factor,0);var newValue=void 0;if(precicionValue<precicionStep||precicionValue-precicionStep<precicionStep){newValue=precicionStep;}else if(precicionValue>precicionMax){newValue=precicionMax;}else if(precicionValue>precicionStep&&precicionValue%precicionStep){var nextIncrementalValue=_this.mathFloor((precicionValue+precicionStep)/precicionStep)*precicionStep;var nextIncrementalValueStep=nextIncrementalValue-_this.mathFloor((precicionValue-precicionStep)/precicionStep)*precicionStep;newValue=nextIncrementalValue-nextIncrementalValueStep/2;}else{newValue=precicionValue-precicionStep;}if(balanceUserAccount){newValue=_this.countBalanceUserBalance(precicionValue,precicionStep,newValue);}var roundedWithPrecisionValue=String(Object(__WEBPACK_IMPORTED_MODULE_12__util_number__["e" /* roundWithPrecision */])(newValue/factor,2));field.setValue(roundedWithPrecisionValue);_this.updateProductQuantity(roundedWithPrecisionValue);};_this.updateProductQuantity=function(value){if(_this.props.onUpdateProductQuantity){_this.props.onUpdateProductQuantity(Number(value));}};_this.onChangeProductQuantity=function(e){var field=_this.props.field;var newValue=e.target.value;field.setValue(String(newValue));if(_this.props.onUpdateProductQuantity){_this.props.onUpdateProductQuantity(Number(newValue));}};_this.initializeValue(props);_this.mathFloor=Math.floor;return _this;}_createClass(QuantityFieldGroup,[{key:'countBalanceUserBalance',value:function countBalanceUserBalance(precicionValue,precicionStep,newValue){if(precicionValue<precicionStep||precicionValue-precicionStep<precicionStep){newValue=precicionStep;}if(precicionValue===precicionStep){newValue=newValue-precicionStep;}return newValue;}},{key:'render',value:function render(){var _props=this.props,className=_props.className,decrementQuantity=_props.decrementQuantity,incrementQuantity=_props.incrementQuantity,intl=_props.intl,disabled=_props.disabled,field=_props.field,maxQuantity=_props.maxQuantity,unit=_props.unit,balanceUserAccount=_props.balanceUserAccount;var step=this.getStep();var disableDecrementButton=balanceUserAccount&&field.value>0?false:field.value<=step;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('QuantityFieldGroup',className)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* Label */],{'for':this.uniqueId,hidden:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].quantityTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* InputGroup */],{className:'QuantityFieldGroup__input-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* InputGroupAddon */],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{size:'sm',color:'secondary',disabled:disabled||disableDecrementButton,onClick:decrementQuantity||this.decrementQuantity,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].quantityDecrementTitle)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icon__["a" /* default */],{name:'minus'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_Field__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Input */],field:field,className:'QuantityFieldGroup__quantity',value:step,type:'number',min:'1',max:maxQuantity,disabled:disabled,pattern:'[0-9]*',id:this.uniqueId,onChange:this.onChangeProductQuantity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* InputGroupText */],null,unit),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{size:'sm',color:'secondary',disabled:disabled||field.value>=maxQuantity,onClick:incrementQuantity||this.incrementQuantity,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].quantityIncrementTitle)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icon__["a" /* default */],{name:'plus'})))));}}]);return QuantityFieldGroup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;QuantityFieldGroup.propTypes={intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,field:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["b" /* default */]).isRequired,className:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,unit:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,onUpdateProductQuantity:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,incrementQuantity:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,decrementQuantity:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,maxQuantity:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,quantityStep:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,incrementStep:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,defaultValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,disabled:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,balanceUserAccount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};QuantityFieldGroup.defaultProps={maxQuantity:1,quantityStep:1,balanceUserAccount:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(QuantityFieldGroup));

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderShipping__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecurringOrderProduct__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderTotalValue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__ = __webpack_require__(191);
var RecurringOrder=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('RecurringOrder',{allow_shipping_method_change:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,allow_under_delivery:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,autogenerated_title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,created_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,cycles:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__["a" /* RecurringOrderCycleTypeType */]),delivery_address_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,min_custom_cycle:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),on_hold_until:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__RecurringOrderProduct__["a" /* default */]),recurring_status:__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["a" /* OrderStatusType */],shipping:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1__OrderShipping__["a" /* default */],{}),start_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),totals:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_3__OrderTotalValue__["a" /* default */]),updated_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (RecurringOrder);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GenericMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GenericMeta=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(GenericMeta,_Component);function GenericMeta(){_classCallCheck(this,GenericMeta);return _possibleConstructorReturn(this,(GenericMeta.__proto__||Object.getPrototypeOf(GenericMeta)).apply(this,arguments));}_createClass(GenericMeta,[{key:'render',value:function render(){var _props=this.props,name=_props.name,property=_props.property,content=_props.content;var inputProps={};if(name){inputProps.name=name;}if(property){inputProps.property=property;}if(content){inputProps.content=content;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',inputProps));}}]);return GenericMeta;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;GenericMeta.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,property:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (GenericMeta);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storageKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return urlParams; });
var storageKeys={wishlist:'wishlist',customerHash:'survey_hash',surveysSeen:'surveys_seen'};var urlParams={accessToken:'productListAccessToken'};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SidebarLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_CustomCol__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SidebarLayout=function(_Component){_inherits(SidebarLayout,_Component);function SidebarLayout(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SidebarLayout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SidebarLayout.__proto__||Object.getPrototypeOf(SidebarLayout)).call.apply(_ref,[this].concat(args))),_this),_this.renderCustomCol=function(node,sizes){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_CustomCol__["a" /* default */],sizes,node);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SidebarLayout,[{key:'render',value:function render(){var _props=this.props,sidebar=_props.sidebar,content=_props.content,className=_props.className,configStore=_props.configStore,forceSidebar=_props.forceSidebar;var fullWidthPage=configStore.sidebar.showFullWidthPageContent&&!forceSidebar;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('SidebarLayout',className)},!fullWidthPage&&this.renderCustomCol(sidebar,{md:12,lg:3,xxl:2,className:'SidebarLayout__left'}),fullWidthPage?this.renderCustomCol(content,{md:12}):this.renderCustomCol(content,{md:12,lg:9,xxl:10,className:'SidebarLayout__right'}));}}]);return SidebarLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SidebarLayout.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__["a" /* default */]).isRequired,sidebar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,// Ignores full width configuration and forces sidebar to be used (ex. MyAccountPage)
forceSidebar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('configStore')(SidebarLayout));

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(1132)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shareCountFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);










var SocialMediaShareCount = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SocialMediaShareCount, _Component);

  function SocialMediaShareCount(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SocialMediaShareCount);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SocialMediaShareCount.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SocialMediaShareCount)).call(this, props));

    _this._isMounted = false;
    _this.state = { count: 0 };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SocialMediaShareCount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.updateCount(this.props.url);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.url !== this.props.url) {
        this.updateCount(this.props.url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'updateCount',
    value: function updateCount(url) {
      var _this2 = this;

      if (this.props.getCount) {
        this.setState({
          isLoading: true
        });

        this.props.getCount(url, function (count) {
          if (_this2._isMounted) {
            _this2.setState({
              count: count,
              isLoading: false
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          isLoading = _state.isLoading;
      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('SocialMediaShareCount', className) },
        !isLoading && children(count || 0)
      );
    }
  }]);

  return SocialMediaShareCount;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

SocialMediaShareCount.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  getCount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  url: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

SocialMediaShareCount.defaultProps = {
  children: function children(shareCount) {
    return shareCount;
  }
};

function shareCountFactory(getCount) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SocialMediaShareCount, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ getCount: getCount }, props));
  };
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(133);
var createDesc = __webpack_require__(259);
module.exports = __webpack_require__(134) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(541);
var defined = __webpack_require__(356);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(359)('wks');
var uid = __webpack_require__(260);
var Symbol = __webpack_require__(115).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(369);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(97);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var BalanceUser=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('BalanceUser',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,firstname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,lastname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,email:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,telephone:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),login_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,is_active:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,account_balance:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,account_currency:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,last_purchase:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),password:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (BalanceUser);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AnalyticsEventNames={addToCart:'addToCart',analytics:'analytics',cartStatus:'cartStatus',checkout:'checkout',checkoutOption:'checkoutOption',clearCart:'clearCart',pageNotFound:'pageNotFound',productClick:'productClick',productDetail:'productDetail',productImpressions:'productImpressions',promotionClick:'promotionClick',promoView:'promoView',purchase:'purchase',quickSearch:'quickSearch',refund:'refund',removeFromCart:'removeFromCart',reserveAndCollect:'reserveAndCollect',setPage:'setPage',suggestionSelection:'suggestionSelection',updateDimension:'updateDimension'};/* harmony default export */ __webpack_exports__["a"] = (AnalyticsEventNames);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(422);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(791),
    Map = __webpack_require__(285),
    Promise = __webpack_require__(792),
    Set = __webpack_require__(437),
    WeakMap = __webpack_require__(793),
    baseGetTag = __webpack_require__(106),
    toSource = __webpack_require__(421);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Currency=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Currency',{code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,symbol_left:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,symbol_right:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,symbol:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,decimal_point:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,thousands_point:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,decimal_places:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,precision:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});/* harmony default export */ __webpack_exports__["a"] = (Currency);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PrivacyStatementLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_page_InfoPageModal__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ButtonLink__ = __webpack_require__(70);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyStatementLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PrivacyStatementLink,_Component);function PrivacyStatementLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrivacyStatementLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrivacyStatementLink.__proto__||Object.getPrototypeOf(PrivacyStatementLink)).call.apply(_ref,[this].concat(args))),_this),_this.state={show:false},_this.toggle=function(){_this.setState({show:!_this.state.show});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrivacyStatementLink,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_ButtonLink__["a" /* default */],{className:'PrivacyStatementLink',onClick:this.toggle},children||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'privacyStatement.readLinkSentence',defaultMessage:'Privacy statement here'})),this.state.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__info_page_InfoPageModal__["a" /* default */],{isOpen:this.state.show,toggle:this.toggle,pageId:configStore.privacyStatement.infoPageId}));}}]);return PrivacyStatementLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PrivacyStatementLink.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(PrivacyStatementLink));

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CustomNavigationLinkParentTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CustomNavigationLinkParentType={CATEGORY:'CATEGORY',CUSTOM_NAVIGATION_LINK:'CUSTOM_NAVIGATION_LINK',SECTION:'SECTION'};/* harmony default export */ __webpack_exports__["a"] = (CustomNavigationLinkParentType);var CustomNavigationLinkParentTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CustomNavigationLinkParentType',Object.values(CustomNavigationLinkParentType));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(430),
    baseIteratee = __webpack_require__(84),
    baseSome = __webpack_require__(816),
    isArray = __webpack_require__(47),
    isIterateeCall = __webpack_require__(150);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(306),
    baseAssignValue = __webpack_require__(178);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ManufacturerLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Manufacturer__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManufacturerLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ManufacturerLink,_Component);function ManufacturerLink(){_classCallCheck(this,ManufacturerLink);return _possibleConstructorReturn(this,(ManufacturerLink.__proto__||Object.getPrototypeOf(ManufacturerLink)).apply(this,arguments));}_createClass(ManufacturerLink,[{key:'render',value:function render(){var _props=this.props,routeService=_props.routeService,manufacturer=_props.manufacturer,className=_props.className,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('ManufacturerLink',className),to:routeService.getPath(manufacturer.path)},children||manufacturer.name);}}]);return ManufacturerLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ManufacturerLink.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired,manufacturer:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Manufacturer__["a" /* default */]).isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService')(ManufacturerLink));

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductId=function(_Component){_inherits(ProductId,_Component);function ProductId(){_classCallCheck(this,ProductId);return _possibleConstructorReturn(this,(ProductId.__proto__||Object.getPrototypeOf(ProductId)).apply(this,arguments));}_createClass(ProductId,[{key:'render',value:function render(){var id=this.props.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.idLabel',defaultMessage:'Product Code: {id}',values:{id:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,id)}});}}]);return ProductId;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductId.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductId);

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = clamp

function clamp(value, min, max) {
  return min < max
    ? (value < min ? min : value > max ? max : value)
    : (value < max ? max : value > min ? min : value)
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Point__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image__ = __webpack_require__(318);




/* harmony default export */ __webpack_exports__["a"] = ({
    cursorOffset: __WEBPACK_IMPORTED_MODULE_1__Point__["a" /* default */],
    fadeDurationInMs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    isPositionOutside: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    position: __WEBPACK_IMPORTED_MODULE_1__Point__["a" /* default */],
    smallImage: __WEBPACK_IMPORTED_MODULE_2__Image__["b" /* SmallImageShape */],
    style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductProperty__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductCollectionItem__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_ProductPropertyType__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Product__ = __webpack_require__(18);
var ProductMatrix=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductMatrix',{row:__WEBPACK_IMPORTED_MODULE_1__ProductProperty__["a" /* default */],column:__WEBPACK_IMPORTED_MODULE_1__ProductProperty__["a" /* default */],items:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__ProductCollectionItem__["a" /* default */])}).views(function(self){return{get product(){return Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["f" /* getParentOfType */])(self,__WEBPACK_IMPORTED_MODULE_4__Product__["a" /* default */]);},shouldSwapCollectionOrder:function shouldSwapCollectionOrder(){// Default order is: column, row. If later collection (row) is COLOR, collections are swapped.
return self.row.type===__WEBPACK_IMPORTED_MODULE_3__types_ProductPropertyType__["b" /* default */].COLOR;},getItemStatus:function getItemStatus(columnId,rowId){var status={exists:false,available:false};var item=self.getItem(columnId,rowId);if(item){status.exists=true;}if(item&&(item.canBeOrderedOutOfStock()||item.getAvailableAmount()>self.product.package_size)){status.available=true;}return status;},getRowStatus:function getRowStatus(rowId){return self.getPropertyStatus('row_id',rowId);},getColumnStatus:function getColumnStatus(columnId){return self.getPropertyStatus('column_id',columnId);},getPropertyStatus:function getPropertyStatus(propertyName,elementId){var status={exists:false,available:false};// Check if we have any items for the property and if they are available
var matchingItems=self.items.filter(function(currentItem){return currentItem[propertyName]===elementId;});if(matchingItems.length>0){status.exists=true;}status.available=matchingItems.some(function(currentItem){return currentItem.getAvailableAmount()>=self.product.package_size;});return status;},getItem:function getItem(columnId,rowId){return self.items.find(function(item){return item.column_id===columnId&&item.row_id===rowId;});},getItemWithProductId:function getItemWithProductId(productId){return self.items.find(function(item){return item.product.id===productId;});},propertyIsSelectable:function propertyIsSelectable(property){return!property.isEmpty()&&property.elements.length>1;},columnIsSelectable:function columnIsSelectable(){return self.propertyIsSelectable(self.column);},getDefaultColumnElement:function getDefaultColumnElement(){return!self.columnIsSelectable()?self.column.elements[0]:null;},rowIsSelectable:function rowIsSelectable(){return self.propertyIsSelectable(self.row);},getDefaultRowElement:function getDefaultRowElement(){return!self.rowIsSelectable()?self.row.elements[0]:null;},getNames:function getNames(){return self.shouldSwapCollectionOrder()?{columnName:self.row.name,rowName:self.column.name}:{columnName:self.column.name,rowName:self.row.name};},getRowElements:function getRowElements(){return self.shouldSwapCollectionOrder()?self.column.elements:self.row.elements;},getColumnElements:function getColumnElements(){return self.shouldSwapCollectionOrder()?self.row.elements:self.column.elements;},getProductElementNamesByItemElementId:function getProductElementNamesByItemElementId(rowId,columnId){var rowElement=self.row&&self.row.elements&&self.row.elements.find(function(row){return row.id===rowId;});var columnElement=self.column&&self.column.elements&&self.column.elements.find(function(column){return column.id===columnId;});// Element names can contain non-breaking space character as a string
var trimmedRowName=rowElement.name.replace(/&nbsp;/g,' ').trim();var trimmedColumnName=columnElement.name.replace(/&nbsp;/g,' ').trim();return self.shouldSwapCollectionOrder()?{columnName:trimmedRowName,rowName:trimmedColumnName}:{columnName:trimmedColumnName,rowName:trimmedRowName};}};});/* harmony default export */ __webpack_exports__["a"] = (ProductMatrix);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShippingOptionSelectionField__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_ProductShippingClass__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_ShippingDeliveryTimeType__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingCampaignInfo__ = __webpack_require__(975);
var Service=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Service',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});var DeliveryTime=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('DeliveryTime',{type:__WEBPACK_IMPORTED_MODULE_4__types_ShippingDeliveryTimeType__["a" /* ShippingDeliveryTimeTypeType */],min:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,max:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});var ShippingOption=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ShippingDetail',{additional_services:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(Service),campaign_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_5__ShippingCampaignInfo__["a" /* default */]),class:__WEBPACK_IMPORTED_MODULE_3__types_ProductShippingClass__["a" /* ProductShippingClassType */],delivery_time:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(DeliveryTime),description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,has_area_limitations:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,has_starting_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),includes_low_order_fee:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */]),low_order_fee_limit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */]),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),pickup_point_integration:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),pickup_point_types:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)),price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */],requires_pickup_point:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,selection_fields:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__ShippingOptionSelectionField__["a" /* default */])}).views(function(self){return{get selectionFields(){return self.selection_fields;},getPrice:function getPrice(){return self.price&&self.price.with_tax;},getDefaultSelectionField:function getDefaultSelectionField(){return self.selection_fields&&self.selection_fields.length>0&&self.selection_fields[0]&&self.selection_fields[0].options.length>0&&self.selection_fields[0].options[0]||null;}};});/* harmony default export */ __webpack_exports__["a"] = (ShippingOption);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecurringOrderCycleTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var RecurringOrderCycleType={WEEKLY:'WEEKLY',BIWEEKLY:'BIWEEKLY',MONTHLY:'MONTHLY',BIMONTHLY:'BIMONTHLY',QUARTERLY:'QUARTERLY',CUSTOM:'CUSTOM'};/* harmony default export */ __webpack_exports__["b"] = (RecurringOrderCycleType);var RecurringOrderCycleTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('RecurringOrderCycleType',Object.values(RecurringOrderCycleType));

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Storage__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__ = __webpack_require__(25);
var StorageStore=__WEBPACK_IMPORTED_MODULE_4__models_StatefulStore__["a" /* default */].named('StorageStore').props({storages:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_3__models_Storage__["a" /* default */]),[])}).actions(function(self){var ifShoppingCenter=function ifShoppingCenter(){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore.siteConfig.isShoppingCenter;};var baseApi=function baseApi(endpoint){return ifShoppingCenter()?'shopping-center/'+endpoint:''+endpoint;};return{makeSureStoragesLoaded:function makeSureStoragesLoaded(merchantUrl){//Ensure shopping center always has fresh storage data. => ifShoppingCenter()
if(self.state===__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].NONE||ifShoppingCenter()){return self.loadStorages(merchantUrl);}return Promise.resolve();},loadStorages:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadStorages(merchantUrl){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadStorages$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+baseApi('storages'),{params:{merchantUrl:merchantUrl}});case 4:self.storages=_context.sent;_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 11:self.setLoading(false);case 12:case'end':return _context.stop();}}},loadStorages,this,[[1,7]]);}))};}).views(function(self){return{findStorageById:function findStorageById(storageId){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_3__models_Storage__["a" /* default */],self.storages,storageId);},get pickupStorages(){return self.storages.filter(function(storage){return storage.is_pickup_storage;});},get listingStorages(){return self.storages.filter(function(storage){return storage.show_on_store_listing;});}};});/* harmony default export */ __webpack_exports__["a"] = (StorageStore);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_compact__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_compact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_compact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReserveInStoreService__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StoragePhoneNumber__ = __webpack_require__(1034);
var Storage=__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].model('Storage',{city:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string,emails:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string),[]),id:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].identifierNumber,is_pickup_storage:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].boolean,lower_limit:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].number,map_link_search_text:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string),name:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string,opening_hours:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string,phone_numbers:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_3__StoragePhoneNumber__["a" /* default */]),[]),postcode:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string,service_ids:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].number),[]),show_on_store_listing:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].boolean,stock_display_style:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string,street_address:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].string,upper_limit:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].number}).views(function(self){return{get hasInformation(){return self.map_link_search_text;},get hasAddress(){return self.city&&self.street_address&&self.postcode;},get services(){return __WEBPACK_IMPORTED_MODULE_0_lodash_compact___default()(self.service_ids.map(function(service_id){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_2__ReserveInStoreService__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self),service_id);}));}};});/* harmony default export */ __webpack_exports__["a"] = (Storage);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectField=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SelectField,_Component);function SelectField(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectField.__proto__||Object.getPrototypeOf(SelectField)).call.apply(_ref,[this].concat(args))),_this),_this.id=null,_this.getFieldId=function(){if(!_this.id){// In the normal use cases, the form and field names don't change, and
// this only really affects the input/label binding, so not updating the id
// afterwards if props change should still be fine.
_this.id=__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(_this.props.formName+'__'+_this.props.fieldName+'--');}return _this.id;},_this.getTooltip=function(text){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'info',className:'tooltip-'+_this.id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["V" /* UncontrolledTooltip */],{target:'.tooltip-'+_this.id},text));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectField,[{key:'render',value:function render(){var _props=this.props,label=_props.label,fieldName=_props.fieldName,field=_props.field,options=_props.options,required=_props.required,tooltip=_props.tooltip,formName=_props.formName,rest=_objectWithoutProperties(_props,['label','fieldName','field','options','required','tooltip','formName']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],{className:'SelectField',tag:'fieldset',id:this.getFieldId()},label&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{className:'SelectField__label'},label,required&&' * ',tooltip&&this.getTooltip(tooltip)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Field__["a" /* default */],Object.assign({component:__WEBPACK_IMPORTED_MODULE_4_reactstrap__["v" /* Input */],field:field,type:'select',name:fieldName,id:this.getFieldId()},rest),options.map(function(option){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(option.value),value:option.value},option.label);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FieldError__["a" /* default */],{field:field}));}}]);return SelectField;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;SelectField.propTypes={field:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_FormField__["b" /* default */]).isRequired,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,formName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,fieldName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,options:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node})).isRequired,required:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (SelectField);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductEnquiryTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductEnquiryType={MESSAGE:'MESSAGE',PROPOSAL_REQUEST:'PROPOSAL_REQUEST'};/* harmony default export */ __webpack_exports__["a"] = (ProductEnquiryType);var ProductEnquiryTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductEnquiryType',Object.values(ProductEnquiryType));

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_PaymentModule__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_PaymentWidgetQueryResult__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_PaymentWidget__ = __webpack_require__(530);
var PaymentModuleStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named('PaymentModuleStore').props({methods:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__models_PaymentModule__["a" /* default */]),[]),widgets:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_7__models_PaymentWidget__["a" /* default */]),[]),paymentWidgetQueryResults:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_5__models_PaymentWidgetQueryResult__["a" /* default */]),{}),paymentWidgetQueryStates:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["a" /* RequestStateType */]),{})}).actions(function(self){var loadPaymentModules=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadPaymentModules(params){var paymentInfo;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadPaymentModules$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(self.methods.length||self.widgets.length)){_context.next=2;break;}return _context.abrupt('return');case 2:self.setLoading(true);_context.prev=3;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('payment-info',{params:params});case 6:paymentInfo=_context.sent;self.methods=paymentInfo.methods;self.widgets=paymentInfo.widgets;_context.next=15;break;case 11:_context.prev=11;_context.t0=_context['catch'](3);self.setError(_context.t0);throw _context.t0;case 15:self.setLoading(false);case 16:case'end':return _context.stop();}}},loadPaymentModules,this,[[3,11]]);}));var loadProductWidget=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadProductWidget(params){var identifier,paymentWidget;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadProductWidget$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:identifier=Object(__WEBPACK_IMPORTED_MODULE_4_qs__["stringify"])(params);// Skip the API call if we already have the data
if(!self.paymentWidgetQueryStates.get(identifier)){_context2.next=3;break;}return _context2.abrupt('return');case 3:self.setLoading(true);self.paymentWidgetQueryStates.set(identifier,__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["b" /* default */].LOADING);paymentWidget=void 0;_context2.prev=6;_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('payment-info/product-widgets',{params:params});case 9:paymentWidget=_context2.sent;// Set current query results
self.paymentWidgetQueryResults.set(identifier,{widgets:paymentWidget.map(function(widget){return widget;})});_context2.next=18;break;case 13:_context2.prev=13;_context2.t0=_context2['catch'](6);self.setError(_context2.t0);self.paymentWidgetQueryStates.set(identifier,__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["b" /* default */].ERROR);throw _context2.t0;case 18:self.setLoading(false);self.paymentWidgetQueryStates.set(identifier,__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["b" /* default */].LOADED);case 20:case'end':return _context2.stop();}}},loadProductWidget,this,[[6,13]]);}));return{loadPaymentModules:loadPaymentModules,loadProductWidget:loadProductWidget};}).views(function(self){return{get isKlarnaEnabled(){return self.paymentModules.some(function(p){return p.class==='klarna_checkout';});},get getPaymentWidgets(){return self.widgets&&self.widgets.length&&self.widgets.find(function(widget){return widget.type==='KLARNA';});}};});/* harmony default export */ __webpack_exports__["a"] = (PaymentModuleStore);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(198);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(540);
var enumBugKeys = __webpack_require__(360);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__ = __webpack_require__(1237);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Address__ = __webpack_require__(202);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddressStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named('AddressStore').props({addresses:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_5__models_Address__["a" /* default */]),{}),addressStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */]),{})}).views(function(self){return{get addressArray(){return Array.from(self.addresses,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;});}};}).actions(function(self){return{loadAddress:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAddress(id){var page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAddress$(_context){while(1){switch(_context.prev=_context.next){case 0:self.addressStates.set(id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('address-book/'+id);case 4:page=_context.sent;self.addresses.set(id,page);_context.next=13;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);self.setError(_context.t0);self.addressStates.set(id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);throw _context.t0;case 13:self.addressStates.set(id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);case 14:case'end':return _context.stop();}}},loadAddress,this,[[1,8]]);})),loadAddresses:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadAddresses(){var addresses;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadAddresses$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('address-book');case 4:addresses=_context2.sent;self.addresses=__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(addresses,'id');self.addressArray.forEach(function(address){self.addressStates.set(address.id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);});_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 13:self.setLoading(false);case 14:case'end':return _context2.stop();}}},loadAddresses,this,[[1,9]]);})),removeAddress:function removeAddress(addressId){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete('address-book/'+addressId);},saveAddress:function saveAddress(address){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('address-book/',address);},updateAddress:function updateAddress(addressId,address){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().put('address-book/'+addressId,address);}};});/* harmony default export */ __webpack_exports__["a"] = (AddressStore);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Country__ = __webpack_require__(228);
var Address=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Address',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,is_primary:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,company:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,firstname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,lastname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,street_address:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,city:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,postal_code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,telephone:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,country_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number}).views(function(self){return{get country(){return Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_1__Country__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["g" /* getRoot */])(self),self.country_id);}};});/* harmony default export */ __webpack_exports__["a"] = (Address);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderProduct__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderPayment__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderShipping__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderTotalValue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderStatusHistoryEntry__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_OrderStatusClass__ = __webpack_require__(158);
var Order=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Order',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,date_purchased:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,last_status:__WEBPACK_IMPORTED_MODULE_6__types_OrderStatusClass__["a" /* OrderStatusType */],last_modified:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,weight:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),seller_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,external_type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),receipt_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),your_reference:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),no_taxes:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__OrderProduct__["a" /* default */]),payment:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__OrderPayment__["a" /* default */],{}),shipping:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__OrderShipping__["a" /* default */],{}),totals:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__OrderTotalValue__["a" /* default */]),status_history:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_5__OrderStatusHistoryEntry__["a" /* default */])}).views(function(self){return{getOrderReference:function getOrderReference(){return self.your_reference;}};});/* harmony default export */ __webpack_exports__["a"] = (Order);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(176);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
  CHARSET: 'charset',
  CSS_TEXT: 'cssText',
  HREF: 'href',
  HTTPEQUIV: 'http-equiv',
  INNER_HTML: 'innerHTML',
  ITEM_PROP: 'itemprop',
  NAME: 'name',
  PROPERTY: 'property',
  REL: 'rel',
  SRC: 'src'
};

var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
  BODY: 'bodyAttributes',
  HTML: 'htmlAttributes',
  TITLE: 'titleAttributes'
};

var TAG_NAMES = exports.TAG_NAMES = {
  BASE: 'base',
  BODY: 'body',
  HEAD: 'head',
  HTML: 'html',
  LINK: 'link',
  META: 'meta',
  NOSCRIPT: 'noscript',
  SCRIPT: 'script',
  STYLE: 'style',
  TITLE: 'title'
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
  return TAG_NAMES[name];
});

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
  accesskey: 'accessKey',
  charset: 'charSet',
  class: 'className',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  'http-equiv': 'httpEquiv',
  itemprop: 'itemProp',
  tabindex: 'tabIndex'
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
  obj[REACT_TAG_MAP[key]] = key;
  return obj;
}, {});

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = 'data-rh';

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(655)();
}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(706);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslatedImageTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var TranslatedImageType={STORE_LOGO:'STORE_LOGO',STORE_MOBILE_LOGO:'STORE_MOBILE_LOGO',STORE_SCROLL_LOGO:'STORE_SCROLL_LOGO',IMAGE_NOT_FOUND_NAME:'IMAGE_NOT_FOUND_NAME',EMAIL_LOGO:'EMAIL_LOGO'};/* harmony default export */ __webpack_exports__["b"] = (TranslatedImageType);var TranslatedImageTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('TranslatedImageType',Object.values(TranslatedImageType));

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(743),
    hasPath = __webpack_require__(420);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(124);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(758),
    listCacheDelete = __webpack_require__(759),
    listCacheGet = __webpack_require__(760),
    listCacheHas = __webpack_require__(761),
    listCacheSet = __webpack_require__(762);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(217);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(764);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(769),
    baseAggregator = __webpack_require__(770),
    baseIteratee = __webpack_require__(84),
    isArray = __webpack_require__(47);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(397);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(290)(module)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(143),
    toKey = __webpack_require__(145);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionIntegrationTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var SectionIntegrationType={ZOOVU:'ZOOVU',ARINET:'ARINET'};/* harmony default export */ __webpack_exports__["b"] = (SectionIntegrationType);var SectionIntegrationTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('SectionIntegrationType',Object.values(SectionIntegrationType));

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CouponText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_CouponStore__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_CouponActivationType__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Coupon__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_CouponDiscountType__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__product_Discount__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CouponText=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CouponText,_Component);function CouponText(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CouponText);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CouponText.__proto__||Object.getPrototypeOf(CouponText)).call.apply(_ref,[this].concat(args))),_this),_this.getOffer=function(){var coupon=_this.props.coupon;switch(coupon.discount_type){case __WEBPACK_IMPORTED_MODULE_8__types_CouponDiscountType__["b" /* default */].AMOUNT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__product_Price__["a" /* default */],{price:coupon.amount});case __WEBPACK_IMPORTED_MODULE_8__types_CouponDiscountType__["b" /* default */].PERCENTAGE:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__product_Discount__["a" /* default */],{percentage:coupon.percentage});case __WEBPACK_IMPORTED_MODULE_8__types_CouponDiscountType__["b" /* default */].FREE_SHIPPING:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CouponText__free-shipping'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].freeDeliverySentence));default:return'';}},_this.getShortText=function(){var coupon=_this.props.coupon;var text='';if(coupon.discount_type===__WEBPACK_IMPORTED_MODULE_8__types_CouponDiscountType__["b" /* default */].FREE_SHIPPING){text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].couponFreeShippingSentence);}else{text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].couponDiscountOfferSentence,{values:{offer:_this.getOffer()}}));}return text;},_this.getLongText=function(){var coupon=_this.props.coupon;var text='';switch(coupon.activation_type){case __WEBPACK_IMPORTED_MODULE_6__types_CouponActivationType__["b" /* default */].REGISTRATION:if(coupon.discount_type===__WEBPACK_IMPORTED_MODULE_8__types_CouponDiscountType__["b" /* default */].FREE_SHIPPING){text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].couponRegisterFreeDeliverySentence);}else{text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].couponRegisterOfferSentence,{values:{offer:_this.getOffer()}}));}break;case __WEBPACK_IMPORTED_MODULE_6__types_CouponActivationType__["b" /* default */].LOGIN:if(coupon.discount_type===__WEBPACK_IMPORTED_MODULE_8__types_CouponDiscountType__["b" /* default */].FREE_SHIPPING){text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].couponLoginFreeDeliverySentence);}else{text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].couponLoginOfferSentence,{values:{offer:_this.getOffer()}}));}break;case __WEBPACK_IMPORTED_MODULE_6__types_CouponActivationType__["b" /* default */].PRODUCT_REVIEW:text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].couponReviewValueSentence,{values:{value:_this.getOffer()}}));break;default:}return text;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CouponText,[{key:'render',value:function render(){var short=this.props.short;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CouponText'},short?this.getShortText():this.getLongText());}}]);return CouponText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CouponText.propTypes={couponStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_CouponStore__["a" /* default */]).isRequired,coupon:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Coupon__["a" /* default */]).isRequired,short:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('couponStore')(CouponText));

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Discount=function(_Component){_inherits(Discount,_Component);function Discount(){_classCallCheck(this,Discount);return _possibleConstructorReturn(this,(Discount.__proto__||Object.getPrototypeOf(Discount)).apply(this,arguments));}_createClass(Discount,[{key:'render',value:function render(){var _props=this.props,percentage=_props.percentage,withLabel=_props.withLabel,withUpTo=_props.withUpTo;var discount='-'+Math.round(percentage)+'%';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Discount'},withLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'discount.sale',defaultMessage:'Sale'}),withUpTo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'discount.upTo',defaultMessage:'Up to'}),' ',discount);}}]);return Discount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Discount.propTypes={percentage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,withLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,withUpTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Discount);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner__ = __webpack_require__(300);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BlockSpinner=function(_Component){_inherits(BlockSpinner,_Component);function BlockSpinner(){_classCallCheck(this,BlockSpinner);return _possibleConstructorReturn(this,(BlockSpinner.__proto__||Object.getPrototypeOf(BlockSpinner)).apply(this,arguments));}_createClass(BlockSpinner,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BlockSpinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Spinner__["a" /* default */],null));}}]);return BlockSpinner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BlockSpinner);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
// TODO: add separate field for flag to show next to the item in the menu
var Language=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Language',{code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (Language);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Currency__ = __webpack_require__(180);
// TODO: current values for "name" should be in some kind of short code field instead and a proper name field be added.
// If we also want to show flags in the menu, a third field for that (2-letter code) would be needed as well.
var Country=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Country',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,iso_code_2:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,currency_code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)}).views(function(self){return{get currency(){if(!self.currency_code){return null;}return Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_1__Currency__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["g" /* getRoot */])(self),self.currency_code);}};});/* harmony default export */ __webpack_exports__["a"] = (Country);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DropdownSelect=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(DropdownSelect,_Component);function DropdownSelect(){_classCallCheck(this,DropdownSelect);return _possibleConstructorReturn(this,(DropdownSelect.__proto__||Object.getPrototypeOf(DropdownSelect)).apply(this,arguments));}_createClass(DropdownSelect,[{key:'render',value:function render(){var _props=this.props,label=_props.label,children=_props.children,disabled=_props.disabled,isLarge=_props.isLarge,props=_objectWithoutProperties(_props,['label','children','disabled','isLarge']);var styles=isLarge?{overflowY:'scroll',maxHeight:'500px'}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["U" /* UncontrolledDropdown */],Object.assign({className:'DropdownSelect',disabled:disabled},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* DropdownToggle */],{caret:true,disabled:disabled},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["q" /* DropdownMenu */],{style:styles},children));}}]);return DropdownSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;DropdownSelect.propTypes={label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,isLarge:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};DropdownSelect.defaultTypes={isLarge:false};/* harmony default export */ __webpack_exports__["a"] = (DropdownSelect);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FlagIcon__ = __webpack_require__(804);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LOCALE_TO_COUNTRY_CODE_MAPPING={en:'gb',sv:'se'};var LocaleFlagIcon=function(_Component){_inherits(LocaleFlagIcon,_Component);function LocaleFlagIcon(){_classCallCheck(this,LocaleFlagIcon);return _possibleConstructorReturn(this,(LocaleFlagIcon.__proto__||Object.getPrototypeOf(LocaleFlagIcon)).apply(this,arguments));}_createClass(LocaleFlagIcon,[{key:'render',value:function render(){var locale=this.props.locale;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FlagIcon__["a" /* default */],{countryCode:LocaleFlagIcon.countryCodeFromLocale(locale)});}}],[{key:'countryCodeFromLocale',value:function countryCodeFromLocale(locale){// If the country has no mapping set above, it is assumed that the
// equivalent country code is the same as the locale.
// (i.e. fi locale and fi country are a pair)
return LOCALE_TO_COUNTRY_CODE_MAPPING[locale]||locale;}}]);return LocaleFlagIcon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LocaleFlagIcon.propTypes={locale:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (LocaleFlagIcon);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Category__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryBadges=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CategoryBadges,_Component);function CategoryBadges(){_classCallCheck(this,CategoryBadges);return _possibleConstructorReturn(this,(CategoryBadges.__proto__||Object.getPrototypeOf(CategoryBadges)).apply(this,arguments));}_createClass(CategoryBadges,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CategoryBadges'},this.props.category.discount>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Badge */],{pill:true,className:'CategoryBadges__discount-badge'},'\u2013',Math.round(this.props.category.discount),'%'),this.props.category.is_new&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Badge */],{pill:true,className:'CategoryBadges__new-badge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].newTitle)));}}]);return CategoryBadges;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CategoryBadges.propTypes={category:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_Category__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (CategoryBadges);

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ManufacturerIntegration__ = __webpack_require__(843);
var Manufacturer=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Manufacturer',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,slug:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),description_html:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),SEO_title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),SEO_description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),section_ids:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].integer),has_products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean),integrations:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_3__ManufacturerIntegration__["a" /* default */])}).views(function(self){return{get path(){return Object(__WEBPACK_IMPORTED_MODULE_2__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__types_Paths__["a" /* default */].Manufacturer,{slug:self.slug||self.name||self.id,id:self.id});},get breadcrumbs(){return[{text:self.name,url:self.path}];},belongsToSection:function belongsToSection(sectionId){return self.section_ids.indexOf(sectionId)!==-1;}};});/* harmony default export */ __webpack_exports__["a"] = (Manufacturer);

/***/ }),
/* 233 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceVisible = exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(66);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(873);

var _scrollParent = __webpack_require__(874);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(875);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(876);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

/**
 * Forces the component to display regardless of whether the element is visible in the viewport.
 */
var forceVisible = function forceVisible() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    listener.visible = true;
    listener.forceUpdate();
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    // this.setRef = this.setRef.bind(this);
    return _this;
  }

  // setRef(element) {
  //   if (element) {
  //     this.ref = element;
  //   }
  // }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        // const parent = scrollParent(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        // const parent = scrollParent(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
      // <span ref={this.setRef} className="lazyload-custom-placeholder">
      //   {this.props.placeholder}
      // </span> :
      // <div ref={this.setRef} style={{ height: this.props.height }} className="lazyload-placeholder" />;
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

exports.lazyload = decorator;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
exports.forceVisible = forceVisible;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(304);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartNewProductTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CartNewProductType={NORMAL:'NORMAL',BUNDLE:'BUNDLE',ARRAY:'ARRAY'};/* harmony default export */ __webpack_exports__["b"] = (CartNewProductType);var CartNewProductTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CartNewProductType',Object.values(CartNewProductType));

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);




var Lens = function Lens(props) {
    var fadeDurationInMs = props.fadeDurationInMs,
        isActive = props.isActive,
        isPositionOutside = props.isPositionOutside,
        parentSpecifiedStyle = props.style;


    var defaultStyle = {
        width: 'auto',
        height: 'auto',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        display: 'block'
    };

    var computedStyle = {
        position: 'absolute',
        opacity: isActive && !isPositionOutside ? 1 : 0,
        transition: 'opacity ' + fadeDurationInMs + 'ms ease-in'
    };

    var compositStyle = __WEBPACK_IMPORTED_MODULE_2_object_assign___default()({}, defaultStyle, parentSpecifiedStyle, computedStyle);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: compositStyle });
};

Lens.propTypes = {
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    fadeDurationInMs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    translateX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    translateY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    userStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Lens.defaultProps = {
    isActive: false,
    fadeDurationInMs: 0,
    translateX: 0,
    translateY: 0
};

/* harmony default export */ __webpack_exports__["a"] = (Lens);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Menu__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
var MenuStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named('MenuStore').props({menus:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__models_Menu__["a" /* default */]),[])}).actions(function(self){var setup=function setup(menus){self.menus=menus;self.setLoading(false);};var loadMenus=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadMenus(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadMenus$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('menus');case 4:self.menus=_context.sent;_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 11:self.setLoading(false);case 12:case'end':return _context.stop();}}},loadMenus,this,[[1,7]]);}));return{setup:setup,loadMenus:loadMenus};});/* harmony default export */ __webpack_exports__["a"] = (MenuStore);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContentSlots */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentSlot__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdLoader__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_SSRAwareLazyLoad__ = __webpack_require__(929);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentSlots=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ContentSlots,_Component);function ContentSlots(){_classCallCheck(this,ContentSlots);return _possibleConstructorReturn(this,(ContentSlots.__proto__||Object.getPrototypeOf(ContentSlots)).apply(this,arguments));}_createClass(ContentSlots,[{key:'render',value:function render(){var _props=this.props,className=_props.className,searchParams=_props.searchParams;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_SSRAwareLazyLoad__["a" /* default */],{once:true,offset:50,height:25},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AdLoader__["a" /* default */],{searchParams:searchParams},function(ads){if(!ads||ads.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('ContentSlots',className)},ads.map(function(ad){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContentSlot__["a" /* default */],{ad:ad,bannerZone:searchParams.bannerZone,key:ad.id});}));}));}}]);return ContentSlots;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ContentSlots.propTypes={searchParams:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('adStore')(ContentSlots));

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(478);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(951);
var parse = __webpack_require__(952);
var formats = __webpack_require__(487);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_AcceptableTermsType__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Price__ = __webpack_require__(79);
var ProductMerchantInfo=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductMerchantInfo',{acceptable_terms:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({link:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__types_AcceptableTermsType__["a" /* AcceptableTermsTypeType */])})),[]),buying_allowed:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean),id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber),merchant_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),shipping_starting_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2__Price__["a" /* default */]),site_description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),site_logo:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),site_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),site_platform:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),site_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)}).views(function(self){return{get buyingAllowed(){return self.buying_allowed;},get deliveryTerms(){return self.acceptable_terms.length>0&&self.acceptable_terms.find(function(term){return term.type===__WEBPACK_IMPORTED_MODULE_1__types_AcceptableTermsType__["b" /* default */].DELIVERY_TERMS;});},get privacyStatement(){return self.acceptable_terms.length>0&&self.acceptable_terms.find(function(term){return term.type===__WEBPACK_IMPORTED_MODULE_1__types_AcceptableTermsType__["b" /* default */].PRIVACY_TERMS;});}};});/* harmony default export */ __webpack_exports__["a"] = (ProductMerchantInfo);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderMethod__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderAddress__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PickUpPointInfo__ = __webpack_require__(985);
var OrderTracking=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrderTracking',{code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});var OrderShipping=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrderShipping',{address:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__OrderAddress__["a" /* default */],{}),method:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1__OrderMethod__["a" /* default */],{}),pick_up_point:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_3__PickUpPointInfo__["a" /* default */]),tracking:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(OrderTracking),[])});/* harmony default export */ __webpack_exports__["a"] = (OrderShipping);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_OrderTotalClass__ = __webpack_require__(112);
var OrderTotalValue=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrderTotalValue',{analytics_value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,class:__WEBPACK_IMPORTED_MODULE_1__types_OrderTotalClass__["a" /* OrderTotalType */],name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});/* harmony default export */ __webpack_exports__["a"] = (OrderTotalValue);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Icon___ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Stars=function(_Component){_inherits(Stars,_Component);function Stars(){_classCallCheck(this,Stars);return _possibleConstructorReturn(this,(Stars.__proto__||Object.getPrototypeOf(Stars)).apply(this,arguments));}_createClass(Stars,[{key:'render',value:function render(){var amount=this.props.amount;var backgroundStars=[];for(var i=0;i<5;i++){backgroundStars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Icon___["a" /* default */],{key:i,name:'star'}));}var stars=[];for(var starsLeft=amount;starsLeft>=0.25;starsLeft--){var iconName='star';if(starsLeft<0.75){iconName='star-half';}stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Icon___["a" /* default */],{key:starsLeft,name:iconName}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Stars'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Stars__background'},backgroundStars),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Stars__foreground'},stars));}}]);return Stars;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Stars.propTypes={amount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Stars);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExternalReviewTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ExternalReviewType={WITVIEW:'WITVIEW'};/* harmony default export */ __webpack_exports__["a"] = (ExternalReviewType);var ExternalReviewTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ExternalReviewType',Object.values(ExternalReviewType));

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PriceWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductPriceRange__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductPrice__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PriceWrapper=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PriceWrapper,_Component);function PriceWrapper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PriceWrapper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PriceWrapper.__proto__||Object.getPrototypeOf(PriceWrapper)).call.apply(_ref,[this].concat(args))),_this),_this.showPrices=function(configStore,accountStore){var hideTaxIncludedInfo=configStore.product.showSecondaryTaxPrice;var retailer=accountStore.isRetailer;return{hideTaxIncludedInfo:hideTaxIncludedInfo,retailer:retailer};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PriceWrapper,[{key:'render',value:function render(){var _props=this.props,product=_props.product,withTax=_props.withTax,accountStore=_props.accountStore,configStore=_props.configStore,isSecondaryPrice=_props.isSecondaryPrice,isMultiProductPicker=_props.isMultiProductPicker,depositInPrice=_props.depositInPrice;var _showPrices=this.showPrices(configStore,accountStore),hideTaxIncludedInfo=_showPrices.hideTaxIncludedInfo,retailer=_showPrices.retailer;var showTaxIncludedInfo=withTax&&(hideTaxIncludedInfo||retailer);var price=null;if(product.class===__WEBPACK_IMPORTED_MODULE_4__types_ProductClass__["b" /* default */].MULTI){var priceRange=withTax?product.multi.getSecondaryPriceRange(withTax):product.multi.priceRange;if(priceRange&&priceRange.min&&priceRange.max){price=priceRange.min!==priceRange.max?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductPriceRange__["a" /* default */],{range:priceRange,withTax:withTax,showTaxIncludedInfo:showTaxIncludedInfo,isSecondaryPrice:isSecondaryPrice}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductPrice__["a" /* default */],{product:product,priceInfo:priceRange.min,withTax:withTax,showTaxIncludedInfo:showTaxIncludedInfo,isSecondaryPrice:isSecondaryPrice,depositInPrice:depositInPrice});}}else{if(product.price_info){price=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductPrice__["a" /* default */],{product:product,priceInfo:product.price_info,withTax:withTax,showTaxIncludedInfo:showTaxIncludedInfo,isSecondaryPrice:isSecondaryPrice,isMultiProductPicker:isMultiProductPicker,depositInPrice:depositInPrice});}}return price;}}]);return PriceWrapper;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;PriceWrapper.propTypes={product:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]).isRequired,withTax:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,isSecondaryPrice:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,isMultiProductPicker:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,depositInPrice:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};PriceWrapper.defaultProps={depositInPrice:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])(function(stores,props){return{accountStore:stores.accountStore,configStore:stores.configStore,withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(PriceWrapper));

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_analytics_PageView__ = __webpack_require__(991);
var TrackingStore=__WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__["a" /* default */].named('TrackingStore').props({pageView:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__models_analytics_PageView__["a" /* default */],{})}).actions(function(self){var baseApi='tracking/';var setStoreLoadingState=function setStoreLoadingState(loading){return self.setLoading(loading);};var getLang=function getLang(){return Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["e" /* getParent */])(self).languageStore.activeLanguage.code;};var setPageView=function setPageView(pageView){var lang=getLang();self.pageView=Object.assign({},pageView,{lang:lang});};var postPageView=function postPageView(){setStoreLoadingState(true);if(!self.pageView.lang||!self.pageView.visitedUrl){return null;}try{Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post(baseApi+'page-view',self.pageView);}catch(error){self.setError(error);throw error;}setStoreLoadingState(false);};return{setPageView:setPageView,postPageView:postPageView};});/* harmony default export */ __webpack_exports__["a"] = (TrackingStore);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AVAILABILITY_TAB_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHIPPING_TAB_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRODUCT_INFORMATION_BANNER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADDITIONAL_SERVICES_ID; });
/* unused harmony export ProductPageContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_head__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lazyload__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_qs__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProductImages__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ProductFiles__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ProductCollectionProductPicker__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ProductMultiProductPicker__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__manufacturer_ManufacturerLink__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ProductReviewWidget__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ProductStoreAvailability__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__slider_LastVisitedProductsSlider__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ProductImageSigns__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ProductExtraInfo__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_HashTabs__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ProductAvailabilityList__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ProductPagePrice__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__head_SEODescription__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ProductOfferSchema__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__slider_RecommendedProductsSlider__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ProductShippingDetails__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ProductReviews__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__ProductPackageSize__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__ProductAddToCart__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ProductSeasonInfo__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ad_BannerSlider__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__ad_ContentSlots__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ProductBundles__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ProductId__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__category_CategoryLink__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__common_AccordionTabs__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__store_PaymentModuleStore__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__integrations_klarna_KlarnaPromotionWidget__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__ad_AdLoader__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__bootstrap_CustomCol__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__ad_ContentSlot__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__ProductAdditionalTabText__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__product_enquiry_ProductEnquiry__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__slider_AlsoPurchasedProductsSlider__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ProductFileUploads__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ProductQuantityDiscounts__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ProductSizeGuides__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__ProductOnlyInStore__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__types_ProductAvailabilityType__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__services_LocationContext__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__ProductDateAvailable__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__integrations_loadBee_LoadBeeProductContentWidget__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__types_ManufacturerIntegrationType__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__ProductReserveInStoreModal__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__ProductReserveInStoreButton__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__common_ImageLightboxHelper__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__types_ProductEnquiryType__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__ProductFeatureImages__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__PriceWrapper__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__ProductAddToWishList__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__util_locale__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__vehicle_CompatibleVehicleModels__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__vehicle_VehiclePartSlider__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__slider_GenericProductsSlider__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__ProductCollectionMatrix__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__PriceSecondary__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__types_ExternalReviewType__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__integrations_klarna_KlarnaInstantShopping__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__info_page_InfoPageLink__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__ProductDescription__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__integrations_swogo_SwogoBundleWidget__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__loader_BlockSpinner__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__integrations_yotpo_YotpoMainWidget__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__head_SEOSchema__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__ProductDeposit__ = __webpack_require__(527);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["d" /* defineMessages */])({'product.manufacturerLogoAlt':{'id':'product.manufacturerLogoAlt','defaultMessage':'{manufacturer} logo'},shoppingCenterAcceptableTerms:{'id':'product.shoppingCenterAcceptableTerms','defaultMessage':'Merchant\'s {merchantName} {deliveryAndPaymentTerms} and {merchantPrivacyStatement}'}});var BRAND_TAB_ID='brand';var DESCRIPTION_TAB_ID='description';var REVIEWS_TAB_ID='reviews';var AVAILABILITY_TAB_ID='availability';var SHIPPING_TAB_ID='shipping';var PRODUCT_INFORMATION_BANNER_ID='product-information';var ADDITIONAL_SERVICES_ID='additional-services';var ProductPageContent=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(ProductPageContent,_Component);function ProductPageContent(props){_classCallCheck(this,ProductPageContent);var _this=_possibleConstructorReturn(this,(ProductPageContent.__proto__||Object.getPrototypeOf(ProductPageContent)).call(this,props));_initialiseProps.call(_this);var configStore=props.configStore;_this.pageResized=true;_this.tabYOffsetTop=0;_this.resizeEventAttached=false;_this.supportedPurchaseCountriesAndCurrencies={};_this.ifSupportedCountryWithCurrency=false;_this.ifProductRowImages=true;_this.yotpoTimeout=null;_this.state={quantity:1,hasValidShippingMethods:window.isSSR||!configStore.productPage.validateForCartQuery,shippingOptionLoaded:__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].NONE,productIsValidForCart:true};_this.maybeLoadBundleProductInfos();_this.maybeLoadAdditionalTabs();_this.maybeLoadAdditionalServices();_this.maybeOpenDefaultTab();_this.maybeLoadSizeGuides();_this.maybeLoadRelatedProducts();_this.maybeLoadPaymentWidget();_this.getPurchaseCountriesAndCurrencies();_this.supportedCountryWithCurrency();return _this;}_createClass(ProductPageContent,[{key:'componentDidMount',value:function componentDidMount(){var hash=this.getHash();if(hash){this.updateElementYOffset(hash);}this.resizeHandler=this.resizeHandler.bind(this);this.addResizeEventListener();window.addEventListener('scroll',this.handleScroll,true);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.activeProductId!==this.props.activeProductId){this.maybeLoadBundleProductInfos();this.maybeLoadAdditionalTabs();this.maybeLoadSizeGuides();this.maybeLoadRelatedProducts();this.maybeOpenDefaultTab();this.maybeLoadPaymentWidget();this.getPurchaseCountriesAndCurrencies();this.supportedCountryWithCurrency();}if(prevProps.activeProductId!==this.props.activeProductId||prevProps.product!==this.props.product){this.maybeReloadScripts();}if(prevProps.activeProductId!==this.props.activeProductId||this.props.categoryStore.activeCategory){this.maybeLoadAdditionalServices();}if(prevProps.activeProductId!==this.props.activeProductId||this.props.cartLoaded===true&&this.state.hasValidShippingMethods===false&&this.state.shippingOptionLoaded===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].NONE){this.maybeDisableCart();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.resizeEventAttached=false;window.removeEventListener('resize',this.resizeHandler);window.removeEventListener('scroll',this.handleScroll,true);this.props.uiStore.toggleAddToCartRow(false);this.yotpoTimeout&&clearTimeout(this.yotpoTimeout);}},{key:'getProductDescriptionTab',value:function getProductDescriptionTab(addToCartProduct){var _this2=this;var _props=this.props,product=_props.product,adSearchParams=_props.adSearchParams;var productHasWysiwygContent=addToCartProduct&&addToCartProduct.description_long;var productHasFiles=addToCartProduct&&addToCartProduct.files.length>0;var showProductDescriptionTab=productHasWysiwygContent||productHasFiles;if(showProductDescriptionTab){return Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])(DESCRIPTION_TAB_ID,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.descriptionTitle',defaultMessage:'Description'}),function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12',lg:'10'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__description'},productHasFiles&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ProductFiles__["a" /* default */],{key:product.id,product:addToCartProduct}),productHasWysiwygContent&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__common_WysiwygContent__["a" /* default */],{html:addToCartProduct.description_long}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:'12',lg:'2',className:'ProductPageContent__description-details'},_this2.renderSideAd(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.descriptionDetails',defaultMessage:'Details'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__ProductExtraInfo__["a" /* default */],{product:addToCartProduct,singleColumn:true})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__ad_BannerSlider__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_47__types_AdZones__["a" /* default */].PRODUCT_PAGE_BANNER_2},adSearchParams),className:'ProductPageContent__banner-slider--2',aspectRatio:2.85,maximumCrossAxisSize:250}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__ad_ContentSlots__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_47__types_AdZones__["a" /* default */].PRODUCT_PAGE_CONTENT_2},adSearchParams),className:'ProductPageContent__content-slots--2'}))));});}}},{key:'render',value:function render(){var _props2=this.props,shareButtons=_props2.shareButtons,product=_props2.product,activeProductId=_props2.activeProductId,categoryStore=_props2.categoryStore,configStore=_props2.configStore,uiStore=_props2.uiStore,routeService=_props2.routeService,adSearchParams=_props2.adSearchParams,locationContext=_props2.locationContext,accountStore=_props2.accountStore,paymentModuleStore=_props2.paymentModuleStore,setActiveProductId=_props2.setActiveProductId;var quantity=this.state.quantity;var hideAddToCart=accountStore.isViewOnly;var hideStorageInfo=accountStore.isViewOnly;var cartMatrixEnabled=accountStore.showCartMatrix&&product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION;var hidePrice=accountStore.isViewOnly;var addToCartProduct=product.getActualProduct(activeProductId)||product;var shouldHideParentPriceInfo=this.shouldHideParentPriceInfo();var activeCollectionElementIds=this.getActiveCollectionElementIds();var activeCollectionElementIdsArray=Object.values(activeCollectionElementIds).filter(function(item){return!!item;});var depositInPrice=configStore.productPage.depositInPrice&&product.bottle_deposit&&product.bottle_deposit.with_tax>0;var price=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_80__PriceWrapper__["a" /* default */],{product:product,depositInPrice:depositInPrice});var ifWebStore=configStore.siteConfig.isWebStore;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifBuyingAllowed=product.merchantInfo&&product.merchantInfo.buyingAllowed;var hasPriceRange=false;if(product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI){var priceRange=product.multi.priceRange;if(priceRange&&priceRange.min&&priceRange.max){hasPriceRange=priceRange.min!==priceRange.max;}}if(price){hidePrice=false;}var productForDiscountCalculations=product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI?product.multi.getChildWithBestDiscount():product;var tabs=this.getTabs(addToCartProduct);tabs=this.getVisibleTabs(tabs);var hash=this.getHash();var activeTabId=__WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(tabs,{id:hash})?hash:'';var tabProps={activeTabId:activeTabId,toggle:this.toggleTab,tabs:tabs,onUpdateElementYOffsetUpdate:this.updateElementYOffset};var tabComponent=uiStore.isMobile?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_54__common_AccordionTabs__["a" /* default */],tabProps):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["b" /* default */],tabProps);var withServices=product.additionalServicesState===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].LOADED&&product.additionalServices.length>0;var withRecurringOrder=configStore.recurringOrder.enabled&&addToCartProduct.hasRecurringOrder();var canonicalPath=routeService.getCanonicalProductPath(product);var hasImages=product.images.length>0;var enquireForProposal=configStore.product.enquireForProposal;var soldOut=activeProductId&&addToCartProduct.availability_type===__WEBPACK_IMPORTED_MODULE_69__types_ProductAvailabilityType__["b" /* default */].CLOSEOUT&&!product.hasEnoughStockAvailable(activeProductId);var disabled=!activeProductId||soldOut;var widgets=paymentModuleStore.paymentWidgetQueryResults.get(Object(__WEBPACK_IMPORTED_MODULE_97__util_queryString__["c" /* stringify */])(this.getWidgetQueryParameters()));var hasWidget=void 0;if(widgets){hasWidget=widgets.widgets.length>0;}var ifOutOfStock=this.getShowOutOfStockParam();var isValidByShippingMethods=!configStore.productPage.validateForCartQuery||this.state.hasValidShippingMethods;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{ref:this.setSelfRef,id:'productPageContent',className:'ProductPageContent'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_102__head_SEOSchema__["a" /* default */],{data:this.getSchemaData()}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__head_SEOTitle__["a" /* default */],{title:product.seoTitle}),product.seoDescription&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__head_SEODescription__["a" /* default */],{content:product.seoDescription}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__head_CanonicalLink__["a" /* default */],{path:canonicalPath}),uiStore.isMobile&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__mobile-header'},this.renderTitleBlock(),product.class!==__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__id'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__ProductId__["a" /* default */],{id:addToCartProduct.id})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__mobile-header-links'},ifWebStore&&product.manufacturer&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__mobile-header-manufacturer'},this.renderManufacturer()),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__mobile-header-category'},!categoryStore.activeCategory&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].loading),categoryStore.activeCategory&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__category_CategoryLink__["a" /* default */],{category:categoryStore.activeCategory,className:'ProductPageContent__extra-link'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.allProductsFromCategory',defaultMessage:'All {categoryLink}',values:{categoryLink:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'ProductPageContent__extra-link-target'},categoryStore.activeCategory.navigationName)}}))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_60__bootstrap_CustomCol__["a" /* default */],{xs:'12',md:'6',className:'ProductPageContent__column-images'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProductImages__["a" /* default */],{key:product.id,product:product,size:'large',lazyLoading:false,activeElementIds:activeCollectionElementIdsArray,activeProductId:activeProductId,mainImageOverlay:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__product-images-overlay'},hasImages&&(!accountStore.showCartMatrix||product.class!==__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_77__common_ImageLightboxHelper__["a" /* default */],{visible:!uiStore.isDesktop}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_79__ProductFeatureImages__["a" /* default */],{product:product,position:'product_image'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__ProductImageSigns__["a" /* default */],{product:product})),ifProductRowImages:this.ifProductRowImages}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__ad_BannerSlider__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_47__types_AdZones__["a" /* default */].PRODUCT_PAGE_BANNER_4},adSearchParams),aspectRatio:2.85,className:'ProductPageContent__banner-slider--4'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_60__bootstrap_CustomCol__["a" /* default */],{xs:'12',md:'6',className:'ProductPageContent__column-info'},!uiStore.isMobile&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()('ProductPageContent__side-content',{'col-xxl-5':ifShoppingCenter})},product.manufacturer&&product.manufacturer.image&&ifWebStore&&this.renderManufacturerImage(product),product.manufacturer&&ifWebStore&&this.renderManufacturer(),ifShoppingCenter&&uiStore.isLargest&&this.renderMerchantDescription(),ifShoppingCenter&&uiStore.isLargest&&ifBuyingAllowed&&this.renderMerchantAcceptableTerms(),this.renderSideAd(),ifShoppingCenter&&ifBuyingAllowed&&uiStore.isLargest&&this.renderProductPurchaseGuideLink()),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()('ProductPageContent__product-content',{'col-xxl-7':ifShoppingCenter})},!uiStore.isMobile&&this.renderTitleBlock(),product.class!==__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__ProductOfferSchema__["a" /* default */],{product:product}),price&&!addToCartProduct.isProposalType(addToCartProduct.id,enquireForProposal)&&!hidePrice&&!shouldHideParentPriceInfo&&productForDiscountCalculations&&!ifOutOfStock&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__price'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__ProductPagePrice__["a" /* default */],{price:price,depositInPrice:depositInPrice,product:productForDiscountCalculations,merchantInfo:product.merchantInfo,withDiscountLabel:false,withDiscountUpTo:hasPriceRange,withDiscountBalloon:!hasPriceRange,withDiscountSavings:!hasPriceRange,discountInverted:hasPriceRange}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_89__PriceSecondary__["a" /* default */],{product:product}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_105__ProductDeposit__["a" /* default */],{product:addToCartProduct||product,showPrice:!configStore.productPage.depositInPrice}),hasWidget&&this.renderKlarnaPromotionWidget(hidePrice,addToCartProduct,product)),product.class!==__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()('ProductPageContent__extra-info',{'ProductPageContent__extra-info-hide':hidePrice})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__ProductExtraInfo__["a" /* default */],{product:product})),!accountStore.isViewOnly&&product.sizeGuides.length>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_67__ProductSizeGuides__["a" /* default */],{product:addToCartProduct}),!accountStore.isViewOnly&&product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION&&!accountStore.showCartMatrix&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ProductCollectionProductPicker__["a" /* default */],{product:product,productImages:product.images,activeProductId:activeProductId,productCollection:product.collection,onProductChange:setActiveProductId,columnId:activeCollectionElementIds.columnId,rowId:activeCollectionElementIds.rowId}),!accountStore.isViewOnly&&product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ProductMultiProductPicker__["a" /* default */],{key:product.id,scrollToTab:this.scrollToTab,activeProductId:activeProductId,product:product,productImages:product.images,onProductChange:setActiveProductId,path:locationContext.protocol+'//'+locationContext.host,hasPriceRange:hasPriceRange}),ifShoppingCenter&&product.merchantInfo&&product.merchantInfo.site_name&&ifBuyingAllowed&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__merchant-info-site-name'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'ProductPageContent__merchant-info-site-name-marker'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'productPageContent.shoppingCenterSiteName',defaultMessage:'You\'re buying from {siteName}',values:{siteName:product.merchantInfo.site_name}}))),!hideStorageInfo&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__availability-list'},product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION&&activeProductId&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__ProductAvailabilityList__["a" /* default */],{scrollToTab:this.scrollToTab,product:product,activeProduct:product.collection.getItemWithProductId(activeProductId).product,shipping:this.showShipping()}),product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].SINGLE&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__ProductAvailabilityList__["a" /* default */],{scrollToTab:this.scrollToTab,product:product,activeProduct:product,shipping:this.showShipping()})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_71__ProductDateAvailable__["a" /* default */],{product:addToCartProduct})),addToCartProduct.sellInPackage&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__ProductPackageSize__["a" /* default */],{product:addToCartProduct}),addToCartProduct.season&&!hideAddToCart&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__ProductSeasonInfo__["a" /* default */],{season:addToCartProduct.season}),configStore.product.allowFileUploads&&!hideAddToCart&&product.allow_file_upload&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_65__ProductFileUploads__["a" /* default */],{product:addToCartProduct}),addToCartProduct.quantityDiscounts&&!hidePrice&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_66__ProductQuantityDiscounts__["a" /* default */],{product:addToCartProduct}),addToCartProduct.isProposalType(addToCartProduct.id,enquireForProposal)?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_63__product_enquiry_ProductEnquiry__["a" /* default */],{id:activeProductId,type:__WEBPACK_IMPORTED_MODULE_78__types_ProductEnquiryType__["a" /* default */].PROPOSAL_REQUEST}):!hideAddToCart&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,(!accountStore.showCartMatrix||product.class!==__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__AddToCartPosition',ref:this.setAddToCartRef}),this.renderNotValidForCartBanner(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__ProductAddToCart__["b" /* default */],{product:product,price:price,activeProductId:activeProductId,addToCartProduct:addToCartProduct,withReserveInStore:configStore.reserveInStore.enabled,withRecurringOrder:withRecurringOrder,withServices:withServices,onUpdateProductQuantity:this.updateProductQuantity,history:this.props.history,quantity:quantity,ifWebStore:ifWebStore,isValid:isValidByShippingMethods,scrollToServices:this.scrollToTab})),configStore.reserveInStore.enabled&&!product.isBlockedFromStoreReservation(configStore.reserveInStore.excludePropertyId)&&!hideStorageInfo&&addToCartProduct.availability_type===__WEBPACK_IMPORTED_MODULE_69__types_ProductAvailabilityType__["b" /* default */].ONLY_IN_SHOP&&(!accountStore.showCartMatrix||product.class!==__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductReserveInStore__wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].buttonInfo),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_75__ProductReserveInStoreButton__["a" /* default */],{product:product,activeProductId:activeProductId})),ifBuyingAllowed&&this.renderKlarnaInstantShopping(disabled),ifShoppingCenter&&this.renderMerchantInfo(),product.manufacturer&&ifShoppingCenter&&ifBuyingAllowed&&this.renderManufacturer(),ifShoppingCenter&&!uiStore.isLargest&&ifBuyingAllowed&&this.renderMerchantAcceptableTerms(),ifShoppingCenter&&ifBuyingAllowed&&!uiStore.isLargest&&this.renderProductPurchaseGuideLink(),cartMatrixEnabled&&this.renderProductInformationOnCartMatrix(),!soldOut&&configStore.wishlist.enabled&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_81__ProductAddToWishList__["a" /* default */],{disabled:disabled,activeProductId:activeProductId,price:this.props.price,product:addToCartProduct,accountStore:accountStore,quantity:this.state.quantity,history:this.props.history}),configStore.reserveInStore.enabled&&!hideStorageInfo&&(!accountStore.showCartMatrix||product.class!==__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_74__ProductReserveInStoreModal__["a" /* default */],null)),addToCartProduct.availability_type===__WEBPACK_IMPORTED_MODULE_69__types_ProductAvailabilityType__["b" /* default */].ONLY_IN_SHOP&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__ProductOnlyInStore__["a" /* default */],null),configStore.product.shortDescriptionBottom&&this.renderShortDescription(),activeProductId&&!addToCartProduct.isProposalType(addToCartProduct.id,enquireForProposal)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_63__product_enquiry_ProductEnquiry__["a" /* default */],{id:activeProductId,type:__WEBPACK_IMPORTED_MODULE_78__types_ProductEnquiryType__["a" /* default */].MESSAGE}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__ad_BannerSlider__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_47__types_AdZones__["a" /* default */].PRODUCT_PAGE_BANNER_1},adSearchParams),aspectRatio:2.85,className:'ProductPageContent__banner-slider--1'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__ad_ContentSlots__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_47__types_AdZones__["a" /* default */].PRODUCT_PAGE_CONTENT_1},adSearchParams),className:'ProductPageContent__content-slots--1'})))),!accountStore.isViewOnly&&this.renderProductCollectionMatrix(),configStore.witView.enabled&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:'12'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'wit-body','data-wit-container':'BodyLayout'}),this.renderWitViewWidget())),configStore.integrations.swogo.isEnabled&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_99__integrations_swogo_SwogoBundleWidget__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:'12'},uiStore.isMobile&&shareButtons,tabs.length>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__tabs'},tabComponent))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__ad_BannerSlider__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_47__types_AdZones__["a" /* default */].PRODUCT_PAGE_BANNER_3},adSearchParams),aspectRatio:2.85,className:'ProductPageContent__banner-slider--3'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__ad_ContentSlots__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_47__types_AdZones__["a" /* default */].PRODUCT_PAGE_CONTENT_3},adSearchParams),className:'ProductPageContent__content-slots--3'}),ifShoppingCenter&&!uiStore.isLargest&&this.renderMerchantDescription(),product&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_64__slider_AlsoPurchasedProductsSlider__["a" /* default */],{key:activeProductId,product:product}),product.id&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__slider_LastVisitedProductsSlider__["a" /* default */],{currentProductId:product.id}));}}]);return ProductPageContent;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this3=this;this.setAddToCartRef=function(elem){_this3.ref=elem;};this.setSelfRef=function(elem){_this3.refSelf=elem;};this.handleScroll=function(){var uiStore=_this3.props.uiStore;if(_this3.ref&&_this3.refSelf){var position=_this3.ref.getBoundingClientRect().bottom;var positionSelf=_this3.refSelf.getBoundingClientRect().bottom-80;if(position<0&&positionSelf>0&&!uiStore.addToCartRowIsVisible){uiStore.toggleAddToCartRow(true);}if((position>0||positionSelf<0)&&uiStore.addToCartRowIsVisible){uiStore.toggleAddToCartRow(false);}}};this.scrollToTab=function(tabId){if(window.isSSR){return;}_this3.setHash(tabId);Object(__WEBPACK_IMPORTED_MODULE_41__util_dom__["i" /* scrollToElementById */])(tabId,null,_this3.tabYOffsetTop);};this.toggleTab=function(tabId){if(tabId&&_this3.getHash()!==tabId){_this3.setHash(tabId);}else{_this3.setHash(null);}};this.setHash=function(hash){var history=_this3.props.history;var hashString=hash?'#'+hash:'';if(hash===REVIEWS_TAB_ID){_this3.maybeUpdateYotpoTab();}history.replace(history.location.pathname+history.location.search+hashString);};this.getHash=function(){var history=_this3.props.history;if(history.location.hash){// History hash includes the hashtag (#), strip it off.
return Object(__WEBPACK_IMPORTED_MODULE_58__util_url__["f" /* parseHash */])(history.location.hash);}return'';};this.maybeLoadBundleProductInfos=function(){var _props3=_this3.props,activeProductId=_props3.activeProductId,product=_props3.product;if(activeProductId){var actualProduct=product.getActualProduct(activeProductId);if(actualProduct.bundleProductInfosState===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].NONE){actualProduct.loadBundleProductInfos().catch(function(e){if(e.response&&e.response.status!==404){console.error(e);}});}}};this.maybeLoadAdditionalTabs=function(){var _props4=_this3.props,activeProductId=_props4.activeProductId,product=_props4.product,configStore=_props4.configStore;if(configStore.product.additionalProductTabsActive){var actualProduct=product.getActualProduct(activeProductId)||product;if(actualProduct&&actualProduct.additionalTabsState===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].NONE){actualProduct.loadAdditionalTabs().catch(function(e){if(e.response&&e.response.status!==404){console.error(e);}});}}};this.maybeLoadSizeGuides=function(){var _props5=_this3.props,activeProductId=_props5.activeProductId,product=_props5.product,adSearchParams=_props5.adSearchParams;var actualProduct=product.getActualProduct(activeProductId||product.id);_this3.getProductSizeGuides(product,activeProductId,adSearchParams);_this3.getActiveProductSizeGuides(activeProductId,actualProduct,adSearchParams);};this.getProductSizeGuides=function(product,activeProductId,adSearchParams){if(product&&product.sizeGuidesState===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].NONE&&!activeProductId){product.loadSizeGuides(adSearchParams).catch(function(e){if(e.response&&e.response.status!==404){console.error(e);}});}};this.getActiveProductSizeGuides=function(activeProductId,actualProduct,adSearchParams){if(activeProductId&&actualProduct&&actualProduct.sizeGuidesState===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].NONE){actualProduct.loadSizeGuides(adSearchParams).catch(function(e){if(e.response&&e.response.status!==404){console.error(e);}});}};this.maybeLoadRelatedProducts=function(){var _props6=_this3.props,configStore=_props6.configStore,product=_props6.product;configStore.vehiclePartSearch.enabled&&product.loadRelatedProducts().catch(function(e){if(e.response&&e.response.status!==404){console.error(e);}});};this.maybeLoadAdditionalServices=function(){var _props7=_this3.props,product=_props7.product,categoryStore=_props7.categoryStore;if(categoryStore.activeCategory&&product.additionalServicesState===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].NONE){product.loadAdditionalServices(categoryStore.activeCategory.id).catch(function(e){if(e.response&&e.response.status!==404){console.error(e);}});}};this.maybeOpenDefaultTab=function(){var uiStore=_this3.props.uiStore;if(uiStore.isMobile&&!_this3.getHash()){if(_this3.hasBrandTab()){_this3.toggleTab(BRAND_TAB_ID);}else{_this3.toggleTab(DESCRIPTION_TAB_ID);}}};this.maybeLoadPaymentWidget=function(){var paymentModuleStore=_this3.props.paymentModuleStore;paymentModuleStore.loadProductWidget(_this3.getWidgetQueryParameters()).catch(function(e){if(e.response&&e.response.status!==404){console.error(e);}});};this.maybeReloadScripts=function(){var configStore=_this3.props.configStore;if(configStore.witView.enabled&&window._witViewPluginApp){window._witViewPluginApp.run();}if(configStore.yotpo.enabled&&window&&window.yotpo){_this3.yotpoTimeout=setTimeout(function(){return window.yotpo.refreshWidgets();},800);}};this.maybeUpdateYotpoTab=function(){var configStore=_this3.props.configStore;if(configStore.yotpo.enabled&&document&&window&&window.yotpo){var domElements=document.getElementsByClassName('main-widget');_this3.refreshYotpo(domElements);}};this.refreshYotpo=function(elements){if(elements.length===0){_this3.yotpoTimeout=setTimeout(function(){return window.yotpo.refreshWidgets();},0);}};this.setAddingToCart=function(value){_this3.setState({hasValidShippingMethods:value,shippingOptionLoaded:!!value?__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].LOADED:__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].LOADING});};this.maybeDisableCart=function(){var _props8=_this3.props,apiWrapper=_props8.apiWrapper,cartStore=_props8.cartStore,configStore=_props8.configStore,cartLoaded=_props8.cartLoaded;if(window.isSSR||!configStore.productPage.validateForCartQuery||!cartLoaded){return;}// When cart is loaded and it has products we check valid shipping methods for current products eligibility to cart.
if(cartStore.cart.number_of_products===0){_this3.setAddingToCart(true);return;}if(cartStore.cart.number_of_products>0){_this3.setAddingToCart(false);apiWrapper.request('shipping/options-for-products/?'+__WEBPACK_IMPORTED_MODULE_12_qs___default.a.stringify(_this3.getOptionsQueryParameters())).then(function(data){if(data.length>0){_this3.setAddingToCart(true);}else{_this3.setState({productIsValidForCart:false});}});}};this.getOptionsQueryParameters=function(){var _props9=_this3.props,cartStore=_props9.cartStore,countryStore=_props9.countryStore;var productPayload=_this3.getCartProducts();return{countryCode:countryStore.activeCountry.iso_code_2.toLowerCase(),paymentModuleId:cartStore.cart.payment_method_id,products:productPayload};};this.getCartProducts=function(){var _props10=_this3.props,cartStore=_props10.cartStore,activeProductId=_props10.activeProductId;var productPayload=cartStore.cart.products.map(function(product){return{extendedId:product.id,quantity:product.quantity,reference:product.reference};});// Add current product also for the payload.
productPayload.push({extendedId:activeProductId,quantity:1});return productPayload;};this.getWidgetQueryParameters=function(){var _props11=_this3.props,accountStore=_props11.accountStore,countryStore=_props11.countryStore,product=_props11.product;return{countryCode:countryStore.activeCountry.id,groupId:accountStore.getCustomerGroupId,productLicenseType:product.required_license};};this.getActiveCollectionElementIds=function(){var _props12=_this3.props,activeProductId=_props12.activeProductId,product=_props12.product,queryParams=_props12.queryParams;if(product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION){if(activeProductId){var activeItem=product.collection.getItemWithProductId(activeProductId);if(activeItem){return{columnId:activeItem.column_id,rowId:activeItem.row_id};}}return{columnId:queryParams.columnId?Number(queryParams.columnId):null,rowId:queryParams.rowId?Number(queryParams.rowId):null};}return{columnId:null,rowId:null};};this.goToReviews=function(){_this3.addResizeEventListener(REVIEWS_TAB_ID);_this3.updateElementYOffset(REVIEWS_TAB_ID);_this3.scrollToTab(REVIEWS_TAB_ID);};this.goToDescription=function(){_this3.addResizeEventListener(DESCRIPTION_TAB_ID);_this3.updateElementYOffset(DESCRIPTION_TAB_ID);_this3.scrollToTab(DESCRIPTION_TAB_ID);};this.hasBrandTab=function(){var _props13=_this3.props,product=_props13.product,configStore=_props13.configStore;return configStore.zoovu.enabled&&product.manufacturer&&__WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(product.manufacturer.integrations,{type:__WEBPACK_IMPORTED_MODULE_73__types_ManufacturerIntegrationType__["b" /* default */].LOADBEE});};this.getTabs=function(addToCartProduct){var _props14=_this3.props,product=_props14.product,activeProductId=_props14.activeProductId,configStore=_props14.configStore,accountStore=_props14.accountStore,routeService=_props14.routeService,currencyStore=_props14.currencyStore;var tabs=[];var isViewOnly=accountStore.isViewOnly;var ifWebStore=configStore.siteConfig.isWebStore;var brandTab=_this3.getBrandTab();brandTab&&tabs.push(brandTab);var descriptionTab=_this3.getProductDescriptionTab(addToCartProduct);descriptionTab&&tabs.push(descriptionTab);if(activeProductId&&addToCartProduct.bundleProductInfos.length>0&&!isViewOnly){var productBundleTab=_this3.buildProductBundleTab(addToCartProduct);productBundleTab&&tabs.push(productBundleTab);}var recommendedProductSlider=_this3.buildRecommendedProductsTab();if(!configStore.integrations.swogo.isEnabled&&!configStore.vehiclePartSearch.enabled&&product.recommended_with_ids.length>0&&ifWebStore){recommendedProductSlider&&tabs.push(recommendedProductSlider);}if(!configStore.integrations.swogo.isEnabled&&configStore.vehiclePartSearch.enabled&&product.recommendedIds.length>0&&ifWebStore){recommendedProductSlider&&tabs.push(recommendedProductSlider);}if(configStore.vehiclePartSearch.enabled&&product.alternativeIds.length>0){var relatedProductsTitle=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].relatedProductsTitle);tabs.push(Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])('related products',relatedProductsTitle,function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_87__slider_GenericProductsSlider__["a" /* default */],{listName:'Related Products',mainComponentClassName:'RelatedProductsSlider',allSections:true,ids:product.alternativeIds.slice(),formattedMessage:relatedProductsTitle});}));}if(configStore.product.showStoreAvailability&&activeProductId&&!isViewOnly){var availabilityTab=_this3.renderProductAvailabilityTab();availabilityTab&&tabs.push(availabilityTab);}var reviewComponent=void 0;if(configStore.yotpo.enabled){var productId=''+product.id;var path=''+window.location.host+routeService.getProductPath(product);var image=product.getMainImage(product.product_id);var price=''+product.getPriceWithPrecision(true,activeProductId);var currency=''+currencyStore.activeCurrency.code;var name=product.name;reviewComponent=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_101__integrations_yotpo_YotpoMainWidget__["a" /* default */],{className:'ProductPageContent__reviews',productId:productId,productPrice:price,currency:currency,productName:name,productPath:path,productImage:image,refresher:_this3.maybeUpdateYotpoTab});}else{reviewComponent=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__ProductReviews__["a" /* default */],{product:product});}if(configStore.reviews.enabled&&!isViewOnly){var reviewsTab=_this3.renderProductReviewsTab(reviewComponent);reviewsTab&&tabs.push(reviewsTab);}if((addToCartProduct||activeProductId)&&!isViewOnly){var shippingTab=_this3.renderShippingTab(addToCartProduct);shippingTab&&tabs.push(shippingTab);}if(configStore.product.additionalProductTabsActive&&addToCartProduct.additionalTabs.length>0){addToCartProduct.additionalTabs.slice().forEach(function(tab,index){return tabs.push(Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])(tab.title+'-'+index,tab.title,function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__ProductAdditionalTabText__["a" /* default */],{additionalTabHtml:tab.text});}));});}if(product.startaxInfo){if(product.startaxInfo.compatibleModels&&product.startaxInfo.compatibleModels.length>0){tabs.push(Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])('compatibleModels','compatibleModels',function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_85__vehicle_CompatibleVehicleModels__["a" /* default */],{product:product});}));}if(product.startaxInfo.alternatives&&product.startaxInfo.alternatives.length>0){tabs.push(Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])('alternatives','alternatives',function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_86__vehicle_VehiclePartSlider__["a" /* default */],{productIds:product.startaxInfo.alternatives,title:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.vehiclePartAlternatives',defaultMessage:'Alternatives'})});}));}if(product.startaxInfo.compatibleProducts&&product.startaxInfo.compatibleProducts.length>0){tabs.push(Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])('compatibleProducts','compatibleProducts',function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_86__vehicle_VehiclePartSlider__["a" /* default */],{productIds:product.startaxInfo.compatibleProducts,title:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.compatibleVehicleParts',defaultMessage:'Compatible'})});}));}if(product.startaxInfo.spareParts&&product.startaxInfo.spareParts.length>0){tabs.push(Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])('spareParts','spareParts',function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_86__vehicle_VehiclePartSlider__["a" /* default */],{productIds:product.startaxInfo.spareParts,title:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.spareParts',defaultMessage:'Spares'})});}));}}var servicesTab=_this3.getAdditionalServicesTab();servicesTab&&tabs.push(servicesTab);return tabs;};this.getBrandTab=function(){var product=_this3.props.product;if(_this3.hasBrandTab()){return Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])(BRAND_TAB_ID,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.manufacturersContentTitle',defaultMessage:'Manufacturers content'}),function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__integrations_loadBee_LoadBeeProductContentWidget__["a" /* default */],{manufacturer:product.manufacturer,gtin:product.ean});});}};this.buildProductBundleTab=function(addToCartProduct){var _props15=_this3.props,activeProductId=_props15.activeProductId,configStore=_props15.configStore,product=_props15.product;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var swogo=configStore.integrations.swogo;var ifBuyingAllowed=ifShoppingCenter&&product.merchantInfo&&product.merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed||swogo.isEnabled){return;}return Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])('bundles',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].productBundlesTitle),function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__ProductBundles__["a" /* default */],{product:addToCartProduct,activeProductId:activeProductId}));});};this.buildRecommendedProductsTab=function(){var _props16=_this3.props,configStore=_props16.configStore,product=_props16.product;var swogo=configStore.integrations.swogo;if(swogo.isEnabled){return;}return Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])('recommended',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].recommendedProductsTitle),function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__slider_RecommendedProductsSlider__["a" /* default */],{ids:configStore.vehiclePartSearch.enabled?product.recommendedIds.slice():product.recommended_with_ids.slice()});});};this.renderProductAvailabilityTab=function(){var _props17=_this3.props,activeProductId=_props17.activeProductId,configStore=_props17.configStore,product=_props17.product;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifBuyingAllowed=product.merchantInfo&&product.merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed){return;}return Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])(AVAILABILITY_TAB_ID,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'stock.storeAvailability',defaultMessage:'Store availability'}),function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,activeProductId&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ProductStoreAvailability__["a" /* default */],{activeProductId:activeProductId,product:product,merchantSiteUrl:product.merchantSiteUrl}));});};this.renderProductReviewsTab=function(reviewComponent){var _props18=_this3.props,product=_props18.product,configStore=_props18.configStore;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifReviews=product.reviews_count;if(ifShoppingCenter&&!ifReviews){return;}return Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])(REVIEWS_TAB_ID,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].reviewsTitle),function(){return reviewComponent;});};this.renderShippingTab=function(addToCartProduct){var _props19=_this3.props,activeProductId=_props19.activeProductId,product=_props19.product,configStore=_props19.configStore;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifBuyingAllowed=product.merchantInfo&&product.merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed){return;}var ifOutOfStock=_this3.getShowOutOfStockParam();if(addToCartProduct.isNotAvailable()||ifOutOfStock){return;}var costsSentence=configStore.productPage.shippingOnlyProduct?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'shipping.allCostsTitle',defaultMessage:'Products shipping costs'}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].shippingCostsTitle);return Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])(SHIPPING_TAB_ID,costsSentence,function(){return(addToCartProduct||activeProductId)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__ProductShippingDetails__["a" /* default */],{activeProductId:activeProductId||product.id,product:addToCartProduct});});};this.getAdditionalServicesTab=function(){var _props20=_this3.props,product=_props20.product,configStore=_props20.configStore;var ifAdditionalServicesModalEnabled=configStore.productPage.enableAdditionalServicesModal;var servicesAmount=product.additionalServices.length;var content=_this3.getServiceTabContent();if(ifAdditionalServicesModalEnabled&&servicesAmount>0){return Object(__WEBPACK_IMPORTED_MODULE_27__common_HashTabs__["a" /* createHashTab */])(ADDITIONAL_SERVICES_ID,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].additionalServicesTitle),content);}};this.getServiceTabContent=function(){var product=_this3.props.product;var servicesAreLoading=product.additionalServicesState===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].LOADING;return servicesAreLoading?function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_100__loader_BlockSpinner__["a" /* default */],null);}:function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__additional-services-information'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'additionalService.information',defaultMessage:'You can select additional services, when the product is being added to the cart.'})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'ProductPageContent__additional-services'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,product.additionalServices.map(function(service){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{key:service.id,sm:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,service.selection_text));}))));};};this.getVisibleTabs=function(tabs){var _props21=_this3.props,activeProductId=_props21.activeProductId,product=_props21.product;var ifLoaded=product.stockStates.get(activeProductId)===__WEBPACK_IMPORTED_MODULE_49__types_RequestState__["b" /* default */].LOADED;var stocks=ifLoaded&&product.stocks.get(activeProductId);var ifStocks=ifLoaded&&stocks&&stocks.length>0;return ifLoaded&&!ifStocks?tabs.filter(function(tab){return tab.id!==AVAILABILITY_TAB_ID;}):tabs;};this.showShipping=function(){var _props22=_this3.props,activeProductId=_props22.activeProductId,product=_props22.product,hideAddToCart=_props22.hideAddToCart;return activeProductId&&product.canBeOrdered(activeProductId)&&!hideAddToCart;};this.renderManufacturerImage=function(product){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:product.manufacturer},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__manufacturer-image'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:product.manufacturer.image,alt:_this3.props.intl.formatMessage(messages['product.manufacturerLogoAlt'],{manufacturer:product.manufacturer.name}),loading:'lazy'})));};this.renderManufacturer=function(){var product=_this3.props.product;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__manufacturer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:product.manufacturer,className:'ProductPageContent__extra-link'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.allProductsFromManufacturer',defaultMessage:'All {manufacturerLink} products',values:{manufacturerLink:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'ProductPageContent__extra-link-target'},product.manufacturer.name)}})));};this.renderMerchantDescription=function(){var product=_this3.props.product;if(!product.merchantInfo){return null;}return product.merchantInfo.site_description&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__site-description',dangerouslySetInnerHTML:{__html:product.merchantInfo.site_description}});};this.renderMerchantAcceptableTerms=function(){var product=_this3.props.product;if(!product.merchantInfo){return null;}var merchantName=product.merchantInfo.site_name;var deliveryAndPaymentTerms=product.merchantInfo.deliveryTerms.link;var merchantPrivacyStatement=product.merchantInfo.privacyStatement.link;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__acceptable-terms'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.shoppingCenterAcceptableTerms,{values:{merchantName:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'ProductPageContent__merchant-name'},merchantName),deliveryAndPaymentTerms:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:deliveryAndPaymentTerms,target:'_blank',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].shoppingCenterDeliveryAndPaymentTerms)),merchantPrivacyStatement:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:merchantPrivacyStatement,target:'_blank',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].shoppingCenterPrivacyStatement))}})));};this.renderSideAd=function(){var adSearchParams=_this3.props.adSearchParams;var bannerZone=__WEBPACK_IMPORTED_MODULE_47__types_AdZones__["a" /* default */].PRODUCT_PAGE_CONTENT_4;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_lazyload___default.a,{once:true,offset:50,height:25},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__ad_AdLoader__["a" /* default */],{searchParams:Object.assign({},adSearchParams,{bannerZone:bannerZone})},function(ads){if(!ads||ads.length===0){return null;}var ad=__WEBPACK_IMPORTED_MODULE_1_lodash_head___default()(ads);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_61__ad_ContentSlot__["a" /* default */],{ad:ad,bannerZone:bannerZone,className:'ProductPageContent__side-ad'});}));};this.renderKlarnaPromotionWidget=function(hidePrice,addToCartProduct,product){return!hidePrice&&product.price_info&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_56__integrations_klarna_KlarnaPromotionWidget__["a" /* default */],{paymentModuleQueryResultKey:Object(__WEBPACK_IMPORTED_MODULE_97__util_queryString__["c" /* stringify */])(_this3.getWidgetQueryParameters()),priceInfo:addToCartProduct.price_info,widgetType:'credit-promotion-standard',ifSupportedCountryWithCurrency:_this3.ifSupportedCountryWithCurrency});};this.getPurchaseCountriesAndCurrencies=function(){var configStore=_this3.props.configStore;if(!configStore.klarnaSupportedLocaleCurrencies){return;}var supportedCountriesAndCurrencies=configStore.klarnaSupportedLocaleCurrencies;supportedCountriesAndCurrencies.split(';').forEach(function(currency){var supportedCountriesAndCurrenciesArr=currency.split(',');supportedCountriesAndCurrenciesArr[1]&&(_this3.supportedPurchaseCountriesAndCurrencies[supportedCountriesAndCurrenciesArr[0]]=supportedCountriesAndCurrenciesArr[1]);});};this.supportedCountryWithCurrency=function(){var _props23=_this3.props,countryStore=_props23.countryStore,currencyStore=_props23.currencyStore;if(!countryStore.activeCountry||!countryStore.activeCountry.iso_code_2||!currencyStore.activeCurrency||!currencyStore.activeCurrency.code){return;}var purchaseCountryCode=Object(__WEBPACK_IMPORTED_MODULE_84__util_locale__["a" /* convertLocaleToFinlandIfAland */])(countryStore.activeCountry.iso_code_2);var purchaseCurrencyCode=currencyStore.activeCurrency.code;var purchaseCountry=_this3.supportedPurchaseCountriesAndCurrencies.hasOwnProperty(purchaseCountryCode);var purchaseCurrency=_this3.supportedPurchaseCountriesAndCurrencies[purchaseCountryCode];_this3.ifSupportedCountryWithCurrency=purchaseCountry&&purchaseCurrencyCode===purchaseCurrency;};this.updateElementYOffset=function(tabId){var element=Object(__WEBPACK_IMPORTED_MODULE_41__util_dom__["e" /* getElementById */])(tabId);if(!element){return;}if(_this3.pageResized){_this3.countElementPositionOnMobile(element);_this3.countElementPositionOnLandscape(element);_this3.countElementPositionOnTablet(element);_this3.pageResized=false;}};this.countElementPositionOnMobile=function(element){if(_this3.props.uiStore.isMobile){_this3.tabYOffsetTop=Object(__WEBPACK_IMPORTED_MODULE_41__util_dom__["c" /* countElementYOffsetFromDocumentTop */])(element);}};this.countElementPositionOnLandscape=function(element){if(window.screen.width>window.screen.height&&_this3.props.uiStore.isTablet){_this3.countCloseApproximate(element,2.5);}};this.countElementPositionOnTablet=function(element){if(window.screen.width>window.screen.height&&_this3.props.uiStore.isDesktop){_this3.countCloseApproximate(element,3);}};this.shouldHideParentPriceInfo=function(){var product=_this3.props.product;if(product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI){return product.multi.children.length===1;}return false;};this.countCloseApproximate=function(element,divider){var getCloseApproximate=window.innerHeight/divider;_this3.tabYOffsetTop=Object(__WEBPACK_IMPORTED_MODULE_41__util_dom__["c" /* countElementYOffsetFromDocumentTop */])(element)-getCloseApproximate;};this.addResizeEventListener=function(){if(!_this3.resizeEventAttached){_this3.resizeEventAttached=true;window.addEventListener('resize',_this3.resizeHandler);}};this.resizeHandler=function(){var hash=_this3.getHash();if(hash){_this3.pageResized=true;_this3.updateElementYOffset(hash);}};this.updateProductQuantity=function(quantity){var cartStore=_this3.props.cartStore;cartStore.updateProductQuantity(quantity);_this3.setState({quantity:quantity});};this.renderProductInformationOnCartMatrix=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__cart-matrix-product-information',onClick:function onClick(){return _this3.scrollToTab(PRODUCT_INFORMATION_BANNER_ID);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductPageContent__cart-matrix-product-information-row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{md:12,className:'ProductPageContent__cart-matrix-product-information-column'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'ProductPageContent__cart-matrix-product-information-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.cartMatrixProductInformation',defaultMessage:'Select the products to order from the table below.'})))));};this.renderProductCollectionMatrix=function(){var _props24=_this3.props,accountStore=_props24.accountStore,product=_props24.product;var productMatrix=product.collection;var ifProductCollection=_this3.checkIfProductCollection(productMatrix);var matrixEnabled=accountStore.showCartMatrix;return ifProductCollection&&matrixEnabled&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_88__ProductCollectionMatrix__["a" /* default */],{ifProductRowImages:_this3.productRowImages,product:product,productMatrix:productMatrix});};this.checkIfProductCollection=function(productMatrix){return _this3.props.product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].COLLECTION&&productMatrix&&(productMatrix.column||productMatrix.row)&&(productMatrix.column.elements||productMatrix.row.elements);};this.productRowImages=function(){return _this3.ifProductRowImages;};this.renderWitViewWidget=function(){var _props25=_this3.props,configStore=_props25.configStore,languageStore=_props25.languageStore;var customerId=configStore.witView.customerId;var apiUrl=configStore.witView.apiUrl;if(!customerId.length>0||!apiUrl.length>0){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('script',null,'(function (w, i, t) {\n            w._witViewPlugin = {\n              ci: "'+customerId+'", //Client id\n              locale: "'+languageStore.activeLocale+'",\n              fields: {\n                selectors: {\n                  fullTitle: "h1.PageTitle", // selector for product name in the page\n                  stars: \'//div[@class="originalAggregateRating"]/div[@class="originalRatingValue"]/@content\', //selector for parent site stars\n                  reviewerCount: \'//div[@class="originalAggregateRating"]/div[@class="originalReviewCount"]/@content\', //selector for parent site\n                },\n                buttons: {\n                  showShopReviewsLink: \'.ProductPageContent__show-reviews-link\',\n                  submitReviewLink: \'.ProductPageContent__write-review-link\',\n                },\n                  hideMe: {\n                  parentReviewTopStars: \'.ProductReviewWidget\',\n                }\n              }\n            };\n            a = i.getElementsByTagName(\'head\')[0]; r = i.createElement(\'script\'); r.async = 1; r.src = t + \'/witview.js?ci=\' +\n            w._witViewPlugin.ci; a.appendChild(r);\n            })(window, document, \''+apiUrl+'\');')));};this.renderTitleBlock=function(){var _props26=_this3.props,configStore=_props26.configStore,product=_props26.product;var productTitle=product.multiproduct_title||product.name;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_59__common_PageTitle__["a" /* default */],null,productTitle),_this3.ifShowModel()&&product.model&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__model'},product.model),configStore.product.shortDescriptionTop&&_this3.renderShortDescription(),_this3.renderReviews());};this.renderShortDescription=function(){var _props27=_this3.props,configStore=_props27.configStore,product=_props27.product;if(!configStore.product.showShortDescription){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_98__ProductDescription__["a" /* default */],{className:'ProductPageContent__short-description',overflowHandler:_this3.goToDescription,product:product,isProductPage:true});};this.renderReviews=function(){var _props28=_this3.props,accountStore=_props28.accountStore,configStore=_props28.configStore;var hideReviews=accountStore.isViewOnly;var witViewEnabled=configStore.witView.enabled;var reviewsWidget=null;if(!configStore.reviews.enabled||hideReviews){return null;}if(witViewEnabled){reviewsWidget=_this3.renderWitviewReviews();}else{reviewsWidget=_this3.renderStoreReviews();}return reviewsWidget;};this.renderWitviewReviews=function(){var _props29=_this3.props,intl=_props29.intl,product=_props29.product;var _getReviews=_this3.getReviews(),noReviews=_getReviews.noReviews;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__reviews'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ProductReviewWidget__["a" /* default */],{product:product}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'wit-heading','data-wit-container':'heading'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__common_ButtonLink__["a" /* default */],{className:'ProductPageContent__show-reviews-link',onClick:_this3.goToReviews}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__common_ButtonLink__["a" /* default */],{className:'ProductPageContent__write-review-link',onClick:_this3.goToReviews,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].writeNewReview)},noReviews&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].writeNewReview)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'originalAggregateRating'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'originalRatingValue',content:product.reviews_average}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'originalReviewCount',content:product.reviews_count})));};this.renderStoreReviews=function(){var _props30=_this3.props,configStore=_props30.configStore,product=_props30.product,intl=_props30.intl;var isWebStore=configStore.siteConfig.isWebStore;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__reviews'},product.reviews_count>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__common_ButtonLink__["a" /* default */],{className:'ProductPageContent__show-reviews-link',onClick:_this3.goToReviews},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ProductReviewWidget__["a" /* default */],{product:product})):isWebStore&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__common_ButtonLink__["a" /* default */],{className:'ProductPageContent__write-review-link',onClick:_this3.goToReviews,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].writeNewReview)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].writeNewReview)));};this.getReviews=function(){var _props31=_this3.props,configStore=_props31.configStore,product=_props31.product;var witViewEnabled=configStore.witView.enabled;var schemaAverage=void 0;var schemaCount=void 0;var witViewRating=void 0;if(witViewEnabled){witViewRating=_this3.getWitViewRating();}if(witViewEnabled&&witViewRating){schemaAverage=witViewRating.reviews_average;schemaCount=witViewRating.reviews_count;}else{schemaAverage=product.reviews_average;schemaCount=product.reviews_count;}var noReviews=schemaCount===0&&schemaAverage===0;return{schemaAverage:schemaAverage,schemaCount:schemaCount,noReviews:noReviews};};this.getWitViewRating=function(){var product=_this3.props.product;if(!product.external_reviews){return;}return product.external_reviews.find(function(_ref){var type=_ref.type;return type===__WEBPACK_IMPORTED_MODULE_91__types_ExternalReviewType__["a" /* default */].WITVIEW;});};this.renderKlarnaInstantShopping=function(disabled){var _props32=_this3.props,configStore=_props32.configStore,activeProductId=_props32.activeProductId,product=_props32.product;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var productIsUnavailable=activeProductId&&product.isTemporarilyUnavailable(activeProductId);var merchantId=product.merchantId;return ifShoppingCenter&&!productIsUnavailable&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_92__integrations_klarna_KlarnaInstantShopping__["a" /* default */],{activeProductId:activeProductId,product:product,disabled:disabled,quantity:_this3.state.quantity,merchantId:merchantId});};this.renderMerchantInfo=function(){var _props33=_this3.props,product=_props33.product,activeProductId=_props33.activeProductId;if(!product.merchantInfo){return null;}var activeProduct=product.getActualProduct(activeProductId)||product;var url=_this3.redirectToMerchantsPage(activeProduct.id);var ifBuyingAllowed=product.merchantInfo.buying_allowed;var merchantName=product.merchantInfo.site_name;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__merchant-info'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:url,target:'_blank',rel:'noopener'},product.merchantInfo.site_logo&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__merchant-image'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:product.merchantInfo.site_logo,alt:'Merchant Logo',loading:'lazy'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__merchant-page-buy-products-info'},ifBuyingAllowed?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'productPageContent.shoppingCenterBuyProductsInfo',defaultMessage:'If you buy several products at once, you can also go to the merchant\'s online store. There you can also find the merchant\'s whole selection'}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'productPageContent.shoppingCenterBuyingNotAllowed',defaultMessage:'This product has limitations for purchase. Please check the merchants store for more information.',values:{merchantName:merchantName}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductPageContent__merchant-page-redirect-button'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'productPageContent.shoppingCenterProductMerchantLink',defaultMessage:'Go to the merchant\'s online store'}))));};this.redirectToMerchantsPage=function(productId){var _props34=_this3.props,locationContext=_props34.locationContext,languageStore=_props34.languageStore;var lang=languageStore.activeLanguage.code;return locationContext.protocol+'//'+locationContext.host+'/backend/api/v1/shopping-center/redirect/'+productId+'?lang='+lang;};this.renderProductPurchaseGuideLink=function(){var configStore=_this3.props.configStore;var pageId=configStore.infoPages.productPurchaseGuide;var linkText=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'productPageContent.productPurchaseGuideTitle',defaultMessage:'See purchase guide'});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_94__info_page_InfoPageLink__["a" /* default */],{pageId:Number(pageId),linkText:linkText});};this.ifShowModel=function(){var _props35=_this3.props,configStore=_props35.configStore,product=_props35.product;if(product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI){return configStore.productPage.showModelName&&configStore.product.showModel;}return configStore.product.showModel;};this.getShowOutOfStockParam=function(){var params=_this3.props.queryParams;if(params){return params.showOutOfStock;}return false;};this.renderNotValidForCartBanner=function(){if(_this3.state.productIsValidForCart){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["a" /* Alert */],{color:'warning',className:'ProductPageContent__AddToCartMessage'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'productPageContent.productNotValidForCart',defaultMessage:'This product does not have any common shipping methods with the products in the cart. For example pickup from different storage.'}));};this.getSchemaData=function(){var _props36=_this3.props,accountStore=_props36.accountStore,configStore=_props36.configStore,product=_props36.product;var productTitle=product.multiproduct_title||product.name;var _getReviews2=_this3.getReviews(),schemaAverage=_getReviews2.schemaAverage,schemaCount=_getReviews2.schemaCount;var hideReviews=accountStore.isViewOnly;var images=product.getImagesBySize('full');var baseData={'@context':'https://schema.org/','@type':'Product',name:productTitle,description:product.description_short||product.seoDescription,mpn:product.manufacturer_product_id,gtin:product.ean,image:images,sku:_this3.getProductSkuSchema()};if(product.manufacturer){baseData.brand={'@type':'Brand',name:product.manufacturer.name};}if(_this3.ifShowModel()){baseData.model=product.model;}if(product.mainCategory){baseData.category=product.mainCategory.hierarchy.map(function(category){return category.name;}).join('>');}if(configStore.reviews.enabled&&!hideReviews&&!configStore.yotpo.enabled&&product.reviews.length){baseData.aggregateRating={'@type':'AggregateRating',ratingValue:schemaAverage,reviewCount:schemaCount};baseData.review=_this3.getProductReviewsSchema();}if(configStore.productPage.showWeight){baseData.weight=product.display_weight;}baseData.offers=_this3.getProductOfferSchema();baseData.warranty=_this3.getProductWarrantySchema();return baseData;};this.getProductSkuSchema=function(){var product=_this3.props.product;if(product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI){return product.multi.children.map(function(childProduct){return childProduct.id;});}return product.id;};this.getProductReviewsSchema=function(){var _props37=_this3.props,intl=_props37.intl,product=_props37.product;return product.reviews.map(function(review){return{'@type':'Review',author:{'@type':'Person',name:review.customers_name},datePublished:__WEBPACK_IMPORTED_MODULE_103_luxon__["DateTime"].fromISO(review.data_added).toISODate(),reviewBody:review.description.reviews_text,reviewRating:[{'@type':'Rating',ratingValue:review.reviews_rating,worstRating:1,bestRating:5,reviewAspect:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].reviewProductRatingTitle)},{'@type':'Rating',ratingValue:review.service_rating,worstRating:1,bestRating:5,reviewAspect:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_37__i18n_globalTranslations__["a" /* default */].reviewServiceRatingTitle)}]};});};this.getProductOfferSchema=function(){var _props38=_this3.props,accountStore=_props38.accountStore,currencyStore=_props38.currencyStore,routeService=_props38.routeService,product=_props38.product,locationContext=_props38.locationContext;var withTax=accountStore.showPricesWithTax;var baseUrlSchema=locationContext.protocol+'//'+locationContext.host;var baseOffer={'@type':'Offer',priceCurrency:currencyStore.currencyCode};if(product.class===__WEBPACK_IMPORTED_MODULE_17__types_ProductClass__["b" /* default */].MULTI){return product.multi.children.map(function(childProduct){return Object.assign({},baseOffer,{url:{'@type':'URL',url:''+baseUrlSchema+childProduct.pathWithActiveProductId(childProduct.id)},price:childProduct.price_info?Object(__WEBPACK_IMPORTED_MODULE_104__util_number__["e" /* roundWithPrecision */])(childProduct.price_info.getPrice(withTax),2):0,priceValidUntil:_this3.getValidProductPriceDate(childProduct),availability:_this3.getAvailability(childProduct)});});}return Object.assign({},baseOffer,{url:{'@type':'URL',url:''+baseUrlSchema+routeService.getProductPath(product)},price:product.price_info?Object(__WEBPACK_IMPORTED_MODULE_104__util_number__["e" /* roundWithPrecision */])(product.price_info.getPrice(withTax),2):0,priceValidUntil:_this3.getValidProductPriceDate(product),availability:_this3.getAvailability(product)});};this.getValidProductPriceDate=function(product){if(!product.price_info){return null;}return __WEBPACK_IMPORTED_MODULE_103_luxon__["DateTime"].fromISO(product.price_info.valid_until).toISODate();};this.getAvailability=function(product){if(product.availability_html.length===0){return null;}if(product.availability_type===__WEBPACK_IMPORTED_MODULE_69__types_ProductAvailabilityType__["b" /* default */].ONLY_IN_SHOP){return'https://schema.org/InStoreOnly';}else if(product.free_quantity===0&&product.availability_type===__WEBPACK_IMPORTED_MODULE_69__types_ProductAvailabilityType__["b" /* default */].ALLOW_BACKORDER){return'https://schema.org/PreOrder';}else if(product.free_quantity>0){return'https://schema.org/InStock';}};this.getProductWarrantySchema=function(){var product=_this3.props.product;return{'@type':'WarrantyPromise',durationOfWarranty:{'@type':'QuantitativeValue',value:product.warranty,unitCode:'MON'}};};},_temp))||_class;ProductPageContent.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_76__store_AccountStore__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_96__services_ApiWrapper__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_95__store_CartStore__["a" /* default */]).isRequired,categoryStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_53__store_CategoryStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_25__store_ConfigStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_82__store_CountryStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_83__store_CurrencyStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_90__store_LanguageStore__["a" /* default */]).isRequired,paymentModuleStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_55__store_PaymentModuleStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_93__store_ProductStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__models_Product__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_30__store_UIStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_34__services_RouteService__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_8_react_router_prop_types___default.a.history.isRequired,intl:__WEBPACK_IMPORTED_MODULE_6_react_intl__["f" /* intlShape */].isRequired,locationContext:__WEBPACK_IMPORTED_MODULE_70__services_LocationContext__["a" /* LocationContextPropType */].isRequired,setActiveProductId:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,queryParams:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,adSearchParams:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,shareButtons:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,cartLoaded:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["e"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','apiWrapper','categoryStore','cartStore','configStore','countryStore','currencyStore','languageStore','paymentModuleStore','productStore','uiStore','routeService','locationContext')(Object(__WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* withRouter */])(ProductPageContent))));

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FilterOption__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_FilterType__ = __webpack_require__(252);
var Filter=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Filter',{name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,key:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,type:__WEBPACK_IMPORTED_MODULE_2__types_FilterType__["a" /* FilterTypeType */],options:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__FilterOption__["a" /* default */])),step:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),unit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),min:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),max:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var FilterType={TERM:'TERM',RANGE:'RANGE',BOOLEAN:'BOOLEAN'};/* harmony default export */ __webpack_exports__["b"] = (FilterType);var FilterTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('FilterTypeType',Object.values(FilterType));

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductPagePrice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiscountSign__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProductSingularPrice__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_ProductMerchantInfo__ = __webpack_require__(243);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPagePrice=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductPagePrice,_Component);function ProductPagePrice(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductPagePrice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductPagePrice.__proto__||Object.getPrototypeOf(ProductPagePrice)).call.apply(_ref,[this].concat(args))),_this),_this.renderDiscountDescription=function(){var product=_this.props.product;var discountPercentage=Math.round(product.price_info.discount_percentage);if(discountPercentage>=40){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.topDiscount',defaultMessage:'Top discount'});}else if(discountPercentage>=30){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.superOffer',defaultMessage:'Super offer'});}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.nowOnly',defaultMessage:'Now only'});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductPagePrice,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,product=_props.product,price=_props.price,withTax=_props.withTax,withDiscountLabel=_props.withDiscountLabel,withDiscountUpTo=_props.withDiscountUpTo,withDiscountBalloon=_props.withDiscountBalloon,withDiscountSavings=_props.withDiscountSavings,discountInverted=_props.discountInverted,className=_props.className,isSecondaryPrice=_props.isSecondaryPrice,merchantInfo=_props.merchantInfo;var isDiscount=product.price_info&&product.price_info.is_discount;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifBuyingAllowed=merchantInfo&&merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductPagePrice'},isDiscount&&withDiscountBalloon&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductPagePrice__balloon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].productOffer)),isDiscount&&withDiscountSavings&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductPagePrice__savings'},this.renderDiscountDescription(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'ProductPagePrice__savings-amount'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].youSaveSentence,{values:{savings:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:product.price_info.getSavings(withTax)})}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductPagePrice__price-container'},price,isDiscount&&!isSecondaryPrice&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DiscountSign__["a" /* default */],{percentage:product.price_info.discount_percentage,withLabel:withDiscountLabel,withUpTo:withDiscountUpTo,inverted:discountInverted,className:className})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ProductSingularPrice__["a" /* default */],{product:product,withTax:withTax}),product.price_info&&product.price_info.valid_until_html&&!isSecondaryPrice&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductPagePrice__valid-until',dangerouslySetInnerHTML:{__html:product.price_info.valid_until_html}}));}}]);return ProductPagePrice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductPagePrice.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__["a" /* default */]).isRequired,price:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({price_info:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_ProductPriceInfo__["a" /* default */]),package_size:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,stock_unit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,singular_price_unit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,singular_price_divider:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number}).isRequired,withDiscountLabel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,withDiscountUpTo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,withDiscountBalloon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,withDiscountSavings:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,withTax:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,discountInverted:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isSecondaryPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,merchantInfo:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__models_ProductMerchantInfo__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])(function(stores,props){return{configStore:stores.configStore,withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(ProductPagePrice));

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_MAX_QUANTITY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cart_AddToCart__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_ProductAvailabilityType__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProductSeasonButton__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__product_watcher_ProductWatcherWidget__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ProductReserveInStoreButton__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__cart_SimpleAddToCart__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cart_CartIcon__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ProductRecurringOrder__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_RecurringOrderStore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_MAX_QUANTITY=99999;var ProductAddToCart=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductAddToCart,_Component);function ProductAddToCart(props){_classCallCheck(this,ProductAddToCart);var _this=_possibleConstructorReturn(this,(ProductAddToCart.__proto__||Object.getPrototypeOf(ProductAddToCart)).call(this,props));_this.getMaxByPackage=function(product){var activeProductId=_this.props.activeProductId;return product.sellInPackage?_this.mathFloor(product.getFreeQuantity(activeProductId)/product.package_size)*product.package_size:product.getFreeQuantity(activeProductId);};_this.getMaxQuantity=function(product){var _this$props=_this.props,accountStore=_this$props.accountStore,configStore=_this$props.configStore;var backOrderLimit=configStore.product.backorderLimit>0?configStore.product.backorderLimit:DEFAULT_MAX_QUANTITY;var normalMaxLimit=product.canBeOrderedOutOfStock?DEFAULT_MAX_QUANTITY:_this.getMaxByPackage(product);var maxAccountQuantity=accountStore.account&&accountStore.account.max_product_quantity>0?accountStore.account.max_product_quantity:DEFAULT_MAX_QUANTITY;var maxBackorderQuantity=product.availability_type===__WEBPACK_IMPORTED_MODULE_12__types_ProductAvailabilityType__["b" /* default */].ALLOW_BACKORDER?backOrderLimit:DEFAULT_MAX_QUANTITY;var maxNormalProductQuantity=product.availability_type!==__WEBPACK_IMPORTED_MODULE_12__types_ProductAvailabilityType__["b" /* default */].ALLOW_BACKORDER?normalMaxLimit:DEFAULT_MAX_QUANTITY;return _this.mathMin(maxAccountQuantity,maxBackorderQuantity,maxNormalProductQuantity,DEFAULT_MAX_QUANTITY);};_this.handleAddToCartClick=function(quantity){var services=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var newRecurring=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var _this$props2=_this.props,cartStore=_this$props2.cartStore,analytics=_this$props2.analytics,product=_this$props2.product,activeProductId=_this$props2.activeProductId,accountStore=_this$props2.accountStore,addToCartProduct=_this$props2.addToCartProduct,productListView=_this$props2.productListView;// If cartStore is already loading, don't do anything
if(cartStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADING){return;}if(activeProductId){var withTax=accountStore.showPricesWithTax;var quantityStep=addToCartProduct.getQuantityStep(product);var newQuantity=_this.nearestProductQuantity(quantity,quantityStep);var withActiveCategory=productListView!==true;_this.setState({loading:true});cartStore.addToCart(activeProductId,newQuantity,[],services,newRecurring,withActiveCategory).then(function(){_this.setState({loading:false,addToCartError:null,messageOK:null});analytics.addToCart([{product:product,newQuantity:newQuantity,activeProductId:activeProductId,price:product.getPrice(withTax,activeProductId)}]);analytics.cartStatus({cart:cartStore.cart});}).catch(function(e){_this.setState({loading:false,addToCartError:e,messageOK:null});});}};_this.handleAddToOrderClick=function(orderId,quantity,cycle){var _this$props3=_this.props,cartStore=_this$props3.cartStore,recurringOrderStore=_this$props3.recurringOrderStore,analytics=_this$props3.analytics,product=_this$props3.product,activeProductId=_this$props3.activeProductId,accountStore=_this$props3.accountStore,addToCartProduct=_this$props3.addToCartProduct;// If cartStore is already loading, don't do anything
if(recurringOrderStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADING){return;}if(activeProductId){var withTax=accountStore.showPricesWithTax;var quantityStep=addToCartProduct.getQuantityStep(product);var newQuantity=_this.nearestProductQuantity(quantity,quantityStep);_this.setState({loading:true});var orderProduct=Object.assign({quantity:newQuantity,extendedId:activeProductId},cycle);recurringOrderStore.addProduct(orderId,orderProduct).then(function(){_this.setState({loading:false,messageOK:true});analytics.addToCart([{product:product,newQuantity:newQuantity,activeProductId:activeProductId,price:product.getPrice(withTax,activeProductId)}]);analytics.cartStatus({cart:cartStore.cart});}).catch(function(e){_this.setState({loading:false,messageOK:false});});}};_this.handleRecurringToCart=function(newRecurring){_this.handleAddToCartClick(_this.props.quantity,[],newRecurring);};_this.handleRecurringToOrder=function(orderId,newRecurring){_this.handleAddToOrderClick(orderId,_this.props.quantity,newRecurring);};_this.updateQuantity=function(quantity){if(_this.props.onUpdateProductQuantity){_this.props.onUpdateProductQuantity(quantity);}};_this.renderMinOrderQuantityErrorBanner=function(){var _this$props4=_this.props,quantity=_this$props4.quantity,addToCartProduct=_this$props4.addToCartProduct;if(!addToCartProduct.min_order_quantity||quantity>=addToCartProduct.min_order_quantity){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{color:'light',className:'ProductAddToCart__minimum-order-quantity-banner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.minOrderQuantityError',defaultMessage:'Products minimum quantity is {minOrderQuantity} {stockUnit}',values:{minOrderQuantity:addToCartProduct.min_order_quantity,stockUnit:addToCartProduct.stock_unit}}));};_this.renderError=function(){var addToCartError=_this.state.addToCartError;if(!addToCartError){return null;}var errors=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(addToCartError,'response.data.errors');if(!errors){errors=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(addToCartError,'response.data');}if(errors){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{className:'ProductAddToCart__errors',color:'danger'},Object.values(errors).map(function(message){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:message},message);}));}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__loader_UnexpectedError__["a" /* default */],null);};_this.renderOrderMessage=function(){var messageOK=_this.state.messageOK;return messageOK?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{className:'ProductAddToCart__errors',color:'success'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'order.productAddedSentence',defaultMessage:'Product added to order'})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{className:'ProductAddToCart__errors',color:'danger'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'order.productAddFailedSentence',defaultMessage:'Product cannot be added for order'}));};_this.state={loading:false,addToCartError:null,messageOK:null};// Saving the function as a reference so we don't create a new Math-function on every render.
_this.nearestProductQuantity=__WEBPACK_IMPORTED_MODULE_22__util_number__["a" /* calculateNearestProductQuantityWithQuantityStep */];_this.mathFloor=Math.floor;_this.mathMin=Math.min;return _this;}_createClass(ProductAddToCart,[{key:'render',value:function render(){var _this2=this;var _props=this.props,cartStore=_props.cartStore,accountStore=_props.accountStore,configStore=_props.configStore,uiStore=_props.uiStore,product=_props.product,activeProductId=_props.activeProductId,addToCartProduct=_props.addToCartProduct,simple=_props.simple,withReserveInStore=_props.withReserveInStore,withRecurringOrder=_props.withRecurringOrder,withServices=_props.withServices,hideQuantity=_props.hideQuantity,quantity=_props.quantity,ifWebStore=_props.ifWebStore,withQuantityPicker=_props.withQuantityPicker,isValid=_props.isValid,scrollToServices=_props.scrollToServices,rest=_objectWithoutProperties(_props,['cartStore','accountStore','configStore','uiStore','product','activeProductId','addToCartProduct','simple','withReserveInStore','withRecurringOrder','withServices','hideQuantity','quantity','ifWebStore','withQuantityPicker','isValid','scrollToServices']);var _state=this.state,addToCartError=_state.addToCartError,messageOK=_state.messageOK,loading=_state.loading;if(product.season&&!product.season.hasStarted()){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProductSeasonButton__["a" /* default */],{season:product.season});}var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifBuyingAllowed=product.merchantInfo&&product.merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed){return null;}if(activeProductId&&product.isTemporarilyUnavailable(activeProductId)){var productNameWithModel=addToCartProduct.name+' '+addToCartProduct.model;if(product.class===__WEBPACK_IMPORTED_MODULE_11__types_ProductClass__["b" /* default */].COLLECTION){var collectionItem=product.collection.getItemWithProductId(activeProductId);if(collectionItem&&collectionItem.name){productNameWithModel=productNameWithModel+' – '+collectionItem.name;}}return!simple?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__product_watcher_ProductWatcherWidget__["a" /* default */],{productName:productNameWithModel,activeProductId:activeProductId}):null;}var onlyInShop=addToCartProduct.availability_type===__WEBPACK_IMPORTED_MODULE_12__types_ProductAvailabilityType__["b" /* default */].ONLY_IN_SHOP;var soldOut=activeProductId&&addToCartProduct.availability_type===__WEBPACK_IMPORTED_MODULE_12__types_ProductAvailabilityType__["b" /* default */].CLOSEOUT&&!product.hasEnoughStockAvailable(activeProductId);var hideAddToCart=onlyInShop||product.season&&product.season.hasEnded()||soldOut&&// Don't hide for collection or multi products to avoid confusion caused
// by arriving to the page and not seeing an add to cart button.
product.class!==__WEBPACK_IMPORTED_MODULE_11__types_ProductClass__["b" /* default */].COLLECTION&&product.class!==__WEBPACK_IMPORTED_MODULE_11__types_ProductClass__["b" /* default */].MULTI;if(hideAddToCart){return null;}var disabled=!activeProductId||soldOut||!isValid;var disabledMessage=void 0;if(!activeProductId){disabledMessage=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.selectProductFirst',defaultMessage:'First choose the product.'});}else if((product.class!==__WEBPACK_IMPORTED_MODULE_11__types_ProductClass__["b" /* default */].COLLECTION||product.class!==__WEBPACK_IMPORTED_MODULE_11__types_ProductClass__["b" /* default */].MULTI)&&soldOut){disabledMessage=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.currentProductSoldOut',defaultMessage:'The selected product has been sold out.'});}else if(soldOut){disabledMessage=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.hasBeenSoldOut',defaultMessage:'This product has been sold out.'});}else if(!isValid){disabledMessage=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.checkingShippingValidity',defaultMessage:'Product validity for the cart.'});}var tooltipMessage=void 0;var updateInProgress=cartStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADING;if(updateInProgress){tooltipMessage=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'cart.beingUpdated',defaultMessage:'Cart is being updated'});}var quantityAllowed=accountStore.isRetailer||configStore.productCard.showQuantitySelection;if(hideQuantity){quantityAllowed=false;}var content=null;var quantityStep=addToCartProduct.getQuantityStep(product);var withTax=accountStore.showPricesWithTax;var buyingAllowed=!(configStore.recurringOrder.enabled&&accountStore.loggedIn&&addToCartProduct.hasOnlyRecurringOrder());if(!simple){content=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAddToCart ProductAddToCart--normal'},buyingAllowed&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__cart_AddToCart__["a" /* default */],Object.assign({key:addToCartProduct.id,notAllowed:updateInProgress,disabled:disabled,tooltipMessage:disabledMessage||tooltipMessage,onAddToCartClick:this.handleAddToCartClick,maxQuantity:this.getMaxQuantity(addToCartProduct),quantityStep:quantityStep,unit:addToCartProduct.stock_unit,loading:loading,withServices:withServices,withTax:withTax,product:product,onUpdateProductQuantity:this.updateQuantity,quantity:quantity,minOrderQuantity:addToCartProduct.min_order_quantity,ifWebStore:ifWebStore,withQuantityPicker:withQuantityPicker,scrollToServices:scrollToServices},rest)),this.renderMinOrderQuantityErrorBanner(),addToCartError&&this.renderError()),withRecurringOrder&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__ProductRecurringOrder__["a" /* default */],{product:product,withTax:withTax,onAddToCartClick:this.handleRecurringToCart,onAddToOrderClick:this.handleRecurringToOrder,disabled:disabled,loading:loading}),withRecurringOrder&&messageOK!==null&&this.renderOrderMessage(),withReserveInStore&&!product.isBlockedFromStoreReservation(configStore.reserveInStore.excludePropertyId)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductReserveInStore__wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].buttonInfo),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ProductReserveInStoreButton__["a" /* default */],{product:product,activeProductId:activeProductId})));}else if(simple&&!disabled&&buyingAllowed){content=quantityAllowed?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__cart_SimpleAddToCart__["a" /* default */],{notAllowed:updateInProgress,loading:loading,maxQuantity:this.getMaxQuantity(addToCartProduct),quantityStep:quantityStep,onAddToCartClick:this.handleAddToCartClick,unit:addToCartProduct.stock_unit,tooltipMessage:disabledMessage||tooltipMessage,disabled:disabled,onUpdateProductQuantity:this.updateQuantity,minOrderQuantity:addToCartProduct.min_order_quantity,quantity:quantity,ifWebStore:ifWebStore}):ifWebStore&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__cart_CartIcon__["a" /* default */],{notAllowed:updateInProgress,onClick:function onClick(){return _this2.handleAddToCartClick(1);},loading:loading,tooltipMessage:tooltipMessage});}return content;}}]);return ProductAddToCart;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;ProductAddToCart.propTypes={analytics:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__analytics_Analytics__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_AccountStore__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_CartStore__["a" /* default */]).isRequired,recurringOrderStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_25__store_RecurringOrderStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_26__store_UIStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,addToCartProduct:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onUpdateProductQuantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,scrollToServices:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,activeProductId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,simple:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,withReserveInStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,withRecurringOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,withServices:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,withQuantityPicker:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hideQuantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,columnId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,rowId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,quantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,ifWebStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ProductAddToCart.defaultProps={simple:false,hideQuantity:false,ifWebStore:true,withQuantityPicker:true,isValid:true};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('analytics','accountStore','cartStore','configStore','productStore','uiStore','recurringOrderStore')(ProductAddToCart));

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__product_ProductCard__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_ProductListStyle__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__product_ProductImpressions__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CategoryHeader__ = __webpack_require__(1071);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardWrapper=function CardWrapper(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:6,sm:4,md:3,lg:3,xl:'1-5'},children);};var LargeCardWrapper=function LargeCardWrapper(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:6,sm:6,md:4,lg:4,xl:3},children);};var CategoryNameWrapper=function CategoryNameWrapper(_ref3){var children=_ref3.children;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:12},children);};var ProductList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductList,_Component);function ProductList(){_classCallCheck(this,ProductList);return _possibleConstructorReturn(this,(ProductList.__proto__||Object.getPrototypeOf(ProductList)).apply(this,arguments));}_createClass(ProductList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,products=_props.products,name=_props.name,style=_props.style,completeListingLink=_props.completeListingLink,productParams=_props.productParams;var Wrapper=void 0;var CategoryWrapper=CategoryNameWrapper;var large=void 0;switch(style){case __WEBPACK_IMPORTED_MODULE_8__types_ProductListStyle__["a" /* default */].CARD_LARGE:Wrapper=LargeCardWrapper;large=true;break;default:case __WEBPACK_IMPORTED_MODULE_8__types_ProductListStyle__["a" /* default */].CARD:Wrapper=CardWrapper;large=false;}var productMainCategoryId=null;var productCols=products.map(function(product,index){var _props2=_this2.props,cardSettings=_props2.cardSettings,showCategoryHeaders=_props2.showCategoryHeaders;var mergedCardSettings=Object.assign({productListView:true,product:product,position:index+1,listName:name,large:large,modelMargin:true,productParams:productParams},cardSettings);var productCardComponent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{key:product.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__product_ProductCard__["a" /* default */],mergedCardSettings));if(productMainCategoryId!==product.main_category_id&&showCategoryHeaders){productMainCategoryId=product.main_category_id;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],{key:__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(product.main_category_id)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CategoryWrapper,{key:__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(product.main_category_id)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CategoryHeader__["a" /* default */],{breadcrumb:product.mainCategory.breadcrumbs})),productCardComponent);}return productCardComponent;});var productsArray=products.slice();if(completeListingLink&&productCols.length>0){productCols[productCols.length-1]=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{key:'_completeListingLink'},completeListingLink);// Drop the last product impression because it is not shown.
productsArray.pop();}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductList'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__product_ProductImpressions__["a" /* default */],{listName:name,products:productsArray}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,productCols));}}]);return ProductList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductList.propTypes={style:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(Object.values(__WEBPACK_IMPORTED_MODULE_8__types_ProductListStyle__["a" /* default */])),products:__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Product__["a" /* default */])),name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,completeListingLink:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,showCategoryHeaders:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ProductList);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_InstantShoppingCartProduct__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_InstantShoppingPickupOption__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_InstantShoppingInstance__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_ShippingOption__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_ShippingOptionSelectionField__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_ShippingSelectionFieldOption__ = __webpack_require__(495);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var InstantShoppingCartStore=__WEBPACK_IMPORTED_MODULE_5__models_StatefulStore__["a" /* default */].named('InstantShoppingCartStore').props({selectedShippingOption:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_9__models_ShippingOption__["a" /* default */])),selectedPickupOption:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_7__models_InstantShoppingPickupOption__["a" /* default */])),selectedSelectionFieldOption:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_11__models_ShippingSelectionFieldOption__["a" /* default */])),instantShoppingInstance:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_8__models_InstantShoppingInstance__["a" /* default */]),{}),productCart:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].model({cart:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_6__models_InstantShoppingCartProduct__["a" /* default */]),[]),success:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].boolean),false)}),{}),productCartStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */]),{}),shippingOptions:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_9__models_ShippingOption__["a" /* default */]),[]),shippingSelectionFieldOptions:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_10__models_ShippingOptionSelectionField__["a" /* default */])),pickupPointOptions:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_7__models_InstantShoppingPickupOption__["a" /* default */])),{}),shippingOptionState:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */]),{}),pickupPointStates:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["a" /* RequestStateType */]),{}),instantShoppingOrderForm:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].model({postalCode:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string,streetAddress:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string}),{postalCode:'',streetAddress:''}),klarnaEnvironmentLoaded:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].boolean,false),merchantId:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].number),isOpen:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].model({orderModal:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].boolean}),{orderModal:false}),instanceId:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string)}).actions(function(self){var getProductStore=function getProductStore(){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["g" /* getRoot */])(self).productStore;};var getLang=function getLang(){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["g" /* getRoot */])(self).languageStore.activeLanguage.code;};var ifShoppingCenter=function ifShoppingCenter(){return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["g" /* getRoot */])(self).configStore.siteConfig.isShoppingCenter;};var baseApi=function baseApi(endpoint){return ifShoppingCenter()?'shopping-center/'+endpoint:''+endpoint;};var setInstantShoppingProducts=function setInstantShoppingProducts(response,productId){self.productCart.cart=response;self.productCart.success=true;self.productCartStates.set(productId,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);};var setInstantShoppingProductCart=function setInstantShoppingProductCart(response,extendedId){self.productCart=response;self.productCartStates.set(extendedId,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);};var setProductCollectionVariations=function setProductCollectionVariations(){var productStore=getProductStore();if(!productStore.selectedProductRow&&!productStore.selectedProductColumn){return null;}var trimmedRowName=productStore.selectedProductRow.replace(/&nbsp;/g,' ').trim();var trimmedColumnName=productStore.selectedProductColumn.replace(/&nbsp;/g,' ').trim();return[trimmedRowName,trimmedColumnName];};var createInstantShoppingOrderEntity=function createInstantShoppingOrderEntity(){var lang=getLang();var products=getProducts();var merchantId=self.merchantId;var orderEntity={lang:lang,merchantId:merchantId,products:products};if(self.selectedShippingOption){orderEntity.shippingModuleId=self.selectedShippingOption.id;}if(self.selectedShippingOption&&self.selectedPickupOption&&self.selectedShippingOption.requires_pickup_point){orderEntity.pickupPointInfo=selectedPickupPoint();}if(self.selectedShippingOption&&self.selectedShippingOption.selection_fields&&self.selectedShippingOption.selection_fields.length>0){orderEntity.shippingSelectionFields=selectedShippingSelectionField();}if(self.instantShoppingInstance.get(self.merchantId)){orderEntity.instantShoppingId=self.instantShoppingInstance.get(self.merchantId).instant_shopping_id;}if(self.instantShoppingOrderForm&&self.instantShoppingOrderForm.postalCode&&self.instantShoppingOrderForm.streetAddress&&self.selectedShippingOption&&self.selectedShippingOption.requires_pickup_point){orderEntity.pickupPointAddressInfo={postCode:self.instantShoppingOrderForm.postalCode,streetAddress:self.instantShoppingOrderForm.streetAddress};}return orderEntity;};var createPickupPointEntity=function createPickupPointEntity(shippingOption){var lang=getLang();var products=getProducts();var merchantId=self.merchantId;return{lang:lang,merchantId:merchantId,products:products,paymentModuleId:getInstantShoppingFlowProcessByMerchant().paymentModuleId,shippingModuleId:shippingOption.id,integration:shippingOption.pickup_point_integration,types:shippingOption.pickup_point_types?shippingOption.pickup_point_types.slice():null,postCode:self.instantShoppingOrderForm.postalCode,streetAddress:self.instantShoppingOrderForm.streetAddress};};var getProducts=function getProducts(){return self.productCart.cart.map(function(product){return{extendedId:product.id,quantity:product.quantity,reference:product.reference};});};var getAnalyticsProducts=function getAnalyticsProducts(){return self.productCart.cart.map(function(product){return{product_id:product.id,quantity:product.quantity,name:product.name};});};var selectedPickupPoint=function selectedPickupPoint(){return{id:self.selectedPickupOption.unique_id,integration:self.selectedShippingOption.pickup_point_integration,name:self.selectedPickupOption.name,address:self.selectedPickupOption.address,openingHours:self.selectedPickupOption.opening_hours,externalInfo:self.selectedPickupOption.external_info?getExternalInfo():null};};var getExternalInfo=function getExternalInfo(){var externalInfo={};var externalInfoKeyValuePairs=self.selectedPickupOption.external_info.map(function(info){return _defineProperty({},info.key,info.value);});externalInfoKeyValuePairs.forEach(function(keyValuePair){externalInfo=Object.assign({},externalInfo,keyValuePair);});return externalInfo;};var selectedShippingSelectionField=function selectedShippingSelectionField(){return[{fieldId:self.selectedShippingOption.selection_fields[0].id,valueId:self.selectedSelectionFieldOption.id}];};var createInstanceId=function createInstanceId(){self.instanceId=!self.instanceId?'buttonkey-'+__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default()(self.merchantId):self.instanceId;};var getInstantShoppingFlowProcessByMerchant=function getInstantShoppingFlowProcessByMerchant(){return self.instantShoppingInstance.get(self.merchantId.toString());};return{setup:function setup(merchantId){self.merchantId=merchantId;createInstanceId();},getAnalyticsProductCartProducts:function getAnalyticsProductCartProducts(){return getAnalyticsProducts();},loadKlarnaInstantShoppingInstance:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadKlarnaInstantShoppingInstance(){var instantShoppingId,instantShoppingEnvironment,instantShoppingRegion;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadKlarnaInstantShoppingInstance$(_context){while(1){switch(_context.prev=_context.next){case 0:instantShoppingId=getInstantShoppingFlowProcessByMerchant().instant_shopping_id;instantShoppingEnvironment=getInstantShoppingFlowProcessByMerchant().integrationInfo.environment;instantShoppingRegion=getInstantShoppingFlowProcessByMerchant().integrationInfo.region;_context.prev=3;_context.next=6;return window.Klarna.InstantShopping.load({setup:{instance_id:self.instanceId,key:instantShoppingId,environment:instantShoppingEnvironment.toLowerCase()==='development'?'playground':'production',region:instantShoppingRegion}});case 6:self.klarnaEnvironmentLoaded=true;_context.next=14;break;case 9:_context.prev=9;_context.t0=_context['catch'](3);console.error(_context.t0);self.setError(_context.t0);throw _context.t0;case 14:case'end':return _context.stop();}}},loadKlarnaInstantShoppingInstance,this,[[3,9]]);})),openKlarnaInstantShoppingModal:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function openKlarnaInstantShoppingInstance(){var instantShoppingId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function openKlarnaInstantShoppingInstance$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:instantShoppingId=getInstantShoppingFlowProcessByMerchant();_context2.prev=1;_context2.t0=instantShoppingId;if(!_context2.t0){_context2.next=6;break;}_context2.next=6;return window.Klarna.InstantShopping.open({instance_id:self.instanceId});case 6:_context2.next=13;break;case 8:_context2.prev=8;_context2.t1=_context2['catch'](1);console.error(_context2.t1);self.setError(_context2.t1);throw _context2.t1;case 13:case'end':return _context2.stop();}}},openKlarnaInstantShoppingInstance,this,[[1,8]]);})),addToInstantShoppingProductCart:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function addToInstantShoppingProductCart(product,quantity,activeProductId){var extendedId,variations,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addToInstantShoppingProductCart$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:extendedId=activeProductId||product.id;variations=setProductCollectionVariations();self.productCartStates.set(extendedId,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING);_context3.prev=3;_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post(''+baseApi('instant-shopping/cart/products'),{extendedId:extendedId,quantity:quantity,packageSize:product.package_size||1,lang:getLang(),variations:variations});case 6:response=_context3.sent;setInstantShoppingProductCart(response.data,extendedId);_context3.next=16;break;case 10:_context3.prev=10;_context3.t0=_context3['catch'](3);console.error(_context3.t0);self.setError(_context3.t0);self.productCartStates.set(product.id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);throw _context3.t0;case 16:case'end':return _context3.stop();}}},addToInstantShoppingProductCart,this,[[3,10]]);})),removeInstantShoppingCartProduct:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function removeInstantShoppingCartProduct(id){var response,products;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeInstantShoppingCartProduct$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:self.setLoading(true);_context4.prev=1;_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete(''+baseApi('instant-shopping/cart/products/'+id));case 4:response=_context4.sent;if(response.status===204){products=self.productCart.cart.filter(function(product){return product.id!==id;});self.productCart.cart=products;self.setLoading(false);}_context4.next=15;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);self.setLoading(false);console.error(_context4.t0);self.setError(_context4.t0);self.productCartStates.set(id,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);throw _context4.t0;case 15:case'end':return _context4.stop();}}},removeInstantShoppingCartProduct,this,[[1,8]]);})),getInstantShoppingCartProducts:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getInstantShoppingCartProducts(merchantId,product,activeProductId){var productId,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getInstantShoppingCartProducts$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:self.setLoading(true);productId=activeProductId||product.id;_context5.prev=2;_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(''+baseApi('instant-shopping/cart/products'),{params:{merchantId:merchantId}},{active_section:null});case 5:response=_context5.sent;setInstantShoppingProducts(response,productId);self.setLoading(false);_context5.next=16;break;case 10:_context5.prev=10;_context5.t0=_context5['catch'](2);self.setError(_context5.t0);self.productCartStates.set(productId,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);self.setLoading(false);throw _context5.t0;case 16:case'end':return _context5.stop();}}},getInstantShoppingCartProducts,this,[[2,10]]);})),loadShippingOptions:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadShippingOptions(){var orderEntity,shippingOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadShippingOptions$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!(!self.productCart.cart||self.productCart.cart.length===0)){_context6.next=2;break;}return _context6.abrupt('return');case 2:self.shippingOptionState.set(self.merchantId,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING);orderEntity=createInstantShoppingOrderEntity();if(getInstantShoppingFlowProcessByMerchant()){orderEntity.paymentModuleId=getInstantShoppingFlowProcessByMerchant().paymentModuleId;}_context6.prev=5;_context6.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(baseApi('instant-shopping/order/shipping-options')+'?'+__WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(orderEntity));case 8:shippingOptions=_context6.sent;self.shippingOptions=shippingOptions;self.selectedShippingOption=shippingOptions.length>0?__WEBPACK_IMPORTED_MODULE_9__models_ShippingOption__["a" /* default */].create(shippingOptions[0]):null;self.selectedSelectionFieldOption=shippingOptions.length>0?self.selectedShippingOption.getDefaultSelectionField():null;self.shippingOptionState.set(self.merchantId,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);_context6.next=20;break;case 15:_context6.prev=15;_context6.t0=_context6['catch'](5);self.shippingOptionState.set(self.merchantId,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);self.setError(_context6.t0);throw _context6.t0;case 20:case'end':return _context6.stop();}}},loadShippingOptions,this,[[5,15]]);})),loadPickupPointOptions:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadPickupPointOptions(shippingOption){var customerAddress,ifAlreadyLoading,pickupPointEntity,pickupPointOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadPickupPointOptions$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:customerAddress=self.instantShoppingOrderForm.postalCode+','+self.instantShoppingOrderForm.streetAddress;ifAlreadyLoading=self.pickupPointStates.get(customerAddress)===__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING;// Skip Api call if we are already fetching the data
if(!(ifAlreadyLoading||!self.instantShoppingOrderForm.postalCode&&!self.instantShoppingOrderForm.streetAddress)){_context7.next=4;break;}return _context7.abrupt('return');case 4:self.pickupPointStates.set(customerAddress,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADING);_context7.prev=5;pickupPointEntity=createPickupPointEntity(shippingOption);_context7.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request(baseApi('instant-shopping/order/pickup-points')+'?'+__WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(pickupPointEntity));case 9:pickupPointOptions=_context7.sent;self.pickupPointOptions.set(customerAddress,pickupPointOptions);self.selectedPickupOption=pickupPointOptions.length>0?__WEBPACK_IMPORTED_MODULE_7__models_InstantShoppingPickupOption__["a" /* default */].create(pickupPointOptions[0]):null;self.pickupPointStates.set(customerAddress,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].LOADED);_context7.next=20;break;case 15:_context7.prev=15;_context7.t0=_context7['catch'](5);self.setError(_context7.t0);self.pickupPointStates.set(customerAddress,__WEBPACK_IMPORTED_MODULE_4__types_RequestState__["b" /* default */].ERROR);throw _context7.t0;case 20:case'end':return _context7.stop();}}},loadPickupPointOptions,this,[[5,15]]);})),orderProducts:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function orderProducts(){var orderEntity,order;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function orderProducts$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:orderEntity=createInstantShoppingOrderEntity();self.setLoading(true);_context8.prev=2;_context8.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post(''+baseApi('instant-shopping/order'),orderEntity);case 5:order=_context8.sent;self.instantShoppingInstance.set(self.merchantId,order.data);self.setLoading(false);_context8.next=15;break;case 10:_context8.prev=10;_context8.t0=_context8['catch'](2);self.setLoading(false);self.setError(_context8.t0);throw _context8.t0;case 15:case'end':return _context8.stop();}}},orderProducts,this,[[2,10]]);})),resetShippingOptions:function resetShippingOptions(){self.selectedSelectionFieldOption=null;self.selectedShippingOption=null;self.shippingOptions.clear();self.shippingOptionState.clear();},resetPickupPoint:function resetPickupPoint(){self.selectedPickupOption=null;self.instantShoppingOrderForm.postalCode='';self.instantShoppingOrderForm.streetAddress='';self.pickupPointOptions.clear();self.pickupPointStates.clear();},resetInstantShoppingInstance:function resetInstantShoppingInstance(){self.instantShoppingInstance.clear();self.klarnaEnvironmentLoaded=false;},resetStore:function resetStore(){self.resetShippingOptions();self.resetPickupPoint();self.resetInstantShoppingInstance();},toggleModal:function toggleModal(modal){self.isOpen[modal]=!self.isOpen[modal];},closeModal:function closeModal(modal){self.isOpen[modal]=false;},updateOrder:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function updateOrder(){var orderEntity,order,instantShoppingInstance;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateOrder$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:orderEntity=createInstantShoppingOrderEntity();self.setLoading(true);_context9.prev=2;_context9.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().put(''+baseApi('instant-shopping/order'),__WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(orderEntity));case 5:order=_context9.sent;instantShoppingInstance=self.instantShoppingInstance.get(self.merchantId);instantShoppingInstance.order=order.data.order;instantShoppingInstance.success=order.data.success;self.setLoading(false);_context9.next=17;break;case 12:_context9.prev=12;_context9.t0=_context9['catch'](2);self.setLoading(false);self.setError(_context9.t0);throw _context9.t0;case 17:case'end':return _context9.stop();}}},updateOrder,this,[[2,12]]);})),updateShippingOption:function updateShippingOption(shippingOption){return self.selectedShippingOption=shippingOption;},updatePickupOption:function updatePickupOption(pickupOption){return self.selectedPickupOption=pickupOption;},updateSelectionFieldOption:function updateSelectionFieldOption(selectionFieldOption){return self.selectedSelectionFieldOption=selectionFieldOption;},updateInstantShoppingOrderForm:function updateInstantShoppingOrderForm(name,value){return self.instantShoppingOrderForm[name]=value;}};}).views(function(self){return{get hasCart(){return self.productCart&&self.productCart.cart&&self.productCart.cart.length>0;},get instanceShoppingInstanceId(){return self.instantShoppingInstance.get(self.merchantId.toString())?self.instantShoppingInstance.get(self.merchantId.toString()).instant_shopping_id:null;},get selectedInstantShoppingProducts(){return self.productCart&&self.productCart.cart&&self.productCart.cart.length?self.productCart.cart:[];},getShippingOptions:function getShippingOptions(){return self.shippingOptions&&self.shippingOptions.length>0?self.shippingOptions:null;},get defaultPickupPoint(){var option=self.pickupPointOptions.get(this.postalCode+','+this.streetAddress);return option&&option.length>0?option[0]:null;},get selectedShippingOptionName(){return self.selectedShippingOption&&self.selectedShippingOption.name;},get selectedPickupOptionName(){return self.selectedPickupOption&&self.selectedPickupOption.name;},get postalCode(){return self.instantShoppingOrderForm&&self.instantShoppingOrderForm.postalCode&&self.instantShoppingOrderForm.postalCode;},get streetAddress(){return self.instantShoppingOrderForm&&self.instantShoppingOrderForm.streetAddress&&self.instantShoppingOrderForm.streetAddress;},get formValues(){return{postalCode:this.postalCode,streetAddress:this.streetAddress};},getPickupPointsOptions:function getPickupPointsOptions(customerAddress){return customerAddress&&self.pickupPointOptions&&self.pickupPointOptions.length&&self.pickupPointOptions.get(customerAddress).slice();}};});/* harmony default export */ __webpack_exports__["a"] = (InstantShoppingCartStore);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultSidebar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_LayoutBoxStore__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_SidebarNavigation__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_box_ManufacturerBox__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ad_SidebarBanner__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout_box_CampaignCodeBox__ = __webpack_require__(1123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LayoutBoxComponents={categories_new:__WEBPACK_IMPORTED_MODULE_6__common_SidebarNavigation__["a" /* default */],categories_minimized:__WEBPACK_IMPORTED_MODULE_6__common_SidebarNavigation__["a" /* default */],manufacturers:__WEBPACK_IMPORTED_MODULE_7__layout_box_ManufacturerBox__["a" /* default */],campaign_code:__WEBPACK_IMPORTED_MODULE_9__layout_box_CampaignCodeBox__["a" /* default */]};var DefaultSidebar=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(DefaultSidebar,_Component);function DefaultSidebar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DefaultSidebar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DefaultSidebar.__proto__||Object.getPrototypeOf(DefaultSidebar)).call.apply(_ref,[this].concat(args))),_this),_this.getLayoutBox=function(layoutBox){if(LayoutBoxComponents[layoutBox.key]){var _Component2=LayoutBoxComponents[layoutBox.key];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_Component2,{title:layoutBox.title});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DefaultSidebar,[{key:'render',value:function render(){var _this2=this;var _props=this.props,layoutBoxStore=_props.layoutBoxStore,bannerSearchParams=_props.bannerSearchParams,uiStore=_props.uiStore;if(uiStore.isMobile){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DefaultSidebar'},layoutBoxStore.layoutBoxes.map(function(layoutBox){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DefaultSidebar__box',key:layoutBox.key},_this2.getLayoutBox(layoutBox));}),bannerSearchParams&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ad_SidebarBanner__["a" /* default */],{searchParams:bannerSearchParams}));}}]);return DefaultSidebar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;DefaultSidebar.propTypes={layoutBoxStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_LayoutBoxStore__["a" /* default */]).isRequired,bannerSearchParams:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,uiStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_UIStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('layoutBoxStore','uiStore')(DefaultSidebar));

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_NavigationEntityItem__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_CustomNavigationLinkLocation__ = __webpack_require__(151);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationTree=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationTree,_Component);function NavigationTree(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationTree);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationTree.__proto__||Object.getPrototypeOf(NavigationTree)).call.apply(_ref,[this].concat(args))),_this),_this.getNavigationTree=function(items){return items.map(function(item){var id=item.id,children=item.children,active=item.active,customNavLinks=item.customNavLinks;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:id},customNavLinks&&customNavLinks.map(function(customNavLink,i){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_7__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&customNavLink.parent_sibling_id===item.id&&_this.getCustomNavItem(customNavLink,i);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* NavItem */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationTree__item',{'NavigationTree__item--has-children':children&&children.length>0})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__navigation_NavigationEntityItem__["a" /* default */],{entity:item,className:'NavigationTree__link'}),active&&children&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationTree,{items:children,className:'NavigationTree__subtree'})),customNavLinks&&customNavLinks.map(function(customNavLink,i){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_7__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&customNavLink.parent_sibling_id===item.id&&_this.getCustomNavItem(customNavLink,i);}));});},_this.getCustomNavItem=function(customNavLink,i){var linkClassName='NavigationTree__link';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:i},_this.getSubNavCustomLinks(customNavLink,__WEBPACK_IMPORTED_MODULE_7__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE,linkClassName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* NavItem */],{className:'NavigationTree__item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__navigation_NavigationEntityItem__["a" /* default */],{entity:customNavLink,type:customNavLink.link_type,className:'NavigationTree__link'})),_this.getSubNavCustomLinks(customNavLink,__WEBPACK_IMPORTED_MODULE_7__types_CustomNavigationLinkLocation__["a" /* default */].BELOW,linkClassName));},_this.getSubNavCustomLinks=function(customNavlink,location,linkClassName){return customNavlink.customNavLinks&&customNavlink.customNavLinks.map(function(subCustomNavLink,subIndex){return subCustomNavLink.location===location&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:subIndex},_this.getSubNavCustomLinks(subCustomNavLink,__WEBPACK_IMPORTED_MODULE_7__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE,linkClassName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* NavItem */],{className:'NavigationTree__item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__navigation_NavigationEntityItem__["a" /* default */],{entity:subCustomNavLink,type:subCustomNavLink.link_type,className:linkClassName})),_this.getSubNavCustomLinks(subCustomNavLink,__WEBPACK_IMPORTED_MODULE_7__types_CustomNavigationLinkLocation__["a" /* default */].BELOW,linkClassName));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationTree,[{key:'render',value:function render(){var _props=this.props,items=_props.items,className=_props.className;var navItems=this.getNavigationTree(items);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["G" /* Nav */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationTree','flex-column',className),vertical:true},navItems);}}]);return NavigationTree;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationTree.propTypes={items:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__["a" /* default */]).isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (NavigationTree);

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 261 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(356);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;

  if (target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }

  return {
    remove: function remove() {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback);
      }
    }
  };
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn__ = __webpack_require__(171);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf__["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fillRef;
/* harmony export (immutable) */ __webpack_exports__["a"] = composeRef;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_is__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_is__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */

function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;

  var type = Object(__WEBPACK_IMPORTED_MODULE_0_react_is__["isMemo"])(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type; // Function component node

  if (typeof type === 'function' && !((_type$prototype = type.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }

  return true;
}
/* eslint-enable */

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductTabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_ProductTab__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__product_list_TabProductList__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_ProductRecommendedPosition__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_HashTabs__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__slider_ProductSlider__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_SimpleListTabs__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__product_list_ProductList__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__types_ProductSortOrderBy__ = __webpack_require__(86);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* defineMessages */])({'product.showAllOfType.RECOMMENDED_PRODUCTS':{'id':'product.showAllOfType.RECOMMENDED_PRODUCTS','defaultMessage':'recommended products'},'product.showAllOfType.MOST_SOLD_PRODUCTS':{'id':'product.showAllOfType.MOST_SOLD_PRODUCTS','defaultMessage':'popular products'},'product.showAllOfType.NEW_PRODUCTS':{'id':'product.showAllOfType.NEW_PRODUCTS','defaultMessage':'new products'},'product.showAllOfType.CAMPAIGN_PRODUCTS':{'id':'product.showAllOfType.CAMPAIGN_PRODUCTS','defaultMessage':'products on sale'},'product.showAllOfType.FALLBACK':{'id':'product.showAllOfType.FALLBACK','defaultMessage':'products'}});var ProductTabs=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductTabs,_Component);function ProductTabs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductTabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductTabs.__proto__||Object.getPrototypeOf(ProductTabs)).call.apply(_ref,[this].concat(args))),_this),_this.toggleTab=function(tabId){if(tabId&&_this.getHash()!==tabId){_this.setHash(tabId);}},_this.setHash=function(hash){var history=_this.props.history;var hashString=hash?'#'+hash:'';history.replace(history.location.pathname+history.location.search+hashString);},_this.getHash=function(){var history=_this.props.history;if(history.location.hash){// History hash includes the hashtag (#), strip it off.
return Object(__WEBPACK_IMPORTED_MODULE_25__util_url__["f" /* parseHash */])(history.location.hash);}return'';},_this.getTabSettings=function(section,categoryIds){var _tabs;var _this$props=_this.props,routeService=_this$props.routeService,configStore=_this$props.configStore,searchParams=_this$props.searchParams;var recommendedPositions=void 0;if(searchParams.categories&&searchParams.categories.length>0){recommendedPositions=[__WEBPACK_IMPORTED_MODULE_15__types_ProductRecommendedPosition__["a" /* default */].CATEGORY,__WEBPACK_IMPORTED_MODULE_15__types_ProductRecommendedPosition__["a" /* default */].EVERYWHERE];}else{recommendedPositions=[__WEBPACK_IMPORTED_MODULE_15__types_ProductRecommendedPosition__["a" /* default */].FRONTPAGE,__WEBPACK_IMPORTED_MODULE_15__types_ProductRecommendedPosition__["a" /* default */].EVERYWHERE];}var tabs=(_tabs={},_defineProperty(_tabs,__WEBPACK_IMPORTED_MODULE_11__types_ProductTab__["c" /* default */].RECOMMENDED_PRODUCTS,{labelMessage:__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].weRecommendTitle,completeListingPath:routeService.getPath(__WEBPACK_IMPORTED_MODULE_22__types_Paths__["a" /* default */].RecommendedProducts,section),dynamicTabSearchParams:{recommendedPositions:recommendedPositions}}),_defineProperty(_tabs,__WEBPACK_IMPORTED_MODULE_11__types_ProductTab__["c" /* default */].MOST_SOLD_PRODUCTS,{labelMessage:__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].mostPopularTitle,completeListingPath:routeService.getPath(__WEBPACK_IMPORTED_MODULE_22__types_Paths__["a" /* default */].PopularProducts,section)}),_defineProperty(_tabs,__WEBPACK_IMPORTED_MODULE_11__types_ProductTab__["c" /* default */].NEW_PRODUCTS,{labelMessage:__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].newProductsTitle,completeListingPath:routeService.getPath(__WEBPACK_IMPORTED_MODULE_22__types_Paths__["a" /* default */].NewProducts,section),dynamicTabSearchParams:{dateAdded:{// We set second and millisecond to 0 in order for the query key not to
// change every (milli)second
min:__WEBPACK_IMPORTED_MODULE_9_luxon__["DateTime"].fromObject({second:0,millisecond:0}).minus({seconds:configStore.product.isNewForSeconds}).toISO()}}}),_defineProperty(_tabs,__WEBPACK_IMPORTED_MODULE_11__types_ProductTab__["c" /* default */].CAMPAIGN_PRODUCTS,{labelMessage:__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].onSaleTitle,completeListingPath:routeService.getPath(__WEBPACK_IMPORTED_MODULE_22__types_Paths__["a" /* default */].OnSale,section)}),_tabs);if(categoryIds){__WEBPACK_IMPORTED_MODULE_0_lodash_each___default()(tabs,function(tab){return tab.completeListingPath=Object(__WEBPACK_IMPORTED_MODULE_24__util_queryString__["a" /* addParametersToPath */])(tab.completeListingPath,{f:{categories:categoryIds}});});}return tabs;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductTabs,[{key:'render',value:function render(){var _props=this.props,searchParams=_props.searchParams,configStore=_props.configStore,productStore=_props.productStore,sectionStore=_props.sectionStore,uiStore=_props.uiStore,singleRowMode=_props.singleRowMode,requireCanonicalLink=_props.requireCanonicalLink;var ListComponent=uiStore.isMobile?__WEBPACK_IMPORTED_MODULE_26__slider_ProductSlider__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_28__product_list_ProductList__["a" /* default */];var ContainerComponent=uiStore.isMobile?__WEBPACK_IMPORTED_MODULE_27__common_SimpleListTabs__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_16__common_HashTabs__["b" /* default */];var isSingleRow=singleRowMode&&!uiStore.isMobile;var componentProps={};if(uiStore.isMobile){componentProps.lazyLoad=true;componentProps.lazyLoadOptions={height:400};}var section=void 0;if(searchParams.sections&&searchParams.sections.length>0){section=sectionStore.findSectionById(searchParams.sections[0]);}var categoryIds=void 0;if(searchParams.categories&&searchParams.categories.length>0){categoryIds=searchParams.categories;}var configurationParams={inStock:configStore.inStockProductsOnly?'1':'0'};var tabSettings=this.getTabSettings(section,categoryIds);var tabSearchParams={};configStore.frontpageTabOrder.forEach(function(tabId){var dynamicTabSearchParams=tabSettings[tabId].dynamicTabSearchParams||{};if(configStore.siteConfig.isShoppingCenter&&__WEBPACK_IMPORTED_MODULE_11__types_ProductTab__["b" /* ProductTabSearchParams */][tabId].orderBy===__WEBPACK_IMPORTED_MODULE_30__types_ProductSortOrderBy__["a" /* default */].CAMPAIGN_DATE_ADDED){__WEBPACK_IMPORTED_MODULE_11__types_ProductTab__["b" /* ProductTabSearchParams */][tabId].orderBy=__WEBPACK_IMPORTED_MODULE_30__types_ProductSortOrderBy__["a" /* default */].DISCOUNT;}tabSearchParams[tabId]=Object.assign({resultsPerPage:singleRowMode?5:configStore.frontpageTabMaxProducts},__WEBPACK_IMPORTED_MODULE_11__types_ProductTab__["b" /* ProductTabSearchParams */][tabId],searchParams,dynamicTabSearchParams,configurationParams);});var visibleTabs=configStore.frontpageTabOrder.filter(function(tabId){var params=tabSearchParams[tabId];var queryResults=productStore.productQueryResults.get(Object(__WEBPACK_IMPORTED_MODULE_17__util_query__["a" /* paramsToQueryIdentifier */])(params));var loadedAndResultEmpty=queryResults&&queryResults.data.length===0;return!loadedAndResultEmpty;}).map(function(tabId){var tabName=__WEBPACK_IMPORTED_MODULE_11__types_ProductTab__["a" /* ProductTabName */][tabId];var params=tabSearchParams[tabId];var listingLink=tabSettings[tabId].completeListingPath?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* NavLink */],{to:tabSettings[tabId].completeListingPath,className:'ProductList__complete-listing-link'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.showAllOfType',defaultMessage:'Show all {type}',values:{type:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],messages['product.showAllOfType.'+tabName]||messages['product.showAllOfType.FALLBACK'])}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__common_Icon__["a" /* default */],{name:'angle-right'})):null;return Object(__WEBPACK_IMPORTED_MODULE_16__common_HashTabs__["a" /* createHashTab */])(tabName,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],tabSettings[tabId].labelMessage),function(contextProps){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__product_list_TabProductList__["a" /* default */],Object.assign({searchParams:params,name:'Tab "'+tabName+'"',completeListingLink:listingLink,listComponent:ListComponent,singleRowMode:singleRowMode,requireCanonicalLink:requireCanonicalLink},componentProps,contextProps));});});var hash=this.getHash();var activeTabId=__WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(visibleTabs,{id:hash})?hash:'';return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()('ProductTabs',{'ProductTabs__single-row':isSingleRow})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ContainerComponent,{tabs:visibleTabs,toggle:this.toggleTab,activeTabId:activeTabId}));}}]);return ProductTabs;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;ProductTabs.propTypes={searchParams:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,productStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_ProductStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_SectionStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_29__store_UIStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_20__services_RouteService__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default.a.history,singleRowMode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,requireCanonicalLink:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};ProductTabs.defaultProps={searchParams:{},singleRowMode:false,requireCanonicalLink:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["c" /* inject */])('configStore','productStore','sectionStore','uiStore','routeService')(Object(__WEBPACK_IMPORTED_MODULE_8_react_router__["e" /* withRouter */])(ProductTabs)));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CustomerUser=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CustomerUser',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,firstname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,lastname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,email:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,telephone:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),login_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,is_active:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,seller_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,allow_address_modifications:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean});/* harmony default export */ __webpack_exports__["a"] = (CustomerUser);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _labels;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var labels=(_labels={},_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].PROCESSING,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'orderStatus.processing',defaultMessage:'Processing'})),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].READY,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'orderStatus.ready',defaultMessage:'Ready'})),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].CANCELED,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'orderStatus.canceled',defaultMessage:'Canceled'})),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].PENDING,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'orderStatus.pending',defaultMessage:'Pending'})),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].ACTIVE,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'orderStatus.active',defaultMessage:'Active'})),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].DEACTIVATED,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'orderStatus.deactivated',defaultMessage:'Deactivated'})),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].ON_HOLD,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'orderStatus.onHold',defaultMessage:'On hold'})),_labels);var OrderStatusLabel=function(_Component){_inherits(OrderStatusLabel,_Component);function OrderStatusLabel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrderStatusLabel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrderStatusLabel.__proto__||Object.getPrototypeOf(OrderStatusLabel)).call.apply(_ref,[this].concat(args))),_this),_this.getModifierClassName=function(){var modifier=void 0;switch(_this.props.status){case __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].CANCELED:case __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].DEACTIVATED:modifier='canceled';break;case __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].PENDING:case __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].PROCESSING:case __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].ON_HOLD:modifier='processing';break;case __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].READY:case __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */].ACTIVE:modifier='ready';break;default:return null;}return'OrderStatusLabel__status--'+modifier;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrderStatusLabel,[{key:'render',value:function render(){var status=this.props.status;var statusMessage=labels[status];return statusMessage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('OrderStatusLabel',this.getModifierClassName(this.props.status))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{className:'OrderStatusLabel__status-icon',name:'circle'}),statusMessage):null;}}]);return OrderStatusLabel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrderStatusLabel.propTypes={status:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(Object.values(__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["b" /* default */]))};/* harmony default export */ __webpack_exports__["a"] = (OrderStatusLabel);

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(383);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(384);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(175);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(58);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(206);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(207);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducePropsToState = exports.flattenArray = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(209);

var HELMET_PROPS = {
  DEFAULT_TITLE: 'defaultTitle',
  DEFER: 'defer',
  ENCODE_SPECIAL_CHARACTERS: 'encodeSpecialCharacters',
  ON_CHANGE_CLIENT_STATE: 'onChangeClientState',
  TITLE_TEMPLATE: 'titleTemplate'
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
  for (var i = propsList.length - 1; i >= 0; i -= 1) {
    var props = propsList[i];

    if (Object.prototype.hasOwnProperty.call(props, property)) {
      return props[property];
    }
  }

  return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
  var innermostTitle = getInnermostProperty(propsList, _constants.TAG_NAMES.TITLE);
  var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
  if (Array.isArray(innermostTitle)) {
    innermostTitle = innermostTitle.join('');
  }
  if (innermostTemplate && innermostTitle) {
    // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function () {
      return innermostTitle;
    });
  }

  var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

  return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
  return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
  return propsList.filter(function (props) {
    return typeof props[tagType] !== 'undefined';
  }).map(function (props) {
    return props[tagType];
  }).reduce(function (tagAttrs, current) {
    return _extends({}, tagAttrs, current);
  }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
  return propsList.filter(function (props) {
    return typeof props[_constants.TAG_NAMES.BASE] !== 'undefined';
  }).map(function (props) {
    return props[_constants.TAG_NAMES.BASE];
  }).reverse().reduce(function (innermostBaseTag, tag) {
    if (!innermostBaseTag.length) {
      var keys = Object.keys(tag);

      for (var i = 0; i < keys.length; i += 1) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();

        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
          return innermostBaseTag.concat(tag);
        }
      }
    }

    return innermostBaseTag;
  }, []);
};

// eslint-disable-next-line no-console
var warn = function warn(msg) {
  return console && typeof console.warn === 'function' && console.warn(msg);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
  // Calculate list of tags, giving priority innermost component (end of the propslist)
  var approvedSeenTags = {};

  return propsList.filter(function (props) {
    if (Array.isArray(props[tagName])) {
      return true;
    }
    if (typeof props[tagName] !== 'undefined') {
      warn('Helmet: ' + tagName + ' should be of type "Array". Instead found type "' + _typeof(props[tagName]) + '"');
    }
    return false;
  }).map(function (props) {
    return props[tagName];
  }).reverse().reduce(function (approvedTags, instanceTags) {
    var instanceSeenTags = {};

    instanceTags.filter(function (tag) {
      var primaryAttributeKey = void 0;
      var keys = Object.keys(tag);
      for (var i = 0; i < keys.length; i += 1) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();

        // Special rule with link tags, since rel and href are both primary tags, rel takes priority
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _constants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === 'canonical') && !(lowerCaseAttributeKey === _constants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === 'stylesheet')) {
          primaryAttributeKey = lowerCaseAttributeKey;
        }
        // Special case for innerHTML which doesn't work lowercased
        if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _constants.TAG_PROPERTIES.INNER_HTML || attributeKey === _constants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _constants.TAG_PROPERTIES.ITEM_PROP)) {
          primaryAttributeKey = attributeKey;
        }
      }

      if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
        return false;
      }

      var value = tag[primaryAttributeKey].toLowerCase();

      if (!approvedSeenTags[primaryAttributeKey]) {
        approvedSeenTags[primaryAttributeKey] = {};
      }

      if (!instanceSeenTags[primaryAttributeKey]) {
        instanceSeenTags[primaryAttributeKey] = {};
      }

      if (!approvedSeenTags[primaryAttributeKey][value]) {
        instanceSeenTags[primaryAttributeKey][value] = true;
        return true;
      }

      return false;
    }).reverse().forEach(function (tag) {
      return approvedTags.push(tag);
    });

    // Update seen tags with tags from this instance
    var keys = Object.keys(instanceSeenTags);
    for (var i = 0; i < keys.length; i += 1) {
      var attributeKey = keys[i];
      var tagUnion = Object.assign({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

      approvedSeenTags[attributeKey] = tagUnion;
    }

    return approvedTags;
  }, []).reverse();
};

var reducePropsToState = function reducePropsToState(propsList) {
  return {
    baseTag: getBaseTagFromPropsList([_constants.TAG_PROPERTIES.HREF], propsList),
    bodyAttributes: getAttributesFromPropsList(_constants.ATTRIBUTE_NAMES.BODY, propsList),
    defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
    encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
    htmlAttributes: getAttributesFromPropsList(_constants.ATTRIBUTE_NAMES.HTML, propsList),
    linkTags: getTagsFromPropsList(_constants.TAG_NAMES.LINK, [_constants.TAG_PROPERTIES.REL, _constants.TAG_PROPERTIES.HREF], propsList),
    metaTags: getTagsFromPropsList(_constants.TAG_NAMES.META, [_constants.TAG_PROPERTIES.NAME, _constants.TAG_PROPERTIES.CHARSET, _constants.TAG_PROPERTIES.HTTPEQUIV, _constants.TAG_PROPERTIES.PROPERTY, _constants.TAG_PROPERTIES.ITEM_PROP], propsList),
    noscriptTags: getTagsFromPropsList(_constants.TAG_NAMES.NOSCRIPT, [_constants.TAG_PROPERTIES.INNER_HTML], propsList),
    onChangeClientState: getOnChangeClientState(propsList),
    scriptTags: getTagsFromPropsList(_constants.TAG_NAMES.SCRIPT, [_constants.TAG_PROPERTIES.SRC, _constants.TAG_PROPERTIES.INNER_HTML], propsList),
    styleTags: getTagsFromPropsList(_constants.TAG_NAMES.STYLE, [_constants.TAG_PROPERTIES.CSS_TEXT], propsList),
    title: getTitleFromPropsList(propsList),
    titleAttributes: getAttributesFromPropsList(_constants.ATTRIBUTE_NAMES.TITLE, propsList)
  };
};

var flattenArray = exports.flattenArray = function flattenArray(possibleArray) {
  return Array.isArray(possibleArray) ? possibleArray.join('') : possibleArray;
};

exports.reducePropsToState = reducePropsToState;

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ResizeDetector__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_withResizeDetector__ = __webpack_require__(699);
/* unused harmony reexport withResizeDetector */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_ResizeDetector__["a" /* default */]);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(700);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SiteTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var SiteType={WEB_STORE:'WEB_STORE',SHOPPING_CENTER:'SHOPPING_CENTER',HOME_PAGE:'HOME_PAGE'};/* harmony default export */ __webpack_exports__["b"] = (SiteType);var SiteTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('type',Object.values(SiteType));

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProductListStyle={CARD:'CARD',CARD_LARGE:'CARD_LARGE'};/* harmony default export */ __webpack_exports__["a"] = (ProductListStyle);

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(82);
var normalizeHeaderName = __webpack_require__(709);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(411);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(411);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_has__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_SectionStatusType__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_SectionIntegrationType__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_LinkType__ = __webpack_require__(76);
var Section=__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].model('Section',{id:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].identifierNumber,slug:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string,display_name:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string,link_type:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string),blocked_categories:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].number),main_categories:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].number),content_html:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string),configurations:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].frozen(),status:__WEBPACK_IMPORTED_MODULE_5__types_SectionStatusType__["a" /* SectionStatusTypeType */],SEO_title:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string),SEO_description:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string),integration_type:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_6__types_SectionIntegrationType__["a" /* SectionIntegrationTypeType */]),integration_feed_url:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string),integration_api_key:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string),footer_description_html:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string),name_in_navigation:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].string)}).views(function(self){return{get blockedCategoriesDict(){return __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(self.blocked_categories,function(categoryId){return categoryId;});},get mainCategoryIds(){return self.main_categories.filter(function(categoryId){return!self.blockedCategoriesDict[categoryId];});},get mainCategories(){var categoryStore=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["g" /* getRoot */])(self).categoryStore;return categoryStore.flattenedCategories.filter(function(category){return self.mainCategoryIds.includes(category.id);});},get path(){if(self.link_type===__WEBPACK_IMPORTED_MODULE_7__types_LinkType__["b" /* default */].EXTERNAL_LINK||self.link_type===__WEBPACK_IMPORTED_MODULE_7__types_LinkType__["b" /* default */].INTERNAL_LINK){return self.slug;}if(self.slug&&self.slug.length>0){return Object(__WEBPACK_IMPORTED_MODULE_4__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__types_Paths__["a" /* default */].Section,{section:self.slug});}},get breadcrumbs(){return[{text:self.display_name,url:self.path}];},get mainCategoriesDict(){return __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(self.mainCategoryIds,function(categoryId){return categoryId;});},get navigationName(){return self.name_in_navigation&&self.name_in_navigation.length>0?self.name_in_navigation:self.display_name;},hasMainCategory:function hasMainCategory(categoryId){return __WEBPACK_IMPORTED_MODULE_0_lodash_has___default()(self.mainCategoriesDict,categoryId);},includesCategory:function includesCategory(category){return self.hasMainCategory(category.mainCategory.id)&&!__WEBPACK_IMPORTED_MODULE_0_lodash_has___default()(self.blockedCategoriesDict,category.id);}};});/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(47),
    isSymbol = __webpack_require__(138);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(747),
    mapCacheDelete = __webpack_require__(763),
    mapCacheGet = __webpack_require__(765),
    mapCacheHas = __webpack_require__(766),
    mapCacheSet = __webpack_require__(767);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isObject = __webpack_require__(89);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(124),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(139),
    arrayMap = __webpack_require__(144),
    isArray = __webpack_require__(47),
    isSymbol = __webpack_require__(138);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(768),
    isObjectLike = __webpack_require__(90);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(88),
    stubFalse = __webpack_require__(774);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(290)(module)))

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(215),
    stackClear = __webpack_require__(780),
    stackDelete = __webpack_require__(781),
    stackGet = __webpack_require__(782),
    stackHas = __webpack_require__(783),
    stackSet = __webpack_require__(784);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(785),
    isObjectLike = __webpack_require__(90);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(435),
    stubArray = __webpack_require__(436);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CouponActivationTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CouponActivationType={GIVEN_CODE:'GIVEN_CODE',AUTO_GENERATION:'AUTO_GENERATION',REGISTRATION:'REGISTRATION',LOGIN:'LOGIN',FIRST_PURCHASE:'FIRST_PURCHASE',NEWSLETTER_SUBSCRIPTION:'NEWSLETTER_SUBSCRIPTION',VISIT_TIME:'VISIT_TIME',PRODUCT_REVIEW:'PRODUCT_REVIEW'};/* harmony default export */ __webpack_exports__["b"] = (CouponActivationType);var CouponActivationTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CouponActivationType',Object.values(CouponActivationType));

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CouponDiscountTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CouponDiscountType={AMOUNT:'AMOUNT',PERCENTAGE:'PERCENTAGE',FREE_SHIPPING:'FREE_SHIPPING'};/* harmony default export */ __webpack_exports__["b"] = (CouponDiscountType);var CouponDiscountTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CouponDiscountType',Object.values(CouponDiscountType));

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InfoPageModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_InfoPageStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoPageModal=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(InfoPageModal,_Component);function InfoPageModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPageModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPageModal.__proto__||Object.getPrototypeOf(InfoPageModal)).call.apply(_ref,[this].concat(args))),_this),_this.getInfoPage=function(){var _this$props=_this.props,infoPageStore=_this$props.infoPageStore,pageId=_this$props.pageId;return infoPageStore.pages.get(pageId);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPageModal,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,infoPageStore=_props.infoPageStore,pageId=_props.pageId;var infoPage=this.getInfoPage();if(!infoPage||infoPage.content===null){infoPageStore.loadPage(pageId).catch(function(e){console.error(e);});}}},{key:'render',value:function render(){var _props2=this.props,infoPageStore=_props2.infoPageStore,routeService=_props2.routeService,pageId=_props2.pageId,toggle=_props2.toggle,isOpen=_props2.isOpen;var infoPage=this.getInfoPage();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["C" /* Modal */],{className:'InfoPageModal',size:'lg',toggle:toggle,isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["F" /* ModalHeader */],{className:'InfoPageModal__header',toggle:toggle},infoPage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["c" /* NavLink */],{to:routeService.getPath(infoPage.path),onClick:toggle},infoPage.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loader_ContentForState__["a" /* default */],{state:infoPageStore.pageStates.get(pageId),error:infoPageStore.lastError,forLoaded:function forLoaded(){return infoPage&&infoPage.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:infoPage.content},className:'InfoPageModal__contents'});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["E" /* ModalFooter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'secondary',onClick:toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].closeTitle))));}}]);return InfoPageModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;InfoPageModal.propTypes={infoPageStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_InfoPageStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10__services_RouteService__["a" /* default */]).isRequired,pageId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,toggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isOpen:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('infoPageStore','routeService')(InfoPageModal));

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spinner=function(_Component){_inherits(Spinner,_Component);function Spinner(){_classCallCheck(this,Spinner);return _possibleConstructorReturn(this,(Spinner.__proto__||Object.getPrototypeOf(Spinner)).apply(this,arguments));}_createClass(Spinner,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Spinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sr-only',role:'alert','aria-busy':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__i18n_globalTranslations__["a" /* default */].loading)));}}]);return Spinner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_generatePath__ = __webpack_require__(48);
var InfoPage=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('InfoPage',{content:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,parent_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),SEO_description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),SEO_title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),show_in_listing:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,slug:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,sort_order:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number}).views(function(self){return{get path(){return Object(__WEBPACK_IMPORTED_MODULE_2__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__types_Paths__["a" /* default */].InfoPage,{slug:self.slug,id:self.id});},get children(){var infoPageStore=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["e" /* getParent */])(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["e" /* getParent */])(self));return infoPageStore&&infoPageStore.pagesArray?infoPageStore.pagesArray.filter(function(page){return page.parent_id===self.id;}):[];},get parent(){var parent=self.parent_id&&Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["k" /* resolveIdentifier */])(InfoPage,Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["g" /* getRoot */])(self),self.parent_id);return parent||null;},get ancestors(){var ancestors=[];var currentPage=self;while(currentPage.parent){var parent=currentPage.parent;ancestors.push(parent);currentPage=parent;}ancestors.reverse();return ancestors;},get breadcrumbs(){var ancestors=self.ancestors;var breadcrumbs=ancestors.map(function(ancestor){return{text:ancestor.name,url:ancestor.path};});breadcrumbs.push({text:self.name,url:self.path});return breadcrumbs;}};});/* harmony default export */ __webpack_exports__["a"] = (InfoPage);

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(446),
    baseEach = __webpack_require__(146),
    castFunction = __webpack_require__(801),
    isArray = __webpack_require__(47);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var FieldType={NORMAL:'NORMAL',FILE:'FILE'};/* harmony default export */ __webpack_exports__["b"] = (FieldType);var FieldTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('FieldTypeType',Object.values(FieldType));

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(295),
    isFlattenable = __webpack_require__(812);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(306),
    castPath = __webpack_require__(143),
    isIndex = __webpack_require__(219),
    isObject = __webpack_require__(89),
    toKey = __webpack_require__(145);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(178),
    eq = __webpack_require__(217);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClickOutside=function(_Component){_inherits(ClickOutside,_Component);function ClickOutside(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClickOutside);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClickOutside.__proto__||Object.getPrototypeOf(ClickOutside)).call.apply(_ref,[this].concat(args))),_this),_this.isTouch=false,_this.inExcluded=function(target){var excludedSelector=_this.props.excludedSelector;return __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(document.querySelectorAll(excludedSelector),function(element){return element.contains(target);});},_this.handle=function(e){if(e.type==='touchend'){_this.isTouch=true;}if(e.type==='click'&&_this.isTouch){return;}var onClickOutside=_this.props.onClickOutside;var el=_this.container;if(!_this.inExcluded(e.target)&&el&&!el.contains(e.target)){onClickOutside(e);}},_this.setContainer=function(ref){_this.container=ref;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClickOutside,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('touchend',this.handle,true);document.addEventListener('click',this.handle,true);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('touchend',this.handle,true);document.removeEventListener('click',this.handle,true);}},{key:'render',value:function render(){var _props=this.props,children=_props.children,onClickOutside=_props.onClickOutside,excludedSelector=_props.excludedSelector,props=_objectWithoutProperties(_props,['children','onClickOutside','excludedSelector']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',Object.assign({},props,{ref:this.setContainer}),children);}}]);return ClickOutside;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ClickOutside.propTypes={onClickOutside:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,excludedSelector:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ClickOutside);

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(292),
    arrayEach = __webpack_require__(446),
    assignValue = __webpack_require__(306),
    baseAssign = __webpack_require__(818),
    baseAssignIn = __webpack_require__(819),
    cloneBuffer = __webpack_require__(822),
    copyArray = __webpack_require__(454),
    copySymbols = __webpack_require__(823),
    copySymbolsIn = __webpack_require__(824),
    getAllKeys = __webpack_require__(433),
    getAllKeysIn = __webpack_require__(310),
    getTag = __webpack_require__(179),
    initCloneArray = __webpack_require__(825),
    initCloneByTag = __webpack_require__(826),
    initCloneObject = __webpack_require__(831),
    isArray = __webpack_require__(47),
    isBuffer = __webpack_require__(289),
    isMap = __webpack_require__(833),
    isObject = __webpack_require__(89),
    isSet = __webpack_require__(835),
    keys = __webpack_require__(147);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(427);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(434),
    getSymbolsIn = __webpack_require__(455),
    keysIn = __webpack_require__(453);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(432);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManufacturerIntegrationTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ManufacturerIntegrationType={LOADBEE:'LOADBEE'};/* harmony default export */ __webpack_exports__["b"] = (ManufacturerIntegrationType);var ManufacturerIntegrationTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ManufacturerIntegrationType',Object.values(ManufacturerIntegrationType));

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_LayoutBox__ = __webpack_require__(856);
var LayoutBoxStore=__WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__["a" /* default */].named('LayoutBoxStore').props({layoutBoxes:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__models_LayoutBox__["a" /* default */]),[])}).actions(function(self){return{setup:function setup(layoutBoxes){self.layoutBoxes=layoutBoxes;self.setLoading(false);}};});/* harmony default export */ __webpack_exports__["a"] = (LayoutBoxStore);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductPriceInfo__ = __webpack_require__(93);
var Ad=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Ad',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,content:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),link_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),hide_from_desktop_tablet_users:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean),mobile_image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),hide_from_mobile_users:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean),price_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__ProductPriceInfo__["a" /* default */]),discount_text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),overlay_background_color:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),text_color:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),overlay_image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),scent:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),priority:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,manufacturer:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),// This refers to the possible product, not the banner itself.
date_added:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (Ad);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AdLoader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_AdStore__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_query__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdLoader=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AdLoader,_Component);function AdLoader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AdLoader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AdLoader.__proto__||Object.getPrototypeOf(AdLoader)).call.apply(_ref,[this].concat(args))),_this),_this.loadAds=function(){var _this$props=_this.props,adStore=_this$props.adStore,searchParams=_this$props.searchParams;adStore.loadAds(searchParams);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AdLoader,[{key:'componentDidMount',value:function componentDidMount(){this.loadAds();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.searchParams,this.props.searchParams)){this.loadAds();}}},{key:'render',value:function render(){var _props=this.props,adStore=_props.adStore,searchParams=_props.searchParams,children=_props.children;if(!adStore){return null;}var ads=adStore.adQueries.get(Object(__WEBPACK_IMPORTED_MODULE_6__util_query__["a" /* paramsToQueryIdentifier */])(searchParams));return children(ads);}}]);return AdLoader;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;AdLoader.propTypes={searchParams:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,adStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_AdStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('adStore')(AdLoader));

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_MarkerBadge__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavigationCartPopover__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types_ProductAddedToCartModalStyle__ = __webpack_require__(469);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationCart=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationCart,_Component);function NavigationCart(props){_classCallCheck(this,NavigationCart);var _this=_possibleConstructorReturn(this,(NavigationCart.__proto__||Object.getPrototypeOf(NavigationCart)).call(this,props));_this.getPrice=function(){var _this$props=_this.props,cartStore=_this$props.cartStore,withTax=_this$props.withTax;return cartStore.cart&&cartStore.cart.total.getPrice(withTax);};_this.getHidePriceOnMobile=function(){return _this.getPrice()>1000;};_this.renderPrice=function(){var price=_this.getPrice();return price!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__product_Price__["a" /* default */],{price:price}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__product_Price__["a" /* default */],{price:0});};_this.renderCartText=function(){var cartStore=_this.props.cartStore;var text=void 0;switch(cartStore.state){case __WEBPACK_IMPORTED_MODULE_13__types_RequestState__["b" /* default */].LOADED:if(!cartStore.cart||cartStore.cart.number_of_products===0){text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].cartEmptySentence);}else{text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].itemCount,{values:{count:cartStore.cart.number_of_products}})),' ',_this.renderPrice());}break;case __WEBPACK_IMPORTED_MODULE_13__types_RequestState__["b" /* default */].LOADING:default:text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].loading);break;}return text;};_this.sendAnalyticsCheckoutEvent=function(){var _this$props2=_this.props,analytics=_this$props2.analytics,cartStore=_this$props2.cartStore,configStore=_this$props2.configStore;if(!configStore.gtm.enabled){return;}var cartProducts=cartStore.cart.products;var actionField={step:1,option:'Move To Checkout'};analytics.checkout(cartProducts,actionField);};_this.cartIsPopover=function(){var _this$props3=_this.props,accountStore=_this$props3.accountStore,configStore=_this$props3.configStore;if(!accountStore.account){return null;}var isRetailer=accountStore.account.is_retailer;var modalType=configStore.productAddedToCardModalType;return isRetailer||modalType===__WEBPACK_IMPORTED_MODULE_18__types_ProductAddedToCartModalStyle__["a" /* default */].POPOVER;};_this.cartIsPopover=_this.cartIsPopover();return _this;}_createClass(NavigationCart,[{key:'render',value:function render(){var _props=this.props,accountStore=_props.accountStore,configStore=_props.configStore,cartStore=_props.cartStore,className=_props.className,intl=_props.intl,withCheckoutButton=_props.withCheckoutButton,wrapperClassName=_props.wrapperClassName;var checkout=configStore.checkout;var ifProductCatalog=accountStore.isViewOnly;if(ifProductCatalog){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationCart',className)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationCart__cart-button-wrapper',wrapperClassName)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{block:true,color:'primary',onClick:function onClick(){return cartStore.cartModal.toggle(true);},disabled:cartStore.state!==__WEBPACK_IMPORTED_MODULE_13__types_RequestState__["b" /* default */].LOADED},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'shopping-cart'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationCart__cart-text',{'NavigationCart__cart-text--hide-on-mobile':this.getHidePriceOnMobile()})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'NavigationCart__cart-text-desktop'},this.renderCartText()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'NavigationCart__cart-text-mobile'},this.renderPrice()))),cartStore.cart&&cartStore.cart.number_of_products>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_MarkerBadge__["a" /* default */],{className:'d-xs-inline d-md-none'},cartStore.cart.number_of_products)),withCheckoutButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationCart__checkout-button-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{block:true,color:'primary',tag:'a',href:checkout.checkoutPath,rel:'noopener',className:'NavigationCart__checkout-button',onClick:this.sendAnalyticsCheckoutEvent,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].proceedToCheckoutSentence)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].proceedToCheckoutSentence))),this.cartIsPopover&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__NavigationCartPopover__["a" /* default */],null));}}]);return NavigationCart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationCart.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_AccountStore__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_CartStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_UIStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_17__analytics_Analytics__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_5_react_intl__["f" /* intlShape */].isRequired,withTax:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,withCheckoutButton:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,wrapperClassName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};NavigationCart.defaultProps={withCheckoutButton:false,className:''};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])(function(stores){return{accountStore:stores.accountStore,cartStore:stores.cartStore,configStore:stores.configStore,uiStore:stores.uiStore,analytics:stores.analytics,withTax:stores.accountStore.showPricesWithTax};})(NavigationCart)));

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LargeImageShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SmallImageShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_required_if__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_required_if___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_required_if__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);




var BaseImageShape = {
    alt: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    src: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    srcSet: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    sizes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    onLoad: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

var LargeImageShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_2_object_assign___default()({}, BaseImageShape, {
    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
}));

var SmallImageShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_2_object_assign___default()({}, BaseImageShape, {
    isFluidWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_1_react_required_if___default()(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, function (props) {
        return !props.isFluidWidth;
    }),
    height: __WEBPACK_IMPORTED_MODULE_1_react_required_if___default()(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, function (props) {
        return !props.isFluidWidth;
    })
}));

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuickSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_search__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_SuggestionStore__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__loader_Spinner__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__product_ProductQuickSearchResult__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_LocationContext__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_SuggestionType__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_Autosuggest__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__store_SearchRedirectionStore__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__types_StoreThemeLayoutTypes__ = __webpack_require__(409);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_SUGGESTED_PRODUCTS_VISIBLE=3;var MAX_SUGGESTED_PRODUCTS_VISIBLE=10;var SEARCH_HISTORY_LIMIT=5;var LOCALSTORAGE_HISTORY_KEY='history';var TEXT_SEARCH_MIN_CHARACTERS=1;var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({searchProducts:{'id':'search.searchProducts','defaultMessage':'Search products'}});var highlightResult=function highlightResult(text,textToHighlight){var matchAll=['*'];var regexTextToHighlight=matchAll.some(function(item){return item===textToHighlight;})?'':'('+textToHighlight+')';var regex=new RegExp('(.*)'+regexTextToHighlight+'(.*)','i');var matches=text.match(regex);return matches?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,matches[1],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,matches[2]),matches[3]):text;};var getSuggestionValue=function getSuggestionValue(suggestion){return suggestion?suggestion.value:'';};var renderSuggestion=function renderSuggestion(suggestion){return suggestion?suggestion.render:'';};var getSectionSuggestions=function getSectionSuggestions(section){return section?section.suggestions:[];};var renderSectionTitle=function renderSectionTitle(section){return section?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,section.title):'';};var createSuggestionAnalyticsData=function createSuggestionAnalyticsData(type,value){return{type:type,value:value};};var createSuggestion=function createSuggestion(value,render,action,analyticsData){return{value:value,render:render,action:action,analyticsData:analyticsData};};var QuickSearch=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(QuickSearch,_Component);function QuickSearch(props){_classCallCheck(this,QuickSearch);var _this=_possibleConstructorReturn(this,(QuickSearch.__proto__||Object.getPrototypeOf(QuickSearch)).call(this,props));_this.registerEventListeners=function(){if(_this.closeButtonElement){_this.closeButtonElement.addEventListener('touchend',_this.handleCloseEvent);_this.closeButtonElement.addEventListener('mousedown',_this.handleCloseEvent);}if(_this.searchButtonElement){_this.searchButtonElement.addEventListener('touchend',_this.handleSearchEvent);_this.searchButtonElement.addEventListener('mousedown',_this.handleSearchEvent);}};_this.handleCloseEvent=function(event){event.preventDefault();event.stopPropagation();_this.clearSearch();_this.onBlur();};_this.handleSearchEvent=function(event){event.preventDefault();event.stopPropagation();_this.onClickFunctions();_this.onBlur();};_this.maybeUpdateSearchValue=function(){var prevSearch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var searchText=_this.getKeywords();if(prevSearch.length>0&&!searchText){_this.reset();return;}if(_this.state.value.length===0&&searchText&&searchText.length>0){_this.update(searchText);}};_this.loadHistoryFromLocalStorage=function(){var historyFromLocalStorage=JSON.parse(localStorage.getItem(LOCALSTORAGE_HISTORY_KEY));if(historyFromLocalStorage){_this.history=historyFromLocalStorage;}else{_this.history=[];}_this.setState({searchHistory:_this.history});};_this.saveHistoryToLocalStorage=function(){localStorage.setItem(LOCALSTORAGE_HISTORY_KEY,JSON.stringify(_this.history));};_this.historyToSuggestions=function(){var suggestionSections=[];if(_this.history){var visibleHistory=_this.history.filter(function(h){return h!==null;}).map(function(h,i){return createSuggestion(h,_this.historySuggestionItem(h,i),function(){return _this.search(h);});});suggestionSections.push({title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].searchHistoryTitle),suggestions:visibleHistory});}_this.setState({searchHistory:suggestionSections});};_this.handleDeleteClick=function(i){_this.doNotTriggerSearch=true;_this.history.splice(i,1);_this.saveHistoryToLocalStorage();_this.historyToSuggestions();_this.setState({inputFocus:false});};_this.historySuggestionItem=function(value,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'history__result'},value,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{onClick:_this.handleDeleteClick.bind(_this,index),className:'history__delete-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'times'}),' ')));};_this.checkHistoryArray=function(){return _this.history.every(function(element){return element===null;})?false:true;};_this.removeNullsFromHistory=function(){if(_this.history){_this.history=_this.history.filter(function(h){return h!==null;});_this.saveHistoryToLocalStorage();_this.setState({searchHistory:_this.history});_this.historyToSuggestions();}};_this.getKeywords=function(){if(!_this.props.location){return null;}var queryParams=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["b" /* parse */])(_this.props.location.search);return queryParams.keywords;};_this.update=function(search){_this.setState({value:search});};_this.onChange=function(event,_ref){var newValue=_ref.newValue,method=_ref.method;if(_this.doNotTriggerSearch){return;}var ignoredMethods=['enter','up','down'];// Toggle variable if arrow navigation was used. Special check for enter
// because enter is also considered as a change and causes some problems
// in onSuggestionSelected.
if(_this.recentlyArrowNavigated&&method==='enter'||method==='up'||method==='down'){_this.recentlyArrowNavigated=true;}// Don't change state if user presses enter while hovering a suggestion.
if(ignoredMethods.includes(method)){return;}// When backspacing the value away we need to clear the suggestions so
// the old values suggestions do not distract user.
if(method==='type'&&!_this.validCharacterLength(newValue)){_this.setState({suggestions:[]});}_this.setState({value:newValue,inputFocus:true},function(){return!_this.state.value&&_this.getFilterText();});};_this.onFocus=function(){_this.setState({inputFocus:true});_this.props.handleFocus();};_this.onBlur=function(){var _this$props=_this.props,handleBlur=_this$props.handleBlur,uiStore=_this$props.uiStore;_this.setState({inputFocus:false});uiStore.toggleSearch(false);handleBlur();};_this.handleKeyPress=function(e){if(e.key==='Enter'){_this.onClickFunctions();_this.toggleSearch();_this.getFilterText();_this.setState({inputFocus:false});}};_this.search=function(searchText){var _this$props2=_this.props,routeService=_this$props2.routeService,searchRedirectionStore=_this$props2.searchRedirectionStore,locationContext=_this$props2.locationContext,productListFilter=_this$props2.productListFilter;if(searchText===''){return;}productListFilter&&_this.getFilterText(true);var maybeRedirection=searchRedirectionStore.getRedirection(searchText);if(maybeRedirection&&!productListFilter){var url=Object(__WEBPACK_IMPORTED_MODULE_27__util_url__["i" /* stripHostIfMatches */])(maybeRedirection.link,locationContext.host);var notHandledByReactRouter=Object(__WEBPACK_IMPORTED_MODULE_27__util_url__["e" /* isNotHandledByReactRouter */])(url);return notHandledByReactRouter?window.open(url,'_blank','noopener'):_this.navigateTo(url);}!productListFilter&&_this.navigateTo(routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["a" /* addParametersToPath */])(__WEBPACK_IMPORTED_MODULE_20__types_Paths__["a" /* default */].AdvancedSearch,{keywords:searchText})));};_this.navigateTo=function(url){_this.props.history.push(url);};_this.toggleSearch=function(){_this.props.toggleSearch();};_this.reset=function(){_this.setState({value:''});};_this.setSuggestionCount=function(){var configStore=_this.props.configStore;var count=Number(configStore.productSuggestions.count);if(!isNaN(count)){if(count<0){_this.suggestionCount=0;}if(count>MAX_SUGGESTED_PRODUCTS_VISIBLE){_this.suggestionCount=MAX_SUGGESTED_PRODUCTS_VISIBLE;}else{_this.suggestionCount=count;}return;}else if(configStore.productSuggestions.enabled){_this.suggestionCount=DEFAULT_SUGGESTED_PRODUCTS_VISIBLE;return;}_this.suggestionCount=0;};_this.onSuggestionSelected=function(event,_ref2){var suggestion=_ref2.suggestion,method=_ref2.method;if(_this.doNotTriggerSearch){return;}// We need to prevent default events, because we do not wan't to trigger our
// custom onKeyPress handler.
event.preventDefault();// Prevents search from changing to suggestion value/action,
// while hovering a suggestion and pressing enter.
// Instead performs a regular search on enter press.
if(method==='enter'&&!_this.recentlyArrowNavigated){_this.onClickFunctions();_this.toggleSearch();return;}if(suggestion.analyticsData){_this.sendSuggestionSelection(_this.state.value,suggestion.analyticsData.type,suggestion.analyticsData.value);}if(suggestion.action){suggestion.action();}_this.recentlyArrowNavigated=false;};_this.sendSuggestionSelection=function(searchText,suggestionType,suggestionValue){var analytics=_this.props.analytics;analytics.suggestionSelection(searchText,suggestionType,suggestionValue);};_this.updateSuggestions=function(searchText,products,suggestions,total){var _this$props3=_this.props,configStore=_this$props3.configStore,uiStore=_this$props3.uiStore,analytics=_this$props3.analytics,intl=_this$props3.intl,routeService=_this$props3.routeService,searchRedirectionStore=_this$props3.searchRedirectionStore;var totalResults=total?total:_this.state.total;var suggestionSections=[];var maybeRedirection=searchRedirectionStore.getRedirection(searchText);if(!maybeRedirection&&suggestions.length>0){suggestionSections.push({title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].suggestionsTitle),suggestions:suggestions.map(function(suggestion){return createSuggestion(suggestion.text,highlightResult(suggestion.text,searchText),function(){_this.search(suggestion.text);_this.setState({value:suggestion.text});},createSuggestionAnalyticsData(__WEBPACK_IMPORTED_MODULE_23__types_SuggestionType__["a" /* default */].SUGGESTION,suggestion.id));})});}var matchingCategories=configStore.advancedSearch.enabled?_this.getMatchingCategories(searchText):[];if(!maybeRedirection&&matchingCategories.length>0){suggestionSections.push({title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].categoriesTitle),suggestions:matchingCategories.map(function(category){return createSuggestion(category.name,highlightResult(category.name,searchText),function(){_this.navigateTo(routeService.getCategoryPath(category));_this.reset();_this.toggleSearch();},createSuggestionAnalyticsData(__WEBPACK_IMPORTED_MODULE_23__types_SuggestionType__["a" /* default */].CATEGORY,category.id));})});}if(!maybeRedirection&&products.length>0){var productSuggestions=products.map(function(product,index){var position=index+1;return createSuggestion(product.multiproduct_title||product.name,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__product_ProductQuickSearchResult__["a" /* default */],{product:product,position:position,listName:_this.listName,hideDescription:uiStore.isMobile||_this.suggestionCount>4}),function(){_this.sendProductClick(position,product);_this.navigateTo(routeService.getCanonicalProductPath(product));_this.reset();_this.toggleSearch();},createSuggestionAnalyticsData(__WEBPACK_IMPORTED_MODULE_23__types_SuggestionType__["a" /* default */].PRODUCT,product.id));});if(totalResults>_this.suggestionCount){productSuggestions.push(createSuggestion(_this.state.value,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary','aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].showAllProductsSentence)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'QuickSearch__show-all-products'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].showAllProductsSentence),' ('+totalResults+')')),function(){_this.onClickFunctions();_this.toggleSearch();}));}suggestionSections.push({title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].productsTitle),suggestions:productSuggestions});}if(!maybeRedirection&&suggestionSections.length===0&&configStore.siteConfig.isWebStore){suggestionSections.unshift({title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].searchNoResultsSentence),suggestions:[createSuggestion(searchText,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].searchTryAnotherSentence),function(){return _this.setState({value:''});})]});}analytics.quickSearch(searchText.toLowerCase(),{suggestionCount:suggestions.length,categoryCount:matchingCategories.length,productCount:products.length,count:suggestions.length+matchingCategories.length+products.length});_this.setState({suggestions:suggestionSections,total:totalResults});};_this.shouldRenderSuggestions=function(){var inputFocus=_this.state.inputFocus;return!(!_this.showRecentSearches&&!_this.showPopularSearches&&!_this.validCharacterLength()&&!inputFocus);};_this.renderCustomInputComponent=function(inputProps){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',Object.assign({},inputProps,{value:_this.state.value}));};_this.maybeGetPopularSearches=function(){var suggestionStore=_this.props.suggestionStore;if(_this.showPopularSearches&&!_this.popularSearches){suggestionStore.getPopularSearches().then(function(popularSearches){_this.popularSearches={title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].popularSearchesTitle),suggestions:popularSearches.map(function(keyword){return createSuggestion(keyword,keyword,function(){return _this.search(keyword);},{});})};_this.setState({popularSearches:_this.popularSearches});});}};_this.onSuggestionsFetchRequested=__WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function(_ref3){var value=_ref3.value;var _this$props4=_this.props,suggestionStore=_this$props4.suggestionStore,productListFilter=_this$props4.productListFilter;if(productListFilter||!_this.validCharacterLength()){return null;}suggestionStore.suggest(value,_this.suggestionCount).then(function(_ref4){var products=_ref4.products,suggestions=_ref4.suggestions,total=_ref4.total;_this.updateSuggestions(value,products,suggestions,total);_this.sendProductImpressions(products);}).catch(function(e){if(!__WEBPACK_IMPORTED_MODULE_14_axios___default.a.isCancel(e)){console.error(e);}});},300,{leading:false,trailing:true});_this.onSuggestionsClearRequested=function(){if(_this.doNotTriggerSearch){return;}_this.setState({inputFocus:false,suggestions:[]});};_this.sendProductClick=function(position,product){var analytics=_this.props.analytics;analytics.productClick(_this.listName,[{product:product,position:position}]);};_this.sendProductImpressions=function(products){var analytics=_this.props.analytics;var productList=products.map(function(product,index){return{product:product,position:index+1};});analytics.productImpressions(_this.listName,productList);};_this.addSearchToHistory=function(searchText){if(searchText.trim()===''){return;}if(_this.history.includes(searchText.trim())){return;}var isHistoryMaxed=_this.history.length===SEARCH_HISTORY_LIMIT;if(isHistoryMaxed){_this.history.pop();}_this.history.unshift(searchText);_this.saveHistoryToLocalStorage();_this.historyToSuggestions();};_this.clearSearch=function(){var productListFilter=_this.props.productListFilter;_this.clearNavigationBarSearch();productListFilter&&_this.clearProductListFilter();};_this.clearNavigationBarSearch=function(){var key=_this.state.key;_this.setState({key:key+1,suggestions:[],value:''});};_this.clearProductListFilter=function(){_this.props.clearProductListFilter('');_this.setState({value:''});};_this.onClickFunctions=function(){var _this$state=_this.state,value=_this$state.value,key=_this$state.key;_this.search(value);_this.addSearchToHistory(value);_this.setState({key:key+1});};_this.getFilterText=function(){var _this$props5=_this.props,productListFilter=_this$props5.productListFilter,onProductListFiltering=_this$props5.onProductListFiltering;return productListFilter&&onProductListFiltering(_this.state.value);};_this.getInitialSearchSuggestions=function(){var _this$state2=_this.state,searchHistory=_this$state2.searchHistory,popularSearches=_this$state2.popularSearches,inputFocus=_this$state2.inputFocus;if(!inputFocus){return[];}var suggestions=[];if(_this.showRecentSearches&&searchHistory&&searchHistory[0].suggestions.length){suggestions=suggestions.concat(searchHistory);}if(_this.showPopularSearches&&popularSearches&&popularSearches.suggestions.length){suggestions=suggestions.concat(popularSearches);}return suggestions;};_this.validCharacterLength=function(){var preValue=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var value=_this.state.value;if(preValue){return preValue.trim().length>TEXT_SEARCH_MIN_CHARACTERS;}return!!value&&value.trim().length>TEXT_SEARCH_MIN_CHARACTERS;};_this.getDeterminedSuggestions=function(){var productListFilter=_this.props.productListFilter;var _this$state3=_this.state,suggestions=_this$state3.suggestions,inputFocus=_this$state3.inputFocus;if(!inputFocus){return[];}var maybeInitialSuggestions=!productListFilter&&_this.getInitialSearchSuggestions();if(!_this.validCharacterLength()&&maybeInitialSuggestions.length){return maybeInitialSuggestions;}return!productListFilter?suggestions:[];};_this.getStoreTheme=function(){var configStore=_this.props.configStore;var themeSelection=configStore.layoutStoreThemeSelection;var isRounded=themeSelection===__WEBPACK_IMPORTED_MODULE_29__types_StoreThemeLayoutTypes__["a" /* default */].FULLY_ROUNDED_EDGES;var isBox=themeSelection===__WEBPACK_IMPORTED_MODULE_29__types_StoreThemeLayoutTypes__["a" /* default */].BOX;return{isRounded:isRounded,isBox:isBox};};_this.showRecentSearches=null;_this.showPopularSearches=null;_this.listName='Quick Search List';_this.suggestionCount=DEFAULT_SUGGESTED_PRODUCTS_VISIBLE;_this.history=null;_this.doNotTriggerSearch=null;_this.recentlyArrowNavigated=false;_this.popularSearches=null;_this.closeButtonElement=null;_this.searchButtonElement=null;_this.state={// TODO: Improve this anti-pattern. Props should not exist in state. Maybe suggestionstore?
value:_this.props.searchTerm||'',suggestions:[],total:0,searchHistory:[],inputFocus:false,containerOpen:false,key:0};return _this;}_createClass(QuickSearch,[{key:'componentDidMount',value:function componentDidMount(){var configStore=this.props.configStore;var advancedSearch=configStore.advancedSearch;this.showRecentSearches=advancedSearch.recentSearches;this.showPopularSearches=advancedSearch.popularSuggestions;/**
     * Attach event listeners to click events because onBlur event consumes them.
     * Having onBlur event handler with onClick-handlers, creates a race condition where onBlur event happens
     * just before onClick event resolves causing the event to be consumed.
     */this.registerEventListeners();this.maybeUpdateSearchValue();this.setSuggestionCount();this.removeNullsFromHistory();this.maybeGetPopularSearches();this.loadHistoryFromLocalStorage();if(this.checkHistoryArray){this.historyToSuggestions();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var suggestions=this.state.suggestions;// any change in search field
if(this.props.location.search!==prevProps.location.search){this.maybeUpdateSearchValue(prevProps.location.search);}if(prevState.suggestions.length!==suggestions.length){suggestions.length>0&&this.setState({containerOpen:true});suggestions.length===0&&this.setState({containerOpen:false});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.closeButtonElement){this.closeButtonElement.removeEventListener('touchend',this.handleCloseEvent);this.closeButtonElement.removeEventListener('mousedown',this.handleCloseEvent);}if(this.searchButtonElement){this.searchButtonElement.removeEventListener('touchend',this.handleSearchEvent);}}},{key:'setupCategorySearch',value:function setupCategorySearch(){var categoryStore=this.props.categoryStore;var tokenizer={tokenize:function tokenize(text){return text.split(/\s+/).filter(function(text){return text;}// Filter empty tokens
);}};this.categorySearch=new __WEBPACK_IMPORTED_MODULE_5_js_search__["Search"]('id');this.categorySearch.tokenizer=tokenizer;this.categorySearch.indexStrategy=new __WEBPACK_IMPORTED_MODULE_5_js_search__["AllSubstringsIndexStrategy"]();this.categorySearch.addIndex('name');this.categorySearch.addDocuments(categoryStore.flattenedCategories);}},{key:'getMatchingCategories',value:function getMatchingCategories(searchText){// Lazy load categorySearch
if(!this.categorySearch){this.setupCategorySearch();}return this.categorySearch.search(searchText).slice(0,3);}// Input searches to localstorage
},{key:'render',value:function render(){var _this2=this;var _state=this.state,value=_state.value,inputFocus=_state.inputFocus,key=_state.key;var _props=this.props,suggestionStore=_props.suggestionStore,productListFilter=_props.productListFilter,vehiclePartSearchEnabled=_props.vehiclePartSearchEnabled,placeholder=_props.placeholder,buttonText=_props.buttonText,buttonClassName=_props.buttonClassName,intl=_props.intl,quickSearchId=_props.quickSearchId;this.doNotTriggerSearch=false;var placeholderText=placeholder||intl.formatMessage(messages.searchProducts);var searchButtonText=buttonText||__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'search.search',defaultMessage:'Search'});var inputProps={placeholder:placeholderText,value:value,onChange:this.onChange,onKeyPress:this.handleKeyPress,onFocus:this.onFocus,onBlur:this.onBlur,className:'form-control',autoCapitalize:'none',maxLength:'80',type:'search',name:'search'};var determinedSuggestions=this.getDeterminedSuggestions();var ifProductListFilterValue=productListFilter&&value;var _getStoreTheme=this.getStoreTheme(),isRounded=_getStoreTheme.isRounded,isBox=_getStoreTheme.isBox;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* InputGroup */],{className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()('QuickSearch',{'QuickSearch--rounded':isRounded,'QuickSearch--box':isBox})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Autosuggest__["a" /* default */],{key:key,id:quickSearchId,suggestions:determinedSuggestions,onSuggestionsFetchRequested:this.onSuggestionsFetchRequested,onSuggestionsClearRequested:this.onSuggestionsClearRequested,getSuggestionValue:getSuggestionValue,renderSuggestion:renderSuggestion,inputProps:inputProps,onSuggestionSelected:this.onSuggestionSelected,shouldRenderSuggestions:this.shouldRenderSuggestions,focusInputOnSuggestionClick:false,multiSection:true,renderSectionTitle:renderSectionTitle,getSectionSuggestions:getSectionSuggestions,renderInputComponent:productListFilter&&this.renderCustomInputComponent}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'QuickSearch__group-addons'},!productListFilter&&suggestionStore.state===__WEBPACK_IMPORTED_MODULE_15__types_RequestState__["b" /* default */].LOADING&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'QuickSearch__spinner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__loader_Spinner__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'','aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].clearTitle),className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()('QuickSearch__clear',{'QuickSearch__clear--visible':value}),innerRef:function innerRef(ref){return _this2.closeButtonElement=ref;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'close'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:!productListFilter?'primary':'','aria-label':intl.formatMessage(messages.searchProducts),className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()('QuickSearch__filter-button',buttonClassName,{'QuickSearch__filter-button--active':ifProductListFilterValue,'QuickSearch__suggestion-container--loaded':!productListFilter&&inputFocus&&determinedSuggestions.length}),innerRef:function innerRef(ref){return _this2.searchButtonElement=ref;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'search'}),!vehiclePartSearchEnabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'QuickSearch__filter-button-text'},searchButtonText))));}}]);return QuickSearch;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;QuickSearch.propTypes={categoryStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_CategoryStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_25__store_ConfigStore__["a" /* default */]).isRequired,suggestionStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_SuggestionStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_26__store_UIStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_22__analytics_Analytics__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_18__services_RouteService__["a" /* default */]).isRequired,searchRedirectionStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_28__store_SearchRedirectionStore__["a" /* default */]).isRequired,locationContext:__WEBPACK_IMPORTED_MODULE_19__services_LocationContext__["a" /* LocationContextPropType */].isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,quickSearchId:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,handleBlur:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,handleFocus:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,toggleSearch:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,buttonClassName:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,searchTerm:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,productListFilter:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,vehiclePartSearchEnabled:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,clearProductListFilter:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,onProductListFiltering:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,buttonText:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node};QuickSearch.defaultProps={quickSearchId:'QuickSearch__Autosuggest'};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('categoryStore','configStore','searchRedirectionStore','suggestionStore','uiStore','analytics','routeService','locationContext')(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(QuickSearch))));

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AllSubstringsIndexStrategy = __webpack_require__(937);

Object.defineProperty(exports, 'AllSubstringsIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _AllSubstringsIndexStrategy.AllSubstringsIndexStrategy;
  }
});

var _ExactWordIndexStrategy = __webpack_require__(938);

Object.defineProperty(exports, 'ExactWordIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _ExactWordIndexStrategy.ExactWordIndexStrategy;
  }
});

var _PrefixIndexStrategy = __webpack_require__(939);

Object.defineProperty(exports, 'PrefixIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _PrefixIndexStrategy.PrefixIndexStrategy;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CaseSensitiveSanitizer = __webpack_require__(940);

Object.defineProperty(exports, 'CaseSensitiveSanitizer', {
  enumerable: true,
  get: function get() {
    return _CaseSensitiveSanitizer.CaseSensitiveSanitizer;
  }
});

var _LowerCaseSanitizer = __webpack_require__(941);

Object.defineProperty(exports, 'LowerCaseSanitizer', {
  enumerable: true,
  get: function get() {
    return _LowerCaseSanitizer.LowerCaseSanitizer;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(304),
    baseOrderBy = __webpack_require__(488),
    baseRest = __webpack_require__(489),
    isIterateeCall = __webpack_require__(150);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductPropertyElement__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_ProductPropertyType__ = __webpack_require__(156);
var ProductProperty=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductProperty',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),type:__WEBPACK_IMPORTED_MODULE_2__types_ProductPropertyType__["a" /* ProductPropertyTypeType */],placeholder:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),elements:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__ProductPropertyElement__["a" /* default */])}).views(function(self){return{getElementWithId:function getElementWithId(id){return self.elements.find(function(element){return element.id===id;});},isEmpty:function isEmpty(){return self.id===0;}};});/* harmony default export */ __webpack_exports__["a"] = (ProductProperty);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductPropertyElement=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductPropertyElement',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (ProductPropertyElement);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Review=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Review',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,reviews_rating:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,service_rating:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,customers_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,date_added:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({reviews_text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,admin_reply:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)})});/* harmony default export */ __webpack_exports__["a"] = (Review);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductSeason=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductSeason',{start_date:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,end_date:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string}).views(function(self){return{get startDate(){return self.start_date&&new Date(self.start_date);},get endDate(){return self.end_date&&new Date(self.end_date);},hasStarted:function hasStarted(){return!self.startDate||self.startDate<=Date.now();},hasEnded:function hasEnded(){return self.endDate&&self.endDate<Date.now();},isActive:function isActive(){return self.hasStarted()&&!self.hasEnded();}};});/* harmony default export */ __webpack_exports__["a"] = (ProductSeason);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ShippingSelectionFieldType__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShippingSelectionFieldOption__ = __webpack_require__(495);
var ShippingOptionSelectionField=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ShippingOptionSelectionField',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,type:__WEBPACK_IMPORTED_MODULE_1__types_ShippingSelectionFieldType__["a" /* ShippingSelectionFieldTypeType */],options:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__ShippingSelectionFieldOption__["a" /* default */]),[])});/* harmony default export */ __webpack_exports__["a"] = (ShippingOptionSelectionField);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdditionalServiceOption__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_AdditionalServiceType__ = __webpack_require__(978);
var AdditionalService=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('AdditionalService',{description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,enable_text_input:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,header_html:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,is_required:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,options:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__AdditionalServiceOption__["a" /* default */]),price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */],product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),requires_area_validation:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,selected_by_default:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,selection_text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,service_type:__WEBPACK_IMPORTED_MODULE_3__types_AdditionalServiceType__["a" /* AdditionalServiceTypeType */],text_input_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,text_max_length:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),text_required:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,valid_postal_code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean});/* harmony default export */ __webpack_exports__["a"] = (AdditionalService);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceOptionTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ServiceOptionType={RADIO:'RADIO',CHECKBOX:'CHECKBOX',DROPDOWN:'DROPDOWN'};/* harmony default export */ __webpack_exports__["b"] = (ServiceOptionType);var ServiceOptionTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ServiceOptionType',Object.values(ServiceOptionType));

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__ = __webpack_require__(100);
var RecurringOrderProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('RecurringOrderProduct',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,quantity_ordered:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,quantity_delivered:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,package_size:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),stock_unit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,starting_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),final_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,total_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,type:__WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__["a" /* ProductType */],reference:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),warranty_in_months:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),package_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),is_free_of_charge:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,variations:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),image_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),product_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),tax_rate:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),recurring_order_cycle_type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),recurring_order_custom_cycle:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)}).views(function(self){return{get isPhysicalProduct(){return self.type===__WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__["b" /* default */].PHYSICAL;},get sellInPackage(){return self.package_size&&self.package_size>0&&self.package_size!==1;},getQuantityStep:function getQuantityStep(product){return product&&self.sellInPackage?self.package_size:1;}};});/* harmony default export */ __webpack_exports__["a"] = (RecurringOrderProduct);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductReviewWidget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__review_Stars__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_ExternalReviewType__ = __webpack_require__(247);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductReviewWidget=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductReviewWidget,_Component);function ProductReviewWidget(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductReviewWidget);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductReviewWidget.__proto__||Object.getPrototypeOf(ProductReviewWidget)).call.apply(_ref,[this].concat(args))),_this),_this.getWitViewRating=function(){var product=_this.props.product;if(!product.external_reviews){return;}return product.external_reviews.find(function(_ref2){var type=_ref2.type;return type===__WEBPACK_IMPORTED_MODULE_9__types_ExternalReviewType__["a" /* default */].WITVIEW;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductReviewWidget,[{key:'render',value:function render(){var _props=this.props,product=_props.product,compact=_props.compact,configStore=_props.configStore,useWitViewRating=_props.useWitViewRating;if(!configStore.reviews.enabled){return null;}var amount=void 0;var reviewCount=void 0;var witViewRating=null;if(useWitViewRating){witViewRating=this.getWitViewRating();}if(useWitViewRating&&witViewRating){amount=witViewRating.reviews_average;reviewCount=witViewRating.reviews_count;}else{amount=product.reviews_average;reviewCount=product.reviews_count;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductReviewWidget'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__review_Stars__["a" /* default */],{amount:amount}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductReviewWidget__text'},compact?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].reviewCountCompact,{values:{count:reviewCount}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].reviewCount,{values:{count:reviewCount}}))));}}]);return ProductReviewWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductReviewWidget.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]),compact:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,product:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_Product__["a" /* default */]).isRequired,reserveSpace:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,useWitViewRating:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductReviewWidget));

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var READ_MORE_ACTIVATION_LENGTH=170;var ProductDescription=function(_Component){_inherits(ProductDescription,_Component);function ProductDescription(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductDescription);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductDescription.__proto__||Object.getPrototypeOf(ProductDescription)).call.apply(_ref,[this].concat(args))),_this),_this.getSeoShortDescription=function(){var _this$props=_this.props,product=_this$props.product,overflowHandler=_this$props.overflowHandler,isProductPage=_this$props.isProductPage;if(!product.seoDescription){return null;}var hasMoreContent=product.seoDescription.length>=READ_MORE_ACTIVATION_LENGTH;var description=hasMoreContent?product.seoDescription+'... ':product.seoDescription;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,description,hasMoreContent&&isProductPage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_ButtonLink__["a" /* default */],{className:'ProductPageContent__read-more-description-link',onClick:function onClick(){return overflowHandler();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].readMoreSentence)));},_this.getShortDescription=function(){var product=_this.props.product;return!!product.description_short?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:product.description_short}):null;},_this.getDangerouslyDescription=function(){var product=_this.props.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:product.suitability_description}});},_this.hasShortDescription=function(){var product=_this.props.product;return!!product.description_short&&product.description_short.length>0;},_this.getDescriptionContent=function(){var _this$props2=_this.props,configStore=_this$props2.configStore,isSuitability=_this$props2.isSuitability;if(isSuitability){return _this.getDangerouslyDescription();}return configStore.product.useSeoDescriptionForShort&&!_this.hasShortDescription()?_this.getSeoShortDescription():_this.getShortDescription();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductDescription,[{key:'render',value:function render(){var className=this.props.className;var content=this.getDescriptionContent();if(!content){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('ProductDescription',className)},content);}}]);return ProductDescription;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductDescription.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,overflowHandler:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isProductPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isSuitability:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};ProductDescription.defaultProps={isProductPage:false,isSuitability:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductDescription));

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LicensePlateInput=function(_Component){_inherits(LicensePlateInput,_Component);function LicensePlateInput(props){_classCallCheck(this,LicensePlateInput);var _this=_possibleConstructorReturn(this,(LicensePlateInput.__proto__||Object.getPrototypeOf(LicensePlateInput)).call(this,props));_this.form=null;_this.handleSubmit=function(event){event.preventDefault();_this.form.validate();if(_this.form.valid&&_this.props.handleOnSubmit){_this.props.handleOnSubmit(_this.state.licensePlateNumber);}if(_this.props.clearAfterSubmit){_this.setState({licensePlateNumber:''});}};_this.handleInput=function(event){return _this.setState({licensePlateNumber:event.target.value});};_this.state={licensePlateNumber:''};_this.form=Object(__WEBPACK_IMPORTED_MODULE_8__models_Form__["a" /* createForm */])({licensePlateNumber:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({})});return _this;}_createClass(LicensePlateInput,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var prevParams=prevProps&&prevProps.location&&Object(__WEBPACK_IMPORTED_MODULE_10__util_queryString__["b" /* parse */])(prevProps.location.search);var params=this.props&&this.props.location&&Object(__WEBPACK_IMPORTED_MODULE_10__util_queryString__["b" /* parse */])(this.props.location.search);if(prevParams&&this.props&&prevParams.id&&!params.id){this.setState({licensePlateNumber:''});}}},{key:'render',value:function render(){var _props=this.props,disabled=_props.disabled,overrideText=_props.overrideText,hideSearchButtonText=_props.hideSearchButtonText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* InputGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_Field__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Input */],field:this.form.fields.get('licensePlateNumber'),type:'text',name:'licensePlateNumber',id:'LicensePlateInput__licensePlateNumber',disabled:disabled,value:overrideText?overrideText:this.state.licensePlateNumber,onChange:this.handleInput,className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(['LicensePlateInput'],{'LicensePlateInput--disabled':!disabled}),placeholder:'ABC-123'}),!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Icon__["a" /* default */],{name:'search'}),!hideSearchButtonText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'LicensePlateInput__button-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'search.search',defaultMessage:'Search'}))))));}}]);return LicensePlateInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LicensePlateInput.propTypes={location:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.location,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,handleOnSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,overrideText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,clearAfterSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hideSearchButtonText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (LicensePlateInput);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEOSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEOSchema=function(_Component){_inherits(SEOSchema,_Component);function SEOSchema(){_classCallCheck(this,SEOSchema);return _possibleConstructorReturn(this,(SEOSchema.__proto__||Object.getPrototypeOf(SEOSchema)).apply(this,arguments));}_createClass(SEOSchema,[{key:'render',value:function render(){var data=this.props.data;var schema=JSON.stringify(data);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',{type:'application/ld+json'},schema));}}]);return SEOSchema;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SEOSchema.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SEOSchema);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImageLightbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_lightbox__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_image_lightbox_style_css__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_image_lightbox_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_image_lightbox_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Z-index above sticky navigation.
var LIGHTBOX_Z_INDEX='1040';var LIGHTBOX_SETTINGS={reactModalStyle:{overlay:{zIndex:LIGHTBOX_Z_INDEX},content:{backgroundColor:'rgba(255, 255, 255, 1)',background:'#fff'}}};var ImageLightbox=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ImageLightbox,_Component);function ImageLightbox(props){_classCallCheck(this,ImageLightbox);var _this=_possibleConstructorReturn(this,(ImageLightbox.__proto__||Object.getPrototypeOf(ImageLightbox)).call(this,props));_this.getImageSrc=function(target){var images=_this.props.images;var targetImage=images.filter(function(image,index){return index===target;});return targetImage[0].sizes.full||targetImage[0].sizes.xlarge||targetImage[0].sizes.large;};_this.getSettings=function(){var images=_this.props.images;var options=Object.assign({},LIGHTBOX_SETTINGS);if(images.length>1){options.prevSrc=_this.getImageSrc(_this.getPreviousIndex());options.nextSrc=_this.getImageSrc(_this.getNextIndex());}options.mainSrc=_this.getImageSrc(_this.state.currentImageIndex);options.imageLoadErrorMessage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'global.imageLoadFailed',defaultMessage:'Image failed to load'});return options;};_this.getPreviousIndex=function(){var currentImageIndex=_this.state.currentImageIndex;var images=_this.props.images;return(currentImageIndex+images.length-1)%images.length;};_this.getNextIndex=function(){var currentImageIndex=_this.state.currentImageIndex;var images=_this.props.images;return(currentImageIndex+1)%images.length;};_this.toPrevIndex=function(){_this.setState({currentImageIndex:_this.getPreviousIndex()});};_this.toNextIndex=function(){_this.setState({currentImageIndex:_this.getNextIndex()});};_this.state={currentImageIndex:null};return _this;}_createClass(ImageLightbox,[{key:'componentDidMount',value:function componentDidMount(){this.setState({currentImageIndex:this.props.mainImageIndex});}},{key:'render',value:function render(){if(this.state.currentImageIndex===null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ImageLightbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_image_lightbox__["a" /* default */],Object.assign({onCloseRequest:this.props.onClick,onMovePrevRequest:this.toPrevIndex,onMoveNextRequest:this.toNextIndex},this.getSettings())));}}]);return ImageLightbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ImageLightbox.propTypes={mainImageIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,images:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ProductImage__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ProductImage__["a" /* default */]))])};/* harmony default export */ __webpack_exports__["a"] = (ImageLightbox);

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(1006);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMSTPatch;
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function effectiveTypeOf(node){var type=typeof node==='undefined'?'undefined':_typeof(node);if(type!=='object'){return type;}if(node===null){return'null';}if(node instanceof Array){return'array';}return'object';}function createLeafNodeOperation(op,path,value){var operation={op:op,path:path.join('/')};if(value!==undefined){operation.value=value;}return[operation];}function createMSTPatch(mstNode,newValue){var parentType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'root';var commonPath=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];// If the node doesn't have a toJSON method, it is not a MobX node, but a primitive node instead.
var mstNodeJson=mstNode&&mstNode.toJSON?mstNode.toJSON():mstNode;// Short circuit equal primitives right away.
if(mstNodeJson===newValue){return[];}var mstNodeType=effectiveTypeOf(mstNodeJson);var newValueType=effectiveTypeOf(newValue);if(mstNodeType!==newValueType){if(parentType==='object'&&newValueType==='undefined'){// In MST, an object doesn't support the "remove" operation; it would make no sense for an instance of a model
// to lose any of its fields, anyway. If a field is not present in the new object, it means that that value
// should just not be changed in our case.
// (This deviation is what prevents us from using a generic JSON patch library!)
return[];}else if(parentType==='array'&&mstNodeType==='undefined'){return createLeafNodeOperation('add',commonPath,newValue);}else if(parentType==='array'&&newValueType==='undefined'){return createLeafNodeOperation('remove',commonPath);}else{return createLeafNodeOperation('replace',commonPath,newValue);}}if(mstNodeType==='array'){var longerArrayLength=Math.max(mstNode.length,newValue.length);var mstNodeLength=mstNode.length;var operations=[];for(var i=0;i<longerArrayLength;i++){// Check against array length to avoid MST throwing out of bounds access warnings.
operations.unshift.apply(operations,_toConsumableArray(createMSTPatch(mstNodeLength>i?mstNode[i]:undefined,newValue[i],mstNodeType,commonPath.concat([i]))));}return operations;}if(mstNodeType==='object'){var _operations=[];// Only check the model's properties; the model doesn't care about the fields it has not been told to handle,
// so adding them in the patch is pointless
Object.getOwnPropertyNames(mstNodeJson).forEach(function(property){_operations.unshift.apply(_operations,_toConsumableArray(createMSTPatch(mstNode[property],newValue[property],mstNodeType,commonPath.concat([property]))));});return _operations;}// number -> number, string -> string, boolean -> boolean, (function -> function, symbol -> symbol)
// Undefined and null only have one possible value so they don't end up here ever.
return createLeafNodeOperation('replace',commonPath,newValue);}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductWarranty=function(_Component){_inherits(ProductWarranty,_Component);function ProductWarranty(){_classCallCheck(this,ProductWarranty);return _possibleConstructorReturn(this,(ProductWarranty.__proto__||Object.getPrototypeOf(ProductWarranty)).apply(this,arguments));}_createClass(ProductWarranty,[{key:'render',value:function render(){var warranty=this.props.warranty;var duration=__WEBPACK_IMPORTED_MODULE_2_luxon__["Duration"].fromObject({months:warranty}).shiftTo('years','months');var formattedYears=duration.years?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].formattedYears,{values:{years:duration.years}})):'';var formattedMonths=duration.months?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].formattedMonths,{values:{months:duration.months}})):'';var formattedWarranty=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductWarranty__warranty'},formattedYears,' ',formattedMonths);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductWarranty'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].warrantyLabel,{values:{warranty:formattedWarranty}})));}}]);return ProductWarranty;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductWarranty.propTypes={warranty:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductWarranty);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductFeatureImages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_groupBy__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductFeatureImage__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductFeatureImages=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductFeatureImages,_Component);function ProductFeatureImages(props){_classCallCheck(this,ProductFeatureImages);var _this=_possibleConstructorReturn(this,(ProductFeatureImages.__proto__||Object.getPrototypeOf(ProductFeatureImages)).call(this,props));_this.maybeLoadFeatureImages=function(){var product=_this.props.product;if(product.propertyImagesState===__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].NONE){product.loadPropertyImages();}};_this.getFeatureImageContainers=function(featureImages){return __WEBPACK_IMPORTED_MODULE_0_lodash_groupBy___default()(featureImages,'position');};_this.productListLabelFilter=function(label){return label.show_on_product_listings&&label.placement==='product_image';};_this.productCardLabelFilter=function(label){return label.show_on_product_card&&label.placement==='product_image';};_this.maybeLoadFeatureImages();return _this;}_createClass(ProductFeatureImages,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.maybeLoadFeatureImages();}},{key:'render',value:function render(){var _props=this.props,product=_props.product,productListView=_props.productListView,position=_props.position;if(!product.labels||!product.labels.length){return null;}if(position==='product_image'){var labelFilter=productListView?this.productListLabelFilter:this.productCardLabelFilter;var propertyImages=product.labels.filter(labelFilter);var featureImages=this.getFeatureImageContainers(propertyImages);var top_element=null;if(featureImages.top_left||featureImages.top_right){top_element=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFeatureImages__wrapper top'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFeatureImages__container top-left'},featureImages.top_left?featureImages.top_left.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductFeatureImage__["a" /* default */],Object.assign({key:index},image));}):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFeatureImages__container top-right'},featureImages.top_right?featureImages.top_right.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductFeatureImage__["a" /* default */],Object.assign({key:index},image));}):null));}var bottom_element=null;if(featureImages.bottom_left||featureImages.bottom_right){bottom_element=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFeatureImages__wrapper bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFeatureImages__container bottom-left'},featureImages.bottom_left?featureImages.bottom_left.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductFeatureImage__["a" /* default */],Object.assign({key:index},image));}):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFeatureImages__container bottom-right'},featureImages.bottom_right?featureImages.bottom_right.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductFeatureImage__["a" /* default */],Object.assign({key:index},image));}):null));}return top_element||bottom_element?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,top_element,bottom_element):null;}else{var _propertyImages=product.labels.filter(function(image){return image.placement==='product_properties'&&image.show_on_product_card;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFeatureImages__container properties'},_propertyImages.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductFeatureImage__["a" /* default */],Object.assign({key:index},image));}));}}}]);return ProductFeatureImages;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductFeatureImages.propTypes={// Both Products and ChildProducts are allowed.
product:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,position:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,productListView:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore')(ProductFeatureImages));

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PriceSecondary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PriceWrapper__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductPagePrice__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Product__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PriceSecondary=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PriceSecondary,_Component);function PriceSecondary(){_classCallCheck(this,PriceSecondary);return _possibleConstructorReturn(this,(PriceSecondary.__proto__||Object.getPrototypeOf(PriceSecondary)).apply(this,arguments));}_createClass(PriceSecondary,[{key:'render',value:function render(){var _props=this.props,accountStore=_props.accountStore,configStore=_props.configStore,product=_props.product,isProductCard=_props.isProductCard,isMultiProductPicker=_props.isMultiProductPicker,className=_props.className;if(!configStore.product.showSecondaryTaxPrice&&!accountStore.isRetailer){return null;}var cssClasses=__WEBPACK_IMPORTED_MODULE_3_classnames___default()('PriceSecondary',className,{'PriceSecondary--isMultiProductPicker':isMultiProductPicker});var secondaryPriceWrapper=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PriceWrapper__["a" /* default */],{product:product,withTax:!accountStore.showPricesWithTax,isSecondaryPrice:true,isMultiProductPicker:isMultiProductPicker});var secondaryProductPagePrice=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ProductPagePrice__["a" /* default */],{price:secondaryPriceWrapper,product:product,withTax:!accountStore.showPricesWithTax,isSecondaryPrice:true});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClasses},isProductCard?secondaryPriceWrapper:secondaryProductPagePrice);}}]);return PriceSecondary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PriceSecondary.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_Product__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]).isRequired,isMultiProductPicker:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isProductCard:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','configStore')(PriceSecondary));

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductReserveInStoreButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ReserveInStoreStore__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_StorageStore__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Storage__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductReserveInStoreButton=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductReserveInStoreButton,_Component);function ProductReserveInStoreButton(props){_classCallCheck(this,ProductReserveInStoreButton);var _this=_possibleConstructorReturn(this,(ProductReserveInStoreButton.__proto__||Object.getPrototypeOf(ProductReserveInStoreButton)).call(this,props));_this.toggleModal=function(){var _this$props=_this.props,reserveInStoreStore=_this$props.reserveInStoreStore,storage=_this$props.storage,product=_this$props.product,activeProductId=_this$props.activeProductId;var modal=reserveInStoreStore.modal;modal.toggle();modal.setProduct(product.id,activeProductId);if(storage){modal.setStorage(storage);}};_this.productInStock=function(){var _this$props2=_this.props,storageStore=_this$props2.storageStore,storage=_this$props2.storage,product=_this$props2.product,activeProductId=_this$props2.activeProductId;var pickupStorageIds=storage?[storage.id]:storageStore.pickupStorages.map(function(storage){return storage.id;});var stocks=product.stocks.get(activeProductId);if(!stocks){return false;}return stocks.some(function(stock){return stock.real_stock>0&&pickupStorageIds.includes(stock.storage_id);});};_this.setButtonElement=function(ref){_this.buttonElement=ref;_this.setState({buttonMounted:true});};_this.buttonElement=null;_this.state={buttonMounted:false};return _this;}_createClass(ProductReserveInStoreButton,[{key:'render',value:function render(){var _props=this.props,product=_props.product,configStore=_props.configStore,activeProductId=_props.activeProductId,storage=_props.storage,shouldHideButton=_props.shouldHideButton;if(!product||product.isBlockedFromStoreReservation(configStore.reserveInStore.excludePropertyId)){return null;}var productSelected=!!activeProductId;var stockLoaded=!!product.stocks.get(activeProductId);var inStock=stockLoaded&&this.productInStock();if(!(productSelected&&stockLoaded&&inStock)&&shouldHideButton){return null;}var selectProductMessage=productSelected?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.selectChildProductHint',defaultMessage:'First choose the product. After this you can reserve this product from a store.'});var loadingMessage=stockLoaded?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.stockLoadingHint',defaultMessage:'Please wait, loading in-store availability...'});var outOfStockMessage=null;if(!inStock){outOfStockMessage=storage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.outOfStockSingleStoreHint',defaultMessage:'This store doesn\'t currently have this product in stock.'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.outOfStockMultipleStoresHint',defaultMessage:'No pick-up stores currently have this product in stock.'});}var tooltipMessage=selectProductMessage||loadingMessage||outOfStockMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',onClick:this.toggleModal,disabled:!(productSelected&&stockLoaded&&inStock),innerRef:this.setButtonElement,className:'ProductReserveInStoreButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.button',defaultMessage:'Reserve in store'})),tooltipMessage&&this.state.buttonMounted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["V" /* UncontrolledTooltip */],{placement:'top',target:this.buttonElement},tooltipMessage));}}]);return ProductReserveInStoreButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductReserveInStoreButton.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Product__["a" /* default */]).isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,storage:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_Storage__["a" /* default */]),reserveInStoreStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ReserveInStoreStore__["a" /* default */]).isRequired,storageStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_StorageStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,shouldHideButton:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('reserveInStoreStore','storageStore','configStore')(ProductReserveInStoreButton));

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_ReserveInStoreService__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_ReserveInStoreModal__ = __webpack_require__(1040);
var ReserveInStoreStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named('ReserveInStoreStore').props({services:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__models_ReserveInStoreService__["a" /* default */]),[]),modal:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_5__models_ReserveInStoreModal__["a" /* default */],{})}).actions(function(self){return{makeSureServicesLoaded:function makeSureServicesLoaded(){if(self.state===__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].NONE){return self.loadServices();}return Promise.resolve();},loadServices:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadServices(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadServices$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('reserve-in-store/services');case 4:self.services=_context.sent;_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 11:self.setLoading(false);case 12:case'end':return _context.stop();}}},loadServices,this,[[1,7]]);}))};}).views(function(self){return{findServiceById:function findServiceById(serviceId){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["k" /* resolveIdentifier */])(__WEBPACK_IMPORTED_MODULE_4__models_ReserveInStoreService__["a" /* default */],self.services,serviceId);}};});/* harmony default export */ __webpack_exports__["a"] = (ReserveInStoreStore);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_head__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductLink__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductReviewWidget__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_ImagePreload__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ProductCardProperties__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProductImageSigns__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_ProductPropertyType__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ProductId__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ProductCardPropertiesStatic__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__product_enquiry_ProductEnquiry__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__types_ProductEnquiryType__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ProductPackageSize__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PriceWrapper__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ProductSingularPrice__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ProductFeatureImages__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__types_ProductLabelType__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__PriceSecondary__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__types_ExternalReviewType__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__shopping_center_ShoppingCenterProductMerchantInfo__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ProductDescription__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ProductDeposit__ = __webpack_require__(527);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductCollectionPropertyTypeHeights=new Map().set(__WEBPACK_IMPORTED_MODULE_17__types_ProductPropertyType__["b" /* default */].COLOR,60).set(__WEBPACK_IMPORTED_MODULE_17__types_ProductPropertyType__["b" /* default */].OTHER,35).set(__WEBPACK_IMPORTED_MODULE_17__types_ProductPropertyType__["b" /* default */].SIZE,35);var ProductCard=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductCard,_Component);function ProductCard(props){_classCallCheck(this,ProductCard);var _this=_possibleConstructorReturn(this,(ProductCard.__proto__||Object.getPrototypeOf(ProductCard)).call(this,props));_this.onEventStart=function(){_this.enableSecondaryImage();// mobile uses static properties
if(!_this.props.uiStore.isMobile){_this.enableProperties();}};_this.onEventEnd=function(){_this.disableSecondaryImage();if(!_this.props.uiStore.isMobile){_this.disableProperties();}};_this.enableSecondaryImage=function(){if(!_this.state.secondaryImageActive){_this.setState({secondaryImageActive:true});}};_this.disableSecondaryImage=function(){if(_this.state.secondaryImageActive){_this.setState({secondaryImageActive:false,selectedElementId:null});}};_this.enableProperties=function(){if(!_this.state.hoverProperties){_this.setState({hoverProperties:true});}};_this.disableProperties=function(){if(_this.state.hoverProperties){_this.setState({hoverProperties:false,selectedElementId:null});}};_this.handleProductClick=function(){var _this$props=_this.props,analytics=_this$props.analytics,position=_this$props.position,listName=_this$props.listName,product=_this$props.product;analytics.productClick(listName,[{product:product,position:position}]);};_this.onSecondaryImagePreload=function(){_this.setState({secondaryImageLoaded:true});};_this.onFirstCollectionElementHovered=function(hoveredElementId){_this.setState({selectedElementId:hoveredElementId});};_this.productCollectionTotalHeight=function(){var height=0;var collection=_this.props.product.collection;if(collection&&collection.column&&collection.column.id!==0&&collection.column.elements.length>0&&collection.column.elements[0].id!==0){height+=ProductCollectionPropertyTypeHeights.get(collection.column.type);}if(collection&&collection.row&&collection.row.id!==0&&collection.row.elements.length>0&&collection.row.elements[0].id!==0){height+=ProductCollectionPropertyTypeHeights.get(collection.row.type);}return height;};_this.isColumnCollectionElementId=function(product,elementId){return product.collection.column.elements.some(function(el){return el.id===elementId;});};_this.getMobileProperties=function(){var product=_this.props.product;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ProductCardPropertiesStatic__["a" /* default */],{product:product});};_this.getAvailability=function(showProperties){var product=_this.props.product;var availability=product.listingAvailability;if(availability.length===0||product.class===__WEBPACK_IMPORTED_MODULE_16__types_ProductClass__["b" /* default */].COLLECTION&&showProperties){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:availability}});};_this.getLabelsBelowTitle=function(){var product=_this.props.product;var textLabels=product.labels.filter(function(label){return label.show_on_product_listings&&label.placement==='product_properties'&&label.display_style!==__WEBPACK_IMPORTED_MODULE_31__types_ProductLabelType__["a" /* default */].IMAGE;});var imageLabels=product.labels.filter(function(label){return label.show_on_product_listings&&label.placement==='product_properties'&&label.display_style===__WEBPACK_IMPORTED_MODULE_31__types_ProductLabelType__["a" /* default */].IMAGE;});if(textLabels.length===0&&imageLabels.length===0){return null;}var imageLabelHtml=null;if(imageLabels.length>0){imageLabelHtml=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__LabelImageContainer'},imageLabels.map(function(label,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{alt:'',key:index,className:'ProductCard__LabelImage',src:label.image,loading:'lazy'});}));}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,imageLabelHtml&&imageLabelHtml,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'ProductCard__LabelList'},textLabels.map(function(labelObject,index){var label=labelObject.label;var label_text=label?label.label_text:null;var label_value=label?label.label_value:null;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:index,className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ProductCard__LabelListItem',{'ProductCard__LabelListItem--withImage':labelObject.image})},labelObject.image&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{alt:'',className:'ProductCard__LabelImage',src:labelObject.image,loading:'lazy'}),label_text&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',{className:'ProductLabel__propertyName'},label.label_text),label_value&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'ProductLabel__propertyValue'},': ',label_value));})));};_this.getWitViewRating=function(){var product=_this.props.product;if(!product.external_reviews){return;}return product.external_reviews.find(function(_ref){var type=_ref.type;return type===__WEBPACK_IMPORTED_MODULE_33__types_ExternalReviewType__["a" /* default */].WITVIEW;});};_this.shouldUseWitViewRating=function(){var configStore=_this.props.configStore;if(configStore.witView.enabled){var witViewRating=_this.getWitViewRating();if(witViewRating&&witViewRating.reviews_count===0){return false;}return true;}return false;};_this.getProductQuantity=function(quantity){_this.setState({quantity:quantity});};_this.getProductManufacturerId=function(){var product=_this.props.product;var manufacturer=product.manufacturer;return product&&manufacturer&&manufacturer.id;};_this.renderShoppingCenterProductMerchantInfo=function(){var product=_this.props.product;var merchantInfo=product.merchantInfo;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__shopping_center_ShoppingCenterProductMerchantInfo__["a" /* default */],{merchantInfo:merchantInfo});};_this.ifShowModel=function(){var _this$props2=_this.props,configStore=_this$props2.configStore,product=_this$props2.product;if(product.class===__WEBPACK_IMPORTED_MODULE_16__types_ProductClass__["b" /* default */].MULTI){return configStore.productPage.showModelName&&configStore.product.showModel;}return configStore.product.showModel;};_this.renderProductInformation=function(){var _this$props3=_this.props,configStore=_this$props3.configStore,product=_this$props3.product;var hasContent=false;if(configStore.productCard.showProductCode){hasContent=true;}if(configStore.productCard.showEanCode&&product.ean){hasContent=true;}if(configStore.productCard.showExtraId&&product.extra_id){hasContent=true;}if(configStore.productCard.showManufacturersCode&&product.manufacturer_product_id){hasContent=true;}if(!hasContent){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__information'},configStore.productCard.showProductCode&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'ProductCard__productId'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ProductId__["a" /* default */],{id:product.id})),configStore.productCard.showEanCode&&product.ean&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_23__i18n_globalTranslations__["a" /* default */].eanLabel,{values:{manufacturerCode:product.manufacturer_product_id}})),configStore.productCard.showExtraId&&product.extra_id&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_23__i18n_globalTranslations__["a" /* default */].extraIdLabel,{values:{extraId:product.extra_id}})),configStore.productCard.showManufacturersCode&&product.manufacturer_product_id&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_23__i18n_globalTranslations__["a" /* default */].manufacturerCodeLabel,{values:{manufacturerCode:product.manufacturer_product_id}})));};_this.state={secondaryImageActive:false,secondaryImageLoaded:false,selectedElementId:null,hoverProperties:false,quantity:1};return _this;}_createClass(ProductCard,[{key:'render',value:function render(){var _this2=this;var _props=this.props,product=_props.product,configStore=_props.configStore,large=_props.large,hideDescription=_props.hideDescription,hidePrice=_props.hidePrice,hideProperties=_props.hideProperties,target=_props.target,modelMargin=_props.modelMargin,uiStore=_props.uiStore,accountStore=_props.accountStore,hideQuantity=_props.hideQuantity,hideAddToCartButton=_props.hideAddToCartButton,showAsSold=_props.showAsSold,disableLinks=_props.disableLinks,productListView=_props.productListView,productParams=_props.productParams,requireCanonicalLink=_props.requireCanonicalLink;var _state=this.state,secondaryImageActive=_state.secondaryImageActive,selectedElementId=_state.selectedElementId,secondaryImageLoaded=_state.secondaryImageLoaded;var doHideDescription=hideDescription||!configStore.productCard.showDescription||accountStore.isViewOnly;var doHidePrice=product.isProposalType(product.id,configStore.product.enquireForProposal)||hidePrice||accountStore.isViewOnly;var doHideProperties=hideProperties||accountStore.isViewOnly;var doHideReviews=accountStore.isViewOnly;var hideAddToCart=hideAddToCartButton||product.has_required_services||!configStore.productCard.showAddToCart;var productImage=selectedElementId?product.images.find(function(i){return i.for_color_id===selectedElementId;})||__WEBPACK_IMPORTED_MODULE_0_lodash_head___default()(product.images):__WEBPACK_IMPORTED_MODULE_0_lodash_head___default()(product.images);var secondaryImage=__WEBPACK_IMPORTED_MODULE_1_lodash_size___default()(product.images)>1&&!(product.class===__WEBPACK_IMPORTED_MODULE_16__types_ProductClass__["b" /* default */].COLLECTION&&!!product.images.find(function(i){return i.for_color_id!==null;}))?product.images[1]:null;var imageSize=large?'large':'medium';var secondaryImagePreload='';var productLinkParams={};// If first collection element is selected, link will contain this selection as parameter
if(selectedElementId){if(this.isColumnCollectionElementId(product,selectedElementId)){productLinkParams={columnId:selectedElementId};}else{productLinkParams={rowId:selectedElementId};}}productLinkParams=Object.assign({},productLinkParams,productParams);/* This is used to load secondary image when user hovers over image. Secondary image is shown when it is loaded (see below) */if(secondaryImage&&secondaryImageActive){secondaryImagePreload=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_ImagePreload__["a" /* default */],{src:secondaryImage.sizes['medium'],onImageLoad:this.onSecondaryImagePreload});}var showProperties=!doHideProperties&&configStore.productCard.showProperties;var propertiesHeight=showProperties?this.productCollectionTotalHeight():0;var depositInPrice=configStore.productPage.depositInPrice&&product.bottle_deposit&&product.bottle_deposit.with_tax>0;var price=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__PriceWrapper__["a" /* default */],{product:product,depositInPrice:depositInPrice});if(price&&!hidePrice){doHidePrice=false;}var productTitle=product.multiproduct_title||product.name;var quantityAllowed=accountStore.isRetailer||configStore.productCard.showQuantitySelection;var renderProductImage=function renderProductImage(){var _props2=_this2.props,lazyLoading=_props2.lazyLoading,productImageSettings=_props2.productImageSettings;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ProductCard__images-wrapper')},secondaryImagePreload,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ProductImage__["a" /* default */],Object.assign({product:product,size:imageSize,productImage:productImage,lazyLoading:lazyLoading},productImageSettings)),secondaryImage&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ProductCard__secondary-image-wrapper',{'ProductCard__secondary-image-wrapper--image-loaded':secondaryImageLoaded,'ProductCard__secondary-image-wrapper--image-touched':secondaryImageLoaded&&secondaryImageActive}),onMouseOver:_this2.onEventStart,onTouchStart:_this2.onEventStart,onMouseLeave:_this2.onEventEnd,onTouchEnd:_this2.onEventEnd},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ProductImage__["a" /* default */],Object.assign({product:product,size:imageSize,productImage:secondaryImage,lazyLoading:lazyLoading},productImageSettings))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__data-over-image'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__ProductFeatureImages__["a" /* default */],{productListView:productListView,product:product,position:'product_image'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProductImageSigns__["a" /* default */],{product:product})));};var renderProductTitleAndModel=function renderProductTitleAndModel(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,productTitle),_this2.ifShowModel()&&product.model&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ProductCard__model',{'ProductCard__model-margin':!!modelMargin})},product.model));};var useWitViewRating=this.shouldUseWitViewRating();var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifWebStore=configStore.siteConfig.isWebStore;var merchantInfo=product.merchantInfo;var ifBuyingAllowed=merchantInfo&&merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed){doHidePrice=true;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('article',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ProductCard',this.getProductManufacturerId())},!disableLinks?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ProductLink__["a" /* default */],{product:product,target:target,onClick:this.handleProductClick,params:productParams,requireCanonical:requireCanonicalLink},renderProductImage()):renderProductImage(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ProductCard__product-data-wrapper',_defineProperty({},'ProductCard__product-data-wrapper--margin-top-'+propertiesHeight,showProperties&&!uiStore.isMobile))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__manufacturer'},product.manufacturer&&product.manufacturer.name,'\xA0'),!disableLinks?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ProductLink__["a" /* default */],{product:product,params:productLinkParams,onClick:this.handleProductClick,target:target,requireCanonical:requireCanonicalLink},renderProductTitleAndModel()):renderProductTitleAndModel(),!doHideDescription&&configStore.product.shortDescriptionTop&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__ProductDescription__["a" /* default */],{className:'ProductCardDescription',product:product,overflowHandler:this.handleProductClick}),this.getLabelsBelowTitle(),this.renderProductInformation(),!uiStore.isMobile&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__properties'},showProperties&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ProductCardProperties__["a" /* default */],{product:product,onFirstCollectionElementHovered:this.onFirstCollectionElementHovered,selectedElementId:selectedElementId})),!doHideReviews&&!configStore.siteConfig.isShoppingCenter&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ProductReviewWidget__["a" /* default */],{product:product,useWitViewRating:useWitViewRating,compact:true}),!doHidePrice&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ProductCard__price-and-cart',{'ProductCard__price-and-cart-with-quantity':quantityAllowed})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__price-and-availability'},!doHidePrice&&price,!doHidePrice&&product&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__ProductDeposit__["a" /* default */],{product:product,showPrice:!configStore.productPage.depositInPrice}),!doHidePrice&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__PriceSecondary__["a" /* default */],{product:product,isProductCard:true}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__ProductSingularPrice__["a" /* default */],{product:product,hideSingular:!configStore.productCard.showSingularPrice}),configStore.siteConfig.isWebStore&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__availability'},this.getAvailability(showProperties))),quantityAllowed&&product.sellInPackage&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__ProductPackageSize__["a" /* default */],{product:product}),!accountStore.isViewOnly&&!hideAddToCart&&!hideAddToCartButton&&product.class===__WEBPACK_IMPORTED_MODULE_16__types_ProductClass__["b" /* default */].SINGLE&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__["b" /* default */],{product:product,addToCartProduct:product,activeProductId:product.id,hideQuantity:hideQuantity,quantity:this.state.quantity,productListView:true,simple:true,onUpdateProductQuantity:this.getProductQuantity,ifWebStore:ifWebStore})),showAsSold&&doHidePrice&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'ProductCard__sold-out'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.sold',defaultMessage:'Sold'})),doHidePrice&&product.isProposalType(product.id,configStore.product.enquireForProposal)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__product_enquiry_ProductEnquiry__["a" /* default */],{id:product.id,type:__WEBPACK_IMPORTED_MODULE_26__types_ProductEnquiryType__["a" /* default */].PROPOSAL_REQUEST}),!doHideDescription&&configStore.product.shortDescriptionBottom&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__ProductDescription__["a" /* default */],{className:'ProductCardDescription',product:product,overflowHandler:this.handleProductClick}),showProperties&&uiStore.isMobile&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__properties--static'},this.getMobileProperties()),product.suitability_description&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCard__suitability-description'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__ProductDescription__["a" /* default */],{className:'ProductCardDescription',product:product,isSuitability:true})),this.renderShoppingCenterProductMerchantInfo()));}}]);return ProductCard;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;ProductCard.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]).isRequired,listName:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,position:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,large:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_UIStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_12__analytics_Analytics__["a" /* default */]).isRequired,hidePrice:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,hideDescription:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,hideProperties:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,hideQuantity:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,hideAddToCartButton:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,modelMargin:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,target:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,showAsSold:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,disableLinks:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,productImageSettings:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,accountStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__store_AccountStore__["a" /* default */]).isRequired,productListView:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,// Card is used in product list
requireCanonicalLink:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,lazyLoading:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool};ProductCard.defaultProps={hideQuantity:false,requireCanonicalLink:false,lazyLoading:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('analytics','configStore','uiStore','accountStore')(ProductCard));

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(426),
    getTag = __webpack_require__(179),
    isArrayLike = __webpack_require__(125),
    isString = __webpack_require__(418),
    stringSize = __webpack_require__(1045);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_ProductClass__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductLink=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductLink,_Component);function ProductLink(){_classCallCheck(this,ProductLink);return _possibleConstructorReturn(this,(ProductLink.__proto__||Object.getPrototypeOf(ProductLink)).apply(this,arguments));}_createClass(ProductLink,[{key:'render',value:function render(){var _props=this.props,product=_props.product,requireCanonical=_props.requireCanonical,params=_props.params,children=_props.children,routeService=_props.routeService,rest=_objectWithoutProperties(_props,['product','requireCanonical','params','children','routeService']);var path=product.class===__WEBPACK_IMPORTED_MODULE_8__types_ProductClass__["b" /* default */].MULTI_CHILD?product.pathWithActiveProductId(product.id):product.path;var pathToNavigate=requireCanonical?routeService.getCanonicalProductPath(product):routeService.getProductPath(product,Object(__WEBPACK_IMPORTED_MODULE_4__util_queryString__["a" /* addParametersToPath */])(path,params));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],Object.assign({className:'ProductLink',to:pathToNavigate},rest),children||product.name);}}]);return ProductLink;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductLink.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Product__["a" /* default */]).isRequired,requireCanonical:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,params:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({columnId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,rowId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('routeService')(ProductLink));

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(435),
    baseFilter = __webpack_require__(1051),
    baseIteratee = __webpack_require__(84),
    isArray = __webpack_require__(47);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RadioField=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RadioField,_Component);function RadioField(props){_classCallCheck(this,RadioField);// In the normal use cases, the form and field names don't change, and
// this only really affects the input/label binding, so not updating the id
// afterwards if props change should still be fine.
var _this=_possibleConstructorReturn(this,(RadioField.__proto__||Object.getPrototypeOf(RadioField)).call(this,props));_this.getTooltip=function(text){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Icon__["a" /* default */],{name:'info',className:'tooltip-'+_this.id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["V" /* UncontrolledTooltip */],{target:'.tooltip-'+_this.id},text));};_this.createUniqueKey=function(option,index){return __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(option+'--'+index);};_this.id=__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(props.formName+'__'+props.fieldName+'--');return _this;}_createClass(RadioField,[{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,fieldName=_props.fieldName,field=_props.field,options=_props.options,tooltip=_props.tooltip,className=_props.className,inline=_props.inline,formName=_props.formName,rest=_objectWithoutProperties(_props,['label','fieldName','field','options','tooltip','className','inline','formName']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('RadioField',className),tag:'fieldset',id:this.id},label&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RadioField__label'},label,' ',tooltip&&this.getTooltip(tooltip)),options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],{className:'RadioFieldSet__radio-field',check:true,inline:_this2.props.inline,key:_this2.createUniqueKey(option.value,index)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{check:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Field__["a" /* default */],Object.assign({component:__WEBPACK_IMPORTED_MODULE_4_reactstrap__["v" /* Input */],field:field,type:'radio',name:fieldName,checked:field.value===option.value,value:option.value},rest)),option.label));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FieldError__["a" /* default */],{field:field}));}}]);return RadioField;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;RadioField.propTypes={field:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["b" /* default */]).isRequired,formName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,fieldName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,tooltip:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,options:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node})).isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,inline:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};RadioField.defaultProps={inline:true};/* harmony default export */ __webpack_exports__["a"] = (RadioField);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductImpressions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Product__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductImpressions=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductImpressions,_Component);function ProductImpressions(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductImpressions);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductImpressions.__proto__||Object.getPrototypeOf(ProductImpressions)).call.apply(_ref,[this].concat(args))),_this),_this.sendImpressions=function(){var _this$props=_this.props,sendProductImpressions=_this$props.sendProductImpressions,listName=_this$props.listName,products=_this$props.products;var productList=products.map(function(product,index){return{product:product,position:index+1};});sendProductImpressions(listName,productList);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductImpressions,[{key:'componentDidMount',value:function componentDidMount(){this.sendImpressions();}},{key:'render',value:function render(){return null;}}]);return ProductImpressions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductImpressions.propTypes={products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_Product__["a" /* default */])),listName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,sendProductImpressions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])(function(stores){return{sendProductImpressions:function sendProductImpressions(){var _stores$analytics;return(_stores$analytics=stores.analytics).productImpressions.apply(_stores$analytics,arguments);}};})(ProductImpressions));

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MissingProductLoader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MissingProductLoader=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MissingProductLoader,_Component);function MissingProductLoader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MissingProductLoader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MissingProductLoader.__proto__||Object.getPrototypeOf(MissingProductLoader)).call.apply(_ref,[this].concat(args))),_this),_this.state={missingIds:null},_this.loadProducts=function(){var productStore=_this.props.productStore;var missingIds=_this.state.missingIds;if(missingIds&&missingIds.length>0){productStore.loadProducts(_this.getQueryParams(),true);}},_this.setMissingIds=function(){var _this$props=_this.props,productStore=_this$props.productStore,ids=_this$props.ids;var missingIds=ids.filter(function(productId){return!productStore.products.has(productId);});_this.setState({missingIds:missingIds});},_this.getQueryParams=function(){return{ids:_this.state.missingIds};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MissingProductLoader,[{key:'componentDidMount',value:function componentDidMount(){this.setMissingIds();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.ids,this.props.ids)){this.setMissingIds();}if(!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevState.missingIds,this.state.missingIds)){this.loadProducts();}}},{key:'getQueryIdentifier',value:function getQueryIdentifier(){return Object(__WEBPACK_IMPORTED_MODULE_5__util_query__["a" /* paramsToQueryIdentifier */])(this.getQueryParams());}},{key:'getCurrentSearchProducts',value:function getCurrentSearchProducts(){var _props=this.props,productStore=_props.productStore,ids=_props.ids;// Skip products that were not found.
return ids.map(function(productId){return productStore.products.get(productId);}).filter(function(product){return!!product;});}},{key:'getCurrentSearchState',value:function getCurrentSearchState(){var productStore=this.props.productStore;var missingIds=this.state.missingIds;if(!missingIds){return __WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADING;}if(missingIds.length===0){return __WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADED;}return productStore.productQueryStates.get(this.getQueryIdentifier());}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,productStore=_props2.productStore,ids=_props2.ids,children=_props2.children,rest=_objectWithoutProperties(_props2,['productStore','ids','children']);if(!productStore){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__["a" /* default */],Object.assign({state:this.getCurrentSearchState(),error:productStore.lastError,forLoaded:function forLoaded(){return children(_this2.getCurrentSearchProducts());}},rest));}}]);return MissingProductLoader;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MissingProductLoader.propTypes={ids:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ProductStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('productStore','configStore')(MissingProductLoader));

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createHashTab; });
/* unused harmony export HashTabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__anchor_ScrollableAnchor__ = __webpack_require__(129);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createHashTab=function createHashTab(id,title,getContent){return{id:id,title:title,getContent:getContent};};var HashTabs=function(_Component){_inherits(HashTabs,_Component);function HashTabs(props){_classCallCheck(this,HashTabs);var _this=_possibleConstructorReturn(this,(HashTabs.__proto__||Object.getPrototypeOf(HashTabs)).call(this,props));_this.toggle=function(tabId){var _this$props=_this.props,activeTabId=_this$props.activeTabId,toggle=_this$props.toggle;// Only toggle if we have a new tab, because hash tabs cannot be closed
if(tabId&&activeTabId!==tabId){toggle(tabId);_this.updateElementYOffset(tabId);}};_this.updateElementYOffset=function(tabId){if(_this.props.onUpdateElementYOffsetUpdate){_this.props.onUpdateElementYOffsetUpdate(tabId);}};_this.renderNavItems=function(activeTabId){return _this.props.tabs.map(function(tab){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* NavItem */],{key:tab.id,name:tab.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__anchor_ScrollableAnchor__["a" /* default */],{id:tab.id,scrollIfInHash:false,offset:125}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["I" /* NavLink */],{href:'#',className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({'HashTabs__nav-inactive-tab':activeTabId!==tab.id,active:activeTabId===tab.id}),onClick:function onClick(){_this.toggle(tab.id);}},tab.title));});};_this.renderTabPanes=function(activeTabId){return _this.props.tabs.map(function(tab){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Q" /* TabPane */],{tabId:tab.id,key:tab.id,onBlur:_this.updateElementYOffset},tab.getContent({preloadOnly:!(_this.state.visitedTabs.has(tab.id)||activeTabId===tab.id)}));});};_this.state={visitedTabs:[]};if(props.activeTabId||props.tabs.length>0){_this.state.visitedTabs=new Set([props.activeTabId||props.tabs[0].id]);}return _this;}_createClass(HashTabs,[{key:'render',value:function render(){var tabs=this.props.tabs;if(!tabs||!tabs.length){return null;}var activeTabId=this.props.activeTabId||tabs[0].id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HashTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["G" /* Nav */],{tabs:true,className:'HashTabs__nav HashTabs__nav--top'},this.renderNavItems(activeTabId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["P" /* TabContent */],{activeTab:activeTabId},this.renderTabPanes(activeTabId)));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,prevState){return{visitedTabs:new Set([].concat(_toConsumableArray(prevState.visitedTabs),[nextProps.activeTabId]))};}}]);return HashTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HashTabs.propTypes={activeTabId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,toggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onUpdateElementYOffsetUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,tabs:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,getContent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired})).isRequired};/* harmony default export */ __webpack_exports__["b"] = (HashTabs);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SimpleProductList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductList__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_query__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleProductList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SimpleProductList,_Component);function SimpleProductList(props){_classCallCheck(this,SimpleProductList);var _this=_possibleConstructorReturn(this,(SimpleProductList.__proto__||Object.getPrototypeOf(SimpleProductList)).call(this,props));_this.loadProducts=function(){var _this$props=_this.props,productStore=_this$props.productStore,allSections=_this$props.allSections;productStore.loadProducts(_this.props.searchParams,allSections).catch(function(e){console.error(e);});};if(!_this.getCurrentSearchResult()){_this.loadProducts();}return _this;}_createClass(SimpleProductList,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.searchParams,this.props.searchParams)){this.loadProducts();}}},{key:'getQueryIdentifier',value:function getQueryIdentifier(){return Object(__WEBPACK_IMPORTED_MODULE_9__util_query__["a" /* paramsToQueryIdentifier */])(this.props.searchParams);}},{key:'getCurrentSearchResult',value:function getCurrentSearchResult(){var productStore=this.props.productStore;return productStore.productQueryResults.get(this.getQueryIdentifier());}},{key:'getCurrentSearchState',value:function getCurrentSearchState(){var productStore=this.props.productStore;return productStore.productQueryStates.get(this.getQueryIdentifier());}},{key:'render',value:function render(){var _this2=this;var _props=this.props,productStore=_props.productStore,searchParams=_props.searchParams,name=_props.name,ListComponent=_props.listComponent,completeListingLink=_props.completeListingLink,preloadOnly=_props.preloadOnly,singleRowMode=_props.singleRowMode,requireCanonicalLink=_props.requireCanonicalLink,rest=_objectWithoutProperties(_props,['productStore','searchParams','name','listComponent','completeListingLink','preloadOnly','singleRowMode','requireCanonicalLink']);if(!productStore||!searchParams||preloadOnly){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SimpleProductList'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__loader_ContentForState__["a" /* default */],{state:this.getCurrentSearchState(),error:productStore.lastError,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ListComponent,Object.assign({products:_this2.getCurrentSearchResult().data,name:name,completeListingLink:!singleRowMode?completeListingLink:null,cardSettings:{requireCanonicalLink:requireCanonicalLink}},rest));}}));}}]);return SimpleProductList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;SimpleProductList.propTypes={productStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ProductStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,searchParams:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,listComponent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,completeListingLink:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,preloadOnly:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,allSections:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,singleRowMode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,requireCanonicalLink:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};SimpleProductList.defaultProps={listComponent:__WEBPACK_IMPORTED_MODULE_7__ProductList__["a" /* default */],preloadOnly:false,allSections:false,singleRowMode:false,requireCanonicalLink:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('productStore','configStore')(SimpleProductList));

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertLocaleToFinlandIfAland; });
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRFC5646Tag;
var convertLocaleToFinlandIfAland=function convertLocaleToFinlandIfAland(locale){return locale==='AX'?'FI':locale;};// https://datatracker.ietf.org/doc/html/rfc5646
function parseRFC5646Tag(tag){if(!tag){return null;}var subTags=tag.split('-');return{language:subTags[0],region:subTags[1]};}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecaptchaField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_recaptcha__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecaptchaField=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RecaptchaField,_Component);function RecaptchaField(){_classCallCheck(this,RecaptchaField);return _possibleConstructorReturn(this,(RecaptchaField.__proto__||Object.getPrototypeOf(RecaptchaField)).apply(this,arguments));}_createClass(RecaptchaField,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,rest=_objectWithoutProperties(_props,['configStore']);if(!configStore.recaptcha.sitekey){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["u" /* FormGroup */],{className:'RecaptchaField'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_recaptcha__["a" /* default */],Object.assign({sitekey:configStore.recaptcha.sitekey},rest)));}}]);return RecaptchaField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RecaptchaField.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(RecaptchaField));

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_CampaignCode__ = __webpack_require__(1124);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CampaignCodeStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named('CampaignCodeStore').props({activeCodes:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__models_CampaignCode__["a" /* default */]),[])}).views(function(self){return{get campaignCodesArray(){return Array.from(self.activeCodes,function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return value;});}};}).actions(function(self){return{setup:function setup(activeCodes){self.activeCodes=__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(activeCodes,'id');self.setLoading(false);},loadActiveCodes:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getActiveCodes(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getActiveCodes$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('campaign-codes',{},{active_section:null});case 4:self.activeCodes=_context.sent;_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 11:self.setLoading(false);case 12:case'end':return _context.stop();}}},getActiveCodes,this,[[1,7]]);})),setCode:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setCode(campaignCode){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setCode$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('campaign-codes/set',{campaignCode:campaignCode});case 2:_context2.next=4;return self.loadActiveCodes();case 4:case'end':return _context2.stop();}}},setCode,this);})),unsetCode:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function unsetCode(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function unsetCode$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('campaign-codes/unset');case 2:_context3.next=4;return self.loadActiveCodes();case 4:case'end':return _context3.stop();}}},unsetCode,this);}))};});/* harmony default export */ __webpack_exports__["a"] = (CampaignCodeStore);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(198);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 356 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(359)('keys');
var uid = __webpack_require__(260);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(115);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 361 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1148);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1159);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(197);
var dPs = __webpack_require__(1153);
var enumBugKeys = __webpack_require__(360);
var IE_PROTO = __webpack_require__(358)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(539)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1154).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(133).f;
var has = __webpack_require__(135);
var TAG = __webpack_require__(170)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(170);


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(115);
var core = __webpack_require__(96);
var LIBRARY = __webpack_require__(363);
var wksExt = __webpack_require__(367);
var defineProperty = __webpack_require__(133).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warning */
/* unused harmony export note */
/* unused harmony export resetWarned */
/* unused harmony export call */
/* unused harmony export warningOnce */
/* unused harmony export noteOnce */
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}
function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
/* harmony default export */ __webpack_exports__["a"] = (warningOnce);
/* eslint-enable */

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Handle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(263);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





var Handle = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Handle, _React$Component);

  var _super = _createSuper(Handle);

  function Handle() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Handle);

    _this = _super.apply(this, arguments);
    _this.state = {
      clickFocused: false
    };

    _this.setHandleRef = function (node) {
      _this.handle = node;
    };

    _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    };

    _this.handleMouseDown = function (e) {
      // avoid selecting text during drag
      // https://github.com/ant-design/ant-design/issues/25010
      e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324

      _this.focus();
    };

    _this.handleBlur = function () {
      _this.setClickFocus(false);
    };

    _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Handle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: "setClickFocus",
    value: function setClickFocus(focused) {
      this.setState({
        clickFocused: focused
      });
    }
  }, {
    key: "clickFocus",
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _ref, _ref2;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          vertical = _this$props.vertical,
          reverse = _this$props.reverse,
          offset = _this$props.offset,
          style = _this$props.style,
          disabled = _this$props.disabled,
          min = _this$props.min,
          max = _this$props.max,
          value = _this$props.value,
          tabIndex = _this$props.tabIndex,
          ariaLabel = _this$props.ariaLabel,
          ariaLabelledBy = _this$props.ariaLabelledBy,
          ariaValueTextFormatter = _this$props.ariaValueTextFormatter,
          restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props, ["prefixCls", "vertical", "reverse", "offset", "style", "disabled", "min", "max", "value", "tabIndex", "ariaLabel", "ariaLabelledBy", "ariaValueTextFormatter"]);

      var className = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(this.props.className, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
      var positionStyle = vertical ? (_ref = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, reverse ? 'bottom' : 'top', 'auto'), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, reverse ? 'left' : 'right', 'auto'), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "transform", "translateX(".concat(reverse ? '+' : '-', "50%)")), _ref2);

      var elStyle = _objectSpread(_objectSpread({}, style), positionStyle);

      var mergedTabIndex = tabIndex || 0;

      if (disabled || tabIndex === null) {
        mergedTabIndex = null;
      }

      var ariaValueText;

      if (ariaValueTextFormatter) {
        ariaValueText = ariaValueTextFormatter(value);
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", Object.assign({
        ref: this.setHandleRef,
        tabIndex: mergedTabIndex
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        // aria attribute
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-disabled": !!disabled,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText
      }));
    }
  }]);

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);



/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isEventFromHandle;
/* harmony export (immutable) */ __webpack_exports__["i"] = isValueOutOfRange;
/* harmony export (immutable) */ __webpack_exports__["h"] = isNotTouchEvent;
/* unused harmony export getClosestPoint */
/* unused harmony export getPrecision */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMousePosition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHandleCenterPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureValueInRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureValuePrecision;
/* harmony export (immutable) */ __webpack_exports__["j"] = pauseEvent;
/* unused harmony export calculateNextValue */
/* harmony export (immutable) */ __webpack_exports__["d"] = getKeyboardValueMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(1245);



function isEventFromHandle(e, handles) {
  try {
    return Object.keys(handles).some(function (key) {
      return e.target === Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(handles[key]);
    });
  } catch (error) {
    return false;
  }
}
function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;
  return value < min || value > max;
}
function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}
function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;
  var points = Object.keys(marks).map(parseFloat);

  if (step !== null) {
    var maxSteps = Math.floor((max - min) / step);
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }

  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(diffs)))];
}
function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;

  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }

  return precision;
}
function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}
function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }

  if (val >= max) {
    return max;
  }

  return val;
}
function ensureValuePrecision(val, props) {
  var step = props.step;
  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line

  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}
function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}
function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a, b) {
      return a + b;
    },
    decrease: function decrease(a, b) {
      return a - b;
    }
  };
  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];

  if (props.step) {
    return operations[func](value, props.step);
  }

  if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }

  return value;
}
function getKeyboardValueMutator(e, vertical, reverse) {
  var increase = 'increase';
  var decrease = 'decrease';
  var method = increase;

  switch (e.keyCode) {
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP:
      method = vertical && reverse ? decrease : increase;
      break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].RIGHT:
      method = !vertical && reverse ? decrease : increase;
      break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].DOWN:
      method = vertical && reverse ? increase : decrease;
      break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].LEFT:
      method = !vertical && reverse ? increase : decrease;
      break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].END:
      return function (value, props) {
        return props.max;
      };

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].HOME:
      return function (value, props) {
        return props.min;
      };

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }

  return function (value, props) {
    return calculateNextValue(method, value, props);
  };
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_generatePath__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaginationLinkLink=function PaginationLinkLink(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["N" /* PaginationLink */],Object.assign({tag:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */]},props));};var Paginator=function(_Component){_inherits(Paginator,_Component);function Paginator(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Paginator);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Paginator.__proto__||Object.getPrototypeOf(Paginator)).call.apply(_ref,[this].concat(args))),_this),_this.getPagePath=function(page){var pathTemplate=_this.props.pathTemplate;return Object(__WEBPACK_IMPORTED_MODULE_5__util_generatePath__["a" /* default */])(pathTemplate,{page:page});},_this.getPaginationItem=function(page){var _this$props=_this.props,currentPage=_this$props.currentPage,onClick=_this$props.onClick;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["M" /* PaginationItem */],{active:currentPage===page,key:page},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PaginationLinkLink,{to:_this.getPagePath(page),onClick:onClick},page));},_this.getMoreItem=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["M" /* PaginationItem */],{disabled:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["N" /* PaginationLink */],null,'...'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Paginator,[{key:'render',value:function render(){var _this2=this;var _props=this.props,currentPage=_props.currentPage,lastPage=_props.lastPage,pagesToShow=_props.pagesToShow,label=_props.label,onClick=_props.onClick;var itemsToShow=Math.min(lastPage,pagesToShow);var maxItemsOnRight=lastPage-currentPage;var pagesToLeft=Math.max(Math.floor(itemsToShow/2),itemsToShow-maxItemsOnRight-1);var leftmostPage=Math.max(currentPage-pagesToLeft,1);var leftmostItem=leftmostPage===1?this.getPaginationItem(1):this.getMoreItem();var middleItems=[];var firstMiddlePage=leftmostPage+1;var numberOfMiddlePages=itemsToShow-2;if(numberOfMiddlePages>=1){middleItems=__WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(firstMiddlePage,firstMiddlePage+numberOfMiddlePages).map(function(page){return _this2.getPaginationItem(page);});}var rightmostItem=void 0;var rightmostPage=leftmostPage+(itemsToShow-1);if(rightmostPage>leftmostPage){rightmostItem=rightmostPage>=lastPage?this.getPaginationItem(lastPage):this.getMoreItem();}var previousPage=currentPage>lastPage?lastPage:currentPage<=1?currentPage:currentPage-1;var nextPage=currentPage>=lastPage?lastPage:currentPage+1;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Pagination */],{'aria-label':label||'Pagination',className:'Paginator',size:'lg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["M" /* PaginationItem */],{disabled:currentPage===1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PaginationLinkLink,{previous:true,to:this.getPagePath(previousPage),onClick:onClick})),leftmostItem,middleItems,rightmostItem,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["M" /* PaginationItem */],{disabled:currentPage>=lastPage},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PaginationLinkLink,{next:true,to:this.getPagePath(nextPage),onClick:onClick})));}}]);return Paginator;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Paginator.propTypes={pathTemplate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,lastPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,pagesToShow:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};Paginator.defaultProps={pagesToShow:5};/* harmony default export */ __webpack_exports__["a"] = (Paginator);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LocalStorageKeyType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var LocalStorageKey={SITE_CHOSEN:'nh_site_chosen'};/* harmony default export */ __webpack_exports__["a"] = (LocalStorageKey);var LocalStorageKeyType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('LocalStorageKey',Object.values(LocalStorageKey));

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Survey__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_SurveyType__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_constants__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_storage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie__);
var SurveyStore=__WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__["a" /* default */].named('SurveyStore').props({surveys:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_3__models_Survey__["a" /* default */]),activeSurvey:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_3__models_Survey__["a" /* default */])),modalOpen:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].boolean,true),userFields:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].frozen(),surveySubmitting:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].boolean,false)}).views(function(self){return{modalShouldOpen:function modalShouldOpen(){return self.activeSurvey&&self.modalOpen;},getUserField:function getUserField(key){if(self.userFields){return self.userFields[key];}return null;}};}).volatile(function(self){return{timer:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].function};}).actions(function(self){return{loadSurveys:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadSurveys(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadSurveys$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('surveys');case 4:response=_context.sent;self.surveys=response.surveys;self.userFields=response.userFields;_context.next=13;break;case 9:_context.prev=9;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 13:self.setLoading(false);case 14:case'end':return _context.stop();}}},loadSurveys,this,[[1,9]]);})),activateTimedSurvey:function activateTimedSurvey(){var alreadySeen=Object(__WEBPACK_IMPORTED_MODULE_6__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_5__util_constants__["a" /* storageKeys */].surveysSeen);var survey=self.surveys.find(function(survey){if(alreadySeen&&alreadySeen.includes(survey.id)){return false;}return survey.type===__WEBPACK_IMPORTED_MODULE_4__types_SurveyType__["a" /* default */].TIMED_POPUP&&survey.popup_time>0;});if(survey){self.timer=setTimeout(function(){self.loadSurvey(survey.id);},survey.popup_time*1000);}return survey;},previewSurvey:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function previewSurvey(id){var survey;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function previewSurvey$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:self.setLoading(true);_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('surveys/preview/'+id);case 4:survey=_context2.sent;self.surveys.push(survey[0]);self.activeSurvey=self.surveys.find(function(survey){return survey.id===Number(id);});_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);self.setError(_context2.t0);throw _context2.t0;case 13:self.setLoading(false);return _context2.abrupt('return',true);case 15:case'end':return _context2.stop();}}},previewSurvey,this,[[1,9]]);})),loadSurvey:function loadSurvey(id){clearTimeout(self.timer);var survey=self.surveys.find(function(survey){return survey.id===Number(id);});if(survey){self.activeSurvey=survey;self.modalOpen=true;self.setLoading(false);return true;}self.setLoading(false);return false;},setup:function setup(surveys){if(!surveys){return;}self.surveys=surveys.surveys;self.userFields=surveys.userFields;},toggleModal:function toggleModal(){self.modalOpen=!self.modalOpen;self.setSurveySeen(self.activeSurvey.id);},submitSurvey:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(values){var existingHash,response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!self.surveySubmitting){_context3.next=2;break;}return _context3.abrupt('return');case 2:self.setSurveySubmitting();_context3.prev=3;existingHash=__WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.get('customer_hash');_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().post('surveys/submit',{values:values,surveyId:self.activeSurvey.id});case 7:response=_context3.sent;data=response.data;if(data.survey_hash){if(!existingHash&&existingHash!==data.survey_hash){__WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.set('customer_hash',data.survey_hash,{expires:60});}}// Set updated user fields from response.
if(data.values){self.userFields=data.values;}self.toggleModal();self.setSurveyNotSubmitting();return _context3.abrupt('return',data);case 16:_context3.prev=16;_context3.t0=_context3['catch'](3);self.setSurveyNotSubmitting();throw _context3.t0;case 20:case'end':return _context3.stop();}}},_callee,this,[[3,16]]);})),setSurveySeen:function setSurveySeen(id){var alreadySeen=Object(__WEBPACK_IMPORTED_MODULE_6__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_5__util_constants__["a" /* storageKeys */].surveysSeen);if(!alreadySeen){return Object(__WEBPACK_IMPORTED_MODULE_6__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_5__util_constants__["a" /* storageKeys */].surveysSeen,[id]);}if(!alreadySeen.includes(id)){alreadySeen.push(id);Object(__WEBPACK_IMPORTED_MODULE_6__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_5__util_constants__["a" /* storageKeys */].surveysSeen,alreadySeen);}},setSurveySubmitting:function setSurveySubmitting(){self.surveySubmitting=true;},setSurveyNotSubmitting:function setSurveyNotSubmitting(){self.surveySubmitting=false;}};});/* harmony default export */ __webpack_exports__["a"] = (SurveyStore);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_PaymentTokens__ = __webpack_require__(1323);
var PaymentTokenStore=__WEBPACK_IMPORTED_MODULE_2__models_StatefulStore__["a" /* default */].named('PaymentTokenStore').props({paymentTokens:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__models_PaymentTokens__["a" /* default */],{})}).views(function(self){return{get newTokenUrl(){return self.paymentTokens&&self.paymentTokens.creation_url;},get tokens(){return self.paymentTokens&&self.paymentTokens.tokens;}};}).actions(function(self){return{setup:function setup(activeTokens){self.paymentTokens=activeTokens;},loadTokens:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadTokens(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadTokens$(_context){while(1){switch(_context.prev=_context.next){case 0:self.setLoading(true);_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('payment-tokens',{},{active_section:null});case 4:self.paymentTokens=_context.sent;_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);self.setError(_context.t0);throw _context.t0;case 11:self.setLoading(false);case 12:case'end':return _context.stop();}}},loadTokens,this,[[1,7]]);})),removeToken:function removeToken(id){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.apiAxios().delete('payment-tokens/'+id);}};});/* harmony default export */ __webpack_exports__["a"] = (PaymentTokenStore);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QueryParamRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QueryParamRedirect=function(_Component){_inherits(QueryParamRedirect,_Component);function QueryParamRedirect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QueryParamRedirect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QueryParamRedirect.__proto__||Object.getPrototypeOf(QueryParamRedirect)).call.apply(_ref,[this].concat(args))),_this),_this.maybeRedirect=function(){var _this$props=_this.props,location=_this$props.location,paramName=_this$props.paramName,paramValidator=_this$props.paramValidator,to=_this$props.to,onRedirect=_this$props.onRedirect;var query=Object(__WEBPACK_IMPORTED_MODULE_4__util_queryString__["b" /* parse */])(location.search);if(query[paramName]!==undefined&&!!paramValidator(query[paramName])){var target=typeof to==='function'?to(query[paramName],location):to;onRedirect(target);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */],{to:target});}return null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QueryParamRedirect,[{key:'render',value:function render(){return this.maybeRedirect();}}]);return QueryParamRedirect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);QueryParamRedirect.propTypes={location:__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default.a.location.isRequired,paramName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,paramValidator:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,to:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]).isRequired,onRedirect:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};QueryParamRedirect.defaultProps={paramValidator:function paramValidator(){return true;},onRedirect:function onRedirect(){}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* withRouter */])(QueryParamRedirect));

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MainOrderList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderList__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_OrderStore__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Paginator__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_RecurringOrderStore__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainOrderList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MainOrderList,_Component);function MainOrderList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MainOrderList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MainOrderList.__proto__||Object.getPrototypeOf(MainOrderList)).call.apply(_ref,[this].concat(args))),_this),_this.state={searchParameters:'',removeError:null},_this.loadOrders=function(){var store=_this.getStore();if(!_this.getCurrentResult()&&store.orderQueryStates.get(_this.getQueryIdentifier())!==__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADING){store.loadOrders(_this.getQueryParameters());}},_this.onRemoveClick=function(id){var recurringOrderStore=_this.props.recurringOrderStore;recurringOrderStore.removeOrder(id).then(function(){recurringOrderStore.loadOrders(_this.getQueryParameters());_this.setState({removeError:null});}).catch(function(error){return _this.setState({removeError:error,requestId:_this.state.requestId+1});});},_this.getStore=function(){var _this$props=_this.props,orderStore=_this$props.orderStore,recurringOrderStore=_this$props.recurringOrderStore,useRecurringOrders=_this$props.useRecurringOrders;return useRecurringOrders?recurringOrderStore:orderStore;},_this.getQueryParameters=function(){var search=_this.props.location.search;var params=Object.assign({page:1,resultsPerPage:_this.props.resultsPerPage},Object(__WEBPACK_IMPORTED_MODULE_11__util_queryString__["b" /* parse */])(search));params.page=Number(params.page);return params;},_this.getQueryIdentifier=function(){return Object(__WEBPACK_IMPORTED_MODULE_6__util_query__["a" /* paramsToQueryIdentifier */])(_this.getQueryParameters());},_this.getCurrentResult=function(){var store=_this.getStore();return store.orderQueryResults.get(_this.getQueryIdentifier());},_this.getOrderPageItems=function(){var page=_this.getCurrentResult();return page?page.data:[];},_this.getOrderPageItemCount=function(){var page=_this.getCurrentResult();return page?page.total:0;},_this.getPaginator=function(){var location=_this.props.location;var _this$getCurrentResul=_this.getCurrentResult(),lastPage=_this$getCurrentResul.last_page,currentPage=_this$getCurrentResul.current_page;var searchTemplate=void 0;var regex=/page=(\d+?)(?=(&|$))/;var pageParameter='page=:page';if(location.search.charAt(0)!=='?'){searchTemplate=location.search+'?'+pageParameter;}else{searchTemplate=location.search.match(regex)?location.search.replace(regex,pageParameter):location.search+'&'+pageParameter;}var pathTemplate=location.pathname+searchTemplate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Paginator__["a" /* default */],{pathTemplate:pathTemplate,currentPage:currentPage,lastPage:lastPage,pagesToShow:5});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MainOrderList,[{key:'componentDidMount',value:function componentDidMount(){this.loadOrders();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;if(this.state.searchParameters!==Object(__WEBPACK_IMPORTED_MODULE_11__util_queryString__["c" /* stringify */])(this.getQueryParameters())){this.setState(function(){return{searchParameters:Object(__WEBPACK_IMPORTED_MODULE_11__util_queryString__["c" /* stringify */])(_this2.getQueryParameters())};},this.loadOrders);}}},{key:'render',value:function render(){var _this3=this;var _props=this.props,singlePage=_props.singlePage,useRecurringOrders=_props.useRecurringOrders;var store=this.getStore();var state=store.orderQueryStates.get(this.getQueryIdentifier());if(this.props.onOrderCount){this.props.onOrderCount(this.getOrderPageItemCount());}// TODO tän komponentin stateen orders, jotta päivittyy listaus poiston jälkeen
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MainOrderList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:state,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OrderList__["a" /* default */],{orders:_this3.getOrderPageItems(),useRecurringOrders:useRecurringOrders,onRemoveClick:_this3.onRemoveClick}),!singlePage&&_this3.getOrderPageItemCount()>0&&_this3.getPaginator());}}));}}]);return MainOrderList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MainOrderList.propTypes={orderStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_OrderStore__["a" /* default */]).isRequired,recurringOrderStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_RecurringOrderStore__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.location.isRequired,resultsPerPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,singlePage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onOrderCount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,useRecurringOrders:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};MainOrderList.defaultProps={resultsPerPage:5};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('orderStore','recurringOrderStore')(MainOrderList)));

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Redirect302 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Redirect302=function(_Component){_inherits(Redirect302,_Component);function Redirect302(){_classCallCheck(this,Redirect302);return _possibleConstructorReturn(this,(Redirect302.__proto__||Object.getPrototypeOf(Redirect302)).apply(this,arguments));}_createClass(Redirect302,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{render:function render(_ref){var staticContext=_ref.staticContext;// There is no `staticContext` on the client, so
// We need to guard against that here
if(staticContext)staticContext.status=302;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */],{to:_this2.props.to});}});}}]);return Redirect302;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Redirect302.propTypes={to:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Redirect302);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Balance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Balance=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Balance,_Component);function Balance(){_classCallCheck(this,Balance);return _possibleConstructorReturn(this,(Balance.__proto__||Object.getPrototypeOf(Balance)).apply(this,arguments));}_createClass(Balance,[{key:'render',value:function render(){var _props=this.props,amount=_props.amount,currencyType=_props.currencyType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,amount,' ',currencyType);}}]);return Balance;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;Balance.propTypes={amount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired]).isRequired,currencyType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};Balance.defaultProps={amount:0};/* harmony default export */ __webpack_exports__["a"] = (Balance);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(599);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(206);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(272);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(627);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(206);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(207);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(272);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerShape = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _server = __webpack_require__(396);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var providerShape = exports.providerShape = {
  setHelmet: _propTypes2.default.func,
  helmetInstances: _propTypes2.default.shape({
    get: _propTypes2.default.func,
    add: _propTypes2.default.func,
    remove: _propTypes2.default.func
  })
};

var canUseDOM = typeof document !== 'undefined';

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return {
        setHelmet: function setHelmet(serverState, state) {
          _this2.props.context.helmet = serverState;
          _this2.props.context.state = state;
        },
        helmetInstances: {
          get: function get() {
            return _this2.instances;
          },
          add: function add(instance) {
            _this2.instances.push(instance);
          },
          remove: function remove(instance) {
            var index = _this2.instances.indexOf(instance);
            _this2.instances.splice(index, 1);
          }
        }
      };
    }
  }]);

  function Provider(props) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props));

    _this.instances = [];


    if (!Provider.canUseDOM) {
      props.context.helmet = (0, _server2.default)({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: true,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: '',
        titleAttributes: {}
      });
    }
    return _this;
  }

  _createClass(Provider, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return Provider;
}(_react.Component);

Provider.canUseDOM = canUseDOM;
Provider.propTypes = {
  context: _propTypes2.default.shape({}),
  children: _propTypes2.default.node.isRequired
};
Provider.defaultProps = {
  context: {}
};
Provider.childContextTypes = providerShape;
exports.default = Provider;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(209);

var _utils = __webpack_require__(274);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SELF_CLOSING_TAGS = [_constants.TAG_NAMES.NOSCRIPT, _constants.TAG_NAMES.SCRIPT, _constants.TAG_NAMES.STYLE];

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
  var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (encode === false) {
    return String(str);
  }

  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
  return Object.keys(attributes).reduce(function (str, key) {
    var attr = typeof attributes[key] !== 'undefined' ? key + '="' + attributes[key] + '"' : '' + key;
    return str ? str + ' ' + attr : attr;
  }, '');
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
  var attributeString = generateElementAttributesAsString(attributes);
  var flattenedTitle = (0, _utils.flattenArray)(title);
  return attributeString ? '<' + type + ' ' + _constants.HELMET_ATTRIBUTE + '="true" ' + attributeString + '>' + encodeSpecialCharacters(flattenedTitle, encode) + '</' + type + '>' : '<' + type + ' ' + _constants.HELMET_ATTRIBUTE + '="true">' + encodeSpecialCharacters(flattenedTitle, encode) + '</' + type + '>';
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
  return tags.reduce(function (str, tag) {
    var attributeHtml = Object.keys(tag).filter(function (attribute) {
      return !(attribute === _constants.TAG_PROPERTIES.INNER_HTML || attribute === _constants.TAG_PROPERTIES.CSS_TEXT);
    }).reduce(function (string, attribute) {
      var attr = typeof tag[attribute] === 'undefined' ? attribute : attribute + '="' + encodeSpecialCharacters(tag[attribute], encode) + '"';
      return string ? string + ' ' + attr : attr;
    }, '');

    var tagContent = tag.innerHTML || tag.cssText || '';

    var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

    return str + '<' + type + ' ' + _constants.HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? '/>' : '>' + tagContent + '</' + type + '>');
  }, '');
};

var convertElementAttributesToReactProps = function convertElementAttributesToReactProps(attributes) {
  var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(attributes).reduce(function (obj, key) {
    obj[_constants.REACT_TAG_MAP[key] || key] = attributes[key];
    return obj;
  }, initProps);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
  // assigning into an array to define toString function on it
  var initProps = _defineProperty({
    key: title
  }, _constants.HELMET_ATTRIBUTE, true);
  var props = convertElementAttributesToReactProps(attributes, initProps);

  return [_react2.default.createElement(_constants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
  return tags.map(function (tag, i) {
    var mappedTag = _defineProperty({
      key: i
    }, _constants.HELMET_ATTRIBUTE, true);

    Object.keys(tag).forEach(function (attribute) {
      var mappedAttribute = _constants.REACT_TAG_MAP[attribute] || attribute;

      if (mappedAttribute === _constants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _constants.TAG_PROPERTIES.CSS_TEXT) {
        var content = tag.innerHTML || tag.cssText;
        mappedTag.dangerouslySetInnerHTML = { __html: content };
      } else {
        mappedTag[mappedAttribute] = tag[attribute];
      }
    });

    return _react2.default.createElement(type, mappedTag);
  });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
  switch (type) {
    case _constants.TAG_NAMES.TITLE:
      return {
        toComponent: function toComponent() {
          return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
        },
        toString: function toString() {
          return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
        }
      };
    case _constants.ATTRIBUTE_NAMES.BODY:
    case _constants.ATTRIBUTE_NAMES.HTML:
      return {
        toComponent: function toComponent() {
          return convertElementAttributesToReactProps(tags);
        },
        toString: function toString() {
          return generateElementAttributesAsString(tags);
        }
      };
    default:
      return {
        toComponent: function toComponent() {
          return generateTagsAsReactComponent(type, tags);
        },
        toString: function toString() {
          return generateTagsAsString(type, tags, encode);
        }
      };
  }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
  var baseTag = _ref.baseTag,
      bodyAttributes = _ref.bodyAttributes,
      encode = _ref.encode,
      htmlAttributes = _ref.htmlAttributes,
      linkTags = _ref.linkTags,
      metaTags = _ref.metaTags,
      noscriptTags = _ref.noscriptTags,
      scriptTags = _ref.scriptTags,
      styleTags = _ref.styleTags,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      titleAttributes = _ref.titleAttributes;
  return {
    base: getMethodsForTag(_constants.TAG_NAMES.BASE, baseTag, encode),
    bodyAttributes: getMethodsForTag(_constants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
    htmlAttributes: getMethodsForTag(_constants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
    link: getMethodsForTag(_constants.TAG_NAMES.LINK, linkTags, encode),
    meta: getMethodsForTag(_constants.TAG_NAMES.META, metaTags, encode),
    noscript: getMethodsForTag(_constants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
    script: getMethodsForTag(_constants.TAG_NAMES.SCRIPT, scriptTags, encode),
    style: getMethodsForTag(_constants.TAG_NAMES.STYLE, styleTags, encode),
    title: getMethodsForTag(_constants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
  };
};

exports.default = mapStateOnServer;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    isSymbol = __webpack_require__(138);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(663)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(670);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sticky = __webpack_require__(681);

var _sticky2 = _interopRequireDefault(_sticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _sticky2.default;
module.exports = exports['default'];

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_resize_observer_polyfill__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_schd__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChildWrapper__ = __webpack_require__(698);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var ResizeDetector =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ResizeDetector, _PureComponent);

  function ResizeDetector(props) {
    var _this;

    _classCallCheck(this, ResizeDetector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResizeDetector).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "cancelHandler", function () {
      if (_this.resizeHandler && _this.resizeHandler.cancel) {
        // cancel debounced handler
        _this.resizeHandler.cancel();

        _this.resizeHandler = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "rafClean", function () {
      if (_this.raf && _this.raf.cancel) {
        _this.raf.cancel();

        _this.raf = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleObserver", function (type) {
      var element = _this.getElement();

      if (!element || !_this.resizeObserver[type]) return;

      _this.resizeObserver[type](element);
    });

    _defineProperty(_assertThisInitialized(_this), "getElement", function () {
      var querySelector = _this.props.querySelector;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["c" /* isSSR */])()) return undefined;
      if (querySelector) return document.querySelector(querySelector); // eslint-disable-next-line react/no-find-dom-node

      var currentElement = _this.element && Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.element);
      if (!currentElement) return undefined;
      return currentElement.parentElement;
    });

    _defineProperty(_assertThisInitialized(_this), "createUpdater", function () {
      _this.rafClean();

      _this.raf = Object(__WEBPACK_IMPORTED_MODULE_3_raf_schd__["a" /* default */])(function (_ref) {
        var width = _ref.width,
            height = _ref.height;
        var onResize = _this.props.onResize;

        if (Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["b" /* isFunction */])(onResize)) {
          onResize(width, height);
        }

        _this.setState({
          width: width,
          height: height
        });
      });
      return _this.raf;
    });

    _defineProperty(_assertThisInitialized(_this), "createResizeHandler", function (entries) {
      var _this$state = _this.state,
          widthCurrent = _this$state.width,
          heightCurrent = _this$state.height;
      var _this$props = _this.props,
          handleWidth = _this$props.handleWidth,
          handleHeight = _this$props.handleHeight;
      if (!handleWidth && !handleHeight) return;

      var updater = _this.createUpdater();

      entries.forEach(function (entry) {
        var _ref2 = entry && entry.contentRect || {},
            width = _ref2.width,
            height = _ref2.height;

        var isWidthChanged = handleWidth && widthCurrent !== width;
        var isHeightChanged = handleHeight && heightCurrent !== height;
        var isSizeChanged = isWidthChanged || isHeightChanged;
        var shouldSetSize = !_this.skipOnMount && isSizeChanged && !Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["c" /* isSSR */])();

        if (shouldSetSize) {
          updater({
            width: width,
            height: height
          });
        }

        _this.skipOnMount = false;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRef", function (el) {
      _this.element = el;
    });

    _defineProperty(_assertThisInitialized(_this), "getRenderType", function () {
      var _this$props2 = _this.props,
          render = _this$props2.render,
          children = _this$props2.children;

      if (Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["b" /* isFunction */])(render)) {
        return 'renderProp';
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["b" /* isFunction */])(children)) {
        return 'childFunction';
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(children)) {
        return 'child';
      }

      if (Array.isArray(children)) {
        return 'childArray';
      }

      return 'parent';
    });

    _defineProperty(_assertThisInitialized(_this), "getTargetComponent", function () {
      var _this$props3 = _this.props,
          render = _this$props3.render,
          children = _this$props3.children,
          nodeType = _this$props3.nodeType;
      var _this$state2 = _this.state,
          width = _this$state2.width,
          height = _this$state2.height;
      var childProps = {
        width: width,
        height: height
      };

      var renderType = _this.getRenderType();

      switch (renderType) {
        case 'renderProp':
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(render(childProps), {
            key: 'resize-detector'
          });

        case 'childFunction':
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(children(childProps));

        case 'child':
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(children, childProps);

        case 'childArray':
          return children.map(function (el) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(el, childProps);
          });

        default:
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(nodeType);
      }
    });

    var skipOnMount = props.skipOnMount,
        refreshMode = props.refreshMode,
        refreshRate = props.refreshRate,
        refreshOptions = props.refreshOptions;
    _this.state = {
      width: undefined,
      height: undefined
    };
    _this.skipOnMount = skipOnMount;
    _this.raf = null;
    _this.element = null;
    _this.unmounted = false;
    var handle = Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["a" /* getHandle */])(refreshMode);
    _this.resizeHandler = handle ? handle(_this.createResizeHandler, refreshRate, refreshOptions) : _this.createResizeHandler;
    _this.resizeObserver = new __WEBPACK_IMPORTED_MODULE_2_resize_observer_polyfill__["a" /* default */](_this.resizeHandler);
    return _this;
  }

  _createClass(ResizeDetector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.toggleObserver('observe');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.toggleObserver('unobserve');
      this.rafClean();
      this.cancelHandler();
      this.unmounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ChildWrapper__["a" /* default */], {
        ref: this.onRef
      }, this.getTargetComponent());
    }
  }]);

  return ResizeDetector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ResizeDetector.propTypes = {
  handleWidth: __WEBPACK_IMPORTED_MODULE_4_prop_types__["bool"],
  handleHeight: __WEBPACK_IMPORTED_MODULE_4_prop_types__["bool"],
  skipOnMount: __WEBPACK_IMPORTED_MODULE_4_prop_types__["bool"],
  refreshRate: __WEBPACK_IMPORTED_MODULE_4_prop_types__["number"],
  refreshMode: __WEBPACK_IMPORTED_MODULE_4_prop_types__["string"],
  refreshOptions: Object(__WEBPACK_IMPORTED_MODULE_4_prop_types__["shape"])({
    leading: __WEBPACK_IMPORTED_MODULE_4_prop_types__["bool"],
    trailing: __WEBPACK_IMPORTED_MODULE_4_prop_types__["bool"]
  }),
  querySelector: __WEBPACK_IMPORTED_MODULE_4_prop_types__["string"],
  onResize: __WEBPACK_IMPORTED_MODULE_4_prop_types__["func"],
  render: __WEBPACK_IMPORTED_MODULE_4_prop_types__["func"],
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types__["any"],
  // eslint-disable-line react/forbid-prop-types
  nodeType: __WEBPACK_IMPORTED_MODULE_4_prop_types__["node"]
};
ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false,
  skipOnMount: false,
  refreshRate: 1000,
  refreshMode: undefined,
  refreshOptions: undefined,
  querySelector: null,
  onResize: null,
  render: undefined,
  children: null,
  nodeType: 'div'
};
/* harmony default export */ __webpack_exports__["a"] = (ResizeDetector);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(691);




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(690);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(406);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationLogo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_TranslationStore__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_TranslatedImageType__ = __webpack_require__(212);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationLogo=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationLogo,_Component);function NavigationLogo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationLogo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationLogo.__proto__||Object.getPrototypeOf(NavigationLogo)).call.apply(_ref,[this].concat(args))),_this),_this.getLogoUrl=function(translatedImageType){var translationStore=_this.props.translationStore;var logo=translationStore.translatedImages.find(function(image){return image.image_key===translatedImageType;});return logo&&logo.image_path;},_this.getScrollLogoUrl=function(){return _this.getLogoUrl(__WEBPACK_IMPORTED_MODULE_9__types_TranslatedImageType__["b" /* default */].STORE_SCROLL_LOGO);},_this.getStoreLogoUrl=function(){return _this.getLogoUrl(__WEBPACK_IMPORTED_MODULE_9__types_TranslatedImageType__["b" /* default */].STORE_LOGO);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationLogo,[{key:'render',value:function render(){var _props=this.props,accountStore=_props.accountStore,configStore=_props.configStore,sticky=_props.sticky,useStickyHeaderOnStartup=_props.useStickyHeaderOnStartup;var logoUrl=accountStore.account&&accountStore.account.logo?accountStore.account.logo:(useStickyHeaderOnStartup||sticky)&&this.getScrollLogoUrl()?this.getScrollLogoUrl():this.getStoreLogoUrl();return logoUrl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["K" /* NavbarBrand */],{tag:__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],className:'NavigationLogo',to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoUrl,alt:configStore.store.name})):null;}}]);return NavigationLogo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationLogo.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_AccountStore__["a" /* default */]).isRequired,translationStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_TranslationStore__["a" /* default */]).isRequired,sticky:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,useStickyHeaderOnStartup:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','configStore','translationStore')(NavigationLogo));

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AcceptableTermsTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var StoreThemeLayoutTypes={SOFTLY_ROUNDED_CORNERS:'SOFTLY_ROUNDED_CORNERS',FULLY_ROUNDED_EDGES:'FULLY_ROUNDED_EDGES',BOX:'BOX'};/* harmony default export */ __webpack_exports__["a"] = (StoreThemeLayoutTypes);var AcceptableTermsTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('StoreThemeLayoutTypes',Object.values(StoreThemeLayoutTypes));

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);
var settle = __webpack_require__(710);
var buildURL = __webpack_require__(712);
var parseHeaders = __webpack_require__(713);
var isURLSameOrigin = __webpack_require__(714);
var createError = __webpack_require__(412);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(715);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(716);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(711);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Client=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Client',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,firstname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,lastname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,company:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')});/* harmony default export */ __webpack_exports__["a"] = (Client);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return storeSessionId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSessionId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var SESSION_KEY='jsh_id';var storeSessionId=function storeSessionId(sessionId){// TODO: Fetch session expiration from backend configuration
var dayInMS=24*60*60*1000;var expiration=new Date(new Date().getTime()+dayInMS);return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(SESSION_KEY,sessionId,{expires:expiration});};var getSessionId=function getSessionId(){return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(SESSION_KEY);};

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationDropdownMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_url__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationDropdownMenu=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationDropdownMenu,_Component);function NavigationDropdownMenu(props){_classCallCheck(this,NavigationDropdownMenu);var _this=_possibleConstructorReturn(this,(NavigationDropdownMenu.__proto__||Object.getPrototypeOf(NavigationDropdownMenu)).call(this,props));_this.toggleAccountMenu=function(){var disabled=_this.props.disabled;_this.setState({open:disabled?false:!_this.state.open});};_this.toggleMenu=function(){return _this.setState({open:!_this.state.open});};_this.openMenu=function(){var entity=_this.props.entity;_this.props.setActiveId(entity.id);_this.setState({open:true});};_this.closeMenu=function(e){var entity=_this.props.entity;var isClick=!!(e&&e.type==='click');if(isClick&&(entity.path.length===0||entity.path==='#')){return;}_this.setState({open:false});};_this.navigateTo=function(){var _this$props=_this.props,history=_this$props.history,host=_this$props.host,entity=_this$props.entity;var maybeRelativeUrl=Object(__WEBPACK_IMPORTED_MODULE_8__util_url__["i" /* stripHostIfMatches */])(entity.path,host);if(Object(__WEBPACK_IMPORTED_MODULE_8__util_url__["e" /* isNotHandledByReactRouter */])(maybeRelativeUrl)){document.location=maybeRelativeUrl;}else{history.push(maybeRelativeUrl);}};_this.state={open:false};_this.toggleAccountMenu=_this.toggleAccountMenu.bind(_this);_this.toggleMenu=_this.toggleMenu.bind(_this);return _this;}_createClass(NavigationDropdownMenu,[{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,children=_props.children,className=_props.className,disabled=_props.disabled,entity=_props.entity,isOpen=_props.isOpen,debouncer=_props.debouncer,isAccount=_props.isAccount,staticContext=_props.staticContext,rest=_objectWithoutProperties(_props,['label','children','className','disabled','entity','isOpen','debouncer','isAccount','staticContext']);var image=entity?entity.image:null;var accountMenuIsOpen=disabled?false:this.state.open;var menuIsOpen=disabled?false:!!(isOpen&&this.state.open);return isAccount?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["o" /* Dropdown */],Object.assign({isOpen:accountMenuIsOpen,toggle:this.toggleAccountMenu,nav:true,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationDropdownMenu',className),disabled:disabled},rest),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* DropdownToggle */],{nav:true,caret:true,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({disabled:disabled})},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* DropdownMenu */],null,children)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["o" /* Dropdown */],{key:entity.id,isOpen:menuIsOpen,toggle:this.toggleMenu,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationDropdownMenu',className),disabled:disabled,nav:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationDropdownMenu__hover',onClick:this.closeMenu,onMouseOver:function onMouseOver(){return debouncer(function(){return _this2.openMenu();});},onMouseOut:function onMouseOut(){return debouncer(function(){return _this2.closeMenu();});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* DropdownToggle */],{nav:true,onClick:this.navigateTo,caret:true,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()({disabled:disabled})},image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:image,loading:'lazy'}),label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* DropdownMenu */],{modifiers:{preventOverflow:{boundariesElement:'viewport'}}},children)));}}]);return NavigationDropdownMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationDropdownMenu.propTypes={history:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.history.isRequired,host:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,debouncer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,entity:__WEBPACK_IMPORTED_MODULE_7__types_NavigationEntity__["a" /* default */],isAccount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,setActiveId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};NavigationDropdownMenu.defaultProps={label:'',className:'',children:[],disabled:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["c" /* inject */])(function(stores){return{host:stores.locationContext.host};})(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(NavigationDropdownMenu)));

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isArray = __webpack_require__(47),
    isObjectLike = __webpack_require__(90);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClientLoginLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClientLoginLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ClientLoginLink,_Component);function ClientLoginLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientLoginLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientLoginLink.__proto__||Object.getPrototypeOf(ClientLoginLink)).call.apply(_ref,[this].concat(args))),_this),_this.toggle=function(){_this.props.accountStore.accountModal.setTab(__WEBPACK_IMPORTED_MODULE_3__types_AccountModalTab__["b" /* default */].CHANGE_CLIENT);_this.props.accountStore.accountModal.toggle();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientLoginLink,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ClientLoginLink',onClick:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].accountChangeClientSentence));}}]);return ClientLoginLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ClientLoginLink.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_AccountStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore')(ClientLoginLink));

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(143),
    isArguments = __webpack_require__(287),
    isArray = __webpack_require__(47),
    isIndex = __webpack_require__(219),
    isLength = __webpack_require__(288),
    toKey = __webpack_require__(145);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(124);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(771),
    keys = __webpack_require__(147);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(773),
    isArguments = __webpack_require__(287),
    isArray = __webpack_require__(47),
    isBuffer = __webpack_require__(289),
    isIndex = __webpack_require__(219),
    isTypedArray = __webpack_require__(425);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(775),
    baseUnary = __webpack_require__(148),
    nodeUtil = __webpack_require__(221);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(291),
    nativeKeys = __webpack_require__(776);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 427 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(429),
    arraySome = __webpack_require__(430),
    cacheHas = __webpack_require__(431);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(283),
    setCacheAdd = __webpack_require__(786),
    setCacheHas = __webpack_require__(787);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(88);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(434),
    getSymbols = __webpack_require__(296),
    keys = __webpack_require__(147);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(295),
    isArray = __webpack_require__(47);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(124),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionStatusTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var SectionStatusType={ACTIVE:'ACTIVE',TEST_MODE:'TEST_MODE',NOT_IN_USE:'NOT_IN_USE'};/* harmony default export */ __webpack_exports__["b"] = (SectionStatusType);var SectionStatusTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('SectionStatusType',Object.values(SectionStatusType));

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigationDropdownDrawerButton__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_CLOSE_BUTTON=Object(__WEBPACK_IMPORTED_MODULE_6__NavigationDropdownDrawerButton__["a" /* default */])({label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'times'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].closeTitle)),color:'primary',onClick:function onClick(context){return context.close();},key:'_default-close'});var NavigationDropdownDrawer=function(_Component){_inherits(NavigationDropdownDrawer,_Component);function NavigationDropdownDrawer(props){_classCallCheck(this,NavigationDropdownDrawer);var _this=_possibleConstructorReturn(this,(NavigationDropdownDrawer.__proto__||Object.getPrototypeOf(NavigationDropdownDrawer)).call(this,props));_this.state={open:false};return _this;}_createClass(NavigationDropdownDrawer,[{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,children=_props.children,className=_props.className,buttons=_props.buttons,right=_props.right,props=_objectWithoutProperties(_props,['label','children','className','buttons','right']);var buttonContext={close:function close(){_this2.setState({open:false});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["o" /* Dropdown */],Object.assign({isOpen:this.state.open,toggle:function toggle(){return _this2.setState({open:!_this2.state.open});},nav:true,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationDropdownDrawer',className)},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* DropdownToggle */],{nav:true,caret:true},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* DropdownMenu */],{right:right},children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationDropdownDrawer__hanging-buttons'},buttons.map(function(button){return button(buttonContext);}))));}}]);return NavigationDropdownDrawer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NavigationDropdownDrawer.propTypes={label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,buttons:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func),right:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};NavigationDropdownDrawer.defaultProps={label:'',className:'',children:[],buttons:[DEFAULT_CLOSE_BUTTON]};/* harmony default export */ __webpack_exports__["a"] = (NavigationDropdownDrawer);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var NavigationDropdownDrawerButton=function NavigationDropdownDrawerButton(props){var label=props.label,_onClick=props.onClick,rest=_objectWithoutProperties(props,['label','onClick']);return function(context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],Object.assign({className:'NavigationDropdownDrawerButton',onClick:function onClick(){return _onClick(context);}},rest),label);};};NavigationDropdownDrawerButton.propTypes={label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]).isRequired,onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (NavigationDropdownDrawerButton);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_CouponActivationType__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_CouponDiscountType__ = __webpack_require__(298);
var Coupon=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Coupon',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),activation_type:__WEBPACK_IMPORTED_MODULE_1__types_CouponActivationType__["a" /* CouponActivationTypeType */],discount_type:__WEBPACK_IMPORTED_MODULE_2__types_CouponDiscountType__["a" /* CouponDiscountTypeType */],amount:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),percentage:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),minimum_order:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),time_to_activation:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),end_date:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (Coupon);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewsletterSubscriptionForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__privacy_statement_PrivacyStatementLink__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_FormGroupField__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubscriptionStatus={NONE:'NONE',VALIDATION_ERROR:'VALIDATION_ERROR',SUCCESS:'SUCCESS',EMAIL_EXISTS:'EMAIL_EXISTS',UNEXPECTED_ERROR:'UNEXPECTED_ERROR'};var NewsletterSubscriptionForm=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(NewsletterSubscriptionForm,_Component);function NewsletterSubscriptionForm(props){_classCallCheck(this,NewsletterSubscriptionForm);var _this=_possibleConstructorReturn(this,(NewsletterSubscriptionForm.__proto__||Object.getPrototypeOf(NewsletterSubscriptionForm)).call(this,props));_initialiseProps.call(_this);var configStore=_this.props.configStore;var fields={email:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_10__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailTitle)),Object(__WEBPACK_IMPORTED_MODULE_10__util_formValidators__["d" /* isEmail */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailTitle))])};if(configStore.newsletter.requireName){fields.firstName=Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_10__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].firstNameTitle))]);fields.lastName=Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_10__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].lastNameTitle))]);}_this.form=Object(__WEBPACK_IMPORTED_MODULE_8__models_Form__["a" /* createForm */])(fields);return _this;}_createClass(NewsletterSubscriptionForm,[{key:'render',value:function render(){var compact=this.props.compact;var status=this.state.status;var message=void 0;switch(status){case SubscriptionStatus.NONE:break;case SubscriptionStatus.SUCCESS:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'newsletter.status.SUCCESS',defaultMessage:'You have been added to our e-mail list. Thank you for subscribing!'}));break;case SubscriptionStatus.VALIDATION_ERROR:// This is just in case, as it should actually never happen, because we validate the fields client side.
message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'newsletter.status.VALIDATION_ERROR',defaultMessage:'Information you provided is not valid. Please recheck the form.'}));break;case SubscriptionStatus.EMAIL_EXISTS:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'newsletter.status.EMAIL_EXISTS',defaultMessage:'The e-mail address you entered is already in our e-mail list.'}));break;default:case SubscriptionStatus.UNEXPECTED_ERROR:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__loader_UnexpectedError__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NewsletterSubscriptionForm',{'NewsletterSubscriptionForm--compact':compact})},message,status!==SubscriptionStatus.SUCCESS&&this.getForm(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NewsletterSubscriptionForm__privacy-statement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'newsletter.subscriberAgreesTo',defaultMessage:'By subscribing you agree to'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__privacy_statement_PrivacyStatementLink__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'privacyStatement.subscriberAgreesLink',defaultMessage:'the Privacy Statement'})),'.'));}}]);return NewsletterSubscriptionForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.state={status:SubscriptionStatus.NONE};this.handleSubmit=function(e){var apiWrapper=_this2.props.apiWrapper;e.preventDefault();_this2.form.validate();if(_this2.form.valid){apiWrapper.apiAxios().post('newsletter-subscriptions',_this2.form.getFieldValues()).then(function(){_this2.setState({status:SubscriptionStatus.SUCCESS});}).catch(function(e){var status=e.response?e.response.status:500;var errorMap={400:SubscriptionStatus.VALIDATION_ERROR,409:SubscriptionStatus.EMAIL_EXISTS,422:SubscriptionStatus.VALIDATION_ERROR,500:SubscriptionStatus.UNEXPECTED_ERROR};_this2.setState({status:errorMap[status]});});}};this.getField=function(name,message){var compact=_this2.props.compact;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NewsletterSubscriptionForm__field NewsletterSubscriptionForm__field--'+name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__form_FormGroupField__["a" /* default */],{field:_this2.form.fields.get(name),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],message),formName:'NewsletterSubscriptionForm',fieldName:name,hideLabel:compact,placeholder:compact&&_this2.props.intl.formatMessage(message)}));};this.getForm=function(){var _props=_this2.props,configStore=_props.configStore,compact=_props.compact;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{noValidate:true,onSubmit:_this2.handleSubmit},configStore.newsletter.requireName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NewsletterSubscriptionForm__row'},_this2.getField('firstName',__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].firstNameTitle),_this2.getField('lastName',__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].lastNameTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NewsletterSubscriptionForm__row'},_this2.getField('email',__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'NewsletterSubscriptionForm__submit',color:'primary',disabled:_this2.form.valid===false},compact?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'newsletter.subscribeCompact',defaultMessage:'Subscribe'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'newsletter.subscribe',defaultMessage:'Subscribe'}))));};},_temp))||_class;NewsletterSubscriptionForm.propTypes={compact:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,configStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_ConfigStore__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_ApiWrapper__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('apiWrapper','configStore')(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(NewsletterSubscriptionForm)));

/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegionalSettingsDeliveryCountryDropdown__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegionalSettingsLanguageDropdown__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RegionalSettingsCurrencyDropdown__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_Country__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_Currency__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_Language__ = __webpack_require__(227);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegionalSettingsDropdowns=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RegionalSettingsDropdowns,_Component);function RegionalSettingsDropdowns(){_classCallCheck(this,RegionalSettingsDropdowns);return _possibleConstructorReturn(this,(RegionalSettingsDropdowns.__proto__||Object.getPrototypeOf(RegionalSettingsDropdowns)).apply(this,arguments));}_createClass(RegionalSettingsDropdowns,[{key:'render',value:function render(){var _props=this.props,languageStore=_props.languageStore,currencyStore=_props.currencyStore,countryStore=_props.countryStore,country=_props.country,language=_props.language,currency=_props.currency,onChange=_props.onChange;var showCountries=countryStore.countries.length>1;var showLanguages=languageStore.languages.length>1;var showCurrencies=currencyStore.currencies.length>1;var dropdowns=[];if(showCountries){dropdowns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RegionalSettingsDeliveryCountryDropdown__["a" /* default */],{key:'country',country:country,countries:countryStore.countries,onSelect:function onSelect(newCountry){return onChange('country',newCountry);}}));}if(showLanguages){dropdowns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RegionalSettingsLanguageDropdown__["a" /* default */],{key:'language',language:language,languages:languageStore.languages,onSelect:function onSelect(newLanguage){return onChange('language',newLanguage);}}));}if(showCurrencies){dropdowns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RegionalSettingsCurrencyDropdown__["a" /* default */],{key:'currency',currency:currency,currencies:currencyStore.currencies,onSelect:function onSelect(newCurrency){return onChange('currency',newCurrency);}}));}if(dropdowns.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationRegionalSettingsMenu__selectors'},dropdowns);}}]);return RegionalSettingsDropdowns;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RegionalSettingsDropdowns.propTypes={languageStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_LanguageStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_CurrencyStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_CountryStore__["a" /* default */]).isRequired,country:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__models_Country__["a" /* default */]).isRequired,currency:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__models_Currency__["a" /* default */]).isRequired,language:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__models_Language__["a" /* default */]).isRequired,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('countryStore','currencyStore','languageStore')(RegionalSettingsDropdowns));

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RegionalSettings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegionalSettings=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(RegionalSettings,_Component);function RegionalSettings(props){_classCallCheck(this,RegionalSettings);var _this=_possibleConstructorReturn(this,(RegionalSettings.__proto__||Object.getPrototypeOf(RegionalSettings)).call(this,props));_initialiseProps.call(_this);var languageStore=props.languageStore,currencyStore=props.currencyStore,countryStore=props.countryStore;_this.state={country:countryStore.activeCountry,language:languageStore.activeLanguage,currency:currencyStore.activeCurrency,effectiveCurrency:currencyStore.activeCurrency,isSaving:false};return _this;}_createClass(RegionalSettings,[{key:'render',value:function render(){var isSaving=this.state.isSaving;var effectiveState={country:this.state.country,language:this.state.language,currency:this.state.effectiveCurrency};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.props.children(this.save,this.onChange,effectiveState,isSaving));}}]);return RegionalSettings;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.save=function(){var _props=_this2.props,languageStore=_props.languageStore,accountStore=_props.accountStore;_this2.setState(function(){return{isSaving:true};});return languageStore.getRedirectedUrl(_this2.state.language.code).then(function(url){return accountStore.updateSessionParams({currency:_this2.state.effectiveCurrency.code,country:_this2.state.country.id,lang:_this2.state.language.code}).then(function(){if(window.location.href!==url.href){window.location=url;}else{window.location.reload();}});});};this.setLanguage=function(language){_this2.setState({language:language});};this.setCountry=function(country){var effectiveCurrency=_this2.state.currency;if(country.currency){effectiveCurrency=country.currency;}_this2.setState({country:country,effectiveCurrency:effectiveCurrency});};this.setCurrency=function(currency){_this2.setState({currency:currency,effectiveCurrency:currency});};this.onChange=function(field,value){switch(field){case'language':_this2.setLanguage(value);break;case'country':_this2.setCountry(value);break;case'currency':_this2.setCurrency(value);break;default:break;}};},_temp))||_class;RegionalSettings.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_AccountStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_LanguageStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_CurrencyStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_CountryStore__["a" /* default */]).isRequired,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','countryStore','currencyStore','languageStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* withRouter */])(RegionalSettings)));

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(146),
    isArrayLike = __webpack_require__(125);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(305);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return produce; });
/* unused harmony export applyPatches */
/* unused harmony export nothing */
/* unused harmony export setAutoFreeze */
/* unused harmony export setUseProxies */
/* unused harmony export original */
function generatePatches(state, basepath, patches, inversePatches, baseValue, resultValue) {
    if (patches) if (Array.isArray(baseValue)) generateArrayPatches(state, basepath, patches, inversePatches, baseValue, resultValue);else generateObjectPatches(state, basepath, patches, inversePatches, baseValue, resultValue);
}

function generateArrayPatches(state, basepath, patches, inversePatches, baseValue, resultValue) {
    var shared = Math.min(baseValue.length, resultValue.length);
    for (var i = 0; i < shared; i++) {
        if (state.assigned[i] && baseValue[i] !== resultValue[i]) {
            var path = basepath.concat(i);
            patches.push({ op: "replace", path: path, value: resultValue[i] });
            inversePatches.push({ op: "replace", path: path, value: baseValue[i] });
        }
    }
    if (shared < resultValue.length) {
        // stuff was added
        for (var _i = shared; _i < resultValue.length; _i++) {
            var _path = basepath.concat(_i);
            patches.push({ op: "add", path: _path, value: resultValue[_i] });
        }
        inversePatches.push({
            op: "replace",
            path: basepath.concat("length"),
            value: baseValue.length
        });
    } else if (shared < baseValue.length) {
        // stuff was removed
        patches.push({
            op: "replace",
            path: basepath.concat("length"),
            value: resultValue.length
        });
        for (var _i2 = shared; _i2 < baseValue.length; _i2++) {
            var _path2 = basepath.concat(_i2);
            inversePatches.push({ op: "add", path: _path2, value: baseValue[_i2] });
        }
    }
}

function generateObjectPatches(state, basepath, patches, inversePatches, baseValue, resultValue) {
    each(state.assigned, function (key, assignedValue) {
        var origValue = baseValue[key];
        var value = resultValue[key];
        var op = !assignedValue ? "remove" : key in baseValue ? "replace" : "add";
        if (origValue === baseValue && op === "replace") return;
        var path = basepath.concat(key);
        patches.push(op === "remove" ? { op: op, path: path } : { op: op, path: path, value: value });
        inversePatches.push(op === "add" ? { op: "remove", path: path } : op === "remove" ? { op: "add", path: path, value: origValue } : { op: "replace", path: path, value: origValue });
    });
}

function applyPatches(draft, patches) {
    var _loop = function _loop(i) {
        var patch = patches[i];
        if (patch.path.length === 0 && patch.op === "replace") {
            draft = patch.value;
        } else {
            var path = patch.path.slice();
            var key = path.pop();
            var base = path.reduce(function (current, part) {
                if (!current) throw new Error("Cannot apply patch, path doesn't resolve: " + patch.path.join("/"));
                return current[part];
            }, draft);
            if (!base) throw new Error("Cannot apply patch, path doesn't resolve: " + patch.path.join("/"));
            switch (patch.op) {
                case "replace":
                case "add":
                    // TODO: add support is not extensive, it does not support insertion or `-` atm!
                    base[key] = patch.value;
                    break;
                case "remove":
                    if (Array.isArray(base)) {
                        if (key === base.length - 1) base.length -= 1;else throw new Error("Remove can only remove the last key of an array, index: " + key + ", length: " + base.length);
                    } else delete base[key];
                    break;
                default:
                    throw new Error("Unsupported patch operation: " + patch.op);
            }
        }
    };

    for (var i = 0; i < patches.length; i++) {
        _loop(i);
    }
    return draft;
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};



















var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var NOTHING = typeof Symbol !== "undefined" ? Symbol("immer-nothing") : defineProperty({}, "immer-nothing", true);

var PROXY_STATE = typeof Symbol !== "undefined" ? Symbol("immer-proxy-state") : "__$immer_state";

var RETURNED_AND_MODIFIED_ERROR = "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.";

function verifyMinified() {}

var inProduction = typeof process !== "undefined" && "production" === "production" || verifyMinified.name !== "verifyMinified";

var autoFreeze = !inProduction;
var useProxies = typeof Proxy !== "undefined";

/**
 * Automatically freezes any state trees generated by immer.
 * This protects against accidental modifications of the state tree outside of an immer function.
 * This comes with a performance impact, so it is recommended to disable this option in production.
 * It is by default enabled.
 *
 * @returns {void}
 */
function setAutoFreeze(enableAutoFreeze) {
    autoFreeze = enableAutoFreeze;
}

function setUseProxies(value) {
    useProxies = value;
}

function getUseProxies() {
    return useProxies;
}

function isProxy(value) {
    return !!value && !!value[PROXY_STATE];
}

function isProxyable(value) {
    if (!value) return false;
    if ((typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object") return false;
    if (Array.isArray(value)) return true;
    var proto = Object.getPrototypeOf(value);
    return proto === null || proto === Object.prototype;
}

function freeze(value) {
    if (autoFreeze) {
        Object.freeze(value);
    }
    return value;
}

function original(value) {
    if (value && value[PROXY_STATE]) {
        return value[PROXY_STATE].base;
    }
    // otherwise return undefined
}

var assign = Object.assign || function assign(target, value) {
    for (var key in value) {
        if (has(value, key)) {
            target[key] = value[key];
        }
    }
    return target;
};

function shallowCopy(value) {
    if (Array.isArray(value)) return value.slice();
    var target = value.__proto__ === undefined ? Object.create(null) : {};
    return assign(target, value);
}

function each(value, cb) {
    if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            cb(i, value[i]);
        }
    } else {
        for (var key in value) {
            cb(key, value[key]);
        }
    }
}

function has(thing, prop) {
    return Object.prototype.hasOwnProperty.call(thing, prop);
}

// given a base object, returns it if unmodified, or return the changed cloned if modified
function finalize(base, path, patches, inversePatches) {
    if (isProxy(base)) {
        var state = base[PROXY_STATE];
        if (state.modified === true) {
            if (state.finalized === true) return state.copy;
            state.finalized = true;
            var result = finalizeObject(useProxies ? state.copy : state.copy = shallowCopy(base), state, path, patches, inversePatches);
            generatePatches(state, path, patches, inversePatches, state.base, result);
            return result;
        } else {
            return state.base;
        }
    }
    finalizeNonProxiedObject(base);
    return base;
}

function finalizeObject(copy, state, path, patches, inversePatches) {
    var base = state.base;
    each(copy, function (prop, value) {
        if (value !== base[prop]) {
            // if there was an assignment on this property, we don't need to generate
            // patches for the subtree
            var _generatePatches = patches && !has(state.assigned, prop);
            copy[prop] = finalize(value, _generatePatches && path.concat(prop), _generatePatches && patches, inversePatches);
        }
    });
    return freeze(copy);
}

function finalizeNonProxiedObject(parent) {
    // If finalize is called on an object that was not a proxy, it means that it is an object that was not there in the original
    // tree and it could contain proxies at arbitrarily places. Let's find and finalize them as well
    if (!isProxyable(parent)) return;
    if (Object.isFrozen(parent)) return;
    each(parent, function (i, child) {
        if (isProxy(child)) {
            parent[i] = finalize(child);
        } else finalizeNonProxiedObject(child);
    });
    // always freeze completely new data
    freeze(parent);
}



function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

// @ts-check

var proxies = null;

var objectTraps = {
    get: get$1,
    has: function has$$1(target, prop) {
        return prop in source(target);
    },
    ownKeys: function ownKeys(target) {
        return Reflect.ownKeys(source(target));
    },

    set: set$1,
    deleteProperty: deleteProperty,
    getOwnPropertyDescriptor: getOwnPropertyDescriptor,
    defineProperty: defineProperty$1,
    setPrototypeOf: function setPrototypeOf() {
        throw new Error("Immer does not support `setPrototypeOf()`.");
    }
};

var arrayTraps = {};
each(objectTraps, function (key, fn) {
    arrayTraps[key] = function () {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function (state, prop) {
    if (isNaN(parseInt(prop))) throw new Error("Immer does not support deleting properties from arrays: " + prop);
    return objectTraps.deleteProperty.call(this, state[0], prop);
};
arrayTraps.set = function (state, prop, value) {
    if (prop !== "length" && isNaN(parseInt(prop))) throw new Error("Immer does not support setting non-numeric properties on arrays: " + prop);
    return objectTraps.set.call(this, state[0], prop, value);
};

function createState(parent, base) {
    return {
        modified: false, // this tree is modified (either this object or one of it's children)
        assigned: {}, // true: value was assigned to these props, false: was removed
        finalized: false,
        parent: parent,
        base: base,
        copy: undefined,
        proxies: {}
    };
}

function source(state) {
    return state.modified === true ? state.copy : state.base;
}

function get$1(state, prop) {
    if (prop === PROXY_STATE) return state;
    if (state.modified) {
        var value = state.copy[prop];
        if (value === state.base[prop] && isProxyable(value))
            // only create proxy if it is not yet a proxy, and not a new object
            // (new objects don't need proxying, they will be processed in finalize anyway)
            return state.copy[prop] = createProxy(state, value);
        return value;
    } else {
        if (has(state.proxies, prop)) return state.proxies[prop];
        var _value = state.base[prop];
        if (!isProxy(_value) && isProxyable(_value)) return state.proxies[prop] = createProxy(state, _value);
        return _value;
    }
}

function set$1(state, prop, value) {
    // TODO: optimize
    state.assigned[prop] = true;
    if (!state.modified) {
        if (prop in state.base && is(state.base[prop], value) || has(state.proxies, prop) && state.proxies[prop] === value) return true;
        markChanged(state);
    }
    state.copy[prop] = value;
    return true;
}

function deleteProperty(state, prop) {
    state.assigned[prop] = false;
    markChanged(state);
    delete state.copy[prop];
    return true;
}

function getOwnPropertyDescriptor(state, prop) {
    var owner = state.modified ? state.copy : has(state.proxies, prop) ? state.proxies : state.base;
    var descriptor = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (descriptor && !(Array.isArray(owner) && prop === "length")) descriptor.configurable = true;
    return descriptor;
}

function defineProperty$1() {
    throw new Error("Immer does not support defining properties on draft objects.");
}

function markChanged(state) {
    if (!state.modified) {
        state.modified = true;
        state.copy = shallowCopy(state.base);
        // copy the proxies over the base-copy
        Object.assign(state.copy, state.proxies); // yup that works for arrays as well
        if (state.parent) markChanged(state.parent);
    }
}

// creates a proxy for plain objects / arrays
function createProxy(parentState, base, key) {
    if (isProxy(base)) throw new Error("Immer bug. Plz report.");
    var state = createState(parentState, base, key);
    var proxy = Array.isArray(base) ? Proxy.revocable([state], arrayTraps) : Proxy.revocable(state, objectTraps);
    proxies.push(proxy);
    return proxy.proxy;
}

function produceProxy(baseState, producer, patchListener) {
    if (isProxy(baseState)) {
        // See #100, don't nest producers
        var returnValue = producer.call(baseState, baseState);
        return returnValue === undefined ? baseState : returnValue;
    }
    var previousProxies = proxies;
    proxies = [];
    var patches = patchListener && [];
    var inversePatches = patchListener && [];
    try {
        // create proxy for root
        var rootProxy = createProxy(undefined, baseState);
        // execute the thunk
        var _returnValue = producer.call(rootProxy, rootProxy);
        // and finalize the modified proxy
        var result = void 0;
        // check whether the draft was modified and/or a value was returned
        if (_returnValue !== undefined && _returnValue !== rootProxy) {
            // something was returned, and it wasn't the proxy itself
            if (rootProxy[PROXY_STATE].modified) throw new Error(RETURNED_AND_MODIFIED_ERROR);

            // See #117
            // Should we just throw when returning a proxy which is not the root, but a subset of the original state?
            // Looks like a wrongly modeled reducer
            result = finalize(_returnValue);
            if (patches) {
                patches.push({ op: "replace", path: [], value: result });
                inversePatches.push({ op: "replace", path: [], value: baseState });
            }
        } else {
            result = finalize(rootProxy, [], patches, inversePatches);
        }
        // revoke all proxies
        each(proxies, function (_, p) {
            return p.revoke();
        });
        patchListener && patchListener(patches, inversePatches);
        return result;
    } finally {
        proxies = previousProxies;
    }
}

// @ts-check

var descriptors = {};
var states = null;

function createState$1(parent, proxy, base) {
    return {
        modified: false,
        assigned: {}, // true: value was assigned to these props, false: was removed
        hasCopy: false,
        parent: parent,
        base: base,
        proxy: proxy,
        copy: undefined,
        finished: false,
        finalizing: false,
        finalized: false
    };
}

function source$1(state) {
    return state.hasCopy ? state.copy : state.base;
}

function _get(state, prop) {
    assertUnfinished(state);
    var value = source$1(state)[prop];
    if (!state.finalizing && value === state.base[prop] && isProxyable(value)) {
        // only create a proxy if the value is proxyable, and the value was in the base state
        // if it wasn't in the base state, the object is already modified and we will process it in finalize
        prepareCopy(state);
        return state.copy[prop] = createProxy$1(state, value);
    }
    return value;
}

function _set(state, prop, value) {
    assertUnfinished(state);
    state.assigned[prop] = true; // optimization; skip this if there is no listener
    if (!state.modified) {
        if (is(source$1(state)[prop], value)) return;
        markChanged$1(state);
        prepareCopy(state);
    }
    state.copy[prop] = value;
}

function markChanged$1(state) {
    if (!state.modified) {
        state.modified = true;
        if (state.parent) markChanged$1(state.parent);
    }
}

function prepareCopy(state) {
    if (state.hasCopy) return;
    state.hasCopy = true;
    state.copy = shallowCopy(state.base);
}

// creates a proxy for plain objects / arrays
function createProxy$1(parent, base) {
    var proxy = shallowCopy(base);
    each(base, function (i) {
        Object.defineProperty(proxy, "" + i, createPropertyProxy("" + i));
    });
    var state = createState$1(parent, proxy, base);
    createHiddenProperty(proxy, PROXY_STATE, state);
    states.push(state);
    return proxy;
}

function createPropertyProxy(prop) {
    return descriptors[prop] || (descriptors[prop] = {
        configurable: true,
        enumerable: true,
        get: function get$$1() {
            return _get(this[PROXY_STATE], prop);
        },
        set: function set$$1(value) {
            _set(this[PROXY_STATE], prop, value);
        }
    });
}

function assertUnfinished(state) {
    if (state.finished === true) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(state.copy || state.base));
}

// this sounds very expensive, but actually it is not that expensive in practice
// as it will only visit proxies, and only do key-based change detection for objects for
// which it is not already know that they are changed (that is, only object for which no known key was changed)
function markChangesSweep() {
    // intentionally we process the proxies in reverse order;
    // ideally we start by processing leafs in the tree, because if a child has changed, we don't have to check the parent anymore
    // reverse order of proxy creation approximates this
    for (var i = states.length - 1; i >= 0; i--) {
        var state = states[i];
        if (state.modified === false) {
            if (Array.isArray(state.base)) {
                if (hasArrayChanges(state)) markChanged$1(state);
            } else if (hasObjectChanges(state)) markChanged$1(state);
        }
    }
}

function markChangesRecursively(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object") return;
    var state = object[PROXY_STATE];
    if (!state) return;
    var proxy = state.proxy,
        base = state.base;

    if (Array.isArray(object)) {
        if (hasArrayChanges(state)) {
            markChanged$1(state);
            state.assigned.length = true;
            if (proxy.length < base.length) for (var i = proxy.length; i < base.length; i++) {
                state.assigned[i] = false;
            } else for (var _i = base.length; _i < proxy.length; _i++) {
                state.assigned[_i] = true;
            }each(proxy, function (index, child) {
                if (!state.assigned[index]) markChangesRecursively(child);
            });
        }
    } else {
        var _diffKeys = diffKeys(base, proxy),
            added = _diffKeys.added,
            removed = _diffKeys.removed;

        if (added.length > 0 || removed.length > 0) markChanged$1(state);
        each(added, function (_, key) {
            state.assigned[key] = true;
        });
        each(removed, function (_, key) {
            state.assigned[key] = false;
        });
        each(proxy, function (key, child) {
            if (!state.assigned[key]) markChangesRecursively(child);
        });
    }
}

function diffKeys(from, to) {
    // TODO: optimize
    var a = Object.keys(from);
    var b = Object.keys(to);
    return {
        added: b.filter(function (key) {
            return a.indexOf(key) === -1;
        }),
        removed: a.filter(function (key) {
            return b.indexOf(key) === -1;
        })
    };
}

function hasObjectChanges(state) {
    var baseKeys = Object.keys(state.base);
    var keys = Object.keys(state.proxy);
    return !shallowEqual(baseKeys, keys);
}

function hasArrayChanges(state) {
    var proxy = state.proxy;

    if (proxy.length !== state.base.length) return true;
    // See #116
    // If we first shorten the length, our array interceptors will be removed.
    // If after that new items are added, result in the same original length,
    // those last items will have no intercepting property.
    // So if there is no own descriptor on the last position, we know that items were removed and added
    // N.B.: splice, unshift, etc only shift values around, but not prop descriptors, so we only have to check
    // the last one
    var descriptor = Object.getOwnPropertyDescriptor(proxy, proxy.length - 1);
    // descriptor can be null, but only for newly created sparse arrays, eg. new Array(10)
    if (descriptor && !descriptor.get) return true;
    // For all other cases, we don't have to compare, as they would have been picked up by the index setters
    return false;
}

function produceEs5(baseState, producer, patchListener) {
    if (isProxy(baseState)) {
        // See #100, don't nest producers
        var returnValue = producer.call(baseState, baseState);
        return returnValue === undefined ? baseState : returnValue;
    }
    var prevStates = states;
    states = [];
    var patches = patchListener && [];
    var inversePatches = patchListener && [];
    try {
        // create proxy for root
        var rootProxy = createProxy$1(undefined, baseState);
        // execute the thunk
        var _returnValue = producer.call(rootProxy, rootProxy);
        // and finalize the modified proxy
        each(states, function (_, state) {
            state.finalizing = true;
        });
        var result = void 0;
        // check whether the draft was modified and/or a value was returned
        if (_returnValue !== undefined && _returnValue !== rootProxy) {
            // something was returned, and it wasn't the proxy itself
            if (rootProxy[PROXY_STATE].modified) throw new Error(RETURNED_AND_MODIFIED_ERROR);
            result = finalize(_returnValue);
            if (patches) {
                patches.push({ op: "replace", path: [], value: result });
                inversePatches.push({ op: "replace", path: [], value: baseState });
            }
        } else {
            if (patchListener) markChangesRecursively(rootProxy);
            markChangesSweep(); // this one is more efficient if we don't need to know which attributes have changed
            result = finalize(rootProxy, [], patches, inversePatches);
        }
        // make sure all proxies become unusable
        each(states, function (_, state) {
            state.finished = true;
        });
        patchListener && patchListener(patches, inversePatches);
        return result;
    } finally {
        states = prevStates;
    }
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function createHiddenProperty(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        enumerable: false,
        writable: true
    });
}

/**
 * produce takes a state, and runs a function against it.
 * That function can freely mutate the state, as it will create copies-on-write.
 * This means that the original state will stay unchanged, and once the function finishes, the modified state is returned
 *
 * @export
 * @param {any} baseState - the state to start with
 * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
 * @param {Function} patchListener - optional function that will be called with all the patches produced here
 * @returns {any} a new state, or the base state if nothing was modified
 */
function produce(baseState, producer, patchListener) {
    // prettier-ignore
    if (arguments.length < 1 || arguments.length > 3) throw new Error("produce expects 1 to 3 arguments, got " + arguments.length);

    // curried invocation
    if (typeof baseState === "function") {
        // prettier-ignore
        if (typeof producer === "function") throw new Error("if first argument is a function (curried invocation), the second argument to produce cannot be a function");

        var initialState = producer;
        var recipe = baseState;

        return function () {
            var args = arguments;

            var currentState = args[0] === undefined && initialState !== undefined ? initialState : args[0];

            return produce(currentState, function (draft) {
                args[0] = draft; // blegh!
                return recipe.apply(draft, args);
            });
        };
    }

    // prettier-ignore
    {
        if (typeof producer !== "function") throw new Error("if first argument is not a function, the second argument to produce should be a function");
        if (patchListener !== undefined && typeof patchListener !== "function") throw new Error("the third argument of a producer should not be set or a function");
    }

    // if state is a primitive, don't bother proxying at all
    if ((typeof baseState === "undefined" ? "undefined" : _typeof(baseState)) !== "object" || baseState === null) {
        var returnValue = producer(baseState);
        return returnValue === undefined ? baseState : normalizeResult(returnValue);
    }

    if (!isProxyable(baseState)) throw new Error("the first argument to an immer producer should be a primitive, plain object or array, got " + (typeof baseState === "undefined" ? "undefined" : _typeof(baseState)) + ": \"" + baseState + "\"");
    return normalizeResult(getUseProxies() ? produceProxy(baseState, producer, patchListener) : produceEs5(baseState, producer, patchListener));
}

function normalizeResult(result) {
    return result === NOTHING ? undefined : result;
}

var applyPatches$1 = produce(applyPatches);

var nothing = NOTHING;


/* unused harmony default export */ var _unused_webpack_default_export = (produce);
//# sourceMappingURL=immer.module.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(118)))

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeepWith__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeepWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeepWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/**
 * Deep clones an entire object, except for React nodes, which are shallow
 * cloned. The internal state of a React node can contain objects that are
 * not cloneable, and using a clone of a React node in the DOM can confuse
 * React's internals (such as displaying unnecessary warnings about missing
 * key parameters).
 *
 * @param object The object to clone.
 * @returns object A clone of the given object, with all elements except for
 *                 valid React nodes deep cloned.
 */var safeCloneDeep=function safeCloneDeep(object){return __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeepWith___default()(object,function(value){if(__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(value)){return value;}});};/* harmony default export */ __webpack_exports__["a"] = (safeCloneDeep);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(424),
    baseKeysIn = __webpack_require__(820),
    isArrayLike = __webpack_require__(125);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 454 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(295),
    getPrototype = __webpack_require__(309),
    getSymbols = __webpack_require__(296),
    stubArray = __webpack_require__(436);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationFirstLevelCategory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigationFirstLevelItem__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavigationMegaMenuTitle__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_MaybeExternalLink__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_CustomNavigationLinkLocation__ = __webpack_require__(151);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationFirstLevelCategory=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationFirstLevelCategory,_Component);function NavigationFirstLevelCategory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationFirstLevelCategory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationFirstLevelCategory.__proto__||Object.getPrototypeOf(NavigationFirstLevelCategory)).call.apply(_ref,[this].concat(args))),_this),_this.getFirstLevelCustomNavigationItem=function(customNavLink){var _this$props=_this.props,onMouseOver=_this$props.onMouseOver,onClick=_this$props.onClick,hasManufacturers=_this$props.hasManufacturers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:customNavLink.id},_this.getSubNavCustomLinks(customNavLink,__WEBPACK_IMPORTED_MODULE_10__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NavigationFirstLevelItem__["a" /* default */],{key:customNavLink.id,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationMegaMenu__first-level-item'),hasManufacturers:hasManufacturers},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_MaybeExternalLink__["a" /* default */],{to:customNavLink.path,onClick:onClick,onMouseOver:onMouseOver,type:customNavLink.link_type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NavigationMegaMenuTitle__["a" /* default */],{entity:customNavLink}))),_this.getSubNavCustomLinks(customNavLink,__WEBPACK_IMPORTED_MODULE_10__types_CustomNavigationLinkLocation__["a" /* default */].BELOW));},_this.getSubNavCustomLinks=function(customNavLink,location){var _this$props2=_this.props,onSubEntityMouseOver=_this$props2.onSubEntityMouseOver,onClick=_this$props2.onClick,hasManufacturers=_this$props2.hasManufacturers;return customNavLink.customNavLinks&&customNavLink.customNavLinks.map(function(subCustomNavLink){return subCustomNavLink.location===location&&subCustomNavLink.parent_sibling_id===customNavLink.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:subCustomNavLink.id},_this.getSubNavCustomLinks(subCustomNavLink,__WEBPACK_IMPORTED_MODULE_10__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NavigationFirstLevelItem__["a" /* default */],{key:subCustomNavLink.id,className:'NavigationMegaMenu__first-level-item',hasManufacturers:hasManufacturers},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_MaybeExternalLink__["a" /* default */],{to:subCustomNavLink.path,onClick:onClick,onMouseOver:onSubEntityMouseOver,type:subCustomNavLink.link_type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NavigationMegaMenuTitle__["a" /* default */],{entity:subCustomNavLink}))),_this.getSubNavCustomLinks(subCustomNavLink,__WEBPACK_IMPORTED_MODULE_10__types_CustomNavigationLinkLocation__["a" /* default */].BELOW));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationFirstLevelCategory,[{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,entity=_props.entity,onMouseOver=_props.onMouseOver,onClick=_props.onClick,entityIndex=_props.entityIndex,hasManufacturers=_props.hasManufacturers;var customNavLinks=entity.customNavLinks;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,customNavLinks&&customNavLinks.map(function(customNavLink){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_10__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&customNavLink.parent_sibling_id===entity.id&&_this2.getFirstLevelCustomNavigationItem(customNavLink);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NavigationFirstLevelItem__["a" /* default */],{key:entity.id,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationMegaMenu__first-level-item',{'NavigationMegaMenu__first-level-item--open':entity.active}),hasManufacturers:hasManufacturers},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_MaybeExternalLink__["a" /* default */],{to:entity.path,onClick:onClick,onMouseOver:onMouseOver,type:entity.type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NavigationMegaMenuTitle__["a" /* default */],{entity:entity,entityIndex:entityIndex})),children),customNavLinks&&customNavLinks.map(function(customNavLink){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_10__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&customNavLink.parent_sibling_id===entity.id&&_this2.getFirstLevelCustomNavigationItem(customNavLink);}));}}]);return NavigationFirstLevelCategory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationFirstLevelCategory.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__["a" /* default */]).isRequired,entity:__WEBPACK_IMPORTED_MODULE_6__types_NavigationEntity__["a" /* default */],entityIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onMouseOver:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSubEntityMouseOver:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,hasManufacturers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore')(NavigationFirstLevelCategory));

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationSecondLevelCategory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkLocation__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigationSecondLevelItem__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationSecondLevelCategory=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationSecondLevelCategory,_Component);function NavigationSecondLevelCategory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationSecondLevelCategory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationSecondLevelCategory.__proto__||Object.getPrototypeOf(NavigationSecondLevelCategory)).call.apply(_ref,[this].concat(args))),_this),_this.getSecondLevelCustomNavigationItem=function(customNavLink,index){var onClick=_this.props.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:index},customNavLink.customNavLinks&&customNavLink.customNavLinks.map(function(subCustomNavLink){return subCustomNavLink.location===__WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&subCustomNavLink.parent_sibling_id===customNavLink.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NavigationSecondLevelItem__["a" /* default */],{key:subCustomNavLink.id,className:'NavigationSecondLevelItem__custom-second-level-item',entity:subCustomNavLink,onClick:onClick});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NavigationSecondLevelItem__["a" /* default */],{key:customNavLink.id,entity:customNavLink,onClick:onClick,className:'NavigationSecondLevelItem__custom-second-level-item'}),customNavLink.customNavLinks&&customNavLink.customNavLinks.map(function(subCustomNavLink){return subCustomNavLink.location===__WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&subCustomNavLink.parent_sibling_id===customNavLink.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NavigationSecondLevelItem__["a" /* default */],{key:subCustomNavLink.id,className:'NavigationSecondLevelItem__custom-second-level-item',entity:subCustomNavLink,onClick:onClick});}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationSecondLevelCategory,[{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,entity=_props.entity,onClick=_props.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,entity.customNavLinks&&entity.customNavLinks.map(function(customNavLink,index){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&customNavLink.parent_sibling_id===entity.id&&_this2.getSecondLevelCustomNavigationItem(customNavLink,index);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NavigationSecondLevelItem__["a" /* default */],{key:entity.id,entity:entity,onClick:onClick},children),entity.customNavLinks&&entity.customNavLinks.map(function(customNavLink,index){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_3__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&customNavLink.parent_sibling_id===entity.id&&_this2.getSecondLevelCustomNavigationItem(customNavLink,index);}));}}]);return NavigationSecondLevelCategory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationSecondLevelCategory.propTypes={entity:__WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__["a" /* default */],onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (NavigationSecondLevelCategory);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ManufacturerBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ManufacturerStore__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Autosuggest__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__manufacturer_ManufacturerLink__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* defineMessages */])({'manufacturer.chooseManufacturer':{'id':'manufacturer.chooseManufacturerPlaceholder','defaultMessage':'Choose brand...'}});var STYLES={DROPDOWN:'0',LIST:'1'};var ManufacturerBox=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ManufacturerBox,_Component);function ManufacturerBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ManufacturerBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ManufacturerBox.__proto__||Object.getPrototypeOf(ManufacturerBox)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:'',suggestions:[]},_this.maybeLoadManufacturers=function(){var manufacturerStore=_this.props.manufacturerStore;if(!manufacturerStore.loadedWithContent&&manufacturerStore.state===__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].NONE){manufacturerStore.loadManufacturers(false).then(function(){_this.updateManufacturers();});}if(manufacturerStore.state===__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADED){_this.updateManufacturers();}},_this.updateManufacturers=function(){var _this$props=_this.props,manufacturerStore=_this$props.manufacturerStore,twoLayerMegamenuEnabled=_this$props.twoLayerMegamenuEnabled;var manufacturers=manufacturerStore.manufacturersWithProducts;if(twoLayerMegamenuEnabled){manufacturers=_this.getMegaMenuManufacturers(manufacturers);}else{manufacturers=_this.getManufacturersByActiveSection(manufacturers);}_this.setState({manufacturers:manufacturers});twoLayerMegamenuEnabled&&_this.onManufacturersUpdates(manufacturers);},_this.getMegaMenuManufacturers=function(manufacturers){var _this$props2=_this.props,configStore=_this$props2.configStore,uiStore=_this$props2.uiStore;if(configStore.activateSections&&configStore.manufacturerBox.limitByActiveSection&&uiStore.megaMenu.activeSection){return _this.filterManufactursByActiveSectionId();}return manufacturers;},_this.getManufacturersByActiveSection=function(manufacturers){var _this$props3=_this.props,configStore=_this$props3.configStore,sectionStore=_this$props3.sectionStore;if(configStore.activateSections&&configStore.manufacturerBox.limitByActiveSection&&sectionStore.activeSection){return _this.filterManufactursByActiveSectionId();}return manufacturers;},_this.filterManufactursByActiveSectionId=function(){var manufacturerStore=_this.props.manufacturerStore;return manufacturerStore.manufacturersArray.filter(function(manufacturer){return manufacturer.belongsToSection(_this.getActiveSectionId());});},_this.getActiveSectionId=function(){var _this$props4=_this.props,sectionStore=_this$props4.sectionStore,uiStore=_this$props4.uiStore,twoLayerMegamenuEnabled=_this$props4.twoLayerMegamenuEnabled;if(twoLayerMegamenuEnabled){return uiStore.megaMenu.activeSection.id;}return sectionStore.activeSection.id;},_this.onChange=function(event,_ref2){var newValue=_ref2.newValue;_this.setState({value:newValue});},_this.getManufacturers=function(value){var manufacturers=_this.state.manufacturers;var searchValue=value.trim().toLowerCase();return searchValue===''?manufacturers:manufacturers.filter(function(manufacturer){return manufacturer.name.toLowerCase().startsWith(searchValue);});},_this.onSuggestionsFetchRequested=function(_ref3){var value=_ref3.value;_this.setState({suggestions:_this.getManufacturers(value)});},_this.onSuggestionsClearRequested=function(){_this.setState({suggestions:_this.getManufacturers('')});},_this.onSuggestionSelected=function(event,_ref4){var suggestion=_ref4.suggestion;var _this$props5=_this.props,history=_this$props5.history,routeService=_this$props5.routeService,onLinkClick=_this$props5.onLinkClick,twoLayerMegamenuEnabled=_this$props5.twoLayerMegamenuEnabled;history.push(routeService.getPath(suggestion.path));if(twoLayerMegamenuEnabled){onLinkClick();}},_this.renderManufacturerList=function(){var twoLayerMegamenuEnabled=_this.props.twoLayerMegamenuEnabled;if(twoLayerMegamenuEnabled){return _this.renderMegaMenuList();}return _this.renderList();},_this.renderList=function(){var manufacturers=_this.state.manufacturers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ManufacturerBox__list'},manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:manufacturer.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer}));}));},_this.renderMegaMenuList=function(){var manufacturers=_this.state.manufacturers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],{className:'ManufacturerBox__list-two-layer-megamenu'},manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:12,key:manufacturer.id,onClick:_this.props.onLinkClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer}));}));},_this.renderDropdown=function(){var intl=_this.props.intl;var _this$state=_this.state,value=_this$state.value,suggestions=_this$state.suggestions;var inputProps={placeholder:intl.formatMessage(messages['manufacturer.chooseManufacturer']),value:value,onChange:_this.onChange,className:'form-control'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Autosuggest__["a" /* default */],{id:'ManufacturerBox__Autosuggest',suggestions:suggestions,onSuggestionsFetchRequested:_this.onSuggestionsFetchRequested,onSuggestionsClearRequested:_this.onSuggestionsClearRequested,onSuggestionSelected:_this.onSuggestionSelected,getSuggestionValue:function getSuggestionValue(manufacturer){return manufacturer.id;},shouldRenderSuggestions:function shouldRenderSuggestions(){return true;},renderSuggestion:function renderSuggestion(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,manufacturer.name);},inputProps:inputProps,renderInputComponent:_this.renderInputComponent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerBox__all-link'},_this.renderLinkButton()));},_this.renderLinkButton=function(){var _this$props6=_this.props,routeService=_this$props6.routeService,linkButtonClassName=_this$props6.linkButtonClassName,onLinkClick=_this$props6.onLinkClick,twoLayerMegamenuEnabled=_this$props6.twoLayerMegamenuEnabled;if(twoLayerMegamenuEnabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_17__types_Paths__["a" /* default */].ManufacturerList)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:linkButtonClassName,color:'link',onClick:onLinkClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'manufacturer.seeAllBrands',defaultMessage:'See all brands'})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_17__types_Paths__["a" /* default */].ManufacturerList)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'manufacturer.seeAllBrands',defaultMessage:'See all brands'}));},_this.renderInputComponent=function(inputProps){var twoLayerMegamenuEnabled=_this.props.twoLayerMegamenuEnabled;if(twoLayerMegamenuEnabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerBox__two-layer-megamenu-brand-dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({},inputProps,{value:_this.state.value})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_Icon__["a" /* default */],{name:'caret-down'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({},inputProps,{value:_this.state.value}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ManufacturerBox,[{key:'componentDidMount',value:function componentDidMount(){this.maybeLoadManufacturers();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var manufacturerStore=this.props.manufacturerStore;if(manufacturerStore.state===__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADED&&!this.state.manufacturers){this.updateManufacturers();}}},{key:'onManufacturersUpdates',value:function onManufacturersUpdates(manufacturers){var onManufacturersUpdate=this.props.onManufacturersUpdate;onManufacturersUpdate&&onManufacturersUpdate(manufacturers);}},{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,manufacturerStore=_props.manufacturerStore,className=_props.className,minManufacturersForDropdown=_props.minManufacturersForDropdown,title=_props.title;var manufacturers=this.state.manufacturers;if(!manufacturerStore.manufacturersWithProducts||!manufacturers||manufacturers.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()('ManufacturerBox',className)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["j" /* CardHeader */],null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* CardBody */],null,manufacturers.length>minManufacturersForDropdown&&configStore.manufacturerBox.style===STYLES.DROPDOWN?this.renderDropdown():this.renderManufacturerList())));}}]);return ManufacturerBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ManufacturerBox.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_ConfigStore__["a" /* default */]).isRequired,manufacturerStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ManufacturerStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_15__services_RouteService__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_SectionStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_UIStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.history.isRequired,title:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,linkButtonClassName:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,minManufacturersForDropdown:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,twoLayerMegamenuEnabled:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,onLinkClick:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onManufacturersUpdate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};ManufacturerBox.defaultProps={minManufacturersForDropdown:1,twoLayerMegamenuEnabled:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','manufacturerStore','routeService','sectionStore','uiStore')(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(ManufacturerBox))));

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Autosuggest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autosuggest__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_autosuggest__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Autosuggest=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Autosuggest,_Component);function Autosuggest(){_classCallCheck(this,Autosuggest);return _possibleConstructorReturn(this,(Autosuggest.__proto__||Object.getPrototypeOf(Autosuggest)).apply(this,arguments));}_createClass(Autosuggest,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Autosuggest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_autosuggest___default.a,this.props));}}]);return Autosuggest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (Autosuggest);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(233);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(862),
    hasUnicode = __webpack_require__(234),
    unicodeToArray = __webpack_require__(863);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductSigns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductSignDiscount__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSignNew__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSigns=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductSigns,_Component);function ProductSigns(){_classCallCheck(this,ProductSigns);return _possibleConstructorReturn(this,(ProductSigns.__proto__||Object.getPrototypeOf(ProductSigns)).apply(this,arguments));}_createClass(ProductSigns,[{key:'render',value:function render(){var _props=this.props,dateAdded=_props.dateAdded,hasDiscount=_props.hasDiscount,discountProps=_props.discountProps,configStore=_props.configStore;var isNew=new Date()-new Date(dateAdded)<configStore.product.isNewForSeconds*1000;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductSigns'},hasDiscount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ProductSignDiscount__["a" /* default */],discountProps),isNew&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductSignNew__["a" /* default */],null));}}]);return ProductSigns;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductSigns.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,dateAdded:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,hasDiscount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,discountProps:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('configStore')(ProductSigns));

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductImageSign=function(_Component){_inherits(ProductImageSign,_Component);function ProductImageSign(){_classCallCheck(this,ProductImageSign);return _possibleConstructorReturn(this,(ProductImageSign.__proto__||Object.getPrototypeOf(ProductImageSign)).apply(this,arguments));}_createClass(ProductImageSign,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ProductSign"},this.props.children);}}]);return ProductImageSign;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProductImageSign);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(143),
    last = __webpack_require__(465),
    parent = __webpack_require__(881),
    toKey = __webpack_require__(145);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(885);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(886),
    shortOut = __webpack_require__(887);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProductAddedToCartModalStyle={MODAL:'MODAL',POPOVER:'POPOVER'};/* harmony default export */ __webpack_exports__["a"] = (ProductAddedToCartModalStyle);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getSmallToLargeImageRatio;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLargeToSmallImageRatio;
/* harmony export (immutable) */ __webpack_exports__["a"] = getContainerToImageRatio;

function getSmallToLargeImageRatio(smallImage, largeImage) {
    return getSmallToLargeElementRatio(smallImage, largeImage);
}

function getLargeToSmallImageRatio(smallImage, largeImage) {
    return {
        x: smallImage.width / largeImage.width,
        y: smallImage.height / largeImage.height
    };
}

function getContainerToImageRatio(container, image) {
    return getSmallToLargeElementRatio(container, {
        width: image.width - container.width,
        height: image.height - container.height
    });
}

function getSmallToLargeElementRatio(smallElement, largeElement) {
    return {
        x: largeElement.width / smallElement.width,
        y: largeElement.height / smallElement.height
    };
}

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EnlargedImagePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EnlargedImageContainerDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerDimensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(472);



var EnlargedImagePosition = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ENLARGED_IMAGE_POSITION */].beside, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ENLARGED_IMAGE_POSITION */].over]);

var EnlargedImageContainerDimensions = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
});

var ContainerDimensions = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INPUT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENLARGED_IMAGE_POSITION; });
var INPUT_TYPE = {
    mouse: 'mouse',
    touch: 'touch'
};

var ENLARGED_IMAGE_POSITION = {
    over: 'over',
    beside: 'beside'
};

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    y: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
}));

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getContainerStyle;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSmallImageStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = getEnlargedImageContainerStyle;
/* harmony export (immutable) */ __webpack_exports__["c"] = getEnlargedImageStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_deep_equal__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_deep_equal__);



function getContainerStyle(smallImage, userSpecifiedStyle) {
    var isSmallImageFluidWidth = smallImage.isFluidWidth,
        width = smallImage.width,
        height = smallImage.height;


    var fluidWidthContainerStyle = {
        width: 'auto',
        height: 'auto',
        fontSize: '0px',
        position: 'relative'
    };

    var fixedWidthContainerStyle = {
        width: width + 'px',
        height: height + 'px',
        position: 'relative'
    };

    var priorityContainerStyle = isSmallImageFluidWidth ? fluidWidthContainerStyle : fixedWidthContainerStyle;

    var compositContainerStyle = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({ cursor: 'crosshair' }, userSpecifiedStyle, priorityContainerStyle);

    return compositContainerStyle;
}

function getSmallImageStyle(smallImage, style) {
    var isSmallImageFluidWidth = smallImage.isFluidWidth,
        width = smallImage.width,
        height = smallImage.height;


    var fluidWidthSmallImageStyle = {
        width: '100%',
        height: 'auto',
        display: 'block',
        pointerEvents: 'none'
    };

    var fixedWidthSmallImageStyle = {
        width: width + 'px',
        height: height + 'px',
        pointerEvents: 'none'
    };

    var prioritySmallImageStyle = isSmallImageFluidWidth ? fluidWidthSmallImageStyle : fixedWidthSmallImageStyle;

    var compositSmallImageStyle = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, style, prioritySmallImageStyle);

    return compositSmallImageStyle;
}

function getPrimaryEnlargedImageContainerStyle(isInPlaceMode, isPortalRendered) {
    var baseContainerStyle = {
        overflow: 'hidden'
    };

    if (isPortalRendered) {
        return baseContainerStyle;
    }

    var sharedPositionStyle = {
        position: 'absolute',
        top: '0px'
    };

    if (isInPlaceMode) {
        return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(baseContainerStyle, sharedPositionStyle, { left: '0px' });
    }

    return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(baseContainerStyle, sharedPositionStyle, {
        left: '100%',
        marginLeft: '10px',
        border: '1px solid #d6d6d6'
    });
}

function getPriorityEnlargedImageContainerStyle(params) {
    var containerDimensions = params.containerDimensions,
        fadeDurationInMs = params.fadeDurationInMs,
        isTransitionActive = params.isTransitionActive;


    return {
        width: containerDimensions.width,
        height: containerDimensions.height,
        opacity: isTransitionActive ? 1 : 0,
        transition: 'opacity ' + fadeDurationInMs + 'ms ease-in',
        pointerEvents: 'none'
    };
}

var enlargedImageContainerStyleCache = {};

function getEnlargedImageContainerStyle(params) {
    var cache = enlargedImageContainerStyleCache;
    var _cache$params = cache.params,
        memoizedParams = _cache$params === undefined ? {} : _cache$params,
        memoizedStyle = cache.compositStyle;


    if (__WEBPACK_IMPORTED_MODULE_1_fast_deep_equal___default()(memoizedParams, params)) {
        return memoizedStyle;
    }

    var containerDimensions = params.containerDimensions,
        userSpecifiedStyle = params.containerStyle,
        fadeDurationInMs = params.fadeDurationInMs,
        isTransitionActive = params.isTransitionActive,
        isInPlaceMode = params.isInPlaceMode,
        isPortalRendered = params.isPortalRendered;


    var primaryStyle = getPrimaryEnlargedImageContainerStyle(isInPlaceMode, isPortalRendered);
    var priorityStyle = getPriorityEnlargedImageContainerStyle({
        containerDimensions: containerDimensions,
        fadeDurationInMs: fadeDurationInMs,
        isTransitionActive: isTransitionActive
    });

    cache.compositStyle = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, primaryStyle, userSpecifiedStyle, priorityStyle);
    cache.params = params;

    return cache.compositStyle;
}

function getEnlargedImageStyle(params) {
    var imageCoordinates = params.imageCoordinates,
        userSpecifiedStyle = params.imageStyle,
        largeImage = params.largeImage;


    var translate = 'translate(' + imageCoordinates.x + 'px, ' + imageCoordinates.y + 'px)';

    var priorityStyle = {
        width: largeImage.width,
        height: largeImage.height,
        transform: translate,
        WebkitTransform: translate,
        msTransform: translate,
        pointerEvents: 'none'
    };

    var compositeImageStyle = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, userSpecifiedStyle, priorityStyle);

    return compositeImageStyle;
}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImagePreload=function(_Component){_inherits(ImagePreload,_Component);function ImagePreload(){_classCallCheck(this,ImagePreload);return _possibleConstructorReturn(this,(ImagePreload.__proto__||Object.getPrototypeOf(ImagePreload)).apply(this,arguments));}_createClass(ImagePreload,[{key:'render',value:function render(){var _props=this.props,onImageLoad=_props.onImageLoad,src=_props.src;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ImagePreload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{onLoad:onImageLoad,src:src,alt:''}));}}]);return ImagePreload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ImagePreload.propTypes={src:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onImageLoad:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ImagePreload);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContentSlot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_MaybeExternalLink__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Ad__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__ = __webpack_require__(72);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentSlot=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ContentSlot,_Component);function ContentSlot(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContentSlot);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContentSlot.__proto__||Object.getPrototypeOf(ContentSlot)).call.apply(_ref,[this].concat(args))),_this),_this.sendView=function(){var _this$props=_this.props,analytics=_this$props.analytics,bannerZone=_this$props.bannerZone,ad=_this$props.ad;if(!ad){return;}analytics.promoView([{bannerZone:bannerZone,banner:ad}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContentSlot,[{key:'componentWillMount',value:function componentWillMount(){this.sendView();}},{key:'render',value:function render(){var _props=this.props,ad=_props.ad,className=_props.className;if(!ad){return null;}if(ad.link_url){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('ContentSlot',className,{ContentSlot__link:ad.link_url})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_MaybeExternalLink__["a" /* default */],{to:ad.link_url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:ad.content})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('ContentSlot',className)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:ad.content}));}}]);return ContentSlot;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ContentSlot.propTypes={ad:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Ad__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6__analytics_Analytics__["a" /* default */]).isRequired,bannerZone:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('analytics')(ContentSlot));

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(398);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationAssistButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_MobileNavigationButton__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_MobileNavigationTab__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationAssistButton=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationAssistButton,_Component);function NavigationAssistButton(){_classCallCheck(this,NavigationAssistButton);return _possibleConstructorReturn(this,(NavigationAssistButton.__proto__||Object.getPrototypeOf(NavigationAssistButton)).apply(this,arguments));}_createClass(NavigationAssistButton,[{key:'render',value:function render(){var _props=this.props,bottom=_props.bottom,tab=_props.tab,intl=_props.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()('NavigationAssistButton',{NavigationAssistButton__bottom:bottom})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__header_MobileNavigationButton__["a" /* default */],{tab:tab,ariaLabel:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].seeCategoriesNavi)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */],{name:'bars',className:'NavigationAssistButton__icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].seeCategoriesNavi)));}}]);return NavigationAssistButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationAssistButton.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,bottom:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,tab:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(Object.values(__WEBPACK_IMPORTED_MODULE_5__types_MobileNavigationTab__["b" /* default */]))};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(NavigationAssistButton));

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MobileNavigationButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_MobileNavigationTab__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MobileNavigationButton=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MobileNavigationButton,_Component);function MobileNavigationButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MobileNavigationButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MobileNavigationButton.__proto__||Object.getPrototypeOf(MobileNavigationButton)).call.apply(_ref,[this].concat(args))),_this),_this.toggleMenu=function(){var forceClose=_this.props.forceClose;var navigation=_this.props.uiStore.mobileNavigation;var isTabChange=_this.props.tab!==navigation.activeTab;if(forceClose){navigation.close();}else if(isTabChange){navigation.selectTab(_this.props.tab);navigation.open();}else{navigation.toggle();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MobileNavigationButton,[{key:'render',value:function render(){var _props=this.props,className=_props.className,children=_props.children,withBorder=_props.withBorder,ariaLabel=_props.ariaLabel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('MobileNavigationButton',className,{'MobileNavigationButton--with-border':withBorder}),color:'plain',onClick:this.toggleMenu,'aria-label':ariaLabel},children);}}]);return MobileNavigationButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MobileNavigationButton.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_UIStore__["a" /* default */]).isRequired,tab:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(Object.values(__WEBPACK_IMPORTED_MODULE_7__types_MobileNavigationTab__["b" /* default */])),className:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,withBorder:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,forceClose:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,ariaLabel:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};MobileNavigationButton.defaultProps={className:'',withBorder:false,forceClose:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('uiStore')(MobileNavigationButton));

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TfIdfSearchIndex = __webpack_require__(942);

Object.defineProperty(exports, 'TfIdfSearchIndex', {
  enumerable: true,
  get: function get() {
    return _TfIdfSearchIndex.TfIdfSearchIndex;
  }
});

var _UnorderedSearchIndex = __webpack_require__(943);

Object.defineProperty(exports, 'UnorderedSearchIndex', {
  enumerable: true,
  get: function get() {
    return _UnorderedSearchIndex.UnorderedSearchIndex;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getNestedFieldValue;
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */
function getNestedFieldValue(object, path) {
  path = path || [];
  object = object || {};

  var value = object;

  // walk down the property path
  for (var i = 0; i < path.length; i++) {
    value = value[path[i]];

    if (value == null) {
      return null;
    }
  }

  return value;
}
//# sourceMappingURL=getNestedFieldValue.js.map

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleTokenizer = __webpack_require__(944);

Object.defineProperty(exports, 'SimpleTokenizer', {
  enumerable: true,
  get: function get() {
    return _SimpleTokenizer.SimpleTokenizer;
  }
});

var _StemmingTokenizer = __webpack_require__(945);

Object.defineProperty(exports, 'StemmingTokenizer', {
  enumerable: true,
  get: function get() {
    return _StemmingTokenizer.StemmingTokenizer;
  }
});

var _StopWordsTokenizer = __webpack_require__(946);

Object.defineProperty(exports, 'StopWordsTokenizer', {
  enumerable: true,
  get: function get() {
    return _StopWordsTokenizer.StopWordsTokenizer;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var StopWordsMap = exports.StopWordsMap = {
  a: true,
  able: true,
  about: true,
  across: true,
  after: true,
  all: true,
  almost: true,
  also: true,
  am: true,
  among: true,
  an: true,
  and: true,
  any: true,
  are: true,
  as: true,
  at: true,
  be: true,
  because: true,
  been: true,
  but: true,
  by: true,
  can: true,
  cannot: true,
  could: true,
  dear: true,
  did: true,
  'do': true,
  does: true,
  either: true,
  'else': true,
  ever: true,
  every: true,
  'for': true,
  from: true,
  'get': true,
  got: true,
  had: true,
  has: true,
  have: true,
  he: true,
  her: true,
  hers: true,
  him: true,
  his: true,
  how: true,
  however: true,
  i: true,
  'if': true,
  'in': true,
  into: true,
  is: true,
  it: true,
  its: true,
  just: true,
  least: true,
  let: true,
  like: true,
  likely: true,
  may: true,
  me: true,
  might: true,
  most: true,
  must: true,
  my: true,
  neither: true,
  no: true,
  nor: true,
  not: true,
  of: true,
  off: true,
  often: true,
  on: true,
  only: true,
  or: true,
  other: true,
  our: true,
  own: true,
  rather: true,
  said: true,
  say: true,
  says: true,
  she: true,
  should: true,
  since: true,
  so: true,
  some: true,
  than: true,
  that: true,
  the: true,
  their: true,
  them: true,
  then: true,
  there: true,
  these: true,
  they: true,
  'this': true,
  tis: true,
  to: true,
  too: true,
  twas: true,
  us: true,
  wants: true,
  was: true,
  we: true,
  were: true,
  what: true,
  when: true,
  where: true,
  which: true,
  'while': true,
  who: true,
  whom: true,
  why: true,
  will: true,
  'with': true,
  would: true,
  yet: true,
  you: true,
  your: true
};

// Prevent false positives for inherited properties
StopWordsMap.constructor = false;
StopWordsMap.hasOwnProperty = false;
StopWordsMap.isPrototypeOf = false;
StopWordsMap.propertyIsEnumerable = false;
StopWordsMap.toLocaleString = false;
StopWordsMap.toString = false;
StopWordsMap.valueOf = false;
//# sourceMappingURL=StopWordsMap.js.map

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_SortOrder__ = __webpack_require__(95);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var SuggestionStore=__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].model('SuggestionStore',{state:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["a" /* RequestStateType */],__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED)}).actions(function(self){var source=void 0;var env=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self);var suggestionResultsCache=[];var popularSearches=[];var popularSearchesLoaded=false;var addToCache=function addToCache(text,products,suggestions,total){suggestionResultsCache.unshift({text:text,products:products,suggestions:suggestions,total:total});suggestionResultsCache=suggestionResultsCache.slice(0,20);};var findFromCache=function findFromCache(text){return suggestionResultsCache.find(function(result){return result.text===text;});};var ifShoppingCenter=function ifShoppingCenter(){return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore.siteConfig.isShoppingCenter;};var baseApi=function baseApi(endpoint){return ifShoppingCenter()?'shopping-center/'+endpoint:''+endpoint;};return{suggest:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function suggest(text){var count=arguments.length>1&&arguments[1]!==undefined?arguments[1]:3;var _getRoot,configStore,inStock,cacheResult,defaultSection,suggestions,_ref,_ref2,productsResult,_suggestions,_getRoot2,productStore,total,products;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function suggest$(_context){while(1){switch(_context.prev=_context.next){case 0:_getRoot=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self),configStore=_getRoot.configStore;inStock=configStore.inStockProductsOnly?'1':'0';cacheResult=findFromCache(text);if(!(cacheResult&&!ifShoppingCenter())){_context.next=5;break;}return _context.abrupt('return',{suggestions:cacheResult.suggestions,products:cacheResult.products,total:cacheResult.total});case 5:self.state=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING;// If we already have a query running, cancel it.
if(source){source.cancel();}source=__WEBPACK_IMPORTED_MODULE_2_axios__["CancelToken"].source();defaultSection=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self).configStore.defaultSection;if(!(count<=0)){_context.next=25;break;}_context.prev=10;_context.next=13;return env.apiWrapper.request(baseApi('auto-complete')+'?'+Object(__WEBPACK_IMPORTED_MODULE_4__util_queryString__["c" /* stringify */])({q:text}),{cancelToken:source.token},{active_section:defaultSection});case 13:suggestions=_context.sent;addToCache(text,[],suggestions,0);self.state=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED;return _context.abrupt('return',{suggestions:suggestions,products:[],total:0});case 19:_context.prev=19;_context.t0=_context['catch'](10);if(!__WEBPACK_IMPORTED_MODULE_2_axios___default.a.isCancel(_context.t0)){self.state=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR;}throw _context.t0;case 23:_context.next=44;break;case 25:_context.prev=25;_context.next=28;return Promise.all([env.apiWrapper.request(baseApi('products')+'?'+Object(__WEBPACK_IMPORTED_MODULE_4__util_queryString__["c" /* stringify */])({text:text,inStock:inStock,resultsPerPage:count,includeFilters:0,orderBy:__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].RELEVANCE,order:__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].DESC}),{cancelToken:source.token},{active_section:defaultSection}),env.apiWrapper.request(baseApi('auto-complete')+'?'+Object(__WEBPACK_IMPORTED_MODULE_4__util_queryString__["c" /* stringify */])({q:text}),{cancelToken:source.token},{active_section:defaultSection})]);case 28:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);productsResult=_ref2[0];_suggestions=_ref2[1];_getRoot2=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["g" /* getRoot */])(self),productStore=_getRoot2.productStore;total=productsResult.total;products=productsResult.data.map(function(product){productStore.updateProduct(product);return productStore.products.get(product.id);});addToCache(text,products,_suggestions,total);self.state=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED;return _context.abrupt('return',{suggestions:_suggestions,products:products,total:total});case 40:_context.prev=40;_context.t1=_context['catch'](25);if(!__WEBPACK_IMPORTED_MODULE_2_axios___default.a.isCancel(_context.t1)){self.state=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR;}throw _context.t1;case 44:case'end':return _context.stop();}}},suggest,this,[[10,19],[25,40]]);})),getPopularSearches:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getPopularSearches(){var popularSearchesResult;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPopularSearches$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!popularSearchesLoaded){_context2.next=2;break;}return _context2.abrupt('return',popularSearches);case 2:self.state=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADING;_context2.prev=3;_context2.next=6;return Promise.resolve(env.apiWrapper.request('popular-searches?'+Object(__WEBPACK_IMPORTED_MODULE_4__util_queryString__["c" /* stringify */])({limit:10})));case 6:popularSearchesResult=_context2.sent;popularSearches=popularSearchesResult;popularSearchesLoaded=true;self.state=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].LOADED;return _context2.abrupt('return',popularSearches);case 13:_context2.prev=13;_context2.t0=_context2['catch'](3);self.state=__WEBPACK_IMPORTED_MODULE_3__types_RequestState__["b" /* default */].ERROR;throw _context2.t0;case 17:case'end':return _context2.stop();}}},getPopularSearches,this,[[3,13]]);}))};});/* harmony default export */ __webpack_exports__["a"] = (SuggestionStore);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

exports.arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

exports.isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(144),
    baseIteratee = __webpack_require__(84),
    baseMap = __webpack_require__(449),
    baseSortBy = __webpack_require__(954),
    baseUnary = __webpack_require__(148),
    compareMultiple = __webpack_require__(955),
    identity = __webpack_require__(149);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(149),
    overRest = __webpack_require__(466),
    setToString = __webpack_require__(467);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(957),
    baseEvery = __webpack_require__(958),
    baseIteratee = __webpack_require__(84),
    isArray = __webpack_require__(47),
    isIterateeCall = __webpack_require__(150);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_minBy__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChildProduct__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductProperty__ = __webpack_require__(323);
var ProductMulti=__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].model('ProductMulti',{properties:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__ProductProperty__["a" /* default */]),children:__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2_mobx_state_tree__["l" /* types */].late(__WEBPACK_IMPORTED_MODULE_3__ChildProduct__["a" /* default */]))}).actions(function(self){return{setChildren:function setChildren(children){self.children=children;}};}).views(function(self){return{findChildWithProperties:function findChildWithProperties(propertyElementMap){return self.children.find(function(childProduct){return childProduct.hasProperties(propertyElementMap);});},findChild:function findChild(activeProductId){return self.children.find(function(child){return child.id===activeProductId;});},getChildIdentifiers:function getChildIdentifiers(){return self.children.map(function(child){return child.id;});},getChildWithBestDiscount:function getChildWithBestDiscount(){return __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy___default()(self.children,'price_info.discount_percentage');},getMinMaxPrice:function getMinMaxPrice(withTax){var getPrice=function getPrice(childProduct){return childProduct.price_info?childProduct.price_info.getPrice(withTax):function(){};};var minProduct=__WEBPACK_IMPORTED_MODULE_0_lodash_minBy___default()(self.children,getPrice);var maxProduct=__WEBPACK_IMPORTED_MODULE_1_lodash_maxBy___default()(self.children,getPrice);return{min:minProduct?minProduct.price_info:0.0,max:maxProduct?maxProduct.price_info:0.0};},getPropertyElementStatus:function getPropertyElementStatus(propertyElementMap){var status={exists:false,available:false};// Check if we have any children with the given properties and if they are available
var matchingChildren=self.children.filter(function(currentChild){return currentChild.hasProperties(propertyElementMap);});if(matchingChildren.length>0){status.exists=true;}status.available=matchingChildren.some(function(currentChild){return currentChild.free_quantity>0;});return status;},getSecondaryPriceRange:function getSecondaryPriceRange(withTax){return self.getMinMaxPrice(withTax);},get priceRange(){return self.getMinMaxPrice();}};});/* harmony default export */ __webpack_exports__["a"] = (ProductMulti);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(138);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Stock=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Stock',{storage_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,free_quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,count_availability:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,is_pickup_storage:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,last_arrival_date:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),last_date_sold:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),last_modified:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),real_stock:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,reserved_quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,shelf_location:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),stock_label:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (Stock);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShippingSelectionFieldTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ShippingSelectionFieldType={DROPDOWN_MENU:'DROPDOWN_MENU',TEXT_FIELD:'TEXT_FIELD',RADIO_BUTTON:'RADIO_BUTTON'};/* harmony default export */ __webpack_exports__["b"] = (ShippingSelectionFieldType);var ShippingSelectionFieldTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ShippingSelectionFieldTypeType',Object.values(ShippingSelectionFieldType));

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ShippingSelectionFieldOption=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ShippingSelectionFieldOption',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (ShippingSelectionFieldOption);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductShippingClassType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductShippingClass={PICKUP:'PICKUP',DELIVERY:'DELIVERY'};/* harmony default export */ __webpack_exports__["b"] = (ProductShippingClass);var ProductShippingClassType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductShippingClass',Object.values(ProductShippingClass));

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShippingCampaignTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ShippingCampaignType={FIXED_PRICE:'FIXED_PRICE',FREE_SHIPPING:'FREE_SHIPPING',TOTAL_SUM_TABLE:'TOTAL_SUM_TABLE',TOTAL_WEIGHT_TABLE:'TOTAL_WEIGHT_TABLE',PRODUCT_QUANTITY_TABLE:'PRODUCT_QUANTITY_TABLE',TOTAL_VOLUME_TABLE:'TOTAL_VOLUME_TABLE'};/* harmony default export */ __webpack_exports__["b"] = (ShippingCampaignType);var ShippingCampaignTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ShippingCampaignType',Object.values(ShippingCampaignType));

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PropertyImageLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var PropertyImageLabel=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PropertyImageLabel',{label_text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),label_value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});var PropertyImage=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PropertyImage',{name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),display_style:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,placement:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,property_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].integer),property_value_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].integer),position:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,label_background:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),label_fontcolor:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),show_on_product_listings:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,show_on_product_card:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,label:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(PropertyImageLabel)});/* harmony default export */ __webpack_exports__["b"] = (PropertyImage);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AcceptableTermsTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var AcceptableTermsType={DELIVERY_TERMS:'DELIVERY_TERMS',PRIVACY_TERMS:'PRIVACY_TERMS'};/* harmony default export */ __webpack_exports__["b"] = (AcceptableTermsType);var AcceptableTermsTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('AcceptableTermsType',Object.values(AcceptableTermsType));

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductRecurringOrderTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductRecurringOrderType={NOT_ALLOWED:'NOT_ALLOWED',NORMAL_AND_RECURRING_ALLOWED:'NORMAL_AND_RECURRING_ALLOWED',RECURRING_ORDERS_ONLY:'RECURRING_ORDERS_ONLY'};/* harmony default export */ __webpack_exports__["b"] = (ProductRecurringOrderType);var ProductRecurringOrderTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductRecurringOrderType',Object.values(ProductRecurringOrderType));

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var OrderMethod=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrderMethod',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),logo:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')});/* harmony default export */ __webpack_exports__["a"] = (OrderMethod);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var OrderAddress=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrderAddress',{care_of:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),city:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),company:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),country_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),email:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),postalcode:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),street_address:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),street_address2:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),telephone:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')});/* harmony default export */ __webpack_exports__["a"] = (OrderAddress);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_SearchRedirection__ = __webpack_require__(988);
var SearchRedirectionStore=__WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__["a" /* default */].named('SearchRedirectionStore').props({redirections:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__models_SearchRedirection__["a" /* default */]),[])}).actions(function(self){return{setup:function setup(redirections){self.redirections=redirections;},getRedirection:function getRedirection(searchTerm){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=self.redirections[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var redirection=_step.value;// For some reason, .find doesn't work with MSTArray.
var maybeResult=redirection.search_terms.map(function(term){return term.toLowerCase();}).includes(searchTerm.toLowerCase());if(maybeResult){return redirection;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return null;}};});/* harmony default export */ __webpack_exports__["a"] = (SearchRedirectionStore);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Breadcrumbs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_BreadcrumbPath__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__head_SEOSchema__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_LocationContext__ = __webpack_require__(128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Breadcrumbs=function(_Component){_inherits(Breadcrumbs,_Component);function Breadcrumbs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Breadcrumbs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Breadcrumbs.__proto__||Object.getPrototypeOf(Breadcrumbs)).call.apply(_ref,[this].concat(args))),_this),_this.getSchemaData=function(){var itemListSchema=_this.getItemListSchema();return{'@context':'https://schema.org/','@type':'BreadcrumbList',itemListElement:itemListSchema,numberOfItems:itemListSchema.length};},_this.getItemListSchema=function(){var _this$props=_this.props,locationContext=_this$props.locationContext,intl=_this$props.intl;var baseUrlSchema=locationContext.protocol+'//'+locationContext.host;var rootListItemSchema={'@type':'ListItem',name:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].homeTitle),item:baseUrlSchema+'/',position:1};return[rootListItemSchema].concat(_toConsumableArray(_this.getListItemSchemas()));},_this.getListItemSchemas=function(){var _this$props2=_this.props,locationContext=_this$props2.locationContext,path=_this$props2.path;var baseUrlSchema=locationContext.protocol+'//'+locationContext.host;return path.map(function(item,index){return{'@type':'ListItem',name:item.text,item:''+baseUrlSchema+(item.url?item.url:item.text),position:index+2};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Breadcrumbs,[{key:'render',value:function render(){var path=this.props.path;var items=path.map(function(item,index){var itemTextInner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.text);var itemText=item.url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:item.url},itemTextInner):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,itemTextInner);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* BreadcrumbItem */],{key:index+'_'+item.text,active:index===path.length-1},itemText);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Breadcrumbs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__head_SEOSchema__["a" /* default */],{data:this.getSchemaData()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Breadcrumb */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* BreadcrumbItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */],{name:'home'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sr-only'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].homeTitle)))),items));}}]);return Breadcrumbs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Breadcrumbs.propTypes={path:__WEBPACK_IMPORTED_MODULE_5__types_BreadcrumbPath__["a" /* default */].isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,locationContext:__WEBPACK_IMPORTED_MODULE_9__services_LocationContext__["a" /* LocationContextPropType */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('locationContext')(Breadcrumbs)));

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({url:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,text:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired})));

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(1005);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductCollectionPropertySelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_ProductProperty__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_ProductPropertyElement__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_ProductAvailabilityType__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["d" /* defineMessages */])({soldOut:{'id':'stock.soldOut','defaultMessage':'Sold out'},notAvailable:{'id':'stock.notAvailable','defaultMessage':'Not available'},temporarilyOutOfStock:{'id':'stock.temporarilyOutOfStock','defaultMessage':'Temporarily out of stock'}});var ProductCollectionPropertySelect=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductCollectionPropertySelect,_Component);function ProductCollectionPropertySelect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductCollectionPropertySelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductCollectionPropertySelect.__proto__||Object.getPrototypeOf(ProductCollectionPropertySelect)).call.apply(_ref,[this].concat(args))),_this),_this.onSelectChange=function(event){var id=Number(event.target.value);_this.props.onPropertySelect(_this.props.property.getElementWithId(id));},_this.onButtonClick=function(id){var _this$props=_this.props,activeElementId=_this$props.activeElementId,onPropertySelect=_this$props.onPropertySelect,property=_this$props.property;var newElement=null;if(!activeElementId||activeElementId!==id){newElement=property.getElementWithId(id);}onPropertySelect(newElement);},_this.elementIsActive=function(id){var activeElementId=_this.props.activeElementId;return id===activeElementId;},_this.getProductCollectionImages=function(){var _this$props2=_this.props,product=_this$props2.product,productImages=_this$props2.productImages,elementsWithAvailability=_this$props2.elementsWithAvailability;var productImageDict=__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(productImages,'for_color_id');var someElementHasImage=__WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(elementsWithAvailability,function(_ref2){var element=_ref2.element;return!!productImageDict[element.id];});if(!someElementHasImage){return null;}var images=elementsWithAvailability.map(function(_ref3){var element=_ref3.element,available=_ref3.available;var isActive=_this.elementIsActive(element.id);var productImageForElement=productImageDict[element.id];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:element.id,className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()('ProductCollectionPropertySelect__image',{'ProductCollectionPropertySelect__image--active':isActive,'ProductCollectionPropertySelect__image--not-available':!available,'ProductCollectionPropertySelect__image--empty-image':!productImageForElement}),onClick:function onClick(){return _this.onButtonClick(element.id);}},productImageForElement?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ProductImage__["a" /* default */],{product:product,productImage:productImageForElement,size:'small',lazyLoading:false}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,element.name));});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCollectionPropertySelect__images'},images);},_this.getDropdown=function(){var _this$props3=_this.props,product=_this$props3.product,property=_this$props3.property,activeElementId=_this$props3.activeElementId,elementsWithAvailability=_this$props3.elementsWithAvailability,intl=_this$props3.intl,disabled=_this$props3.disabled,hidden=_this$props3.hidden;var inputId='property-'+property.id;var value=activeElementId?activeElementId:'';var options=elementsWithAvailability.map(function(_ref4){var element=_ref4.element,available=_ref4.available,disabled=_ref4.disabled;var statusMessage='';if(disabled){statusMessage=intl.formatMessage(messages.notAvailable);}else if(!available){if(product.availability_type===__WEBPACK_IMPORTED_MODULE_14__types_ProductAvailabilityType__["b" /* default */].CLOSEOUT){statusMessage=intl.formatMessage(messages.soldOut);}else if(product.can_be_ordered_out_of_stock){statusMessage='';}else{statusMessage=intl.formatMessage(messages.temporarilyOutOfStock);}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option',{key:element.id,value:element.id,disabled:disabled},element.name,' ',statusMessage&&'('+statusMessage+')');});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["z" /* Label */],{'for':inputId,hidden:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].propertyChooseTitle,{values:{property:property.name.toLowerCase()}}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["v" /* Input */],{type:'select',name:inputId,id:inputId,onChange:_this.onSelectChange,value:value,disabled:disabled,hidden:hidden},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option',{value:null},intl.formatMessage(__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].propertyChooseTitle,{property:property.placeholder})),options));},_this.getButtons=function(){var elementsWithAvailability=_this.props.elementsWithAvailability;var buttons=elementsWithAvailability.map(function(_ref5){var element=_ref5.element,available=_ref5.available,disabled=_ref5.disabled;var isActive=_this.elementIsActive(element.id);var color=isActive?'primary':'default';return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{xs:'3',key:element.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{color:color,block:true,className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()('ProductCollectionPropertySelect__button',{/* When not available, the button should look disabled, but still be clickable. */disabled:!available,'border-primary':isActive,'border-dark':!isActive}),disabled:disabled,onClick:function onClick(){return _this.onButtonClick(element.id);}},element.name));});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],{className:'ProductCollectionPropertySelect__buttons'},buttons);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductCollectionPropertySelect,[{key:'render',value:function render(){var _props=this.props,showImages=_props.showImages,showDropdown=_props.showDropdown,showButtons=_props.showButtons,multiproductAsDropdown=_props.multiproductAsDropdown,hidden=_props.hidden;if(hidden){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCollectionPropertySelect'},showImages&&!multiproductAsDropdown&&this.getProductCollectionImages(),showDropdown&&this.getDropdown(),showButtons&&this.getButtons());}}]);return ProductCollectionPropertySelect;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;ProductCollectionPropertySelect.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__models_Product__["a" /* default */]).isRequired,productImages:__WEBPACK_IMPORTED_MODULE_4_mobx_react__["a" /* PropTypes */].observableArray.isRequired,property:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_ProductProperty__["a" /* default */]).isRequired,elementsWithAvailability:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({element:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__models_ProductPropertyElement__["a" /* default */]).isRequired,available:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool})).isRequired,onPropertySelect:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_6_react_intl__["f" /* intlShape */].isRequired,activeElementId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,showImages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showDropdown:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showButtons:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,hidden:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,multiproductAsDropdown:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onProductChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,activeProductId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('configStore')(Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* injectIntl */])(ProductCollectionPropertySelect)));

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(510),
    baseIsNaN = __webpack_require__(1017),
    strictIndexOf = __webpack_require__(1018);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 510 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductExtraInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductWarranty__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProductId__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ProductFeatureImages__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_ProductClass__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductExtraInfo=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductExtraInfo,_Component);function ProductExtraInfo(props){_classCallCheck(this,ProductExtraInfo);var _this=_possibleConstructorReturn(this,(ProductExtraInfo.__proto__||Object.getPrototypeOf(ProductExtraInfo)).call(this,props));_this.maybeLoadFeatureImages=function(){var product=_this.props.product;if(product.propertyImagesState===__WEBPACK_IMPORTED_MODULE_13__types_RequestState__["b" /* default */].NONE){product.loadPropertyImages();}};_this.renderProductId=function(){var _this$props=_this.props,configStore=_this$props.configStore,product=_this$props.product;var showProductCode=configStore.productPage.showProductCode;var showAdditionalProductCode=configStore.productPage.showAdditionalProductCode;var ifHideProductCode=!product.id||!showProductCode;var ifHideAdditionalProductCode=showAdditionalProductCode&&product.class===__WEBPACK_IMPORTED_MODULE_14__types_ProductClass__["b" /* default */].MULTI_CHILD;if(ifHideProductCode||ifHideAdditionalProductCode){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:'id',className:'ProductExtraInfo--product-id'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ProductId__["a" /* default */],{id:product.id}));};_this.maybeLoadFeatureImages();return _this;}_createClass(ProductExtraInfo,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.maybeLoadFeatureImages();}},{key:'render',value:function render(){var _props=this.props,product=_props.product,singleColumn=_props.singleColumn,configStore=_props.configStore;var warranty=configStore.productPage.showWarranty&&product.warranty&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:'warranty',className:'ProductExtraInfo--warranty'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductWarranty__["a" /* default */],{warranty:product.warranty}));var weight=configStore.productPage.showWeight&&product.display_weight&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:'weight',className:'ProductExtraInfo--weight'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'product.weightLabel',defaultMessage:'Weight: {weight}',values:{weight:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,product.display_weight)}}));var propertyImages=product.labels.filter(function(image){return image.placement==='product_properties'&&image.show_on_product_card;});var extra_properties=product.extra_properties.filter(function(property){return(// Filter out properties with a defined property image
!__WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(propertyImages,function(image){return image.property_value_id===property.value_id;}));}).map(function(property){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default()('property-'+property.value_id),className:'ProductExtraInfo--property-'+property.id},property.name,': ',property.value_name);});var features=product.features.map(function(feature){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:'feature-'+feature.id,className:'ProductExtraInfo--feature-'+feature.id},feature.name);});var free_text_fields=product.free_text_fields.map(function(free_text_field){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:'free-text-'+free_text_field.name+free_text_field.value,className:'ProductExtraInfo--free-text'},free_text_field.name,': ',free_text_field.value);});var id=this.renderProductId();var ean=configStore.productPage.showEanCode&&product.ean&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:'ean',className:'ProductExtraInfo--ean'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].eanLabel,{values:{ean:product.ean}})));var extraId=configStore.productPage.showExtraId&&product.extra_id&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:'extra_id',className:'ProductExtraInfo--extra-id'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].extraIdLabel,{values:{extraId:product.extra_id}})));var manufacturersCode=configStore.productPage.showManufacturersCode&&product.manufacturer_product_id&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:'manufacturer_product_id',className:'ProductExtraInfo--manufacturer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].manufacturerCodeLabel,{values:{manufacturerCode:product.manufacturer_product_id}})));var extraInfos=[id,ean,extraId,manufacturersCode,warranty,weight].concat(_toConsumableArray(extra_properties),_toConsumableArray(features),_toConsumableArray(free_text_fields)).filter(function(info){return!!info;});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ProductFeatureImages__["a" /* default */],{product:product,position:'product_properties'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ProductExtraInfo',{'ProductExtraInfo--short-list':extraInfos.length<4,'ProductExtraInfo--single-column':singleColumn})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'inline-dot'},extraInfos)));}}]);return ProductExtraInfo;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;ProductExtraInfo.propTypes={// Both Products and ChildProducts are allowed.
product:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,singleColumn:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,showId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('configStore')(ProductExtraInfo));

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductAvailabilityList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductAvailabilityText__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductPageContent__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_ProductAvailabilityType__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProductAvailabilityShipping__ = __webpack_require__(1031);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductAvailabilityList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductAvailabilityList,_Component);function ProductAvailabilityList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductAvailabilityList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductAvailabilityList.__proto__||Object.getPrototypeOf(ProductAvailabilityList)).call.apply(_ref,[this].concat(args))),_this),_this.scrollToTab=function(tabId){var scrollToTab=_this.props.scrollToTab;if(scrollToTab){scrollToTab(tabId);}},_this.scrollToAvailability=function(e){e.stopPropagation();_this.props.onBeforeScroll();_this.scrollToTab(__WEBPACK_IMPORTED_MODULE_5__ProductPageContent__["b" /* AVAILABILITY_TAB_ID */]);},_this.scrollToShipping=function(e){e.stopPropagation();_this.props.onBeforeScroll();_this.scrollToTab(__WEBPACK_IMPORTED_MODULE_5__ProductPageContent__["d" /* SHIPPING_TAB_ID */]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductAvailabilityList,[{key:'getStoreAvailability',value:function getStoreAvailability(){var _props=this.props,product=_props.product,activeProduct=_props.activeProduct,configStore=_props.configStore;if(!configStore.product.showStoreAvailability){return null;}var availabilityText=void 0;switch(product.stockStates.get(activeProduct.id)){case __WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADING:availabilityText=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'stock.loadingStoreAvailability',defaultMessage:'Loading store availability...'});break;case __WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADED:var stocks=product.stocks.get(activeProduct.id);var hasMultipleStores=stocks.length>1;var available=stocks.some(function(stock){return stock.free_quantity>0;});if(available){var availabilityMessage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_ButtonLink__["a" /* default */],{className:'text-success',onClick:this.scrollToAvailability},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'stock.availableInStores',defaultMessage:'Check store availability here'}));availabilityText=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-success'},availabilityMessage);}else{var _availabilityMessage=hasMultipleStores?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'stock.storesOutOfStock',defaultMessage:'Stores out of stock'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'stock.storeOutOfStock',defaultMessage:'Store out of stock'});availabilityText=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_availabilityMessage);}break;case __WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].ERROR:break;case __WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].NONE:default:availabilityText='';break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ProductAvailabilityList__store-availability'},availabilityText);}},{key:'render',value:function render(){var _props2=this.props,configStore=_props2.configStore,product=_props2.product,activeProduct=_props2.activeProduct,shipping=_props2.shipping,onlineAvailability=_props2.onlineAvailability,storeAvailability=_props2.storeAvailability;var onlyInShop=activeProduct.availability_type===__WEBPACK_IMPORTED_MODULE_10__types_ProductAvailabilityType__["b" /* default */].ONLY_IN_SHOP;var shippingProduct=product.class===__WEBPACK_IMPORTED_MODULE_12__types_ProductClass__["b" /* default */].COLLECTION?product:activeProduct;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifBuyingAllowed=product.merchantInfo&&product.merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ProductAvailabilityList'},!onlyInShop&&onlineAvailability&&activeProduct.availability_html&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ProductAvailabilityList__availability'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductAvailabilityText__["a" /* default */],{availabilityHtml:activeProduct.availability_html})),storeAvailability&&this.getStoreAvailability(),!onlyInShop&&shipping&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProductAvailabilityShipping__["a" /* default */],{activeProductId:activeProduct.id,product:shippingProduct,scrollToShipping:this.scrollToShipping}));}}]);return ProductAvailabilityList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductAvailabilityList.propTypes={scrollToTab:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]).isRequired,activeProduct:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,availability_html:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired}).isRequired,shipping:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onlineAvailability:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,storeAvailability:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onBeforeScroll:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};ProductAvailabilityList.defaultProps={onlineAvailability:true,storeAvailability:true,onBeforeScroll:function onBeforeScroll(){}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductAvailabilityList));

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductAvailabilityText=function(_Component){_inherits(ProductAvailabilityText,_Component);function ProductAvailabilityText(){_classCallCheck(this,ProductAvailabilityText);return _possibleConstructorReturn(this,(ProductAvailabilityText.__proto__||Object.getPrototypeOf(ProductAvailabilityText)).apply(this,arguments));}_createClass(ProductAvailabilityText,[{key:'render',value:function render(){var availabilityHtml=this.props.availabilityHtml;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductAvailabilityText',dangerouslySetInnerHTML:{__html:availabilityHtml}});}}]);return ProductAvailabilityText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductAvailabilityText.propTypes={availabilityHtml:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductAvailabilityText);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductSingularPrice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Price__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSingularPrice=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductSingularPrice,_Component);function ProductSingularPrice(){_classCallCheck(this,ProductSingularPrice);return _possibleConstructorReturn(this,(ProductSingularPrice.__proto__||Object.getPrototypeOf(ProductSingularPrice)).apply(this,arguments));}_createClass(ProductSingularPrice,[{key:'render',value:function render(){var _props=this.props,product=_props.product,withTax=_props.withTax,hideSingular=_props.hideSingular;if(!product.singular_price_unit||product.singular_price_divider<=0||hideSingular){return null;}var showTaxExcludedInfo=!withTax;var isMulti=product.class===__WEBPACK_IMPORTED_MODULE_7__types_ProductClass__["b" /* default */].MULTI;var price=product.getPrice(withTax);if(isMulti&&product.priceRange){price=product.priceRange.min.getPrice(withTax);}var priceSuffix=' / '+product.singular_price_unit;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductSingularPrice'},isMulti&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].priceFrom),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:price/product.singular_price_divider,suffix:priceSuffix,showTaxExcludedInfo:showTaxExcludedInfo}));}}]);return ProductSingularPrice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductSingularPrice.propTypes={product:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({price_info:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ProductPriceInfo__["a" /* default */]),package_size:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,stock_unit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,singular_price_unit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,singular_price_divider:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number}).isRequired,withTax:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,hideSingular:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])(function(stores,props){return{withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(ProductSingularPrice));

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductOfferSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductOfferSchema=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductOfferSchema,_Component);function ProductOfferSchema(){_classCallCheck(this,ProductOfferSchema);return _possibleConstructorReturn(this,(ProductOfferSchema.__proto__||Object.getPrototypeOf(ProductOfferSchema)).apply(this,arguments));}_createClass(ProductOfferSchema,[{key:'render',value:function render(){var product=this.props.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,product.price_info&&product.price_info.valid_until&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('time',{dateTime:__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(product.price_info.valid_until).toISODate()}));}}]);return ProductOfferSchema;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductOfferSchema.propTypes={product:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductOfferSchema);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ReserveInStoreService=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ReserveInStoreService',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (ReserveInStoreService);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumberType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var PhoneNumber={NORMAL:'NORMAL',WHATSAPP:'WHATSAPP'};/* harmony default export */ __webpack_exports__["b"] = (PhoneNumber);var PhoneNumberType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('PhoneNumber',Object.values(PhoneNumber));

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LastVisitedProductsSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pull__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_pull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductSlider__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__product_MissingProductLoader__ = __webpack_require__(349);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LastVisitedProductsSlider=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(LastVisitedProductsSlider,_Component);function LastVisitedProductsSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LastVisitedProductsSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LastVisitedProductsSlider.__proto__||Object.getPrototypeOf(LastVisitedProductsSlider)).call.apply(_ref,[this].concat(args))),_this),_this.listName='Last Visited Products',_this.getProductIds=function(){var _this$props=_this.props,productStore=_this$props.productStore,currentProductId=_this$props.currentProductId;var lastVisitedProducts=productStore.lastVisitedProducts.slice();// Remove current product id from the list.
return __WEBPACK_IMPORTED_MODULE_0_lodash_pull___default()(lastVisitedProducts,currentProductId);},_this.renderContent=function(products){if(products.length===0){return null;}var cardSettings={requireCanonicalLink:true};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'LastVisitedProductsSlider'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.lastVisitedProducts',defaultMessage:'Last visited products'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductSlider__["a" /* default */],{name:_this.listName,products:products,cardSettings:cardSettings}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LastVisitedProductsSlider,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__product_MissingProductLoader__["a" /* default */],{ids:this.getProductIds()},function(products){return _this2.renderContent(products);});}}]);return LastVisitedProductsSlider;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;LastVisitedProductsSlider.propTypes={productStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ProductStore__["a" /* default */]).isRequired,currentProductId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('productStore')(LastVisitedProductsSlider));

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductImageSigns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductSigns__ = __webpack_require__(462);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductImageSigns=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductImageSigns,_Component);function ProductImageSigns(){_classCallCheck(this,ProductImageSigns);return _possibleConstructorReturn(this,(ProductImageSigns.__proto__||Object.getPrototypeOf(ProductImageSigns)).apply(this,arguments));}_createClass(ProductImageSigns,[{key:'render',value:function render(){var product=this.props.product;var productForDiscountCalculations=product.class===__WEBPACK_IMPORTED_MODULE_1__types_ProductClass__["b" /* default */].MULTI?product.multi.getChildWithBestDiscount():product;if(!productForDiscountCalculations){return null;}var hasPriceRange=product.class===__WEBPACK_IMPORTED_MODULE_1__types_ProductClass__["b" /* default */].MULTI&&product.multi.priceRange&&product.multi.priceRange.min!==product.multi.priceRange.max;var hasDiscount=productForDiscountCalculations.price_info?productForDiscountCalculations.price_info.is_discount:false;var discountPropsPercent=productForDiscountCalculations.price_info?productForDiscountCalculations.price_info.discount_percentage:0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductImageSigns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductSigns__["a" /* default */],{dateAdded:product.date_added,hasDiscount:hasDiscount,discountProps:{percent:discountPropsPercent,withUpTo:hasPriceRange}}));}}]);return ProductImageSigns;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductImageSigns.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_Product__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductImageSigns);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Switch=function(_Component){_inherits(Switch,_Component);function Switch(props){_classCallCheck(this,Switch);var _this=_possibleConstructorReturn(this,(Switch.__proto__||Object.getPrototypeOf(Switch)).call(this,props));_this.uniqueId=__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('Switch--');return _this;}_createClass(Switch,[{key:'render',value:function render(){var _props=this.props,children=_props.children,size=_props.size,rest=_objectWithoutProperties(_props,['children','size']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('Switch',_defineProperty({},'Switch--'+size,!!size))},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',Object.assign({id:this.uniqueId,type:'checkbox'},rest)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:this.uniqueId},children));}}]);return Switch;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Switch.propTypes={size:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Countdown=function(_Component){_inherits(Countdown,_Component);function Countdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Countdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Countdown.__proto__||Object.getPrototypeOf(Countdown)).call.apply(_ref,[this].concat(args))),_this),_this.state={secondsRemaining:0},_this.updateInterval=null,_this.clearInterval=function(){if(_this.updateInterval!==null){clearInterval(_this.updateInterval);_this.updateInterval=null;}},_this.updateRemainingTime=function(){var _this$props=_this.props,expiresOn=_this$props.expiresOn,onExpiry=_this$props.onExpiry;var secondsRemaining=(expiresOn.valueOf()-new Date().valueOf())/1000;if(secondsRemaining<0){if(onExpiry){onExpiry();}_this.clearInterval();}_this.setState({secondsRemaining:secondsRemaining});},_this.padPart=function(part){var toLength=arguments.length>1&&arguments[1]!==undefined?arguments[1]:2;var padChar=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'0';part=part.toString();if(part.length>=toLength){return part;}return padChar.repeat(toLength-part.length)+part;},_this.format=function(){var secondsRemaining=_this.state.secondsRemaining;var parts={h:_this.padPart(Math.floor(secondsRemaining/3600)),m:_this.padPart(Math.floor(secondsRemaining/60%60)),s:_this.padPart(Math.floor(secondsRemaining%60))};return parts.h+':'+parts.m+':'+parts.s;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Countdown,[{key:'componentDidMount',value:function componentDidMount(){this.updateInterval=setInterval(this.updateRemainingTime,1000);this.updateRemainingTime();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.clearInterval();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Countdown'},this.format());}}]);return Countdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Countdown.propTypes={expiresOn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,onExpiry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Countdown);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CartIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartIcon=function(_Component){_inherits(CartIcon,_Component);function CartIcon(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CartIcon);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CartIcon.__proto__||Object.getPrototypeOf(CartIcon)).call.apply(_ref,[this].concat(args))),_this),_this.buttonElement=null,_this.state={buttonMounted:false},_this.setButtonElement=function(ref){_this.buttonElement=ref;_this.setState({buttonMounted:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CartIcon,[{key:'render',value:function render(){var _props=this.props,intl=_props.intl,loading=_props.loading,onClick=_props.onClick,disabled=_props.disabled,tooltipMessage=_props.tooltipMessage,notAllowed=_props.notAllowed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('CartIcon',{'CartIcon--not-allowed':notAllowed}),innerRef:this.setButtonElement,onClick:onClick,disabled:disabled,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].addToCartButton)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:loading?'circle-o-notch':'shopping-cart',spin:loading})),tooltipMessage&&this.state.buttonMounted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["V" /* UncontrolledTooltip */],{placement:'top',target:this.buttonElement},tooltipMessage));}}]);return CartIcon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CartIcon.propTypes={intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired,onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,notAllowed:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,tooltipMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(CartIcon));

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecurringCycleDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__ = __webpack_require__(191);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({placeholderCycle:{'id':'recurringOrder.cyclePlaceholder','defaultMessage':'Choose your cycle'},weekly:{'id':'recurringOrder.cycleWeekly','defaultMessage':'Every week'},biWeekly:{'id':'recurringOrder.cycleBiWeekly','defaultMessage':'Every other week'},monthly:{'id':'recurringOrder.cycleMonthly','defaultMessage':'Every month'},biMonthly:{'id':'recurringOrder.cycleBiMonthly','defaultMessage':'Every other month'},quarterly:{'id':'recurringOrder.cycleQuarterly','defaultMessage':'Every three months'},custom:{'id':'recurringOrder.cycleCustom','defaultMessage':'Choose your interval'}});var RecurringCycleDropdown=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RecurringCycleDropdown,_Component);function RecurringCycleDropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecurringCycleDropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecurringCycleDropdown.__proto__||Object.getPrototypeOf(RecurringCycleDropdown)).call.apply(_ref,[this].concat(args))),_this),_this.getCycleTranslation=function(cycle){var intl=_this.props.intl;switch(cycle){case __WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__["b" /* default */].WEEKLY:return intl.formatMessage(messages.weekly);case __WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__["b" /* default */].BIWEEKLY:return intl.formatMessage(messages.biWeekly);case __WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__["b" /* default */].MONTHLY:return intl.formatMessage(messages.monthly);case __WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__["b" /* default */].BIMONTHLY:return intl.formatMessage(messages.biMonthly);case __WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__["b" /* default */].QUARTERLY:return intl.formatMessage(messages.quarterly);case __WEBPACK_IMPORTED_MODULE_5__types_RecurringOrderCycleType__["b" /* default */].CUSTOM:return intl.formatMessage(messages.custom);default:return null;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecurringCycleDropdown,[{key:'render',value:function render(){var _this2=this;var _props=this.props,cycles=_props.cycles,intl=_props.intl,onChange=_props.onChange,selectedValue=_props.selectedValue;if(cycles.length===0){return null;}var options=cycles.map(function(cycle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:cycle,value:cycle},_this2.getCycleTranslation(cycle));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* Label */],{'for':'RecurringCycleDropdown__cycle-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.selectCycle',defaultMessage:'Choose cycle for your subscription'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Input */],{type:'select',name:'select',className:'RecurringCycleDropdown__cycle-select',id:'RecurringCycleDropdown__cycle-select',onChange:onChange,defaultValue:selectedValue},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},intl.formatMessage(messages.placeholderCycle)),options));}}]);return RecurringCycleDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RecurringCycleDropdown.propTypes={intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,cycles:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,selectedValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(RecurringCycleDropdown));

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecurringDaysDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecurringDaysDropdown=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RecurringDaysDropdown,_Component);function RecurringDaysDropdown(){_classCallCheck(this,RecurringDaysDropdown);return _possibleConstructorReturn(this,(RecurringDaysDropdown.__proto__||Object.getPrototypeOf(RecurringDaysDropdown)).apply(this,arguments));}_createClass(RecurringDaysDropdown,[{key:'render',value:function render(){var _props=this.props,onChange=_props.onChange,minDays=_props.minDays,selectedValue=_props.selectedValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* Label */],{'for':'RecurringDaysDropdown__days-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.selectDays',defaultMessage:'Interval. (Minimum of {days} days)',values:{days:minDays}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringDaysDropdown__text-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* InputGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Input */],{type:'number',value:selectedValue,onChange:onChange,min:0,className:'RecurringDaysDropdown__text-box-input--with-addon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* InputGroupText */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.days',defaultMessage:'days'}))))));}}]);return RecurringDaysDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RecurringDaysDropdown.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,minDays:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,selectedValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};RecurringDaysDropdown.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (RecurringDaysDropdown);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductEnquiry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductEnquiryModal__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_ProductEnquiryType__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductEnquiry=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductEnquiry,_Component);function ProductEnquiry(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductEnquiry);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductEnquiry.__proto__||Object.getPrototypeOf(ProductEnquiry)).call.apply(_ref,[this].concat(args))),_this),_this.state={modal:false},_this.toggleModal=function(){_this.setState({modal:!_this.state.modal});},_this.getTitle=function(){var type=_this.props.type;switch(type){case __WEBPACK_IMPORTED_MODULE_8__types_ProductEnquiryType__["a" /* default */].PROPOSAL_REQUEST:return __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].productEnquiryProposalTitle;case __WEBPACK_IMPORTED_MODULE_8__types_ProductEnquiryType__["a" /* default */].MESSAGE:default:return __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].productEnquiryTitle;}},_this.renderMessage=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],_this.getTitle());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductEnquiry,[{key:'render',value:function render(){var _props=this.props,id=_props.id,type=_props.type,configStore=_props.configStore;if(!configStore.product.enableEnquiry){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductEnquiry'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductEnquiryModal__["a" /* default */],{id:id,isOpen:this.state.modal,toggle:this.toggleModal,enquiry:{title:this.getTitle(),type:type}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{className:'ProductEnquiry__modal-button',onClick:this.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Icon__["a" /* default */],{name:'question-circle'}),' ',this.renderMessage()));}}]);return ProductEnquiry;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductEnquiry.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(Object.values(__WEBPACK_IMPORTED_MODULE_8__types_ProductEnquiryType__["a" /* default */]))};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore')(ProductEnquiry));

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductPackageSize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_number__ = __webpack_require__(69);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPackageSize=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductPackageSize,_Component);function ProductPackageSize(){_classCallCheck(this,ProductPackageSize);return _possibleConstructorReturn(this,(ProductPackageSize.__proto__||Object.getPrototypeOf(ProductPackageSize)).apply(this,arguments));}_createClass(ProductPackageSize,[{key:'render',value:function render(){var _props=this.props,currencyStore=_props.currencyStore,product=_props.product,withTax=_props.withTax;var showTaxExcludedInfo=!withTax;var price=Object(__WEBPACK_IMPORTED_MODULE_6__util_number__["e" /* roundWithPrecision */])(product.package_size*Object(__WEBPACK_IMPORTED_MODULE_6__util_number__["e" /* roundWithPrecision */])(product.getPrice(withTax),currencyStore.activeCurrency.precision),currencyStore.activeCurrency.precision);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductPackageSize'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.packageSizeDescription',defaultMessage:'{packageSizeSentence}: 1 {packageUnitName} = {packageSize} {stockUnit} ({packagePrice} / {packageUnitName})',values:{packageSizeSentence:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.packageSizeSentence',defaultMessage:'Package size'}),packageUnitName:product.package_unit_name,packageSize:product.package_size,stockUnit:product.stock_unit,packagePrice:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__product_Price__["a" /* default */],{price:price,showTaxExcludedInfo:showTaxExcludedInfo})}}));}}]);return ProductPackageSize;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductPackageSize.propTypes={product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,withTax:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])(function(stores,props){return{currencyStore:stores.currencyStore,withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(ProductPackageSize));

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductDeposit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Price__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductDeposit=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductDeposit,_Component);function ProductDeposit(){_classCallCheck(this,ProductDeposit);return _possibleConstructorReturn(this,(ProductDeposit.__proto__||Object.getPrototypeOf(ProductDeposit)).apply(this,arguments));}_createClass(ProductDeposit,[{key:'render',value:function render(){var _props=this.props,product=_props.product,showPrice=_props.showPrice;if(!product.hasDeposit()){return null;}var message=showPrice&&product.bottle_deposit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.deposit',defaultMessage:'Product price will be included deposit of {deposit}',values:{deposit:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Price__["a" /* default */],{price:product.bottle_deposit.getPrice(true)})}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.depositIncluded',defaultMessage:'Includes deposit of {deposit}',values:{deposit:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Price__["a" /* default */],{price:product.bottle_deposit.getPrice(true)})}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDeposit'},message);}}]);return ProductDeposit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductDeposit.propTypes={// Both Products and ChildProducts are allowed.
product:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,showPrice:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductDeposit));

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEOLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LocationContext__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GenericMeta__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEOLink=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SEOLink,_Component);function SEOLink(){_classCallCheck(this,SEOLink);return _possibleConstructorReturn(this,(SEOLink.__proto__||Object.getPrototypeOf(SEOLink)).apply(this,arguments));}_createClass(SEOLink,[{key:'render',value:function render(){var _props=this.props,rel=_props.rel,path=_props.path,addOpenGraphTag=_props.addOpenGraphTag,locationContext=_props.locationContext;var url=locationContext.protocol+'//'+locationContext.host+path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,addOpenGraphTag&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GenericMeta__["a" /* default */],{name:'twitter:url',property:'og:url',content:url}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{rel:rel,href:url})));}}]);return SEOLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SEOLink.propTypes={addOpenGraphTag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,rel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,locationContext:__WEBPACK_IMPORTED_MODULE_4__services_LocationContext__["a" /* LocationContextPropType */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('locationContext')(SEOLink));

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CouponExpiry=function(_Component){_inherits(CouponExpiry,_Component);function CouponExpiry(){_classCallCheck(this,CouponExpiry);return _possibleConstructorReturn(this,(CouponExpiry.__proto__||Object.getPrototypeOf(CouponExpiry)).apply(this,arguments));}_createClass(CouponExpiry,[{key:'render',value:function render(){var date=this.props.date;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CouponExpiry'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].couponValidUntilSentence,{values:{offerExpiry:__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(date).toLocaleString()}})));}}]);return CouponExpiry;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CouponExpiry.propTypes={// ISO 8601 date
date:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CouponExpiry);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_PaymentWidgetType__ = __webpack_require__(531);
var PaymentWidget=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PaymentWidget',{type:__WEBPACK_IMPORTED_MODULE_1__types_PaymentWidgetType__["a" /* PaymentWidgetTypeType */],script:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (PaymentWidget);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentWidgetTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var PaymentWidgetType={KLARNA:'KLARNA'};/* harmony default export */ __webpack_exports__["b"] = (PaymentWidgetType);var PaymentWidgetTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('PaymentWidgetType',Object.values(PaymentWidgetType));

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KlarnaPromotionWidget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_PaymentModuleStore__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_locale__ = __webpack_require__(352);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KlarnaPromotionWidget=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(KlarnaPromotionWidget,_Component);function KlarnaPromotionWidget(){var _ref;var _temp,_this,_ret;_classCallCheck(this,KlarnaPromotionWidget);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=KlarnaPromotionWidget.__proto__||Object.getPrototypeOf(KlarnaPromotionWidget)).call.apply(_ref,[this].concat(args))),_this),_this.key=0,_this.isVisible=function(){var _this$props=_this.props,accountStore=_this$props.accountStore,countryStore=_this$props.countryStore,languageStore=_this$props.languageStore;return!!(countryStore.activeCountry&&languageStore.activeLocale&&!accountStore.isRetailer);},_this.getLocale=function(){var _this$props2=_this.props,countryStore=_this$props2.countryStore,languageStore=_this$props2.languageStore;return languageStore.activeLocale+'-'+Object(__WEBPACK_IMPORTED_MODULE_11__util_locale__["a" /* convertLocaleToFinlandIfAland */])(countryStore.activeCountry.iso_code_2);},_this.getPrice=function(){var _this$props3=_this.props,priceInfo=_this$props3.priceInfo,accountStore=_this$props3.accountStore;if(!priceInfo){return null;}var withTax=accountStore.showPricesWithTax;return priceInfo.getPrice(withTax);},_this.getKlarnaScriptById=function(){var _this$props4=_this.props,paymentModuleStore=_this$props4.paymentModuleStore,paymentModuleQueryResultKey=_this$props4.paymentModuleQueryResultKey;var modules=paymentModuleStore.paymentWidgetQueryResults.get(paymentModuleQueryResultKey);if(!modules){return[];}var widgets=modules.widgets;return widgets.map(function(widgets){return widgets.script;});},_this.createDummyHtmlDocument=function(klarnaWidget){var doc=document.implementation.createHTMLDocument('');doc.body.innerHTML=klarnaWidget;return[].map.call(doc.getElementsByTagName('script'),function(el){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',{key:_this.key++,async:true,src:el.src,'data-client-id':el.getAttribute('data-client-id')});});},_this.renderHtmlWidget=function(price){var _this$props5=_this.props,widgetType=_this$props5.widgetType,externalKlarnaScript=_this$props5.externalKlarnaScript;var klarnaScript=_this.getKlarnaScriptById();if(externalKlarnaScript){klarnaScript=externalKlarnaScript;}// Don't try rendering if we don't have any scripts or are in SSR context
if(!klarnaScript.length||typeof document==='undefined'){return null;}var scripts=_this.createDummyHtmlDocument(klarnaScript);var amount=price>0?price:null;var locale=_this.getLocale();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,scripts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('klarna-placement',{'data-key':widgetType,'data-locale':locale,'data-purchase-amount':amount}));},_this.refreshKlarnaWidgetPlacements=function(){window.KlarnaOnsiteService=window.KlarnaOnsiteService||[];window.KlarnaOnsiteService.push({eventName:'refresh-placements'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(KlarnaPromotionWidget,[{key:'componentDidMount',value:function componentDidMount(){this.refreshKlarnaWidgetPlacements();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.priceInfo!==this.props.priceInfo||prevProps.activeProductId!==this.props.activeProductId){this.refreshKlarnaWidgetPlacements();}}},{key:'render',value:function render(){if(!this.isVisible()||!this.props.ifSupportedCountryWithCurrency){return null;}var price=Math.floor(this.getPrice()*100);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'KlarnaPromotionWidget'},this.renderHtmlWidget(price),this.refreshKlarnaWidgetPlacements());}}]);return KlarnaPromotionWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;KlarnaPromotionWidget.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_CountryStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_LanguageStore__["a" /* default */]).isRequired,paymentModuleStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_PaymentModuleStore__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_AccountStore__["a" /* default */]).isRequired,widgetType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,paymentModuleQueryResultKey:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,priceInfo:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_ProductPriceInfo__["a" /* default */]),ifSupportedCountryWithCurrency:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,externalKlarnaScript:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};KlarnaPromotionWidget.defaultProps={ifSupportedCountryWithCurrency:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','countryStore','languageStore','paymentModuleStore','accountStore')(KlarnaPromotionWidget));

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AlsoPurchasedProductsSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductSlider__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_ViewBreakpoint__ = __webpack_require__(122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SLIDER_SETTINGS={cartModal:{slidesToShow:4,slidesToScroll:4,responsive:[{breakpoint:__WEBPACK_IMPORTED_MODULE_10__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].XXL,settings:{slidesToShow:4,slidesToScroll:4}},{breakpoint:__WEBPACK_IMPORTED_MODULE_10__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].XL,settings:{slidesToShow:4,slidesToScroll:4}},{breakpoint:__WEBPACK_IMPORTED_MODULE_10__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].MD,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:__WEBPACK_IMPORTED_MODULE_10__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].SM,settings:{slidesToShow:2,slidesToScroll:2}}]},default:{}};var CARD_SETTINGS={cartModal:{hideDescription:true,hideProperties:true,requireCanonicalLink:true,productImageSettings:{overrideConfigStoreAspectRatio:true,customAspectRatio:'100'}},default:{}};var AlsoPurchasedProductsSlider=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AlsoPurchasedProductsSlider,_Component);function AlsoPurchasedProductsSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AlsoPurchasedProductsSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AlsoPurchasedProductsSlider.__proto__||Object.getPrototypeOf(AlsoPurchasedProductsSlider)).call.apply(_ref,[this].concat(args))),_this),_this.listName='Also Purchased Products',_this.loadProductIds=function(){var _this$props=_this.props,product=_this$props.product,forceRefresh=_this$props.forceRefresh;if(product.alsoPurchasedState===__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].NONE||forceRefresh){product.loadAlsoPurchased(product.id).then(function(){_this.loadMissingProducts();}).catch(function(e){if(e.response&&e.response.status!==404){console.error(e);}});}},_this.loadMissingProducts=function(){var _this$props2=_this.props,productStore=_this$props2.productStore,product=_this$props2.product;if(product.alsoPurchasedIds.length>0){productStore.loadProducts({ids:product.alsoPurchasedIds.slice()},true);}},_this.getSliderSettings=function(){var variant=_this.props.variant;if(SLIDER_SETTINGS[variant]){return SLIDER_SETTINGS[_this.props.variant];}return SLIDER_SETTINGS['default'];},_this.getCardSettings=function(){var variant=_this.props.variant;if(CARD_SETTINGS[variant]){return CARD_SETTINGS[_this.props.variant];}return CARD_SETTINGS['default'];},_this.getProducts=function(){var _this$props3=_this.props,productStore=_this$props3.productStore,product=_this$props3.product;if(product.alsoPurchasedIds.length===0){return null;}var products=product.alsoPurchasedIds.filter(function(productId){return productStore.products.has(productId);}).map(function(productId){return productStore.products.get(productId);});if(products.length===0){return null;}return products;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AlsoPurchasedProductsSlider,[{key:'componentDidMount',value:function componentDidMount(){this.loadProductIds();}},{key:'render',value:function render(){var _this2=this;var product=this.props.product;var products=this.getProducts();if(!products){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:product.alsoPurchasedState,forLoaded:function forLoaded(){return products&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AlsoPurchasedProductsSlider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'AlsoPurchasedProductSlider__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.alsoPurchasedProducts',defaultMessage:'Customers who purchased this item, also purchased'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductSlider__["a" /* default */],{settings:_this2.getSliderSettings(),cardSettings:_this2.getCardSettings(),name:_this2.listName,products:products}));}});}}]);return AlsoPurchasedProductsSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AlsoPurchasedProductsSlider.propTypes={productStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ProductStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,variant:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,forceRefresh:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};AlsoPurchasedProductsSlider.defaultProps={variant:'default'};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('productStore')(AlsoPurchasedProductsSlider));

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ReCAPTCHA = function (_React$Component) {
  _inherits(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    _classCallCheck(this, ReCAPTCHA);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.handleExpired = _this.handleExpired.bind(_this);
    _this.handleErrored = _this.handleErrored.bind(_this);
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_this);
    return _this;
  }

  ReCAPTCHA.prototype.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }
    return null;
  };

  ReCAPTCHA.prototype.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }
    return null;
  };

  ReCAPTCHA.prototype.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;


    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  ReCAPTCHA.prototype.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  ReCAPTCHA.prototype.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else if (this.props.onChange) {
      this.props.onChange(null);
    }
  };

  ReCAPTCHA.prototype.handleErrored = function handleErrored() {
    if (this.props.onErrored) this.props.onErrored();
  };

  ReCAPTCHA.prototype.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.props.onChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }
    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  ReCAPTCHA.prototype.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  ReCAPTCHA.prototype.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none";

    // move of the recaptcha to a temporary node
    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    }

    // delete the temporary node after reset will be done
    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  ReCAPTCHA.prototype.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  ReCAPTCHA.prototype.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _props = this.props,
        sitekey = _props.sitekey,
        onChange = _props.onChange,
        theme = _props.theme,
        type = _props.type,
        tabindex = _props.tabindex,
        onExpired = _props.onExpired,
        onErrored = _props.onErrored,
        size = _props.size,
        stoken = _props.stoken,
        grecaptcha = _props.grecaptcha,
        badge = _props.badge,
        childProps = _objectWithoutProperties(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge"]);
    /* eslint-enable no-unused-vars */


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, childProps, { ref: this.handleRecaptchaRef }));
  };

  return ReCAPTCHA;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ReCAPTCHA);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  grecaptcha: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dark", "light"]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["image", "audio"]),
  tabindex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onErrored: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
  stoken: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  badge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SidebarBanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BannerSlider__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SidebarBanner=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SidebarBanner,_Component);function SidebarBanner(){_classCallCheck(this,SidebarBanner);return _possibleConstructorReturn(this,(SidebarBanner.__proto__||Object.getPrototypeOf(SidebarBanner)).apply(this,arguments));}_createClass(SidebarBanner,[{key:'render',value:function render(){var _props=this.props,className=_props.className,searchParams=_props.searchParams;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BannerSlider__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_4__types_AdZones__["a" /* default */].SIDEBAR_BANNER},searchParams),settingOverrides:{slidesToShow:3,slidesToScroll:1,vertical:true,variableWidth:false},className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('SidebarBanner',className),aspectRatio:1});}}]);return SidebarBanner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SidebarBanner.propTypes={className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,searchParams:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (SidebarBanner);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1135);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1138);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(134) && !__webpack_require__(168)(function () {
  return Object.defineProperty(__webpack_require__(539)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(198);
var document = __webpack_require__(115).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(135);
var toIObject = __webpack_require__(169);
var arrayIndexOf = __webpack_require__(1140)(false);
var IE_PROTO = __webpack_require__(358)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(542);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 542 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1143), __esModule: true };

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(135);
var toObject = __webpack_require__(262);
var IE_PROTO = __webpack_require__(358)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(132);
var core = __webpack_require__(96);
var fails = __webpack_require__(168);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1145);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(362);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(363);
var $export = __webpack_require__(132);
var redefine = __webpack_require__(550);
var hide = __webpack_require__(167);
var has = __webpack_require__(135);
var Iterators = __webpack_require__(364);
var $iterCreate = __webpack_require__(1152);
var setToStringTag = __webpack_require__(366);
var getPrototypeOf = __webpack_require__(544);
var ITERATOR = __webpack_require__(170)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(167);


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(540);
var hiddenKeys = __webpack_require__(360).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(261);
var createDesc = __webpack_require__(259);
var toIObject = __webpack_require__(169);
var toPrimitive = __webpack_require__(355);
var has = __webpack_require__(135);
var IE8_DOM_DEFINE = __webpack_require__(538);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(134) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1169);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1173);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(362);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1177), __esModule: true };

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TrackingEventTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var TrackingEventType={CHECKOUT:'CHECKOUT',CHECKOUT_SUCCESS:'CHECKOUT_SUCCESS',PRODUCT:'PRODUCT'};/* harmony default export */ __webpack_exports__["a"] = (TrackingEventType);var TrackingEventTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('TrackingEventType',Object.values(TrackingEventType));

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Filter__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Switch__ = __webpack_require__(520);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BooleanFilter=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BooleanFilter,_Component);function BooleanFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BooleanFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BooleanFilter.__proto__||Object.getPrototypeOf(BooleanFilter)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(){var _this$props=_this.props,filter=_this$props.filter,isSelected=_this$props.isSelected,onAccept=_this$props.onAccept;onAccept(filter,!isSelected);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BooleanFilter,[{key:'render',value:function render(){var _props=this.props,filter=_props.filter,isSelected=_props.isSelected;if(!filter){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BooleanFilter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Switch__["a" /* default */],{checked:isSelected,onChange:this.onChange,size:'xs'},filter.name));}}]);return BooleanFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;BooleanFilter.propTypes={filter:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_Filter__["a" /* default */]),isSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onAccept:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (BooleanFilter);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_ClickOutside__ = __webpack_require__(307);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilterContainer=function(_Component){_inherits(FilterContainer,_Component);function FilterContainer(props){_classCallCheck(this,FilterContainer);var _this=_possibleConstructorReturn(this,(FilterContainer.__proto__||Object.getPrototypeOf(FilterContainer)).call(this,props));_this.handleOutsideClick=function(){var onFilterClosedAutomatically=_this.props.onFilterClosedAutomatically;var open=_this.state.open;if(open){if(onFilterClosedAutomatically){onFilterClosedAutomatically();}else{_this.toggleOpen();}}};_this.toggleOpen=function(){_this.setState({open:!_this.state.open});};_this.state={open:false};return _this;}_createClass(FilterContainer,[{key:'render',value:function render(){var _props=this.props,children=_props.children,filterInUse=_props.filterInUse,headerText=_props.headerText;var open=this.state.open;var iconName='angle-down';if(open){iconName='angle-up';}else if(filterInUse){iconName='check';}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_ClickOutside__["a" /* default */],{onClickOutside:this.handleOutsideClick},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_0_classnames___default()('FilterContainer',{'FilterContainer--open':open,'FilterContainer--closed':!open,'FilterContainer--filter-in-use':filterInUse})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{onClick:this.toggleOpen,color:'link',className:'FilterContainer__toggle'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,headerText),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Icon__["a" /* default */],{name:iconName})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["m" /* Collapse */],{className:'FilterContainer__contents',isOpen:open},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'FilterContainer__contents-children'},children))));}}]);return FilterContainer;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);FilterContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,filterInUse:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,headerText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onFilterClosedAutomatically:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (FilterContainer);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilterAcceptButton=function(_Component){_inherits(FilterAcceptButton,_Component);function FilterAcceptButton(){_classCallCheck(this,FilterAcceptButton);return _possibleConstructorReturn(this,(FilterAcceptButton.__proto__||Object.getPrototypeOf(FilterAcceptButton)).apply(this,arguments));}_createClass(FilterAcceptButton,[{key:'render',value:function render(){var _props=this.props,children=_props.children,className=_props.className,onClick=_props.onClick,rest=_objectWithoutProperties(_props,['children','className','onClick']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],Object.assign({className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('FilterAcceptButton',className),onClick:onClick,color:'primary',block:true},rest),children);}}]);return FilterAcceptButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FilterAcceptButton.propTypes={className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (FilterAcceptButton);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var Track = function Track(props) {
  var _ref, _ref2;

  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      style = props.style;
  var length = props.length,
      offset = props.offset,
      reverse = props.reverse;

  if (length < 0) {
    reverse = !reverse;
    length = Math.abs(length);
    offset = 100 - offset;
  }

  var positonStyle = vertical ? (_ref = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, reverse ? 'bottom' : 'top', 'auto'), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, reverse ? 'left' : 'right', 'auto'), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "width", "".concat(length, "%")), _ref2);

  var elStyle = _objectSpread(_objectSpread({}, style), positonStyle);

  return included ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: className,
    style: elStyle
  }) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (Track);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_get__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_warning__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Steps__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Marks__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Handle__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(372);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }










function noop() {}

function createSlider(Component) {
  var _a;

  return _a = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(ComponentEnhancer, _Component);

    var _super = _createSuper(ComponentEnhancer);

    function ComponentEnhancer(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ComponentEnhancer);

      _this = _super.call(this, props);

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_15__utils__["e" /* getMousePosition */](isVertical, e);

        if (!__WEBPACK_IMPORTED_MODULE_15__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_15__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }

        _this.removeDocumentEvents();

        _this.onStart(position);

        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_15__utils__["h" /* isNotTouchEvent */](e)) return;
        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_15__utils__["f" /* getTouchPosition */](isVertical, e);

        if (!__WEBPACK_IMPORTED_MODULE_15__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_15__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }

        _this.onStart(position);

        _this.addDocumentTouchEvents();

        __WEBPACK_IMPORTED_MODULE_15__utils__["j" /* pauseEvent */](e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (__WEBPACK_IMPORTED_MODULE_15__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_15__utils__["c" /* getHandleCenterPosition */](vertical, e.target);
          _this.dragOffset = 0;

          _this.onStart(handlePosition);

          __WEBPACK_IMPORTED_MODULE_15__utils__["j" /* pauseEvent */](e);

          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd();

        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();

          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_15__utils__["e" /* getMousePosition */](_this.props.vertical, e);

        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_15__utils__["h" /* isNotTouchEvent */](e) || !_this.sliderRef) {
          _this.onEnd();

          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_15__utils__["f" /* getTouchPosition */](_this.props.vertical, e);

        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && __WEBPACK_IMPORTED_MODULE_15__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();

        _this.onChange({
          value: value
        });

        _this.setState({
          value: value
        }, function () {
          return _this.onEnd(true);
        });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      var step = props.step,
          max = props.max,
          min = props.min;
      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line

      Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_warning__["a" /* default */])(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
      _this.handlesRefs = {};
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(ComponentEnhancer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;
        var _this$props2 = this.props,
            autoFocus = _this$props2.autoFocus,
            disabled = _this$props2.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ComponentEnhancer.prototype), "componentWillUnmount", this)) Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: "getSliderStart",
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _this$props3 = this.props,
            vertical = _this$props3.vertical,
            reverse = _this$props3.reverse;
        var rect = slider.getBoundingClientRect();

        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }

        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: "getSliderLength",
      value: function getSliderLength() {
        var slider = this.sliderRef;

        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: "addDocumentTouchEvents",
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: "addDocumentMouseEvents",
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: "removeDocumentEvents",
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();
        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: "focus",
      value: function focus() {
        if (!this.props.disabled) {
          this.handlesRefs[0].focus();
        }
      }
    }, {
      key: "blur",
      value: function blur() {
        var _this2 = this;

        if (!this.props.disabled) {
          Object.keys(this.handlesRefs).forEach(function (key) {
            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
              _this2.handlesRefs[key].blur();
            }
          });
        }
      }
    }, {
      key: "calcValue",
      value: function calcValue(offset) {
        var _this$props4 = this.props,
            vertical = _this$props4.vertical,
            min = _this$props4.min,
            max = _this$props4.max;
        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: "calcValueByPos",
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : +1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: "calcOffset",
      value: function calcOffset(value) {
        var _this$props5 = this.props,
            min = _this$props5.min,
            max = _this$props5.max;
        var ratio = (value - min) / (max - min);
        return Math.max(0, ratio * 100);
      }
    }, {
      key: "saveHandle",
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames;

        var _this$props6 = this.props,
            prefixCls = _this$props6.prefixCls,
            className = _this$props6.className,
            marks = _this$props6.marks,
            dots = _this$props6.dots,
            step = _this$props6.step,
            included = _this$props6.included,
            disabled = _this$props6.disabled,
            vertical = _this$props6.vertical,
            reverse = _this$props6.reverse,
            min = _this$props6.min,
            max = _this$props6.max,
            children = _this$props6.children,
            maximumTrackStyle = _this$props6.maximumTrackStyle,
            style = _this$props6.style,
            railStyle = _this$props6.railStyle,
            dotStyle = _this$props6.dotStyle,
            activeDotStyle = _this$props6.activeDotStyle;

        var _get$call = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ComponentEnhancer.prototype), "render", this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(prefixCls, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-disabled"), disabled), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-vertical"), vertical), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, className, className), _classNames));
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled ? noop : this.onTouchStart,
          onMouseDown: disabled ? noop : this.onMouseDown,
          onMouseUp: disabled ? noop : this.onMouseUp,
          onKeyDown: disabled ? noop : this.onKeyDown,
          onFocus: disabled ? noop : this.onFocus,
          onBlur: disabled ? noop : this.onBlur,
          style: style
        }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
          className: "".concat(prefixCls, "-rail"),
          style: _objectSpread(_objectSpread({}, maximumTrackStyle), railStyle)
        }), tracks, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Steps__["a" /* default */], {
          prefixCls: prefixCls,
          vertical: vertical,
          reverse: reverse,
          marks: marks,
          dots: dots,
          step: step,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          dotStyle: dotStyle,
          activeDotStyle: activeDotStyle
        }), handles, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Marks__["a" /* default */], {
          className: "".concat(prefixCls, "-mark"),
          onClickLabel: disabled ? noop : this.onClickMarkLabel,
          vertical: vertical,
          marks: marks,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          reverse: reverse
        }), children);
      }
    }]);

    return ComponentEnhancer;
  }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = _objectSpread(_objectSpread({}, Component.defaultProps), {}, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(props) {
      var index = props.index,
          restProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["index"]);

      delete restProps.dragging;

      if (restProps.value === null) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Handle__["a" /* default */], Object.assign({}, restProps, {
        key: index
      }));
    },
    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _a;
}

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread__ = __webpack_require__(1244);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__ = __webpack_require__(562);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(o, minLen);
}

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findDOMNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(node);
}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest__ = __webpack_require__(1263);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genCSSMotion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_typeof__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_findDOMNode__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ref__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raf__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_motion__ = __webpack_require__(570);









/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */






var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */

function genCSSMotion(config) {
  var transitionSupport = config;
  var forwardRef = !!__WEBPACK_IMPORTED_MODULE_8_react___default.a.forwardRef;

  if (Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_typeof__["a" /* default */])(config) === 'object') {
    transitionSupport = config.transitionSupport;
    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = /*#__PURE__*/function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(CSSMotion, _React$Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(CSSMotion);

    function CSSMotion() {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, CSSMotion);

      _this = _super.apply(this, arguments);
      _this.$cacheEle = null;
      _this.node = null;
      _this.raf = null;
      _this.destroyed = false;
      _this.deadlineId = null;
      _this.state = {
        status: STATUS_NONE,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;

        if (!isSupportTransition(_this.props)) {
          return;
        } // Event injection


        var $ele = _this.getElement();

        if (_this.$cacheEle !== $ele) {
          _this.removeEventListener(_this.$cacheEle);

          _this.addEventListener($ele);

          _this.$cacheEle = $ele;
        } // Init status


        if (newStatus && status === STATUS_APPEAR && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
          });
        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
          });
        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        if (event && !event.deadline && event.target !== _this.getElement()) {
          // event exists
          // not initiated by deadline
          // transitionend not fired by inner elements
          return;
        }

        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR && statusActive) {
          _this.updateStatus(onAppearEnd, {
            status: STATUS_NONE
          }, event);
        } else if (status === STATUS_ENTER && statusActive) {
          _this.updateStatus(onEnterEnd, {
            status: STATUS_NONE
          }, event);
        } else if (status === STATUS_LEAVE && statusActive) {
          _this.updateStatus(onLeaveEnd, {
            status: STATUS_NONE
          }, event);
        }
      };

      _this.setNodeRef = function (node) {
        var internalRef = _this.props.internalRef;
        _this.node = node;
        Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_ref__["b" /* fillRef */])(internalRef, node);
      };

      _this.getElement = function () {
        try {
          return Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_findDOMNode__["a" /* default */])(_this.node || Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
        } catch (e) {
          /**
           * Fallback to cache element.
           * This is only happen when `motionDeadline` trigger but element removed.
           */
          return _this.$cacheEle;
        }
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;
        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_13__util_motion__["d" /* transitionEndName */], _this.onMotionEnd);
        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_13__util_motion__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;
        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_13__util_motion__["d" /* transitionEndName */], _this.onMotionEnd);
        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_13__util_motion__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;
        if (statusStyle === false || _this.destroyed) return;
        var nextStep;

        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          statusStyle: Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_typeof__["a" /* default */])(statusStyle) === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`

      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;
          if (status !== currentStatus) return;
          var motionDeadline = _this.props.motionDeadline;

          _this.updateStatus(styleFunc, {
            statusActive: true
          });

          if (motionDeadline > 0) {
            _this.deadlineId = setTimeout(function () {
              _this.onMotionEnd({
                deadline: true
              });
            }, motionDeadline);
          }
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();

        _this.raf = __WEBPACK_IMPORTED_MODULE_12_raf___default()(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          __WEBPACK_IMPORTED_MODULE_12_raf___default.a.cancel(_this.raf);
          _this.raf = null;
        }
      };

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(CSSMotion, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyed = true;
        this.removeEventListener(this.$cacheEle);
        this.cancelNextFrame();
        clearTimeout(this.deadlineId);
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames;

        var _this$state3 = this.state,
            status = _this$state3.status,
            statusActive = _this$state3.statusActive,
            statusStyle = _this$state3.statusStyle;
        var _this$props3 = this.props,
            children = _this$props3.children,
            motionName = _this$props3.motionName,
            visible = _this$props3.visible,
            removeOnLeave = _this$props3.removeOnLeave,
            leavedClassName = _this$props3.leavedClassName,
            eventProps = _this$props3.eventProps;
        if (!children) return null;

        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
          if (visible) {
            return children(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, eventProps), this.setNodeRef);
          }

          if (!removeOnLeave) {
            return children(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, eventProps), {}, {
              className: leavedClassName
            }), this.setNodeRef);
          }

          return null;
        }

        return children(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, eventProps), {}, {
          className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_13__util_motion__["b" /* getTransitionName */])(motionName, status), (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, Object(__WEBPACK_IMPORTED_MODULE_13__util_motion__["b" /* getTransitionName */])(motionName, "".concat(status, "-active")), statusActive), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        }), this.setNodeRef);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps,
            prevStatus = _ref.status;
        if (!isSupportTransition(props)) return {};
        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;
        var newState = {
          prevProps: props
        }; // Clean up status if prop set to false

        if (prevStatus === STATUS_APPEAR && !motionAppear || prevStatus === STATUS_ENTER && !motionEnter || prevStatus === STATUS_LEAVE && !motionLeave) {
          newState.status = STATUS_NONE;
          newState.statusActive = false;
          newState.newStatus = false;
        } // Appear


        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR;
          newState.statusActive = false;
          newState.newStatus = true;
        } // Enter


        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER;
          newState.statusActive = false;
          newState.newStatus = true;
        } // Leave


        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);

    return CSSMotion;
  }(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true,
    removeOnLeave: true
  };

  if (!forwardRef) {
    return CSSMotion;
  }

  return __WEBPACK_IMPORTED_MODULE_8_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CSSMotion, Object.assign({
      internalRef: ref
    }, props));
  });
}
/* harmony default export */ __webpack_exports__["a"] = (genCSSMotion(__WEBPACK_IMPORTED_MODULE_13__util_motion__["c" /* supportTransition */]));

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getVendorPrefixes */
/* unused harmony export getVendorPrefixedEventName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transitionEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportTransition; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransitionName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(172);

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement); // ================= Transition =================
// Event wrapper. Copy from react source code

function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});
var style = {};

if (canUseDOM) {
  var _document$createEleme = document.createElement('div');

  style = _document$createEleme.style;
}

var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;

    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];

      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}
var animationEndName = getVendorPrefixedEventName('animationend');
var transitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(animationEndName && transitionEndName);
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return "".concat(transitionName, "-").concat(transitionType);
}

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortSelection__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_ProductListStyle__ = __webpack_require__(279);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductListTools=function(_Component){_inherits(ProductListTools,_Component);function ProductListTools(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductListTools);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductListTools.__proto__||Object.getPrototypeOf(ProductListTools)).call.apply(_ref,[this].concat(args))),_this),_this.getStyleSelect=function(icon,selectedStyle){var _this$props=_this.props,style=_this$props.style,onStyleSelect=_this$props.onStyleSelect;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(){return onStyleSelect(selectedStyle);},className:'ProductListTools__style-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{className:style===selectedStyle?'active':'',name:icon}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductListTools,[{key:'render',value:function render(){var _props=this.props,countOfProducts=_props.countOfProducts,onSelectSort=_props.onSelectSort,selectedSortOrderBy=_props.selectedSortOrderBy,selectedSortOrder=_props.selectedSortOrder,showSort=_props.showSort;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductListTools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductListTools__product-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].productCount,{values:{count:countOfProducts}}))),showSort&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SortSelection__["a" /* default */],{onSelectSort:onSelectSort,selectedSortKey:selectedSortOrderBy,selectedSortOrder:selectedSortOrder}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductListTools__style-selects'},this.getStyleSelect('th',__WEBPACK_IMPORTED_MODULE_6__types_ProductListStyle__["a" /* default */].CARD),this.getStyleSelect('th-large',__WEBPACK_IMPORTED_MODULE_6__types_ProductListStyle__["a" /* default */].CARD_LARGE)));}}]);return ProductListTools;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductListTools.propTypes={countOfProducts:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,selectedSortOrderBy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selectedSortOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onSelectSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onStyleSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ProductListTools.defaultProps={showSort:true,onSelectSort:function onSelectSort(){}};/* harmony default export */ __webpack_exports__["a"] = (ProductListTools);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProductRecommendedPosition={EVERYWHERE:'EVERYWHERE',CATEGORY:'CATEGORY',FRONTPAGE:'FRONTPAGE'};/* harmony default export */ __webpack_exports__["a"] = (ProductRecommendedPosition);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_NavigationEntityItem__ = __webpack_require__(99);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MenuItemList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MenuItemList,_Component);function MenuItemList(){_classCallCheck(this,MenuItemList);return _possibleConstructorReturn(this,(MenuItemList.__proto__||Object.getPrototypeOf(MenuItemList)).apply(this,arguments));}_createClass(MenuItemList,[{key:'render',value:function render(){var items=this.props.items;var navItems=items.map(function(item,index){var id=item.id,children=item.children,active=item.active;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* NavItem */],{key:id+'_'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__navigation_NavigationEntityItem__["a" /* default */],{entity:item}),active&&children&&children.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItemList,{items:children}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["G" /* Nav */],{className:'MenuItemList flex-column',vertical:true},navItems);}}]);return MenuItemList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MenuItemList.propTypes={items:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4__types_NavigationEntity__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (MenuItemList);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddressStore__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdStore__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CampaignCodeStore__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CouponStore__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CustomNavigationLinkStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__InfoPageStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__InstantShoppingCartStore__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LayoutBoxStore__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LocalizationStore__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ManufacturerStore__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MenuStore__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__OrderStore__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PaymentModuleStore__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RecurringOrderStore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ReserveInStoreStore__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SearchRedirectionStore__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__StorageStore__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SuggestionStore__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__SurveyStore__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__TrackingStore__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__TranslationStore__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__util_storage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__types_LocalStorageKey__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__PaymentTokenStore__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ScriptStore__ = __webpack_require__(582);
var RootStore=__WEBPACK_IMPORTED_MODULE_29__models_StatefulStore__["a" /* default */].named('RootStore').props({accountStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__AccountStore__["a" /* default */],{}),addressStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_3__AddressStore__["a" /* default */],{}),adStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_4__AdStore__["a" /* default */],{}),campaignCodeStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_5__CampaignCodeStore__["a" /* default */],{}),cartStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_6__CartStore__["a" /* default */],{}),categoryStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_7__CategoryStore__["a" /* default */],{}),configStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_8__ConfigStore__["a" /* default */],{}),countryStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_9__CountryStore__["a" /* default */],{}),couponStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_10__CouponStore__["a" /* default */],{}),currencyStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_11__CurrencyStore__["a" /* default */],{}),customerUserStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_12__CustomerUserStore__["a" /* default */],{}),customNavigationLinkStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_13__CustomNavigationLinkStore__["a" /* default */],{}),infoPageStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_14__InfoPageStore__["a" /* default */],{}),instantShoppingCartStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_15__InstantShoppingCartStore__["a" /* default */],{}),languageStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_16__LanguageStore__["a" /* default */],{}),layoutBoxStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_17__LayoutBoxStore__["a" /* default */],{}),localizationStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_18__LocalizationStore__["a" /* default */],{}),manufacturerStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_19__ManufacturerStore__["a" /* default */],{}),menuStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_20__MenuStore__["a" /* default */],{}),orderStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_21__OrderStore__["a" /* default */],{}),paymentModuleStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_22__PaymentModuleStore__["a" /* default */],{}),paymentTokenStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_38__PaymentTokenStore__["a" /* default */],{}),productStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_23__ProductStore__["a" /* default */],{}),recurringOrderStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_24__RecurringOrderStore__["a" /* default */],{}),reserveInStoreStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_26__ReserveInStoreStore__["a" /* default */],{}),scriptStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_39__ScriptStore__["a" /* default */],{}),searchRedirectionStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_27__SearchRedirectionStore__["a" /* default */],{}),sectionStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_28__SectionStore__["a" /* default */],{}),storageStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_30__StorageStore__["a" /* default */],{}),suggestionStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_31__SuggestionStore__["a" /* default */],{}),surveyStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_32__SurveyStore__["a" /* default */],{}),trackingStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_33__TrackingStore__["a" /* default */],{}),translationStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_34__TranslationStore__["a" /* default */],{}),uiStore:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_35__UIStore__["a" /* default */],{})}).actions(function(self){var urlLanguageIsValid=function urlLanguageIsValid(){return!(self.languageStore.locale!==self.languageStore.activeLocale||self.languageStore.languages.map(function(language){return language.code;}).indexOf(self.languageStore.locale)===-1);};var setupLanguageStoreFromAccount=function setupLanguageStoreFromAccount(languageCode){/* If url language is not found from the active languages default should be set. */if(self.languageStore.hasBeenSetup&&!urlLanguageIsValid()){self.languageStore.getRedirectedUrl(languageCode).then(function(url){window.location=url;});}if(!self.languageStore.hasBeenSetup){self.languageStore.setupLocale(languageCode);}};var setup=function setup(bootstrapData){self.accountStore.setup(bootstrapData.account);self.categoryStore.setup(bootstrapData.categories);self.configStore.setup(bootstrapData.globalConfig,bootstrapData.site);self.countryStore.setup(bootstrapData.countries,bootstrapData.account&&bootstrapData.account.user?bootstrapData.account.user.country_id:bootstrapData.countries[0].id);self.couponStore.setup(bootstrapData.coupons);self.currencyStore.setup(bootstrapData.currencies,bootstrapData.account&&bootstrapData.account.user?bootstrapData.account.user.currency_code:bootstrapData.currencies[0].code);self.customNavigationLinkStore.setup(bootstrapData.customNavigationLinks);self.languageStore.setup(bootstrapData.languages);self.layoutBoxStore.setup(bootstrapData.layoutBoxes);self.localizationStore.setup(bootstrapData.localization);self.menuStore.setup(bootstrapData.menus);self.scriptStore.setup(bootstrapData.scripts);self.searchRedirectionStore.setup(bootstrapData.searchRedirections);self.sectionStore.setup(bootstrapData.sections);self.translationStore.setup(bootstrapData.translations,bootstrapData.translatedImages);self.surveyStore.setup(bootstrapData.surveys);setupLanguageStoreFromAccount(bootstrapData.account.default_language_code);};var bootstrap=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function bootstrap(sellerID,campaignCode,allowTestModeScripts,processLogout){var params,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function bootstrap$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(self.state===__WEBPACK_IMPORTED_MODULE_25__types_RequestState__["b" /* default */].LOADED)){_context.next=2;break;}return _context.abrupt('return');case 2:self.setLoading(true);params={};_context.prev=4;if(!window.isSSR){params.landingPageUrl=window.location.href;if(!!Object(__WEBPACK_IMPORTED_MODULE_36__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_37__types_LocalStorageKey__["a" /* default */].SITE_CHOSEN)){params.siteChosen=1;}}if(sellerID){params.sellerID=sellerID;}if(campaignCode){params.campaignCode=campaignCode;}if(localStorage.getItem('surveys_seen')){params.surveys_seen=localStorage.getItem('surveys_seen');}if(allowTestModeScripts){params.allowTestModeScripts=allowTestModeScripts;}if(processLogout){params.processLogout=processLogout;}_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('bootstrap',{params:params});case 13:result=_context.sent;self.setup(result);_context.next=21;break;case 17:_context.prev=17;_context.t0=_context['catch'](4);self.setError(_context.t0);throw _context.t0;case 21:self.setLoading(false);case 22:case'end':return _context.stop();}}},bootstrap,this,[[4,17]]);}));return{setup:setup,bootstrap:bootstrap};});/* harmony default export */ __webpack_exports__["a"] = (RootStore);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Purchase=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Purchase',{user_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,order_count:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,currency:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,total_with_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,total_without_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (Purchase);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var PurchaseProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PurchaseProduct',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,total_qty:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,total_sum_with_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,total_sum_without_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (PurchaseProduct);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BalancePayment__ = __webpack_require__(1312);
var BalancePaymentHistory=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('BalancePaymentHistory',{current_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,data:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__BalancePayment__["a" /* default */])),from:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),last_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,next_page_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),path:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,per_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,prev_page_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),to:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),total:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});/* harmony default export */ __webpack_exports__["a"] = (BalancePaymentHistory);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Modal__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_LocalizationSites__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_storage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_LocalStorageKey__ = __webpack_require__(374);
var LocalizationStore=__WEBPACK_IMPORTED_MODULE_1__models_StatefulStore__["a" /* default */].named('LocalizationStore').props({countryCode:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),sites:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_3__models_LocalizationSites__["a" /* default */]),localizationModal:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__models_Modal__["a" /* default */].named('LocalizationModal'),{})}).views(function(self){return{get suggestionEnabled(){return self.sites.length>0;}};}).actions(function(self){var getLocalStorage=function getLocalStorage(){return!!Object(__WEBPACK_IMPORTED_MODULE_4__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_5__types_LocalStorageKey__["a" /* default */].SITE_CHOSEN);};var setLocalStorage=function setLocalStorage(){Object(__WEBPACK_IMPORTED_MODULE_4__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_5__types_LocalStorageKey__["a" /* default */].SITE_CHOSEN,true);};var setup=function setup(localization){if(localization){self.countryCode=localization.countryCode;self.sites=localization.sites;self.suggestedSite=localization.suggestedSite;}};return{getLocalStorage:getLocalStorage,setLocalStorage:setLocalStorage,setup:setup};});/* harmony default export */ __webpack_exports__["a"] = (LocalizationStore);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderMethod__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderAddress__ = __webpack_require__(502);
var OrderPayment=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({address:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__OrderAddress__["a" /* default */],{}),method:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1__OrderMethod__["a" /* default */],{})});/* harmony default export */ __webpack_exports__["a"] = (OrderPayment);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_OrderStatusClass__ = __webpack_require__(158);
var OrderStatusHistoryEntry=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrderStatusHistoryEntry',{date:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,status:__WEBPACK_IMPORTED_MODULE_1__types_OrderStatusClass__["a" /* OrderStatusType */],message:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (OrderStatusHistoryEntry);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Token=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Token',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,is_expired:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,created_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (Token);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Script__ = __webpack_require__(1324);
var ScriptStore=__WEBPACK_IMPORTED_MODULE_3__models_StatefulStore__["a" /* default */].named().props({scripts:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__models_Script__["a" /* default */]),[]),scriptsState:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["a" /* RequestStateType */]),{})}).actions(function(self){return{setup:function setup(scripts){self.scripts=scripts;scripts.map(function(script){return self.scriptsState.set(script.id,__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].NONE);});},getScripts:function getScripts(_ref){var pageType=_ref.pageType,location=_ref.location,status=_ref.status;return self.scripts.filter(function(script){var ifScriptFound=script.location===location&&script.status===status&&script.pages.find(function(page){return page===pageType;});if(self.scriptsState.get(script.id)===__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].LOADED){return false;}if(ifScriptFound&&!script.execute_on_page_view){self.scriptsState.set(script.id,__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].LOADED);}return ifScriptFound;});},loadScripts:Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* flow */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function loadScripts(pageType){var scripts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadScripts$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(self.scriptsState.get(pageType)===__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].LOADED)){_context.next=2;break;}return _context.abrupt('return');case 2:self.scriptsState.set(pageType,__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].LOADING);self.setLoading(true);_context.prev=4;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["d" /* getEnv */])(self).apiWrapper.request('scripts',{params:{pageType:pageType}});case 7:scripts=_context.sent;self.scripts.set(pageType,scripts);self.scriptsState.set(pageType,__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].LOADED);self.setLoading(false);_context.next=18;break;case 13:_context.prev=13;_context.t0=_context['catch'](4);self.scriptsState.set(pageType,__WEBPACK_IMPORTED_MODULE_2__types_RequestState__["b" /* default */].ERROR);self.setError(_context.t0);throw _context.t0;case 18:case'end':return _context.stop();}}},loadScripts,this,[[4,13]]);}))};}).views(function(self){return{getScript:function getScript(pageType){return self.scripts.find(pageType);},getScriptState:function getScriptState(pageType){return self.scriptsState.get(pageType);}};});/* harmony default export */ __webpack_exports__["a"] = (ScriptStore);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* unused harmony export AccountModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LoginForm__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RegisterForm__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ResetPasswordForm__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_CouponStore__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__coupon_CouponText__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__coupon_CouponExpiry__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__loader_ErrorHandler__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__route_QueryParamRedirect__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_InfoPageStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_storage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__util_constants__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AccountModalClientDropdown__ = __webpack_require__(1328);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginStatus={USERNAME_OR_PASSWORD_WRONG:'USERNAME_OR_PASSWORD_WRONG',ACCOUNT_DISABLED:'ACCOUNT_DISABLED',SHOP_LOGIN_DISABLED:'SHOP_LOGIN_DISABLED',SUCCESS:'SUCCESS',USER_ALREADY_LOGGED_IN:'USER_ALREADY_LOGGED_IN'};var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({'account.loginStatus.USERNAME_OR_PASSWORD_WRONG':{'id':'account.loginStatus.USERNAME_OR_PASSWORD_WRONG','defaultMessage':'Invalid username or password!'},'account.loginStatus.ACCOUNT_DISABLED':{'id':'account.loginStatus.ACCOUNT_DISABLED','defaultMessage':'This user account has been disabled.'},'account.loginStatus.SHOP_LOGIN_DISABLED':{'id':'account.loginStatus.SHOP_LOGIN_DISABLED','defaultMessage':'Logging in is not allowed at this time.'},// This is likely not ever used, but it is defined here to cover every possible LoginStatus value.
'account.loginStatus.SUCCESS':{'id':'account.loginStatus.SUCCESS','defaultMessage':'Logged in.'},'account.loginStatus.USER_ALREADY_LOGGED_IN':{'id':'account.loginStatus.USER_ALREADY_LOGGED_IN','defaultMessage':'You are already logged in!'}});var AccountModal=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(AccountModal,_Component);function AccountModal(props){_classCallCheck(this,AccountModal);var _this=_possibleConstructorReturn(this,(AccountModal.__proto__||Object.getPrototypeOf(AccountModal)).call(this,props));_initialiseProps.call(_this);_this.state={loginStatus:null,loginLoading:false,registerLoading:false,clientLoadingState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].NONE,resetPasswordError:null,resetPasswordRequestState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].NONE,selectedClient:null,clientSearch:''};var accountStore=props.accountStore,configStore=props.configStore,useAsModal=props.useAsModal;var infoPageId=useAsModal?configStore.infoPages.customerBenefits:configStore.infoPages.entryLogin;if(accountStore.accountModal.isOpen&&infoPageId||!useAsModal&&infoPageId){_this.maybeLoadBenefitsInfoPage();}Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["observe"])(accountStore.accountModal,function(change){// Reset state when reopening the modal
if(change.name==='isOpen'&&!change.oldValue.value&&change.newValue.value){_this.setState(function(){return{loginStatus:null,loginLoading:false,registerLoading:false,clientLoadingState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].NONE,resetPasswordError:null,resetPasswordRequestState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].NONE,selectedClient:null,clientSearch:''};});}});return _this;}_createClass(AccountModal,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,accountStore=_props.accountStore,configStore=_props.configStore,infoPageStore=_props.infoPageStore,useAsModal=_props.useAsModal;var pageId=useAsModal?configStore.infoPages.customerBenefits:configStore.infoPages.entryLogin;if((accountStore.accountModal.isOpen&&pageId||!useAsModal&&pageId)&&infoPageStore.pageStates.get(pageId)!==__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADING&&infoPageStore.pageStates.get(pageId)!==__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED&&infoPageStore.pageStates.get(pageId)!==__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].ERROR){this.maybeLoadBenefitsInfoPage();}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,accountStore=_props2.accountStore,useAsModal=_props2.useAsModal;/* Reactstrap doesn't support document at the moment.
    *  https://github.com/reactstrap/reactstrap/issues/1071
    *  Once the bug is fixed modal can be tested in SSR env.
    * */if(window.isSSR&&useAsModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,useAsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["C" /* Modal */],{toggle:accountStore.accountModal.toggle,className:'AccountModal',size:'lg',isOpen:accountStore.accountModal.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["F" /* ModalHeader */],{className:'AccountModal__header',toggle:accountStore.accountModal.toggle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* ModalBody */],null,this.getNav(),this.getBody())),!useAsModal&&this.getBody(),['openRegistrationModal','openLoginModal','openPasswordForgottenModal'].map(function(param){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__route_QueryParamRedirect__["a" /* default */],{key:param,paramName:param,to:function to(){return _this2.getPathForRedirect(param);},onRedirect:function onRedirect(){return _this2.openModalOnRedirect(param);}});}));}}]);return AccountModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this3=this;this.tabs=[{id:__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].LOGIN,text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].logInSentence)},{id:__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].REGISTER,text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].accountCreateSentence)},{id:__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].CHANGE_CLIENT,text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].accountChangeClientSentence)}];this.maybeLoadBenefitsInfoPage=function(){var _props3=_this3.props,infoPageStore=_props3.infoPageStore,configStore=_props3.configStore,accountStore=_props3.accountStore,useAsModal=_props3.useAsModal;var pageId=useAsModal?configStore.infoPages.customerBenefits:configStore.infoPages.entryLogin;if((accountStore.accountModal.isOpen&&configStore.registration.enabled&&pageId||!useAsModal&&pageId)&&pageId.length>0&&infoPageStore.pageStates.get(pageId)!==__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED&&infoPageStore.pageStates.get(pageId)!==__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].ERROR){infoPageStore.loadPage(pageId).catch(function(e){if(e.responce&&e.responce.status!==404){console.error(e);}});}};this.loadClients=function(){var accountStore=_this3.props.accountStore;var searchText=_this3.state.clientSearch;if(accountStore.accountModal.isOpen&&accountStore.isClientLoginEnabled&&_this3.state.clientLoadingState!==__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADING&&searchText.length>1){_this3.setState(function(){return{clientLoadingState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADING};});accountStore.loadClients(searchText).then(function(){_this3.setState(function(){return{clientLoadingState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED};});}).catch(function(e){console.log(e);});}};this.setClientSearch=function(text){_this3.setState({clientSearch:text.toLowerCase()});};this.getInfoPage=function(){var _props4=_this3.props,configStore=_props4.configStore,infoPageStore=_props4.infoPageStore,useAsModal=_props4.useAsModal;var infoPageId=useAsModal?configStore.infoPages.customerBenefits:configStore.infoPages.entryLogin;return infoPageId&&infoPageStore.pageStates.get(infoPageId)===__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED?infoPageStore.pages.get(infoPageId):null;};this.getBenefitsState=function(){var _props5=_this3.props,infoPageStore=_props5.infoPageStore,configStore=_props5.configStore,useAsModal=_props5.useAsModal;var infoPageId=useAsModal?configStore.infoPages.customerBenefits:configStore.infoPages.entryLogin;if(!infoPageId){return __WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED;}if(infoPageStore.pageStates.get(infoPageId)!==__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADING){return __WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED;}return infoPageStore.pageStates.get(infoPageId);};this.getProductListProducts=function(products){if(!products){return;}var productListProducts=[];products.forEach(function(product){productListProducts.push({extendedId:product.id,quantity:product.quantity});});return productListProducts;};this.loginStatusOk=function(status){return status===LoginStatus.SUCCESS||status===LoginStatus.USER_ALREADY_LOGGED_IN;};this.login=function(values){var accountStore=_this3.props.accountStore;_this3.setState({loginLoading:true});var storageProductListProducts=Object(__WEBPACK_IMPORTED_MODULE_29__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_30__util_constants__["a" /* storageKeys */].wishlist);var productListProducts=_this3.getProductListProducts(storageProductListProducts);accountStore.login(values.username,values.password,productListProducts).then(function(response){_this3.processLogin(response);});};this.getPostLoginRedirectPath=function(response){return _this3.props.routeService.getPath(response.user.post_login_redirect_path);};this.ifPostLoginRedirectPath=function(response){return response&&response.user&&response.user.post_login_redirect_path&&response.user.post_login_redirect_path.length>0;};this.resetPassword=function(_ref){var email=_ref.email;_this3.setState(function(){return{resetPasswordRequestState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADING,resetPasswordError:null};},function(){_this3.props.accountStore.resetPassword(email).then(function(){_this3.setState(function(){return{resetPasswordRequestState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED};});}).catch(function(e){_this3.setState(function(){return{resetPasswordRequestState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].ERROR,resetPasswordError:e};});});});};this.getNav=function(){var _props6=_this3.props,accountStore=_props6.accountStore,configStore=_props6.configStore;var tabs=_this3.tabs.filter(function(tab){if(tab.id===__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].LOGIN&&accountStore.loggedIn){return false;}if(tab.id===__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].REGISTER&&(!configStore.registration.enabled||accountStore.loggedIn)){return false;}if(tab.id===__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].CHANGE_CLIENT&&(!accountStore.loggedIn||!accountStore.isClientLoginEnabled)){return false;}return true;}).map(function(tab){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* NavItem */],{key:tab.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["I" /* NavLink */],{href:'#',active:tab.id===_this3.props.accountStore.accountModal.tab,onClick:function onClick(){return _this3.props.accountStore.accountModal.setTab(tab.id);}},tab.text));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["G" /* Nav */],{tabs:true,className:'AccountModal__tabs'},tabs);};this.getCoupon=function(){var couponStore=_this3.props.couponStore;var coupon=couponStore.loginCoupon||couponStore.registrationCoupon;if(coupon){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccountModal__coupon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,coupon.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__coupon_CouponText__["a" /* default */],{coupon:coupon}),coupon.end_date&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__coupon_CouponExpiry__["a" /* default */],{date:coupon.end_date}),')'));}};this.getDefaultBenefits=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.registrationBenefitsHeader',defaultMessage:'Registration benefits'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'AccountModal__registration-benefits'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.registrationBenefitsNewsletterItem',defaultMessage:'Newsletter - you\'ll be informed of special offers and campaigns available through our store.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.registrationBenefitsFasterCheckoutItem',defaultMessage:'Easy and quick checkout - your personal details will be filled in automatically.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.registrationBenefitsOrderHistoryItem',defaultMessage:'Order history - you\'ll be able to see the orders you\'ve previously done through our store.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.registrationBenefitsPersistentCartItem',defaultMessage:'Persistent cart - the items you add to your cart will stay there until you remove them or confirm the order.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.registrationBenefitsWishlistItem',defaultMessage:'You\'ll be able to create a wishlist you can then share with your friends.'}))));};this.getBenefits=function(){var useAsModal=_this3.props.useAsModal;var infoPage=_this3.getInfoPage();return infoPage&&infoPage.content?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccountModal__body-content',dangerouslySetInnerHTML:{__html:infoPage.content}}):useAsModal&&_this3.getDefaultBenefits();};this.getClients=function(){var accountStore=_this3.props.accountStore;var clientSearch=_this3.state.clientSearch;var filteredList=accountStore.account.clients;return filteredList.filter(function(client){return client.firstname.toLowerCase().includes(clientSearch)||client.lastname.toLowerCase().includes(clientSearch)||client.company.toLowerCase().includes(clientSearch);});};this.onClientChange=function(client){_this3.setState(function(){return{selectedClient:client};});};this.processLogin=function(response){var _props7=_this3.props,accountStore=_props7.accountStore,configStore=_props7.configStore,languageStore=_props7.languageStore,routeService=_props7.routeService;var status=response.status,default_language_code=response.default_language_code;if(!_this3.loginStatusOk(status)){_this3.setState({loginStatus:LoginStatus[status],loginLoading:false,clientLoadingState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].NONE});}else{Object(__WEBPACK_IMPORTED_MODULE_29__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_30__util_constants__["a" /* storageKeys */].wishlist,[]);languageStore.getRedirectedUrl(default_language_code).then(function(url){accountStore.accountModal.toggle();// Reload in order to refresh everything
var browserUrl=_this3.ifPostLoginRedirectPath(response)?_this3.getPostLoginRedirectPath(response):url;if(accountStore.account.redirect_to_customers_prices){browserUrl=routeService.getPath(__WEBPACK_IMPORTED_MODULE_27__types_Paths__["a" /* default */].CustomerProducts);}if(configStore.account.isMoneyTransfer){// money transfer application always uses myAccount pages
browserUrl=accountStore.isBalanceUser?routeService.getPath(__WEBPACK_IMPORTED_MODULE_27__types_Paths__["a" /* default */].MyAccountBalanceSubUser):routeService.getPath(__WEBPACK_IMPORTED_MODULE_27__types_Paths__["a" /* default */].MyAccountBalanceUser);}window.location.assign(browserUrl);});}};this.clientLogin=function(){var accountStore=_this3.props.accountStore;_this3.setState({loginLoading:true});accountStore.loginClient(_this3.state.selectedClient.id).then(function(response){_this3.processLogin(response);});};this.getBody=function(){var _props8=_this3.props,accountStore=_props8.accountStore,configStore=_props8.configStore,useAsModal=_props8.useAsModal;var resetPassword=_this3.state.resetPasswordRequestState===__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.resetPasswordSuccessful',defaultMessage:'A password reset email has been sent to the provided address successfully. Remember to check your spam folder as well or make sure that the email address is correct if the message doesn\'t seem to have arrived.'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ResetPasswordForm__["a" /* default */],{onSubmit:_this3.resetPassword,disableSubmit:_this3.state.resetPasswordRequestState===__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADING});var resetPasswordContent=configStore.account.enableMyAccount?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'link',onClick:accountStore.accountModal.toggleResetPasswordVisible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.forgotPasswordLink',defaultMessage:'Forgot your password? Click here.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["m" /* Collapse */],{isOpen:accountStore.accountModal.resetPasswordVisible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'account.forgotPasswordInstructions',defaultMessage:'If you have forgotten your password, please enter the email address of your customer account below in order to reset your password.'})),_this3.state.resetPasswordError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__loader_ErrorHandler__["a" /* default */],{error:Object(__WEBPACK_IMPORTED_MODULE_21__util_error__["a" /* createErrorModel */])(_this3.state.resetPasswordError)}),resetPassword)):null;var content=void 0;switch(accountStore.accountModal.tab){case __WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].REGISTER:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:12},_this3.getCoupon()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__RegisterForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__loader_ContentForState__["a" /* default */],{state:_this3.getBenefitsState(),forLoaded:function forLoaded(){return _this3.getBenefits();}})));break;case __WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].CHANGE_CLIENT:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:12},_this3.state.loginStatus&&!_this3.loginStatusOk(_this3.state.loginStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},_this3.props.intl.formatMessage(messages['account.loginStatus.'+_this3.state.loginStatus])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__AccountModalClientDropdown__["a" /* default */],{client:_this3.state.selectedClient,clients:_this3.getClients(),clientFilter:_this3.state.clientSearch,setClientFilter:_this3.setClientSearch,searchClients:_this3.loadClients,onSelect:_this3.onClientChange,loading:_this3.state.clientLoadingState}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',onClick:_this3.clientLogin,disabled:!_this3.state.selectedClient},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].accountChangeClientSentence))));break;case __WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].LOGIN:default:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:12},_this3.getCoupon(),_this3.state.loginStatus&&!_this3.loginStatusOk(_this3.state.loginStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},_this3.props.intl.formatMessage(messages['account.loginStatus.'+_this3.state.loginStatus])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LoginForm__["a" /* default */],{onSubmit:_this3.login,disableSubmit:_this3.state.loginLoading}),resetPasswordContent,!useAsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccountModal__benefits-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__loader_ContentForState__["a" /* default */],{state:_this3.getBenefitsState(),forLoaded:function forLoaded(){return _this3.getBenefits();}}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccountModal__tab-content'},content);};this.getPathForRedirect=function(type){var location=_this3.props.location;var params=Object(__WEBPACK_IMPORTED_MODULE_23__util_queryString__["b" /* parse */])(location.search);delete params[type];params=Object(__WEBPACK_IMPORTED_MODULE_23__util_queryString__["c" /* stringify */])(params);if(params.length>0){params='?'+params;}return location.pathname+params+location.hash;};this.openModalOnRedirect=function(type){var accountModal=_this3.props.accountStore.accountModal;// Trigger the side effect (actually opening the modal)
// outside the render cycle.
setImmediate(function(){switch(type){case'openLoginModal':default:accountModal.setTab(__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].LOGIN);break;case'openRegistrationModal':accountModal.setTab(__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].REGISTER);break;case'openPasswordForgottenModal':accountModal.setTab(__WEBPACK_IMPORTED_MODULE_13__types_AccountModalTab__["b" /* default */].LOGIN);if(!accountModal.resetPasswordVisible){accountModal.toggleResetPasswordVisible();}break;}if(!accountModal.isOpen){accountModal.toggle();}});};},_temp))||_class;AccountModal.propTypes={location:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.location.isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_AccountStore__["a" /* default */]).isRequired,couponStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_CouponStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_LanguageStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_25__store_ConfigStore__["a" /* default */]).isRequired,infoPageStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_26__store_InfoPageStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_28__services_RouteService__["a" /* default */]).isRequired,useAsModal:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool};AccountModal.defaultProps={useAsModal:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('accountStore','couponStore','languageStore','configStore','infoPageStore','routeService')(AccountModal))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(277).setImmediate))

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1330);
var objectAssign = __webpack_require__(63);
var decodeComponent = __webpack_require__(1331);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TopLevelNavigationDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TopLevelNavigationDropdown=function(_Component){_inherits(TopLevelNavigationDropdown,_Component);function TopLevelNavigationDropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TopLevelNavigationDropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TopLevelNavigationDropdown.__proto__||Object.getPrototypeOf(TopLevelNavigationDropdown)).call.apply(_ref,[this].concat(args))),_this),_this.makeDropdownItem=function(id,path,name){var routeService=_this.props.routeService;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{key:id,tag:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],to:routeService.getPath(path)},name);},_this.getItems=function(){var _this$props=_this.props,sectionStore=_this$props.sectionStore,categoryStore=_this$props.categoryStore,configStore=_this$props.configStore;if(configStore.activateSections){return sectionStore.sections.map(function(section){return _this.makeDropdownItem(section.id,section.path,section.display_name);});}else{return categoryStore.categories.map(function(category){return _this.makeDropdownItem(category.id,category.path,category.navigationName);});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TopLevelNavigationDropdown,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["T" /* UncontrolledButtonDropdown */],{className:'TopLevelNavigationDropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* DropdownToggle */],{block:true,caret:true/* DropdownToggle has a default color definition that cannot be easily
               removed. We style the button with its own color scheme in our style
               separately, so we don't want any of the existing color schemes to be
               applied here. */,color:'top-level-nav',className:'TopLevelNavigationDropdown__toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].categoriesTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["q" /* DropdownMenu */],null,this.getItems()));}}]);return TopLevelNavigationDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TopLevelNavigationDropdown.propTypes={sectionStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_SectionStore__["a" /* default */]).isRequired,categoryStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_CategoryStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_mobx_react__["c" /* inject */])('sectionStore','categoryStore','configStore','routeService')(TopLevelNavigationDropdown));

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEOHomePage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SEODescription__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEOHomePage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SEOHomePage,_Component);function SEOHomePage(){_classCallCheck(this,SEOHomePage);return _possibleConstructorReturn(this,(SEOHomePage.__proto__||Object.getPrototypeOf(SEOHomePage)).apply(this,arguments));}_createClass(SEOHomePage,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,routeService=_props.routeService;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SEOTitle__["a" /* default */],{title:configStore.configurationTexts.CONF_SEO_TITLE||__WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__["a" /* default */].homeTitle,noSuffix:configStore.configurationTexts.CONF_SEO_TITLE!==''}),configStore.configurationTexts.CONF_SEO_DESCRIPTION&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SEODescription__["a" /* default */],{content:configStore.configurationTexts.CONF_SEO_DESCRIPTION}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_5__types_Paths__["a" /* default */].FrontPage)}));}}]);return SEOHomePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SEOHomePage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','routeService')(SEOHomePage));

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IntlWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_en__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_fi__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_fi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_fi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_sv__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_sv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_sv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_ru__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messages_en_json__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messages_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__messages_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__messages_fi_json__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__messages_fi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__messages_fi_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__messages_sv_json__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__messages_sv_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__messages_sv_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__messages_ru_json__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__messages_ru_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__messages_ru_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_TranslationStore__ = __webpack_require__(141);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* addLocaleData */])([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_en___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_fi___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_sv___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_ru___default.a)));var validLanguages=['en','fi','sv','ru'];var IntlWrapper=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(IntlWrapper,_Component);function IntlWrapper(props){_classCallCheck(this,IntlWrapper);var _this=_possibleConstructorReturn(this,(IntlWrapper.__proto__||Object.getPrototypeOf(IntlWrapper)).call(this,props));_this.translations={en:__WEBPACK_IMPORTED_MODULE_8__messages_en_json___default.a,fi:__WEBPACK_IMPORTED_MODULE_9__messages_fi_json___default.a,sv:__WEBPACK_IMPORTED_MODULE_10__messages_sv_json___default.a,ru:__WEBPACK_IMPORTED_MODULE_11__messages_ru_json___default.a};return _this;}_createClass(IntlWrapper,[{key:'render',value:function render(){var _props=this.props,languageStore=_props.languageStore,translationStore=_props.translationStore,overrideLocale=_props.overrideLocale,loadableMessages=_props.loadableMessages;var locale=!!overrideLocale&&validLanguages.includes(overrideLocale)?overrideLocale:languageStore.activeLocale;var appMessages=this.translations[locale]||this.translations.en;var extraMessages=void 0;if(loadableMessages){extraMessages=loadableMessages[locale]||loadableMessages.en;}// Override messages with those provided by the backend
// Extra messages include translations that are not needed by default and should be lazy loaded at some point.
var messages=Object.assign({},appMessages,translationStore.messages,extraMessages);// The locale and translation are both loaded only at the start of the page load. Lazy loading will be added later.
// Locale changes from the UI will reload the page to make sure the new locale is loaded fully.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* IntlProvider */],{locale:locale,messages:messages},this.props.children);}}]);return IntlWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;IntlWrapper.propTypes={languageStore:Object(__WEBPACK_IMPORTED_MODULE_12__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_LanguageStore__["a" /* default */]).isRequired,translationStore:Object(__WEBPACK_IMPORTED_MODULE_12__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_TranslationStore__["a" /* default */]).isRequired,loadableMessages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,overrideLocale:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (IntlWrapper);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrderCloneButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Order__ = __webpack_require__(203);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrderCloneButton=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(OrderCloneButton,_Component);function OrderCloneButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrderCloneButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrderCloneButton.__proto__||Object.getPrototypeOf(OrderCloneButton)).call.apply(_ref,[this].concat(args))),_this),_this.handleAddFromOrder=function(){var _this$props=_this.props,order=_this$props.order,cartStore=_this$props.cartStore;// If cartStore is already loading, don't do anything
if(cartStore.state===__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADING){return;}if(cartStore.cart){cartStore.addFromOrder(order.id).catch(function(e){console.error(e);});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrderCloneButton,[{key:'render',value:function render(){var _this2=this;var cartStore=this.props.cartStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'OrderCloneButton',color:'primary',disabled:cartStore.state!==__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADED,onClick:function onClick(){return window.confirm(_this2.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].confirmAddToCartTitle))&&_this2.handleAddFromOrder();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].cloneOrder));}}]);return OrderCloneButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;OrderCloneButton.propTypes={cartStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_CartStore__["a" /* default */]).isRequired,order:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Order__["a" /* default */]),intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('cartStore')(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(OrderCloneButton)));

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddressForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_Address__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_CheckboxField__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_SelectField__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_FormValidator__ = __webpack_require__(102);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={company:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].companyTitle),firstname:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].firstNameTitle),lastname:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].lastNameTitle),postalCode:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].zipCodeTitle),streetAddress:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].streetAddressTitle),city:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].cityTitle),telephone:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].telephoneTitle),countryId:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].countryTitle),setAsPrimary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'address.setAsPrimary',defaultMessage:'Set as a primary address'})};function createOption(value,label){return{value:value,label:label};}var AddressForm=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(AddressForm,_Component);function AddressForm(props){_classCallCheck(this,AddressForm);var _this=_possibleConstructorReturn(this,(AddressForm.__proto__||Object.getPrototypeOf(AddressForm)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,accountStore=_this$props.accountStore,formValidator=_this$props.formValidator,address=_this$props.address;_this.form=Object(__WEBPACK_IMPORTED_MODULE_5__models_Form__["a" /* createForm */])({company:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address&&address.company},accountStore.isRetailer?[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(labels.company)]:[]),firstname:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address&&address.firstname},!accountStore.isRetailer?formValidator.firstName(labels.firstname):formValidator.firstName(labels.firstname).map(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["a" /* allowEmpty */])),lastname:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address&&address.lastname},!accountStore.isRetailer?formValidator.lastName(labels.firstname):formValidator.lastName(labels.firstname).map(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["a" /* allowEmpty */])),streetAddress:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address&&address.street_address},formValidator.streetAddress(labels.streetAddress)),postalCode:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address&&address.postal_code},formValidator.postalCode(labels.postalCode)),city:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address&&address.city},formValidator.city(labels.city)),countryId:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address?address.country_id:accountStore.account.country_id}),telephone:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address&&address.telephone},formValidator.telephone(labels.telephone).map(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["a" /* allowEmpty */])),setAsPrimary:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:address&&address.is_primary?'1':''})});return _this;}_createClass(AddressForm,[{key:'render',value:function render(){var _props=this.props,loading=_props.loading,accountStore=_props.accountStore,buttonText=_props.buttonText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{className:this.formName,noValidate:true,onSubmit:this.handleSubmit},this.field('firstname',{autoComplete:'given-name',required:!accountStore.isRetailer}),this.field('lastname',{autoComplete:'family-name',required:!accountStore.isRetailer}),this.field('company',{autoComplete:'organization',required:accountStore.isRetailer}),this.field('streetAddress',{autoComplete:'street-address',required:true}),this.field('postalCode',{autoComplete:'postal-code',required:true}),this.field('city',{autoComplete:'address-level2',required:true}),this.renderCountrySelect(),this.field('telephone',{type:'tel',autoComplete:'tel-national'}),this.checkbox('setAsPrimary',{options:[createOption('1',labels.setAsPrimary)]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',disabled:this.form.valid===false||loading},buttonText));}}]);return AddressForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='AddressForm';this.handleSubmit=function(e){var onSubmit=_this2.props.onSubmit;e.preventDefault();_this2.form.validate();if(_this2.form.valid){onSubmit(_this2.form.getFieldValues());}};this.field=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.checkbox=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_CheckboxField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName},props));};this.renderCountrySelect=function(){var countryStore=_this2.props.countryStore;if(countryStore.countries.length<=1){return null;}var fieldName='countryId';var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__form_SelectField__["a" /* default */],{field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName],options:countryStore.countries.map(function(country){return createOption(String(country.id),country.name);})});};},_temp))||_class;AddressForm.propTypes={loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,buttonText:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,address:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__models_Address__["a" /* default */]),onSubmit:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AccountStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_CountryStore__["a" /* default */]).isRequired,formValidator:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_16__services_FormValidator__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('accountStore','countryStore','formValidator')(AddressForm));

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_CheckboxField__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_FormValidator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_CustomerUser__ = __webpack_require__(267);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={firstname:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].firstNameTitle),lastname:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].lastNameTitle),email:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].emailTitle),telephone:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].telephoneTitle),loginName:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].emailOrUsernameTitle),password:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].passwordTitle),isActive:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].isActiveLabel),notifyUser:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].notifyUserLabel),allowCreateAddress:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].allowUserCreateAddressLabel)};function createOption(value,label){return{value:value,label:label};}var UserForm=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(UserForm,_Component);function UserForm(props){_classCallCheck(this,UserForm);var _this=_possibleConstructorReturn(this,(UserForm.__proto__||Object.getPrototypeOf(UserForm)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,formValidator=_this$props.formValidator,user=_this$props.user;_this.form=Object(__WEBPACK_IMPORTED_MODULE_12__models_Form__["a" /* createForm */])({firstname:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({value:user&&user.firstname},formValidator.firstName(labels.firstname)),lastname:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({value:user&&user.lastname},formValidator.lastName(labels.firstname)),email:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({value:user&&user.email},formValidator.email(labels.email)),telephone:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({value:user&&user.telephone},formValidator.telephone(labels.telephone).map(__WEBPACK_IMPORTED_MODULE_7__util_formValidators__["a" /* allowEmpty */])),loginName:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({value:user&&user.login_name},formValidator.username(labels.loginName)),password:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({},user?null:formValidator.password(labels.password)),// Apparently our form handles string zero, '0', as a valid value and we have to use empty string.
allowUserCreateAddress:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({value:user&&user.allow_address_modifications===false?'':'1'}),isActive:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({value:user&&user.is_active===false?'':'1'}),notifyUser:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({value:'1'})});return _this;}_createClass(UserForm,[{key:'render',value:function render(){var _props=this.props,loading=_props.loading,buttonText=_props.buttonText,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{className:this.formName,noValidate:true,onSubmit:this.handleSubmit},this.field('firstname',{autoComplete:'given-name',required:true}),this.field('lastname',{autoComplete:'family-name',required:true}),this.field('email',{autoComplete:'email',required:true}),this.field('telephone',{type:'tel',autoComplete:'tel-national'}),this.field('loginName',{autocapitalization:'off',autoComplete:'username',required:true}),this.field('password',{type:'password',autoComplete:'new-password',required:true,disabled:!!user}),this.checkbox('allowUserCreateAddress',{options:createOption('1',labels.allowCreateAddress)}),this.checkbox('isActive',{options:createOption('1',labels.isActive),disabled:!!!user}),this.checkbox('notifyUser',{options:createOption('1',labels.notifyUser),disabled:!!!user}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',disabled:this.form.valid===false||loading},buttonText));}}]);return UserForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='UserForm';this.handleSubmit=function(e){var onSubmit=_this2.props.onSubmit;e.preventDefault();_this2.form.validate();if(_this2.form.valid){onSubmit(_this2.form.getFieldValues());}};this.field=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.checkbox=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_CheckboxField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName},props));};},_temp))||_class;UserForm.propTypes={loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,buttonText:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,user:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__models_CustomerUser__["a" /* default */]),onSubmit:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,formValidator:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_FormValidator__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('formValidator')(UserForm));

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceUserForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_CheckboxField__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_FormValidator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_BalanceUser__ = __webpack_require__(174);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={firstName:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].firstNameTitle),lastName:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].lastNameTitle),email:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].emailTitle),loginName:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].emailOrUsernameTitle),password:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].passwordTitle),isActive:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].isActiveLabel)};var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({updatePassword:{'id':'myAccount.balanceUserAccountUpdatePassword','defaultMessage':'Optional. Only change, if you want to change your password.'}});var BalanceUserForm=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(BalanceUserForm,_Component);function BalanceUserForm(props){_classCallCheck(this,BalanceUserForm);var _this=_possibleConstructorReturn(this,(BalanceUserForm.__proto__||Object.getPrototypeOf(BalanceUserForm)).call(this,props));_initialiseProps.call(_this);_this.createForm();return _this;}_createClass(BalanceUserForm,[{key:'render',value:function render(){var _props=this.props,loading=_props.loading,buttonText=_props.buttonText,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{className:this.formName,noValidate:true,onSubmit:this.handleSubmit},this.getFirstName(),this.getLastName(),this.getEmail(),this.getLoginName(),this.getPassword(user),this.getActiveStatus(user),this.renderSubmitButton(loading,buttonText));}}]);return BalanceUserForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='BalanceUserForm';this.createForm=function(){var _props2=_this2.props,formValidator=_props2.formValidator,user=_props2.user;_this2.form=Object(__WEBPACK_IMPORTED_MODULE_11__models_Form__["a" /* createForm */])({firstName:Object(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["a" /* createFormField */])({value:user&&user.firstname},formValidator.firstName(labels.firstName)),lastName:Object(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["a" /* createFormField */])({value:user&&user.lastname},formValidator.lastName(labels.lastName)),email:Object(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["a" /* createFormField */])({value:user&&user.email},formValidator.email(labels.email)),loginName:Object(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["a" /* createFormField */])({value:user&&user.login_name},formValidator.username(labels.loginName)),password:Object(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["a" /* createFormField */])({value:user&&user.password},user?null:formValidator.password(labels.password)),isActive:Object(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["a" /* createFormField */])({value:user&&user.is_active===false?'':'1'})});};this.getFirstName=function(){return _this2.field('firstName',{autoComplete:'given-name',required:true});};this.getLastName=function(){return _this2.field('lastName',{autoComplete:'family-name',required:true});};this.getEmail=function(){return _this2.field('email',{autoComplete:'email',required:true});};this.getLoginName=function(){return _this2.field('loginName',{autocapitalization:'off',autoComplete:'username',required:true});};this.getPassword=function(user){return _this2.field('password',{type:'password',autoComplete:'new-password'},!!user&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],messages.updatePassword));};this.getActiveStatus=function(user){return _this2.checkbox('isActive',{options:_this2.createOption('1',labels.isActive),disabled:!!!user});};this.createOption=function(value,label){return{value:value,label:label};};this.renderSubmitButton=function(loading,buttonText){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',disabled:_this2.form.valid===false||loading},buttonText);};this.handleSubmit=function(e){var onSubmit=_this2.props.onSubmit;e.preventDefault();_this2.form.validate();if(_this2.form.valid){onSubmit(_this2.form.getFieldValues());}};this.field=function(fieldName,props,description){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName],description:description},props));};this.checkbox=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_CheckboxField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName},props));};},_temp))||_class;BalanceUserForm.propTypes={loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,buttonText:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,user:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__models_BalanceUser__["a" /* default */]),onSubmit:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,formValidator:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10__services_FormValidator__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('formValidator')(BalanceUserForm));

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_SortOrder__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_AdPages__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_account_AccountModalLink__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomerProductsPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CustomerProductsPage,_Component);function CustomerProductsPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CustomerProductsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CustomerProductsPage.__proto__||Object.getPrototypeOf(CustomerProductsPage)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].customerProductsTitle),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].CustomerProducts}]);},_this.getSearchParams=function(){return{bannerPage:__WEBPACK_IMPORTED_MODULE_23__types_AdPages__["a" /* default */].CUSTOMER_PRODUCTS};},_this.renderLogIn=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_account_AccountModalLink__["a" /* default */],{tab:__WEBPACK_IMPORTED_MODULE_24__types_AccountModalTab__["b" /* default */].LOGIN},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{tag:'span',color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].logInSentence)));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CustomerProductsPage,[{key:'render',value:function render(){var listName='Customer Products List';var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,routeService=_props.routeService,accountStore=_props.accountStore;var contentAllowed=accountStore.loggedIn&&accountStore.isRetailer;var fixedParams={orderBy:__WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__["a" /* default */].CATEGORY,order:__WEBPACK_IMPORTED_MODULE_10__types_SortOrder__["a" /* default */].ASC,hasCustomerPrice:1};if(sectionStore.activeSection){fixedParams.sections=[sectionStore.activeSection.id];}var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ad_MainBanner__["a" /* default */],{searchParams:this.getSearchParams()});var mainBannerWithinContent=configStore.mainBanner.withinContent&&!configStore.mainBanner.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_27__types_CommonPage__["b" /* default */].CUSTOMER_PRODUCTS,className:'CustomerProductsPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_head_SEOTitle__["a" /* default */],{title:Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].customerProductsTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].CustomerProducts)}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'CustomerProductsPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].customerProductsTitle)),contentAllowed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showSort:false,showCategoryHeaders:true}),!contentAllowed&&!accountStore.loggedIn&&this.renderLogIn(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__["a" /* default */],{searchParams:this.getSearchParams()}))})));}}]);return CustomerProductsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CustomerProductsPage.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_26__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_SectionStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_20__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','configStore','sectionStore','routeService')(CustomerProductsPage)));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_head_RobotsMeta__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_checkout_MyAccountThankYouPageContent__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({successfulPurchasePageTitle:{'id':'checkout.successfulPurchasePageTitle','defaultMessage':'Your order has been registered!'}});var MyAccountThankYouPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountThankYouPage,_Component);function MyAccountThankYouPage(){_classCallCheck(this,MyAccountThankYouPage);return _possibleConstructorReturn(this,(MyAccountThankYouPage.__proto__||Object.getPrototypeOf(MyAccountThankYouPage)).apply(this,arguments));}_createClass(MyAccountThankYouPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_9__types_CommonPage__["b" /* default */].MY_ACCOUNT_THANK_YOU,className:'MyAccountThankYouPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'MyAccountThankYouPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_head_SEOTitle__["a" /* default */],{title:messages.successfulPurchasePageTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_head_RobotsMeta__["a" /* default */],{noindex:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_checkout_MyAccountThankYouPageContent__["a" /* default */],null))})));}}]);return MyAccountThankYouPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (MyAccountThankYouPage);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThankYouPageContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_OrderStore__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loader_ErrorHandler__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__route_Redirect302__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CheckoutOrderConfirmation__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__bootstrap_CustomCol__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__analytics_TrackingPixels__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__analytics_ShopAlike__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ad_ContentSlots__ = __webpack_require__(240);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThankYouPageContent=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(ThankYouPageContent,_Component);function ThankYouPageContent(props){_classCallCheck(this,ThankYouPageContent);var _this=_possibleConstructorReturn(this,(ThankYouPageContent.__proto__||Object.getPrototypeOf(ThankYouPageContent)).call(this,props));_initialiseProps.call(_this);_this.state={productStoreError:null,renderTrackingPixels:false};return _this;}_createClass(ThankYouPageContent,[{key:'componentDidMount',value:function componentDidMount(){this.loadOrder();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ThankYouPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:this.getCurrentlyRunningRequestState(),forLoaded:this.renderSuccessPage,error:this.getError(),errorHandler:this.renderErrorHandler}));}}]);return ThankYouPageContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.loadOrder=function(){var _props=_this2.props,match=_props.match,location=_props.location,orderStore=_props.orderStore,configStore=_props.configStore;var _match$params=match.params,orderId=_match$params.orderId,trackingCode=_match$params.trackingCode;var queryParams=__WEBPACK_IMPORTED_MODULE_20__util_queryString__["b" /* parse */](location.search);var merchantId=queryParams.merchantId;var orderParams={orderId:orderId,trackingCode:trackingCode,merchantId:merchantId};orderStore.loadCurrentOrderPostPurchase(orderParams).then(function(){configStore.gtm.enabled&&_this2.updateAnalyticsDataLayer();_this2.loadProductData();}).catch(function(error){return console.error(error);});};this.updateAnalyticsDataLayer=function(){var _props2=_this2.props,analytics=_props2.analytics,orderStore=_props2.orderStore;var currentOrder=orderStore.currentOrder;// Because the data array is not organized with keys or inside js objects, we have to assume that the correct object is at index 0.
if(currentOrder&&currentOrder.shippingMethod&&window.dataLayer&&window.dataLayer.length>0){var dimensionKey='shippingMethod';var dimensionValue=currentOrder.shippingMethod.name;analytics.updateDimension(dimensionKey,dimensionValue);}if(currentOrder&&currentOrder.paymentMethod&&window.dataLayer&&window.dataLayer.length>0){var _dimensionKey='paymentMethod';var _dimensionValue=currentOrder.paymentMethod.name;analytics.updateDimension(_dimensionKey,_dimensionValue);}};this.loadProductData=function(){var productStore=_this2.props.productStore;productStore.loadProducts(Object.assign({},_this2.getProductIdQuery(),{includeChildProducts:1})).then(function(){_this2.sendAnalyticsRequest();_this2.setupAnalyticsTrackingEvent();}).catch(function(error){_this2.setState(function(){return{productStoreError:Object(__WEBPACK_IMPORTED_MODULE_15__util_error__["a" /* createErrorModel */])(error)};});});};this.sendAnalyticsRequest=function(){var _props3=_this2.props,productStore=_props3.productStore,analytics=_props3.analytics,orderStore=_props3.orderStore;var currentOrder=orderStore.currentOrder;_this2.setState({renderTrackingPixels:!currentOrder.is_seen});if(currentOrder.is_seen){return;}var productData=productStore.productQueryResults.get(_this2.getProductRequestIdentifier()).data;analytics.purchase(currentOrder,productData);};this.setupAnalyticsTrackingEvent=function(){var _props4=_this2.props,onOrderSuccess=_props4.onOrderSuccess,orderStore=_props4.orderStore;var currentOrder=orderStore.currentOrder;onOrderSuccess&&currentOrder&&_this2.props.onOrderSuccess(currentOrder);};this.getProductIdQuery=function(){var currentOrder=_this2.props.orderStore.currentOrder;return{ids:currentOrder?currentOrder.products.map(function(product){return product.product_id;}):[]};};this.getProductRequestIdentifier=function(){return Object(__WEBPACK_IMPORTED_MODULE_14__util_query__["a" /* paramsToQueryIdentifier */])(Object.assign({},_this2.getProductIdQuery(),{includeChildProducts:1}));};this.getProductRequestState=function(){var _props5=_this2.props,productStore=_props5.productStore,orderStore=_props5.orderStore;if(!orderStore.currentOrder){return __WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].NONE;}return productStore.productQueryStates.get(_this2.getProductRequestIdentifier());};this.getCurrentlyRunningRequestState=function(){var orderStore=_this2.props.orderStore;var currentRequestState=[orderStore.currentOrderState,_this2.getProductRequestState()].find(function(state){return state!==__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADED;});return currentRequestState||__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADED;};this.getBreadcrumbsPath=function(){var intl=_this2.props.intl;return[{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].checkoutTitle)},{text:intl.formatMessage({id:'checkout.successfulPurchaseBreadcrumbName',defaultMessage:'Thank You'})}];};this.getError=function(){var orderStore=_this2.props.orderStore;var productStoreError=_this2.state.productStoreError;var error=orderStore.lastCurrentOrderError||productStoreError;return error||null;};this.renderHtmlWidget=function(widgetHtml){var doc=document.implementation.createHTMLDocument('');doc.body.innerHTML=widgetHtml;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_helmet_async___default.a,null,[].map.call(doc.getElementsByTagName('script'),function(el){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,el.textContent);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:widgetHtml}}));};this.renderErrorHandler=function(props){var configStore=_this2.props.configStore;var checkout=configStore.checkout;switch(props.error.httpStatusCode){case 401:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__route_Redirect302__["a" /* default */],{to:'/'});case 404:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__route_Redirect302__["a" /* default */],{to:checkout.checkoutPath});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__loader_ErrorHandler__["a" /* default */],props);}};this.getContent=function(){var orderStore=_this2.props.orderStore;var currentOrder=orderStore.currentOrder;var paymentMethodMessages=currentOrder.payment_method_messages;return currentOrder.html_widget?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__bootstrap_CustomCol__["a" /* default */],{xs:12,md:10,xxl:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ThankYouPageContent__payment-method-messages'},paymentMethodMessages&&paymentMethodMessages.length>0&&paymentMethodMessages.map(function(message,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_reactstrap__["a" /* Alert */],{key:index,color:'warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,message));})),_this2.renderHtmlWidget(currentOrder.html_widget)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__CheckoutOrderConfirmation__["a" /* default */],null);};this.renderBannerContent=function(){var searchParams={bannerZone:__WEBPACK_IMPORTED_MODULE_30__types_AdZones__["a" /* default */].ORDER_CONFIRMATION_CONTENT};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ThankYouPageContent__banner-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__ad_ContentSlots__["a" /* default */],{searchParams:searchParams}));};this.renderReceiptUrl=function(){var currentOrder=_this2.props.orderStore.currentOrder;if(!currentOrder){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,currentOrder.receipt_url&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_reactstrap__["e" /* Button */],{tag:'a',href:currentOrder.receipt_url,target:'_blank',rel:'nofollow noopener',color:'primary',className:'ThankYouPageContent__receipt-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__common_Icon__["a" /* default */],{name:'print'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'checkout.successfulPurchaseReceipt',defaultMessage:'Receipt'})));};this.renderSuccessPage=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:_this2.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_reactstrap__["O" /* Row */],{className:'ThankYouPageContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__bootstrap_CustomCol__["a" /* default */],{xs:12,className:'ThankYouPageContent__order-confirmation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'checkout.successfulPurchasePageHeading',defaultMessage:'Order confirmation'}))),_this2.getContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__bootstrap_CustomCol__["a" /* default */],{xs:12,md:10,xxl:7},_this2.renderBannerContent(),_this2.renderReceiptUrl(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ThankYouPageContent__back-to-store-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_reactstrap__["e" /* Button */],{tag:__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */],to:'/',color:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'checkout.backToStore',defaultMessage:'Back to the store'}))))),_this2.state.renderTrackingPixels&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__analytics_TrackingPixels__["a" /* default */],null),_this2.state.renderTrackingPixels&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__analytics_ShopAlike__["a" /* default */],null));};},_temp))||_class;ThankYouPageContent.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_29__store_ConfigStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_27__store_CurrencyStore__["a" /* default */]).isRequired,orderStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_OrderStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_ProductStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_13__analytics_Analytics__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,match:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.match.isRequired,location:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.location.isRequired,onOrderSuccess:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','currencyStore','orderStore','productStore','analytics')(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(ThankYouPageContent))));

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isTestingTool;
/* harmony export (immutable) */ __webpack_exports__["a"] = browserLanguage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(352);
/**
 * Tries to parse testing tools from the current user agent.
 *
 * @returns {boolean}
 */function isTestingTool(){var testingTools=['Chrome-Lighthouse'];var response=false;testingTools.forEach(function(tool){if(navigator.userAgent.indexOf(tool)!==-1){response=true;}});return response;}function browserLanguage(){return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["b" /* parseRFC5646Tag */])(navigator.language);}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(597);
module.exports = __webpack_require__(602);


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(598).enable();
  window.Promise = __webpack_require__(600);
}

// fetch() polyfill for making API calls.
__webpack_require__(601);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(63);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(381);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(381);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 601 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfill__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrowserApp__ = __webpack_require__(613);
__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.hydrate(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BrowserApp__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomEvent_polyfill__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomEvent_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CustomEvent_polyfill__);


/***/ }),
/* 604 */
/***/ (function(module, exports) {

(function(){if(typeof window.CustomEvent==='function')return false;function CustomEvent(event,params){params=params||{bubbles:false,cancelable:false,detail:undefined};var evt=document.createEvent('CustomEvent');evt.initCustomEvent(event,params.bubbles,params.cancelable,params.detail);return evt;}CustomEvent.prototype=window.Event.prototype;window.CustomEvent=CustomEvent;})();

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(63),n=__webpack_require__(204),p=__webpack_require__(382),q=__webpack_require__(205),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(204),ea=__webpack_require__(0),m=__webpack_require__(607),A=__webpack_require__(63),C=__webpack_require__(205),fa=__webpack_require__(608),ha=__webpack_require__(609),ja=__webpack_require__(610),ka=__webpack_require__(382);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(611);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(612);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_maintenance_MaintenanceHandler__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_LocationContext__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_error_SentryErrorBoundary__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_FormValidator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState=window.__INITIAL_STATE__||{};var pageLoadQueryParams=Object(__WEBPACK_IMPORTED_MODULE_13__util_queryString__["b" /* parse */])(window.location.search);var apiWrapper=new __WEBPACK_IMPORTED_MODULE_7__services_ApiWrapper__["a" /* default */]("/backend/api/v1/"||window.location.hostname+'/backend/v1',{gclid:pageLoadQueryParams.gclid,cuad:pageLoadQueryParams.cuad});var store=__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].create(initialState,{apiWrapper:apiWrapper});var routeService=new __WEBPACK_IMPORTED_MODULE_10__services_RouteService__["a" /* default */](store.sectionStore,store.languageStore,store.configStore,store.categoryStore);var formValidator=new __WEBPACK_IMPORTED_MODULE_12__services_FormValidator__["a" /* default */](store.configStore);var analytics=new __WEBPACK_IMPORTED_MODULE_4__analytics_Analytics__["a" /* default */](store.currencyStore,store.accountStore,store.uiStore);var locationContext=new __WEBPACK_IMPORTED_MODULE_9__services_LocationContext__["b" /* default */](function(){return window.location.protocol;},function(){return window.location.host;},function(){return window.location.href;});var BrowserApp=function(_Component){_inherits(BrowserApp,_Component);function BrowserApp(props){_classCallCheck(this,BrowserApp);var _this=_possibleConstructorReturn(this,(BrowserApp.__proto__||Object.getPrototypeOf(BrowserApp)).call(this,props));_this.state={maintenance:{active:false,message:''}};_this.setMaintenance=function(active,message){_this.setState({maintenance:{active:active,message:message}});};apiWrapper.registerMaintenanceCallback(_this.setMaintenance);return _this;}_createClass(BrowserApp,[{key:'render',value:function render(){var ErrorBoundaryWrapper= true?__WEBPACK_IMPORTED_MODULE_11__components_error_SentryErrorBoundary__["a" /* default */]:Fragment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorBoundaryWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_maintenance_MaintenanceHandler__["a" /* default */],this.state.maintenance,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* Provider */],Object.assign({},store,{routeService:routeService,analytics:analytics,apiWrapper:apiWrapper,locationContext:locationContext,formValidator:formValidator}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async__["HelmetProvider"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */],{store:store}))))));}}]);return BrowserApp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BrowserApp);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(271);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(205);
var invariant = __webpack_require__(204);
var ReactPropTypesSecret = __webpack_require__(616);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(58);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(67);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(269);

var _PathUtils = __webpack_require__(175);

var _createTransitionManager = __webpack_require__(270);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(385);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(271);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(58);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(67);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(269);

var _PathUtils = __webpack_require__(175);

var _createTransitionManager = __webpack_require__(270);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(385);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(387);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(58);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(175);

var _LocationUtils = __webpack_require__(269);

var _createTransitionManager = __webpack_require__(270);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(386);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(624)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(389);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(390);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(628);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(629);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(630);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(176);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(391);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(391);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(273);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(392);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(393);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(207);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(394);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(637);
var isArguments = __webpack_require__(638);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 637 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 638 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _shallowequal = __webpack_require__(640);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _client = __webpack_require__(641);

var _client2 = _interopRequireDefault(_client);

var _server = __webpack_require__(396);

var _server2 = _interopRequireDefault(_server);

var _utils = __webpack_require__(274);

var _Provider = __webpack_require__(395);

var _Provider2 = _interopRequireDefault(_Provider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dispatcher = function (_Component) {
  _inherits(Dispatcher, _Component);

  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    return _possibleConstructorReturn(this, (Dispatcher.__proto__ || Object.getPrototypeOf(Dispatcher)).apply(this, arguments));
  }

  _createClass(Dispatcher, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowequal2.default)(nextProps, this.props);
    }
  }, {
    key: 'emitChange',
    value: function emitChange() {
      var _context = this.context,
          helmetInstances = _context.helmetInstances,
          setHelmet = _context.setHelmet;

      var serverState = null;
      var state = (0, _utils.reducePropsToState)(helmetInstances.get().map(function (instance) {
        return instance.props;
      }));
      if (_Provider2.default.canUseDOM) {
        (0, _client2.default)(state);
      } else if (_server2.default) {
        serverState = (0, _server2.default)(state);
      }
      setHelmet(serverState, state);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var helmetInstances = this.context.helmetInstances;

      helmetInstances.add(this);
      this.emitChange();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var helmetInstances = this.context.helmetInstances;

      helmetInstances.remove(this);
      this.emitChange();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Dispatcher;
}(_react.Component);

Dispatcher.contextTypes = _Provider.providerShape;
exports.default = Dispatcher;

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAnimationFrame = undefined;

var _constants = __webpack_require__(209);

var _utils = __webpack_require__(274);

var rafPolyfill = function () {
  var clock = Date.now();

  return function (callback) {
    var currentTime = Date.now();

    if (currentTime - clock > 16) {
      clock = currentTime;
      callback(currentTime);
    } else {
      setTimeout(function () {
        rafPolyfill(callback);
      }, 0);
    }
  };
}();

var updateTags = function updateTags(type, tags) {
  var headElement = document.head || document.querySelector(_constants.TAG_NAMES.HEAD);
  var tagNodes = headElement.querySelectorAll(type + '[' + _constants.HELMET_ATTRIBUTE + ']');
  var oldTags = [].slice.call(tagNodes);
  var newTags = [];
  var indexToDelete = void 0;

  if (tags && tags.length) {
    tags.forEach(function (tag) {
      var newElement = document.createElement(type);

      // eslint-disable-next-line
      for (var attribute in tag) {
        if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
          if (attribute === _constants.TAG_PROPERTIES.INNER_HTML) {
            newElement.innerHTML = tag.innerHTML;
          } else if (attribute === _constants.TAG_PROPERTIES.CSS_TEXT) {
            if (newElement.styleSheet) {
              newElement.styleSheet.cssText = tag.cssText;
            } else {
              newElement.appendChild(document.createTextNode(tag.cssText));
            }
          } else {
            var value = typeof tag[attribute] === 'undefined' ? '' : tag[attribute];
            newElement.setAttribute(attribute, value);
          }
        }
      }

      newElement.setAttribute(_constants.HELMET_ATTRIBUTE, 'true');

      // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
      if (oldTags.some(function (existingTag, index) {
        indexToDelete = index;
        return newElement.isEqualNode(existingTag);
      })) {
        oldTags.splice(indexToDelete, 1);
      } else {
        newTags.push(newElement);
      }
    });
  }

  oldTags.forEach(function (tag) {
    return tag.parentNode.removeChild(tag);
  });
  newTags.forEach(function (tag) {
    return headElement.appendChild(tag);
  });

  return {
    oldTags: oldTags,
    newTags: newTags
  };
};

var updateAttributes = function updateAttributes(tagName, attributes) {
  var elementTag = document.getElementsByTagName(tagName)[0];

  if (!elementTag) {
    return;
  }

  var helmetAttributeString = elementTag.getAttribute(_constants.HELMET_ATTRIBUTE);
  var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(',') : [];
  var attributesToRemove = [].concat(helmetAttributes);
  var attributeKeys = Object.keys(attributes);

  for (var i = 0; i < attributeKeys.length; i += 1) {
    var attribute = attributeKeys[i];
    var value = attributes[attribute] || '';

    if (elementTag.getAttribute(attribute) !== value) {
      elementTag.setAttribute(attribute, value);
    }

    if (helmetAttributes.indexOf(attribute) === -1) {
      helmetAttributes.push(attribute);
    }

    var indexToSave = attributesToRemove.indexOf(attribute);
    if (indexToSave !== -1) {
      attributesToRemove.splice(indexToSave, 1);
    }
  }

  for (var _i = attributesToRemove.length - 1; _i >= 0; _i -= 1) {
    elementTag.removeAttribute(attributesToRemove[_i]);
  }

  if (helmetAttributes.length === attributesToRemove.length) {
    elementTag.removeAttribute(_constants.HELMET_ATTRIBUTE);
  } else if (elementTag.getAttribute(_constants.HELMET_ATTRIBUTE) !== attributeKeys.join(',')) {
    elementTag.setAttribute(_constants.HELMET_ATTRIBUTE, attributeKeys.join(','));
  }
};

var updateTitle = function updateTitle(title, attributes) {
  if (typeof title !== 'undefined' && document.title !== title) {
    document.title = (0, _utils.flattenArray)(title);
  }

  updateAttributes(_constants.TAG_NAMES.TITLE, attributes);
};

var commitTagChanges = function commitTagChanges(newState, cb) {
  var baseTag = newState.baseTag,
      bodyAttributes = newState.bodyAttributes,
      htmlAttributes = newState.htmlAttributes,
      linkTags = newState.linkTags,
      metaTags = newState.metaTags,
      noscriptTags = newState.noscriptTags,
      onChangeClientState = newState.onChangeClientState,
      scriptTags = newState.scriptTags,
      styleTags = newState.styleTags,
      title = newState.title,
      titleAttributes = newState.titleAttributes;

  updateAttributes(_constants.TAG_NAMES.BODY, bodyAttributes);
  updateAttributes(_constants.TAG_NAMES.HTML, htmlAttributes);

  updateTitle(title, titleAttributes);

  var tagUpdates = {
    baseTag: updateTags(_constants.TAG_NAMES.BASE, baseTag),
    linkTags: updateTags(_constants.TAG_NAMES.LINK, linkTags),
    metaTags: updateTags(_constants.TAG_NAMES.META, metaTags),
    noscriptTags: updateTags(_constants.TAG_NAMES.NOSCRIPT, noscriptTags),
    scriptTags: updateTags(_constants.TAG_NAMES.SCRIPT, scriptTags),
    styleTags: updateTags(_constants.TAG_NAMES.STYLE, styleTags)
  };

  var addedTags = {};
  var removedTags = {};

  Object.keys(tagUpdates).forEach(function (tagType) {
    var _tagUpdates$tagType = tagUpdates[tagType],
        newTags = _tagUpdates$tagType.newTags,
        oldTags = _tagUpdates$tagType.oldTags;


    if (newTags.length) {
      addedTags[tagType] = newTags;
    }
    if (oldTags.length) {
      removedTags[tagType] = tagUpdates[tagType].oldTags;
    }
  });

  if (cb) {
    cb();
  }

  onChangeClientState(newState, addedTags, removedTags);
};

var cafPolyfill = function cafPolyfill(id) {
  return clearTimeout(id);
};

var requestAnimationFrame = exports.requestAnimationFrame = typeof window !== 'undefined' ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== 'undefined' ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

// eslint-disable-next-line
var _helmetCallback = null;

var handleStateChangeOnClient = function handleStateChangeOnClient(newState) {
  if (_helmetCallback) {
    cancelAnimationFrame(_helmetCallback);
  }

  if (newState.defer) {
    _helmetCallback = requestAnimationFrame(function () {
      commitTagChanges(newState, function () {
        _helmetCallback = null;
      });
    });
  } else {
    commitTagChanges(newState);
    _helmetCallback = null;
  }
};

exports.default = handleStateChangeOnClient;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_css__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_header_CommonNavigation__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ProductPage__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_CategoryPage__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_footer_CommonFooter__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_account_AccountModal__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_cart_CartModal__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_InfoPage__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_HomePage__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_AdvancedSearchPage__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_setResizeListener__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__analytics_GoogleTagManager__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__analytics_CriteoAnalytics__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_ManufacturerPage__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_SectionPage__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_OnSalePage__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_NewProductsPage__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_PopularProductsPage__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_RecommendedProductsPage__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_ManufacturerListPage__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__i18n_IntlWrapper__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_route_RouteHistoryKeeper__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_cookie_notice_CookieNotice__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_coupon_TimerCoupons__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_coupon_ActivatedCoupons__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_common_MobileRegionalSettingsModal__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_loader_UninitializedAppSpinner__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_error_FatalError__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_head_RobotsMeta__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_common_ScrollTracker__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_MyAccountPage__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_SetNewPasswordPage__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_route_PasswordResetRedirect__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_ThankYouPage__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_NotFoundPage__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_common_GclidTracker__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__analytics_FacebookPixel__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_CustomerProductsPage__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_head_StyleOverrides__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__analytics_Giosg__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_WishListPage__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__util_constants__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__util_storage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__pages_MyAccountThankYouPage__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__pages_SoldProductsPage__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_surveys_SurveyModal__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__pages_VehiclePartSearchPage__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__pages_KlarnaInstantShoppingThankYouPage__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_head_GenericMeta__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_marketing_SpotmoreWidget__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_review_YotpoReviewWrapper__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_localization_RedirectModal__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__types_LocalStorageKey__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__util_browser__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__integrations_postaffiliate_PostAffiliateWidget__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_account_LoginPageContent__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_cart_CartErrorModal__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_route_LogoutParamRedirect__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_common_UniversalJavascriptTool__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_head_SEOSchema__ = __webpack_require__(334);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SectionRoutes=[createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].Product,__WEBPACK_IMPORTED_MODULE_9__pages_ProductPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MainProductGroup,__WEBPACK_IMPORTED_MODULE_10__pages_CategoryPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].ProductGroup,__WEBPACK_IMPORTED_MODULE_10__pages_CategoryPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].SubProductGroup,__WEBPACK_IMPORTED_MODULE_10__pages_CategoryPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].OnSale,__WEBPACK_IMPORTED_MODULE_27__pages_OnSalePage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].NewProducts,__WEBPACK_IMPORTED_MODULE_28__pages_NewProductsPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].SoldProducts,__WEBPACK_IMPORTED_MODULE_60__pages_SoldProductsPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].PopularProducts,__WEBPACK_IMPORTED_MODULE_29__pages_PopularProductsPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].RecommendedProducts,__WEBPACK_IMPORTED_MODULE_30__pages_RecommendedProductsPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].CustomerProducts,__WEBPACK_IMPORTED_MODULE_53__pages_CustomerProductsPage__["a" /* default */]),createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].WishList,__WEBPACK_IMPORTED_MODULE_56__pages_WishListPage__["a" /* default */])];function createSectionRoute(path,component){return{path:path,component:component};}var App=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,store=_this$props.store,location=_this$props.location,apiWrapper=_this$props.apiWrapper;var uiStore=store.uiStore;// Set up the language for the first time. We only have the URL to go with at this point.
// If the URL doesn't specify a language, we'll set it again after the bootstrap.
_this.setLanguageCodeFromUrl();var queryParams=__WEBPACK_IMPORTED_MODULE_39__util_queryString__["b" /* parse */](location.search);_this.setLocalStorageFromUrl(queryParams);if(store.state!==__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED){store.bootstrap(queryParams.sellerID,queryParams.campaign_code,queryParams.allowTestModeScripts,queryParams.processLogout).then(function(){// Set up the API wrapper language once the bootstrap has finished. If we had a
// language from the URL before, this should do nothing, but if we received the
// language from the bootstrap response and configured the language store in
// the bootstrapper, the API language is not yet set at this point.
apiWrapper.setLanguageCode(store.languageStore.locale);}).catch(function(e){// 503 is sent from backend for maintenance mode therefore error is not needed to print.
if(e.response&&e.response.status!==503){console.error(e.response);}// Catch errors in bootstrapping.
if(!e.response){console.error(e);}});}Object(__WEBPACK_IMPORTED_MODULE_22__util_setResizeListener__["a" /* default */])(uiStore.setViewActiveBreakpoint);_this.maybeSetProductListAccessTokenParamFromUrl();return _this;}/**
   * Some of our routes change, if sections are enabled.
   *
   * @param prefix Prefix for all routes (e.g. "/dogs/")
   * @param component Optional component that replaces all Route targets (e.g. for redirecting).
   * @param section Section to which this route belongs to.
   * @returns {Component[]}
   *//**
   * We first match if the route matches to any section and then render all
   * routes under that section.
   *
   * @param prefix Route prefix (e.g. "/en")
   * @param component Optional component that replaces all Route targets (e.g. for redirecting).
   * @returns {Component[]}
   *//**
   * Some of our routes need to be rendered for each language.
   *
   * @param prefix Language prefix (e.g. "/en")
   * @param component Optional component for overriding normal
   * @returns {Component[]}
   *//**
   * If we have more than one language, we need to redirect routes without a
   * language prefix to the active language routes.
   *
   * @returns {Component[]}
   *//**
   * Returns a switch with all the routes for the main content ("pages").
   * The routes have two optional prefixes: Language (code) and Section (slug).
   * Language prefixes are used, if there are more than 1 language.
   * Section prefixes are used, if sections are enabled.
   *
   * @returns {Switch}
   */_createClass(App,[{key:'render',value:function render(){var _props=this.props,store=_props.store,location=_props.location,baseUrl=_props.baseUrl;var accountStore=store.accountStore,categoryStore=store.categoryStore,cartStore=store.cartStore,configStore=store.configStore,countryStore=store.countryStore,currencyStore=store.currencyStore,languageStore=store.languageStore,sectionStore=store.sectionStore,translationStore=store.translationStore;if(store.lastError){var navigatorLanguage=Object(__WEBPACK_IMPORTED_MODULE_69__util_browser__["a" /* browserLanguage */])();var overrideLocale=navigatorLanguage&&navigatorLanguage.language;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__i18n_IntlWrapper__["a" /* default */],{languageStore:languageStore,translationStore:translationStore,overrideLocale:overrideLocale},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__components_error_FatalError__["a" /* default */],null));}var loaded=configStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED&&sectionStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED&&languageStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED&&languageStore.activeLanguage&&languageStore.hasBeenSetup&&currencyStore.activeCurrency&&(categoryStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED||categoryStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].ERROR);// URLs with parameters should not be indexed.
var shouldIndex=true;if(loaded){shouldIndex=this.allowIndexing();}if(loaded&&!shouldIndex&&categoryStore.activeCategory&&configStore.suitableProducts.enabledOnCategories.indexOf(categoryStore.activeCategory.id)!==-1){shouldIndex=true;}var loginRequired=false;if(loaded){this.setProductListFeaturesIfEnabled();loginRequired=configStore.store.loginRequired&&!accountStore.loggedIn;}var openGraphPrefix='og: https://ogp.me/ns#';var doLoadCart=!accountStore.isViewOnly;var ifCartError=cartStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED&&cartStore.cart.ifRenderErrorModal;var baseHref=!!window.isSSR?baseUrl:window.location.origin;var _ref=loaded&&configStore.integrations,postAffiliate=_ref.postAffiliate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{path:'/',component:__WEBPACK_IMPORTED_MODULE_35__components_route_RouteHistoryKeeper__["a" /* default */]}),loaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__i18n_IntlWrapper__["a" /* default */],{languageStore:languageStore,translationStore:translationStore},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,configStore.gclid.enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__components_common_GclidTracker__["a" /* default */],{location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_75__components_head_SEOSchema__["a" /* default */],{data:this.getSchemaData()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('html',{lang:languageStore.activeLocale,prefix:openGraphPrefix}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('body',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('category-'+(categoryStore.activeCategory&&categoryStore.activeCategory.id),'country-'+(countryStore.activeCountry&&countryStore.activeCountry.iso_code_2),'currency-'+currencyStore.currencyCode,'customer-group-'+(accountStore.account&&accountStore.account.customer_group_id),'language-'+languageStore.activeLocale,'path-'+location.pathname,'section-'+(sectionStore.activeSection&&sectionStore.activeSection.id)).toLowerCase()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('base',{href:baseHref})),!shouldIndex&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__components_head_RobotsMeta__["a" /* default */],{noindex:true}),configStore.denyRobots&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__components_head_RobotsMeta__["a" /* default */],{noindex:true,nofollow:true}),configStore.facebookVerification.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_64__components_head_GenericMeta__["a" /* default */],{name:'facebook-domain-verification',content:configStore.facebookVerification}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__analytics_GoogleTagManager__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__analytics_CriteoAnalytics__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__analytics_FacebookPixel__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_55__analytics_Giosg__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_66__components_review_YotpoReviewWrapper__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_65__components_marketing_SpotmoreWidget__["a" /* default */],null),!window.isSSR&&postAffiliate.isEnabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_70__integrations_postaffiliate_PostAffiliateWidget__["a" /* default */],null),!loginRequired&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_header_CommonNavigation__["a" /* default */],null),this.getRoutes(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_footer_CommonFooter__["a" /* default */],null)),loginRequired&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_71__components_account_LoginPageContent__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_cookie_notice_CookieNotice__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__components_coupon_TimerCoupons__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__components_coupon_ActivatedCoupons__["a" /* default */],null),!loginRequired&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_account_AccountModal__["a" /* default */],null),doLoadCart&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_cart_CartModal__["a" /* default */],null),ifCartError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_cart_CartErrorModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_common_MobileRegionalSettingsModal__["a" /* default */],null),!window.isSSR&&!Object(__WEBPACK_IMPORTED_MODULE_69__util_browser__["b" /* isTestingTool */])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_67__components_localization_RedirectModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_61__components_surveys_SurveyModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__components_common_ScrollTracker__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__components_route_PasswordResetRedirect__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_73__components_route_LogoutParamRedirect__["a" /* default */],null),!window.isSSR&&!Object(__WEBPACK_IMPORTED_MODULE_69__util_browser__["b" /* isTestingTool */])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_74__components_common_UniversalJavascriptTool__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_54__components_head_StyleOverrides__["a" /* default */],null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__components_loader_UninitializedAppSpinner__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.setLanguageCodeFromUrl=function(){var _props2=_this2.props,store=_props2.store,location=_props2.location,apiWrapper=_props2.apiWrapper;var languageStore=store.languageStore;var languageCode=Object(__WEBPACK_IMPORTED_MODULE_33__util_url__["g" /* parseLanguageCode */])(location.pathname);if(languageCode){languageStore.setupLocale(languageCode);apiWrapper.setLanguageCode(languageCode);}};this.setLocalStorageFromUrl=function(params){// Check user choice for chosen site.
if(params.siteChosen&&params.siteChosen==='1'){Object(__WEBPACK_IMPORTED_MODULE_58__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_68__types_LocalStorageKey__["a" /* default */].SITE_CHOSEN,true);}};this.setProductListFeaturesIfEnabled=function(){if(!_this2.props.store.configStore.wishlist.enabled){return;}_this2.setProductListGuestStorage();};this.setProductListGuestStorage=function(){var storage=Object(__WEBPACK_IMPORTED_MODULE_58__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_57__util_constants__["a" /* storageKeys */].wishlist);if(!storage){Object(__WEBPACK_IMPORTED_MODULE_58__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_57__util_constants__["a" /* storageKeys */].wishlist,[]);}};this.maybeSetProductListAccessTokenParamFromUrl=function(){var _props3=_this2.props,location=_props3.location,history=_props3.history;var search=location.search;if(search.includes(__WEBPACK_IMPORTED_MODULE_57__util_constants__["b" /* urlParams */].accessToken)){var params=search.replace('?'+__WEBPACK_IMPORTED_MODULE_57__util_constants__["b" /* urlParams */].accessToken+'=','');history.push(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].WishList+params);}};this.getSectionDependantRoutes=function(prefix,component,section){var routes=SectionRoutes.concat(_this2.getRoutesBehindConfig());return routes.map(function(sectionRoute){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:sectionRoute.path,section:section,exact:true,path:prefix+sectionRoute.path,component:component||sectionRoute.component});});};this.getRoutesBehindConfig=function(){var configStore=_this2.props.store.configStore;var routes=[];if(configStore.vehiclePartSearch.enabled){routes.push(createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].VehiclePartSearch,__WEBPACK_IMPORTED_MODULE_62__pages_VehiclePartSearchPage__["a" /* default */]));}if(configStore.siteConfig.isShoppingCenter){routes.push(createSectionRoute(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].KlarnaInstantShoppingThankYouPage,__WEBPACK_IMPORTED_MODULE_63__pages_KlarnaInstantShoppingThankYouPage__["a" /* default */]));}return routes;};this.getSectionRoutes=function(prefix,component){var sectionStore=_this2.props.store.sectionStore;return sectionStore.sections.map(function(section){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:section.id,path:prefix+'/'+section.slug+'/',section:section,render:function render(_ref2){var match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{exact:true,section:section,path:match.url,component:component||__WEBPACK_IMPORTED_MODULE_26__pages_SectionPage__["a" /* default */]}),_this2.getSectionDependantRoutes(match.url,component,section),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */],{to:'/'}));}});});};this.getLanguageDependantRoutes=function(prefix,component){var configStore=_this2.props.store.configStore;var sectionDependantRoutes=configStore.activateSections?_this2.getSectionRoutes(prefix,component):[];// We need to return an array, because <Switch /> does not support nesting or Fragments.
var languageDependantRoutes=[];if(configStore.account.enableMyAccount&&!configStore.siteConfig.isShoppingCenter){languageDependantRoutes.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MyAccount,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MyAccount,component:component||__WEBPACK_IMPORTED_MODULE_45__pages_MyAccountPage__["a" /* default */]}));}languageDependantRoutes.push([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].AdvancedSearch,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].AdvancedSearch,component:component||__WEBPACK_IMPORTED_MODULE_21__pages_AdvancedSearchPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].InfoPage,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].InfoPage,component:component||__WEBPACK_IMPORTED_MODULE_18__pages_InfoPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].Manufacturer,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].Manufacturer,component:component||__WEBPACK_IMPORTED_MODULE_25__pages_ManufacturerPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].OnSale,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].OnSale,component:component||__WEBPACK_IMPORTED_MODULE_27__pages_OnSalePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].NewProducts,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].NewProducts,component:component||__WEBPACK_IMPORTED_MODULE_28__pages_NewProductsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].PopularProducts,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].PopularProducts,component:component||__WEBPACK_IMPORTED_MODULE_29__pages_PopularProductsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].RecommendedProducts,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].RecommendedProducts,component:component||__WEBPACK_IMPORTED_MODULE_30__pages_RecommendedProductsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].ManufacturerList,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].ManufacturerList,component:component||__WEBPACK_IMPORTED_MODULE_31__pages_ManufacturerListPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].SetNewPassword,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].SetNewPassword,component:component||__WEBPACK_IMPORTED_MODULE_46__pages_SetNewPasswordPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].ThankYouPage,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].ThankYouPage,component:component||__WEBPACK_IMPORTED_MODULE_48__pages_ThankYouPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MyAccountThankYouPage,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MyAccountThankYouPage,component:component||__WEBPACK_IMPORTED_MODULE_59__pages_MyAccountThankYouPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].CustomerProducts,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].CustomerProducts,component:component||__WEBPACK_IMPORTED_MODULE_53__pages_CustomerProductsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].WishList,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].WishList,component:component||__WEBPACK_IMPORTED_MODULE_56__pages_WishListPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].WishListProductList,exact:true,path:prefix+__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].WishListProductList,component:component||__WEBPACK_IMPORTED_MODULE_56__pages_WishListPage__["a" /* default */]})].concat(_toConsumableArray(sectionDependantRoutes),_toConsumableArray(_this2.getSectionDependantRoutes(prefix,component))));return languageDependantRoutes;};this.getDefaultLanguageRedirects=function(){var languageStore=_this2.props.store.languageStore;var RedirectComponent=function RedirectComponent(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */],{to:'/'+languageStore.activeLocale+props.location.pathname+props.location.search+props.location.hash});};return _this2.getLanguageDependantRoutes('',RedirectComponent);};this.getRoutes=function(){var _props4=_this2.props,routeService=_props4.routeService,store=_props4.store;var languageStore=store.languageStore;var routes=languageStore.languages.length>1?[].concat(_toConsumableArray(languageStore.languages.map(function(language){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{key:language.code,path:'/'+language.code+'/',render:function render(_ref3){var match=_ref3.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{exact:true,path:match.url,component:__WEBPACK_IMPORTED_MODULE_20__pages_HomePage__["a" /* default */]}),_this2.getLanguageDependantRoutes(match.url),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_49__pages_NotFoundPage__["a" /* default */]}));}});})),[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{exact:true,path:'/',key:'/',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].FrontPage)});}})],_toConsumableArray(_this2.getDefaultLanguageRedirects())):[].concat(_toConsumableArray(_this2.getLanguageDependantRoutes('')),[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{exact:true,path:'/',key:'/',component:__WEBPACK_IMPORTED_MODULE_20__pages_HomePage__["a" /* default */]})]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{exact:true,strict:true,path:'/:url*',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */],{to:props.location.pathname+'/'+props.location.search+props.location.hash});}}),routes,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].NotFoundPage,component:__WEBPACK_IMPORTED_MODULE_49__pages_NotFoundPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_route_SectionAwareRoute__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_49__pages_NotFoundPage__["a" /* default */]}));};this.allowIndexing=function(){var _props5=_this2.props,location=_props5.location,store=_props5.store;var queryParams=__WEBPACK_IMPORTED_MODULE_39__util_queryString__["b" /* parse */](location.search);var filterParams=store.configStore.seo.indexedParameters;filterParams.forEach(function(parameter){delete queryParams[parameter];});return Object.keys(queryParams).length===0;};this.getSchemaData=function(){return{'@context':'https://schema.org/','@type':'WebPage',name:_this2.props.store.configStore.store.name};};},_temp))||_class;App.propTypes={store:Object(__WEBPACK_IMPORTED_MODULE_12__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_19__services_ApiWrapper__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.location.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_51__services_RouteService__["a" /* default */]).isRequired,baseUrl:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};// withRouter is needed for the observer to update the component on route changes.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('apiWrapper','routeService')(Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* withRouter */])(App)));

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(644)();
}


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(205);
var invariant = __webpack_require__(204);
var ReactPropTypesSecret = __webpack_require__(645);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommonNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_sticky_el__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_sticky_el___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_sticky_el__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_resize_detector__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavigationLogo__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__account_AccountLinks__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__navigation_NavigationMenuRow__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_MobileNavigationTab__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__NavigationNewsletterDropdown__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__NavigationRegionalSettingsMenu__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__NavigationTopLevelMegaMenu__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__NavigationLinkCarousel__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__NavigationCart__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__navigation_NavigationSingleLevelMenuRow__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__store_MenuStore__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MobileNavigation__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__common_ClickOutside__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__common_NavigationAssistButton__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__types_SectionIntegrationType__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__NavigationWishListButton__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__TopNavigationSearchButton__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__CommonNavigationMiddle__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__search_QuickSearch__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__types_CustomNavigationLinkParentType__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__store_CustomNavigationLinkStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__vehicle_LicensePlateInput__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CommonNavigation=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CommonNavigation,_Component);function CommonNavigation(props){_classCallCheck(this,CommonNavigation);var _this=_possibleConstructorReturn(this,(CommonNavigation.__proto__||Object.getPrototypeOf(CommonNavigation)).call(this,props));_this.attachResizeEventListener=function(){window.addEventListener('resize',_this.deviceOrientationHandler,false);};_this.deviceOrientationHandler=function(){var uiStore=_this.props.uiStore;var inputHasFocus=_this.state.inputHasFocus;inputHasFocus&&uiStore.toggleSearch(uiStore.isLandscape);_this.updateHeaderHeight();};_this.onResize=function(){var uiStore=_this.props.uiStore;var showSearchOnMobile=_this.state.showSearchOnMobile;if(!showSearchOnMobile||uiStore.isDesktop){_this.maybeResetSearchVisibilityState();_this.updateHeaderHeight();}};_this.maybeResetSearchVisibilityState=function(){if(_this.props.uiStore.isDesktop){_this.setState({showSearchOnMobile:false});}else{_this.setState({showSearchOnDesktop:false});}};_this.updateHeaderHeight=function(){var _this$props=_this.props,uiStore=_this$props.uiStore,configStore=_this$props.configStore;var _this$state=_this.state,isSticky=_this$state.isSticky,showSearchOnMobile=_this$state.showSearchOnMobile,showSearchOnDesktop=_this$state.showSearchOnDesktop;if(_this.stickyElement){var currentHeaderHeight=_this.stickyElement.wrapperEl.clientHeight;uiStore.setHeaderHeight(currentHeaderHeight);var showSearch=!showSearchOnMobile&&!showSearchOnDesktop;if(!isSticky&&!_this.shouldShowMobileMenu()&&showSearch){_this.setState({nonStickyHeaderHeight:currentHeaderHeight});}if(configStore.topNavigation.moveSearchbarTopNavigation&&!showSearch){_this.setState({nonStickyHeaderHeight:currentHeaderHeight});}}};_this.handleVehicleSearch=function(licensePlate){var _this$props2=_this.props,routeService=_this$props2.routeService,history=_this$props2.history;var licensePlateUrl=licensePlate?Object(__WEBPACK_IMPORTED_MODULE_46__util_queryString__["a" /* addParametersToPath */])(__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].VehiclePartSearch,{id:licensePlate}):__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].VehiclePartSearch;var url=routeService.getPath(licensePlateUrl);history.push(url);};_this.onKeyPress=function(){_this.blurElement();};_this.onInputFocus=function(){_this.setState({inputHasFocus:true});};_this.onInputBlur=function(){_this.blurElement();};_this.shouldShowFullHeader=function(){var uiStore=_this.props.uiStore;return uiStore.isDesktop&&!_this.searchIsFocused()&&!uiStore.scrollingDown&&uiStore.documentScrollTop<uiStore.headerHeight+500&&uiStore.documentScrollTop!==0&&!_this.shouldShowMobileMenu()&&!_this.shouldShowMobileModal();};_this.shouldHideSticky=function(){var uiStore=_this.props.uiStore;return!uiStore.isDesktop&&!_this.searchIsFocused()&&uiStore.scrollingDown&&uiStore.documentScrollTop>uiStore.headerHeight&&!_this.shouldShowMobileMenu()&&!_this.shouldShowMobileModal();};_this.shouldHideStickyShoppingCenter=function(){var uiStore=_this.props.uiStore;return uiStore.isDesktop&&!_this.searchIsFocused()&&uiStore.scrollingDown&&uiStore.documentScrollTop>uiStore.headerHeight+300&&!_this.shouldShowMobileMenu()&&!_this.shouldShowMobileModal();};_this.shouldHideMixedContent=function(){var _this$props3=_this.props,configStore=_this$props3.configStore,sectionStore=_this$props3.sectionStore;return configStore.account.isMoneyTransfer||configStore.zoovu.enabled&&sectionStore.activeSection&&sectionStore.activeSection.integration_type===__WEBPACK_IMPORTED_MODULE_35__types_SectionIntegrationType__["b" /* default */].ZOOVU;};_this.searchIsFocused=function(){return _this.state.inputHasFocus;};_this.shouldShowMobileMenu=function(){var uiStore=_this.props.uiStore;return!uiStore.isDesktop&&uiStore.mobileNavigation.isOpen;};_this.shouldShowMobileModal=function(){var uiStore=_this.props.uiStore;return uiStore.popoverActive;};_this.onFixedToggle=function(wasSticky){_this.setState({isSticky:!wasSticky},function(){// Use setTimeout to wait for renders so that the header has been updated.
_this.headerTimeout=setTimeout(function(){_this.updateHeaderHeight();});});};_this.getAdditionalLinks=function(){var _this$props4=_this.props,routeService=_this$props4.routeService,accountStore=_this$props4.accountStore,configStore=_this$props4.configStore;var additionalLinks=[];if(accountStore.isRetailer){additionalLinks.push({id:'_customerProducts',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__["a" /* default */].customerProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].CustomerProducts)});}if(configStore.sidebar.showOnSale){additionalLinks.push({id:'_onSale',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__["a" /* default */].onSaleTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].OnSale)});}if(configStore.sidebar.showNewProducts){additionalLinks.push({id:'_newProducts',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__["a" /* default */].newProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].NewProducts)});}if(configStore.sidebar.showSoldProducts){additionalLinks.push({id:'_soldProducts',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__["a" /* default */].soldProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].SoldProducts)});}if(configStore.sidebar.showMostSold){additionalLinks.push({id:'_mostSold',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__["a" /* default */].mostPopularTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].PopularProducts)});}if(configStore.sidebar.showRecommended){additionalLinks.push({id:'_recommended',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__["a" /* default */].weRecommendTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].RecommendedProducts)});}return additionalLinks;};_this.getBottomBarLinks=function(){var _this$props5=_this.props,sectionStore=_this$props5.sectionStore,categoryStore=_this$props5.categoryStore,uiStore=_this$props5.uiStore,configStore=_this$props5.configStore;var items=void 0;var closeMegaMenu=function closeMegaMenu(){return uiStore.megaMenu.close();};if(configStore.activateSections){items=sectionStore.activeSections.map(function(section){var toggleSection=section.mainCategoryIds&&section.mainCategoryIds.length>0?function(){return uiStore.megaMenu.toggle(section);}:function(){return uiStore.megaMenu.close();};var debouncedToggleSection=function debouncedToggleSection(){return _this.debouncedHover(toggleSection);};var onMouseOut=function onMouseOut(){return _this.debouncedHover(closeMegaMenu);};var path=_this.getCategoryOrSectionPath(section);return{id:section.id,label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:closeMegaMenu,onMouseOver:debouncedToggleSection,onMouseOut:onMouseOut},section.navigationName),path:path,className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()({open:uiStore.megaMenu.activeSection&&uiStore.megaMenu.activeSection.id===section.id}),active:sectionStore.activeSection===section,children:[],type:section.link_type,customNavLinks:_this.getCustomNavigationLinks(section,__WEBPACK_IMPORTED_MODULE_42__types_CustomNavigationLinkParentType__["a" /* default */].SECTION)};});}else{items=categoryStore.categories.map(function(category){var toggleCategory=category.children&&category.children.length>0?function(){return uiStore.megaMenu.toggle(category);}:null;var onMouseOver=function onMouseOver(){return _this.debouncedHover(toggleCategory);};var onMouseOut=function onMouseOut(){return _this.debouncedHover(closeMegaMenu);};var activeMainCategory=categoryStore.activeCategory&&categoryStore.activeCategory.mainCategory;var path=_this.getCategoryOrSectionPath(category);return{id:category.id,label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:closeMegaMenu,onMouseOver:onMouseOver,onMouseOut:onMouseOut},category.navigationName),path:path,className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()({open:uiStore.megaMenu.rootCategory&&uiStore.megaMenu.rootCategory.id===category.id}),active:activeMainCategory===category,children:[],type:category.link_type,customNavLinks:_this.getCustomNavigationLinks(category,__WEBPACK_IMPORTED_MODULE_42__types_CustomNavigationLinkParentType__["a" /* default */].CATEGORY)};});}var additionalLinks=_this.getAdditionalLinks();if(configStore.megaMenu.groupAdditionalLinks){additionalLinks=_this.groupAdditionalLinks(additionalLinks);}return items.concat(additionalLinks);};_this.getCategoryOrSectionPath=function(categoryOrSection){var routeService=_this.props.routeService;if(categoryOrSection.link_type===__WEBPACK_IMPORTED_MODULE_41__types_LinkType__["b" /* default */].EXTERNAL_LINK){return categoryOrSection.path;}else if(categoryOrSection.link_type===__WEBPACK_IMPORTED_MODULE_41__types_LinkType__["b" /* default */].INTERNAL_LINK){return routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_45__util_url__["l" /* transformInternalLink */])(categoryOrSection.path));}else{return routeService.getPath(categoryOrSection.path);}};_this.getCustomNavigationLinks=function(categoryOrSection,type){var customNavigationLinkStore=_this.props.customNavigationLinkStore;return type===__WEBPACK_IMPORTED_MODULE_42__types_CustomNavigationLinkParentType__["a" /* default */].CATEGORY?customNavigationLinkStore.filterByCategoryId(categoryOrSection.id):customNavigationLinkStore.filterBySectionId(categoryOrSection.id);};_this.groupAdditionalLinks=function(links){// No need to group, if only one item.
if(links.length<=1){return links;}return[{id:'_customerProducts',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__["a" /* default */].additionalLinksTitle),children:links,dropdown:true}];};_this.convertMenuToNavigationEntity=function(menu){var label=void 0;if(typeof menu.title==='string'){label=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CommonNavigation__html-content',dangerouslySetInnerHTML:{__html:menu.title}});}else if(menu.title!=null){label=menu.title;}else{label='';}return{id:menu.id,path:menu.url,type:menu.type,image:menu.image,label:label,children:menu.children.map(_this.convertMenuToNavigationEntity)};};_this.getMenuBarLinks=function(){var _this$props6=_this.props,menuStore=_this$props6.menuStore,routeService=_this$props6.routeService;var items=menuStore.menus.map(_this.convertMenuToNavigationEntity);items.unshift({id:'_top',path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].FrontPage),type:__WEBPACK_IMPORTED_MODULE_41__types_LinkType__["b" /* default */].INTERNAL_LINK,image:null,label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_Icon__["a" /* default */],{name:'home'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_27__i18n_globalTranslations__["a" /* default */].homeTitle))});return items;};_this.toggleSearch=function(){_this.updateState('showSearchOnMobile');_this.updateState('showSearchOnDesktop');};_this.updateState=function(stateVariable){_this.setState(function(prevState){return _defineProperty({},stateVariable,!prevState[stateVariable]);},function(){return _this.focusElement();});};_this.focusElement=function(){var _this$state2=_this.state,showSearchOnMobile=_this$state2.showSearchOnMobile,showSearchOnDesktop=_this$state2.showSearchOnDesktop;if(showSearchOnMobile,showSearchOnDesktop){var element=_this.getAutosuggestInput();if(element){element.focus();}}};_this.blurElement=function(){var element=_this.getAutosuggestInput();if(element){element.blur();}_this.setState({inputHasFocus:false});};_this.getDefaultMobileMenuTab=function(){var location=_this.props.location;if(Object(__WEBPACK_IMPORTED_MODULE_8_react_router__["d" /* matchPath */])(location.pathname,{path:'/:locale?'+__WEBPACK_IMPORTED_MODULE_29__types_Paths__["a" /* default */].InfoPage})){return __WEBPACK_IMPORTED_MODULE_17__types_MobileNavigationTab__["b" /* default */].INFO;}return __WEBPACK_IMPORTED_MODULE_17__types_MobileNavigationTab__["b" /* default */].PRODUCTS;};_this.debouncedHover=__WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function(callback){if(callback){callback();}},200);_this.getTopOffset=function(){var _this$props7=_this.props,configStore=_this$props7.configStore,uiStore=_this$props7.uiStore;var useStickyHeaderOnStartup=uiStore.isDesktop&&configStore.topNavigation.useStickyHeaderOnStartup;if(useStickyHeaderOnStartup){return 0;}return uiStore.isDesktop&&!uiStore.searchIsActive?100:0;};_this.renderNavigationTop=function(){var _this$props8=_this.props,configStore=_this$props8.configStore,uiStore=_this$props8.uiStore;var hideCheckout=!configStore.topNavigation.hideCheckout&&uiStore.isDesktop;var moveShoppingCartLoginRight=!configStore.topNavigation.moveShoppingCartLoginRight;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["J" /* Navbar */],{className:'CommonNavigation__top d-none d-lg-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'CommonNavigation__top-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CommonNavigation__top-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__navigation_NavigationMenuRow__["a" /* default */],{items:_this.getMenuBarLinks()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()(!moveShoppingCartLoginRight&&'CommonNavigation__top-right-navigation-shopping-buttons-wrapper')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["G" /* Nav */],{className:'CommonNavigation__top-right-navigation'},configStore.topNavigation.moveSearchbarTopNavigation&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__TopNavigationSearchButton__["a" /* default */],{onShowSearchOnTopNavigation:_this.toggleSearch}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__NavigationNewsletterDropdown__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__NavigationRegionalSettingsMenu__["a" /* default */],null),configStore.wishlist.enabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__NavigationWishListButton__["a" /* default */],null),configStore.siteConfig.isWebStore&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__account_AccountLinks__["a" /* default */],null)),!moveShoppingCartLoginRight&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__NavigationCart__["a" /* default */],{className:'NavigationCart__right-side-shopping-button',withCheckoutButton:hideCheckout}))),configStore.topNavigation.moveSearchbarTopNavigation&&_this.state.showSearchOnDesktop&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'justify-content-center pb-2'},configStore.vehiclePartSearch.enabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__vehicle_LicensePlateInput__["a" /* default */],{handleOnSubmit:_this.handleVehicleSearch,clearAfterSubmit:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{sm:'5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__search_QuickSearch__["a" /* default */],{handleFocus:_this.onInputFocus,handleBlur:_this.onInputBlur,toggleSearch:function toggleSearch(){return null;}})))));};_this.renderNavigationTopBalance=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["J" /* Navbar */],{className:'CommonNavigation__top d-none d-lg-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'CommonNavigation__top-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CommonNavigation__top-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__navigation_NavigationMenuRow__["a" /* default */],{items:_this.getMenuBarLinks()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__account_AccountLinks__["a" /* default */],null))));};_this.renderNavigationMiddle=function(){var _this$props9=_this.props,configStore=_this$props9.configStore,uiStore=_this$props9.uiStore;var _this$state3=_this.state,isSticky=_this$state3.isSticky,showSearchOnMobile=_this$state3.showSearchOnMobile,inputHasFocus=_this$state3.inputHasFocus;var hideCheckout=!configStore.topNavigation.hideCheckout&&uiStore.isDesktop;var moveShoppingCartLoginRight=!configStore.topNavigation.moveShoppingCartLoginRight;var useStickyHeaderOnStartup=uiStore.isDesktop&&configStore.topNavigation.useStickyHeaderOnStartup;var ifShouldShowFullHeader=_this.shouldShowFullHeader();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["J" /* Navbar */],{className:'CommonNavigation__middle',expand:'lg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'CommonNavigation__middle-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__CommonNavigationMiddle__["a" /* default */],{hideCheckout:hideCheckout,moveShoppingCartLoginRight:moveShoppingCartLoginRight,isSticky:isSticky,onShowSearchOnMobile:_this.toggleSearch,onSearchKeyPress:_this.onKeyPress,inputFocus:_this.onInputFocus,inputBlur:_this.onInputBlur,inputHasFocus:inputHasFocus,shouldShowSearchOnMobile:showSearchOnMobile,useStickyHeaderOnStartup:useStickyHeaderOnStartup,ifShouldShowFullHeader:ifShouldShowFullHeader})));};_this.renderNavigationBottom=function(){var configStore=_this.props.configStore;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__navigation_NavigationSingleLevelMenuRow__["a" /* default */],{items:_this.getBottomBarLinks(),className:'CommonNavigation__bottom'}),configStore.mainNavigation.useMegamenu&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__NavigationTopLevelMegaMenu__["a" /* default */],{debouncer:_this.debouncedHover}));};_this.getAutosuggestInput=function(){return document.querySelector('.CommonNavigation .QuickSearch input');};_this.state={isSticky:false,nonStickyHeaderHeight:null,showSearchOnMobile:false,showSearchOnDesktop:false,inputHasFocus:false};_this.stickyElement=null;_this.headerTimeout=null;return _this;}_createClass(CommonNavigation,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var uiStore=this.props.uiStore;var _props=this.props,showSearchOnDesktop=_props.showSearchOnDesktop,showSearchOnMobile=_props.showSearchOnMobile;if(!uiStore.isDesktop){// Update header height on page load only if we're on mobile.
this.updateHeaderHeight();}// Hide search field when the navbar is hidden on mobile
Object(__WEBPACK_IMPORTED_MODULE_9_mobx__["autorun"])(function(){if(_this2.shouldHideSticky()&&showSearchOnMobile&&showSearchOnDesktop){_this2.setState({showSearchOnMobile:false,showSearchOnDesktop:false},function(){_this2.updateHeaderHeight();_this2.blurElement();});}},{delay:500});// Attach resize event listener to window since ReactResizeDetector component reports resize event too early from landscape to portrait.
!uiStore.isDesktop&&!window.isSSR&&this.attachResizeEventListener();}},{key:'componentDidUpdate',value:function componentDidUpdate(_,prevState){var uiStore=this.props.uiStore;var inputHasFocus=this.state.inputHasFocus;if(!uiStore.isDesktop&&prevState.inputHasFocus!==inputHasFocus){inputHasFocus&&uiStore.toggleSearch(uiStore.isLandscape);!inputHasFocus&&uiStore.toggleSearch(false);this.updateHeaderHeight();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var uiStore=this.props.uiStore;if(this.headerTimeout){clearTimeout(this.headerTimeout);}!uiStore.isDesktop&&!window.isSSR&&window.removeEventListener('resize',this.deviceOrientationHandler);}// This debounced function allows us to have a single timeout for all hover
// (onMouseOut and onMouseOver) callbacks so that only the last one is called.
//
// This allows us to
// 1) prevent showing MegaMenu when the user hovers over the menubar quickly
// 2) prevent hiding MegaMenu when the user moves the mouse from the menubar
//    to the actual MegaMenu. This is achieved by having a separate onMouseOver
//    in the MegaMenu that overrides the last onMouseOut callback.
//
},{key:'render',value:function render(){var _this3=this;var _props2=this.props,configStore=_props2.configStore,uiStore=_props2.uiStore;var nonStickyHeaderHeight=this.state.nonStickyHeaderHeight;var hideAssistantMenu=configStore.mobileSettings.showAssistantMenu==='0';var useStickyHeaderOnStartup=uiStore.isDesktop&&configStore.topNavigation.useStickyHeaderOnStartup;var hideHeaderOnScrollingDown=uiStore.isDesktop&&configStore.topNavigation.hideHeaderOnScrollingDown;var ifShouldShowFullHeader=this.shouldShowFullHeader();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,uiStore.isDesktop&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__NavigationLinkCarousel__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_sticky_el___default.a,{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('CommonNavigation',{'CommonNavigation--show-full-header':!useStickyHeaderOnStartup&&ifShouldShowFullHeader,'CommonNavigation--hide-sticky':this.shouldHideSticky(),'CommonNavigation--hide-sticky-shoppingCenter':hideHeaderOnScrollingDown&&this.shouldHideStickyShoppingCenter(),'CommonNavigation--scroll-logo':useStickyHeaderOnStartup,'CommonNavigation--mobile-navigation-open':this.shouldShowMobileMenu(),'CommonNavigation--forced-static':!!window.isSSR}),name:'top',topOffset:this.getTopOffset(),onFixedToggle:this.onFixedToggle,ref:function ref(_ref2){return _this3.stickyElement=_ref2;},holderProps:{className:'CommonNavigation__sticky-placeholder',style:{height:nonStickyHeaderHeight&&nonStickyHeaderHeight+'px'}}},!configStore.siteConfig.isHomePage&&this.renderNavigationTop(),configStore.siteConfig.isHomePage&&configStore.account.isMoneyTransfer&&this.renderNavigationTopBalance(),this.renderNavigationMiddle(),configStore.siteConfig.isShoppingCenter&&uiStore.isDesktop&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CommonNavigation__shopping-center--separator'}),this.shouldShowMobileMenu()&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__common_ClickOutside__["a" /* default */],{onClickOutside:uiStore.mobileNavigation.toggle,excludedSelector:'.MobileNavigationButton, .modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__MobileNavigation__["a" /* default */],{shouldHideProductContent:this.shouldHideMixedContent()})),uiStore.isDesktop&&!this.shouldHideMixedContent()&&!configStore.mainNavigation.useSidebar&&this.renderNavigationBottom()),!uiStore.isDesktop&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,!this.shouldHideMixedContent()&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'CommonNavigation__mobile-wide-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CommonNavigation__mobile-link-carousel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__NavigationLinkCarousel__["a" /* default */],null))),configStore.mobileSettings.showStoreLogo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'CommonNavigation__mobile-logo-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CommonNavigation__mobile-logo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__NavigationLogo__["a" /* default */],null))),!this.shouldHideMixedContent()&&hideAssistantMenu&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'CommonNavigation__mobile-assist-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CommonNavigation__mobile-assist'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__common_NavigationAssistButton__["a" /* default */],{tab:this.getDefaultMobileMenuTab()})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_resize_detector__["a" /* default */],{handleHeight:true,onResize:this.onResize,refreshMode:'throttle',refreshRate:100,refreshOptions:{leading:true,trailing:true},querySelector:'.CommonNavigation, .NavigationLinkCarousel'}));}}]);return CommonNavigation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;CommonNavigation.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_36__store_AccountStore__["a" /* default */]).isRequired,categoryStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_26__store_CategoryStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_25__store_ConfigStore__["a" /* default */]).isRequired,menuStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_30__store_MenuStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__store_SectionStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_UIStore__["a" /* default */]).isRequired,customNavigationLinkStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_43__store_CustomNavigationLinkStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_31__services_RouteService__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_10_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','categoryStore','configStore','menuStore','sectionStore','uiStore','customNavigationLinkStore','routeService')(Object(__WEBPACK_IMPORTED_MODULE_8_react_router__["e" /* withRouter */])(CommonNavigation)));

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(88);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(139);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 650 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 652 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Arrow__["a"]; });





/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(656);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(659);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          positionFixed = _props.positionFixed;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          positionFixed = _props2.positionFixed,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionFixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  positionFixed: false,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 661 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 662 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(664), src$en$$ = __webpack_require__(669);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(401), src$es5$$ = __webpack_require__(665), src$compiler$$ = __webpack_require__(666), intl$messageformat$parser$$ = __webpack_require__(667);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(401);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(668)['default'];
exports['default'] = exports;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 670 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(672)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(677);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(673), src$en$$ = __webpack_require__(676);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(400), src$diff$$ = __webpack_require__(674), src$es5$$ = __webpack_require__(675);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 677 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(679)['default'];
exports['default'] = exports;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(680);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(66);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(682);

var _find = __webpack_require__(683);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var stickyOwnProps = ['mode', 'disbled', 'onFixedToggle', 'stickyStyle', 'stickyClassName', 'boundaryElement', 'scrollElement', 'bottomOffset', 'topOffset', 'positionRecheckInterval', 'noExceptionOnMissedScrollElement', 'wrapperCmp', 'holderCmp', 'hideOnBoundaryHit', 'holderProps'];

var isEqual = function isEqual(obj1, obj2) {
  for (var field in obj1) {
    if (obj1.hasOwnProperty(field) && obj1[field] !== obj2[field]) {
      return false;
    }
  }

  return true;
};

var Sticky = function (_Component) {
  _inherits(Sticky, _Component);

  function Sticky(props) {
    _classCallCheck(this, Sticky);

    var _this = _possibleConstructorReturn(this, (Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call(this, props));

    _this.createWrapperRef = function (wrapper) {
      _this.wrapperEl = wrapper;
    };

    _this.createHolderRef = function (holder) {
      _this.holderEl = holder;
    };

    _this.checkPosition = function () {
      var holderEl = _this.holderEl,
          wrapperEl = _this.wrapperEl,
          boundaryElement = _this.boundaryElement,
          scrollElement = _this.scrollElement,
          disabled = _this.disabled;
      var _this$props = _this.props,
          mode = _this$props.mode,
          onFixedToggle = _this$props.onFixedToggle;


      if (disabled) {
        if (_this.state.fixed) {
          _this.setState(function () {
            return { fixed: false };
          });
        }
        return;
      }

      var holderRect = holderEl.getBoundingClientRect();
      var wrapperRect = wrapperEl.getBoundingClientRect();
      var boundaryRect = boundaryElement ? getRect(boundaryElement) : { top: -Infinity, bottom: Infinity };
      var scrollRect = getRect(scrollElement);
      var fixed = _this.isFixed(holderRect, wrapperRect, boundaryRect, scrollRect);

      var newState = {
        fixed: fixed,
        boundaryTop: mode === 'bottom' ? boundaryRect.top : 0,
        boundaryBottom: mode === 'top' ? boundaryRect.bottom : 0,
        top: mode === 'top' ? scrollRect.top : 0,
        bottom: mode === 'bottom' ? scrollRect.bottom : 0,
        width: holderRect.width,
        height: wrapperRect.height
      };

      if (fixed !== _this.state.fixed && onFixedToggle && typeof onFixedToggle === 'function') {
        onFixedToggle(_this.state.fixed);
      }

      if (!isEqual(_this.state, newState)) {
        _this.setState(function () {
          return newState;
        });
      }
    };

    _this.disabled = props.disabled;
    _this.state = {
      height: 0,
      fixed: false
    };
    return _this;
  }

  _createClass(Sticky, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var me = _reactDom2.default.findDOMNode(this);
      var _props = this.props,
          boundaryElement = _props.boundaryElement,
          scrollElement = _props.scrollElement,
          noExceptionOnMissedScrollElement = _props.noExceptionOnMissedScrollElement,
          positionRecheckInterval = _props.positionRecheckInterval,
          disabled = _props.disabled;


      this.disabled = disabled;
      this.boundaryElement = (0, _find2.default)(boundaryElement, me);
      if (this.boundaryElement === window || this.boundaryElement === document) {
        // such objects can't be used as boundary
        // and in fact there is no point in such a case
        this.boundaryElement = null;
      }

      this.scrollElement = (0, _find2.default)(scrollElement, me);

      if (this.scrollElement) {
        (0, _events.listen)(this.scrollElement, ['scroll'], this.checkPosition);
      } else if (!noExceptionOnMissedScrollElement) {
        throw new Error('Cannot find scrollElement ' + scrollElement);
      }

      (0, _events.listen)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
      this.checkPosition();

      if (positionRecheckInterval) {
        this.checkPositionIntervalId = setInterval(this.checkPosition, positionRecheckInterval);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var disabled = _ref.disabled;

      if (this.disabled !== disabled) {
        this.disabled = disabled;
        this.checkPosition();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.scrollElement) {
        (0, _events.unlisten)(this.scrollElement, ['scroll'], this.checkPosition);
      }
      (0, _events.unlisten)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
      this.boundaryElement = null;
      this.scrollElement = null;
      clearTimeout(this.checkPositionIntervalId);
    }
  }, {
    key: 'isFixed',
    value: function isFixed(holderRect, wrapperRect, boundaryRect, scrollRect) {
      var _props2 = this.props,
          hideOnBoundaryHit = _props2.hideOnBoundaryHit,
          bottomOffset = _props2.bottomOffset,
          topOffset = _props2.topOffset,
          mode = _props2.mode;


      if (this.disabled) {
        return false;
      }

      if (boundaryRect && !instersect(boundaryRect, scrollRect, topOffset, bottomOffset)) {
        return false;
      }

      var hideOffset = hideOnBoundaryHit ? wrapperRect.height + bottomOffset : 0;

      if (mode === 'top') {
        return holderRect.top + topOffset < scrollRect.top && scrollRect.top + hideOffset <= boundaryRect.bottom;
      }

      return holderRect.bottom - topOffset > scrollRect.bottom && scrollRect.bottom - hideOffset >= boundaryRect.top;
    }
  }, {
    key: 'buildTopStyles',
    value: function buildTopStyles() {
      var _props3 = this.props,
          bottomOffset = _props3.bottomOffset,
          hideOnBoundaryHit = _props3.hideOnBoundaryHit;
      var _state = this.state,
          top = _state.top,
          height = _state.height,
          boundaryBottom = _state.boundaryBottom;


      if (hideOnBoundaryHit || top + height + bottomOffset < boundaryBottom) {
        return { top: top, position: 'fixed' };
      }

      return { bottom: bottomOffset, position: 'absolute' };
    }
  }, {
    key: 'buildBottomStyles',
    value: function buildBottomStyles() {
      var _props4 = this.props,
          bottomOffset = _props4.bottomOffset,
          hideOnBoundaryHit = _props4.hideOnBoundaryHit;
      var _state2 = this.state,
          bottom = _state2.bottom,
          height = _state2.height,
          boundaryTop = _state2.boundaryTop;


      if (hideOnBoundaryHit || bottom - height - bottomOffset > boundaryTop) {
        return { top: bottom - height, position: 'fixed' };
      }

      return { top: bottomOffset, position: 'absolute' };
    }
  }, {
    key: 'buildStickyStyle',
    value: function buildStickyStyle() {
      var style = void 0;
      if (this.props.mode === 'top') {
        style = this.buildTopStyles();
      } else {
        style = this.buildBottomStyles();
      }
      style.width = this.state.width;

      return style;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var _state3 = this.state,
          fixed = _state3.fixed,
          height = _state3.height;
      var stickyClassName = props.stickyClassName,
          stickyStyle = props.stickyStyle,
          holderCmp = props.holderCmp,
          wrapperCmp = props.wrapperCmp,
          holderProps = props.holderProps,
          children = props.children;

      var wrapperProps = sanitizeProps(props, stickyOwnProps);
      // To ensure that this component becomes sticky immediately on mobile devices instead
      // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
      // to 'kick' rendering of this element to the GPU
      // @see http://stackoverflow.com/questions/32875046
      var wrapperStyle = { transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)' };
      if (wrapperProps.style) {
        wrapperStyle = _extends({}, wrapperStyle, wrapperProps.style);
      }

      if (fixed) {
        wrapperProps.className += ' ' + stickyClassName;
        wrapperStyle = _extends({}, wrapperStyle, stickyStyle, this.buildStickyStyle());
      }

      holderProps.style = _extends({}, holderProps.style, { minHeight: height + 'px' });
      holderProps.ref = this.createHolderRef;

      wrapperProps.style = wrapperStyle;
      wrapperProps.ref = this.createWrapperRef;

      return _react2.default.createElement(holderCmp, holderProps, _react2.default.createElement(wrapperCmp, wrapperProps, children));
    }
  }]);

  return Sticky;
}(_react.Component);

// some helpers

Sticky.propTypes = {
  mode: _propTypes2.default.oneOf(['top', 'bottom']),
  onFixedToggle: _propTypes2.default.func,
  stickyStyle: _propTypes2.default.object,
  stickyClassName: _propTypes2.default.string,
  hideOnBoundaryHit: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  boundaryElement: _propTypes2.default.string,
  scrollElement: _propTypes2.default.string,
  bottomOffset: _propTypes2.default.number,
  topOffset: _propTypes2.default.number,
  positionRecheckInterval: _propTypes2.default.number,
  noExceptionOnMissedScrollElement: _propTypes2.default.bool,
  wrapperCmp: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  holderCmp: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  holderProps: _propTypes2.default.object
};
Sticky.defaultProps = {
  className: '',
  style: {},
  mode: 'top',
  holderCmp: 'div',
  holderProps: {},
  wrapperCmp: 'div',
  stickyClassName: 'sticky',
  stickyStyle: null,
  hideOnBoundaryHit: true,
  disabled: false,
  boundaryElement: null,
  scrollElement: 'window',
  topOffset: 0,
  bottomOffset: 0,
  noExceptionOnMissedScrollElement: false,
  positionRecheckInterval: 0
};
exports.default = Sticky;
function getRect(el) {
  if (el && typeof el.getBoundingClientRect === 'function') {
    return el.getBoundingClientRect();
  }

  if (el === window || el === document) {
    return { top: 0, left: 0, bottom: window.innerHeight, height: window.innerHeight, width: window.innerWidth, right: window.innerWidth };
  }

  return { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };
}

function instersect(r1, r2, topOffset, bottomOffset) {
  var r1Top = r1.top + topOffset,
      r1Bottom = r1.bottom + bottomOffset;

  return r1Top >= r2.top && r1Top <= r2.bottom || r1Bottom >= r2.top && r1Bottom <= r2.bottom || r1Bottom >= r2.bottom && r1Top <= r2.top;
}

/**
 * Simply removes all unwanted props in order to avoid react 'unkown prop' warning
 * @param  {Object} props     that should be sanitized
 * @param  {Object} toRemove  array of prop names to remove
 * @return {Object}           cloned and sanitized props
 */
function sanitizeProps(props, toRemove) {
  props = _extends({}, props);
  for (var i = 0, l = toRemove.length; i < l; i += 1) {
    delete props[toRemove[i]];
  }
  return props;
}
module.exports = exports['default'];

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;
exports.unlisten = unlisten;
////////////////////////////////////////////////////////////////////////////////////////
// Small helpers that provide an easy and effecient way to add/remove event listeners //
////////////////////////////////////////////////////////////////////////////////////////

var elementsWithListeners = [],
    registeredListeners = [];

function addListener(el, event, cb) {
  var idx = elementsWithListeners.indexOf(el);
  if (idx === -1) {
    idx = elementsWithListeners.length;
    elementsWithListeners.push(el);
    registeredListeners.push({ el: el, totalCount: 0 });
  }

  var listeners = registeredListeners[idx],
      listener = listeners[event];

  if (!listener) {
    listener = listeners[event] = { callbacks: [] };
    listener.cb = function (e) {
      for (var i = 0, l = listener.callbacks.length; i < l; i += 1) {
        listener.callbacks[i](e);
      }
    };
    listeners.totalCount += 1;
    listeners.el.addEventListener(event, listener.cb);
  }

  // just to prevent double listeners
  if (listener.callbacks.indexOf(cb) !== -1) {
    return;
  }

  listener.callbacks.push(cb);
}

function removeListener(el, event, cb) {
  var idx = elementsWithListeners.indexOf(el);
  if (idx === -1) {
    return;
  }

  var listeners = registeredListeners[idx],
      listener = listeners[event],
      callbacks = listener ? listener.callbacks : [];

  if (!listener || callbacks.indexOf(cb) === -1) {
    return;
  }

  callbacks.splice(callbacks.indexOf(cb), 1);
  if (callbacks.length > 0) {
    return;
  }

  listeners.el.removeEventListener(event, listener.cb);
  listeners.totalCount -= 1;
  delete listeners[event];

  if (listeners.totalCount > 0) {
    return;
  }

  elementsWithListeners.splice(idx, 1);
  registeredListeners.splice(idx, 1);
}

/**
 * Subscribe cb to events list
 * @param  {HTMLElement}   el       target element
 * @param  {Array}         events   array of event names
 * @param  {Function} cb   callback that should be called
 */
function listen(el, events, cb) {
  for (var i = 0, l = events.length; i < l; i += 1) {
    addListener(el, events[i], cb);
  }
}

/**
 * Unsubscribe cb from events list
 * @param  {HTMLElement}   el       target element
 * @param  {Array}         events   array of event names
 * @param  {Function} cb   callback that should be unsubscribed
 */

function unlisten(el, events, cb) {
  for (var i = 0, l = events.length; i < l; i += 1) {
    removeListener(el, events[i], cb);
  }
}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = find;
var basicSelectors = {};
if (typeof document !== 'undefined') {
  basicSelectors.body = document.body;
  basicSelectors.window = window;
  basicSelectors.document = document;
}

var matchesMethodName = function () {
  if (typeof document !== 'undefined') {
    var body = document.body;
    return typeof body.matches === 'function' ? 'matches' : typeof body.webkitMatchesSelector === 'function' ? 'webkitMatchesSelector' : //webkit
    typeof body.mozMatchesSelector === 'function' ? 'mozMatchesSelector' : //mozilla
    typeof body.msMatchesSelector === 'function' ? 'msMatchesSelector' : //ie
    typeof body.oMatchesSelector === 'function' ? 'oMatchesSelector' : //old opera
    null;
  }
}();

function find(selector, el) {
  if (!selector) {
    return null;
  }

  if (basicSelectors.hasOwnProperty(selector)) {
    return basicSelectors[selector];
  }

  // select by id
  if (selector[0] === '#') {
    return document.getElementById(selector.slice(1));
  }

  if (!matchesMethodName) {
    return null;
  }

  // eslint-disable-next-line no-cond-assign
  while (el = el.parentElement) {
    if (el[matchesMethodName](selector)) {
      return el;
    }
  }

  // nothing has been found :(
  return null;
}
module.exports = exports['default'];

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var index = (function (fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(undefined, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  var resultFn = wrapperFn;

  return resultFn;
});

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(686)();
}


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(687);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listHandle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSSR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_throttle__ = __webpack_require__(697);


var listHandle = {
  debounce: __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */],
  throttle: __WEBPACK_IMPORTED_MODULE_1_lodash_es_throttle__["a" /* default */]
};
var getHandle = function getHandle(type) {
  return listHandle[type];
};
var isFunction = function isFunction(fn) {
  return typeof fn === 'function';
};
var isSSR = function isSSR() {
  return typeof window === 'undefined';
};

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(406);


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(692);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(696);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(695);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(407);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debounce_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(276);



/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__debounce_js__["a" /* default */])(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ __webpack_exports__["a"] = (throttle);


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var ChildWrapper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ChildWrapper, _PureComponent);

  function ChildWrapper() {
    _classCallCheck(this, ChildWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChildWrapper).apply(this, arguments));
  }

  _createClass(ChildWrapper, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/prop-types
      return this.props.children;
    }
  }]);

  return ChildWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ChildWrapper);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResizeDetector__ = __webpack_require__(403);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var withResizeDetector = function withResizeDetector(WrappedComponent) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    handleWidth: true,
    handleHeight: true
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line
    function (_Component) {
      _inherits(ResizeDetectorHOC, _Component);

      function ResizeDetectorHOC() {
        _classCallCheck(this, ResizeDetectorHOC);

        return _possibleConstructorReturn(this, _getPrototypeOf(ResizeDetectorHOC).apply(this, arguments));
      }

      _createClass(ResizeDetectorHOC, [{
        key: "render",
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_ResizeDetector__["a" /* default */], props, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props));
        }
      }]);

      return ResizeDetectorHOC;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])
  );
};

/* unused harmony default export */ var _unused_webpack_default_export = (withResizeDetector);

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57), __webpack_require__(118)))

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainableTypeChecker;
var ANONYMOUS='<<anonymous>>';// Based on: https://github.com/facebook/prop-types/blob/534a07a3a52d2447e2a65ebf9f7635d858682ee0/factoryWithTypeCheckers.js
function createChainableTypeChecker(validate){function checkType(isRequired,props,propName,componentName,location,propFullName){componentName=componentName||ANONYMOUS;propFullName=propFullName||propName;if(props[propName]==null){if(isRequired){if(props[propName]===null){return new Error('The '+location+' "'+propFullName+'" is marked as required in "'+componentName+'", but its value is "null".\'');}return new Error('The '+location+' "'+propFullName+'" is marked as required in "'+componentName+'", but its value is "undefined".');}return null;}else{return validate(props,propName,componentName,location,propFullName);}}var chainedCheckType=checkType.bind(null,false);chainedCheckType.isRequired=checkType.bind(null,true);return chainedCheckType;}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(703);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 703 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var GlobalConfig=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('GlobalConfig',{ACCOUNT_COMPANY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ACTIVATE_SECTIONS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ACTIVATE_SPOTMORE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ACTIVE_VEHICLE_PART_SEARCH_INTEGRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ADD_BOTTLE_DEPOSIT_TO_PRICE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ADDITIONAL_PRODUCT_TABS_ACTIVE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ALLOW_FILE_UPLOAD_FOR_CUSTOMERS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ALLOW_PRODUCT_REVIEWS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),BOX_MANUFACTURERS_STYLE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),BOX_MANUFACTURERS_LIMIT_TO_SECTION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),CAPTCHA_ENABLE_CONTACT_US:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),CAPTCHA_ENABLE_REGISTRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),CAPTCHA_SITE_KEY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),CART_ERROR_INFO_PAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),CART_SHOW_ADDED_PRODUCT_IMAGES:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),CONFIGURATION_TEXTS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({CONF_SEO_TITLE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),CONF_SEO_DESCRIPTION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')}),CONTACT_ENTRY_ADDRESS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),CONTACT_FORM_ADDRESS_NEEDED:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),CONTACT_ENTRY_PHONE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),COOKIE_PRIVACY_INFO_PAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),CRITEO_MERCHANT_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),CUSTOMER_NAME_NEEDED_ON_NEWSLETTER:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),CUSTOMER_SERVICE_OPEN:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),CUSTOMER_SERVICE_PRICE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),DEFAULT_CATEGORY_PRODUCT_SORT_OPTION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),DEFAULT_CUSTOMER_TYPE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),DEFAULT_LANGUAGE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),DENY_ROBOTS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),DELIVERYTERMS_PAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),DISPLAY_MULTI_PRODUCTS_MODEL:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),DISPLAY_PRODUCTS_MODEL:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_ARINET_INTEGRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_CRITEO_INTEGRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_CUSTOMER_REGISTRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_EXTERNAL_CAMPAIGN_VISIT_TRACKING:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_FACEBOOK_TRACKING:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_LITE_CHECKOUT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_MONEY_TRANSFER_ACCOUNT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_MY_ACCOUNT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_NEWSLETTER_SUBSCRIPTION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_POSTAFFILIATE_INTEGRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_PRODUCT_PAGE_PRODUCT_ENQUIRY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_PRODUCT_SEARCH_SUGGESTIONS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_PRODUCTS_WATCHER:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_QUICK_REGISTERATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_RECURRING_ORDERS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_RESERVE_IN_STORE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_STORAGE_INFO:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_SWOGO_INTEGRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_YOTPO_INTEGRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_WISHLIST_EMAIL_SHARE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),ENABLE_WITVIEW_INTEGRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENABLE_ZOOVU_INTEGRATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),ENTRY_CITY_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_DOB_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_EMAIL_ADDRESS_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_FIRST_NAME_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_LAST_NAME_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_LOGIN_INFO_PAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_LOGIN_NAME_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_PASSWORD_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_POSTCODE_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_STATE_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_STREET_ADDRESS_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ENTRY_TELEPHONE_MIN_LENGTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),EXTERNAL_CAMPAIGNS_EXPIRY_TIME:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),FACEBOOK_PIXEL_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),FACEBOOK_VERIFICATION_CONTENT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),FIND_FROM_ACCESSORIES_CATEGORIES:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')),FRONTPAGE_TABS_MAX_PRODUCTS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),FRONTPAGE_TABS_ORDER:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')),FRONTPAGE_TEXT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),GIOSG_CUSTOMER_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),GTM_CUSTOMERS_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),HEADER_CENTER:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),HEADER_HIDE_CHECKOUT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),HEADER_SEARCH_BAR_MOVE_TOP_NAVIGATION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),HEADER_SHOPPING_CART_MOVE_LOGIN_RIGHT_SIDE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),HEADER_CENTER_SHOP_LOGO:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),HEADER_SHOW_STICKY_HEADER_ON_STARTUP:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),HEADER_HIDE_STICKY_HEADER_ON_SCROLLING_DOWN:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),HEADER_MOBILE_SEARCHBAR_VISIBILITY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),HIDE_MULTIPRODUCT_SELECTION_IMAGE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),INVOICE_TELEPHONE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),KLARNA_SUPPORTED_LOCALE_CURRENCIES:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),LANGUAGE_TEXTS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({TEXT_SEO_STORE_NAME_ADD:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')}),LAYOUT_STORE_THEME_SELECTION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),MAIN_BANNER_FULL_WIDTH:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),MAIN_BANNER_WITHIN_CONTENT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),MEGAMENU_FORCE_TWO_PRODUCT_CATEGORY_COLUMNS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),MEGAMENU_TWO_COLUMN_MAX_COUNT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),MEGAMENU_GROUP_ADDITIONAL_LINKS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),MODULE_PAYMENT_KCO_EID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),MODULE_PAYMENT_KREDITOR_EID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),MULTIPRODUCT_AS_DROPDOWN:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),NAVIGATION_MENU_STYLE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),NAVIGATION_ADD_TO_CART_ROW:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),NEW_PRODUCTS_EXPIRARY_TIME:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),ORDER_ONLY_PRODUCT_ORDER_LIMIT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PAGE_SUBCATEGORY_ENABLE_TABS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),POSTAFFILIATE_ACCOUNT_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),POSTAFFILIATE_MERCHANT_URL:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PREVENT_NOINDEX_BY_PARAMETER:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')),PRIVACY_STATEMENT_PAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_ADDED_TO_CART_MODAL_STYLE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_IMAGE_ASPECT_RATIO:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_LIST_CARD_DEFAULT_STYLE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_LIST_CART_BUTTON:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCT_LIST_CODE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_LIST_DESCRIPTION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCT_LIST_EAN:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_LIST_EXTRA_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_LIST_FILTER_BY_SEARCH_PHRASE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_LIST_FILTER_BY_STOCK:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCT_LIST_FILTER_BY_STOCK_DEFAULT_STATE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCT_LIST_MANUFACTURERS_CODE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_LIST_QUANTITY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_LIST_SINGULAR_PRICE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_LIST_SORT_SELECTORS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_PAGE_SHIPPING_OPTIONS_CALCULATION_TYPE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_PAGE_SHORT_DESCRIPTION_POSITION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_PAGE_SHOW_EAN_CODE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCT_PAGE_SHOW_EXTRA_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_PAGE_SHOW_MANUFACTURERS_CODE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_PAGE_SHOW_PRODUCT_CODE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCT_PAGE_SHOW_ADDITIONAL_PRODUCT_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_PAGE_ENABLE_ADDITIONAL_SERVICE_MODAL:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_PAGE_SHOW_WARRANTY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCT_PAGE_SHOW_WEIGHT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_PAGE_SHOW_TAX_BREAKDOWN_FOR_CONSUMERS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_PAGE_VALIDATE_FOR_CART:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_REVIEWS_ALLOW_FOR_VISITORS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_REVIEWS_ANONYMOUS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_REVIEWS_REQUIRE_APPROVAL:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),PRODUCT_SEARCH_SUGGESTIONS_COUNT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_SEARCH_PLAN:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),PRODUCT_SEARCH_POPULAR_SEARCHES:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCT_SEARCH_RECENT_SEARCHES:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),PRODUCTS_PRICE_ZERO_IS_VIEW_ONLY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),QUICK_REGISTERATION_PHONE_NEEDED:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),RECURRING_ORDERS_INFO_PAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),REQUIRE_LOGIN_FOR_ENTRY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),RESERVE_IN_STORE_EXCLUDE_PROPERTY_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),RESERVE_IN_STORE_USE_CAPTCHA:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),RESERVE_IN_STORE_RESERVATION_EXPIRY_TIME:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),SHOPALIKE_TRACKING_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),SECTIONPAGE_USE_PRODUCT_LIST:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SECTION_PAGE_SINGLE_ROW_TABS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOPPING_CENTER_BUYING_GUIDE_PAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),SHOW_ALL_PRODUCTS_FROM_TOP:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_ALWAYS_PRODUCT_PACKAGES:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_COLORS_AND_SIZES_ON_LISTING:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_COOKIE_USAGE_NOTICE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_CUSTOMER_GROUP_NAME:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_CUSTOMERS_VAT_NUMBER:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_FOOTER_MANUFACTURERS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_LEFT_COLUMN:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_MAIN_LINK_SPECIAL_PRODUCTS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_MAIN_LINK_NEW_PRODUCTS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_MAIN_LINK_SOLD_PRODUCTS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_MAIN_LINK_MOST_SOLD:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_MAIN_LINK_RECOMMENDED:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_MEGAMENU_MANUFACTURERS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_PRODUCTS_SHORT_DESCRIPTION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_SUBCATEGORIES_ON_MAINCAT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_WISHLIST:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_PAGES_100_PERCENT_WIDE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),SHOW_STORE_LOGO_ON_MOBILE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),SHOW_ASSISTANT_MENU_ON_MOBILE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),SOLD_PRODUCTS_SHOW_PRODUCT_CARD:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),STORE_INFO_PAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),STORE_NAME:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),STORE_OWNER_EMAIL_ADDRESS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),SYSTEM_COPYRIGHT_CONTENTS:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),USE_GIOSG:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),USE_GTM:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),USE_IMAGE_DESCRIPTION_ALT_TEXT:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),USE_PRODUCT_LONG_DESCRIPTION_AS_SHORT_DESCRIPTION:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,true),USE_SHOPALIKE_SERVICE:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false),YOTPO_APP_KEY:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),VIP_CUSTOMER_BENEFITS_INFOPAGE_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),WITVIEW_API_URL:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),WITVIEW_CUSTOMER_ID:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')});/* harmony default export */ __webpack_exports__["a"] = (GlobalConfig);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_Site__ = __webpack_require__(278);
var Site=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Site',{type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__types_Site__["a" /* SiteTypeType */]),section_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});/* harmony default export */ __webpack_exports__["a"] = (Site);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);
var bind = __webpack_require__(410);
var Axios = __webpack_require__(708);
var defaults = __webpack_require__(280);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(414);
axios.CancelToken = __webpack_require__(722);
axios.isCancel = __webpack_require__(413);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(723);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 707 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(280);
var utils = __webpack_require__(82);
var InterceptorManager = __webpack_require__(717);
var dispatchRequest = __webpack_require__(718);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(412);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);
var transformData = __webpack_require__(719);
var isCancel = __webpack_require__(413);
var defaults = __webpack_require__(280);
var isAbsoluteURL = __webpack_require__(720);
var combineURLs = __webpack_require__(721);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(82);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(414);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountPersonalInfo__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Client__ = __webpack_require__(415);
var Token=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Token',{algorithm:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});var User=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('User',{clients:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__Client__["a" /* default */]),[]),country_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,currency_code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,customer_group_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,customer_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,group_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),is_customer_user:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,is_logged:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,is_logged_as_client:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,is_retailer:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,is_client_login_enabled:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,logo:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),max_product_quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,personal_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__AccountPersonalInfo__["a" /* default */]),redirect_to_customers_prices:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,show_prices_with_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,show_cart_matrix:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,styles:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),tokens:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(Token),user_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),view_only:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,allow_address_modifications:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean)});/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var AccountPersonalInfo=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('AccountPersonalInfo',{firstname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,lastname:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,email:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,telephone:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),company:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')});/* harmony default export */ __webpack_exports__["a"] = (AccountPersonalInfo);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(140);
var AccountModal=__WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* default */].named('AccountModal').props({tab:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1__types_AccountModalTab__["a" /* AccountModalTabType */],__WEBPACK_IMPORTED_MODULE_1__types_AccountModalTab__["b" /* default */].LOGIN),resetPasswordVisible:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,false)}).actions(function(self){return{setTab:function setTab(tab){self.tab=tab;self.resetPasswordVisible=false;},toggleResetPasswordVisible:function toggleResetPasswordVisible(){self.resetPasswordVisible=!self.resetPasswordVisible;if(self.resetPasswordVisible){// The element might not be present in the DOM at the time this is
// called; schedule it to be done right after the React lifecycle
// methods (incl. a new render) have finished.
setImmediate(function(){var element=document.querySelector('.AccountModal .ResetPasswordForm input[name=email]');if(element){element.focus();}});}}};});/* harmony default export */ __webpack_exports__["a"] = (AccountModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(277).setImmediate))

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActivatedCoupon__ = __webpack_require__(728);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var Session=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Session',{activated_coupons:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__ActivatedCoupon__["a" /* default */])}).actions(function(self){return{removeCoupon:function removeCoupon(coupon){return self.activated_coupons.remove(coupon);},addCoupons:function addCoupons(coupons){self.activated_coupons=[].concat(_toConsumableArray(self.activated_coupons),_toConsumableArray(coupons));}};});/* harmony default export */ __webpack_exports__["a"] = (Session);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ActivatedCoupon=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ActivatedCoupon',{coupon_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,html:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),activation_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});/* harmony default export */ __webpack_exports__["a"] = (ActivatedCoupon);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_TranslatedImageType__ = __webpack_require__(212);
var TranslatedImage=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('TranslatedImage',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,image_key:__WEBPACK_IMPORTED_MODULE_1__types_TranslatedImageType__["a" /* TranslatedImageTypeType */],image_path:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (TranslatedImage);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccountLinks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoginLink__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegisterLink__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__header_NavigationAccountMenu__ = __webpack_require__(733);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccountLinks=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AccountLinks,_Component);function AccountLinks(){_classCallCheck(this,AccountLinks);return _possibleConstructorReturn(this,(AccountLinks.__proto__||Object.getPrototypeOf(AccountLinks)).apply(this,arguments));}_createClass(AccountLinks,[{key:'render',value:function render(){var accountLinks=void 0;if(!this.props.accountStore.loggedIn){accountLinks=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["H" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LoginLink__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RegisterLink__["a" /* default */],{prefix:'/'}));}else{accountLinks=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__header_NavigationAccountMenu__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["G" /* Nav */],{className:'AccountLinks'},accountLinks);}}]);return AccountLinks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AccountLinks.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_1__store_AccountStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore')(AccountLinks));

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccountModalLink__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(LoginLink,_Component);function LoginLink(){_classCallCheck(this,LoginLink);return _possibleConstructorReturn(this,(LoginLink.__proto__||Object.getPrototypeOf(LoginLink)).apply(this,arguments));}_createClass(LoginLink,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AccountModalLink__["a" /* default */],{className:'LoginLink',tab:__WEBPACK_IMPORTED_MODULE_4__types_AccountModalTab__["b" /* default */].LOGIN},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'unlock-alt'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].logInSentence));}}]);return LoginLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (LoginLink);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RegisterLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccountModalLink__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RegisterLink,_Component);function RegisterLink(){_classCallCheck(this,RegisterLink);return _possibleConstructorReturn(this,(RegisterLink.__proto__||Object.getPrototypeOf(RegisterLink)).apply(this,arguments));}_createClass(RegisterLink,[{key:'render',value:function render(){var _props=this.props,prefix=_props.prefix,configStore=_props.configStore;if(!configStore.registration.enabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,prefix||null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AccountModalLink__["a" /* default */],{className:'RegisterLink',tab:__WEBPACK_IMPORTED_MODULE_5__types_AccountModalTab__["b" /* default */].REGISTER},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].accountCreateSentence)));}}]);return RegisterLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RegisterLink.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,prefix:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(RegisterLink));

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationAccountMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_NavigationDropdownMenu__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__account_ClientLoginLink__ = __webpack_require__(419);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationAccountMenu=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationAccountMenu,_Component);function NavigationAccountMenu(){_classCallCheck(this,NavigationAccountMenu);return _possibleConstructorReturn(this,(NavigationAccountMenu.__proto__||Object.getPrototypeOf(NavigationAccountMenu)).apply(this,arguments));}_createClass(NavigationAccountMenu,[{key:'getBalanceUserPaymentHistoryNavigation',value:function getBalanceUserPaymentHistoryNavigation(routeService){var accountStore=this.props.accountStore;var accountType=accountStore.isBalanceBuyer?routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountBalanceUserPaymentHistory):routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountOrderList);var accountTypeTitle=accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].balanceUserAccountBalanceInfo:__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myOrderHistoryTitle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{tag:__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],to:accountType},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],accountTypeTitle));}},{key:'render',value:function render(){var _props=this.props,accountStore=_props.accountStore,routeService=_props.routeService,analytics=_props.analytics,configStore=_props.configStore;var enableMyAccount=configStore.account.enableMyAccount;var balanceBuyerPath=accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountBalanceUser:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccount;var userAccountTypePath=accountStore.isBalanceUser?__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountBalanceSubUser:balanceBuyerPath;var accountTitle=!accountStore.isClient?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myAccountTitle):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myAccountUserTitle,{values:{user:accountStore.name}}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_NavigationDropdownMenu__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'user'}),accountTitle),isAccount:true},enableMyAccount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{tag:__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],to:routeService.getPath(userAccountTypePath)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myAccountTitle)),accountStore.isBalanceBuyer&&!accountStore.isBalanceUser&&enableMyAccount&&this.getBalanceUserPaymentHistoryNavigation(routeService),!accountStore.isBalanceBuyer&&configStore.wishlist.enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{tag:__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],to:this.props.routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].WishList)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].wishListTitle)),accountStore.isClientLoginEnabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{tag:__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],to:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__account_ClientLoginLink__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{tag:__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],to:'#',className:'NavigationDropdownMenu__highlighted-action-item',onClick:function onClick(e){e.preventDefault();analytics.clearCart();accountStore.logout();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'sign-out'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].accountLogOutSentence))));}}]);return NavigationAccountMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationAccountMenu.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_AccountStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_12__services_RouteService__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14__analytics_Analytics__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('accountStore','routeService','analytics','configStore')(NavigationAccountMenu));

/***/ }),
/* 734 */
/***/ (function(module, exports) {


/**
 * Expose `isUrl`.
 */

module.exports = isUrl;

/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */

var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

/**
 * Loosely validate a URL `string`.
 *
 * @param {String} string
 * @return {Boolean}
 */

function isUrl(string){
  if (typeof string !== 'string') {
    return false;
  }

  var match = string.match(protocolAndDomainRE);
  if (!match) {
    return false;
  }

  var everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }

  if (localhostDomainRE.test(everythingAfterProtocol) ||
      nonLocalhostDomainRE.test(everythingAfterProtocol)) {
    return true;
  }

  return false;
}


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_NavigationEntityItem__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_NavigationDropdownMenu__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavigationMenuRowDropdownItem__ = __webpack_require__(738);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationMenuRow=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationMenuRow,_Component);function NavigationMenuRow(props){_classCallCheck(this,NavigationMenuRow);var _this=_possibleConstructorReturn(this,(NavigationMenuRow.__proto__||Object.getPrototypeOf(NavigationMenuRow)).call(this,props));_this.setActiveMenuId=function(id){_this.setState({activeMenuId:id});};_this.debouncedHoverMenu=__WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function(callback){if(callback){callback();}},200);_this.state={activeMenuId:null};return _this;}_createClass(NavigationMenuRow,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["G" /* Nav */],{navbar:true,className:'NavigationMenuRow'},this.props.items.map(function(item){return item.children&&item.children.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_NavigationDropdownMenu__["a" /* default */],{debouncer:_this2.debouncedHoverMenu,isOpen:_this2.state.activeMenuId===item.id,setActiveId:_this2.setActiveMenuId,entity:item,label:item.label,key:item.id},item.children.map(function(subItem){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NavigationMenuRowDropdownItem__["a" /* default */],{item:subItem,key:subItem.id});})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* NavItem */],{key:item.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__navigation_NavigationEntityItem__["a" /* default */],{entity:item}));}));}}]);return NavigationMenuRow;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;NavigationMenuRow.propTypes={items:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (NavigationMenuRow);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_MaybeExternalLink__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationEntityLink=function(_Component){_inherits(NavigationEntityLink,_Component);function NavigationEntityLink(){_classCallCheck(this,NavigationEntityLink);return _possibleConstructorReturn(this,(NavigationEntityLink.__proto__||Object.getPrototypeOf(NavigationEntityLink)).apply(this,arguments));}_createClass(NavigationEntityLink,[{key:'render',value:function render(){var _props=this.props,className=_props.className,entity=_props.entity,rest=_objectWithoutProperties(_props,['className','entity']);var active=entity.active,path=entity.path,label=entity.label,image=entity.image,type=entity.type;if(!entity){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* NavLink */],Object.assign({tag:__WEBPACK_IMPORTED_MODULE_5__common_MaybeExternalLink__["a" /* default */],className:className,to:path,active:active,type:type},rest),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationEntityLink',{'NavigationEntityLink__has-image':image})},image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:image,loading:'lazy'}),label));}}]);return NavigationEntityLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NavigationEntityLink.propTypes={entity:__WEBPACK_IMPORTED_MODULE_4__types_NavigationEntity__["a" /* default */].isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (NavigationEntityLink);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_NavigationEntity__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationEntityTextItem=function(_Component){_inherits(NavigationEntityTextItem,_Component);function NavigationEntityTextItem(){_classCallCheck(this,NavigationEntityTextItem);return _possibleConstructorReturn(this,(NavigationEntityTextItem.__proto__||Object.getPrototypeOf(NavigationEntityTextItem)).apply(this,arguments));}_createClass(NavigationEntityTextItem,[{key:'render',value:function render(){var _props=this.props,className=_props.className,entity=_props.entity,rest=_objectWithoutProperties(_props,['className','entity']);var active=entity.active,label=entity.label;if(!entity){return null;}// nav-item class is used for now to match Bootstrap class names.
// Should be changed in the future.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',Object.assign({className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('nav-text',className,{active:active})},rest),label);}}]);return NavigationEntityTextItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NavigationEntityTextItem.propTypes={entity:__WEBPACK_IMPORTED_MODULE_3__types_NavigationEntity__["a" /* default */].isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (NavigationEntityTextItem);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_NavigationDropdownSubmenu__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_MaybeExternalLink__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationMenuRowDropdownItem=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationMenuRowDropdownItem,_Component);function NavigationMenuRowDropdownItem(){_classCallCheck(this,NavigationMenuRowDropdownItem);return _possibleConstructorReturn(this,(NavigationMenuRowDropdownItem.__proto__||Object.getPrototypeOf(NavigationMenuRowDropdownItem)).apply(this,arguments));}_createClass(NavigationMenuRowDropdownItem,[{key:'render',value:function render(){var item=this.props.item;var image=item.image,label=item.label,type=item.type,path=item.path;if(item.children&&item.children.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_NavigationDropdownSubmenu__["a" /* default */],{labelText:item.label,to:item.path},item.children.map(function(subItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationMenuRowDropdownItem,{item:subItem,key:subItem.id});}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{key:item.id,tag:__WEBPACK_IMPORTED_MODULE_5__common_MaybeExternalLink__["a" /* default */],to:path,type:type,className:'NavigationMenuRowDropdownItem'},image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:image,loading:'lazy'}),label);}}}]);return NavigationMenuRowDropdownItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationMenuRowDropdownItem.propTypes={item:__WEBPACK_IMPORTED_MODULE_4__types_NavigationEntity__["a" /* default */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (NavigationMenuRowDropdownItem);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationDropdownSubmenu=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationDropdownSubmenu,_Component);function NavigationDropdownSubmenu(props){_classCallCheck(this,NavigationDropdownSubmenu);var _this=_possibleConstructorReturn(this,(NavigationDropdownSubmenu.__proto__||Object.getPrototypeOf(NavigationDropdownSubmenu)).call(this,props));_this.debouncedHoverMenu=__WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function(callback){if(callback){callback();}},200);_this.toggleMenu=function(){return _this.setState({open:!_this.state.open});};_this.openMenu=function(){return _this.setState({open:true});};_this.closeMenu=function(e){var to=_this.props.to;var isClick=!!(e&&e.type==='click');if(isClick&&(to.length===0||to==='#')){return;}_this.setState({open:false});};_this.state={open:false};_this.toggleMenu=_this.toggleMenu.bind(_this);return _this;}_createClass(NavigationDropdownSubmenu,[{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,onClick=_props.onClick,labelText=_props.labelText,to=_props.to;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["o" /* Dropdown */],{isOpen:this.state.open,toggle:this.toggleMenu,direction:'right',className:'NavigationDropdownSubmenu'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'NavigationDropdownMenu__hover',onClick:this.closeMenu,onMouseOver:function onMouseOver(){return _this2.debouncedHoverMenu(function(){return _this2.openMenu();});},onMouseOut:function onMouseOut(){return _this2.debouncedHoverMenu(function(){return _this2.closeMenu();});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* DropdownToggle */],{className:'NavigationDropdownSubmenu__label dropdown-item',onClick:onClick,tag:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],to:to,'data-toggle':'dropdown','aria-expanded':this.state.open},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,labelText),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */],{name:'angle-right',className:'chevron'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["q" /* DropdownMenu */],{className:'NavigationDropdownSubmenu_dropdown-menu'},children)));}}]);return NavigationDropdownSubmenu;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;NavigationDropdownSubmenu.propTypes={labelText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,to:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};NavigationDropdownSubmenu.defaultProps={labelText:{},onClick:function onClick(){}};/* harmony default export */ __webpack_exports__["a"] = (NavigationDropdownSubmenu);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_MobileNavigationTab__ = __webpack_require__(107);
var MobileNavigation=__WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */].named('MobileNavigation').props({activeTab:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__types_MobileNavigationTab__["a" /* MobileNavigationTabType */],__WEBPACK_IMPORTED_MODULE_2__types_MobileNavigationTab__["b" /* default */].PRODUCTS)}).actions(function(self){return{selectTab:function selectTab(tab){self.activeTab=tab;},close:function close(){self.isOpen=false;},open:function open(){self.isOpen=true;}};});/* harmony default export */ __webpack_exports__["a"] = (MobileNavigation);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Category__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(281);
var MegaMenu=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('MegaMenu',{isOpen:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,openCategory:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_2__Category__["a" /* default */])),rootCategory:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_2__Category__["a" /* default */])),activeSection:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */])),visibleCategories:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_2__Category__["a" /* default */])),[]),entityCount:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].map(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),{})}).actions(function(self){var afterCreate=function afterCreate(){Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["observe"])(self.visibleCategories,function(){self.setOpenCategory(null);});};var open=function open(categoryOrSection){if(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["i" /* getType */])(categoryOrSection)===__WEBPACK_IMPORTED_MODULE_2__Category__["a" /* default */]){self.activeSection=null;self.rootCategory=categoryOrSection.id;self.visibleCategories=categoryOrSection.children.map(function(category){return category.id;});}else{self.rootCategory=null;self.activeSection=categoryOrSection.id;self.visibleCategories=categoryOrSection.mainCategories;}// Automatically open active category, if it is available.
var _getRoot=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["g" /* getRoot */])(self),categoryStore=_getRoot.categoryStore;if(categoryStore.activeCategory){var activeCategories=categoryStore.activeCategory?categoryStore.activeCategory.hierarchy:[];self.openCategory=self.visibleCategories.find(function(visibleCategory){return activeCategories.indexOf(visibleCategory)!==-1;})||null;}self.isOpen=true;};var setOpenCategory=function setOpenCategory(category){self.openCategory=category;};var close=function close(){self.rootCategory=null;self.activeSection=null;self.visibleCategories=[];self.isOpen=false;};var toggle=function toggle(categoryOrSection){if(self.isOpen&&(self.rootCategory===categoryOrSection||self.activeSection===categoryOrSection)){close();}else{open(categoryOrSection);}};var countEntities=function countEntities(entity){var childEntityCount=0;childEntityCount+=getChildListLength(entity);childEntityCount+=entity.children.length;self.entityCount.set(entity.id,childEntityCount);};var getChildListLength=function getChildListLength(entity){var childList=[];entity.children.forEach(function(childEntity){childList=getChildEntities(childEntity,childList);});return childList.length;};var getChildEntities=function getChildEntities(childEntity,childList){var customNavLinks=childEntity.customNavLinks;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=customNavLinks[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var customNavLink=_step.value;if(customNavLink.customNavLinks.length>0){childList.push(customNavLink);getChildEntities(customNavLink,childList);}else{childList.push(customNavLink);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return childList;};var getChildEntityLength=function getChildEntityLength(childEntity,count){var cumulativeCount=count||0;var customNavLinks=childEntity.customNavLinks;if(customNavLinks.length>0){getChildEntityLength(count);}else{return cumulativeCount;}};return{afterCreate:afterCreate,open:open,setOpenCategory:setOpenCategory,close:close,toggle:toggle,countEntities:countEntities};}).views(function(self){return{getEntityCount:function getEntityCount(entityId){return self.entityCount.get(entityId);}};});/* harmony default export */ __webpack_exports__["a"] = (MegaMenu);

/***/ }),
/* 742 */
/***/ (function(module, exports) {

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * Default configs.
 */
var DEFAULT_DELIMITER = '/'
var DEFAULT_DELIMITERS = './'

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?"]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined]
  '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = (options && options.delimiter) || DEFAULT_DELIMITER
  var delimiters = (options && options.delimiters) || DEFAULT_DELIMITERS
  var pathEscaped = false
  var res

  while ((res = PATH_REGEXP.exec(str)) !== null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      pathEscaped = true
      continue
    }

    var prev = ''
    var next = str[index]
    var name = res[2]
    var capture = res[3]
    var group = res[4]
    var modifier = res[5]

    if (!pathEscaped && path.length) {
      var k = path.length - 1

      if (delimiters.indexOf(path[k]) > -1) {
        prev = path[k]
        path = path.slice(0, k)
      }
    }

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
      pathEscaped = false
    }

    var partial = prev !== '' && next !== undefined && next !== prev
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prev || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prev,
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      pattern: pattern ? escapeGroup(pattern) : '[^' + escapeString(delimiter) + ']+?'
    })
  }

  // Push any remaining characters.
  if (path || index < str.length) {
    tokens.push(path + str.substr(index))
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (data, options) {
    var path = ''
    var encode = (options && options.encode) || encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token
        continue
      }

      var value = data ? data[token.name] : undefined
      var segment

      if (Array.isArray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but got array')
        }

        if (value.length === 0) {
          if (token.optional) continue

          throw new TypeError('Expected "' + token.name + '" to not be empty')
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        segment = encode(String(value))

        if (!matches[i].test(segment)) {
          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"')
        }

        path += token.prefix + segment
        continue
      }

      if (token.optional) {
        // Prepend partial segment prefixes.
        if (token.partial) path += token.prefix

        continue
      }

      throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'))
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$/()])/g, '\\$1')
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  if (!keys) return path

  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
      })
    }
  }

  return path
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  return new RegExp('(?:' + parts.join('|') + ')', flags(options))
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var delimiter = escapeString(options.delimiter || DEFAULT_DELIMITER)
  var delimiters = options.delimiters || DEFAULT_DELIMITERS
  var endsWith = [].concat(options.endsWith || []).map(escapeString).concat('$').join('|')
  var route = ''
  var isEndDelimited = false

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
      isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1
    } else {
      var prefix = escapeString(token.prefix)
      var capture = token.repeat
        ? '(?:' + token.pattern + ')(?:' + prefix + '(?:' + token.pattern + '))*'
        : token.pattern

      if (keys) keys.push(token)

      if (token.optional) {
        if (token.partial) {
          route += prefix + '(' + capture + ')?'
        } else {
          route += '(?:' + prefix + '(' + capture + '))?'
        }
      } else {
        route += prefix + '(' + capture + ')'
      }
    }
  }

  if (end) {
    if (!strict) route += '(?:' + delimiter + ')?'

    route += endsWith === '$' ? '$' : '(?=' + endsWith + ')'
  } else {
    if (!strict) route += '(?:' + delimiter + '(?=' + endsWith + '))?'
    if (!isEndDelimited) route += '(?=' + delimiter + '|' + endsWith + ')'
  }

  return new RegExp('^' + route, flags(options))
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (path instanceof RegExp) {
    return regexpToRegexp(path, keys)
  }

  if (Array.isArray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), keys, options)
  }

  return stringToRegexp(/** @type {string} */ (path), keys, options)
}


/***/ }),
/* 743 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(745);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(746);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(283);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(748),
    ListCache = __webpack_require__(215),
    Map = __webpack_require__(285);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(749),
    hashDelete = __webpack_require__(754),
    hashGet = __webpack_require__(755),
    hashHas = __webpack_require__(756),
    hashSet = __webpack_require__(757);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(214);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(284),
    isMasked = __webpack_require__(751),
    isObject = __webpack_require__(89),
    toSource = __webpack_require__(421);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(752);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(88);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 753 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(214);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(214);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(214);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(216);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(216);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(216);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(216);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(218);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 764 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(218);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(218);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(218);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isObjectLike = __webpack_require__(90);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(146);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(772);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 772 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 773 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isLength = __webpack_require__(288),
    isObjectLike = __webpack_require__(90);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(427);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(125);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(779),
    getMatchData = __webpack_require__(794),
    matchesStrictComparable = __webpack_require__(439);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(292),
    baseIsEqual = __webpack_require__(293);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(215);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 782 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 783 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(215),
    Map = __webpack_require__(285),
    MapCache = __webpack_require__(283);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(292),
    equalArrays = __webpack_require__(428),
    equalByTag = __webpack_require__(788),
    equalObjects = __webpack_require__(790),
    getTag = __webpack_require__(179),
    isArray = __webpack_require__(47),
    isBuffer = __webpack_require__(289),
    isTypedArray = __webpack_require__(425);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 787 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(139),
    Uint8Array = __webpack_require__(432),
    eq = __webpack_require__(217),
    equalArrays = __webpack_require__(428),
    mapToArray = __webpack_require__(789),
    setToArray = __webpack_require__(294);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(433);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(124),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(124),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(124),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(438),
    keys = __webpack_require__(147);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(293),
    get = __webpack_require__(31),
    hasIn = __webpack_require__(796),
    isKey = __webpack_require__(282),
    isStrictComparable = __webpack_require__(438),
    matchesStrictComparable = __webpack_require__(439),
    toKey = __webpack_require__(145);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(797),
    hasPath = __webpack_require__(420);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 797 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(440),
    basePropertyDeep = __webpack_require__(799),
    isKey = __webpack_require__(282),
    toKey = __webpack_require__(145);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(222);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationNewsletterDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigationDropdownDrawer__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coupon_CouponText__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__newsletter_NewsletterSubscriptionForm__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_CouponStore__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationNewsletterDropdown=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationNewsletterDropdown,_Component);function NavigationNewsletterDropdown(){_classCallCheck(this,NavigationNewsletterDropdown);return _possibleConstructorReturn(this,(NavigationNewsletterDropdown.__proto__||Object.getPrototypeOf(NavigationNewsletterDropdown)).apply(this,arguments));}_createClass(NavigationNewsletterDropdown,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,couponStore=_props.couponStore;if(!configStore.newsletter.enabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NavigationDropdownDrawer__["a" /* default */],{className:'NavigationNewsletterDropdown',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Icon__["a" /* default */],{name:'envelope'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].newsletterSubscriptionSentence),' ',couponStore.newsletterCoupon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u2013 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__coupon_CouponText__["a" /* default */],{coupon:couponStore.newsletterCoupon,short:true}))),right:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NewsletterDropdown__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'NewsletterDropdown__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'newsletter.popdownTitleWithoutDiscount',defaultMessage:'Subscribe to our free newsletter!'})),couponStore.newsletterCoupon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'NewsletterDropdown__coupon-incentive-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__coupon_CouponText__["a" /* default */],{coupon:couponStore.newsletterCoupon,short:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__newsletter_NewsletterSubscriptionForm__["a" /* default */],null)));}}]);return NavigationNewsletterDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationNewsletterDropdown.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,couponStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_CouponStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','couponStore')(NavigationNewsletterDropdown));

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(149);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationRegionalSettingsMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigationDropdownDrawer__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationDropdownDrawerButton__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_RegionalSettingsDropdowns__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_RegionalSettings__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_LocaleFlagIcon__ = __webpack_require__(230);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationRegionalSettingsMenu=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationRegionalSettingsMenu,_Component);function NavigationRegionalSettingsMenu(){_classCallCheck(this,NavigationRegionalSettingsMenu);return _possibleConstructorReturn(this,(NavigationRegionalSettingsMenu.__proto__||Object.getPrototypeOf(NavigationRegionalSettingsMenu)).apply(this,arguments));}_createClass(NavigationRegionalSettingsMenu,[{key:'render',value:function render(){var _props=this.props,languageStore=_props.languageStore,currencyStore=_props.currencyStore,countryStore=_props.countryStore;var showCountries=countryStore.countries.length>1;var showLanguages=languageStore.languages.length>1;var showCurrencies=currencyStore.currencies.length>1;var labels=[];if(showCountries){labels.push(countryStore.activeCountry.name);}if(showLanguages){labels.push(languageStore.activeLanguage.name);}if(showCurrencies){labels.push(currencyStore.currencyCode);}if(labels.length===0){return null;}var labelIcon=showCountries?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_LocaleFlagIcon__["a" /* default */],{locale:countryStore.activeCountry.iso_code_2.toLowerCase()}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_LocaleFlagIcon__["a" /* default */],{locale:languageStore.activeLanguage.code});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_RegionalSettings__["a" /* default */],null,function(save,onChange,currentValues,isSaving){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NavigationDropdownDrawer__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'NavigationRegionalSettingsMenu__dropdown-current-label'},labelIcon,labels.join(' / ')),className:'NavigationRegionalSettingsMenu',buttons:[Object(__WEBPACK_IMPORTED_MODULE_5__NavigationDropdownDrawerButton__["a" /* default */])({label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:isSaving?'circle-o-notch':'check',spin:isSaving}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].saveTitle)),onClick:function onClick(context){save().then(context.close);},key:'submit',color:'primary',disabled:isSaving})],right:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationRegionalSettingsMenu__selectors'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_RegionalSettingsDropdowns__["a" /* default */],Object.assign({},currentValues,{onChange:onChange}))));});}}]);return NavigationRegionalSettingsMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationRegionalSettingsMenu.propTypes={languageStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_LanguageStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_CurrencyStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_CountryStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('languageStore','currencyStore','countryStore')(NavigationRegionalSettingsMenu));

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Country__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_DropdownSelect__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LocaleFlagIcon__ = __webpack_require__(230);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_LARGE_MENU_LENGTH=16;var RegionalSettingsDeliveryCountryDropdown=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RegionalSettingsDeliveryCountryDropdown,_Component);function RegionalSettingsDeliveryCountryDropdown(){_classCallCheck(this,RegionalSettingsDeliveryCountryDropdown);return _possibleConstructorReturn(this,(RegionalSettingsDeliveryCountryDropdown.__proto__||Object.getPrototypeOf(RegionalSettingsDeliveryCountryDropdown)).apply(this,arguments));}_createClass(RegionalSettingsDeliveryCountryDropdown,[{key:'render',value:function render(){var _this2=this;var country=this.props.country;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_DropdownSelect__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].deliveryCountryLabel,{values:{country:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LocaleFlagIcon__["a" /* default */],{locale:country.iso_code_2.toLowerCase()}),' ',country.name)}})),isLarge:this.props.countries.length>DEFAULT_LARGE_MENU_LENGTH},this.props.countries.map(function(country){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{onClick:function onClick(e){return _this2.props.onSelect(country);},key:country.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LocaleFlagIcon__["a" /* default */],{locale:country.iso_code_2.toLowerCase()}),' ',country.name));}));}}]);return RegionalSettingsDeliveryCountryDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RegionalSettingsDeliveryCountryDropdown.propTypes={country:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Country__["a" /* default */]).isRequired,countries:__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Country__["a" /* default */])).isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RegionalSettingsDeliveryCountryDropdown);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_famfamfam_flags_dist_sprite_famfamfam_flags_css__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_famfamfam_flags_dist_sprite_famfamfam_flags_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_famfamfam_flags_dist_sprite_famfamfam_flags_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FlagIcon=function(_Component){_inherits(FlagIcon,_Component);function FlagIcon(){_classCallCheck(this,FlagIcon);return _possibleConstructorReturn(this,(FlagIcon.__proto__||Object.getPrototypeOf(FlagIcon)).apply(this,arguments));}_createClass(FlagIcon,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'FlagIcon famfamfam-flags '+this.props.countryCode});}}]);return FlagIcon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FlagIcon.propTypes={countryCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FlagIcon);

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Language__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RegionalSettingsLanguageDropdownItem__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DropdownSelect__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegionalSettingsLanguageDropdown=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RegionalSettingsLanguageDropdown,_Component);function RegionalSettingsLanguageDropdown(){_classCallCheck(this,RegionalSettingsLanguageDropdown);return _possibleConstructorReturn(this,(RegionalSettingsLanguageDropdown.__proto__||Object.getPrototypeOf(RegionalSettingsLanguageDropdown)).apply(this,arguments));}_createClass(RegionalSettingsLanguageDropdown,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DropdownSelect__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].languageLabel,{values:{language:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RegionalSettingsLanguageDropdownItem__["a" /* default */],{language:this.props.language})}}))},this.props.languages.map(function(language){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{onClick:function onClick(e){return _this2.props.onSelect(language);},key:language.code},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RegionalSettingsLanguageDropdownItem__["a" /* default */],{language:language}));}));}}]);return RegionalSettingsLanguageDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RegionalSettingsLanguageDropdown.propTypes={language:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Language__["a" /* default */]).isRequired,languages:__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Language__["a" /* default */])).isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RegionalSettingsLanguageDropdown);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocaleFlagIcon__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Language__ = __webpack_require__(227);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegionalSettingsLanguageDropdownItem=function(_Component){_inherits(RegionalSettingsLanguageDropdownItem,_Component);function RegionalSettingsLanguageDropdownItem(){_classCallCheck(this,RegionalSettingsLanguageDropdownItem);return _possibleConstructorReturn(this,(RegionalSettingsLanguageDropdownItem.__proto__||Object.getPrototypeOf(RegionalSettingsLanguageDropdownItem)).apply(this,arguments));}_createClass(RegionalSettingsLanguageDropdownItem,[{key:'render',value:function render(){var language=this.props.language;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LocaleFlagIcon__["a" /* default */],{locale:language.code}),' ',language.name);}}]);return RegionalSettingsLanguageDropdownItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RegionalSettingsLanguageDropdownItem.propTypes={language:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__models_Language__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (RegionalSettingsLanguageDropdownItem);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Currency__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CurrencyLabel__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_DropdownSelect__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegionalSettingsCurrencyDropdown=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RegionalSettingsCurrencyDropdown,_Component);function RegionalSettingsCurrencyDropdown(){_classCallCheck(this,RegionalSettingsCurrencyDropdown);return _possibleConstructorReturn(this,(RegionalSettingsCurrencyDropdown.__proto__||Object.getPrototypeOf(RegionalSettingsCurrencyDropdown)).apply(this,arguments));}_createClass(RegionalSettingsCurrencyDropdown,[{key:'render',value:function render(){var _this2=this;var currencies=this.props.currencies;var disabled=this.props.disabled;if(currencies.length<2){disabled=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_DropdownSelect__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].currencyLabel,{values:{currency:this.props.currency.code}})),disabled:disabled},currencies.map(function(currency){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{onClick:function onClick(e){return _this2.props.onSelect(currency);},key:currency.code},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CurrencyLabel__["a" /* default */],{currency:currency}));}));}}]);return RegionalSettingsCurrencyDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RegionalSettingsCurrencyDropdown.propTypes={currency:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Currency__["a" /* default */]).isRequired,currencies:__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Currency__["a" /* default */])).isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};RegionalSettingsCurrencyDropdown.defaultProps={disabled:false};/* harmony default export */ __webpack_exports__["a"] = (RegionalSettingsCurrencyDropdown);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Currency__ = __webpack_require__(180);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CurrencyLabel=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CurrencyLabel,_Component);function CurrencyLabel(){_classCallCheck(this,CurrencyLabel);return _possibleConstructorReturn(this,(CurrencyLabel.__proto__||Object.getPrototypeOf(CurrencyLabel)).apply(this,arguments));}_createClass(CurrencyLabel,[{key:'render',value:function render(){var currency=this.props.currency;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CurrencyLabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CurrencyLabel__symbol',dangerouslySetInnerHTML:{__html:currency.symbol}}),' ',currency.code);}}]);return CurrencyLabel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CurrencyLabel.propTypes={currency:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__models_Currency__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (CurrencyLabel);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CategoryBadges__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_CustomNavigationLinkStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__navigation_NavigationMegaMenu__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_CustomNavigationLinkParentType__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_url__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationTopLevelMegaMenu=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationTopLevelMegaMenu,_Component);function NavigationTopLevelMegaMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationTopLevelMegaMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationTopLevelMegaMenu.__proto__||Object.getPrototypeOf(NavigationTopLevelMegaMenu)).call.apply(_ref,[this].concat(args))),_this),_this.getMainLevelItems=function(){var _this$props=_this.props,uiStore=_this$props.uiStore,routeService=_this$props.routeService,customNavigationLinkStore=_this$props.customNavigationLinkStore,configStore=_this$props.configStore;var customNavigationLinks=customNavigationLinkStore.customNavigationLinks;var items=uiStore.megaMenu.visibleCategories.map(_this.convertCategoryToNavigationEntity);var _uiStore$megaMenu=uiStore.megaMenu,rootCategory=_uiStore$megaMenu.rootCategory,activeSection=_uiStore$megaMenu.activeSection;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;// Don't show categoryOrSectionFields for custom navigation links
if(rootCategory&&rootCategory.link_type||activeSection&&activeSection.link_type){return items;}var categoryOrSectionFields={};if(rootCategory&&!twoLevelMegaMenuEnabled){categoryOrSectionFields={label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'navigation.shopAllCategory',defaultMessage:'Shop all {category}',values:{category:uiStore.megaMenu.rootCategory.navigationName}}),path:routeService.getPath(uiStore.megaMenu.rootCategory.path)};}else if(activeSection&&!twoLevelMegaMenuEnabled){categoryOrSectionFields={label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'navigation.shopAllSection',defaultMessage:'Shop all {section}',values:{section:uiStore.megaMenu.activeSection.navigationName}}),path:routeService.getPath(uiStore.megaMenu.activeSection.path)};}var topLevelCustomNavigations=_this.filterTopLevelCustomNavigations(customNavigationLinks);items=topLevelCustomNavigations.concat(items);if(!twoLevelMegaMenuEnabled){items.unshift(Object.assign({},categoryOrSectionFields,{id:'_top'}));}return items;},_this.convertCategoryToNavigationEntity=function(category){var _this$props2=_this.props,uiStore=_this$props2.uiStore,routeService=_this$props2.routeService,categoryStore=_this$props2.categoryStore;return{id:category.id,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,category.navigationName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_CategoryBadges__["a" /* default */],{category:category})),active:categoryStore.isInActiveCategoryHierarchy(category),path:routeService.getPath(category.path,uiStore.megaMenu.activeSection),children:_this.getCategoryNonBlockedChildren(category).map(_this.convertCategoryToNavigationEntity),type:category.link_type,customNavLinks:_this.getCustomNavigationLinks(category)};},_this.getCustomNavigationLinks=function(category){var customNavigationLinkStore=_this.props.customNavigationLinkStore;var customNavItems=customNavigationLinkStore.filterByCategoryId(category.id);return _this.convertCustomNavigationLinksToEntityItems(customNavItems);},_this.convertCustomNavigationLinksToEntityItems=function(topLevelCustomNavigationLinks){var customNavigationLinkStore=_this.props.customNavigationLinkStore;return topLevelCustomNavigationLinks.map(function(topLevelCustomNavigationLink){return{id:topLevelCustomNavigationLink.id,label:_this.getCustomNavigationLinkTitle(topLevelCustomNavigationLink.name),path:_this.getCustomCategoryListPath(topLevelCustomNavigationLink),link_type:topLevelCustomNavigationLink.link_type,location:topLevelCustomNavigationLink.location,parent_sibling_id:topLevelCustomNavigationLink.parent_sibling_id,customNavLinks:_this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.findChildLinks(topLevelCustomNavigationLink.id))};});},_this.getCustomNavigationLinkTitle=function(name){var configStore=_this.props.configStore;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;if(twoLevelMegaMenuEnabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,name));}return name;},_this.getCustomCategoryListPath=function(customNavLink){var _this$props3=_this.props,uiStore=_this$props3.uiStore,routeService=_this$props3.routeService;if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_13__types_LinkType__["b" /* default */].EXTERNAL_LINK){return customNavLink.link;}if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_13__types_LinkType__["b" /* default */].INTERNAL_LINK){return routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_14__util_url__["l" /* transformInternalLink */])(customNavLink.link));}return routeService.getPath(customNavLink.link,uiStore.megaMenu.activeSection);},_this.filterTopLevelCustomNavigations=function(customNavigationLinks){if(!customNavigationLinks){return null;}var topLevelCustomNavigationLinks=customNavigationLinks.filter(function(customNavigationLinkSibling){return!customNavigationLinkSibling.parent_sibling_id&&customNavigationLinkSibling.tree_type===__WEBPACK_IMPORTED_MODULE_12__types_CustomNavigationLinkParentType__["a" /* default */].CATEGORY;});return _this.convertCustomNavigationLinksToEntityItems(topLevelCustomNavigationLinks);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationTopLevelMegaMenu,[{key:'getCategoryNonBlockedChildren',value:function getCategoryNonBlockedChildren(category){var uiStore=this.props.uiStore;if(!category){return[];}return uiStore.megaMenu.activeSection?category.getNonBlockedChildren(uiStore.megaMenu.activeSection.blockedCategoriesDict):category.children;}},{key:'render',value:function render(){var _props=this.props,uiStore=_props.uiStore,configStore=_props.configStore,debouncer=_props.debouncer;var megaMenu=uiStore.megaMenu;var centered=configStore.topNavigation.center;if(!megaMenu.isOpen){return null;}var rootItem=megaMenu.activeSection||megaMenu.rootCategory;var items=this.getMainLevelItems();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__navigation_NavigationMegaMenu__["a" /* default */]// This onMouseOver prevents the onMouseOver that would close the MegaMenu
,{onMouseOver:function onMouseOver(){return debouncer(function(){return null;});},onMouseOut:function onMouseOut(){return debouncer(function(){return uiStore.megaMenu.close();});},entities:items,close:megaMenu.close,key:rootItem.id,centered:centered});}}]);return NavigationTopLevelMegaMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationTopLevelMegaMenu.propTypes={categoryStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_CategoryStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__["a" /* default */]).isRequired,customNavigationLinkStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_CustomNavigationLinkStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_UIStore__["a" /* default */]).isRequired,// This is a hack that we need in order to support onMouseOver and onMouseOut
// when this megamenu and the elements toggling it are separate.
// In normal (non-react) world this would be handled by rendering the
// megamenu as a child of the menu item. This refactoring is however too big
// right now, so we settle for having a global debouncer that only excutes the
// last function call.
debouncer:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('categoryStore','configStore','customNavigationLinkStore','routeService','uiStore')(NavigationTopLevelMegaMenu));

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(304),
    map = __webpack_require__(813);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(139),
    isArguments = __webpack_require__(287),
    isArray = __webpack_require__(47);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(144),
    baseIteratee = __webpack_require__(84),
    baseMap = __webpack_require__(449),
    isArray = __webpack_require__(47);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CustomNavigationLink=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CustomNavigationLink',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,link_type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,link:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,parent_sibling_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),tree_type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,location:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (CustomNavigationLink);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immer__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ClickOutside__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__navigation_NavigationEntityItem__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_safeCloneDeep__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_CustomNavigationLinkLocation__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavigationSidePanelMegaMenu__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__NavigationTwoLevelMegaMenu__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__NavigationSecondLevelCategory__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NavigationFirstLevelCategory__ = __webpack_require__(456);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationMegaMenu=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationMegaMenu,_Component);function NavigationMegaMenu(props){_classCallCheck(this,NavigationMegaMenu);var _this=_possibleConstructorReturn(this,(NavigationMegaMenu.__proto__||Object.getPrototypeOf(NavigationMegaMenu)).call(this,props));_this.renderMegaMenu=function(){var _this$props=_this.props,close=_this$props.close,configStore=_this$props.configStore,centered=_this$props.centered;var _this$state=_this.state,entityTree=_this$state.entityTree,hideBottomLevelItems=_this$state.hideBottomLevelItems;var panelItems=_this.getFirstLevelItems();var activeEntity=entityTree.find(function(item){return item.active;});var panelContent=_this.getSecondLevelCategories(activeEntity,close);var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;if(twoLevelMegaMenuEnabled){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NavigationTwoLevelMegaMenu__["a" /* default */],{entityTree:entityTree,onClick:close});}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__NavigationSidePanelMegaMenu__["a" /* default */],{leftPanelItems:panelItems,rightPanelRef:_this.getChildRef,onOverflow:_this.updateOverflowState,activeLeftPanelEntity:activeEntity,centered:centered,hideBottomLevelItems:hideBottomLevelItems,onCenteredMegamenu:_this.getCenteredStyles,rightPanelContent:panelContent});};_this.getFirstLevelItems=function(){var _this$props2=_this.props,configStore=_this$props2.configStore,close=_this$props2.close;var entityTree=_this.state.entityTree;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;return entityTree.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__NavigationFirstLevelCategory__["a" /* default */],{key:item.id,entityIndex:index,entity:item,onClick:close,onMouseOver:!twoLevelMegaMenuEnabled?_this.activateLeftPanelItem.bind(_this,index):function(){return null;},onSubEntityMouseOver:!twoLevelMegaMenuEnabled?_this.activateLeftPanelItem.bind(_this,index+1):function(){return null;}});});};_this.getSecondLevelCategories=function(activeLeftPanelEntity,close){var configStore=_this.props.configStore;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;return activeLeftPanelEntity&&activeLeftPanelEntity.children&&activeLeftPanelEntity.children.length>0?activeLeftPanelEntity.children.map(function(item){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__NavigationSecondLevelCategory__["a" /* default */],{key:item.id,entity:item,onClick:close},!twoLevelMegaMenuEnabled&&_this.getThirdLevelCategories(item,close));}):null;};_this.getThirdLevelCategories=function(item,close){return item.children&&item.children.length>0&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'NavigationMegaMenu__third-level-items'},item.children.map(function(subItem,i){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],{key:i},subItem.customNavLinks&&subItem.customNavLinks.map(function(customNavLink,index){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_12__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&_this.getThirdLevelCustomNavigationItem(customNavLink,index,close);}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{key:i},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__navigation_NavigationEntityItem__["a" /* default */],{entity:subItem,onClick:close})),subItem.customNavLinks&&subItem.customNavLinks.map(function(customNavLink,index){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_12__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&_this.getThirdLevelCustomNavigationItem(customNavLink,index,close);}));}));};_this.getThirdLevelCustomNavigationItem=function(customNavLink,index,close){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],{key:index},customNavLink.customNavLinks&&customNavLink.customNavLinks.map(function(subCustomNavLink,subIndex){return subCustomNavLink.location===__WEBPACK_IMPORTED_MODULE_12__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&subCustomNavLink.parent_sibling_id===customNavLink.id&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{key:subIndex},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__navigation_NavigationEntityItem__["a" /* default */],{entity:subCustomNavLink,onClick:close,type:subCustomNavLink.link_type}));}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__navigation_NavigationEntityItem__["a" /* default */],{entity:customNavLink,onClick:close,type:customNavLink.link_type})),customNavLink.customNavLinks&&customNavLink.customNavLinks.map(function(subCustomNavLink,subIndex){return subCustomNavLink.location===__WEBPACK_IMPORTED_MODULE_12__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&subCustomNavLink.parent_sibling_id===customNavLink.id&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{key:subIndex},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__navigation_NavigationEntityItem__["a" /* default */],{entity:subCustomNavLink,onClick:close,type:subCustomNavLink.link_type}));}));};_this.getMarginOffset=function(){var centered=_this.props.centered;if(!centered){return;}var domElements=document.getElementsByClassName('NavigationSingleLevelMenuRow__nav');var mainNav=domElements[0];if(mainNav){var marginOffset=mainNav.getBoundingClientRect().x;// 37.5 is second level paddings.
var availableWidth=window.innerWidth-marginOffset-37.5;_this.setState({marginOffset:marginOffset,availableWidth:availableWidth});}};_this.getCenteredStyles=function(){if(!_this.props.centered){return null;}var _this$state2=_this.state,availableWidth=_this$state2.availableWidth,marginOffset=_this$state2.marginOffset;return{marginLeft:marginOffset,maxWidth:availableWidth};};_this.getChildRef=function(measurementElement){return _this.measurementElement=measurementElement;};_this.updateOverflowState=function(){if(_this.measurementElement){var isOverflowed=_this.measurementElement.scrollHeight>_this.measurementElement.clientHeight||_this.measurementElement.scrollWidth>_this.measurementElement.clientWidth;// Only trigger a state change if there is actually a need to do so.
// Otherwise we will get stuck in a loop with componentDidUpdate triggering over and over.
// The measured element's dimensions should be guaranteed to not change after the re-render,
// since the overflow state doesn't alter that element in any way.
if(isOverflowed!==_this.state.hideBottomLevelItems){_this.setState({hideBottomLevelItems:isOverflowed});}}};_this.activateLeftPanelItem=__WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function(currentIndex){if(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_this.state,['entityTree',currentIndex,'active'])){return;}var nextState=Object(__WEBPACK_IMPORTED_MODULE_5_immer__["a" /* produce */])(_this.state,function(draftState){var siblings=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(draftState,'entityTree');siblings.forEach(function(sibling,index){__WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(draftState,['entityTree',index,'active'],index===currentIndex);});});_this.setState(nextState);},100);_this.resizeListener=null;_this.state={entityTree:[],hideBottomLevelItems:false,marginOffset:null,availableWidth:null};_this.state.entityTree=Object(__WEBPACK_IMPORTED_MODULE_11__util_safeCloneDeep__["a" /* default */])(_this.props.entities);return _this;}_createClass(NavigationMegaMenu,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.centered){this.resizeListener=window.addEventListener('resize',this.getMarginOffset);this.getMarginOffset();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.resizeListener){window.removeEventListener('resize',this.resizeListener);}}},{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,close=_props.close,onMouseOut=_props.onMouseOut,onMouseOver=_props.onMouseOver;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_ClickOutside__["a" /* default */],{onClickOutside:close,excludedSelector:'.CommonNavigation__bottom .DropdownNavLink, .NavigationRootMegaMenuButton'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()('NavigationMegaMenu',{'NavigationMegaMenu__two-level-megamenu':twoLevelMegaMenuEnabled,container:twoLevelMegaMenuEnabled}),onMouseOver:onMouseOver,onMouseOut:onMouseOut},this.renderMegaMenu()));}}]);return NavigationMegaMenu;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]))||_class;NavigationMegaMenu.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__["a" /* default */]).isRequired,entities:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_10__types_NavigationEntity__["a" /* default */]).isRequired,close:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onMouseOver:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onMouseOut:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,centered:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["c" /* inject */])('configStore')(NavigationMegaMenu));

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(146);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(308);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(184),
    keys = __webpack_require__(147);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(184),
    keysIn = __webpack_require__(453);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    isPrototype = __webpack_require__(291),
    nativeKeysIn = __webpack_require__(821);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 821 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(88);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(290)(module)))

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(184),
    getSymbols = __webpack_require__(296);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(184),
    getSymbolsIn = __webpack_require__(455);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 825 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(311),
    cloneDataView = __webpack_require__(827),
    cloneRegExp = __webpack_require__(828),
    cloneSymbol = __webpack_require__(829),
    cloneTypedArray = __webpack_require__(830);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(311);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 828 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(139);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(311);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(832),
    getPrototype = __webpack_require__(309),
    isPrototype = __webpack_require__(291);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(834),
    baseUnary = __webpack_require__(148),
    nodeUtil = __webpack_require__(221);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(179),
    isObjectLike = __webpack_require__(90);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(836),
    baseUnary = __webpack_require__(148),
    nodeUtil = __webpack_require__(221);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(179),
    isObjectLike = __webpack_require__(90);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resize_detector__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationSidePanelMegaMenu=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationSidePanelMegaMenu,_Component);function NavigationSidePanelMegaMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationSidePanelMegaMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationSidePanelMegaMenu.__proto__||Object.getPrototypeOf(NavigationSidePanelMegaMenu)).call.apply(_ref,[this].concat(args))),_this),_this.getCenteredStyles=function(){var onCenteredMegamenu=_this.props.onCenteredMegamenu;if(onCenteredMegamenu){return onCenteredMegamenu();}},_this.updateOverflowState=function(){var onOverflow=_this.props.onOverflow;onOverflow&&onOverflow();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationSidePanelMegaMenu,[{key:'render',value:function render(){var _props=this.props,centered=_props.centered,leftPanelItems=_props.leftPanelItems,rightPanelContent=_props.rightPanelContent,rightPanelRef=_props.rightPanelRef,hideBottomLevelItems=_props.hideBottomLevelItems,activeLeftPanelEntity=_props.activeLeftPanelEntity;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationMegaMenu__inner',{'NavigationMegaMenu__inner--centered':centered}),style:this.getCenteredStyles()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'4',xl:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* ListGroup */],{className:'NavigationMegaMenu__first-level-items'},leftPanelItems)),rightPanelContent&&[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'8',xl:'9',className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationMegaMenu__second-level-items',{'NavigationMegaMenu__hidden-bottom-level-items':hideBottomLevelItems}),key:'real_'+activeLeftPanelEntity.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,rightPanelContent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'9',className:'NavigationMegaMenu__second-level-items NavigationMegaMenu__measurement-helper',key:'shadow_'+activeLeftPanelEntity.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(measurementElement){return rightPanelRef(measurementElement);}},rightPanelContent,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_resize_detector__["a" /* default */],{handleWidth:true,handleHeight:true,onResize:this.updateOverflowState,refreshMode:'throttle',refreshRate:1000})))]));}}]);return NavigationSidePanelMegaMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationSidePanelMegaMenu.propTypes={leftPanelItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node).isRequired,rightPanelRef:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onOverflow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,activeLeftPanelEntity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,centered:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hideBottomLevelItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onCenteredMegamenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,rightPanelContent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)};/* harmony default export */ __webpack_exports__["a"] = (NavigationSidePanelMegaMenu);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigationFirstLevelCategory__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigationSecondLevelCategory__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigationManufacturerBox__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavigationMegaMenuBanner__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_AdStore__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_ManufacturerStore__ = __webpack_require__(111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationTwoLevelMegaMenu=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(NavigationTwoLevelMegaMenu,_Component);function NavigationTwoLevelMegaMenu(props){_classCallCheck(this,NavigationTwoLevelMegaMenu);var _this=_possibleConstructorReturn(this,(NavigationTwoLevelMegaMenu.__proto__||Object.getPrototypeOf(NavigationTwoLevelMegaMenu)).call(this,props));_initialiseProps.call(_this);var configStore=props.configStore;_this.showManufacturers=configStore.megaMenu.showManufacturers;_this.state={manufacturers:[],hasActiveManufacturers:true};return _this;}_createClass(NavigationTwoLevelMegaMenu,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_13__util_dom__["b" /* blockScroll */])();}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_13__util_dom__["a" /* allowScroll */])();}},{key:'render',value:function render(){var hasActiveManufacturers=this.state.hasActiveManufacturers;var hasAds=this.getAds();var hasManufacturers=this.hasManufacturers();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationTwoLevelMegaMenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationTwoLevelMegaMenu__wrapper',{'NavigationTwoLevelMegaMenu__wrapper--manufacturer-box-enabled':this.showManufacturers&&hasManufacturers&&hasActiveManufacturers})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationTwoLevelMegaMenu__first-level-items-row',{'NavigationTwoLevelMegaMenu__first-level-items-row--manufacturer-box-enabled':this.showManufacturers&&hasManufacturers&&hasActiveManufacturers})},this.renderMegamenu()),this.showManufacturers&&hasManufacturers&&this.renderManufacturerBox(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationTwoLevelMegaMenu__banner-row',{'NavigationTwoLevelMegaMenu__banner-row--banners-loaded':hasAds})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NavigationMegaMenuBanner__["a" /* default */],null))));}}]);return NavigationTwoLevelMegaMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.renderMegamenu=function(){var _props=_this2.props,configStore=_props.configStore,uiStore=_props.uiStore,entityTree=_props.entityTree,onClick=_props.onClick;var hasActiveManufacturers=_this2.state.hasActiveManufacturers;var hasManufacturers=_this2.hasManufacturers();var maximumSubCategoryCount=configStore.megaMenu.maximumSubCategoryCount;return entityTree.map(function(entity,index){uiStore.megaMenu.countEntities(entity);var ifTwoColumns=configStore.megaMenu.forceTwoSubCategoryColumns||uiStore.megaMenu.getEntityCount(entity.id)<=maximumSubCategoryCount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NavigationFirstLevelCategory__["a" /* default */],{key:entity.id,entityIndex:index,entity:entity,onClick:onClick,hasManufacturers:hasActiveManufacturers&&hasManufacturers},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationTwoLevelMegaMenu__second-level-items-row',{'NavigationTwoLevelMegaMenu__second-level-items-row--two-columns':ifTwoColumns})},_this2.renderSecondLevelCategories(entity)));});};this.renderSecondLevelCategories=function(entity){var onClick=_this2.props.onClick;return entity.children&&entity.children.length>0?entity.children.map(function(subEntity){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__NavigationSecondLevelCategory__["a" /* default */],{key:subEntity.id,entity:subEntity,onClick:onClick});}):null;};this.getAds=function(){var adStore=_this2.props.adStore;var searchParams={bannerZone:__WEBPACK_IMPORTED_MODULE_15__types_AdZones__["a" /* default */].MEGA_MENU_BANNER};return adStore.getAdsBySearchParameters(searchParams);};this.hasManufacturers=function(){var manufacturerStore=_this2.props.manufacturerStore;return manufacturerStore.hasManufacturers;};this.updateManufacturers=function(manufacturers){if(!manufacturers||manufacturers.length===0){_this2.setState({manufacturers:manufacturers,hasActiveManufacturers:false});}if(manufacturers&&manufacturers.length>0){_this2.setState({manufacturers:manufacturers,hasActiveManufacturers:true});}};this.renderManufacturerBox=function(){var hasActiveManufacturers=_this2.state.hasActiveManufacturers;if(hasActiveManufacturers){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationTwoLevelMegaMenu__manufacturers-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NavigationManufacturerBox__["a" /* default */],{onManufacturersUpdate:_this2.updateManufacturers}));}return null;};},_temp))||_class;NavigationTwoLevelMegaMenu.propTypes={adStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_AdStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,manufacturerStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_ManufacturerStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_UIStore__["a" /* default */]).isRequired,entityTree:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__["a" /* default */]).isRequired,onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('adStore','configStore','manufacturerStore','uiStore')(NavigationTwoLevelMegaMenu));

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationFirstLevelItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationFirstLevelItem=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationFirstLevelItem,_Component);function NavigationFirstLevelItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationFirstLevelItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationFirstLevelItem.__proto__||Object.getPrototypeOf(NavigationFirstLevelItem)).call.apply(_ref,[this].concat(args))),_this),_this.getNavigationMegaMenuItemType=function(){var _this$props=_this.props,children=_this$props.children,configStore=_this$props.configStore,className=_this$props.className,hasManufacturers=_this$props.hasManufacturers;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;var showManufacturers=configStore.megaMenu.showManufacturers;if(twoLevelMegaMenuEnabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationFirstLevelItem',className,{'NavigationFirstLevelItem--manufacturer-box-enabled':showManufacturers&&hasManufacturers})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationFirstLevelItem__children')},children));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["B" /* ListGroupItem */],{className:className},children);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationFirstLevelItem,[{key:'render',value:function render(){return this.getNavigationMegaMenuItemType();}}]);return NavigationFirstLevelItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationFirstLevelItem.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hasManufacturers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('configStore')(NavigationFirstLevelItem));

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationMegaMenuTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationMegaMenuTitle=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationMegaMenuTitle,_Component);function NavigationMegaMenuTitle(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationMegaMenuTitle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationMegaMenuTitle.__proto__||Object.getPrototypeOf(NavigationMegaMenuTitle)).call.apply(_ref,[this].concat(args))),_this),_this.renderMegaMenuItemIcon=function(){var _this$props=_this.props,configStore=_this$props.configStore,entity=_this$props.entity,entityIndex=_this$props.entityIndex;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;if(twoLevelMegaMenuEnabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,entity.children&&entity.children.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Icon__["a" /* default */],{name:'angle-right'}),!entity.children&&entityIndex===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Icon__["a" /* default */],{name:'angle-double-right'}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationMegaMenuTitle,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,className=_props.className,entity=_props.entity;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;if(!entity){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('NavigationMegaMenuTitle',className,{'NavigationMegaMenuTitle__two-level-megamenu':twoLevelMegaMenuEnabled})},entity.label,this.renderMegaMenuItemIcon());}}]);return NavigationMegaMenuTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationMegaMenuTitle.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__["a" /* default */]).isRequired,entity:__WEBPACK_IMPORTED_MODULE_6__types_NavigationEntity__["a" /* default */],entityIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('configStore')(NavigationMegaMenuTitle));

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationSecondLevelItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigationEntityItem__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationSecondLevelItem=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationSecondLevelItem,_Component);function NavigationSecondLevelItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationSecondLevelItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationSecondLevelItem.__proto__||Object.getPrototypeOf(NavigationSecondLevelItem)).call.apply(_ref,[this].concat(args))),_this),_this.renderSecondLevelItems=function(){var _this$props=_this.props,children=_this$props.children,className=_this$props.className,configStore=_this$props.configStore,entity=_this$props.entity,onClick=_this$props.onClick;var twoLevelMegaMenuEnabled=configStore.megaMenu.twoLayerMegamenuEnabled;if(twoLevelMegaMenuEnabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationSecondLevelItem',className)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NavigationEntityItem__["a" /* default */],{entity:entity,onClick:onClick}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'NavigationMegaMenu__second-level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'NavigationMegaMenu__second-level-item-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NavigationEntityItem__["a" /* default */],{entity:entity,onClick:onClick,type:entity.link_type}),children));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationSecondLevelItem,[{key:'render',value:function render(){return this.renderSecondLevelItems();}}]);return NavigationSecondLevelItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationSecondLevelItem.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_UIStore__["a" /* default */]).isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,entity:__WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__["a" /* default */],className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','uiStore')(NavigationSecondLevelItem));

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationManufacturerBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_box_ManufacturerBox__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_LayoutBoxStore__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationManufacturerBox=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationManufacturerBox,_Component);function NavigationManufacturerBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationManufacturerBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationManufacturerBox.__proto__||Object.getPrototypeOf(NavigationManufacturerBox)).call.apply(_ref,[this].concat(args))),_this),_this.getManufacturerBoxTitle=function(){var layoutBoxStore=_this.props.layoutBoxStore;var layoutBoxes=layoutBoxStore.layoutBoxes;if(layoutBoxes&&layoutBoxes.length){var manufacturerBox=layoutBoxes.find(function(layoutBox){return layoutBox.key==='manufacturers';});return manufacturerBox.title;}},_this.closeMegaMenu=function(){var uiStore=_this.props.uiStore;return uiStore.megaMenu.close();},_this.getManufacturers=function(manufacturers){var onManufacturersUpdate=_this.props.onManufacturersUpdate;onManufacturersUpdate(manufacturers);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationManufacturerBox,[{key:'render',value:function render(){var title=this.getManufacturerBoxTitle();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_box_ManufacturerBox__["a" /* default */],{className:'ManufacturerBox__two-level-megamenu',twoLayerMegamenuEnabled:true,title:title,minManufacturersForDropdown:5,onLinkClick:this.closeMegaMenu,linkButtonClassName:'NavigationManufacturerBox__link-button',onManufacturersUpdate:this.getManufacturers});}}]);return NavigationManufacturerBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationManufacturerBox.propTypes={layoutBoxStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_LayoutBoxStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_UIStore__["a" /* default */]).isRequired,onManufacturersUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('layoutBoxStore','uiStore')(NavigationManufacturerBox));

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ManufacturerIntegrationType__ = __webpack_require__(312);
var ManufacturerIntegration=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ManufacturerIntegration',{type:__WEBPACK_IMPORTED_MODULE_1__types_ManufacturerIntegrationType__["a" /* ManufacturerIntegrationTypeType */],api_key:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (ManufacturerIntegration);

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(845).default;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arrays = __webpack_require__(846);

var _arrays2 = _interopRequireDefault(_arrays);

var _reactAutowhatever = __webpack_require__(847);

var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);

var _theme = __webpack_require__(855);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          suggestions = _props.suggestions,
          onSuggestionHighlighted = _props.onSuggestionHighlighted,
          highlightFirstSuggestion = _props.highlightFirstSuggestion;


      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          multiSection = _props2.multiSection,
          getSectionSuggestions = _props2.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          suggestions = _props3.suggestions,
          renderInputComponent = _props3.renderInputComponent,
          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
          renderSuggestion = _props3.renderSuggestion,
          inputProps = _props3.inputProps,
          multiSection = _props3.multiSection,
          renderSectionTitle = _props3.renderSectionTitle,
          id = _props3.id,
          getSectionSuggestions = _props3.getSectionSuggestions,
          theme = _props3.theme,
          getSuggestionValue = _props3.getSuggestionValue,
          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isCollapsed = _state2.isCollapsed,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _state2.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();
            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();
            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this3.maybeCallOnChange(event, value, 'type');

          _this3.setState(_extends({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this3.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this3.justPressedUpDown = true;

              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();
                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2.default.func,
  onSuggestionHighlighted: _propTypes2.default.func,
  renderInputComponent: _propTypes2.default.func,
  renderSuggestionsContainer: _propTypes2.default.func,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2.default.func,
  alwaysRenderSuggestions: _propTypes2.default.bool,
  multiSection: _propTypes2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2.default.bool,
  highlightFirstSuggestion: _propTypes2.default.bool,
  theme: _propTypes2.default.object,
  id: _propTypes2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onDocumentMouseDown = function (event) {
    _this4.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this4.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this4.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this4.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);

    _this4.justMouseEntered = true;

    setTimeout(function () {
      _this4.justMouseEntered = false;
    });
  };

  this.highlightFirstSuggestion = function () {
    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
  };

  this.onSuggestionMouseDown = function () {
    _this4.justSelectedSuggestion = true;
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props4 = _this4.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        onSuggestionSelected = _props4.onSuggestionSelected,
        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this4.onSuggestionsClearRequested();
    }

    _this4.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props5 = _this4.props,
        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);

    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this4.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this4.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this4.input.focus();
    } else {
      _this4.onBlur();
    }

    setTimeout(function () {
      _this4.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props6 = _this4.props,
        inputProps = _props6.inputProps,
        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this4.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this4.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.resetHighlightedSuggestionOnMouseLeave = function () {
    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this4.onSuggestionMouseEnter,
      onMouseLeave: _this4.resetHighlightedSuggestionOnMouseLeave,
      onMouseDown: _this4.onSuggestionMouseDown,
      onTouchStart: _this4.onSuggestionMouseDown, // Because on iOS `onMouseDown` is not triggered
      onClick: _this4.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this4.getQuery()
    });
  };
};

exports.default = Autosuggest;

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(848).default;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sectionIterator = __webpack_require__(849);

var _sectionIterator2 = _interopRequireDefault(_sectionIterator);

var _reactThemeable = __webpack_require__(850);

var _reactThemeable2 = _interopRequireDefault(_reactThemeable);

var _SectionTitle = __webpack_require__(852);

var _SectionTitle2 = _interopRequireDefault(_SectionTitle);

var _ItemsList = __webpack_require__(853);

var _ItemsList2 = _interopRequireDefault(_ItemsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck(this, Autowhatever);

    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = 'react-autowhatever-' + id;
      var containerProps = _extends({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'));
      var inputComponent = renderInputComponent(_extends({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends({
          id: itemsContainerId,
          role: 'listbox'
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(_react.Component);

Autowhatever.propTypes = {
  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2.default.func, // This function renders a single item.
  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  inputProps: _propTypes2.default.object, // Arbitrary input props
  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
  _propTypes2.default.object, _propTypes2.default.func]),
  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2.default.object, _propTypes2.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
exports.default = Autowhatever;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__(851);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(313);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(_react.Component);

SectionTitle.propTypes = {
  section: _propTypes2.default.any.isRequired,
  renderSectionTitle: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  sectionKeyPrefix: _propTypes2.default.string.isRequired
};
exports.default = SectionTitle;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(854);

var _Item2 = _interopRequireDefault(_Item);

var _compareObjects = __webpack_require__(313);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2.default.createElement(
        'ul',
        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends({
            id: getItemId(sectionIndex, itemIndex),
            'aria-selected': isHighlighted
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(_react.Component);

ItemsList.propTypes = {
  items: _propTypes2.default.array.isRequired,
  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  sectionIndex: _propTypes2.default.number,
  highlightedItemIndex: _propTypes2.default.number,
  onHighlightedItemChange: _propTypes2.default.func.isRequired,
  getItemId: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  keyPrefix: _propTypes2.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
exports.default = ItemsList;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(313);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2.default.createElement(
        'li',
        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  sectionIndex: _propTypes2.default.number,
  isHighlighted: _propTypes2.default.bool.isRequired,
  itemIndex: _propTypes2.default.number.isRequired,
  item: _propTypes2.default.any.isRequired,
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};
exports.default = Item;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = exports.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var LayoutBox=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('LayoutBox',{key:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (LayoutBox);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationMegaMenuBanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ad_BannerSlider__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationMegaMenuBanner=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationMegaMenuBanner,_Component);function NavigationMegaMenuBanner(){_classCallCheck(this,NavigationMegaMenuBanner);return _possibleConstructorReturn(this,(NavigationMegaMenuBanner.__proto__||Object.getPrototypeOf(NavigationMegaMenuBanner)).apply(this,arguments));}_createClass(NavigationMegaMenuBanner,[{key:'render',value:function render(){var _props=this.props,className=_props.className,searchParams=_props.searchParams;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ad_BannerSlider__["a" /* default */],{searchParams:Object.assign({bannerZone:__WEBPACK_IMPORTED_MODULE_4__types_AdZones__["a" /* default */].MEGA_MENU_BANNER},searchParams),className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(className),aspectRatio:6.85,maximumCrossAxisSize:200});}}]);return NavigationMegaMenuBanner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationMegaMenuBanner.propTypes={className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,searchParams:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (NavigationMegaMenuBanner);

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(859),
    createCompounder = __webpack_require__(864);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(108),
    upperFirst = __webpack_require__(860);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(861);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(460),
    hasUnicode = __webpack_require__(234),
    stringToArray = __webpack_require__(461),
    toString = __webpack_require__(108);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 862 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(865),
    deburr = __webpack_require__(866),
    words = __webpack_require__(869);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 865 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(867),
    toString = __webpack_require__(108);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(868);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 868 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(870),
    hasUnicodeWord = __webpack_require__(871),
    toString = __webpack_require__(108),
    unicodeWords = __webpack_require__(872);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 870 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 871 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 872 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Banner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Ad__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_MaybeExternalLink__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__product_ProductId__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__product_ProductPrice__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__product_ProductSigns__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_ViewBreakpoint__ = __webpack_require__(122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Banner=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Banner,_Component);function Banner(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Banner);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Banner.__proto__||Object.getPrototypeOf(Banner)).call.apply(_ref,[this].concat(args))),_this),_this.sendView=function(){var _this$props=_this.props,analytics=_this$props.analytics,bannerZone=_this$props.bannerZone,banner=_this$props.banner;analytics.promoView([{bannerZone:bannerZone,banner:banner}]);},_this.sendPromotionClick=function(){var _this$props2=_this.props,analytics=_this$props2.analytics,bannerZone=_this$props2.bannerZone,banner=_this$props2.banner;analytics.promotionClick([{bannerZone:bannerZone,banner:banner}]);},_this.renderBannerWrapper=function(){var _this$props3=_this.props,banner=_this$props3.banner,isMobileBanner=_this$props3.isMobileBanner;var bannerWrapper=isMobileBanner?'Banner__wrapper-mobile':'Banner__wrapper';var Wrapper=function Wrapper(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:bannerWrapper},banner.link_url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_MaybeExternalLink__["a" /* default */],{to:banner.link_url},children):children);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,_this.getBannerImage(banner),_this.getBannerOverlay(banner));},_this.getBannerImage=function(banner){return _this.renderImage(banner);},_this.renderImage=function(){var _this$props4=_this.props,banner=_this$props4.banner,isMobileBanner=_this$props4.isMobileBanner;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',null,banner.mobile_image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{media:'(max-width:'+__WEBPACK_IMPORTED_MODULE_11__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].SM+'px)',srcSet:encodeURI(banner.mobile_image)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:isMobileBanner&&banner.mobile_image?'Banner__background-mobile-image':'Banner__background-image',src:banner.image,alt:banner.title}));},_this.getBannerOverlay=function(banner){var title=_this.getBannerTitle(banner);var content=_this.getBannerContent(banner);var priceInformation=_this.getBannerPriceInformation(banner);return(title||content)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Banner__overlay',style:{background:banner.overlay_background_color,color:banner.text_color||undefined}},banner.overlay_image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:banner.overlay_image,alt:banner.title}),_this.getBannerContentWrapper(title,banner,priceInformation,content));},_this.getBannerTitle=function(banner){return banner.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Banner__title'},banner.manufacturer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Banner__manufacturer'},banner.manufacturer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,banner.title));},_this.getBannerContent=function(banner){return banner.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Banner__content'},banner.content);},_this.getBannerPriceInformation=function(banner){return banner.price_info&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Banner__price-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__product_ProductPrice__["a" /* default */],{priceInfo:banner.price_info}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__product_ProductSigns__["a" /* default */],{hasDiscount:banner.price_info.is_discount,dateAdded:banner.date_added,discountProps:{percent:banner.price_info.discount_percentage,withUpTo:false,singlePriceLabel:false}}));},_this.getBannerContentWrapper=function(title,banner,priceInformation,content){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Banner__content_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Banner__texts'},title,banner.product_id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__product_ProductId__["a" /* default */],{id:banner.product_id}),priceInformation,content));},_this.getBannerScent=function(banner){return banner.scent&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Banner__scent',style:{backgroundImage:'url('+banner.scent+')'}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Banner,[{key:'componentWillMount',value:function componentWillMount(){this.sendView();}},{key:'render',value:function render(){var _props=this.props,banner=_props.banner,className=_props.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('Banner',{'Banner--default-width':!banner.image,'Banner--text-color-override':!!banner.text_color},className),onClick:this.sendPromotionClick},this.renderBannerWrapper(),this.getBannerScent(banner));}}]);return Banner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;Banner.propTypes={banner:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_Ad__["a" /* default */]).isRequired,bannerZone:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,analytics:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__analytics_Analytics__["a" /* default */]).isRequired,defaultImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isMobileBanner:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('analytics')(Banner));

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSign__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Discount__ = __webpack_require__(225);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSignDiscount=function(_Component){_inherits(ProductSignDiscount,_Component);function ProductSignDiscount(){_classCallCheck(this,ProductSignDiscount);return _possibleConstructorReturn(this,(ProductSignDiscount.__proto__||Object.getPrototypeOf(ProductSignDiscount)).apply(this,arguments));}_createClass(ProductSignDiscount,[{key:'render',value:function render(){var _props=this.props,percent=_props.percent,withUpTo=_props.withUpTo,singlePriceLabel=_props.singlePriceLabel;if(!percent){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductDiscountPercentageSign'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductSign__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Discount__["a" /* default */],{percentage:percent,withLabel:!withUpTo&&singlePriceLabel,withUpTo:withUpTo})));}}]);return ProductSignDiscount;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ProductSignDiscount.propTypes={percent:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,withUpTo:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,singlePriceLabel:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool};ProductSignDiscount.defaultProps={singlePriceLabel:true};/* harmony default export */ __webpack_exports__["a"] = (ProductSignDiscount);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSign__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSignNew=function(_Component){_inherits(ProductSignNew,_Component);function ProductSignNew(){_classCallCheck(this,ProductSignNew);return _possibleConstructorReturn(this,(ProductSignNew.__proto__||Object.getPrototypeOf(ProductSignNew)).apply(this,arguments));}_createClass(ProductSignNew,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductSignNew'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductSign__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__["a" /* default */].newTitle)));}}]);return ProductSignNew;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProductSignNew);

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(144),
    baseClone = __webpack_require__(308),
    baseUnset = __webpack_require__(464),
    castPath = __webpack_require__(143),
    copyObject = __webpack_require__(184),
    customOmitClone = __webpack_require__(882),
    flatRest = __webpack_require__(884),
    getAllKeysIn = __webpack_require__(310);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(222),
    baseSlice = __webpack_require__(233);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(883);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    getPrototype = __webpack_require__(309),
    isObjectLike = __webpack_require__(90);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(236),
    overRest = __webpack_require__(466),
    setToString = __webpack_require__(467);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(468),
    defineProperty = __webpack_require__(422),
    identity = __webpack_require__(149);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 887 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ITEM_PARAMS */
/* unused harmony export NavigationLinkCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_AdStore__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Slider__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_MaybeExternalLink__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SLIDER_SETTINGS={infinite:true,speed:500,slidesToShow:1,slidesToScroll:1,autoplay:true,autoplaySpeed:5000};var ITEM_PARAMS={bannerZone:__WEBPACK_IMPORTED_MODULE_2__types_AdZones__["a" /* default */].MAIN_TEXT_CAROUSEL};var NavigationLinkCarousel=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationLinkCarousel,_Component);function NavigationLinkCarousel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationLinkCarousel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationLinkCarousel.__proto__||Object.getPrototypeOf(NavigationLinkCarousel)).call.apply(_ref,[this].concat(args))),_this),_this.loadBanners=function(){var adStore=_this.props.adStore;adStore.loadAds(ITEM_PARAMS);},_this.adToLink=function(ad){var Wrapper=function Wrapper(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationLinkCarousel__link'},ad.link_url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_MaybeExternalLink__["a" /* default */],{to:ad.link_url},children):children);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{key:ad.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ad.content}}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationLinkCarousel,[{key:'componentDidMount',value:function componentDidMount(){this.loadBanners();}},{key:'render',value:function render(){var adStore=this.props.adStore;var ads=adStore.adQueries.get(Object(__WEBPACK_IMPORTED_MODULE_3__util_query__["a" /* paramsToQueryIdentifier */])(ITEM_PARAMS));if(!ads||ads.length===0||ads.filter(function(ad){return!!ad.content;}).length===0){return null;}var links=ads.filter(function(ad){return!!ad.content;}).map(this.adToLink);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationLinkCarousel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Slider__["a" /* default */],Object.assign({key:ads.map(function(ad){return ad.id;}).join(',')},SLIDER_SETTINGS),links));}}]);return NavigationLinkCarousel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationLinkCarousel.propTypes={adStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_AdStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('adStore')(NavigationLinkCarousel));

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartOption__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CartNewProduct__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CartProduct__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_ProductTypeClass__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_CartNewProductType__ = __webpack_require__(237);
var CartBasket=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CartOption',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});var Cart=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Cart',{baskets_and_templates:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(CartBasket),expires_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),new_product_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_3__CartNewProduct__["a" /* default */]),number_of_products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,options:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__CartOption__["a" /* default */]),payment_method_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__CartProduct__["a" /* default */]),selected_basket_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),total:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */],total_with_extra_costs:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */]}).views(function(self){return{get getPhysicalProducts(){return self.products.filter(function(product){return product.type===__WEBPACK_IMPORTED_MODULE_5__types_ProductTypeClass__["b" /* default */].PHYSICAL;});},get ifRenderModal(){return self.new_product_info&&self.new_product_info.quantity>0;},get ifRenderErrorModal(){return self.new_product_info&&self.new_product_info.quantity<0&&self.new_product_info.type===__WEBPACK_IMPORTED_MODULE_6__types_CartNewProductType__["b" /* default */].ARRAY;}};});/* harmony default export */ __webpack_exports__["a"] = (Cart);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
var CartOption=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CartOption',{title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */],info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (CartOption);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_CartNewProductType__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Price__ = __webpack_require__(79);
var CartNewProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CartNewProduct',{type:__WEBPACK_IMPORTED_MODULE_1__types_CartNewProductType__["a" /* CartNewProductTypeType */],quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),stock_unit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),manufacturer:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2__Price__["a" /* default */]),variations:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string))});/* harmony default export */ __webpack_exports__["a"] = (CartNewProduct);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__ = __webpack_require__(100);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var CartProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CartProduct',{category_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),final_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,package_size:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,short_description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),starting_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,stock_unit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),total_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,type:__WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__["a" /* ProductType */],variations:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string))}).preProcessSnapshot(function(_ref){var quantity=_ref.quantity,rest=_objectWithoutProperties(_ref,['quantity']);return Object.assign({quantity:Number(quantity)},rest);});/* harmony default export */ __webpack_exports__["a"] = (CartProduct);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var MarkerBadge=function MarkerBadge(_ref){var className=_ref.className,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('MarkerBadge',className)},children);};/* harmony default export */ __webpack_exports__["a"] = (MarkerBadge);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationCartPopover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_CartNewProductType__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__models_ProductImage__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var POPOVER_DURATION=3*1000;var NavigationCartPopover=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationCartPopover,_Component);function NavigationCartPopover(props){_classCallCheck(this,NavigationCartPopover);var _this=_possibleConstructorReturn(this,(NavigationCartPopover.__proto__||Object.getPrototypeOf(NavigationCartPopover)).call(this,props));_this.handleNewNotification=function(){if(_this.timer){clearTimeout(_this.timer);}_this.setState({isOpen:true});_this.props.uiStore.togglePopover(true);_this.timer=setTimeout(function(){_this.setState({isOpen:false});_this.props.uiStore.togglePopover(false);},POPOVER_DURATION);};_this.getProductPrice=function(){var _this$props=_this.props,accountStore=_this$props.accountStore,currencyStore=_this$props.currencyStore;var new_product_info=_this.props.cartStore.cart.new_product_info;if(new_product_info.type===__WEBPACK_IMPORTED_MODULE_16__types_CartNewProductType__["b" /* default */].ARRAY||!new_product_info.price){return null;}var withTax=accountStore.showPricesWithTax;var showTaxExcludedInfo=!withTax;var showUnit=!!new_product_info.stock_unit;var totalPrice=new_product_info.quantity*Object(__WEBPACK_IMPORTED_MODULE_14__util_number__["e" /* roundWithPrecision */])(new_product_info.price.getPrice(withTax),currencyStore.activeCurrency?currencyStore.activeCurrency.precision:2);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,totalPrice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__product_Price__["a" /* default */],{price:totalPrice,showTaxExcludedInfo:showTaxExcludedInfo}),totalPrice&&showUnit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CartModal__stock-unit'},' ','/ ',new_product_info.stock_unit));};_this.renderCartTotal=function(){var _this$props2=_this.props,cartStore=_this$props2.cartStore,accountStore=_this$props2.accountStore;var withTax=accountStore.showPricesWithTax;var price=withTax?cartStore.cart.total.with_tax:cartStore.cart.total.without_tax;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'NavigationCartPopover__cart-details mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block NavigationCartPopover__cart-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cart.itemsInCart',defaultMessage:'{itemCount} in cart.',values:{itemCount:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'global.itemCount',values:{count:cartStore.cart.number_of_products}})}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block NavigationCartPopover__cart-total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].totalPriceSentence),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__product_Price__["a" /* default */],{price:price}))));};_this.createProductImage=function(url){return url?__WEBPACK_IMPORTED_MODULE_17__models_ProductImage__["a" /* default */].create({id:0,product_id:'',sizes:{small:url}}):null;};_this.renderContent=function(){var _this$props3=_this.props,cartStore=_this$props3.cartStore,uiStore=_this$props3.uiStore;var newProductInfo=void 0;if(cartStore.cart){newProductInfo=cartStore.cart.new_product_info;}if(!newProductInfo){return null;}var isBundle=newProductInfo.type===__WEBPACK_IMPORTED_MODULE_16__types_CartNewProductType__["b" /* default */].BUNDLE;var priceText=_this.getProductPrice();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,isBundle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].productBundleAddedToCartSentence):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].productAddedToCartSentence,{values:{quantity:newProductInfo.quantity}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),newProductInfo&&newProductInfo.type!==__WEBPACK_IMPORTED_MODULE_16__types_CartNewProductType__["b" /* default */].ARRAY&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{className:'no-gutters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:3,className:'d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductImage__["a" /* default */],{forceAspectRatio:false,product:newProductInfo,productImage:_this.createProductImage(newProductInfo.image),size:'small',lazyLoading:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:9,className:'NavigationCartPopover__productInfo'},!isBundle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'NavigationCartPopver__quantity'},newProductInfo.quantity,'x'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'NavigationCartPopver__productName',dangerouslySetInnerHTML:{__html:newProductInfo.name}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'NavigationCartPopver__price'},priceText))),uiStore.isMobile&&_this.renderCartTotal());};_this.timer=null;_this.reactionDisposer=null;_this.state={isOpen:false};return _this;}_createClass(NavigationCartPopover,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.reactionDisposer=Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["reaction"])(function(){return _this2.props.cartStore.popoverModal.isOpen;},this.handleNewNotification);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.reactionDisposer();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('NavigationCartPopover',{popoverVisible:this.state.isOpen})},this.renderContent());}}]);return NavigationCartPopover;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationCartPopover.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_AccountStore__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_CartStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_CurrencyStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_UIStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])(function(stores){return{cartStore:stores.cartStore,uiStore:stores.uiStore,currencyStore:stores.currencyStore,accountStore:stores.accountStore,configStore:stores.configStore};})(NavigationCartPopover));

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_it__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_detect_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_cursor_position__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RenderEnlargedImage__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shaded_lens__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hint_DisplayUntilActive__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hint_DefaultHint__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_lens__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_dimensions__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_styles__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__prop_types_Image__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__prop_types_EnlargedImage__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(472);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var ReactImageMagnify = function (_React$Component) {
    _inherits(ReactImageMagnify, _React$Component);

    function ReactImageMagnify(props) {
        _classCallCheck(this, ReactImageMagnify);

        var _this = _possibleConstructorReturn(this, (ReactImageMagnify.__proto__ || Object.getPrototypeOf(ReactImageMagnify)).call(this, props));

        var primaryInput = __WEBPACK_IMPORTED_MODULE_0_detect_it___default.a.primaryInput;
        var MOUSE = __WEBPACK_IMPORTED_MODULE_15__constants__["b" /* INPUT_TYPE */].mouse,
            TOUCH = __WEBPACK_IMPORTED_MODULE_15__constants__["b" /* INPUT_TYPE */].touch;


        _this.state = {
            smallImageWidth: 0,
            smallImageHeight: 0,
            detectedInputType: {
                isMouseDeteced: primaryInput === MOUSE,
                isTouchDetected: primaryInput === TOUCH
            }
        };

        _this.onSmallImageLoad = _this.onSmallImageLoad.bind(_this);
        _this.setSmallImageDimensionState = _this.setSmallImageDimensionState.bind(_this);
        _this.onDetectedInputTypeChanged = _this.onDetectedInputTypeChanged.bind(_this);
        return _this;
    }

    _createClass(ReactImageMagnify, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isFluidWidth = this.props.smallImage.isFluidWidth;


            if (!isFluidWidth) {
                return;
            }

            this.setSmallImageDimensionState();
            window.addEventListener('resize', this.setSmallImageDimensionState);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.setSmallImageDimensionState);
        }
    }, {
        key: 'onSmallImageLoad',
        value: function onSmallImageLoad(e) {
            var _props$smallImage$onL = this.props.smallImage.onLoad,
                onLoad = _props$smallImage$onL === undefined ? __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* noop */] : _props$smallImage$onL;


            onLoad(e);

            if (!this.props.smallImage.isFluidWidth) {
                return;
            }

            this.setSmallImageDimensionState();
        }
    }, {
        key: 'onDetectedInputTypeChanged',
        value: function onDetectedInputTypeChanged(detectedInputType) {
            this.setState({
                detectedInputType: detectedInputType
            });
        }
    }, {
        key: 'setSmallImageDimensionState',
        value: function setSmallImageDimensionState() {
            var _smallImageEl = this.smallImageEl,
                smallImageWidth = _smallImageEl.offsetWidth,
                smallImageHeight = _smallImageEl.offsetHeight;


            this.setState({
                smallImageWidth: smallImageWidth,
                smallImageHeight: smallImageHeight
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                style = _props.style,
                hoverDelayInMs = _props.hoverDelayInMs,
                hoverOffDelayInMs = _props.hoverOffDelayInMs,
                isActivatedOnTouch = _props.isActivatedOnTouch,
                pressDuration = _props.pressDuration,
                pressMoveThreshold = _props.pressMoveThreshold,
                _props$smallImage$onE = _props.smallImage.onError,
                onError = _props$smallImage$onE === undefined ? __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* noop */] : _props$smallImage$onE,
                imageClassName = _props.imageClassName,
                imageStyle = _props.imageStyle,
                lensStyle = _props.lensStyle,
                largeImage = _props.largeImage,
                enlargedImageContainerClassName = _props.enlargedImageContainerClassName,
                enlargedImageContainerStyle = _props.enlargedImageContainerStyle,
                enlargedImageClassName = _props.enlargedImageClassName,
                enlargedImageStyle = _props.enlargedImageStyle,
                enlargedImagePortalId = _props.enlargedImagePortalId,
                isEnlargedImagePortalEnabledForTouch = _props.isEnlargedImagePortalEnabledForTouch,
                fadeDurationInMs = _props.fadeDurationInMs,
                HintComponent = _props.hintComponent,
                isHintEnabled = _props.isHintEnabled,
                hintTextMouse = _props.hintTextMouse,
                hintTextTouch = _props.hintTextTouch,
                shouldHideHintAfterFirstActivation = _props.shouldHideHintAfterFirstActivation;


            var smallImage = this.smallImage;

            var isTouchDetected = this.state.detectedInputType.isTouchDetected;


            var cursorOffset = Object(__WEBPACK_IMPORTED_MODULE_9__lib_lens__["a" /* getLensCursorOffset */])(smallImage, largeImage, this.enlargedImageContainerDimensions);

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_cursor_position__["a" /* default */],
                {
                    className: className,
                    hoverDelayInMs: hoverDelayInMs,
                    hoverOffDelayInMs: hoverOffDelayInMs,
                    isActivatedOnTouch: isActivatedOnTouch,
                    onDetectedInputTypeChanged: this.onDetectedInputTypeChanged,
                    pressDuration: pressDuration,
                    pressMoveThreshold: pressMoveThreshold,
                    shouldStopTouchMovePropagation: true,
                    style: Object(__WEBPACK_IMPORTED_MODULE_11__lib_styles__["a" /* getContainerStyle */])(smallImage, style)
                },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img', {
                    src: smallImage.src,
                    srcSet: smallImage.srcSet,
                    sizes: smallImage.sizes,
                    alt: smallImage.alt,
                    className: imageClassName,
                    style: Object(__WEBPACK_IMPORTED_MODULE_11__lib_styles__["d" /* getSmallImageStyle */])(smallImage, imageStyle),
                    ref: function ref(el) {
                        return _this2.smallImageEl = el;
                    },
                    onLoad: this.onSmallImageLoad,
                    onError: onError
                }),
                isHintEnabled && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__hint_DisplayUntilActive__["a" /* default */],
                    {
                        shouldHideAfterFirstActivation: shouldHideHintAfterFirstActivation
                    },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(HintComponent, {
                        isTouchDetected: isTouchDetected,
                        hintTextMouse: hintTextMouse,
                        hintTextTouch: hintTextTouch
                    })
                ),
                this.shouldShowLens && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shaded_lens__["a" /* default */], {
                    cursorOffset: cursorOffset,
                    fadeDurationInMs: fadeDurationInMs,
                    enlargedImageContainerDimensions: this.enlargedImageContainerDimensions,
                    smallImage: smallImage,
                    style: lensStyle
                }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RenderEnlargedImage__["a" /* default */], {
                    containerClassName: enlargedImageContainerClassName,
                    containerDimensions: this.enlargedImageContainerDimensions,
                    containerStyle: enlargedImageContainerStyle,
                    cursorOffset: cursorOffset,
                    fadeDurationInMs: fadeDurationInMs,
                    imageClassName: enlargedImageClassName,
                    imageStyle: enlargedImageStyle,
                    largeImage: largeImage,
                    smallImage: smallImage,
                    portalId: enlargedImagePortalId,
                    isPortalEnabledForTouch: isEnlargedImagePortalEnabledForTouch,
                    isTouchDetected: this.isTouchDetected,
                    isInPlaceMode: this.isInPlaceMode
                })
            );
        }
    }, {
        key: 'smallImage',
        get: function get() {
            var _props2 = this.props,
                smallImage = _props2.smallImage,
                isFluidWidth = _props2.smallImage.isFluidWidth;


            if (!isFluidWidth) {
                return smallImage;
            }

            var _state = this.state,
                fluidWidth = _state.smallImageWidth,
                fluidHeight = _state.smallImageHeight;


            return __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({}, smallImage, {
                width: fluidWidth,
                height: fluidHeight
            });
        }
    }, {
        key: 'enlargedImagePlacement',
        get: function get() {
            var userDefinedEnlargedImagePosition = this.props.enlargedImagePosition;
            var isTouchDetected = this.state.detectedInputType.isTouchDetected;


            var computedEnlargedImagePosition = isTouchDetected ? __WEBPACK_IMPORTED_MODULE_15__constants__["a" /* ENLARGED_IMAGE_POSITION */].over : __WEBPACK_IMPORTED_MODULE_15__constants__["a" /* ENLARGED_IMAGE_POSITION */].beside;

            return userDefinedEnlargedImagePosition || computedEnlargedImagePosition;
        }
    }, {
        key: 'isInPlaceMode',
        get: function get() {
            var OVER = __WEBPACK_IMPORTED_MODULE_15__constants__["a" /* ENLARGED_IMAGE_POSITION */].over;

            return this.enlargedImagePlacement === OVER;
        }
    }, {
        key: 'enlargedImageContainerDimensions',
        get: function get() {
            var _props$enlargedImageC = this.props.enlargedImageContainerDimensions,
                containerWidth = _props$enlargedImageC.width,
                containerHeight = _props$enlargedImageC.height;
            var _smallImage = this.smallImage,
                smallImageWidth = _smallImage.width,
                smallImageHeight = _smallImage.height;

            var isInPlaceMode = this.isInPlaceMode;

            return {
                width: Object(__WEBPACK_IMPORTED_MODULE_10__lib_dimensions__["a" /* getEnlargedImageContainerDimension */])({
                    containerDimension: containerWidth,
                    smallImageDimension: smallImageWidth,
                    isInPlaceMode: isInPlaceMode
                }),
                height: Object(__WEBPACK_IMPORTED_MODULE_10__lib_dimensions__["a" /* getEnlargedImageContainerDimension */])({
                    containerDimension: containerHeight,
                    smallImageDimension: smallImageHeight,
                    isInPlaceMode: isInPlaceMode
                })
            };
        }
    }, {
        key: 'isTouchDetected',
        get: function get() {
            var isTouchDetected = this.state.detectedInputType.isTouchDetected;


            return isTouchDetected;
        }
    }, {
        key: 'shouldShowLens',
        get: function get() {
            return !this.isInPlaceMode && !this.isTouchDetected;
        }
    }]);

    return ReactImageMagnify;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ReactImageMagnify.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    hoverDelayInMs: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    hoverOffDelayInMs: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    fadeDurationInMs: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    pressDuration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    pressMoveThreshold: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    isActivatedOnTouch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    imageClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    imageStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    lensStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    smallImage: __WEBPACK_IMPORTED_MODULE_12__prop_types_Image__["b" /* SmallImageShape */],
    largeImage: __WEBPACK_IMPORTED_MODULE_12__prop_types_Image__["a" /* LargeImageShape */],
    enlargedImageContainerClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    enlargedImageContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    enlargedImageClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    enlargedImageStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    enlargedImageContainerDimensions: __WEBPACK_IMPORTED_MODULE_13__prop_types_EnlargedImage__["b" /* EnlargedImageContainerDimensions */],
    enlargedImagePosition: __WEBPACK_IMPORTED_MODULE_13__prop_types_EnlargedImage__["c" /* EnlargedImagePosition */],
    enlargedImagePortalId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    isEnlargedImagePortalEnabledForTouch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    hintComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    hintTextMouse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    hintTextTouch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    isHintEnabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    shouldHideHintAfterFirstActivation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
ReactImageMagnify.defaultProps = {
    enlargedImageContainerDimensions: {
        width: '100%',
        height: '100%'
    },
    isEnlargedImagePortalEnabledForTouch: false,
    fadeDurationInMs: 300,
    hintComponent: __WEBPACK_IMPORTED_MODULE_8__hint_DefaultHint__["a" /* default */],
    shouldHideHintAfterFirstActivation: true,
    isHintEnabled: false,
    hintTextMouse: 'Hover to Zoom',
    hintTextTouch: 'Long-Touch to Zoom',
    hoverDelayInMs: 250,
    hoverOffDelayInMs: 150
};


/* harmony default export */ __webpack_exports__["a"] = (ReactImageMagnify);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _detectHover = __webpack_require__(897);

var _detectHover2 = _interopRequireDefault(_detectHover);

var _detectPointer = __webpack_require__(898);

var _detectPointer2 = _interopRequireDefault(_detectPointer);

var _detectTouchEvents = __webpack_require__(899);

var _detectTouchEvents2 = _interopRequireDefault(_detectTouchEvents);

var _detectPassiveEvents = __webpack_require__(900);

var _detectPassiveEvents2 = _interopRequireDefault(_detectPassiveEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * detectIt object structure
 * const detectIt = {
 *   deviceType: 'mouseOnly' / 'touchOnly' / 'hybrid',
 *   passiveEvents: boolean,
 *   hasTouch: boolean,
 *   hasMouse: boolean,
 *   maxTouchPoints: number,
 *   primaryHover: 'hover' / 'none',
 *   primaryPointer: 'fine' / 'coarse' / 'none',
 *   state: {
 *     detectHover,
 *     detectPointer,
 *     detectTouchEvents,
 *     detectPassiveEvents,
 *   },
 *   update() {...},
 * }
 */

function determineDeviceType(hasTouch, anyHover, anyFine, state) {
  // A hybrid device is one that both hasTouch and any input device can hover
  // or has a fine pointer.
  if (hasTouch && (anyHover || anyFine)) return 'hybrid';

  // workaround for browsers that have the touch events api,
  // and have implemented Level 4 media queries but not the
  // hover and pointer media queries, so the tests are all false (notable Firefox)
  // if it hasTouch, no pointer and hover support, and on an android assume it's touchOnly
  // if it hasTouch, no pointer and hover support, and not on an android assume it's a hybrid
  if (hasTouch && Object.keys(state.detectHover).filter(function (key) {
    return key !== 'update';
  }).every(function (key) {
    return state.detectHover[key] === false;
  }) && Object.keys(state.detectPointer).filter(function (key) {
    return key !== 'update';
  }).every(function (key) {
    return state.detectPointer[key] === false;
  })) {
    if (window.navigator && /android/.test(window.navigator.userAgent.toLowerCase())) {
      return 'touchOnly';
    }
    return 'hybrid';
  }

  // In almost all cases a device that doesn’t support touch will have a mouse,
  // but there may be rare exceptions. Note that it doesn’t work to do additional tests
  // based on hover and pointer media queries as older browsers don’t support these.
  // Essentially, 'mouseOnly' is the default.
  return hasTouch ? 'touchOnly' : 'mouseOnly';
}

var detectIt = {
  state: {
    detectHover: _detectHover2.default,
    detectPointer: _detectPointer2.default,
    detectTouchEvents: _detectTouchEvents2.default,
    detectPassiveEvents: _detectPassiveEvents2.default
  },
  update: function update() {
    detectIt.state.detectHover.update();
    detectIt.state.detectPointer.update();
    detectIt.state.detectTouchEvents.update();
    detectIt.state.detectPassiveEvents.update();
    detectIt.updateOnlyOwnProperties();
  },
  updateOnlyOwnProperties: function updateOnlyOwnProperties() {
    if (typeof window !== 'undefined') {
      detectIt.passiveEvents = detectIt.state.detectPassiveEvents.hasSupport || false;

      detectIt.hasTouch = detectIt.state.detectTouchEvents.hasSupport || false;

      detectIt.deviceType = determineDeviceType(detectIt.hasTouch, detectIt.state.detectHover.anyHover, detectIt.state.detectPointer.anyFine, detectIt.state);

      detectIt.hasMouse = detectIt.deviceType !== 'touchOnly';

      detectIt.primaryInput = detectIt.deviceType === 'mouseOnly' && 'mouse' || detectIt.deviceType === 'touchOnly' && 'touch' ||
      // deviceType is hybrid:
      detectIt.state.detectHover.hover && 'mouse' || detectIt.state.detectHover.none && 'touch' ||
      // if there's no support for hover media queries but detectIt determined it's
      // a hybrid  device, then assume it's a mouse first device
      'mouse';

      // issue with Windows Chrome on hybrid devices starting in version 59 where
      // media queries represent a touch only device, so if the browser is an
      // affected Windows Chrome version and hasTouch,
      // then assume it's a hybrid with primaryInput mouse
      // see https://github.com/rafrex/detect-it/issues/8
      var isAffectedWindowsChromeVersion = /windows/.test(window.navigator.userAgent.toLowerCase()) && /chrome/.test(window.navigator.userAgent.toLowerCase()) && parseInt(/Chrome\/([0-9.]+)/.exec(navigator.userAgent)[1], 10) >= 59;

      if (isAffectedWindowsChromeVersion && detectIt.hasTouch) {
        detectIt.deviceType = 'hybrid';
        detectIt.hasMouse = true;
        detectIt.primaryInput = 'mouse';
      }
    }
  }
};

detectIt.updateOnlyOwnProperties();
exports.default = detectIt;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var detectHover = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      detectHover.hover = window.matchMedia('(hover: hover)').matches;
      detectHover.none = window.matchMedia('(hover: none)').matches || window.matchMedia('(hover: on-demand)').matches;
      detectHover.anyHover = window.matchMedia('(any-hover: hover)').matches;
      detectHover.anyNone = window.matchMedia('(any-hover: none)').matches || window.matchMedia('(any-hover: on-demand)').matches;
    }
  }
};

detectHover.update();
exports.default = detectHover;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var detectPointer = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      detectPointer.fine = window.matchMedia('(pointer: fine)').matches;
      detectPointer.coarse = window.matchMedia('(pointer: coarse)').matches;
      detectPointer.none = window.matchMedia('(pointer: none)').matches;
      detectPointer.anyFine = window.matchMedia('(any-pointer: fine)').matches;
      detectPointer.anyCoarse = window.matchMedia('(any-pointer: coarse)').matches;
      detectPointer.anyNone = window.matchMedia('(any-pointer: none)').matches;
    }
  }
};

detectPointer.update();
exports.default = detectPointer;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var detectTouchEvents = {
  update: function update() {
    if (typeof window !== 'undefined') {
      detectTouchEvents.hasSupport = 'ontouchstart' in window;
      detectTouchEvents.browserSupportsApi = Boolean(window.TouchEvent);
    }
  }
};

detectTouchEvents.update();
exports.default = detectTouchEvents;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var detectPassiveEvents = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      var passive = false;
      var options = Object.defineProperty({}, 'passive', {
        get: function get() {
          passive = true;
        }
      });
      // note: have to set and remove a no-op listener instead of null
      // (which was used previously), becasue Edge v15 throws an error
      // when providing a null callback.
      // https://github.com/rafrex/detect-passive-events/pull/3
      var noop = function noop() {};
      window.addEventListener('testPassiveEventSupport', noop, options);
      window.removeEventListener('testPassiveEventSupport', noop, options);
      detectPassiveEvents.hasSupport = passive;
    }
  }
};

detectPassiveEvents.update();
exports.default = detectPassiveEvents;

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_omit__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_addEventListener__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_noop__ = __webpack_require__(908);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _this.state = {
            detectedEnvironment: {
                isMouseDetected: false,
                isTouchDetected: false
            },
            elementDimensions: {
                width: 0,
                height: 0
            },
            isActive: false,
            isPositionOutside: true,
            position: {
                x: 0,
                y: 0
            }
        };

        _this.shouldGuardAgainstMouseEmulationByDevices = false;
        _this.eventListeners = [];
        _this.timers = [];
        _this.elementOffset = {
            x: 0,
            y: 0
        };

        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.onTouchCancel = _this.onTouchCancel.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        return _this;
    }

    _createClass(_class, [{
        key: 'onTouchStart',
        value: function onTouchStart(e) {
            var position = this.getDocumentRelativePosition(this.getTouchEvent(e));

            this.init();
            this.onTouchDetected();
            this.setShouldGuardAgainstMouseEmulationByDevices();
            this.setPositionState(position);

            if (this.props.isActivatedOnTouch) {
                e.preventDefault();
                this.activate();
                return;
            }

            this.initPressEventCriteria(position);
            this.setPressEventTimer();
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(e) {
            var position = this.getDocumentRelativePosition(this.getTouchEvent(e));

            if (!this.state.isActive) {
                this.setPressEventCriteria(position);
                return;
            }

            this.setPositionState(position);
            e.preventDefault();

            if (this.props.shouldStopTouchMovePropagation) {
                e.stopPropagation();
            }
        }
    }, {
        key: 'onTouchEnd',
        value: function onTouchEnd() {
            this.deactivate();
            this.unsetShouldGuardAgainstMouseEmulationByDevices();
        }
    }, {
        key: 'onTouchCancel',
        value: function onTouchCancel() {
            this.deactivate();
            this.unsetShouldGuardAgainstMouseEmulationByDevices();
        }
    }, {
        key: 'onMouseEnter',
        value: function onMouseEnter(e) {
            if (this.shouldGuardAgainstMouseEmulationByDevices) {
                return;
            }

            this.init();
            this.onMouseDetected();
            this.setPositionState(this.getDocumentRelativePosition(e));
            this.clearActivationTimers();
            this.schedulActivation(this.props.hoverDelayInMs);
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove(e) {
            this.setPositionState(this.getDocumentRelativePosition(e));
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave() {
            this.clearActivationTimers();
            this.scheduleDeactivation(this.props.hoverOffDelayInMs);
            this.setState({ isPositionOutside: true });
        }
    }, {
        key: 'onTouchDetected',
        value: function onTouchDetected() {
            var environment = {
                isTouchDetected: true,
                isMouseDetected: false
            };

            this.setState({ detectedEnvironment: environment });
            this.props.onDetectedEnvironmentChanged(environment);
        }
    }, {
        key: 'onMouseDetected',
        value: function onMouseDetected() {
            var environment = {
                isTouchDetected: false,
                isMouseDetected: true
            };

            this.setState({ detectedEnvironment: environment });
            this.props.onDetectedEnvironmentChanged(environment);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isEnabled) {
                this.enable();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var willBeEnabled = _ref.isEnabled;
            var isEnabled = this.props.isEnabled;

            var isEnabledWillChange = isEnabled !== willBeEnabled;

            if (!isEnabledWillChange) {
                return;
            }

            if (willBeEnabled) {
                this.enable();
            } else {
                this.disable();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimers();
            this.disable();
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.addEventListeners();
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.removeEventListeners();
        }
    }, {
        key: 'init',
        value: function init() {
            var _getDocumentRelativeE = this.getDocumentRelativeElementOffset(this.el),
                x = _getDocumentRelativeE.x,
                y = _getDocumentRelativeE.y,
                w = _getDocumentRelativeE.w,
                h = _getDocumentRelativeE.h;

            this.elementOffset = { x: x, y: y };
            this.setElementDimensionsState({ width: w, height: h });
        }
    }, {
        key: 'activate',
        value: function activate() {
            this.setState({ isActive: true });
            this.props.onActivationChanged({ isActive: true });
        }
    }, {
        key: 'deactivate',
        value: function deactivate() {
            var _this2 = this;

            this.clearTimer(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* PRESS_EVENT_TIMER_NAME */]);

            this.setState({ isActive: false }, function () {
                var _state = _this2.state,
                    isPositionOutside = _state.isPositionOutside,
                    position = _state.position;


                _this2.props.onPositionChanged({
                    isPositionOutside: isPositionOutside,
                    position: position
                });

                _this2.props.onActivationChanged({ isActive: false });
            });
        }
    }, {
        key: 'setPositionState',
        value: function setPositionState(position) {
            var _this3 = this;

            var offsetPosition = this.getOffsetPosition(position);
            var isPositionOutside = this.getIsPositionOutside(position);

            this.setState({
                isPositionOutside: isPositionOutside,
                position: offsetPosition
            }, function () {
                _this3.triggerOnPositionChanged();
            });
        }
    }, {
        key: 'setElementDimensionsState',
        value: function setElementDimensionsState(dimensions) {
            this.setState({
                elementDimensions: dimensions
            });
        }
    }, {
        key: 'schedulActivation',
        value: function schedulActivation(schedule) {
            var _this4 = this;

            var scheduleId = setTimeout(function () {
                _this4.activate();
            }, schedule);

            this.timers.push({
                id: scheduleId,
                name: __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* SET_ACTIVATION_TIMER_NAME */]
            });
        }
    }, {
        key: 'scheduleDeactivation',
        value: function scheduleDeactivation(schedule) {
            var _this5 = this;

            var scheduleId = setTimeout(function () {
                _this5.deactivate();
            }, schedule);

            this.timers.push({
                id: scheduleId,
                name: __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* UNSET_ACTIVATION_TIMER_NAME */]
            });
        }
    }, {
        key: 'clearActivationTimers',
        value: function clearActivationTimers() {
            this.clearTimer(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* SET_ACTIVATION_TIMER_NAME */]);
            this.clearTimer(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* UNSET_ACTIVATION_TIMER_NAME */]);
        }
    }, {
        key: 'setPressEventTimer',
        value: function setPressEventTimer() {
            var _this6 = this;

            var _props = this.props,
                pressDuration = _props.pressDuration,
                pressMoveThreshold = _props.pressMoveThreshold;


            this.timers.push({
                name: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* PRESS_EVENT_TIMER_NAME */],
                id: setTimeout(function () {
                    if (Math.abs(_this6.currentElTop - _this6.initialElTop) < pressMoveThreshold) {
                        _this6.activate();
                    }
                }, pressDuration)
            });
        }
    }, {
        key: 'setPressEventCriteria',
        value: function setPressEventCriteria(position) {
            this.currentElTop = position.y;
        }
    }, {
        key: 'initPressEventCriteria',
        value: function initPressEventCriteria(position) {
            var top = position.y;
            this.initialElTop = top;
            this.currentElTop = top;
        }
    }, {
        key: 'setShouldGuardAgainstMouseEmulationByDevices',
        value: function setShouldGuardAgainstMouseEmulationByDevices() {
            this.shouldGuardAgainstMouseEmulationByDevices = true;
        }
    }, {
        key: 'unsetShouldGuardAgainstMouseEmulationByDevices',
        value: function unsetShouldGuardAgainstMouseEmulationByDevices() {
            var _this7 = this;

            this.timers.push({
                name: __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* MOUSE_EMULATION_GUARD_TIMER_NAME */],
                id: setTimeout(function () {
                    _this7.shouldGuardAgainstMouseEmulationByDevices = false;
                }, 0)
            });
        }
    }, {
        key: 'clearTimers',
        value: function clearTimers() {
            var timers = this.timers;
            while (timers.length) {
                var timer = timers.pop();
                clearTimeout(timer.id);
            }
        }
    }, {
        key: 'clearTimer',
        value: function clearTimer(timerName) {
            this.timers.forEach(function (timer) {
                if (timer.name === timerName) {
                    clearTimeout(timer.id);
                }
            });
        }
    }, {
        key: 'getIsPositionOutside',
        value: function getIsPositionOutside(position) {
            var x = position.x,
                y = position.y;
            var _elementOffset = this.elementOffset,
                elx = _elementOffset.x,
                ely = _elementOffset.y;
            var _state$elementDimensi = this.state.elementDimensions,
                elw = _state$elementDimensi.width,
                elh = _state$elementDimensi.height;


            return x < elx || x > elx + elw || y < ely || y > ely + elh;
        }
    }, {
        key: 'getOffsetPosition',
        value: function getOffsetPosition(position) {
            var cursorX = position.x,
                cursorY = position.y;
            var _elementOffset2 = this.elementOffset,
                offsetX = _elementOffset2.x,
                offsetY = _elementOffset2.y;


            return {
                x: cursorX - offsetX,
                y: cursorY - offsetY
            };
        }
    }, {
        key: 'getDocumentRelativeElementOffset',
        value: function getDocumentRelativeElementOffset(el) {
            var rootEl = this.getRootOfEl(el);

            var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
                docLeft = _rootEl$getBoundingCl.left,
                docTop = _rootEl$getBoundingCl.top;

            var _el$getBoundingClient = el.getBoundingClientRect(),
                elLeft = _el$getBoundingClient.left,
                elTop = _el$getBoundingClient.top,
                w = _el$getBoundingClient.width,
                h = _el$getBoundingClient.height;

            return {
                x: Math.abs(docLeft) + elLeft,
                y: Math.abs(docTop) + elTop,
                h: h,
                w: w
            };
        }
    }, {
        key: 'getRootOfEl',
        value: function getRootOfEl(el) {
            if (el.parentElement) {
                return this.getRootOfEl(el.parentElement);
            }
            return el;
        }
    }, {
        key: 'getDocumentRelativePosition',
        value: function getDocumentRelativePosition(event) {
            return {
                x: event.pageX,
                y: event.pageY
            };
        }
    }, {
        key: 'getTouchEvent',
        value: function getTouchEvent(e) {
            return e.touches[0];
        }
    }, {
        key: 'triggerOnPositionChanged',
        value: function triggerOnPositionChanged() {
            this.props.onPositionChanged(__WEBPACK_IMPORTED_MODULE_3_object_omit___default()(this.state, 'isActive'));
        }
    }, {
        key: 'isReactComponent',
        value: function isReactComponent(reactElement) {
            return typeof reactElement.type === 'function';
        }
    }, {
        key: 'shouldDecorateChild',
        value: function shouldDecorateChild(child) {
            return !!child && this.isReactComponent(child) && this.props.shouldDecorateChildren;
        }
    }, {
        key: 'decorateChild',
        value: function decorateChild(child, props) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, props);
        }
    }, {
        key: 'decorateChildren',
        value: function decorateChildren(children, props) {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
                return _this8.shouldDecorateChild(child) ? _this8.decorateChild(child, props) : child;
            });
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.eventListeners.push(Object(__WEBPACK_IMPORTED_MODULE_4__utils_addEventListener__["a" /* default */])(this.el, 'touchstart', this.onTouchStart, { passive: false }), Object(__WEBPACK_IMPORTED_MODULE_4__utils_addEventListener__["a" /* default */])(this.el, 'touchmove', this.onTouchMove, { passive: false }), Object(__WEBPACK_IMPORTED_MODULE_4__utils_addEventListener__["a" /* default */])(this.el, 'touchend', this.onTouchEnd), Object(__WEBPACK_IMPORTED_MODULE_4__utils_addEventListener__["a" /* default */])(this.el, 'touchcancel', this.onTouchCancel), Object(__WEBPACK_IMPORTED_MODULE_4__utils_addEventListener__["a" /* default */])(this.el, 'mouseenter', this.onMouseEnter), Object(__WEBPACK_IMPORTED_MODULE_4__utils_addEventListener__["a" /* default */])(this.el, 'mousemove', this.onMouseMove), Object(__WEBPACK_IMPORTED_MODULE_4__utils_addEventListener__["a" /* default */])(this.el, 'mouseleave', this.onMouseLeave));
        }
    }, {
        key: 'removeEventListeners',
        value: function removeEventListeners() {
            while (this.eventListeners.length) {
                this.eventListeners.pop().removeEventListener();
            }
        }
    }, {
        key: 'getPassThroughProps',
        value: function getPassThroughProps() {
            var ownPropNames = Object.keys(this.constructor.propTypes);
            return __WEBPACK_IMPORTED_MODULE_3_object_omit___default()(this.props, ownPropNames);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this9 = this;

            var _props2 = this.props,
                children = _props2.children,
                className = _props2.className,
                mapChildProps = _props2.mapChildProps,
                style = _props2.style;

            var props = __WEBPACK_IMPORTED_MODULE_2_object_assign___default()({}, mapChildProps(this.state), this.getPassThroughProps());

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: className,
                    ref: function ref(el) {
                        return _this9.el = el;
                    },
                    style: __WEBPACK_IMPORTED_MODULE_2_object_assign___default()({}, style, {
                        WebkitUserSelect: 'none'
                    })
                },
                this.decorateChildren(children, props)
            );
        }
    }]);

    return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

_class.displayName = 'ReactCursorPosition';
_class.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    hoverDelayInMs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    hoverOffDelayInMs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    isActivatedOnTouch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    mapChildProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onActivationChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onPositionChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onDetectedEnvironmentChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    pressDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    pressMoveThreshold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    shouldDecorateChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    shouldStopTouchMovePropagation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
_class.defaultProps = {
    isActivatedOnTouch: false,
    isEnabled: true,
    hoverDelayInMs: 0,
    hoverOffDelayInMs: 0,
    mapChildProps: function mapChildProps(props) {
        return props;
    },
    onActivationChanged: __WEBPACK_IMPORTED_MODULE_6__utils_noop__["a" /* default */],
    onPositionChanged: __WEBPACK_IMPORTED_MODULE_6__utils_noop__["a" /* default */],
    onDetectedEnvironmentChanged: __WEBPACK_IMPORTED_MODULE_6__utils_noop__["a" /* default */],
    pressDuration: 500,
    pressMoveThreshold: 5,
    shouldDecorateChildren: true,
    shouldStopTouchMovePropagation: false
};
/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * object.omit <https://github.com/jonschlinkert/object.omit>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(903);

module.exports = function omit(obj, props, fn) {
  if (!isObject(obj)) return {};

  if (typeof props === 'function') {
    fn = props;
    props = [];
  }

  if (typeof props === 'string') {
    props = [props];
  }

  var isFunction = typeof fn === 'function';
  var keys = Object.keys(obj);
  var res = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];

    if (!props || (props.indexOf(key) === -1 && (!isFunction || fn(val, key, obj)))) {
      res[key] = val;
    }
  }
  return res;
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isPlainObject = __webpack_require__(904);

module.exports = function isExtendable(val) {
  return isPlainObject(val) || typeof val === 'function' || Array.isArray(val);
};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(905);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListener;
function addEventListener(node, eventName, handler, options) {
    node.addEventListener(eventName, handler, options);
    return {
        removeEventListener: function removeEventListener() {
            node.removeEventListener(eventName, handler, options);
        }
    };
}

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRESS_EVENT_TIMER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MOUSE_EMULATION_GUARD_TIMER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ACTIVATION_TIMER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNSET_ACTIVATION_TIMER_NAME; });
var PRESS_EVENT_TIMER_NAME = 'pressEvent';
var MOUSE_EMULATION_GUARD_TIMER_NAME = 'mouseEmulation';
var SET_ACTIVATION_TIMER_NAME = 'setHovering';
var UNSET_ACTIVATION_TIMER_NAME = 'unsetHovering';

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EnlargedImage__ = __webpack_require__(910);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RenderEnlargedImage = function (_Component) {
    _inherits(RenderEnlargedImage, _Component);

    function RenderEnlargedImage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RenderEnlargedImage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RenderEnlargedImage.__proto__ || Object.getPrototypeOf(RenderEnlargedImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isMounted: false }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RenderEnlargedImage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ isMounted: true });

            if (this.isPortalRendered) {
                var portalId = this.props.portalId;

                this.portalElement = document.getElementById(portalId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.isMounted) {
                return null;
            }

            var props = this.compositProps;

            if (this.isPortalRendered) {
                return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EnlargedImage__["a" /* default */], props), this.portalElement);
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EnlargedImage__["a" /* default */], props);
        }
    }, {
        key: 'isPortalIdImplemented',
        get: function get() {
            return !!this.props.portalId;
        }
    }, {
        key: 'isPortalRendered',
        get: function get() {
            var _props = this.props,
                isPortalEnabledForTouch = _props.isPortalEnabledForTouch,
                isTouchDetected = _props.isTouchDetected;


            if (!this.isPortalIdImplemented) {
                return false;
            }

            if (!isTouchDetected) {
                return true;
            }

            if (isPortalEnabledForTouch) {
                return true;
            }

            return false;
        }
    }, {
        key: 'isMounted',
        get: function get() {
            return this.state.isMounted;
        }
    }, {
        key: 'compositProps',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_3_object_assign___default()({}, this.props, { isPortalRendered: this.isPortalRendered });
        }
    }]);

    return RenderEnlargedImage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RenderEnlargedImage.propTypes = {
    isPortalEnabledForTouch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isTouchDetected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    portalId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (RenderEnlargedImage);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_imageCoordinates__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types_Image__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types_EnlargedImage__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types_Point__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_styles__ = __webpack_require__(475);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _this.state = {
            isTransitionEntering: false,
            isTransitionActive: false,
            isTransitionLeaving: false,
            isTransitionDone: false
        };

        _this.timers = [];
        return _this;
    }

    _createClass(_class, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.scheduleCssTransition(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.timers.forEach(function (timerId) {
                clearTimeout(timerId);
            });
        }
    }, {
        key: 'scheduleCssTransition',
        value: function scheduleCssTransition(nextProps) {
            var _this2 = this;

            var _props = this.props,
                fadeDurationInMs = _props.fadeDurationInMs,
                isActive = _props.isActive,
                isPositionOutside = _props.isPositionOutside;

            var willIsActiveChange = isActive !== nextProps.isActive;
            var willIsPositionOutsideChange = isPositionOutside !== nextProps.isPositionOutside;

            if (!willIsActiveChange && !willIsPositionOutsideChange) {
                return;
            }

            if (nextProps.isActive && !nextProps.isPositionOutside) {
                this.setState({
                    isTrainsitionDone: false,
                    isTransitionEntering: true
                });

                this.timers.push(setTimeout(function () {
                    _this2.setState({
                        isTransitionEntering: false,
                        isTransitionActive: true
                    });
                }, 0));
            } else {
                this.setState({
                    isTransitionLeaving: true,
                    isTransitionActive: false
                });

                this.timers.push(setTimeout(function () {
                    _this2.setState({
                        isTransitionDone: true,
                        isTransitionLeaving: false
                    });
                }, fadeDurationInMs));
            }
        }
    }, {
        key: 'getImageCoordinates',
        value: function getImageCoordinates() {
            var _props2 = this.props,
                cursorOffset = _props2.cursorOffset,
                largeImage = _props2.largeImage,
                containerDimensions = _props2.containerDimensions,
                position = _props2.position,
                smallImage = _props2.smallImage,
                isInPlaceMode = _props2.isInPlaceMode;


            if (isInPlaceMode) {
                return Object(__WEBPACK_IMPORTED_MODULE_2__lib_imageCoordinates__["a" /* getInPlaceEnlargedImageCoordinates */])({
                    containerDimensions: containerDimensions,
                    largeImage: largeImage,
                    position: position
                });
            }

            return Object(__WEBPACK_IMPORTED_MODULE_2__lib_imageCoordinates__["b" /* getLensModeEnlargedImageCoordinates */])({
                containerDimensions: containerDimensions,
                cursorOffset: cursorOffset,
                largeImage: largeImage,
                position: position,
                smallImage: smallImage
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                containerClassName = _props3.containerClassName,
                imageClassName = _props3.imageClassName,
                isLazyLoaded = _props3.isLazyLoaded,
                largeImage = _props3.largeImage,
                _props3$largeImage = _props3.largeImage,
                _props3$largeImage$al = _props3$largeImage.alt,
                alt = _props3$largeImage$al === undefined ? '' : _props3$largeImage$al,
                _props3$largeImage$on = _props3$largeImage.onLoad,
                onLoad = _props3$largeImage$on === undefined ? __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* noop */] : _props3$largeImage$on,
                _props3$largeImage$on2 = _props3$largeImage.onError,
                onError = _props3$largeImage$on2 === undefined ? __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* noop */] : _props3$largeImage$on2;


            var component = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: containerClassName,
                    style: this.containerStyle
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                    alt: alt,
                    className: imageClassName,
                    src: largeImage.src,
                    srcSet: largeImage.srcSet,
                    sizes: largeImage.sizes,
                    style: this.imageStyle,
                    onLoad: onLoad,
                    onError: onError
                })
            );

            if (isLazyLoaded) {
                return this.isVisible ? component : null;
            }

            return component;
        }
    }, {
        key: 'isVisible',
        get: function get() {
            var _state = this.state,
                isTransitionEntering = _state.isTransitionEntering,
                isTransitionActive = _state.isTransitionActive,
                isTransitionLeaving = _state.isTransitionLeaving;


            return isTransitionEntering || isTransitionActive || isTransitionLeaving;
        }
    }, {
        key: 'containerStyle',
        get: function get() {
            var _props4 = this.props,
                containerStyle = _props4.containerStyle,
                containerDimensions = _props4.containerDimensions,
                fadeDurationInMs = _props4.fadeDurationInMs,
                isPortalRendered = _props4.isPortalRendered,
                isInPlaceMode = _props4.isInPlaceMode;
            var isTransitionActive = this.state.isTransitionActive;


            return Object(__WEBPACK_IMPORTED_MODULE_7__lib_styles__["b" /* getEnlargedImageContainerStyle */])({
                containerDimensions: containerDimensions,
                containerStyle: containerStyle,
                fadeDurationInMs: fadeDurationInMs,
                isTransitionActive: isTransitionActive,
                isInPlaceMode: isInPlaceMode,
                isPortalRendered: isPortalRendered
            });
        }
    }, {
        key: 'imageStyle',
        get: function get() {
            var _props5 = this.props,
                imageStyle = _props5.imageStyle,
                largeImage = _props5.largeImage;


            return Object(__WEBPACK_IMPORTED_MODULE_7__lib_styles__["c" /* getEnlargedImageStyle */])({
                imageCoordinates: this.getImageCoordinates(),
                imageStyle: imageStyle,
                largeImage: largeImage
            });
        }
    }]);

    return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

_class.displayName = 'EnlargedImage';
_class.defaultProps = {
    fadeDurationInMs: 0,
    isLazyLoaded: true
};
_class.propTypes = {
    containerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    containerStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    cursorOffset: __WEBPACK_IMPORTED_MODULE_6__prop_types_Point__["a" /* default */],
    position: __WEBPACK_IMPORTED_MODULE_6__prop_types_Point__["a" /* default */],
    fadeDurationInMs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    imageClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    imageStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isLazyLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    largeImage: __WEBPACK_IMPORTED_MODULE_3__prop_types_Image__["a" /* LargeImageShape */],
    containerDimensions: __WEBPACK_IMPORTED_MODULE_4__prop_types_EnlargedImage__["a" /* ContainerDimensions */],
    isPortalRendered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isInPlaceMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getLensModeEnlargedImageCoordinates;
/* harmony export (immutable) */ __webpack_exports__["a"] = getInPlaceEnlargedImageCoordinates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clamp__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__imageRatio__ = __webpack_require__(470);



function getMinCoordinates(container, largeImage) {
    return {
        x: (largeImage.width - container.width) * -1,
        y: (largeImage.height - container.height) * -1
    };
}

function getMaxCoordinates() {
    return {
        x: 0,
        y: 0
    };
}

function getLensModeEnlargedImageCoordinates(_ref) {
    var containerDimensions = _ref.containerDimensions,
        lensCursorOffset = _ref.cursorOffset,
        largeImage = _ref.largeImage,
        position = _ref.position,
        smallImage = _ref.smallImage;

    var adjustedPosition = getCursorPositionAdjustedForLens(position, lensCursorOffset);
    var ratio = Object(__WEBPACK_IMPORTED_MODULE_1__imageRatio__["c" /* getSmallToLargeImageRatio */])(smallImage, largeImage);
    var coordinates = {
        x: Math.round(adjustedPosition.x * ratio.x) * -1,
        y: Math.round(adjustedPosition.y * ratio.y) * -1
    };
    var minCoordinates = getMinCoordinates(containerDimensions, largeImage);
    var maxCoordinates = getMaxCoordinates();

    return clampImageCoordinates(coordinates, minCoordinates, maxCoordinates);
}

function getInPlaceEnlargedImageCoordinates(_ref2) {
    var containerDimensions = _ref2.containerDimensions,
        largeImage = _ref2.largeImage,
        position = _ref2.position;

    var minCoordinates = getMinCoordinates(containerDimensions, largeImage);
    var maxCoordinates = getMaxCoordinates();
    var ratio = Object(__WEBPACK_IMPORTED_MODULE_1__imageRatio__["a" /* getContainerToImageRatio */])(containerDimensions, largeImage);
    var coordinates = {
        x: Math.round(position.x * ratio.x) * -1,
        y: Math.round(position.y * ratio.y) * -1
    };

    return clampImageCoordinates(coordinates, minCoordinates, maxCoordinates);
}

function clampImageCoordinates(imageCoordinates, minCoordinates, maxCoordinates) {
    return {
        x: __WEBPACK_IMPORTED_MODULE_0_clamp___default()(imageCoordinates.x, minCoordinates.x, maxCoordinates.x),
        y: __WEBPACK_IMPORTED_MODULE_0_clamp___default()(imageCoordinates.y, minCoordinates.y, maxCoordinates.y)
    };
}

function getCursorPositionAdjustedForLens(position, lensCursorOffset) {
    return {
        x: position.x - lensCursorOffset.x,
        y: position.y - lensCursorOffset.y
    };
}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = function requiredIf(type, condition) {
  return function(props) {
    var test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
};


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function equal(a, b) {
  if (a === b) return true;

  var arrA = Array.isArray(a)
    , arrB = Array.isArray(b)
    , i;

  if (arrA && arrB) {
    if (a.length != b.length) return false;
    for (i = 0; i < a.length; i++)
      if (!equal(a[i], b[i])) return false;
    return true;
  }

  if (arrA != arrB) return false;

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    var keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA && dateB) return a.getTime() == b.getTime();
    if (dateA != dateB) return false;

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA && regexpB) return a.toString() == b.toString();
    if (regexpA != regexpB) return false;

    for (i = 0; i < keys.length; i++)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = 0; i < keys.length; i++)
      if(!equal(a[keys[i]], b[keys[i]])) return false;

    return true;
  }

  return false;
};


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ImageLensShaded;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LensTop__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LensLeft__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LensRight__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LensBottom__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types_Lens__ = __webpack_require__(188);










function ImageLensShaded(inputProps) {
    var userSpecifiedStyle = inputProps.style;


    var compositLensStyle = __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({ backgroundColor: 'rgba(0,0,0,.4)' }, userSpecifiedStyle);

    var props = __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({}, inputProps, { style: compositLensStyle });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LensTop__["a" /* default */], props),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LensLeft__["a" /* default */], props),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LensRight__["a" /* default */], props),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LensBottom__["a" /* default */], props)
    );
}

ImageLensShaded.propTypes = __WEBPACK_IMPORTED_MODULE_6__prop_types_Lens__["a" /* default */];

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clamp__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lens__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types_Lens__ = __webpack_require__(188);






var LensTop = function LensTop(_ref) {
    var cursorOffset = _ref.cursorOffset,
        position = _ref.position,
        fadeDurationInMs = _ref.fadeDurationInMs,
        isActive = _ref.isActive,
        isPositionOutside = _ref.isPositionOutside,
        smallImage = _ref.smallImage,
        parentSpecifiedStyle = _ref.style;

    var clearLensHeight = cursorOffset.y * 2;
    var maxHeight = smallImage.height - clearLensHeight;
    var height = __WEBPACK_IMPORTED_MODULE_1_clamp___default()(position.y - cursorOffset.y, 0, maxHeight);
    var computedStyle = {
        height: height + 'px',
        width: '100%',
        top: '0px'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Lens__["a" /* default */], {
        fadeDurationInMs: fadeDurationInMs,
        isActive: isActive,
        isPositionOutside: isPositionOutside,
        style: __WEBPACK_IMPORTED_MODULE_2_object_assign___default()({}, parentSpecifiedStyle, computedStyle)
    });
};

LensTop.propTypes = __WEBPACK_IMPORTED_MODULE_4__prop_types_Lens__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (LensTop);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clamp__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lens__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types_Lens__ = __webpack_require__(188);






var LensLeft = function LensLeft(_ref) {
    var cursorOffset = _ref.cursorOffset,
        position = _ref.position,
        fadeDurationInMs = _ref.fadeDurationInMs,
        isActive = _ref.isActive,
        isPositionOutside = _ref.isPositionOutside,
        smallImage = _ref.smallImage,
        parentSpecifiedStyle = _ref.style;

    var clearLensHeight = cursorOffset.y * 2;
    var clearLensWidth = cursorOffset.x * 2;
    var maxHeight = smallImage.height - clearLensHeight;
    var maxWidth = smallImage.width - clearLensWidth;
    var height = clearLensHeight;
    var width = __WEBPACK_IMPORTED_MODULE_2_clamp___default()(position.x - cursorOffset.x, 0, maxWidth);
    var top = __WEBPACK_IMPORTED_MODULE_2_clamp___default()(position.y - cursorOffset.y, 0, maxHeight);
    var computedStyle = {
        height: height + 'px',
        width: width + 'px',
        top: top + 'px',
        left: '0px'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Lens__["a" /* default */], {
        fadeDurationInMs: fadeDurationInMs,
        isActive: isActive,
        isPositionOutside: isPositionOutside,
        style: __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({}, parentSpecifiedStyle, computedStyle)
    });
};

LensLeft.propTypes = __WEBPACK_IMPORTED_MODULE_4__prop_types_Lens__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (LensLeft);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clamp__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lens__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types_Lens__ = __webpack_require__(188);






var LensRight = function LensRight(_ref) {
    var cursorOffset = _ref.cursorOffset,
        position = _ref.position,
        fadeDurationInMs = _ref.fadeDurationInMs,
        isActive = _ref.isActive,
        isPositionOutside = _ref.isPositionOutside,
        smallImage = _ref.smallImage,
        parentSpecifiedStyle = _ref.style;

    var clearLensHeight = cursorOffset.y * 2;
    var clearLensWidth = cursorOffset.x * 2;
    var maxHeight = smallImage.height - clearLensHeight;
    var maxWidth = smallImage.width - clearLensWidth;
    var height = clearLensHeight;
    var width = __WEBPACK_IMPORTED_MODULE_2_clamp___default()(smallImage.width - position.x - cursorOffset.x, 0, maxWidth);
    var top = __WEBPACK_IMPORTED_MODULE_2_clamp___default()(position.y - cursorOffset.y, 0, maxHeight);
    var computedStyle = {
        height: height + 'px',
        width: width + 'px',
        top: top + 'px',
        right: '0px'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Lens__["a" /* default */], {
        fadeDurationInMs: fadeDurationInMs,
        isActive: isActive,
        isPositionOutside: isPositionOutside,
        style: __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({}, parentSpecifiedStyle, computedStyle)
    });
};

LensRight.propTypes = __WEBPACK_IMPORTED_MODULE_4__prop_types_Lens__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (LensRight);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clamp__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lens__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types_Lens__ = __webpack_require__(188);






var LensBottom = function LensBottom(_ref) {
    var cursorOffset = _ref.cursorOffset,
        position = _ref.position,
        fadeDurationInMs = _ref.fadeDurationInMs,
        isActive = _ref.isActive,
        isPositionOutside = _ref.isPositionOutside,
        smallImage = _ref.smallImage,
        parentSpecifiedStyle = _ref.style;


    var clearLensHeight = cursorOffset.y * 2;
    var computedHeight = smallImage.height - position.y - cursorOffset.y;
    var maxHeight = smallImage.height - clearLensHeight;
    var height = __WEBPACK_IMPORTED_MODULE_2_clamp___default()(computedHeight, 0, maxHeight);
    var clearLensBottom = position.y + cursorOffset.y;
    var top = Math.max(clearLensBottom, clearLensHeight);
    var computedStyle = {
        height: height + 'px',
        width: '100%',
        top: top + 'px'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Lens__["a" /* default */], {
        fadeDurationInMs: fadeDurationInMs,
        isActive: isActive,
        isPositionOutside: isPositionOutside,
        style: __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({}, parentSpecifiedStyle, computedStyle)
    });
};

LensBottom.propTypes = __WEBPACK_IMPORTED_MODULE_4__prop_types_Lens__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (LensBottom);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DisplayUntilActive = function (_React$Component) {
    _inherits(DisplayUntilActive, _React$Component);

    function DisplayUntilActive(props) {
        _classCallCheck(this, DisplayUntilActive);

        var _this = _possibleConstructorReturn(this, (DisplayUntilActive.__proto__ || Object.getPrototypeOf(DisplayUntilActive)).call(this, props));

        _this.hasShown = false;
        return _this;
    }

    _createClass(DisplayUntilActive, [{
        key: 'setHasShown',
        value: function setHasShown() {
            this.hasShown = true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                isActive = _props.isActive,
                shouldHideAfterFirstActivation = _props.shouldHideAfterFirstActivation,
                hasShown = this.hasShown;

            var shouldShow = !isActive && (!hasShown || !shouldHideAfterFirstActivation);

            if (isActive && !hasShown) {
                this.setHasShown();
            }

            return shouldShow ? children : null;
        }
    }]);

    return DisplayUntilActive;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DisplayUntilActive.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
    isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    shouldHideAfterFirstActivation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
DisplayUntilActive.defaultProps = {
    shouldHideAfterFirstActivation: true
};
/* harmony default export */ __webpack_exports__["a"] = (DisplayUntilActive);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function DefaultHint(_ref) {
    var isTouchDetected = _ref.isTouchDetected,
        hintTextMouse = _ref.hintTextMouse,
        hintTextTouch = _ref.hintTextTouch;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: {
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                bottom: '25px'
            } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 10px',
                    backgroundColor: '#333',
                    borderRadius: '10px',
                    opacity: '0.90'
                } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                style: {
                    width: '25px',
                    height: '25px'
                },
                src: 'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ5MC4yIDQ5MC4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OTAuMiA0OTAuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+CjxnPgoJPGc+CgkJPHBhdGggZD0iTTQxOC41LDQxOC41Yzk1LjYtOTUuNiw5NS42LTI1MS4yLDAtMzQ2LjhzLTI1MS4yLTk1LjYtMzQ2LjgsMHMtOTUuNiwyNTEuMiwwLDM0Ni44UzMyMi45LDUxNC4xLDQxOC41LDQxOC41eiBNODksODkgICAgYzg2LjEtODYuMSwyMjYuMS04Ni4xLDMxMi4yLDBzODYuMSwyMjYuMSwwLDMxMi4ycy0yMjYuMSw4Ni4xLTMxMi4yLDBTMywxNzUuMSw4OSw4OXoiIGZpbGw9IiNGRkZGRkYiLz4KCQk8cGF0aCBkPSJNMjQ1LjEsMzM2LjljMy40LDAsNi40LTEuNCw4LjctMy42YzIuMi0yLjIsMy42LTUuMywzLjYtOC43di02Ny4zaDY3LjNjMy40LDAsNi40LTEuNCw4LjctMy42YzIuMi0yLjIsMy42LTUuMywzLjYtOC43ICAgIGMwLTYuOC01LjUtMTIuMy0xMi4yLTEyLjJoLTY3LjN2LTY3LjNjMC02LjgtNS41LTEyLjMtMTIuMi0xMi4yYy02LjgsMC0xMi4zLDUuNS0xMi4yLDEyLjJ2NjcuM2gtNjcuM2MtNi44LDAtMTIuMyw1LjUtMTIuMiwxMi4yICAgIGMwLDYuOCw1LjUsMTIuMywxMi4yLDEyLjJoNjcuM3Y2Ny4zQzIzMi44LDMzMS40LDIzOC4zLDMzNi45LDI0NS4xLDMzNi45eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                        padding: '2px 0 0 5px',
                        fontFamily: 'Arial, sans-serif',
                        fontSize: '14px',
                        color: 'white'
                    } },
                isTouchDetected ? hintTextTouch : hintTextMouse
            )
        )
    );
}

DefaultHint.displayName = 'DefaultHint';

DefaultHint.propTypes = {
    isTouchDetected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    hintTextMouse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    hintTextTouch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (DefaultHint);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLensCursorOffset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__imageRatio__ = __webpack_require__(470);


function getLensCursorOffset(smallImage, largeImage, enlargedImageContainerDimensions) {
    var ratio = Object(__WEBPACK_IMPORTED_MODULE_0__imageRatio__["b" /* getLargeToSmallImageRatio */])(smallImage, largeImage);
    return {
        x: getLensCursorOffsetDimension(enlargedImageContainerDimensions.width, ratio.x),
        y: getLensCursorOffsetDimension(enlargedImageContainerDimensions.height, ratio.y)
    };
}

function getLensCursorOffsetDimension(enlargedImageContainerDimension, ratio) {
    return Math.round(enlargedImageContainerDimension * ratio / 2);
}

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPercentageFormat */
/* unused harmony export convertPercentageToDecimal */
/* harmony export (immutable) */ __webpack_exports__["a"] = getEnlargedImageContainerDimension;
function isPercentageFormat(val) {
    return typeof val === 'string' && /^\d+%$/.test(val);
}

function convertPercentageToDecimal(percentage) {
    return parseInt(percentage) / 100;
}

function getEnlargedImageContainerDimension(_ref) {
    var containerDimension = _ref.containerDimension,
        smallImageDimension = _ref.smallImageDimension,
        isInPlaceMode = _ref.isInPlaceMode;

    if (isInPlaceMode) {
        return smallImageDimension;
    }

    if (isPercentageFormat(containerDimension)) {
        return smallImageDimension * convertPercentageToDecimal(containerDimension);
    }

    return containerDimension;
}

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_DropdownNavLink__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__header_NavigationDropdownNavItem__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_CustomNavigationLinkLocation__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_CustomNavigationLinkStore__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationSingleLevelMenuRow=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationSingleLevelMenuRow,_Component);function NavigationSingleLevelMenuRow(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationSingleLevelMenuRow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationSingleLevelMenuRow.__proto__||Object.getPrototypeOf(NavigationSingleLevelMenuRow)).call.apply(_ref,[this].concat(args))),_this),_this.getNavItems=function(items){return items.map(function(item){var id=item.id,className=item.className,customNavLinks=item.customNavLinks;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:id},customNavLinks&&customNavLinks.map(function(customNavLink,index){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_14__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&customNavLink.parent_sibling_id===item.id&&_this.getCustomNavItems(customNavLink,index);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* NavItem */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationSingleLevelMenuRow__item',className)},_this.getNavigationElement(item)),customNavLinks&&customNavLinks.map(function(customNavLink,index){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_14__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&customNavLink.parent_sibling_id===item.id&&_this.getCustomNavItems(customNavLink,index);}));});},_this.getCustomNavItems=function(customNavLink,index){var customNavigationLinkStore=_this.props.customNavigationLinkStore;var linkClassName='NavigationSingleLevelMenuRow__link';var subLinks=customNavigationLinkStore.findChildLinks(customNavLink.id);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:index},subLinks&&subLinks.map(function(subCustomNavLink,subIndex){return subCustomNavLink.location===__WEBPACK_IMPORTED_MODULE_14__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&_this.getCustomNavItems(subCustomNavLink,subIndex);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* NavItem */],{key:index,className:'NavigationSingleLevelMenuRow__item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__["a" /* default */],{entity:_this.convertCustomNavigationLinkToEntityItem(customNavLink),type:customNavLink.link_type,className:linkClassName})),subLinks&&subLinks.map(function(subCustomNavLink,subIndex){return subCustomNavLink.location===__WEBPACK_IMPORTED_MODULE_14__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&_this.getCustomNavItems(subCustomNavLink,subIndex);}));},_this.convertCustomNavigationLinkToEntityItem=function(customNavLink){return{id:customNavLink.id,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,customNavLink.name),path:_this.getCategoryListPath(customNavLink),type:customNavLink.link_type};},_this.getCategoryListPath=function(customNavLink){var _this$props=_this.props,routeService=_this$props.routeService,sectionStore=_this$props.sectionStore;if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_13__types_LinkType__["b" /* default */].EXTERNAL_LINK){return customNavLink.link;}if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_13__types_LinkType__["b" /* default */].INTERNAL_LINK){return routeService.getPath(customNavLink.link);}return routeService.getPath(customNavLink.link,sectionStore.activeSection);},_this.getNavigationElement=function(item){var path=item.path,active=item.active;var linkClassName='NavigationSingleLevelMenuRow__link';if(item.dropdown){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__header_NavigationDropdownNavItem__["a" /* default */],{item:item,childLinks:item.children,className:linkClassName,active:active});}if(path){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__["a" /* default */],{entity:item,className:linkClassName});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_DropdownNavLink__["a" /* default */],{item:item,className:linkClassName,active:active});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationSingleLevelMenuRow,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,items=_props.items,className=_props.className;var ifActiveSections=configStore.activateSections;var navItems=this.getNavItems(items,ifActiveSections);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["J" /* Navbar */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('NavigationSingleLevelMenuRow',className),expand:'lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({NavigationSingleLevelMenuRow__container:configStore.topNavigation.center})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["G" /* Nav */],{navbar:true,className:'NavigationSingleLevelMenuRow__nav'},navItems)));}}]);return NavigationSingleLevelMenuRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationSingleLevelMenuRow.propTypes={items:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5__types_NavigationEntity__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_SectionStore__["a" /* default */]).isRequired,customNavigationLinkStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_CustomNavigationLinkStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10__services_RouteService__["a" /* default */]).isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','routeService','sectionStore','customNavigationLinkStore')(NavigationSingleLevelMenuRow));

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DropdownNavLink=function(_Component){_inherits(DropdownNavLink,_Component);function DropdownNavLink(){_classCallCheck(this,DropdownNavLink);return _possibleConstructorReturn(this,(DropdownNavLink.__proto__||Object.getPrototypeOf(DropdownNavLink)).apply(this,arguments));}_createClass(DropdownNavLink,[{key:'render',value:function render(){var _props=this.props,className=_props.className,rest=_objectWithoutProperties(_props,['className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["I" /* NavLink */],Object.assign({className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('DropdownNavLink',className),href:'#',role:'button'},rest));}}]);return DropdownNavLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DropdownNavLink);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationDropdownNavItem=function(_Component){_inherits(NavigationDropdownNavItem,_Component);function NavigationDropdownNavItem(props){_classCallCheck(this,NavigationDropdownNavItem);var _this=_possibleConstructorReturn(this,(NavigationDropdownNavItem.__proto__||Object.getPrototypeOf(NavigationDropdownNavItem)).call(this,props));_this.state={isOpen:false};_this.containerRef=null;_this.timer=null;_this.closeMenu=function(){_this.timer=setTimeout(function(){_this.setState({isOpen:false});},50);};_this.updateOpenState=function(bool){if(bool){clearTimeout(_this.timer);}_this.setState({isOpen:bool});};_this.renderNavLink=function(elem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* NavLink */],Object.assign({key:elem.id,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('nav-link','NavigationDropdownNavItem_NavLink'),to:elem.path},elem),elem.label);};_this.containerRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();return _this;}_createClass(NavigationDropdownNavItem,[{key:'isOutside',value:function isOutside(){if(!this.containerRef.current||this.containerRef.current===null){return false;}// If right + some arbitary safe margin is bigger than innerWidth, we want to
// align dropdown to right.
return this.containerRef.current.getBoundingClientRect().right+80>window.innerWidth;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,className=_props.className,item=_props.item,childLinks=_props.childLinks;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Dropdown */],{inNavbar:true,className:'NavigationDropdownNavItem__container nav-item',toggle:function toggle(){return _this2.updateOpenState(!_this2.state.isOpen);},isOpen:this.state.isOpen,onMouseOver:function onMouseOver(){return _this2.updateOpenState(true);},onMouseLeave:function onMouseLeave(){return _this2.closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* NavLink */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('NavigationDropdownNavItem',className,'nav-link'),to:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.label,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Icon__["a" /* default */],{name:'caret-down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:this.containerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["q" /* DropdownMenu */],{right:this.isOutside(),className:'NavigationDropdownNavItem__list'},childLinks.map(this.renderNavLink))));}}]);return NavigationDropdownNavItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NavigationDropdownNavItem.propTypes={childLinks:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (NavigationDropdownNavItem);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_LinkType__ = __webpack_require__(76);
var Menu=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Menu',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,type:__WEBPACK_IMPORTED_MODULE_1__types_LinkType__["a" /* LinkTypeType */],image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),children:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].late(function(){return __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(Menu);}))}).views(function(self){return{get parent(){// First parent is the parent Menu's children array, the second the Menu itself.
// Find such a parent that also has a URL, i.e. is not one of the top level dropdowns.
// This way we will find the actual active path that can be used in the side menu navigation.
// (Menus are used instead of info pages, since there is no guarantee we have the parent info page
// loaded to the store at all times, which means we don't know the full parent_id chain either.)
var parent=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["e" /* getParent */])(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["e" /* getParent */])(self));if(parent&&parent.url&&Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["i" /* getType */])(parent)===Menu){return parent;}return null;},get ancestors(){var ancestors=[];var currentMenu=self;while(currentMenu.parent){var parent=currentMenu.parent;ancestors.push(parent);currentMenu=parent;}ancestors.reverse();return ancestors;}};});/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MobileNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_MobileNavigationList__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_MenuStore__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_CategoryBadges__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_CustomNavigationLinkStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__types_CustomNavigationLinkParentType__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__account_ClientLoginLink__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__types_Site__ = __webpack_require__(278);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MobileNavigation=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MobileNavigation,_Component);function MobileNavigation(props){_classCallCheck(this,MobileNavigation);var _this=_possibleConstructorReturn(this,(MobileNavigation.__proto__||Object.getPrototypeOf(MobileNavigation)).call(this,props));_this.getProductTabItems=function(){var _this$props=_this.props,configStore=_this$props.configStore,routeService=_this$props.routeService,sectionStore=_this$props.sectionStore,categoryStore=_this$props.categoryStore,accountStore=_this$props.accountStore;var staticItems=[];if(accountStore.isRetailer){staticItems.push({id:'CustomerProducts',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].customerProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].CustomerProducts)});}if(configStore.sidebar.showOnSale){staticItems.push({id:'OnSale',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].onSaleTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].OnSale)});}if(configStore.sidebar.showNewProducts){staticItems.push({id:'NewProducts',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].newProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].NewProducts)});}if(configStore.sidebar.showSoldProducts){staticItems.push({id:'SoldProducts',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].soldProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].SoldProducts)});}if(configStore.sidebar.showMostSold){staticItems.push({id:'MostSold',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].mostPopularTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].PopularProducts)});}if(configStore.sidebar.showRecommended){staticItems.push({id:'Recommended',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].weRecommendTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].RecommendedProducts)});}staticItems.push(_this.getSpacerEntity());staticItems.push({id:'info',path:'#',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationList__sublabel',onClick:function onClick(){_this.toggleTab(__WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__["b" /* default */].INFO);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].infoTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'info-circle'}))});if(!configStore.siteConfig.isShoppingCenter){staticItems.push({id:'my-account',path:'#',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationList__sublabel',onClick:function onClick(){_this.toggleTab(__WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__["b" /* default */].ACCOUNT);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccountTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'user'}))});}staticItems.push(_this.getSpacerEntity());var sectionsOrTopLevelCategories=[];if(configStore.activateSections){sectionsOrTopLevelCategories=sectionStore.activeSections.map(_this.convertSectionToEntity);}else{sectionsOrTopLevelCategories=categoryStore.categories.map(function(category){return _this.convertCategoryToEntity(category,null);});}return sectionsOrTopLevelCategories.concat(staticItems);};_this.convertSectionToEntity=function(section){var _this$props2=_this.props,routeService=_this$props2.routeService,sectionStore=_this$props2.sectionStore;return{id:section.id,label:section.navigationName,path:routeService.getPath(section.path),active:sectionStore.activeSection===section,children:section.mainCategories.map(function(category){return _this.convertCategoryToEntity(category,section);}),customNavLinks:_this.getCustomNavigationLinks(section,__WEBPACK_IMPORTED_MODULE_25__types_CustomNavigationLinkParentType__["a" /* default */].SECTION)};};_this.convertCategoryToEntity=function(category,section){var _this$props3=_this.props,routeService=_this$props3.routeService,categoryStore=_this$props3.categoryStore;var children=section?category.getNonBlockedChildren(section.blockedCategoriesDict):category.children;return{id:category.id,label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,category.navigationName,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_CategoryBadges__["a" /* default */],{category:category})),path:routeService.getPath(category.path,section),active:categoryStore.isInActiveCategoryHierarchy(category),children:children.map(function(subcategory){return _this.convertCategoryToEntity(subcategory,section);}),customNavLinks:_this.getCustomNavigationLinks(category,__WEBPACK_IMPORTED_MODULE_25__types_CustomNavigationLinkParentType__["a" /* default */].CATEGORY)};};_this.getCustomNavigationLinks=function(categoryOrSection,type){var customNavigationLinkStore=_this.props.customNavigationLinkStore;if(type===__WEBPACK_IMPORTED_MODULE_25__types_CustomNavigationLinkParentType__["a" /* default */].CATEGORY){return _this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.filterByCategoryId(categoryOrSection.id));}if(type===__WEBPACK_IMPORTED_MODULE_25__types_CustomNavigationLinkParentType__["a" /* default */].SECTION){return _this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.filterBySectionId(categoryOrSection.id));}};_this.convertCustomNavigationLinksToEntityItems=function(topLevelCustomNavigationLinks){var customNavigationLinkStore=_this.props.customNavigationLinkStore;return topLevelCustomNavigationLinks.map(function(customNavigationLink){return{id:customNavigationLink.id,label:customNavigationLink.name,path:_this.getCategoryListPath(customNavigationLink),location:customNavigationLink.location,parent_sibling_id:customNavigationLink,customNavLinks:_this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.findChildLinks(customNavigationLink.id))};});};_this.getCategoryListPath=function(customNavLink){var _this$props4=_this.props,routeService=_this$props4.routeService,sectionStore=_this$props4.sectionStore;if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_23__types_LinkType__["b" /* default */].EXTERNAL_LINK){return customNavLink.link;}if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_23__types_LinkType__["b" /* default */].INTERNAL_LINK){return routeService.getPath(customNavLink.link);}return routeService.getPath(customNavLink.link,sectionStore.activeSection);};_this.getInfoTabItems=function(){var _this$props5=_this.props,configStore=_this$props5.configStore,menuStore=_this$props5.menuStore;var staticItems=[_this.getSpacerEntity()];configStore.customerService.email.length>0&&staticItems.push({id:'email',path:'#',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationList__sublabel',onClick:function onClick(){document.location='mailto:'+configStore.customerService.email;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].infoSendEmail),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'envelope-square'}))});configStore.customerService.phone.length>0&&staticItems.push({id:'phone',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationList__sublabel',onClick:function onClick(e){e.stopPropagation();document.location='tel:'+configStore.customerService.phone;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MobileNavigationList__text-container d-flex flex-column'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].infoCallPhone,{values:{phone:configStore.customerService.phone}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'customerService.isOpen',defaultMessage:'Customer service is open Mon - Fri {timespan}',values:{timespan:configStore.customerService.open}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationList__sublabel-placer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'fa-stack fa-stack-small'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'square',className:'fa-stack-1x'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'phone',className:'fa-stack-3qx fa-inverse'}))))});return menuStore.menus.map(_this.convertMenuItemToEntity).concat(staticItems);};_this.getSpacerEntity=function(){return{id:'Spacer'+__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(),label:''};};_this.convertMenuItemToEntity=function(menu){return{id:'info'+menu.id,label:typeof menu.title==='string'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:menu.title}}):menu.title!==null?menu.title:'',children:menu.children.map(_this.convertMenuItemToEntity),path:menu.url,image:menu.image,type:menu.type};};_this.getAccountTabItems=function(){var _this$props6=_this.props,accountStore=_this$props6.accountStore,configStore=_this$props6.configStore,routeService=_this$props6.routeService;var accountModal=accountStore.accountModal;var tabItems=[];if(accountStore.loggedIn&&(configStore.siteConfig.siteType===__WEBPACK_IMPORTED_MODULE_27__types_Site__["b" /* default */].WEB_STORE||configStore.account.isMoneyTransfer)){return _this.getLoggedInTabItems();}else{if(configStore.siteConfig.siteType===__WEBPACK_IMPORTED_MODULE_27__types_Site__["b" /* default */].WEB_STORE||configStore.account.isMoneyTransfer){tabItems.push({id:'login',path:'#',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationList__sublabel',onClick:function onClick(){accountModal.setTab(__WEBPACK_IMPORTED_MODULE_21__types_AccountModalTab__["b" /* default */].LOGIN);accountModal.toggle();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].logInSentence),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'sign-in'}))});}if(configStore.registration.enabled&&(configStore.siteConfig.siteType===__WEBPACK_IMPORTED_MODULE_27__types_Site__["b" /* default */].WEB_STORE||configStore.account.isMoneyTransfer)){tabItems.push({id:'register',path:'#',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationList__sublabel',onClick:function onClick(){accountModal.setTab(__WEBPACK_IMPORTED_MODULE_21__types_AccountModalTab__["b" /* default */].REGISTER);accountModal.toggle();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].registerTitle))});}if(configStore.wishlist.enabled&&!configStore.account.isMoneyTransfer){tabItems.push({id:'wishlist',path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].WishList),label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].wishListTitle)});}return tabItems;}};_this.getLoggedInTabItems=function(){var _this$props7=_this.props,routeService=_this$props7.routeService,configStore=_this$props7.configStore,analytics=_this$props7.analytics,accountStore=_this$props7.accountStore;var accountPath=accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].MyAccountBalanceUser:__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].MyAccount;if(accountStore.isBalanceUser){accountPath=__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].MyAccountBalanceSubUser;}var tabItems=[];if(configStore.account.enableMyAccount){tabItems.push({id:'customerAccount',path:routeService.getPath(accountPath),label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myCustomerAccountTitle)});}if(!accountStore.isBalanceUser){if(configStore.account.enableMyAccount){var accountType=accountStore.isBalanceBuyer?_this.getBalanceUserAccount():_this.getCustomerUserOrderHistory();tabItems.push(accountType);}if(configStore.wishlist.enabled){tabItems.push({id:'wishlist',path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].WishList),label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].wishListTitle)});}}if(accountStore.isClientLoginEnabled){var label=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__account_ClientLoginLink__["a" /* default */],null),accountStore.isClient&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigation--client-login'},'(',accountStore.name,')'));tabItems.push({id:'clientLogin',path:'#',label:label});}tabItems.push({id:'logout',path:'#',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationList__sublabel',onClick:function onClick(){analytics.clearCart();accountStore.logout();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].accountLogOutSentence),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'sign-out'}))});return tabItems;};_this.getBalanceUserAccount=function(){var routeService=_this.props.routeService;return{id:'balanceUsers',path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].MyAccountBalanceUserPaymentHistory),label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].balanceUserAccountBalanceInfo)};};_this.getCustomerUserOrderHistory=function(){var routeService=_this.props.routeService;return{id:'orderHistory',path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].MyAccountOrderList),label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myOrderHistoryTitle)};};_this.getEntityTree=function(){var _this$props8=_this.props,shouldHideProductContent=_this$props8.shouldHideProductContent,configStore=_this$props8.configStore;var tree=[];var accountTabItems=_this.getAccountTabItems();if(!shouldHideProductContent){tree.push({id:__WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__["b" /* default */].PRODUCTS,label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].productsTitle),children:_this.getProductTabItems()});}tree.push({id:__WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__["b" /* default */].INFO,label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].infoTitle),children:_this.getInfoTabItems()});if(accountTabItems.length>0&&!configStore.siteConfig.isShoppingCenter){tree.push({id:__WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__["b" /* default */].ACCOUNT,label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccountTitle),children:accountTabItems});}return tree;};_this.toggleTab=function(tabId){var mobileNavigation=_this.props.uiStore.mobileNavigation;mobileNavigation.selectTab(tabId);};if(props.configStore.account.isMoneyTransfer){_this.toggleTab(__WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__["b" /* default */].ACCOUNT);}return _this;}_createClass(MobileNavigation,[{key:'render',value:function render(){var _this2=this;var configStore=this.props.configStore;var mobileNavigation=this.props.uiStore.mobileNavigation;var tree=this.getEntityTree();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MobileNavigation'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MobileNavigation__tabs'},tree.map(function(tab){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{key:tab.id,className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('MobileNavigation__tab',{'MobileNavigation__tab--active':tab.id===mobileNavigation.activeTab}),color:'plain',onClick:function onClick(){return _this2.toggleTab(tab.id);}},tab.label);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_MobileNavigationList__["a" /* default */],{activeTabId:mobileNavigation.activeTab,entities:tree,close:mobileNavigation.close,hasSections:!!configStore.activateSections}));}}]);return MobileNavigation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MobileNavigation.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_ConfigStore__["a" /* default */]).isRequired,menuStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_MenuStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_12__services_RouteService__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_SectionStore__["a" /* default */]).isRequired,categoryStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_CategoryStore__["a" /* default */]).isRequired,customNavigationLinkStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__store_CustomNavigationLinkStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_UIStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_22__analytics_Analytics__["a" /* default */]).isRequired,shouldHideProductContent:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','configStore','menuStore','sectionStore','categoryStore','routeService','uiStore','customNavigationLinkStore','analytics')(MobileNavigation));

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MobileNavigationList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_immer__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ad_ContentSlots__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_safeCloneDeep__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_MobileNavigationRegionalSettingsSummary__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__NavigationHiddenContentHelper__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__types_CustomNavigationLinkLocation__ = __webpack_require__(151);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ENTRY_LEVEL_FOR_HOME_LINK=3;var ENTRY_LEVEL_FOR_HEADER=2;var MAYBE_SECTION_FRONTPAGE=2;var MobileNavigationList=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MobileNavigationList,_Component);function MobileNavigationList(props){_classCallCheck(this,MobileNavigationList);var _this=_possibleConstructorReturn(this,(MobileNavigationList.__proto__||Object.getPrototypeOf(MobileNavigationList)).call(this,props));_this.listElement=null;_this.state={entityTree:[],relativeTop:null,helperIsSeen:false,showHelper:false,updated:false};_this.shouldShowHelper=function(){var tabChanged=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(_this.state.helperIsSeen===false||tabChanged){if(_this.state.updated===false||tabChanged){_this.setState({showHelper:Object(__WEBPACK_IMPORTED_MODULE_21__util_dom__["f" /* getElementRelativeBottom */])(_this.listElement)>window.innerHeight,updated:true});}}};_this.handleScroll=function(e){e.preventDefault();if(_this.state.relativeTop>Object(__WEBPACK_IMPORTED_MODULE_21__util_dom__["g" /* getElementRelativeTop */])(_this.listElement)){_this.setState({helperIsSeen:true,showHelper:false});}};_this.getHomeButton=function(path){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["B" /* ListGroupItem */],{className:'d-sm-none MobileNavigationList__item MobileNavigationList__home-menu-link'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{color:'plain',className:'MobileNavigationList__button-back',onClick:function onClick(){return _this.selectItem(path.slice(0,1));}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_Icon__["a" /* default */],{className:'d-sm-none',name:'angle-double-left'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'d-sm-none'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'navigation.backToBegin',defaultMessage:'Back to the begin'}))));};_this.getMenuBackButton=function(menu,path){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["B" /* ListGroupItem */],{className:'MobileNavigationList__item MobileNavigationList__previous-menu-link-option'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{color:'plain',className:'MobileNavigationList__button-back',onClick:function onClick(){return _this.unselectChildren(path);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_Icon__["a" /* default */],{name:'angle-left'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'d-block d-sm-none'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'navigation.backToItem',defaultMessage:'Back to {name}',values:{name:menu.label}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'d-none d-sm-block'},menu.label)));};_this.getNavigateToMessage=function(path){var _this$props=_this.props,activeTabId=_this$props.activeTabId,hasSections=_this$props.hasSections;var message=null;switch(activeTabId){case __WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__["b" /* default */].PRODUCTS:if(hasSections&&path.length===MAYBE_SECTION_FRONTPAGE){message=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'navigation.navigateToSectionItem',defaultMessage:'See section frontpage here'});}else{message=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'navigation.navigateToCategoryItem',defaultMessage:'See all products here'});}break;case __WEBPACK_IMPORTED_MODULE_20__types_MobileNavigationTab__["b" /* default */].INFO:message=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'navigation.navigateToInfoItem',defaultMessage:'See page content here'});break;default:}return message;};_this.getNavigateToButton=function(menu,path){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["B" /* ListGroupItem */],{className:'MobileNavigationList__item MobileNavigationList__navigate-to-link-option'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{color:'plain',className:'MobileNavigationList__button-navigate',onClick:function onClick(){return _this.navigateTo(menu.path);}},path.length>=ENTRY_LEVEL_FOR_HEADER&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'d-block d-sm-none text-uppercase MobileNavigationList__header'},menu.label),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'d-block d-sm-none'},_this.getNavigateToMessage(path),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_Icon__["a" /* default */],{className:'MobileNavigationList__header-icon',name:'angle-double-right'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'d-none d-sm-block'},menu.label)));};_this.getCustomNavItemProperties=function(customNavLink,index,currentPath,image){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],{key:index},customNavLink.customNavLinks&&customNavLink.customNavLinks.map(function(subCustomNavLink,idx){return subCustomNavLink.location===__WEBPACK_IMPORTED_MODULE_26__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&subCustomNavLink.parent_sibling_id.parent_sibling_id===customNavLink.id&&_this.getCustomNavItemProperties(subCustomNavLink,idx,currentPath,image);}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["B" /* ListGroupItem */],{key:index,className:'MobileNavigationList__item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_ButtonLink__["a" /* default */],{href:customNavLink.path,onClick:function onClick(){_this.navigateTo(customNavLink.path);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,customNavLink.label))),customNavLink.customNavLinks&&customNavLink.customNavLinks.map(function(subCustomNavLink,idx){return subCustomNavLink.location===__WEBPACK_IMPORTED_MODULE_26__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&subCustomNavLink.parent_sibling_id.parent_sibling_id===customNavLink.id&&_this.getCustomNavItemProperties(subCustomNavLink,idx,currentPath,image);}));};_this.getLinkOrLabel=function(child,childPath,currentPath,type,image){var buttonImage=image?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'image-grouper'},image,child.label):child.label;return child.path||child.children&&child.children.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_ButtonLink__["a" /* default */],{href:childPath,onClick:function onClick(){if(child.children&&child.children.length>0||child.path&&child.path==='#'){_this.selectItem(currentPath);}else{_this.navigateTo(childPath);}},type:type},buttonImage,child.children&&child.children.length>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_Icon__["a" /* default */],{name:'angle-right'})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,image,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,child.label));};_this.getChildPath=function(child,type){var childPath=child.path;if(type&&type===__WEBPACK_IMPORTED_MODULE_23__types_LinkType__["b" /* default */].INTERNAL_LINK){return Object(__WEBPACK_IMPORTED_MODULE_19__util_url__["l" /* transformInternalLink */])(childPath);}if(type&&type===__WEBPACK_IMPORTED_MODULE_23__types_LinkType__["b" /* default */].PAGE_LINK){return Object(__WEBPACK_IMPORTED_MODULE_19__util_url__["i" /* stripHostIfMatches */])(childPath);}return childPath;};_this.getNextMenuLevel=function(menu,path,parent){var activeChildIndex=menu.children.findIndex(function(submenu){return submenu.active;});var activeChild=menu.children[activeChildIndex];var isNested=!!parent;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MobileNavigationList__menu-container',key:menu.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["A" /* ListGroup */],null,path.length>=ENTRY_LEVEL_FOR_HOME_LINK&&_this.getHomeButton(path),isNested&&_this.getMenuBackButton(parent,path.slice(0,-1)),isNested&&_this.getNavigateToButton(menu,path),_this.getChildListGroupItem(menu,path))),activeChild&&activeChild.children&&activeChild.children.length>0&&_this.getNextMenuLevel(activeChild,path.concat([activeChildIndex]),menu));};_this.getBody=function(activeTab,path){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MobileNavigationList__body'},_this.getNextMenuLevel(activeTab,path));};_this.getFooter=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MobileNavigationList__footer'},_this.getBannerZone(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_MobileNavigationRegionalSettingsSummary__["a" /* default */],null));};_this.getBannerZone=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ad_ContentSlots__["a" /* default */],{searchParams:{bannerZone:__WEBPACK_IMPORTED_MODULE_12__types_AdZones__["a" /* default */].HEADER_CONTENT},className:'MobileNavigation__content-slots'});};_this.getActualEntityTreePath=function(path){return'entityTree'+path.map(function(index){return'['+index+']';}).join('.children');};_this.unselectChildren=function(path){return _this.selectItem(path);};_this.selectItem=function(path){_this.setState(function(currentState){return Object(__WEBPACK_IMPORTED_MODULE_9_immer__["a" /* produce */])(currentState,function(draftState){var parentIndexes=path.slice(0,-1);var indexToSelect=__WEBPACK_IMPORTED_MODULE_1_lodash_last___default()(path);var childrenOfParentNode=void 0;if(parentIndexes.length>0){childrenOfParentNode=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(draftState,_this.getActualEntityTreePath(parentIndexes)).children;}else{childrenOfParentNode=draftState.entityTree;}// First, unselect all children of the parent node.
childrenOfParentNode.forEach(function(child){child.active=false;});// Then, select the requested node if it exists.
var itemToSelect=childrenOfParentNode[indexToSelect];if(itemToSelect){itemToSelect.active=true;// Also clean up the active states of the selected node's children.
if(itemToSelect.children){itemToSelect.children.forEach(function(child){child.active=false;});}}});});_this.setState({helperIsSeen:false,updated:false});};_this.navigateTo=function(url){var host=_this.props.host;var maybeRelativeUrl=Object(__WEBPACK_IMPORTED_MODULE_19__util_url__["i" /* stripHostIfMatches */])(url,host);if(Object(__WEBPACK_IMPORTED_MODULE_19__util_url__["e" /* isNotHandledByReactRouter */])(maybeRelativeUrl)){return window.open(maybeRelativeUrl,'_blank','noopener');}else{_this.props.history.push(maybeRelativeUrl);}_this.props.close();};_this.state.entityTree=Object(__WEBPACK_IMPORTED_MODULE_16__util_safeCloneDeep__["a" /* default */])(props.entities);return _this;}_createClass(MobileNavigationList,[{key:'componentDidMount',value:function componentDidMount(){if(this.listElement){window.addEventListener('scroll',this.handleScroll,true);this.setState({relativeTop:Object(__WEBPACK_IMPORTED_MODULE_21__util_dom__["g" /* getElementRelativeTop */])(this.listElement)});this.shouldShowHelper();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.helperIsSeen!==this.state.helperIsSeen||this.state.helperIsSeen===false&&prevState.helperIsSeen===false||prevProps.activeTabId!==this.props.activeTabId){this.shouldShowHelper(prevProps.activeTabId!==this.props.activeTabId);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.listElement){window.removeEventListener('scroll',this.handleScroll,true);}}},{key:'getChildListGroupItem',value:function getChildListGroupItem(menu,path){var _this2=this;return menu.children.map(function(child,index){var currentPath=path.concat([index]);var customNavLinks=child.customNavLinks;var image=child.image?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:child.image,alt:child.image,loading:'lazy'}):null;var type=child.type?child.type:null;var childPath=_this2.getChildPath(child,type);var linkOrLabel=_this2.getLinkOrLabel(child,childPath,currentPath,type,image);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],{key:index},customNavLinks&&customNavLinks.map(function(customNavLink,idx){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_26__types_CustomNavigationLinkLocation__["a" /* default */].ABOVE&&customNavLink.parent_sibling_id.parent_sibling_id===child.id&&_this2.getCustomNavItemProperties(customNavLink,idx,currentPath,image);}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["B" /* ListGroupItem */],{active:child.active,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()('MobileNavigationList__item',{'MobileNavigationList__item--empty':!child.label})},linkOrLabel),customNavLinks&&customNavLinks.map(function(customNavLink,idx){return customNavLink.location===__WEBPACK_IMPORTED_MODULE_26__types_CustomNavigationLinkLocation__["a" /* default */].BELOW&&customNavLink.parent_sibling_id.parent_sibling_id===child.id&&_this2.getCustomNavItemProperties(customNavLink,idx,currentPath,image);}));});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,className=_props.className,activeTabId=_props.activeTabId;var _state=this.state,entityTree=_state.entityTree,showHelper=_state.showHelper;if(!entityTree){return null;}var openedTabIndex=entityTree.findIndex(function(tab){return tab.id===activeTabId;});if(openedTabIndex===-1){openedTabIndex=0;}var openedTab=entityTree[openedTabIndex];var openedPathRoot=[openedTabIndex];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{ref:function ref(_ref){return _this3.listElement=_ref;},className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()('MobileNavigationList',className)},this.getBody(openedTab,openedPathRoot),this.getFooter(entityTree),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__NavigationHiddenContentHelper__["a" /* default */],{visible:showHelper}));}}]);return MobileNavigationList;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;MobileNavigationList.propTypes={history:__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default.a.history.isRequired,/**
   * The entity tree is expected to be at least two levels deep.
   * - First level: "Tabs"
   * - Second and below levels: actual menu content
   *
   * Tabs should be considered pure containers; you can't link to
   * anywhere with a tab directly even if you pass a path on that
   * level.
   */entities:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_15__types_NavigationEntity__["a" /* default */]).isRequired,close:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,activeTabId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,host:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,hasSections:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_24__services_RouteService__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_25__store_SectionStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])(function(stores){return{host:stores.locationContext.host,routeService:stores.routeService,sectionStore:stores.sectionStore};})(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(MobileNavigationList)));

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SSRAwareLazyLoad=function(_Component){_inherits(SSRAwareLazyLoad,_Component);function SSRAwareLazyLoad(){_classCallCheck(this,SSRAwareLazyLoad);return _possibleConstructorReturn(this,(SSRAwareLazyLoad.__proto__||Object.getPrototypeOf(SSRAwareLazyLoad)).apply(this,arguments));}_createClass(SSRAwareLazyLoad,[{key:'render',value:function render(){var _props=this.props,children=_props.children,props=_objectWithoutProperties(_props,['children']);return window.isSSR?children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_lazyload___default.a,props,children);}}]);return SSRAwareLazyLoad;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SSRAwareLazyLoad);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MobileNavigationRegionalSettingsSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_dropRight__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LocaleFlagIcon__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// All flags will be shown when languages count <= max slots.
// Otherwise, max slots flags will be shown. By default, the first flags
// in the array will be displayed, but if the currently selected language is
// not among them, it will replace the last flag.
var MAX_VISIBLE_LANGUAGE_FLAG_SLOTS=5;var MobileNavigationRegionalSettingsSummary=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MobileNavigationRegionalSettingsSummary,_Component);function MobileNavigationRegionalSettingsSummary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MobileNavigationRegionalSettingsSummary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MobileNavigationRegionalSettingsSummary.__proto__||Object.getPrototypeOf(MobileNavigationRegionalSettingsSummary)).call.apply(_ref,[this].concat(args))),_this),_this.getLanguagesLabel=function(){var languageStore=_this.props.languageStore;var displayPartialFlagList=languageStore.languages.length>MAX_VISIBLE_LANGUAGE_FLAG_SLOTS;var displayedFlags=languageStore.languages;if(displayPartialFlagList){displayedFlags=displayedFlags.slice(0,MAX_VISIBLE_LANGUAGE_FLAG_SLOTS);if(!displayedFlags.find(function(item){return item.code===languageStore.activeLanguage.code;})){displayedFlags=__WEBPACK_IMPORTED_MODULE_0_lodash_dropRight___default()(displayedFlags);displayedFlags.push(languageStore.activeLanguage);}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,displayedFlags.map(function(language){var isActive=languageStore.activeLanguage===language;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('MobileNavigationRegionalSettingsSummary__flag-container',{active:isActive}),key:language.code},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LocaleFlagIcon__["a" /* default */],{locale:language.code}));}),displayPartialFlagList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MobileNavigationRegionalSettingsSummary__more'},'+'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MobileNavigationRegionalSettingsSummary,[{key:'render',value:function render(){var _props=this.props,languageStore=_props.languageStore,currencyStore=_props.currencyStore,countryStore=_props.countryStore,uiStore=_props.uiStore;var items=[];if(countryStore.countries.length>1){items.push({key:'country',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].deliveryCountryLabel,{values:{country:countryStore.activeCountry.name}})),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LocaleFlagIcon__["a" /* default */],{locale:countryStore.activeCountry.iso_code_2.toLowerCase()}))});}if(languageStore.languages.length>1){items.push({key:'language',label:this.getLanguagesLabel()});}if(currencyStore.currencies.length>1){items.push({key:'currency',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].currencyLabel,{values:{currency:currencyStore.currencyCode}}))});}if(items.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MobileNavigationRegionalSettingsSummary',role:'button',onClick:function onClick(e){e.stopPropagation();uiStore.mobileRegionalSettingsModal.toggle();}},items.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:item.key},item.label);}));}}]);return MobileNavigationRegionalSettingsSummary;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MobileNavigationRegionalSettingsSummary.propTypes={languageStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_LanguageStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_CurrencyStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_CountryStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_UIStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('languageStore','currencyStore','countryStore','uiStore')(MobileNavigationRegionalSettingsSummary));

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(233),
    toInteger = __webpack_require__(241);

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = dropRight;


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationHiddenContentHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationHiddenContentHelper=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationHiddenContentHelper,_Component);function NavigationHiddenContentHelper(){_classCallCheck(this,NavigationHiddenContentHelper);return _possibleConstructorReturn(this,(NavigationHiddenContentHelper.__proto__||Object.getPrototypeOf(NavigationHiddenContentHelper)).apply(this,arguments));}_createClass(NavigationHiddenContentHelper,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationHiddenContentHelper',{'NavigationHiddenContentHelper--hidden':!this.props.visible})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:'NavigationHiddenContent__helper-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'angle-down',className:'NavigationHiddenContentHelper__icon'})))));}}]);return NavigationHiddenContentHelper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationHiddenContentHelper.propTypes={visible:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (NavigationHiddenContentHelper);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationWishListButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__ = __webpack_require__(99);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationWishListButton=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationWishListButton,_Component);function NavigationWishListButton(){_classCallCheck(this,NavigationWishListButton);return _possibleConstructorReturn(this,(NavigationWishListButton.__proto__||Object.getPrototypeOf(NavigationWishListButton)).apply(this,arguments));}_createClass(NavigationWishListButton,[{key:'render',value:function render(){var item={id:'wishlist',path:this.props.routeService.getPath(__WEBPACK_IMPORTED_MODULE_6__types_Paths__["a" /* default */].WishList),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].wishListTitle)};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__["a" /* default */],{entity:item});}}]);return NavigationWishListButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationWishListButton.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','routeService')(NavigationWishListButton));

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TopNavigationSearchButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__ = __webpack_require__(99);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TopNavigationSearchButton=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(TopNavigationSearchButton,_Component);function TopNavigationSearchButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TopNavigationSearchButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TopNavigationSearchButton.__proto__||Object.getPrototypeOf(TopNavigationSearchButton)).call.apply(_ref,[this].concat(args))),_this),_this.item={id:'topNavigationSearch',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].search)},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TopNavigationSearchButton,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["H" /* NavItem */],{className:'TopNavigationSearchButton',onClick:this.props.onShowSearchOnTopNavigation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Icon__["a" /* default */],{name:'search'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__["a" /* default */],{entity:this.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Icon__["a" /* default */],{name:'angle-down'}));}}]);return TopNavigationSearchButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;TopNavigationSearchButton.propTypes={onShowSearchOnTopNavigation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TopNavigationSearchButton);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommonNavigationMiddle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ad_ContentSlots__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MobileNavigationButton__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_MobileNavigationTab__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__NavigationLogo__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__search_QuickSearch__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NavigationCart__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_Hamburger__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__vehicle_LicensePlateInput__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__types_TranslatedImageType__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__store_TranslationStore__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CommonNavigationMiddle=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CommonNavigationMiddle,_Component);function CommonNavigationMiddle(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CommonNavigationMiddle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CommonNavigationMiddle.__proto__||Object.getPrototypeOf(CommonNavigationMiddle)).call.apply(_ref,[this].concat(args))),_this),_this.renderNavigationHeader=function(){var _this$props=_this.props,accountStore=_this$props.accountStore,configStore=_this$props.configStore,hideCheckout=_this$props.hideCheckout,ifShouldShowFullHeader=_this$props.ifShouldShowFullHeader,inputBlur=_this$props.inputBlur,inputFocus=_this$props.inputFocus,isSticky=_this$props.isSticky,moveShoppingCartLoginRight=_this$props.moveShoppingCartLoginRight,onSearchKeyPress=_this$props.onSearchKeyPress,useStickyHeaderOnStartup=_this$props.useStickyHeaderOnStartup;var showCart=!accountStore.isViewOnly;var centerShopLogo=configStore.topNavigation.centerShopLogo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,centerShopLogo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NavigationLogo__["a" /* default */],{sticky:isSticky,useStickyHeaderOnStartup:useStickyHeaderOnStartup,ifShouldShowFullHeader:ifShouldShowFullHeader}),!configStore.siteConfig.isHomePage&&!centerShopLogo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CommonNavigation__middle-right-content',{'CommonNavigation__middle-only-content':!showCart,'CommonNavigation__middle-center-content':configStore.topNavigation.center})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonNavigation__middle-right-content-top'},!configStore.topNavigation.moveSearchbarTopNavigation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__search_QuickSearch__["a" /* default */],{handleFocus:inputFocus,handleBlur:inputBlur,toggleSearch:onSearchKeyPress}),showCart&&moveShoppingCartLoginRight&&configStore.siteConfig.isWebStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__NavigationCart__["a" /* default */],{withCheckoutButton:hideCheckout}))));},_this.renderVehicleSearchPartHeader=function(){var _this$props2=_this.props,accountStore=_this$props2.accountStore,configStore=_this$props2.configStore,uiStore=_this$props2.uiStore,hideCheckout=_this$props2.hideCheckout,inputBlur=_this$props2.inputBlur,inputFocus=_this$props2.inputFocus,isSticky=_this$props2.isSticky,moveShoppingCartLoginRight=_this$props2.moveShoppingCartLoginRight,onSearchKeyPress=_this$props2.onSearchKeyPress,useStickyHeaderOnStartup=_this$props2.useStickyHeaderOnStartup;var showCart=!accountStore.isViewOnly;var vehiclePartSearchEnabled=configStore.vehiclePartSearch.enabled&&uiStore.isHD;var centerShopLogo=configStore.topNavigation.centerShopLogo;return!centerShopLogo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],{className:'CommonNavigation__middle-content-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:centerShopLogo?8:3,xl:centerShopLogo?8:4,className:'pl-0'},centerShopLogo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NavigationLogo__["a" /* default */],{sticky:isSticky,useStickyHeaderOnStartup:useStickyHeaderOnStartup})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:9,xl:8,className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CommonNavigation__middle-right-content',{'CommonNavigation__middle-only-content':!showCart,'CommonNavigation__middle-center-content':configStore.topNavigation.center})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonNavigation__license-plate-input'},!configStore.topNavigation.moveSearchbarTopNavigation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__vehicle_LicensePlateInput__["a" /* default */],{handleOnSubmit:_this.handleVehicleSearch,clearAfterSubmit:true,hideSearchButtonText:vehiclePartSearchEnabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonNavigation__middle-right-content-top'},!configStore.topNavigation.moveSearchbarTopNavigation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__search_QuickSearch__["a" /* default */],{handleFocus:inputFocus,handleBlur:inputBlur,toggleSearch:onSearchKeyPress,vehiclePartSearchEnabled:vehiclePartSearchEnabled}),showCart&&moveShoppingCartLoginRight&&configStore.siteConfig.isWebStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__NavigationCart__["a" /* default */],{withCheckoutButton:hideCheckout,className:'NavigationCart__vehicle-search-part',wrapperClassName:'NavigationCart__vehicle-search-part-cart-button-wrapper'})))):_this.renderNavigationHeader();},_this.getBannerZone=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonNavigation__content-slots CommonNavigation__content-slots__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ad_ContentSlots__["a" /* default */],{searchParams:{bannerZone:__WEBPACK_IMPORTED_MODULE_10__types_AdZones__["a" /* default */].HEADER_CONTENT},className:'CommonNavigation__content-slots'}));},_this.mobileCommonNavigation=function(){var _this$props3=_this.props,accountStore=_this$props3.accountStore,configStore=_this$props3.configStore,uiStore=_this$props3.uiStore,hideCheckout=_this$props3.hideCheckout,inputBlur=_this$props3.inputBlur,inputFocus=_this$props3.inputFocus,intl=_this$props3.intl,onSearchKeyPress=_this$props3.onSearchKeyPress,onShowSearchOnMobile=_this$props3.onShowSearchOnMobile,shouldShowSearchOnMobile=_this$props3.shouldShowSearchOnMobile;var showCart=!accountStore.isViewOnly;var vehiclePartSearchEnabled=configStore.vehiclePartSearch.enabled;var mobileSearchbarVisibility=configStore.topNavigation.headerMobileSearchbarVisibility;var visibleMobileSearchbar=shouldShowSearchOnMobile||mobileSearchbarVisibility;var hideMobileContainer=uiStore.searchIsActive;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonNavigation__middle-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'CommonNavigation__middle-content-container'},!hideMobileContainer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CommonNavigation__mobile-container-row',{'CommonNavigation__mobile-container-row--hidden':hideMobileContainer})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{xs:12,className:'CommonNavigation__mobile-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MobileNavigationButton__["a" /* default */],{tab:_this.getDefaultMobileMenuTab(),withBorder:true,forceClose:uiStore.mobileNavigation.isOpen,ariaLabel:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_29__i18n_globalTranslations__["a" /* default */].seeCategoriesNavi)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__common_Hamburger__["a" /* default */],{active:uiStore.mobileNavigation.isOpen})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonNavigation__mobile-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{color:'plain',className:'CommonNavigation__mobile-home','aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_29__i18n_globalTranslations__["a" /* default */].homeTitle)},_this.getMobileLogoUrl()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:configStore.store.name,src:_this.getMobileLogoUrl()}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_Icon__["a" /* default */],{name:'home',className:'fa-2x'}))),!configStore.siteConfig.isHomePage&&!mobileSearchbarVisibility&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{color:'plain',onClick:onShowSearchOnMobile,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_29__i18n_globalTranslations__["a" /* default */].search)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_Icon__["a" /* default */],{name:'search',className:'fa-2x'})),_this.getMobileIconForAccountIfWebStore(),_this.getMobileIconForWishListIfShoppingCentreAndEnabled(),configStore.storeInfoPageId>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{color:'plain',onClick:_this.navigateToStoreInfoPage,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_29__i18n_globalTranslations__["a" /* default */].infoTitle)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_Icon__["a" /* default */],{name:'map-marker',className:'fa-2x'})),showCart&&configStore.siteConfig.isWebStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__NavigationCart__["a" /* default */],{withCheckoutButton:hideCheckout})))),visibleMobileSearchbar&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CommonNavigation__mobile-search-row',{'CommonNavigation__mobile-search-row--no-padding':hideMobileContainer,'CommonNavigation__mobile-search-row--show':visibleMobileSearchbar})},vehiclePartSearchEnabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:{size:6,offset:6},className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__vehicle_LicensePlateInput__["a" /* default */],{handleOnSubmit:_this.handleVehicleSearch,clearAfterSubmit:true,hideSearchButtonText:!uiStore.isTablet})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__search_QuickSearch__["a" /* default */],{handleFocus:inputFocus,handleBlur:inputBlur,toggleSearch:onSearchKeyPress})))));},_this.getDefaultMobileMenuTab=function(){var location=_this.props.location;if(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["d" /* matchPath */])(location.pathname,{path:'/:locale?'+__WEBPACK_IMPORTED_MODULE_24__types_Paths__["a" /* default */].InfoPage})){return __WEBPACK_IMPORTED_MODULE_12__types_MobileNavigationTab__["b" /* default */].INFO;}return __WEBPACK_IMPORTED_MODULE_12__types_MobileNavigationTab__["b" /* default */].PRODUCTS;},_this.getMobileLogoUrl=function(){var translationStore=_this.props.translationStore;var logo=translationStore.translatedImages.find(function(image){return image.image_key===__WEBPACK_IMPORTED_MODULE_27__types_TranslatedImageType__["b" /* default */].STORE_MOBILE_LOGO;});return logo&&logo.image_path;},_this.getMobileIconForAccountIfWebStore=function(){var _this$props4=_this.props,intl=_this$props4.intl,configStore=_this$props4.configStore;return configStore.siteConfig.isWebStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MobileNavigationButton__["a" /* default */],{tab:__WEBPACK_IMPORTED_MODULE_12__types_MobileNavigationTab__["b" /* default */].ACCOUNT,className:'ml-auto text-uppercase',ariaLabel:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_29__i18n_globalTranslations__["a" /* default */].myAccountTitle)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_Icon__["a" /* default */],{name:'user',className:'fa-2x'}));},_this.getMobileIconForWishListIfShoppingCentreAndEnabled=function(){var _this$props5=_this.props,intl=_this$props5.intl,configStore=_this$props5.configStore;return configStore.wishlist.enabled&&configStore.siteConfig.isShoppingCenter&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MobileNavigationButton__["a" /* default */],{tab:__WEBPACK_IMPORTED_MODULE_12__types_MobileNavigationTab__["b" /* default */].ACCOUNT,className:'ml-auto text-uppercase',ariaLabel:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_29__i18n_globalTranslations__["a" /* default */].seeCategoriesNavi)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_Icon__["a" /* default */],{name:'star',className:'fa-2x'}));},_this.navigateToStoreInfoPage=function(){var _this$props6=_this.props,configStore=_this$props6.configStore,routeService=_this$props6.routeService;var storeInfoPagePath=Object(__WEBPACK_IMPORTED_MODULE_23__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_24__types_Paths__["a" /* default */].InfoPage,{slug:'-',id:configStore.storeInfoPageId});_this.props.history.push(routeService.getPath(storeInfoPagePath));},_this.handleVehicleSearch=function(licensePlate){var _this$props7=_this.props,routeService=_this$props7.routeService,history=_this$props7.history;var licensePlateUrl=licensePlate?Object(__WEBPACK_IMPORTED_MODULE_26__util_queryString__["a" /* addParametersToPath */])(__WEBPACK_IMPORTED_MODULE_24__types_Paths__["a" /* default */].VehiclePartSearch,{id:licensePlate}):__WEBPACK_IMPORTED_MODULE_24__types_Paths__["a" /* default */].VehiclePartSearch;var url=routeService.getPath(licensePlateUrl);history.push(url);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CommonNavigationMiddle,[{key:'desktopCommonNavigation',value:function desktopCommonNavigation(){var configStore=this.props.configStore;var centerShopLogo=configStore.topNavigation.centerShopLogo;var showBanner=configStore.topNavigation.moveSearchbarTopNavigation;var vehiclePartSearchEnabled=configStore.vehiclePartSearch.enabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CommonNavigation__middle-content',{'CommonNavigation__middle-content--centered-logo':centerShopLogo})},vehiclePartSearchEnabled?this.renderVehicleSearchPartHeader():this.renderNavigationHeader(),showBanner&&this.getBannerZone());}},{key:'render',value:function render(){var uiStore=this.props.uiStore;return uiStore.isDesktop?this.desktopCommonNavigation():this.mobileCommonNavigation();}}]);return CommonNavigationMiddle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CommonNavigationMiddle.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_19__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_19__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__["a" /* default */]).isRequired,translationStore:Object(__WEBPACK_IMPORTED_MODULE_19__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_28__store_TranslationStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_19__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_UIStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_22__services_RouteService__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_8_react_intl__["f" /* intlShape */].isRequired,location:__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default.a.location.isRequired,hideCheckout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isSticky:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,moveShoppingCartLoginRight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,shouldShowSearchOnMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,inputBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,inputFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSearchKeyPress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowSearchOnMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,ifShouldShowFullHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,useStickyHeaderOnStartup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["c" /* inject */])('accountStore','configStore','translationStore','uiStore','routeService')(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_intl__["e" /* injectIntl */])(CommonNavigationMiddle))));

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(320);

Object.defineProperty(exports, 'AllSubstringsIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _index.AllSubstringsIndexStrategy;
  }
});
Object.defineProperty(exports, 'ExactWordIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _index.ExactWordIndexStrategy;
  }
});
Object.defineProperty(exports, 'PrefixIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _index.PrefixIndexStrategy;
  }
});

var _index2 = __webpack_require__(321);

Object.defineProperty(exports, 'CaseSensitiveSanitizer', {
  enumerable: true,
  get: function get() {
    return _index2.CaseSensitiveSanitizer;
  }
});
Object.defineProperty(exports, 'LowerCaseSanitizer', {
  enumerable: true,
  get: function get() {
    return _index2.LowerCaseSanitizer;
  }
});

var _index3 = __webpack_require__(481);

Object.defineProperty(exports, 'TfIdfSearchIndex', {
  enumerable: true,
  get: function get() {
    return _index3.TfIdfSearchIndex;
  }
});
Object.defineProperty(exports, 'UnorderedSearchIndex', {
  enumerable: true,
  get: function get() {
    return _index3.UnorderedSearchIndex;
  }
});

var _index4 = __webpack_require__(483);

Object.defineProperty(exports, 'SimpleTokenizer', {
  enumerable: true,
  get: function get() {
    return _index4.SimpleTokenizer;
  }
});
Object.defineProperty(exports, 'StemmingTokenizer', {
  enumerable: true,
  get: function get() {
    return _index4.StemmingTokenizer;
  }
});
Object.defineProperty(exports, 'StopWordsTokenizer', {
  enumerable: true,
  get: function get() {
    return _index4.StopWordsTokenizer;
  }
});

var _Search = __webpack_require__(947);

Object.defineProperty(exports, 'Search', {
  enumerable: true,
  get: function get() {
    return _Search.Search;
  }
});

var _StopWordsMap = __webpack_require__(484);

Object.defineProperty(exports, 'StopWordsMap', {
  enumerable: true,
  get: function get() {
    return _StopWordsMap.StopWordsMap;
  }
});

var _TokenHighlighter = __webpack_require__(948);

Object.defineProperty(exports, 'TokenHighlighter', {
  enumerable: true,
  get: function get() {
    return _TokenHighlighter.TokenHighlighter;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */
var AllSubstringsIndexStrategy = exports.AllSubstringsIndexStrategy = function () {
  function AllSubstringsIndexStrategy() {
    _classCallCheck(this, AllSubstringsIndexStrategy);
  }

  _createClass(AllSubstringsIndexStrategy, [{
    key: 'expandToken',


    /**
     * @inheritDocs
     */
    value: function expandToken(token) {
      var expandedTokens = [];
      var string;

      for (var i = 0, length = token.length; i < length; ++i) {
        string = '';

        for (var j = i; j < length; ++j) {
          string += token.charAt(j);
          expandedTokens.push(string);
        }
      }

      return expandedTokens;
    }
  }]);

  return AllSubstringsIndexStrategy;
}();

;
//# sourceMappingURL=AllSubstringsIndexStrategy.js.map

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Indexes for exact word matches.
 */
var ExactWordIndexStrategy = exports.ExactWordIndexStrategy = function () {
  function ExactWordIndexStrategy() {
    _classCallCheck(this, ExactWordIndexStrategy);
  }

  _createClass(ExactWordIndexStrategy, [{
    key: 'expandToken',


    /**
     * @inheritDocs
     */
    value: function expandToken(token) {
      return token ? [token] : [];
    }
  }]);

  return ExactWordIndexStrategy;
}();

;
//# sourceMappingURL=ExactWordIndexStrategy.js.map

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */
var PrefixIndexStrategy = exports.PrefixIndexStrategy = function () {
  function PrefixIndexStrategy() {
    _classCallCheck(this, PrefixIndexStrategy);
  }

  _createClass(PrefixIndexStrategy, [{
    key: 'expandToken',


    /**
     * @inheritDocs
     */
    value: function expandToken(token) {
      var expandedTokens = [];
      var string = '';

      for (var i = 0, length = token.length; i < length; ++i) {
        string += token.charAt(i);
        expandedTokens.push(string);
      }

      return expandedTokens;
    }
  }]);

  return PrefixIndexStrategy;
}();

;
//# sourceMappingURL=PrefixIndexStrategy.js.map

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Enforces case-sensitive text matches.
 */
var CaseSensitiveSanitizer = exports.CaseSensitiveSanitizer = function () {
  function CaseSensitiveSanitizer() {
    _classCallCheck(this, CaseSensitiveSanitizer);
  }

  _createClass(CaseSensitiveSanitizer, [{
    key: 'sanitize',


    /**
     * @inheritDocs
     */
    value: function sanitize(text) {
      return text ? text.trim() : '';
    }
  }]);

  return CaseSensitiveSanitizer;
}();

;
//# sourceMappingURL=CaseSensitiveSanitizer.js.map

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */
var LowerCaseSanitizer = exports.LowerCaseSanitizer = function () {
  function LowerCaseSanitizer() {
    _classCallCheck(this, LowerCaseSanitizer);
  }

  _createClass(LowerCaseSanitizer, [{
    key: 'sanitize',


    /**
     * @inheritDocs
     */
    value: function sanitize(text) {
      return text ? text.toLocaleLowerCase().trim() : '';
    }
  }]);

  return LowerCaseSanitizer;
}();

;
//# sourceMappingURL=LowerCaseSanitizer.js.map

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TfIdfSearchIndex = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _getNestedFieldValue = __webpack_require__(482);

var _getNestedFieldValue2 = _interopRequireDefault(_getNestedFieldValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */
var TfIdfSearchIndex = exports.TfIdfSearchIndex = function () {
  function TfIdfSearchIndex(uidFieldName) {
    _classCallCheck(this, TfIdfSearchIndex);

    this._uidFieldName = uidFieldName;
    this._tokenToIdfCache = {};
    this._tokenMap = {};
  }

  /**
   * @inheritDocs
   */


  _createClass(TfIdfSearchIndex, [{
    key: 'indexDocument',
    value: function indexDocument(token, uid, doc) {
      this._tokenToIdfCache = {}; // New index invalidates previous IDF caches

      var tokenMap = this._tokenMap;
      var tokenDatum;

      if (_typeof(tokenMap[token]) !== 'object') {
        tokenMap[token] = tokenDatum = {
          $numDocumentOccurrences: 0,
          $totalNumOccurrences: 1,
          $uidMap: {}
        };
      } else {
        tokenDatum = tokenMap[token];
        tokenDatum.$totalNumOccurrences++;
      }

      var uidMap = tokenDatum.$uidMap;

      if (_typeof(uidMap[uid]) !== 'object') {
        tokenDatum.$numDocumentOccurrences++;
        uidMap[uid] = {
          $document: doc,
          $numTokenOccurrences: 1
        };
      } else {
        uidMap[uid].$numTokenOccurrences++;
      }
    }

    /**
     * @inheritDocs
     */

  }, {
    key: 'search',
    value: function search(tokens, corpus) {
      var uidToDocumentMap = {};

      for (var i = 0, numTokens = tokens.length; i < numTokens; i++) {
        var token = tokens[i];
        var tokenMetadata = this._tokenMap[token];

        // Short circuit if no matches were found for any given token.
        if (!tokenMetadata) {
          return [];
        }

        if (i === 0) {
          var keys = Object.keys(tokenMetadata.$uidMap);
          for (var j = 0, numKeys = keys.length; j < numKeys; j++) {
            var uid = keys[j];

            uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
          }
        } else {
          var keys = Object.keys(uidToDocumentMap);
          for (var j = 0, numKeys = keys.length; j < numKeys; j++) {
            var uid = keys[j];

            if (_typeof(tokenMetadata.$uidMap[uid]) !== 'object') {
              delete uidToDocumentMap[uid];
            }
          }
        }
      }

      var documents = [];

      for (var uid in uidToDocumentMap) {
        documents.push(uidToDocumentMap[uid]);
      }

      var calculateTfIdf = this._createCalculateTfIdf();

      // Return documents sorted by TF-IDF
      return documents.sort(function (documentA, documentB) {
        return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
      });
    }
  }, {
    key: '_createCalculateIdf',
    value: function _createCalculateIdf() {
      var tokenMap = this._tokenMap;
      var tokenToIdfCache = this._tokenToIdfCache;

      return function calculateIdf(token, documents) {
        if (!tokenToIdfCache[token]) {
          var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;

          tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
        }

        return tokenToIdfCache[token];
      };
    }
  }, {
    key: '_createCalculateTfIdf',
    value: function _createCalculateTfIdf() {
      var tokenMap = this._tokenMap;
      var uidFieldName = this._uidFieldName;
      var calculateIdf = this._createCalculateIdf();

      return function calculateTfIdf(tokens, document, documents) {
        var score = 0;

        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
          var token = tokens[i];

          var inverseDocumentFrequency = calculateIdf(token, documents);

          if (inverseDocumentFrequency === Infinity) {
            inverseDocumentFrequency = 0;
          }

          var uid;
          if (uidFieldName instanceof Array) {
            uid = document && (0, _getNestedFieldValue2.default)(document, uidFieldName);
          } else {
            uid = document && document[uidFieldName];
          }

          var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;

          score += termFrequency * inverseDocumentFrequency;
        }

        return score;
      };
    }
  }]);

  return TfIdfSearchIndex;
}();

;
//# sourceMappingURL=TfIdfSearchIndex.js.map

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */
var UnorderedSearchIndex = exports.UnorderedSearchIndex = function () {
  function UnorderedSearchIndex() {
    _classCallCheck(this, UnorderedSearchIndex);

    this._tokenToUidToDocumentMap = {};
  }

  /**
   * @inheritDocs
   */


  _createClass(UnorderedSearchIndex, [{
    key: 'indexDocument',
    value: function indexDocument(token, uid, doc) {
      if (_typeof(this._tokenToUidToDocumentMap[token]) !== 'object') {
        this._tokenToUidToDocumentMap[token] = {};
      }

      this._tokenToUidToDocumentMap[token][uid] = doc;
    }

    /**
     * @inheritDocs
     */

  }, {
    key: 'search',
    value: function search(tokens, corpus) {
      var intersectingDocumentMap = {};

      var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;

      for (var i = 0, numTokens = tokens.length; i < numTokens; i++) {
        var token = tokens[i];
        var documentMap = tokenToUidToDocumentMap[token];

        // Short circuit if no matches were found for any given token.
        if (!documentMap) {
          return [];
        }

        if (i === 0) {
          var keys = Object.keys(documentMap);

          for (var j = 0, numKeys = keys.length; j < numKeys; j++) {
            var uid = keys[j];

            intersectingDocumentMap[uid] = documentMap[uid];
          }
        } else {
          var keys = Object.keys(intersectingDocumentMap);

          for (var j = 0, numKeys = keys.length; j < numKeys; j++) {
            var uid = keys[j];

            if (_typeof(documentMap[uid]) !== 'object') {
              delete intersectingDocumentMap[uid];
            }
          }
        }
      }

      var keys = Object.keys(intersectingDocumentMap);
      var documents = [];

      for (var i = 0, numKeys = keys.length; i < numKeys; i++) {
        var uid = keys[i];

        documents.push(intersectingDocumentMap[uid]);
      }

      return documents;
    }
  }]);

  return UnorderedSearchIndex;
}();

;
//# sourceMappingURL=UnorderedSearchIndex.js.map

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REGEX = /[^a-zа-яё0-9\-']+/i;

/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */


var SimpleTokenizer = exports.SimpleTokenizer = function () {
  function SimpleTokenizer() {
    _classCallCheck(this, SimpleTokenizer);
  }

  _createClass(SimpleTokenizer, [{
    key: 'tokenize',


    /**
     * @inheritDocs
     */
    value: function tokenize(text) {
      return text.split(REGEX).filter(function (text) {
        return text;
      } // Filter empty tokens
      );
    }
  }]);

  return SimpleTokenizer;
}();

;
//# sourceMappingURL=SimpleTokenizer.js.map

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */
var StemmingTokenizer = exports.StemmingTokenizer = function () {

  /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */
  function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
    _classCallCheck(this, StemmingTokenizer);

    this._stemmingFunction = stemmingFunction;
    this._tokenizer = decoratedTokenizer;
  }

  /**
   * @inheritDocs
   */


  _createClass(StemmingTokenizer, [{
    key: 'tokenize',
    value: function tokenize(text) {
      return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    }
  }]);

  return StemmingTokenizer;
}();

;
//# sourceMappingURL=StemmingTokenizer.js.map

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StopWordsTokenizer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StopWordsMap = __webpack_require__(484);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */
var StopWordsTokenizer = exports.StopWordsTokenizer = function () {

  /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */
  function StopWordsTokenizer(decoratedTokenizer) {
    _classCallCheck(this, StopWordsTokenizer);

    this._tokenizer = decoratedTokenizer;
  }

  /**
   * @inheritDocs
   */


  _createClass(StopWordsTokenizer, [{
    key: 'tokenize',
    value: function tokenize(text) {
      return this._tokenizer.tokenize(text).filter(function (token) {
        return !_StopWordsMap.StopWordsMap[token];
      });
    }
  }]);

  return StopWordsTokenizer;
}();

;
//# sourceMappingURL=StopWordsTokenizer.js.map

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _getNestedFieldValue = __webpack_require__(482);

var _getNestedFieldValue2 = _interopRequireDefault(_getNestedFieldValue);

var _index = __webpack_require__(320);

var _index2 = __webpack_require__(321);

var _index3 = __webpack_require__(481);

var _index4 = __webpack_require__(483);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */
var Search = exports.Search = function () {

  /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */


  /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */
  function Search(uidFieldName) {
    _classCallCheck(this, Search);

    if (!uidFieldName) {
      throw Error('js-search requires a uid field name constructor parameter');
    }

    this._uidFieldName = uidFieldName;

    // Set default/recommended strategies
    this._indexStrategy = new _index.PrefixIndexStrategy();
    this._searchIndex = new _index3.TfIdfSearchIndex(uidFieldName);
    this._sanitizer = new _index2.LowerCaseSanitizer();
    this._tokenizer = new _index4.SimpleTokenizer();

    this._documents = [];
    this._searchableFields = [];
  }

  /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */


  _createClass(Search, [{
    key: 'addDocument',


    /**
     * Add a searchable document to the index. Document will automatically be indexed for search.
     * @param document
     */
    value: function addDocument(document) {
      this.addDocuments([document]);
    }

    /**
     * Adds searchable documents to the index. Documents will automatically be indexed for search.
     * @param document
     */

  }, {
    key: 'addDocuments',
    value: function addDocuments(documents) {
      this._documents = this._documents.concat(documents);
      this.indexDocuments_(documents, this._searchableFields);
    }

    /**
     * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
     *
     * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
     */

  }, {
    key: 'addIndex',
    value: function addIndex(field) {
      this._searchableFields.push(field);
      this.indexDocuments_(this._documents, [field]);
    }

    /**
     * Search all documents for ones matching the specified query text.
     * @param query
     * @returns {Array<Object>}
     */

  }, {
    key: 'search',
    value: function search(query) {
      var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));

      return this._searchIndex.search(tokens, this._documents);
    }

    /**
     * @param documents
     * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
     * @private
     */

  }, {
    key: 'indexDocuments_',
    value: function indexDocuments_(documents, _searchableFields) {
      this._initialized = true;

      var indexStrategy = this._indexStrategy;
      var sanitizer = this._sanitizer;
      var searchIndex = this._searchIndex;
      var tokenizer = this._tokenizer;
      var uidFieldName = this._uidFieldName;

      for (var di = 0, numDocuments = documents.length; di < numDocuments; di++) {
        var doc = documents[di];
        var uid;

        if (uidFieldName instanceof Array) {
          uid = (0, _getNestedFieldValue2.default)(doc, uidFieldName);
        } else {
          uid = doc[uidFieldName];
        }

        for (var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++) {
          var fieldValue;
          var searchableField = _searchableFields[sfi];

          if (searchableField instanceof Array) {
            fieldValue = (0, _getNestedFieldValue2.default)(doc, searchableField);
          } else {
            fieldValue = doc[searchableField];
          }

          if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) {
            fieldValue = fieldValue.toString();
          }

          if (typeof fieldValue === 'string') {
            var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));

            for (var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++) {
              var fieldToken = fieldTokens[fti];
              var expandedTokens = indexStrategy.expandToken(fieldToken);

              for (var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++) {
                var expandedToken = expandedTokens[eti];

                searchIndex.indexDocument(expandedToken, uid, doc);
              }
            }
          }
        }
      }
    }
  }, {
    key: 'indexStrategy',
    set: function set(value) {
      if (this._initialized) {
        throw Error('IIndexStrategy cannot be set after initialization');
      }

      this._indexStrategy = value;
    },
    get: function get() {
      return this._indexStrategy;
    }

    /**
     * Override the default text sanitizing strategy.
     * @param value Custom text sanitizing strategy
     * @throws Error if documents have already been indexed by this search instance
     */

  }, {
    key: 'sanitizer',
    set: function set(value) {
      if (this._initialized) {
        throw Error('ISanitizer cannot be set after initialization');
      }

      this._sanitizer = value;
    },
    get: function get() {
      return this._sanitizer;
    }

    /**
     * Override the default search index strategy.
     * @param value Custom search index strategy
     * @throws Error if documents have already been indexed
     */

  }, {
    key: 'searchIndex',
    set: function set(value) {
      if (this._initialized) {
        throw Error('ISearchIndex cannot be set after initialization');
      }

      this._searchIndex = value;
    },
    get: function get() {
      return this._searchIndex;
    }

    /**
     * Override the default text tokenizing strategy.
     * @param value Custom text tokenizing strategy
     * @throws Error if documents have already been indexed by this search instance
     */

  }, {
    key: 'tokenizer',
    set: function set(value) {
      if (this._initialized) {
        throw Error('ITokenizer cannot be set after initialization');
      }

      this._tokenizer = value;
    },
    get: function get() {
      return this._tokenizer;
    }
  }]);

  return Search;
}();
//# sourceMappingURL=Search.js.map

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenHighlighter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(320);

var _index2 = __webpack_require__(321);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */
var TokenHighlighter = exports.TokenHighlighter = function () {

  /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */
  function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
    _classCallCheck(this, TokenHighlighter);

    this._indexStrategy = opt_indexStrategy || new _index.PrefixIndexStrategy();
    this._sanitizer = opt_sanitizer || new _index2.LowerCaseSanitizer();
    this._wrapperTagName = opt_wrapperTagName || 'mark';
  }

  /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */


  _createClass(TokenHighlighter, [{
    key: 'highlight',
    value: function highlight(text, tokens) {
      var tagsLength = this._wrapText('').length;

      var tokenDictionary = {};

      // Create a token map for easier lookup below.
      for (var i = 0, numTokens = tokens.length; i < numTokens; i++) {
        var token = this._sanitizer.sanitize(tokens[i]);
        var expandedTokens = this._indexStrategy.expandToken(token);

        for (var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++) {
          var expandedToken = expandedTokens[j];

          if (!tokenDictionary[expandedToken]) {
            tokenDictionary[expandedToken] = [token];
          } else {
            tokenDictionary[expandedToken].push(token);
          }
        }
      }

      // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
      var actualCurrentWord = '';
      var sanitizedCurrentWord = '';
      var currentWordStartIndex = 0;

      // Note this assumes either prefix or full word matching.
      for (var i = 0, textLength = text.length; i < textLength; i++) {
        var character = text.charAt(i);

        if (character === ' ') {
          actualCurrentWord = '';
          sanitizedCurrentWord = '';
          currentWordStartIndex = i + 1;
        } else {
          actualCurrentWord += character;
          sanitizedCurrentWord += this._sanitizer.sanitize(character);
        }

        if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {

          actualCurrentWord = this._wrapText(actualCurrentWord);
          text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);

          i += tagsLength;
          textLength += tagsLength;
        }
      }

      return text;
    }

    /**
     * @param text to wrap
     * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
     * @private
     */

  }, {
    key: '_wrapText',
    value: function _wrapText(text) {
      var tagName = this._wrapperTagName;
      return '<' + tagName + '>' + text + '</' + tagName + '>';
    }
  }]);

  return TokenHighlighter;
}();

;
//# sourceMappingURL=TokenHighlighter.js.map

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(950),
    baseToString = __webpack_require__(286),
    toInteger = __webpack_require__(241),
    toString = __webpack_require__(108);

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = toString(string);
  target = baseToString(target);

  var length = string.length;
  position = position === undefined
    ? length
    : baseClamp(toInteger(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

module.exports = endsWith;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(486);
var formats = __webpack_require__(487);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(486);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_head__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductReviewWidget__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PriceWrapper__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_ExternalReviewType__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductDescription__ = __webpack_require__(332);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductQuickSearchResult=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductQuickSearchResult,_Component);function ProductQuickSearchResult(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductQuickSearchResult);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductQuickSearchResult.__proto__||Object.getPrototypeOf(ProductQuickSearchResult)).call.apply(_ref,[this].concat(args))),_this),_this.getWitViewRating=function(){var product=_this.props.product;if(!product.external_reviews){return;}return product.external_reviews.find(function(_ref2){var type=_ref2.type;return type===__WEBPACK_IMPORTED_MODULE_10__types_ExternalReviewType__["a" /* default */].WITVIEW;});},_this.shouldUseWitViewRating=function(){var configStore=_this.props.configStore;if(configStore.witView.enabled){var witViewRating=_this.getWitViewRating();if(witViewRating&&witViewRating.reviews_count===0){return false;}return true;}return false;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductQuickSearchResult,[{key:'render',value:function render(){var _props=this.props,product=_props.product,configStore=_props.configStore,hideDescription=_props.hideDescription;var productImage=__WEBPACK_IMPORTED_MODULE_0_lodash_head___default()(product.images);var useWitViewRating=this.shouldUseWitViewRating();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('article',{className:'ProductQuickSearchResult'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductQuickSearchResult__image'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductImage__["a" /* default */],{product:product,size:'small',productImage:productImage,lazyLoading:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,product.multiproduct_title||product.name),!hideDescription&&configStore.productCard.showDescription&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ProductDescription__["a" /* default */],{className:'ProductQuickSearchDescription',product:product}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PriceWrapper__["a" /* default */],{product:product}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductReviewWidget__["a" /* default */],{product:product,useWitViewRating:useWitViewRating,compact:true})));}}]);return ProductQuickSearchResult;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductQuickSearchResult.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_Product__["a" /* default */]).isRequired,hideDescription:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore')(ProductQuickSearchResult));

/***/ }),
/* 954 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(956);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(138);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 957 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(146);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductFile=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductFile',{name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,link:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (ProductFile);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductCollectionProduct__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductMatrix__ = __webpack_require__(189);
var ProductCollectionItem=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductCollectionItem',{column_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,row_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,product:__WEBPACK_IMPORTED_MODULE_1__ProductCollectionProduct__["a" /* default */]}).views(function(self){return{getAvailableAmount:function getAvailableAmount(){return self.product.free_quantity;},canBeOrderedOutOfStock:function canBeOrderedOutOfStock(){return self.product.can_be_ordered_out_of_stock;},getInStockQuantity:function getInStockQuantity(){return self.product.in_stock_quantity;},getIncomingQuantities:function getIncomingQuantities(){return self.product.incoming_quantities;},get collection(){return Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["f" /* getParentOfType */])(self,__WEBPACK_IMPORTED_MODULE_2__ProductMatrix__["a" /* default */]);},get rowName(){if(!self.collection){return'';}var element=self.collection.row.getElementWithId(self.row_id);return element?element.name:'';},get columnName(){if(!self.collection){return'';}var element=self.collection.column.getElementWithId(self.column_id);return element?element.name:'';},get name(){return[self.rowName,self.columnName].filter(function(name){return!!name;}).join(', ');}};});/* harmony default export */ __webpack_exports__["a"] = (ProductCollectionItem);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductCollectionProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductCollectionProduct',{availability_html:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,can_be_ordered_out_of_stock:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,ean:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),free_quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,in_stock_quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),incoming_quantities:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({date:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),free_quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)}))});/* harmony default export */ __webpack_exports__["a"] = (ProductCollectionProduct);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(492),
    baseIteratee = __webpack_require__(84),
    baseLt = __webpack_require__(963);

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
    : undefined;
}

module.exports = minBy;


/***/ }),
/* 963 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(492),
    baseGt = __webpack_require__(965),
    baseIteratee = __webpack_require__(84);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),
/* 965 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ChildProduct;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Product__ = __webpack_require__(18);
function ChildProduct(){return __WEBPACK_IMPORTED_MODULE_0__Product__["a" /* default */].named('ChildProduct');}

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductExtraProperty=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductExtraProperty',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,value_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,value_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (ProductExtraProperty);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductFeature=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductFeature',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (ProductFeature);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductFreeTextField=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductFreeTextField',{name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (ProductFreeTextField);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
var BundleProductInfo=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (BundleProductInfo);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductAdditionalTab=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (ProductAdditionalTab);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
var QuantityDiscount=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('QuantityDiscount',{quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,discount:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (QuantityDiscount);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShippingOption__ = __webpack_require__(190);
var ShippingDetails=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ShippingDetails',{cheapest_option:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__ShippingOption__["a" /* default */]),options:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__ShippingOption__["a" /* default */]),preferred_pickup_option:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__ShippingOption__["a" /* default */])});/* harmony default export */ __webpack_exports__["a"] = (ShippingDetails);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShippingDeliveryTimeTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ShippingDeliveryTimeType={HOURS:'HOURS',BUSINESS_DAYS:'BUSINESS_DAYS',WEEKS:'WEEKS',MONTHS:'MONTHS'};/* unused harmony default export */ var _unused_webpack_default_export = (ShippingDeliveryTimeType);var ShippingDeliveryTimeTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ShippingDeliveryTimeType',Object.values(ShippingDeliveryTimeType));

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_ShippingCampaignType__ = __webpack_require__(497);
var ShippingCampaignInfo=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ShippingCampaignInfo',{end_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),fixed_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */]),free_shipping_price_limit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */]),free_shipping_quantity_limit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),free_shipping_weight_limit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),free_shipping_volume_limit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),priority:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].integer,type:__WEBPACK_IMPORTED_MODULE_2__types_ShippingCampaignType__["a" /* ShippingCampaignTypeType */]});/* harmony default export */ __webpack_exports__["a"] = (ShippingCampaignInfo);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var SizeGuide=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('SizeGuide',{contents:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (SizeGuide);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_ServiceOptionType__ = __webpack_require__(329);
var AdditionalServiceOption=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('AdditionalServiceOption',{selection_text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */],type:__WEBPACK_IMPORTED_MODULE_2__types_ServiceOptionType__["a" /* ServiceOptionTypeType */],image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (AdditionalServiceOption);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdditionalServiceTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var AdditionalServiceType={BASIC:'BASIC',UNIQUE_BATCHES:'UNIQUE_BATCHES'};/* unused harmony default export */ var _unused_webpack_default_export = (AdditionalServiceType);var AdditionalServiceTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('AdditionalServiceType',Object.values(AdditionalServiceType));

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var Year=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Year',{start:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),end:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});var CompatibleModelType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CompatibleModelType',{modelCode:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),manufacturingModel:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});var Car=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Car',{brand:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,model:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,motor:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});var compatibleModel=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('compatibleModel',{car:Car,year:Year,type:CompatibleModelType});var StartaxInfo=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('StartaxInfo',{compatibleModels:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(compatibleModel),[]),alternatives:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),[]),compatibleProducts:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),[]),spareParts:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),[])});/* harmony default export */ __webpack_exports__["a"] = (StartaxInfo);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var RelatedProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('RelatedProduct',{recommended_ids:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),alternative_ids:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (RelatedProduct);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ExternalReview=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ExternalReview',{type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,reviews_count:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,reviews_average:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});/* harmony default export */ __webpack_exports__["a"] = (ExternalReview);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductLicenceTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductLicenceType={NONE:'NONE',ACQUISITION_PERMIT:'ACQUISITION_PERMIT',POSSESSION_PERMIT:'POSSESSION_PERMIT'};/* unused harmony default export */ var _unused_webpack_default_export = (ProductLicenceType);var ProductLicenceTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductLicenceType',Object.values(ProductLicenceType));

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_RecurringOrderCycleType__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductRecurringOrder__ = __webpack_require__(984);
var RecurringOrders=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('RecurringOrders',{cycles:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__types_RecurringOrderCycleType__["a" /* RecurringOrderCycleTypeType */]),orders:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__ProductRecurringOrder__["a" /* default */]),min_custom_cycle:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});/* harmony default export */ __webpack_exports__["a"] = (RecurringOrders);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderShipping__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecurringOrderProduct__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderTotalValue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__ = __webpack_require__(158);
var ProductRecurringOrder=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductRecurringOrder',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),autogenerated_title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,recurring_status:__WEBPACK_IMPORTED_MODULE_4__types_OrderStatusClass__["a" /* OrderStatusType */],allow_under_delivery:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,allow_shipping_method_change:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,on_hold_until:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),delivery_address_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),shipping:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_1__OrderShipping__["a" /* default */],{}),created_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,updated_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,start_at:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_2__RecurringOrderProduct__["a" /* default */]),totals:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_3__OrderTotalValue__["a" /* default */])});/* harmony default export */ __webpack_exports__["a"] = (ProductRecurringOrder);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var PickUpPointInfo=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PickUpPointInfo',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),address:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),contact_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')});/* harmony default export */ __webpack_exports__["a"] = (PickUpPointInfo);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductPriceRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Price__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPriceRange=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductPriceRange,_Component);function ProductPriceRange(){_classCallCheck(this,ProductPriceRange);return _possibleConstructorReturn(this,(ProductPriceRange.__proto__||Object.getPrototypeOf(ProductPriceRange)).apply(this,arguments));}_createClass(ProductPriceRange,[{key:'render',value:function render(){var _props=this.props,range=_props.range,withTax=_props.withTax,showTaxIncludedInfo=_props.showTaxIncludedInfo,isSecondaryPrice=_props.isSecondaryPrice;var showTaxExcludedInfo=!withTax;var showMax=range.min!==range.max;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductPrice ProductPriceRange'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Price__["a" /* default */],{price:range.min.getPrice(withTax),showTaxExcludedInfo:showTaxExcludedInfo&&!showMax,showTaxIncludedInfo:showTaxIncludedInfo&&!showMax,fontSize:isSecondaryPrice}),showMax&&isSecondaryPrice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'PriceRangeRange__price-hyphen'},' - '):' - ',showMax&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Price__["a" /* default */],{price:range.max.getPrice(withTax),showTaxExcludedInfo:showTaxExcludedInfo,showTaxIncludedInfo:showTaxIncludedInfo,fontSize:isSecondaryPrice}));}}]);return ProductPriceRange;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductPriceRange.propTypes={range:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({min:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_ProductPriceInfo__["a" /* default */]).isRequired,max:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_ProductPriceInfo__["a" /* default */]).isRequired}).isRequired,withTax:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,showTaxIncludedInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isSecondaryPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])(function(stores,props){return{withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(ProductPriceRange));

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SuggestionType={SUGGESTION:'SUGGESTION',CATEGORY:'CATEGORY',PRODUCT:'PRODUCT'};/* harmony default export */ __webpack_exports__["a"] = (SuggestionType);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var SearchRedirection=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('SearchRedirection',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,search_terms:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),[]),link:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (SearchRedirection);

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Hamburger=function(_Component){_inherits(Hamburger,_Component);function Hamburger(){_classCallCheck(this,Hamburger);return _possibleConstructorReturn(this,(Hamburger.__proto__||Object.getPrototypeOf(Hamburger)).apply(this,arguments));}_createClass(Hamburger,[{key:'render',value:function render(){var _props=this.props,active=_props.active,className=_props.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('Hamburger','Hamburger--spin',{'is-active':active},className)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Hamburger__box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Hamburger__inner'})));}}]);return Hamburger;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Hamburger.propTypes={className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,active:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};Hamburger.defaultProps={className:''};/* harmony default export */ __webpack_exports__["a"] = (Hamburger);

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_product_ProductPageContent__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_layout_SidebarLayout__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_sidebar_DefaultSidebar__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_ShareButtons__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__services_LocationContext__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_header_NavigationAddToCartRow__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_head_GenericMeta__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__store_TrackingStore__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__types_TrackingPageType__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPage=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductPage,_Component);function ProductPage(props){_classCallCheck(this,ProductPage);var _this=_possibleConstructorReturn(this,(ProductPage.__proto__||Object.getPrototypeOf(ProductPage)).call(this,props));_this.maybeLoadProduct=function(id){var _this$props=_this.props,productStore=_this$props.productStore,productParams=_this$props.productParams,configStore=_this$props.configStore,location=_this$props.location;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var params=null;if(productParams){params=productParams;}else if(location.search){params=Object(__WEBPACK_IMPORTED_MODULE_18__util_queryString__["b" /* parse */])(location.search);}if(ifShoppingCenter&&!window.isSSR||!productStore.productStates.get(id)){productStore.loadProduct(id,params).then(function(fixedId){_this.onProductLoad(fixedId);}).catch(function(e){// Don't make error out of 404 product api response,
// so sentry won't pick it up.
if(e.response&&e.response.status!==404){console.error(e);}});}else{_this.onProductLoad();}};_this.onProductLoad=function(fixedId){var _this$props2=_this.props,analytics=_this$props2.analytics,productStore=_this$props2.productStore,routeService=_this$props2.routeService,match=_this$props2.match;if(fixedId&&!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(match.params.id,fixedId)){_this.navigateTo(routeService.getProductPath(_this.getFixedProduct(fixedId)));}var product=_this.getMatchingProduct();if(product){analytics.productDetail([{product:product,activeProductId:_this.getActiveProductId()}]);productStore.insertLastVisitedProduct(product.id);_this.maybeUpdateActiveCategory();_this.sendTrackingData();}};_this.getActiveHierarchyCategory=function(){var categoryStore=_this.props.categoryStore;var product=_this.getMatchingProduct();// Return only one result.
return product.allCategories.filter(function(category){if(category.id!==product.main_category_id){if(category.hierarchy.findIndex(function(filteredCategory){return filteredCategory.id===categoryStore.latestActiveCategory.id;})!==-1){return true;}}return false;})[0];};_this.getCategoryBySection=function(){var sectionStore=_this.props.sectionStore;var product=_this.getMatchingProduct();// Will return one result if the current hierarchy is not the main one.
return product.allCategories.filter(function(category){if(category.id!==product.main_category_id){if(category.hierarchy.findIndex(function(filteredCategory){return sectionStore.activeSection.includesCategory(filteredCategory);})!==-1){return true;}}return false;})[0];};_this.maybeUpdateActiveCategory=function(){var _this$props3=_this.props,categoryStore=_this$props3.categoryStore,sectionStore=_this$props3.sectionStore;var product=_this.getMatchingProduct();if(product){// Default category is products main category.
var activeCategory=product.main_category_id;if(product.allCategories.length===1){categoryStore.setActiveCategory(activeCategory);return;}var mainCategory=categoryStore.findCategoryById(product.main_category_id);if(categoryStore.latestActiveCategory){var activeIsMainCategory=mainCategory.hierarchy.findIndex(function(category){return category.id===categoryStore.latestActiveCategory.id;})!==-1;// When currently active category is not its main category
// the correct one needs to be scanned from product other categories.
if(!activeIsMainCategory&&product.belongsToCategory(categoryStore.latestActiveCategory.id)){var targetCategory=_this.getActiveHierarchyCategory();if(targetCategory){activeCategory=targetCategory.id;}}}else{if(sectionStore.activeSection){var target=_this.getCategoryBySection();if(target){activeCategory=target.id;}}}categoryStore.setActiveCategory(activeCategory);}};_this.sendTrackingData=function(){var _this$props4=_this.props,trackingStore=_this$props4.trackingStore,categoryStore=_this$props4.categoryStore,configStore=_this$props4.configStore;var product=_this.getMatchingProduct();var actualProduct=product&&product.getActualProduct(_this.getActiveProductId());if(!configStore.activateSpotmore.enabled||typeof document==='undefined'||!actualProduct||!_this.getActiveProductId()){return null;}if(configStore.activateSpotmore.enabled&&window.crmtracker){window.crmtracker.sendData();}trackingStore.setPageView({categoryId:categoryStore.activeCategory?categoryStore.activeCategory.id:null,categoryName:categoryStore.activeCategory?categoryStore.activeCategory.name:null,page:__WEBPACK_IMPORTED_MODULE_32__types_TrackingPageType__["a" /* default */].PRODUCT,parentCategoryId:categoryStore.activeCategory?categoryStore.activeCategory.parent_id:null,productActive:typeof actualProduct!=='undefined',productId:_this.getActiveProductId(),productName:actualProduct.name,refererUrl:document.referrer,visitedUrl:window.location.href});trackingStore.postPageView();};_this.navigateTo=function(path){_this.props.history.replace(path);};_this.redirectToProduct=function(product){var routeService=_this.props.routeService;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* Redirect */],{to:routeService.getProductPath(product)});};_this.setActiveProductId=function(activeProductId,queryParams){var _this$props5=_this.props,match=_this$props5.match,history=_this$props5.history;var params=Object.assign({},match.params,{activeProductId:activeProductId});history.replace(Object(__WEBPACK_IMPORTED_MODULE_18__util_queryString__["a" /* addParametersToPath */])(Object(__WEBPACK_IMPORTED_MODULE_12__util_generatePath__["a" /* default */])(match.path,params),queryParams));};_this.getMatchingProduct=function(fixedId){return _this.props.productStore.products.get(fixedId?fixedId:_this.getProductId());};_this.getFixedProduct=function(fixedId){return _this.props.productStore.products.get(fixedId);};_this.getProductId=function(){return Object(__WEBPACK_IMPORTED_MODULE_29__util_url__["d" /* fixPercentDecodingForParam */])(_this.props.match.params.id);};_this.getActiveProductId=function(){var match=_this.props.match;var product=_this.getMatchingProduct();var activeProductId=void 0;if(product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].COLLECTION){activeProductId=match.params.activeProductId;}else if(product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].MULTI){activeProductId=match.params.activeProductId;}else{activeProductId=product.id;}return Object(__WEBPACK_IMPORTED_MODULE_29__util_url__["d" /* fixPercentDecodingForParam */])(activeProductId);};_this.getShareImageUrl=function(){var locationContext=_this.props.locationContext;var product=_this.getMatchingProduct();if(!product||!product.images||product.images.length===0){return null;}var productImage=product.images[0];return productImage.sizes['full'].length>0&&productImage.sizes['full'].startsWith('http')?productImage.sizes['full']:locationContext.protocol+'//'+locationContext.host+productImage.sizes['full'];};_this.getAdSearchParams=function(){var sectionStore=_this.props.sectionStore;var product=_this.getMatchingProduct();if(!product){return null;}var commonAdParams={};if(sectionStore.activeSection){commonAdParams.section=sectionStore.activeSection.id;}if(product.main_category_id){commonAdParams.category=product.main_category_id;}if(product.manufacturer_id){commonAdParams.manufacturer=product.manufacturer_id;}return commonAdParams;};_this.renderShareButtons=function(media){var locationContext=_this.props.locationContext;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_common_ShareButtons__["a" /* default */],{media:media,url:locationContext.href,title:window.document.title||''});};_this.getManufacturerId=function(){var product=_this.getMatchingProduct();return product&&product.manufacturer&&product.manufacturer.id;};_this.maybeLoadProduct(_this.getProductId());return _this;}_createClass(ProductPage,[{key:'componentDidMount',value:function componentDidMount(){// Another component may have reset the active category, set it always
// after mount.
this.maybeUpdateActiveCategory();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.match.params.id!==this.props.match.params.id){this.maybeLoadProduct(this.getProductId());}if(prevProps.match.params.activeProductId!==this.props.match.params.activeProductId){this.sendTrackingData();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var categoryStore=this.props.categoryStore;// Clean-up active category
categoryStore.setActiveCategory(null);}// TODO
// This function is a workaround for an issue regarding percent encoded
// URLs in React Router and its history library.
// It should be fixed in the next version of history > 4.9.0, which had
// not yet been published at the time of this alternate solution;
// when that version is out, this fix can be removed.
//
// See: https://github.com/ReactTraining/history/issues/505
// The same workaround is also applied here.
},{key:'render',value:function render(){var _this2=this;var _props=this.props,cartStore=_props.cartStore,categoryStore=_props.categoryStore,productStore=_props.productStore,routeService=_props.routeService,sectionStore=_props.sectionStore,location=_props.location,match=_props.match;var product=this.getMatchingProduct();var breadcrumbs=product?routeService.transformBreadCrumbs(product.breadcrumbsForCategory(categoryStore.activeCategory)):[];// If the product does not belong to the active section, redirect.
if(product&&(sectionStore.activeSection&&!product.belongsToSection(sectionStore.activeSection.id)||!sectionStore.activeSection&&product.belongsToSomeSection(sectionStore.sectionIds))){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* Redirect */],{to:routeService.getProductPath(product)});}// If the product is MULTI_CHILD, redirect to parent
if(product&&product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].MULTI_CHILD){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* Redirect */],{to:routeService.getProductPath(product,product.pathWithActiveProductId(product.id))});}if(product){var activeProductId=this.getActiveProductId();var expectedPath=activeProductId&&match.params.activeProductId?product.pathWithActiveProductId(activeProductId):product.path;if(!Object(__WEBPACK_IMPORTED_MODULE_29__util_url__["h" /* pathFragmentMatchesLocation */])(expectedPath,location.pathname)){var url=''+routeService.getProductPath(product,expectedPath)+location.search+location.hash;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* Redirect */],{to:url});}}var adSearchParams=this.getAdSearchParams();var shareImageUrl=this.getShareImageUrl();var shareButtons=this.renderShareButtons(shareImageUrl);// If active collection or multi item is not valid, redirect to parent.
if(product&&product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].COLLECTION){if(this.getActiveProductId()&&!product.collection.getItemWithProductId(this.getActiveProductId())){return this.redirectToProduct(product);}}if(product&&product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].MULTI){if(this.getActiveProductId()&&!product.getActualProduct(this.getActiveProductId())){return this.redirectToProduct(product);}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_35__types_CommonPage__["b" /* default */].PRODUCT,className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()('ProductPage',this.getManufacturerId(product)),onDefinedTrackingPage:__WEBPACK_IMPORTED_MODULE_32__types_TrackingPageType__["a" /* default */].PRODUCT},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_ScrollReset__["a" /* default */],{key:this.getProductId()}),product&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_header_NavigationAddToCartRow__["a" /* default */],{product:product,activeProductId:this.getActiveProductId()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["n" /* Container */],{className:'ProductPage__container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_layout_SidebarLayout__["a" /* default */],{sidebar:product&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_sidebar_DefaultSidebar__["a" /* default */],{bannerSearchParams:adSearchParams}),content:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:breadcrumbs,withGoBackLink:true,rightSide:shareButtons}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_loader_ContentForState__["a" /* default */],{state:productStore.productStates.get(this.getProductId()),error:productStore.lastError,forLoaded:function forLoaded(){var queryParams=Object(__WEBPACK_IMPORTED_MODULE_18__util_queryString__["b" /* parse */])(location.search);var matchingProduct=_this2.getMatchingProduct();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_head_GenericMeta__["a" /* default */],{name:'twitter:card',content:'summary'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_head_GenericMeta__["a" /* default */],{property:'og:image',content:shareImageUrl}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_head_GenericMeta__["a" /* default */],{property:'og:type',content:'product.item'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_product_ProductPageContent__["e" /* default */],{shareButtons:shareButtons,product:matchingProduct,activeProductId:_this2.getActiveProductId(),setActiveProductId:_this2.setActiveProductId,queryParams:queryParams,adSearchParams:adSearchParams,cartLoaded:cartStore.state===__WEBPACK_IMPORTED_MODULE_34__types_RequestState__["b" /* default */].LOADED}));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_ad_ContentPopup__["a" /* default */],{searchParams:adSearchParams}))})));}}]);return ProductPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductPage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_33__store_ConfigStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_20__services_RouteService__["a" /* default */]).isRequired,trackingStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_31__store_TrackingStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_SectionStore__["a" /* default */]),productStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_ProductStore__["a" /* default */]),cartStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_CartStore__["a" /* default */]),categoryStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_CategoryStore__["a" /* default */]),match:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.match.isRequired,history:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.history.isRequired,location:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.location.isRequired,locationContext:__WEBPACK_IMPORTED_MODULE_27__services_LocationContext__["a" /* LocationContextPropType */].isRequired,analytics:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_17__analytics_Analytics__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','routeService','productStore','cartStore','categoryStore','sectionStore','analytics','locationContext','trackingStore')(ProductPage));

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var PageView=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PageView',{categoryId:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),categoryName:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),lang:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),parentCategoryId:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),productActive:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean),productId:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),productName:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),refererUrl:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),visitedUrl:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,'')});/* harmony default export */ __webpack_exports__["a"] = (PageView);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GoBackLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoBackLink=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(GoBackLink,_Component);function GoBackLink(){_classCallCheck(this,GoBackLink);return _possibleConstructorReturn(this,(GoBackLink.__proto__||Object.getPrototypeOf(GoBackLink)).apply(this,arguments));}_createClass(GoBackLink,[{key:'render',value:function render(){var _props=this.props,uiStore=_props.uiStore,history=_props.history;var prefix='/:locale?/:section?';var paths=[prefix+__WEBPACK_IMPORTED_MODULE_6__types_Paths__["a" /* default */].NewProducts,prefix+__WEBPACK_IMPORTED_MODULE_6__types_Paths__["a" /* default */].OnSale,prefix+__WEBPACK_IMPORTED_MODULE_6__types_Paths__["a" /* default */].Category,prefix+__WEBPACK_IMPORTED_MODULE_6__types_Paths__["a" /* default */].Manufacturer,'/:locale?'+__WEBPACK_IMPORTED_MODULE_6__types_Paths__["a" /* default */].Section];var lastPageIsListing=paths.some(function(path){return Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["d" /* matchPath */])(uiStore.lastPathname,{path:path,exact:true});});if(!lastPageIsListing){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'GoBackLink',color:'link',onClick:history.goBack,role:'link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Icon__["a" /* default */],{name:'chevron-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'navigation.goBackLink',defaultMessage:'Back to search results'}));}}]);return GoBackLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;GoBackLink.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_UIStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.history.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('uiStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* withRouter */])(GoBackLink)));

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductImages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Slider__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ProductRotatingImage__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_ImageLightbox__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductImages=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(ProductImages,_Component);function ProductImages(props){_classCallCheck(this,ProductImages);var _this=_possibleConstructorReturn(this,(ProductImages.__proto__||Object.getPrototypeOf(ProductImages)).call(this,props));_initialiseProps.call(_this);var mainImageIndex=props.accountStore.showCartMatrix?_this.findMainImage():0;_this.state={mainImageIndex:mainImageIndex,currentThumbnailSliderIndex:0,lightboxIsOpen:false};return _this;}_createClass(ProductImages,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var product=this.props.product;var mainImageIndex=this.state.mainImageIndex;if(prevState.mainImageIndex!==mainImageIndex){if(this.thumbnailSlider&&!this.thumbnailIsVisible(mainImageIndex)){var slidesPerPage=this.getThumbnailSliderSlidesToShow();var firstSlideOfPageIndex=Math.floor(mainImageIndex/slidesPerPage)*slidesPerPage;var lastNavigatableIndex=product.images.length-slidesPerPage;// slickGoTo does not work if the targetIndex + slidesPerPage is bigger
// than number of available slides.
var goToIndex=Math.min(lastNavigatableIndex,firstSlideOfPageIndex);this.thumbnailSlider.slickGoTo(goToIndex);}if(this.mainImageSlider){this.mainImageSlider.slickGoTo(mainImageIndex,true);}}}},{key:'getMainImage',value:function getMainImage(){var _this2=this;var _props=this.props,product=_props.product,size=_props.size,mainImageOverlay=_props.mainImageOverlay,uiStore=_props.uiStore;var mainImageIndex=this.state.mainImageIndex;var mainImage=void 0;if(product.images.length>0){if(uiStore.isMobile){var sliderSettings={slidesToShow:1,slidesToScroll:1,infinite:false,arrows:false,events:{afterChange:this.mainImageSliderOnAfterChange}};mainImage=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Slider__["a" /* default */],Object.assign({key:product.id,sliderRef:function sliderRef(ref){return _this2.mainImageSlider=ref;}},sliderSettings,{className:'ProductImages__main-image-slider'}),product.images.map(function(productImage){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:productImage.id+'__'+productImage.product_id+'__'+productImage.sizes.full},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductImage__["a" /* default */],{product:product.getActualProduct(productImage.product_id)||product,productImage:productImage,size:size,forceAspectRatio:true,lazyLoading:false}));}));}else{var productImage=product.images[mainImageIndex];mainImage=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductImage__["a" /* default */],{product:product.getActualProduct(productImage.product_id)||product,productImage:productImage,size:size,lazyLoading:false,magnify:true});}}else{mainImage=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductImage__["a" /* default */],{product:product,size:size,lazyLoading:false});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductImages__main-image'},mainImageOverlay,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductImages__main-image-lightbox',onClick:this.toggleLightbox},mainImage));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductImages',{'ProductImages--thumbnails-below':this.shouldShowThumbnailsBelow()})},this.getThumbnails(),this.getLightbox(),this.getMainImage());}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){var mainImageIndex=-1;var isMulti=nextProps.product.class===__WEBPACK_IMPORTED_MODULE_7__types_ProductClass__["b" /* default */].MULTI;if(isMulti&&nextProps.activeProductId){mainImageIndex=nextProps.product.images.findIndex(function(image){return nextProps.activeProductId===image.product_id;});}var isCollection=nextProps.product.class===__WEBPACK_IMPORTED_MODULE_7__types_ProductClass__["b" /* default */].COLLECTION;if(isCollection&&nextProps.activeElementIds){mainImageIndex=nextProps.product.images.findIndex(function(image){return nextProps.activeElementIds.indexOf(image.for_color_id)!==-1;});}if(mainImageIndex>=0){return{mainImageIndex:mainImageIndex};}return null;}}]);return ProductImages;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this3=this;this.thumbnailSlider=null;this.mainImageSlider=null;this.findMainImage=function(){var images=_this3.props.product.images.slice();var sortedImages=__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(images,['for_color_id']);var mainImageIndex=sortedImages.findIndex(function(image){return image.for_color_id===null;});return mainImageIndex!==-1?mainImageIndex:0;};this.toggleLightbox=function(){_this3.setState({lightboxIsOpen:!_this3.state.lightboxIsOpen});};this.thumbnailIsVisible=function(thumbnailIndex){var product=_this3.props.product;var currentThumbnailSliderIndex=_this3.state.currentThumbnailSliderIndex;var pageSize=_this3.getThumbnailSliderSlidesToShow();var lastIndex=product.images.length-1;var currentPageLastSlideIndex=currentThumbnailSliderIndex+pageSize-1;var firstVisibleSlideIndex=void 0;var lastVisibleSlideIndex=void 0;if(currentPageLastSlideIndex>lastIndex){firstVisibleSlideIndex=lastIndex-pageSize+1;lastVisibleSlideIndex=firstVisibleSlideIndex+pageSize-1;}else{firstVisibleSlideIndex=currentThumbnailSliderIndex;lastVisibleSlideIndex=currentPageLastSlideIndex;}return thumbnailIndex>=firstVisibleSlideIndex&&thumbnailIndex<=lastVisibleSlideIndex;};this.getThumbnails=function(){var _props2=_this3.props,product=_props2.product,ifProductRowImages=_props2.ifProductRowImages;if(!product||_this3.getTotalSlidesCount()===0||!ifProductRowImages){return null;}var hasProductImages=product.images&&product.images.length;var thumbnails=_this3.ifFilterDuplicateImages()?_this3.getProductMultiThumbnails(hasProductImages):_this3.getProductThumbnails(hasProductImages);var sliderSettings=_this3.getThumbnailSliderSettings();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductImages__thumbnails'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Slider__["a" /* default */],Object.assign({key:product.id,sliderRef:function sliderRef(ref){return _this3.thumbnailSlider=ref;},arrows:_this3.getTotalSlidesCount()>sliderSettings.slidesToShow},sliderSettings),_this3.getRotatingImagesThumbnails(),thumbnails));};this.getTotalSlidesCount=function(){var product=_this3.props.product;return product?product.images.length+product.rotating_images.length:0;};this.ifFilterDuplicateImages=function(){var _props3=_this3.props,product=_props3.product,configStore=_props3.configStore;return product.class===__WEBPACK_IMPORTED_MODULE_7__types_ProductClass__["b" /* default */].MULTI&&(configStore.product.multiproductAsDropdown||!configStore.product.hideMultiProductSelectionImage);};this.getProductThumbnails=function(hasProductImages){var product=_this3.props.product;return hasProductImages&&product.images.map(function(productImage,index){if(productImage.for_color_id){return null;}return _this3.renderThumbnailSlide(index,productImage);});};this.getProductMultiThumbnails=function(hasProductImages){var product=_this3.props.product;return hasProductImages&&product.images.map(function(productImage,index){var parentImage=_this3.getParentProductImages(productImage.product_id);if(!parentImage){return null;}return _this3.renderThumbnailSlide(index,productImage);});};this.renderThumbnailSlide=function(index,productImage){var product=_this3.props.product;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:productImage.id+'__'+productImage.product_id+'__'+productImage.sizes.full,className:'ProductImages__thumbnail-slide'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductImages__thumbnail',{'ProductImages__thumbnail--active':_this3.state.mainImageIndex===index}),onMouseOver:function onMouseOver(){return _this3.setMainImageIndex(index);},onClick:function onClick(){return _this3.setMainImageIndex(index);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductImage__["a" /* default */],{product:product.getActualProduct(productImage.product_id)||product,productImage:productImage,size:'small',lazyLoading:false,schema:true})));};this.getParentProductImages=function(productImageProductId){return productImageProductId===_this3.props.product.id;};this.getThumbnailSliderSettings=function(){var slidesToShow=_this3.getThumbnailSliderSlidesToShow();var commonSettings={draggable:true,swipeToSlide:true,infinite:false,events:{afterChange:_this3.thumbnailSliderOnAfterChange},slidesToShow:slidesToShow,slidesToScroll:slidesToShow};if(_this3.shouldShowThumbnailsBelow()){return Object.assign({},commonSettings);}else{return Object.assign({},commonSettings,{vertical:true,verticalSwiping:true});}};this.thumbnailSliderOnAfterChange=function(event,slick,currentSlide){return _this3.setState({currentThumbnailSliderIndex:currentSlide});};this.getRotatingImagesThumbnails=function(){var product=_this3.props.product;if(!product||product.rotating_images.length===0){return null;}return product.rotating_images.map(function(filePath){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:filePath,className:'ProductImages__thumbnail-slide'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductImages__thumbnail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ProductRotatingImage__["a" /* default */],{product:product,filePath:filePath})));});};this.setMainImageIndex=function(mainImageIndex){return _this3.setState({mainImageIndex:mainImageIndex});};this.shouldShowThumbnailsBelow=function(){var uiStore=_this3.props.uiStore;return![__WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__["c" /* default */].XL,__WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__["c" /* default */].XXL].includes(uiStore.activeBreakpoint);};this.getThumbnailSliderSlidesToShow=function(){var uiStore=_this3.props.uiStore;switch(uiStore.activeBreakpoint){case __WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__["c" /* default */].XS:return 6;case __WEBPACK_IMPORTED_MODULE_6__types_ViewBreakpoint__["c" /* default */].SM:return 8;default:return 6;}};this.mainImageSliderOnAfterChange=function(event,slick,currentSlide){_this3.setState({mainImageIndex:currentSlide});};this.getLightbox=function(){var _props4=_this3.props,product=_props4.product,accountStore=_props4.accountStore;var mainImageIndex=_this3.state.mainImageIndex;var cartMatrixEnabled=product.class===__WEBPACK_IMPORTED_MODULE_7__types_ProductClass__["b" /* default */].COLLECTION&&accountStore.showCartMatrix;if(product.images.length===0||!_this3.state.lightboxIsOpen||cartMatrixEnabled){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_ImageLightbox__["a" /* default */],{images:product.images,mainImageIndex:mainImageIndex,onClick:_this3.toggleLightbox});};},_temp))||_class;ProductImages.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_UIStore__["a" /* default */]).isRequired,size:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]),mainImageOverlay:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,activeProductId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,activeElementIds:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),ifProductRowImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};ProductImages.defaultProps={ifProductRowImages:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','uiStore','configStore')(ProductImages));

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductRotatingImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductRotatingImageModal__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductRotatingImage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductRotatingImage,_Component);function ProductRotatingImage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductRotatingImage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductRotatingImage.__proto__||Object.getPrototypeOf(ProductRotatingImage)).call.apply(_ref,[this].concat(args))),_this),_this.state={modal:false},_this.toggleModal=function(){_this.setState({modal:!_this.state.modal});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductRotatingImage,[{key:'render',value:function render(){var _props=this.props,product=_props.product,filePath=_props.filePath,configStore=_props.configStore;var style={paddingBottom:configStore.productImageAspectRatio+'%'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style,className:'ProductRotatingImage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProductRotatingImageModal__["a" /* default */],{product:product,filePath:filePath,isOpen:this.state.modal,toggle:this.toggleModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRotatingImage__logo',onClick:this.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRotatingImage__logo-degree'},'360\xB0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRotatingImage__logo-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'global.imageTitle',defaultMessage:'image'}))));}}]);return ProductRotatingImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductRotatingImage.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_Product__["a" /* default */]),filePath:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductRotatingImage));

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductRotatingImageModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductRotatingImageModal=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductRotatingImageModal,_Component);function ProductRotatingImageModal(props){_classCallCheck(this,ProductRotatingImageModal);var _this=_possibleConstructorReturn(this,(ProductRotatingImageModal.__proto__||Object.getPrototypeOf(ProductRotatingImageModal)).call(this,props));_this.bodyEl=null;_this.isTouch=false;_this.updateInterval=false;_this.state={dragging:false,imageIndex:0,dragStartIndex:0};_this.clearRotateInterval=function(){if(_this.updateInterval){clearInterval(_this.updateInterval);_this.updateInterval=false;}};_this.attachListeners=function(){if(_this.bodyEl){_this.bodyEl.addEventListener('touchmove',_this.handleMouseMove,true);_this.bodyEl.addEventListener('mousemove',_this.handleMouseMove,true);}window.addEventListener('touchend',_this.handleMouseUp,true);window.addEventListener('mouseup',_this.handleMouseUp,true);_this.clearRotateInterval();_this.updateInterval=setInterval(_this.maybeGetNextFrame,350);};_this.detachListeners=function(){if(_this.bodyEl){_this.bodyEl.removeEventListener('touchmove',_this.handleMouseMove,true);_this.bodyEl.removeEventListener('mousemove',_this.handleMouseMove,true);}window.removeEventListener('touchend',_this.handleMouseUp,true);window.removeEventListener('mouseup',_this.handleMouseUp,true);_this.clearRotateInterval();};_this.maybeLoadRotatingImagesList=function(){var _this$props=_this.props,product=_this$props.product,filePath=_this$props.filePath,isOpen=_this$props.isOpen;if(product&&isOpen&&product.rotatingImagesListStates&&product.rotatingImagesListStates.get(filePath)===undefined&&product.rotatingImagesListStates.get(filePath)!==__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADING){product.loadRotatingImagesList(filePath);}};_this.maybeGetNextFrame=function(){var dragging=_this.state.dragging;var _this$props2=_this.props,product=_this$props2.product,filePath=_this$props2.filePath,isOpen=_this$props2.isOpen;if(product&&product.rotatingImagesListStates&&product.rotatingImagesListStates.get(filePath)===__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADED&&isOpen&&!dragging){_this.getNextFrame();}};_this.getNextFrame=function(){var imageIndex=_this.state.imageIndex;var product=_this.props.product;if(!product){return;}var nextIndex=(imageIndex+1)%_this.getImageCount();_this.setState({imageIndex:nextIndex});};_this.handleMouseDown=function(e){if(e.type==='touchstart'){_this.isTouch=true;}if(e.type==='mousedown'&&_this.isTouch){return;}if(!_this.isTouch){e.preventDefault();}var _this$props3=_this.props,product=_this$props3.product,filePath=_this$props3.filePath;if(product){_this.setState({dragging:true,dragStart:_this.getScreenX(e),imageIndex:_this.state.imageIndex,dragStartIndex:_this.state.imageIndex,framePixelTarget:360/product.rotatingImagesList.get(filePath).length});}};_this.handleMouseUp=function(e){if(e.type==='touchend'){_this.isTouch=true;}if(e.type==='mouseup'&&_this.isTouch){return;}if(!_this.isTouch){e.preventDefault();}_this.setState({dragging:false});};_this.getScreenX=function(e){return e.type==='touchmove'||e.type==='touchstart'?e.touches[0].screenX:e.screenX;};_this.handleMouseMove=function(e){var _this$state=_this.state,dragging=_this$state.dragging,dragStart=_this$state.dragStart,framePixelTarget=_this$state.framePixelTarget;if(!_this.isTouch){e.preventDefault();}if(!dragging){return;}var screenX=_this.getScreenX(e);var dx=(screenX-dragStart)/framePixelTarget;var index=Math.floor(dx)%_this.getImageCount();if(dragging&&index!==0){window.requestAnimationFrame(function(){_this.updateIndexDragging(index);});}};_this.getImageCount=function(){var _this$props4=_this.props,product=_this$props4.product,filePath=_this$props4.filePath;return product.rotatingImagesList.get(filePath).length;};_this.updateIndexDragging=function(indexChange){var _this$state2=_this.state,imageIndex=_this$state2.imageIndex,dragStartIndex=_this$state2.dragStartIndex;var imageCount=_this.getImageCount();var index=indexChange;if(index<0){index=imageCount+index;}index=(index+dragStartIndex)%imageCount;if(index!==imageIndex){_this.setState({imageIndex:index});}};_this.getImagePath=function(){var _this$props5=_this.props,product=_this$props5.product,filePath=_this$props5.filePath;var imageIndex=_this.state.imageIndex;return product.rotatingImagesList.get(filePath)[imageIndex]!==undefined?product.rotatingImagesList.get(filePath)[imageIndex]:null;};_this.renderImage=function(){var imagePath=_this.getImagePath();return imagePath?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRotatingImageModal__image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imagePath,alt:'360',loading:'lazy'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_UnexpectedError__["a" /* default */],null);};_this.maybeLoadRotatingImagesList();return _this;}_createClass(ProductRotatingImageModal,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){this.maybeLoadRotatingImagesList();if(this.props.isOpen!==prevProps.isOpen){this.props.isOpen?this.attachListeners():this.detachListeners();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,product=_props.product,filePath=_props.filePath,toggle=_props.toggle,isOpen=_props.isOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["C" /* Modal */],{className:'ProductRotatingImageModal',size:'lg',toggle:toggle,isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRotatingImageModal__hanging-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{onClick:function onClick(){return toggle();},color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Icon__["a" /* default */],{name:'times'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].closeTitle)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(el){return _this2.bodyEl=el;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__loader_ContentForState__["a" /* default */],{state:product.rotatingImagesListStates.get(filePath),forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRotatingImageModal__rotating-images',onMouseDown:_this2.handleMouseDown,onTouchStart:_this2.handleMouseDown},_this2.renderImage());}}))));}}]);return ProductRotatingImageModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductRotatingImageModal.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,filePath:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,toggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isOpen:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ProductRotatingImageModal);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);




function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * Placeholder for future translate functionality
 */
function translate(str) {
  var replaceStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!str) {
    return '';
  }

  var translated = str;

  if (replaceStrings) {
    Object.keys(replaceStrings).forEach(function (placeholder) {
      translated = translated.replace(placeholder, replaceStrings[placeholder]);
    });
  }

  return translated;
}
function getWindowWidth() {
  return typeof global.window !== 'undefined' ? global.window.innerWidth : 0;
}
function getWindowHeight() {
  return typeof global.window !== 'undefined' ? global.window.innerHeight : 0;
} // Get the highest window context that isn't cross-origin
// (When in an iframe)

function getHighestSafeWindowContext() {
  var self = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.window.self;
  var referrer = self.document.referrer; // If we reached the top level, return self

  if (self === global.window.top || !referrer) {
    return self;
  }

  var getOrigin = function getOrigin(href) {
    return href.match(/(.*\/\/.*?)(\/|$)/)[1];
  }; // If parent is the same origin, we can move up one context
  // Reference: https://stackoverflow.com/a/21965342/1601953


  if (getOrigin(self.location.href) === getOrigin(referrer)) {
    return getHighestSafeWindowContext(self.parent);
  } // If a different origin, we consider the current level
  // as the top reachable one


  return self;
}

// Min image zoom level
var MIN_ZOOM_LEVEL = 0; // Max image zoom level

var MAX_ZOOM_LEVEL = 300; // Size ratio between previous and next zoom levels

var ZOOM_RATIO = 1.007; // How much to increase/decrease the zoom level when the zoom buttons are clicked

var ZOOM_BUTTON_INCREMENT_SIZE = 100; // Used to judge the amount of horizontal scroll needed to initiate a image move

var WHEEL_MOVE_X_THRESHOLD = 200; // Used to judge the amount of vertical scroll needed to initiate a zoom action

var WHEEL_MOVE_Y_THRESHOLD = 1;
var KEYS = {
  ESC: 27,
  LEFT_ARROW: 37,
  RIGHT_ARROW: 39
}; // Actions

var ACTION_NONE = 0;
var ACTION_MOVE = 1;
var ACTION_SWIPE = 2;
var ACTION_PINCH = 3;

var SOURCE_ANY = 0;
var SOURCE_MOUSE = 1;
var SOURCE_TOUCH = 2;
var SOURCE_POINTER = 3; // Minimal swipe distance

var MIN_SWIPE_DISTANCE = 200;

var ReactImageLightbox =
/*#__PURE__*/
function (_Component) {
  _inherits(ReactImageLightbox, _Component);

  _createClass(ReactImageLightbox, null, [{
    key: "isTargetMatchImage",
    value: function isTargetMatchImage(target) {
      return target && /ril-image-current/.test(target.className);
    }
  }, {
    key: "parseMouseEvent",
    value: function parseMouseEvent(mouseEvent) {
      return {
        id: 'mouse',
        source: SOURCE_MOUSE,
        x: parseInt(mouseEvent.clientX, 10),
        y: parseInt(mouseEvent.clientY, 10)
      };
    }
  }, {
    key: "parseTouchPointer",
    value: function parseTouchPointer(touchPointer) {
      return {
        id: touchPointer.identifier,
        source: SOURCE_TOUCH,
        x: parseInt(touchPointer.clientX, 10),
        y: parseInt(touchPointer.clientY, 10)
      };
    }
  }, {
    key: "parsePointerEvent",
    value: function parsePointerEvent(pointerEvent) {
      return {
        id: pointerEvent.pointerId,
        source: SOURCE_POINTER,
        x: parseInt(pointerEvent.clientX, 10),
        y: parseInt(pointerEvent.clientY, 10)
      };
    } // Request to transition to the previous image

  }, {
    key: "getTransform",
    value: function getTransform(_ref) {
      var _ref$x = _ref.x,
          x = _ref$x === void 0 ? 0 : _ref$x,
          _ref$y = _ref.y,
          y = _ref$y === void 0 ? 0 : _ref$y,
          _ref$zoom = _ref.zoom,
          zoom = _ref$zoom === void 0 ? 1 : _ref$zoom,
          width = _ref.width,
          targetWidth = _ref.targetWidth;
      var nextX = x;
      var windowWidth = getWindowWidth();

      if (width > windowWidth) {
        nextX += (windowWidth - width) / 2;
      }

      var scaleFactor = zoom * (targetWidth / width);
      return {
        transform: "translate3d(".concat(nextX, "px,").concat(y, "px,0) scale3d(").concat(scaleFactor, ",").concat(scaleFactor, ",1)")
      };
    }
  }]);

  function ReactImageLightbox(props) {
    var _this;

    _classCallCheck(this, ReactImageLightbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactImageLightbox).call(this, props));
    _this.state = {
      //-----------------------------
      // Animation
      //-----------------------------
      // Lightbox is closing
      // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
      isClosing: !props.animationDisabled,
      // Component parts should animate (e.g., when images are moving, or image is being zoomed)
      shouldAnimate: false,
      //-----------------------------
      // Zoom settings
      //-----------------------------
      // Zoom level of image
      zoomLevel: MIN_ZOOM_LEVEL,
      //-----------------------------
      // Image position settings
      //-----------------------------
      // Horizontal offset from center
      offsetX: 0,
      // Vertical offset from center
      offsetY: 0,
      // image load error for srcType
      loadErrorStatus: {}
    }; // Refs

    _this.outerEl = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.zoomInBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.zoomOutBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.caption = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.closeIfClickInner = _this.closeIfClickInner.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyInput = _this.handleKeyInput.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTouchMove = _this.handleTouchMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handlePointerEvent = _this.handlePointerEvent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.requestClose = _this.requestClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.requestMoveNext = _this.requestMoveNext.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.requestMovePrev = _this.requestMovePrev.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ReactImageLightbox, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // Timeouts - always clear it before umount
      this.timeouts = []; // Current action

      this.currentAction = ACTION_NONE; // Events source

      this.eventsSource = SOURCE_ANY; // Empty pointers list

      this.pointerList = []; // Prevent inner close

      this.preventInnerClose = false;
      this.preventInnerCloseTimeout = null; // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc

      this.keyPressed = false; // Used to store load state / dimensions of images

      this.imageCache = {}; // Time the last keydown event was called (used in keyboard action rate limiting)

      this.lastKeyDownTime = 0; // Used for debouncing window resize event

      this.resizeTimeout = null; // Used to determine when actions are triggered by the scroll wheel

      this.wheelActionTimeout = null;
      this.resetScrollTimeout = null;
      this.scrollX = 0;
      this.scrollY = 0; // Used in panning zoomed images

      this.moveStartX = 0;
      this.moveStartY = 0;
      this.moveStartOffsetX = 0;
      this.moveStartOffsetY = 0; // Used to swipe

      this.swipeStartX = 0;
      this.swipeStartY = 0;
      this.swipeEndX = 0;
      this.swipeEndY = 0; // Used to pinch

      this.pinchTouchList = null;
      this.pinchDistance = 0; // Used to differentiate between images with identical src

      this.keyCounter = 0; // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)

      this.moveRequested = false;

      if (!this.props.animationDisabled) {
        // Make opening animation play
        this.setState({
          isClosing: false
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Prevents cross-origin errors when using a cross-origin iframe
      this.windowContext = getHighestSafeWindowContext();
      this.listeners = {
        resize: this.handleWindowResize,
        mouseup: this.handleMouseUp,
        touchend: this.handleTouchEnd,
        touchcancel: this.handleTouchEnd,
        pointerdown: this.handlePointerEvent,
        pointermove: this.handlePointerEvent,
        pointerup: this.handlePointerEvent,
        pointercancel: this.handlePointerEvent
      };
      Object.keys(this.listeners).forEach(function (type) {
        _this2.windowContext.addEventListener(type, _this2.listeners[type]);
      });
      this.loadAllImages();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // Iterate through the source types for prevProps and nextProps to
      //  determine if any of the sources changed
      var sourcesChanged = false;
      var prevSrcDict = {};
      var nextSrcDict = {};
      this.getSrcTypes().forEach(function (srcType) {
        if (_this3.props[srcType.name] !== nextProps[srcType.name]) {
          sourcesChanged = true;
          prevSrcDict[_this3.props[srcType.name]] = true;
          nextSrcDict[nextProps[srcType.name]] = true;
        }
      });

      if (sourcesChanged || this.moveRequested) {
        // Reset the loaded state for images not rendered next
        Object.keys(prevSrcDict).forEach(function (prevSrc) {
          if (!(prevSrc in nextSrcDict) && prevSrc in _this3.imageCache) {
            _this3.imageCache[prevSrc].loaded = false;
          }
        });
        this.moveRequested = false; // Load any new images

        this.loadAllImages(nextProps);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      // Wait for move...
      return !this.moveRequested;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this4 = this;

      this.didUnmount = true;
      Object.keys(this.listeners).forEach(function (type) {
        _this4.windowContext.removeEventListener(type, _this4.listeners[type]);
      });
      this.timeouts.forEach(function (tid) {
        return clearTimeout(tid);
      });
    }
  }, {
    key: "setTimeout",
    value: function (_setTimeout) {
      function setTimeout(_x, _x2) {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function (func, time) {
      var _this5 = this;

      var id = setTimeout(function () {
        _this5.timeouts = _this5.timeouts.filter(function (tid) {
          return tid !== id;
        });
        func();
      }, time);
      this.timeouts.push(id);
      return id;
    })
  }, {
    key: "setPreventInnerClose",
    value: function setPreventInnerClose() {
      var _this6 = this;

      if (this.preventInnerCloseTimeout) {
        this.clearTimeout(this.preventInnerCloseTimeout);
      }

      this.preventInnerClose = true;
      this.preventInnerCloseTimeout = this.setTimeout(function () {
        _this6.preventInnerClose = false;
        _this6.preventInnerCloseTimeout = null;
      }, 100);
    } // Get info for the best suited image to display with the given srcType

  }, {
    key: "getBestImageForType",
    value: function getBestImageForType(srcType) {
      var imageSrc = this.props[srcType];
      var fitSizes = {};

      if (this.isImageLoaded(imageSrc)) {
        // Use full-size image if available
        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height);
      } else if (this.isImageLoaded(this.props["".concat(srcType, "Thumbnail")])) {
        // Fall back to using thumbnail if the image has not been loaded
        imageSrc = this.props["".concat(srcType, "Thumbnail")];
        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, true);
      } else {
        return null;
      }

      return {
        src: imageSrc,
        height: this.imageCache[imageSrc].height,
        width: this.imageCache[imageSrc].width,
        targetHeight: fitSizes.height,
        targetWidth: fitSizes.width
      };
    } // Get sizing for when an image is larger than the window

  }, {
    key: "getFitSizes",
    value: function getFitSizes(width, height, stretch) {
      var boxSize = this.getLightboxRect();
      var maxHeight = boxSize.height - this.props.imagePadding * 2;
      var maxWidth = boxSize.width - this.props.imagePadding * 2;

      if (!stretch) {
        maxHeight = Math.min(maxHeight, height);
        maxWidth = Math.min(maxWidth, width);
      }

      var maxRatio = maxWidth / maxHeight;
      var srcRatio = width / height;

      if (maxRatio > srcRatio) {
        // height is the constraining dimension of the photo
        return {
          width: width * maxHeight / height,
          height: maxHeight
        };
      }

      return {
        width: maxWidth,
        height: height * maxWidth / width
      };
    }
  }, {
    key: "getMaxOffsets",
    value: function getMaxOffsets() {
      var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
      var currentImageInfo = this.getBestImageForType('mainSrc');

      if (currentImageInfo === null) {
        return {
          maxX: 0,
          minX: 0,
          maxY: 0,
          minY: 0
        };
      }

      var boxSize = this.getLightboxRect();
      var zoomMultiplier = this.getZoomMultiplier(zoomLevel);
      var maxX = 0;

      if (zoomMultiplier * currentImageInfo.width - boxSize.width < 0) {
        // if there is still blank space in the X dimension, don't limit except to the opposite edge
        maxX = (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2;
      } else {
        maxX = (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2;
      }

      var maxY = 0;

      if (zoomMultiplier * currentImageInfo.height - boxSize.height < 0) {
        // if there is still blank space in the Y dimension, don't limit except to the opposite edge
        maxY = (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2;
      } else {
        maxY = (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2;
      }

      return {
        maxX: maxX,
        maxY: maxY,
        minX: -1 * maxX,
        minY: -1 * maxY
      };
    } // Get image src types

  }, {
    key: "getSrcTypes",
    value: function getSrcTypes() {
      return [{
        name: 'mainSrc',
        keyEnding: "i".concat(this.keyCounter)
      }, {
        name: 'mainSrcThumbnail',
        keyEnding: "t".concat(this.keyCounter)
      }, {
        name: 'nextSrc',
        keyEnding: "i".concat(this.keyCounter + 1)
      }, {
        name: 'nextSrcThumbnail',
        keyEnding: "t".concat(this.keyCounter + 1)
      }, {
        name: 'prevSrc',
        keyEnding: "i".concat(this.keyCounter - 1)
      }, {
        name: 'prevSrcThumbnail',
        keyEnding: "t".concat(this.keyCounter - 1)
      }];
    }
    /**
     * Get sizing when the image is scaled
     */

  }, {
    key: "getZoomMultiplier",
    value: function getZoomMultiplier() {
      var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
      return Math.pow(ZOOM_RATIO, zoomLevel);
    }
    /**
     * Get the size of the lightbox in pixels
     */

  }, {
    key: "getLightboxRect",
    value: function getLightboxRect() {
      if (this.outerEl.current) {
        return this.outerEl.current.getBoundingClientRect();
      }

      return {
        width: getWindowWidth(),
        height: getWindowHeight(),
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
    }
  }, {
    key: "clearTimeout",
    value: function (_clearTimeout) {
      function clearTimeout(_x3) {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function (id) {
      this.timeouts = this.timeouts.filter(function (tid) {
        return tid !== id;
      });
      clearTimeout(id);
    }) // Change zoom level

  }, {
    key: "changeZoom",
    value: function changeZoom(zoomLevel, clientX, clientY) {
      // Ignore if zoom disabled
      if (!this.props.enableZoom) {
        return;
      } // Constrain zoom level to the set bounds


      var nextZoomLevel = Math.max(MIN_ZOOM_LEVEL, Math.min(MAX_ZOOM_LEVEL, zoomLevel)); // Ignore requests that don't change the zoom level

      if (nextZoomLevel === this.state.zoomLevel) {
        return;
      }

      if (nextZoomLevel === MIN_ZOOM_LEVEL) {
        // Snap back to center if zoomed all the way out
        this.setState({
          zoomLevel: nextZoomLevel,
          offsetX: 0,
          offsetY: 0
        });
        return;
      }

      var imageBaseSize = this.getBestImageForType('mainSrc');

      if (imageBaseSize === null) {
        return;
      }

      var currentZoomMultiplier = this.getZoomMultiplier();
      var nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel); // Default to the center of the image to zoom when no mouse position specified

      var boxRect = this.getLightboxRect();
      var pointerX = typeof clientX !== 'undefined' ? clientX - boxRect.left : boxRect.width / 2;
      var pointerY = typeof clientY !== 'undefined' ? clientY - boxRect.top : boxRect.height / 2;
      var currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2;
      var currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2;
      var currentImageRealOffsetX = currentImageOffsetX - this.state.offsetX;
      var currentImageRealOffsetY = currentImageOffsetY - this.state.offsetY;
      var currentPointerXRelativeToImage = (pointerX - currentImageRealOffsetX) / currentZoomMultiplier;
      var currentPointerYRelativeToImage = (pointerY - currentImageRealOffsetY) / currentZoomMultiplier;
      var nextImageRealOffsetX = pointerX - currentPointerXRelativeToImage * nextZoomMultiplier;
      var nextImageRealOffsetY = pointerY - currentPointerYRelativeToImage * nextZoomMultiplier;
      var nextImageOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2;
      var nextImageOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2;
      var nextOffsetX = nextImageOffsetX - nextImageRealOffsetX;
      var nextOffsetY = nextImageOffsetY - nextImageRealOffsetY; // When zooming out, limit the offset so things don't get left askew

      if (this.currentAction !== ACTION_PINCH) {
        var maxOffsets = this.getMaxOffsets();

        if (this.state.zoomLevel > nextZoomLevel) {
          nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX));
          nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY));
        }
      }

      this.setState({
        zoomLevel: nextZoomLevel,
        offsetX: nextOffsetX,
        offsetY: nextOffsetY
      });
    }
  }, {
    key: "closeIfClickInner",
    value: function closeIfClickInner(event) {
      if (!this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1) {
        this.requestClose(event);
      }
    }
    /**
     * Handle user keyboard actions
     */

  }, {
    key: "handleKeyInput",
    value: function handleKeyInput(event) {
      event.stopPropagation(); // Ignore key input during animations

      if (this.isAnimating()) {
        return;
      } // Allow slightly faster navigation through the images when user presses keys repeatedly


      if (event.type === 'keyup') {
        this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus;
        return;
      }

      var keyCode = event.which || event.keyCode; // Ignore key presses that happen too close to each other (when rapid fire key pressing or holding down the key)
      // But allow it if it's a lightbox closing action

      var currentTime = new Date();

      if (currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== KEYS.ESC) {
        return;
      }

      this.lastKeyDownTime = currentTime.getTime();

      switch (keyCode) {
        // ESC key closes the lightbox
        case KEYS.ESC:
          event.preventDefault();
          this.requestClose(event);
          break;
        // Left arrow key moves to previous image

        case KEYS.LEFT_ARROW:
          if (!this.props.prevSrc) {
            return;
          }

          event.preventDefault();
          this.keyPressed = true;
          this.requestMovePrev(event);
          break;
        // Right arrow key moves to next image

        case KEYS.RIGHT_ARROW:
          if (!this.props.nextSrc) {
            return;
          }

          event.preventDefault();
          this.keyPressed = true;
          this.requestMoveNext(event);
          break;
      }
    }
    /**
     * Handle a mouse wheel event over the lightbox container
     */

  }, {
    key: "handleOuterMousewheel",
    value: function handleOuterMousewheel(event) {
      var _this7 = this;

      // Prevent scrolling of the background
      event.stopPropagation();
      var xThreshold = WHEEL_MOVE_X_THRESHOLD;
      var actionDelay = 0;
      var imageMoveDelay = 500;
      this.clearTimeout(this.resetScrollTimeout);
      this.resetScrollTimeout = this.setTimeout(function () {
        _this7.scrollX = 0;
        _this7.scrollY = 0;
      }, 300); // Prevent rapid-fire zoom behavior

      if (this.wheelActionTimeout !== null || this.isAnimating()) {
        return;
      }

      if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
        // handle horizontal scrolls with image moves
        this.scrollY = 0;
        this.scrollX += event.deltaX;
        var bigLeapX = xThreshold / 2; // If the scroll amount has accumulated sufficiently, or a large leap was taken

        if (this.scrollX >= xThreshold || event.deltaX >= bigLeapX) {
          // Scroll right moves to next
          this.requestMoveNext(event);
          actionDelay = imageMoveDelay;
          this.scrollX = 0;
        } else if (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) {
          // Scroll left moves to previous
          this.requestMovePrev(event);
          actionDelay = imageMoveDelay;
          this.scrollX = 0;
        }
      } // Allow successive actions after the set delay


      if (actionDelay !== 0) {
        this.wheelActionTimeout = this.setTimeout(function () {
          _this7.wheelActionTimeout = null;
        }, actionDelay);
      }
    }
  }, {
    key: "handleImageMouseWheel",
    value: function handleImageMouseWheel(event) {
      var yThreshold = WHEEL_MOVE_Y_THRESHOLD;

      if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
        event.stopPropagation(); // If the vertical scroll amount was large enough, perform a zoom

        if (Math.abs(event.deltaY) < yThreshold) {
          return;
        }

        this.scrollX = 0;
        this.scrollY += event.deltaY;
        this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
      }
    }
    /**
     * Handle a double click on the current image
     */

  }, {
    key: "handleImageDoubleClick",
    value: function handleImageDoubleClick(event) {
      if (this.state.zoomLevel > MIN_ZOOM_LEVEL) {
        // A double click when zoomed in zooms all the way out
        this.changeZoom(MIN_ZOOM_LEVEL, event.clientX, event.clientY);
      } else {
        // A double click when zoomed all the way out zooms in
        this.changeZoom(this.state.zoomLevel + ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
      }
    }
  }, {
    key: "shouldHandleEvent",
    value: function shouldHandleEvent(source) {
      if (this.eventsSource === source) {
        return true;
      }

      if (this.eventsSource === SOURCE_ANY) {
        this.eventsSource = source;
        return true;
      }

      switch (source) {
        case SOURCE_MOUSE:
          return false;

        case SOURCE_TOUCH:
          this.eventsSource = SOURCE_TOUCH;
          this.filterPointersBySource();
          return true;

        case SOURCE_POINTER:
          if (this.eventsSource === SOURCE_MOUSE) {
            this.eventsSource = SOURCE_POINTER;
            this.filterPointersBySource();
            return true;
          }

          return false;

        default:
          return false;
      }
    }
  }, {
    key: "addPointer",
    value: function addPointer(pointer) {
      this.pointerList.push(pointer);
    }
  }, {
    key: "removePointer",
    value: function removePointer(pointer) {
      this.pointerList = this.pointerList.filter(function (_ref2) {
        var id = _ref2.id;
        return id !== pointer.id;
      });
    }
  }, {
    key: "filterPointersBySource",
    value: function filterPointersBySource() {
      var _this8 = this;

      this.pointerList = this.pointerList.filter(function (_ref3) {
        var source = _ref3.source;
        return source === _this8.eventsSource;
      });
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      if (this.shouldHandleEvent(SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target)) {
        this.addPointer(ReactImageLightbox.parseMouseEvent(event));
        this.multiPointerStart(event);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      if (this.shouldHandleEvent(SOURCE_MOUSE)) {
        this.multiPointerMove(event, [ReactImageLightbox.parseMouseEvent(event)]);
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      if (this.shouldHandleEvent(SOURCE_MOUSE)) {
        this.removePointer(ReactImageLightbox.parseMouseEvent(event));
        this.multiPointerEnd(event);
      }
    }
  }, {
    key: "handlePointerEvent",
    value: function handlePointerEvent(event) {
      if (this.shouldHandleEvent(SOURCE_POINTER)) {
        switch (event.type) {
          case 'pointerdown':
            if (ReactImageLightbox.isTargetMatchImage(event.target)) {
              this.addPointer(ReactImageLightbox.parsePointerEvent(event));
              this.multiPointerStart(event);
            }

            break;

          case 'pointermove':
            this.multiPointerMove(event, [ReactImageLightbox.parsePointerEvent(event)]);
            break;

          case 'pointerup':
          case 'pointercancel':
            this.removePointer(ReactImageLightbox.parsePointerEvent(event));
            this.multiPointerEnd(event);
            break;
        }
      }
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(event) {
      var _this9 = this;

      if (this.shouldHandleEvent(SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target)) {
        [].forEach.call(event.changedTouches, function (eventTouch) {
          return _this9.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
        });
        this.multiPointerStart(event);
      }
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(event) {
      if (this.shouldHandleEvent(SOURCE_TOUCH)) {
        this.multiPointerMove(event, [].map.call(event.changedTouches, function (eventTouch) {
          return ReactImageLightbox.parseTouchPointer(eventTouch);
        }));
      }
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(event) {
      var _this10 = this;

      if (this.shouldHandleEvent(SOURCE_TOUCH)) {
        [].map.call(event.changedTouches, function (touch) {
          return _this10.removePointer(ReactImageLightbox.parseTouchPointer(touch));
        });
        this.multiPointerEnd(event);
      }
    }
  }, {
    key: "decideMoveOrSwipe",
    value: function decideMoveOrSwipe(pointer) {
      if (this.state.zoomLevel <= MIN_ZOOM_LEVEL) {
        this.handleSwipeStart(pointer);
      } else {
        this.handleMoveStart(pointer);
      }
    }
  }, {
    key: "multiPointerStart",
    value: function multiPointerStart(event) {
      this.handleEnd(null);

      switch (this.pointerList.length) {
        case 1:
          {
            event.preventDefault();
            this.decideMoveOrSwipe(this.pointerList[0]);
            break;
          }

        case 2:
          {
            event.preventDefault();
            this.handlePinchStart(this.pointerList);
            break;
          }
      }
    }
  }, {
    key: "multiPointerMove",
    value: function multiPointerMove(event, pointerList) {
      switch (this.currentAction) {
        case ACTION_MOVE:
          {
            event.preventDefault();
            this.handleMove(pointerList[0]);
            break;
          }

        case ACTION_SWIPE:
          {
            event.preventDefault();
            this.handleSwipe(pointerList[0]);
            break;
          }

        case ACTION_PINCH:
          {
            event.preventDefault();
            this.handlePinch(pointerList);
            break;
          }
      }
    }
  }, {
    key: "multiPointerEnd",
    value: function multiPointerEnd(event) {
      if (this.currentAction !== ACTION_NONE) {
        this.setPreventInnerClose();
        this.handleEnd(event);
      }

      switch (this.pointerList.length) {
        case 0:
          {
            this.eventsSource = SOURCE_ANY;
            break;
          }

        case 1:
          {
            event.preventDefault();
            this.decideMoveOrSwipe(this.pointerList[0]);
            break;
          }

        case 2:
          {
            event.preventDefault();
            this.handlePinchStart(this.pointerList);
            break;
          }
      }
    }
  }, {
    key: "handleEnd",
    value: function handleEnd(event) {
      switch (this.currentAction) {
        case ACTION_MOVE:
          this.handleMoveEnd(event);
          break;

        case ACTION_SWIPE:
          this.handleSwipeEnd(event);
          break;

        case ACTION_PINCH:
          this.handlePinchEnd(event);
          break;
      }
    } // Handle move start over the lightbox container
    // This happens:
    // - On a mouseDown event
    // - On a touchstart event

  }, {
    key: "handleMoveStart",
    value: function handleMoveStart(_ref4) {
      var clientX = _ref4.x,
          clientY = _ref4.y;

      if (!this.props.enableZoom) {
        return;
      }

      this.currentAction = ACTION_MOVE;
      this.moveStartX = clientX;
      this.moveStartY = clientY;
      this.moveStartOffsetX = this.state.offsetX;
      this.moveStartOffsetY = this.state.offsetY;
    } // Handle dragging over the lightbox container
    // This happens:
    // - After a mouseDown and before a mouseUp event
    // - After a touchstart and before a touchend event

  }, {
    key: "handleMove",
    value: function handleMove(_ref5) {
      var clientX = _ref5.x,
          clientY = _ref5.y;
      var newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX;
      var newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;

      if (this.state.offsetX !== newOffsetX || this.state.offsetY !== newOffsetY) {
        this.setState({
          offsetX: newOffsetX,
          offsetY: newOffsetY
        });
      }
    }
  }, {
    key: "handleMoveEnd",
    value: function handleMoveEnd() {
      var _this11 = this;

      this.currentAction = ACTION_NONE;
      this.moveStartX = 0;
      this.moveStartY = 0;
      this.moveStartOffsetX = 0;
      this.moveStartOffsetY = 0; // Snap image back into frame if outside max offset range

      var maxOffsets = this.getMaxOffsets();
      var nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX));
      var nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));

      if (nextOffsetX !== this.state.offsetX || nextOffsetY !== this.state.offsetY) {
        this.setState({
          offsetX: nextOffsetX,
          offsetY: nextOffsetY,
          shouldAnimate: true
        });
        this.setTimeout(function () {
          _this11.setState({
            shouldAnimate: false
          });
        }, this.props.animationDuration);
      }
    }
  }, {
    key: "handleSwipeStart",
    value: function handleSwipeStart(_ref6) {
      var clientX = _ref6.x,
          clientY = _ref6.y;
      this.currentAction = ACTION_SWIPE;
      this.swipeStartX = clientX;
      this.swipeStartY = clientY;
      this.swipeEndX = clientX;
      this.swipeEndY = clientY;
    }
  }, {
    key: "handleSwipe",
    value: function handleSwipe(_ref7) {
      var clientX = _ref7.x,
          clientY = _ref7.y;
      this.swipeEndX = clientX;
      this.swipeEndY = clientY;
    }
  }, {
    key: "handleSwipeEnd",
    value: function handleSwipeEnd(event) {
      var xDiff = this.swipeEndX - this.swipeStartX;
      var xDiffAbs = Math.abs(xDiff);
      var yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
      this.currentAction = ACTION_NONE;
      this.swipeStartX = 0;
      this.swipeStartY = 0;
      this.swipeEndX = 0;
      this.swipeEndY = 0;

      if (!event || this.isAnimating() || xDiffAbs < yDiffAbs * 1.5) {
        return;
      }

      if (xDiffAbs < MIN_SWIPE_DISTANCE) {
        var boxRect = this.getLightboxRect();

        if (xDiffAbs < boxRect.width / 4) {
          return;
        }
      }

      if (xDiff > 0 && this.props.prevSrc) {
        event.preventDefault();
        this.requestMovePrev();
      } else if (xDiff < 0 && this.props.nextSrc) {
        event.preventDefault();
        this.requestMoveNext();
      }
    }
  }, {
    key: "calculatePinchDistance",
    value: function calculatePinchDistance() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList,
          _ref9 = _slicedToArray(_ref8, 2),
          a = _ref9[0],
          b = _ref9[1];

      return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
    }
  }, {
    key: "calculatePinchCenter",
    value: function calculatePinchCenter() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList,
          _ref11 = _slicedToArray(_ref10, 2),
          a = _ref11[0],
          b = _ref11[1];

      return {
        x: a.x - (a.x - b.x) / 2,
        y: a.y - (a.y - b.y) / 2
      };
    }
  }, {
    key: "handlePinchStart",
    value: function handlePinchStart(pointerList) {
      if (!this.props.enableZoom) {
        return;
      }

      this.currentAction = ACTION_PINCH;
      this.pinchTouchList = pointerList.map(function (_ref12) {
        var id = _ref12.id,
            x = _ref12.x,
            y = _ref12.y;
        return {
          id: id,
          x: x,
          y: y
        };
      });
      this.pinchDistance = this.calculatePinchDistance();
    }
  }, {
    key: "handlePinch",
    value: function handlePinch(pointerList) {
      this.pinchTouchList = this.pinchTouchList.map(function (oldPointer) {
        for (var i = 0; i < pointerList.length; i += 1) {
          if (pointerList[i].id === oldPointer.id) {
            return pointerList[i];
          }
        }

        return oldPointer;
      });
      var newDistance = this.calculatePinchDistance();
      var zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
      this.pinchDistance = newDistance;

      var _this$calculatePinchC = this.calculatePinchCenter(this.pinchTouchList),
          clientX = _this$calculatePinchC.x,
          clientY = _this$calculatePinchC.y;

      this.changeZoom(zoomLevel, clientX, clientY);
    }
  }, {
    key: "handlePinchEnd",
    value: function handlePinchEnd() {
      this.currentAction = ACTION_NONE;
      this.pinchTouchList = null;
      this.pinchDistance = 0;
    } // Handle the window resize event

  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      this.clearTimeout(this.resizeTimeout);
      this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
    }
  }, {
    key: "handleZoomInButtonClick",
    value: function handleZoomInButtonClick() {
      var nextZoomLevel = this.state.zoomLevel + ZOOM_BUTTON_INCREMENT_SIZE;
      this.changeZoom(nextZoomLevel);

      if (nextZoomLevel === MAX_ZOOM_LEVEL) {
        this.zoomOutBtn.current.focus();
      }
    }
  }, {
    key: "handleZoomOutButtonClick",
    value: function handleZoomOutButtonClick() {
      var nextZoomLevel = this.state.zoomLevel - ZOOM_BUTTON_INCREMENT_SIZE;
      this.changeZoom(nextZoomLevel);

      if (nextZoomLevel === MIN_ZOOM_LEVEL) {
        this.zoomInBtn.current.focus();
      }
    }
  }, {
    key: "handleCaptionMousewheel",
    value: function handleCaptionMousewheel(event) {
      event.stopPropagation();

      if (!this.caption.current) {
        return;
      }

      var _this$caption$current = this.caption.current.getBoundingClientRect(),
          height = _this$caption$current.height;

      var _this$caption$current2 = this.caption.current,
          scrollHeight = _this$caption$current2.scrollHeight,
          scrollTop = _this$caption$current2.scrollTop;

      if (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) {
        event.preventDefault();
      }
    } // Detach key and mouse input events

  }, {
    key: "isAnimating",
    value: function isAnimating() {
      return this.state.shouldAnimate || this.state.isClosing;
    } // Check if image is loaded

  }, {
    key: "isImageLoaded",
    value: function isImageLoaded(imageSrc) {
      return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
    } // Load image from src and call callback with image width and height on load

  }, {
    key: "loadImage",
    value: function loadImage(srcType, imageSrc, done) {
      var _this12 = this;

      // Return the image info if it is already cached
      if (this.isImageLoaded(imageSrc)) {
        this.setTimeout(function () {
          done();
        }, 1);
        return;
      }

      var inMemoryImage = new global.Image();

      if (this.props.imageCrossOrigin) {
        inMemoryImage.crossOrigin = this.props.imageCrossOrigin;
      }

      inMemoryImage.onerror = function (errorEvent) {
        _this12.props.onImageLoadError(imageSrc, srcType, errorEvent); // failed to load so set the state loadErrorStatus


        _this12.setState(function (prevState) {
          return {
            loadErrorStatus: _objectSpread({}, prevState.loadErrorStatus, _defineProperty({}, srcType, true))
          };
        });

        done(errorEvent);
      };

      inMemoryImage.onload = function () {
        _this12.props.onImageLoad(imageSrc, srcType, inMemoryImage);

        _this12.imageCache[imageSrc] = {
          loaded: true,
          width: inMemoryImage.width,
          height: inMemoryImage.height
        };
        done();
      };

      inMemoryImage.src = imageSrc;
    } // Load all images and their thumbnails

  }, {
    key: "loadAllImages",
    value: function loadAllImages() {
      var _this13 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var generateLoadDoneCallback = function generateLoadDoneCallback(srcType, imageSrc) {
        return function (err) {
          // Give up showing image on error
          if (err) {
            return;
          } // Don't rerender if the src is not the same as when the load started
          // or if the component has unmounted


          if (_this13.props[srcType] !== imageSrc || _this13.didUnmount) {
            return;
          } // Force rerender with the new image


          _this13.forceUpdate();
        };
      }; // Load the images


      this.getSrcTypes().forEach(function (srcType) {
        var type = srcType.name; // there is no error when we try to load it initially

        if (props[type] && _this13.state.loadErrorStatus[type]) {
          _this13.setState(function (prevState) {
            return {
              loadErrorStatus: _objectSpread({}, prevState.loadErrorStatus, _defineProperty({}, type, false))
            };
          });
        } // Load unloaded images


        if (props[type] && !_this13.isImageLoaded(props[type])) {
          _this13.loadImage(type, props[type], generateLoadDoneCallback(type, props[type]));
        }
      });
    } // Request that the lightbox be closed

  }, {
    key: "requestClose",
    value: function requestClose(event) {
      var _this14 = this;

      // Call the parent close request
      var closeLightbox = function closeLightbox() {
        return _this14.props.onCloseRequest(event);
      };

      if (this.props.animationDisabled || event.type === 'keydown' && !this.props.animationOnKeyInput) {
        // No animation
        closeLightbox();
        return;
      } // With animation
      // Start closing animation


      this.setState({
        isClosing: true
      }); // Perform the actual closing at the end of the animation

      this.setTimeout(closeLightbox, this.props.animationDuration);
    }
  }, {
    key: "requestMove",
    value: function requestMove(direction, event) {
      var _this15 = this;

      // Reset the zoom level on image move
      var nextState = {
        zoomLevel: MIN_ZOOM_LEVEL,
        offsetX: 0,
        offsetY: 0
      }; // Enable animated states

      if (!this.props.animationDisabled && (!this.keyPressed || this.props.animationOnKeyInput)) {
        nextState.shouldAnimate = true;
        this.setTimeout(function () {
          return _this15.setState({
            shouldAnimate: false
          });
        }, this.props.animationDuration);
      }

      this.keyPressed = false;
      this.moveRequested = true;

      if (direction === 'prev') {
        this.keyCounter -= 1;
        this.setState(nextState);
        this.props.onMovePrevRequest(event);
      } else {
        this.keyCounter += 1;
        this.setState(nextState);
        this.props.onMoveNextRequest(event);
      }
    } // Request to transition to the next image

  }, {
    key: "requestMoveNext",
    value: function requestMoveNext(event) {
      this.requestMove('next', event);
    } // Request to transition to the previous image

  }, {
    key: "requestMovePrev",
    value: function requestMovePrev(event) {
      this.requestMove('prev', event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this16 = this;

      var _this$props = this.props,
          animationDisabled = _this$props.animationDisabled,
          animationDuration = _this$props.animationDuration,
          clickOutsideToClose = _this$props.clickOutsideToClose,
          discourageDownloads = _this$props.discourageDownloads,
          enableZoom = _this$props.enableZoom,
          imageTitle = _this$props.imageTitle,
          nextSrc = _this$props.nextSrc,
          prevSrc = _this$props.prevSrc,
          toolbarButtons = _this$props.toolbarButtons,
          reactModalStyle = _this$props.reactModalStyle,
          _onAfterOpen = _this$props.onAfterOpen,
          imageCrossOrigin = _this$props.imageCrossOrigin,
          reactModalProps = _this$props.reactModalProps;
      var _this$state = this.state,
          zoomLevel = _this$state.zoomLevel,
          offsetX = _this$state.offsetX,
          offsetY = _this$state.offsetY,
          isClosing = _this$state.isClosing,
          loadErrorStatus = _this$state.loadErrorStatus;
      var boxSize = this.getLightboxRect();
      var transitionStyle = {}; // Transition settings for sliding animations

      if (!animationDisabled && this.isAnimating()) {
        transitionStyle = _objectSpread({}, transitionStyle, {
          transition: "transform ".concat(animationDuration, "ms")
        });
      } // Key endings to differentiate between images with the same src


      var keyEndings = {};
      this.getSrcTypes().forEach(function (_ref13) {
        var name = _ref13.name,
            keyEnding = _ref13.keyEnding;
        keyEndings[name] = keyEnding;
      }); // Images to be displayed

      var images = [];

      var addImage = function addImage(srcType, imageClass, transforms) {
        // Ignore types that have no source defined for their full size image
        if (!_this16.props[srcType]) {
          return;
        }

        var bestImageInfo = _this16.getBestImageForType(srcType);

        var imageStyle = _objectSpread({}, transitionStyle, ReactImageLightbox.getTransform(_objectSpread({}, transforms, bestImageInfo)));

        if (zoomLevel > MIN_ZOOM_LEVEL) {
          imageStyle.cursor = 'move';
        } // support IE 9 and 11


        var hasTrueValue = function hasTrueValue(object) {
          return Object.keys(object).some(function (key) {
            return object[key];
          });
        }; // when error on one of the loads then push custom error stuff


        if (bestImageInfo === null && hasTrueValue(loadErrorStatus)) {
          images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "".concat(imageClass, " ril__image ril-errored"),
            style: imageStyle,
            key: _this16.props[srcType] + keyEndings[srcType]
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "ril__errorContainer"
          }, _this16.props.imageLoadErrorMessage)));
          return;
        }

        if (bestImageInfo === null) {
          var loadingIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "ril-loading-circle ril__loadingCircle ril__loadingContainer__icon"
          }, _toConsumableArray(new Array(12)).map(function (_, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
              // eslint-disable-next-line react/no-array-index-key
              key: index,
              className: "ril-loading-circle-point ril__loadingCirclePoint"
            });
          })); // Fall back to loading icon if the thumbnail has not been loaded

          images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "".concat(imageClass, " ril__image ril-not-loaded"),
            style: imageStyle,
            key: _this16.props[srcType] + keyEndings[srcType]
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "ril__loadingContainer"
          }, loadingIcon)));
          return;
        }

        var imageSrc = bestImageInfo.src;

        if (discourageDownloads) {
          imageStyle.backgroundImage = "url('".concat(imageSrc, "')");
          images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "".concat(imageClass, " ril__image ril__imageDiscourager"),
            onDoubleClick: _this16.handleImageDoubleClick,
            onWheel: _this16.handleImageMouseWheel,
            style: imageStyle,
            key: imageSrc + keyEndings[srcType]
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "ril-download-blocker ril__downloadBlocker"
          })));
        } else {
          images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", _extends({}, imageCrossOrigin ? {
            crossOrigin: imageCrossOrigin
          } : {}, {
            className: "".concat(imageClass, " ril__image"),
            onDoubleClick: _this16.handleImageDoubleClick,
            onWheel: _this16.handleImageMouseWheel,
            onDragStart: function onDragStart(e) {
              return e.preventDefault();
            },
            style: imageStyle,
            src: imageSrc,
            key: imageSrc + keyEndings[srcType],
            alt: typeof imageTitle === 'string' ? imageTitle : translate('Image'),
            draggable: false
          })));
        }
      };

      var zoomMultiplier = this.getZoomMultiplier(); // Next Image (displayed on the right)

      addImage('nextSrc', 'ril-image-next ril__imageNext', {
        x: boxSize.width
      }); // Main Image

      addImage('mainSrc', 'ril-image-current', {
        x: -1 * offsetX,
        y: -1 * offsetY,
        zoom: zoomMultiplier
      }); // Previous Image (displayed on the left)

      addImage('prevSrc', 'ril-image-prev ril__imagePrev', {
        x: -1 * boxSize.width
      });
      var modalStyle = {
        overlay: _objectSpread({
          zIndex: 1000,
          backgroundColor: 'transparent'
        }, reactModalStyle.overlay),
        content: _objectSpread({
          backgroundColor: 'transparent',
          overflow: 'hidden',
          // Needed, otherwise keyboard shortcuts scroll the page
          border: 'none',
          borderRadius: 0,
          padding: 0,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }, reactModalStyle.content)
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a, _extends({
        isOpen: true,
        onRequestClose: clickOutsideToClose ? this.requestClose : undefined,
        onAfterOpen: function onAfterOpen() {
          // Focus on the div with key handlers
          if (_this16.outerEl.current) {
            _this16.outerEl.current.focus();
          }

          _onAfterOpen();
        },
        style: modalStyle,
        contentLabel: translate('Lightbox'),
        appElement: typeof global.window !== 'undefined' ? global.window.document.body : undefined
      }, reactModalProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions
        // Floating modal with closing animations
        className: "ril-outer ril__outer ril__outerAnimating ".concat(this.props.wrapperClassName, " ").concat(isClosing ? 'ril-closing ril__outerClosing' : ''),
        style: {
          transition: "opacity ".concat(animationDuration, "ms"),
          animationDuration: "".concat(animationDuration, "ms"),
          animationDirection: isClosing ? 'normal' : 'reverse'
        },
        ref: this.outerEl,
        onWheel: this.handleOuterMousewheel,
        onMouseMove: this.handleMouseMove,
        onMouseDown: this.handleMouseDown,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        tabIndex: "-1" // Enables key handlers on div
        ,
        onKeyDown: this.handleKeyInput,
        onKeyUp: this.handleKeyInput
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        // Image holder
        className: "ril-inner ril__inner",
        onClick: clickOutsideToClose ? this.closeIfClickInner : undefined
      }, images), prevSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Move to previous image button
        type: "button",
        className: "ril-prev-button ril__navButtons ril__navButtonPrev",
        key: "prev",
        "aria-label": this.props.prevLabel,
        onClick: !this.isAnimating() ? this.requestMovePrev : undefined // Ignore clicks during animation

      }), nextSrc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Move to next image button
        type: "button",
        className: "ril-next-button ril__navButtons ril__navButtonNext",
        key: "next",
        "aria-label": this.props.nextLabel,
        onClick: !this.isAnimating() ? this.requestMoveNext : undefined // Ignore clicks during animation

      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // Lightbox toolbar
        className: "ril-toolbar ril__toolbar"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "ril-toolbar-left ril__toolbarSide ril__toolbarLeftSide"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "ril-toolbar__item ril__toolbarItem"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "ril-toolbar__item__child ril__toolbarItemChild"
      }, imageTitle))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "ril-toolbar-right ril__toolbarSide ril__toolbarRightSide"
      }, toolbarButtons && toolbarButtons.map(function (button, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          key: "button_".concat(i + 1),
          className: "ril-toolbar__item ril__toolbarItem"
        }, button);
      }), enableZoom && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "ril-toolbar__item ril__toolbarItem"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Lightbox zoom in button
        type: "button",
        key: "zoom-in",
        "aria-label": this.props.zoomInLabel,
        className: ['ril-zoom-in', 'ril__toolbarItemChild', 'ril__builtinButton', 'ril__zoomInButton'].concat(_toConsumableArray(zoomLevel === MAX_ZOOM_LEVEL ? ['ril__builtinButtonDisabled'] : [])).join(' '),
        ref: this.zoomInBtn,
        disabled: this.isAnimating() || zoomLevel === MAX_ZOOM_LEVEL,
        onClick: !this.isAnimating() && zoomLevel !== MAX_ZOOM_LEVEL ? this.handleZoomInButtonClick : undefined
      })), enableZoom && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "ril-toolbar__item ril__toolbarItem"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Lightbox zoom out button
        type: "button",
        key: "zoom-out",
        "aria-label": this.props.zoomOutLabel,
        className: ['ril-zoom-out', 'ril__toolbarItemChild', 'ril__builtinButton', 'ril__zoomOutButton'].concat(_toConsumableArray(zoomLevel === MIN_ZOOM_LEVEL ? ['ril__builtinButtonDisabled'] : [])).join(' '),
        ref: this.zoomOutBtn,
        disabled: this.isAnimating() || zoomLevel === MIN_ZOOM_LEVEL,
        onClick: !this.isAnimating() && zoomLevel !== MIN_ZOOM_LEVEL ? this.handleZoomOutButtonClick : undefined
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "ril-toolbar__item ril__toolbarItem"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        // Lightbox close button
        type: "button",
        key: "close",
        "aria-label": this.props.closeLabel,
        className: "ril-close ril-toolbar__item__child ril__toolbarItemChild ril__builtinButton ril__closeButton",
        onClick: !this.isAnimating() ? this.requestClose : undefined // Ignore clicks during animation

      })))), this.props.imageCaption && // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // Image caption
        onWheel: this.handleCaptionMousewheel,
        onMouseDown: function onMouseDown(event) {
          return event.stopPropagation();
        },
        className: "ril-caption ril__caption",
        ref: this.caption
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "ril-caption-content ril__captionContent"
      }, this.props.imageCaption))));
    }
  }]);

  return ReactImageLightbox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReactImageLightbox.propTypes = {
  //-----------------------------
  // Image sources
  //-----------------------------
  // Main display image url
  mainSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  // Previous display image url (displayed to the left)
  // If left undefined, movePrev actions will not be performed, and the button not displayed
  prevSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // Next display image url (displayed to the right)
  // If left undefined, moveNext actions will not be performed, and the button not displayed
  nextSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  //-----------------------------
  // Image thumbnail sources
  //-----------------------------
  // Thumbnail image url corresponding to props.mainSrc
  mainSrcThumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-line react/no-unused-prop-types
  // Thumbnail image url corresponding to props.prevSrc
  prevSrcThumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-line react/no-unused-prop-types
  // Thumbnail image url corresponding to props.nextSrc
  nextSrcThumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-line react/no-unused-prop-types
  //-----------------------------
  // Event Handlers
  //-----------------------------
  // Close window event
  // Should change the parent state such that the lightbox is not rendered
  onCloseRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // Move to previous image event
  // Should change the parent state such that props.prevSrc becomes props.mainSrc,
  //  props.mainSrc becomes props.nextSrc, etc.
  onMovePrevRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Move to next image event
  // Should change the parent state such that props.nextSrc becomes props.mainSrc,
  //  props.mainSrc becomes props.prevSrc, etc.
  onMoveNextRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Called when an image fails to load
  // (imageSrc: string, srcType: string, errorEvent: object): void
  onImageLoadError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Called when image successfully loads
  onImageLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Open window event
  onAfterOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  //-----------------------------
  // Download discouragement settings
  //-----------------------------
  // Enable download discouragement (prevents [right-click -> Save Image As...])
  discourageDownloads: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  //-----------------------------
  // Animation settings
  //-----------------------------
  // Disable all animation
  animationDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Disable animation on actions performed with keyboard shortcuts
  animationOnKeyInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Animation duration (ms)
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  //-----------------------------
  // Keyboard shortcut settings
  //-----------------------------
  // Required interval of time (ms) between key actions
  // (prevents excessively fast navigation of images)
  keyRepeatLimit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // Amount of time (ms) restored after each keyup
  // (makes rapid key presses slightly faster than holding down the key to navigate images)
  keyRepeatKeyupBonus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  //-----------------------------
  // Image info
  //-----------------------------
  // Image title
  imageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  // Image caption
  imageCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  // Optional crossOrigin attribute
  imageCrossOrigin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  //-----------------------------
  // Lightbox style
  //-----------------------------
  // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
  reactModalStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  // Padding (px) between the edge of the window and the lightbox
  imagePadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  wrapperClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  //-----------------------------
  // Other
  //-----------------------------
  // Array of custom toolbar buttons
  toolbarButtons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  // When true, clicks outside of the image close the lightbox
  clickOutsideToClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Set to false to disable zoom functionality and hide zoom buttons
  enableZoom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Override props set on react-modal (https://github.com/reactjs/react-modal)
  reactModalProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  // Aria-labels
  nextLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prevLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  zoomInLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  zoomOutLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageLoadErrorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
ReactImageLightbox.defaultProps = {
  imageTitle: null,
  imageCaption: null,
  toolbarButtons: null,
  reactModalProps: {},
  animationDisabled: false,
  animationDuration: 300,
  animationOnKeyInput: false,
  clickOutsideToClose: true,
  closeLabel: 'Close lightbox',
  discourageDownloads: false,
  enableZoom: true,
  imagePadding: 10,
  imageCrossOrigin: null,
  keyRepeatKeyupBonus: 40,
  keyRepeatLimit: 180,
  mainSrcThumbnail: null,
  nextLabel: 'Next image',
  nextSrc: null,
  nextSrcThumbnail: null,
  onAfterOpen: function onAfterOpen() {},
  onImageLoadError: function onImageLoadError() {},
  onImageLoad: function onImageLoad() {},
  onMoveNextRequest: function onMoveNextRequest() {},
  onMovePrevRequest: function onMovePrevRequest() {},
  prevLabel: 'Previous image',
  prevSrc: null,
  prevSrcThumbnail: null,
  reactModalStyle: {},
  wrapperClassName: '',
  zoomInLabel: 'Zoom in',
  zoomOutLabel: 'Zoom out',
  imageLoadErrorMessage: 'This image failed to load'
};

/* harmony default export */ __webpack_exports__["a"] = (ReactImageLightbox);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(998)();
}


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(999);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1001);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(66);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(1002);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(507);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(336);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(399);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(1003);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1004);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(507);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(1007);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(336);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            id: id,
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(506);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(506);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof tabbable[x] === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductFiles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* defineMessages */])({downloadFile:{'id':'product.downloadFile','defaultMessage':'Download'}});var ProductFiles=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_React$Component){_inherits(ProductFiles,_React$Component);function ProductFiles(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductFiles);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductFiles.__proto__||Object.getPrototypeOf(ProductFiles)).call.apply(_ref,[this].concat(args))),_this),_this.getProductFileUrl=function(name){var configStore=_this.props.configStore;var isShoppingCenter=configStore.siteConfig.isShoppingCenter;return isShoppingCenter?name:'/storage/product_files/'+name;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductFiles,[{key:'render',value:function render(){var _this2=this;var _props=this.props,product=_props.product,intl=_props.intl;var downloadFileText=intl.formatMessage(messages.downloadFile);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductFiles'},product.files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:file.name,className:'ProductFile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{title:downloadFileText,className:'ProductFile__link',target:'_blank',rel:'noopener',href:_this2.getProductFileUrl(file.name)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductFile__name'},file.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductFile__download'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Icon__["a" /* default */],{className:'ProductFile__icon',name:'file'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductFile__download-text'},downloadFileText))));}));}}]);return ProductFiles;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;ProductFiles.propTypes={product:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_Product__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductFiles)));

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductCollectionPropertySelect__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_ProductMatrix__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_ProductPropertyType__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductCollectionProductPicker=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductCollectionProductPicker,_Component);function ProductCollectionProductPicker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductCollectionProductPicker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductCollectionProductPicker.__proto__||Object.getPrototypeOf(ProductCollectionProductPicker)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeColumnElement:null,activeRowElement:null},_this.getColumnElementsWithAvailability=function(){var productCollection=_this.props.productCollection;var activeRowElement=_this.state.activeRowElement;return productCollection.column.elements.reduce(function(elementsWithAvailability,element){var status=activeRowElement?productCollection.getItemStatus(element.id,activeRowElement.id):productCollection.getColumnStatus(element.id);if(status.exists){elementsWithAvailability.push({element:element,available:status.available});}return elementsWithAvailability;},[]);},_this.getRowElementsWithAvailability=function(){var productCollection=_this.props.productCollection;var activeColumnElement=_this.state.activeColumnElement;return productCollection.row.elements.reduce(function(elementsWithAvailability,element){var status=activeColumnElement?productCollection.getItemStatus(activeColumnElement.id,element.id):productCollection.getRowStatus(element.id);if(status.exists){elementsWithAvailability.push({element:element,available:status.available});}return elementsWithAvailability;},[]);},_this.updateProductId=function(columnElement,rowElement){var productCollection=_this.props.productCollection;var column=productCollection.column,row=productCollection.row;var productId=null;if(columnElement!==null&&columnElement!==undefined&&rowElement!==null&&rowElement!==undefined){var item=productCollection.getItem(columnElement.id,rowElement.id);if(item){productId=item.product.id;}_this.setProductVariationColumn(column,columnElement);_this.setProductVariationRow(rowElement,row);}// Only set query params, if we do not already have a product
var queryParams=!productId?{columnId:columnElement&&columnElement.id,rowId:rowElement&&rowElement.id}:null;_this.props.onProductChange(productId,queryParams);},_this.onColumnChange=function(columnElement){_this.setState({activeColumnElement:columnElement});_this.updateProductId(columnElement,_this.state.activeRowElement);},_this.onRowChange=function(rowElement){_this.setState({activeRowElement:rowElement});_this.updateProductId(_this.state.activeColumnElement,rowElement);},_this.getDisplayFlagsForProperty=function(property){var isColor=property.type===__WEBPACK_IMPORTED_MODULE_6__types_ProductPropertyType__["b" /* default */].COLOR;return{// TODO: Add a configuration for using buttons
//showButtons: !isColor,
showImages:isColor,showDropdown:true};},_this.setProductVariationColumn=function(column,columnElement){var productStore=_this.props.productStore;if(!columnElement||!column||!column.name||!columnElement.name){productStore.setProductVariationColumn(null);return;}productStore.setProductVariationColumn(column.name+': '+columnElement.name);productStore.setSelectedColumn(columnElement.name);},_this.setProductVariationRow=function(rowElement,row){var productStore=_this.props.productStore;if(!rowElement||!row||!row.name||!rowElement.name){productStore.setProductVariationRow(null);return;}productStore.setProductVariationRow(row.name+': '+rowElement.name);productStore.setSelectedRow(rowElement.name);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductCollectionProductPicker,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,productCollection=_props.productCollection,productStore=_props.productStore;var row=productCollection.row,column=productCollection.column;var _state=this.state,activeColumnElement=_state.activeColumnElement,activeRowElement=_state.activeRowElement;if(activeColumnElement){this.setProductVariationColumn(column,activeColumnElement);productStore.setSelectedColumn(activeColumnElement.name);}if(activeRowElement){this.setProductVariationRow(activeRowElement,row);productStore.setSelectedRow(activeRowElement.name);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.state.activeColumnElement&&this.state.activeRowElement&&!this.props.activeProductId){this.updateProductId(this.state.activeColumnElement,this.state.activeRowElement);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var productStore=this.props.productStore;productStore.setProductVariationColumn(null);productStore.setSelectedColumn(null);productStore.setProductVariationRow(null);productStore.setSelectedRow(null);}},{key:'render',value:function render(){var _props2=this.props,configStore=_props2.configStore,product=_props2.product,productCollection=_props2.productCollection,productImages=_props2.productImages;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifBuyingAllowed=product.merchantInfo&&product.merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed){return null;}var selects=[];if(!productCollection.column.isEmpty()){selects.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProductCollectionPropertySelect__["a" /* default */],Object.assign({key:'column',product:product,productImages:productImages,property:productCollection.column,elementsWithAvailability:this.getColumnElementsWithAvailability(),activeElementId:this.state.activeColumnElement&&this.state.activeColumnElement.id,onPropertySelect:this.onColumnChange},this.getDisplayFlagsForProperty(productCollection.column),{disabled:!productCollection.columnIsSelectable()})));}if(!productCollection.row.isEmpty()){selects.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProductCollectionPropertySelect__["a" /* default */],Object.assign({key:'row',product:product,productImages:productImages,property:productCollection.row,elementsWithAvailability:this.getRowElementsWithAvailability(),activeElementId:this.state.activeRowElement&&this.state.activeRowElement.id,onPropertySelect:this.onRowChange},this.getDisplayFlagsForProperty(productCollection.row),{disabled:!productCollection.rowIsSelectable()})));}if(productCollection.shouldSwapCollectionOrder()){selects.reverse();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductCollectionProductPicker'},selects);}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){return{activeColumnElement:nextProps.columnId?nextProps.productCollection.column.getElementWithId(nextProps.columnId):nextProps.productCollection.getDefaultColumnElement(),activeRowElement:nextProps.rowId?nextProps.productCollection.row.getElementWithId(nextProps.rowId):nextProps.productCollection.getDefaultRowElement()};}}]);return ProductCollectionProductPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductCollectionProductPicker.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ProductStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,productImages:__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArray.isRequired,productCollection:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_ProductMatrix__["a" /* default */]).isRequired,onProductChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,columnId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,rowId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','productStore')(ProductCollectionProductPicker));

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(286),
    castSlice = __webpack_require__(460),
    hasUnicode = __webpack_require__(234),
    isIterateeCall = __webpack_require__(150),
    isRegExp = __webpack_require__(1012),
    stringToArray = __webpack_require__(461),
    toString = __webpack_require__(108);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1013),
    baseUnary = __webpack_require__(148),
    nodeUtil = __webpack_require__(221);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isObjectLike = __webpack_require__(90);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(1015);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(429),
    arrayIncludes = __webpack_require__(1016),
    arrayIncludesWith = __webpack_require__(1019),
    cacheHas = __webpack_require__(431),
    createSet = __webpack_require__(1020),
    setToArray = __webpack_require__(294);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(509);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(437),
    noop = __webpack_require__(1021),
    setToArray = __webpack_require__(294);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Filter__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Product__ = __webpack_require__(18);
var ProductSearchPaginator=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductSearchPaginator',{available_filters:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__Filter__["a" /* default */])),current_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,last_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,total:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,data:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_2__Product__["a" /* default */])),[])});/* harmony default export */ __webpack_exports__["a"] = (ProductSearchPaginator);

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var FilterOption=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('FilterOption',{name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,count:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});/* harmony default export */ __webpack_exports__["a"] = (FilterOption);

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortOrder__ = __webpack_require__(95);
var createSortSelection=function createSortSelection(sortKey,sortOrder,sortIndex){return{sortKey:sortKey,sortOrder:sortOrder,sortIndex:sortIndex};};var ProductSortSelectorMap=[createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].PRICE,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].ASC,1),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].PRICE,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].DESC,2),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].DATE_ADDED,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].DESC,3),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].SALES,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].DESC,4),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].REVIEWS_AVERAGE,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].DESC,5),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].BRAND,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].ASC,6),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].ID,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].ASC,7),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].NAME,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].ASC,8),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].CATEGORY,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].ASC,9),createSortSelection(__WEBPACK_IMPORTED_MODULE_0__ProductSortOrderBy__["a" /* default */].DISCOUNT,__WEBPACK_IMPORTED_MODULE_1__SortOrder__["a" /* default */].DESC,10)];/* harmony default export */ __webpack_exports__["a"] = (ProductSortSelectorMap);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductMultiProductPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProductPrice__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductExtraInfo__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ProductAvailabilityList__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProductCollectionPropertySelect__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Discount__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProductPagePrice__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ProductOfferSchema__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_StorageStore__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PriceSecondary__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ProductId__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ProductMultiProductPickerPropertySelect__ = __webpack_require__(1035);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductMultiProductPicker=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(ProductMultiProductPicker,_Component);function ProductMultiProductPicker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductMultiProductPicker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductMultiProductPicker.__proto__||Object.getPrototypeOf(ProductMultiProductPicker)).call.apply(_ref,[this].concat(args))),_this),_this.state={activePropertyElementMap:{}},_this.checkSingleElementProperties=function(){var product=_this.props.product;product.multi.properties.forEach(function(property){if(property.elements.length===1){_this.onPropertySelect(property.id,property.elements[0].id);}});},_this.loadAllStocks=function(){var product=_this.props.product;product.multi.children.forEach(function(childProduct){if(product.stockStates.get(childProduct.id)!==__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED){product.loadStocks(childProduct.id);}});},_this.getCardPrice=function(childProduct){if(!childProduct.price_info){return null;}var isDiscount=childProduct.price_info.is_discount;var discount=isDiscount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Discount__["a" /* default */],{percentage:childProduct.price_info.discount_percentage});var validUntil=childProduct.price_info.valid_until_html&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__card-valid-until',dangerouslySetInnerHTML:{__html:childProduct.price_info.valid_until_html}});var withTax=_this.props.accountStore.showPricesWithTax;var discountDescription=isDiscount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__card-savings-amount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.offer',defaultMessage:'Offer!'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].youSaveSentence,{values:{savings:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Price__["a" /* default */],{price:childProduct.price_info.getSavings(withTax)})}})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__card-price-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__card-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ProductPrice__["a" /* default */],{hideDiscount:true,product:childProduct,priceInfo:childProduct.price_info}),discount,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__PriceSecondary__["a" /* default */],{product:childProduct,isMultiProductPicker:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__card-discount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ProductPrice__["a" /* default */],{hidePrice:true,hideTaxExcludedInfo:true,product:childProduct,priceInfo:childProduct.price_info}),discountDescription),validUntil);},_this.renderChildProductId=function(childProduct){var configStore=_this.props.configStore;var showProductCode=configStore.productPage.showProductCode;var showAdditionalProductCode=configStore.productPage.showAdditionalProductCode;if(!showProductCode||!showAdditionalProductCode){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__additional-product-id'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__ProductId__["a" /* default */],{id:childProduct.id}));},_this.getCardSelect=function(){var _this$props=_this.props,product=_this$props.product,activeProductId=_this$props.activeProductId,onProductChange=_this$props.onProductChange,scrollToTab=_this$props.scrollToTab,accountStore=_this$props.accountStore,configStore=_this$props.configStore;var isViewOnly=accountStore.isViewOnly;var chooseMessage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].chooseTitle);var multiValueProperties=_this.getPropertiesWithMultipleSelections();var activeProperties=multiValueProperties.length===1?multiValueProperties:product.multi.properties;var unorderedCards=product.multi.children.map(function(childProduct){var effectiveOrder=[];var headerText=activeProperties.map(function(property){var childProperty=childProduct.extra_properties.find(function(extraProperty){return extraProperty.id===property.id;});if(!childProperty){effectiveOrder.push(null);return null;}var sortValue=property.elements.findIndex(function(element){return element.id===childProperty.value_id;});effectiveOrder.push(sortValue>-1?sortValue:null);return childProperty&&childProperty.value_name;}).filter(function(name){return!!name;}).join(', ');var isActive=childProduct.id===activeProductId;var isAvailable=childProduct.free_quantity>0;var onClick=function onClick(){return onProductChange(childProduct.id);};var childProductImage=childProduct.images.find(function(image){return image.product_id===childProduct.id;});return{order:effectiveOrder,component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:childProduct.id,className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductMultiProductPicker__card clearfix',{'ProductMultiProductPicker__card--extra-padding':!configStore.product.hideMultiProductSelectionImage,'ProductMultiProductPicker__card--active':isActive,'ProductMultiProductPicker__card--active-glow':!configStore.product.hideMultiProductSelectionImage&&isActive}),onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__selector-wrapper'},!configStore.product.hideMultiProductSelectionImage&&childProductImage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["u" /* FormGroup */],{className:'ProductMultiProductPicker__card-image',onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ProductImage__["a" /* default */],{product:childProduct,productImage:childProductImage,size:'small',forceAspectRatio:false,lazyLoading:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["u" /* FormGroup */],{check:true,className:'ProductMultiProductPicker__card-checkbox',disabled:!isAvailable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["z" /* Label */],{check:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',checked:isActive,onClick:onClick,readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sr-only'},chooseMessage,' ',headerText)))),!isViewOnly&&_this.getCardPrice(childProduct),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__card-title'},headerText),_this.renderChildProductId(childProduct),!isViewOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ProductAvailabilityList__["a" /* default */],{scrollToTab:scrollToTab,product:product,activeProduct:childProduct,onBeforeScroll:onClick,shipping:false}),isActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ProductExtraInfo__["a" /* default */],{product:childProduct}),isActive&&!isViewOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ProductAvailabilityList__["a" /* default */],{scrollToTab:scrollToTab,product:product,activeProduct:childProduct,shipping:true,onBeforeScroll:onClick,onlineAvailability:false,storeAvailability:false}))};});var cards=unorderedCards.sort(function(a,b){for(var i=0;i<Math.max(a.order.length,b.order.length);++i){if(a.order[i]===null){return-1;}if(b.order[i]===null){return 1;}if(a.order[i]!==b.order[i]){return a.order[i]<b.order[i]?-1:1;}}return 0;}).map(function(card){return card.component;});var labelText=activeProperties.map(function(property){return property.name;}).filter(function(name){return!!name;}).join(', ');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__card-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_Icon__["a" /* default */],{name:'long-arrow-down'}),' ',chooseMessage,' ',labelText),cards);},_this.getDropdowns=function(){var _this$props2=_this.props,product=_this$props2.product,activeProductId=_this$props2.activeProductId,scrollToTab=_this$props2.scrollToTab,accountStore=_this$props2.accountStore,onProductChange=_this$props2.onProductChange;var isViewOnly=accountStore.isViewOnly;var activeChildProduct=product.multi.findChild(activeProductId);var activeProduct=activeChildProduct?activeChildProduct:product;var dropdowns=_this.renderDropdowns();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__dropdowns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__ProductMultiProductPickerPropertySelect__["a" /* default */],{activeProductId:activeProductId,product:product,productImages:product.images,onProductChange:onProductChange,hidden:product.multi.properties.every(function(property){return property.elements.length<=1;})}),dropdowns,_this.renderPrice(),activeProduct&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ProductExtraInfo__["a" /* default */],{product:activeProduct}),!isViewOnly&&activeChildProduct&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ProductAvailabilityList__["a" /* default */],{scrollToTab:scrollToTab,product:product,activeProduct:activeChildProduct,shipping:true})));},_this.renderDropdowns=function(){var _this$props3=_this.props,product=_this$props3.product,activeProductId=_this$props3.activeProductId,onProductChange=_this$props3.onProductChange;var activePropertyElementMap=_this.state.activePropertyElementMap;return product.multi.properties.map(function(property){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProductCollectionPropertySelect__["a" /* default */],Object.assign({key:property.id,activeProductId:activeProductId,product:product,productImages:product.images,property:property,elementsWithAvailability:_this.getPropertyElementsWithAvailability(property),onPropertySelect:function onPropertySelect(element){var elementId=element&&element.id;_this.onPropertySelect(property.id,elementId);},onProductChange:onProductChange,activeElementId:activePropertyElementMap[property.id]},_this.getDisplayFlagsForProperty(),{hidden:property.elements.length<=1,disabled:property.elements.length<=1}));});},_this.getPropertyElementsWithAvailability=function(property){var product=_this.props.product;return property.elements.reduce(function(elementsWithAvailability,element){var propertyElementMap=Object.assign({},_this.state.activePropertyElementMap,_defineProperty({},property.id,element.id));var status=product.multi.getPropertyElementStatus(propertyElementMap);elementsWithAvailability.push({element:element,available:status.available,disabled:!status.exists});return elementsWithAvailability;},[]);},_this.getDisplayFlagsForProperty=function(){var configStore=_this.props.configStore;return{// TODO: Add a configuration for using buttons
//showButtons: !isColor,
showImages:!configStore.product.hideMultiProductSelectionImage,showDropdown:true,multiproductAsDropdown:configStore.product.multiproductAsDropdown};},_this.onPropertySelect=function(propertyId,elementId){var _this$props4=_this.props,product=_this$props4.product,onProductChange=_this$props4.onProductChange;_this.setState(function(state){var activePropertyElementMap=state.activePropertyElementMap;var updatedPropertyElementMap=Object.assign({},activePropertyElementMap,_defineProperty({},propertyId,elementId));if(!elementId){delete updatedPropertyElementMap[propertyId];}return{activePropertyElementMap:updatedPropertyElementMap};},function(){var activePropertyElementMap=_this.state.activePropertyElementMap;var productId=null;if(Object.keys(activePropertyElementMap).length===product.multi.properties.length){var childProduct=product.multi.findChildWithProperties(activePropertyElementMap);if(childProduct){productId=childProduct.id;}}onProductChange(productId);});},_this.renderPrice=function(){var _this$props5=_this.props,activeProductId=_this$props5.activeProductId,hasPriceRange=_this$props5.hasPriceRange,product=_this$props5.product;var activeChildProduct=product.multi.findChild(activeProductId);if(!activeChildProduct||!activeChildProduct.price_info||!hasPriceRange){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker__dropdowns-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProductPagePrice__["a" /* default */],{price:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ProductPrice__["a" /* default */],{product:activeChildProduct,priceInfo:activeChildProduct.price_info}),product:activeChildProduct,withDiscountLabel:true,withDiscountBalloon:true,withDiscountSavings:true}));},_this.showAsCards=function(){var _this$props6=_this.props,configStore=_this$props6.configStore,product=_this$props6.product;var multiSelectProperties=_this.getPropertiesWithMultipleSelections();return!configStore.product.multiproductAsDropdown&&(product.multi.properties.length===1||multiSelectProperties.length===1);},_this.getPropertiesWithMultipleSelections=function(){var product=_this.props.product;return product.multi.properties.filter(function(property){return property.elements.length>1;});},_this.getOfferSchema=function(){var _this$props7=_this.props,product=_this$props7.product,path=_this$props7.path;return product.multi.children.map(function(childProduct){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ProductOfferSchema__["a" /* default */],{key:childProduct.id,product:childProduct,path:path+childProduct.pathWithActiveProductId(childProduct.id)});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductMultiProductPicker,[{key:'componentDidMount',value:function componentDidMount(){this.checkSingleElementProperties();if(this.showAsCards()){var _props=this.props,storageStore=_props.storageStore,product=_props.product;var siteUrl=product&&product.merchant_info&&product.merchant_info.site_url&&product.merchant_info.site_url;storageStore.makeSureStoragesLoaded(siteUrl);this.loadAllStocks();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.product!==this.props.product){if(this.showAsCards()){this.loadAllStocks();}this.checkSingleElementProperties();}}},{key:'render',value:function render(){var _props2=this.props,configStore=_props2.configStore,product=_props2.product;var ifShoppingCenter=configStore.siteConfig.isShoppingCenter;var ifBuyingAllowed=product.merchantInfo&&product.merchantInfo.buyingAllowed;if(ifShoppingCenter&&!ifBuyingAllowed){return null;}var showContentAsCards=this.showAsCards()?this.getCardSelect():this.getDropdowns();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPicker'},showContentAsCards,this.getOfferSchema());}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){if(nextProps.activeProductId){var childProduct=nextProps.product.multi.findChild(nextProps.activeProductId);if(childProduct){return{activePropertyElementMap:ProductMultiProductPicker.getPropertyElementMapForProduct(childProduct)};}}return null;}}]);return ProductMultiProductPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.getPropertyElementMapForProduct=function(product){return product.extra_properties.reduce(function(propertyElementMap,extraProperty){propertyElementMap[extraProperty.id]=extraProperty.value_id;return propertyElementMap;},{});},_temp2))||_class;ProductMultiProductPicker.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,storageStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_StorageStore__["a" /* default */]).isRequired,onProductChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,productImages:__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArray.isRequired,scrollToTab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hasPriceRange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('accountStore','configStore','storageStore')(ProductMultiProductPicker));

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1027),
    findIndex = __webpack_require__(1028);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(84),
    isArrayLike = __webpack_require__(125),
    keys = __webpack_require__(147);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(510),
    baseIteratee = __webpack_require__(84),
    toInteger = __webpack_require__(241);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(178),
    createAggregator = __webpack_require__(220);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_PropertyImage__ = __webpack_require__(498);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductFeatureImage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductFeatureImage,_Component);function ProductFeatureImage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductFeatureImage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductFeatureImage.__proto__||Object.getPrototypeOf(ProductFeatureImage)).call.apply(_ref,[this].concat(args))),_this),_this.defaultBackground='#d6dadb',_this.defaultFontColor='#333',_this.getLabelComponent=function(){var _this$props=_this.props,label=_this$props.label,label_background=_this$props.label_background,label_fontcolor=_this$props.label_fontcolor;if(!label){return;}var styleObject={};styleObject.backgroundColor=label_background?label_background:_this.defaultBackground;styleObject.color=label_fontcolor?label_fontcolor:_this.defaultFontColor;var label_value=label.label_value?': '+label.label_value:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductFeatureImage__label',style:styleObject},label.label_text+label_value);},_this.getImageComponent=function(){var image=_this.props.image;if(!image){return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ProductFeatureImage__image',src:image,alt:'',loading:'lazy'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductFeatureImage,[{key:'render',value:function render(){var _props=this.props,image=_props.image,label=_props.label,display_style=_props.display_style;if(!image&&!label){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductFeatureImage '+display_style},this.getImageComponent(),this.getLabelComponent());}}]);return ProductFeatureImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductFeatureImage.propTypes={image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,label_background:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,label:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_PropertyImage__["a" /* PropertyImageLabel */])};/* harmony default export */ __webpack_exports__["a"] = (ProductFeatureImage);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductAvailabilityShipping */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_CountryStore__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductAvailabilityShipping=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductAvailabilityShipping,_Component);function ProductAvailabilityShipping(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductAvailabilityShipping);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductAvailabilityShipping.__proto__||Object.getPrototypeOf(ProductAvailabilityShipping)).call.apply(_ref,[this].concat(args))),_this),_this.renderActiveCountry=function(){var countryStore=_this.props.countryStore;if(countryStore.countryCount>1){return' ('+countryStore.activeCountry.name+')';}},_this.renderCampaignPromotion=function(options){var campaigns=[];options.filter(function(option){return option.campaign_info&&option.campaign_info.name;}).sort(function(a,b){return b.campaign_info.priority-a.campaign_info.priority||a.campaign_info.id-b.campaign_info.id;}).map(function(option){return campaigns.push(option.campaign_info);});if(campaigns.length===0||!campaigns[0].name){return null;}if(campaigns[0].name.length>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__campaign-promotion'},campaigns[0].name);}return null;},_this.renderCheapestOption=function(details){var withTax=_this.props.withTax;var cheapest_option=details.cheapest_option;if(!cheapest_option){return null;}var lowOrderFeeSentence=cheapest_option.includes_low_order_fee&&(withTax?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__cheapest-option-low-fee'},'(',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].lowOrderFeeNoTaxSentence,{values:{amount:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:cheapest_option.includes_low_order_fee.getPrice(withTax)}),limit:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:cheapest_option.low_order_fee_limit.getPrice(withTax)})}})),')'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__cheapest-option-low-fee'},'(',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].lowOrderFeeSentence,{values:{amount:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:cheapest_option.includes_low_order_fee.getPrice(true)}),amountWithoutTax:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:cheapest_option.includes_low_order_fee.getPrice(false)}),limit:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:cheapest_option.low_order_fee_limit.getPrice(true)}),limitwithoutTax:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:cheapest_option.low_order_fee_limit.getPrice(false)})}})),')'));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__cheapest-option'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductAvailabilityShipping__cheapest-option-delivery',{'ProductAvailabilityShipping__cheapest-option-delivery-no-flex':!lowOrderFeeSentence})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].deliveryStartingSentence,{values:{price:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:cheapest_option.price.getPrice(withTax)})}})),_this.renderActiveCountry()),lowOrderFeeSentence,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Icon__["a" /* default */],{name:'caret-down'})));},_this.renderPreferredPickup=function(details){var withTax=_this.props.withTax;var preferred_pickup_option=details.preferred_pickup_option;if(!preferred_pickup_option){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__preferred-pickup-option'},preferred_pickup_option.name,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__preferred-pickup-option-price'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Price__["a" /* default */],{price:preferred_pickup_option.price.getPrice(withTax)})));},_this.renderCheckoutNotification=function(details){var preferred=details.preferred_pickup_option;var hasPreferredCargoCalculation=preferred&&preferred.has_starting_price===true;var cheapest=details.cheapest_option;var hasCheapestCargoCalculation=cheapest&&cheapest.has_starting_price===true;if(!hasPreferredCargoCalculation&&!hasCheapestCargoCalculation){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__has-starting-price'},'(',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].hasStartingPriceSentence),')');},_this.renderPlaceHolder=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__placeholder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].loading));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductAvailabilityShipping,[{key:'render',value:function render(){var _props=this.props,activeProductId=_props.activeProductId,product=_props.product,scrollToShipping=_props.scrollToShipping;if(product.shippingStates.get(activeProductId)!==__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADED){return this.renderPlaceHolder();}var details=product.shippingDetails.get(activeProductId);if(!details.cheapest_option&&!details.preferred_pickup_option){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'ProductAvailabilityShipping'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_ButtonLink__["a" /* default */],{onClick:scrollToShipping},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductAvailabilityShipping__options'},this.renderCampaignPromotion(details.options),this.renderCheapestOption(details),this.renderPreferredPickup(details),this.renderCheckoutNotification(details))));}}]);return ProductAvailabilityShipping;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductAvailabilityShipping.propTypes={activeProductId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,scrollToShipping:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,withTax:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_CountryStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])(function(stores,props){return{countryStore:stores.countryStore,withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(ProductAvailabilityShipping));

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Discount__ = __webpack_require__(225);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DiscountSign=function(_Component){_inherits(DiscountSign,_Component);function DiscountSign(){_classCallCheck(this,DiscountSign);return _possibleConstructorReturn(this,(DiscountSign.__proto__||Object.getPrototypeOf(DiscountSign)).apply(this,arguments));}_createClass(DiscountSign,[{key:'render',value:function render(){var _props=this.props,percentage=_props.percentage,withLabel=_props.withLabel,withUpTo=_props.withUpTo,inverted=_props.inverted,className=_props.className;if(!percentage){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('DiscountSign',className,{'DiscountSign--inverted':inverted})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Discount__["a" /* default */],{percentage:percentage,withLabel:withLabel,withUpTo:withUpTo}));}}]);return DiscountSign;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DiscountSign.propTypes={percentage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,withLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,withUpTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,inverted:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (DiscountSign);

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_PhoneNumber__ = __webpack_require__(517);
var StoragePhoneNumber=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('StoragePhoneNumber',{type:__WEBPACK_IMPORTED_MODULE_1__types_PhoneNumber__["a" /* PhoneNumberType */],number:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (StoragePhoneNumber);

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductMultiProductPickerPropertySelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductMultiProductPickerPropertySelect=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductMultiProductPickerPropertySelect,_Component);function ProductMultiProductPickerPropertySelect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductMultiProductPickerPropertySelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductMultiProductPickerPropertySelect.__proto__||Object.getPrototypeOf(ProductMultiProductPickerPropertySelect)).call.apply(_ref,[this].concat(args))),_this),_this.renderSelectionImages=function(){var _this$props=_this.props,product=_this$props.product,productImages=_this$props.productImages,onProductChange=_this$props.onProductChange,activeProductId=_this$props.activeProductId,hidden=_this$props.hidden;if(!productImages||hidden){return null;}var images=product.multi.children.map(function(childProduct){var productImage=childProduct.getImage(childProduct.id)?childProduct.getImage(childProduct.id):product.getImage(childProduct.id);var isActive=activeProductId&&activeProductId===childProduct.id;var notAvailable=!childProduct.available_somewhere;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:childProduct.id,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('ProductMultiProductPickerPropertySelect__image',{'ProductMultiProductPickerPropertySelect__image--active':isActive,'ProductMultiProductPickerPropertySelect__image--not-available':notAvailable,'ProductMultiProductPickerPropertySelect__image--empty-image':!productImage}),onClick:function onClick(){return onProductChange(childProduct.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductImage__["a" /* default */],{product:product,productImage:productImage,size:'small',lazyLoading:false}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPickerPropertySelect__images'},images);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductMultiProductPickerPropertySelect,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,productImages=_props.productImages;var showImages=!configStore.product.hideMultiProductSelectionImage;var multiproductAsDropdown=configStore.product.multiproductAsDropdown;var productImagesLength=productImages.length<=1;if(!showImages||!multiproductAsDropdown||productImagesLength){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductMultiProductPickerPropertySelect'},this.renderSelectionImages());}}]);return ProductMultiProductPickerPropertySelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductMultiProductPickerPropertySelect.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,productImages:__WEBPACK_IMPORTED_MODULE_1_mobx_react__["a" /* PropTypes */].observableArray.isRequired,onProductChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,activeProductId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,hidden:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductMultiProductPickerPropertySelect));

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductStoreAvailability */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_StorageStore__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductStorageStock__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_BlockSpinner__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MINIMUM_STORAGES_FOR_FILTER=10;var messages=Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* defineMessages */])({'stock.filterByStorage':{'id':'stock.filterByStorage','defaultMessage':'Filter by storage'}});var ProductStoreAvailability=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductStoreAvailability,_Component);function ProductStoreAvailability(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductStoreAvailability);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductStoreAvailability.__proto__||Object.getPrototypeOf(ProductStoreAvailability)).call.apply(_ref,[this].concat(args))),_this),_this.state={selectedStorageId:''},_this.makeSureShoppingCenterStoragesLoaded=function(prevProps){var _this$props=_this.props,storageStore=_this$props.storageStore,activeProductId=_this$props.activeProductId,merchantSiteUrl=_this$props.merchantSiteUrl;if(prevProps.activeProductId!==activeProductId){storageStore.makeSureStoragesLoaded(merchantSiteUrl);}},_this.loadStocks=function(){var _this$props2=_this.props,product=_this$props2.product,activeProductId=_this$props2.activeProductId;if(product.stockStates.get(activeProductId)!==__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADED){product.loadStocks(activeProductId);}},_this.getStoreAvailability=function(){var _this$props3=_this.props,product=_this$props3.product,activeProductId=_this$props3.activeProductId,storageStore=_this$props3.storageStore;var storageList=storageStore.listingStorages;if(_this.state.selectedStorageId){storageList=[];var selectedStorage=storageStore.findStorageById(_this.state.selectedStorageId);if(selectedStorage){storageList.push(selectedStorage);}}return storageList.map(function(storage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ProductStorageStock__["a" /* default */],{key:storage.id,storage:storage,stock:product.findStorageStock(activeProductId,storage.id),activeProductId:activeProductId,product:product});});},_this.getStorageOptions=function(){var storageStore=_this.props.storageStore;return storageStore.listingStorages.map(function(storage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:storage.id,key:storage.id},storage.name);});},_this.handleChange=function(event){_this.setState({selectedStorageId:event.target.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductStoreAvailability,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,storageStore=_props.storageStore,merchantSiteUrl=_props.merchantSiteUrl;storageStore.makeSureStoragesLoaded(merchantSiteUrl);this.loadStocks();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props2=this.props,activeProductId=_props2.activeProductId,configStore=_props2.configStore;configStore.siteConfig.isShoppingCenter&&this.makeSureShoppingCenterStoragesLoaded(prevProps);if(prevProps.activeProductId!==activeProductId){this.loadStocks();}}},{key:'render',value:function render(){var _props3=this.props,product=_props3.product,activeProductId=_props3.activeProductId,storageStore=_props3.storageStore;var stockState=product.stockStates.get(activeProductId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStoreAvailability'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ProductStoreAvailability__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'stock.storeAvailabilityTitle',defaultMessage:'Product availability in stores'})),storageStore.listingStorages.length>=MINIMUM_STORAGES_FOR_FILTER&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["z" /* Label */],{'for':'ProductStoreAvailability__storage-select',hidden:true},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Input */],{type:'select',name:'select',className:'ProductStoreAvailability__storage-select',id:'ProductStoreAvailability__storage-select',onChange:this.handleChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},this.props.intl.formatMessage(messages['stock.filterByStorage'])),this.getStorageOptions())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStoreAvailability__headings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{className:'ProductStoreAvailability__heading',md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'stock.storeHeading',defaultMessage:'Store'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{className:'ProductStoreAvailability__heading',md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'stock.availabilityHeading',defaultMessage:'Availability'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{className:'ProductStoreAvailability__heading',md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'stock.addressHeading',defaultMessage:'Address'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{className:'ProductStoreAvailability__heading',md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'stock.contactHeading',defaultMessage:'Contact Information and Opening Hours'})))),(storageStore.state===__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADING||stockState===__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADING)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__loader_BlockSpinner__["a" /* default */],null),(storageStore.state===__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].ERROR||stockState===__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].ERROR)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__loader_UnexpectedError__["a" /* default */],null),product.stocks.get(activeProductId)&&storageStore.state===__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].LOADED&&this.getStoreAvailability());}}]);return ProductStoreAvailability;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductStoreAvailability.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_ConfigStore__["a" /* default */]).isRequired,storageStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_StorageStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired,merchantSiteUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','storageStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(ProductStoreAvailability)));

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductStorageStock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Storage__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Stock__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__map_GoogleMapModal__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ProductReserveInStoreButton__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_PhoneNumber__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductStorageStock=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductStorageStock,_Component);function ProductStorageStock(props){_classCallCheck(this,ProductStorageStock);var _this=_possibleConstructorReturn(this,(ProductStorageStock.__proto__||Object.getPrototypeOf(ProductStorageStock)).call(this,props));_this.toggleModal=function(){_this.setState({modal:!_this.state.modal});};_this.renderGoogleMapsModal=function(){var _this$props=_this.props,storage=_this$props.storage,intl=_this$props.intl;if(!storage.hasInformation||!_this.state.modal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__map_GoogleMapModal__["a" /* default */],{location:storage.map_link_search_text,locale:intl.locale,isOpen:_this.state.modal,toggle:_this.toggleModal,title:storage.name});};_this.renderNavigationAidButton=function(){var _this$props2=_this.props,uiStore=_this$props2.uiStore,storage=_this$props2.storage,intl=_this$props2.intl;if(!storage.hasInformation){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductStorageStock__map-button',{'ProductStorageStock__map-button-margin':uiStore.isMobile&&storage.hasInformation&&storage.hasAddress}),onClick:_this.toggleModal,color:'link','aria-label':intl.formatMessage({id:'stock.mapLink',defaultMessage:'Map and driving instructions'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'stock.mapLink',defaultMessage:'Map and driving instructions'}));};_this.renderStockLabel=function(){var stock=_this.props.stock;return stock&&stock.stock_label?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__availability',dangerouslySetInnerHTML:{__html:stock.stock_label}}):null;};_this.renderStockStorePickupLocation=function(){var _this$props3=_this.props,storage=_this$props3.storage,configStore=_this$props3.configStore,activeProductId=_this$props3.activeProductId,product=_this$props3.product;return storage.is_pickup_storage&&configStore.reserveInStore.enabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ProductReserveInStoreButton__["a" /* default */],{storage:storage,activeProductId:activeProductId,product:product,shouldHideButton:true});};_this.renderStorageAddressInformation=function(){var _this$props4=_this.props,uiStore=_this$props4.uiStore,storage=_this$props4.storage;if(!storage.hasInformation){return null;}if(uiStore.isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__address-information'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__street-address'},storage.street_address,' ',storage.postcode,' ',storage.city,' ',_this.renderNavigationAidButton()));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__address-information'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__street-address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,storage.street_address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductStorageStock__postcode'},storage.postcode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductStorageStock__city'},storage.city))));};_this.renderStoragePhoneNumbers=function(){var storage=_this.props.storage;var phoneNumberCount=storage.phone_numbers.length;return phoneNumberCount>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__phone-numbers'},storage.phone_numbers.map(function(phone,index){return phone&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'ProductStorageStock__phone-number'},_this.getPhoneNumber(phone));}));};_this.getPhoneNumber=function(phone){var type=phone.type,number=phone.number;if(type===__WEBPACK_IMPORTED_MODULE_14__types_PhoneNumber__["b" /* default */].WHATSAPP){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_Icon__["a" /* default */],{name:'whatsapp'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://wa.me/'+number,target:'_blank',rel:'noopener'},number));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_Icon__["a" /* default */],{name:'phone'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'tel:'+number},number)));};_this.renderStorageEmails=function(){var storage=_this.props.storage;var emailCount=storage.emails.length;return emailCount>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__storage-emails'},storage.emails.map(function(email,index){return email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'ProductStorageStock__storage-email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_Icon__["a" /* default */],{name:'envelope'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+email},email))));}));};_this.renderStorageOpeningHours=function(){var storage=_this.props.storage;var emailCount=storage.emails.length;return storage.opening_hours&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductStorageStock__storage-opening-hours',{separator:emailCount>0})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_Icon__["a" /* default */],{name:'clock-o'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,storage.opening_hours)));};_this.state={modal:false};return _this;}_createClass(ProductStorageStock,[{key:'renderStockShelfLocation',value:function renderStockShelfLocation(){var stock=this.props.stock;return stock&&stock.shelf_location?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__shelfLocation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'stock.shelfLocation',defaultMessage:'Shelf Location'}),': ',stock.shelf_location)):null;}},{key:'render',value:function render(){var _props=this.props,storage=_props.storage,uiStore=_props.uiStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock'},this.renderGoogleMapsModal(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__storage-name'},storage.name),!uiStore.isMobile&&this.renderNavigationAidButton()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:'3'},this.renderStockLabel(),this.renderStockShelfLocation(),this.renderStockStorePickupLocation()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:'3'},this.renderStorageAddressInformation()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductStorageStock__storage-contact-information'},this.renderStoragePhoneNumbers(),this.renderStorageEmails()),this.renderStorageOpeningHours())));}}]);return ProductStorageStock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductStorageStock.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_UIStore__["a" /* default */]).isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__models_Product__["a" /* default */]).isRequired,storage:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Storage__["a" /* default */]).isRequired,stock:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Stock__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','uiStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(ProductStorageStock)));

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleMapEmbed__ = __webpack_require__(1039);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoogleMapModal=function(_Component){_inherits(GoogleMapModal,_Component);function GoogleMapModal(){_classCallCheck(this,GoogleMapModal);return _possibleConstructorReturn(this,(GoogleMapModal.__proto__||Object.getPrototypeOf(GoogleMapModal)).apply(this,arguments));}_createClass(GoogleMapModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["C" /* Modal */],{className:'GoogleMapModal',size:'lg',toggle:this.props.toggle,isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["F" /* ModalHeader */],{className:'GoogleMapModal__header',toggle:this.props.toggle},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GoogleMapEmbed__["a" /* default */],{location:this.props.location,locale:this.props.locale})));}}]);return GoogleMapModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GoogleMapModal.propTypes={location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,locale:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,toggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isOpen:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (GoogleMapModal);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoogleMapEmbed=function(_Component){_inherits(GoogleMapEmbed,_Component);function GoogleMapEmbed(){_classCallCheck(this,GoogleMapEmbed);return _possibleConstructorReturn(this,(GoogleMapEmbed.__proto__||Object.getPrototypeOf(GoogleMapEmbed)).apply(this,arguments));}_createClass(GoogleMapEmbed,[{key:'render',value:function render(){var _props=this.props,location=_props.location,locale=_props.locale;var src='//maps.google.fi/maps?&q='+location+'&z=14&hl='+locale+'&output=embed';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'Google map',frameBorder:'0',scrolling:'no',marginHeight:'0',marginWidth:'0',width:'100%',height:'320',src:src}));}}]);return GoogleMapEmbed;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GoogleMapEmbed.propTypes={location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,locale:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (GoogleMapEmbed);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Storage__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Product__ = __webpack_require__(18);
var ReserveInStoreModal=__WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */].named('ReserveInStoreModal').props({storage:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_2__Storage__["a" /* default */])),product:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].union(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_3__Product__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].undefined,__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].null),activeProductId:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),// Used as a "key" for forcing the modal to remount when it is opened.
// Using isOpen directly would work, except that it breaks the fadeout
// animation; this way, we can make the key only change when opened and
// not when it is closed.
refreshCounter:0}).actions(function(self){var superToggle=self.toggle;return{setStorage:function setStorage(storageId){self.storage=storageId;},setProduct:function setProduct(productId,activeProductId){self.product=productId;self.activeProductId=activeProductId;self.storage=null;},toggle:function toggle(){superToggle();if(self.isOpen){self.refreshCounter++;self.storage=null;}}};});/* harmony default export */ __webpack_exports__["a"] = (ReserveInStoreModal);

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(489),
    pullAll = __webpack_require__(1042);

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

module.exports = pull;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__(1043);

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

module.exports = pullAll;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(144),
    baseIndexOf = __webpack_require__(509),
    baseIndexOfWith = __webpack_require__(1044),
    baseUnary = __webpack_require__(148),
    copyArray = __webpack_require__(454);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

module.exports = basePullAll;


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOfWith;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(1046),
    hasUnicode = __webpack_require__(234),
    unicodeSize = __webpack_require__(1047);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(440);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductCardProperties */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_ProductPropertyType__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProductCardPropertySelect__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductCardProperties=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductCardProperties,_Component);function ProductCardProperties(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductCardProperties);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductCardProperties.__proto__||Object.getPrototypeOf(ProductCardProperties)).call.apply(_ref,[this].concat(args))),_this),_this.getFirstCollectionProperty=function(product){return product.collection.shouldSwapCollectionOrder()?product.collection.row:product.collection.column;},_this.getSecondCollectionProperty=function(product){return product.collection.shouldSwapCollectionOrder()?product.collection.column:product.collection.row;},_this.getElementIds=function(elementId,isFirstCollection){var _this$props=_this.props,product=_this$props.product,selectedElementId=_this$props.selectedElementId;var elementIds={columnId:null,rowId:null};// Check if collections are swapped
var firstProperty='columnId';var secondProperty='rowId';if(product.collection.shouldSwapCollectionOrder()){firstProperty='rowId';secondProperty='columnId';}if(isFirstCollection){elementIds[firstProperty]=elementId;}else{elementIds[firstProperty]=selectedElementId;elementIds[secondProperty]=elementId;}// If a property is empty, we know that the element ID is 0.
if(product.collection.column.isEmpty()){elementIds.columnId=0;}if(product.collection.row.isEmpty()){elementIds.rowId=0;}return elementIds;},_this.onCollectionPropertyElementClick=function(propertyId,elementId,isFirstCollectionClicked){var _this$props2=_this.props,history=_this$props2.history,product=_this$props2.product,routeService=_this$props2.routeService;var elementIds=_this.getElementIds(elementId,isFirstCollectionClicked);// If we know both element IDs, link directly to active product
var path=void 0;if(elementIds.columnId!==null&&elementIds.rowId!==null){var item=product.collection.getItem(elementIds.columnId,elementIds.rowId);path=product.pathWithActiveProductId(item.product.id);}else{path=Object(__WEBPACK_IMPORTED_MODULE_8__util_queryString__["a" /* addParametersToPath */])(product.path,elementIds);}history.push(routeService.getProductPath(product,path));},_this.onCollectionElementHover=function(elementId,isFirstCollection){var onFirstCollectionElementHovered=_this.props.onFirstCollectionElementHovered;if(isFirstCollection){onFirstCollectionElementHovered(elementId);}},_this.isElementAvailable=function(elementId,isFirstProperty){var product=_this.props.product;var _this$getElementIds=_this.getElementIds(elementId,isFirstProperty),columnId=_this$getElementIds.columnId,rowId=_this$getElementIds.rowId;var status=void 0;if(columnId!==null&&rowId!==null){status=product.collection.getItemStatus(columnId,rowId);}else if(columnId!==null){status=product.collection.getColumnStatus(columnId);}else{status=product.collection.getRowStatus(rowId);}return status.available;},_this.componentForCollectionProperty=function(collectionProperty,isFirstProperty){var _this$props3=_this.props,product=_this$props3.product,filterNotInStockElements=_this$props3.filterNotInStockElements;if(collectionProperty.isEmpty()){return null;}var selectedElementId=_this.props.selectedElementId;var clickHandler=function clickHandler(propertyId,elementId){return _this.onCollectionPropertyElementClick(propertyId,elementId,isFirstProperty);};var hoverHandler=function hoverHandler(propertyId,elementId){return _this.onCollectionElementHover(elementId,isFirstProperty);};var elements=filterNotInStockElements&&!product.canBeOrderedOutOfStock?collectionProperty.elements.filter(function(element){return _this.isElementAvailable(element.id,isFirstProperty);}):collectionProperty.elements;if(elements.length===0){return null;}var selectedElementIdForComponent=null;if(isFirstProperty){selectedElementIdForComponent=selectedElementId||elements[0].id;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ProductCardPropertySelect__["a" /* default */],{product:product,propertyId:collectionProperty.id,elements:elements,onElementClick:clickHandler,onElementHover:hoverHandler,selectedElementId:selectedElementIdForComponent,asThumbnails:collectionProperty.type===__WEBPACK_IMPORTED_MODULE_9__types_ProductPropertyType__["b" /* default */].COLOR});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductCardProperties,[{key:'render',value:function render(){var product=this.props.product;if(product.class!==__WEBPACK_IMPORTED_MODULE_7__types_ProductClass__["b" /* default */].COLLECTION){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductCardProperties'},this.componentForCollectionProperty(this.getFirstCollectionProperty(product),true),this.componentForCollectionProperty(this.getSecondCollectionProperty(product),false));}}]);return ProductCardProperties;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;ProductCardProperties.propTypes={filterNotInStockElements:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,product:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Product__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.history.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired,onFirstCollectionElementHovered:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,selectedElementId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])(function(_ref2){var configStore=_ref2.configStore,routeService=_ref2.routeService;return{filterNotInStockElements:configStore.inStockProductsOnly,routeService:routeService};})(ProductCardProperties)));

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ProductPropertyElement__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Slider__ = __webpack_require__(154);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SLIDER_SETTINGS={draggable:false,swipeToSlide:true,variableWidth:true,arrows:true,infinite:false,slidesToScroll:1,easing:'ease-out',speed:200};var ProductCardPropertySelect=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductCardPropertySelect,_Component);function ProductCardPropertySelect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductCardPropertySelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductCardPropertySelect.__proto__||Object.getPrototypeOf(ProductCardPropertySelect)).call.apply(_ref,[this].concat(args))),_this),_this.getComponentsForElements=function(){var _this$props=_this.props,product=_this$props.product,propertyId=_this$props.propertyId,elements=_this$props.elements,selectedElementId=_this$props.selectedElementId,asThumbnails=_this$props.asThumbnails,onElementClick=_this$props.onElementClick,onElementHover=_this$props.onElementHover;return elements.map(function(element){var content=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,element.name);var productImage=void 0;if(asThumbnails){var imageDataForElement=product.images.find(function(image){return image.for_color_id===element.id;});if(imageDataForElement){productImage=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductImage__["a" /* default */],{product:product,productImage:imageDataForElement,size:'small'});}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:element.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_0_classnames___default()('ProductCardPropertySelect__item',{'ProductCardPropertySelect__item--image':asThumbnails,'ProductCardPropertySelect__item--text':!asThumbnails,'ProductCardPropertySelect__item--selected':selectedElementId===element.id,'ProductCardPropertySelect__item--empty-image':asThumbnails&&!productImage}),onClick:function onClick(){return onElementClick(propertyId,element.id);},onMouseOver:function onMouseOver(){return onElementHover(propertyId,element.id);}},productImage||content));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductCardPropertySelect,[{key:'render',value:function render(){var _props=this.props,asThumbnails=_props.asThumbnails,product=_props.product;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_0_classnames___default()('ProductCardPropertySelect',{'ProductCardPropertySelect--thumbnails':asThumbnails})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Slider__["a" /* default */],Object.assign({key:product.id},SLIDER_SETTINGS),this.getComponentsForElements()));}}]);return ProductCardPropertySelect;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;ProductCardPropertySelect.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_Product__["a" /* default */]).isRequired,propertyId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,elements:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ProductPropertyElement__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ProductPropertyElement__["a" /* default */]))]).isRequired,onElementClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onElementHover:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,selectedElementId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,asThumbnails:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ProductCardPropertySelect);

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddToCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_head__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_QuantityFieldGroup__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__product_ProductAdditionalService__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AddToCartServices__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddToCart=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AddToCart,_Component);function AddToCart(props){_classCallCheck(this,AddToCart);var _this=_possibleConstructorReturn(this,(AddToCart.__proto__||Object.getPrototypeOf(AddToCart)).call(this,props));_this.initializeForm=function(_ref){var ifUpdated=_ref.ifUpdated;var _this$props=_this.props,quantity=_this$props.quantity,maxQuantity=_this$props.maxQuantity,quantityStep=_this$props.quantityStep,product=_this$props.product,withServices=_this$props.withServices,withQuantityPicker=_this$props.withQuantityPicker;_this.form=null;_this.formFields={};_this.formFields.quantity=Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:withQuantityPicker?String(quantityStep):quantity},[Object(__WEBPACK_IMPORTED_MODULE_17__util_formValidators__["j" /* quantityValid */])(maxQuantity,quantityStep),Object(__WEBPACK_IMPORTED_MODULE_17__util_formValidators__["i" /* productCountValid */])(quantityStep)]);if(withServices&&product.additionalServices.length>0){ifUpdated&&_this.updateState();product.additionalServices.forEach(function(service){_this.createTextInputOption(service);_this.createRadioButtonOptions(service);_this.createCheckboxOptions(service);_this.createDropdownOptions(service);_this.createSelectedService(service);});_this.createPostalCodeField();}_this.form=Object(__WEBPACK_IMPORTED_MODULE_9__models_Form__["a" /* createForm */])(_this.formFields);};_this.updateState=function(){// Use state because component tries to render before dynamic form is reinitialized.
_this.setState({servicesInitialized:true});};_this.createTextInputOption=function(service){if(service.enable_text_input){var textFieldName='text_'+service.id;_this.formFields[textFieldName]=Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({});}};_this.createRadioButtonOptions=function(service){var radioButtonOptions=_this.getRadioButtonOptions(service);if(radioButtonOptions.length>0){var radioFieldName='radioOptions_'+service.id;_this.formFields[radioFieldName]=Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({});_this.formFields[radioFieldName].setValue(__WEBPACK_IMPORTED_MODULE_0_lodash_head___default()(radioButtonOptions).product_id);}};_this.createCheckboxOptions=function(service){var checkboxOptions=_this.getCheckboxOptions(service);if(checkboxOptions.length>0){var checkboxFieldName='checkboxOptions_'+service.id;_this.formFields[checkboxFieldName]=Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({});}};_this.getCheckboxOptions=function(service){return service.options.filter(function(option){return option.type.indexOf(__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].CHECKBOX)!==-1;});};_this.createDropdownOptions=function(service){var dropdownOptions=_this.getDropdownOptions(service);if(dropdownOptions.length>0){var dropdownFieldName='dropdownOptions_'+service.id;_this.formFields[dropdownFieldName]=Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({});_this.formFields[dropdownFieldName].setValue(__WEBPACK_IMPORTED_MODULE_0_lodash_head___default()(dropdownOptions).product_id);}};_this.getDropdownOptions=function(service){return service.options.filter(function(option){return option.type.indexOf(__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].DROPDOWN)!==-1;});};_this.createSelectedService=function(service){var selectedService=_this.ifCreateService(service);if(selectedService){var serviceObject=_this.createService(service.id,service.product_id,true,'',{},service.text_max_length,service.text_required);_this.state.selectedServices.push(serviceObject);}};_this.ifCreateService=function(service){return(service.is_required||service.selected_by_default)&&!service.requires_area_validation;};_this.createPostalCodeField=function(){var product=_this.props.product;if(product.ifServiceRequiresPostalCodeValidation()){var postalCodeFieldName='postalCode_'+product.id;_this.formFields[postalCodeFieldName]=Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({});}};_this.handleSubmit=function(e){var _this$props2=_this.props,categoryStore=_this$props2.categoryStore,product=_this$props2.product;e.preventDefault();_this.form.validate();var postalCodeField=_this.getPostalCodeField();if(_this.form.valid&&postalCodeField&&postalCodeField.value){product.validateAdditionalServices({category:categoryStore.activeCategory.id,postalCode:postalCodeField.value}).then(_this.handleValidatedServices);}};_this.handleValidatedServices=function(){var product=_this.props.product;var postalCodeField=_this.getPostalCodeField();var validServices=product.getValidatedServices({productId:product.id,postalCode:postalCodeField.value});validServices.forEach(function(service){var isRequired=service.is_required;var postalCodeIsRequired=service.requires_area_validation;var selectedByDefault=service.selected_by_default;if(postalCodeIsRequired&&(isRequired||selectedByDefault)){var serviceObject=_this.createService(service.id,service.product_id,service.valid_postal_code,'',{},service.text_max_length,service.text_required);_this.handleAdditionalServiceClick(serviceObject);}});};_this.getPostalCodeValidationState=function(){var product=_this.props.product;var postalCodeField=_this.getPostalCodeField();if(!postalCodeField||!postalCodeField.value){return{loading:false,ifValidatedService:false};}var serviceIsLoading=product.validatedServicesState.get(product.id+'--'+postalCodeField.value)===__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;var ifValidatedService=product.ifValidatedServicesExists({productId:product.id,postalCode:postalCodeField.value});return{serviceIsLoading:serviceIsLoading,ifValidatedService:ifValidatedService};};_this.getPostalCodeField=function(){var product=_this.props.product;if(!product.ifServiceRequiresPostalCodeValidation()){return;}return _this.form.fields.get('postalCode_'+product.id);};_this.createService=function(id,productId,isSelected,text,options,textMaxLength,textRequired){return{id:id,productId:productId,isSelected:isSelected,text:text,options:options,textMaxLength:textMaxLength,textRequired:textRequired};};_this.validText=function(service){if(service.textRequired===true&&service.text.length===0){return false;}return!(service.textMaxLength&&service.text.length>service.textMaxLength);};_this.servicesAreValid=function(){var product=_this.props.product;var valid=true;var requiredServiceIds=product.additionalServices.filter(function(service){return service.is_required;}).map(function(service){return service.id;});var selectedService=_this.state.selectedServices.filter(function(service){return service.isSelected;});// Make sure required services are selected.
var selectedServiceIds=selectedService.map(function(service){return service.id;});valid=requiredServiceIds.every(function(id){return selectedServiceIds.includes(id);});selectedService.forEach(function(service){if(!_this.validText(service)){valid=false;}});return valid;};_this.handleAddToCartClick=function(e){var _this$props3=_this.props,disabled=_this$props3.disabled,quantity=_this$props3.quantity,product=_this$props3.product,configStore=_this$props3.configStore,uiStore=_this$props3.uiStore,loading=_this$props3.loading;var ifServices=product.additionalServices&&product.additionalServices.length;var ifAdditionalServicesModalEnabled=configStore.productPage.enableAdditionalServicesModal;var servicesAreLoading=product.additionalServicesState===__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;var toggleServicesModal=uiStore.additionalServicesModal.toggle;if(ifAdditionalServicesModalEnabled&&servicesAreLoading||loading){return;}if(!disabled){e.preventDefault();ifAdditionalServicesModalEnabled&&ifServices?toggleServicesModal():_this.addProductToCart(quantity);}};_this.handleModalAddToCartClick=function(e){var _this$props4=_this.props,disabled=_this$props4.disabled,quantity=_this$props4.quantity,uiStore=_this$props4.uiStore;var toggleServicesModal=uiStore.additionalServicesModal.toggle;if(!disabled){e.preventDefault();toggleServicesModal();_this.addProductToCart(quantity);}};_this.addProductToCart=function(quantity){var onAddToCartClick=_this.props.onAddToCartClick;_this.form.validate();if(_this.form.valid&&_this.servicesAreValid()&&onAddToCartClick&&_this.getQuantity()===quantity){onAddToCartClick(_this.getQuantity(),_this.getServices());}};_this.handleAdditionalServiceClick=function(value){var selectedServices=_this.state.selectedServices;if(selectedServices.length===0||__WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(selectedServices,function(val){return val.id===value.id;}).length===0){selectedServices.push(value);}else{selectedServices.forEach(function(service){if(service.id===value.id){service.isSelected=value.isSelected;service.text=value.text;service.options=value.options;}});}_this.setState({selectedServices:selectedServices});};_this.getQuantity=function(){return Number(_this.form.fields.get('quantity').value);};_this.getOptionProductIds=function(options){var optionsArray=[];if(options.checkbox){options.checkbox.forEach(function(value){optionsArray.push(value);});}return optionsArray;};_this.getProductIds=function(service){var ids=[];if(service.productId){ids.push({service_id:service.id,id:service.productId,addText:true});}if(service.options){var optionIds=_this.getOptionProductIds(service.options);optionIds.forEach(function(id){ids.push({id:id,addText:false});});}if(_this.form.fields.get('radioOptions_'+service.id)){ids.push({id:_this.form.fields.get('radioOptions_'+service.id).value,addText:false});}if(_this.form.fields.get('dropdownOptions_'+service.id)){ids.push({id:_this.form.fields.get('dropdownOptions_'+service.id).value,addText:false});}return ids;};_this.getServices=function(){var selectedServices=_this.state.selectedServices;var servicesToCart=[];var services=selectedServices.filter(function(service){return service.isSelected;});services.forEach(function(service){var productIds=_this.getProductIds(service);productIds.map(function(id){return servicesToCart.push({service_id:id.service_id,products_id:id.id,text:id.addText?service.text:''});});});return servicesToCart;};_this.setButtonElement=function(ref){_this.buttonElement=ref;_this.setState({buttonMounted:true});};_this.getServiceInfo=function(id){var match=_this.state.selectedServices.map(function(service){return service;}).filter(function(service){return service.id===id;});return match.length!==0?match:null;};_this.onUpdateProductQuantity=function(quantity){var _this$props5=_this.props,cartStore=_this$props5.cartStore,onUpdateProductQuantity=_this$props5.onUpdateProductQuantity;if(onUpdateProductQuantity){cartStore.updateProductQuantity(quantity);onUpdateProductQuantity(quantity);}};_this.renderProductAdditionalServices=function(service,index){var _this$props6=_this.props,withTax=_this$props6.withTax,product=_this$props6.product;var data=__WEBPACK_IMPORTED_MODULE_0_lodash_head___default()(_this.getServiceInfo(service.id));var textField=_this.form.fields.get('text_'+service.id);var checkBoxField=_this.form.fields.get('checkboxOptions_'+service.id);var radioField=_this.form.fields.get('radioOptions_'+service.id);var dropdownField=_this.form.fields.get('dropdownOptions_'+service.id);var postalCodeField=_this.getPostalCodeField();return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__product_ProductAdditionalService__["a" /* default */],{key:service.id+'-'+index,service:service,withTax:withTax,formName:_this.formName,isSelected:data?data.isSelected:false,text:data?data.text:'',textField:textField,checkboxField:checkBoxField,radioField:radioField,dropdownField:dropdownField,postalCodeField:postalCodeField,selectedOptions:data?data.options:null,handleSelectedServices:_this.handleAdditionalServiceClick,product:product});};_this.ifRenderServices=function(){var _this$props7=_this.props,disabled=_this$props7.disabled,withServices=_this$props7.withServices;return!disabled&&withServices&&_this.state.servicesInitialized;};_this.ifButtonDisabled=function(){var _this$props8=_this.props,configStore=_this$props8.configStore,product=_this$props8.product,quantity=_this$props8.quantity,minOrderQuantity=_this$props8.minOrderQuantity;var ifRequiresPostalCodeValidation=product.ifServiceRequiresPostalCodeValidation();var ifRequired=product.ifServiceIsRequiredAndRequiresPostalCodeValidation();var _this$getPostalCodeVa=_this.getPostalCodeValidationState(),ifValidatedService=_this$getPostalCodeVa.ifValidatedService;var ifAdditionalServicesModalEnabled=configStore.productPage.enableAdditionalServicesModal;if(ifAdditionalServicesModalEnabled){return _this.form.valid===false||quantity<minOrderQuantity;}return _this.ifOrderDisabled()||ifRequiresPostalCodeValidation&&ifRequired&&!ifValidatedService;};_this.ifOrderDisabled=function(){var _this$props9=_this.props,quantity=_this$props9.quantity,minOrderQuantity=_this$props9.minOrderQuantity;return _this.form.valid===false||_this.servicesAreValid()===false||quantity<minOrderQuantity;};_this.state={buttonMounted:false,servicesInitialized:false,selectedServices:[]};_this.form=null;_this.formName='AddToCartForm';_this.buttonElement=null;_this.initializeForm({ifUpdated:false});return _this;}_createClass(AddToCart,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.onUpdateProductQuantity){this.props.onUpdateProductQuantity(this.getQuantity());}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props=this.props,withServices=_props.withServices,maxQuantity=_props.maxQuantity;if(prevProps.withServices!==withServices||prevProps.maxQuantity!==maxQuantity||prevProps.withServices&&withServices&&!this.state.servicesInitialized){this.initializeForm({ifUpdated:true});}}},{key:'getRadioButtonOptions',value:function getRadioButtonOptions(service){return service.options.filter(function(option){return option.type.indexOf(__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].RADIO)!==-1;});}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,disabled=_props2.disabled,ifWebStore=_props2.ifWebStore,loading=_props2.loading,maxQuantity=_props2.maxQuantity,notAllowed=_props2.notAllowed,product=_props2.product,quantityStep=_props2.quantityStep,scrollToServices=_props2.scrollToServices,tooltipMessage=_props2.tooltipMessage,unit=_props2.unit,withQuantityPicker=_props2.withQuantityPicker;var addToCartButtonClassNames=__WEBPACK_IMPORTED_MODULE_6_classnames___default()({// We add disabled as a className instead of a prop to handle disabled button onClick -events
disabled:disabled,'AddToCart__button--not-allowed':notAllowed},'AddToCart__button');var quantityField=this.form.fields.get('quantity');var servicesAreLoading=product.additionalServicesState===__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'AddToCart'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'form-inline'},this.ifRenderServices()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__AddToCartServices__["a" /* default */],{services:product.additionalServices,onAddToCart:this.handleModalAddToCartClick,renderService:function renderService(service,index){return _this2.renderProductAdditionalServices(service,index);},disabled:servicesAreLoading||this.ifOrderDisabled(),scrollToServices:scrollToServices,ifValidForm:this.form.valid,onSubmit:this.handleSubmit,onChange:this.handleAdditionalServiceClick,postalCodeField:this.getPostalCodeField(),product:product}),withQuantityPicker&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_QuantityFieldGroup__["a" /* default */],{key:product.id,className:'AddToCart__quantity-group',disabled:disabled||servicesAreLoading,field:quantityField,maxQuantity:maxQuantity,quantityStep:quantityStep,unit:unit,onUpdateProductQuantity:this.onUpdateProductQuantity}),ifWebStore&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{color:'primary',className:addToCartButtonClassNames,disabled:loading||servicesAreLoading||this.ifButtonDisabled(),onClick:this.handleAddToCartClick,innerRef:this.setButtonElement},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:loading?'circle-o-notch':'shopping-cart',spin:loading}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__["a" /* default */].addToCartButton)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_FieldError__["a" /* default */],{field:this.form.fields.get('quantity')})),tooltipMessage&&this.state.buttonMounted&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["V" /* UncontrolledTooltip */],{placement:'top',target:this.buttonElement},tooltipMessage));}}]);return AddToCart;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;AddToCart.propTypes={cartStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_CartStore__["a" /* default */]).isRequired,categoryStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_CategoryStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_23__store_UIStore__["a" /* default */]).isRequired,onAddToCartClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,maxQuantity:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,quantityStep:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__models_Product__["a" /* default */]).isRequired,onUpdateProductQuantity:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,scrollToServices:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,tooltipMessage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,unit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,quantity:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,minOrderQuantity:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,disabled:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,notAllowed:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,withTax:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,withServices:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,withQuantityPicker:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,ifWebStore:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};AddToCart.defaultProps={ifWebStore:true,withQuantityPicker:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('cartStore','categoryStore','configStore','uiStore')(AddToCart));

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(146);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductAdditionalService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_head__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Switch__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_AdditionalService__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__form_CheckboxField__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_RadioField__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_SelectField__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_ImageLightbox__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputStatus={NONE:'NONE',TEXT_TOO_LONG:'TEXT_TOO_LONG',TEXT_REQUIRED:'TEXT_REQUIRED'};var DEFAULT_SERVICE_OPTIONS_CONTAINER_HEIGHT=150;var DEFAULT_SERVICE_OPTIONS_COUNT_BREAK=10;var DEFAULT_SERVICE_OPTIONS_ADD_HEIGHT=15;var labels={postalCodeRequired:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'additionalService.postalCodeRequired',defaultMessage:'Eligible postal code is required for the service'}),postalCodeIsInvalid:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'additionalService.postalCodeIsInvalid',defaultMessage:'Postal code is invalid for this service'})};function createImage(index,product_id,path,alt){return{index:index,product_id:product_id,path:path,alt:alt};}var ProductAdditionalService=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductAdditionalService,_Component);function ProductAdditionalService(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductAdditionalService);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductAdditionalService.__proto__||Object.getPrototypeOf(ProductAdditionalService)).call.apply(_ref,[this].concat(args))),_this),_this.state={inputStatus:InputStatus.NONE,selectedDropdown:null,lightboxIsOpen:false,activeImage:0},_this.toggleLightbox=function(){var product_id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';_this.setState({lightboxIsOpen:!_this.state.lightboxIsOpen,activeImage:_this.getImageIndex(product_id)});},_this.radio=function(fieldName,props){var _this$props=_this.props,formName=_this$props.formName,radioField=_this$props.radioField;if(!radioField){return null;}return radioField.active&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__form_RadioField__["a" /* default */],Object.assign({className:'ProductAdditionalService__RadioFieldSet',inline:false,field:radioField,formName:formName,fieldName:fieldName,handleChange:_this.handleRadioChange},props));},_this.checkbox=function(fieldName,props){var _this$props2=_this.props,formName=_this$props2.formName,checkboxField=_this$props2.checkboxField;if(!checkboxField){return null;}return checkboxField.active&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__form_CheckboxField__["a" /* default */],Object.assign({className:'ProductAdditionalService__CheckboxFieldSet',key:fieldName,field:checkboxField,formName:formName,fieldName:fieldName,handleChange:_this.handleCheckboxChange},props));},_this.dropdown=function(fieldName,props){var _this$props3=_this.props,formName=_this$props3.formName,dropdownField=_this$props3.dropdownField;if(!dropdownField){return null;}return dropdownField.active&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__form_SelectField__["a" /* default */],Object.assign({key:fieldName,className:'ProductAdditionalService__DropdownFieldSet',field:dropdownField,formName:formName,fieldName:fieldName,handleChange:_this.handleDropdownChange,style:{width:'100%',color:'#333'}},props));},_this.textarea=function(fieldName,props){var _this$props4=_this.props,formName=_this$props4.formName,text=_this$props4.text,textField=_this$props4.textField;if(!textField){return null;}return textField.active&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_FormGroupField__["a" /* default */],Object.assign({field:textField,formName:formName,fieldName:fieldName,type:'textarea',value:text},props));},_this.createService=function(id,productId,isSelected,text,options,textMaxLength,textRequired){return{id:id,productId:productId,isSelected:isSelected,text:text,options:options,textMaxLength:textMaxLength,textRequired:textRequired};},_this.handleServiceToggle=function(){var _this$props5=_this.props,service=_this$props5.service,isSelected=_this$props5.isSelected,text=_this$props5.text,selectedOptions=_this$props5.selectedOptions,handleSelectedServices=_this$props5.handleSelectedServices;handleSelectedServices(_this.createService(service.id,service.product_id,!isSelected,text,selectedOptions,service.text_max_length,service.text_required));},_this.handleTextChange=function(e){var _this$props6=_this.props,service=_this$props6.service,isSelected=_this$props6.isSelected,selectedOptions=_this$props6.selectedOptions,handleSelectedServices=_this$props6.handleSelectedServices;if(service.text_required&&e.target.value.length===0){_this.setState({inputStatus:InputStatus.TEXT_REQUIRED});}else if(service.text_max_length&&e.target.value.length>service.text_max_length){_this.setState({inputStatus:InputStatus.TEXT_TOO_LONG});}else{if(_this.state.inputStatus!==InputStatus.NONE){_this.setState({inputStatus:InputStatus.NONE});}}handleSelectedServices(_this.createService(service.id,service.product_id,isSelected,e.target.value,selectedOptions,service.text_max_length,service.text_required));},_this.getCheckboxValues=function(value){var selectedOptions=_this.props.selectedOptions;var currentOptions=[];if(selectedOptions&&selectedOptions.checkbox){currentOptions=selectedOptions.checkbox.slice();}var hasValue=currentOptions.indexOf(value);if(hasValue!==-1){currentOptions.splice(hasValue,1);}else{currentOptions.push(value);}return currentOptions;},_this.handleCheckboxChange=function(e){var _this$props7=_this.props,text=_this$props7.text,service=_this$props7.service,isSelected=_this$props7.isSelected,checkboxField=_this$props7.checkboxField,selectedOptions=_this$props7.selectedOptions,handleSelectedServices=_this$props7.handleSelectedServices;var newOptions={};var values=_this.getCheckboxValues(e.target.value);if(selectedOptions){newOptions=selectedOptions;}newOptions.checkbox=values;checkboxField.setValue(values);handleSelectedServices(_this.createService(service.id,service.product_id,isSelected,text,newOptions,service.text_max_length,service.text_required));},_this.handleRadioChange=function(e){var _this$props8=_this.props,text=_this$props8.text,service=_this$props8.service,isSelected=_this$props8.isSelected,radioField=_this$props8.radioField,selectedOptions=_this$props8.selectedOptions,handleSelectedServices=_this$props8.handleSelectedServices;var newOptions={};if(selectedOptions){newOptions=selectedOptions;}newOptions.radio=e.target.value;_this.setState({activeImage:_this.getImageIndex(e.target.value)});radioField.setValue(e.target.value);handleSelectedServices(_this.createService(service.id,service.product_id,isSelected,text,newOptions,service.text_max_length,service.text_required));},_this.handleDropdownChange=function(e){var _this$props9=_this.props,text=_this$props9.text,service=_this$props9.service,isSelected=_this$props9.isSelected,dropdownField=_this$props9.dropdownField,selectedOptions=_this$props9.selectedOptions,handleSelectedServices=_this$props9.handleSelectedServices;var newOptions={};if(selectedOptions){newOptions=selectedOptions;}newOptions.dropdown=e.target.value;_this.setState({selectedDropdown:e.target.value,activeImage:_this.getImageIndex(e.target.value)});dropdownField.setValue(e.target.value);handleSelectedServices(_this.createService(service.id,service.product_id,isSelected,text,newOptions,service.text_max_length,service.text_required));},_this.renderHeaderHtml=function(){var service=_this.props.service;return service.header_html.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_WysiwygContent__["a" /* default */],{html:service.header_html}):null;},_this.renderServiceSelectionText=function(){var service=_this.props.service;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__toggle-description'},service.selection_text,service.is_required&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'ProductAdditionalService__required-service'},'*'));},_this.renderServiceToggler=function(){var _this$props10=_this.props,isSelected=_this$props10.isSelected,service=_this$props10.service,product=_this$props10.product,postalCodeField=_this$props10.postalCodeField;var isRequired=service.is_required;var postalCodeIsRequired=service.requires_area_validation;var ifValidatedService=postalCodeIsRequired&&product.getValidatedService({productId:product.id,postalCode:postalCodeField.value,serviceId:service.id});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__toggle'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__toggle-switch'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Switch__["a" /* default */],{checked:isSelected,disabled:isRequired||postalCodeIsRequired&&(isRequired||!ifValidatedService),onChange:_this.handleServiceToggle},_this.renderServiceSelectionText())),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__toggle-price'},_this.renderPrice(service.price)));},_this.renderDescription=function(){var service=_this.props.service;return service.description.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_WysiwygContent__["a" /* default */],{html:service.description}):null;},_this.renderPrice=function(price){var withTax=_this.props.withTax;if(price.with_tax>0){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Price__["a" /* default */],{price:price.getPrice(withTax)});}return null;},_this.renderTextInput=function(){var service=_this.props.service;if(!service.enable_text_input){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__content-text'},service.text_input_info&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__text-description'},service.text_input_info),_this.textarea('text_'+service.id,{label:service.text_max_length?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'additionalService.typeTextHereLengthSentence',defaultMessage:'Type your text here. Maximum of {maxLength} characters.',values:{maxLength:service.text_max_length}}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'additionalService.typeTextHereSentence',defaultMessage:'Type your text here.'}),onChange:_this.handleTextChange}));},_this.getOptionLabel=function(option){var withTax=_this.props.withTax;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__option-label'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__option-label-text'},option.selection_text),option.price.with_tax>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__option-label-price'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Price__["a" /* default */],{price:option.price.getPrice(withTax)})),_this.hasImages()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__option-label-image',onClick:function onClick(){return _this.toggleLightbox(option.product_id);}},option.image&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:option.image,alt:option.selection_text,loading:'lazy'})));},_this.getSelectOptionLabel=function(option){var _this$props11=_this.props,withTax=_this$props11.withTax,currencyStore=_this$props11.currencyStore;var price=option.price.getPrice(withTax);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,option.selection_text,price>0?'  '+Object(__WEBPACK_IMPORTED_MODULE_20__util_number__["d" /* formatPrice */])(price,currencyStore.activeCurrency):null);},_this.getDropdownOptionImage=function(){var service=_this.props.service;var selectedDropdown=_this.state.selectedDropdown;var filteredOption=void 0;if(selectedDropdown===null){filteredOption=__WEBPACK_IMPORTED_MODULE_1_lodash_head___default()(service.options.filter(function(option){return option.type===__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].DROPDOWN;}));}else{filteredOption=__WEBPACK_IMPORTED_MODULE_1_lodash_head___default()(service.options.filter(function(option){return option.type===__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].DROPDOWN&&option.product_id===selectedDropdown.toString();}));}return filteredOption&&filteredOption.image&&filteredOption.image.length>0?createImage(0,filteredOption.product_id,filteredOption.image,filteredOption.selection_text):null;},_this.hasContent=function(){var service=_this.props.service;return!!(service.description||service.enable_text_input||service.options.length>0);},_this.hasImages=function(){var service=_this.props.service;if(service.options.length===0){return false;}return service.options.filter(function(option){return!!option.image;}).length>0;},_this.getImageIndex=function(product_id){var images=_this.getImages();var value=0;images.forEach(function(image,index){if(image.product_id.toString()===product_id.toString()){value=index;}});return value;},_this.getImages=function(){var service=_this.props.service;if(service.options.length===0){return null;}return service.options.filter(function(option){return!!(option.image&&option.image.length>0);}).map(function(option,index){return createImage(index,option.product_id,option.image,option.selection_text);});},_this.renderSelectedDropdown=function(){var _this$props12=_this.props,service=_this$props12.service,withTax=_this$props12.withTax;var selectedDropdown=_this.state.selectedDropdown;if(!selectedDropdown){return null;}var filteredOption=__WEBPACK_IMPORTED_MODULE_1_lodash_head___default()(service.options.filter(function(option){return option.type===__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].DROPDOWN&&option.product_id===selectedDropdown.toString();}));if(!filteredOption){return null;}var price=filteredOption.price.getPrice(withTax);if(price<=0){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__dropdown-info'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'additionalService.optionPriceSentence',defaultMessage:'The price for this option is {price}',values:{price:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Price__["a" /* default */],{price:price}))}}));},_this.renderDropdownImage=function(){var image=_this.getDropdownOptionImage();if(!image){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__dropdown-image',onClick:function onClick(){return _this.toggleLightbox(image.product_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:image.path,alt:image.alt,loading:'lazy'}));},_this.renderServiceOptions=function(){var _this$props13=_this.props,service=_this$props13.service,radioField=_this$props13.radioField,checkboxField=_this$props13.checkboxField,dropdownField=_this$props13.dropdownField,uiStore=_this$props13.uiStore;if(service.options.length===0){return null;}var radio=radioField?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__radio-option'},!uiStore.isSmallest&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style',null,_this.getCSS(service.options,'.ProductAdditionalService__radio-option-field')),_this.radio('radioOptions_'+service.id,{options:service.options.filter(function(option){return option.type===__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].RADIO;}).map(function(option){return{value:String(option.product_id),label:_this.getOptionLabel(option)};})})):null;var checkbox=checkboxField?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__checkbox-option'},!uiStore.isSmallest&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style',null,_this.getCSS(service.options,'.ProductAdditionalService__checkbox-option-field')),_this.checkbox('checkboxOptions_'+service.id,{options:service.options.filter(function(option){return option.type===__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].CHECKBOX;}).map(function(option){return{value:String(option.product_id),label:_this.getOptionLabel(option)};})})):null;var dropdown=dropdownField?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__dropdown'},!uiStore.isSmallest&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style',null,_this.getCSS(service.options,'.ProductAdditionalService__dropdown-option-field')),_this.dropdown('dropdownOptions_'+service.id,{options:service.options.filter(function(option){return option.type===__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].DROPDOWN;}).map(function(option){return{value:String(option.product_id),label:_this.getSelectOptionLabel(option)};})})):null;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,radio,checkbox,dropdown,_this.renderSelectedDropdown(),_this.renderDropdownImage());},_this.getCSS=function(services,className){// Need to somehow calculate height dynamically to divide fields into two columns.
var height=DEFAULT_SERVICE_OPTIONS_CONTAINER_HEIGHT;if(services.length>DEFAULT_SERVICE_OPTIONS_COUNT_BREAK){var addedHeight=services.length-DEFAULT_SERVICE_OPTIONS_COUNT_BREAK;height=DEFAULT_SERVICE_OPTIONS_CONTAINER_HEIGHT+addedHeight*DEFAULT_SERVICE_OPTIONS_ADD_HEIGHT;}return className+'\n     {\n      flex-flow: column wrap !important;\n      align-content: start;\n      height: '+height+'px\n    }';},_this.showToggle=function(){var service=_this.props.service;var onlyDropdown=!!!service.options.filter(function(option){return option.type!==__WEBPACK_IMPORTED_MODULE_16__types_ServiceOptionType__["b" /* default */].DROPDOWN;}).length;return!(service.is_required&&service.price.with_tax===0&&onlyDropdown);},_this.renderError=function(){var inputStatus=_this.state.inputStatus;var message=null;switch(inputStatus){case InputStatus.TEXT_REQUIRED:message=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'validation.additionalService.TEXT_REQUIRED',defaultMessage:'Additional service requires text input.'}));break;case InputStatus.TEXT_TOO_LONG:message=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'validation.additionalService.TEXT_TOO_LONG',defaultMessage:'Too many characters.'}));break;case InputStatus.NONE:default:break;}return message;},_this.renderLightbox=function(){var service=_this.props.service;var images=_this.getImages();if(!service.product_id||!images||images.length===0||!_this.state.lightboxIsOpen){return null;}var lightboxImages=images.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_22__models_ProductImage__["a" /* default */].create({id:index,product_id:service.product_id,sizes:{full:image.path},description:''});});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__common_ImageLightbox__["a" /* default */],{images:lightboxImages,mainImageIndex:_this.state.activeImage,onClick:_this.toggleLightbox});},_this.postalCodeValidationState=function(){var _this$props14=_this.props,product=_this$props14.product,service=_this$props14.service,postalCodeField=_this$props14.postalCodeField;var postalCodeIsRequired=service.requires_area_validation;return postalCodeIsRequired&&product.getValidatedService({productId:product.id,postalCode:postalCodeField.value,serviceId:service.id});},_this.renderPostalCodeRequiredText=function(){var validPostalCode=_this.postalCodeValidationState();return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()('ProductAdditionalService__information-text',{'ProductAdditionalService__information-text--invalid':validPostalCode===false})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__common_Icon__["a" /* default */],{name:validPostalCode===false?'exclamation-triangle':'info-circle'}),validPostalCode===false?labels.postalCodeIsInvalid:labels.postalCodeRequired);},_temp),_possibleConstructorReturn(_this,_ret);}// This components logic should perhaps be remade to use eg.
// reactstrap components.
_createClass(ProductAdditionalService,[{key:'render',value:function render(){var _props=this.props,service=_props.service,isSelected=_props.isSelected;var postalCodeIsRequired=service.requires_area_validation;if(!service){return null;}var validPostalCode=this.postalCodeValidationState();return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService'},this.renderHeaderHtml(),this.showToggle()?this.renderServiceToggler():this.renderServiceSelectionText(),this.hasContent()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["m" /* Collapse */],{isOpen:isSelected},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'ProductAdditionalService__content'},this.renderDescription(),this.renderTextInput(),this.renderServiceOptions(),this.renderError(),this.renderLightbox())),postalCodeIsRequired&&!validPostalCode&&this.renderPostalCodeRequiredText());}}]);return ProductAdditionalService;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;ProductAdditionalService.propTypes={currencyStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_CurrencyStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_UIStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__models_Product__["a" /* default */]).isRequired,service:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__models_AdditionalService__["a" /* default */]).isRequired,formName:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,handleSelectedServices:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,isSelected:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,text:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,withTax:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,checkboxField:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__models_FormField__["b" /* default */]),dropdownField:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__models_FormField__["b" /* default */]),radioField:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__models_FormField__["b" /* default */]),textField:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__models_FormField__["b" /* default */]),postalCodeField:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__models_FormField__["b" /* default */]),selectedOptions:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])(function(stores,props){return{currencyStore:stores.currencyStore,uiStore:stores.uiStore,withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(ProductAdditionalService));

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node}));

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_AdditionalService__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_ProductAdditionalServicesModal__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__product_ProductPageContent__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AddToCartPostalCodeValidation__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_Product__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddToCartServices=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AddToCartServices,_Component);function AddToCartServices(props){_classCallCheck(this,AddToCartServices);var _this=_possibleConstructorReturn(this,(AddToCartServices.__proto__||Object.getPrototypeOf(AddToCartServices)).call(this,props));_this.renderAdditionalServicesTabButton=function(){var configStore=_this.props.configStore;var ifAdditionalServicesModalEnabled=configStore.productPage.enableAdditionalServicesModal;if(!ifAdditionalServicesModalEnabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'AddToCart__additional-services-tab-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_ButtonLink__["a" /* default */],{className:'AddToCart__additional-services-tab-button-text',onClick:_this.scrollToTab},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:'additionalService.availableServices',defaultMessage:'Check available services here'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'AddToCart__additional-services-tab-button-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Icon__["a" /* default */],{name:'caret-down'})));};_this.scrollToTab=function(){var scrollToServices=_this.props.scrollToServices;scrollToServices&&scrollToServices(__WEBPACK_IMPORTED_MODULE_11__product_ProductPageContent__["a" /* ADDITIONAL_SERVICES_ID */]);};_this.renderServices=function(){var configStore=_this.props.configStore;var ifAdditionalServicesModalEnabled=configStore.productPage.enableAdditionalServicesModal;return ifAdditionalServicesModalEnabled?_this.renderServiceModal():_this.getServices();};_this.renderServiceModal=function(){var _this$props=_this.props,uiStore=_this$props.uiStore,onAddToCart=_this$props.onAddToCart,disabled=_this$props.disabled;var isOpen=uiStore.additionalServicesModal.isOpen;if(!isOpen){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__product_ProductAdditionalServicesModal__["a" /* default */],{onAddToCart:onAddToCart,disabled:disabled},_this.renderPostalCodeValidationInput(),_this.getServices());};_this.getServices=function(){var _this$props2=_this.props,services=_this$props2.services,renderService=_this$props2.renderService;return services.map(renderService);};_this.scrollToTab=_this.scrollToTab.bind(_this);return _this;}_createClass(AddToCartServices,[{key:'renderPostalCodeValidationInput',value:function renderPostalCodeValidationInput(){var _props=this.props,product=_props.product,ifValidForm=_props.ifValidForm,onSubmit=_props.onSubmit,onChange=_props.onChange,postalCodeField=_props.postalCodeField;if(!postalCodeField){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__AddToCartPostalCodeValidation__["a" /* default */],{product:product,postalCodeField:postalCodeField,ifValidForm:ifValidForm,handleSubmit:onSubmit,handleChange:onChange});}},{key:'render',value:function render(){var configStore=this.props.configStore;var ifAdditionalServicesModalEnabled=configStore.productPage.enableAdditionalServicesModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddToCart__additional-services-wrapper'},this.renderAdditionalServicesTabButton(),!ifAdditionalServicesModalEnabled&&this.renderPostalCodeValidationInput(),this.renderServices());}}]);return AddToCartServices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AddToCartServices.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_UIStore__["a" /* default */]).isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onAddToCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__models_Product__["a" /* default */]).isRequired,renderService:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,services:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__models_AdditionalService__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__models_AdditionalService__["a" /* default */]))]).isRequired,ifValidForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,scrollToServices:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,postalCodeField:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__models_FormField__["b" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','uiStore')(AddToCartServices));

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_dom__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'additionalService.selectService',defaultMessage:'Select service'}),continue:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].continueTitle),cancel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].cancelTitle)};var ProductAdditionalServicesModal=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductAdditionalServicesModal,_Component);function ProductAdditionalServicesModal(){_classCallCheck(this,ProductAdditionalServicesModal);return _possibleConstructorReturn(this,(ProductAdditionalServicesModal.__proto__||Object.getPrototypeOf(ProductAdditionalServicesModal)).apply(this,arguments));}_createClass(ProductAdditionalServicesModal,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_9__util_dom__["b" /* blockScroll */])();}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_9__util_dom__["a" /* allowScroll */])();}},{key:'render',value:function render(){var _props=this.props,children=_props.children,uiStore=_props.uiStore,disabled=_props.disabled,onAddToCart=_props.onAddToCart;var isOpen=uiStore.additionalServicesModal.isOpen;var toggle=uiStore.additionalServicesModal.toggle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["C" /* Modal */],{isOpen:isOpen,toggle:toggle,className:'ProductAdditionalServicesModal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["F" /* ModalHeader */],{toggle:toggle,className:'ProductAdditionalServicesModal__title'},labels.header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["D" /* ModalBody */],{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductAdditionalServicesModal__additional-services')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["E" /* ModalFooter */],{className:'ProductAdditionalServicesModal__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],{className:'ProductAdditionalServicesModal__buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:'ProductAdditionalServicesModal__cancel-button',onClick:toggle},labels.cancel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{color:'primary',onClick:onAddToCart,disabled:disabled,className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductAdditionalServicesModal__continue-button',{'ProductAdditionalServicesModal__continue-button--not-allowed':disabled})},labels.continue)))));}}]);return ProductAdditionalServicesModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductAdditionalServicesModal.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_UIStore__["a" /* default */]).isRequired,onAddToCart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('uiStore')(ProductAdditionalServicesModal));

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddToCartPostalCodeValidation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_CategoryStore__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels=Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* defineMessages */])({postalCode:{'id':'addToCartPostalCodeValidation.checkPostalCodeInfo','defaultMessage':'Search the availabilities of the services with your postal code'},postalCodePlaceholder:{'id':'addToCartPostalCodeValidation.postalCodePlaceholder','defaultMessage':'Enter your postal code'}});var AddToCartPostalCodeValidation=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AddToCartPostalCodeValidation,_Component);function AddToCartPostalCodeValidation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddToCartPostalCodeValidation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddToCartPostalCodeValidation.__proto__||Object.getPrototypeOf(AddToCartPostalCodeValidation)).call.apply(_ref,[this].concat(args))),_this),_this.getPostalCodeValidationState=function(){var _this$props=_this.props,product=_this$props.product,postalCodeField=_this$props.postalCodeField;if(!postalCodeField||!postalCodeField.value){return{loading:false,ifValidatedService:false};}var serviceIsLoading=product.validatedServicesState.get(product.id+'--'+postalCodeField.value)===__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].LOADING;var ifValidatedService=product.ifValidatedServicesExists({productId:product.id,postalCode:postalCodeField.value});var validServices=product.ifValidServices({productId:product.id,postalCode:postalCodeField.value});return{serviceIsLoading:serviceIsLoading,ifValidatedService:ifValidatedService,validServices:validServices};},_this.getValidatedServices=function(event){var _this$props2=_this.props,product=_this$props2.product,postalCodeField=_this$props2.postalCodeField,handleChange=_this$props2.handleChange;var postalCode=event.target.value;postalCodeField.setValue(postalCode);var validatedServices=product.getValidatedServices({productId:product.id,postalCode:postalCode});if(validatedServices&&validatedServices.length>0){validatedServices.forEach(function(service){var isRequired=service.is_required;var postalCodeIsRequired=service.requires_area_validation;var selectedByDefault=service.selected_by_default;var ifValidatedService=postalCodeIsRequired&&product.getValidatedService({productId:product.id,postalCode:postalCodeField.value,serviceId:service.id});if(postalCodeIsRequired&&(isRequired||selectedByDefault)){var serviceObject=_this.createService(service.id,service.product_id,ifValidatedService,'',{},service.text_max_length,service.text_required);handleChange(serviceObject);}else{if(postalCodeIsRequired){var _serviceObject=_this.createService(service.id,service.product_id,false,'',{},service.text_max_length,service.text_required);handleChange(_serviceObject);}}});}else{product.additionalServices.forEach(function(service){var postalCodeIsRequired=service.requires_area_validation;if(postalCodeIsRequired){var serviceObject=_this.createService(service.id,service.product_id,service.valid_postal_code,'',{},service.text_max_length,service.text_required);handleChange(serviceObject);}});}},_this.createService=function(id,productId,isSelected,text,options,textMaxLength,textRequired){return{id:id,productId:productId,isSelected:isSelected,text:text,options:options,textMaxLength:textMaxLength,textRequired:textRequired};},_this.renderValidateButton=function(){var _this$props3=_this.props,ifValidForm=_this$props3.ifValidForm,postalCodeField=_this$props3.postalCodeField;var buttonStates={initial:'primary',valid:'success',invalid:'danger'};var buttonState='initial';var _this$getPostalCodeVa=_this.getPostalCodeValidationState(),serviceIsLoading=_this$getPostalCodeVa.serviceIsLoading,ifValidatedService=_this$getPostalCodeVa.ifValidatedService,validServices=_this$getPostalCodeVa.validServices;var buttonDisabled=serviceIsLoading||ifValidForm===false||ifValidatedService||!postalCodeField.value;if(validServices===false){buttonState='invalid';}if(validServices){buttonState='valid';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddToCartPostalCodeValidation__additional-services-postal-code-form-validate-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:buttonStates[buttonState],disabled:buttonDisabled},_this.getCheckButtonContent()));},_this.getCheckButtonContent=function(){var _this$getPostalCodeVa2=_this.getPostalCodeValidationState(),serviceIsLoading=_this$getPostalCodeVa2.serviceIsLoading,validServices=_this$getPostalCodeVa2.validServices;if(serviceIsLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Icon__["a" /* default */],{name:'circle-o-notch',spin:serviceIsLoading});}if(validServices===false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Icon__["a" /* default */],{name:'times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].notFoundTitle));}if(validServices){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Icon__["a" /* default */],{name:'check'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].checkedTitle));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Icon__["a" /* default */],{name:'search'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].checkTitle));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddToCartPostalCodeValidation,[{key:'render',value:function render(){var _props=this.props,product=_props.product,intl=_props.intl,postalCodeField=_props.postalCodeField,handleSubmit=_props.handleSubmit;if(!product.ifServiceRequiresPostalCodeValidation()){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{className:'AddToCartPostalCodeValidation',noValidate:true,onSubmit:handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* FormGroup */],{className:'AddToCartPostalCodeValidation__additional-services-postal-code-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddToCartPostalCodeValidation__additional-services-postal-code-form-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* Label */],{'for':'AddToCartForm__postalCode'},intl.formatMessage(labels.postalCode))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddToCartPostalCodeValidation__additional-services-postal-code-form-input-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddToCartPostalCodeValidation__additional-services-postal-code-form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_Field__["a" /* default */],{handleChange:this.getValidatedServices,component:__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Input */],field:postalCodeField,type:'text',name:'postalCode',id:'AddToCartForm__postalCode',placeholder:intl.formatMessage(labels.postalCodePlaceholder)})),this.renderValidateButton())));}}]);return AddToCartPostalCodeValidation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AddToCartPostalCodeValidation.propTypes={categoryStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_CategoryStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_Product__["a" /* default */]).isRequired,postalCodeField:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["b" /* default */]).isRequired,handleSubmit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,ifValidForm:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('categoryStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(AddToCartPostalCodeValidation)));

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_ProductSeason__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Countdown__ = __webpack_require__(521);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSeasonButton=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductSeasonButton,_Component);function ProductSeasonButton(){_classCallCheck(this,ProductSeasonButton);return _possibleConstructorReturn(this,(ProductSeasonButton.__proto__||Object.getPrototypeOf(ProductSeasonButton)).apply(this,arguments));}_createClass(ProductSeasonButton,[{key:'render',value:function render(){var season=this.props.season;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{className:'ProductSeasonButton',color:'primary',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Icon__["a" /* default */],{name:'shopping-cart'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.salesBeginAt',defaultMessage:'Sales begin at {date}',values:{date:season.startDate<__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].utc().plus({days:1})?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Countdown__["a" /* default */],{expiresOn:season.startDate,onExpiry:function onExpiry(){return window.location.reload();}}):__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(season.start_date).toLocaleString(__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].DATETIME_SHORT)}}));}}]);return ProductSeasonButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductSeasonButton.propTypes={season:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_ProductSeason__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (ProductSeasonButton);

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductWatcherWidget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductWatcherForm__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductWatcherWidget=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductWatcherWidget,_Component);function ProductWatcherWidget(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductWatcherWidget);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductWatcherWidget.__proto__||Object.getPrototypeOf(ProductWatcherWidget)).call.apply(_ref,[this].concat(args))),_this),_this.state={dropdownOpen:false},_this.toggle=function(){_this.setState({dropdownOpen:!_this.state.dropdownOpen});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductWatcherWidget,[{key:'render',value:function render(){var _props=this.props,activeProductId=_props.activeProductId,productName=_props.productName,accountStore=_props.accountStore,configStore=_props.configStore;if(!configStore.product.enableProductWatcher){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductWatcherWidget'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["f" /* ButtonDropdown */],{className:'ProductWatcherWidget__dropdown-wrapper',isOpen:this.state.dropdownOpen,toggle:this.toggle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* DropdownToggle */],{className:'ProductWatcherWidget__button',color:'secondary',caret:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'envelope'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.watcherButton',defaultMessage:'Inform me when product is in stock'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* DropdownMenu */],{className:'ProductWatcherWidget__dropdown',flip:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.watcherHeading',defaultMessage:'I want to receive a notification when this product is available'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,productName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.watcherInfo',defaultMessage:'Please enter your email address and we will send you a notification when the product is in stock again. After this your email will be removed from our list.'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductWatcherForm__["a" /* default */],{activeProductId:activeProductId,initialEmail:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(accountStore,'account.personal_info.email')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductWatcherWidget__hanging-buttons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{onClick:this.toggle,color:'primary'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'times'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].closeTitle)))))));}}]);return ProductWatcherWidget;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductWatcherWidget.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('accountStore','configStore')(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(ProductWatcherWidget)));

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductWatcherForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__form_Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_ApiWrapper__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductWatcherForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductWatcherForm,_Component);function ProductWatcherForm(props){_classCallCheck(this,ProductWatcherForm);var _this=_possibleConstructorReturn(this,(ProductWatcherForm.__proto__||Object.getPrototypeOf(ProductWatcherForm)).call(this,props));_this.form=null;_this.state={status:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].NONE};_this.handleSubmit=function(e){e.preventDefault();_this.form.validate();if(_this.form.valid){var _this$props=_this.props,activeProductId=_this$props.activeProductId,apiWrapper=_this$props.apiWrapper;_this.setState({status:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING});apiWrapper.apiAxios().post('product-watchers',Object.assign({id:activeProductId},_this.form.getFieldValues())).then(function(){_this.setState({status:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED});}).catch(function(){_this.setState({status:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR});});}};_this.form=Object(__WEBPACK_IMPORTED_MODULE_7__models_Form__["a" /* createForm */])({email:Object(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].emailTitle)),Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["d" /* isEmail */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].emailTitle))])});_this.form.fields.get('email').setValue(_this.props.initialEmail);return _this;}_createClass(ProductWatcherForm,[{key:'render',value:function render(){var status=this.state.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductWatcherForm'},status!==__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,status===__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__loader_UnexpectedError__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{className:'ProductWatcherForm__form',noValidate:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["w" /* InputGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__form_Field__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Input */],field:this.form.fields.get('email'),type:'text',name:'email',placeholder:this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].yourEmailSentence)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["x" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',onClick:this.handleSubmit,disabled:this.form.valid===false||status===__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'envelope'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].sendTitle)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_FieldError__["a" /* default */],{field:this.form.fields.get('email')}))),status===__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].newsletterSuccessSentence)));}}]);return ProductWatcherForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductWatcherForm.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,initialEmail:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,apiWrapper:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14__services_ApiWrapper__["a" /* default */]).isRequired};ProductWatcherForm.defaultProps={initialEmail:''};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('apiWrapper')(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(ProductWatcherForm)));

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SimpleAddToCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_QuantityFieldGroup__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CartIcon__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_formValidators__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleAddToCart=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SimpleAddToCart,_Component);function SimpleAddToCart(props){_classCallCheck(this,SimpleAddToCart);var _this=_possibleConstructorReturn(this,(SimpleAddToCart.__proto__||Object.getPrototypeOf(SimpleAddToCart)).call(this,props));_this.form=null;_this.buttonElement=null;_this.state={buttonMounted:false};_this.handleAddToCartClick=function(){var onAddToCartClick=_this.props.onAddToCartClick;_this.form.validate();if(_this.form.valid&&onAddToCartClick){_this.props.onAddToCartClick(_this.getQuantity());}};_this.getQuantity=function(){return Number(_this.form.fields.get('quantity').value);};_this.setButtonElement=function(ref){_this.buttonElement=ref;_this.setState({buttonMounted:true});};_this.form=Object(__WEBPACK_IMPORTED_MODULE_4__models_Form__["a" /* createForm */])({quantity:Object(__WEBPACK_IMPORTED_MODULE_5__models_FormField__["a" /* createFormField */])({value:String(props.quantityStep)},[Object(__WEBPACK_IMPORTED_MODULE_12__util_formValidators__["j" /* quantityValid */])(props.maxQuantity,props.quantityStep),Object(__WEBPACK_IMPORTED_MODULE_12__util_formValidators__["i" /* productCountValid */])(props.quantityStep)])});_this.form.validate();return _this;}_createClass(SimpleAddToCart,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.onUpdateProductQuantity){this.props.onUpdateProductQuantity(this.getQuantity());}}},{key:'render',value:function render(){var _props=this.props,tooltipMessage=_props.tooltipMessage,maxQuantity=_props.maxQuantity,unit=_props.unit,loading=_props.loading,notAllowed=_props.notAllowed,uiStore=_props.uiStore,quantityStep=_props.quantityStep,quantity=_props.quantity,minOrderQuantity=_props.minOrderQuantity,ifWebStore=_props.ifWebStore;var quantityField=this.form.fields.get('quantity');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimpleAddToCart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('form-inline',{SimpleAddToCart__wrap:!uiStore.isLargest})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_QuantityFieldGroup__["a" /* default */],{className:'SimpleAddToCart__quantity-group',disabled:false,field:quantityField,maxQuantity:maxQuantity,unit:unit,quantityStep:quantityStep,onUpdateProductQuantity:this.props.onUpdateProductQuantity}),ifWebStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimpleAddToCart__button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CartIcon__["a" /* default */],{onClick:this.handleAddToCartClick,notAllowed:notAllowed,loading:loading,tooltipMessage:tooltipMessage,disabled:!this.form.valid||quantity<minOrderQuantity}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_FieldError__["a" /* default */],{field:this.form.fields.get('quantity')}));}}]);return SimpleAddToCart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SimpleAddToCart.propTypes={onAddToCartClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,maxQuantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,quantityStep:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_UIStore__["a" /* default */]).isRequired,onUpdateProductQuantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,notAllowed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,unit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tooltipMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,quantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,minOrderQuantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,ifWebStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};SimpleAddToCart.defaultProps={ifWebStore:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','uiStore')(SimpleAddToCart));

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductRecurringOrder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_RecurringOrderStore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_RecurringOrderCycleType__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RecurringInfoLink__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__recurring_RecurringCycleDropdown__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__recurring_RecurringDaysDropdown__ = __webpack_require__(524);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* defineMessages */])({placeholderOrder:{'id':'recurringOrder.subscriptionPlaceholder','defaultMessage':'Choose your subscription'}});function createNewRecurringOrder(cycle,days){return{cycle:cycle,days:days};}var INITIAL_MIN_RECURRING_DAYS='7';var ProductRecurringOrder=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductRecurringOrder,_Component);function ProductRecurringOrder(props){_classCallCheck(this,ProductRecurringOrder);var _this=_possibleConstructorReturn(this,(ProductRecurringOrder.__proto__||Object.getPrototypeOf(ProductRecurringOrder)).call(this,props));_this.maybeLoadRecurringOrders=function(){var _this$props=_this.props,accountStore=_this$props.accountStore,product=_this$props.product;if(accountStore.loggedIn&&product.recurringOrdersState===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].NONE){product.loadRecurringOrders().catch(function(e){console.error(e);});}};_this.toggleContent=function(){_this.setState({isOpen:!_this.state.isOpen});};_this.handleAddToCart=function(){var onAddToCartClick=_this.props.onAddToCartClick;var _this$state=_this.state,selectedCycle=_this$state.selectedCycle,selectedDays=_this$state.selectedDays;onAddToCartClick(createNewRecurringOrder(selectedCycle,selectedDays));};_this.handleAddToOrder=function(){var onAddToOrderClick=_this.props.onAddToOrderClick;var _this$state2=_this.state,selectedCycle=_this$state2.selectedCycle,selectedDays=_this$state2.selectedDays,selectedOrder=_this$state2.selectedOrder;var payload={cycleType:selectedCycle};if(selectedDays&&selectedCycle===__WEBPACK_IMPORTED_MODULE_13__types_RecurringOrderCycleType__["b" /* default */].CUSTOM){payload.customCycle=selectedDays;}onAddToOrderClick(selectedOrder,payload);};_this.handleCycleChange=function(event){var renderDays=_this.state.renderDays;var value=event.target.value;var newRenderDays=renderDays;if(value===__WEBPACK_IMPORTED_MODULE_13__types_RecurringOrderCycleType__["b" /* default */].CUSTOM){newRenderDays=true;}if(value!==__WEBPACK_IMPORTED_MODULE_13__types_RecurringOrderCycleType__["b" /* default */].CUSTOM&&renderDays===true){newRenderDays=false;}_this.setState({selectedCycle:value,renderDays:newRenderDays});};_this.handleDaysChange=function(event){var value=event.target.value;_this.setState({selectedDays:value});};_this.handleOrderChange=function(event){_this.setState({selectedOrder:event.target.value});};_this.renderBadge=function(){var _this$props2=_this.props,product=_this$props2.product,withTax=_this$props2.withTax;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Badge */],{color:'danger',className:'ProductRecurringOrder__button-badge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Price__["a" /* default */],{price:product.recurring_order_price.getPrice(withTax)}));};_this.renderLoggedIn=function(){var accountStore=_this.props.accountStore;if(!accountStore.loggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.onlyForLoggedIn',defaultMessage:'Subscriptions are available for registered users.'});}return null;};_this.renderContentDescription=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRecurringOrder__content-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RecurringInfoLink__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].readAboutRecurring)));};_this.renderOrdersDropdown=function(){var _this$props3=_this.props,product=_this$props3.product,intl=_this$props3.intl;var options=product.recurringOrders.orders.map(function(order){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:order.id,value:order.id},order.title||order.autogenerated_title);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["z" /* Label */],{'for':'ProductRecurringOrder__orders-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.selectOrder',defaultMessage:'Choose on which subscription product should be added'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].modifyOrderNotify))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Input */],{type:'select',name:'select',className:'ProductRecurringOrder__orders-select',id:'ProductRecurringOrder__orders-select',onChange:_this.handleOrderChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},intl.formatMessage(messages.placeholderOrder)),options));};_this.isValidRecurring=function(){var product=_this.props.product;var _this$state3=_this.state,selectedCycle=_this$state3.selectedCycle,selectedDays=_this$state3.selectedDays;if(!selectedCycle){return false;}return!(selectedCycle===__WEBPACK_IMPORTED_MODULE_13__types_RecurringOrderCycleType__["b" /* default */].CUSTOM&&(!selectedDays||Number(selectedDays)<product.recurringOrders.min_custom_cycle));};_this.renderExistingOrders=function(){var _this$props4=_this.props,product=_this$props4.product,loading=_this$props4.loading;if(product.recurringOrders.orders.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRecurringOrder__existing-orders'},_this.renderOrdersDropdown(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',onClick:_this.handleAddToOrder,className:'ProductRecurringOrder__button-to-order',disabled:loading||!_this.isValidRecurring()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.addToOrder',defaultMessage:'Add subscription to order'})));};_this.renderRecurringOrder=function(){var _this$props5=_this.props,product=_this$props5.product,loading=_this$props5.loading;var _this$state4=_this.state,renderDays=_this$state4.renderDays,selectedDays=_this$state4.selectedDays;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRecurringOrder__recurring-order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__recurring_RecurringCycleDropdown__["a" /* default */],{cycles:product.recurringOrders.cycles,onChange:_this.handleCycleChange}),renderDays&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__recurring_RecurringDaysDropdown__["a" /* default */],{onChange:_this.handleDaysChange,selectedValue:selectedDays,minDays:product.recurringOrders.min_custom_cycle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',onClick:_this.handleAddToCart,className:'ProductRecurringOrder__button-to-cart',disabled:loading||!_this.isValidRecurring()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.addToCart',defaultMessage:'Add new subscription to cart'})),_this.renderExistingOrders());};_this.renderContent=function(){var product=_this.props.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductRecurringOrder__content'},_this.renderLoggedIn(),_this.renderContentDescription(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__loader_ContentForState__["a" /* default */],{state:product.recurringOrdersState,forLoaded:function forLoaded(){return _this.renderRecurringOrder();}}));};_this.state={isOpen:false,renderDays:false,selectedCycle:null,selectedOrder:null,selectedDays:INITIAL_MIN_RECURRING_DAYS};return _this;}_createClass(ProductRecurringOrder,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.state.isOpen!==prevState.isOpen&&this.state.isOpen){this.maybeLoadRecurringOrders();}}},{key:'render',value:function render(){var isOpen=this.state.isOpen;var _props=this.props,disabled=_props.disabled,product=_props.product,accountStore=_props.accountStore;var hasLowerPrice=!!product&&!!product.recurring_order_price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('ProductRecurringOrder',{'ProductRecurringOrder--solo':accountStore.loggedIn&&product.hasOnlyRecurringOrder()})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'ProductRecurringOrder__button',onClick:this.toggleContent,disabled:disabled,color:'primary'},hasLowerPrice&&this.renderBadge(),hasLowerPrice?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.subscriptionButton',defaultMessage:'Save money by subscribing'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.subscribe',defaultMessage:'Subscribe'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["m" /* Collapse */],{isOpen:isOpen&&!disabled},this.renderContent()));}}]);return ProductRecurringOrder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductRecurringOrder.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AccountStore__["a" /* default */]).isRequired,recurringOrderStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_RecurringOrderStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]).isRequired,onAddToCartClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onAddToOrderClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,withTax:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('accountStore','recurringOrderStore','configStore')(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(ProductRecurringOrder)));

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecurringOrder__ = __webpack_require__(161);
var RecurringOrdersPaginator=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrdersPaginator',{current_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,data:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_1__RecurringOrder__["a" /* default */])),[]),last_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,total:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});/* harmony default export */ __webpack_exports__["a"] = (RecurringOrdersPaginator);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecurringInfoLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_page_InfoPageModal__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ButtonLink__ = __webpack_require__(70);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecurringInfoLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RecurringInfoLink,_Component);function RecurringInfoLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecurringInfoLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecurringInfoLink.__proto__||Object.getPrototypeOf(RecurringInfoLink)).call.apply(_ref,[this].concat(args))),_this),_this.state={show:false},_this.toggle=function(){_this.setState({show:!_this.state.show});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecurringInfoLink,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,children=_props.children;var hasInfoPage=configStore.recurringOrder.infoPage.length>=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,children,hasInfoPage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_ButtonLink__["a" /* default */],{className:'RecurringInfoLink',onClick:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.readLinkSentence',defaultMessage:'Read more about subscriptions.'}))),this.state.show&&hasInfoPage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__info_page_InfoPageModal__["a" /* default */],{isOpen:this.state.show,toggle:this.toggle,pageId:configStore.recurringOrder.infoPage}));}}]);return RecurringInfoLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RecurringInfoLink.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(RecurringInfoLink));

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductCardPropertiesStatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_size__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_ProductPropertyType__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProductLink__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_ShowMoreContent__ = __webpack_require__(1065);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductCardPropertiesStatic=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductCardPropertiesStatic,_Component);function ProductCardPropertiesStatic(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductCardPropertiesStatic);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductCardPropertiesStatic.__proto__||Object.getPrototypeOf(ProductCardPropertiesStatic)).call.apply(_ref,[this].concat(args))),_this),_this.container=null,_this.getFirstCollectionProperty=function(product){return product.collection.shouldSwapCollectionOrder()?product.collection.row:product.collection.column;},_this.getSecondCollectionProperty=function(product){return product.collection.shouldSwapCollectionOrder()?product.collection.column:product.collection.row;},_this.onCollectionPropertyElementClick=function(propertyId,elementId,isFirstCollectionClicked){var _this$props=_this.props,history=_this$props.history,product=_this$props.product,routeService=_this$props.routeService;var elementIds=_this.getElementIds(elementId,isFirstCollectionClicked);history.push(routeService.getProductPath(product,Object(__WEBPACK_IMPORTED_MODULE_11__util_queryString__["a" /* addParametersToPath */])(product.path,elementIds)));},_this.getElementIds=function(elementId,isFirstCollection){var product=_this.props.product;var elementIds={columnId:null,rowId:null};// Check if collections are swapped
var firstProperty='columnId';var secondProperty='rowId';if(product.collection.shouldSwapCollectionOrder()){firstProperty='rowId';secondProperty='columnId';}if(isFirstCollection){elementIds[firstProperty]=elementId;}else{elementIds[secondProperty]=elementId;}// If a property is empty, we know that the element ID is 0.
if(product.collection.column.isEmpty()){elementIds.columnId=0;}if(product.collection.row.isEmpty()){elementIds.rowId=0;}return elementIds;},_this.getCollectionComponent=function(collectionProperty,clickHandler,isFirstProperty){var _this$props2=_this.props,product=_this$props2.product,filterNotInStockElements=_this$props2.filterNotInStockElements;var count=__WEBPACK_IMPORTED_MODULE_0_lodash_size___default()(collectionProperty.elements);if(count<=1){return null;}var elements=filterNotInStockElements&&!product.canBeOrderedOutOfStock?collectionProperty.elements.filter(function(element){return _this.isElementAvailable(element.id,isFirstProperty);}):collectionProperty.elements;if(elements.length===0){return null;}var componentElements=elements.map(function(element){var content=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null,element.name);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:element.id,className:'ProductCardPropertiesStatic__item',onClick:function onClick(){return clickHandler(collectionProperty.id,element.id);}},content);});return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_ShowMoreContent__["a" /* default */],{className:'ProductCardPropertiesStatic__items'},componentElements);},_this.getCollectionComponentForColor=function(collectionProperty){var _this$props3=_this.props,product=_this$props3.product,onClick=_this$props3.onClick;var count=__WEBPACK_IMPORTED_MODULE_0_lodash_size___default()(collectionProperty.elements);if(count<=1){return null;}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProductLink__["a" /* default */],{product:product,onClick:onClick},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductCardPropertiesStatic__color'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductCardPropertiesStatic__color-gradient'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'product.propertyColourVariants',defaultMessage:'{ count } different colours available',values:{count:__WEBPACK_IMPORTED_MODULE_0_lodash_size___default()(collectionProperty.elements)}})));},_this.isElementAvailable=function(elementId,isFirstProperty){var product=_this.props.product;var _this$getElementIds=_this.getElementIds(elementId,isFirstProperty),columnId=_this$getElementIds.columnId,rowId=_this$getElementIds.rowId;var status=void 0;if(columnId!==null&&rowId!==null){status=product.collection.getItemStatus(columnId,rowId);}else if(columnId!==null){status=product.collection.getColumnStatus(columnId);}else{status=product.collection.getRowStatus(rowId);}return status.available;},_this.componentForCollectionProperty=function(collectionProperty,isFirstProperty){if(collectionProperty.isEmpty()){return null;}var clickHandler=function clickHandler(propertyId,elementId){return _this.onCollectionPropertyElementClick(propertyId,elementId,isFirstProperty);};var propertyComponent=void 0;if(collectionProperty.type===__WEBPACK_IMPORTED_MODULE_12__types_ProductPropertyType__["b" /* default */].COLOR){propertyComponent=_this.getCollectionComponentForColor(collectionProperty);}else{propertyComponent=_this.getCollectionComponent(collectionProperty,clickHandler,isFirstProperty);}return propertyComponent;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductCardPropertiesStatic,[{key:'render',value:function render(){var product=this.props.product;if(product.class!==__WEBPACK_IMPORTED_MODULE_9__types_ProductClass__["b" /* default */].COLLECTION){return null;}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductCardPropertiesStatic'},this.componentForCollectionProperty(this.getFirstCollectionProperty(product),true),this.componentForCollectionProperty(this.getSecondCollectionProperty(product),false));}}]);return ProductCardPropertiesStatic;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]))||_class;ProductCardPropertiesStatic.propTypes={filterNotInStockElements:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,product:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.history.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10__services_RouteService__["a" /* default */]).isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])(function(_ref2){var configStore=_ref2.configStore,routeService=_ref2.routeService;return{filterNotInStockElements:configStore.inStockProductsOnly,routeService:routeService};})(ProductCardPropertiesStatic)));

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShowMoreContent=function(_Component){_inherits(ShowMoreContent,_Component);function ShowMoreContent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShowMoreContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShowMoreContent.__proto__||Object.getPrototypeOf(ShowMoreContent)).call.apply(_ref,[this].concat(args))),_this),_this.state={isLess:true,referenceHeight:0,parentElement:null,childElement:null},_this.toggle=function(){_this.setState({isLess:!_this.state.isLess});},_this.setParentElement=function(ref){if(!_this.state.parentElement&&ref){_this.setState({parentElement:ref,referenceHeight:ref.clientHeight});}},_this.setChildElement=function(ref){if(_this.state.childElement!==ref){_this.setState({childElement:ref});}},_this.hasOverflow=function(){if(_this.state.childElement&&_this.state.parentElement){return _this.state.childElement.clientHeight>_this.state.referenceHeight;}return false;},_this.renderShowMore=function(){if(!_this.hasOverflow()){return null;}var showMoreText=_this.state.isLess?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__["a" /* default */].showMoreText):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__["a" /* default */].showLessText);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ShowMoreContent__indicator',onClick:_this.toggle},showMoreText);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShowMoreContent,[{key:'render',value:function render(){var _props=this.props,children=_props.children,props=_objectWithoutProperties(_props,['children']);var _state=this.state,isLess=_state.isLess,childElement=_state.childElement;var hasOverflow=this.hasOverflow();var style=childElement&&hasOverflow&&!isLess?{height:childElement.clientHeight+'px'}:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('ShowMoreContent',{'ShowMoreContent--overflow-hidden':hasOverflow&&isLess,'ShowMoreContent--overflow-visible':hasOverflow&&!isLess}),style:style,ref:this.setParentElement},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:'ShowMoreContent__children',ref:this.setChildElement},props),children)),this.renderShowMore());}}]);return ShowMoreContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ShowMoreContent);

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductEnquiryModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductEnquiryForm__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_ProductEnquiryType__ = __webpack_require__(195);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductEnquiryModal=function(_Component){_inherits(ProductEnquiryModal,_Component);function ProductEnquiryModal(){_classCallCheck(this,ProductEnquiryModal);return _possibleConstructorReturn(this,(ProductEnquiryModal.__proto__||Object.getPrototypeOf(ProductEnquiryModal)).apply(this,arguments));}_createClass(ProductEnquiryModal,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,enquiry=_props.enquiry;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["C" /* Modal */],{className:'ProductEnquiryModal',size:'md',toggle:this.props.toggle,isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["F" /* ModalHeader */],{className:'ProductEnquiryModal__header',toggle:this.props.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],enquiry.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ProductEnquiryForm__["a" /* default */],{id:this.props.id,type:enquiry.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductEnquiryModal__customer-service-open-hours'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'customerService.isOpen',defaultMessage:'Customer service is open Mon - Fri {timespan}',values:{timespan:configStore.customerService.open}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductEnquiryModal__customer-service-phone-number'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'phone'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].infoCallPhone,{values:{phone:configStore.customerService.phone}}))),configStore.customerService.callCost&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductEnquiryModal__customer-service-call-cost',dangerouslySetInnerHTML:{__html:configStore.customerService.callCost}})));}}]);return ProductEnquiryModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductEnquiryModal.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,toggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isOpen:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__["a" /* default */]).isRequired,enquiry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(Object.values(__WEBPACK_IMPORTED_MODULE_10__types_ProductEnquiryType__["a" /* default */]))}).isRequired};ProductEnquiryModal.defaultProps={enquiry:{title:__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].productEnquiryTitle,type:__WEBPACK_IMPORTED_MODULE_10__types_ProductEnquiryType__["a" /* default */].MESSAGE}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('configStore')(ProductEnquiryModal));

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductEnquiryForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_ErrorHandler__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_FormValidator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_ProductEnquiryType__ = __webpack_require__(195);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={customerName:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].fullNameTitle),email:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailTitle),message:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].messageTitle)};var FORM_MESSAGE_ROWS=7;var ProductEnquiryForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(ProductEnquiryForm,_Component);function ProductEnquiryForm(props){_classCallCheck(this,ProductEnquiryForm);var _this=_possibleConstructorReturn(this,(ProductEnquiryForm.__proto__||Object.getPrototypeOf(ProductEnquiryForm)).call(this,props));_initialiseProps.call(_this);var formValidator=_this.props.formValidator;_this.form=Object(__WEBPACK_IMPORTED_MODULE_6__models_Form__["a" /* createForm */])({customerName:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({},formValidator.fullName(labels.customerName)),email:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({},formValidator.email(labels.email)),message:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["g" /* notBlank */])(labels.message)])});return _this;}_createClass(ProductEnquiryForm,[{key:'render',value:function render(){var requestState=this.state.requestState;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductEnquiryForm'},requestState===__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].LOADED?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'product.enquirySuccess',defaultMessage:'Your message was sent to our customer service successfully. We aim to handle the message as soon as possible.'})):this.renderForm());}}]);return ProductEnquiryForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='ProductEnquiryForm';this.state={error:null,requestState:__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].NONE,// This is used to know, if we've made a new request so we can re-animate errors
requestId:0};this.handleSubmit=function(e){e.preventDefault();var _props=_this2.props,id=_props.id,type=_props.type,apiWrapper=_props.apiWrapper;_this2.form.validate();if(_this2.form.valid){_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].LOADING});apiWrapper.apiAxios().post('product-enquiries/'+id+'/by-email',Object.assign({},_this2.form.getFieldValues(),{enquiryType:type})).then(function(){_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].LOADED});}).catch(function(error){console.error(error);_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].ERROR,error:error,requestId:_this2.state.requestId+1});});}};this.field=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__["a" /* default */],Object.assign({required:field.hasValidators(),field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.getErrorMessages=function(){var error=_this2.state.error;return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(error,'response.data.messages');};this.renderIcon=function(){var requestState=_this2.state.requestState;var loading=requestState===__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].LOADING;if(!loading){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_Icon__["a" /* default */],{name:'circle-o-notch',spin:loading}),' ');};this.renderForm=function(){var _state=_this2.state,requestState=_state.requestState,requestId=_state.requestId,error=_state.error;var loading=requestState===__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].LOADING;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{className:'ProductEnquiryForm__form',noValidate:true,onSubmit:_this2.handleSubmit},error&&__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(error,'response.status')!==422&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__loader_ErrorHandler__["a" /* default */],{error:Object(__WEBPACK_IMPORTED_MODULE_13__util_error__["a" /* createErrorModel */])(error)}),_this2.getErrorMessages()&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'danger',key:requestId},_this2.getErrorMessages().map(function(message,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:index},message);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'12'},_this2.field('customerName',{autoComplete:'name'}),_this2.field('email',{type:'email',autoComplete:'email'}),_this2.field('message',{type:'textarea',rows:FORM_MESSAGE_ROWS}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary',block:true,disabled:_this2.form.valid===false||loading},_this2.renderIcon(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].sendTitle)))));};},_temp))||_class;ProductEnquiryForm.propTypes={id:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(Object.values(__WEBPACK_IMPORTED_MODULE_17__types_ProductEnquiryType__["a" /* default */])),apiWrapper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14__services_ApiWrapper__["a" /* default */]).isRequired,formValidator:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_16__services_FormValidator__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('apiWrapper','formValidator')(ProductEnquiryForm));

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductLabelTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var ProductLabelType={IMAGE:'image',LABEL:'label',IMAGE_AND_LABEL:'image_and_label'};/* harmony default export */ __webpack_exports__["a"] = (ProductLabelType);var ProductLabelTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('ProductLabelType',Object.values(ProductLabelType));

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShoppingCenterProductMerchantInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ProductMerchantInfo__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShoppingCenterProductMerchantInfo=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ShoppingCenterProductMerchantInfo,_Component);function ShoppingCenterProductMerchantInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShoppingCenterProductMerchantInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShoppingCenterProductMerchantInfo.__proto__||Object.getPrototypeOf(ShoppingCenterProductMerchantInfo)).call.apply(_ref,[this].concat(args))),_this),_this.renderMerchantInfo=function(){var merchantInfo=_this.props.merchantInfo;var siteName=merchantInfo.site_name;return siteName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{xs:12,className:'ShoppingCenterProductMerchantInfo__merchant-info--merchant-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shoppingCenterProductMerchantInfo.sellerTitle',defaultMessage:'Seller'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,': ',siteName));},_this.renderMerchantPrice=function(){var merchantInfo=_this.props.merchantInfo;var price=merchantInfo.shipping_starting_price&&merchantInfo.shipping_starting_price.with_tax;var ifBuyingAllowed=merchantInfo&&merchantInfo.buyingAllowed;if(!ifBuyingAllowed){return null;}return price!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{xs:12,className:'ShoppingCenterProductMerchantInfo__merchant-info--shipping-costs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].deliveryStartingAbridged),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__product_Price__["a" /* default */],{price:price}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShoppingCenterProductMerchantInfo,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,merchantInfo=_props.merchantInfo;var ifWebStore=configStore.siteConfig.isWebStore;if(ifWebStore||!merchantInfo){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ShoppingCenterProductMerchantInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ShoppingCenterProductMerchantInfo__merchant-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],null,this.renderMerchantInfo(),this.renderMerchantPrice())));}}]);return ShoppingCenterProductMerchantInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ShoppingCenterProductMerchantInfo.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,merchantInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ProductMerchantInfo__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),withTax:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};ShoppingCenterProductMerchantInfo.defaultProps={withTax:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ShoppingCenterProductMerchantInfo));

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecommendedProductsSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductSlider__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_list_SimpleProductList__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecommendedProductsSlider=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RecommendedProductsSlider,_Component);function RecommendedProductsSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecommendedProductsSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecommendedProductsSlider.__proto__||Object.getPrototypeOf(RecommendedProductsSlider)).call.apply(_ref,[this].concat(args))),_this),_this.listName='Recommended Products',_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecommendedProductsSlider,[{key:'render',value:function render(){var _props=this.props,ids=_props.ids,configStore=_props.configStore;var searchParams={ids:ids,includeChildProducts:'1',inStock:configStore.inStockProductsOnly?'1':'0'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecommendedProductsSlider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].recommendedProductsTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__product_list_SimpleProductList__["a" /* default */],{name:this.listName,searchParams:searchParams,listComponent:__WEBPACK_IMPORTED_MODULE_4__ProductSlider__["a" /* default */],allSections:true}));}}]);return RecommendedProductsSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RecommendedProductsSlider.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,ids:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(RecommendedProductsSlider));

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CategoryHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Breadcrumbs__ = __webpack_require__(504);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryHeader=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CategoryHeader,_Component);function CategoryHeader(){_classCallCheck(this,CategoryHeader);return _possibleConstructorReturn(this,(CategoryHeader.__proto__||Object.getPrototypeOf(CategoryHeader)).apply(this,arguments));}_createClass(CategoryHeader,[{key:'render',value:function render(){var breadcrumb=this.props.breadcrumb;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategoryHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Breadcrumbs__["a" /* default */],{path:breadcrumb}));}}]);return CategoryHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CategoryHeader.propTypes={breadcrumb:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({text:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,url:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('productStore')(CategoryHeader));

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductShippingDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__ = __webpack_require__(497);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_IMAGE_WIDTH=70;var IMAGE_ASPECT_RATIO=20/11;var ProductShippingDetails=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductShippingDetails,_Component);function ProductShippingDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductShippingDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductShippingDetails.__proto__||Object.getPrototypeOf(ProductShippingDetails)).call.apply(_ref,[this].concat(args))),_this),_this.loadShippingDetails=function(){var _this$props=_this.props,activeProductId=_this$props.activeProductId,product=_this$props.product;if(product.shippingStates.get(activeProductId)!==__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["b" /* default */].LOADED){product.loadShippingDetails(activeProductId).catch(function(e){console.error(e);});}},_this.getUniqueKeys=function(options){var keys=[];options.sort(function(a,b){return b.campaign_info.priority-a.campaign_info.priority||a.campaign_info.id-b.campaign_info.id;}).map(function(option){return keys.push(option.campaign_info.id);});var uniqueKeys=new Set(keys);return[].concat(_toConsumableArray(uniqueKeys));},_this.renderAdditionalServices=function(detail){var services=detail.additional_services.map(function(service){return service.name;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__detail-additional-services'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.availableServicesSentence',defaultMessage:'Optional services'}),' '+services.join(', '));},_this.renderDetail=function(detail,index){var withTax=_this.props.withTax;var imgWidth=MAX_IMAGE_WIDTH;var imgHeight=Math.round(MAX_IMAGE_WIDTH/IMAGE_ASPECT_RATIO);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:detail.name+'--'+index,className:'ProductShippingDetails__detail'},detail.image&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__detail-image'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:detail.image,alt:detail.name,width:imgWidth,height:imgHeight,loading:'lazy'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__detail-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__detail-name'},detail.name),detail.has_starting_price&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__detail-has-starting-price'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].hasStartingPriceSentence)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__detail-price'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:detail.price.getPrice(withTax)})),detail.low_order_fee_limit&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__detail-low-order-fee'},withTax?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].lowOrderFeeNoTaxSentence,{values:{amount:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:detail.includes_low_order_fee.getPrice(withTax)}),limit:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:detail.low_order_fee_limit.getPrice(withTax)})}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].lowOrderFeeSentence,{values:{amount:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:detail.includes_low_order_fee.getPrice(true)}),amountWithoutTax:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:detail.includes_low_order_fee.getPrice(false)}),limit:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:detail.low_order_fee_limit.getPrice(true)}),limitwithoutTax:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:detail.low_order_fee_limit.getPrice(false)})}}))),detail.additional_services.length>0&&_this.renderAdditionalServices(detail)));},_this.renderGroupDetails=function(options){var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var index=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var product=_this.props.product;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:product.id+index,className:'ProductShippingDetails__group'},title&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__group-title'},title),info&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails__group-info'},info),options.map(function(detail,index){return _this.renderDetail(detail,index);}));},_this.getTitleContentByType=function(campaign){var withTax=_this.props.withTax;var endAt=campaign.end_at===null?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,' - ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].couponValidUntilSentence,{values:{offerExpiry:__WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(campaign.end_at).toLocaleString()}})));switch(campaign.type){case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].FREE_SHIPPING:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.freeShippingSentence',defaultMessage:'Free shipping{endAt}',values:{endAt:endAt}});case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].TOTAL_SUM_TABLE:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.totalSumSentence',defaultMessage:'Free shipping for orders over {amount}{endAt}',values:{amount:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:campaign.free_shipping_price_limit.getPrice(withTax)}),endAt:endAt}});case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].TOTAL_WEIGHT_TABLE:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.totalWeightSentence',defaultMessage:'Free shipping for orders total weight over {amount}{endAt}',values:{amount:campaign.free_shipping_weight_limit,endAt:endAt}});case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].PRODUCT_QUANTITY_TABLE:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.totalQuantitySentence',defaultMessage:'Free shipping for orders with at least {amount} products{endAt}',values:{amount:campaign.free_shipping_quantity_limit,endAt:endAt}});case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].TOTAL_VOLUME_TABLE:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.totalVolumeSentence',defaultMessage:'Free shipping for orders volume over {amount} m3{endAt}',values:{amount:campaign.free_shipping_volume_limit,endAt:endAt}});case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].FIXED_PRICE:default:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.fixedPriceSentence',defaultMessage:'Lowered price'});}},_this.campaignHasValidLimit=function(campaign){switch(campaign.type){case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].TOTAL_SUM_TABLE:return!!campaign.free_shipping_price_limit;case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].TOTAL_WEIGHT_TABLE:return!!campaign.free_shipping_weight_limit;case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].PRODUCT_QUANTITY_TABLE:return!!campaign.free_shipping_quantity_limit;case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].TOTAL_VOLUME_TABLE:return!!campaign.free_shipping_volume_limit;case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].FREE_SHIPPING:case __WEBPACK_IMPORTED_MODULE_12__types_ShippingCampaignType__["b" /* default */].FIXED_PRICE:default:return true;}},_this.renderShippingDetails=function(){var _this$props2=_this.props,activeProductId=_this$props2.activeProductId,product=_this$props2.product;var details=product.shippingDetails.get(activeProductId);if(details.options.length===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.noMethodsAvailable',defaultMessage:'This product doesn\'t have any available shipping methods for the chosen delivery country'}));}var basicOptions=details.options.filter(function(option){return option.campaign_info===null||!_this.campaignHasValidLimit(option.campaign_info);});var basicTitle=null;var sortedCampaignKeys=_this.getUniqueKeys(details.options.filter(function(option){return option.campaign_info!==null&&_this.campaignHasValidLimit(option.campaign_info);}));var campaignOptions=sortedCampaignKeys.map(function(campaignKey,index){var filtered=details.options.filter(function(option){return option.campaign_info&&_this.campaignHasValidLimit(option.campaign_info)&&option.campaign_info.id===campaignKey;});var campaign=filtered[0].campaign_info;var title=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.campaignHeader',defaultMessage:'{name}',values:{name:!!campaign.name?campaign.name:_this.getTitleContentByType(campaign)}});return _this.renderGroupDetails(filtered,title,null,index);});if(campaignOptions.length>0){basicTitle=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'shipping.otherMethodsSentence',defaultMessage:'Normal prices'});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:activeProductId,className:'ProductShippingDetailsContent'},campaignOptions,basicOptions.length>0&&_this.renderGroupDetails(basicOptions,basicTitle));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductShippingDetails,[{key:'componentDidMount',value:function componentDidMount(){this.loadShippingDetails();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props=this.props,product=_props.product,activeProductId=_props.activeProductId;if(prevProps.activeProductId!==activeProductId||product.shippingStates.get(activeProductId)===undefined){this.loadShippingDetails();}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,activeProductId=_props2.activeProductId,product=_props2.product;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductShippingDetails'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__["a" /* default */],{state:product.shippingStates.get(activeProductId),forLoaded:function forLoaded(){return _this2.renderShippingDetails();}}));}}]);return ProductShippingDetails;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductShippingDetails.propTypes={activeProductId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,product:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,withTax:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])(function(stores,props){return{configStore:stores.configStore,withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(ProductShippingDetails));

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductReviews */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__review_Review__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__review_ReviewForm__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__account_AccountModalLink__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__review_ReviewAggregation__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__anchor_ScrollableAnchor__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_CouponStore__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__coupon_CouponText__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__coupon_CouponExpiry__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_dom__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_NUMBER_OF_REVIEWS_SHOWN=6;var ProductReviews=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductReviews,_Component);function ProductReviews(props){_classCallCheck(this,ProductReviews);var _this=_possibleConstructorReturn(this,(ProductReviews.__proto__||Object.getPrototypeOf(ProductReviews)).call(this,props));_this.state={showAll:false};_this.maybeLoadReviews=function(){var product=_this.props.product;if(product.reviewsState===__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].NONE){product.loadReviews().catch(function(e){console.error(e);});}};_this.renderMoreReviewsButton=function(){var toggle=function toggle(){_this.setState({showAll:!_this.state.showAll});};if(_this.props.product.reviews.length<=DEFAULT_NUMBER_OF_REVIEWS_SHOWN){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'secondary',onClick:toggle,className:'ProductReviews__more-reviews-button'},_this.state.showAll?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'review.showDefaultTitle',defaultMessage:'Show default number of reviews'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'review.showAllTitle',defaultMessage:'Show all reviews ({count})',values:{count:_this.props.product.reviews.length}}));};_this.renderCouponPromoBox=function(){var couponStore=_this.props.couponStore;var coupon=couponStore.reviewCoupon;if(!coupon){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductReviews__coupon-promo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductReviews__coupon-promo-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'review.reviewCouponTitle',defaultMessage:'Review this product to receive a discount coupon!'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductReviews__coupon-promo-title-highlight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__coupon_CouponText__["a" /* default */],{coupon:coupon}))),coupon.minimum_order&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].couponMinimumOrderSentence,{values:{minimumOrder:coupon.minimum_order+' €'}})),' ',coupon.end_date&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__coupon_CouponExpiry__["a" /* default */],{date:coupon.end_date}));};_this.maybeLoadReviews();return _this;}_createClass(ProductReviews,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.maybeLoadReviews();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,product=_props.product,configStore=_props.configStore,accountStore=_props.accountStore,couponStore=_props.couponStore;var reviews=product.reviews;var shownReviews=this.state.showAll?reviews:reviews.slice(0,DEFAULT_NUMBER_OF_REVIEWS_SHOWN);var coupon=couponStore.reviewCoupon;var formOrLogin=configStore.reviews.allowedForVisitors||accountStore.loggedIn?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__review_ReviewForm__["a" /* default */],{couponsEnabled:!!coupon,product:product}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__account_AccountModalLink__["a" /* default */],{tab:__WEBPACK_IMPORTED_MODULE_10__types_AccountModalTab__["b" /* default */].LOGIN},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{tag:'span',color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].writeNewReview)));var isWebStore=configStore.siteConfig.isWebStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductReviews'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__loader_ContentForState__["a" /* default */],{state:product.reviewsState,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,reviews.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__review_ReviewAggregation__["a" /* default */],{reviews:reviews})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'6'},_this2.renderCouponPromoBox(),isWebStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_20__util_dom__["i" /* scrollToElementById */])('newReviewForm');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].writeNewReview)),_this2.renderMoreReviewsButton())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,shownReviews.map(function(review){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'12',lg:'6',key:review.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__review_Review__["a" /* default */],{review:review}));})),_this2.renderMoreReviewsButton(),isWebStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductReviews__new-review'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__anchor_ScrollableAnchor__["a" /* default */],{id:'newReviewForm',offset:50}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'review.haveYouBoughtSentence',defaultMessage:'Have you purchased this product before?'})),_this2.renderCouponPromoBox(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,formOrLogin)));}}));}}]);return ProductReviews;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductReviews.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__models_Product__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_AccountStore__["a" /* default */]).isRequired,couponStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_CouponStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','accountStore','couponStore')(ProductReviews));

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Review */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Stars__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Review__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_WysiwygContent__ = __webpack_require__(72);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Review=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Review,_Component);function Review(){_classCallCheck(this,Review);return _possibleConstructorReturn(this,(Review.__proto__||Object.getPrototypeOf(Review)).apply(this,arguments));}_createClass(Review,[{key:'render',value:function render(){var _props=this.props,review=_props.review,configStore=_props.configStore;var reviewAddDate=__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(review.date_added);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Review'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Review__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Review__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,review.customers_name,',',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,reviewAddDate.toLocaleString()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Review__text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_WysiwygContent__["a" /* default */],{html:review.description.reviews_text})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'Review__ratings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].reviewProductRatingTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stars__["a" /* default */],{amount:review.reviews_rating}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].reviewServiceRatingTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stars__["a" /* default */],{amount:review.service_rating}))))),review.description.admin_reply&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Review__admin-reply'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Review__admin-reply-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'review.staffReplySentence',defaultMessage:'{name} responds:',values:{name:configStore.store.name}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Review__admin-reply-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_WysiwygContent__["a" /* default */],{html:review.description.admin_reply})))));}}]);return Review;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;Review.propTypes={review:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Review__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('configStore')(Review));

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReviewForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_ErrorHandler__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__InteractiveStars__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__form_FieldError__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={nickname:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].nicknameTitle),email:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].emailTitle),review:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].reviewTitle),reviewRating:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].reviewProductRatingTitle),serviceRating:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].reviewServiceRatingTitle)};var ReviewStatus={PENDING:'PENDING',APPROVED:'APPROVED'};var ReviewForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(ReviewForm,_Component);function ReviewForm(props){_classCallCheck(this,ReviewForm);var _this=_possibleConstructorReturn(this,(ReviewForm.__proto__||Object.getPrototypeOf(ReviewForm)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,configStore=_this$props.configStore,accountStore=_this$props.accountStore,couponsEnabled=_this$props.couponsEnabled;_this.form=Object(__WEBPACK_IMPORTED_MODULE_5__models_Form__["a" /* createForm */])({nickname:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(labels.nickname)],function(){return!accountStore.loggedIn||configStore.reviews.anonymous;}),email:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["e" /* minLength */])(labels.email,configStore.formValidation.email.minLength),Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["d" /* isEmail */])(labels.email)],function(){return!accountStore.loggedIn&&(configStore.reviews.approvalRequired||couponsEnabled);}),text:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({},[]),reviewRating:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(labels.reviewRating),Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["h" /* numberBetween */])(labels.reviewRating,1,5)]),serviceRating:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(labels.serviceRating),Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["h" /* numberBetween */])(labels.serviceRating,1,5)])});return _this;}_createClass(ReviewForm,[{key:'render',value:function render(){var successStatus=this.state.successStatus;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.formName},successStatus?this.getSuccessMessage():this.getForm());}}]);return ReviewForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='ReviewForm';this.state={successStatus:null,error:null,requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADED};this.handleSubmit=function(e){var _props=_this2.props,product=_props.product,accountStore=_props.accountStore;e.preventDefault();_this2.form.validate();if(_this2.form.valid){_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADING});product.submitReview(_this2.form.getFieldValues()).then(function(response){var successStatus=void 0;if(response.status===202){successStatus=ReviewStatus.PENDING;}else{accountStore.refreshCoupons();successStatus=ReviewStatus.APPROVED;}_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADED,successStatus:successStatus});}).catch(function(error){_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].ERROR,error:error});});}};this.field=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.textarea=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName],type:'textarea'},props));};this.starsControl=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__InteractiveStars__["a" /* default */],Object.assign({amount:field.value||0,onClick:field.setValue},props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__form_FieldError__["a" /* default */],{field:field}));};this.getForm=function(){var _state=_this2.state,requestState=_state.requestState,error=_state.error;var _props2=_this2.props,configStore=_props2.configStore,couponsEnabled=_props2.couponsEnabled;var leftColumnVisible=_this2.form.fields.get('nickname').active||_this2.form.fields.get('email').active;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{noValidate:true,onSubmit:_this2.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'ReviewForm__rating-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].reviewProductRatingTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.starsControl('reviewRating',{}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].reviewServiceRatingTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.starsControl('serviceRating',{}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,leftColumnVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'12',md:'4',xl:'3'},_this2.field('nickname',{autoComplete:'nickname'},function(){return configStore.reviews.anonymous;}),_this2.form.fields.get('nickname').active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* FormGroup */],{className:'ReviewForm__field-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'review.nicknameFieldHint',defaultMessage:'A nickname of your choice that we\'ll show next to your review.'})),_this2.field('email',{type:'email',autoComplete:'email'}),_this2.form.fields.get('email').active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* FormGroup */],{className:'ReviewForm__field-hint'},couponsEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'review.emailAddressForCouponHint',defaultMessage:'The coupon details will be sent to this address. We will remove the email address from our registry after the coupon has been sent.'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'review.emailAddressForApprovalHint',defaultMessage:'We will notify you via this address after your review has been approved. We will remove the email address from our registry right after.'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'12',md:leftColumnVisible?8:12,xl:{size:leftColumnVisible?7:12,offset:leftColumnVisible?1:0}},_this2.textarea('text',{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'review.typeReviewHereSentence',defaultMessage:'Type your review here'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* FormGroup */],{className:'ReviewForm__field-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'review.reviewHint',defaultMessage:'By submitting your review, you agree to give us the permission to publish it on this website as well as on other sites and media. {storeName} reserves the right to not publish the review. By submitting, you agree to these terms.',values:{storeName:configStore.store.name}})),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_ErrorHandler__["a" /* default */],{error:Object(__WEBPACK_IMPORTED_MODULE_16__util_error__["a" /* createErrorModel */])(error)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary',disabled:_this2.form.valid===false||requestState===__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADING},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'review.sendTitle',defaultMessage:'Submit review'})))));};this.getSuccessMessage=function(){var successStatus=_this2.state.successStatus;var message=void 0;if(successStatus===ReviewStatus.PENDING){message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'review.successPending',defaultMessage:'We have received your review. We check all reviews and you will get a message when yours is published.'});}else{message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'review.success',defaultMessage:'Your product review was added successfully!'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'success'},message);};},_temp))||_class;ReviewForm.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_LanguageStore__["a" /* default */]).isRequired,couponsEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','configStore','languageStore')(ReviewForm));

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Icon___ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Stars__ = __webpack_require__(246);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InteractiveStars=function(_Component){_inherits(InteractiveStars,_Component);function InteractiveStars(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InteractiveStars);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InteractiveStars.__proto__||Object.getPrototypeOf(InteractiveStars)).call.apply(_ref,[this].concat(args))),_this),_this.state={hoveredStar:0},_this.setHoverStarCount=function(count){_this.setState({hoveredStar:count});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InteractiveStars,[{key:'render',value:function render(){var _this2=this;var _props=this.props,amount=_props.amount,_onClick=_props.onClick,rest=_objectWithoutProperties(_props,['amount','onClick']);var stars=[];var _loop=function _loop(i){stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],Object.assign({className:'InteractiveStars__star-container',color:'link',key:i,onMouseOver:function onMouseOver(){return _this2.setHoverStarCount(i);},onClick:function onClick(){return _onClick(i);}},rest),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sr-only'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'review.interactiveStarsLabel',defaultMessage:'{count, plural, one {# star} other {# stars}} out of 5',values:{count:i}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Icon___["a" /* default */],{name:'star',className:_this2.state.hoveredStar>=i?'InteractiveStars__star--hover':''})));};for(var i=1;i<=5;i++){_loop(i);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'InteractiveStars',onMouseLeave:function onMouseLeave(){return _this2.setHoverStarCount(0);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stars__["a" /* default */],{amount:amount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'InteractiveStars__control'},stars));}}]);return InteractiveStars;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InteractiveStars.propTypes={amount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InteractiveStars);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_countBy__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_countBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_countBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Review__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Stars__ = __webpack_require__(246);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReviewAggregation=function(_Component){_inherits(ReviewAggregation,_Component);function ReviewAggregation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ReviewAggregation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReviewAggregation.__proto__||Object.getPrototypeOf(ReviewAggregation)).call.apply(_ref,[this].concat(args))),_this),_this.cumulativeAverage=function(key){return function(previous,nextReview,index){return(nextReview[key]+index*previous)/(index+1);};},_this.getAggregateRatings=function(){var reviews=_this.props.reviews;var ratingBuckets=__WEBPACK_IMPORTED_MODULE_0_lodash_countBy___default()(reviews,function(review){return Math.round((review.service_rating+review.reviews_rating)/2);});var aggregates=[];var totalCount=reviews.length;for(var i=5;i>=1;--i){aggregates.push({stars:i,count:ratingBuckets[i]||0,percentage:(ratingBuckets[i]||0)/totalCount*100});}return aggregates;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReviewAggregation,[{key:'render',value:function render(){var reviews=this.props.reviews;var aggregateRatings=this.getAggregateRatings();var productAverageRating=reviews.reduce(this.cumulativeAverage('reviews_rating'),0);var serviceAverageRating=reviews.reduce(this.cumulativeAverage('service_rating'),0);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'ReviewAggregation'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'6',className:'ReviewAggregation__rating-buckets'},aggregateRatings.map(function(_ref2){var stars=_ref2.stars,count=_ref2.count,percentage=_ref2.percentage;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ReviewAggregation__rating-bucket',key:stars},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ReviewAggregation__rating-bucket-top-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Stars__["a" /* default */],{amount:stars}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'ReviewAggregation__rating-bucket-count'},'(',count,')')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ReviewAggregation__rating-bucket-percentage-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ReviewAggregation__rating-bucket-percentage-bar-fill',style:{width:percentage+'%'}})));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ReviewAggregation__average-rating'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].reviewProductRatingTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,productAverageRating.toFixed(1),' / 5.0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Stars__["a" /* default */],{amount:productAverageRating}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ReviewAggregation__average-rating'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].reviewServiceRatingTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,serviceAverageRating.toFixed(1),' / 5.0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Stars__["a" /* default */],{amount:serviceAverageRating})))));}}]);return ReviewAggregation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ReviewAggregation.propTypes={reviews:__WEBPACK_IMPORTED_MODULE_4_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Review__["a" /* default */]))};/* harmony default export */ __webpack_exports__["a"] = (ReviewAggregation);

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(178),
    createAggregator = __webpack_require__(220);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    ++result[key];
  } else {
    baseAssignValue(result, key, 1);
  }
});

module.exports = countBy;


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_ProductSeason__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSeasonInfo=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductSeasonInfo,_Component);function ProductSeasonInfo(){_classCallCheck(this,ProductSeasonInfo);return _possibleConstructorReturn(this,(ProductSeasonInfo.__proto__||Object.getPrototypeOf(ProductSeasonInfo)).apply(this,arguments));}_createClass(ProductSeasonInfo,[{key:'render',value:function render(){var season=this.props.season;var text='';var startDate=__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(season.start_date).toLocaleString(__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].DATETIME_SHORT);var endDate=__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(season.end_date).toLocaleString(__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].DATETIME_SHORT);if(!season.hasStarted()){text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.seasonStartsOn',defaultMessage:'Product\'s sales start online on {startDate}.',values:{startDate:startDate}});}else if(season.hasStarted()&&!season.hasEnded()){text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.seasonIs',defaultMessage:'Product sale period online is {startDate} - {endDate}.',values:{startDate:startDate,endDate:endDate}});}else{text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.seasonEndedOn',defaultMessage:'Product\'s sales ended online on {endDate}.',values:{endDate:endDate}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductSeasonInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,text),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,season.description));}}]);return ProductSeasonInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductSeasonInfo.propTypes={season:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_ProductSeason__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductSeasonInfo);

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductBundles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_Slider__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProductPrice__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_ViewBreakpoint__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__models_ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__bootstrap_CustomCol__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ProductCard__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__MissingProductLoader__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__product_ProductImpressions__ = __webpack_require__(348);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SLIDER_SETTINGS={arrows:true,infinite:false,slidesToShow:6,slidesToScroll:6,adaptiveHeight:true,dots:true,responsive:[{breakpoint:__WEBPACK_IMPORTED_MODULE_16__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].XXL,settings:{slidesToShow:4,slidesToScroll:4}},{breakpoint:__WEBPACK_IMPORTED_MODULE_16__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].MD,settings:{slidesToShow:3,slidesToScroll:3}},{breakpoint:__WEBPACK_IMPORTED_MODULE_16__types_ViewBreakpoint__["a" /* ViewBreakpointMinWidth */].SM,settings:{slidesToShow:2,slidesToScroll:2}}]};var ProductBundles=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductBundles,_Component);function ProductBundles(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductBundles);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductBundles.__proto__||Object.getPrototypeOf(ProductBundles)).call.apply(_ref,[this].concat(args))),_this),_this.listName='Product Bundle List',_this.state={selectedProductIds:[],cartLoading:false},_this.getProductIds=function(){var product=_this.props.product;return product.bundleProductInfos.slice()// Slice is used to convert Mobx array to normal array.
.map(function(_ref2){var product_id=_ref2.product_id;return product_id;});},_this.renderProductCard=function(product,priceInfo,position){var activeProductId=_this.props.activeProductId;var renderPrice=priceInfo||product.price_info;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ProductCard__["a" /* default */],{product:product,position:position,listName:_this.listName,hideDescription:true,hidePrice:true,hideProperties:true,hideQuantity:true,target:'_blank'}),renderPrice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProductPrice__["a" /* default */],{activeProductId:activeProductId,productBundle:true,product:product,priceInfo:priceInfo||product.price_info}));},_this.renderIconCheckbox=function(checked){return checked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_Icon__["a" /* default */],{name:'check-square'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_Icon__["a" /* default */],{name:'square-o'});},_this.renderBundleProductSlider=function(){var _this$props=_this.props,product=_this$props.product,productStore=_this$props.productStore;var slides=product.bundleProductInfos.filter(function(_ref3){var product_id=_ref3.product_id;return productStore.products.has(product_id);}).map(function(_ref4,index){var price=_ref4.price,product_id=_ref4.product_id;var position=index+1;var product=productStore.products.get(product_id);var priceInfo=product.price_info?__WEBPACK_IMPORTED_MODULE_17__models_ProductPriceInfo__["a" /* default */].create(Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3_mobx_state_tree__["h" /* getSnapshot */])(product.price_info),{price:Object(__WEBPACK_IMPORTED_MODULE_3_mobx_state_tree__["h" /* getSnapshot */])(price),is_discount:true})):null;var checked=_this.isProductSelected(product_id);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{className:'ProductBundles__slide',key:product.id},_this.renderProductCard(product,priceInfo,position),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('ProductBundles__slide-button',{'ProductBundles__slide-button--active':checked}),color:'primary',outline:true,block:true,onClick:function onClick(){return _this.toggleProduct(product_id);}},_this.renderIconCheckbox(checked),checked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].selectedTitle):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].selectTitle)));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_Slider__["a" /* default */],Object.assign({className:'ProductBundles__slider'},SLIDER_SETTINGS),slides);},_this.renderProductImpressions=function(){var _this$props2=_this.props,productStore=_this$props2.productStore,product=_this$props2.product;var products=product.bundleProductInfos.filter(function(_ref5){var product_id=_ref5.product_id;return productStore.products.has(product_id);}).map(function(_ref6){var product_id=_ref6.product_id;return productStore.products.get(product_id);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__product_ProductImpressions__["a" /* default */],{listName:_this.listName,products:products});},_this.isProductSelected=function(productId){return _this.state.selectedProductIds.indexOf(productId)!==-1;},_this.getSelectedBundleProductInfos=function(){var _this$props3=_this.props,productStore=_this$props3.productStore,product=_this$props3.product;var selectedProductIds=_this.state.selectedProductIds;return product.bundleProductInfos.filter(function(_ref7){var product_id=_ref7.product_id;return selectedProductIds.indexOf(product_id)!==-1&&productStore.products.has(product_id);});},_this.renderSelectedProduct=function(product,price,onClick){var accountStore=_this.props.accountStore;var withTax=accountStore.showPricesWithTax;var showTaxExcludedInfo=!withTax;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__selected-product',onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__selected-product-icon'},_this.renderIconCheckbox(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__selected-product-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__selected-product-title'},product.name,' ',price&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Price__["a" /* default */],{price:price.getPrice(withTax),showTaxExcludedInfo:showTaxExcludedInfo})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__selected-product-model'},product.model)));},_this.renderSelectedProducts=function(){var _this$props4=_this.props,productStore=_this$props4.productStore,product=_this$props4.product;var checkboxes=_this.getSelectedBundleProductInfos().map(function(_ref8){var price=_ref8.price,product_id=_ref8.product_id;var product=productStore.products.get(product_id);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__bootstrap_CustomCol__["a" /* default */],{xxl:'4',lg:'12',key:product.id},_this.renderSelectedProduct(product,price,function(){return _this.toggleProduct(product_id);}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__selected-products'},checkboxes.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__selected-product-main-product'},_this.renderSelectedProduct(product,product.price_info?product.price_info.price:null,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],null,checkboxes));},_this.renderAdditionalProductCount=function(){var selectedProductIds=_this.state.selectedProductIds;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__product-count'},selectedProductIds.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'productBundle.selectedProducts',defaultMessage:'You have selected {count, plural, one {# additional product} other {# additional products}}',values:{count:selectedProductIds.length}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'productBundle.noSelectedProducts',defaultMessage:'No additional products selected'}));},_this.renderAddToCartButton=function(){var _this$state=_this.state,selectedProductIds=_this$state.selectedProductIds,cartLoading=_this$state.cartLoading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__add-to-cart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{size:'lg',color:'primary',className:'ProductBundles__add-to-cart-button',disabled:selectedProductIds.length===0,onClick:_this.handleAddToCartClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_Icon__["a" /* default */],{name:cartLoading?'circle-o-notch':'shopping-cart',spin:cartLoading}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'productBundle.addToCartButton',defaultMessage:'Add bundle to cart'})));},_this.handleAddToCartClick=function(){var _this$props5=_this.props,accountStore=_this$props5.accountStore,productStore=_this$props5.productStore,cartStore=_this$props5.cartStore,analytics=_this$props5.analytics,product=_this$props5.product,activeProductId=_this$props5.activeProductId;var selectedProductIds=_this.state.selectedProductIds;var quantity=1;// If cartStore is already cartLoading, don't do anything
if(cartStore.state===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADING){return;}if(activeProductId){var withTax=accountStore.showPricesWithTax;_this.setState({cartLoading:true});cartStore.addToCart(activeProductId,quantity,selectedProductIds).then(function(){var bundleProductEvents=_this.getSelectedBundleProductInfos().map(function(_ref9){var price=_ref9.price,product_id=_ref9.product_id;var product=productStore.products.get(product_id);return{product:product,quantity:quantity,price:price.getPrice(withTax)};});analytics.addToCart([{product:product,quantity:quantity,activeProductId:activeProductId,price:product.getPrice(withTax,activeProductId)}].concat(_toConsumableArray(bundleProductEvents)));analytics.cartStatus({cart:cartStore.cart});_this.setState({cartLoading:false});}).catch(function(){_this.setState({cartLoading:false});});}},_this.renderBundleTotal=function(){var _this$props6=_this.props,accountStore=_this$props6.accountStore,productStore=_this$props6.productStore,currencyStore=_this$props6.currencyStore,product=_this$props6.product,activeProductId=_this$props6.activeProductId;var withTax=accountStore.showPricesWithTax;var showTaxExcludedInfo=!withTax;var prices=_this.getSelectedBundleProductInfos().filter(function(_ref10){var price=_ref10.price,product_id=_ref10.product_id;var product=productStore.products.get(product_id);return!!(price&&product&&product.price_info);}).map(function(_ref11){var price=_ref11.price,product_id=_ref11.product_id;var product=productStore.products.get(product_id);return{inBundle:price.getPrice(withTax),withoutBundle:product.price_info.getNormalPrice(withTax)};});var mainProductPrice=product.getPrice(withTax,activeProductId);var precision=currencyStore.activeCurrency.precision;var bundleTotal=Object(__WEBPACK_IMPORTED_MODULE_22__util_number__["c" /* calculateTotal */])([mainProductPrice].concat(_toConsumableArray(prices.map(function(_ref12){var inBundle=_ref12.inBundle;return inBundle;}))),precision);var withoutBundleTotal=Object(__WEBPACK_IMPORTED_MODULE_22__util_number__["c" /* calculateTotal */])([mainProductPrice].concat(_toConsumableArray(prices.map(function(_ref13){var withoutBundle=_ref13.withoutBundle;return withoutBundle;}))),precision);var totalSavings=withoutBundleTotal-bundleTotal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__total-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'productBundle.price',defaultMessage:'Bundle price'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Price__["a" /* default */],{price:bundleTotal,discount:true}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Price__["a" /* default */],{price:withoutBundleTotal,muted:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__total-savings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'productBundle.youSave',defaultMessage:'You save'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Price__["a" /* default */],{price:totalSavings,discount:true,showTaxExcludedInfo:showTaxExcludedInfo})));},_this.renderContent=function(){var selectedProductIds=_this.state.selectedProductIds;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__content'},_this.renderBundleProductSlider(),_this.renderProductImpressions(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__selected-products'},_this.renderAdditionalProductCount(),_this.renderSelectedProducts()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles__buy'},selectedProductIds.length>0&&_this.renderBundleTotal(),_this.renderAddToCartButton()))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductBundles,[{key:'toggleProduct',value:function toggleProduct(productId){var _state=this.state,selectedProductIds=_state.selectedProductIds,cartLoading=_state.cartLoading;if(cartLoading){return;}var productIdIndex=selectedProductIds.indexOf(productId);var productIdExists=productIdIndex!==-1;var newIds=selectedProductIds.slice();if(productIdExists){newIds.splice(productIdIndex,1);}else{newIds.push(productId);}this.setState({selectedProductIds:newIds});}},{key:'render',value:function render(){var _this2=this;var product=this.props.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductBundles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ProductBundles__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'productBundle.createYourOwn',defaultMessage:'Bundle "{productName}" with additional products and save',values:{productName:product.name}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__MissingProductLoader__["a" /* default */],{ids:this.getProductIds()},function(){return _this2.renderContent();}));}}]);return ProductBundles;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductBundles.propTypes={activeProductId:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,product:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_24__analytics_Analytics__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ProductStore__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AccountStore__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_CartStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_CurrencyStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','analytics','cartStore','currencyStore','productStore')(ProductBundles));

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CategoryLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Category__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CategoryLink,_Component);function CategoryLink(){_classCallCheck(this,CategoryLink);return _possibleConstructorReturn(this,(CategoryLink.__proto__||Object.getPrototypeOf(CategoryLink)).apply(this,arguments));}_createClass(CategoryLink,[{key:'render',value:function render(){var _props=this.props,routeService=_props.routeService,category=_props.category,className=_props.className,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CategoryLink',className),to:routeService.getPath(category.path)},children||category.name);}}]);return CategoryLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CategoryLink.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired,category:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Category__["a" /* default */]).isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService')(CategoryLink));

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__anchor_ScrollableAnchor__ = __webpack_require__(129);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccordionTabs=function(_Component){_inherits(AccordionTabs,_Component);function AccordionTabs(props){_classCallCheck(this,AccordionTabs);var _this=_possibleConstructorReturn(this,(AccordionTabs.__proto__||Object.getPrototypeOf(AccordionTabs)).call(this,props));_this.state={visitedTabs:[]};_this.updateElementYOffset=function(){if(_this.props.onUpdateElementYOffsetUpdate){_this.props.onUpdateElementYOffsetUpdate(_this.props.activeTabId);}};_this.state.visitedTabs=new Set([props.activeTabId]);return _this;}_createClass(AccordionTabs,[{key:'render',value:function render(){var _this2=this;var _props=this.props,tabs=_props.tabs,activeTabId=_props.activeTabId,toggle=_props.toggle;if(!tabs||!tabs.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccordionTabs'},tabs.map(function(tab){var isOpen=activeTabId===tab.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('AccordionTabs__tab',{'AccordionTabs__tab--open':isOpen}),key:tab.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccordionTabs__tab-toggle',onClick:function onClick(){return toggle(tab.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__anchor_ScrollableAnchor__["a" /* default */],{id:tab.id,offset:15,className:'AccordionTabs__tab-anchor',scrollIfInHash:false}),tab.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* default */],{className:'AccordionTabs__tab-toggle-icon',name:'angle-up'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["m" /* Collapse */],{onExited:_this2.updateElementYOffset,isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccordionTabs__tab-content'},tab.getContent({preloadOnly:!_this2.state.visitedTabs.has(tab.id)}))));}));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,prevState){return{visitedTabs:new Set([].concat(_toConsumableArray(prevState.visitedTabs),[nextProps.activeTabId]))};}}]);return AccordionTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccordionTabs.propTypes={activeTabId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,toggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onUpdateElementYOffsetUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,tabs:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,getContent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (AccordionTabs);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var PaymentModule=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PaymentModule',{logo:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (PaymentModule);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentWidget__ = __webpack_require__(530);
var PaymentWidgetQueryResult=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PaymentWidgetQueryResult',{widgets:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__PaymentWidget__["a" /* default */]),[])});/* harmony default export */ __webpack_exports__["a"] = (PaymentWidgetQueryResult);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductAdditionalTabText=function(_Component){_inherits(ProductAdditionalTabText,_Component);function ProductAdditionalTabText(){_classCallCheck(this,ProductAdditionalTabText);return _possibleConstructorReturn(this,(ProductAdditionalTabText.__proto__||Object.getPrototypeOf(ProductAdditionalTabText)).apply(this,arguments));}_createClass(ProductAdditionalTabText,[{key:'render',value:function render(){var additionalTabHtml=this.props.additionalTabHtml;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductAdditionalTabText',dangerouslySetInnerHTML:{__html:additionalTabHtml}});}}]);return ProductAdditionalTabText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductAdditionalTabText.propTypes={additionalTabHtml:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductAdditionalTabText);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductFileUploadForm__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({'product.fileUploadDeleteFile':{'id':'product.fileUploadDeleteFile','defaultMessage':'Delete file {file}'}});var ProductFileUploads=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductFileUploads,_Component);function ProductFileUploads(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductFileUploads);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductFileUploads.__proto__||Object.getPrototypeOf(ProductFileUploads)).call.apply(_ref,[this].concat(args))),_this),_this.loadUploadedFiles=function(){_this.props.productStore.loadUploadedFiles();},_this.deleteFile=function(fileName){var product=_this.props.product;product.deleteFile(fileName).then(_this.loadUploadedFiles);},_this.renderContent=function(){var _this$props=_this.props,product=_this$props.product,productStore=_this$props.productStore,intl=_this$props.intl;if(productStore.uploadedFilesState!==__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["b" /* default */].LOADED){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.fileUploadLoading',defaultMessage:'Loading file list...'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,product.uploadedFiles.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductFileUploads__subheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.fileUploadExistingFilesHeader',defaultMessage:'Currently uploaded files'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ProductFileUploads__uploaded-items'},product.uploadedFiles.map(function(file){var fileDeleteString=intl.formatMessage(messages['product.fileUploadDeleteFile'],{file:file});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ProductFileUploads__uploaded-item',key:file},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,file),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_ButtonLink__["a" /* default */],{className:'ProductFileUploads__uploaded-item-delete-button',onClick:function onClick(){return _this.deleteFile(file);},title:fileDeleteString},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sr-only'},fileDeleteString),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{name:'close'})));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductFileUploadForm__["a" /* default */],{product:product,onFileUploaded:_this.loadUploadedFiles}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductFileUploads,[{key:'componentDidMount',value:function componentDidMount(){this.loadUploadedFiles();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductFileUploads'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.fileUploadExplanationSentence',defaultMessage:'Upload your files for this product here'})),this.renderContent());}}]);return ProductFileUploads;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductFileUploads.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_Product__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ProductStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('productStore')(ProductFileUploads)));

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductFileUploadForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_FileField__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_FieldType__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loader_ErrorHandler__ = __webpack_require__(91);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadStatus={NONE:'NONE',VALIDATION_ERROR:'VALIDATION_ERROR',SUCCESS:'SUCCESS',UNEXPECTED_ERROR:'UNEXPECTED_ERROR',UPLOADING:'UPLOADING'};var ProductFileUploadForm=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductFileUploadForm,_Component);function ProductFileUploadForm(props){_classCallCheck(this,ProductFileUploadForm);var _this=_possibleConstructorReturn(this,(ProductFileUploadForm.__proto__||Object.getPrototypeOf(ProductFileUploadForm)).call(this,props));_this.form=null;_this.state={status:UploadStatus.NONE,error:null,formFiles:{}};_this.handleSubmit=function(e){var _this$props=_this.props,product=_this$props.product,onFileUploaded=_this$props.onFileUploaded;e.preventDefault();_this.form.validate();if(_this.form.valid){_this.setState(function(){return{status:UploadStatus.UPLOADING,error:null};},function(){product.uploadFile(_this.state.formFiles.file).then(function(){_this.setState(function(){return{status:UploadStatus.SUCCESS};},onFileUploaded);}).catch(function(e){var status=e.response?e.response.status:500;var errorMap={400:UploadStatus.VALIDATION_ERROR,409:UploadStatus.VALIDATION_ERROR,500:UploadStatus.UNEXPECTED_ERROR};_this.setState(function(){return{status:errorMap[status],error:e};});});});}};_this.handleFileChange=function(field,file){_this.setState(function(state){return{formFiles:Object.assign({},state.formFiles,_defineProperty({},field,file))};});};_this.getFileField=function(name,message){var field=_this.form.fields.get(name);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFileUploadForm__field ProductFileUploadForm__field--'+name},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_FileField__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],message),formName:'ProductFileUploadForm',type:'file',fieldName:name,field:field,handleChange:_this.handleFileChange,hideLabel:true,disabled:_this.state.status===UploadStatus.UPLOADING}));};_this.getError=function(){var _this$state=_this.state,status=_this$state.status,error=_this$state.error;switch(status){case UploadStatus.UNEXPECTED_ERROR:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__loader_UnexpectedError__["a" /* default */],null);case UploadStatus.VALIDATION_ERROR:var errorData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(error,'response.data.errors');if(!errorData){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__loader_ErrorHandler__["a" /* default */],{error:Object(__WEBPACK_IMPORTED_MODULE_16__util_error__["a" /* createErrorModel */])(error)});}else if(errorData.fileCount===false){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.fileUploadTooManyFileUploadsError',defaultMessage:'You have reached the maximum amount of uploaded files.'}));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__loader_UnexpectedError__["a" /* default */],null);}case UploadStatus.NONE:case UploadStatus.UPLOADING:case UploadStatus.SUCCESS:default:break;}};_this.getForm=function(){var status=_this.state.status;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{noValidate:true,onSubmit:_this.handleSubmit},_this.getFileField('file',__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].fileTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'secondary',block:true,disabled:_this.form.valid===false||status===UploadStatus.UPLOADING},status===UploadStatus.UPLOADING?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_Icon__["a" /* default */],{name:'circle-o-notch',spin:true}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'product.fileUploadWorking',defaultMessage:'Uploading...'})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].uploadFileTitle)));};var fields={file:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({type:__WEBPACK_IMPORTED_MODULE_13__types_FieldType__["b" /* default */].FILE},[Object(__WEBPACK_IMPORTED_MODULE_12__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].fileTitle))])};_this.form=Object(__WEBPACK_IMPORTED_MODULE_7__models_Form__["a" /* createForm */])(fields);return _this;}_createClass(ProductFileUploadForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductFileUploadForm'},this.getError(),this.getForm());}}]);return ProductFileUploadForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductFileUploadForm.propTypes={product:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__models_Product__["a" /* default */]).isRequired,onFileUploaded:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func};ProductFileUploadForm.defaultProps={onFileUploaded:function onFileUploaded(){}};/* harmony default export */ __webpack_exports__["a"] = (ProductFileUploadForm);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldError__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileField=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FileField,_Component);function FileField(props){_classCallCheck(this,FileField);// In the normal use cases, the form and field names don't change, and
// this only really affects the input/label binding, so not updating the id
// afterwards if props change should still be fine.
var _this=_possibleConstructorReturn(this,(FileField.__proto__||Object.getPrototypeOf(FileField)).call(this,props));_this.handleChange=function(event){_this.props.field.setValue(event.target.value);_this.props.handleChange(_this.props.fieldName,_this.fileFieldRef.current.files[0]);};_this.handleBlur=function(){if(_this.props.field.value){_this.props.field.setShouldValidate(true);}};_this.getFileNameToDisplay=function(){var value=_this.props.field.value;if(!value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'form.noFileSelected',defaultMessage:'No file selected'});}return value.substr(Math.max(value.lastIndexOf('/'),value.lastIndexOf('\\'))+1);};_this.id=__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(props.formName+'__'+props.fieldName+'--');_this.fileFieldRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(FileField,[{key:'render',value:function render(){var _props=this.props,label=_props.label,field=_props.field,hideLabel=_props.hideLabel,required=_props.required,disabled=_props.disabled;// TODO: ensure this remains suitably accessible
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],{className:'FileField'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{'for':this.id,hidden:hideLabel},label,required&&' *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'FileField__field'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('FileField__input-container btn btn-secondary',{disabled:disabled})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'form.selectFileSentence',defaultMessage:'Select file...'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'file',ref:this.fileFieldRef,onChange:this.handleChange,id:this.id,disabled:disabled})),this.getFileNameToDisplay()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FieldError__["a" /* default */],{field:field}));}}]);return FileField;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;FileField.propTypes={field:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_FormField__["b" /* default */]).isRequired,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,formName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,fieldName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,hideLabel:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,required:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,handleChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FileField);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductQuantityDiscounts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Price__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductQuantityDiscounts=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductQuantityDiscounts,_Component);function ProductQuantityDiscounts(props){_classCallCheck(this,ProductQuantityDiscounts);var _this=_possibleConstructorReturn(this,(ProductQuantityDiscounts.__proto__||Object.getPrototypeOf(ProductQuantityDiscounts)).call(this,props));_this.maybeLoadDiscounts=function(){var product=_this.props.product;if(product.quantityDiscountsState===__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["b" /* default */].NONE){product.loadQuantityDiscounts().catch(function(e){console.error(e);});}};_this.getCellValue=function(value,center){return{value:value,center:center};};_this.renderHeaderRow=function(headers){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',{className:'thead-light'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'ProductQuantityDiscounts__discount-table-header'},headers.map(function(header,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:header.center?'ProductQuantityDiscounts__discount-table-header-center':'',key:header.value+'_'+index},header.value);})));};_this.renderDiscountRow=function(row){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'ProductQuantityDiscounts__discount-table-row'},row.map(function(cell,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:cell.center?'ProductQuantityDiscounts__discount-table-cell-center':'ProductQuantityDiscounts__discount-table-cell',key:cell.value+'_'+index},cell.value);})));};_this.renderDiscountTable=function(){var _this$props=_this.props,product=_this$props.product,withTax=_this$props.withTax;var showTaxExcludedInfo=!withTax;var headerRow=[];var cellRow=[];headerRow.push(_this.getCellValue(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].quantityTitle),false));cellRow.push(_this.getCellValue(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].unitPriceTitle),showTaxExcludedInfo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].taxExcluded))),false));product.quantityDiscounts.forEach(function(discount){headerRow.push(_this.getCellValue(discount.quantity+' '+product.stock_unit,true));cellRow.push(_this.getCellValue(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Price__["a" /* default */],{price:discount.price.getPrice(withTax),discount:discount.quantity!==1}),true));});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["R" /* Table */],{size:'sm',bordered:true,className:'ProductQuantityDiscounts__discount-table'},_this.renderHeaderRow(headerRow),_this.renderDiscountRow(cellRow));};_this.maybeLoadDiscounts();return _this;}_createClass(ProductQuantityDiscounts,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.maybeLoadDiscounts();}},{key:'render',value:function render(){var product=this.props.product;if(product.quantityDiscounts.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductQuantityDiscounts'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductQuantityDiscounts__description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'discount.quantityDescription',defaultMessage:'Order more and save money!'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductQuantityDiscounts__discount'},this.renderDiscountTable()));}}]);return ProductQuantityDiscounts;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductQuantityDiscounts.propTypes={product:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,withTax:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])(function(stores,props){return{withTax:__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.withTax)?stores.accountStore.showPricesWithTax:props.withTax};})(ProductQuantityDiscounts));

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductSizeGuides */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductSizeGuideModal__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Product__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSizeGuides=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductSizeGuides,_Component);function ProductSizeGuides(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductSizeGuides);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductSizeGuides.__proto__||Object.getPrototypeOf(ProductSizeGuides)).call.apply(_ref,[this].concat(args))),_this),_this.state={modal:false},_this.toggleModal=function(){_this.setState({modal:!_this.state.modal});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductSizeGuides,[{key:'render',value:function render(){var _this2=this;var sizeGuides=this.props.product.sizeGuides;if(sizeGuides.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductSizeGuides'},sizeGuides.map(function(guide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:guide.name+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductSizeGuideModal__["a" /* default */],{isOpen:_this2.state.modal,toggle:_this2.toggleModal,guide:guide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'secondary',className:'ProductSizeGuides__modal-button',onClick:_this2.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Icon__["a" /* default */],{name:'info-circle'}),' ',guide.name));}));}}]);return ProductSizeGuides;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductSizeGuides.propTypes={product:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Product__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductSizeGuides);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductSizeGuideModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSizeGuideModal=function(_Component){_inherits(ProductSizeGuideModal,_Component);function ProductSizeGuideModal(){_classCallCheck(this,ProductSizeGuideModal);return _possibleConstructorReturn(this,(ProductSizeGuideModal.__proto__||Object.getPrototypeOf(ProductSizeGuideModal)).apply(this,arguments));}_createClass(ProductSizeGuideModal,[{key:'render',value:function render(){var guide=this.props.guide;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["C" /* Modal */],{className:'ProductSizeGuideModal',size:'lg',toggle:this.props.toggle,isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["F" /* ModalHeader */],{toggle:this.props.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductSizeGuideModal__header'},guide.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:guide.name,className:'ProductSizeGuideModal__content',dangerouslySetInnerHTML:{__html:guide.contents}})));}}]);return ProductSizeGuideModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductSizeGuideModal.propTypes={guide:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,toggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isOpen:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('configStore')(ProductSizeGuideModal));

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductOnlyInStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductOnlyInStore=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductOnlyInStore,_Component);function ProductOnlyInStore(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductOnlyInStore);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductOnlyInStore.__proto__||Object.getPrototypeOf(ProductOnlyInStore)).call.apply(_ref,[this].concat(args))),_this),_this.getInfoPageLink=function(){var configStore=_this.props.configStore;if(configStore.storeInfoPageId===0){return null;}var storeInfoPagePath=Object(__WEBPACK_IMPORTED_MODULE_6__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].InfoPage,{slug:'-',id:configStore.storeInfoPageId});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductOnlyInStore__link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:storeInfoPagePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.onlyInStoreLink',defaultMessage:'Please see contact information'})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductOnlyInStore,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductOnlyInStore'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.onlyInStore',defaultMessage:'This product cannot be purchased from the online store. Please contact sales'}),this.getInfoPageLink());}}]);return ProductOnlyInStore;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductOnlyInStore.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductOnlyInStore));

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductDateAvailable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductDateAvailable=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductDateAvailable,_Component);function ProductDateAvailable(){_classCallCheck(this,ProductDateAvailable);return _possibleConstructorReturn(this,(ProductDateAvailable.__proto__||Object.getPrototypeOf(ProductDateAvailable)).apply(this,arguments));}_createClass(ProductDateAvailable,[{key:'render',value:function render(){var product=this.props.product;if(product.free_quantity!==0||__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].utc()>=__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(product.date_available)){return null;}var dateAvailable=__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(product.date_available).toLocaleString();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDateAvailable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.dateAvailable',defaultMessage:'Product will be available {date}',values:{date:dateAvailable}}));}}]);return ProductDateAvailable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductDateAvailable.propTypes={// Both Products and ChildProducts are allowed.
product:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(ProductDateAvailable));

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoadBeeProductContentWidget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_ManufacturerIntegrationType__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Manufacturer__ = __webpack_require__(232);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LOADBEE_DEBUG='false';var LoadBeeProductContentWidget=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(LoadBeeProductContentWidget,_Component);function LoadBeeProductContentWidget(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LoadBeeProductContentWidget);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LoadBeeProductContentWidget.__proto__||Object.getPrototypeOf(LoadBeeProductContentWidget)).call.apply(_ref,[this].concat(args))),_this),_this.getLocale=function(){var _this$props=_this.props,countryStore=_this$props.countryStore,languageStore=_this$props.languageStore;return languageStore.activeLocale.toLowerCase()+'_'+countryStore.activeCountry.iso_code_2.toUpperCase();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoadBeeProductContentWidget,[{key:'render',value:function render(){var _this2=this;var _props=this.props,gtin=_props.gtin,manufacturer=_props.manufacturer;if(!gtin){return null;}var integrations=manufacturer.integrations.filter(function(integration){return integration.type===__WEBPACK_IMPORTED_MODULE_8__types_ManufacturerIntegrationType__["b" /* default */].LOADBEE;}).map(function(integration,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:gtin+'-'+index,className:'LoadBeeProductContentWidget loadbeeTabContent',id:'loadbeeTabContentId','data-loadbee-apikey':integration.api_key,'data-loadbee-gtin':gtin,'data-loadbee-locale':_this2.getLocale(),'data-loadbee-debug':LOADBEE_DEBUG});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('script',{'data-id':__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('LoadBeeProductContentWidget-'),async:true,src:'https://cdn.loadbee.com/js/loadbee_integration.js'})),integrations);}}]);return LoadBeeProductContentWidget;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;LoadBeeProductContentWidget.propTypes={countryStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_CountryStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_LanguageStore__["a" /* default */]).isRequired,manufacturer:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_Manufacturer__["a" /* default */]).isRequired,gtin:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('countryStore','languageStore')(LoadBeeProductContentWidget));

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductReserveInStoreModalInner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_has__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_StorageStore__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_QuantityFieldGroup__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ProductPrice__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__form_CheckboxField__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__form_RecaptchaField__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_ReserveInStoreStore__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__loader_ErrorHandler__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__models_Storage__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__analytics_Analytics__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps,_class3;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["d" /* defineMessages */])({storageFilterPlaceholder:{'id':'reserveInStore.storageFilterPlaceholder','defaultMessage':'Post code or city'}});var MAX_STORAGES_SHOWN_BY_DEFAULT=5;var labels={firstName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].firstNameTitle),lastName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].lastNameTitle),email:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].emailTitle),phoneNumber:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].telephoneTitle)};var ProductReserveInStoreModalPage={STORAGE:'STORAGE',PERSONAL_DETAILS:'PERSONAL_DETAILS',CONFIRMATION:'CONFIRMATION'};var ProductReserveInStoreModalInner=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(ProductReserveInStoreModalInner,_Component);function ProductReserveInStoreModalInner(props){_classCallCheck(this,ProductReserveInStoreModalInner);var _this=_possibleConstructorReturn(this,(ProductReserveInStoreModalInner.__proto__||Object.getPrototypeOf(ProductReserveInStoreModalInner)).call(this,props));_initialiseProps.call(_this);var reserveInStoreStore=props.reserveInStoreStore;_this.state={requestState:__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].NONE,requestId:0,storeFilterString:'',showAllStorages:false,error:null,reservationID:null};_this.form=null;_this.formName='reserveInStoreModalForm';_this.mathRound=Math.round;reserveInStoreStore.makeSureServicesLoaded();_this.initializeForm(props);return _this;}_createClass(ProductReserveInStoreModalInner,[{key:'render',value:function render(){var reserveInStoreStore=this.props.reserveInStoreStore;var modal=reserveInStoreStore.modal;if(!modal.product||!modal.activeProductId){return null;}var stockLoaded=!!modal.product.stocks.get(modal.activeProductId);var inStock=stockLoaded&&this.productInStock();if(!stockLoaded||!inStock){return null;}var currentPage=this.getCurrentPage();return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["C" /* Modal */],{isOpen:modal.isOpen,toggle:modal.toggle,className:'ProductReserveInStoreModal'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["D" /* ModalBody */],null,this.renderModalTitle(currentPage),this.renderModalBody(currentPage)));}}]);return ProductReserveInStoreModalInner;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.componentDidUpdate=function(oldProps){if(_this2.props.activeProductId!==oldProps.activeProductId){_this2.loadStocks();}};this.initializeForm=function(props){var configStore=props.configStore,accountStore=props.accountStore;_this2.form=Object(__WEBPACK_IMPORTED_MODULE_13__models_Form__["a" /* createForm */])({quantity:Object(__WEBPACK_IMPORTED_MODULE_14__models_FormField__["a" /* createFormField */])({value:'1'}),serviceIds:Object(__WEBPACK_IMPORTED_MODULE_14__models_FormField__["a" /* createFormField */])({value:[]}),firstName:Object(__WEBPACK_IMPORTED_MODULE_14__models_FormField__["a" /* createFormField */])({value:accountStore.loggedIn?accountStore.account.personal_info.firstname:''},[Object(__WEBPACK_IMPORTED_MODULE_15__util_formValidators__["e" /* minLength */])(labels.firstName,configStore.formValidation.firstName.minLength)]),lastName:Object(__WEBPACK_IMPORTED_MODULE_14__models_FormField__["a" /* createFormField */])({value:accountStore.loggedIn?accountStore.account.personal_info.lastname:''},[Object(__WEBPACK_IMPORTED_MODULE_15__util_formValidators__["e" /* minLength */])(labels.lastName,configStore.formValidation.lastName.minLength)]),email:Object(__WEBPACK_IMPORTED_MODULE_14__models_FormField__["a" /* createFormField */])({value:accountStore.loggedIn?accountStore.account.personal_info.email:''},[Object(__WEBPACK_IMPORTED_MODULE_15__util_formValidators__["e" /* minLength */])(labels.email,configStore.formValidation.email.minLength),Object(__WEBPACK_IMPORTED_MODULE_15__util_formValidators__["d" /* isEmail */])(labels.email)]),phoneNumber:Object(__WEBPACK_IMPORTED_MODULE_14__models_FormField__["a" /* createFormField */])({value:accountStore.loggedIn?accountStore.account.personal_info.telephone:''},[Object(__WEBPACK_IMPORTED_MODULE_15__util_formValidators__["e" /* minLength */])(labels.phoneNumber,configStore.formValidation.telephone.minLength)])});};this.toggleModal=function(){_this2.props.reserveInStoreStore.modal.toggle();if(_this2.state.requestState===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADED){window.location.reload();}};this.field=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.checkbox=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__form_CheckboxField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.loadStocks=function(){var _props=_this2.props,product=_props.product,activeProductId=_props.activeProductId;if(product.stockStates.get(activeProductId)!==__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADED){product.loadStocks(activeProductId);}};this.getMatchingStorages=function(){var _props2=_this2.props,reserveInStoreStore=_props2.reserveInStoreStore,storageStore=_props2.storageStore;var storeFilterString=_this2.state.storeFilterString;var _reserveInStoreStore$=reserveInStoreStore.modal,activeProductId=_reserveInStoreStore$.activeProductId,product=_reserveInStoreStore$.product;var minimumRequiredStock=Math.max(1,Number(_this2.form.fields.get('quantity').value));var stocksByStorageId=__WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default()(product.stocks.get(activeProductId).filter(function(stock){return stock.free_quantity>=minimumRequiredStock;}),'storage_id');var storageMatchesSearch=function storageMatchesSearch(storage){return storage.postcode.includes(storeFilterString)||storage.city.toLowerCase().includes(storeFilterString.toLowerCase());};return storageStore.pickupStorages.filter(function(storage){var storageHasStock=!!stocksByStorageId[String(storage.id)];return storageHasStock&&(!storeFilterString||storageMatchesSearch(storage));});};this.getMaximumAvailableStock=function(storages){var _props$reserveInStore=_this2.props.reserveInStoreStore.modal,activeProductId=_props$reserveInStore.activeProductId,product=_props$reserveInStore.product;var storageIds=storages.map(function(storage){return storage.id;});var stocks=product.stocks.get(activeProductId).filter(function(stock){return storageIds.includes(stock.storage_id);});if(!stocks){return 0;}return stocks.reduce(function(maxStock,stock){return Math.max(maxStock,stock.free_quantity);},0);};this.productInStock=function(){var _props$reserveInStore2=_this2.props.reserveInStoreStore.modal,product=_props$reserveInStore2.product,activeProductId=_props$reserveInStore2.activeProductId;var _props3=_this2.props,storageStore=_props3.storageStore,storage=_props3.storage;var pickupStorageIds=storage?[storage.id]:storageStore.pickupStorages.map(function(storage){return storage.id;});var stocks=product.stocks.get(activeProductId);if(!stocks){return false;}return stocks.some(function(stock){return stock.real_stock>0&&pickupStorageIds.includes(stock.storage_id);});};this.getTotalPrice=function(){var _props$reserveInStore3=_this2.props.reserveInStoreStore.modal,product=_props$reserveInStore3.product,activeProductId=_props$reserveInStore3.activeProductId;var withTax=_this2.props.accountStore.showPricesWithTax;return product.getPrice(withTax,activeProductId)*_this2.form.fields.get('quantity').value;};this.setStoreFilterString=function(newString){_this2.setState(function(){return{storeFilterString:newString};});};this.toggleShowAllStorages=function(){_this2.setState(function(state){return{showAllStorages:!state.showAllStorages};});};this.setStorage=function(storage){var storageId=storage?storage.id:null;_this2.props.reserveInStoreStore.modal.setStorage(storageId);_this2.form.fields.get('serviceIds').setValue([]);};this.onRecaptchaChange=function(value){_this2.setState(function(){return{recaptcha:value};});};this.isRecaptchaValid=function(){var recaptcha=_this2.state.recaptcha;var configStore=_this2.props.configStore;return!!recaptcha||!configStore.reserveInStore.enableCaptcha;};this.handleSubmit=function(e){e.preventDefault();var _state=_this2.state,recaptcha=_state.recaptcha,requestId=_state.requestId;var _props4=_this2.props,apiWrapper=_props4.apiWrapper,reserveInStoreStore=_props4.reserveInStoreStore;var _reserveInStoreStore$2=reserveInStoreStore.modal,activeProductId=_reserveInStoreStore$2.activeProductId,storage=_reserveInStoreStore$2.storage;_this2.form.validate();if(_this2.form.valid&&_this2.isRecaptchaValid()){_this2.setState(function(){return{requestState:__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADING,error:null};});var _form$getFieldValues=_this2.form.getFieldValues(),quantity=_form$getFieldValues.quantity,fieldValues=_objectWithoutProperties(_form$getFieldValues,['quantity']);apiWrapper.apiAxios().post('reserve-in-store',Object.assign({recaptcha:recaptcha,quantities:[quantity],productIds:[activeProductId],storageId:storage.id},fieldValues)).then(function(reservation){_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADED,reservationID:reservation.data.reservation_id},function(){return _this2.sendReserveAndCollectAnalyticsEvent();});}).catch(function(error){_this2.setState(function(){return{requestState:__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].ERROR,error:error,requestId:requestId+1};});});}};this.sendReserveAndCollectAnalyticsEvent=function(){var _props5=_this2.props,analytics=_props5.analytics,reserveInStoreStore=_props5.reserveInStoreStore;var requestState=_this2.state.requestState;if(requestState===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADED){var modal=reserveInStoreStore.modal;var _form$getFieldValues2=_this2.form.getFieldValues(),quantity=_form$getFieldValues2.quantity;var storage=modal.storage.name;var productId=modal.activeProductId;var productName=modal.product.name;var totalSum=_this2.getTotalPrice();var data={reserveAndCollect_storage:storage,reserveAndCollect_product_id:productId,reserveAndCollect_product_name:productName,reserveAndCollect_quantity:quantity,// We have to round to two nearest decimals with Number.EPSILON to round cases like 289.0000000000000007 correctly.
reserveAndCollect_totalSum:Math.round((totalSum+Number.EPSILON)*100)/100};analytics.reserveAndCollect(data);}};this.getErrorMessages=function(){var error=_this2.state.error;return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error,'response.data.messages');};this.getCollectionImage=function(){var reserveInStoreStore=_this2.props.reserveInStoreStore;var _reserveInStoreStore$3=reserveInStoreStore.modal,product=_reserveInStoreStore$3.product,activeProductId=_reserveInStoreStore$3.activeProductId;var productImageDict=__WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default()(product.images,'for_color_id');var collectionItem=product.collection.getItemWithProductId(activeProductId);var columnElement=product.collection.column.getElementWithId(collectionItem.column_id);var rowElement=product.collection.row.getElementWithId(collectionItem.row_id);var productImageForElement=product.getMainImage(activeProductId);if(__WEBPACK_IMPORTED_MODULE_0_lodash_has___default()(productImageDict,columnElement.id)){productImageForElement=productImageDict[columnElement.id];}else if(__WEBPACK_IMPORTED_MODULE_0_lodash_has___default()(productImageDict,rowElement.id)){productImageForElement=productImageDict[rowElement.id];}return productImageForElement;};this.getImage=function(){var reserveInStoreStore=_this2.props.reserveInStoreStore;var _reserveInStoreStore$4=reserveInStoreStore.modal,product=_reserveInStoreStore$4.product,activeProductId=_reserveInStoreStore$4.activeProductId;var productImage=product.class===__WEBPACK_IMPORTED_MODULE_29__types_ProductClass__["b" /* default */].COLLECTION?_this2.getCollectionImage():product.getMainImage(activeProductId);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ProductImage__["a" /* default */],{product:product,productImage:productImage,size:'small'});};this.renderHowItWorksBlock=function(){var configStore=_this2.props.configStore;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.howItWorks',defaultMessage:'Reserve the product now and pick it up from the store later! The reservation is valid for {expiryHours} hours, after which it will be removed. Please note that discount coupons cannot be used with in-store reservations.',values:{expiryHours:configStore.reserveInStore.expireTimeHours}}));};this.renderProductSummary=function(isEditable,maxQuantity){var _props6=_this2.props,reserveInStoreStore=_props6.reserveInStoreStore,configStore=_props6.configStore;var _reserveInStoreStore$5=reserveInStoreStore.modal,product=_reserveInStoreStore$5.product,activeProductId=_reserveInStoreStore$5.activeProductId;var productName=product.name;if(product.class===__WEBPACK_IMPORTED_MODULE_29__types_ProductClass__["b" /* default */].COLLECTION){var item=product.collection.getItemWithProductId(activeProductId);productName=productName+(product.class===__WEBPACK_IMPORTED_MODULE_29__types_ProductClass__["b" /* default */].COLLECTION&&' ('+item.columnName+', '+item.rowName+')');}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["n" /* Container */],{className:'ProductReserveInStoreModal__product-summary'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'3'},_this2.getImage()),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'9'},product.manufacturer&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__product-manufacturer'},product.manufacturer.name),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__product-name'},productName),configStore.product.showModel&&product.model&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__product-model'},product.model),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'form-inline ProductReserveInStoreModal__product-quantity'},isEditable?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_QuantityFieldGroup__["a" /* default */],{maxQuantity:maxQuantity,unit:product.unitName,field:_this2.form.fields.get('quantity')}):_this2.form.fields.get('quantity').value,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'ProductReserveInStoreModal__product-quantity-times'},'x'),product.price_info&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ProductPrice__["a" /* default */],{product:product,priceInfo:product.price_info}))))));};this.renderStorageSummary=function(storage){if(!storage){return null;}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__storage-summary'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__storage-item-name'},storage.name),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__storage-item-address'},storage.street_address,', ',storage.postcode,' ',storage.city),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__storage-item-opening-hours'},storage.opening_hours));};this.renderStorageServicesCheckboxes=function(storage){if(!storage){return null;}var services=storage.services;if(services.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.availableServicesForStorage',defaultMessage:'The following services are available in the store you selected:'}),_this2.checkbox('serviceIds',{options:services.map(function(service){return{value:String(service.id),label:service.description};})})));};this.renderModalStoragePage=function(){var _props7=_this2.props,reserveInStoreStore=_props7.reserveInStoreStore,intl=_props7.intl;var _reserveInStoreStore$6=reserveInStoreStore.modal,product=_reserveInStoreStore$6.product,activeProductId=_reserveInStoreStore$6.activeProductId;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,_this2.renderHowItWorksBlock(),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:product.stockStates.get(activeProductId),forLoaded:function forLoaded(){var storages=_this2.getMatchingStorages();var visibleStorages=_this2.state.showAllStorages?storages:storages.slice(0,MAX_STORAGES_SHOWN_BY_DEFAULT);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,_this2.renderProductSummary(true,_this2.getMaximumAvailableStock(storages)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'9'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["v" /* Input */],{value:_this2.state.storeFilterString,onChange:function onChange(e){return _this2.setStoreFilterString(e.target.value);},placeholder:intl.formatMessage(messages.storageFilterPlaceholder)})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{onClick:function onClick(){return _this2.setStoreFilterString('');},block:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].clearTitle)))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductReserveInStoreModal__available-storages-hint'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.availableStoragesHint',defaultMessage:'The following stores have the selected quantity of this item in stock.'}))),visibleStorages.map(function(storage){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductReserveInStoreModal__storage-item',key:storage.id},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'9',className:'ProductReserveInStoreModal__storage-item-data'},_this2.renderStorageSummary(storage)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'3',className:'ProductReserveInStoreModal__storage-item-button'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{onClick:function onClick(){return _this2.setStorage(storage);},color:'primary',className:'ProductReserveInStoreModal__select-storage-button',block:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.selectStorageButton',defaultMessage:'Select this store'}))));})),storages.length>visibleStorages.length&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__section ProductReserveInStoreModal__show-all-storages-section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{onClick:_this2.toggleShowAllStorages,color:'primary'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.showAllStoragesButton',defaultMessage:'Show all stores'}))));}}));};this.renderModalDetailsPage=function(){var _props8=_this2.props,configStore=_props8.configStore,reserveInStoreStore=_props8.reserveInStoreStore,accountStore=_props8.accountStore;var _state2=_this2.state,requestId=_state2.requestId,requestState=_state2.requestState,error=_state2.error;var storage=reserveInStoreStore.modal.storage;var withTax=accountStore.showPricesWithTax;var showTaxExcludedInfo=!withTax;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,_this2.renderHowItWorksBlock(),_this2.renderProductSummary(true,_this2.getMaximumAvailableStock([storage])),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductReserveInStoreModal__storage-item'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'9',className:'ProductReserveInStoreModal__storage-item-data'},_this2.renderStorageSummary(storage)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'3',className:'ProductReserveInStoreModal__storage-item-button'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{onClick:function onClick(){return _this2.setStorage(null);},color:'primary',className:'ProductReserveInStoreModal__select-storage-button'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.unselectStorageButton',defaultMessage:'Select another store'})))),_this2.renderStorageServicesCheckboxes(storage),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'6'},_this2.field('firstName')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'6'},_this2.field('lastName'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12'},_this2.field('email'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12'},_this2.field('phoneNumber'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'8'},configStore.reserveInStore.enableCaptcha&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__form_RecaptchaField__["a" /* default */],{key:requestId,ref:function ref(recaptcha){return _this2.recaptcha=recaptcha;},onChange:_this2.onRecaptchaChange})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'4',className:'ProductReserveInStoreModal__total-price'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'ProductReserveInStoreModal__total-price-label'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].totalPriceSentence)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'ProductReserveInStoreModal__total-price-value'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Price__["a" /* default */],{price:_this2.getTotalPrice(),showTaxExcludedInfo:showTaxExcludedInfo}))))),error&&!_this2.getErrorMessages()&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__loader_ErrorHandler__["a" /* default */],{error:Object(__WEBPACK_IMPORTED_MODULE_28__util_error__["a" /* createErrorModel */])(error)}),_this2.getErrorMessages()&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["a" /* Alert */],{color:'danger',key:requestId},_this2.getErrorMessages().map(function(message){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:message},message);})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{block:true,size:'lg',color:'primary',className:'ProductReserveInStoreModal__reserve-button',onClick:_this2.handleSubmit,disabled:requestState===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADING},requestState===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADING&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__common_Icon__["a" /* default */],{name:'circle-o-notch',spin:true}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.confirmReservation',defaultMessage:'Reserve now'})));};this.renderModalConfirmationPage=function(){var _props9=_this2.props,reserveInStoreStore=_props9.reserveInStoreStore,accountStore=_props9.accountStore;var modal=reserveInStoreStore.modal;var selectedServiceIds=_this2.form.fields.get('serviceIds').value;var selectedServices=reserveInStoreStore.services.filter(function(service){return selectedServiceIds.includes(String(service.id));});var withTax=accountStore.showPricesWithTax;var showTaxExcludedInfo=!withTax;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.reservationSuccessfulMessage',defaultMessage:'Thank you for your reservation! A confirmation message has been sent to the email address {email}.',values:{email:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,_this2.form.fields.get('email').value)}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.cancellationInfo',defaultMessage:'You can cancel your reservation by calling the store.'}))),_this2.renderProductSummary(false),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductReserveInStoreModal__storage-item'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12',className:'ProductReserveInStoreModal__storage-item-data'},_this2.renderStorageSummary(modal.storage))),selectedServices.length>0&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.selectedServicesSentence',defaultMessage:'With the following selected services:'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',null,selectedServices.map(function(service){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{key:service.id},service.description);}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'ProductReserveInStoreModal__total-price'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'ProductReserveInStoreModal__total-price-label'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].totalPriceSentence)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'ProductReserveInStoreModal__total-price-value'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Price__["a" /* default */],{price:_this2.getTotalPrice(),showTaxExcludedInfo:showTaxExcludedInfo})))));};this.getCurrentPage=function(){if(!_this2.props.reserveInStoreStore.modal.storage){return ProductReserveInStoreModalPage.STORAGE;}else if(_this2.state.requestState!==__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADED){return ProductReserveInStoreModalPage.PERSONAL_DETAILS;}else{return ProductReserveInStoreModalPage.CONFIRMATION;}};this.renderModalTitle=function(page){var message=page===ProductReserveInStoreModalPage.CONFIRMATION?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.reservationConfirmationTitle',defaultMessage:'Reservation #{reservationID}',values:{reservationID:_this2.state.reservationID}}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'reserveInStore.reservationTitle',defaultMessage:'Reserve in store'});// TODO: layout specs specify a hanging-type close button for this modal
// and several other modals. Currently we are using vanilla Reactstrap
// modal type close buttons, though; for consistency, use a similar close
// button here for now. ModalHeader itself is not used as we don't want
// the rest of the styling that comes with that element.
return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'ProductReserveInStoreModal__section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'close',onClick:_this2.props.reserveInStoreStore.modal.toggle},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{'aria-hidden':true},'\xD7'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'sr-only'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].closeTitle))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h2',null,message));};this.renderModalBody=function(page){if(!_this2.form){return null;}switch(page){case ProductReserveInStoreModalPage.PERSONAL_DETAILS:return _this2.renderModalDetailsPage();case ProductReserveInStoreModalPage.CONFIRMATION:return _this2.renderModalConfirmationPage();case ProductReserveInStoreModalPage.STORAGE:default:return _this2.renderModalStoragePage();}};},_temp))||_class;ProductReserveInStoreModalInner.propTypes={analytics:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_32__analytics_Analytics__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_25__services_ApiWrapper__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_30__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,reserveInStoreStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__store_ReserveInStoreStore__["a" /* default */]).isRequired,storageStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_StorageStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_7_react_intl__["f" /* intlShape */].isRequired,storage:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_31__models_Storage__["a" /* default */])};var ProductReserveInStoreModal=Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["d" /* observer */])(_class3=function(_Component2){_inherits(ProductReserveInStoreModal,_Component2);function ProductReserveInStoreModal(){_classCallCheck(this,ProductReserveInStoreModal);return _possibleConstructorReturn(this,(ProductReserveInStoreModal.__proto__||Object.getPrototypeOf(ProductReserveInStoreModal)).apply(this,arguments));}_createClass(ProductReserveInStoreModal,[{key:'render',value:function render(){var _props10=this.props,reserveInStoreStore=_props10.reserveInStoreStore,rest=_objectWithoutProperties(_props10,['reserveInStoreStore']);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ProductReserveInStoreModalInner,Object.assign({key:reserveInStoreStore.modal.refreshCounter,reserveInStoreStore:reserveInStoreStore},rest));}}]);return ProductReserveInStoreModal;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]))||_class3;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["c" /* inject */])('accountStore','analytics','configStore','storageStore','reserveInStoreStore','apiWrapper')(ProductReserveInStoreModal)));

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recaptcha__ = __webpack_require__(534);
/* unused harmony reexport ReCAPTCHA */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__["a" /* default */]);


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_async_script__);



function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function getURL() {
  var dynamicOptions = getOptions();
  var lang = dynamicOptions.lang ? "&hl=" + dynamicOptions.lang : "";
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
}

var callbackName = "onloadcallback";
var globalName = "grecaptcha";
var initialOptions = getOptions();

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_async_script___default()(getURL, {
  callbackName: callbackName,
  globalName: globalName,
  removeOnUnmount: initialOptions.removeOnUnmount || false
})(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a" /* default */]));

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeAsyncScript;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(1099);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SCRIPT_MAP = {};

// A counter used to generate a unique id for each component that uses the function
var idCount = 0;

function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader = function (_Component) {
      _inherits(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        _classCallCheck(this, AsyncScriptLoader);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      AsyncScriptLoader.prototype.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }
        return this.__scriptLoaderID;
      };

      AsyncScriptLoader.prototype.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      AsyncScriptLoader.prototype.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      AsyncScriptLoader.prototype.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];
        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }
        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }
        delete window[options.callbackName];
      };

      AsyncScriptLoader.prototype.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName;

        // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = { loaded: true, observers: {} };
        }

        // check if script loading already
        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL];
          // if loaded or errored then "finish"
          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          }
          // if still loading then callback to observer queue
          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };
          return;
        }

        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */
        var observers = {};
        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };
        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };

        var script = document.createElement("script");

        script.src = scriptURL;
        script.async = true;

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];
          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }
              observer(mapEntry);
              return true;
            });
          }
        };
        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];
          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      AsyncScriptLoader.prototype.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;
        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");
          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        }
        // Clean the observer entry
        var mapEntry = SCRIPT_MAP[scriptURL];
        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      AsyncScriptLoader.prototype.render = function render() {
        var globalName = options.globalName;
        // remove asyncScriptOnLoad from childProps

        var _props = this.props,
            asyncScriptOnLoad = _props.asyncScriptOnLoad,
            forwardedRef = _props.forwardedRef,
            childProps = _objectWithoutProperties(_props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }
        childProps.ref = forwardedRef;
        return (0, _react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(_react.Component);

    // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0, _react.forwardRef)(function (props, ref) {
      return (0, _react.createElement)(AsyncScriptLoader, _extends({}, props, { forwardedRef: ref }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: _propTypes2.default.func
    };

    return (0, _hoistNonReactStatics2.default)(ForwardedComponent, WrappedComponent);
  };
}

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(1100);
var React = __webpack_require__(0);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1101);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-is.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol["for"],c=b?Symbol["for"]("react.element"):60103,d=b?Symbol["for"]("react.portal"):60106,e=b?Symbol["for"]("react.fragment"):60107,f=b?Symbol["for"]("react.strict_mode"):60108,g=b?Symbol["for"]("react.provider"):60109,h=b?Symbol["for"]("react.context"):60110,k=b?Symbol["for"]("react.async_mode"):60111,l=b?Symbol["for"]("react.forward_ref"):60112;
function m(a){if("object"===typeof a&&null!==a){var n=a.$$typeof;switch(n){case c:switch(a=a.type,a){case k:case e:case f:return a;default:switch(a=a&&a.$$typeof,a){case h:case l:case g:return a;default:return n}}case d:return n}}}exports.typeOf=m;exports.AsyncMode=k;exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=c;exports.ForwardRef=l;exports.Fragment=e;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===k||a===f||"object"===typeof a&&null!==a&&(a.$$typeof===g||a.$$typeof===h||a.$$typeof===l)};exports.isAsyncMode=function(a){return m(a)===k};exports.isContextConsumer=function(a){return m(a)===h};exports.isContextProvider=function(a){return m(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return m(a)===l};
exports.isFragment=function(a){return m(a)===e};exports.isPortal=function(a){return m(a)===d};exports.isStrictMode=function(a){return m(a)===f};


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImageLightboxHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageLightboxHelper=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ImageLightboxHelper,_Component);function ImageLightboxHelper(){_classCallCheck(this,ImageLightboxHelper);return _possibleConstructorReturn(this,(ImageLightboxHelper.__proto__||Object.getPrototypeOf(ImageLightboxHelper)).apply(this,arguments));}_createClass(ImageLightboxHelper,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('ImageLightboxHelper',{ImageLightboxHelper__visible:this.props.visible})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:'ImageLightBoxHelper__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'12',className:'ImageLightboxHelper__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */],{name:'expand',className:'ImageLightboxHelper__icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ImageLightboxHelper__text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'image.lightboxHelper',defaultMessage:'Click image to enlarge'}))))));}}]);return ImageLightboxHelper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ImageLightboxHelper.propTypes={visible:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ImageLightboxHelper);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_storage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_constants__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductAddToWishList=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductAddToWishList,_Component);function ProductAddToWishList(props){_classCallCheck(this,ProductAddToWishList);var _this=_possibleConstructorReturn(this,(ProductAddToWishList.__proto__||Object.getPrototypeOf(ProductAddToWishList)).call(this,props));_this.state={productAddedBanner:false,alertVisible:false};_this.storage=[];_this.addProductToWishlist=function(){var _this$props=_this.props,product=_this$props.product,quantity=_this$props.quantity;var newQuantity=Object(__WEBPACK_IMPORTED_MODULE_14__util_number__["a" /* calculateNearestProductQuantityWithQuantityStep */])(quantity,_this.getQuantityStep(product));_this.findProduct(product,Math.ceil(newQuantity));Object(__WEBPACK_IMPORTED_MODULE_9__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_10__util_constants__["a" /* storageKeys */].wishlist,_this.storage);_this.showProductAddedToWishListBanner();};_this.findProduct=function(product,newQuantity){var productId=_this.getProductIdByProductClass(product);var productFound=_this.storage.find(function(p){return p.id===productId;});if(productFound){_this.updateProduct(productFound,newQuantity);_this.resetProductVariationChoices();}else{_this.addProduct(product,newQuantity);_this.resetProductVariationChoices();}};_this.updateProduct=function(productFound,newQuantity){var productIndex=_this.storage.findIndex(function(p){return p.id===productFound.id;});if(newQuantity===1){productFound.quantity++;}else{productFound.quantity=newQuantity;}_this.storage.splice(productIndex,1,productFound);};_this.addProduct=function(product,newQuantity){var productListProduct=_this.initializeProductListProduct(product,newQuantity);if(_this.props.accountStore.account.is_logged){_this.ifLoggedInSaveToDatabase(productListProduct,newQuantity);}else{_this.storage.push(productListProduct);}};_this.initializeProductListProduct=function(product,quantity){var _this$props2=_this.props,productStore=_this$props2.productStore,routeService=_this$props2.routeService;_this.setVariationIfMultiProduct(productStore,product);return{id:_this.getProductIdByProductClass(product),recurring_order_type:product.recurring_order_type,multiproduct_id:product.multiproduct_id,product_id:product.id,name:product.name,quantity:Number(quantity),class:product.class,collection:product.collection,multi:product.multi,multiproduct_title:product.multiproduct_title,stock_unit:product.stock_unit,price_info:product.price_info,total_price:product.price_info.price,link:routeService.getCanonicalProductPath(product),image:_this.getSmallProductImageOrDefault(product.images),package_size:product.package_size,availability_html:product.availability_html,available_for_purchase:product.can_be_ordered_out_of_stock,variations:_this.resetVariationsIfProductIsNormal(productStore,product)};};_this.getProductIdByProductClass=function(product){return product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].COLLECTION||product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].MULTI?_this.props.activeProductId:product.id;};_this.setVariationIfMultiProduct=function(productStore,product){if(product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].MULTI_CHILD){productStore.setProductVariationColumn(''+product.model);}};_this.getSmallProductImageOrDefault=function(images){return images[0]?images[0].sizes.small:null;};_this.resetVariationsIfProductIsNormal=function(productStore,product){if(product.class===__WEBPACK_IMPORTED_MODULE_13__types_ProductClass__["b" /* default */].SINGLE){_this.resetProductVariationChoices();return _this.getProductVariations(productStore);}else{return _this.getProductVariations(productStore);}};_this.resetProductVariationChoices=function(){var productStore=_this.props.productStore;productStore.setProductVariationColumn(null);productStore.setProductVariationRow(null);};_this.getProductVariations=function(productStore){return[productStore.getProductVariationColumn(),productStore.getProductVariationRow()];};_this.ifLoggedInSaveToDatabase=function(productListProduct,newQuantity){var productStore=_this.props.productStore;var newProduct={extendedId:productListProduct.id,quantity:newQuantity};productStore.saveProduct(newProduct).then(function(response){if(response.status===200){_this.showProductAddedToWishListBanner();}}).catch(function(err){return console.error(err);});};_this.getQuantityStep=function(product){return product&&product.sellInPackage?product.package_size:1;};_this.showProductAddedToWishListBanner=function(){_this.setState({productAddedBanner:true,alertVisible:true});};_this.onAlertDismiss=function(){_this.setState({alertVisible:false});};_this.addToWishListButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',className:'ProductAddToWishList__button',onClick:_this.addProductToWishlist.bind(_this),disabled:_this.props.disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'heart'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.AddWishListTitle',defaultMessage:'Add to wishlist'}));};_this.productAddedBanner=function(){if(_this.state.productAddedBanner){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'secondary',isOpen:_this.state.alertVisible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.ProductAddedToWishlist',defaultMessage:'Product added to wishlist. You can view it {link}.',values:{link:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_ButtonLink__["a" /* default */],{onClick:_this.navigateToWishList},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'product.ProductAddedToWishlist_here',defaultMessage:'here'}))}}));}};_this.navigateToWishList=function(){_this.props.history.push(__WEBPACK_IMPORTED_MODULE_6__types_Paths__["a" /* default */].WishList);};_this.addProductToWishlist=_this.addProductToWishlist.bind(_this);_this.onAlertDismiss=_this.onAlertDismiss.bind(_this);return _this;}_createClass(ProductAddToWishList,[{key:'componentDidMount',value:function componentDidMount(){this.storage=Object(__WEBPACK_IMPORTED_MODULE_9__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_10__util_constants__["a" /* storageKeys */].wishlist);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState,snapshot){if(prevProps!==this.props){this.setState({alertVisible:false});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductAddToWishList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{className:'pr-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:12},this.addToWishListButton()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:12},this.productAddedBanner())));}}]);return ProductAddToWishList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductAddToWishList.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_AccountStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_ProductStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_15__services_RouteService__["a" /* default */]).isRequired,product:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','productStore','routeService')(ProductAddToWishList));

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
var getModelYearString=function getModelYearString(start,end){if(end==='9999'){if(start==='0'){return'';}else{return start+' -';}}return start+' - '+end;};var getModelString=function getModelString(model,type){var modelString=model;if(type){if(type.manufacturerModel){modelString+=' '+type.manufacturerModel;}if(type.modelCode){modelString+=' '+type.modelCode;}}return modelString;};var CompatibleVehicleModels=function CompatibleVehicleModels(props){var product=props.product;if(!product.startaxInfo.compatibleModels){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["R" /* Table */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'vehicle.brand',defaultMessage:'Brand'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'vehicle.model',defaultMessage:'Model'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'vehicle.motor',defaultMessage:'Motor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'vehicle.years',defaultMessage:'Years'})))),product.startaxInfo.compatibleModels.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,model.car.brand),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,getModelString(model.car.model,model.type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,model.car.motor),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,getModelYearString(model.year.start,model.year.end)));}));};/* harmony default export */ __webpack_exports__["a"] = (CompatibleVehicleModels);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider_ProductSlider__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_MissingProductLoader__ = __webpack_require__(349);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VehiclePartSlider=function(_Component){_inherits(VehiclePartSlider,_Component);function VehiclePartSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VehiclePartSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VehiclePartSlider.__proto__||Object.getPrototypeOf(VehiclePartSlider)).call.apply(_ref,[this].concat(args))),_this),_this.renderContent=function(products){if(products.length===0){return null;}var title=_this.props.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'VehiclePartAlternativesSlider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__slider_ProductSlider__["a" /* default */],{name:_this.listName,products:products}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VehiclePartSlider,[{key:'render',value:function render(){var _this2=this;var productIds=this.props.productIds;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_MissingProductLoader__["a" /* default */],{ids:productIds},function(products){return _this2.renderContent(products);});}}]);return VehiclePartSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VehiclePartSlider);

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GenericProductsSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductSlider__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_list_SimpleProductList__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GenericProductsSlider=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(GenericProductsSlider,_Component);function GenericProductsSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GenericProductsSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GenericProductsSlider.__proto__||Object.getPrototypeOf(GenericProductsSlider)).call.apply(_ref,[this].concat(args))),_this),_this.listName=_this.props.listName,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GenericProductsSlider,[{key:'render',value:function render(){var _props=this.props,mainComponentClassName=_props.mainComponentClassName,formattedMessage=_props.formattedMessage,ids=_props.ids,allSections=_props.allSections,configStore=_props.configStore;var searchParams={ids:ids,includeChildProducts:'1',inStock:configStore.inStockProductsOnly?'1':'0'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(mainComponentClassName)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,formattedMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__product_list_SimpleProductList__["a" /* default */],{name:this.listName,searchParams:searchParams,listComponent:__WEBPACK_IMPORTED_MODULE_4__ProductSlider__["a" /* default */],allSections:allSections}));}}]);return GenericProductsSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;GenericProductsSlider.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__["a" /* default */]).isRequired,allSections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,mainComponentClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,listName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,formattedMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,ids:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('configStore')(GenericProductsSlider));

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductCollectionMatrix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__anchor_ScrollableAnchor__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProductPageContent__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_ImageLightbox__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__types_ProductAvailabilityType__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__models_ProductMatrix__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__bootstrap_CustomCol__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* defineMessages */])({productMatrixInfo:{'id':'product.productMatrixInfo','defaultMessage':'Select the products to be ordered by entering the quantities in the "Quantity" fields in the table. You can move between cells using the tab.'},quantityInput:{'id':'product.quantityInput','defaultMessage':'Quantity'},inventoryQuantity:{'id':'product.inventoryQuantity','defaultMessage':'Inventory Quantity: {inventoryQuantity} {stockUnit}'},incomingQuantity:{'id':'product.incomingQuantity','defaultMessage':'Incoming: {freeQuantity} {stockUnit} {date}'},noDateAvailable:{'id':'product.noDateAvailable','defaultMessage':'(no date available)'},incomingQuantityNoQuantities:{'id':'product.incomingQuantityNoQuantities','defaultMessage':'Incoming: {date}'},productsHasBeenOrdered:{'id':'product.productsHasBeenOrdered','defaultMessage':'(Products has been ordered)'},notAvailable:{'id':'product.notAvailable','defaultMessage':'(Not available)'}});var ProductCollectionMatrix=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductCollectionMatrix,_Component);function ProductCollectionMatrix(props){_classCallCheck(this,ProductCollectionMatrix);var _this=_possibleConstructorReturn(this,(ProductCollectionMatrix.__proto__||Object.getPrototypeOf(ProductCollectionMatrix)).call(this,props));_this.remainingGridColumns=10;_this.getImageLightbox=function(){var product=_this.props.product;var _this$state=_this.state,mainImageIndex=_this$state.mainImageIndex,lightboxIsOpen=_this$state.lightboxIsOpen;if(product.images.length===0||!lightboxIsOpen||mainImageIndex===null){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ImageLightbox__["a" /* default */],{images:product.images,mainImageIndex:mainImageIndex,onClick:_this.toggleLightbox.bind(_this,false)});};_this.toggleLightbox=function(lightboxIsOpen){return _this.setState({lightboxIsOpen:lightboxIsOpen});};_this.getCollectionRowElements=function(){return _this.props.productMatrix.getRowElements();};_this.addSelectedProducts=function(){var _this$props=_this.props,cartStore=_this$props.cartStore,analytics=_this$props.analytics,accountStore=_this$props.accountStore;var _this$state2=_this.state,selectedProducts=_this$state2.selectedProducts,analyticsProducts=_this$state2.analyticsProducts;selectedProducts&&analyticsProducts&&selectedProducts.length>0&&analyticsProducts.length>0&&cartStore.populate(selectedProducts,accountStore.showCartMatrix).then(function(){analytics.addToCart(analyticsProducts);analytics.cartStatus({cart:cartStore.cart});});};_this.renderProductMatrixTitles=function(){var titles=_this.props.productMatrix.getNames();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{className:'ProductCollectionMatrix__column-row-label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,titles.columnName,titles.columnName&&titles.rowName&&' / ',titles.rowName)));};_this.renderProductElementRows=function(){var productRows=_this.getCollectionRowElements();return productRows&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,productRows[0].name&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null),productRows.map(function(rowElement,index){return rowElement.name&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:index,className:'ProductCollectionMatrix__row-element-title',dangerouslySetInnerHTML:{__html:rowElement.name}});})));};_this.renderProductColumns=function(){var _this$props2=_this.props,product=_this$props2.product,productMatrix=_this$props2.productMatrix,uiStore=_this$props2.uiStore,ifProductRowImages=_this$props2.ifProductRowImages;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,productMatrix.getColumnElements().map(function(element){var productRowImage=product.images.find(function(image){return image.for_color_id===element.id;});var columnTitle=productMatrix.getNames();ifProductRowImages&&ifProductRowImages(productRowImage);var productImage=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ProductImage__["a" /* default */],{product:product,size:'small',productImage:productRowImage,forceAspectRatio:false,lazyLoading:false,className:'ProductCollectionMatrix__product-image',wrapperClassName:'ProductCollectionMatrix__product-image-wrapper',overlayIcon:productRowImage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'ProductCollectionMatrix__product-image-overlay-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_Icon__["a" /* default */],{name:'expand'}))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'ProductCollectionMatrix__product-column-title'},columnTitle.columnName,': ',element.name));return element&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:element.id,className:'ProductCollectionMatrix__product-row'},!uiStore.isMobile&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'ProductCollectionMatrix__product-row-header',scope:'row',onClick:productRowImage&&_this.setMainImageIndex.bind(_this,productRowImage)},productImage),uiStore.isMobile&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'ProductCollectionMatrix__font-label-weight',onClick:productRowImage&&_this.setMainImageIndex.bind(_this,productRowImage)},productImage),element&&_this.renderProductQuantityInputs(element.id));}));};_this.setMainImageIndex=function(productRowImage){var product=_this.props.product;var mainImageIndex=product.images.findIndex(function(image){return image.for_color_id===productRowImage.for_color_id;});_this.setState({mainImageIndex:mainImageIndex},function(){return _this.toggleLightbox(true);});};_this.renderProductQuantityInputs=function(productCollectionElementId){var _this$props3=_this.props,product=_this$props3.product,productMatrix=_this$props3.productMatrix,uiStore=_this$props3.uiStore,intl=_this$props3.intl;var rowElements=_this.getCollectionRowElements();return rowElements&&rowElements.map(function(rowElement){var elementIds=productMatrix.shouldSwapCollectionOrder()?{rowId:productCollectionElementId,columnId:rowElement.id}:{columnId:productCollectionElementId,rowId:rowElement.id};var productCollectionElementItem=_this.findProductCollectionElementItem(elementIds.columnId,elementIds.rowId);var element=uiStore.isMobile&&_this.findRowElementById(rowElement.id);var incomingQuantities=productCollectionElementItem.getIncomingQuantities();var ifProductAvailable=_this.checkProductAvailability(productCollectionElementItem);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{key:productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id,className:'ProductCollectionMatrix__quantity-display-and-selection-column'},uiStore.isMobile&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{className:'ProductCollectionMatrix__font-label-weight',dangerouslySetInnerHTML:{__html:element.name}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductCollectionMatrix__quantity-selection-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:12,className:'align-self-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{className:'ProductCollectionMatrix__quantity-and-stock-unit','for':'qty--'+productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id},_this.getFreeQuantity(productCollectionElementItem),' ',product.stock_unit)),(incomingQuantities.length>0||!ifProductAvailable)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],{className:'ProductCollectionMatrix__exceptionalAvailability'},ifProductAvailable?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_25__i18n_globalTranslations__["a" /* default */].exceptionalAvailability):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],messages.notAvailable))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["v" /* Input */],{disabled:!ifProductAvailable,id:'qty--'+productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id,name:'qty--'+productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id,className:'ProductCollectionMatrix__quantity-input',type:'number',onChange:_this.setProduct.bind(_this,productCollectionElementItem,productCollectionElementItem.row_id,productCollectionElementItem.column_id),value:_this.state['qty--'+productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id]||'',placeholder:intl.formatMessage(messages.quantityInput),onClick:_this.openTooltip.bind(_this,productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id+'--tooltip'),onBlur:_this.hideTooltip.bind(_this,productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id+'--tooltip'),invalid:!!_this.state['qty--'+productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id+'--error']}),_this.quantityError(productCollectionElementItem,productCollectionElementItem.column_id)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["S" /* Tooltip */],{className:'ProductCollectionMatrix__product-quantity-tooltip',innerClassName:'ProductCollectionMatrix__product-quantity-inner-tooltip',arrowClassName:'ProductCollectionMatrix__product-quantity-tooltip-arrow',placement:'top',isOpen:_this.state[productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id+'--tooltip'],target:'qty--'+productCollectionElementItem.row_id+'--'+productCollectionElementItem.column_id},_this.renderTooltipContent(productCollectionElementItem))));});};_this.findProductCollectionElementItem=function(productCollectionColumnElementId,productCollectionRowElementId){return _this.props.productMatrix.getItem(productCollectionColumnElementId,productCollectionRowElementId);};_this.findRowElementById=function(rowElementId){return _this.props.productMatrix.getRowElements().find(function(rowElement){return rowElement.id===rowElementId;});};_this.getFreeQuantity=function(productCollectionElementItem){var product=_this.props.product;var freeQuantity=product.getFreeQuantity(productCollectionElementItem.product.id);return freeQuantity>0?freeQuantity:0;};_this.checkProductAvailability=function(productCollectionElementItem){var product=_this.props.product;var quantity=productCollectionElementItem.getAvailableAmount()>0;var ifCanBeOrderedOutOfStock=productCollectionElementItem.canBeOrderedOutOfStock();var allowBackOrder=product.availability_type===__WEBPACK_IMPORTED_MODULE_19__types_ProductAvailabilityType__["b" /* default */].ALLOW_BACKORDER;return quantity||ifCanBeOrderedOutOfStock||allowBackOrder;};_this.ifOrderedProducts=function(productCollectionElementItem){var incomingQuantities=productCollectionElementItem.getIncomingQuantities();if(!incomingQuantities||incomingQuantities.length===0){return null;}var predicate={date:null,free_quantity:null,quantity:null};return __WEBPACK_IMPORTED_MODULE_0_lodash_every___default()(incomingQuantities,predicate);};_this.renderTooltipContent=function(productCollectionElementItem){var _this$props4=_this.props,product=_this$props4.product,productMatrix=_this$props4.productMatrix;var inStockQuantity=productCollectionElementItem.getInStockQuantity();var freeQuantity=_this.getFreeQuantity(productCollectionElementItem);var incomingQuantities=productCollectionElementItem.getIncomingQuantities();var rowId=productCollectionElementItem.row_id;var columnId=productCollectionElementItem.column_id;var elementName=productMatrix.getProductElementNamesByItemElementId(rowId,columnId);var ifOrderedProducts=_this.ifOrderedProducts(productCollectionElementItem);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["n" /* Container */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductCollectionMatrix__tooltip'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:12,className:'ProductCollectionMatrix__tooltip-label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* Label */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,elementName.columnName,elementName.columnName&&elementName.rowName&&' / ',elementName.rowName))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:12,className:'ProductCollectionMatrix__tooltip-stock-quantity'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.inventoryQuantity,{values:{inventoryQuantity:inStockQuantity,stockUnit:product.stock_unit}}))),ifOrderedProducts?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],messages.productsHasBeenOrdered):_this.renderIncomingQuantities(incomingQuantities),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:12,className:'ProductCollectionMatrix__tooltip-separator'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:12,className:'ProductCollectionMatrix__tooltip-free-quantity'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_25__i18n_globalTranslations__["a" /* default */].freeQuantity,{values:{freeQuantity:freeQuantity,stockUnit:product.stock_unit}})))));};_this.renderIncomingQuantities=function(incomingQuantities){var product=_this.props.product;if(!incomingQuantities||incomingQuantities.length===0){return null;}return incomingQuantities.map(function(incomingQuantity,index){var incomingQuantityDate=incomingQuantity.date&&__WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(incomingQuantity.date).toLocaleString();var freeQuantity=incomingQuantity.free_quantity;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{key:index,sm:12,className:'ProductCollectionMatrix__tooltip-incoming-quantity'},freeQuantity?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.incomingQuantity,{values:{date:incomingQuantityDate?incomingQuantityDate:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],messages.noDateAvailable),freeQuantity:freeQuantity,stockUnit:product.stock_unit}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.incomingQuantityNoQuantities,{values:{date:incomingQuantityDate?incomingQuantityDate:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],messages.noDateAvailable)}})));});};_this.setProduct=function(productCollectionElementItem,productCollectionRowElementId,productCollectionColumnElementId,event){var name=event.target.name;var selectedProducts=_this.state.selectedProducts;var id=productCollectionElementItem.product.id;var maxQuantity=_this.getMaxQuantity(id);var qty=_this.getQuantity(Number(event.target.value),maxQuantity);_this.setState(_defineProperty({},name,qty),function(){var quantity=_this.state['qty--'+productCollectionRowElementId+'--'+productCollectionColumnElementId];_this.validateProductQuantity(productCollectionRowElementId,productCollectionColumnElementId,maxQuantity,name);_this.findSelectedProduct(selectedProducts,id,quantity);_this.modifySelectedProductsForAnalytics();});};_this.getMaxQuantity=function(activeProductId){var _this$props5=_this.props,accountStore=_this$props5.accountStore,configStore=_this$props5.configStore,product=_this$props5.product;var maxAccountQuantity=accountStore.account&&accountStore.account.max_product_quantity>0?accountStore.account.max_product_quantity:__WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__["a" /* DEFAULT_MAX_QUANTITY */];var maxBackorderQuantity=product.availability_type===__WEBPACK_IMPORTED_MODULE_19__types_ProductAvailabilityType__["b" /* default */].ALLOW_BACKORDER?configStore.product.backorderLimit>0?configStore.product.backorderLimit:__WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__["a" /* DEFAULT_MAX_QUANTITY */]:__WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__["a" /* DEFAULT_MAX_QUANTITY */];var maxNormalProductQuantity=product.availability_type!==__WEBPACK_IMPORTED_MODULE_19__types_ProductAvailabilityType__["b" /* default */].ALLOW_BACKORDER?product.canBeOrderedOutOfStock?__WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__["a" /* DEFAULT_MAX_QUANTITY */]:_this.getMaxByPackage(product,activeProductId):__WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__["a" /* DEFAULT_MAX_QUANTITY */];return Math.min(maxAccountQuantity,maxBackorderQuantity,maxNormalProductQuantity,__WEBPACK_IMPORTED_MODULE_18__ProductAddToCart__["a" /* DEFAULT_MAX_QUANTITY */]);};_this.getQuantity=function(qty,id,maxQuantity){var product=_this.props.product;var freeQuantity=product.getFreeQuantity(id);var cannotBeOrdered=freeQuantity<=0&&!product.canBeOrderedOutOfStock&&qty<0;var canBeOrdered=freeQuantity>0&&qty>0&&qty<=maxQuantity;var exceedsMaxQuantity=qty>=maxQuantity;var nonNegativeQuantity=qty>0&&qty;return cannotBeOrdered?0:canBeOrdered?nonNegativeQuantity:exceedsMaxQuantity?maxQuantity:nonNegativeQuantity;};_this.getMaxByPackage=function(product,activeProductId){return product.sellInPackage?Math.floor(product.getFreeQuantity(activeProductId)/product.package_size)*product.package_size:product.getFreeQuantity(activeProductId);};_this.getQuantityStep=function(){var product=_this.props.product;return product&&product.sellInPackage?product.package_size:1;};_this.findSelectedProduct=function(selectedProducts,id,qty){var selectedProduct=selectedProducts.find(function(product){return product.id===id;});if(selectedProduct){_this.updateOrRemoveSelectedProductQuantity(selectedProducts,selectedProduct,qty);}else{qty>0&&_this.addSelectedProduct(selectedProducts,id,qty);}};_this.updateOrRemoveSelectedProductQuantity=function(selectedProducts,selectedProduct,qty){var productIndex=selectedProducts.findIndex(function(product){return product.id===selectedProduct.id;});qty>0&&_this.updateSelectedProductQuantity(selectedProducts,selectedProduct,qty,productIndex);(!qty||qty===0)&&_this.removeSelectedProduct(selectedProducts,productIndex);};_this.updateSelectedProductQuantity=function(selectedProducts,selectedProduct,qty,productIndex){selectedProduct.qty=qty;selectedProducts.splice(productIndex,1,selectedProduct);_this.setState({selectedProducts:selectedProducts});};_this.removeSelectedProduct=function(selectedProducts,productIndex){selectedProducts.splice(productIndex,1);_this.setState({selectedProducts:selectedProducts});};_this.addSelectedProduct=function(selectedProducts,id,qty){selectedProducts.push({id:id,qty:qty});_this.setState({selectedProducts:selectedProducts});};_this.modifySelectedProductsForAnalytics=function(){var _this$props6=_this.props,product=_this$props6.product,accountStore=_this$props6.accountStore;var withTax=accountStore.showPricesWithTax;var analyticsProducts=_this.state.selectedProducts.map(function(selectedProduct){var analyticsProduct={};analyticsProduct.product=product;analyticsProduct.quantity=selectedProduct.qty;analyticsProduct.activeProductId=selectedProduct.id;analyticsProduct.price=product.getPrice(withTax,selectedProduct.id);return analyticsProduct;});_this.setState({analyticsProducts:analyticsProducts});};_this.openTooltip=function(inputTooltip){return _this.setState(function(){return _defineProperty({},inputTooltip,true);});};_this.hideTooltip=function(inputTooltip){return _this.setState(function(){return _defineProperty({},inputTooltip,false);});};_this.quantityError=function(productCollectionElementItem,productCollectionColumnElementId){var quantity=_this.state['qty--'+productCollectionElementItem.row_id+'--'+productCollectionColumnElementId+'--error'];var formError=quantity&&quantity.error;if(!formError){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["t" /* FormFeedback */],{className:'ProductCollectionMatrix__invalid-feedback'},formError);};_this.renderAddSelectedProductsButton=function(className){var cartStore=_this.props.cartStore;var loading=cartStore.state===__WEBPACK_IMPORTED_MODULE_23__types_RequestState__["b" /* default */].LOADING;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{className:className,onClick:_this.addSelectedProducts,color:'primary',disabled:_this.state.formError||loading,block:true},loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_Icon__["a" /* default */],{name:'circle-o-notch',spin:loading}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'productCollectionMatrix.addSelectedProducts',defaultMessage:'Add Selected Products'}));};props.product.sortProductImages('for_color_id');_this.state={selectedProducts:[],analyticsProducts:[],mainImageIndex:null,lightboxIsOpen:false,formError:false};return _this;}_createClass(ProductCollectionMatrix,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.product.id!==this.props.product.id){this.setState({selectedProducts:null,analyticsProducts:null});}}},{key:'validateProductQuantity',value:function validateProductQuantity(productCollectionRowElementId,productCollectionColumnElementId,maxQuantity,name){var quantityStep=this.getQuantityStep();var currentQuantity=this.state['qty--'+productCollectionRowElementId+'--'+productCollectionColumnElementId];if(quantityStep>1){var validQuantity=Object(__WEBPACK_IMPORTED_MODULE_20__util_formValidators__["j" /* quantityValid */])(maxQuantity,quantityStep);var validProductCount=Object(__WEBPACK_IMPORTED_MODULE_20__util_formValidators__["i" /* productCountValid */])(quantityStep);var invalidQuantity=validQuantity(currentQuantity)||validProductCount(currentQuantity);if(invalidQuantity){var _setState;var error={error:invalidQuantity};this.setState((_setState={},_defineProperty(_setState,name+'--error',error),_defineProperty(_setState,'formError',true),_setState));}if(!invalidQuantity||!currentQuantity){var _setState2;this.setState((_setState2={},_defineProperty(_setState2,name+'--error',null),_defineProperty(_setState2,'formError',false),_setState2));}}}},{key:'render',value:function render(){var _props=this.props,accountStore=_props.accountStore,uiStore=_props.uiStore;var size=accountStore.isViewOnly?12:{size:8,offset:2};var productRows=this.getCollectionRowElements();var styles={tableLayout:!uiStore.isMobile&&productRows.length>=4?'fixed':'unset'};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ProductCollectionMatrix'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__anchor_ScrollableAnchor__["a" /* default */],{id:__WEBPACK_IMPORTED_MODULE_15__ProductPageContent__["c" /* PRODUCT_INFORMATION_BANNER_ID */],scrollIfInHash:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductCollectionMatrix__info-row'},!accountStore.isViewOnly&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__bootstrap_CustomCol__["a" /* default */],{md:3,xxl:2},this.renderAddSelectedProductsButton('ProductCollectionMatrix__info-row--add-selected-products-button')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__bootstrap_CustomCol__["a" /* default */],{md:{size:accountStore.isViewOnly?12:9},xxl:size},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'ProductCollectionMatrix__product-matrix-info'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],messages.productMatrixInfo)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,this.renderProductMatrixTitles()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["R" /* Table */],{striped:true,className:'ProductCollectionMatrix__product-table',style:styles},!uiStore.isMobile&&this.renderProductElementRows(),this.renderProductColumns()))),!accountStore.isViewOnly&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'ProductCollectionMatrix__info-row-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__bootstrap_CustomCol__["a" /* default */],{md:{size:3,offset:9},xxl:{size:2,offset:10}},this.renderAddSelectedProductsButton('ProductCollectionMatrix__info-row-footer--add-selected-products-button'))),this.getImageLightbox());}}]);return ProductCollectionMatrix;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;ProductCollectionMatrix.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_AccountStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_12__analytics_Analytics__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_CartStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_UIStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]).isRequired,productMatrix:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_22__models_ProductMatrix__["a" /* default */]).isRequired,ifProductRowImages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('accountStore','configStore','analytics','cartStore','uiStore')(ProductCollectionMatrix)));

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KlarnaInstantShopping */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__KlarnaInstantShoppingModal__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_InstantShoppingCartStore__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__analytics_Analytics__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["d" /* defineMessages */])({selectProductButton:{'id':'klarnaInstantShopping.selectProduct','defaultMessage':'Select product'},orderProductsInfo:{'id':'klarnaInstantShopping.orderProductsInfo','defaultMessage':'Order these products or add other variations'},emptyInstantShoppingCart:{'id':'klarnaInstantShopping.emptyInstantShoppingCart','defaultMessage':'You haven\'t selected any products.'}});var KLARNA_SCRIPT='https://x.klarnacdn.net/instantshopping/lib/v1/lib.js';var INSTANT_SHOPPING_FLOW_CLOSED='instant_shopping_flow_closed';var KlarnaInstantShopping=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(KlarnaInstantShopping,_Component);function KlarnaInstantShopping(props){var _this2=this;_classCallCheck(this,KlarnaInstantShopping);var _this=_possibleConstructorReturn(this,(KlarnaInstantShopping.__proto__||Object.getPrototypeOf(KlarnaInstantShopping)).call(this,props));_this.loadProducts=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,merchantId,product,instantShoppingCartStore,activeProductId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,merchantId=_this$props.merchantId,product=_this$props.product,instantShoppingCartStore=_this$props.instantShoppingCartStore,activeProductId=_this$props.activeProductId;_context.next=3;return instantShoppingCartStore.getInstantShoppingCartProducts(merchantId,product,activeProductId);case 3:case'end':return _context.stop();}}},_callee,_this2);}));_this.renderOrderProductsInfoRow=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],{className:'KlarnaInstantShopping__order-products-info-row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],messages.orderProductsInfo)));};_this.renderOrderProductButtonRow=function(){var instantShoppingCartStore=_this.props.instantShoppingCartStore;var ifSelectedProducts=instantShoppingCartStore.selectedInstantShoppingProducts.length>0;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],{className:'KlarnaInstantShopping__product-buttons-row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{xs:6},_this.renderAddProductButton()),ifSelectedProducts&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{xs:6},_this.renderOrderProductButton()));};_this.renderAddProductButton=function(){var _this$props2=_this.props,instantShoppingCartStore=_this$props2.instantShoppingCartStore,disabled=_this$props2.disabled,product=_this$props2.product,activeProductId=_this$props2.activeProductId;var extendedId=activeProductId||product.id;var productState=instantShoppingCartStore.productCartStates.get(extendedId);var loading=productState===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADING;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{disabled:disabled,block:true,color:'primary',className:'KlarnaInstantShopping__select-product-button',onClick:_this.addProduct.bind(_this,product)},_this.setButtonLoadingState(messages.selectProductButton,loading));};_this.addProduct=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this$props3,product,instantShoppingCartStore,quantity,activeProductId,merchantId,instanceShoppingInstanceId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this$props3=_this.props,product=_this$props3.product,instantShoppingCartStore=_this$props3.instantShoppingCartStore,quantity=_this$props3.quantity,activeProductId=_this$props3.activeProductId;merchantId=product.merchantId;instanceShoppingInstanceId=instantShoppingCartStore.instanceShoppingInstanceId;_context2.next=5;return instantShoppingCartStore.addToInstantShoppingProductCart(product,quantity,activeProductId);case 5:_context2.t0=instanceShoppingInstanceId;if(!_context2.t0){_context2.next=9;break;}_context2.next=9;return instantShoppingCartStore.updateOrder(merchantId);case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.renderOrderProductButton=function(){var _this$props4=_this.props,instantShoppingCartStore=_this$props4.instantShoppingCartStore,product=_this$props4.product,activeProductId=_this$props4.activeProductId;var extendedId=activeProductId||product.id;var loading=instantShoppingCartStore.state===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADING;var ifError=instantShoppingCartStore.state===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].ERROR;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{id:extendedId,color:'dark',disabled:loading||ifError,block:true,className:'KlarnaInstantShopping__klarna-express-checkout-button',onClick:_this.openOrderProductModal.bind(_this)},_this.setButtonLoadingState(__WEBPACK_IMPORTED_MODULE_17__i18n_globalTranslations__["a" /* default */].klarnaExpressCheckout,loading));};_this.sendAnalyticsCheckoutEvent=function(){var _this$props5=_this.props,analytics=_this$props5.analytics,configStore=_this$props5.configStore,instantShoppingCartStore=_this$props5.instantShoppingCartStore;if(!configStore.gtm.enabled){return;}var cartProducts=instantShoppingCartStore.getAnalyticsProductCartProducts();var actionField={step:1,option:'Move To Checkout'};analytics.checkout(cartProducts,actionField);};_this.openOrderProductModal=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var instantShoppingCartStore,instanceShoppingInstanceId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:instantShoppingCartStore=_this.props.instantShoppingCartStore;instanceShoppingInstanceId=instantShoppingCartStore.instanceShoppingInstanceId;instantShoppingCartStore.resetShippingOptions();instanceShoppingInstanceId&&instantShoppingCartStore.updateOrder().then(function(){instantShoppingCartStore.loadShippingOptions();_this.sendAnalyticsCheckoutEvent();});!instanceShoppingInstanceId&&_this.createOrder();instantShoppingCartStore.state!==__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].ERROR&&_this.toggleModal();case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.toggleModal=function(){return _this.props.instantShoppingCartStore.toggleModal('orderModal');};_this.setButtonLoadingState=function(formattedMessage,loading){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,loading?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_Icon__["a" /* default */],{name:'circle-o-notch',spin:loading}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],formattedMessage));};_this.renderModal=function(){var _this$props6=_this.props,product=_this$props6.product,activeProductId=_this$props6.activeProductId;var _this$state=_this.state,shippingDropdownOpen=_this$state.shippingDropdownOpen,pickupDropdownOpen=_this$state.pickupDropdownOpen,selectionFieldDropdownOpen=_this$state.selectionFieldDropdownOpen;var merchantId=product.merchantId;var productId=activeProductId||product.id;var recommendedProductIds=product.recommended_with_ids.slice();var merchantInfo=product.merchantInfo;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__KlarnaInstantShoppingModal__["a" /* default */],{merchantInfo:merchantInfo,extendedId:productId,merchantId:merchantId,productRecommmendedIds:recommendedProductIds,shippingDropdownOpen:shippingDropdownOpen,pickupDropdownOpen:pickupDropdownOpen,selectionFieldDropdownOpen:selectionFieldDropdownOpen,toggleShippingDropdown:_this.toggleShippingDropdown,togglePickupDropdown:_this.togglePickupDropdown,toggleSelectionFieldDropdown:_this.toggleSelectionFieldDropdown,onProductOrder:_this.orderProducts,onOrderCancel:_this.cancelOrderProducts});};_this.orderProducts=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var instantShoppingCartStore;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:instantShoppingCartStore=_this.props.instantShoppingCartStore;instantShoppingCartStore.updateOrder().then(function(){instantShoppingCartStore.resetPickupPoint();_this.toggleModal();_this.loadKlarnaInstantShoppingInstance();}).catch(function(err){console.error(err);_this.createOrder();});case 2:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.loadKlarnaInstantShoppingInstance=function(){var instantShoppingCartStore=_this.props.instantShoppingCartStore;var instanceShoppingInstanceId=instantShoppingCartStore.instanceShoppingInstanceId;instanceShoppingInstanceId&&instantShoppingCartStore.loadKlarnaInstantShoppingInstance().then(function(){_this.registerInstantShoppingFlowEventHandler();instantShoppingCartStore.openKlarnaInstantShoppingModal();}).catch(function(err){return console.error(err);});};_this.registerInstantShoppingFlowEventHandler=function(){try{if(!_this.klarnaInstantShoppingFlowSubscription){window.Klarna.InstantShopping.on(INSTANT_SHOPPING_FLOW_CLOSED,function(data){_this.klarnaInstantShoppingFlowSubscription=data;_this.props.instantShoppingCartStore.resetPickupPoint();});}}catch(err){console.error(err);}};_this.createOrder=function(){var instantShoppingCartStore=_this.props.instantShoppingCartStore;instantShoppingCartStore.hasCart&&instantShoppingCartStore.orderProducts().then(function(){instantShoppingCartStore.loadShippingOptions();_this.sendAnalyticsCheckoutEvent();});};_this.cancelOrderProducts=function(){return _this.toggleModal();};_this.toggleShippingDropdown=function(){return _this.setState({shippingDropdownOpen:!_this.state.shippingDropdownOpen,pickupDropdownOpen:false,selectionFieldDropdownOpen:false});};_this.togglePickupDropdown=function(){return _this.setState({pickupDropdownOpen:!_this.state.pickupDropdownOpen,shippingDropdownOpen:false,selectionFieldDropdownOpen:false});};_this.toggleSelectionFieldDropdown=function(){return _this.setState({selectionFieldDropdownOpen:!_this.state.selectionFieldDropdownOpen,pickupDropdownOpen:false,shippingDropdownOpen:false});};_this.renderSelectedProducts=function(){var instantShoppingCartStore=_this.props.instantShoppingCartStore;var selectedProducts=instantShoppingCartStore&&instantShoppingCartStore.selectedInstantShoppingProducts;var loading=instantShoppingCartStore.state===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].LOADING;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,selectedProducts.map(function(product){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default()(product.id),className:'KlarnaInstantShopping__product-cart-product'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'KlarnaInstantShopping__product'},product.name,' x ',product.quantity),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'KlarnaInstantShopping__product-delete'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{color:'danger',disabled:loading,onClick:_this.removeProduct.bind(_this,product.id)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_Icon__["a" /* default */],{name:'trash'}))));}),!selectedProducts.length&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'KlarnaInstantShopping__product-cart-empty'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'KlarnaInstantShopping__product-cart-empty-message'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],messages.emptyInstantShoppingCart))));};_this.removeProduct=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(productId){var instantShoppingCartStore;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:instantShoppingCartStore=_this.props.instantShoppingCartStore;_context5.next=3;return instantShoppingCartStore.removeInstantShoppingCartProduct(productId);case 3:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x){return _ref5.apply(this,arguments);};}();_this.state={shippingDropdownOpen:false,pickupDropdownOpen:false,selectionFieldDropdownOpen:false};props.instantShoppingCartStore.setup(props.merchantId);_this.klarnaInstantShoppingFlowSubscription=null;_this.confirmationButtonClickedSubscription=null;return _this;}_createClass(KlarnaInstantShopping,[{key:'componentDidMount',value:function componentDidMount(){this.loadProducts().catch(function(err){return console.error(err);});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.activeProductId!==this.props.activeProductId){this.loadProducts().catch(function(err){return console.error(err);});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.klarnaInstantShoppingFlowSubscription&&window.Klarna.InstantShopping.off(INSTANT_SHOPPING_FLOW_CLOSED);this.props.instantShoppingCartStore.closeModal('orderModal');}},{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,product=_props.product,instantShoppingCartStore=_props.instantShoppingCartStore;var instanceShoppingInstanceId=instantShoppingCartStore.instanceShoppingInstanceId;var ifWebStore=configStore.siteConfig.isWebStore;var singleProduct=product.class===__WEBPACK_IMPORTED_MODULE_16__types_ProductClass__["b" /* default */].SINGLE;var error=instantShoppingCartStore.state===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].ERROR;if(!product&&ifWebStore){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'KlarnaInstantShopping'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('script',{async:true,src:KLARNA_SCRIPT})),!singleProduct&&this.renderOrderProductsInfoRow(),this.renderOrderProductButtonRow(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],{className:'KlarnaInstantShopping__product-cart'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{sm:12},this.renderSelectedProducts())),error&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],{className:'KlarnaInstantShopping__unexpected-error'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_loader_UnexpectedError__["a" /* default */],null))),instanceShoppingInstanceId&&this.renderModal());}}]);return KlarnaInstantShopping;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;KlarnaInstantShopping.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,instantShoppingCartStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_InstantShoppingCartStore__["a" /* default */]).isRequired,product:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Product__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_18__analytics_Analytics__["a" /* default */]).isRequired,quantity:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,activeProductId:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,merchantId:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('analytics','configStore','instantShoppingCartStore')(KlarnaInstantShopping));

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KlarnaInstantShoppingModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_InstantShoppingCartStore__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__KlarnaInstantShoppingForm__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_privacy_statement_PrivacyStatementLink__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_terms_of_use_statement_TermsOfUseStatementLink__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__KlarnaInstantShoppingShippingSelectionFieldTypes_KlarnaInstantShoppingDropdownMenu__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__types_ProductShippingClass__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__models_ProductMerchantInfo__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__types_ShippingSelectionFieldType__ = __webpack_require__(494);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["d" /* defineMessages */])({creatingOrder:{'id':'klarnaInstantShoppingModal.creatingOrder','defaultMessage':'Please wait...'},updatingOrder:{'id':'klarnaInstantShoppingModal.updatingOrder','defaultMessage':'Updating order...'},chooseShippingMethod:{'id':'klarnaInstantShoppingModal.chooseShippingMethod','defaultMessage':'Choose shipping method:'},choosePickupPoint:{'id':'klarnaInstantShoppingModal.choosePickupPoint','defaultMessage':'Choose pickup point:'},fetchingShippingOptions:{'id':'klarnaInstantShoppingModal.fetchingShippingOptions','defaultMessage':'Fetching shipping options...'},distance:{'id':'klarnaInstantShoppingModal.distance','defaultMessage':'Distance: {distance} {distanceUnit}'},openingHours:{'id':'klarnaInstantShoppingModal.openingHours','defaultMessage':'Opening hours: {openingHours}'},noPickupPoints:{'id':'klarnaInstantShoppingModal.noPickupPoints','defaultMessage':'Unfortunately, no pickup points were found. Check that the address is correct or choose another delivery method.'},shippingAndPickup:{'id':'klarnaInstantShoppingModal.shippingAndPickup','defaultMessage':'{storeName} - order'},orderProductsButton:{'id':'klarnaInstantShoppingModal.orderProductsButton','defaultMessage':'Continue to order'}});var KlarnaInstantShoppingModal=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(KlarnaInstantShoppingModal,_Component);function KlarnaInstantShoppingModal(props){var _this2=this;_classCallCheck(this,KlarnaInstantShoppingModal);var _this=_possibleConstructorReturn(this,(KlarnaInstantShoppingModal.__proto__||Object.getPrototypeOf(KlarnaInstantShoppingModal)).call(this,props));_this.updatePickupPointOptions=function(){_this.validateForm();if(_this.state.form.valid){_this.fetchingInterval=setTimeout(_this.handleInputThrottled,500);}};_this.validateForm=function(){var form=_this.state.form;var _form$getFieldValues=form.getFieldValues(),postalCode=_form$getFieldValues.postalCode,streetAddress=_form$getFieldValues.streetAddress;if(postalCode&&streetAddress){form&&form.validate();}};_this.renderShippingAndPickupDropdowns=function(){var instantShoppingCartStore=_this.props.instantShoppingCartStore;var error=instantShoppingCartStore.state===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].ERROR;var selectedShippingOption=instantShoppingCartStore.selectedShippingOption;var ifRequiresPickupPoint=selectedShippingOption&&selectedShippingOption.requires_pickup_point;var ifSelectedFields=selectedShippingOption&&selectedShippingOption.selectionFields&&selectedShippingOption.selectionFields.length>0;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{className:'KlarnaInstantShoppingModal__shipping-and-pickup-options'},error?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_loader_UnexpectedError__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,_this.renderShippingDropdown(),ifRequiresPickupPoint&&_this.renderPickUpPointForm(selectedShippingOption),ifRequiresPickupPoint&&_this.state.form&&_this.renderPickupDropdown(),ifSelectedFields&&_this.renderSelectionFields()));};_this.renderShippingDropdown=function(){var _this$props=_this.props,shippingDropdownOpen=_this$props.shippingDropdownOpen,toggleShippingDropdown=_this$props.toggleShippingDropdown,instantShoppingCartStore=_this$props.instantShoppingCartStore,uiStore=_this$props.uiStore,merchantId=_this$props.merchantId;var loading=instantShoppingCartStore.shippingOptionState.get(merchantId)===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADING;var selectedShippingOption=instantShoppingCartStore.selectedShippingOption;var shippingOptionName=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__shipping-method-dropdown-name'},instantShoppingCartStore.selectedShippingOptionName),selectedShippingOption&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_product_Price__["a" /* default */],{price:selectedShippingOption.getPrice()}),' ');return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,loading?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["z" /* Label */],{className:'KlarnaInstantShoppingModal__fetching-icon'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],messages.fetchingShippingOptions),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__fetching-shipping-options'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_Icon__["a" /* default */],{name:'circle-o-notch',spin:loading})))):selectedShippingOption&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12,className:'KlarnaInstantShoppingModal__shipping-method'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["z" /* Label */],{className:'KlarnaInstantShoppingModal__label'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],messages.chooseShippingMethod)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["o" /* Dropdown */],{isOpen:shippingDropdownOpen,toggle:toggleShippingDropdown},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["r" /* DropdownToggle */],{className:'KlarnaInstantShoppingModal__shipping-method-dropdown-toggle',caret:true},instantShoppingCartStore.selectedShippingOptionName&&shippingOptionName),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["q" /* DropdownMenu */],{className:'KlarnaInstantShoppingModal__shipping-method-dropdown-menu'},instantShoppingCartStore.shippingOptions.map(function(shippingDetailOption){return shippingDetailOption&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["p" /* DropdownItem */],{key:shippingDetailOption.id,onClick:_this.updateShippingMethod.bind(_this,shippingDetailOption)},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'KlarnaInstantShoppingModal__shipping-method-price'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__shipping-method-name'},shippingDetailOption.name),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__shipping-method-price-title'},!uiStore.isSmallest&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].priceTitle),': '),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_product_Price__["a" /* default */],{price:shippingDetailOption.getPrice()}))));})))),selectedShippingOption.description&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12,className:'KlarnaInstantShoppingModal__shipping-method-description'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:selectedShippingOption.description}}))));};_this.updateShippingMethod=function(shippingOption){var instantShoppingCartStore=_this.props.instantShoppingCartStore;instantShoppingCartStore.updateShippingOption(shippingOption);_this.resetSelectionFieldOption(shippingOption);_this.resetPickupPointOption(shippingOption);_this.populateFormIfExistingValues();_this.ifUpdatedShippingMethod=true;};_this.resetSelectionFieldOption=function(shippingOption){var instantShoppingCartStore=_this.props.instantShoppingCartStore;if(shippingOption.class===__WEBPACK_IMPORTED_MODULE_19__types_ProductShippingClass__["b" /* default */].DELIVERY&&shippingOption.requires_pickup_point){instantShoppingCartStore.updatePickupOption(instantShoppingCartStore.defaultPickupPoint);instantShoppingCartStore.updateSelectionFieldOption(null);}};_this.resetPickupPointOption=function(shippingOption){var instantShoppingCartStore=_this.props.instantShoppingCartStore;if(shippingOption.class===__WEBPACK_IMPORTED_MODULE_19__types_ProductShippingClass__["b" /* default */].PICKUP&&!shippingOption.requires_pickup_point){_this.setState({form:null});_this.setDefaultSelectedFieldOption(shippingOption);instantShoppingCartStore.updatePickupOption(null);}if(shippingOption.class===__WEBPACK_IMPORTED_MODULE_19__types_ProductShippingClass__["b" /* default */].DELIVERY&&!shippingOption.requires_pickup_point){_this.setState({form:null});_this.setDefaultSelectedFieldOption(shippingOption);instantShoppingCartStore.updatePickupOption(null);}};_this.setDefaultSelectedFieldOption=function(shippingOption){var instantShoppingCartStore=_this.props.instantShoppingCartStore;if(!shippingOption||shippingOption.selection_fields.length===0){return null;}var defaultSelectionFieldOption=shippingOption.selection_fields[0].options[0];instantShoppingCartStore.updateSelectionFieldOption(defaultSelectionFieldOption);};_this.populateFormIfExistingValues=function(){var instantShoppingCartStore=_this.props.instantShoppingCartStore;var _instantShoppingCartS=instantShoppingCartStore.instantShoppingOrderForm,postalCode=_instantShoppingCartS.postalCode,streetAddress=_instantShoppingCartS.streetAddress;if(!_this.state.form){return null;}postalCode&&_this.setPostalCodeField(postalCode);streetAddress&&_this.setStreetAddressField(streetAddress);};_this.setPostalCodeField=function(postalCode){var postalCodeField=postalCode&&_this.getFormField(__WEBPACK_IMPORTED_MODULE_14__KlarnaInstantShoppingForm__["b" /* formFieldNames */].postalCode);postalCodeField.setValue(postalCode);};_this.setStreetAddressField=function(streetAddress){var streetAddressField=streetAddress&&_this.getFormField(__WEBPACK_IMPORTED_MODULE_14__KlarnaInstantShoppingForm__["b" /* formFieldNames */].streetAddress);streetAddressField.setValue(streetAddress);};_this.renderPickUpPointForm=function(shippingOption){var _this$props2=_this.props,instantShoppingCartStore=_this$props2.instantShoppingCartStore,merchantId=_this$props2.merchantId;var loaded=instantShoppingCartStore.shippingOptionState.get(merchantId)===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADED;return loaded&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__KlarnaInstantShoppingForm__["a" /* default */],{shippingOption:shippingOption,onFormInit:_this.getForm,onChange:_this.updateFieldValue,postalCode:_this.props.instantShoppingCartStore.instantShoppingOrderForm.postalCode,streetAddress:_this.props.instantShoppingCartStore.instantShoppingOrderForm.streetAddress});};_this.getForm=function(form){return _this.setState({form:form});};_this.updateFieldValue=function(fieldValues){_this.resetTimeout();var formField=_this.getFormField(fieldValues.name);_this.setFormFieldValue(formField,fieldValues.name,fieldValues.value);_this.state.form&&_this.state.form.validateField(fieldValues.name);};_this.getFormField=function(name){return _this.state.form.fields.get(name);};_this.setFormFieldValue=function(formField,name,value){var instantShoppingCartStore=_this.props.instantShoppingCartStore;instantShoppingCartStore.updateInstantShoppingOrderForm(name,value);formField.setValue(value);};_this.fetchPickupPointOptions=function(){var instantShoppingCartStore=_this.props.instantShoppingCartStore;var shippingInfo=instantShoppingCartStore.formValues;var shippingOption=instantShoppingCartStore.selectedShippingOption;instantShoppingCartStore.loadPickupPointOptions(shippingOption).then(function(){_this.resetTimeout();_this.tempFormFieldValues=shippingInfo;_this.ifUpdatedShippingMethod=false;});};_this.renderPickupDropdown=function(){var _this$props3=_this.props,pickupDropdownOpen=_this$props3.pickupDropdownOpen,togglePickupDropdown=_this$props3.togglePickupDropdown,instantShoppingCartStore=_this$props3.instantShoppingCartStore;var shippingInfo=_this.state.form&&instantShoppingCartStore.instantShoppingOrderForm;var loadingPickUpPoints=shippingInfo&&shippingInfo.postalCode&&instantShoppingCartStore.pickupPointStates.get(shippingInfo.postalCode+','+shippingInfo.streetAddress)===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADING;var loadedPickUpPoints=shippingInfo&&shippingInfo.postalCode&&instantShoppingCartStore.pickupPointStates.get(shippingInfo.postalCode+','+shippingInfo.streetAddress)===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADED;var pickupPointOptions=shippingInfo&&shippingInfo.postalCode&&instantShoppingCartStore.pickupPointOptions.get(shippingInfo.postalCode+','+shippingInfo.streetAddress);var selectedPickupPointOption=instantShoppingCartStore.selectedPickupOption;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,loadingPickUpPoints?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["z" /* Label */],{className:'KlarnaInstantShoppingModal__fetching-icon'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'klarnaInstantShoppingModal.fetchingPickupPoints',defaultMessage:'Fetching pickup points...'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__fetching-pickup-points'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_Icon__["a" /* default */],{name:'circle-o-notch',spin:loadingPickUpPoints})))):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,selectedPickupPointOption&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12,className:'KlarnaInstantShoppingModal__pickup-point-option'},selectedPickupPointOption&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["z" /* Label */],{className:'KlarnaInstantShoppingModal__label'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],messages.choosePickupPoint)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["o" /* Dropdown */],{isOpen:pickupDropdownOpen,toggle:togglePickupDropdown},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["r" /* DropdownToggle */],{className:'KlarnaInstantShoppingModal__pickup-point-dropdown-toggle',caret:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__pickup-point-dropdown-name'},selectedPickupPointOption.name),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__pickup-point-dropdown-address'},_this.trimPickupPointAddress(selectedPickupPointOption.address))),pickupPointOptions&&pickupPointOptions.length>0&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["q" /* DropdownMenu */],{className:'KlarnaInstantShoppingModal__pickup-point-dropdown-menu'},pickupPointOptions.map(function(pickupPointMethodOption){return pickupPointMethodOption&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["p" /* DropdownItem */],{key:pickupPointMethodOption.unique_id,onClick:_this.updatePickupPointMethod.bind(_this,pickupPointMethodOption)},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'KlarnaInstantShoppingModal__pickup-point'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__pickup-point-name'},pickupPointMethodOption.name),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__pickup-point-address'},pickupPointMethodOption.address)));}))),selectedPickupPointOption&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'KlarnaInstantShoppingModal__pickup-point-external-info'},selectedPickupPointOption.distance&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'KlarnaInstantShoppingModal__pickup-point-external-info-distance'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.distance,{values:{distance:selectedPickupPointOption.distance.toString().replace('.',','),distanceUnit:'km'}}))),selectedPickupPointOption.opening_hours&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'KlarnaInstantShoppingModal__pickup-point-external-info-opening-hours'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.openingHours,{values:{openingHours:selectedPickupPointOption.opening_hours}})))))),loadedPickUpPoints&&(!pickupPointOptions||pickupPointOptions.length===0)&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12,className:'KlarnaInstantShoppingModal__no-pickup-points'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],messages.noPickupPoints))));};_this.trimPickupPointAddress=function(pickupPointAddress){return pickupPointAddress&&pickupPointAddress.replace(',','').trim();};_this.updatePickupPointMethod=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(pickupPointOption){var instantShoppingCartStore;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:instantShoppingCartStore=_this.props.instantShoppingCartStore;_context.next=3;return instantShoppingCartStore.updatePickupOption(pickupPointOption);case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.renderSelectionFields=function(){var _this$props4=_this.props,instantShoppingCartStore=_this$props4.instantShoppingCartStore,selectionFieldDropdownOpen=_this$props4.selectionFieldDropdownOpen,toggleSelectionFieldDropdown=_this$props4.toggleSelectionFieldDropdown;var selectionFields=instantShoppingCartStore.selectedShippingOption.selectionFields;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12},selectionFields&&selectionFields.length>0&&selectionFields.map(function(selectionField){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],{key:selectionField.id},_this.ifDropdownMenu(selectionField)&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__KlarnaInstantShoppingShippingSelectionFieldTypes_KlarnaInstantShoppingDropdownMenu__["a" /* default */],{selectionField:selectionField,selectionFieldDropdownOpen:selectionFieldDropdownOpen,toggleSelectionFieldDropdown:toggleSelectionFieldDropdown,onUpdateSelectionFieldOption:_this.updateSelectionFieldOption}));}));};_this.ifDropdownMenu=function(selectionField){return selectionField.type===__WEBPACK_IMPORTED_MODULE_25__types_ShippingSelectionFieldType__["b" /* default */].DROPDOWN_MENU;};_this.updateSelectionFieldOption=function(selectionFieldOption){var instantShoppingCartStore=_this.props.instantShoppingCartStore;instantShoppingCartStore.updateSelectionFieldOption(selectionFieldOption);};_this.renderAcceptableTerms=function(){var _this$props5=_this.props,configStore=_this$props5.configStore,merchantInfo=_this$props5.merchantInfo;var storeName=configStore.store.name;var merchantName=merchantInfo.site_name;var deliveryAndPaymentTerms=merchantInfo.deliveryTerms.link;var merchantPrivacyStatement=merchantInfo.privacyStatement.link;return deliveryAndPaymentTerms&&merchantPrivacyStatement&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{className:'KlarnaInstantShoppingModal__footer-info-page-links'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].shoppingCenterAcceptableTerms,{values:{continuePurchase:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__continue-purchase'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],messages.orderProductsButton)),storeName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__store-name'},storeName),termsOfUse:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_terms_of_use_statement_TermsOfUseStatementLink__["a" /* default */],null),privacyStatement:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_privacy_statement_PrivacyStatementLink__["a" /* default */],null),merchantName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'KlarnaInstantShoppingModal__merchant-name'},merchantName),deliveryAndPaymentTerms:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:deliveryAndPaymentTerms,target:'_blank',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].shoppingCenterDeliveryAndPaymentTerms)),merchantPrivacyStatement:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:merchantPrivacyStatement,target:'_blank',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].shoppingCenterPrivacyStatement))}}))));};_this.renderCancelButton=function(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'secondary',onClick:_this.cancelOrder.bind(_this),className:'KlarnaInstantShoppingModal__cancel-button',block:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].cancelTitle));};_this.cancelOrder=function(){var _this$props6=_this.props,instantShoppingCartStore=_this$props6.instantShoppingCartStore,onOrderCancel=_this$props6.onOrderCancel;instantShoppingCartStore.resetPickupPoint();_this.ifUpdatedShippingMethod=false;_this.tempFormFieldValues=null;_this.resetTimeout();onOrderCancel&&onOrderCancel();};_this.renderContinueButton=function(){var _this$props7=_this.props,instantShoppingCartStore=_this$props7.instantShoppingCartStore,merchantId=_this$props7.merchantId;var selectedShippingOption=instantShoppingCartStore.selectedShippingOption;var selectedPickupOption=instantShoppingCartStore.selectedPickupOption;var ifRequiresPickupPoint=selectedShippingOption&&selectedShippingOption.requires_pickup_point&&!selectedPickupOption;var shippingInfo=_this.state.form&&instantShoppingCartStore.instantShoppingOrderForm;var loadingShippingMethods=instantShoppingCartStore.shippingOptionState.get(merchantId)===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADING;var loadingPickupPoints=shippingInfo&&shippingInfo.postalCode&&instantShoppingCartStore.pickupPointStates.get(shippingInfo.postalCode+','+shippingInfo.streetAddress)===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADING;var loading=instantShoppingCartStore.state===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADING;var ifInvalidPickupPointSelection=ifRequiresPickupPoint&&_this.state.form&&!_this.state.form.valid;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'dark',className:'KlarnaInstantShoppingModal__order-products-button',disabled:loading||loadingShippingMethods||loadingPickupPoints||ifRequiresPickupPoint||ifInvalidPickupPointSelection,onClick:_this.orderProduct,block:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],messages.orderProductsButton));};_this.orderProduct=function(){var onProductOrder=_this.props.onProductOrder;_this.ifUpdatedShippingMethod=false;_this.tempFormFieldValues=null;_this.resetTimeout();onProductOrder&&onProductOrder();};_this.resetTimeout=function(){_this.handleInputThrottled&&_this.handleInputThrottled.cancel();_this.fetchingInterval&&clearTimeout(_this.fetchingInterval);_this.fetchingInterval=null;};_this.renderOrderStateMessage=function(){var instantShoppingCartStore=_this.props.instantShoppingCartStore;var instantShoppingInstanceId=instantShoppingCartStore.instanceShoppingInstanceId;return instantShoppingInstanceId?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],messages.updatingOrder):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],messages.creatingOrder);};_this.state={form:null};_this.handleInputThrottled=__WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(_this.fetchPickupPointOptions,350);_this.fetchingInterval=null;_this.tempFormFieldValues=null;_this.ifUpdatedShippingMethod=false;return _this;}_createClass(KlarnaInstantShoppingModal,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_24__util_dom__["b" /* blockScroll */])();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,instantShoppingCartStore=_props.instantShoppingCartStore,shippingDropdownOpen=_props.shippingDropdownOpen,pickupDropdownOpen=_props.pickupDropdownOpen;var instantShoppingInstanceId=instantShoppingCartStore.instanceShoppingInstanceId;var ifLoaded=instantShoppingCartStore.state===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADED;var formValues=instantShoppingCartStore&&instantShoppingCartStore.formValues;var orderModalIsOpen=instantShoppingCartStore.isOpen.orderModal;if(!orderModalIsOpen){Object(__WEBPACK_IMPORTED_MODULE_24__util_dom__["a" /* allowScroll */])();}if(instantShoppingInstanceId&&orderModalIsOpen&&this.state.form&&ifLoaded&&!shippingDropdownOpen&&!pickupDropdownOpen&&!!formValues.postalCode&&!!formValues.streetAddress&&(!__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(formValues,this.tempFormFieldValues)||this.ifUpdatedShippingMethod)){this.populateFormIfExistingValues();this.updatePickupPointOptions();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_24__util_dom__["a" /* allowScroll */])();}},{key:'render',value:function render(){var _props2=this.props,merchantInfo=_props2.merchantInfo,onOrderCancel=_props2.onOrderCancel,instantShoppingCartStore=_props2.instantShoppingCartStore;var loading=instantShoppingCartStore.state===__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADING;var storeName=merchantInfo.site_name;var orderModalIsOpen=instantShoppingCartStore.isOpen.orderModal;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["C" /* Modal */],{isOpen:orderModalIsOpen,toggle:onOrderCancel,className:'KlarnaInstantShoppingModal',contentClassName:'KlarnaInstantShoppingModal__content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["F" /* ModalHeader */],{className:'KlarnaInstantShoppingModal__header',toggle:onOrderCancel},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.shippingAndPickup,{values:{storeName:storeName}}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["D" /* ModalBody */],{className:'KlarnaInstantShoppingModal__shipping-and-pickup-dropdowns'},loading?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["z" /* Label */],{className:'KlarnaInstantShoppingModal__order-status-text'},this.renderOrderStateMessage(),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_Icon__["a" /* default */],{name:'circle-o-notch',spin:loading}))):this.renderShippingAndPickupDropdowns()),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["E" /* ModalFooter */],{className:'KlarnaInstantShoppingModal__footer'},this.renderAcceptableTerms(),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:6},this.renderCancelButton()),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:6},this.renderContinueButton()))));}}]);return KlarnaInstantShoppingModal;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]))||_class;KlarnaInstantShoppingModal.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_ConfigStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_CurrencyStore__["a" /* default */]).isRequired,instantShoppingCartStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_InstantShoppingCartStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_UIStore__["a" /* default */]).isRequired,merchantInfo:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_22__models_ProductMerchantInfo__["a" /* default */]).isRequired,merchantId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,productRecommmendedIds:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string),shippingDropdownOpen:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,pickupDropdownOpen:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,toggleShippingDropdown:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,togglePickupDropdown:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onProductOrder:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onOrderCancel:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["c" /* inject */])('configStore','currencyStore','instantShoppingCartStore','uiStore')(KlarnaInstantShoppingModal));

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var InstantShoppingCartProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('InstantShoppingCartProduct',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,merchant_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,sku:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string}),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,reference:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (InstantShoppingCartProduct);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var InstantShoppingPickupOption=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('InstantShoppingPickupOption',{address:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),distance:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),external_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({key:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)})),[]),location_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),opening_hours:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),unique_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier)});/* harmony default export */ __webpack_exports__["a"] = (InstantShoppingPickupOption);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InstantShoppingOrder__ = __webpack_require__(1113);
var InstantShoppingInstance=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('InstantShoppingInstance',{instant_shopping_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,integrationInfo:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({environment:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),integration_type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),region:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),use_on_product_listings:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean),use_on_product_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean)})),order:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__InstantShoppingOrder__["a" /* default */]),success:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean)}).views(function(self){return{get paymentModuleId(){return self.order&&self.order.payment_module_id;}};});/* harmony default export */ __webpack_exports__["a"] = (InstantShoppingInstance);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_AcceptableTermsType__ = __webpack_require__(499);
var InstantShoppingOrder=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('InstantShoppingOrder',{acceptable_terms:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({link:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__types_AcceptableTermsType__["a" /* AcceptableTermsTypeType */])})),[]),country:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),currency:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),id_for_analytics:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),language:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),payment_module_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),pickup_point_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model({name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)})),[]),shipping_module_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});/* harmony default export */ __webpack_exports__["a"] = (InstantShoppingOrder);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formFieldNames; });
/* unused harmony export KlarnaInstantShoppingForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_FormValidator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_ShippingOption__ = __webpack_require__(190);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var formFieldNames={postalCode:'postalCode',streetAddress:'streetAddress'};var labels={postalCode:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].zipCodeTitle),streetAddress:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].streetAddressTitle)};var KlarnaInstantShoppingForm=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(KlarnaInstantShoppingForm,_Component);function KlarnaInstantShoppingForm(props){_classCallCheck(this,KlarnaInstantShoppingForm);var _this=_possibleConstructorReturn(this,(KlarnaInstantShoppingForm.__proto__||Object.getPrototypeOf(KlarnaInstantShoppingForm)).call(this,props));_this.handleChange=function(event){var target=event.target;var value=target.value;var name=target.name;_this.props.onChange&&_this.props.onChange({form:_this.form,name:name,value:value});};_this.getFieldError=function(field){return field&&field.errors[0];};_this.renderFieldError=function(field,labelFor,label,labelProp){var error=field&&field.errors[0];return error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()('KlarnaInstantShoppingForm__error-row',{'invalid-field-background':error})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_Icon__["a" /* default */],{className:'KlarnaInstantShoppingForm__error-icon',name:'exclamation-circle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_form_FieldError__["a" /* default */],{field:field})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["z" /* Label */],{className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()('KlarnaInstantShoppingForm__label',{active:labelProp}),'for':labelFor},label);};var formValidator=props.formValidator;_this.form=Object(__WEBPACK_IMPORTED_MODULE_5__models_Form__["a" /* createForm */])({postalCode:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},formValidator.postalCode(labels.postalCode)),streetAddress:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},formValidator.streetAddress(labels.streetAddress))});return _this;}_createClass(KlarnaInstantShoppingForm,[{key:'componentDidMount',value:function componentDidMount(){this.props.onFormInit&&this.props.onFormInit(this.form);}},{key:'render',value:function render(){var _props=this.props,postalCode=_props.postalCode,streetAddress=_props.streetAddress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["z" /* Label */],{className:'KlarnaInstantShoppingForm__form-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'klarnaInstantShoppingForm.fillPickupPointInformation',defaultMessage:'Write your address'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["s" /* Form */],{className:'KlarnaInstantShoppingForm',noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()('KlarnaInstantShoppingForm__postalCode-input',{'invalid-field-input-background':this.getFieldError(this.form.fields.get(formFieldNames.postalCode)),'invalid-field-border':this.getFieldError(this.form.fields.get(formFieldNames.postalCode))})},this.renderFieldError(this.form.fields.get(formFieldNames.postalCode),formFieldNames.postalCode,labels.postalCode,postalCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_form_Field__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Input */],field:this.form.fields.get(formFieldNames.postalCode),type:'text',name:formFieldNames.postalCode,id:formFieldNames.postalCode,onChange:this.handleChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()('KlarnaInstantShoppingForm__streetAddress-input',{'invalid-field-input-background':this.getFieldError(this.form.fields.get(formFieldNames.streetAddress)),'invalid-field-border':this.getFieldError(this.form.fields.get(formFieldNames.streetAddress))})},this.renderFieldError(this.form.fields.get(formFieldNames.streetAddress),formFieldNames.streetAddress,labels.streetAddress,streetAddress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_form_Field__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Input */],field:this.form.fields.get(formFieldNames.streetAddress),type:'text',name:formFieldNames.streetAddress,id:formFieldNames.streetAddress,onChange:this.handleChange}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'KlarnaInstantShoppingForm__address-acknowledgement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'klarnaInstantShoppingForm.addressAcknowledgement',defaultMessage:'Given address must correspond with the shipping address given in the next step'}))));}}]);return KlarnaInstantShoppingForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;KlarnaInstantShoppingForm.propTypes={formValidator:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_FormValidator__["a" /* default */]).isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onFormInit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired,shippingOption:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__models_ShippingOption__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('formValidator')(KlarnaInstantShoppingForm)));

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TermsOfUseStatementLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_page_InfoPageModal__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ButtonLink__ = __webpack_require__(70);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TermsOfUseStatementLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(TermsOfUseStatementLink,_Component);function TermsOfUseStatementLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TermsOfUseStatementLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TermsOfUseStatementLink.__proto__||Object.getPrototypeOf(TermsOfUseStatementLink)).call.apply(_ref,[this].concat(args))),_this),_this.state={show:false},_this.toggle=function(){_this.setState({show:!_this.state.show});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TermsOfUseStatementLink,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,children||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'termsOfUseStatement.termsOfUse',defaultMessage:'{termsOfUse}',values:{termsOfUse:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_ButtonLink__["a" /* default */],{className:'TermsOfUseStatementLink',onClick:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'termsOfUseStatement.termsOfUseLink',defaultMessage:'terms of use'}))}}),this.state.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__info_page_InfoPageModal__["a" /* default */],{isOpen:this.state.show,toggle:this.toggle,pageId:configStore.termsOfUseStatement.infoPageId}));}}]);return TermsOfUseStatementLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;TermsOfUseStatementLink.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(TermsOfUseStatementLink));

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KlarnaInstantShoppingDropdownMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_InstantShoppingCartStore__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ShippingOptionSelectionField__ = __webpack_require__(327);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KlarnaInstantShoppingDropdownMenu=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(KlarnaInstantShoppingDropdownMenu,_Component);function KlarnaInstantShoppingDropdownMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,KlarnaInstantShoppingDropdownMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=KlarnaInstantShoppingDropdownMenu.__proto__||Object.getPrototypeOf(KlarnaInstantShoppingDropdownMenu)).call.apply(_ref,[this].concat(args))),_this),_this.updateSelectionFieldOption=function(option){var onUpdateSelectionFieldOption=_this.props.onUpdateSelectionFieldOption;onUpdateSelectionFieldOption&&onUpdateSelectionFieldOption(option);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(KlarnaInstantShoppingDropdownMenu,[{key:'render',value:function render(){var _this2=this;var _props=this.props,instantShoppingCartStore=_props.instantShoppingCartStore,selectionFieldDropdownOpen=_props.selectionFieldDropdownOpen,toggleSelectionFieldDropdown=_props.toggleSelectionFieldDropdown,selectionField=_props.selectionField;var selectedSelectionFieldOption=instantShoppingCartStore.selectedSelectionFieldOption;if(!selectedSelectionFieldOption){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["z" /* Label */],{className:'KlarnaInstantShoppingModal__selection-field-label'},selectionField.text,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["o" /* Dropdown */],{isOpen:selectionFieldDropdownOpen,toggle:toggleSelectionFieldDropdown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* DropdownToggle */],{className:'KlarnaInstantShoppingModal__selection-field-dropdown-toggle',caret:true},selectedSelectionFieldOption.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["q" /* DropdownMenu */],{className:'KlarnaInstantShoppingModal__selection-field-options-dropdown-menu'},selectionField.options.map(function(option){return option&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* DropdownItem */],{key:option.id,onClick:_this2.updateSelectionFieldOption.bind(_this2,option)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'KlarnaInstantShoppingModal__selection-field-option'},option.name));})))));}}]);return KlarnaInstantShoppingDropdownMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;KlarnaInstantShoppingDropdownMenu.propTypes={instantShoppingCartStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_InstantShoppingCartStore__["a" /* default */]).isRequired,selectionField:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_ShippingOptionSelectionField__["a" /* default */]).isRequired,selectionFieldDropdownOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,toggleSelectionFieldDropdown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUpdateSelectionFieldOption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('instantShoppingCartStore')(KlarnaInstantShoppingDropdownMenu));

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InfoPageLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_InfoPageStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoPageLink=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(InfoPageLink,_Component);function InfoPageLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPageLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPageLink.__proto__||Object.getPrototypeOf(InfoPageLink)).call.apply(_ref,[this].concat(args))),_this),_this.getInfoPage=function(){var _this$props=_this.props,infoPageStore=_this$props.infoPageStore,pageId=_this$props.pageId;return infoPageStore.pages.get(pageId);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPageLink,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,infoPageStore=_props.infoPageStore,pageId=_props.pageId;if(!pageId){return null;}var infoPage=this.getInfoPage();if(!infoPage||infoPage.content===null){infoPageStore.loadPage(pageId).catch(function(e){console.error(e);});}}},{key:'render',value:function render(){var _props2=this.props,linkText=_props2.linkText,routeService=_props2.routeService,className=_props2.className,navLinkClassName=_props2.navLinkClassName;var infoPage=this.getInfoPage();if(!infoPage){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('InfoPageLink',className)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["I" /* NavLink */],{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('InfoPageLink__nav-link',navLinkClassName),href:routeService.getPath(infoPage.path),target:'_blank',rel:'noopener'},linkText||infoPage.name));}}]);return InfoPageLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;InfoPageLink.propTypes={infoPageStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_InfoPageStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5__services_RouteService__["a" /* default */]).isRequired,pageId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,navLinkClassName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,linkText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('infoPageStore','routeService')(InfoPageLink));

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Swogo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Swogo=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Swogo,_Component);function Swogo(){_classCallCheck(this,Swogo);return _possibleConstructorReturn(this,(Swogo.__proto__||Object.getPrototypeOf(Swogo)).apply(this,arguments));}_createClass(Swogo,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'Swogo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'swogo-bundle-1',className:'swogo-box'})));}}]);return Swogo;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (Swogo);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export YotpoMainWidget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YotpoMainWidget=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(YotpoMainWidget,_Component);function YotpoMainWidget(){_classCallCheck(this,YotpoMainWidget);return _possibleConstructorReturn(this,(YotpoMainWidget.__proto__||Object.getPrototypeOf(YotpoMainWidget)).apply(this,arguments));}_createClass(YotpoMainWidget,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.refresher){this.props.refresher();}}},{key:'render',value:function render(){var _props=this.props,currency=_props.currency,productImage=_props.productImage,productPrice=_props.productPrice,productId=_props.productId,productName=_props.productName,productPath=_props.productPath,className=_props.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:productId,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(className)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'yotpo yotpo-main-widget','data-product-id':productId,'data-price':productPrice,'data-currency':currency,'data-name':productName,'data-url':productPath,'data-image-url':productImage}));}}]);return YotpoMainWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;YotpoMainWidget.propTypes={currency:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,productImage:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_ProductImage__["a" /* default */]).isRequired,productPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,productId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,productName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,productPath:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,refresher:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (YotpoMainWidget);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SidebarNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CategoryList__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TopLevelNavigationList__ = __webpack_require__(1122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SidebarNavigation=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SidebarNavigation,_Component);function SidebarNavigation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SidebarNavigation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SidebarNavigation.__proto__||Object.getPrototypeOf(SidebarNavigation)).call.apply(_ref,[this].concat(args))),_this),_this.getActiveCategories=function(){var categoryStore=_this.props.categoryStore;return categoryStore.activeCategory?categoryStore.activeCategory.hierarchy:[];},_this.getCategories=function(){var _this$props=_this.props,categoryStore=_this$props.categoryStore,sectionStore=_this$props.sectionStore;if(sectionStore.activeSection){return sectionStore.activeSection.mainCategories;}else if(categoryStore.activeCategory){return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(categoryStore.activeCategory,'hierarchy[0].children',[]);}return categoryStore.categories;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SidebarNavigation,[{key:'render',value:function render(){var configStore=this.props.configStore;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SidebarNavigation'},configStore.mainNavigation.useSidebar?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TopLevelNavigationList__["a" /* default */],{activeCategories:this.getActiveCategories()}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CategoryList__["a" /* default */],{activeCategories:this.getActiveCategories(),categories:this.getCategories()}));}}]);return SidebarNavigation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;SidebarNavigation.propTypes={categoryStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_CategoryStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_SectionStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('categoryStore','sectionStore','configStore')(SidebarNavigation));

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CategoryList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryBadges__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_NavigationTree__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_CustomNavigationLinkStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_Category__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_url__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CategoryList,_Component);function CategoryList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CategoryList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CategoryList.__proto__||Object.getPrototypeOf(CategoryList)).call.apply(_ref,[this].concat(args))),_this),_this.convertCategoriesToNavigationEntities=function(categories,activeCategories){var sectionStore=_this.props.sectionStore;if(!categories){return[];}return categories.map(function(category){return _this.getCategoryListItem(category,activeCategories,sectionStore);});},_this.getCategoryListItem=function(category,activeCategories,sectionStore){return{id:category.id,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CategoryBadges__["a" /* default */],{category:category}),category.navigationName),active:activeCategories.indexOf(category)!==-1,path:_this.getCategoryListPath(category),children:_this.convertCategoriesToNavigationEntities(sectionStore.activeSection?category.getNonBlockedChildren(sectionStore.activeSection.blockedCategoriesDict):category.children,activeCategories),type:category.link_type,customNavLinks:_this.getCustomNavigationLinks(category)};},_this.getCategoryListPath=function(category){var _this$props=_this.props,routeService=_this$props.routeService,sectionStore=_this$props.sectionStore;if(category.link_type===__WEBPACK_IMPORTED_MODULE_14__types_LinkType__["b" /* default */].EXTERNAL_LINK){return category.path;}if(category.link_type===__WEBPACK_IMPORTED_MODULE_14__types_LinkType__["b" /* default */].INTERNAL_LINK){return routeService.getPath(category.path);}return routeService.getPath(category.path,sectionStore.activeSection);},_this.getCustomNavigationLinks=function(category){var customNavigationLinkStore=_this.props.customNavigationLinkStore;return _this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.filterByCategoryId(category.id));},_this.convertCustomNavigationLinksToEntityItems=function(customNavLinks){var customNavigationLinkStore=_this.props.customNavigationLinkStore;return customNavLinks.map(function(customNavLink){return{id:customNavLink.id,label:customNavLink.name,path:_this.getCustomCategoryListPath(customNavLink),link_type:customNavLink.link_type,location:customNavLink.location,parent_sibling_id:customNavLink.parent_sibling_id,customNavLinks:_this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.findChildLinks(customNavLink.id))};});},_this.getCustomCategoryListPath=function(customNavLink){var _this$props2=_this.props,routeService=_this$props2.routeService,sectionStore=_this$props2.sectionStore;if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_14__types_LinkType__["b" /* default */].EXTERNAL_LINK){return customNavLink.link;}if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_14__types_LinkType__["b" /* default */].INTERNAL_LINK){return routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_15__util_url__["l" /* transformInternalLink */])(customNavLink.link));}return routeService.getPath(customNavLink.link,sectionStore.activeSection);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CategoryList,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,routeService=_props.routeService,categories=_props.categories,activeCategories=_props.activeCategories;var navItems=this.convertCategoriesToNavigationEntities(categories,activeCategories);if(configStore.sidebar.showNewProducts){navItems.push({id:'new_products',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].newProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].NewProducts,sectionStore.activeSection)});}if(configStore.sidebar.showOnSale){navItems.push({id:'on_sale',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].onSaleTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].OnSale,sectionStore.activeSection)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__navigation_NavigationTree__["a" /* default */],{items:navItems,className:'CategoryList'});}}]);return CategoryList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CategoryList.propTypes={categories:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__models_Category__["a" /* default */])).isRequired,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__models_Category__["a" /* default */])).isRequired]),activeCategories:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_SectionStore__["a" /* default */]).isRequired,customNavigationLinkStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_CustomNavigationLinkStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_12__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','sectionStore','routeService','customNavigationLinkStore')(CategoryList));

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TopLevelNavigationList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryBadges__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_NavigationTree__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_CustomNavigationLinkStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_CustomNavigationLinkParentType__ = __webpack_require__(182);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TopLevelNavigationList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(TopLevelNavigationList,_Component);function TopLevelNavigationList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TopLevelNavigationList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TopLevelNavigationList.__proto__||Object.getPrototypeOf(TopLevelNavigationList)).call.apply(_ref,[this].concat(args))),_this),_this.convertCategoriesToNavigationEntities=function(categories,activeCategories,section){var routeService=_this.props.routeService;if(!categories||categories.length===0){return[];}return categories.filter(function(category){return!!category;}).map(function(category){return{id:category.id,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CategoryBadges__["a" /* default */],{category:category}),category.navigationName),active:activeCategories.indexOf(category)!==-1,path:routeService.getPath(category.path,section),children:_this.convertCategoriesToNavigationEntities(section?category.getNonBlockedChildren(section.blockedCategoriesDict):category.children,activeCategories,section),customNavLinks:_this.getCustomNavigationLinks(category,__WEBPACK_IMPORTED_MODULE_16__types_CustomNavigationLinkParentType__["a" /* default */].CATEGORY)};});},_this.convertSectionsToNavigationEntities=function(sections,activeCategories){var _this$props=_this.props,sectionStore=_this$props.sectionStore,routeService=_this$props.routeService;return sections.map(function(section){return{id:section.id,label:section.navigationName,active:sectionStore.activeSection===section,path:routeService.getPath(section.path),children:_this.convertCategoriesToNavigationEntities(section.mainCategories,activeCategories,section),customNavLinks:_this.getCustomNavigationLinks(section,__WEBPACK_IMPORTED_MODULE_16__types_CustomNavigationLinkParentType__["a" /* default */].SECTION)};});},_this.getCustomNavigationLinks=function(categoryOrSection,type){var customNavigationLinkStore=_this.props.customNavigationLinkStore;if(type===__WEBPACK_IMPORTED_MODULE_16__types_CustomNavigationLinkParentType__["a" /* default */].CATEGORY){return _this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.filterByCategoryId(categoryOrSection.id));}if(type===__WEBPACK_IMPORTED_MODULE_16__types_CustomNavigationLinkParentType__["a" /* default */].SECTION){return _this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.filterBySectionId(categoryOrSection.id));}},_this.convertCustomNavigationLinksToEntityItems=function(customNavLinks){var customNavigationLinkStore=_this.props.customNavigationLinkStore;return customNavLinks.map(function(customNavLink){return{id:customNavLink.id,label:customNavLink.name,path:_this.getCustomCategoryListPath(customNavLink),link_type:customNavLink.link_type,location:customNavLink.location,parent_sibling_id:customNavLink.parent_sibling_id,customNavLinks:_this.convertCustomNavigationLinksToEntityItems(customNavigationLinkStore.findChildLinks(customNavLink.id))};});},_this.getCustomCategoryListPath=function(customNavLink){var _this$props2=_this.props,routeService=_this$props2.routeService,sectionStore=_this$props2.sectionStore;if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_14__types_LinkType__["b" /* default */].EXTERNAL_LINK){return customNavLink.link;}if(customNavLink.link_type===__WEBPACK_IMPORTED_MODULE_14__types_LinkType__["b" /* default */].INTERNAL_LINK){return routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_15__util_url__["l" /* transformInternalLink */])(customNavLink.link));}return routeService.getPath(customNavLink.link,sectionStore.activeSection);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TopLevelNavigationList,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,categoryStore=_props.categoryStore,routeService=_props.routeService,activeCategories=_props.activeCategories;var navItems=configStore.activateSections?this.convertSectionsToNavigationEntities(sectionStore.sections,activeCategories):this.convertCategoriesToNavigationEntities(categoryStore.categories,activeCategories,null);if(configStore.sidebar.showNewProducts){navItems.push({id:'new_products',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].newProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].NewProducts)});}if(configStore.sidebar.showOnSale){navItems.push({id:'on_sale',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].onSaleTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].OnSale)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__navigation_NavigationTree__["a" /* default */],{items:navItems,className:'TopLevelNavigationList'});}}]);return TopLevelNavigationList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;TopLevelNavigationList.propTypes={activeCategories:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_SectionStore__["a" /* default */]).isRequired,categoryStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_CategoryStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired,customNavigationLinkStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_CustomNavigationLinkStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','sectionStore','categoryStore','routeService','customNavigationLinkStore')(TopLevelNavigationList));

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CampaignCodeBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_CampaignCodeStore__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__campaign_code_CampaignCodeDiscount__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivationStatus={NONE:'NONE',SUCCESS:'SUCCESS',FAILED:'FAILED',ACTIVATING:'ACTIVATING',REMOVING:'REMOVING',UNEXPECTED_ERROR:'UNEXPECTED_ERROR'};var CampaignCodeBox=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CampaignCodeBox,_Component);function CampaignCodeBox(props){_classCallCheck(this,CampaignCodeBox);var _this=_possibleConstructorReturn(this,(CampaignCodeBox.__proto__||Object.getPrototypeOf(CampaignCodeBox)).call(this,props));_this.form=null;_this.state={activationStatus:ActivationStatus.NONE};_this.loadActiveCodes=function(){var campaignCodeStore=_this.props.campaignCodeStore;if(campaignCodeStore.state!==__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADED){campaignCodeStore.loadActiveCodes().catch(function(e){console.error(e);});}};_this.handleSet=function(e){e.preventDefault();var campaignCodeStore=_this.props.campaignCodeStore;var campaignCode=_this.form.fields.get('campaignCode').value;if(campaignCode){_this.setState({activationStatus:ActivationStatus.ACTIVATING});campaignCodeStore.setCode(campaignCode).then(function(){_this.setState({activationStatus:ActivationStatus.SUCCESS});}).catch(function(e){var status=e.response?e.response.status:500;var errorMap={404:ActivationStatus.FAILED,500:ActivationStatus.UNEXPECTED_ERROR};_this.setState({activationStatus:errorMap[status]});});_this.form.fields.get('campaignCode').setValue('');}};_this.handleUnset=function(){var campaignCodeStore=_this.props.campaignCodeStore;_this.setState({activationStatus:ActivationStatus.REMOVING});campaignCodeStore.unsetCode().then(function(){_this.setState({activationStatus:ActivationStatus.NONE});}).catch(function(e){console.error(e);});};_this.renderForm=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["s" /* Form */],{noValidate:true,onSubmit:_this.handleSet},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeBox__form-fields'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeBox__field CampaignCodeBox__field--campaignCode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_FormGroupField__["a" /* default */],{field:_this.form.fields.get('campaignCode'),fieldName:'campaignCode',formName:'CampaignCodeBox',label:'',hideLabel:true,placeholder:_this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].campaignBoxTitle)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:'CampaignCodeBox__submit',color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.activateCode',defaultMessage:'Activate'}))));};_this.renderActivatedView=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeBox__activated-view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Icon__["a" /* default */],{name:'check',className:'CampaignCodeBox__icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.isActivated',defaultMessage:'The campaign code is activated!'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__campaign_code_CampaignCodeDiscount__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeBox__remove-code'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_ButtonLink__["a" /* default */],{className:'RemoveCampaignCodeLink',onClick:_this.handleUnset},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.removeCouponCode',defaultMessage:'Remove code'}))));};_this.renderFormView=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeBox__form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.haveYouReceived',defaultMessage:'Have you received a campaign or discount code?'}),_this.renderForm());};_this.renderMessage=function(){var activationStatus=_this.state.activationStatus;var message=void 0;switch(activationStatus){case ActivationStatus.SUCCESS:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.setSuccess',defaultMessage:'The campaign code was activated successfully!'}));break;case ActivationStatus.FAILED:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.setError',defaultMessage:'The entered campaign code was not found.'}));break;case ActivationStatus.ACTIVATING:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Alert */],{color:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.activationInProgress',defaultMessage:'Activating code...'}));break;case ActivationStatus.REMOVING:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Alert */],{color:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.removalInProgress',defaultMessage:'Removing code...'}));break;case ActivationStatus.UNEXPECTED_ERROR:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__loader_UnexpectedError__["a" /* default */],null);break;case ActivationStatus.NONE:default:break;}return message;};var fields={campaignCode:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({})};_this.form=Object(__WEBPACK_IMPORTED_MODULE_8__models_Form__["a" /* createForm */])(fields);return _this;}_createClass(CampaignCodeBox,[{key:'componentDidMount',value:function componentDidMount(){this.loadActiveCodes();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,accountStore=_props.accountStore,title=_props.title,campaignCodeStore=_props.campaignCodeStore;var ifProductCatalog=accountStore.isViewOnly;if(ifProductCatalog){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["j" /* CardHeader */],null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_ContentForState__["a" /* default */],{state:campaignCodeStore.state,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* CardBody */],null,_this2.renderMessage(),campaignCodeStore.activeCodes.length===0?_this2.renderFormView():_this2.renderActivatedView()));}}));}}]);return CampaignCodeBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CampaignCodeBox.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_AccountStore__["a" /* default */]).isRequired,campaignCodeStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_CampaignCodeStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,title:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','campaignCodeStore')(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(CampaignCodeBox)));

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_CouponDiscountType__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_CampaignCodeType__ = __webpack_require__(1125);
var Discount=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Discount',{allow_sale_products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,amount:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),limited_to_categories:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)),limited_to_manufacturers:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)),limited_to_products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)),percentage:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),type:__WEBPACK_IMPORTED_MODULE_1__types_CouponDiscountType__["a" /* CouponDiscountTypeType */]});var CampaignCode=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CampaignCode',{code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,discounts:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(Discount),[]),type:__WEBPACK_IMPORTED_MODULE_2__types_CampaignCodeType__["a" /* CampaignCodeTypeType */]});/* harmony default export */ __webpack_exports__["a"] = (CampaignCode);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CampaignCodeTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CampaignCodeType={NOT_IN_USE:'NOT_IN_USE',PRODUCT:'PRODUCT',CUSTOMER_GROUP:'CUSTOMER_GROUP',COUPON:'COUPON',GIFT_VOUCHER:'GIFT_VOUCHER'};/* unused harmony default export */ var _unused_webpack_default_export = (CampaignCodeType);var CampaignCodeTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CampaignCodeType',Object.values(CampaignCodeType));

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CampaignCodeDiscount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_CampaignCodeStore__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_CampaignCodeDiscountType__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ManufacturerStore__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__manufacturer_ManufacturerLink__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CampaignCodeProducts__ = __webpack_require__(1128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignCodeDiscount=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CampaignCodeDiscount,_Component);function CampaignCodeDiscount(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CampaignCodeDiscount);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CampaignCodeDiscount.__proto__||Object.getPrototypeOf(CampaignCodeDiscount)).call.apply(_ref,[this].concat(args))),_this),_this.getCategoryLimitDescription=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.categoryLimitation',defaultMessage:'Using this discount coupon, you will receive a discount for products belonging to the following product categories:'}));},_this.getManufacturerLimitDescription=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.manufacturerLimitation',defaultMessage:'Using this discount coupon, you will receive a discount for products from the following brands:'}));},_this.getTypeDescription=function(discount){var currencyStore=_this.props.currencyStore;var typeDescription=null;switch(discount.type){case __WEBPACK_IMPORTED_MODULE_8__types_CampaignCodeDiscountType__["a" /* default */].AMOUNT:if(discount.amount){typeDescription=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'global.discountAmountSentence',defaultMessage:'Discount: {discount}',values:{discount:Object(__WEBPACK_IMPORTED_MODULE_13__util_number__["d" /* formatPrice */])(discount.amount,currencyStore.activeCurrency)}});}break;case __WEBPACK_IMPORTED_MODULE_8__types_CampaignCodeDiscountType__["a" /* default */].PERCENTAGE:if(discount.percentage){typeDescription=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'global.discountPercentageSentence',defaultMessage:'Discount: {discount} %',values:{discount:discount.percentage}});}break;case __WEBPACK_IMPORTED_MODULE_8__types_CampaignCodeDiscountType__["a" /* default */].FREE_SHIPPING:typeDescription=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].freeDeliverySentence);break;default:break;}return typeDescription?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__type'},typeDescription):null;},_this.getLimitedToProducts=function(discount){if(!discount.limited_to_products){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__CampaignCodeProducts__["a" /* default */],{productIds:discount.limited_to_products.slice()});},_this.getLimitedToCategories=function(discount){var _this$props=_this.props,categoryStore=_this$props.categoryStore,routeService=_this$props.routeService;if(!discount.limited_to_categories){return null;}var categoryItems=discount.limited_to_categories.map(function(limitation){var category=categoryStore.findCategoryById(limitation);if(!category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'limitation-'+limitation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.categoryNotFound',defaultMessage:'Given category {category} not found',values:{category:limitation}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:category.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'CategoryLink',to:routeService.getPath(category.path)},category.name));});return categoryItems&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__category'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__category-desription'},_this.getCategoryLimitDescription()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__category-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,categoryItems)));},_this.getLimitedToManufacturers=function(discount){var manufacturerStore=_this.props.manufacturerStore;if(!discount.limited_to_manufacturers){return null;}var manufacturerItems=discount.limited_to_manufacturers.map(function(manufacturerId){var manufacturer=manufacturerStore.manufacturers.get(manufacturerId);return manufacturer&&manufacturer.has_products&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:manufacturer.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer}));});return manufacturerItems&&manufacturerItems.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__manufacturer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__manufacturer-desription'},_this.getManufacturerLimitDescription()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount__manufacturer-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,manufacturerItems))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'campaign.manufacturerMultiLimitation',defaultMessage:'Allowed for limited manufacturers'});},_this.renderDiscounts=function(){var campaignCodeStore=_this.props.campaignCodeStore;if(campaignCodeStore.activeCodes.length>0){var activeCode=campaignCodeStore.activeCodes[0];var discounts=activeCode.discounts.map(function(discount){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:activeCode.code,className:'CampaignCodeDiscount__campaign-code'},_this.getTypeDescription(discount),_this.getLimitedToProducts(discount),_this.getLimitedToCategories(discount),_this.getLimitedToManufacturers(discount));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:activeCode.code},discounts);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CampaignCodeDiscount,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeDiscount'},this.renderDiscounts());}}]);return CampaignCodeDiscount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CampaignCodeDiscount.propTypes={campaignCodeStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_CampaignCodeStore__["a" /* default */]).isRequired,manufacturerStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ManufacturerStore__["a" /* default */]).isRequired,categoryStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_CategoryStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_CurrencyStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('campaignCodeStore','manufacturerStore','categoryStore','currencyStore','routeService')(CampaignCodeDiscount));

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CampaignCodeDiscountTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CampaignCodeDiscountType={AMOUNT:'AMOUNT',PERCENTAGE:'PERCENTAGE',FREE_SHIPPING:'FREE_SHIPPING'};/* harmony default export */ __webpack_exports__["a"] = (CampaignCodeDiscountType);var CampaignCodeDiscountTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CampaignCodeDiscountType',Object.values(CampaignCodeDiscountType));

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CampaignCodeProducts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_ProductLink__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignCodeProducts=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CampaignCodeProducts,_Component);function CampaignCodeProducts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CampaignCodeProducts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CampaignCodeProducts.__proto__||Object.getPrototypeOf(CampaignCodeProducts)).call.apply(_ref,[this].concat(args))),_this),_this.loadProducts=function(){var _this$props=_this.props,productIds=_this$props.productIds,productStore=_this$props.productStore;if(_this.getCurrentSearchState()!==__WEBPACK_IMPORTED_MODULE_9__types_RequestState__["b" /* default */].LOADED){productStore.loadProducts({ids:productIds},true);}},_this.getProductLimitDescription=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeProducts__description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'campaign.productLimitation',defaultMessage:'Using this discount coupon, you will receive a discount for the following products:'}));},_this.getProductList=function(){var _this$props2=_this.props,productIds=_this$props2.productIds,productStore=_this$props2.productStore;var productItems=productIds.map(function(productId){var product=productStore.products.get(productId);if(!product){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:product.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__product_ProductLink__["a" /* default */],{requireCanonical:true,product:product}));}).filter(function(item){return!!item;});return productItems&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeProducts'},_this.getProductLimitDescription(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CampaignCodeProducts__list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,productItems)));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CampaignCodeProducts,[{key:'componentDidMount',value:function componentDidMount(){this.loadProducts();}},{key:'getQueryIdentifier',value:function getQueryIdentifier(){var productIds=this.props.productIds;return Object(__WEBPACK_IMPORTED_MODULE_8__util_query__["a" /* paramsToQueryIdentifier */])({ids:productIds});}},{key:'getCurrentSearchState',value:function getCurrentSearchState(){var productStore=this.props.productStore;return productStore.productQueryStates.get(this.getQueryIdentifier());}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__["a" /* default */],{state:this.getCurrentSearchState(),forLoaded:function forLoaded(){return _this2.getProductList();}});}}]);return CampaignCodeProducts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CampaignCodeProducts.propTypes={productIds:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ProductStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('productStore','configStore')(CampaignCodeProducts));

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_share__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShareButtons=function(_Component){_inherits(ShareButtons,_Component);function ShareButtons(){_classCallCheck(this,ShareButtons);return _possibleConstructorReturn(this,(ShareButtons.__proto__||Object.getPrototypeOf(ShareButtons)).apply(this,arguments));}_createClass(ShareButtons,[{key:'render',value:function render(){var _props=this.props,url=_props.url,title=_props.title,media=_props.media;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ShareButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_share__["b" /* FacebookShareButton */],{url:url,quote:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */],{name:'facebook'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_share__["e" /* TwitterShareButton */],{url:url,title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */],{name:'twitter'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_share__["f" /* WhatsappShareButton */],{url:url,title:title,separator:':: '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */],{name:'whatsapp'})),media&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_share__["c" /* PinterestShareButton */],{url:url,media:media,windowWidth:1000,windowHeight:730},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */],{name:'pinterest'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_share__["d" /* RedditShareButton */],{url:url,title:title,windowWidth:660,windowHeight:460},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */],{name:'reddit'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_share__["a" /* EmailShareButton */],{url:url,subject:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */],{name:'envelope'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SocialMediaShareButton SocialMediaShareButton--print',tabIndex:'0',onClick:function onClick(){return window.print();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */],{name:'print'})));}}]);return ShareButtons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ShareButtons.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,url:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,media:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ShareButtons);

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FacebookShareCount__ = __webpack_require__(1131);
/* unused harmony reexport FacebookShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PinterestShareCount__ = __webpack_require__(1176);
/* unused harmony reexport PinterestShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VKShareCount__ = __webpack_require__(1179);
/* unused harmony reexport VKShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OKShareCount__ = __webpack_require__(1180);
/* unused harmony reexport OKShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedditShareCount__ = __webpack_require__(1181);
/* unused harmony reexport RedditShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TumblrShareCount__ = __webpack_require__(1182);
/* unused harmony reexport TumblrShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FacebookShareButton__ = __webpack_require__(1183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__FacebookShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LinkedinShareButton__ = __webpack_require__(1188);
/* unused harmony reexport LinkedinShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TwitterShareButton__ = __webpack_require__(1189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__TwitterShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PinterestShareButton__ = __webpack_require__(1190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__PinterestShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VKShareButton__ = __webpack_require__(1191);
/* unused harmony reexport VKShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OKShareButton__ = __webpack_require__(1192);
/* unused harmony reexport OKShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TelegramShareButton__ = __webpack_require__(1193);
/* unused harmony reexport TelegramShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WhatsappShareButton__ = __webpack_require__(1194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__WhatsappShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RedditShareButton__ = __webpack_require__(1195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__RedditShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EmailShareButton__ = __webpack_require__(1196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__EmailShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TumblrShareButton__ = __webpack_require__(1197);
/* unused harmony reexport TumblrShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LivejournalShareButton__ = __webpack_require__(1198);
/* unused harmony reexport LivejournalShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__MailruShareButton__ = __webpack_require__(1199);
/* unused harmony reexport MailruShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ViberShareButton__ = __webpack_require__(1200);
/* unused harmony reexport ViberShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__WorkplaceShareButton__ = __webpack_require__(1201);
/* unused harmony reexport WorkplaceShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__LineShareButton__ = __webpack_require__(1202);
/* unused harmony reexport LineShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__WeiboShareButton__ = __webpack_require__(1203);
/* unused harmony reexport WeiboShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PocketShareButton__ = __webpack_require__(1204);
/* unused harmony reexport PocketShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__InstapaperShareButton__ = __webpack_require__(1205);
/* unused harmony reexport InstapaperShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__FacebookIcon__ = __webpack_require__(1206);
/* unused harmony reexport FacebookIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__TwitterIcon__ = __webpack_require__(1207);
/* unused harmony reexport TwitterIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__LinkedinIcon__ = __webpack_require__(1208);
/* unused harmony reexport LinkedinIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PinterestIcon__ = __webpack_require__(1209);
/* unused harmony reexport PinterestIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__VKIcon__ = __webpack_require__(1210);
/* unused harmony reexport VKIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__OKIcon__ = __webpack_require__(1211);
/* unused harmony reexport OKIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__TelegramIcon__ = __webpack_require__(1212);
/* unused harmony reexport TelegramIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__WhatsappIcon__ = __webpack_require__(1213);
/* unused harmony reexport WhatsappIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__RedditIcon__ = __webpack_require__(1214);
/* unused harmony reexport RedditIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__TumblrIcon__ = __webpack_require__(1215);
/* unused harmony reexport TumblrIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__MailruIcon__ = __webpack_require__(1216);
/* unused harmony reexport MailruIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__EmailIcon__ = __webpack_require__(1217);
/* unused harmony reexport EmailIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__LivejournalIcon__ = __webpack_require__(1218);
/* unused harmony reexport LivejournalIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ViberIcon__ = __webpack_require__(1219);
/* unused harmony reexport ViberIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__WorkplaceIcon__ = __webpack_require__(1220);
/* unused harmony reexport WorkplaceIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__LineIcon__ = __webpack_require__(1221);
/* unused harmony reexport LineIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__PocketIcon__ = __webpack_require__(1222);
/* unused harmony reexport PocketIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__InstapaperIcon__ = __webpack_require__(1223);
/* unused harmony reexport InstapaperIcon */














































/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__(166);




function getFacebookShareCount(shareUrl, callback) {
  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, function (err, data) {
    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getFacebookShareCount));

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1133);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"/backend/api/v1/"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1134);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1136), __esModule: true };

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1137);
module.exports = __webpack_require__(96).Object.assign;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(132);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1139) });


/***/ }),
/* 1138 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(199);
var gOPS = __webpack_require__(361);
var pIE = __webpack_require__(261);
var toObject = __webpack_require__(262);
var IObject = __webpack_require__(541);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(168)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(169);
var toLength = __webpack_require__(1141);
var toAbsoluteIndex = __webpack_require__(1142);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(357);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(357);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1144);
module.exports = __webpack_require__(96).Object.getPrototypeOf;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(262);
var $getPrototypeOf = __webpack_require__(544);

__webpack_require__(545)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1146), __esModule: true };

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1147);
var $Object = __webpack_require__(96).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(132);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(134), 'Object', { defineProperty: __webpack_require__(133).f });


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1149), __esModule: true };

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1150);
__webpack_require__(1155);
module.exports = __webpack_require__(367).f('iterator');


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1151)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(549)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(357);
var defined = __webpack_require__(356);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(365);
var descriptor = __webpack_require__(259);
var setToStringTag = __webpack_require__(366);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(167)(IteratorPrototype, __webpack_require__(170)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(133);
var anObject = __webpack_require__(197);
var getKeys = __webpack_require__(199);

module.exports = __webpack_require__(134) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(115).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1156);
var global = __webpack_require__(115);
var hide = __webpack_require__(167);
var Iterators = __webpack_require__(364);
var TO_STRING_TAG = __webpack_require__(170)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1157);
var step = __webpack_require__(1158);
var Iterators = __webpack_require__(364);
var toIObject = __webpack_require__(169);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(549)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1158 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1160), __esModule: true };

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1161);
__webpack_require__(1166);
__webpack_require__(1167);
__webpack_require__(1168);
module.exports = __webpack_require__(96).Symbol;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(115);
var has = __webpack_require__(135);
var DESCRIPTORS = __webpack_require__(134);
var $export = __webpack_require__(132);
var redefine = __webpack_require__(550);
var META = __webpack_require__(1162).KEY;
var $fails = __webpack_require__(168);
var shared = __webpack_require__(359);
var setToStringTag = __webpack_require__(366);
var uid = __webpack_require__(260);
var wks = __webpack_require__(170);
var wksExt = __webpack_require__(367);
var wksDefine = __webpack_require__(368);
var enumKeys = __webpack_require__(1163);
var isArray = __webpack_require__(1164);
var anObject = __webpack_require__(197);
var toIObject = __webpack_require__(169);
var toPrimitive = __webpack_require__(355);
var createDesc = __webpack_require__(259);
var _create = __webpack_require__(365);
var gOPNExt = __webpack_require__(1165);
var $GOPD = __webpack_require__(552);
var $DP = __webpack_require__(133);
var $keys = __webpack_require__(199);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(551).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(261).f = $propertyIsEnumerable;
  __webpack_require__(361).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(363)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(167)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(260)('meta');
var isObject = __webpack_require__(198);
var has = __webpack_require__(135);
var setDesc = __webpack_require__(133).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(168)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(199);
var gOPS = __webpack_require__(361);
var pIE = __webpack_require__(261);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(542);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(169);
var gOPN = __webpack_require__(551).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1166 */
/***/ (function(module, exports) {



/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(368)('asyncIterator');


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(368)('observable');


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1170), __esModule: true };

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1171);
module.exports = __webpack_require__(96).Object.setPrototypeOf;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(132);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1172).set });


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(198);
var anObject = __webpack_require__(197);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(537)(Function.call, __webpack_require__(552).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1174), __esModule: true };

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1175);
var $Object = __webpack_require__(96).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(132);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(365) });


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(166);





function getPinterestShareCount(shareUrl, callback) {
  var url = 'https://api.pinterest.com/v1/urls/count.json';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getPinterestShareCount));

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1178);
module.exports = __webpack_require__(96).Object.keys;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(262);
var $keys = __webpack_require__(199);

__webpack_require__(545)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(166);





function getVKShareCount(shareUrl, callback) {
  if (!window.VK) {
    window.VK = {
      Share: {
        count: function count(index, _count) {
          return window.VK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://vk.com/share.php';
  var index = window.VK.callbacks.length;

  window.VK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    act: 'count',
    index: index,
    url: shareUrl
  }));
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getVKShareCount));

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(166);





function getOKShareCount(shareUrl, callback) {
  if (!window.OK) {
    window.OK = {
      Share: {
        count: function count(index, _count) {
          return window.OK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://connect.ok.ru/dk';
  var index = window.OK.callbacks.length;

  window.ODKL = {
    updateCount: function updateCount(a, b) {
      window.OK.callbacks[index](b);
    }
  };
  window.OK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + (0, __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    'st.cmd': 'extLike',
    uid: 'odklcnt0',
    ref: shareUrl
  }));
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getOKShareCount));

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__(166);




function getRedditShareCount(shareUrl, callback) {
  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, { param: 'jsonp' }, function (err, response) {
    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getRedditShareCount));

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(166);





function getTumblrShareCount(shareUrl, callback) {
  var endpoint = 'https://api.tumblr.com/v2/share/stats';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.note_count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getTumblrShareCount));

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function facebookLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'facebook.url');

  return 'https://www.facebook.com/sharer/sharer.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var FacebookShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('facebook', facebookLink, function (props) {
  /* eslint-disable no-console */
  if (props.picture) {
    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
  }

  if (props.title) {
    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
  }

  if (props.description) {
    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
  }
  /* eslint-enable no-console */

  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookShareButton);

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"/backend/api/v1/"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1185);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1186);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57), __webpack_require__(118)))

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(45);





function linkedinLink(url) {
  __WEBPACK_IMPORTED_MODULE_0_assert___default()(url, 'linkedin.url');

  return 'https://linkedin.com/shareArticle' + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ url: url });
}

var LinkedinShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('linkedin', linkedinLink, undefined, undefined, {
  windowWidth: 750,
  windowHeight: 600
});

/* unused harmony default export */ var _unused_webpack_default_export = (LinkedinShareButton);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function twitterLink(url, _ref) {
  var title = _ref.title,
      via = _ref.via,
      _ref$hashtags = _ref.hashtags,
      hashtags = _ref$hashtags === undefined ? [] : _ref$hashtags;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'twitter.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(Array.isArray(hashtags), 'twitter.hashtags is not an array');

  return 'https://twitter.com/share' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title,
    via: via,
    hashtags: hashtags.join(',')
  });
}

var TwitterShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('twitter', twitterLink, function (props) {
  return {
    hashtags: props.hashtags,
    title: props.title,
    via: props.via
  };
}, {
  hashtags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (TwitterShareButton);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function pinterestLink(url, _ref) {
  var media = _ref.media,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'pinterest.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(media, 'pinterest.media');

  return 'https://pinterest.com/pin/create/button/' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    media: media,
    description: description
  });
}

var PinterestShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('pinterest', pinterestLink, function (props) {
  return {
    media: props.media,
    description: props.description
  };
}, {
  media: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 1000,
  windowHeight: 730
});

/* harmony default export */ __webpack_exports__["a"] = (PinterestShareButton);

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function vkLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'vk.url');

  return 'https://vk.com/share.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    image: image
  });
}

var VKShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('vk', vkLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (VKShareButton);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function okLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'ok.url');

  return 'https://connect.ok.ru/offer' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageUrl: image
  });
}

var OKShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('ok', okLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 588,
  windowHeight: 480,
  windowPosition: 'screenCenter'
});

/* unused harmony default export */ var _unused_webpack_default_export = (OKShareButton);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function telegramLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'telegram.url');

  return 'https://telegram.me/share/' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var TelegramShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('telegram', telegramLink, function (props) {
  return {
    title: props.title,
    via: props.via
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (TelegramShareButton);

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function isMobileOrTablet() {
  return (/(android|iphone|ipad|mobile)/i.test(navigator.userAgent)
  );
}

function whatsappLink(url, _ref) {
  var title = _ref.title,
      separator = _ref.separator;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'whatsapp.url');
  return 'https://' + (isMobileOrTablet() ? 'api' : 'web') + '.whatsapp.com/send' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: title ? title + separator + url : url
  });
}

var WhatsappShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('whatsapp', whatsappLink, function (props) {
  return {
    title: props.title,
    separator: props.separator
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  separator: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  separator: ' ',
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (WhatsappShareButton);

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function redditLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'reddit.url');

  return 'https://www.reddit.com/submit' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title
  });
}

var RedditShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('reddit', redditLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (RedditShareButton);

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(45);





function emailLink(url, _ref) {
  var subject = _ref.subject,
      body = _ref.body,
      separator = _ref.separator;

  return 'mailto:' + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ subject: subject, body: body ? body + separator + url : url });
}

var EmailShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('email', emailLink, function (props) {
  return {
    subject: props.subject,
    body: props.body,
    separator: props.separator
  };
}, {
  subject: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  body: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  separator: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  separator: ' ',
  openWindow: false,
  onClick: function onClick(link) {
    window.location.href = link;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EmailShareButton);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function tumblrLink(url, _ref) {
  var title = _ref.title,
      caption = _ref.caption,
      tags = _ref.tags,
      posttype = _ref.posttype;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'tumblr.url');

  return 'https://www.tumblr.com/widgets/share/tool' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    canonicalUrl: url,
    title: title,
    caption: caption,
    tags: tags,
    posttype: posttype
  });
}

var TumblrShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('tumblr', tumblrLink, function (props) {
  return {
    title: props.title,
    tags: props.tags.join(','),
    caption: props.caption,
    posttype: props.posttype
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  caption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  posttype: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)
}, {
  tags: [],
  posttype: 'link',
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (TumblrShareButton);

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function livejournalLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'livejournal.url');

  return 'https://www.livejournal.com/update.bml' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    subject: title,
    event: description
  });
}

var LivejournalShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('livejournal', livejournalLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (LivejournalShareButton);

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function mailruLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'mailru.url');

  return 'https://connect.mail.ru/share' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageurl: image
  });
}

var MailruShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('mailru', mailruLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (MailruShareButton);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function viberLink(url, _ref) {
  var title = _ref.title,
      separator = _ref.separator;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'viber.url');
  return 'viber://forward' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: title ? title + separator + url : url
  });
}

var ViberShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('viber', viberLink, function (props) {
  return {
    title: props.title,
    separator: props.separator
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  separator: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  separator: ' ',
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (ViberShareButton);

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function workplaceLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'workplace.url');

  return 'https://work.facebook.com/sharer.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var WorkplaceShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('workplace', workplaceLink, function (props) {
  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (WorkplaceShareButton);

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__ = __webpack_require__(39);







function lineLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'line.url');

  return 'https://social-plugins.line.me/lineit/share' + Object(__WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var LineShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('line', lineLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 500,
  windowHeight: 500
});

/* unused harmony default export */ var _unused_webpack_default_export = (LineShareButton);

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(45);







function weiboLink(url, _ref) {
  var title = _ref.title,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'weibo.url');

  return 'http://service.weibo.com/share/share.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    pic: image
  });
}

var WeiboShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('weibo', weiboLink, function (props) {
  return {
    title: props.title,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 650,
  windowHeight: 350,
  windowPosition: 'screenCenter'
});

/* unused harmony default export */ var _unused_webpack_default_export = (WeiboShareButton);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__ = __webpack_require__(39);







function pocketLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'pocket.url');

  return 'https://getpocket.com/save' + Object(__WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title
  });
}

var PocketShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('pocket', pocketLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 500,
  windowHeight: 500
});

/* unused harmony default export */ var _unused_webpack_default_export = (PocketShareButton);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__ = __webpack_require__(39);







function instapaperLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'instapaper.url');

  return 'http://www.instapaper.com/hello2' + Object(__WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description
  });
}

var InstapaperShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('instapaper', instapaperLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 500,
  windowHeight: 500
});

/* unused harmony default export */ var _unused_webpack_default_export = (InstapaperShareButton);

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var FacebookIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('facebook', {
  icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
  mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
  color: '#3b5998'
});

/* unused harmony default export */ var _unused_webpack_default_export = (FacebookIcon);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var TwitterIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('twitter', {
  icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
  mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
  color: '#00aced'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TwitterIcon);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var LinkedinIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('linkedin', {
  icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
  mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
  color: '#007fb1'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LinkedinIcon);

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var PinterestIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('pinterest', {
  icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#cb2128'
});

/* unused harmony default export */ var _unused_webpack_default_export = (PinterestIcon);

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var VKIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('vk', {
  icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  color: '#45668e'
});

/* unused harmony default export */ var _unused_webpack_default_export = (VKIcon);

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var OKIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('ok', {
  icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
  mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
  color: '#f2720c'
});

/* unused harmony default export */ var _unused_webpack_default_export = (OKIcon);

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var TelegramIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('telegram', {
  icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#37aee2'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TelegramIcon);

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var WhatsappIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('whatsapp', {
  icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#2cb742'
});

/* unused harmony default export */ var _unused_webpack_default_export = (WhatsappIcon);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var RedditIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('reddit', {
  icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
  color: '#5f99cf'
});

/* unused harmony default export */ var _unused_webpack_default_export = (RedditIcon);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var TumblrIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('tumblr', {
  icon: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#2c4762'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TumblrIcon);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var MailruIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('mailru', {
  icon: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#168DE2'
});

/* unused harmony default export */ var _unused_webpack_default_export = (MailruIcon);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var EmailIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('email', {
  icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
  mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
  color: '#7f7f7f'
});

/* unused harmony default export */ var _unused_webpack_default_export = (EmailIcon);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var LivejournalIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('livejournal', {
  icon: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#21A5D8'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LivejournalIcon);

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var ViberIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('viber', {
  icon: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
  mask: '',
  color: '#7C529E'
});

/* unused harmony default export */ var _unused_webpack_default_export = (ViberIcon);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var WorkplaceIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('workplace', {
  icon: 'M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z',
  color: '#3b3d4a'
});

/* unused harmony default export */ var _unused_webpack_default_export = (WorkplaceIcon);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var LineIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('line', {
  icon: 'M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z',
  mask: '',
  color: '#00b800'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LineIcon);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var PocketIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('pocket', {
  icon: 'M41.084 29.065l-7.528 7.882a2.104 2.104 0 0 1-1.521.666 2.106 2.106 0 0 1-1.522-.666l-7.528-7.882c-.876-.914-.902-2.43-.065-3.384.84-.955 2.228-.987 3.1-.072l6.015 6.286 6.022-6.286c.88-.918 2.263-.883 3.102.071.841.938.82 2.465-.06 3.383l-.015.002zm6.777-10.976C47.463 16.84 46.361 16 45.14 16H18.905c-1.2 0-2.289.82-2.716 2.044-.125.363-.189.743-.189 1.125v10.539l.112 2.096c.464 4.766 2.73 8.933 6.243 11.838.06.053.125.102.19.153l.04.033c1.882 1.499 3.986 2.514 6.259 3.014a14.662 14.662 0 0 0 6.13.052c.118-.042.235-.065.353-.087.03 0 .065-.022.098-.042a15.395 15.395 0 0 0 6.011-2.945l.039-.045.18-.153c3.502-2.902 5.765-7.072 6.248-11.852L48 29.674v-10.52c0-.366-.041-.728-.161-1.08l.022.015z',
  mask: 'M0,0v64h64V0H0z M41.084 29.065l-7.528 7.882a2.104 2.104 0 0 1-1.521.666 2.106 2.106 0 0 1-1.522-.666l-7.528-7.882c-.876-.914-.902-2.43-.065-3.384.84-.955 2.228-.987 3.1-.072l6.015 6.286 6.022-6.286c.88-.918 2.263-.883 3.102.071.841.938.82 2.465-.06 3.383l-.015.002zm6.777-10.976C47.463 16.84 46.361 16 45.14 16H18.905c-1.2 0-2.289.82-2.716 2.044-.125.363-.189.743-.189 1.125v10.539l.112 2.096c.464 4.766 2.73 8.933 6.243 11.838.06.053.125.102.19.153l.04.033c1.882 1.499 3.986 2.514 6.259 3.014a14.662 14.662 0 0 0 6.13.052c.118-.042.235-.065.353-.087.03 0 .065-.022.098-.042a15.395 15.395 0 0 0 6.011-2.945l.039-.045.18-.153c3.502-2.902 5.765-7.072 6.248-11.852L48 29.674v-10.52c0-.366-.041-.728-.161-1.08l.022.015z',
  color: '#EF3F56'
});

/* unused harmony default export */ var _unused_webpack_default_export = (PocketIcon);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(51);


var InstapaperIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('instapaper', {
  icon: 'M35.688 43.012c0 2.425.361 2.785 3.912 3.056V48H24.401v-1.932c3.555-.27 3.912-.63 3.912-3.056V20.944c0-2.379-.36-2.785-3.912-3.056V16H39.6v1.888c-3.55.27-3.912.675-3.912 3.056v22.068h.001z',
  mask: 'M0,0v64h64V0H0z M35.688 43.012c0 2.425.361 2.785 3.912 3.056V48H24.401v-1.932c3.555-.27 3.912-.63 3.912-3.056V20.944c0-2.379-.36-2.785-3.912-3.056V16H39.6v1.888c-3.55.27-3.912.675-3.912 3.056v22.068h.001z',
  color: '#1F1F1F'
});

/* unused harmony default export */ var _unused_webpack_default_export = (InstapaperIcon);

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationAddToCartRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Product__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__product_ProductAddToCart__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationAddToCartRow=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NavigationAddToCartRow,_Component);function NavigationAddToCartRow(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavigationAddToCartRow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavigationAddToCartRow.__proto__||Object.getPrototypeOf(NavigationAddToCartRow)).call.apply(_ref,[this].concat(args))),_this),_this.getElementTopPosition=function(){var _this$props=_this.props,uiStore=_this$props.uiStore,configStore=_this$props.configStore;if(!uiStore.isDesktop&&uiStore.scrollingDown){return 0;}else{return uiStore.isDesktop&&configStore.topNavigation.hideHeaderOnScrollingDown&&uiStore.scrollingDown?0:uiStore.headerHeight;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavigationAddToCartRow,[{key:'render',value:function render(){var _props=this.props,accountStore=_props.accountStore,cartStore=_props.cartStore,configStore=_props.configStore,productStore=_props.productStore,uiStore=_props.uiStore,product=_props.product,activeProductId=_props.activeProductId;var addToCartRowIsVisible=uiStore.addToCartRowIsVisible,isDesktop=uiStore.isDesktop;var _configStore$topNavig=configStore.topNavigation.addToCartRow,mobileActive=_configStore$topNavig.mobile,desktopActive=_configStore$topNavig.desktop;var hideAddToCart=accountStore.isViewOnly;var addToCartProduct=product.getActualProduct(activeProductId)||product;var quantity=cartStore.productQuantity;if(!addToCartProduct||!addToCartRowIsVisible||hideAddToCart||isDesktop&&!desktopActive||!isDesktop&&!mobileActive){return null;}var pickedCollection=productStore.selectedProductColumn&&productStore.selectedProductRow?productStore.selectedProductColumn+' '+productStore.selectedProductRow:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_reactstrap__["n" /* Container */],{fluid:true,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('NavigationAddToCartRow','NavigationAddToCartRow__container'),style:{top:this.getElementTopPosition()}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_reactstrap__["O" /* Row */],{className:'NavigationAddToCartRow__row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_reactstrap__["l" /* Col */],{xs:12,className:'NavigationAddToCartRow__column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationAddToCartRow__product'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'NavigationAddToCartRow__product-title'},product.name),quantity>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationAddToCartRow__product-quantity'},pickedCollection&&pickedCollection+' ',quantity+' '+addToCartProduct.stock_unit)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__product_ProductAddToCart__["b" /* default */],{product:product,addToCartProduct:addToCartProduct,activeProductId:activeProductId,withQuantityPicker:false,quantity:quantity})),!activeProductId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_reactstrap__["l" /* Col */],{xs:12,className:'NavigationAddToCartRow__not-active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationAddToCartRow__notifier'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_Icon__["a" /* default */],{name:'arrow-up'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'addToCart.selectProductVariant',defaultMessage:'Please choose the product variant'})))));}}]);return NavigationAddToCartRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NavigationAddToCartRow.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_AccountStore__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_CartStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ConfigStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_ProductStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_UIStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_Product__["a" /* default */]).isRequired,activeProductId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('accountStore','cartStore','configStore','productStore','uiStore')(NavigationAddToCartRow));

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_product_ProductTabs__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_category_CategoryGrid__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_layout_SidebarLayout__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_head_SEODescription__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_sidebar_DefaultSidebar__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_suitable_product_SuitableProductFinder__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CategoryPage,_Component);function CategoryPage(props){_classCallCheck(this,CategoryPage);var _this=_possibleConstructorReturn(this,(CategoryPage.__proto__||Object.getPrototypeOf(CategoryPage)).call(this,props));_this.ensureCorrectActiveCategorySet=function(){var _this$props=_this.props,categoryStore=_this$props.categoryStore,match=_this$props.match;if(!categoryStore.activeCategory||categoryStore.activeCategory.id!==Number(match.params.id)){_this.updateActiveCategory();}};_this.updateActiveCategory=function(){var _this$props2=_this.props,categoryStore=_this$props2.categoryStore,match=_this$props2.match;categoryStore.setActiveCategory(match.params.id);// If active category did not get set, return 404 to user, because it means it was not found.
if(!categoryStore.activeCategory){categoryStore.setSingleStateError({response:{status:404}});return;}if(categoryStore.activeCategory.description_html===null){categoryStore.loadCategory(match.params.id).catch(function(e){console.error(e);});}};_this.getBreadcrumbsPath=function(){var _this$props3=_this.props,categoryStore=_this$props3.categoryStore,routeService=_this$props3.routeService;if(!categoryStore.activeCategory){return[];}return routeService.transformBreadCrumbs(categoryStore.activeCategory.breadcrumbs);};_this.getCategoryContent=function(){var listName='Category List';var _this$props4=_this.props,match=_this$props4.match,sectionStore=_this$props4.sectionStore,categoryStore=_this$props4.categoryStore,configStore=_this$props4.configStore,uiStore=_this$props4.uiStore;var fixedParams={categories:[match.params.id],excludeContent:1,cross_categories:[]};if(sectionStore.activeSection){fixedParams.sections=[sectionStore.activeSection.id];}var isMainCategory=categoryStore.activeCategory.ancestors.length===0;var showCategoryFilter=categoryStore.activeCategory.show_category_filter;if(configStore.suitableProducts.enabledOnCategories.indexOf(categoryStore.activeCategory.id)!==-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_suitable_product_SuitableProductFinder__["a" /* default */],{categoryId:Number(match.params.id),listName:listName});}else if(isMainCategory){var maybeCategoryGrid=void 0,hasChildren=void 0,drawCategoryGrid=void 0;if(configStore.mainCategoryPage.showCategoryGrid){var children=sectionStore.activeSection?categoryStore.activeCategory.getNonBlockedChildren(sectionStore.activeSection.blockedCategoriesDict):categoryStore.activeCategory.children;hasChildren=children.length>0;maybeCategoryGrid=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_category_CategoryGrid__["a" /* default */],{categories:children});drawCategoryGrid=true;}var maybeProductList=void 0;if(configStore.mainCategoryPage.showMainProductList||!hasChildren){maybeProductList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showCategoryFilter:showCategoryFilter});if(uiStore.isMobile){drawCategoryGrid=false;}}else if(configStore.mainCategoryPage.showProductTabs){maybeProductList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_product_ProductTabs__["a" /* default */],{searchParams:Object.assign({},fixedParams)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,drawCategoryGrid&&maybeCategoryGrid,maybeProductList);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showCategoryFilter:showCategoryFilter});}};_this.yotpoTimeout=null;_this.ensureCorrectActiveCategorySet();return _this;}_createClass(CategoryPage,[{key:'componentDidMount',value:function componentDidMount(){// Another component from the previous DOM may fire its componentWillUnmount
// and clear the category in between the initial getDerivedStateFromProps
// and componentDidMount. To compensate for that, check whether the category
// needs to be loaded again.
this.ensureCorrectActiveCategorySet();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var configStore=this.props.configStore;this.ensureCorrectActiveCategorySet();if(configStore.yotpo.enabled&&window&&window.yotpo){this.yotpoTimeout=setTimeout(function(){return window.yotpo.refreshWidgets();},800);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _props=this.props,categoryStore=_props.categoryStore,match=_props.match;// Clean-up active category, if it was set by this component
if(categoryStore.activeCategory&&categoryStore.activeCategory.id===Number(match.params.id)){categoryStore.setActiveCategory(null);}this.yotpoTimeout&&clearTimeout(this.yotpoTimeout);}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,configStore=_props2.configStore,categoryStore=_props2.categoryStore,routeService=_props2.routeService,sectionStore=_props2.sectionStore,match=_props2.match,location=_props2.location;if(categoryStore.activeCategory===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* Redirect */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_30__types_Paths__["a" /* default */].NotFoundPage)});}var adSearchParams={category:categoryStore.activeCategory&&categoryStore.activeCategory.id};var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_ad_MainBanner__["a" /* default */],{searchParams:adSearchParams});var mainBannerWithinContent=configStore.mainBanner.withinContent;var maybeRedirectTo=''+routeService.getCategoryPath(categoryStore.activeCategory)+location.search+location.hash;// Fix the URL when section store is missing activeSection
if(configStore.activateSections&&sectionStore.activeSection===null){// Unless the category has no section
if(routeService.getCategoryPath(categoryStore.activeCategory)!==categoryStore.activeCategory.path){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* Redirect */],{to:maybeRedirectTo});}}// Fix the URL if it contains unexpected parts
if(categoryStore.activeCategory&&String(categoryStore.activeCategory.id)===match.params.id&&!Object(__WEBPACK_IMPORTED_MODULE_28__util_url__["h" /* pathFragmentMatchesLocation */])(categoryStore.activeCategory.path,location.pathname)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* Redirect */],{to:maybeRedirectTo});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_31__types_CommonPage__["b" /* default */].CATEGORY,className:'CategoryPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_ScrollReset__["a" /* default */],{key:match.params.id}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'CategoryPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_layout_SidebarLayout__["a" /* default */],{sidebar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_sidebar_DefaultSidebar__["a" /* default */],{bannerSearchParams:adSearchParams}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_loader_ContentForState__["a" /* default */],{state:categoryStore.singleState,error:categoryStore.lastError,forLoaded:function forLoaded(){return categoryStore.activeCategory&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_head_SEOTitle__["a" /* default */],{title:categoryStore.activeCategory.SEO_title||categoryStore.activeCategory.name,noSuffix:!!categoryStore.activeCategory.SEO_title}),categoryStore.activeCategory.SEO_description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_head_SEODescription__["a" /* default */],{content:categoryStore.activeCategory.SEO_description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_head_CanonicalLink__["a" /* default */],{path:routeService.getCanonicalCategoryPath(categoryStore.activeCategory)}),mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:_this2.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_PageTitle__["a" /* default */],null,categoryStore.activeCategory.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategoryPage__category-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_common_WysiwygContent__["a" /* default */],{html:categoryStore.activeCategory.description_html})),_this2.getCategoryContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategoryPage__category-footer-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_common_WysiwygContent__["a" /* default */],{html:categoryStore.activeCategory.footer_description_html})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_ad_ContentPopup__["a" /* default */],{searchParams:adSearchParams}));}})})));}}]);return CategoryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CategoryPage.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_ConfigStore__["a" /* default */]),categoryStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_CategoryStore__["a" /* default */]),sectionStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_SectionStore__["a" /* default */]),uiStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_29__store_UIStore__["a" /* default */]),match:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.match.isRequired,location:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','categoryStore','routeService','sectionStore','uiStore')(CategoryPage));

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var createAggregator = __webpack_require__(220);

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

module.exports = partition;


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(464);

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(308);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(305);

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

module.exports = setWith;


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BooleanFilter__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TermFilter__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RangeFilter__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_FilterType__ = __webpack_require__(252);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FILTER_COUNT_TO_SHOW_BY_DEFAULT=9;var FilteringOptions=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FilteringOptions,_Component);function FilteringOptions(){_classCallCheck(this,FilteringOptions);var _this=_possibleConstructorReturn(this,(FilteringOptions.__proto__||Object.getPrototypeOf(FilteringOptions)).call(this));_this.getFilterComponent=function(activeFilter,filter,onAcceptFilter){var component=null;var activeFilterArray=[];switch(filter.type){case __WEBPACK_IMPORTED_MODULE_8__types_FilterType__["b" /* default */].TERM:{if(activeFilter&&activeFilter.value){Object.values(activeFilter.value).forEach(function(filterItem){activeFilterArray.push(filterItem);});}component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TermFilter__["a" /* default */],{contentFilter:filter,onAccept:onAcceptFilter,selectedValues:activeFilter?activeFilterArray:[]});break;}case __WEBPACK_IMPORTED_MODULE_8__types_FilterType__["b" /* default */].RANGE:{component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RangeFilter__["a" /* default */],{filter:filter,onAccept:onAcceptFilter,min:activeFilter?activeFilter.min:filter.min,max:activeFilter?activeFilter.max:filter.max,filterInUse:!!activeFilter});break;}case __WEBPACK_IMPORTED_MODULE_8__types_FilterType__["b" /* default */].BOOLEAN:{component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BooleanFilter__["a" /* default */],{onAccept:onAcceptFilter,filter:filter,isSelected:activeFilter?activeFilter.value==='1':false});break;}default:{break;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:filter.key},component);};_this.createFilterItem=function(key,content){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{key:key,className:'FilteringOptions__option-wrapper '+('FilteringOptions__option-wrapper--'+key),xs:'12',sm:'6',md:'4',xl:'3'},content);};_this.state={showAllFilters:false};return _this;}_createClass(FilteringOptions,[{key:'render',value:function render(){var _this2=this;var _props=this.props,activeFilters=_props.activeFilters,filters=_props.filters,onAcceptFilter=_props.onAcceptFilter,inGrid=_props.inGrid,toggleShowAll=_props.toggleShowAll,showAllFilters=_props.showAllFilters;var filterItems=filters?filters.map(function(filter){var activeFilter=activeFilters?activeFilters.find(function(af){return af.key===filter.key;}):[];return _this2.createFilterItem(filter.key,_this2.getFilterComponent(activeFilter,filter,onAcceptFilter));}):[];var allElements=showAllFilters?filterItems:filterItems.slice(0,FILTER_COUNT_TO_SHOW_BY_DEFAULT);if(!showAllFilters&&filterItems.length>FILTER_COUNT_TO_SHOW_BY_DEFAULT){allElements.push(this.createFilterItem('more-link',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:'FilteringOptions__heading',onClick:toggleShowAll,color:'link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'filter.showMore',defaultMessage:'Show more filters'}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FilteringOptions'},inGrid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],null,allElements.map(function(element){return element;})):allElements);}}]);return FilteringOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FilteringOptions.propTypes={activeFilters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,filters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,onAcceptFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,toggleShowAll:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,showAllFilters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,inGrid:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (FilteringOptions);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TermFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FilterContainer__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Filter__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FilterAcceptButton__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TermFilter=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(TermFilter,_Component);function TermFilter(props){_classCallCheck(this,TermFilter);var _this=_possibleConstructorReturn(this,(TermFilter.__proto__||Object.getPrototypeOf(TermFilter)).call(this,props));_this.renderFilterOptions=function(){var contentFilter=_this.props.contentFilter;var _this$state=_this.state,selectedValues=_this$state.selectedValues,filterOptions=_this$state.filterOptions;if(!filterOptions){return null;}return filterOptions.map(function(filterOption){var checked=selectedValues&&selectedValues.constructor===Array?selectedValues.some(function(sv){return sv===filterOption.value;}):selectedValues===filterOption.value;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',{key:contentFilter.key+filterOption.value,className:'TermFilter__option'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(){if(!checked){_this.addSelection(filterOption.value);}else{_this.removeSelection(filterOption.value);}},value:filterOption.value,checked:checked,className:'TermFilter__option-checkbox'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'TermFilter__option-name'},filterOption.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'TermFilter__option-items-count'},filterOption.count));});};_this.addSelection=function(value){var selectedValues=_this.state.selectedValues;selectedValues.push(value);_this.setState({selectedValues:selectedValues});};_this.removeSelection=function(value){var selectedValues=_this.state.selectedValues;selectedValues=__WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(selectedValues,function(val){return val!==value;});_this.setState({selectedValues:selectedValues});};_this.isValueChanged=function(){return!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(_this.props.selectedValues,_this.state.selectedValues);};_this.acceptValues=function(){var _this$props=_this.props,contentFilter=_this$props.contentFilter,onAccept=_this$props.onAccept;var selectedValues=_this.state.selectedValues;if(_this.isValueChanged())onAccept(contentFilter,selectedValues);if(_this.filterContainer)_this.filterContainer.toggleOpen();};_this.onFilterClosedAutomatically=function(){return _this.acceptValues();};_this.renderTextFilterInput=function(filterTerm){var _this$props2=_this.props,contentFilter=_this$props2.contentFilter,defaultOptionsAmount=_this$props2.defaultOptionsAmount,intl=_this$props2.intl;var filterOptions=contentFilter.options;return filterOptions&&filterOptions.length>=defaultOptionsAmount&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["w" /* InputGroup */],{className:'TermFilter__text-filter btn-group'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["v" /* Input */],{value:filterTerm,onChange:_this.setAddressFilterString,placeholder:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].termFilterPlaceholder)}),filterTerm&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["x" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'primary',onClick:_this.clearSearch},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Icon__["a" /* default */],{name:'close'}))));};_this.setAddressFilterString=function(event){var contentFilter=_this.props.contentFilter;var filterTerm=event.target.value.toLowerCase();var filterOptions=contentFilter.options.filter(function(filterOption){return filterOption.name.toLowerCase().includes(filterTerm);});_this.setState({filterOptions:filterOptions,filterTerm:filterTerm});};_this.clearSearch=function(){return _this.setState({filterTerm:'',filterOptions:_this.props.contentFilter.options});};_this.state={selectedValues:props.selectedValues.slice(0),filterOptions:props.contentFilter.options,filterTerm:''};_this.setAddressFilterString=_this.setAddressFilterString.bind(_this);_this.clearSearch=_this.clearSearch.bind(_this);return _this;}_createClass(TermFilter,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){this.setState({selectedValues:props.selectedValues.slice(0),filterOptions:props.contentFilter.options});}},{key:'render',value:function render(){var _this2=this;var contentFilter=this.props.contentFilter;var _state=this.state,selectedValues=_state.selectedValues,filterTerm=_state.filterTerm;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'TermFilter'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FilterContainer__["a" /* default */],{filterInUse:selectedValues.length>0,headerText:contentFilter.name,onFilterClosedAutomatically:this.onFilterClosedAutomatically,ref:function ref(_ref){return _this2.filterContainer=_ref;}},this.renderTextFilterInput(filterTerm),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'TermFilter__options-container'},this.renderFilterOptions()),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__FilterAcceptButton__["a" /* default */],{className:'TermFilter__accept-button',onClick:this.acceptValues},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].saveTitle))));}}]);return TermFilter;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;TermFilter.propTypes={contentFilter:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Filter__["a" /* default */]).isRequired,onAccept:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_5_react_intl__["f" /* intlShape */].isRequired,selectedValues:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string)};TermFilter.defaultProps={selectedValues:[],defaultOptionsAmount:20};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["e" /* injectIntl */])(TermFilter));

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Filter__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FilterContainer__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_RangeSlider__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FilterAcceptButton__ = __webpack_require__(558);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RangeFilter=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(RangeFilter,_Component);function RangeFilter(props){_classCallCheck(this,RangeFilter);var _this=_possibleConstructorReturn(this,(RangeFilter.__proto__||Object.getPrototypeOf(RangeFilter)).call(this,props));_initialiseProps.call(_this);_this.state={min:props.min,max:props.max};return _this;}// This method is called when user clicks outside open filter.
// Call onAccept and close filter container.
_createClass(RangeFilter,[{key:'render',value:function render(){var _this2=this;var _props=this.props,filter=_props.filter,filterInUse=_props.filterInUse;var _state=this.state,min=_state.min,max=_state.max;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RangeFilter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FilterContainer__["a" /* default */],{headerText:filter.name,filterInUse:filterInUse,onFilterClosedAutomatically:this.onFilterClosedAutomatically,ref:function ref(_ref){return _this2.filterContainer=_ref;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_RangeSlider__["a" /* default */],{allowCross:false,min:Number(filter.min),max:Number(filter.max),value:[min,max],step:filter.step,onChange:this.onValueChanged}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RangeFilter__text-inputs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RangeFilter__text-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Input */],{type:'text',value:min,onChange:function onChange(event){return _this2.onMinValueChanged(Number(event.target.value));},bsSize:'sm',className:'RangeFilter__text-box-input'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'RangeFilter__between-text-boxes'},'\u2013'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RangeFilter__text-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["w" /* InputGroup */],{size:'sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Input */],{type:'text',value:max,onChange:function onChange(event){return _this2.onMaxValueChanged(Number(event.target.value));},className:'RangeFilter__text-box-input RangeFilter__text-box-input--with-addon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["x" /* InputGroupAddon */],{addonType:'append'},filter.unit)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FilterAcceptButton__["a" /* default */],{className:'RangeFilter__accept-button',onClick:this.onAcceptRange,disabled:!this.isValidRange()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].saveTitle))));}}]);return RangeFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this3=this;this.componentWillReceiveProps=function(props){if(props.min!==_this3.state.min||props.max!==_this3.state.max){_this3.setState({min:props.min,max:props.max});}};this.onValueChanged=function(value){if(isNaN(value[0])||isNaN(value[1]))return;_this3.setState({min:value[0],max:value[1]});};this.onMinValueChanged=function(value){if(isNaN(value))return;_this3.setState({min:value});};this.onMaxValueChanged=function(value){if(isNaN(value))return;_this3.setState({max:value});};this.isValueChanged=function(){return _this3.props.min!==_this3.state.min||_this3.props.max!==_this3.state.max;};this.isValidRange=function(){var _state2=_this3.state,min=_state2.min,max=_state2.max;return min<=max;};this.validateAndMaybeAccept=function(){var _props2=_this3.props,filter=_props2.filter,onAccept=_props2.onAccept;var _state3=_this3.state,min=_state3.min,max=_state3.max;if(_this3.isValidRange()){onAccept(filter,[min,max]);}else{_this3.setState(function(state){state.min=_this3.props.min;state.max=_this3.props.max;return state;});}};this.onAcceptRange=function(){var filterInUse=_this3.props.filterInUse;if(_this3.isValueChanged()||!filterInUse){_this3.validateAndMaybeAccept();}_this3.filterContainer.toggleOpen();};this.onFilterClosedAutomatically=function(){if(_this3.isValueChanged()){_this3.validateAndMaybeAccept();}if(_this3.filterContainer){_this3.filterContainer.toggleOpen();}};},_temp))||_class;RangeFilter.propTypes={filter:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Filter__["a" /* default */]),filterInUse:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onAccept:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,min:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,max:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (RangeFilter);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_slider__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_slider_assets_index_css__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_slider_assets_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rc_slider_assets_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RangeSlider=function(_Component){_inherits(RangeSlider,_Component);function RangeSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RangeSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RangeSlider.__proto__||Object.getPrototypeOf(RangeSlider)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(value){var onChange=_this.props.onChange;onChange(value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RangeSlider,[{key:'render',value:function render(){var _props=this.props,min=_props.min,max=_props.max,step=_props.step,value=_props.value;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'RangeSlider'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_rc_slider__["a" /* Range */],{allowCross:false,value:value,min:min,max:max,step:step,onChange:this.handleChange,className:'RangeSlider__slider'}));}}]);return RangeSlider;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);RangeSlider.propTypes={min:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,max:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,step:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,value:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number)};/* harmony default export */ __webpack_exports__["a"] = (RangeSlider);

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Range__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handle__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__ = __webpack_require__(1248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Range__["a"]; });
/* unused harmony reexport Handle */
/* unused harmony reexport createSliderWithTooltip */




__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Range = __WEBPACK_IMPORTED_MODULE_1__Range__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Handle = __WEBPACK_IMPORTED_MODULE_2__Handle__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].createSliderWithTooltip = __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_warning__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Track__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_createSlider__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(372);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var Slider = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Slider, _React$Component);

  var _super = _createSuper(Slider);

  /* eslint-enable */
  function Slider(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Slider);

    _this = _super.call(this, props);

    _this.onEnd = function (force) {
      var dragging = _this.state.dragging;

      _this.removeDocumentEvents();

      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        dragging: false
      });
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;
    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_warning__["a" /* default */])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
    Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_warning__["a" /* default */])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
    return _this;
  }
  /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */

  /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */


  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Slider, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value) {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index, h) {}
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }

      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange;
      var theValue = value !== undefined ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);

      if (nextValue !== prevState.value) {
        // eslint-disable-next-line
        this.setState({
          value: nextValue
        });

        if (__WEBPACK_IMPORTED_MODULE_10__utils__["i" /* isValueOutOfRange */](theValue, this.props)) {
          onChange(nextValue);
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      var nextState = state.value > this.props.max ? _objectSpread(_objectSpread({}, state), {}, {
        value: this.props.max
      }) : state;

      if (isNotControlled) {
        this.setState(nextState);
      }

      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      this.setState({
        dragging: true
      });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      if (value === prevValue) return;
      this.prevMovedHandleIndex = 0;
      this.onChange({
        value: value
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_10__utils__["j" /* pauseEvent */](e);
      var oldValue = this.state.value;
      var value = this.calcValueByPos(position);
      if (value === oldValue) return;
      this.onChange({
        value: value
      });
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e) {
      var _this$props2 = this.props,
          reverse = _this$props2.reverse,
          vertical = _this$props2.vertical;
      var valueMutator = __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* getKeyboardValueMutator */](e, vertical, reverse);

      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_10__utils__["j" /* pauseEvent */](e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;
        this.onChange({
          value: value
        });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (v === null) {
        return null;
      }

      var mergedProps = _objectSpread(_objectSpread({}, this.props), nextProps);

      var val = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* ensureValueInRange */](v, mergedProps);
      return __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* ensureValuePrecision */](val, mergedProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          vertical = _this$props3.vertical,
          included = _this$props3.included,
          disabled = _this$props3.disabled,
          minimumTrackStyle = _this$props3.minimumTrackStyle,
          trackStyle = _this$props3.trackStyle,
          handleStyle = _this$props3.handleStyle,
          tabIndex = _this$props3.tabIndex,
          ariaLabelForHandle = _this$props3.ariaLabelForHandle,
          ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle,
          ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle,
          min = _this$props3.min,
          max = _this$props3.max,
          startPoint = _this$props3.startPoint,
          reverse = _this$props3.reverse,
          handleGenerator = _this$props3.handle;
      var _this$state = this.state,
          value = _this$state.value,
          dragging = _this$state.dragging;
      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: "".concat(prefixCls, "-handle"),
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        reverse: reverse,
        index: 0,
        tabIndex: tabIndex,
        ariaLabel: ariaLabelForHandle,
        ariaLabelledBy: ariaLabelledByForHandle,
        ariaValueTextFormatter: ariaValueTextFormatterForHandle,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });
      var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
      var mergedTrackStyle = trackStyle[0] || trackStyle;
      var track = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Track__["a" /* default */], {
        className: "".concat(prefixCls, "-track"),
        vertical: vertical,
        included: included,
        offset: trackOffset,
        reverse: reverse,
        length: offset - trackOffset,
        style: _objectSpread(_objectSpread({}, minimumTrackStyle), mergedTrackStyle)
      });
      return {
        tracks: track,
        handles: handle
      };
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__common_createSlider__["a" /* default */])(Slider));

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__superPropBase__ = __webpack_require__(1239);

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = Object(__WEBPACK_IMPORTED_MODULE_0__superPropBase__["a" /* default */])(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _superPropBase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf__ = __webpack_require__(136);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf__["a" /* default */])(object);
    if (object === null) break;
  }

  return object;
}

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_warning__ = __webpack_require__(370);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_warning__["a" /* default */])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
    return a - b;
  });

  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }

  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;
  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = "".concat(Math.abs(point - min) / range * 100, "%");
    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? _objectSpread(_objectSpread({}, dotStyle), {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, reverse ? 'top' : 'bottom', offset)) : _objectSpread(_objectSpread({}, dotStyle), {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, reverse ? 'right' : 'left', offset));

    if (isActived) {
      style = _objectSpread(_objectSpread({}, style), activeDotStyle);
    }

    var pointClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-dot"), true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-dot-active"), isActived), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
      className: pointClassName,
      style: style,
      key: point
    });
  });
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, elements);
};

/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;
  var marksKeys = Object.keys(marks);
  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(markPoint) === 'object' && !__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;

    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()((_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(className, "-text"), true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(className, "-text-active"), isActive), _classNames));

    var bottomStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      marginBottom: '-50%'
    }, reverse ? 'top' : 'bottom', "".concat((point - min) / range * 100, "%"));

    var leftStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
      msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
    }, reverse ? 'right' : 'left', "".concat((point - min) / range * 100, "%"));

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? _objectSpread(_objectSpread({}, style), markPoint.style) : style;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: markClassName,
      style: markStyle,
      key: point,
      onMouseDown: function onMouseDown(e) {
        return onClickLabel(e, point);
      },
      onTouchStart: function onTouchStart(e) {
        return onClickLabel(e, point);
      }
    }, markLabel);
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: className
  }, elements);
};

/* harmony default export */ __webpack_exports__["a"] = (Marks);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__ = __webpack_require__(562);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(arr);
}

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shallowequal__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Track__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_createSlider__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(372);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }








var _trimAlignValue = function trimAlignValue(_ref) {
  var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
  var allowCross = props.allowCross,
      pushable = props.pushable;
  var thershold = Number(pushable);
  var valInRange = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* ensureValueInRange */](value, props);
  var valNotConflict = valInRange;

  if (!allowCross && handle != null && bounds !== undefined) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }

    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }

  return __WEBPACK_IMPORTED_MODULE_12__utils__["b" /* ensureValuePrecision */](valNotConflict, props);
};

var Range = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Range, _React$Component);

  var _super = _createSuper(Range);

  function Range(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Range);

    _this = _super.call(this, props);

    _this.onEnd = function (force) {
      var handle = _this.state.handle;

      _this.removeDocumentEvents();

      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        handle: null
      });
    };

    var count = props.count,
        min = props.min,
        max = props.max;
    var initialValue = Array.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _trimAlignValue({
        value: v,
        handle: i,
        props: props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;
    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }
  /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */

  /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */


  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Range, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value) {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index, h) {}
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }

      if (this.props.min === prevProps.min && this.props.max === prevProps.max && __WEBPACK_IMPORTED_MODULE_9_shallowequal___default()(this.props.value, prevProps.value)) {
        return;
      }

      var _this$props = this.props,
          onChange = _this$props.onChange,
          value = _this$props.value;
      var currentValue = value || prevState.bounds;

      if (currentValue.some(function (v) {
        return __WEBPACK_IMPORTED_MODULE_12__utils__["i" /* isValueOutOfRange */](v, _this2.props);
      })) {
        var newValues = currentValue.map(function (v) {
          return __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* ensureValueInRange */](v, _this2.props);
        });
        onChange(newValues);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);

      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};
        ['handle', 'recent'].forEach(function (item) {
          if (state[item] !== undefined) {
            controlledState[item] = state[item];
          }
        });

        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }

      var data = _objectSpread(_objectSpread({}, this.state), state);

      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      var props = this.props,
          state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });
      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(state.bounds);

      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({
        bounds: nextBounds
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_12__utils__["j" /* pauseEvent */](e);
      var state = this.state;
      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;
      this.moveTo(value);
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e) {
      var _this$props2 = this.props,
          reverse = _this$props2.reverse,
          vertical = _this$props2.vertical;
      var valueMutator = __WEBPACK_IMPORTED_MODULE_12__utils__["d" /* getKeyboardValueMutator */](e, vertical, reverse);

      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_12__utils__["j" /* pauseEvent */](e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;
        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);

        var value = _trimAlignValue({
          value: mutatedValue,
          handle: handle,
          bounds: state.bounds,
          props: props
        });

        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: "getClosestBound",
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;
      var closestBound = 0;

      for (var i = 1; i < bounds.length - 1; i += 1) {
        if (value >= bounds[i]) {
          closestBound = i;
        }
      }

      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }

      return closestBound;
    }
  }, {
    key: "getBoundNeedMoving",
    value: function getBoundNeedMoving(value, closestBound) {
      var _this$state = this.state,
          bounds = _this$state.bounds,
          recent = _this$state.recent;
      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }

      return boundNeedMoving;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      var bounds = this.state.bounds;
      return bounds[bounds.length - 1];
    }
    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: "getPoints",
    value: function getPoints() {
      var _this$props3 = this.props,
          marks = _this$props3.marks,
          step = _this$props3.step,
          min = _this$props3.min,
          max = _this$props3.max;
      var cache = this.internalPointsCache;

      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = _objectSpread({}, marks);

        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }

        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this.internalPointsCache = {
          marks: marks,
          step: step,
          points: points
        };
      }

      return this.internalPointsCache.points;
    }
  }, {
    key: "moveTo",
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(state.bounds);

      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;

      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }

      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });

      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.props.onAfterChange(nextBounds);
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: "pushSurroundingHandles",
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var direction = 0;

      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }

      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);

      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        // eslint-disable-next-line no-param-reassign
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: "pushHandle",
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];

      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          // eslint-disable-next-line no-param-reassign
          bounds[handle] = originalValue;
          return false;
        }

        currentValue = bounds[handle];
      } // the handle was pushed enough to create the needed `amount` gap


      return true;
    }
  }, {
    key: "pushHandleOnePoint",
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;

      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }

      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var diffToNext = direction * (bounds[nextHandle] - nextValue);

      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      } // push the handle
      // eslint-disable-next-line no-param-reassign


      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue(value) {
      var _this$state2 = this.state,
          handle = _this$state2.handle,
          bounds = _this$state2.bounds;
      return _trimAlignValue({
        value: value,
        handle: handle,
        bounds: bounds,
        props: this.props
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state3 = this.state,
          handle = _this$state3.handle,
          bounds = _this$state3.bounds;
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          vertical = _this$props4.vertical,
          included = _this$props4.included,
          disabled = _this$props4.disabled,
          min = _this$props4.min,
          max = _this$props4.max,
          reverse = _this$props4.reverse,
          handleGenerator = _this$props4.handle,
          trackStyle = _this$props4.trackStyle,
          handleStyle = _this$props4.handleStyle,
          tabIndex = _this$props4.tabIndex,
          ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles,
          ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles,
          ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });
      var handleClassName = "".concat(prefixCls, "-handle");
      var handles = bounds.map(function (v, i) {
        var _classNames;

        var mergedTabIndex = tabIndex[i] || 0;

        if (disabled || tabIndex[i] === null) {
          mergedTabIndex = null;
        }

        var dragging = handle === i;
        return handleGenerator({
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, handleClassName, true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          dragging: dragging,
          offset: offsets[i],
          value: v,
          index: i,
          tabIndex: mergedTabIndex,
          min: min,
          max: max,
          reverse: reverse,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          },
          ariaLabel: ariaLabelGroupForHandles[i],
          ariaLabelledBy: ariaLabelledByGroupForHandles[i],
          ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
        });
      });
      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classNames2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-track"), true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Track__["a" /* default */], {
          className: trackClassName,
          vertical: vertical,
          reverse: reverse,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });
      return {
        tracks: tracks,
        handles: handles
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props || 'min' in props || 'max' in props) {
        var value = props.value || state.bounds;
        var nextBounds = value.map(function (v, i) {
          return _trimAlignValue({
            value: v,
            handle: i,
            bounds: state.bounds,
            props: props
          });
        });

        if (nextBounds.length === state.bounds.length && nextBounds.every(function (v, i) {
          return v === state.bounds[i];
        })) {
          return null;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          bounds: nextBounds
        });
      }

      return null;
    }
  }]);

  return Range;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
/* eslint-enable */


Range.displayName = 'Range';
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: [],
  ariaLabelGroupForHandles: [],
  ariaLabelledByGroupForHandles: [],
  ariaValueTextFormatterGroupForHandles: []
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__common_createSlider__["a" /* default */])(Range));

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSliderWithTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_tooltip__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Handle__ = __webpack_require__(371);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function createSliderWithTooltip(Component) {
  var _a;

  return _a = /*#__PURE__*/function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(ComponentWrapper, _React$Component);

    var _super = _createSuper(ComponentWrapper);

    function ComponentWrapper() {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ComponentWrapper);

      _this = _super.apply(this, arguments);
      _this.state = {
        visibles: {}
      };

      _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: _objectSpread(_objectSpread({}, prevState.visibles), {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, index, visible))
          };
        });
      };

      _this.handleWithTooltip = function (_ref) {
        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["value", "dragging", "index", "disabled"]);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle,
            getTooltipContainer = _this$props.getTooltipContainer;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === void 0 ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === void 0 ? false : _tipProps$visible,
            restTooltipProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(tipProps, ["prefixCls", "overlay", "placement", "visible"]);

        var handleStyleWithIndex;

        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_rc_tooltip__["a" /* default */], Object.assign({}, restTooltipProps, {
          getTooltipContainer: getTooltipContainer,
          prefixCls: prefixCls,
          overlay: overlay,
          placement: placement,
          visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
          key: index
        }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Handle__["a" /* default */], Object.assign({}, restProps, {
          style: _objectSpread({}, handleStyleWithIndex),
          value: value,
          onMouseEnter: function onMouseEnter() {
            return _this.handleTooltipVisibleChange(index, true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this.handleTooltipVisibleChange(index, false);
          }
        })));
      };

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(ComponentWrapper, [{
      key: "render",
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, Object.assign({}, this.props, {
          handle: this.handleWithTooltip
        }));
      }
    }]);

    return ComponentWrapper;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _a.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },
    handleStyle: [{}],
    tipProps: {},
    getTooltipContainer: function getTooltipContainer(node) {
      return node.parentNode;
    }
  }, _a;
}

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1250);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_trigger__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__placements__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Content__ = __webpack_require__(1275);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var Tooltip = function Tooltip(props, ref) {
  var overlayClassName = props.overlayClassName,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
      _props$mouseEnterDela = props.mouseEnterDelay,
      mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela,
      _props$mouseLeaveDela = props.mouseLeaveDelay,
      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
      overlayStyle = props.overlayStyle,
      _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls,
      children = props.children,
      onVisibleChange = props.onVisibleChange,
      afterVisibleChange = props.afterVisibleChange,
      transitionName = props.transitionName,
      animation = props.animation,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right' : _props$placement,
      _props$align = props.align,
      align = _props$align === void 0 ? {} : _props$align,
      _props$destroyTooltip = props.destroyTooltipOnHide,
      destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip,
      defaultVisible = props.defaultVisible,
      getTooltipContainer = props.getTooltipContainer,
      overlayInnerStyle = props.overlayInnerStyle,
      restProps = _objectWithoutProperties(props, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle"]);

  var domRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(ref, function () {
    return domRef.current;
  });

  var extraProps = _objectSpread({}, restProps);

  if ('visible' in props) {
    extraProps.popupVisible = props.visible;
  }

  var getPopupElement = function getPopupElement() {
    var _props$arrowContent = props.arrowContent,
        arrowContent = _props$arrowContent === void 0 ? null : _props$arrowContent,
        overlay = props.overlay,
        id = props.id;
    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "".concat(prefixCls, "-arrow"),
      key: "arrow"
    }, arrowContent), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Content__["a" /* default */], {
      key: "content",
      prefixCls: prefixCls,
      id: id,
      overlay: overlay,
      overlayInnerStyle: overlayInnerStyle
    })];
  };

  var destroyTooltip = false;
  var autoDestroy = false;

  if (typeof destroyTooltipOnHide === 'boolean') {
    destroyTooltip = destroyTooltipOnHide;
  } else if (destroyTooltipOnHide && _typeof(destroyTooltipOnHide) === 'object') {
    var keepParent = destroyTooltipOnHide.keepParent;
    destroyTooltip = keepParent === true;
    autoDestroy = keepParent === false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_rc_trigger__["a" /* default */], Object.assign({
    popupClassName: overlayClassName,
    prefixCls: prefixCls,
    popup: getPopupElement,
    action: trigger,
    builtinPlacements: __WEBPACK_IMPORTED_MODULE_2__placements__["a" /* placements */],
    popupPlacement: placement,
    ref: domRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    defaultPopupVisible: defaultVisible,
    destroyPopupOnHide: destroyTooltip,
    autoDestroy: autoDestroy,
    mouseLeaveDelay: mouseLeaveDelay,
    popupStyle: overlayStyle,
    mouseEnterDelay: mouseEnterDelay
  }, extraProps), children);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(Tooltip));

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_findDOMNode__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ref__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_addEventListener__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Portal__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_alignUtil__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Popup__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__context__ = __webpack_require__(1273);


















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
/**
 * Internal usage. Do not use in your code since this will be removed.
 */

function generateTrigger(PortalComponent) {
  var Trigger = /*#__PURE__*/function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Trigger, _React$Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Trigger);

    function Trigger(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Trigger);

      _this = _super.call(this, props);
      _this.popupRef = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef();
      _this.triggerRef = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef();

      _this.onMouseEnter = function (e) {
        var mouseEnterDelay = _this.props.mouseEnterDelay;

        _this.fireEvents('onMouseEnter', e);

        _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
      };

      _this.onMouseMove = function (e) {
        _this.fireEvents('onMouseMove', e);

        _this.setPoint(e);
      };

      _this.onMouseLeave = function (e) {
        _this.fireEvents('onMouseLeave', e);

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      };

      _this.onPopupMouseEnter = function () {
        _this.clearDelayTimer();
      };

      _this.onPopupMouseLeave = function (e) {
        // https://github.com/react-component/trigger/pull/13
        // react bug?
        if (e.relatedTarget && !e.relatedTarget.setTimeout && _this.popupRef.current && _this.popupRef.current.popupRef.current && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this.popupRef.current.popupRef.current, e.relatedTarget)) {
          return;
        }

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      };

      _this.onFocus = function (e) {
        _this.fireEvents('onFocus', e); // incase focusin and focusout


        _this.clearDelayTimer();

        if (_this.isFocusToShow()) {
          _this.focusTime = Date.now();

          _this.delaySetPopupVisible(true, _this.props.focusDelay);
        }
      };

      _this.onMouseDown = function (e) {
        _this.fireEvents('onMouseDown', e);

        _this.preClickTime = Date.now();
      };

      _this.onTouchStart = function (e) {
        _this.fireEvents('onTouchStart', e);

        _this.preTouchTime = Date.now();
      };

      _this.onBlur = function (e) {
        _this.fireEvents('onBlur', e);

        _this.clearDelayTimer();

        if (_this.isBlurToHide()) {
          _this.delaySetPopupVisible(false, _this.props.blurDelay);
        }
      };

      _this.onContextMenu = function (e) {
        e.preventDefault();

        _this.fireEvents('onContextMenu', e);

        _this.setPopupVisible(true, e);
      };

      _this.onContextMenuClose = function () {
        if (_this.isContextMenuToShow()) {
          _this.close();
        }
      };

      _this.onClick = function (event) {
        _this.fireEvents('onClick', event); // focus will trigger click


        if (_this.focusTime) {
          var preTime;

          if (_this.preClickTime && _this.preTouchTime) {
            preTime = Math.min(_this.preClickTime, _this.preTouchTime);
          } else if (_this.preClickTime) {
            preTime = _this.preClickTime;
          } else if (_this.preTouchTime) {
            preTime = _this.preTouchTime;
          }

          if (Math.abs(preTime - _this.focusTime) < 20) {
            return;
          }

          _this.focusTime = 0;
        }

        _this.preClickTime = 0;
        _this.preTouchTime = 0; // Only prevent default when all the action is click.
        // https://github.com/ant-design/ant-design/issues/17043
        // https://github.com/ant-design/ant-design/issues/17291

        if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) {
          event.preventDefault();
        }

        var nextVisible = !_this.state.popupVisible;

        if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) {
          _this.setPopupVisible(!_this.state.popupVisible, event);
        }
      };

      _this.onPopupMouseDown = function () {
        _this.hasPopupMouseDown = true;
        clearTimeout(_this.mouseDownTimeout);
        _this.mouseDownTimeout = window.setTimeout(function () {
          _this.hasPopupMouseDown = false;
        }, 0);

        if (_this.context) {
          var _this$context;

          (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
        }
      };

      _this.onDocumentClick = function (event) {
        if (_this.props.mask && !_this.props.maskClosable) {
          return;
        }

        var target = event.target;

        var root = _this.getRootDomNode();

        var popupNode = _this.getPopupDomNode();

        if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(popupNode, target) && !_this.hasPopupMouseDown) {
          _this.close();
        }
      };

      _this.getRootDomNode = function () {
        var getTriggerDOMNode = _this.props.getTriggerDOMNode;

        if (getTriggerDOMNode) {
          return getTriggerDOMNode(_this.triggerRef.current);
        }

        try {
          var domNode = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_findDOMNode__["a" /* default */])(_this.triggerRef.current);

          if (domNode) {
            return domNode;
          }
        } catch (err) {// Do nothing
        }

        return __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
      };

      _this.getPopupClassNameFromAlign = function (align) {
        var className = [];
        var _this$props = _this.props,
            popupPlacement = _this$props.popupPlacement,
            builtinPlacements = _this$props.builtinPlacements,
            prefixCls = _this$props.prefixCls,
            alignPoint = _this$props.alignPoint,
            getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;

        if (popupPlacement && builtinPlacements) {
          className.push(Object(__WEBPACK_IMPORTED_MODULE_14__utils_alignUtil__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
        }

        if (getPopupClassNameFromAlign) {
          className.push(getPopupClassNameFromAlign(align));
        }

        return className.join(' ');
      };

      _this.getComponent = function () {
        var _this$props2 = _this.props,
            prefixCls = _this$props2.prefixCls,
            destroyPopupOnHide = _this$props2.destroyPopupOnHide,
            popupClassName = _this$props2.popupClassName,
            onPopupAlign = _this$props2.onPopupAlign,
            popupMotion = _this$props2.popupMotion,
            popupAnimation = _this$props2.popupAnimation,
            popupTransitionName = _this$props2.popupTransitionName,
            popupStyle = _this$props2.popupStyle,
            mask = _this$props2.mask,
            maskAnimation = _this$props2.maskAnimation,
            maskTransitionName = _this$props2.maskTransitionName,
            maskMotion = _this$props2.maskMotion,
            zIndex = _this$props2.zIndex,
            popup = _this$props2.popup,
            stretch = _this$props2.stretch,
            alignPoint = _this$props2.alignPoint;
        var _this$state = _this.state,
            popupVisible = _this$state.popupVisible,
            point = _this$state.point;

        var align = _this.getPopupAlign();

        var mouseProps = {};

        if (_this.isMouseEnterToShow()) {
          mouseProps.onMouseEnter = _this.onPopupMouseEnter;
        }

        if (_this.isMouseLeaveToHide()) {
          mouseProps.onMouseLeave = _this.onPopupMouseLeave;
        }

        mouseProps.onMouseDown = _this.onPopupMouseDown;
        mouseProps.onTouchStart = _this.onPopupMouseDown;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Popup__["a" /* default */], Object.assign({
          prefixCls: prefixCls,
          destroyPopupOnHide: destroyPopupOnHide,
          visible: popupVisible,
          point: alignPoint && point,
          className: popupClassName,
          align: align,
          onAlign: onPopupAlign,
          animation: popupAnimation,
          getClassNameFromAlign: _this.getPopupClassNameFromAlign
        }, mouseProps, {
          stretch: stretch,
          getRootDomNode: _this.getRootDomNode,
          style: popupStyle,
          mask: mask,
          zIndex: zIndex,
          transitionName: popupTransitionName,
          maskAnimation: maskAnimation,
          maskTransitionName: maskTransitionName,
          maskMotion: maskMotion,
          ref: _this.popupRef,
          motion: popupMotion
        }), typeof popup === 'function' ? popup() : popup);
      };

      _this.getContainer = function () {
        var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
            props = _assertThisInitialize.props;

        var popupContainer = document.createElement('div'); // Make sure default popup container will never cause scrollbar appearing
        // https://github.com/react-component/trigger/issues/41

        popupContainer.style.position = 'absolute';
        popupContainer.style.top = '0';
        popupContainer.style.left = '0';
        popupContainer.style.width = '100%';
        var mountNode = props.getPopupContainer ? props.getPopupContainer(_this.getRootDomNode()) : props.getDocument().body;
        mountNode.appendChild(popupContainer);
        return popupContainer;
      };

      _this.setPoint = function (point) {
        var alignPoint = _this.props.alignPoint;
        if (!alignPoint || !point) return;

        _this.setState({
          point: {
            pageX: point.pageX,
            pageY: point.pageY
          }
        });
      };

      _this.handlePortalUpdate = function () {
        if (_this.state.prevPopupVisible !== _this.state.popupVisible) {
          _this.props.afterPopupVisibleChange(_this.state.popupVisible);
        }
      };

      var popupVisible;

      if ('popupVisible' in props) {
        popupVisible = !!props.popupVisible;
      } else {
        popupVisible = !!props.defaultPopupVisible;
      }

      _this.state = {
        prevPopupVisible: popupVisible,
        popupVisible: popupVisible
      };
      ALL_HANDLERS.forEach(function (h) {
        _this["fire".concat(h)] = function (e) {
          _this.fireEvents(h, e);
        };
      });
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Trigger, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;
        var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
        // https://github.com/ant-design/ant-design/issues/5804
        // https://github.com/react-component/calendar/issues/250
        // https://github.com/react-component/trigger/issues/50

        if (state.popupVisible) {
          var currentDocument;

          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
            currentDocument = props.getDocument();
            this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
          } // always hide on mobile


          if (!this.touchOutsideHandler) {
            currentDocument = currentDocument || props.getDocument();
            this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
          } // close popup when trigger type contains 'onContextMenu' and document is scrolling.


          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
            currentDocument = currentDocument || props.getDocument();
            this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
          } // close popup when trigger type contains 'onContextMenu' and window is blur.


          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
            this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
          }

          return;
        }

        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
      }
    }, {
      key: "getPopupDomNode",
      value: function getPopupDomNode() {
        // for test
        if (this.popupRef.current && this.popupRef.current.popupRef.current) {
          return this.popupRef.current.popupRef.current;
        }

        return null;
      }
    }, {
      key: "getPopupAlign",
      value: function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement,
            popupAlign = props.popupAlign,
            builtinPlacements = props.builtinPlacements;

        if (popupPlacement && builtinPlacements) {
          return Object(__WEBPACK_IMPORTED_MODULE_14__utils_alignUtil__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
        }

        return popupAlign;
      }
      /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */

    }, {
      key: "setPopupVisible",
      value: function setPopupVisible(popupVisible, event) {
        var alignPoint = this.props.alignPoint;
        var prevPopupVisible = this.state.popupVisible;
        this.clearDelayTimer();

        if (prevPopupVisible !== popupVisible) {
          if (!('popupVisible' in this.props)) {
            this.setState({
              popupVisible: popupVisible,
              prevPopupVisible: prevPopupVisible
            });
          }

          this.props.onPopupVisibleChange(popupVisible);
        } // Always record the point position since mouseEnterDelay will delay the show


        if (alignPoint && event) {
          this.setPoint(event);
        }
      }
    }, {
      key: "delaySetPopupVisible",
      value: function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;

        var delay = delayS * 1000;
        this.clearDelayTimer();

        if (delay) {
          var point = event ? {
            pageX: event.pageX,
            pageY: event.pageY
          } : null;
          this.delayTimer = window.setTimeout(function () {
            _this2.setPopupVisible(visible, point);

            _this2.clearDelayTimer();
          }, delay);
        } else {
          this.setPopupVisible(visible, event);
        }
      }
    }, {
      key: "clearDelayTimer",
      value: function clearDelayTimer() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }
      }
    }, {
      key: "clearOutsideHandler",
      value: function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
          this.clickOutsideHandler.remove();
          this.clickOutsideHandler = null;
        }

        if (this.contextMenuOutsideHandler1) {
          this.contextMenuOutsideHandler1.remove();
          this.contextMenuOutsideHandler1 = null;
        }

        if (this.contextMenuOutsideHandler2) {
          this.contextMenuOutsideHandler2.remove();
          this.contextMenuOutsideHandler2 = null;
        }

        if (this.touchOutsideHandler) {
          this.touchOutsideHandler.remove();
          this.touchOutsideHandler = null;
        }
      }
    }, {
      key: "createTwoChains",
      value: function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;

        if (childPros[event] && props[event]) {
          return this["fire".concat(event)];
        }

        return childPros[event] || props[event];
      }
    }, {
      key: "isClickToShow",
      value: function isClickToShow() {
        var _this$props3 = this.props,
            action = _this$props3.action,
            showAction = _this$props3.showAction;
        return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
      }
    }, {
      key: "isContextMenuToShow",
      value: function isContextMenuToShow() {
        var _this$props4 = this.props,
            action = _this$props4.action,
            showAction = _this$props4.showAction;
        return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function isClickToHide() {
        var _this$props5 = this.props,
            action = _this$props5.action,
            hideAction = _this$props5.hideAction;
        return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function isMouseEnterToShow() {
        var _this$props6 = this.props,
            action = _this$props6.action,
            showAction = _this$props6.showAction;
        return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function isMouseLeaveToHide() {
        var _this$props7 = this.props,
            action = _this$props7.action,
            hideAction = _this$props7.hideAction;
        return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function isFocusToShow() {
        var _this$props8 = this.props,
            action = _this$props8.action,
            showAction = _this$props8.showAction;
        return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function isBlurToHide() {
        var _this$props9 = this.props,
            action = _this$props9.action,
            hideAction = _this$props9.hideAction;
        return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function forcePopupAlign() {
        if (this.state.popupVisible && this.popupRef.current && this.popupRef.current.alignRef.current) {
          this.popupRef.current.alignRef.current.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function fireEvents(type, e) {
        var childCallback = this.props.children.props[type];

        if (childCallback) {
          childCallback(e);
        }

        var callback = this.props[type];

        if (callback) {
          callback(e);
        }
      }
    }, {
      key: "close",
      value: function close() {
        this.setPopupVisible(false);
      }
    }, {
      key: "render",
      value: function render() {
        var popupVisible = this.state.popupVisible;
        var _this$props10 = this.props,
            children = _this$props10.children,
            forceRender = _this$props10.forceRender,
            alignPoint = _this$props10.alignPoint,
            className = _this$props10.className,
            autoDestroy = _this$props10.autoDestroy;
        var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
        var newChildProps = {
          key: 'trigger'
        };

        if (this.isContextMenuToShow()) {
          newChildProps.onContextMenu = this.onContextMenu;
        } else {
          newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
        }

        if (this.isClickToHide() || this.isClickToShow()) {
          newChildProps.onClick = this.onClick;
          newChildProps.onMouseDown = this.onMouseDown;
          newChildProps.onTouchStart = this.onTouchStart;
        } else {
          newChildProps.onClick = this.createTwoChains('onClick');
          newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
          newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
        }

        if (this.isMouseEnterToShow()) {
          newChildProps.onMouseEnter = this.onMouseEnter;

          if (alignPoint) {
            newChildProps.onMouseMove = this.onMouseMove;
          }
        } else {
          newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
        }

        if (this.isMouseLeaveToHide()) {
          newChildProps.onMouseLeave = this.onMouseLeave;
        } else {
          newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
        }

        if (this.isFocusToShow() || this.isBlurToHide()) {
          newChildProps.onFocus = this.onFocus;
          newChildProps.onBlur = this.onBlur;
        } else {
          newChildProps.onFocus = this.createTwoChains('onFocus');
          newChildProps.onBlur = this.createTwoChains('onBlur');
        }

        var childrenClassName = __WEBPACK_IMPORTED_MODULE_13_classnames___default()(child && child.props && child.props.className, className);

        if (childrenClassName) {
          newChildProps.className = childrenClassName;
        }

        var cloneProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, newChildProps);

        if (Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_ref__["c" /* supportRef */])(child)) {
          cloneProps.ref = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_ref__["a" /* composeRef */])(this.triggerRef, child.ref);
        }

        var trigger = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, cloneProps);
        var portal; // prevent unmounting after it's rendered

        if (popupVisible || this.popupRef.current || forceRender) {
          portal = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PortalComponent, {
            key: "portal",
            getContainer: this.getContainer,
            didUpdate: this.handlePortalUpdate
          }, this.getComponent());
        }

        if (!popupVisible && autoDestroy) {
          portal = null;
        }

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__context__["a" /* default */].Provider, {
          value: {
            onPopupMouseDown: this.onPopupMouseDown
          }
        }, trigger, portal);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref, prevState) {
        var popupVisible = _ref.popupVisible;
        var newState = {};

        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
          newState.popupVisible = popupVisible;
          newState.prevPopupVisible = prevState.popupVisible;
        }

        return newState;
      }
    }]);

    return Trigger;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

  Trigger.contextType = __WEBPACK_IMPORTED_MODULE_16__context__["a" /* default */];
  Trigger.defaultProps = {
    prefixCls: 'rc-trigger-popup',
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop,
    afterPopupVisibleChange: noop,
    onPopupAlign: noop,
    popupClassName: '',
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: false
  };
  return Trigger;
}
/* harmony default export */ __webpack_exports__["a"] = (generateTrigger(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_Portal__["a" /* default */]));

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1254);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(173);


function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }

  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements = Object.keys(builtinPlacements);

  for (var i = 0; i < placements.length; i += 1) {
    var placement = placements[i];

    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }

  return '';
}

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raf__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_align__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ref__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_motion__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PopupInner__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_legacyUtil__ = __webpack_require__(1272);







/* eslint-disable no-param-reassign */









function supportMotion(motion) {
  return motion && motion.motionName;
}

var Popup = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Popup, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Popup);

  function Popup() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Popup);

    _this = _super.apply(this, arguments);
    _this.state = {
      targetWidth: undefined,
      targetHeight: undefined,
      status: null,
      prevVisible: null,
      alignClassName: null,
      inMotion: false
    };
    _this.popupRef = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef();
    _this.alignRef = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef();
    _this.nextFrameState = null;
    _this.nextFrameId = null;

    _this.onAlign = function (popupDomNode, align) {
      var status = _this.state.status;
      var _this$props = _this.props,
          getClassNameFromAlign = _this$props.getClassNameFromAlign,
          onAlign = _this$props.onAlign;
      var alignClassName = getClassNameFromAlign(align);

      if (status === 'align') {
        _this.setState({
          alignClassName: alignClassName,
          status: 'aligned'
        }, function () {
          _this.alignRef.current.forceAlign();
        });
      } else if (status === 'aligned') {
        _this.setState({
          alignClassName: alignClassName,
          status: 'afterAlign'
        });

        onAlign(popupDomNode, align);
      } else {
        _this.setState({
          alignClassName: alignClassName
        });
      }
    };

    _this.onMotionEnd = function () {
      var visible = _this.props.visible;

      _this.setState({
        status: visible ? 'AfterMotion' : 'stable',
        inMotion: false
      });
    };

    _this.setStateOnNextFrame = function (state) {
      _this.cancelFrameState();

      _this.nextFrameState = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, _this.nextFrameState), state);
      _this.nextFrameId = __WEBPACK_IMPORTED_MODULE_7_raf___default()(function () {
        var submitState = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, _this.nextFrameState);

        _this.nextFrameState = null;

        _this.setState(submitState);
      });
    };

    _this.getMotion = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_13__utils_legacyUtil__["a" /* getMotion */])(_this.props));
    }; // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align


    _this.getAlignTarget = function () {
      var _this$props2 = _this.props,
          point = _this$props2.point,
          getRootDomNode = _this$props2.getRootDomNode;

      if (point) {
        return point;
      }

      return getRootDomNode;
    };

    _this.cancelFrameState = function () {
      __WEBPACK_IMPORTED_MODULE_7_raf___default.a.cancel(_this.nextFrameId);
    };

    _this.renderPopupElement = function () {
      var _this$state = _this.state,
          status = _this$state.status,
          targetHeight = _this$state.targetHeight,
          targetWidth = _this$state.targetWidth,
          alignClassName = _this$state.alignClassName;
      var _this$props3 = _this.props,
          prefixCls = _this$props3.prefixCls,
          className = _this$props3.className,
          style = _this$props3.style,
          stretch = _this$props3.stretch,
          visible = _this$props3.visible,
          align = _this$props3.align,
          destroyPopupOnHide = _this$props3.destroyPopupOnHide,
          onMouseEnter = _this$props3.onMouseEnter,
          onMouseLeave = _this$props3.onMouseLeave,
          onMouseDown = _this$props3.onMouseDown,
          onTouchStart = _this$props3.onTouchStart,
          children = _this$props3.children;
      var mergedClassName = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(prefixCls, className, alignClassName);
      var hiddenClassName = "".concat(prefixCls, "-hidden"); // ================== Style ==================

      var sizeStyle = {};

      if (stretch) {
        // Stretch with target
        if (stretch.indexOf('height') !== -1) {
          sizeStyle.height = targetHeight;
        } else if (stretch.indexOf('minHeight') !== -1) {
          sizeStyle.minHeight = targetHeight;
        }

        if (stretch.indexOf('width') !== -1) {
          sizeStyle.width = targetWidth;
        } else if (stretch.indexOf('minWidth') !== -1) {
          sizeStyle.minWidth = targetWidth;
        }
      }

      var mergedStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, sizeStyle), _this.getZIndexStyle()), style), {}, {
        opacity: status === 'stable' || !visible ? undefined : 0
      }); // ================= Motions =================


      var mergedMotion = _this.getMotion();

      var mergedMotionVisible = visible;

      if (visible && status !== 'beforeMotion' && status !== 'motion' && status !== 'stable') {
        mergedMotion.motionAppear = false;
        mergedMotion.motionEnter = false;
        mergedMotion.motionLeave = false;
      }

      if (status === 'afterAlign' || status === 'beforeMotion') {
        mergedMotionVisible = false;
      } // Update trigger to tell if is in motion


      ['onEnterStart', 'onAppearStart', 'onLeaveStart'].forEach(function (event) {
        var originFunc = mergedMotion === null || mergedMotion === void 0 ? void 0 : mergedMotion[event];

        mergedMotion[event] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          originFunc === null || originFunc === void 0 ? void 0 : originFunc.apply(void 0, args);

          _this.setState({
            inMotion: true
          });
        };
      }); // ================== Align ==================

      var mergedAlignDisabled = !visible || status !== 'align' && status !== 'aligned' && status !== 'stable'; // ================== Popup ==================

      var mergedPopupVisible = true;

      if (status === 'stable') {
        mergedPopupVisible = visible;
      } // Only remove popup since mask may still need animation


      if (destroyPopupOnHide && !mergedPopupVisible) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_rc_motion__["a" /* default */], Object.assign({
        visible: mergedMotionVisible
      }, mergedMotion, {
        removeOnLeave: false,
        onEnterEnd: _this.onMotionEnd,
        onLeaveEnd: _this.onMotionEnd,
        leavedClassName: hiddenClassName
      }), function (_ref, motionRef) {
        var motionStyle = _ref.style,
            motionClassName = _ref.className;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_rc_align__["a" /* default */], {
          target: _this.getAlignTarget(),
          key: "popup",
          ref: _this.alignRef,
          monitorWindowResize: true,
          disabled: mergedAlignDisabled,
          align: align,
          onAlign: _this.onAlign
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PopupInner__["a" /* default */], {
          prefixCls: prefixCls,
          className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(mergedClassName, motionClassName),
          ref: Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_ref__["a" /* composeRef */])(motionRef, _this.popupRef),
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          onMouseDown: onMouseDown,
          onTouchStart: onTouchStart,
          style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, mergedStyle), motionStyle)
        }, children));
      });
    };

    _this.renderMaskElement = function () {
      var _this$props4 = _this.props,
          mask = _this$props4.mask,
          maskMotion = _this$props4.maskMotion,
          maskTransitionName = _this$props4.maskTransitionName,
          maskAnimation = _this$props4.maskAnimation,
          prefixCls = _this$props4.prefixCls,
          visible = _this$props4.visible;

      if (!mask) {
        return null;
      }

      var motion = {};

      if (maskMotion && maskMotion.motionName) {
        motion = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          motionAppear: true
        }, Object(__WEBPACK_IMPORTED_MODULE_13__utils_legacyUtil__["a" /* getMotion */])({
          motion: maskMotion,
          prefixCls: prefixCls,
          transitionName: maskTransitionName,
          animation: maskAnimation
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_rc_motion__["a" /* default */], Object.assign({}, motion, {
        visible: visible,
        removeOnLeave: true
      }), function (_ref2) {
        var className = _ref2.className;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
          style: _this.getZIndexStyle(),
          key: "mask",
          className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()("".concat(prefixCls, "-mask"), className)
        });
      });
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var status = this.state.status;
      var _this$props5 = this.props,
          getRootDomNode = _this$props5.getRootDomNode,
          visible = _this$props5.visible,
          stretch = _this$props5.stretch; // If there is a pending state update, cancel it, a new one will be set if necessary

      this.cancelFrameState();

      if (visible && status !== 'stable') {
        switch (status) {
          case null:
            {
              this.setStateOnNextFrame({
                status: stretch ? 'measure' : 'align'
              });
              break;
            }

          case 'afterAlign':
            {
              this.setStateOnNextFrame({
                status: supportMotion(this.getMotion()) ? 'beforeMotion' : 'stable'
              });
              break;
            }

          case 'AfterMotion':
            {
              this.setStateOnNextFrame({
                status: 'stable'
              });
              break;
            }

          default:
            {
              // Go to next status
              var queue = ['measure', 'align', null, 'beforeMotion', 'motion'];
              var index = queue.indexOf(status);
              var nextStatus = queue[index + 1];

              if (index !== -1 && nextStatus) {
                this.setStateOnNextFrame({
                  status: nextStatus
                });
              }
            }
        }
      } // Measure stretch size


      if (status === 'measure') {
        var $ele = getRootDomNode();

        if ($ele) {
          this.setStateOnNextFrame({
            targetHeight: $ele.offsetHeight,
            targetWidth: $ele.offsetWidth
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelFrameState();
    }
  }, {
    key: "getZIndexStyle",
    value: function getZIndexStyle() {
      var zIndex = this.props.zIndex;
      return {
        zIndex: zIndex
      };
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", null, this.renderMaskElement(), this.renderPopupElement());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, _ref4) {
      var visible = _ref3.visible,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref3, ["visible"]);

      var prevVisible = _ref4.prevVisible,
          status = _ref4.status,
          inMotion = _ref4.inMotion;
      var newState = {
        prevVisible: visible,
        status: status
      };
      var mergedMotion = Object(__WEBPACK_IMPORTED_MODULE_13__utils_legacyUtil__["a" /* getMotion */])(props);

      if (prevVisible === null && visible === false) {
        // Init render should always be stable
        newState.status = 'stable';
        newState.inMotion = false;
      } else if (visible !== prevVisible) {
        newState.inMotion = false;

        if (visible || supportMotion(mergedMotion) && inMotion) {
          newState.status = null;
        } else {
          newState.status = 'stable';
        }

        if (visible) {
          newState.alignClassName = null;
        }
      }

      return newState;
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Popup);
/* eslint-enable */

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(567)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(1260);
// export this package's api

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_ref__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_align__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_addEventListener__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks_useBuffer__ = __webpack_require__(1266);



/**
 * Removed props:
 *  - childrenProps
 */







function getElement(func) {
  if (typeof func !== 'function') return null;
  return func();
}

function getPoint(point) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(point) !== 'object' || !point) return null;
  return point;
}

var Align = function Align(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      target = _ref.target,
      align = _ref.align,
      onAlign = _ref.onAlign,
      monitorWindowResize = _ref.monitorWindowResize,
      _ref$monitorBufferTim = _ref.monitorBufferTime,
      monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
  var cacheRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef({});
  var nodeRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var childNode = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children); // ===================== Align ======================
  // We save the props here to avoid closure makes props ood

  var forceAlignPropsRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef({});
  forceAlignPropsRef.current.disabled = disabled;
  forceAlignPropsRef.current.target = target;
  forceAlignPropsRef.current.onAlign = onAlign;

  var _useBuffer = Object(__WEBPACK_IMPORTED_MODULE_7__hooks_useBuffer__["a" /* default */])(function () {
    var _forceAlignPropsRef$c = forceAlignPropsRef.current,
        latestDisabled = _forceAlignPropsRef$c.disabled,
        latestTarget = _forceAlignPropsRef$c.target;

    if (!latestDisabled && latestTarget) {
      var source = nodeRef.current;
      var result;
      var element = getElement(latestTarget);
      var point = getPoint(latestTarget);
      cacheRef.current.element = element;
      cacheRef.current.point = point; // IE lose focus after element realign
      // We should record activeElement and restore later

      var _document = document,
          activeElement = _document.activeElement;

      if (element) {
        result = Object(__WEBPACK_IMPORTED_MODULE_4_dom_align__["a" /* alignElement */])(source, element, align);
      } else if (point) {
        result = Object(__WEBPACK_IMPORTED_MODULE_4_dom_align__["b" /* alignPoint */])(source, point, align);
      }

      Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* restoreFocus */])(activeElement, source);

      if (onAlign) {
        onAlign(source, result);
      }

      return true;
    }

    return false;
  }, monitorBufferTime),
      _useBuffer2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useBuffer, 2),
      _forceAlign = _useBuffer2[0],
      cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
  // Listen for target updated


  var resizeMonitor = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef({
    cancel: function cancel() {}
  }); // Listen for source updated

  var sourceResizeMonitor = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef({
    cancel: function cancel() {}
  });
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    var element = getElement(target);
    var point = getPoint(target);

    if (nodeRef.current !== sourceResizeMonitor.current.element) {
      sourceResizeMonitor.current.cancel();
      sourceResizeMonitor.current.element = nodeRef.current;
      sourceResizeMonitor.current.cancel = Object(__WEBPACK_IMPORTED_MODULE_6__util__["b" /* monitorResize */])(nodeRef.current, _forceAlign);
    }

    if (cacheRef.current.element !== element || !Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* isSamePoint */])(cacheRef.current.point, point)) {
      _forceAlign(); // Add resize observer


      if (resizeMonitor.current.element !== element) {
        resizeMonitor.current.cancel();
        resizeMonitor.current.element = element;
        resizeMonitor.current.cancel = Object(__WEBPACK_IMPORTED_MODULE_6__util__["b" /* monitorResize */])(element, _forceAlign);
      }
    }
  }); // Listen for disabled change

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (!disabled) {
      _forceAlign();
    } else {
      cancelForceAlign();
    }
  }, [disabled]); // Listen for window resize

  var winResizeRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (monitorWindowResize) {
      if (!winResizeRef.current) {
        winResizeRef.current = Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', _forceAlign);
      }
    } else if (winResizeRef.current) {
      winResizeRef.current.remove();
      winResizeRef.current = null;
    }
  }, [monitorWindowResize]); // Clear all if unmount

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      resizeMonitor.current.cancel();
      sourceResizeMonitor.current.cancel();
      if (winResizeRef.current) winResizeRef.current.remove();
      cancelForceAlign();
    };
  }, []); // ====================== Ref =======================

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useImperativeHandle(ref, function () {
    return {
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    };
  }); // ===================== Render =====================

  if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(childNode)) {
    childNode = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(childNode, {
      ref: Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_ref__["a" /* composeRef */])(childNode.ref, nodeRef)
    });
  }

  return childNode;
};

var RefAlign = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(Align);
RefAlign.displayName = 'Align';
/* harmony default export */ __webpack_exports__["a"] = (RefAlign);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["c"] = restoreFocus;
/* harmony export (immutable) */ __webpack_exports__["b"] = monitorResize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_Dom_contains__ = __webpack_require__(564);



function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}
function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement) && typeof activeElement.focus === 'function') {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;

  function onResize(_ref) {
    var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 1),
        target = _ref2[0].target;

    var _target$getBoundingCl = target.getBoundingClientRect(),
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;

    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);

    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      callback({
        width: fixedWidth,
        height: fixedHeight
      });
    }

    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }

  var resizeObserver = new __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__["a" /* default */](onResize);

  if (element) {
    resizeObserver.observe(element);
  }

  return function () {
    resizeObserver.disconnect();
  };
}

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (function (callback, buffer) {
  var calledRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
  var timeoutRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(null);

  function cancelTrigger() {
    window.clearTimeout(timeoutRef.current);
  }

  function trigger(force) {
    if (!calledRef.current || force === true) {
      if (callback() === false) {
        // Not delay since callback cancelled self
        return;
      }

      calledRef.current = true;
      cancelTrigger();
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
      }, buffer);
    } else {
      cancelTrigger();
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
        trigger();
      }, buffer);
    }
  }

  return [trigger, function () {
    calledRef.current = false;
    cancelTrigger();
  }];
});

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSMotion__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CSSMotionList__ = __webpack_require__(1269);
/* unused harmony reexport CSSMotionList */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__CSSMotion__["a" /* default */]);

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(567)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genCSSMotionList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CSSMotion__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_motion__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_diff__ = __webpack_require__(1270);







/* eslint react/prop-types: 0 */




var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_7__CSSMotion__["a" /* default */];

  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(CSSMotionList, _React$Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(CSSMotionList);

    function CSSMotionList() {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, CSSMotionList);

      _this = _super.apply(this, arguments);
      _this.state = {
        keyEntities: []
      };

      _this.removeKey = function (removeKey) {
        _this.setState(function (_ref) {
          var keyEntities = _ref.keyEntities;
          return {
            keyEntities: keyEntities.map(function (entity) {
              if (entity.key !== removeKey) return entity;
              return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, entity), {}, {
                status: __WEBPACK_IMPORTED_MODULE_9__util_diff__["d" /* STATUS_REMOVED */]
              });
            })
          };
        });
      };

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var keyEntities = this.state.keyEntities;

        var _this$props = this.props,
            component = _this$props.component,
            children = _this$props.children,
            restProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props, ["component", "children"]);

        var Component = component || __WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, Object.assign({}, restProps), keyEntities.map(function (_ref2) {
          var status = _ref2.status,
              eventProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref2, ["status"]);

          var visible = status === __WEBPACK_IMPORTED_MODULE_9__util_diff__["a" /* STATUS_ADD */] || status === __WEBPACK_IMPORTED_MODULE_9__util_diff__["b" /* STATUS_KEEP */];
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CSSMotion, Object.assign({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onLeaveEnd: function onLeaveEnd() {
              if (motionProps.onLeaveEnd) {
                motionProps.onLeaveEnd.apply(motionProps, arguments);
              }

              _this2.removeKey(eventProps.key);
            }
          }), children);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = Object(__WEBPACK_IMPORTED_MODULE_9__util_diff__["f" /* parseKeys */])(keys); // Always as keep when motion not support

        if (!transitionSupport) {
          return {
            keyEntities: parsedKeyObjects.map(function (obj) {
              return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, obj), {}, {
                status: __WEBPACK_IMPORTED_MODULE_9__util_diff__["b" /* STATUS_KEEP */]
              });
            })
          };
        }

        var mixedKeyEntities = Object(__WEBPACK_IMPORTED_MODULE_9__util_diff__["e" /* diffKeys */])(keyEntities, parsedKeyObjects);
        var keyEntitiesLen = keyEntities.length;
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            // IE 9 not support Array.prototype.find
            var prevEntity = null;

            for (var i = 0; i < keyEntitiesLen; i += 1) {
              var currentEntity = keyEntities[i];

              if (currentEntity.key === entity.key) {
                prevEntity = currentEntity;
                break;
              }
            } // Remove if already mark as removed


            if (prevEntity && prevEntity.status === __WEBPACK_IMPORTED_MODULE_9__util_diff__["d" /* STATUS_REMOVED */] && entity.status === __WEBPACK_IMPORTED_MODULE_9__util_diff__["c" /* STATUS_REMOVE */]) {
              return false;
            }

            return true;
          })
        };
      }
    }]);

    return CSSMotionList;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

  CSSMotionList.defaultProps = {
    component: 'div'
  };
  return CSSMotionList;
}
/* unused harmony default export */ var _unused_webpack_default_export = (genCSSMotionList(__WEBPACK_IMPORTED_MODULE_8__util_motion__["c" /* supportTransition */]));

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_KEEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_REMOVED; });
/* unused harmony export wrapKeyToObject */
/* harmony export (immutable) */ __webpack_exports__["f"] = parseKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = diffKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(172);


var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;

  if (key && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys); // Check prev keys to insert or keep

  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;

    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];

      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }

        list.push(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    } // If not hit, it means key is removed


    if (!hit) {
      list.push(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  }); // Add rest to the list

  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */


  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
          status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    }); // Update `STATUS_ADD` to `STATUS_KEEP`

    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var PopupInner = function PopupInner(props, ref) {
  var prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      children = props.children,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseDown = props.onMouseDown,
      onTouchStart = props.onTouchStart;
  var childNode = children;

  if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) > 1) {
    childNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: ref,
    className: className,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart,
    style: style
  }, childNode);
};

var RefPopupInner = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PopupInner);
RefPopupInner.displayName = 'PopupInner';
/* harmony default export */ __webpack_exports__["a"] = (RefPopupInner);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMotion;
function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      animation = _ref.animation,
      transitionName = _ref.transitionName;

  if (motion) {
    return motion;
  }

  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }

  if (transitionName) {
    return {
      motionName: transitionName
    };
  }

  return null;
}

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TriggerContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* harmony default export */ __webpack_exports__["a"] = (TriggerContext);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Content = function Content(props) {
  var overlay = props.overlay,
      prefixCls = props.prefixCls,
      id = props.id,
      overlayInnerStyle = props.overlayInnerStyle;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    id: id,
    role: "tooltip",
    style: overlayInnerStyle
  }, typeof overlay === 'function' ? overlay() : overlay);
};

/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ActiveFilterList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_FilterType__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActiveFilterItem__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* defineMessages */])({'filter.removeFilterButtonLabel':{'id':'filter.removeFilterButtonLabel','defaultMessage':'Remove filter'}});var ActiveFilterList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ActiveFilterList,_Component);function ActiveFilterList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ActiveFilterList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ActiveFilterList.__proto__||Object.getPrototypeOf(ActiveFilterList)).call.apply(_ref,[this].concat(args))),_this),_this.getTermFilterOptionName=function(filter,activeFilterOptionValue){var optionName='';if(filter.options&&filter.options.length>0){var option=filter.options.find(function(opt){return opt.value===activeFilterOptionValue;});if(option)optionName=option.name;}return optionName;},_this.getFilterValueAsText=function(filter,activeFilterValue,activeFilterMin,activeFilterMax){switch(filter.type){case __WEBPACK_IMPORTED_MODULE_6__types_FilterType__["b" /* default */].TERM:{return _this.getTermFilterOptionName(filter,activeFilterValue);}case __WEBPACK_IMPORTED_MODULE_6__types_FilterType__["b" /* default */].RANGE:{return filter.name+(': '+activeFilterMin+' - '+activeFilterMax);}case __WEBPACK_IMPORTED_MODULE_6__types_FilterType__["b" /* default */].BOOLEAN:{return filter.name;}default:{return activeFilterValue||(activeFilterMin||'')+' - '+(activeFilterMax||'');}}},_this.getActiveFilterItem=function(key,value,removeFilter){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ActiveFilterItem__["a" /* default */],{key:key,value:value,removeFilter:removeFilter,iconMessage:_this.props.intl.formatMessage(messages['filter.removeFilterButtonLabel'])});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ActiveFilterList,[{key:'render',value:function render(){var _this2=this;var activeFilters=this.props.activeFilters;if(activeFilters.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({ActiveFilterList:true,'ActiveFilterList--horizontal':this.props.horizontal})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:'ActiveFilterList__remove-all-button',color:'primary',size:'sm',onClick:this.props.clearFilters},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'filter.removeAllFiltersButton',defaultMessage:'Clear filters'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'times'})),activeFilters.map(function(activeFilter){var activeFilterArray=[];if(activeFilter&&activeFilter.value){Object.values(activeFilter.value).forEach(function(filterItem){activeFilterArray.push(filterItem);});}if(activeFilter.filter.type==='TERM'&&Array.isArray(activeFilterArray)){// If TERM filter, show own button for every option:
return activeFilterArray.sort().map(function(activeFilterValue){return _this2.getActiveFilterItem(activeFilterValue,_this2.getFilterValueAsText(activeFilter.filter,activeFilterValue,activeFilter.min,activeFilter.max),function(){return _this2.props.removeFilter(activeFilter,activeFilterValue);});});}else{return _this2.getActiveFilterItem(activeFilter.key,_this2.getFilterValueAsText(activeFilter.filter,activeFilter.value,activeFilter.min,activeFilter.max),function(){return _this2.props.removeFilter(activeFilter);});}}));}}]);return ActiveFilterList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ActiveFilterList.propTypes={activeFilters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,removeFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,clearFilters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,horizontal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,intl:__WEBPACK_IMPORTED_MODULE_5_react_intl__["f" /* intlShape */].isRequired};ActiveFilterList.defaultProps={horizontal:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["e" /* injectIntl */])(ActiveFilterList));

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActiveFilterItem=function(_Component){_inherits(ActiveFilterItem,_Component);function ActiveFilterItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ActiveFilterItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ActiveFilterItem.__proto__||Object.getPrototypeOf(ActiveFilterItem)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(){var _this$props=_this.props,filter=_this$props.filter,isSelected=_this$props.isSelected,onAccept=_this$props.onAccept;_this.filterContainer.toggleOpen();onAccept(filter,!isSelected);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ActiveFilterItem,[{key:'render',value:function render(){var _props=this.props,iconMessage=_props.iconMessage,value=_props.value,removeFilter=_props.removeFilter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{className:'ActiveFilterItem',size:'sm',color:'link',onClick:removeFilter,title:iconMessage},value,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Icon__["a" /* default */],{name:'times'}));}}]);return ActiveFilterItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ActiveFilterItem.propTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,iconMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,removeFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ActiveFilterItem);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SortSelection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_SortOrder__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ProductStore__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sortNameMessages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({sortDefault:{'id':'sort.default','defaultMessage':'Default'},sortCheapest:{'id':'sort.cheapest','defaultMessage':'Cheapest'},sortMostExpensive:{'id':'sort.mostExpensive','defaultMessage':'Most expensive'},sortLatest:{'id':'sort.latest','defaultMessage':'Latest'},sortMostPopular:{'id':'sort.mostPopular','defaultMessage':'Most popular'},sortBestRated:{'id':'sort.bestRated','defaultMessage':'Best rated'},sortBrand:{'id':'sort.brand','defaultMessage':'Brand'},sortId:{'id':'sort.id','defaultMessage':'Product number'},sortAlphabetical:{'id':'sort.alphabetical','defaultMessage':'Alphabetical'},sortCategory:{'id':'sort.category','defaultMessage':'Product category'},sortDiscount:{'id':'sort.discount','defaultMessage':'Best discount'}});var SortSelection=function(_Component){_inherits(SortSelection,_Component);function SortSelection(props){_classCallCheck(this,SortSelection);var _this=_possibleConstructorReturn(this,(SortSelection.__proto__||Object.getPrototypeOf(SortSelection)).call(this,props));_this.createSortSelection=function(message,sortKey,sortOrder,sortIndex){return{message:message,sortKey:sortKey,sortOrder:sortOrder,sortIndex:sortIndex};};_this.filterActiveSortSelections=function(){var productStore=_this.props.productStore;var activeProductSortSelectors=productStore.activeProductSortList();var activeSortSelections=_this.sortSelections.filter(function(ss){return activeProductSortSelectors.find(function(sort){return sort.sortIndex===ss.sortIndex;});});if(!activeSortSelections.length){return;}_this.sortSelections=activeSortSelections.splice(0,0,_this.sortSelections[0]);_this.sortSelections=activeSortSelections;};_this.getSelected=function(sortKey,sortOrder){return _this.sortSelections.find(function(ss){return ss.sortKey===sortKey&&ss.sortOrder===sortOrder;});};_this.toggleOpen=function(){return _this.setState({open:!_this.state.open});};_this.state={open:false};_this.sortSelections=[_this.createSortSelection(sortNameMessages.sortDefault,null,null),_this.createSortSelection(sortNameMessages.sortCheapest,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].PRICE,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].ASC,1),_this.createSortSelection(sortNameMessages.sortMostExpensive,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].PRICE,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].DESC,2),_this.createSortSelection(sortNameMessages.sortLatest,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].DATE_ADDED,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].DESC,3),_this.createSortSelection(sortNameMessages.sortMostPopular,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].SALES,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].DESC,4),_this.createSortSelection(sortNameMessages.sortBestRated,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].REVIEWS_AVERAGE,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].DESC,5),_this.createSortSelection(sortNameMessages.sortBrand,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].BRAND,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].ASC,6),_this.createSortSelection(sortNameMessages.sortId,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].ID,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].ASC,7),_this.createSortSelection(sortNameMessages.sortAlphabetical,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].NAME,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].ASC,8),_this.createSortSelection(sortNameMessages.sortCategory,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].CATEGORY,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].ASC,9),_this.createSortSelection(sortNameMessages.sortDiscount,__WEBPACK_IMPORTED_MODULE_5__types_ProductSortOrderBy__["a" /* default */].DISCOUNT,__WEBPACK_IMPORTED_MODULE_6__types_SortOrder__["a" /* default */].DESC,10)];_this.filterActiveSortSelections();return _this;}_createClass(SortSelection,[{key:'render',value:function render(){var open=this.state.open;var _props=this.props,onSelectSort=_props.onSelectSort,selectedSortKey=_props.selectedSortKey,selectedSortOrder=_props.selectedSortOrder,intl=_props.intl;var selectedValue=this.getSelected(selectedSortKey,selectedSortOrder);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'SortSelection'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'sort.sortLabel',defaultMessage:'Sort:'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["o" /* Dropdown */],{isOpen:open,toggle:this.toggleOpen,direction:'down',className:'SortSelection__dropdown'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["r" /* DropdownToggle */],{'data-toggle':'dropdown',color:'plain','aria-expanded':open,className:'SortSelection__dropdown-toggle'},selectedValue?intl.formatMessage(selectedValue.message):intl.formatMessage(this.sortSelections[0].message),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Icon__["a" /* default */],{name:'angle-down',className:'SortSelection__toggle-icon'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["q" /* DropdownMenu */],null,this.sortSelections.map(function(ss){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["p" /* DropdownItem */],{key:ss.sortKey+ss.sortOrder,onClick:function onClick(){return onSelectSort(ss.sortKey,ss.sortOrder);},className:'SortSelection__dropdown-item',active:ss===selectedValue},intl.formatMessage(ss.message));}))));}}]);return SortSelection;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);SortSelection.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ProductStore__["a" /* default */]).isRequired,selectedSortKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selectedSortOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onSelectSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* inject */])('configStore','productStore')(SortSelection)));

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1281);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1282),
    isIterateeCall = __webpack_require__(150),
    toFinite = __webpack_require__(478);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1282 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NoProductsFound=function(_Component){_inherits(NoProductsFound,_Component);function NoProductsFound(){_classCallCheck(this,NoProductsFound);return _possibleConstructorReturn(this,(NoProductsFound.__proto__||Object.getPrototypeOf(NoProductsFound)).apply(this,arguments));}_createClass(NoProductsFound,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NoProductsFound'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__i18n_globalTranslations__["a" /* default */].noProductsFoundSentence));}}]);return NoProductsFound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NoProductsFound);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SEOLink__ = __webpack_require__(528);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SEOPagination=function(_Component){_inherits(SEOPagination,_Component);function SEOPagination(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SEOPagination);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SEOPagination.__proto__||Object.getPrototypeOf(SEOPagination)).call.apply(_ref,[this].concat(args))),_this),_this.getPathForPage=function(page){var path=_this.props.path;return page===1?path:path+'?page='+page;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SEOPagination,[{key:'render',value:function render(){var _props=this.props,currentPage=_props.currentPage,lastPage=_props.lastPage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,currentPage>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SEOLink__["a" /* default */],{rel:'prev',path:this.getPathForPage(currentPage-1)}),currentPage<lastPage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SEOLink__["a" /* default */],{rel:'next',path:this.getPathForPage(currentPage+1)}));}}]);return SEOPagination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SEOPagination.propTypes={currentPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,lastPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SEOPagination);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductListFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_QuickSearch__ = __webpack_require__(319);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({filterList:{'id':'productListFilter.filterList','defaultMessage':'Filter list'}});var ProductListFilter=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ProductListFilter,_Component);function ProductListFilter(){_classCallCheck(this,ProductListFilter);return _possibleConstructorReturn(this,(ProductListFilter.__proto__||Object.getPrototypeOf(ProductListFilter)).apply(this,arguments));}_createClass(ProductListFilter,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,onProductListFiltering=_props.onProductListFiltering,clearProductListFilter=_props.clearProductListFilter,searchTerm=_props.searchTerm,intl=_props.intl;if(!configStore.productListFilter.enabled){return null;}var placeholder=intl.formatMessage(messages.filterList);var productListFilterButtonText=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'productListFilter.filter',defaultMessage:'Filter by keyword'});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductListFilter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__search_QuickSearch__["a" /* default */],{handleFocus:function handleFocus(){return null;},handleBlur:function handleBlur(){return null;},toggleSearch:function toggleSearch(){return null;},productListFilter:true,onProductListFiltering:onProductListFiltering,clearProductListFilter:clearProductListFilter,searchTerm:searchTerm,placeholder:placeholder,buttonText:productListFilterButtonText,quickSearchId:'ProductListFilter__Autosuggest'}));}}]);return ProductListFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ProductListFilter.propTypes={onProductListFiltering:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,clearProductListFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,searchTerm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('categoryStore','configStore','sectionStore','uiStore')(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(ProductListFilter)));

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(302);


/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductTabName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductTabSearchParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_invert__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_invert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_invert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SortOrder__ = __webpack_require__(95);
var ProductTab={RECOMMENDED_PRODUCTS:'1',CAMPAIGN_PRODUCTS:'2',NEW_PRODUCTS:'3',MOST_SOLD_PRODUCTS:'4'};/* harmony default export */ __webpack_exports__["c"] = (ProductTab);var ProductTabName=__WEBPACK_IMPORTED_MODULE_0_lodash_invert___default()(ProductTab);var ProductTabSearchParams={};ProductTabSearchParams[ProductTab.RECOMMENDED_PRODUCTS]={orderBy:__WEBPACK_IMPORTED_MODULE_1__ProductSortOrderBy__["a" /* default */].RECOMMENDED_SORT_ORDER,order:__WEBPACK_IMPORTED_MODULE_2__SortOrder__["a" /* default */].ASC,includeChildProducts:1,includeFilters:0};ProductTabSearchParams[ProductTab.CAMPAIGN_PRODUCTS]={orderBy:__WEBPACK_IMPORTED_MODULE_1__ProductSortOrderBy__["a" /* default */].CAMPAIGN_DATE_ADDED,order:__WEBPACK_IMPORTED_MODULE_2__SortOrder__["a" /* default */].DESC,hasCampaign:1,includeFilters:0};ProductTabSearchParams[ProductTab.NEW_PRODUCTS]={orderBy:__WEBPACK_IMPORTED_MODULE_1__ProductSortOrderBy__["a" /* default */].DATE_ADDED,order:__WEBPACK_IMPORTED_MODULE_2__SortOrder__["a" /* default */].DESC,includeFilters:0};ProductTabSearchParams[ProductTab.MOST_SOLD_PRODUCTS]={orderBy:__WEBPACK_IMPORTED_MODULE_1__ProductSortOrderBy__["a" /* default */].SALES,order:__WEBPACK_IMPORTED_MODULE_2__SortOrder__["a" /* default */].DESC,includeFilters:0};

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(468),
    createInverter = __webpack_require__(1289),
    identity = __webpack_require__(149);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, constant(identity));

module.exports = invert;


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

var baseInverter = __webpack_require__(1290);

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

module.exports = createInverter;


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(423);

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

module.exports = baseInverter;


/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TabProductList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductList__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductListTools__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SimpleProductList__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabProductList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(TabProductList,_Component);function TabProductList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TabProductList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TabProductList.__proto__||Object.getPrototypeOf(TabProductList)).call.apply(_ref,[this].concat(args))),_this),_this.getQueryIdentifier=function(){return Object(__WEBPACK_IMPORTED_MODULE_6__util_query__["a" /* paramsToQueryIdentifier */])(_this.props.searchParams);},_this.getCurrentSearchResult=function(){return _this.props.productStore.productQueryResults.get(_this.getQueryIdentifier());},_this.onStyleSelect=function(style){return _this.props.configStore.setProductListStyle(style);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabProductList,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,productStore=_props.productStore,uiStore=_props.uiStore,searchParams=_props.searchParams,name=_props.name,listComponent=_props.listComponent,completeListingLink=_props.completeListingLink,preloadOnly=_props.preloadOnly,singleRowMode=_props.singleRowMode,requireCanonicalLink=_props.requireCanonicalLink,rest=_objectWithoutProperties(_props,['configStore','productStore','uiStore','searchParams','name','listComponent','completeListingLink','preloadOnly','singleRowMode','requireCanonicalLink']);if(!productStore||!searchParams){return null;}var result=this.getCurrentSearchResult();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'TabProductList'},result&&!preloadOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'TabProductList__active-filter-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductListTools__["a" /* default */],{showSort:false,onStyleSelect:this.onStyleSelect,style:configStore.productListStyle,countOfProducts:result.total}),completeListingLink),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SimpleProductList__["a" /* default */],Object.assign({searchParams:searchParams,name:name,style:configStore.productListStyle,listComponent:listComponent,completeListingLink:result&&result.total>result.data.length?completeListingLink:null,preloadOnly:preloadOnly,singleRowMode:singleRowMode,requireCanonicalLink:requireCanonicalLink},rest)));}}]);return TabProductList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;TabProductList.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_ProductStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_UIStore__["a" /* default */]).isRequired,searchParams:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,listComponent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,completeListingLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,preloadOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,singleRowMode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,requireCanonicalLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};TabProductList.defaultProps={listComponent:__WEBPACK_IMPORTED_MODULE_5__ProductList__["a" /* default */],preloadOnly:false,disableQuickSearch:false,singleRowMode:false,requireCanonicalLink:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('productStore','configStore','uiStore')(TabProductList));

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__anchor_ScrollableAnchor__ = __webpack_require__(129);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleListTabs=function(_Component){_inherits(SimpleListTabs,_Component);function SimpleListTabs(){_classCallCheck(this,SimpleListTabs);return _possibleConstructorReturn(this,(SimpleListTabs.__proto__||Object.getPrototypeOf(SimpleListTabs)).apply(this,arguments));}_createClass(SimpleListTabs,[{key:'render',value:function render(){var tabs=this.props.tabs;if(!tabs||!tabs.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimpleListTabs'},tabs.map(function(tab){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:tab.id,className:'SimpleListTabs__item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimpleListTabs__item-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__anchor_ScrollableAnchor__["a" /* default */],{id:tab.id,offset:15,className:'SimpleListTabs__item-anchor',scrollIfInHash:false}),tab.title),tab.getContent());}));}}]);return SimpleListTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleListTabs.propTypes={tabs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,getContent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (SimpleListTabs);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CategoryGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Category__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_CustomNavigationLinkStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_LinkType__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_MaybeExternalLink__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryGrid=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CategoryGrid,_Component);function CategoryGrid(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CategoryGrid);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CategoryGrid.__proto__||Object.getPrototypeOf(CategoryGrid)).call.apply(_ref,[this].concat(args))),_this),_this.getSubCategoryList=function(subCategories){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'CategoryGrid__subcategories'},subCategories.map(function(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:category.id,className:'CategoryGrid__subcategory-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:_this.getCategoryPath(category),className:'CategoryGrid__subcategory-link'},category.navigationName));}));},_this.getCategoryCard=function(category){var sectionStore=_this.props.sectionStore;var children=sectionStore.activeSection?category.getNonBlockedChildren(sectionStore.activeSection.blockedCategoriesDict):category.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Card */],{className:'CategoryGrid__card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["i" /* CardBody */],null,category.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'CategoryGrid__card-image',src:category.image,alt:category.name,title:category.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'CategoryGrid__card-heading-link',to:_this.getCategoryPath(category)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["k" /* CardTitle */],{tag:'h4'},category.navigationName)),_this.getSubCategoryList(children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:_this.getCategoryPath(category)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].showAllProductsSentence)))));},_this.getCustomNavigationLinks=function(category){var customNavigationLinkStore=_this.props.customNavigationLinkStore;var customNavItems=customNavigationLinkStore.filterByCategoryId(category.id);if(!customNavItems.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,customNavItems.map(function(customNavItem,i){return _this.getCustomNavigationCard(customNavItem,i);}));},_this.getCustomNavigationCard=function(customNavItem,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Card */],{key:i,className:'CategoryGrid__card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_MaybeExternalLink__["a" /* default */],{to:_this.getCustomCategoryPath(customNavItem),type:customNavItem.link_type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["k" /* CardTitle */],{tag:'h4'},customNavItem.name))));},_this.getCategoryPath=function(category){var _this$props=_this.props,routeService=_this$props.routeService,sectionStore=_this$props.sectionStore;return routeService.getPath(category.path,sectionStore.activeSection);},_this.getCustomCategoryPath=function(category){var _this$props2=_this.props,routeService=_this$props2.routeService,sectionStore=_this$props2.sectionStore;if(category.link_type===__WEBPACK_IMPORTED_MODULE_12__types_LinkType__["b" /* default */].EXTERNAL_LINK){return category.link;}if(category.link_type===__WEBPACK_IMPORTED_MODULE_12__types_LinkType__["b" /* default */].INTERNAL_LINK){return routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_13__util_url__["l" /* transformInternalLink */])(category.link));}return routeService.getPath(category.link,sectionStore.activeSection);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CategoryGrid,[{key:'render',value:function render(){var _this2=this;var categories=this.props.categories;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategoryGrid'},categories.map(function(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:category.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this2.getCategoryCard(category)),_this2.getCustomNavigationLinks(category));}));}}]);return CategoryGrid;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CategoryGrid.propTypes={customNavigationLinkStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_CustomNavigationLinkStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_SectionStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8__services_RouteService__["a" /* default */]).isRequired,categories:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Category__["a" /* default */])).isRequired,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Category__["a" /* default */])).isRequired])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('routeService','sectionStore','customNavigationLinkStore')(CategoryGrid));

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SuitableProductFinder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_show_more_text__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_show_more_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_show_more_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__head_SEODescription__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_LocationContext__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__head_GenericMeta__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_ApiWrapper__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SuitableProductFinder=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(SuitableProductFinder,_Component);function SuitableProductFinder(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SuitableProductFinder);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SuitableProductFinder.__proto__||Object.getPrototypeOf(SuitableProductFinder)).call.apply(_ref,[this].concat(args))),_this),_this.state={requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].NONE,filters:[],product:{},recommendWithProductId:null,error:null},_this.loadData=function(){var _this$props=_this.props,categoryId=_this$props.categoryId,apiWrapper=_this$props.apiWrapper;_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING});var currentSelections=_this.getCurrentSelections();apiWrapper.request('suitable-products/'+categoryId,{params:{selectedValues:currentSelections}}).then(function(data){var state={product:{},requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED};if(data.product){state.product=data.product;}if(data.options){state.filters=data.options;}_this.setState(state);}).catch(function(error){_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR,error:Object(__WEBPACK_IMPORTED_MODULE_12__util_error__["a" /* createErrorModel */])(error)});});},_this.getSearchParameters=function(){return SuitableProductFinder.getSearchParamsFromProps(_this.props);},_this.setSearchParameters=function(newParameters){var history=_this.props.history;history.push({search:Object(__WEBPACK_IMPORTED_MODULE_6__util_queryString__["c" /* stringify */])(Object.assign({},_this.getSearchParameters(),newParameters))});},_this.getCurrentSelections=function(){return _this.getSearchParameters().suitableFor||[];},_this.handleChange=function(event,level){var value=event.target.value;// If empty option is selected, do nothing.
if(value===''){return;}_this.setSearchParameters({suitableFor:[].concat(_toConsumableArray(_this.getCurrentSelections().slice(0,level)),[value])});},_this.getImageUrl=function(){var product=_this.state.product;var locationContext=_this.props.locationContext;return product.image?locationContext.protocol+'//'+locationContext.host+product.image:null;},_this.renderSelect=function(options,level){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Input */],{className:'SuitableProductFinder__select',key:level,type:'select',onChange:function onChange(e){return _this.handleChange(e,level);},value:String(_this.getCurrentSelections()[level])},options.map(function(option){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:option.value,value:option.value||''},option.name);}));},_this.renderSelects=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SuitableProductFinder__selects'},_this.state.filters.slice(0,_this.getCurrentSelections().length+1).map(function(filter,index){return _this.renderSelect(filter,index);}));},_this.renderDescription=function(){var product=_this.state.product;var uiStore=_this.props.uiStore;var hasImage=!!product.image;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SuitableProductFinder__information'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{className:'SuitableProductFinder__header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,product.name))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],null,hasImage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{xs:'4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SuitableProductFinder__image'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:product.image,alt:product.image,loading:'lazy'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{xs:hasImage?8:12},product.html&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_show_more_text___default.a,{lines:uiStore.isMobile?6:12,more:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].showMoreText),less:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_19__i18n_globalTranslations__["a" /* default */].showLessText)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:product.html}})))));},_this.renderSEORelated=function(){var product=_this.state.product;var imageUrl=_this.getImageUrl();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,product.name&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__head_SEOTitle__["a" /* default */],{title:product.name}),product.description&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__head_SEODescription__["a" /* default */],{content:product.description}),imageUrl&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__head_GenericMeta__["a" /* default */],{name:'twitter:card',content:imageUrl}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__head_GenericMeta__["a" /* default */],{property:'og:image',content:imageUrl})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SuitableProductFinder,[{key:'componentDidMount',value:function componentDidMount(){this.loadData();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.categoryId!==this.props.categoryId||!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(SuitableProductFinder.getSearchParamsFromProps(prevProps),SuitableProductFinder.getSearchParamsFromProps(this.props))){this.loadData();}}},{key:'render',value:function render(){var listName=this.props.listName;var product=this.state.product;if(!product&&!product.id){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SuitableProductFinder'},this.renderSEORelated(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SuitableProductFinder__top'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{sm:'12',xl:'4'},this.renderSelects()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{sm:'12',xl:'8'},this.renderDescription()))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:this.state.requestState,error:this.state.error,forLoaded:function forLoaded(){return product.id?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__product_list_MainProductList__["b" /* default */],{name:listName,fixedParams:{recommendedWithId:product.id}}):null;}}));}}]);return SuitableProductFinder;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class2.getSearchParamsFromProps=function(props){var search=props.location.search;return Object(__WEBPACK_IMPORTED_MODULE_6__util_queryString__["b" /* parse */])(search);},_temp2))||_class;SuitableProductFinder.propTypes={categoryId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,listName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,history:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.history.isRequired,location:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.location.isRequired,locationContext:__WEBPACK_IMPORTED_MODULE_15__services_LocationContext__["a" /* LocationContextPropType */].isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_16__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_UIStore__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_21__services_ApiWrapper__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('apiWrapper','locationContext','uiStore')(SuitableProductFinder)));

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1296);

var _reactTruncate = __webpack_require__(1299);

var _reactTruncate2 = _interopRequireDefault(_reactTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowMoreText = function (_Component) {
    _inherits(ShowMoreText, _Component);

    function ShowMoreText() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ShowMoreText);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShowMoreText.__proto__ || Object.getPrototypeOf(ShowMoreText)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            expanded: false,
            truncated: false
        }, _this.handleTruncate = function (truncated) {
            if (truncated !== _this.state.truncated) {
                _this.setState({
                    truncated: truncated
                });
            }
        }, _this.toggleLines = function (event) {
            event.preventDefault();
            var _self = _this;
            _this.setState({
                expanded: !_this.state.expanded
            }, function () {
                if (_self.props.onClick) {
                    _self.props.onClick(_self.state.expanded);
                }
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ShowMoreText, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _self = this;
            this.setState({
                expanded: _self.props.expanded
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                more = _props.more,
                less = _props.less,
                lines = _props.lines,
                anchorClass = _props.anchorClass;
            var _state = this.state,
                expanded = _state.expanded,
                truncated = _state.truncated;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactTruncate2.default,
                    {
                        lines: !expanded && lines,
                        ellipsis: _react2.default.createElement(
                            'span',
                            null,
                            '... ',
                            _react2.default.createElement(
                                'a',
                                { href: '#', className: anchorClass, onClick: this.toggleLines },
                                more
                            )
                        ),
                        onTruncate: this.handleTruncate
                    },
                    children
                ),
                !truncated && expanded && _react2.default.createElement(
                    'span',
                    null,
                    ' ',
                    _react2.default.createElement(
                        'a',
                        { href: '#', className: anchorClass, onClick: this.toggleLines },
                        less
                    )
                )
            );
        }
    }]);

    return ShowMoreText;
}(_react.Component);

ShowMoreText.defaultProps = {
    lines: 3,
    more: 'Show more',
    less: 'Show less',
    anchorClass: '',
    onClick: undefined,
    expanded: false
};
ShowMoreText.propTypes = {
    children: _propTypes.PropTypes.node,
    lines: _propTypes.PropTypes.number,
    more: _propTypes.PropTypes.node,
    less: _propTypes.PropTypes.node,
    anchorClass: _propTypes.PropTypes.string,
    onClick: _propTypes.PropTypes.func,
    expanded: _propTypes.PropTypes.bool
};
exports.default = ShowMoreText;
module.exports = exports['default'];

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1297)();
}


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1298);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Truncate = function (_Component) {
    _inherits(Truncate, _Component);

    function Truncate() {
        var _ref;

        _classCallCheck(this, Truncate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Truncate.__proto__ || Object.getPrototypeOf(Truncate)).call.apply(_ref, [this].concat(args)));

        _this.state = {};
        _this.styles = {
            ellipsis: {
                position: 'fixed',
                visibility: 'hidden',
                top: 0,
                left: 0
            }
        };


        _this.elements = {};

        _this.onResize = _this.onResize.bind(_this);
        _this.onTruncate = _this.onTruncate.bind(_this);
        _this.calcTargetWidth = _this.calcTargetWidth.bind(_this);
        _this.measureWidth = _this.measureWidth.bind(_this);
        _this.getLines = _this.getLines.bind(_this);
        _this.renderLine = _this.renderLine.bind(_this);
        return _this;
    }

    _createClass(Truncate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var text = this.elements.text,
                calcTargetWidth = this.calcTargetWidth,
                onResize = this.onResize;


            var canvas = document.createElement('canvas');
            this.canvasContext = canvas.getContext('2d');

            calcTargetWidth(function () {
                // Node not needed in document tree to read its content
                if (text) {
                    text.parentNode.removeChild(text);
                }
            });

            window.addEventListener('resize', onResize);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // Render was based on outdated refs and needs to be rerun
            if (this.props.children !== prevProps.children) {
                this.forceUpdate();
            }

            // If the width prop has changed, recalculate size of contents
            if (this.props.width !== prevProps.width) {
                this.calcTargetWidth();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var ellipsis = this.elements.ellipsis,
                onResize = this.onResize,
                timeout = this.timeout;


            ellipsis.parentNode.removeChild(ellipsis);

            window.removeEventListener('resize', onResize);

            window.cancelAnimationFrame(timeout);
        }

        // Shim innerText to consistently break lines at <br/> but not at \n

    }, {
        key: 'innerText',
        value: function innerText(node) {
            var div = document.createElement('div');
            var contentKey = 'innerText' in window.HTMLElement.prototype ? 'innerText' : 'textContent';

            div.innerHTML = node.innerHTML.replace(/\r\n|\r|\n/g, ' ');

            var text = div[contentKey];

            var test = document.createElement('div');
            test.innerHTML = 'foo<br/>bar';

            if (test[contentKey].replace(/\r\n|\r/g, '\n') !== 'foo\nbar') {
                div.innerHTML = div.innerHTML.replace(/<br.*?[\/]?>/gi, '\n');
                text = div[contentKey];
            }

            return text;
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.calcTargetWidth();
        }
    }, {
        key: 'onTruncate',
        value: function onTruncate(didTruncate) {
            var onTruncate = this.props.onTruncate;


            if (typeof onTruncate === 'function') {
                this.timeout = window.requestAnimationFrame(function () {
                    onTruncate(didTruncate);
                });
            }
        }
    }, {
        key: 'calcTargetWidth',
        value: function calcTargetWidth(callback) {
            var target = this.elements.target,
                calcTargetWidth = this.calcTargetWidth,
                canvasContext = this.canvasContext,
                width = this.props.width;

            // Calculation is no longer relevant, since node has been removed

            if (!target) {
                return;
            }

            var targetWidth = width ||
            // Floor the result to deal with browser subpixel precision
            Math.floor(target.parentNode.getBoundingClientRect().width);

            // Delay calculation until parent node is inserted to the document
            // Mounting order in React is ChildComponent, ParentComponent
            if (!targetWidth) {
                return window.requestAnimationFrame(function () {
                    return calcTargetWidth(callback);
                });
            }

            var style = window.getComputedStyle(target);

            var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');

            canvasContext.font = font;

            this.setState({
                targetWidth: targetWidth
            }, callback);
        }
    }, {
        key: 'measureWidth',
        value: function measureWidth(text) {
            return this.canvasContext.measureText(text).width;
        }
    }, {
        key: 'ellipsisWidth',
        value: function ellipsisWidth(node) {
            return node.offsetWidth;
        }
    }, {
        key: 'trimRight',
        value: function trimRight(text) {
            return text.replace(/\s+$/, '');
        }
    }, {
        key: 'getLines',
        value: function getLines() {
            var elements = this.elements,
                _props = this.props,
                numLines = _props.lines,
                ellipsis = _props.ellipsis,
                trimWhitespace = _props.trimWhitespace,
                targetWidth = this.state.targetWidth,
                innerText = this.innerText,
                measureWidth = this.measureWidth,
                onTruncate = this.onTruncate,
                trimRight = this.trimRight;


            var lines = [];
            var text = innerText(elements.text);
            var textLines = text.split('\n').map(function (line) {
                return line.split(' ');
            });
            var didTruncate = true;
            var ellipsisWidth = this.ellipsisWidth(this.elements.ellipsis);

            for (var line = 1; line <= numLines; line++) {
                var textWords = textLines[0];

                // Handle newline
                if (textWords.length === 0) {
                    lines.push();
                    textLines.shift();
                    line--;
                    continue;
                }

                var resultLine = textWords.join(' ');

                if (measureWidth(resultLine) <= targetWidth) {
                    if (textLines.length === 1) {
                        // Line is end of text and fits without truncating
                        didTruncate = false;

                        lines.push(resultLine);
                        break;
                    }
                }

                if (line === numLines) {
                    // Binary search determining the longest possible line inluding truncate string
                    var textRest = textWords.join(' ');

                    var lower = 0;
                    var upper = textRest.length - 1;

                    while (lower <= upper) {
                        var middle = Math.floor((lower + upper) / 2);

                        var testLine = textRest.slice(0, middle + 1);

                        if (measureWidth(testLine) + ellipsisWidth <= targetWidth) {
                            lower = middle + 1;
                        } else {
                            upper = middle - 1;
                        }
                    }

                    var lastLineText = textRest.slice(0, lower);

                    if (trimWhitespace) {
                        lastLineText = trimRight(lastLineText);

                        // Remove blank lines from the end of text
                        while (!lastLineText.length && lines.length) {
                            var prevLine = lines.pop();

                            lastLineText = trimRight(prevLine);
                        }
                    }

                    resultLine = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        lastLineText,
                        ellipsis
                    );
                } else {
                    // Binary search determining when the line breaks
                    var _lower = 0;
                    var _upper = textWords.length - 1;

                    while (_lower <= _upper) {
                        var _middle = Math.floor((_lower + _upper) / 2);

                        var _testLine = textWords.slice(0, _middle + 1).join(' ');

                        if (measureWidth(_testLine) <= targetWidth) {
                            _lower = _middle + 1;
                        } else {
                            _upper = _middle - 1;
                        }
                    }

                    // The first word of this line is too long to fit it
                    if (_lower === 0) {
                        // Jump to processing of last line
                        line = numLines - 1;
                        continue;
                    }

                    resultLine = textWords.slice(0, _lower).join(' ');
                    textLines[0].splice(0, _lower);
                }

                lines.push(resultLine);
            }

            onTruncate(didTruncate);

            return lines;
        }
    }, {
        key: 'renderLine',
        value: function renderLine(line, i, arr) {
            if (i === arr.length - 1) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { key: i },
                    line
                );
            } else {
                var br = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', { key: i + 'br' });

                if (line) {
                    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { key: i },
                        line
                    ), br];
                } else {
                    return br;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var target = this.elements.target,
                _props2 = this.props,
                children = _props2.children,
                ellipsis = _props2.ellipsis,
                lines = _props2.lines,
                spanProps = _objectWithoutProperties(_props2, ['children', 'ellipsis', 'lines']),
                targetWidth = this.state.targetWidth,
                getLines = this.getLines,
                renderLine = this.renderLine,
                onTruncate = this.onTruncate;

            var text = void 0;

            var mounted = !!(target && targetWidth);

            if (typeof window !== 'undefined' && mounted) {
                if (lines > 0) {
                    text = getLines().map(renderLine);
                } else {
                    text = children;

                    onTruncate(false);
                }
            }

            delete spanProps.onTruncate;
            delete spanProps.trimWhitespace;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                _extends({}, spanProps, { ref: function ref(targetEl) {
                        _this2.elements.target = targetEl;
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    text
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { ref: function ref(textEl) {
                            _this2.elements.text = textEl;
                        } },
                    children
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { ref: function ref(ellipsisEl) {
                            _this2.elements.ellipsis = ellipsisEl;
                        }, style: this.styles.ellipsis },
                    ellipsis
                )
            );
        }
    }]);

    return Truncate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Truncate.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    ellipsis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    lines: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([false]), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    trimWhitespace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    onTruncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Truncate.defaultProps = {
    children: '',
    ellipsis: '…',
    lines: 1,
    trimWhitespace: false,
    width: 0
};
/* harmony default export */ __webpack_exports__["default"] = (Truncate);
;


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommonFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__menu_CollapsibleMenu__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__menu_MenuItemList__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FooterBackToTopButton__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FooterCartExpirationBar__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FooterPaymentModules__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_MenuStore__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__newsletter_NewsletterSubscriptionForm__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FooterColumn__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_CouponStore__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__coupon_CouponText__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__FooterManufacturers__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ad_BannerSlider__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__types_AdPages__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__store_ManufacturerStore__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__store_PaymentModuleStore__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__common_NavigationAssistButton__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__types_MobileNavigationTab__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__types_SectionIntegrationType__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__services_ApiWrapper__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CommonFooter=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(CommonFooter,_Component);function CommonFooter(props){_classCallCheck(this,CommonFooter);var _this=_possibleConstructorReturn(this,(CommonFooter.__proto__||Object.getPrototypeOf(CommonFooter)).call(this,props));_initialiseProps.call(_this);var manufacturerStore=_this.props.manufacturerStore;if(!manufacturerStore.loadedWithContent&&manufacturerStore.state===__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE){manufacturerStore.loadManufacturers(false);}return _this;}_createClass(CommonFooter,[{key:'render',value:function render(){var _props=this.props,apiWrapper=_props.apiWrapper,menuStore=_props.menuStore,cartStore=_props.cartStore,uiStore=_props.uiStore,configStore=_props.configStore,accountStore=_props.accountStore;var isCartExpirable=!accountStore.isViewOnly&&cartStore.cart&&cartStore.cart.expires_at&&cartStore.cart.number_of_products>0;var hideMobileAssistMenu=configStore.mobileSettings.showAssistantMenu!=='2';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter'},!this.shouldHideMixedContent()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__ad_BannerSlider__["a" /* default */],{className:'FooterBanner',searchParams:{bannerZone:__WEBPACK_IMPORTED_MODULE_29__types_AdZones__["a" /* default */].FOOTER_BANNER,bannerPage:this.getAdPageParameter()},aspectRatio:2.85}),isCartExpirable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__FooterCartExpirationBar__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FooterBackToTopButton__["a" /* default */],null),!this.shouldHideMixedContent()&&uiStore.isMobile&&hideMobileAssistMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__mobile-assist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__common_NavigationAssistButton__["a" /* default */],{bottom:true,tab:this.getDefaultMobileMenuTab()})),!this.shouldHideMixedContent()&&menuStore.state===__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED&&(uiStore.isMobile?this.getMobileFooterItems():this.getDesktopFooterItems()),!this.shouldHideMixedContent()&&!configStore.siteConfig.isHomePage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:'FooterPaymentModules__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FooterPaymentModules__["a" /* default */],{languageIsSet:apiWrapper.hasLanguageCode()})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__copyright',dangerouslySetInnerHTML:{__html:configStore.copyright}}));}}]);return CommonFooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.convertMenuToEntity=function(chevron){return function(menu){return{id:menu.id,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,typeof menu.title==='string'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:menu.title}}):menu.title!==null?menu.title:'',chevron&&menu.children.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'chevron-right'})),path:menu.url,children:menu.children.map(_this2.convertMenuToEntity(false))};};};this.shouldHideMixedContent=function(){var _props2=_this2.props,configStore=_props2.configStore,sectionStore=_props2.sectionStore;return configStore.zoovu.enabled&&sectionStore.activeSection&&sectionStore.activeSection.integration_type===__WEBPACK_IMPORTED_MODULE_39__types_SectionIntegrationType__["b" /* default */].ZOOVU;};this.getMenuEntities=function(chevron){var _props3=_this2.props,configStore=_props3.configStore,menuStore=_props3.menuStore;// @todo This will have a separete configuration for visibility.
if(!configStore.siteConfig.isStore){return null;}return menuStore.menus.map(_this2.convertMenuToEntity(chevron));};this.getStaticDesktopColumnEntities=function(){var _props4=_this2.props,routeService=_props4.routeService,configStore=_props4.configStore,accountStore=_props4.accountStore,manufacturerStore=_props4.manufacturerStore;var children=[];if(accountStore.isRetailer){children.push({id:'shopCustomerProducts',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].customerProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].CustomerProducts)});}children.push({id:'shopOnSale',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].onSaleTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].OnSale)});children.push({id:'shopNewProducts',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].newProductsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].NewProducts)});if(manufacturerStore.hasManufacturers){children.push({id:'shopBrands',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].brandsTitle),path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].ManufacturerList)});}if(!accountStore.loggedIn&&configStore.registration.enabled){children.push({id:'shopRegistration',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(e){e.preventDefault();accountStore.accountModal.setTab(__WEBPACK_IMPORTED_MODULE_31__types_AccountModalTab__["b" /* default */].REGISTER);accountStore.accountModal.toggle();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.doYouWantToRegister',defaultMessage:'Would you like to become a registered customer?'})),path:'#'});}return[{id:'shop',label:configStore.store.name,children:children}];};this.getStaticMobileColumnEntities=function(){var _props5=_this2.props,configStore=_props5.configStore,routeService=_props5.routeService,couponStore=_props5.couponStore,accountStore=_props5.accountStore;var mobileEntities={beforeMenuItems:[],afterMenuItems:[]};if(configStore.newsletter.enabled){mobileEntities.beforeMenuItems.push({id:'infoNewsletter',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].newsletterSubscriptionSentence),' ',couponStore.newsletterCoupon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u2013 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__coupon_CouponText__["a" /* default */],{coupon:couponStore.newsletterCoupon,short:true}))),children:[{id:'newsletter',label:_this2.getNewsLetterForm()}]});}if(configStore.customerService.email.length>0){mobileEntities.afterMenuItems.push({id:'infoSendEmail',path:'mailto:'+configStore.customerService.email,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].infoSendEmail,{values:{email:configStore.customerService.email}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'envelope'}))});}if(configStore.customerService.phone.length>0){mobileEntities.afterMenuItems.push({id:'infoCallPhone',path:'tel:'+configStore.customerService.phone,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__text-container d-flex flex-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].infoCallPhone,{values:{phone:configStore.customerService.phone}})),configStore.customerService.open.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'customerService.isOpen',defaultMessage:'Customer service is open Mon - Fri {timespan}',values:{timespan:configStore.customerService.open}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'phone'}))});}if(configStore.siteConfig.isStore){mobileEntities.afterMenuItems.push({id:'brands',path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].ManufacturerList),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].ourBrandsTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'chevron-right'}))});}if(!configStore.siteConfig.isShoppingCenter){mobileEntities.afterMenuItems.push(_this2.getAccountColumnEntities());}if(!accountStore.isViewOnly&&configStore.siteConfig.isWebStore){mobileEntities.afterMenuItems.push({id:'cartContents',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'cart.cartContents',defaultMessage:'Cart contents'}),children:[{id:'cartContents',label:_this2.getCartContents()||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'cart.loadingCartContents',defaultMessage:'Loading cart contents'})}]});}return mobileEntities;};this.getAccountColumnEntities=function(){var _props6=_this2.props,accountStore=_props6.accountStore,configStore=_props6.configStore,routeService=_props6.routeService,analytics=_props6.analytics;if(accountStore.loggedIn){var accountPath=accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].MyAccountBalanceUser:__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].MyAccount;if(accountStore.isBalanceUser){accountPath=__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].MyAccountBalanceSubUser;}var entities={id:'account',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myAccountTitle),children:[{id:'accountLogout',path:'#',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(e){e.preventDefault();analytics.clearCart();accountStore.logout();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].accountLogOutSentence))}]};if(configStore.account.enableMyAccount){entities.children.push({id:'accountDetails',path:routeService.getPath(accountPath),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myCustomerAccountTitle)});}if(configStore.account.enableMyAccount&&!configStore.account.isMoneyTransfer){entities.children.push({id:'accountHistory',path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].MyAccountOrderList),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myOrderHistoryTitle)});}return entities;}else{return{id:'account',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myAccountTitle),children:[{id:'accountLogin',path:'#',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(e){e.preventDefault();accountStore.accountModal.setTab(__WEBPACK_IMPORTED_MODULE_31__types_AccountModalTab__["b" /* default */].LOGIN);accountStore.accountModal.toggle();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].logInSentence))},{id:'accountForgotPassword',path:'#',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(e){e.preventDefault();accountStore.accountModal.setTab(__WEBPACK_IMPORTED_MODULE_31__types_AccountModalTab__["b" /* default */].LOGIN);accountStore.accountModal.toggle();accountStore.accountModal.toggleResetPasswordVisible();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.forgotYourPassword',defaultMessage:'Forgot your password?'}))}]};}};this.getCartContents=function(){var _props7=_this2.props,accountStore=_props7.accountStore,cartStore=_props7.cartStore,configStore=_props7.configStore;var checkout=configStore.checkout;if(!cartStore.cart){return null;}var withTax=accountStore.showPricesWithTax;var showTaxExcludedInfo=!withTax;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__cart-contents-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].itemCount,{values:{count:cartStore.cart.number_of_products}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__product_Price__["a" /* default */],{price:cartStore.cart.total.getPrice(withTax),showTaxExcludedInfo:showTaxExcludedInfo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'success',tag:'a',href:checkout.checkoutPath,className:'CommonFooter__cart-contents-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'shopping-cart'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].proceedToCartSentence)));};this.getNewsLetterForm=function(){var couponStore=_this2.props.couponStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__newsletter-container'},couponStore.newsletterCoupon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'CommonFooter__newsletter-discount-coupon-paragraph'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__coupon_CouponText__["a" /* default */],{coupon:couponStore.newsletterCoupon,short:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'newsletter.isFree',defaultMessage:'Newsletter is free'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__newsletter_NewsletterSubscriptionForm__["a" /* default */],{compact:true}));};this.getNewsletterColumn=function(){var configStore=_this2.props.configStore;if(!configStore.newsletter.enabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__FooterColumn__["a" /* default */],{lg:12,xl:3,className:'CommonFooter__newsletter-column',title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].newsletterSubscriptionSentence)},_this2.getNewsLetterForm());};this.getColumnFromEntity=function(menu){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__FooterColumn__["a" /* default */],{className:menu.className,key:menu.id,title:menu.label},menu.children&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__menu_MenuItemList__["a" /* default */],{items:menu.children}));};this.getDesktopFooterItems=function(){var configStore=_this2.props.configStore;var entities=_this2.getMenuEntities(false);var menuColumnSizes={};var menus=void 0,multipleMenus=void 0;if(entities){menus=entities.filter(function(menu){return menu.children&&menu.children.length>0;});multipleMenus=menus.length>1;if(multipleMenus){menuColumnSizes={xl:4,md:6,xs:12};}}var columns=[].concat(_this2.getStaticDesktopColumnEntities());if(!configStore.siteConfig.isShoppingCenter){columns.push(_this2.getAccountColumnEntities());}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,!configStore.siteConfig.isHomePage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:'CommonFooter__menu-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xl:'1-24'}),menus&&menus.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__FooterColumn__["a" /* default */],Object.assign({},menuColumnSizes,{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('CommonFooter__menu-column',{'CommonFooter__menu-column--multiple-menus':multipleMenus})}),menus.map(function(menu){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__menu-column-menu',key:menu.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,menu.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__menu_MenuItemList__["a" /* default */],{items:menu.children}));})),columns.map(function(menuItem,i){return _this2.getColumnFromEntity(menuItem);}),_this2.getNewsletterColumn()))),configStore.footer.showManufacturers&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__manufacturers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:'CommonFooter__manufacturers-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xl:{size:11,offset:'1-24'},lg:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__FooterManufacturers__["a" /* default */],null))))));};this.getMobileFooterItems=function(){var staticItems=_this2.getStaticMobileColumnEntities();var menuEntities=_this2.getMenuEntities(true);var items=void 0;if(menuEntities){items=[].concat(staticItems.beforeMenuItems,menuEntities,staticItems.afterMenuItems);}else{items=[].concat(staticItems.beforeMenuItems,staticItems.afterMenuItems);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__links-small'},items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CommonFooter__links-small-link',key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__menu_CollapsibleMenu__["a" /* default */],{item:item}));}));};this.getAdPageParameter=function(){var _props8=_this2.props,location=_props8.location,routeService=_props8.routeService,sectionStore=_props8.sectionStore;var candidates=[{path:__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].FrontPage,parameter:__WEBPACK_IMPORTED_MODULE_33__types_AdPages__["a" /* default */].FRONT_PAGE},{path:__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].NewProducts,parameter:__WEBPACK_IMPORTED_MODULE_33__types_AdPages__["a" /* default */].NEW_PRODUCTS},{path:__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].OnSale,parameter:__WEBPACK_IMPORTED_MODULE_33__types_AdPages__["a" /* default */].CAMPAIGN_PRODUCTS}];var matchingPath=candidates.find(function(candidate){return Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["d" /* matchPath */])(location.pathname,{path:routeService.getPath(candidate.path,sectionStore.activeSection),strict:false,exact:true});});if(matchingPath){return matchingPath.parameter;}return undefined;};this.getDefaultMobileMenuTab=function(){var location=_this2.props.location;if(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["d" /* matchPath */])(location.pathname,{path:'/:locale?'+__WEBPACK_IMPORTED_MODULE_23__types_Paths__["a" /* default */].InfoPage})){return __WEBPACK_IMPORTED_MODULE_38__types_MobileNavigationTab__["b" /* default */].INFO;}return __WEBPACK_IMPORTED_MODULE_38__types_MobileNavigationTab__["b" /* default */].PRODUCTS;};},_temp))||_class;CommonFooter.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_AccountStore__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_41__services_ApiWrapper__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_CartStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_ConfigStore__["a" /* default */]).isRequired,couponStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_25__store_CouponStore__["a" /* default */]).isRequired,menuStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_MenuStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_30__store_UIStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_34__store_SectionStore__["a" /* default */]).isRequired,manufacturerStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_35__store_ManufacturerStore__["a" /* default */]).isRequired,paymentModuleStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_36__store_PaymentModuleStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_24__services_RouteService__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_40__analytics_Analytics__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','apiWrapper','cartStore','configStore','couponStore','menuStore','uiStore','sectionStore','manufacturerStore','routeService','analytics','paymentModuleStore')(CommonFooter)));

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MenuItemList__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_NavigationEntity__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__ = __webpack_require__(99);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* NOTE: this component shows only one level menus under the menu title */var CollapsibleMenu=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CollapsibleMenu,_Component);function CollapsibleMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CollapsibleMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CollapsibleMenu.__proto__||Object.getPrototypeOf(CollapsibleMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={collapse:false},_this.toggle=function(){_this.setState({collapse:!_this.state.collapse});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CollapsibleMenu,[{key:'render',value:function render(){var collapse=this.state.collapse;var item=this.props.item;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('CollapsibleMenu',{'CollapsibleMenu--has-children':!!item.children})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'CollapsibleMenu__container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{className:'col-12 CollapsibleMenu__menu-col',onClick:this.toggle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_NavigationEntityItem__["a" /* default */],{entity:item}),item.children&&item.children.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:this.state.collapse?'minus':'plus'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{className:'col-12 CollapsibleMenu__menu-col-children'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["m" /* Collapse */],{isOpen:collapse},item.children&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MenuItemList__["a" /* default */],{items:item.children,key:item.id}))))));}}]);return CollapsibleMenu;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;CollapsibleMenu.propTypes={item:__WEBPACK_IMPORTED_MODULE_6__types_NavigationEntity__["a" /* default */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (CollapsibleMenu);

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FooterBackToTopButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SHORT_BUTTON_THRESHOLD_PX=400;var FooterBackToTopButton=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FooterBackToTopButton,_Component);function FooterBackToTopButton(){_classCallCheck(this,FooterBackToTopButton);return _possibleConstructorReturn(this,(FooterBackToTopButton.__proto__||Object.getPrototypeOf(FooterBackToTopButton)).apply(this,arguments));}_createClass(FooterBackToTopButton,[{key:'shouldHide',value:function shouldHide(){var uiStore=this.props.uiStore;if(window.isSSR){return true;}return uiStore.isMobile&&(uiStore.scrollingDown||uiStore.documentScrollTop<SHORT_BUTTON_THRESHOLD_PX);}},{key:'render',value:function render(){var uiStore=this.props.uiStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('FooterBackToTopButton',{'FooterBackToTopButton--hidden':this.shouldHide()}),id:'CommonFooter__BackToTop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:'FooterBackToTop__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'link',onClick:function onClick(){return window.scrollTo(0,0);},className:'text-light FooterBackToTopButton__button'},uiStore.isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'footer.backToTopShort',defaultMessage:'Top'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'footer.backToTop',defaultMessage:'Back to top'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Icon__["a" /* default */],{name:'long-arrow-up',className:'FooterBackToTopButton__icon'}))))));}}]);return FooterBackToTopButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FooterBackToTopButton.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_UIStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('uiStore')(FooterBackToTopButton));

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FooterCartExpirationBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_NavigationCart__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Countdown__ = __webpack_require__(521);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FooterCartExpirationBar=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FooterCartExpirationBar,_Component);function FooterCartExpirationBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FooterCartExpirationBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FooterCartExpirationBar.__proto__||Object.getPrototypeOf(FooterCartExpirationBar)).call.apply(_ref,[this].concat(args))),_this),_this.state={expired:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FooterCartExpirationBar,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Container */],{className:'FooterCartExpirationBar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'col-xs-12'},this.state.expired?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'footer.cartExpirationExpired',defaultMessage:'Reservation for the items in your cart has expired.'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'footer.cartExpirationPending',defaultMessage:'Reservation for the items in your cart expires in'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Countdown__["a" /* default */],{expiresOn:new Date(this.props.cartStore.cart.expires_at),onExpiry:function onExpiry(){return _this2.setState({expired:true});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__header_NavigationCart__["a" /* default */],{withCheckoutButton:true}))));}}]);return FooterCartExpirationBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FooterCartExpirationBar.propTypes={cartStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_CartStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('cartStore')(FooterCartExpirationBar));

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FooterPaymentModules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_PaymentModuleStore__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integrations_klarna_KlarnaPromotionWidget__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_PaymentWidgetType__ = __webpack_require__(531);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_IMAGE_HEIGHT=35;var IMAGE_ASPECT_RATIO=20/11;var FooterPaymentModules=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FooterPaymentModules,_Component);function FooterPaymentModules(props){_classCallCheck(this,FooterPaymentModules);var _this=_possibleConstructorReturn(this,(FooterPaymentModules.__proto__||Object.getPrototypeOf(FooterPaymentModules)).call(this,props));_this.maybeLoadPaymentInfo=function(){var _this$props=_this.props,accountStore=_this$props.accountStore,countryStore=_this$props.countryStore,paymentModuleStore=_this$props.paymentModuleStore,languageIsSet=_this$props.languageIsSet;if(paymentModuleStore.state===__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].NONE&&languageIsSet){paymentModuleStore.loadPaymentModules({countryCode:countryStore.activeCountry.id,groupId:accountStore.getCustomerGroupId}).then(function(){_this.setState({loaded:__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].LOADED});}).catch(function(error){return console.error(error);});}};_this.getKlarnaScript=function(){var paymentModuleStore=_this.props.paymentModuleStore;if(!paymentModuleStore.widgets){return null;}var klarnaWidget=paymentModuleStore.widgets.find(function(widget){return widget.type===__WEBPACK_IMPORTED_MODULE_9__types_PaymentWidgetType__["b" /* default */].KLARNA;});return klarnaWidget.script;};_this.renderPaymentModules=function(){var paymentModuleStore=_this.props.paymentModuleStore;var imgHeight=MAX_IMAGE_HEIGHT;var imgWidth=Math.round(MAX_IMAGE_HEIGHT*IMAGE_ASPECT_RATIO);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FooterPaymentModules__images'},paymentModuleStore.methods.map(function(module,index){return module&&module.logo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:index,width:imgWidth,height:imgHeight,src:module.logo,alt:module.name,loading:'lazy',title:module.name,className:'FooterPaymentModules__image'}):null;}));};_this.state={loaded:__WEBPACK_IMPORTED_MODULE_7__types_RequestState__["b" /* default */].NONE};return _this;}_createClass(FooterPaymentModules,[{key:'componentDidMount',value:function componentDidMount(){this.maybeLoadPaymentInfo();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.maybeLoadPaymentInfo();}},{key:'render',value:function render(){var _props=this.props,paymentModuleStore=_props.paymentModuleStore,languageIsSet=_props.languageIsSet;if(!languageIsSet){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FooterPaymentModules'},paymentModuleStore.widgets.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__integrations_klarna_KlarnaPromotionWidget__["a" /* default */],{widgetType:'footer-promotion-auto-size',paymentModuleQueryResultKey:'footer',externalKlarnaScript:this.getKlarnaScript()}):this.renderPaymentModules());}}]);return FooterPaymentModules;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FooterPaymentModules.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_AccountStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_CountryStore__["a" /* default */]).isRequired,paymentModuleStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_PaymentModuleStore__["a" /* default */]).isRequired,languageIsSet:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','countryStore','paymentModuleStore')(FooterPaymentModules));

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_CustomCol__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var gridPropType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]);var defaultGridProps={xs:{size:12},md:{size:3},xl:{size:2}};var FooterColumn=function(_Component){_inherits(FooterColumn,_Component);function FooterColumn(){_classCallCheck(this,FooterColumn);return _possibleConstructorReturn(this,(FooterColumn.__proto__||Object.getPrototypeOf(FooterColumn)).apply(this,arguments));}_createClass(FooterColumn,[{key:'render',value:function render(){var _props=this.props,title=_props.title,children=_props.children,className=_props.className,rest=_objectWithoutProperties(_props,['title','children','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_CustomCol__["a" /* default */],Object.assign({},defaultGridProps,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('FooterColumn',className)},rest),title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,title),children);}}]);return FooterColumn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FooterColumn.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,xs:gridPropType,sm:gridPropType,md:gridPropType,lg:gridPropType,xl:gridPropType,xxl:gridPropType,xxxl:gridPropType};/* harmony default export */ __webpack_exports__["a"] = (FooterColumn);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FooterManufacturers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__manufacturer_ManufacturerLink__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ManufacturerStore__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_RequestState__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FooterManufacturers=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FooterManufacturers,_Component);function FooterManufacturers(props){_classCallCheck(this,FooterManufacturers);var _this=_possibleConstructorReturn(this,(FooterManufacturers.__proto__||Object.getPrototypeOf(FooterManufacturers)).call(this,props));var manufacturerStore=_this.props.manufacturerStore;if(!manufacturerStore.loadedWithContent&&manufacturerStore.state===__WEBPACK_IMPORTED_MODULE_11__types_RequestState__["b" /* default */].NONE){manufacturerStore.loadManufacturers(false);}return _this;}_createClass(FooterManufacturers,[{key:'render',value:function render(){var _props=this.props,manufacturerStore=_props.manufacturerStore,routeService=_props.routeService;if(!manufacturerStore.hasManufacturers){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FooterManufacturers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_9__types_Paths__["a" /* default */].ManufacturerList)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].ourBrandsTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FooterManufacturers__list'},manufacturerStore.manufacturersWithProducts.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:manufacturer.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer}));})));}}]);return FooterManufacturers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FooterManufacturers.propTypes={manufacturerStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ManufacturerStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('manufacturerStore','routeService')(FooterManufacturers));

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Purchase__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchasesTotal__ = __webpack_require__(1308);
var CustomerUserPurchases=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CustomerUserPurchases',{purchases:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__Purchase__["a" /* default */]),[]),total:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_2__PurchasesTotal__["a" /* default */],{})});/* harmony default export */ __webpack_exports__["a"] = (CustomerUserPurchases);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var PurchasesTotalValue=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PurchasesTotalValue',{currency:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,value:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});var PurchasesTotal=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PurchasesTotal',{order_count:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(PurchasesTotalValue),with_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(PurchasesTotalValue),without_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(PurchasesTotalValue)});/* harmony default export */ __webpack_exports__["a"] = (PurchasesTotal);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_CreditAccountType__ = __webpack_require__(1310);
var CreditAccount=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CreditAccount',{type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__types_CreditAccountType__["a" /* CreditAccountTypeType */]),limit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),credit_used:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),date_updated:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),balance:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});/* harmony default export */ __webpack_exports__["a"] = (CreditAccount);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreditAccountTypeType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CreditAccountType={DEBT:'DEBT',PREPAID:'PREPAID'};/* unused harmony default export */ var _unused_webpack_default_export = (CreditAccountType);var CreditAccountTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CreditAccountTypeType',Object.values(CreditAccountType));

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var BalancePaymentWidget=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('BalancePaymentWidget',{html_widget:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string)});/* harmony default export */ __webpack_exports__["a"] = (BalancePaymentWidget);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BalancePaymentOrderUser__ = __webpack_require__(1313);
var BalancePayment=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('BalancePayment',{orders_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,amount_with_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,amount_without_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,date_purchased:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,users:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__BalancePaymentOrderUser__["a" /* default */])});/* harmony default export */ __webpack_exports__["a"] = (BalancePayment);

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var BalancePaymentOrderUser=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('BalancePaymentOrderUser',{name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,amount_with_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,amount_without_tax:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (BalancePaymentOrderUser);

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var LocalizationSites=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('GeoIpSites',{domain:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,recommendedForCountry:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean),shipsToCountry:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean)});/* harmony default export */ __webpack_exports__["a"] = (LocalizationSites);

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__ = __webpack_require__(100);
var OrderProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrderProduct',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifier,product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,quantity_ordered:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,quantity_delivered:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,package_size:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),stock_unit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,starting_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),final_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,total_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,type:__WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__["a" /* ProductType */],reference:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,warranty_in_months:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,package_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,is_free_of_charge:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,variations:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),image_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),product_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),tax_rate:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),recurring_order_cycle_type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),recurring_order_custom_cycle:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)}).views(function(self){return{get isPhysicalProduct(){return self.type===__WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__["b" /* default */].PHYSICAL;}};});/* harmony default export */ __webpack_exports__["a"] = (OrderProduct);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Order__ = __webpack_require__(203);
var OrdersPaginator=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrdersPaginator',{current_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,data:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].reference(__WEBPACK_IMPORTED_MODULE_1__Order__["a" /* default */])),[]),last_page:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,total:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number});/* harmony default export */ __webpack_exports__["a"] = (OrdersPaginator);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CurrentOrderProduct__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderPayment__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderShipping__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderTotalValue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderStatusHistoryEntry__ = __webpack_require__(580);
var CurrentOrder=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('CurrentOrder',{analytics_currency:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,campaign_code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),confirmation_email:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),currency:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,date_purchased:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),external_type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),has_licensed_products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,html_widget:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,id_for_analytics:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,is_seen:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,merchant_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),payment:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2__OrderPayment__["a" /* default */]),payment_method_messages:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),[]),products:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__CurrentOrderProduct__["a" /* default */]),real_total:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,receipt_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),seller_name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),shipping:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_3__OrderShipping__["a" /* default */]),status_history:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_5__OrderStatusHistoryEntry__["a" /* default */]),[]),totals:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_4__OrderTotalValue__["a" /* default */]),tracking_pixels:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),tracking_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string}).views(function(self){return{get paymentAddress(){return self.payment&&self.payment.address;},get shippingAddress(){return self.shipping&&self.shipping.address;},get shippingMethod(){return self.shipping&&self.shipping.method;},get paymentMethod(){return self.payment&&self.payment.method;},get pickupPoint(){return self.shipping&&self.shipping.pick_up_point;}};});/* harmony default export */ __webpack_exports__["a"] = (CurrentOrder);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__ = __webpack_require__(100);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var CurrentOrderProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('OrderProduct',{analytics_final_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,analytics_starting_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,analytics_total_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,final_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,image_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),package_size:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,starting_unit_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,stock_unit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,''),total_price:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,type:__WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__["a" /* ProductType */],variations:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),[])}).views(function(self){return{get isPhysicalProduct(){return self.type===__WEBPACK_IMPORTED_MODULE_1__types_ProductTypeClass__["b" /* default */].PHYSICAL;}};}).preProcessSnapshot(function(_ref){var quantity=_ref.quantity,rest=_objectWithoutProperties(_ref,['quantity']);return Object.assign({quantity:Number(quantity)},rest);});/* harmony default export */ __webpack_exports__["a"] = (CurrentOrderProduct);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Question__ = __webpack_require__(1320);
var Survey=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Survey',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,has_pre_question:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,styles:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),embed_code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,header_text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),body:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),footer_text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),pre_question_description:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),questions:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__Question__["a" /* default */]),popup_time:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),questions_placement:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,survey_modal_width:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),body_column_width:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),answers_column_width:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});/* harmony default export */ __webpack_exports__["a"] = (Survey);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyField__ = __webpack_require__(1321);
var Question=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Question',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,is_required:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),hint:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),field:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_1__SurveyField__["a" /* default */])});/* harmony default export */ __webpack_exports__["a"] = (Question);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var SurveyFieldValue=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('SurveyFieldValue',{key:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,text:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,value_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number)});var SurveyField=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('SurveyField',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,key:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,is_public:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,type:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,values:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(SurveyFieldValue)});/* harmony default export */ __webpack_exports__["a"] = (SurveyField);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SurveyTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var SurveyType={TIMED_POPUP:'TIMED_POPUP',NORMAL:'NORMAL'};/* harmony default export */ __webpack_exports__["a"] = (SurveyType);var SurveyTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('SurveyType',Object.values(SurveyType));

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Token__ = __webpack_require__(581);
var PaymentTokens=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('PaymentTokens',{creation_url:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),tokens:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__Token__["a" /* default */]),[])});/* harmony default export */ __webpack_exports__["a"] = (PaymentTokens);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_CommonPage__ = __webpack_require__(40);
var Script=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('Script',{code:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,execute_on_page_view:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].identifierNumber,location:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,pages:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_1__types_CommonPage__["a" /* CommonPageType */]),status:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string});/* harmony default export */ __webpack_exports__["a"] = (Script);

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_Field__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_FieldError__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(LoginForm,_Component);function LoginForm(props){_classCallCheck(this,LoginForm);var _this=_possibleConstructorReturn(this,(LoginForm.__proto__||Object.getPrototypeOf(LoginForm)).call(this,props));_this.form=null;_this.handleSubmit=function(e){e.preventDefault();_this.form.validate();if(_this.form.valid&&_this.props.onSubmit){_this.props.onSubmit(_this.form.getFieldValues());}};_this.form=Object(__WEBPACK_IMPORTED_MODULE_5__models_Form__["a" /* createForm */])({username:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailOrUsernameTitle))]),password:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].passwordTitle))])});return _this;}_createClass(LoginForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{className:'LoginForm',noValidate:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* Label */],{'for':'LoginForm__username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailOrUsernameTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_Field__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Input */],field:this.form.fields.get('username'),type:'text',name:'username',id:'LoginForm__username',autoComplete:'username',autoCorrect:'off',autoCapitalize:'none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_FieldError__["a" /* default */],{field:this.form.fields.get('username')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* Label */],{'for':'LoginForm__password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].passwordTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_Field__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Input */],field:this.form.fields.get('password'),type:'password',name:'password',id:'LoginForm__password',autoComplete:'current-password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_FieldError__["a" /* default */],{field:this.form.fields.get('password')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary',block:true,disabled:this.form.valid===false||this.props.disableSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].logInSentence)));}}]);return LoginForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;LoginForm.propTypes={onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disableSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (LoginForm);

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RegisterForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_has__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_RadioField__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_CheckboxField__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__loader_ErrorHandler__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__privacy_statement_PrivacyStatementLink__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__services_FormValidator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__form_SelectField__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_storage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_constants__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__form_RecaptchaField__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_js_cookie__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_js_cookie__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={isCompany:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].isCorporateCustomerSentence),company:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].companyTitle),businessId:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].businessIdTitle),yes:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].yesTitle),no:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].noTitle),firstName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].firstNameTitle),companyFirstName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].contactPersonFirstNameTitle),lastName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].lastNameTitle),companyLastName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].contactPersonLastNameTitle),email:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].emailTitle),telephone:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].telephoneTitle),streetAddress:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].streetAddressTitle),postalCode:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].zipCodeTitle),city:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].cityTitle),country:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].countryTitle),username:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].emailOrUsernameTitle),password:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].passwordTitle),confirmPassword:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].confirmPasswordTitle),newsletter:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].newsletterSubscriptionSentence),privacyStatement:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].privacyStatementAcceptSentence)};function createOption(value,label){return{value:value,label:label};}var RegisterForm=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(RegisterForm,_Component);function RegisterForm(props){_classCallCheck(this,RegisterForm);var _this=_possibleConstructorReturn(this,(RegisterForm.__proto__||Object.getPrototypeOf(RegisterForm)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,configStore=_this$props.configStore,countryStore=_this$props.countryStore,formValidator=_this$props.formValidator;var validateBusinessId=countryStore.countries.length===1&&__WEBPACK_IMPORTED_MODULE_2_lodash_has___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(countryStore.countries,'iso_code_2'),'FI');_this.form=Object(__WEBPACK_IMPORTED_MODULE_9__models_Form__["a" /* createForm */])({isCompany:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({value:configStore.registration.isCompanyDefault},[],function(){return configStore.registration.companyEnabled;}),company:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_12__util_formValidators__["g" /* notBlank */])(labels.company)],function(){return _this.form.fields.get('isCompany').value==='1';}),businessId:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},[validateBusinessId?Object(__WEBPACK_IMPORTED_MODULE_12__util_formValidators__["b" /* finnishBusinessId */])():Object(__WEBPACK_IMPORTED_MODULE_12__util_formValidators__["g" /* notBlank */])(labels.businessId)],function(){return configStore.registration.requireBusinessId&&_this.form.fields.get('isCompany').value==='1';}),firstName:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.firstName(labels.firstName)),lastName:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.lastName(labels.lastName)),email:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.email(labels.email)),telephone:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.telephone(labels.telephone),function(){return!configStore.registration.quickRegistrationEnabled||configStore.registration.quickRegistrationEnabled&&configStore.registration.quickRegistrationRequirePhone;}),streetAddress:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.streetAddress(labels.streetAddress),function(){return!configStore.registration.quickRegistrationEnabled;}),postalCode:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.postalCode(labels.postalCode),function(){return!configStore.registration.quickRegistrationEnabled;}),city:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.city(labels.city),function(){return!configStore.registration.quickRegistrationEnabled;}),country:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({value:_this.getCountryId()}),username:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.username(labels.username),function(){return!configStore.registration.quickRegistrationEnabled;}),password:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},formValidator.password(labels.password)),confirmPassword:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_12__util_formValidators__["f" /* mustMatch */])(function(){return _this.form.fields.get('password').value;})]),newsletter:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},[],function(){return configStore.newsletter.enabled;}),privacyStatement:Object(__WEBPACK_IMPORTED_MODULE_16__models_FormField__["a" /* createFormField */])({},[function(value){return!value?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],Object.assign({key:'mustApprove'},__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].privacyStatementMustApproveSentence)):null;}])});// Reactstrap Tooltip throws if it is open when rendered first time, so we
// need to explicitly close it in case it was left open when toggling
// "isCompany".
_this.isCompanyAutorunDisposer=Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["autorun"])(function(){if(_this.form.fields.get('isCompany').value==='0'&&_this.state.businessIdHelpVisible){_this.setState({businessIdHelpVisible:false});}});return _this;}_createClass(RegisterForm,[{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.isCompanyAutorunDisposer){this.isCompanyAutorunDisposer();}}},{key:'businessIdTooltip',value:function businessIdTooltip(){var _props=this.props,languageStore=_props.languageStore,countryStore=_props.countryStore;var validateBusinessId=countryStore.countries.length===1&&__WEBPACK_IMPORTED_MODULE_2_lodash_has___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(countryStore.countries,'iso_code_2'),'FI');if(!validateBusinessId){return null;}var ytjLanguageIdDict={fi:1,sv:2,en:3};var languageId=ytjLanguageIdDict[languageStore.activeLocale]||ytjLanguageIdDict.en;var url='https://tietopalvelu.ytj.fi/yrityshaku.aspx?kielikoodi='+languageId;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["S" /* Tooltip */],{placement:'right',isOpen:this.state.businessIdHelpVisible,target:'BusinessIdTooltip',toggle:this.toggle},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].businessIdHelp,{values:{link:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:url,target:'_blank',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].hereSentence))}}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{id:'BusinessIdTooltip',onClick:this.toggleBusinessIdHelp},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_Icon__["a" /* default */],{name:'question-circle'})));}},{key:'render',value:function render(){var _this2=this;var configStore=this.props.configStore;var _state=this.state,requestState=_state.requestState,requestId=_state.requestId,error=_state.error;var isCompany=this.form.fields.get('isCompany').value==='1';return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["s" /* Form */],{className:this.formName,noValidate:true,onSubmit:this.handleSubmit},this.radio('isCompany',{options:[createOption('1',labels.yes),createOption('0',labels.no)]}),this.field('company',{autoComplete:'organization'}),this.field('businessId',{label:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null,labels.businessId,' ',this.businessIdTooltip()),// We don't want autocomplete here, so we put in a non-existent string
autoComplete:'businessId'}),this.field('firstName',{label:isCompany?labels.companyFirstName:labels.firstName,autoComplete:'given-name'}),this.field('lastName',{label:isCompany?labels.companyLastName:labels.lastName,autoComplete:'family-name'}),this.field('email',{type:'email',autoComplete:'email',autoCorrect:'off',autoCapitalize:'none'}),this.field('telephone',{type:'tel',autoComplete:'tel-national'}),this.field('streetAddress',{autoComplete:'street-address'}),this.field('postalCode',{autoComplete:'postal-code'}),this.field('city',{autoComplete:'address-level2'}),this.renderCountrySelect(),this.form.fields.get('username').active&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].loginInformationTitle))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'account.loginInformationHint',defaultMessage:'Create a username (you can use e.g. your e-mail address) and a password for your account.'}))),this.field('username',{autoComplete:'username',autoCorrect:'off',autoCapitalize:'none'}),this.field('password',{type:'password',autoComplete:'new-password'}),this.field('confirmPassword',{type:'password',autoComplete:'new-password'}),this.checkbox('newsletter',{options:createOption('1',labels.newsletter)}),this.checkbox('privacyStatement',{options:createOption('1',labels.privacyStatement)}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'RegisterForm__privacy-statement-link-wrapper'},'(',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__privacy_statement_PrivacyStatementLink__["a" /* default */],null),')'),error&&__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(error,'response.status')!==400&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__loader_ErrorHandler__["a" /* default */],{error:Object(__WEBPACK_IMPORTED_MODULE_23__util_error__["a" /* createErrorModel */])(error)}),this.getErrorMessages()&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["a" /* Alert */],{color:'danger',key:requestId},this.getErrorMessages().map(function(message){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:message},message);})),configStore.registration.enableCaptcha&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__form_RecaptchaField__["a" /* default */],{ref:function ref(recaptcha){return _this2.recaptcha=recaptcha;},onChange:this.onRecaptchaChange}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{color:'primary',block:true,disabled:this.form.valid===false||this.isRecaptchaValid()===false||requestState===__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].registerTitle)));}}]);return RegisterForm;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this3=this;this.form=null;this.isCompanyAutorunDisposer=null;this.formName='RegisterForm';this.state={businessIdHelpVisible:false,error:null,requestState:__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADED,// This is used to know, if we've made a new request so we can re-animate errors
requestId:0,recaptcha:null};this.getCountryId=function(){var _props2=_this3.props,accountStore=_props2.accountStore,countryStore=_props2.countryStore;var defaultId=accountStore.account&&accountStore.account.country_id;return defaultId||__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(countryStore,'countries[0].id');};this.onRecaptchaChange=function(value){_this3.setState({recaptcha:value});};this.getProductListProducts=function(products){if(!products){return;}var productListProducts=[];products.forEach(function(product){productListProducts.push({extendedId:product.id,quantity:product.quantity});});return productListProducts;};this.isRecaptchaValid=function(){var recaptcha=_this3.state.recaptcha;var configStore=_this3.props.configStore;return!!recaptcha||!configStore.registration.enableCaptcha;};this.handleSubmit=function(e){var accountStore=_this3.props.accountStore;var recaptcha=_this3.state.recaptcha;e.preventDefault();_this3.form.validate();if(_this3.form.valid&&_this3.isRecaptchaValid()){var storageProductListProducts=Object(__WEBPACK_IMPORTED_MODULE_28__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_29__util_constants__["a" /* storageKeys */].wishlist);var productListProducts=_this3.getProductListProducts(storageProductListProducts);var customerHash=__WEBPACK_IMPORTED_MODULE_31_js_cookie___default.a.get('customer_hash');_this3.setState({requestState:__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].LOADING});var values=_this3.form.getFieldValues();values.recaptcha=recaptcha;accountStore.register(values,productListProducts,customerHash).then(function(response){Object(__WEBPACK_IMPORTED_MODULE_28__util_storage__["a" /* deleteStorageItem */])(__WEBPACK_IMPORTED_MODULE_29__util_constants__["a" /* storageKeys */].wishlist);__WEBPACK_IMPORTED_MODULE_31_js_cookie___default.a.remove('customer_hash');window.location.reload();_this3.redirectToPostLoginPath(response);}).catch(function(error){_this3.setState({requestState:__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].ERROR,error:error,requestId:_this3.state.requestId+1});});}};this.redirectToPostLoginPath=function(response){if(response.data&&response.data.user&&response.data.user.post_login_redirect_path&&response.data.user.post_login_redirect_path.length>0){window.location.assign(response.data.user.post_login_redirect_path);}};this.field=function(fieldName,props){var field=_this3.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this3.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.radio=function(fieldName,props){var field=_this3.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__form_RadioField__["a" /* default */],Object.assign({field:field,formName:_this3.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.checkbox=function(fieldName,props){var field=_this3.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__form_CheckboxField__["a" /* default */],Object.assign({field:field,formName:_this3.formName,fieldName:fieldName},props));};this.toggleBusinessIdHelp=function(e){e.preventDefault();_this3.setState({businessIdHelpVisible:!_this3.state.businessIdHelpVisible});};this.renderCountrySelect=function(){var countryStore=_this3.props.countryStore;if(countryStore.countries.length<=1){return null;}var fieldName='country';var field=_this3.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__form_SelectField__["a" /* default */],{field:field,formName:_this3.formName,fieldName:fieldName,label:labels[fieldName],options:countryStore.countries.map(function(country){return createOption(String(country.id),country.name);})});};this.getErrorMessages=function(){var error=_this3.state.error;return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(error,'response.data.messages');};},_temp))||_class;RegisterForm.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_ConfigStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_27__store_CountryStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_LanguageStore__["a" /* default */]).isRequired,formValidator:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_25__services_FormValidator__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["c" /* inject */])('accountStore','configStore','countryStore','languageStore','formValidator')(RegisterForm));

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_FormField__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResetPasswordForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ResetPasswordForm,_Component);function ResetPasswordForm(props){_classCallCheck(this,ResetPasswordForm);var _this=_possibleConstructorReturn(this,(ResetPasswordForm.__proto__||Object.getPrototypeOf(ResetPasswordForm)).call(this,props));_this.form=null;_this.handleSubmit=function(e){e.preventDefault();_this.form.validate();if(_this.form.valid&&_this.props.onSubmit){_this.props.onSubmit(_this.form.getFieldValues());}};_this.form=Object(__WEBPACK_IMPORTED_MODULE_5__models_Form__["a" /* createForm */])({email:Object(__WEBPACK_IMPORTED_MODULE_9__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_7__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].emailTitle)),Object(__WEBPACK_IMPORTED_MODULE_7__util_formValidators__["d" /* isEmail */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].emailTitle))])});return _this;}_createClass(ResetPasswordForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{className:'ResetPasswordForm',noValidate:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__["a" /* default */],{field:this.form.fields.get('email'),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].emailTitle),formName:'ResetPasswordForm',fieldName:'email'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary',block:true,disabled:this.form.valid===false||this.props.disableSubmit,onClick:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'account.resetPassword',defaultMessage:'Reset password'})));}}]);return ResetPasswordForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ResetPasswordForm.propTypes={onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disableSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordForm);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccountModalClientDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_DropdownSelect__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Client__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({clientFilterButton:{'id':'account.clientSearchButton','defaultMessage':'Search for clients'},clientFilterPlaceholder:{'id':'account.clientSearchPlaceholder','defaultMessage':'New search with Enter or search button'}});var AccountModalClientDropdown=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AccountModalClientDropdown,_Component);function AccountModalClientDropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AccountModalClientDropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AccountModalClientDropdown.__proto__||Object.getPrototypeOf(AccountModalClientDropdown)).call.apply(_ref,[this].concat(args))),_this),_this.getClientName=function(client){var name=client.lastname?client.firstname?client.lastname+' '+client.firstname:client.lastname:client.firstname?client.firstname:'';return client.company&&name.length>0?client.company+', '+name:client.company?client.company:name;},_this.getLabel=function(){var client=_this.props.client;return client?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].selectedTitleWithValue,{values:{value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.getClientName(client))}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].selectTitle);},_this.handleKeyPress=function(e){var searchClients=_this.props.searchClients;if(e.key==='Enter'){searchClients();}},_this.renderItems=function(){var _this$props=_this.props,clients=_this$props.clients,onSelect=_this$props.onSelect;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,clients.length>0?clients.map(function(client){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* DropdownItem */],{onClick:function onClick(e){return onSelect(client);},key:client.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.getClientName(client)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccountModalClientDropdown__filter-no-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].searchNoResultsSentence)));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AccountModalClientDropdown,[{key:'render',value:function render(){var _props=this.props,intl=_props.intl,setClientFilter=_props.setClientFilter,clientFilter=_props.clientFilter,searchClients=_props.searchClients,loading=_props.loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AccountModalClientDropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_DropdownSelect__["a" /* default */],{label:this.getLabel(),isLarge:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["w" /* InputGroup */],{className:'AccountModalClientDropdown__filter btn-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Input */],{value:clientFilter,onChange:function onChange(e){return setClientFilter(e.target.value);},onKeyPress:this.handleKeyPress,placeholder:intl.formatMessage(messages.clientFilterPlaceholder)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{onClick:searchClients,className:'AccountModalClientDropdown__filter-button',block:true},intl.formatMessage(messages.clientFilterButton))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:loading,forLoaded:this.renderItems})));}}]);return AccountModalClientDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AccountModalClientDropdown.propTypes={client:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Client__["a" /* default */]),clients:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Client__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Client__["a" /* default */]))]),clientFilter:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,setClientFilter:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,searchClients:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(AccountModalClientDropdown));

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CartModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__loader_BlockSpinner__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types_CartNewProductType__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__product_ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__slider_AlsoPurchasedProductsSlider__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartModal=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CartModal,_Component);function CartModal(props){_classCallCheck(this,CartModal);var _this=_possibleConstructorReturn(this,(CartModal.__proto__||Object.getPrototypeOf(CartModal)).call(this,props));_this.updateRightColumnHeight=function(){var rightColumnHeight=_this.rightColumn?_this.rightColumn.clientHeight:300;_this.setState({rightColumnHeight:rightColumnHeight});};_this.maybeLoadCart=function(){var _this$props=_this.props,cartStore=_this$props.cartStore,analytics=_this$props.analytics,location=_this$props.location,routeService=_this$props.routeService,sectionStore=_this$props.sectionStore,configStore=_this$props.configStore;if(cartStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].NONE&&!!!window.isSSR&&!configStore.siteConfig.isShoppingCenter){cartStore.loadCart().then(function(){var thankYouPath=Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["d" /* matchPath */])(location.pathname,{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].ThankYouPage,sectionStore.activeSection),strict:false,exact:true});if(!thankYouPath){analytics.cartStatus({cart:cartStore.cart});}});}};_this.handleOpen=function(){if(typeof document==='undefined'){return null;}document.body.classList.add('modal-open');_this.updateRightColumnHeight();};_this.handleCartPopulate=function(){var params=__WEBPACK_IMPORTED_MODULE_8_query_string___default.a.parse(_this.props.location.search,{arrayFormat:'brackets'});var action=params.action;var _this$props2=_this.props,cartStore=_this$props2.cartStore,history=_this$props2.history,location=_this$props2.location;if(!action||action!=='populate'){return false;}var productArr=_this.getProductsIdsFromUrl(params);if(productArr.length>0){cartStore.populate(productArr);history.replace(Object.assign({},location,{search:__WEBPACK_IMPORTED_MODULE_8_query_string___default.a.stringify({})}));return true;}return false;};_this.getProductsIdsFromUrl=function(params){var regex=/product\[(.+)\]/;return Object.keys(params).map(function(param){var match=regex.exec(param);if(match){return{id:match[1],qty:Number(params[param])};}return null;}).filter(function(element){return element;});};_this.changeBasket=function(event){var cartStore=_this.props.cartStore;cartStore.setBasket(event.target.value);};_this.getNewProductTitle=function(){var new_product_info=_this.props.cartStore.cart.new_product_info;var message=void 0;if(!new_product_info){return null;}switch(new_product_info.type){case __WEBPACK_IMPORTED_MODULE_18__types_CartNewProductType__["b" /* default */].BUNDLE:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].productBundleAddedToCartSentence);break;case __WEBPACK_IMPORTED_MODULE_18__types_CartNewProductType__["b" /* default */].NORMAL:case __WEBPACK_IMPORTED_MODULE_18__types_CartNewProductType__["b" /* default */].ARRAY:default:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].productAddedToCartSentence,{values:{quantity:new_product_info.quantity}}));break;}return message;};_this.createProductImage=function(url){return url?__WEBPACK_IMPORTED_MODULE_20__models_ProductImage__["a" /* default */].create({id:0,product_id:'',sizes:{small:url}}):null;};_this.getAlsoPurchased=function(){var alsoPurchasedProductId=_this.props.cartStore.alsoPurchasedProductId;if(!alsoPurchasedProductId){return null;}var actualId=alsoPurchasedProductId.split('{')[0];var product=_this.props.productStore.products.get(actualId);if(!product){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'CartModal__also-purchased mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__slider_AlsoPurchasedProductsSlider__["a" /* default */],{forceRefresh:true,variant:'cartModal',activeProductId:product.id,product:product})));};_this.getNewProductContent=function(){var withTax=_this.props.withTax;var new_product_info=_this.props.cartStore.cart.new_product_info;if(!new_product_info||new_product_info.type===__WEBPACK_IMPORTED_MODULE_18__types_CartNewProductType__["b" /* default */].ARRAY){return null;}var showUnit=!!new_product_info.stock_unit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'CartModal__left-column-left',xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__product_ProductImage__["a" /* default */],{product:new_product_info,productImage:_this.createProductImage(new_product_info.image),size:'small',forceAspectRatio:false,lazyLoading:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-manufacturer'},new_product_info.manufacturer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-name',dangerouslySetInnerHTML:{__html:new_product_info.name}}),new_product_info.variations.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-variations'},new_product_info.variations.map(function(variation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:variation,className:'CartModal__column-variation'},variation);})),new_product_info.price&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__product_Price__["a" /* default */],{price:new_product_info.price.getPrice(withTax)}),showUnit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CartModal__stock-unit'},' ','/ ',new_product_info.stock_unit)))));};_this.getProductsWithImage=function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{key:product.id,className:'CartModal__product-list--item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'CartModal__left-column-left d-flex align-content-center',xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-image d-flex align-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__product_ProductImage__["a" /* default */],{product:product,productImage:_this.createProductImage(product.image),size:'small',forceAspectRatio:false,lazyLoading:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,product.quantity,' ',product.stock_unit,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-name',dangerouslySetInnerHTML:{__html:product.name}}),product.variations.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-variations'},product.variations.map(function(variation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:variation,className:'CartModal__column-variation'},variation);})),product.total_price&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__product_Price__["a" /* default */],{price:product.total_price}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CartModal__stock-unit'},' ')))));};_this.getOptions=function(options){var withTax=_this.props.withTax;return options.map(function(option,index){var info='';if(option.info){info='('+option.info+')';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'CartModal__price',xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-options'},option.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-options-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__product_Price__["a" /* default */],{price:option.price.getPrice(withTax)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'CartModal__price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:info},className:'CartModal__price-option-info'})));});};_this.getProductList=function(){var cartStore=_this.props.cartStore;var cart=cartStore.cart;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,cart.getPhysicalProducts.map(function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:12,className:'CartModal__price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-products'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,product.quantity,' ',product.stock_unit),' ',product.name,product.variations.length>0&&' ('+product.variations.join(', ')+')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-products-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__product_Price__["a" /* default */],{price:product.total_price})));}));};_this.getNewProductPriceInfo=function(){var _this$props3=_this.props,cartStore=_this$props3.cartStore,withTax=_this$props3.withTax;var cart=cartStore.cart;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'CartModal__price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-products'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cart.productsTotalLabel',defaultMessage:'Products total:'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-products-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__product_Price__["a" /* default */],{price:cart.total.getPrice(withTax)})))),_this.getOptions(cart.options),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{className:'CartModal__price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-products-extra'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cart.productsTotalWithExtraLabel',defaultMessage:'Total amount'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].sumWithVat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-products-extra-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__product_Price__["a" /* default */],{price:cart.total_with_extra_costs.getPrice(withTax)})))));};_this.sendAnalyticsCheckoutEvent=function(){var _this$props4=_this.props,analytics=_this$props4.analytics,cartStore=_this$props4.cartStore,configStore=_this$props4.configStore;if(!configStore.gtm.enabled){return;}var cartProducts=cartStore.cart.products;var actionField={step:1,option:'Move To Checkout'};analytics.checkout(cartProducts,actionField);};_this.getCartContent=function(){var _this$props5=_this.props,cartStore=_this$props5.cartStore,uiStore=_this$props5.uiStore,configStore=_this$props5.configStore,intl=_this$props5.intl;var cart=cartStore.cart;var checkout=configStore.checkout;var productListImages=configStore.cartModal.productListImages;var showLeftColumn=!cartStore.cartModal.openedManually;var showProductListingColumn=cartStore.cartModal.openedManually&&productListImages&&cart.products.length>0;var leftColumnActive=showLeftColumn||showProductListingColumn;var showHigherButton=showLeftColumn&&uiStore.isMobile;var openedManually=cartStore.cartModal.openedManually;var continueShoppingButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__continue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'secondary',onClick:cartStore.cartModal.toggle,size:'lg',block:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Icon__["a" /* default */],{className:'CartModal__continue-icon',name:'angle-double-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cart.continueShopping',defaultMessage:'Continue shopping'})));var checkoutButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__checkout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{block:true,color:'primary',tag:'a',href:checkout.checkoutPath,rel:'noopener',size:'lg',onClick:_this.sendAnalyticsCheckoutEvent,'aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].proceedToCheckoutSentence)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Icon__["a" /* default */],{className:'CartModal__checkout-icon',name:'shopping-cart'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].proceedToCheckoutSentence)));// TODO: Change after coupons have been implemented
var activeCoupons=true;var selectBasketElementId='CartModal__select-basket';var productListHeight=_this.state.rightColumnHeight+'px';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,showLeftColumn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'12',md:'6',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CartModal__column CartModal__left-column',{'CartModal__left-column-with-coupons-compensation':activeCoupons})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'CartModal__title'},_this.getNewProductTitle()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-inner'},_this.getNewProductContent(),showProductListingColumn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__product-list--with-images',style:{maxHeight:productListHeight}},cart.products.map(function(product){return _this.getProductsWithImage(product);})))),showProductListingColumn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'12',md:'6',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CartModal__column CartModal__left-column',{'CartModal__left-column-with-coupons-compensation':activeCoupons,'order-2':showProductListingColumn&&uiStore.isMobile})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'CartModal__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].productsTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-inner--small-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__product-list--with-images',style:{maxHeight:productListHeight}},cart.products.map(function(product){return _this.getProductsWithImage(product);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:12,md:leftColumnActive?6:12,className:'CartModal__right-column CartModal__column'},showHigherButton&&checkoutButton,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'CartModal__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cart.cartContents',defaultMessage:'Cart contents'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__column-inner',ref:function ref(rightColumn){return _this.rightColumn=rightColumn;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CartModal__cart-product-count'},cart&&cart.baskets_and_templates.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["u" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["z" /* Label */],{'for':selectBasketElementId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cart.selectShoppingCart',defaultMessage:'Select shopping cart'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Input */],{type:'select',onChange:_this.changeBasket,id:selectBasketElementId,value:cart.selected_basket_id},cart.baskets_and_templates.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:option.id,value:option.id},option.text);}))),(!cart||cart.number_of_products===0)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].cartEmptySentence),cart&&cart.number_of_products>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cart.itemsInCart',defaultMessage:'{itemCount} in cart.',values:{itemCount:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].itemCount,{values:{count:cart.number_of_products}}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__price-information'},_this.getNewProductPriceInfo())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!showHigherButton&&checkoutButton,activeCoupons&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__coupon-instructions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cart.couponInstructions',defaultMessage:'Discount coupons may be provided on the checkout page.'})),continueShoppingButton)))),showLeftColumn&&!openedManually&&cartStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED&&_this.getAlsoPurchased());};_this.toggleCartModal=function(){return _this.props.cartStore.cartModal.toggle();};_this.rightColumn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state={rightColumnHeight:null};return _this;}_createClass(CartModal,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,cartStore=_props.cartStore,history=_props.history;var cartModal=cartStore.cartModal;var populated=this.handleCartPopulate();if(!populated){this.maybeLoadCart();}// Close modal if user navigates to new product with AlsoPurchasedSlider
history.listen(function(location){if(cartModal.isOpen){cartModal.toggle();}});}},{key:'render',value:function render(){var _props2=this.props,cartStore=_props2.cartStore,configStore=_props2.configStore;var productListImages=configStore.cartModal.productListImages;if(!cartStore.cart){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["C" /* Modal */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('CartModal',{'CartModal--after-add-to-cart':!cartStore.cartModal.openedManually||productListImages&&cartStore.cart.products.length>0}),size:'lg',onOpened:this.handleOpen,isOpen:cartStore.cartModal.isOpen,toggle:cartStore.cartModal.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartModal__hanging-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{onClick:this.toggleCartModal.bind(this),color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CartModal__close-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Icon__["a" /* default */],{className:'CartModal__close-icon',name:'times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].closeTitle)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* ModalBody */],null,cartStore.state===__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADING?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__loader_BlockSpinner__["a" /* default */],null):this.getCartContent()));}}]);return CartModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CartModal.propTypes={cartStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_CartStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_26__store_ConfigStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_25__store_ProductStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_23__store_SectionStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_UIStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_21__analytics_Analytics__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_22__services_RouteService__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,location:__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default.a.location.isRequired,withTax:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])(function(stores){return{cartStore:stores.cartStore,configStore:stores.configStore,sectionStore:stores.sectionStore,productStore:stores.productStore,uiStore:stores.uiStore,analytics:stores.analytics,routeService:stores.routeService,withTax:stores.accountStore.showPricesWithTax};})(CartModal))));

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_info_page_InfoPageNavigation__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_InfoPageStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_layout_SidebarLayout__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_head_SEODescription__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ad_SidebarBanner__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ad_BannerSlider__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_WysiwygOrBlockContent__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(InfoPage,_Component);function InfoPage(props){_classCallCheck(this,InfoPage);var _this=_possibleConstructorReturn(this,(InfoPage.__proto__||Object.getPrototypeOf(InfoPage)).call(this,props));_initialiseProps.call(_this);var infoPageStore=_this.props.infoPageStore;_this.state={contentState:__WEBPACK_IMPORTED_MODULE_18__types_RequestState__["b" /* default */].LOADED};_this.yotpoTimeout=null;// We load all pages without content first for hierarchy
if(infoPageStore.state!==__WEBPACK_IMPORTED_MODULE_18__types_RequestState__["b" /* default */].LOADED){infoPageStore.loadPages().then(function(){_this.maybeLoadPage();});}else{_this.maybeLoadPage();}return _this;}_createClass(InfoPage,[{key:'componentDidMount',value:function componentDidMount(){var configStore=this.props.configStore;if(configStore.yotpo.enabled&&window&&window.yotpo){this.yotpoTimeout=setTimeout(function(){return window.yotpo.refreshWidgets();},800);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props=this.props,match=_props.match,history=_props.history,routeService=_props.routeService;if(prevProps.match.params.id!==match.params.id){this.maybeLoadPage();}// If we have a link, where the slug is '-', update it.
// Used when linking based only on page ID.
if(match.params.slug==='-'){var infoPage=this.getActiveInfoPage();if(infoPage){history.replace(''+routeService.getPath(infoPage.path)+history.location.search+history.location.hash);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.yotpoTimeout&&clearTimeout(this.yotpoTimeout);}},{key:'render',value:function render(){var _props2=this.props,match=_props2.match,location=_props2.location,infoPageStore=_props2.infoPageStore,routeService=_props2.routeService;var infoPage=this.getActiveInfoPage();if(infoPage){if(!Object(__WEBPACK_IMPORTED_MODULE_26__util_url__["h" /* pathFragmentMatchesLocation */])(infoPage.path,location.pathname)){var url=''+routeService.getPath(infoPage.path)+location.search+location.hash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* Redirect */],{to:url});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_28__types_CommonPage__["b" /* default */].INFO,className:'InfoPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_common_ScrollReset__["a" /* default */],{key:match.params.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_loader_ContentForState__["a" /* default */],{state:this.state.contentState,error:infoPageStore.lastError,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,infoPage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(infoPage.path)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'InfoPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_layout_SidebarLayout__["a" /* default */],{sidebar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_info_page_InfoPageNavigation__["a" /* default */],{currentInfoPage:infoPage,key:infoPage?infoPage.id:-1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_ad_SidebarBanner__["a" /* default */],null)),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_loader_ContentForState__["a" /* default */],{state:infoPageStore.pageStates.get(match.params.id),error:infoPageStore.lastSinglePageError,forLoaded:function forLoaded(){if(!infoPage){// The page should always exist if no error occurred, but...
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_loader_UnexpectedError__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:routeService.transformBreadCrumbs(infoPage.breadcrumbs)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_PageTitle__["a" /* default */],null,infoPage.name),infoPage.content!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_SEOTitle__["a" /* default */],{title:infoPage.SEO_title||infoPage.name,noSuffix:!!infoPage.SEO_title}),infoPage.SEO_description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_head_SEODescription__["a" /* default */],{content:infoPage.SEO_description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'InfoPage__contents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_common_WysiwygOrBlockContent__["a" /* default */],{content:infoPage.content})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_ad_BannerSlider__["a" /* default */],{searchParams:{bannerZone:__WEBPACK_IMPORTED_MODULE_21__types_AdZones__["a" /* default */].INFO_PAGE_BANNER},aspectRatio:2.85}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_ad_ContentPopup__["a" /* default */],null)));}})})));}}));}}]);return InfoPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.maybeLoadPage=function(){var _props3=_this2.props,infoPageStore=_props3.infoPageStore,configStore=_props3.configStore,match=_props3.match;var pageState=infoPageStore.pageStates.get(match.params.id);if(!pageState||pageState!==__WEBPACK_IMPORTED_MODULE_18__types_RequestState__["b" /* default */].LOADED){_this2.setState({contentState:__WEBPACK_IMPORTED_MODULE_18__types_RequestState__["b" /* default */].LOADING});infoPageStore.loadPage(match.params.id).then(function(){if(configStore.yotpo.enabled&&window&&window.yotpo){_this2.yotpoTimeout=setTimeout(function(){return window.yotpo.refreshWidgets();},800);}_this2.setState({contentState:__WEBPACK_IMPORTED_MODULE_18__types_RequestState__["b" /* default */].LOADED});}).catch(function(e){_this2.setState({contentState:__WEBPACK_IMPORTED_MODULE_18__types_RequestState__["b" /* default */].ERROR});console.error(e);});}};this.getActiveInfoPage=function(){var _props4=_this2.props,match=_props4.match,infoPageStore=_props4.infoPageStore;var activePageId=match.params.id;return infoPageStore.pages.get(activePageId);};},_temp))||_class;InfoPage.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_27__store_ConfigStore__["a" /* default */]),infoPageStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_InfoPageStore__["a" /* default */]),match:__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default.a.match.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','infoPageStore','routeService')(InfoPage));

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InfoPageNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_InfoPage__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_InfoPageStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InfoPageList__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_TopLevelNavigationDropdown__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoPageNavigation=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(InfoPageNavigation,_Component);function InfoPageNavigation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPageNavigation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPageNavigation.__proto__||Object.getPrototypeOf(InfoPageNavigation)).call.apply(_ref,[this].concat(args))),_this),_this.getActiveInfoPages=function(){return[].concat(_toConsumableArray(_this.props.currentInfoPage.ancestors),[_this.props.currentInfoPage]);},_this.getInfoPages=function(id){var infoPageStore=_this.props.infoPageStore;return infoPageStore.pagesArray.filter(function(page){return!page.parent_id&&page.show_in_listing&&page.id===id;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPageNavigation,[{key:'render',value:function render(){var _props=this.props,currentInfoPage=_props.currentInfoPage,uiStore=_props.uiStore,configStore=_props.configStore;var activeInfoPages=currentInfoPage?this.getActiveInfoPages():[];if(!uiStore.isDesktop){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,configStore.mainNavigation.useSidebar&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_TopLevelNavigationDropdown__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'InfoPageNavigation'},activeInfoPages.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__InfoPageList__["a" /* default */],{infoPages:this.getInfoPages(activeInfoPages[0].id),activeInfoPages:activeInfoPages})));}}]);return InfoPageNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;InfoPageNavigation.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_UIStore__["a" /* default */]).isRequired,infoPageStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_InfoPageStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_ConfigStore__["a" /* default */]).isRequired,currentInfoPage:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__models_InfoPage__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('infoPageStore','uiStore','configStore')(InfoPageNavigation));

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InfoPageList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_InfoPage__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_NavigationTree__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoPageList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(InfoPageList,_Component);function InfoPageList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPageList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPageList.__proto__||Object.getPrototypeOf(InfoPageList)).call.apply(_ref,[this].concat(args))),_this),_this.convertInfoPagesToNavigationEntities=function(infoPages,activeInfoPages){var routeService=_this.props.routeService;var orderedPages=infoPages;if(infoPages.length>1){orderedPages=__WEBPACK_IMPORTED_MODULE_0_lodash_orderBy___default()(infoPages,['sort_order']);}return orderedPages.filter(function(page){return page.show_in_listing;}).map(function(page){return{id:page.id,sort_order:page.sort_order,label:page.name,active:activeInfoPages.indexOf(page)!==-1,path:routeService.getPath(page.path),children:_this.convertInfoPagesToNavigationEntities(page.children,activeInfoPages)};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPageList,[{key:'render',value:function render(){var _props=this.props,infoPages=_props.infoPages,activeInfoPages=_props.activeInfoPages;var navigationEntities=this.convertInfoPagesToNavigationEntities(infoPages,activeInfoPages);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__navigation_NavigationTree__["a" /* default */],{items:navigationEntities,className:'InfoPageList'});}}]);return InfoPageList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;InfoPageList.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired,infoPages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_InfoPage__["a" /* default */])).isRequired,activeInfoPages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_InfoPage__["a" /* default */])).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('routeService')(InfoPageList));

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(488),
    isArray = __webpack_require__(47);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WysiwygContent___ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BlockContent__ = __webpack_require__(1337);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WysiwygOrBlockContent=function(_Component){_inherits(WysiwygOrBlockContent,_Component);function WysiwygOrBlockContent(){_classCallCheck(this,WysiwygOrBlockContent);return _possibleConstructorReturn(this,(WysiwygOrBlockContent.__proto__||Object.getPrototypeOf(WysiwygOrBlockContent)).apply(this,arguments));}_createClass(WysiwygOrBlockContent,[{key:'render',value:function render(){var content=this.props.content;var json=void 0;try{json=JSON.parse(content);}catch(e){}var output=void 0;if(json&&Array.isArray(json)){output=json.map(function(block,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BlockContent__["a" /* default */],{key:index,block:block});});}else{output=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__WysiwygContent___["a" /* default */],{html:content});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'WysiwygOrBlockContent'},output);}}]);return WysiwygOrBlockContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);__WEBPACK_IMPORTED_MODULE_2__WysiwygContent___["a" /* default */].propTypes={content:__WEBPACK_IMPORTED_MODULE_1_prop_types____default.a.string};/* harmony default export */ __webpack_exports__["a"] = (WysiwygOrBlockContent);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BlockTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WysiwygContent___ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contact_us_ContactUsForm__ = __webpack_require__(1338);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BlockTypes={CONTACT_FORM:'contactUs',WYSIWYG:'ckeditor'};var BlockContent=function(_Component){_inherits(BlockContent,_Component);function BlockContent(){_classCallCheck(this,BlockContent);return _possibleConstructorReturn(this,(BlockContent.__proto__||Object.getPrototypeOf(BlockContent)).apply(this,arguments));}_createClass(BlockContent,[{key:'render',value:function render(){var block=this.props.block;var content=void 0;switch(block.type){case BlockTypes.CONTACT_FORM:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__contact_us_ContactUsForm__["a" /* default */],null);break;case BlockTypes.WYSIWYG:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__WysiwygContent___["a" /* default */],{html:block.content});break;default:content=null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BlockContent BlockContent--'+block.type},content);}}]);return BlockContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BlockContent.propTypes={block:__WEBPACK_IMPORTED_MODULE_1_prop_types____default.a.shape({type:__WEBPACK_IMPORTED_MODULE_1_prop_types____default.a.string.isRequired})};/* harmony default export */ __webpack_exports__["a"] = (BlockContent);

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContactUsForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_CheckboxField__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_ErrorHandler__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__privacy_statement_PrivacyStatementLink__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_RecaptchaField__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_LanguageStore__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={fullName:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].fullNameTitle),lastName:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].lastNameTitle),email:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailTitle),telephone:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].telephoneTitle),streetAddress:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].streetAddressTitle),postalCode:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].zipCodeTitle),city:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].cityTitle),message:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].messageTitle),privacyStatement:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].privacyStatementAcceptSentence)};function createOption(value,label){return{value:value,label:label};}var ContactUsForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(ContactUsForm,_Component);function ContactUsForm(props){_classCallCheck(this,ContactUsForm);var _this=_possibleConstructorReturn(this,(ContactUsForm.__proto__||Object.getPrototypeOf(ContactUsForm)).call(this,props));_initialiseProps.call(_this);var configStore=_this.props.configStore;_this.form=Object(__WEBPACK_IMPORTED_MODULE_6__models_Form__["a" /* createForm */])({fullName:Object(__WEBPACK_IMPORTED_MODULE_12__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["e" /* minLength */])(labels.fullName,configStore.formValidation.firstName.minLength)]),email:Object(__WEBPACK_IMPORTED_MODULE_12__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["e" /* minLength */])(labels.email,configStore.formValidation.email.minLength),Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["d" /* isEmail */])(labels.email)]),telephone:Object(__WEBPACK_IMPORTED_MODULE_12__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["e" /* minLength */])(labels.telephone,configStore.formValidation.telephone.minLength)],function(){return configStore.contactUs.requirePhone;}),streetAddress:Object(__WEBPACK_IMPORTED_MODULE_12__models_FormField__["a" /* createFormField */])({},configStore.contactUs.requireAddress?[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["e" /* minLength */])(labels.streetAddress,configStore.formValidation.streetAddress.minLength)]:[],function(){return configStore.contactUs.enableAddress;}),postalCode:Object(__WEBPACK_IMPORTED_MODULE_12__models_FormField__["a" /* createFormField */])({},configStore.contactUs.requireAddress?[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["e" /* minLength */])(labels.postalCode,configStore.formValidation.postalCode.minLength)]:[],function(){return configStore.contactUs.enableAddress;}),city:Object(__WEBPACK_IMPORTED_MODULE_12__models_FormField__["a" /* createFormField */])({},configStore.contactUs.requireAddress?[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["e" /* minLength */])(labels.city,configStore.formValidation.city.minLength)]:[],function(){return configStore.contactUs.enableAddress;}),message:Object(__WEBPACK_IMPORTED_MODULE_12__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["g" /* notBlank */])(labels.message)]),privacyStatement:Object(__WEBPACK_IMPORTED_MODULE_12__models_FormField__["a" /* createFormField */])({},[function(value){return!value?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({key:'mustApprove'},__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].privacyStatementMustApproveSentence)):null;}])});return _this;}_createClass(ContactUsForm,[{key:'render',value:function render(){var requestState=this.state.requestState;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ContactUsForm'},requestState===__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADED?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'contactUs.success',defaultMessage:'Your message was sent to our customer service successfully. We aim to handle the message as soon as possible.'})):this.getForm());}}]);return ContactUsForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='ContactUsForm';this.state={recaptcha:null,error:null,requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].NONE,// This is used to know, if we've made a new request so we can re-animate errors
requestId:0};this.onRecaptchaChange=function(value){_this2.setState({recaptcha:value});};this.isRecaptchaValid=function(){var recaptcha=_this2.state.recaptcha;var configStore=_this2.props.configStore;return!!recaptcha||!configStore.contactUs.enableCaptcha;};this.handleSubmit=function(e){e.preventDefault();var recaptcha=_this2.state.recaptcha;var _props=_this2.props,apiWrapper=_props.apiWrapper,languageStore=_props.languageStore;_this2.form.validate();if(_this2.form.valid&&_this2.isRecaptchaValid()){_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADING});apiWrapper.apiAxios().post('forms/contact-us?lang='+languageStore.activeLocale,Object.assign({recaptcha:recaptcha},_this2.form.getFieldValues())).then(function(){_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADED});}).catch(function(error){_this2.setState({requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].ERROR,error:error,requestId:_this2.state.requestId+1});});}};this.field=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__["a" /* default */],Object.assign({required:field.hasValidators(),field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.checkbox=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_CheckboxField__["a" /* default */],Object.assign({required:field.hasValidators(),field:field,formName:_this2.formName,fieldName:fieldName},props));};this.getErrorMessages=function(){var error=_this2.state.error;return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(error,'response.data.messages');};this.getForm=function(){var _state=_this2.state,requestState=_state.requestState,requestId=_state.requestId,error=_state.error;var configStore=_this2.props.configStore;// If address fields are shown, make the message field a bit longer.
var messageRows=configStore.contactUs.enableAddress?10:7;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{className:'ContactUsForm__form',noValidate:true,onSubmit:_this2.handleSubmit},error&&__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(error,'response.status')!==422&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_ErrorHandler__["a" /* default */],{error:Object(__WEBPACK_IMPORTED_MODULE_16__util_error__["a" /* createErrorModel */])(error)}),_this2.getErrorMessages()&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'danger',key:requestId},_this2.getErrorMessages().map(function(message,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:index},message);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'6'},_this2.field('fullName',{autoComplete:'name'}),_this2.field('streetAddress',{autoComplete:'street-address'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{sm:'4'},_this2.field('postalCode',{autoComplete:'postal-code'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{sm:'8'},_this2.field('city',{autoComplete:'address-level2'}))),_this2.field('email',{type:'email',autoComplete:'email'}),_this2.field('telephone',{type:'tel',autoComplete:'tel-national'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'6'},_this2.field('message',{type:'textarea',rows:messageRows}),_this2.checkbox('privacyStatement',{options:createOption('1',labels.privacyStatement)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ContactUsForm__privacy-statement-link-wrapper'},'(',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__privacy_statement_PrivacyStatementLink__["a" /* default */],null),')'),configStore.contactUs.enableCaptcha&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__form_RecaptchaField__["a" /* default */],{key:requestId,ref:function ref(recaptcha){return _this2.recaptcha=recaptcha;},onChange:_this2.onRecaptchaChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary',block:true,disabled:_this2.form.valid===false||_this2.isRecaptchaValid()===false||requestState===__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADING},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].sendTitle)))));};},_temp))||_class;ContactUsForm.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ConfigStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_LanguageStore__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_18__services_ApiWrapper__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('configStore','languageStore','apiWrapper')(ContactUsForm));

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductTabs__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_AdPages__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_SEOHomePage__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomePage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(HomePage,_Component);function HomePage(props){_classCallCheck(this,HomePage);var _this=_possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).call(this,props));_this.getSearchParams=function(){return{bannerPage:__WEBPACK_IMPORTED_MODULE_12__types_AdPages__["a" /* default */].FRONT_PAGE};};_this.yotpoTimeout=null;return _this;}_createClass(HomePage,[{key:'componentDidMount',value:function componentDidMount(){var configStore=this.props.configStore;if(configStore.yotpo.enabled&&window&&window.yotpo){this.yotpoTimeout=setTimeout(function(){return window.yotpo.refreshWidgets();},800);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.yotpoTimeout&&clearTimeout(this.yotpoTimeout);}},{key:'render',value:function render(){var configStore=this.props.configStore;var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ad_MainBanner__["a" /* default */],{searchParams:this.getSearchParams()});var mainBannerWithinContent=configStore.mainBanner.withinContent&&!configStore.mainBanner.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_16__types_CommonPage__["b" /* default */].HOME,className:'HomePage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_SEOHomePage__["a" /* default */],null),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'HomePage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SectionPage__section-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_WysiwygContent__["a" /* default */],{html:configStore.frontpageText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductTabs__["a" /* default */],{disableQuickSearch:true,requireCanonicalLink:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ad_ContentPopup__["a" /* default */],{searchParams:this.getSearchParams()}))})));}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;HomePage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','routeService')(HomePage));

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AdvancedSearchPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types_SortOrder__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_head_RobotsMeta__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdvancedSearchPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AdvancedSearchPage,_Component);function AdvancedSearchPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AdvancedSearchPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AdvancedSearchPage.__proto__||Object.getPrototypeOf(AdvancedSearchPage)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].searchResultsTitle),url:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].AdvancedSearch}]);},_this.renderSearchContent=function(searchText){var listName='Advanced Search List';var fixedParams={text:searchText,orderBy:__WEBPACK_IMPORTED_MODULE_17__types_ProductSortOrderBy__["a" /* default */].RELEVANCE,order:__WEBPACK_IMPORTED_MODULE_18__types_SortOrder__["a" /* default */].DESC,excludeContent:1};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showSort:false,allSections:true,redirectOnSingleMatch:true,disableQuickSearch:true,advancedSearchPage:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AdvancedSearchPage,[{key:'render',value:function render(){var _props=this.props,location=_props.location,routeService=_props.routeService;var queryParams=Object(__WEBPACK_IMPORTED_MODULE_12__util_queryString__["b" /* parse */])(location.search);var searchText=queryParams.keywords;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_22__types_CommonPage__["b" /* default */].ADVANCED_SEARCH,className:'AdvancedSearchPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_common_ScrollReset__["a" /* default */],{key:searchText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_head_SEOTitle__["a" /* default */],{title:Object.assign({values:{term:searchText}},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].searchResultsForTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].AdvancedSearch)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_head_RobotsMeta__["a" /* default */],{noindex:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'AdvancedSearchPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].searchResultsForTermTitle,{values:{term:searchText}}))),searchText?this.renderSearchContent(searchText):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'search.termTooShort',defaultMessage:'Search term is too short.'})))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_ad_ContentPopup__["a" /* default */],null));}}]);return AdvancedSearchPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AdvancedSearchPage.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService')(AdvancedSearchPage))));

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var setResizeListener=function setResizeListener(callback){var pending=false;var doResize=function doResize(width){if(!pending&&!!width){pending=true;window.requestAnimationFrame(function(){callback(width);pending=false;});}};window.addEventListener('resize',function(e){e.preventDefault();doResize(window.innerWidth);},true);// Initialize with current width
doResize(window.innerWidth);};/* harmony default export */ __webpack_exports__["a"] = (setResizeListener);

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GoogleAnalyticsGTM__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoogleTagManager=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(GoogleTagManager,_Component);function GoogleTagManager(){_classCallCheck(this,GoogleTagManager);return _possibleConstructorReturn(this,(GoogleTagManager.__proto__||Object.getPrototypeOf(GoogleTagManager)).apply(this,arguments));}_createClass(GoogleTagManager,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,accountStore=_props.accountStore,configStore=_props.configStore;if(configStore.gtm.enabled){new __WEBPACK_IMPORTED_MODULE_5__GoogleAnalyticsGTM__["a" /* default */](accountStore);}}},{key:'render',value:function render(){var configStore=this.props.configStore;if(!configStore.gtm.enabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,'\n            window.dataLayer = window.dataLayer || [];\n            window.dataLayer.push({\n              originalLocation: document.location.protocol + \'//\' +\n              document.location.hostname +\n              document.location.pathname +\n              document.location.search\n            });\n            '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,'(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n            new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n            \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,\'script\',\'dataLayer\',\''+configStore.gtm.containerId+'\');')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'GTM',src:'https://www.googletagmanager.com/ns.html?id='+configStore.gtm.containerId,height:'0',width:'0',style:{display:'none',visibility:'hidden'}})));}}]);return GoogleTagManager;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;GoogleTagManager.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','configStore')(GoogleTagManager));

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleAnalyticsGTM; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_chunk__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_OrderTotalClass__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var IMPRESSION_MAX_BATCH_SIZE=35;var dimension1={VISITOR:'Vierailija asiakas',LOGGED_IN_USER:'Kirjautunut asiakas'};var dimension2={RETAILER:'Tukkuasiakas',CONSUMER:'Kuluttaja-asiakas'};var GoogleAnalyticsGTM=function(){function GoogleAnalyticsGTM(accountStore){var _this=this;_classCallCheck(this,GoogleAnalyticsGTM);this.handleEvents=function(event){switch(event.detail.name){case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].addToCart:_this.addToCart(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].productClick:_this.productClick(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].productImpressions:_this.productImpressions(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].productDetail:_this.productDetail(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].promotionClick:_this.promotionClick(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].promoView:_this.promoView(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].purchase:_this.purchase(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].removeFromCart:_this.removeFromCart(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].reserveAndCollect:_this.sendReserveAndCollect(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].updateDimension:_this.updateDimension(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].checkout:_this.checkout(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].pageNotFound:_this.sendPageNotFoundError(event.detail.payload);break;default:}};this.createCartProductFieldObject=function(product){var id=product.product_id;var category=product.category_name;var price=product.total_price;var quantity=product.quantity;var name=product.name;var cartProductFieldObject={id:id,quantity:quantity,name:name};if(category){cartProductFieldObject.category=category;}if(price){cartProductFieldObject.price=price;}return cartProductFieldObject;};this.cartDataToProductFieldObjectList=function(product){var productFieldObject=_this.createCartProductFieldObject(product);if(product.variations&&product.variations.length>0){productFieldObject.variant=product.variations.join(',');}return productFieldObject;};this.accountStore=accountStore;this.initializeDataLayer();Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["autorun"])(function(){var initialDataLayer={loggedInStatus:_this.accountStore.loggedIn?dimension1.LOGGED_IN_USER:dimension1.VISITOR,customerType:_this.accountStore.isRetailer?dimension2.RETAILER:dimension2.CONSUMER,customerGroup:_this.accountStore.account.group_name};window.dataLayer.push(initialDataLayer);});document.addEventListener('analytics',this.handleEvents,true);// We use our own impressionDataQueue & promoViewDataQueue to hold the data in order to send it in batches
this.impressionDataQueue=[];this.promoViewDataQueue=[];// We don't want to spam Google Analytics, so we will always wait for 100ms for new data before sending impressions
// and promoViews data out. If we have a constant flow of data, we will send data every 500 ms (maxWait).
var wait=100;// ms
var maxWait=500;// ms
this.requestImpressionPushToDataLayer=__WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(this.pushImpressionsToDataLayer,wait,{maxWait:maxWait});this.requestPromoViewPushToDataLayer=__WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(this.pushPromoViewsToDataLayer,wait,{maxWait:maxWait});}_createClass(GoogleAnalyticsGTM,[{key:'initializeDataLayer',value:function initializeDataLayer(){if(!window.dataLayer){window.dataLayer=[];}}/**
   * @param {string} currencyCode
   * @param {Array} productList An array with objects in the format { quantity, product, price, activeProductId }.
   */},{key:'addToCart',value:function addToCart(_ref){var _this2=this;var currencyCode=_ref.currencyCode,productList=_ref.productList;var data={ecommerce:{currencyCode:currencyCode,add:{products:productList.map(function(item){return _this2.productListObjectToProductFieldObject(item);})}}};this.pushEventToDataLayer(data,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].addToCart);}},{key:'checkout',value:function checkout(_ref2){var _this3=this;var currencyCode=_ref2.currencyCode,productList=_ref2.productList,actionField=_ref2.actionField;var data={ecommerce:{currencyCode:currencyCode,checkout:{actionField:actionField,products:productList.map(function(product){return _this3.cartDataToProductFieldObjectList(product);})}}};this.pushEventToDataLayer(data,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].checkout);}},{key:'sendPageNotFoundError',value:function sendPageNotFoundError(_ref3){var location=_ref3.location,referrer=_ref3.referrer;var data={ecommerce:{pageNotFound:{address:location,referrer:referrer}}};this.pushEventToDataLayer(data,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].pageNotFound);}/**
   * @param {string} currencyCode
   * @param {Array} productList An array with objects in the format { quantity, product, price, activeProductId }.
   */},{key:'removeFromCart',value:function removeFromCart(_ref4){var _this4=this;var currencyCode=_ref4.currencyCode,productList=_ref4.productList;var data={ecommerce:{currencyCode:currencyCode,remove:{products:productList.map(function(item){return _this4.productListObjectToProductFieldObject(item);})}}};this.pushEventToDataLayer(data,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].removeFromCart);}/**
   * @param {string} currencyCode
   * @param {Array} productList An array with objects in the format { position, product }.
   * @param {string} listName
   */},{key:'productClick',value:function productClick(_ref5){var _this5=this;var currencyCode=_ref5.currencyCode,productList=_ref5.productList,listName=_ref5.listName;var data={ecommerce:{currencyCode:currencyCode,click:{products:productList.map(function(item){return _this5.productListObjectToProductFieldObject(item);})}}};if(listName){data.ecommerce.click.actionField={list:listName};}this.pushEventToDataLayer(data,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].productClick);}/**
   * @param {string} currencyCode
   * @param {Array} productList An array with objects in the format { position, product }.
   * @param {string} listName
   */},{key:'productImpressions',value:function productImpressions(_ref6){var _this6=this;var currencyCode=_ref6.currencyCode,productList=_ref6.productList,listName=_ref6.listName;var impressions=productList.map(function(item){return _this6.productListObjectToProductFieldObject(item);});if(listName){impressions.forEach(function(productFieldObject){productFieldObject.list=listName;});}this.pushToImpressionDataQueue(impressions,currencyCode);}/**
   * @param {string} currencyCode
   * @param {Array} productList An array with objects in the format { product }.
   */},{key:'productDetail',value:function productDetail(_ref7){var _this7=this;var currencyCode=_ref7.currencyCode,productList=_ref7.productList;var data={ecommerce:{currencyCode:currencyCode,detail:{products:productList.map(function(item){return _this7.productListObjectToProductFieldObject(item);})}}};this.pushEventToDataLayer(data,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].productDetail);}/**
   * @param {Array} bannerList An array with objects in the format { banner, bannerZone }.
   */},{key:'promotionClick',value:function promotionClick(_ref8){var _this8=this;var bannerList=_ref8.bannerList;var data={ecommerce:{promoClick:{promotions:bannerList.map(function(item){return _this8.bannerListobjectToPromoFieldObject(item);})}}};this.pushEventToDataLayer(data,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].promotionClick);}/**
   * @param {Array} bannerList An array with objects in the format { banner, bannerZone }.
   */},{key:'promoView',value:function promoView(_ref9){var _this9=this;var bannerList=_ref9.bannerList;var promotions=bannerList.map(function(item){return _this9.bannerListobjectToPromoFieldObject(item);});this.pushToPromoViewDataQueue(promotions);}/**
   * @param {Order} order An order
   * @param {Product[]} products An array with products
   */},{key:'purchase',value:function purchase(_ref10){var _this10=this;var order=_ref10.order,products=_ref10.products;var productDataById=__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(products,'id');var orderTotalsByClass=__WEBPACK_IMPORTED_MODULE_1_lodash_keyBy___default()(order.totals,'class');var getTotalByClass=function getTotalByClass(totalClass){var total=orderTotalsByClass[totalClass];// The totals we use should always be there, but...
return total?total.analytics_value:null;};var orderProducts=order.products.map(function(product){var matchingPhysicalProduct=productDataById[product.product_id];// This conveniently filters out the "meta products", e.g. shipping or
// service fees, which we don't have in the Products API.
// (We don't currently know the types of the included products.)
if(!matchingPhysicalProduct){return null;}var isWholeNumber=!!(product.package_size&&product.package_size%1===0);return _this10.productListObjectToProductFieldObject({product:matchingPhysicalProduct,quantity:isWholeNumber?product.package_size*product.quantity:product.quantity,price:!isWholeNumber&&product.package_size!==null?product.package_size*product.analytics_final_unit_price:product.analytics_final_unit_price,activeProductId:product.id},true);}).filter(function(product){return!!product;});var data={ecommerce:{currencyCode:order.analytics_currency,purchase:{actionField:{id:order.id_for_analytics,revenue:getTotalByClass(__WEBPACK_IMPORTED_MODULE_6__types_OrderTotalClass__["b" /* default */].TOTAL),tax:getTotalByClass(__WEBPACK_IMPORTED_MODULE_6__types_OrderTotalClass__["b" /* default */].TAX_TOTAL),shipping:getTotalByClass(__WEBPACK_IMPORTED_MODULE_6__types_OrderTotalClass__["b" /* default */].EXTRA_TOTAL),coupon:order.campaign_code},products:orderProducts}}};this.pushEventToDataLayer(data,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].purchase);}},{key:'sendReserveAndCollect',value:function sendReserveAndCollect(data){var analyticsData={ecommerce:Object.assign({},data)};this.pushEventToDataLayer(analyticsData,__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].reserveAndCollect);}},{key:'bannerListobjectToPromoFieldObject',value:function bannerListobjectToPromoFieldObject(_ref11){var bannerZone=_ref11.bannerZone,banner=_ref11.banner;// TODO Check name & creative fields with marketing
return{id:banner.id,name:banner.title||banner.image,creative:banner.image,position:bannerZone};}},{key:'productListObjectToProductFieldObject',value:function productListObjectToProductFieldObject(_ref12){var product=_ref12.product,quantity=_ref12.quantity,position=_ref12.position,price=_ref12.price,newQuantity=_ref12.newQuantity,activeProductId=_ref12.activeProductId;var knownProduct=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(product.class===__WEBPACK_IMPORTED_MODULE_5__types_ProductClass__["b" /* default */].MULTI&&activeProductId){product=product.multi.findChild(activeProductId)||product;}// Product is known when it is in checkout or later stage
var productName=knownProduct?product.name:product.multiproduct_title||product.name;var productFieldObject={name:productName,id:product.id,category:product.mainCategory&&product.mainCategory.hierarchy.map(function(category){return category.name;}).join('/')};if(product.class===__WEBPACK_IMPORTED_MODULE_5__types_ProductClass__["b" /* default */].COLLECTION&&activeProductId){productFieldObject.variant=this.formatCollectionVariant(product.collection,activeProductId);}// If no numeric price is given, default to price with tax
if(!(Number(price)===price)){price=product.price_info?product.price_info.getPrice(true):0.0;}productFieldObject.price=price.toFixed(2);if(product.manufacturer){productFieldObject.brand=product.manufacturer.name;}// Product may have newQuantity or quantity field.
var realQuantity=newQuantity||quantity;if(realQuantity){productFieldObject.quantity=realQuantity;}if(position){productFieldObject.position=position;}return productFieldObject;}},{key:'formatCollectionVariant',value:function formatCollectionVariant(collection,activeProductId){var item=collection.getItemWithProductId(activeProductId);var columnElement=collection.column.getElementWithId(item.column_id);var columnElementFormatted=this.formatPropertyElement(columnElement);var rowElement=collection.row.getElementWithId(item.row_id);var rowElementFormatted=this.formatPropertyElement(rowElement);return columnElementFormatted+' - '+rowElementFormatted;}},{key:'formatPropertyElement',value:function formatPropertyElement(element){return element.name+' (ID: '+element.id+')';}/**
   * Impressions come from multiple components, so we queue them instead of sending them right away.
   *
   * @param impressions
   * @param currencyCode
   */},{key:'pushToImpressionDataQueue',value:function pushToImpressionDataQueue(impressions,currencyCode){this.impressionCurrencyCode=currencyCode;this.impressionDataQueue=this.impressionDataQueue.concat(impressions);this.requestImpressionPushToDataLayer();}},{key:'pushImpressionsToDataLayer',value:function pushImpressionsToDataLayer(){var _this11=this;// GA has a maximum payload size of 8KB. If we have too many impressions we need to split them into chunks.
var impressionChunks=__WEBPACK_IMPORTED_MODULE_0_lodash_chunk___default()(this.impressionDataQueue,IMPRESSION_MAX_BATCH_SIZE);impressionChunks.forEach(function(impressionChunk){return _this11.pushEventToDataLayer({ecommerce:{currencyCode:_this11.impressionCurrencyCode,impressions:impressionChunk}},__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].productImpressions);});this.impressionDataQueue=[];}/**
   * Promo views come from multiple components, so we queue them instead of sending them right away.
   * @param promoViews
   */},{key:'pushToPromoViewDataQueue',value:function pushToPromoViewDataQueue(promoViews){this.promoViewDataQueue=this.promoViewDataQueue.concat(promoViews);this.requestPromoViewPushToDataLayer();}},{key:'pushPromoViewsToDataLayer',value:function pushPromoViewsToDataLayer(){var _this12=this;// GA has a maximum payload size of 8KB. If we have too many impressions we need to split them into chunks.
var chunks=__WEBPACK_IMPORTED_MODULE_0_lodash_chunk___default()(this.promoViewDataQueue,IMPRESSION_MAX_BATCH_SIZE);chunks.forEach(function(chunk){return _this12.pushEventToDataLayer({ecommerce:{promoView:{promotions:chunk}}},__WEBPACK_IMPORTED_MODULE_4__AnalyticsEventNames__["a" /* default */].promoView);});this.impressionDataQueue=[];}},{key:'updateDimension',value:function updateDimension(_ref13){var dimensionKey=_ref13.dimensionKey,dimensionValue=_ref13.dimensionValue;window.dataLayer[0][dimensionKey]=dimensionValue;}},{key:'pushEventToDataLayer',value:function pushEventToDataLayer(data,action){window.dataLayer.push(Object.assign({// Send all data under a generic "ecommerce" -event. -- But why?
// Event name here should be what we use in the eventAction, https://developers.google.com/tag-manager/enhanced-ecommerce
// Potentially disrupts the analytics of many clients, if name/structure is changed without proper planning.
// It seems to work but creates confusion why it's different of the documentation.
event:'ecommerce',eventAction:action},data));// Reset the ecommerce data after pushes. -- But why?
window.dataLayer.push({eventAction:undefined,ecommerce:undefined});}}]);return GoogleAnalyticsGTM;}();

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(233),
    isIterateeCall = __webpack_require__(150),
    toInteger = __webpack_require__(241);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CriteoEventHandler__ = __webpack_require__(1346);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CriteoAnalytics=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CriteoAnalytics,_Component);function CriteoAnalytics(){_classCallCheck(this,CriteoAnalytics);return _possibleConstructorReturn(this,(CriteoAnalytics.__proto__||Object.getPrototypeOf(CriteoAnalytics)).apply(this,arguments));}_createClass(CriteoAnalytics,[{key:'componentDidMount',value:function componentDidMount(){var configStore=this.props.configStore;if(configStore.criteo.enabled){new __WEBPACK_IMPORTED_MODULE_6__CriteoEventHandler__["a" /* default */](configStore.criteo.containerId,this.props.accountStore);}}},{key:'render',value:function render(){var configStore=this.props.configStore;if(!configStore.criteo.enabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',{type:'text/javascript',src:'//static.criteo.net/js/ld/ld.js',async:'true'}));}}]);return CriteoAnalytics;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CriteoAnalytics.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__["a" /* default */]),accountStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_AccountStore__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','accountStore')(CriteoAnalytics));

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteoEventHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnalyticsEventNames__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_ProductClass__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var VIEWLIST_IGNORED_PAGES=['HomePage','ProductPage'];var CriteoEventHandler=function(){function CriteoEventHandler(merchantId,accountStore){var _this=this;_classCallCheck(this,CriteoEventHandler);this.handleEvents=function(event){switch(event.detail.name){case __WEBPACK_IMPORTED_MODULE_2__AnalyticsEventNames__["a" /* default */].setPage:_this.setPage(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_2__AnalyticsEventNames__["a" /* default */].productImpressions:_this.productImpressions(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_2__AnalyticsEventNames__["a" /* default */].productDetail:_this.productDetail(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_2__AnalyticsEventNames__["a" /* default */].purchase:_this.purchase(event.detail.payload);break;default:}};if(!window.criteo_q){window.criteo_q=[];}var deviceType=/iPad/.test(navigator.userAgent)?'t':/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)?'m':'d';this.pushEvent('setAccount',{account:merchantId});this.pushEvent('setSiteType',{type:deviceType});// Push new setEmail event whenever customer email changes.
Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["autorun"])(function(){var customerEmail=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(accountStore,'account.personal_info.email','');_this.pushEvent('setEmail',{email:customerEmail});});document.addEventListener('analytics',this.handleEvents,true);}_createClass(CriteoEventHandler,[{key:'setPage',value:function setPage(_ref){var pageName=_ref.pageName;if(pageName==='HomePage'){this.pushEvent('viewHome');}}/**
   * @param {Array} productList An array with objects in the format { position, product }.
   * @param {string} listName
   */},{key:'productImpressions',value:function productImpressions(_ref2){var productList=_ref2.productList,pageName=_ref2.pageName;if(VIEWLIST_IGNORED_PAGES.includes(pageName)){return;}if(productList.length>0){// Criteo is only interested in first three products.
var productsIds=productList.slice(0,3).map(function(_ref3){var product=_ref3.product;return product.id;});this.pushEvent('viewList',{item:productsIds});}}/**
   * @param {Array} productList An array with objects in the format { product, activeProductId }.
   */},{key:'productDetail',value:function productDetail(_ref4){var productList=_ref4.productList;var _productList$=productList[0],product=_productList$.product,activeProductId=_productList$.activeProductId;var data={item:product.id};if(product.class===__WEBPACK_IMPORTED_MODULE_3__types_ProductClass__["b" /* default */].MULTI){data.item=activeProductId||product.id;data.item_group_id=product.id;}this.pushEvent('viewItem',data);}/**
   * @param {Order} order An order.
   */},{key:'purchase',value:function purchase(_ref5){var order=_ref5.order;var orderId=order.id;var orderProducts=order.products.filter(function(product){return product.isPhysicalProduct;}).map(function(product){return{id:product.product_id,price:product.final_unit_price,quantity:product.quantity};});this.pushEvent('trackTransaction',{id:orderId,item:orderProducts});}/**
   * @param {string} event Event name.
   * @param {object} data Object containing data for the event.
   */},{key:'pushEvent',value:function pushEvent(event){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};window.criteo_q.push(Object.assign({event:event},data));}}]);return CriteoEventHandler;}();

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_head_SEODescription__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__store_ManufacturerStore__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManufacturerPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ManufacturerPage,_Component);function ManufacturerPage(props){_classCallCheck(this,ManufacturerPage);var _this=_possibleConstructorReturn(this,(ManufacturerPage.__proto__||Object.getPrototypeOf(ManufacturerPage)).call(this,props));_this.maybeLoadManufacturer=function(id){var manufacturerStore=_this.props.manufacturerStore;var manufacturer=manufacturerStore.manufacturers.get(id);if(!manufacturerStore.manufacturerContentStates.get(id)||manufacturer&&manufacturer.description_html===null){manufacturerStore.loadManufacturer(id).catch(function(e){console.error(e);});}};_this.getActiveManufacturer=function(){var _this$props=_this.props,match=_this$props.match,manufacturerStore=_this$props.manufacturerStore;return manufacturerStore.manufacturers.get(match.params.id);};_this.getBreadcrumbsPath=function(){var routeService=_this.props.routeService;var manufacturer=_this.getActiveManufacturer();return routeService.transformBreadCrumbs(manufacturer.breadcrumbs);};_this.yotpoTimeout=null;_this.maybeLoadManufacturer(_this.props.match.params.id);return _this;}_createClass(ManufacturerPage,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var configStore=this.props.configStore;if(prevProps.match.params.id!==this.props.match.params.id){this.maybeLoadManufacturer(this.props.match.params.id);}if(prevProps.match.path!==this.props.match.path){if(configStore.yotpo.enabled&&window&&window.yotpo){this.yotpoTimeout=setTimeout(function(){return window.yotpo.refreshWidgets();},800);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.yotpoTimeout&&clearTimeout(this.yotpoTimeout);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,manufacturerStore=_props.manufacturerStore,routeService=_props.routeService,match=_props.match,location=_props.location;var manufacturer=this.getActiveManufacturer();if(manufacturer){if(!Object(__WEBPACK_IMPORTED_MODULE_19__util_url__["h" /* pathFragmentMatchesLocation */])(manufacturer.path,location.pathname)){var url=''+routeService.getPath(manufacturer.path)+location.search+location.hash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Redirect */],{to:url});}}var adSearchParams={manufacturer:manufacturer&&manufacturer.id};var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_ad_MainBanner__["a" /* default */],{searchParams:adSearchParams});var mainBannerWithinContent=configStore.mainBanner.withinContent&&!configStore.mainBanner.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_25__types_CommonPage__["b" /* default */].MANUFACTURER,className:'ManufacturerPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_ScrollReset__["a" /* default */],{key:match.params.id}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'ManufacturerPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_loader_ContentForState__["a" /* default */],{state:manufacturerStore.manufacturerContentStates.get(match.params.id),error:manufacturerStore.lastError,forLoaded:function forLoaded(){if(!manufacturer){return null;}var listName='Manufacturer List';var fixedParams={manufacturers:[manufacturer.id]};if(sectionStore.activeSection){fixedParams.sections=[sectionStore.activeSection.id];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_head_SEOTitle__["a" /* default */],{title:manufacturer.SEO_title||manufacturer.name,noSuffix:!!manufacturer.SEO_title}),manufacturer.SEO_description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_head_SEODescription__["a" /* default */],{content:manufacturer.SEO_description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(manufacturer.path)}),mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:_this2.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_PageTitle__["a" /* default */],null,manufacturer.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerPage__description'},manufacturer.description_html&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_WysiwygContent__["a" /* default */],{html:manufacturer.description_html})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,allSections:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__["a" /* default */],{searchParams:adSearchParams}));}})})));}}]);return ManufacturerPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ManufacturerPage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_23__store_ConfigStore__["a" /* default */]).isRequired,manufacturerStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_22__store_ManufacturerStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_20__services_RouteService__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__store_SectionStore__["a" /* default */]).isRequired,match:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.match.isRequired,location:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','manufacturerStore','routeService','sectionStore')(ManufacturerPage));

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_product_ProductTabs__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_layout_SidebarLayout__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_head_SEODescription__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_sidebar_DefaultSidebar__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__integrations_loadBee_LoadBeeSectionContentWidget__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__integrations_arinet_ArinetWidget__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_product_list_SingleRowProductTabs__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__types_SectionIntegrationType__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SectionPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SectionPage,_Component);function SectionPage(props){_classCallCheck(this,SectionPage);var _this=_possibleConstructorReturn(this,(SectionPage.__proto__||Object.getPrototypeOf(SectionPage)).call(this,props));_this.maybeLoadSection=function(){var sectionStore=_this.props.sectionStore;if(sectionStore.activeSection.content_html===null){sectionStore.loadSection(sectionStore.activeSection.id).catch(function(e){console.error(e);});}};_this.getSingleRowTabs=function(){var _this$props=_this.props,configStore=_this$props.configStore,sectionStore=_this$props.sectionStore;if(!configStore.sectionPage.singleRowTabs||!configStore.sectionPage.useProductList||configStore.integrations.arinet.isEnabled&&configStore.integrations.arinet.appKey){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_product_list_SingleRowProductTabs__["a" /* default */],{searchParams:{sections:[sectionStore.activeSection.id]}});};_this.getProductListing=function(){var _this$props2=_this.props,configStore=_this$props2.configStore,sectionStore=_this$props2.sectionStore;var useMainProductList=configStore.sectionPage.useProductList;if(configStore.integrations.arinet.isEnabled&&sectionStore.activeSection.integration_type===__WEBPACK_IMPORTED_MODULE_28__types_SectionIntegrationType__["b" /* default */].ARINET&&sectionStore.activeSection.integration_api_key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__integrations_arinet_ArinetWidget__["a" /* default */],null);}if(useMainProductList){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_product_list_MainProductList__["b" /* default */],{fixedParams:{excludeContent:1,cross_categories:[],sections:[sectionStore.activeSection.id]},name:'Section List'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_product_ProductTabs__["a" /* default */],{searchParams:{sections:[sectionStore.activeSection.id]}});}};_this.maybeLoadSection();_this.yotpoTimeout=null;return _this;}_createClass(SectionPage,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var configStore=this.props.configStore;if(prevProps.match.params.id!==this.props.match.params.id){this.maybeLoadSection();}if(prevProps.match.path!==this.props.match.path){if(configStore.yotpo.enabled&&window&&window.yotpo){this.yotpoTimeout=setTimeout(function(){window.yotpo.refreshWidgets();},800);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.yotpoTimeout&&clearTimeout(this.yotpoTimeout);}/**
   * Renders MainProductList or ProducTabs depending of section's configuration
   */},{key:'render',value:function render(){var _this2=this;var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,routeService=_props.routeService,match=_props.match;var useIntegrationContent=configStore.zoovu.enabled&&!!sectionStore.activeSection.integration_type&&!!sectionStore.activeSection.integration_feed_url&&!!sectionStore.activeSection.integration_api_key;if(useIntegrationContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__integrations_loadBee_LoadBeeSectionContentWidget__["a" /* default */],null);}var adSearchParams={section:sectionStore.activeSection&&sectionStore.activeSection.id};var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_ad_MainBanner__["a" /* default */],{searchParams:adSearchParams});var mainBannerWithinContent=configStore.mainBanner.withinContent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_29__types_CommonPage__["b" /* default */].SECTION,className:'SectionPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_common_ScrollReset__["a" /* default */],{key:match.params.id}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["n" /* Container */],{className:'SectionPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_layout_SidebarLayout__["a" /* default */],{sidebar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_sidebar_DefaultSidebar__["a" /* default */],{bannerSearchParams:sectionStore.activeSection?{section:sectionStore.activeSection.id}:null}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_loader_ContentForState__["a" /* default */],{state:sectionStore.singleState,error:sectionStore.lastError,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_SEOTitle__["a" /* default */],{title:sectionStore.activeSection.SEO_title||sectionStore.activeSection.display_name,noSuffix:!!sectionStore.activeSection.SEO_title}),sectionStore.activeSection.SEO_description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_head_SEODescription__["a" /* default */],{content:sectionStore.activeSection.SEO_description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(sectionStore.activeSection.path)}),mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:sectionStore.activeSection.breadcrumbs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_PageTitle__["a" /* default */],null,sectionStore.activeSection.display_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SectionPage__section-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_WysiwygContent__["a" /* default */],{html:sectionStore.activeSection.content_html})),_this2.getSingleRowTabs(),!configStore.siteConfig.isHomePage&&_this2.getProductListing(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SectionPage__section-footer-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_WysiwygContent__["a" /* default */],{html:sectionStore.activeSection.footer_description_html})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_ad_ContentPopup__["a" /* default */],{searchParams:adSearchParams}));}})})));}}]);return SectionPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SectionPage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_23__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_SectionStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_18__services_RouteService__["a" /* default */]).isRequired,match:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.match.isRequired,history:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.history.isRequired,location:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','sectionStore','routeService')(Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* withRouter */])(SectionPage)));

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoadBeeSectionContentWidget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_SectionStore__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LOADBEE_TEMPLATE='_catalogue';var LOADBEE_DEBUG='false';var LoadBeeSectionContentWidget=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(LoadBeeSectionContentWidget,_Component);function LoadBeeSectionContentWidget(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LoadBeeSectionContentWidget);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LoadBeeSectionContentWidget.__proto__||Object.getPrototypeOf(LoadBeeSectionContentWidget)).call.apply(_ref,[this].concat(args))),_this),_this.getLocale=function(){var _this$props=_this.props,countryStore=_this$props.countryStore,languageStore=_this$props.languageStore;return languageStore.activeLocale.toLowerCase()+'_'+countryStore.activeCountry.iso_code_2.toUpperCase();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoadBeeSectionContentWidget,[{key:'render',value:function render(){var section=this.props.sectionStore.activeSection;var catalogue=section.slug;if(!section.integration_api_key||!section.integration_feed_url){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('script',{'data-id':__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('LoadBeeSectionContentWidget-'),async:true,src:'https://cdn.loadbee.com/js/loadbee_integration.js'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'LoadBeeSectionContentWidget loadbeeTabContent',id:'loadbeeTabContentId','data-loadbee-apikey':section.integration_api_key,'data-loadbee-catalogue':catalogue,'data-loadbee-template':''+catalogue+LOADBEE_TEMPLATE,'data-loadbee-locale':this.getLocale(),'data-loadbee-cat-products':section.integration_feed_url,'data-loadbee-debug':LOADBEE_DEBUG}));}}]);return LoadBeeSectionContentWidget;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;LoadBeeSectionContentWidget.propTypes={sectionStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_SectionStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_CountryStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_LanguageStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('sectionStore','countryStore','languageStore')(LoadBeeSectionContentWidget));

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ArinetWidget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_SectionStore__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArinetWidget=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ArinetWidget,_Component);function ArinetWidget(props){_classCallCheck(this,ArinetWidget);var _this=_possibleConstructorReturn(this,(ArinetWidget.__proto__||Object.getPrototypeOf(ArinetWidget)).call(this,props));_this.arinetRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();return _this;}_createClass(ArinetWidget,[{key:'componentDidMount',value:function componentDidMount(){!window.isSSR&&this.loadScript();}},{key:'loadScript',value:function loadScript(){var sectionStore=this.props.sectionStore;var script='<script type="text/javascript" async id="aripartstream" src="//servicesstg.arinet.com/PartStream/?appKey='+sectionStore.activeSection.integration_api_key+'"></script>';window.postscribe(this.arinetRef.current,script);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.arinetRef=null;}},{key:'render',value:function render(){if(window.isSSR){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'arinetWidget',className:'ArinetWidget',ref:this.arinetRef}));}}]);return ArinetWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ArinetWidget.propTypes={sectionStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_SectionStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('sectionStore')(ArinetWidget));

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__product_ProductTabs__ = __webpack_require__(266);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SingleRowProductTabs=function(_Component){_inherits(SingleRowProductTabs,_Component);function SingleRowProductTabs(){_classCallCheck(this,SingleRowProductTabs);return _possibleConstructorReturn(this,(SingleRowProductTabs.__proto__||Object.getPrototypeOf(SingleRowProductTabs)).apply(this,arguments));}_createClass(SingleRowProductTabs,[{key:'render',value:function render(){var _props=this.props,children=_props.children,props=_objectWithoutProperties(_props,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__product_ProductTabs__["a" /* default */],Object.assign({singleRowMode:true},props),children);}}]);return SingleRowProductTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SingleRowProductTabs);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_SortOrder__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_AdPages__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnSalePage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(OnSalePage,_Component);function OnSalePage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OnSalePage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OnSalePage.__proto__||Object.getPrototypeOf(OnSalePage)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].onSaleTitle),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].OnSale}]);},_this.getSearchParams=function(){return{bannerPage:__WEBPACK_IMPORTED_MODULE_23__types_AdPages__["a" /* default */].CAMPAIGN_PRODUCTS};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OnSalePage,[{key:'render',value:function render(){var listName='New Products List';var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,routeService=_props.routeService;var fixedParams={orderBy:configStore.siteConfig.isShoppingCenter?__WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__["a" /* default */].DISCOUNT:__WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__["a" /* default */].CAMPAIGN_DATE_ADDED,order:__WEBPACK_IMPORTED_MODULE_10__types_SortOrder__["a" /* default */].DESC,hasCampaign:1,excludeContent:1};if(sectionStore.activeSection){fixedParams.sections=[sectionStore.activeSection.id];}var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ad_MainBanner__["a" /* default */],{searchParams:this.getSearchParams()});var mainBannerWithinContent=configStore.mainBanner.withinContent&&!configStore.mainBanner.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_24__types_CommonPage__["b" /* default */].ON_SALE,className:'OnSalePage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_head_SEOTitle__["a" /* default */],{title:Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].onSaleTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].OnSale)}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'OnSalePage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].onSaleTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showSort:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__["a" /* default */],{searchParams:this.getSearchParams()}))})));}}]);return OnSalePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;OnSalePage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_SectionStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_20__services_RouteService__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','sectionStore','routeService')(OnSalePage)));

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewProductsPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_SortOrder__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__types_AdPages__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__types_CommonPage__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewProductsPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NewProductsPage,_Component);function NewProductsPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewProductsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewProductsPage.__proto__||Object.getPrototypeOf(NewProductsPage)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].newProductsTitle),url:__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].NewProducts}]);},_this.getSearchParams=function(){return{bannerPage:__WEBPACK_IMPORTED_MODULE_20__types_AdPages__["a" /* default */].NEW_PRODUCTS};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewProductsPage,[{key:'render',value:function render(){var listName='New Products List';var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,routeService=_props.routeService;var fixedParams={orderBy:__WEBPACK_IMPORTED_MODULE_10__types_ProductSortOrderBy__["a" /* default */].DATE_ADDED,order:__WEBPACK_IMPORTED_MODULE_11__types_SortOrder__["a" /* default */].DESC,dateAdded:{// We set second and millisecond to 0 in order for the query key not to
// change every (milli)second
min:__WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromObject({second:0,millisecond:0}).minus({seconds:configStore.product.isNewForSeconds}).toISO()}};if(sectionStore.activeSection){fixedParams.sections=[sectionStore.activeSection.id];}var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_ad_MainBanner__["a" /* default */],{searchParams:this.getSearchParams()});var mainBannerWithinContent=configStore.mainBanner.withinContent&&!configStore.mainBanner.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_21__types_CommonPage__["b" /* default */].NEW_PRODUCTS,className:'NewProductsPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_SEOTitle__["a" /* default */],{title:Object.assign({},__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].newProductsTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_14__types_Paths__["a" /* default */].NewProducts)}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'NewProductsPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].newProductsTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showSort:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ad_ContentPopup__["a" /* default */],{searchParams:this.getSearchParams()}))})));}}]);return NewProductsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NewProductsPage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_22__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_23__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_22__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__store_SectionStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_25__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','sectionStore','routeService')(NewProductsPage)));

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_SortOrder__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_AdPages__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PopularProductsPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PopularProductsPage,_Component);function PopularProductsPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PopularProductsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PopularProductsPage.__proto__||Object.getPrototypeOf(PopularProductsPage)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].mostPopularTitle),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].PopularProducts}]);},_this.getSearchParams=function(){return{bannerPage:__WEBPACK_IMPORTED_MODULE_23__types_AdPages__["a" /* default */].POPULAR_PRODUCTS};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PopularProductsPage,[{key:'render',value:function render(){var listName='Popular Products List';var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,routeService=_props.routeService;var fixedParams={orderBy:__WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__["a" /* default */].SALES,order:__WEBPACK_IMPORTED_MODULE_10__types_SortOrder__["a" /* default */].DESC,excludeContent:1};if(sectionStore.activeSection){fixedParams.sections=[sectionStore.activeSection.id];}var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ad_MainBanner__["a" /* default */],{searchParams:this.getSearchParams()});var mainBannerWithinContent=configStore.mainBanner.withinContent&&!configStore.mainBanner.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_24__types_CommonPage__["b" /* default */].POPULAR_PRODUCTS,className:'PopularProductsPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_head_SEOTitle__["a" /* default */],{title:Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].mostPopularTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].PopularProducts)}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'PopularProductsPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].mostPopularTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showSort:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__["a" /* default */],null))})));}}]);return PopularProductsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PopularProductsPage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_SectionStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_20__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','sectionStore','routeService')(PopularProductsPage)));

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_SortOrder__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_ProductRecommendedPosition__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_CategoryStore__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__types_AdPages__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecommendedProductsPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RecommendedProductsPage,_Component);function RecommendedProductsPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecommendedProductsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecommendedProductsPage.__proto__||Object.getPrototypeOf(RecommendedProductsPage)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].weRecommendTitle),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].RecommendedProducts}]);},_this.getSearchParams=function(){return{bannerPage:__WEBPACK_IMPORTED_MODULE_25__types_AdPages__["a" /* default */].RECOMMENDED_PRODUCTS};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecommendedProductsPage,[{key:'render',value:function render(){var listName='Recommended Products List';var _props=this.props,categoryStore=_props.categoryStore,configStore=_props.configStore,sectionStore=_props.sectionStore,routeService=_props.routeService;var fixedParams={orderBy:__WEBPACK_IMPORTED_MODULE_9__types_ProductSortOrderBy__["a" /* default */].RECOMMENDED_SORT_ORDER,order:__WEBPACK_IMPORTED_MODULE_10__types_SortOrder__["a" /* default */].ASC,recommendedPositions:[__WEBPACK_IMPORTED_MODULE_17__types_ProductRecommendedPosition__["a" /* default */].EVERYWHERE],excludeContent:1,includeChildProducts:1,includeFilters:0};if(categoryStore.activeCategory){fixedParams.categories=[categoryStore.activeCategory.id];fixedParams.recommendedPositions.push(__WEBPACK_IMPORTED_MODULE_17__types_ProductRecommendedPosition__["a" /* default */].CATEGORY);}else{fixedParams.recommendedPositions.push(__WEBPACK_IMPORTED_MODULE_17__types_ProductRecommendedPosition__["a" /* default */].FRONTPAGE);if(sectionStore.activeSection){fixedParams.sections=[sectionStore.activeSection.id];}}var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_ad_MainBanner__["a" /* default */],{searchParams:this.getSearchParams()});var mainBannerWithinContent=configStore.mainBanner.withinContent&&!configStore.mainBanner.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_26__types_CommonPage__["b" /* default */].RECOMMENDED_PRODUCTS,className:'RecommendedProductsPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_head_SEOTitle__["a" /* default */],{title:Object.assign({},__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].weRecommendTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].RecommendedProducts)}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'RecommendedProductsPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].weRecommendTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showSort:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ad_ContentPopup__["a" /* default */],null))})));}}]);return RecommendedProductsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RecommendedProductsPage.propTypes={categoryStore:Object(__WEBPACK_IMPORTED_MODULE_23__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_CategoryStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_23__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_23__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_SectionStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_22__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('categoryStore','configStore','sectionStore','routeService')(RecommendedProductsPage)));

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sticky_el__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sticky_el___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_sticky_el__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_manufacturer_ManufacturerLink__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_ManufacturerStore__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_anchor_ScrollableAnchor__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__types_CommonPage__ = __webpack_require__(40);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var STYLES={DETAILED:'0',ONLY_NAME:'1',ONLY_LOGO:'2'};var ManufacturerListPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(ManufacturerListPage,_Component);function ManufacturerListPage(props){_classCallCheck(this,ManufacturerListPage);var _this=_possibleConstructorReturn(this,(ManufacturerListPage.__proto__||Object.getPrototypeOf(ManufacturerListPage)).call(this,props));_initialiseProps.call(_this);var manufacturerStore=_this.props.manufacturerStore;if(!manufacturerStore.loadedWithContent&&manufacturerStore.state===__WEBPACK_IMPORTED_MODULE_26__types_RequestState__["b" /* default */].NONE){manufacturerStore.loadManufacturers(false);}return _this;}_createClass(ManufacturerListPage,[{key:'render',value:function render(){var _this2=this;var _props=this.props,manufacturerStore=_props.manufacturerStore,uiStore=_props.uiStore,routeService=_props.routeService,intl=_props.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_28__types_CommonPage__["b" /* default */].MANUFACTURER_LIST,className:'ManufacturerListPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'ManufacturerListPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_loader_ContentForState__["a" /* default */],{state:manufacturerStore.state,error:manufacturerStore.lastError,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_head_SEOTitle__["a" /* default */],{title:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].ourBrandsTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].ManufacturerList)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:_this2.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].ourBrandsTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'10',md:'11'},_this2.getManufacturerListing()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'2',md:'1',className:'ManufacturerListPage__sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_sticky_el___default.a,{boundaryElement:'.ManufacturerListPage__sidebar',topOffset:-uiStore.headerHeight,bottomOffset:uiStore.headerHeight,stickyStyle:{transform:'translateZ(0px) translateY('+uiStore.headerHeight+'px)'},hideOnBoundaryHit:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerListPage__alphabetical-index'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerListPage__alphabetical-index-scroller'},_this2.getAlphabeticalIndex()))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_ad_ContentPopup__["a" /* default */],null));}})})));}}]);return ManufacturerListPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this3=this;this.getBreadcrumbsPath=function(){var _props2=_this3.props,intl=_props2.intl,routeService=_props2.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].ourBrandsTitle),url:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].ManufacturerList}]);};this.getAlphabeticalLinkForManufacturer=function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:manufacturer.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_common_ButtonLink__["a" /* default */],{onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_22__util_dom__["i" /* scrollToElementById */])(manufacturer.id);}},manufacturer.name.charAt(0).toUpperCase()));};this.getAlphabeticalIndex=function(){var manufacturerStore=_this3.props.manufacturerStore;return manufacturerStore.manufacturersWithProducts.reduce(function(letters,manufacturer,index,manufacturers){if(index===0){letters.push(_this3.getAlphabeticalLinkForManufacturer(manufacturer));return letters;}var previousManufacturer=manufacturers[index-1];if(manufacturer.name.charAt(0).toUpperCase()!==previousManufacturer.name.charAt(0).toUpperCase()){letters.push(_this3.getAlphabeticalLinkForManufacturer(manufacturer));}return letters;},[]);};this.getImage=function(manufacturer){return manufacturer.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{key:manufacturer.id,sm:'6',md:'4',lg:'3',className:'ManufacturerListPage__listing-image-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerListPage__listing-image-column-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:manufacturer.image,alt:manufacturer.name,loading:'lazy'}))));};this.getName=function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{key:manufacturer.id,md:'6',lg:'4',className:'ManufacturerListPage__listing-header-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_anchor_ScrollableAnchor__["a" /* default */],{id:manufacturer.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer}));};this.getDetailedManufacturer=function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'ManufacturerListPage__listing',key:manufacturer.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{key:manufacturer.id,md:'2',className:'ManufacturerListPage__listing-image-column'},manufacturer.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerListPage__listing-image-column-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:manufacturer.image,alt:manufacturer.name,loading:'lazy'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'10',className:'ManufacturerListPage__listing-info-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_anchor_ScrollableAnchor__["a" /* default */],{id:manufacturer.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerListPage__listing-info-column-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerListPage__listing-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,manufacturer.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerListPage__listing-description'},manufacturer.description_html&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_WysiwygContent__["a" /* default */],{html:manufacturer.description_html})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ManufacturerListPage__listing-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_manufacturer_ManufacturerLink__["a" /* default */],{manufacturer:manufacturer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'manufacturer.browserManufacturerProducts',defaultMessage:'Browse brands\' products'}),' ','\xBB')))));};this.getManufacturersAlphabetically=function(){var manufacturerStore=_this3.props.manufacturerStore;return manufacturerStore.manufacturersWithProducts.reduce(function(group,manufacturer){var title=manufacturer.name.charAt(0).toLowerCase();if(!group[title]){group[title]=[];}group[title].push(manufacturer);return group;},{});};this.getManufacturerListing=function(){var _props3=_this3.props,configStore=_props3.configStore,manufacturerStore=_props3.manufacturerStore;var manufacturerCols=void 0;switch(configStore.manufacturerListPage.style){case STYLES.ONLY_NAME:manufacturerCols=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'ManufacturerListPage__listing'},Object.entries(_this3.getManufacturersAlphabetically()).map(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{key:key,xs:'12',className:'ManufacturerListPage__listing-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'ManufacturerListPage__listing-group-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'12'},key.toUpperCase())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'ManufacturerListPage__listing-group-data'},value.map(function(manufacturer,j){if(!manufacturer||!manufacturer.name){return null;}return _this3.getName(manufacturer);})));}));break;case STYLES.ONLY_LOGO:manufacturerCols=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'ManufacturerListPage__listing'},manufacturerStore.manufacturersWithProducts.map(function(manufacturer){if(!manufacturer||!manufacturer.image){return null;}return _this3.getImage(manufacturer);}));break;case STYLES.DETAILED:default:manufacturerCols=manufacturerStore.manufacturersWithProducts.map(function(manufacturer){return _this3.getDetailedManufacturer(manufacturer);});break;}return manufacturerCols;};},_temp))||_class;ManufacturerListPage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_17__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_27__store_ConfigStore__["a" /* default */]).isRequired,manufacturerStore:Object(__WEBPACK_IMPORTED_MODULE_17__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_ManufacturerStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_18__services_RouteService__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_17__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_23__store_UIStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','manufacturerStore','uiStore','routeService')(ManufacturerListPage)));

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t.ReactIntlLocaleData=t.ReactIntlLocaleData||{},t.ReactIntlLocaleData.fi=e())}(this,function(){"use strict";return[{locale:"fi",pluralRuleFunction:function(t,e){var n=!String(t).split(".")[1];return e?"other":1==t&&n?"one":"other"},fields:{year:{displayName:"vuosi",relative:{0:"tänä vuonna",1:"ensi vuonna","-1":"viime vuonna"},relativeTime:{future:{one:"{0} vuoden päästä",other:"{0} vuoden päästä"},past:{one:"{0} vuosi sitten",other:"{0} vuotta sitten"}}},month:{displayName:"kuukausi",relative:{0:"tässä kuussa",1:"ensi kuussa","-1":"viime kuussa"},relativeTime:{future:{one:"{0} kuukauden päästä",other:"{0} kuukauden päästä"},past:{one:"{0} kuukausi sitten",other:"{0} kuukautta sitten"}}},day:{displayName:"päivä",relative:{0:"tänään",1:"huomenna",2:"ylihuomenna","-2":"toissa päivänä","-1":"eilen"},relativeTime:{future:{one:"{0} päivän päästä",other:"{0} päivän päästä"},past:{one:"{0} päivä sitten",other:"{0} päivää sitten"}}},hour:{displayName:"tunti",relative:{0:"tämän tunnin aikana"},relativeTime:{future:{one:"{0} tunnin päästä",other:"{0} tunnin päästä"},past:{one:"{0} tunti sitten",other:"{0} tuntia sitten"}}},minute:{displayName:"minuutti",relative:{0:"tämän minuutin aikana"},relativeTime:{future:{one:"{0} minuutin päästä",other:"{0} minuutin päästä"},past:{one:"{0} minuutti sitten",other:"{0} minuuttia sitten"}}},second:{displayName:"sekunti",relative:{0:"nyt"},relativeTime:{future:{one:"{0} sekunnin päästä",other:"{0} sekunnin päästä"},past:{one:"{0} sekunti sitten",other:"{0} sekuntia sitten"}}}}}]});


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.sv=a())}(this,function(){"use strict";return[{locale:"sv",pluralRuleFunction:function(e,a){var r=String(e).split("."),n=!r[1],t=Number(r[0])==e,o=t&&r[0].slice(-1),i=t&&r[0].slice(-2);return a?1!=o&&2!=o||11==i||12==i?"other":"one":1==e&&n?"one":"other"},fields:{year:{displayName:"år",relative:{0:"i år",1:"nästa år","-1":"i fjol"},relativeTime:{future:{one:"om {0} år",other:"om {0} år"},past:{one:"för {0} år sedan",other:"för {0} år sedan"}}},month:{displayName:"månad",relative:{0:"denna månad",1:"nästa månad","-1":"förra månaden"},relativeTime:{future:{one:"om {0} månad",other:"om {0} månader"},past:{one:"för {0} månad sedan",other:"för {0} månader sedan"}}},day:{displayName:"dag",relative:{0:"i dag",1:"i morgon",2:"i övermorgon","-2":"i förrgår","-1":"i går"},relativeTime:{future:{one:"om {0} dag",other:"om {0} dagar"},past:{one:"för {0} dag sedan",other:"för {0} dagar sedan"}}},hour:{displayName:"timme",relative:{0:"denna timme"},relativeTime:{future:{one:"om {0} timme",other:"om {0} timmar"},past:{one:"för {0} timme sedan",other:"för {0} timmar sedan"}}},minute:{displayName:"minut",relative:{0:"denna minut"},relativeTime:{future:{one:"om {0} minut",other:"om {0} minuter"},past:{one:"för {0} minut sedan",other:"för {0} minuter sedan"}}},second:{displayName:"sekund",relative:{0:"nu"},relativeTime:{future:{one:"om {0} sekund",other:"om {0} sekunder"},past:{one:"för {0} sekund sedan",other:"för {0} sekunder sedan"}}}}},{locale:"sv-AX",parentLocale:"sv"},{locale:"sv-FI",parentLocale:"sv"}]});


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ru=a())}(this,function(){"use strict";return[{locale:"ru",pluralRuleFunction:function(e,a){var t=String(e).split("."),r=t[0],o=!t[1],n=r.slice(-1),l=r.slice(-2);return a?"other":o&&1==n&&11!=l?"one":o&&n>=2&&n<=4&&(l<12||l>14)?"few":o&&0==n||o&&n>=5&&n<=9||o&&l>=11&&l<=14?"many":"other"},fields:{year:{displayName:"год",relative:{0:"в этом году",1:"в следующем году","-1":"в прошлом году"},relativeTime:{future:{one:"через {0} год",few:"через {0} года",many:"через {0} лет",other:"через {0} года"},past:{one:"{0} год назад",few:"{0} года назад",many:"{0} лет назад",other:"{0} года назад"}}},month:{displayName:"месяц",relative:{0:"в этом месяце",1:"в следующем месяце","-1":"в прошлом месяце"},relativeTime:{future:{one:"через {0} месяц",few:"через {0} месяца",many:"через {0} месяцев",other:"через {0} месяца"},past:{one:"{0} месяц назад",few:"{0} месяца назад",many:"{0} месяцев назад",other:"{0} месяца назад"}}},day:{displayName:"день",relative:{0:"сегодня",1:"завтра",2:"послезавтра","-2":"позавчера","-1":"вчера"},relativeTime:{future:{one:"через {0} день",few:"через {0} дня",many:"через {0} дней",other:"через {0} дня"},past:{one:"{0} день назад",few:"{0} дня назад",many:"{0} дней назад",other:"{0} дня назад"}}},hour:{displayName:"час",relative:{0:"в этом часе"},relativeTime:{future:{one:"через {0} час",few:"через {0} часа",many:"через {0} часов",other:"через {0} часа"},past:{one:"{0} час назад",few:"{0} часа назад",many:"{0} часов назад",other:"{0} часа назад"}}},minute:{displayName:"минута",relative:{0:"в эту минуту"},relativeTime:{future:{one:"через {0} минуту",few:"через {0} минуты",many:"через {0} минут",other:"через {0} минуты"},past:{one:"{0} минуту назад",few:"{0} минуты назад",many:"{0} минут назад",other:"{0} минуты назад"}}},second:{displayName:"секунда",relative:{0:"сейчас"},relativeTime:{future:{one:"через {0} секунду",few:"через {0} секунды",many:"через {0} секунд",other:"через {0} секунды"},past:{one:"{0} секунду назад",few:"{0} секунды назад",many:"{0} секунд назад",other:"{0} секунды назад"}}}}},{locale:"ru-BY",parentLocale:"ru"},{locale:"ru-KG",parentLocale:"ru"},{locale:"ru-KZ",parentLocale:"ru"},{locale:"ru-MD",parentLocale:"ru"},{locale:"ru-UA",parentLocale:"ru"}]});


/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports = {"account.clientSearchButton":"Search for clients","account.clientSearchPlaceholder":"New search with Enter or search button","account.doYouWantToRegister":"Would you like to become a registered customer?","account.forgotPasswordInstructions":"If you have forgotten your password, please enter the email address of your customer account below in order to reset your password.","account.forgotPasswordLink":"Forgot your password? Click here.","account.forgotYourPassword":"Forgot your password?","account.loginInformationHint":"Create a username (you can use e.g. your e-mail address) and a password for your account.","account.loginStatus.ACCOUNT_DISABLED":"This user account has been disabled.","account.loginStatus.SHOP_LOGIN_DISABLED":"Logging in is not allowed at this time.","account.loginStatus.SUCCESS":"Logged in.","account.loginStatus.USERNAME_OR_PASSWORD_WRONG":"Invalid username or password!","account.loginStatus.USER_ALREADY_LOGGED_IN":"You are already logged in!","account.password.PASSWORDS_DO_NOT_MATCH":"The password confirmation text must match your chosen password.","account.password.PASSWORD_NOT_VALID":"Your password does not match the password in our database. Please try again.","account.password.SUCCESS":"Your password was updated successfully.","account.password.VALIDATION_ERROR":"Information you provided is not valid. Please recheck the form.","account.registrationBenefitsFasterCheckoutItem":"Easy and quick checkout - your personal details will be filled in automatically.","account.registrationBenefitsHeader":"Registration benefits","account.registrationBenefitsNewsletterItem":"Newsletter - you'll be informed of special offers and campaigns available through our store.","account.registrationBenefitsOrderHistoryItem":"Order history - you'll be able to see the orders you've previously done through our store.","account.registrationBenefitsPersistentCartItem":"Persistent cart - the items you add to your cart will stay there until you remove them or confirm the order.","account.registrationBenefitsWishlistItem":"You'll be able to create a wishlist you can then share with your friends.","account.resetPassword":"Reset password","account.resetPasswordSuccessful":"A password reset email has been sent to the provided address successfully. Remember to check your spam folder as well or make sure that the email address is correct if the message doesn't seem to have arrived.","account.setNewPassword":"Set new password","account.setNewPasswordSuccessful":"Your password was changed successfully. You may now log in.","account.setNewPasswordTitle":"Choose a new password","account.userInfo.EMAIL_NOT_VALID":"Your e-mail address seems to have an incorrect format.","account.userInfo.FIRSTNAME_NOT_VALID":"The first name must contain at least {characterCount} characters.","account.userInfo.LASTNAME_NOT_VALID":"The last name must contain at least {characterCount} characters.","account.userInfo.SUCCESS":"Your customer account information was updated successfully.","account.userInfo.TELEPHONE_NOT_VALID":"The phone number must contain at least {characterCount} characters.","account.userInfo.VALIDATION_ERROR":"The information you entered is not valid. Please check the form.","addToCart.selectProductVariant":"Please choose the product variant","addToCartPostalCodeValidation.checkPostalCodeInfo":"Search the availabilities of the services with your postal code","addToCartPostalCodeValidation.postalCodePlaceholder":"Enter your postal code","additionalService.availableServices":"Check available services here","additionalService.information":"You can select additional services, when the product is being added to the cart.","additionalService.optionPriceSentence":"The price for this option is {price}","additionalService.postalCodeIsInvalid":"Postal code is invalid for this service","additionalService.postalCodeRequired":"Eligible postal code is required for the service","additionalService.selectService":"Select service","additionalService.typeTextHereLengthSentence":"Type your text here. Maximum of {maxLength} characters.","additionalService.typeTextHereSentence":"Type your text here.","address.addressFilterPlaceholder":"Search for addresses","address.primaryNotice":"This address is used as your default delivery and billing address in your orders.","address.setAsPrimary":"Set as a primary address","address.showAllAddressesButton":"Show all addresses","balanceUser.pinCodeHeader":"PIN code","campaign.activateCode":"Activate","campaign.activationInProgress":"Activating code...","campaign.categoryLimitation":"Using this discount coupon, you will receive a discount for products belonging to the following product categories:","campaign.categoryNotFound":"Given category {category} not found","campaign.haveYouReceived":"Have you received a campaign or discount code?","campaign.isActivated":"The campaign code is activated!","campaign.manufacturerLimitation":"Using this discount coupon, you will receive a discount for products from the following brands:","campaign.manufacturerMultiLimitation":"Allowed for limited manufacturers","campaign.productLimitation":"Using this discount coupon, you will receive a discount for the following products:","campaign.removalInProgress":"Removing code...","campaign.removeCouponCode":"Remove code","campaign.setError":"The entered campaign code was not found.","campaign.setSuccess":"The campaign code was activated successfully!","cart.beingUpdated":"Cart is being updated","cart.cartContents":"Cart contents","cart.continueShopping":"Continue shopping","cart.couponInstructions":"Discount coupons may be provided on the checkout page.","cart.itemsInCart":"{itemCount} in cart.","cart.loadingCartContents":"Loading cart contents","cart.productsTotalLabel":"Products total:","cart.productsTotalWithExtraLabel":"Total amount","cart.selectShoppingCart":"Select shopping cart","checkout.backToStore":"Back to the store","checkout.buyBalanceSentence":"Buy balance","checkout.cancelPayment":"Cancel","checkout.orderCompleted":"Your order has been received.","checkout.orderConfirmationThankYou":"Thank you for your order!","checkout.orderInformationTitle":"Order information","checkout.paymentInformation":"Confirmation email has also been sent to the email address {email}. Make sure email address is correct.","checkout.paymentInformation2":"If you don't see the message, be sure to check your spam folder as well.","checkout.shoppingCenterMerchantInfo":"merchant's {merchant}","checkout.successfulPurchaseBreadcrumbName":"Thank You","checkout.successfulPurchaseLicensedProductsSentence":"Some products in your order require a license. You may pay your order now; after this, you are required to send the relevant licenses to us by email. Please refer to the shipping terms page for more details.","checkout.successfulPurchasePageHeading":"Order confirmation","checkout.successfulPurchasePageTitle":"Your order has been registered!","checkout.successfulPurchaseReceipt":"Receipt","checkout.successfulTransferPageHeading":"Money transfer confirmation","checkout.trackOrder":"You can track your order by clicking {link}, you can also get to the {merchantInfo} order tracking page from the confirmation email.","contactUs.success":"Your message was sent to our customer service successfully. We aim to handle the message as soon as possible.","cookieNotice.content":"In order to serve our customers as well as possible, we use cookies on our site. By continuing, you agree to use the cookies.","cookieNotice.readMore":"Read more about cookies","coupon.emailError":"The information could not be sent to your email. Please contact our customer service using the contact form.","coupon.emailSubscribeNotice":"By giving us your email address you subscribe to our newsletter.","coupon.emailSuccess":"The discount coupon information has been sent to your email.","coupon.fetchDiscountCode":"Fetch discount code","coupon.setError":"The campaign code could not be activated. Please contact our customer service using the contact form.","coupon.setSuccess":"The campaign code was activated successfully!","coupon.showInformation":"Show coupon information","coupon.useLater":"I want to use my code later","coupon.useNow":"I want to activate my code now","creditAccount.accountStatusTitle":"Credit account status","creditAccount.balanceTitle":"Balance","creditAccount.creditUsedTitle":"Credit used","creditAccount.limitTitle":"Credit limit","customerService.isOpen":"Customer service is open Mon - Fri {timespan}","customerUser.fetchPurchases":"Fetch purchases","discount.quantityDescription":"Order more and save money!","discount.sale":"Sale","discount.upTo":"Up to","error.notFoundBackToHome":"Return to the front page","error.notFoundGoToSearch":"or use the product search.","error.notFoundHeader":"Unfortunately the page you requested could not be found anymore.","error.notFoundHelpText":"If it still exists, its address might have changed. You can continue browsing the web store or attempt to find what you were looking by using the search function.","error.notFoundTitle":"Page not found","errorModal.content":"Something went wrong. Please check the provided information and try again.","errorModal.title":"Unexpected error has occurred","filter.removeAllFiltersButton":"Clear filters","filter.removeFilterButtonLabel":"Remove filter","filter.showMore":"Show more filters","footer.backToTop":"Back to top","footer.backToTopShort":"Top","footer.cartExpirationExpired":"Reservation for the items in your cart has expired.","footer.cartExpirationPending":"Reservation for the items in your cart expires in","form.noFileSelected":"No file selected","form.selectFileSentence":"Select file...","global.acceptTitle":"Accept","global.accountChangeClientSentence":"Log in as a client","global.accountCreateSentence":"Create an account","global.accountLogOutSentence":"Log out","global.active":"Active subscription","global.addNewAddressTitle":"Add New Address","global.addNewUserTitle":"Add New User","global.addToCartButton":"Add to Cart","global.additionalLinksTitle":"Quick links","global.additionalServicesTitle":"Additional Services","global.addressBookTitle":"Address Book","global.allowPartialDeliverySentence":"Allow delivery even though not every product is available","global.allowUserCreateAddressLabel":"Allow user to create addresses","global.balanceUser":"Client account","global.balanceUserAccountBalanceInfo":"Balance orders","global.balanceUserAccountInfo":"Client information","global.balanceUserAccountPaymentWidgetError":"Sorry, an error occurred with your payment.Try refreshing the page and try again.If the problem persists, please contact our customer service.","global.balanceUserAccountStatus":"Status","global.balanceUserBalanceValidationError":"Only even numbers are accepted.","global.balanceUserCurrentBalance":"Balance","global.balanceUserNameTitle":"User's Name","global.balanceUserNewBalance":"Add balance","global.balanceUserNoBalancePurchases":"No balance purchases","global.balanceUserPageTitle":"Balance","global.balanceUserPaymentHistoryOrderDate":"Date","global.balanceUserPaymentHistoryOrderNumber":"Order number","global.balanceUserPaymentTotal":"Total","global.brandsTitle":"Brands","global.businessIdHelp":"If you have forgotten your Business ID, you can find it by clicking {link}","global.businessIdTitle":"Business ID","global.buttonInfo":"You can also reserve and pick up the product from our store","global.campaignBoxTitle":"Enter the code here","global.cancelTitle":"Cancel","global.cartEmptySentence":"Your cart is empty","global.categoriesTitle":"Categories","global.checkTitle":"Search","global.checkedTitle":"Searched","global.checkout":"Checkout","global.chooseTitle":"Choose","global.cityTitle":"City","global.clearTitle":"Clear","global.cloneOrder":"Repeat order","global.closeTitle":"Close","global.companyTitle":"Company","global.confirmAddToCartTitle":"Do you want to add products to the cart?","global.confirmPasswordTitle":"Confirm Password","global.confirmRemoveTitle":"Are you sure?","global.contactPersonFirstNameTitle":"Contact Person First Name","global.contactPersonLastNameTitle":"Contact Person Last Name","global.continue":"Continue","global.continueShopping":"Continue Shopping","global.countryTitle":"Country / area","global.couponDiscountOfferSentence":"Receive a {offer} discount coupon!","global.couponFreeShippingSentence":"Receive free delivery!","global.couponLoginFreeDeliverySentence":"Join as a registered customer now or sign in and you will instantly receive a coupon for free shipping of your purchase.","global.couponLoginOfferSentence":"Join as a registered customer now or sign in and you will instantly receive a {offer} coupon.","global.couponMinimumOrderSentence":"Minimum order {minimumOrder}.","global.couponRegisterFreeDeliverySentence":"Register as our customer now and get a discount coupon. The coupon can be used for free delivery.","global.couponRegisterOfferSentence":"Register as our customer now and get a {offer} discount coupon.","global.couponReviewValueSentence":"Value: {value}","global.couponValidUntilSentence":"Offer valid until {offerExpiry}.","global.creditAccountTitle":"Credit account","global.currencyLabel":"Currency: {currency}","global.currentPasswordTitle":"Current Password","global.customerProductsTitle":"Contract Products","global.dateUpdatedTitle":"Last updated","global.deliveryCountryLabel":"Delivery to: {country}","global.deliveryStartingAbridged":"Shipping starting from","global.deliveryStartingSentence":"Delivery costs starting from {price}","global.discountAmountSentence":"Discount: {discount}","global.discountPercentageSentence":"Discount: {discount} %","global.eanLabel":"EAN: {ean}","global.editTitle":"Edit","global.emailOrUsernameTitle":"Username or Email","global.emailTitle":"Email","global.endDateTitle":"End date","global.errorContent":"Please refresh the page. If the problem continues please try again later.","global.errorContentFront":"Please refresh the page. If the problem continues please go to frontpage.","global.errorFrontpage":"To frontpage","global.errorHeader":"We're sorry - something's gone wrong","global.errorRefresh":"Refresh page","global.errorReport":"Send report","global.exceptionalAvailability":"(Exceptional availability)","global.extraIdLabel":"Extra ID: {extraId}","global.fileTitle":"File","global.firstNameTitle":"First Name","global.formattedMonths":"{months, plural, one {# month} other {# months}}","global.formattedYears":"{years, plural, one {# year} other {# years}}","global.freeDeliverySentence":"Free delivery","global.freeQuantity":"Free Quantity: {freeQuantity} {stockUnit}","global.fullNameTitle":"Name","global.hasStartingPriceSentence":"Final shipping costs will be calculated in the checkout","global.here":"here","global.homeTitle":"Home","global.imageLoadFailed":"Image failed to load","global.imageTitle":"image","global.infoCallPhone":"Call {phone}","global.infoSendEmail":"Send email","global.infoTitle":"Info","global.isActiveLabel":"Active username","global.isCorporateCustomerSentence":"I am a corporate customer","global.itemCount":"{count, plural, one {# product} other {# products}}","global.klarnaExpressCheckout":"Klarna. Express Checkout","global.languageLabel":"Language: {language}","global.lastNameTitle":"Last Name","global.loading":"Loading...","global.logInSentence":"Log in","global.loginInformationTitle":"Login Information","global.lowOrderFeeNoTaxSentence":"Low order fee of {amount} for orders less than {limit}","global.lowOrderFeeSentence":"Low order fee of {amount} ({amountWithoutTax}) for orders less than {limit} ({limitwithoutTax} without VAT)","global.manufacturerCodeLabel":"Manufacturer part number: {manufacturerCode}","global.messageTitle":"Message","global.modifyOrderNotify":"Modifying existing orders may change shipping costs.","global.mostPopularTitle":"Most Popular","global.myAccount":"Overview","global.myAccountChangePassword":"Change password","global.myAccountInfo":"Personal information","global.myAccountNoOrders":"You have not ordered anything yet.","global.myAccountNoPurchases":"No purchases found.","global.myAccountTitle":"My Account","global.myAccountUserTitle":"My Account: {user}","global.myCustomerAccountTitle":"My Customer Account","global.myOrderHistoryTitle":"Order History","global.newPasswordTitle":"New Password","global.newProductsTitle":"New Products","global.newTitle":"New","global.newsletterSubscriptionSentence":"Subscribe to our newsletter","global.newsletterSuccessSentence":"You have been added to the mailing list successfully.","global.nicknameTitle":"Nickname","global.noProductsFoundSentence":"No products found.","global.noTitle":"No","global.notFoundTitle":"Not found","global.notifyUserLabel":"Automatically send username to email.","global.ok":"OK","global.onSaleTitle":"On Sale","global.orderDate":"Order date","global.orderInfoHeader":"Order information","global.orderListingWeb":"Webstore order","global.orderNumber":"Order number","global.ourBrandsTitle":"Our Brands","global.passwordTitle":"Password","global.paymentMethod":"Payment method","global.paymentTokensNewTitle":"Add new payment card","global.paymentTokensTitle":"Payment cards","global.pickupPointTitle":"Pickup Point","global.popularSearchesTitle":"Popular searches","global.priceFrom":"from","global.priceTitle":"Price","global.privacyStatementAcceptSentence":"I authorize the processing of my personal data according to the Privacy statement","global.privacyStatementMustApproveSentence":"Approval of Privacy statement is required.","global.proceedToCartSentence":"Shopping cart","global.proceedToCheckoutSentence":"Proceed to checkout","global.productAddedToCartSentence":"{quantity, plural, one {# product} other {# products}} added to cart","global.productBundleAddedToCartSentence":"Product bundle added to cart","global.productBundlesTitle":"Product Bundles","global.productCount":"{count, plural, one {# product} other {# products}}","global.productEnquiryProposalTitle":"Ask for a proposal","global.productEnquiryTitle":"Ask about the product","global.productOffer":"Product offer","global.productTitle":"Product","global.productsTitle":"Products","global.propertyChooseTitle":"Choose {property}","global.purchaseOrderCountHeader":"Order count","global.purchaseUserHeader":"User","global.purchaseWithVatHeader":"With VAT","global.purchaseWithoutVatHeader":"Without VAT","global.purchasesListTitle":"User purchases","global.quantityDecrementTitle":"Decrement quantity","global.quantityIncrementTitle":"Increment quantity","global.quantityTitle":"Quantity","global.readAboutRecurring":"Subscription is a recurring and automatically sent order. You can decide the products and how often you need a delivery.","global.readMoreSentence":"Read more","global.recommendedProductsTitle":"Recommended Products","global.recurringOrdersTitle":"Subscriptions","global.regionalSettingsTitle":"Regional settings","global.registerTitle":"Register","global.relatedProductsTitle":"Related Products","global.removeTitle":"Remove","global.retailerTitle":"Retailer","global.reviewCount":"{count, plural, one {# review} other {# reviews}}","global.reviewCountCompact":"({count})","global.reviewProductRatingTitle":"Product","global.reviewServiceRatingTitle":"Service and delivery","global.reviewTitle":"Review","global.reviewsTitle":"Reviews","global.saveTitle":"Save","global.search":"Search","global.searchHistoryTitle":"Recent searches","global.searchNoResults":"No results found","global.searchResultsForTermTitle":"Results for the Search Term \"{term}\"","global.searchResultsForTitle":"Search Results for {term}","global.searchResultsTitle":"Search Results","global.searchTryAnotherSentence":"Try another search","global.seeCategoriesNavi":"See categories and infopages","global.selectTitle":"Select","global.selectedTitle":"Selected","global.selectedTitleWithValue":"Selected: {value}","global.sendTitle":"Send","global.shipping":"Shipping","global.shippingAddressTitle":"Shipping address","global.shippingCostsTitle":"Shipping costs","global.shippingMethod":"Shipping method","global.shoppingCenterAcceptableTerms":"By clicking \"{continuePurchase}\" I confirm I've read {storeName} {termsOfUse} and {privacyStatement}, and merchant's {merchantName} {deliveryAndPaymentTerms} and {merchantPrivacyStatement}","global.shoppingCenterProductMerchantDeliveryAndPaymentTerms":"delivery and payment terms","global.shoppingCenterProductMerchantPrivacy":"privacy statement","global.showAllProductsSentence":"Show all products","global.showLessText":"Show less","global.showMoreText":"Show more","global.sizeGuideSentence":"Size guide","global.soldProductsTitle":"Sold Products","global.startDateTitle":"Start date","global.statusTitle":"Status","global.stockTemporarilyOutOfSentence":"Product temporarily out of stock","global.streetAddressTitle":"Street Address","global.submitSurvey":"Submit","global.suggestionsTitle":"Suggestions","global.sumWithVat":"Total with VAT","global.sumWithoutVat":"Total without VAT","global.surveySubmitError":"Error submitting form. Please try again.","global.taxExcluded":"(tax excl.)","global.taxIncluded":"(tax incl.)","global.telephoneTitle":"Telephone","global.termFilterPlaceholder":"Search","global.toOrder":"See info","global.totalPriceSentence":"Total","global.unitPriceTitle":"Unit price","global.update":"Update","global.uploadFileTitle":"Upload file","global.userListTitle":"Users for account","global.validUntilFurtherNotice":"Valid until further notice.","global.validationMessageInvalidFloor":"The quantity must be divisible with the package product count {size}.","global.validationMessageInvalidQuantity":"The quantity must be between {min} and {max}.","global.vehiclePartSearchTitle":"Vehicle part search","global.warrantyLabel":"Warranty: {warranty}","global.weRecommendTitle":"We Recommend","global.weightTitle":"Weight","global.wishListPageTitle":"Wishlist","global.writeNewReview":"Write a review","global.yesTitle":"Yes","global.youSaveSentence":"You save {savings}","global.yourEmail":"Your email","global.yourReferenceTitle":"Reference","global.zipCodeTitle":"Zip Code","image.lightboxHelper":"Click image to enlarge","klarnaInstantShopping.emptyInstantShoppingCart":"You haven't selected any products.","klarnaInstantShopping.orderProductsInfo":"Order these products or add other variations","klarnaInstantShopping.selectProduct":"Select product","klarnaInstantShoppingForm.addressAcknowledgement":"Given address must correspond with the shipping address given in the next step","klarnaInstantShoppingForm.fillPickupPointInformation":"Write your address","klarnaInstantShoppingModal.choosePickupPoint":"Choose pickup point:","klarnaInstantShoppingModal.chooseShippingMethod":"Choose shipping method:","klarnaInstantShoppingModal.creatingOrder":"Please wait...","klarnaInstantShoppingModal.distance":"Distance: {distance} {distanceUnit}","klarnaInstantShoppingModal.fetchingPickupPoints":"Fetching pickup points...","klarnaInstantShoppingModal.fetchingShippingOptions":"Fetching shipping options...","klarnaInstantShoppingModal.noPickupPoints":"Unfortunately, no pickup points were found. Check that the address is correct or choose another delivery method.","klarnaInstantShoppingModal.openingHours":"Opening hours: {openingHours}","klarnaInstantShoppingModal.orderProductsButton":"Continue to order","klarnaInstantShoppingModal.shippingAndPickup":"{storeName} - order","klarnaInstantShoppingModal.updatingOrder":"Updating order...","localization.doNotRedirect":"Stay on this online store","localization.isSuggestedSite":"We recommend using this online store.","localization.moveToSite":"Go to the online store","localization.noShipping":"Please check out our available online stores as unfortunately we do not deliver to the detected country.","localization.noSuggestion":"We do not recognize where you are. Please check out our available online stores.","localization.shippingPossible":"Shipping is possible to your country.","localization.yourLocation":"We detected you are in {country}","manufacturer.browserManufacturerProducts":"Browse brands' products","manufacturer.chooseManufacturerPlaceholder":"Choose brand...","manufacturer.seeAllBrands":"See all brands","myAccount.balanceUserAccountStatusActive":"Active","myAccount.balanceUserAccountStatusNotActive":"Disabled","myAccount.balanceUserAccountUpdatePassword":"Optional. Only change, if you want to change your password.","myAccount.basicInfo":"Account basic info","myAccount.billingAddressTitle":"Billing address","myAccount.billingMethodTitle":"Billing method","myAccount.buyBalanceInfoText":"Select an amount for the users you want to transfer money to and wait a moment.","myAccount.cancelOrder":"Cancel order","myAccount.companyLabel":"Company: {company}","myAccount.customerIdLabel":"Customer ID: {customerId}","myAccount.emailLabel":"Email: {email}","myAccount.groupNameLabel":"Customer group: {group}","myAccount.klarnaCheckoutPaymentInfo":"Please give your payment info.","myAccount.loginInfo":"By logging in you can see your order history and modify your personal information.","myAccount.nameLabel":"Name: {name}","myAccount.orderDate":"Ordered on: {orderDate}","myAccount.orderHistory":"See All","myAccount.orderHistoryTitle":"Shipping history","myAccount.orderTitle":"Order {orderId}","myAccount.packageTitle":"Packet {parcelCount}:","myAccount.packageToTracking":"{trackingCode} (Go to tracking)","myAccount.paymentDetailsTitle":"Payment details","myAccount.pinExpires":"PIN-code expires at {expires}. Time is now {nowTime}","myAccount.previousOrders":"Previous orders","myAccount.printReceiptSentence":"Print a receipt of this order","myAccount.shippingAddressTitle":"Shipping address","myAccount.shippingDetailsTitle":"Shipping details","myAccount.shippingMethodTitle":"Shipping method","myAccount.telephoneLabel":"Telephone: {telephone}","myAccount.trackingDescription":"(If the tracking page notifies you that no orders were found, it may be that the parcel is not yet received at the delivery company)","myAccount.trackingTitle":"Tracking order parcels","myAccount.updateAddress":"Update Address","myAccount.updateUser":"Update User","navigation.backToBegin":"Back to the begin","navigation.backToItem":"Back to {name}","navigation.goBackLink":"Back to search results","navigation.navigateToCategoryItem":"See all products here","navigation.navigateToInfoItem":"See page content here","navigation.navigateToSectionItem":"See section frontpage here","navigation.shopAllCategory":"Shop all {category}","navigation.shopAllSection":"Shop all {section}","newsletter.isFree":"Newsletter is free","newsletter.popdownTitleWithoutDiscount":"Subscribe to our free newsletter!","newsletter.status.EMAIL_EXISTS":"The e-mail address you entered is already in our e-mail list.","newsletter.status.SUCCESS":"You have been added to our e-mail list. Thank you for subscribing!","newsletter.status.VALIDATION_ERROR":"Information you provided is not valid. Please recheck the form.","newsletter.subscribe":"Subscribe","newsletter.subscribeCompact":"Subscribe","newsletter.subscriberAgreesTo":"By subscribing you agree to","order.dateHeader":"Order date","order.dateTitle":"Date","order.deliveredQuantityTitle":"Delivered qty","order.orderNotFound":"Given code is not found","order.orderNotFoundSentence":"Order is not found","order.productAddFailedSentence":"Product cannot be added for order","order.productAddedSentence":"Product added to order","order.productNameTitle":"Name","order.statusDescriptionTitle":"Description","order.sumHeader":"Total","order.totalShortTitle":"Total","order.trackingHeader":"Status","orderStatus.active":"Active","orderStatus.canceled":"Canceled","orderStatus.deactivated":"Deactivated","orderStatus.onHold":"On hold","orderStatus.pending":"Pending","orderStatus.processing":"Processing","orderStatus.ready":"Ready","payment.addedAtSentence":"Added on {createdAt}","payment.expiredSentence":"Expired","payment.validSentence":"Valid","privacyStatement.readLinkSentence":"Privacy statement here","privacyStatement.subscriberAgreesLink":"the Privacy Statement","product.AddWishListTitle":"Add to wishlist","product.ProductAddedToWishlist":"Product added to wishlist. You can view it {link}.","product.ProductAddedToWishlist_here":"here","product.RRP":"RRP","product.allProductsFromCategory":"All {categoryLink}","product.allProductsFromManufacturer":"All {manufacturerLink} products","product.alsoPurchasedProducts":"Customers who purchased this item, also purchased","product.cartMatrixProductInformation":"Select the products to order from the table below.","product.checkingShippingValidity":"Product validity for the cart.","product.compatibleVehicleParts":"Compatible","product.currentProductSoldOut":"The selected product has been sold out.","product.dateAvailable":"Product will be available {date}","product.deposit":"Product price will be included deposit of {deposit}","product.depositIncluded":"Includes deposit of {deposit}","product.descriptionDetails":"Details","product.descriptionTitle":"Description","product.downloadFile":"Download","product.enquirySuccess":"Your message was sent to our customer service successfully. We aim to handle the message as soon as possible.","product.fileUploadDeleteFile":"Delete file {file}","product.fileUploadExistingFilesHeader":"Currently uploaded files","product.fileUploadExplanationSentence":"Upload your files for this product here","product.fileUploadLoading":"Loading file list...","product.fileUploadTooManyFileUploadsError":"You have reached the maximum amount of uploaded files.","product.fileUploadWorking":"Uploading...","product.hasBeenSoldOut":"This product has been sold out.","product.idLabel":"Product Code: {id}","product.incomingQuantity":"Incoming: {freeQuantity} {stockUnit} {date}","product.incomingQuantityNoQuantities":"Incoming: {date}","product.inventoryQuantity":"Inventory Quantity: {inventoryQuantity} {stockUnit}","product.lastVisitedProducts":"Last visited products","product.manufacturerLogoAlt":"{manufacturer} logo","product.manufacturersContentTitle":"Manufacturers content","product.minOrderQuantityError":"Products minimum quantity is {minOrderQuantity} {stockUnit}","product.noDateAvailable":"(no date available)","product.notAvailable":"(Not available)","product.nowOnly":"Now only","product.offer":"Offer!","product.onlyInStore":"This product cannot be purchased from the online store. Please contact sales","product.onlyInStoreLink":"Please see contact information","product.packageSizeDescription":"{packageSizeSentence}: 1 {packageUnitName} = {packageSize} {stockUnit} ({packagePrice} / {packageUnitName})","product.packageSizeSentence":"Package size","product.productMatrixInfo":"Select the products to be ordered by entering the quantities in the \"Quantity\" fields in the table. You can move between cells using the tab.","product.productsHasBeenOrdered":"(Products has been ordered)","product.propertyColourVariants":"{count} different colours available","product.quantityInput":"Quantity","product.salesBeginAt":"Sales begin at {date}","product.seasonEndedOn":"Product's sales ended online on {endDate}.","product.seasonIs":"Product sale period online is {startDate} - {endDate}.","product.seasonStartsOn":"Product's sales start online on {startDate}.","product.selectProductFirst":"First choose the product.","product.shoppingCenterAcceptableTerms":"Merchant's {merchantName} {deliveryAndPaymentTerms} and {merchantPrivacyStatement}","product.showAllOfType":"Show all {type}","product.showAllOfType.CAMPAIGN_PRODUCTS":"products on sale","product.showAllOfType.FALLBACK":"products","product.showAllOfType.MOST_SOLD_PRODUCTS":"popular products","product.showAllOfType.NEW_PRODUCTS":"new products","product.showAllOfType.RECOMMENDED_PRODUCTS":"recommended products","product.sold":"Sold","product.spareParts":"Spares","product.superOffer":"Super offer","product.topDiscount":"Top discount","product.vehiclePartAlternatives":"Alternatives","product.watcherButton":"Inform me when product is in stock","product.watcherHeading":"I want to receive a notification when this product is available","product.watcherInfo":"Please enter your email address and we will send you a notification when the product is in stock again. After this your email will be removed from our list.","product.weightLabel":"Weight: {weight}","productBundle.addToCartButton":"Add bundle to cart","productBundle.createYourOwn":"Bundle \"{productName}\" with additional products and save","productBundle.noSelectedProducts":"No additional products selected","productBundle.price":"Bundle price","productBundle.selectedProducts":"You have selected {count, plural, one {# additional product} other {# additional products}}","productBundle.youSave":"You save","productCollectionMatrix.addSelectedProducts":"Add Selected Products","productListFilter.filter":"Filter by keyword","productListFilter.filterList":"Filter list","productPageContent.productNotValidForCart":"This product does not have any common shipping methods with the products in the cart. For example pickup from different storage.","productPageContent.productPurchaseGuideTitle":"See purchase guide","productPageContent.shoppingCenterBuyProductsInfo":"If you buy several products at once, you can also go to the merchant's online store. There you can also find the merchant's whole selection","productPageContent.shoppingCenterBuyingNotAllowed":"This product has limitations for purchase. Please check the merchants store for more information.","productPageContent.shoppingCenterProductMerchantLink":"Go to the merchant's online store","productPageContent.shoppingCenterSiteName":"You're buying from {siteName}","recurringOrder.addToCart":"Add new subscription to cart","recurringOrder.addToOrder":"Add subscription to order","recurringOrder.allowShippingChangeSentence":"Allow automatic change of shipping method when current method is not possible. (Might change shipping costs)","recurringOrder.allowShippingChangeValue":"Allow automatic change of shipping method when current method is not possible: {allowUnder}","recurringOrder.allowUnderDeliveryValue":"Allow partial delivery when all products are not available: {allowUnder}","recurringOrder.changeQuantity":"Change product quantity","recurringOrder.cycleBiMonthly":"Every other month","recurringOrder.cycleBiWeekly":"Every other week","recurringOrder.cycleCustom":"Choose your interval","recurringOrder.cycleMonthly":"Every month","recurringOrder.cyclePlaceholder":"Choose your cycle","recurringOrder.cycleQuarterly":"Every three months","recurringOrder.cycleWeekly":"Every week","recurringOrder.days":"days","recurringOrder.deliveryAddressSentence":"Delivery address","recurringOrder.onHoldPlaceholder":"Choose date from calendar","recurringOrder.onHoldSentence":"On hold until: {untilDate}","recurringOrder.onHoldTitle":"Set subscription on hold until (Use dropdown or calendar icon)","recurringOrder.onlyForLoggedIn":"Subscriptions are available for registered users.","recurringOrder.paymentCardReminder":"Subscriptions will be charged from a payment card. Please make sure you have added valid payment card. You can have multiple payment cards.","recurringOrder.readLinkSentence":"Read more about subscriptions.","recurringOrder.selectCycle":"Choose cycle for your subscription","recurringOrder.selectDays":"Interval. (Minimum of {days} days)","recurringOrder.selectOrder":"Choose on which subscription product should be added","recurringOrder.shippingMethodSentence":"Subscription shipping method","recurringOrder.subscribe":"Subscribe","recurringOrder.subscriptionButton":"Save money by subscribing","recurringOrder.subscriptionPlaceholder":"Choose your subscription","recurringOrder.titleSentence":"Give descriptive title","reserveInStore.availableServicesForStorage":"The following services are available in the store you selected:","reserveInStore.availableStoragesHint":"The following stores have the selected quantity of this item in stock.","reserveInStore.button":"Reserve in store","reserveInStore.cancellationInfo":"You can cancel your reservation by calling the store.","reserveInStore.confirmReservation":"Reserve now","reserveInStore.howItWorks":"Reserve the product now and pick it up from the store later! The reservation is valid for {expiryHours} hours, after which it will be removed. Please note that discount coupons cannot be used with in-store reservations.","reserveInStore.outOfStockMultipleStoresHint":"No pick-up stores currently have this product in stock.","reserveInStore.outOfStockSingleStoreHint":"This store doesn't currently have this product in stock.","reserveInStore.reservationConfirmationTitle":"Reservation #{reservationID}","reserveInStore.reservationSuccessfulMessage":"Thank you for your reservation! A confirmation message has been sent to the email address {email}.","reserveInStore.reservationTitle":"Reserve in store","reserveInStore.selectChildProductHint":"First choose the product. After this you can reserve this product from a store.","reserveInStore.selectStorageButton":"Select this store","reserveInStore.selectedServicesSentence":"With the following selected services:","reserveInStore.showAllStoragesButton":"Show all stores","reserveInStore.stockLoadingHint":"Please wait, loading in-store availability...","reserveInStore.storageFilterPlaceholder":"Post code or city","reserveInStore.unselectStorageButton":"Select another store","review.emailAddressForApprovalHint":"We will notify you via this address after your review has been approved. We will remove the email address from our registry right after.","review.emailAddressForCouponHint":"The coupon details will be sent to this address. We will remove the email address from our registry after the coupon has been sent.","review.haveYouBoughtSentence":"Have you purchased this product before?","review.interactiveStarsLabel":"{count, plural, one {# star} other {# stars}} out of 5","review.nicknameFieldHint":"A nickname of your choice that we'll show next to your review.","review.reviewCouponTitle":"Review this product to receive a discount coupon!","review.reviewHint":"By submitting your review, you agree to give us the permission to publish it on this website as well as on other sites and media. {storeName} reserves the right to not publish the review. By submitting, you agree to these terms.","review.sendTitle":"Submit review","review.showAllTitle":"Show all reviews ({count})","review.showDefaultTitle":"Show default number of reviews","review.staffReplySentence":"{name} responds:","review.success":"Your product review was added successfully!","review.successPending":"We have received your review. We check all reviews and you will get a message when yours is published.","review.typeReviewHereSentence":"Type your review here","search.search":"Search","search.searchProducts":"Search products","search.termTooShort":"Search term is too short.","shipping.allCostsTitle":"Products shipping costs","shipping.availableServicesSentence":"Optional services","shipping.campaignHeader":"{name}","shipping.fixedPriceSentence":"Lowered price","shipping.freeShippingSentence":"Free shipping{endAt}","shipping.noMethodsAvailable":"This product doesn't have any available shipping methods for the chosen delivery country","shipping.otherMethodsSentence":"Normal prices","shipping.totalQuantitySentence":"Free shipping for orders with at least {amount} products{endAt}","shipping.totalSumSentence":"Free shipping for orders over {amount}{endAt}","shipping.totalVolumeSentence":"Free shipping for orders volume over {amount} m3{endAt}","shipping.totalWeightSentence":"Free shipping for orders total weight over {amount}{endAt}","shoppingCenterProductMerchantInfo.sellerTitle":"Seller","site.reloadPage":"Reload page","sort.alphabetical":"Alphabetical","sort.bestRated":"Best rated","sort.brand":"Brand","sort.category":"Product category","sort.cheapest":"Cheapest","sort.default":"Default","sort.discount":"Best discount","sort.id":"Product number","sort.latest":"Latest","sort.mostExpensive":"Most expensive","sort.mostPopular":"Most popular","sort.sortLabel":"Sort:","state.networkError":"Connection failure. Please ensure you are connected to the Internet.","state.unexpectedError":"An unexpected error happened. Please try to reload the page. If the error persists try again later.","stock.addressHeading":"Address","stock.availabilityHeading":"Availability","stock.availableInStores":"Check store availability here","stock.contactHeading":"Contact Information and Opening Hours","stock.filterByStorage":"Filter by storage","stock.loadingStoreAvailability":"Loading store availability...","stock.mapLink":"Map and driving instructions","stock.notAvailable":"Not available","stock.shelfLocation":"Shelf Location","stock.soldOut":"Sold out","stock.storeAvailability":"Store availability","stock.storeAvailabilityTitle":"Product availability in stores","stock.storeHeading":"Store","stock.storeOutOfStock":"Store out of stock","stock.storesOutOfStock":"Stores out of stock","stock.temporarilyOutOfStock":"Temporarily out of stock","survey.selectOption":"'-- Select option'","termsOfUseStatement.termsOfUse":"{termsOfUse}","termsOfUseStatement.termsOfUseLink":"terms of use","tokens.createFailSentence":"Failed adding the payment card.","tokens.createSuccessSentence":"Card added successfully.","userInfo.active":"Username is active","userInfo.notInUse":"Username is not active","validation.additionalService.TEXT_REQUIRED":"Additional service requires text input.","validation.additionalService.TEXT_TOO_LONG":"Too many characters.","validation.finnishBusinessId":"Please check the business ID format.","validation.isDate":"{field} format is not allowed.","validation.isEmail":"{field} must be a valid email address.","validation.maxLength":"{field} must not have more than {maxLength} characters.","validation.minLength":"{field} must have at least {minLength} characters.","validation.mustMatch":"Field does not match.","validation.numberBetween":"{field} must be a number between {min} and {max}.","validation.required":"{field} cannot be blank.","vehicle.brand":"Brand","vehicle.model":"Model","vehicle.motor":"Motor","vehicle.years":"Years","vehiclePartSearch.clearVehicle":"Clear vehicle information","vehiclePartSearch.helpText":"Insert your license plate number to find compatible parts for the vehicle","vehiclePartSearch.noSearchResults":"No search results","vehiclePartSearch.notFound":"No vehicle found with given license plate number","vehiclePartSearch.selectModel":"Select more precise model","vehiclePartSearch.severalCarsFound":"Several models were found with the license plate","wishlist.AmountAndInTotal":"Amount / In Total","wishlist.DeleteProduct":"Delete","wishlist.EmailMessage":"Message","wishlist.EmailTitle":"Title","wishlist.InvalidForm":"Form is invalid. Please check your form.","wishlist.NotLoggedInBanner":"You're not yet logged in. You have to {login_link} as a customer to send the list as an email or save it permanently.","wishlist.NotLoggedInBanner_Registration_Enabled":"You're not yet logged in. You have to {login_link} or {register_link} as a customer to send the list as an email or save it permanently.,","wishlist.Product":"Product","wishlist.ProductListEmailInformation":"You can add products to the list and make order decision later. You can also send the list as an email of your choosing.","wishlist.SendList":"Send List","wishlist.UnitPrice":"Price per Unit","wishlist.ValidForm":"Email has been sent successfully.","wishlist.login":"login","wishlist.register":"register","wishlist.wishlistIsEmpty":"Wishlist is empty.","wishlist.wishlistNotFound":"Wishlist doesn't exist with the given id."}

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

module.exports = {"account.clientSearchButton":"Hae asiakasta","account.clientSearchPlaceholder":"Uusi haku painamalla Enter tai hakua","account.doYouWantToRegister":"Haluatko kanta-asiakkaaksi?","account.forgotPasswordInstructions":"Mikäli olet unohtanut salasanasi, kirjoita alle asiakastiliin tallentamasi sähköpostiosoite, jotta voimme uusia vanhan salasanasi.","account.forgotPasswordLink":"Unohtunut salasana? Klikkaa tästä.","account.forgotYourPassword":"Salasana unohtunut?","account.loginInformationHint":"Luo itsellesi käyttäjätunnus ja salasana. Voit käyttää esimerkiksi sähköpostiosoitettasi.","account.loginStatus.ACCOUNT_DISABLED":"Tällä käyttäjätunnuksella ei voi kirjautua sisään.","account.loginStatus.SHOP_LOGIN_DISABLED":"Sisäänkirjautuminen on tällä hetkellä poissa käytöstä.","account.loginStatus.SUCCESS":"Sisäänkirjautuminen onnistui.","account.loginStatus.USERNAME_OR_PASSWORD_WRONG":"Virheellinen käyttäjätunnus tai salasana!","account.loginStatus.USER_ALREADY_LOGGED_IN":"Olet jo kirjautunut sisään!","account.password.PASSWORDS_DO_NOT_MATCH":"Salasanan vahvistuksen täytyy täsmätä salasanaasi.","account.password.PASSWORD_NOT_VALID":"Salasanasi ei täsmää tietokannassamme olevan salasanan kanssa. Ole hyvä ja yritä uudelleen.","account.password.SUCCESS":"Salasanasi on päivitetty onnistuneesti.","account.password.VALIDATION_ERROR":"Annetut tiedot eivät kelpaa. Tarkista tiedot.","account.registrationBenefitsFasterCheckoutItem":"Tilausten teko helppoa ja nopeaa - henkilötietosi ovat valmiiksi täytettyinä.","account.registrationBenefitsHeader":"Kanta-asiakkuuden edut","account.registrationBenefitsNewsletterItem":"Uutiskirje - saat tietoa verkkokaupan tarjouksista sekä muista kampanjoista.","account.registrationBenefitsOrderHistoryItem":"Tilaushistoria - voit tarkastella aikaisemmin verkkokaupassamme tekemiäsi tilauksia.","account.registrationBenefitsPersistentCartItem":"Pysyvä ostoskori - ostoskoriisi lisäämäsi tuotteet pysyvät korissa kunnes poistat ne tai vahvistat tilauksen.","account.registrationBenefitsWishlistItem":"Voit luoda ja lähettää toivelistan kaverillesi.","account.resetPassword":"Pyydä uusi salasana","account.resetPasswordSuccessful":"Sähköpostiosoitteeseesi on lähetetty salasanan palautuslinkki. Mikäli viestiä ei näy, muista tarkistaa myös sähköpostin roskapostikansio tai varmista, että olet juuri tällä sähköpostilla rekisteröitynyt palveluun.","account.setNewPassword":"Vaihda salasana","account.setNewPasswordSuccessful":"Uuden salasanan asettaminen onnistui. Voit nyt kirjautua sisään.","account.setNewPasswordTitle":"Aseta uusi salasana","account.userInfo.EMAIL_NOT_VALID":"Sähköpostiosoitteesi ei näytä olevan oikeaa muotoa.","account.userInfo.FIRSTNAME_NOT_VALID":"Etunimessä on oltava vähintään {characterCount} merkkiä.","account.userInfo.LASTNAME_NOT_VALID":"Sukunimessä on oltava vähintään {characterCount} merkkiä.","account.userInfo.SUCCESS":"Asiakastilisi tiedot päivitettiin onnistuneesti.","account.userInfo.TELEPHONE_NOT_VALID":"Puhelinnumerossa täytyy olla vähintään {characterCount} merkkiä.","account.userInfo.VALIDATION_ERROR":"Annetut tiedot eivät kelpaa. Tarkista tiedot.","addToCart.selectProductVariant":"Valitse vielä tuotevaihtoehto","addToCartPostalCodeValidation.checkPostalCodeInfo":"Hae palveluiden saatavuudet postinumerollasi","addToCartPostalCodeValidation.postalCodePlaceholder":"Syötä postinumerosi","additionalService.availableServices":"Katso saatavilla olevat lisäpalvelut","additionalService.information":"Voit valita haluamasi lisäpalvelut, kun lisäät tuotteen ostoskoriin.","additionalService.optionPriceSentence":"Tämän valinnan hinta on {price}","additionalService.postalCodeIsInvalid":"Haettu postinumero ei ole kelvollinen tälle palvelulle","additionalService.postalCodeRequired":"Tätä palvelua varten tarvitaan kelvollinen postinumero","additionalService.selectService":"Valitse lisäpalvelu","additionalService.typeTextHereLengthSentence":"Teksti tähän. Enintään {maxLength} merkkiä.","additionalService.typeTextHereSentence":"Syötä teksti tähän.","address.addressFilterPlaceholder":"Hae osoitteita","address.primaryNotice":"Tätä osoitetta käytetään oletusarvoisesti toimitus- ja laskutusosoitteenasi tekemissäsi tilauksissa.","address.setAsPrimary":"Aseta ensisijaiseksi osoitteeksi","address.showAllAddressesButton":"Näytä kaikki osoitteet","balanceUser.pinCodeHeader":"PIN koodi","campaign.activateCode":"Aktivoi","campaign.activationInProgress":"Aktivoidaan koodi...","campaign.categoryLimitation":"Käyttämällä alennuskupongin saat alennuksen tuotteista seuraavista ryhmistä:","campaign.categoryNotFound":"Annettua ryhmää {category} ei löydy","campaign.haveYouReceived":"Onko sinulla kampanja- tai alennuskoodi?","campaign.isActivated":"Koodi on aktivoitu!","campaign.manufacturerLimitation":"Käyttämällä alennuskupongin saat alennuksen tuotteista seuraavilta valmistajilta:","campaign.manufacturerMultiLimitation":"Sallittu tietyille valmistajille","campaign.productLimitation":"Käyttämällä alennuskupongin saat alennuksen seuraavista tuotteista:","campaign.removalInProgress":"Poistetaan koodi...","campaign.removeCouponCode":"Poista alennuskoodi","campaign.setError":"Annettua kampanjaa ei löydy.","campaign.setSuccess":"Koodi on aktivoitu onnistuneesti!","cart.beingUpdated":"Ostoskoria päivitetään","cart.cartContents":"Ostoskorin sisältö","cart.continueShopping":"Jatka ostoksia","cart.couponInstructions":"Alennuskoodit annetaan tilaussivulla.","cart.itemsInCart":"Ostoskorissa on yhteensä {itemCount}.","cart.loadingCartContents":"Ladataan ostoskorin sisältöä","cart.productsTotalLabel":"Tuotteet yhteensä:","cart.productsTotalWithExtraLabel":"Kokonaissumma","cart.selectShoppingCart":"Valitse ostoskori","checkout.backToStore":"Takaisin kauppaan","checkout.buyBalanceSentence":"Osta saldoa","checkout.cancelPayment":"Peruuta","checkout.orderCompleted":"Tilauksenne on vastaanotettu","checkout.orderConfirmationThankYou":"Kiitos tilauksestanne!","checkout.orderInformationTitle":"Tilauksen tiedot","checkout.paymentInformation":"Vahvistus on lähetetty myös sähköpostiosoitteeseen {email}. Varmista, että sähköpostinne on oikea.","checkout.paymentInformation2":"Mikäli viestiä ei näy, muista tarkistaa myös roskapostikansiosi.","checkout.shoppingCenterMerchantInfo":"kauppiaan {merchant}","checkout.successfulPurchaseBreadcrumbName":"Kiitos tilauksestasi","checkout.successfulPurchaseLicensedProductsSentence":"Tilauksenne sisältää tuotteita, jotka ovat luvanvaraisia. Voitte maksaa ostoksenne nyt; tämän jälkeen teidän tulee toimittaa tarvittavat luvat sähköpostiimme. Lisätietoja löydätte toimitusehdoista.","checkout.successfulPurchasePageHeading":"Tilausvahvistus","checkout.successfulPurchasePageTitle":"Tilauksenne on vastaanotettu!","checkout.successfulPurchaseReceipt":"Kuitti","checkout.successfulTransferPageHeading":"Rahansiirto vahvistus","checkout.trackOrder":"Voitte seurata tilauksenne etenemistä {link}, {merchantInfo} tilausseurantasivulle pääsette myös sähköpostiinne tulleesta vahvistuksesta.","contactUs.success":"Viestisi lähetettiin onnistuneesti asiakaspalveluumme. Pyrimme käsittelemään viestin mahdollisimman nopeasti.","cookieNotice.content":"Jotta voisimme palvella asiakkaitamme mahdollisimman hyvin, käytämme sivustollamme evästeitä. Jatkamalla eteenpäin hyväksyt evästeiden käyttämisen.","cookieNotice.readMore":"Lue lisää evästeistä","coupon.emailError":"Tietoja ei voitu lähettää sähköpostiisi. Ota tarvittaessa yhteyttä kauppamme yhteydenottopyyntölomakkeella.","coupon.emailSubscribeNotice":"Antamalla sähköpostiosoitteen tilaat samalla uutiskirjeemme.","coupon.emailSuccess":"Etukupongin tiedot lähetetty sähköpostiisi.","coupon.fetchDiscountCode":"Hae alennuskoodi","coupon.setError":"Alennuskoodia ei voitu aktivoida. Ota tarvittaessa yhteyttä kauppamme yhteydenottopyyntölomakkeella","coupon.setSuccess":"Alennuskoodi aktivoitu onnistuneesti!","coupon.showInformation":"Näytä kupongin tiedot","coupon.useLater":"Käytän koodin myöhemmin","coupon.useNow":"Haluan aktivoida koodin heti","creditAccount.accountStatusTitle":"Luottotilin tila","creditAccount.balanceTitle":"Käytättävissä oleva saldo","creditAccount.creditUsedTitle":"Käytetty saldo","creditAccount.limitTitle":"Luottoraja","customerService.isOpen":"Asiakaspalvelumme palvelee arkisin klo {timespan}","customerUser.fetchPurchases":"Hae ostot","discount.quantityDescription":"Tilaa kerralla useampi ja säästä!","discount.sale":"Ale","discount.upTo":"Jopa","error.notFoundBackToHome":"Palaa etusivulle","error.notFoundGoToSearch":"tai käytä tuotehakua.","error.notFoundHeader":"Hakemaanne sivua ei valitettavasti enää löytynyt.","error.notFoundHelpText":"Sivu voi olla olemassa, mutta sen osoite on voinut muuttua. Voitte jatkaa verkkokaupan selaamista tai koettaa löytää etsimänne hakutoiminnon avulla.","error.notFoundTitle":"Sivua ei löydy","errorModal.content":"Jotakin meni pieleen. Tarkista antamasi tiedot ja yritä uudelleen.","errorModal.title":"Odottamaton virhe tapahtui","filter.removeAllFiltersButton":"Poista valinnat","filter.removeFilterButtonLabel":"Poista suodatus","filter.showMore":"Näytä lisää rajauksia","footer.backToTop":"Takaisin ylös","footer.backToTopShort":"Ylös","footer.cartExpirationExpired":"Ostoskorisi sisällön varaus on päättynyt.","footer.cartExpirationPending":"Ostoskorisi sisällön varaus päättyy:","form.noFileSelected":"Ei valittua tiedostoa","form.selectFileSentence":"Valitse tiedosto...","global.acceptTitle":"Tallenna valinnat","global.accountChangeClientSentence":"Vaihda asiakastiliä","global.accountCreateSentence":"Rekisteröidy","global.accountLogOutSentence":"Kirjaudu ulos","global.active":"Voimassa oleva tilaus","global.addNewAddressTitle":"Anna uusi osoite","global.addNewUserTitle":"Uusi käyttäjä","global.addToCartButton":"Lisää tuote ostoskoriin","global.additionalLinksTitle":"Pikavalinnat","global.additionalServicesTitle":"Lisäpalvelut","global.addressBookTitle":"Osoitekirja","global.allowPartialDeliverySentence":"Salli osittainen toimitus, mikäli kaikki tuotteet eivät ole saatavilla","global.allowUserCreateAddressLabel":"Salli käyttäjän luoda osoitteita","global.balanceUser":"Etusivu","global.balanceUserAccountBalanceInfo":"Saldotilaukset","global.balanceUserAccountInfo":"Asiakastiedot","global.balanceUserAccountPaymentWidgetError":"Maksussa tapahtui valitettavasti virhe. Kokeile päivittää sivu ja yritä uudelleen. Mikäli ongelma ei korjaannu ota yhteyttä asiakaspalveluumme.","global.balanceUserAccountStatus":"Tila","global.balanceUserBalanceValidationError":"Vain tasalukuiset numerot kelpaavat.","global.balanceUserCurrentBalance":"Saldo","global.balanceUserNameTitle":"Käyttäjän nimi","global.balanceUserNewBalance":"Lisää saldoa","global.balanceUserNoBalancePurchases":"Ei saldotilauksia","global.balanceUserPageTitle":"Saldot","global.balanceUserPaymentHistoryOrderDate":"Pvm.","global.balanceUserPaymentHistoryOrderNumber":"Tilausnumero","global.balanceUserPaymentTotal":"Summa","global.brandsTitle":"Tuotemerkkimme","global.businessIdHelp":"Jos olet unohtanut Y-tunnuksen, voit hakea sen klikkaamalla {link}","global.businessIdTitle":"Y-tunnus","global.buttonInfo":"Voit myös vaihtoehtoisesti varata ja noutaa tuotteen myymälästä","global.campaignBoxTitle":"Anna koodi tähän","global.cancelTitle":"Peruuta","global.cartEmptySentence":"Ostoskori on tyhjä","global.categoriesTitle":"Tuoteryhmät","global.checkTitle":"Hae","global.checkedTitle":"Haettu","global.checkout":"Kassa","global.chooseTitle":"Valitse","global.cityTitle":"Paikkakunta","global.clearTitle":"Tyhjennä","global.cloneOrder":"Tilaa uudelleen","global.closeTitle":"Sulje","global.companyTitle":"Yrityksen nimi","global.confirmAddToCartTitle":"Haluatko siirtää tilauksen tuotteet nykyiseen ostoskoriin?","global.confirmPasswordTitle":"Vahvista salasana","global.confirmRemoveTitle":"Oletko varma?","global.contactPersonFirstNameTitle":"Yhteyshenkilön etunimi","global.contactPersonLastNameTitle":"Yhteyshenkilön sukunimi","global.continue":"Jatka","global.continueShopping":"Jatka ostoksia","global.countryTitle":"Maa / alue","global.couponDiscountOfferSentence":"Saat {offer} etukupongin!","global.couponFreeShippingSentence":"Saat ilmaisen toimituksen!","global.couponLoginFreeDeliverySentence":"Liity kanta-asiakkaaksi nyt tai kirjaudu sisään niin saat heti etukupongin. Etukupongilla saat ilmaisen toimituksen.","global.couponLoginOfferSentence":"Liity kanta-asiakkaaksi nyt tai kirjaudu sisään niin saat heti {offer} etukupongin.","global.couponMinimumOrderSentence":"Minimitilaus: {minimumOrder}.","global.couponRegisterFreeDeliverySentence":"Liity kanta-asiakkaaksi nyt niin saat heti etukupongin. Etukupongilla saat ilmaisen toimituksen.","global.couponRegisterOfferSentence":"Liity kanta-asiakkaaksi nyt niin saat heti {offer} etukupongin.","global.couponReviewValueSentence":"Kupongin etu: {value}","global.couponValidUntilSentence":"Kampanja voimassa {offerExpiry} asti.","global.creditAccountTitle":"Luottotili","global.currencyLabel":"Valuutta: {currency}","global.currentPasswordTitle":"Nykyinen salasana","global.customerProductsTitle":"Sopimustuotteet","global.dateUpdatedTitle":"Viimeksi päivitetty","global.deliveryCountryLabel":"Toimitusmaa: {country}","global.deliveryStartingAbridged":"Toimituskulut alk.","global.deliveryStartingSentence":"Toimituskulut alkaen {price}","global.discountAmountSentence":"Alennus: {discount}","global.discountPercentageSentence":"Alennus: {discount} %","global.eanLabel":"EAN: {ean}","global.editTitle":"Muokkaa","global.emailOrUsernameTitle":"Käyttäjätunnus / sähköposti","global.emailTitle":"Sähköposti","global.endDateTitle":"Loppupäivämäärä","global.errorContent":"Päivitä sivu uudelleen. Jos ongelma jatkuu jätä virhekuvaus.","global.errorContentFront":"Päivitä sivu uudelleen. Jos ongelma jatkuu siirry etusivulle.","global.errorFrontpage":"Etusivulle","global.errorHeader":"Pahoittelut - jotakin meni pieleen","global.errorRefresh":"Päivitä sivu","global.errorReport":"Kuvaus virheestä","global.exceptionalAvailability":"(Poikkeava saatavuus)","global.extraIdLabel":"Lisätunnus: {extraId}","global.fileTitle":"Tiedosto","global.firstNameTitle":"Etunimi","global.formattedMonths":"{months, plural, one {# kuukausi} other {# kuukautta}}","global.formattedYears":"{years, plural, one {# vuosi} other {# vuotta}}","global.freeDeliverySentence":"Ilmainen toimitus","global.freeQuantity":"Vapaana: {freeQuantity} {stockUnit}","global.fullNameTitle":"Nimi","global.hasStartingPriceSentence":"Lopulliset toimituskulut lasketaan kassasivulla","global.here":"tästä","global.homeTitle":"Etusivu","global.imageLoadFailed":"Kuvan lataus epäonnistui","global.imageTitle":"kuva","global.infoCallPhone":"Soita {phone}","global.infoSendEmail":"Lähetä sähköpostia","global.infoTitle":"Tietoa","global.isActiveLabel":"Aktiivi käyttäjätunnus","global.isCorporateCustomerSentence":"Olen yritysasiakas","global.itemCount":"{count, plural, one {# tuote} other {# tuotetta}}","global.klarnaExpressCheckout":"Klarna. Pikakassa","global.languageLabel":"Kieli: {language}","global.lastNameTitle":"Sukunimi","global.loading":"Ladataan...","global.logInSentence":"Kirjaudu sisään","global.loginInformationTitle":"Kirjautumistiedot","global.lowOrderFeeNoTaxSentence":"Pientoimituslisä {amount} alle {limit} tilauksista","global.lowOrderFeeSentence":"Pientoimituslisä {amount} ({amountWithoutTax}) alle {limit} ({limitwithoutTax} ALV 0 %) tilauksista","global.manufacturerCodeLabel":"Tilauskoodi: {manufacturerCode}","global.messageTitle":"Viesti","global.modifyOrderNotify":"Lisäys voi aiheuttaa muutoksia toimituskuluissa.","global.mostPopularTitle":"Myydyimmät","global.myAccount":"Asiakastili","global.myAccountChangePassword":"Muuta tilin salasanaa","global.myAccountInfo":"Henkilökohtaiset tiedot","global.myAccountNoOrders":"Et ole tehnyt vielä tilauksia.","global.myAccountNoPurchases":"Ostoja ei löytynyt.","global.myAccountTitle":"Oma tili","global.myAccountUserTitle":"Oma tili: {user}","global.myCustomerAccountTitle":"Asiakastilini","global.myOrderHistoryTitle":"Tilaushistoria","global.newPasswordTitle":"Uusi salasana","global.newProductsTitle":"Uutuudet","global.newTitle":"Uusi","global.newsletterSubscriptionSentence":"Tilaa uutiskirje","global.newsletterSuccessSentence":"Sinut on lisätty sähköpostilistalle onnistuneesti.","global.nicknameTitle":"Nimimerkki","global.noProductsFoundSentence":"Tuotteita ei löytynyt.","global.noTitle":"Ei","global.notFoundTitle":"Ei löytynyt","global.notifyUserLabel":"Lähetä käyttäjätunnus henkilön sähköpostiin automaattisesti","global.ok":"OK","global.onSaleTitle":"Tarjouksessa","global.orderDate":"Tilaus pvm","global.orderInfoHeader":"Tilauksen tiedot","global.orderListingWeb":"Verkkokauppatilaus","global.orderNumber":"Tilausnumero","global.ourBrandsTitle":"Tuotemerkkimme","global.passwordTitle":"Salasana","global.paymentMethod":"Maksutapa","global.paymentTokensNewTitle":"Lisää uusi maksukortti","global.paymentTokensTitle":"Maksukortit","global.pickupPointTitle":"Noutopiste","global.popularSearchesTitle":"Suosittuja hakuja","global.priceFrom":"alk.","global.priceTitle":"Hinta","global.privacyStatementAcceptSentence":"Hyväksyn henkilötietojeni käsittelyn tietosuojaselosteen mukaisesti","global.privacyStatementMustApproveSentence":"Tietosuojaselosteen hyväksyntä vaaditaan.","global.proceedToCartSentence":"Ostoskori","global.proceedToCheckoutSentence":"Siirry tilaamaan","global.productAddedToCartSentence":"{quantity, plural, one {# tuote} other {# tuotetta}} lisätty ostoskoriin","global.productBundleAddedToCartSentence":"Tuotepaketti lisätty ostoskoriin","global.productBundlesTitle":"Tarjouspaketit","global.productCount":"{count, plural, one {# tuote} other {# tuotetta}}","global.productEnquiryProposalTitle":"Pyydä tarjous","global.productEnquiryTitle":"Kysy lisää tuotteesta","global.productOffer":"Tarjoustuote!","global.productTitle":"Tuote","global.productsTitle":"Tuotteet","global.propertyChooseTitle":"Valitse {property}","global.purchaseOrderCountHeader":"Tilausmäärä","global.purchaseUserHeader":"Käyttäjä","global.purchaseWithVatHeader":"Ostot sis. ALV","global.purchaseWithoutVatHeader":"Ostot ALV 0 %","global.purchasesListTitle":"Käyttäjien ostot","global.quantityDecrementTitle":"Vähennä määrää","global.quantityIncrementTitle":"Lisää määrää","global.quantityTitle":"Määrä","global.readAboutRecurring":"Kestotilaus on toistuva ja automaattisesti lähetettävä tilaus. Voit valita tuotteet sekä kuinka usein haluat toimituksen.","global.readMoreSentence":"Lue lisää","global.recommendedProductsTitle":"Yhteensopivat tuotteet","global.recurringOrdersTitle":"Kestotilaukset","global.regionalSettingsTitle":"Alueelliset valinnat","global.registerTitle":"Rekisteröidy","global.relatedProductsTitle":"Vaihtoehtoiset tuotteet","global.removeTitle":"Poista","global.retailerTitle":"Jälleenmyyjä","global.reviewCount":"{count, plural, one {# arvostelu} other {# arvostelua}}","global.reviewCountCompact":"({count})","global.reviewProductRatingTitle":"Tuotearviointi","global.reviewServiceRatingTitle":"Palvelu/toimitus","global.reviewTitle":"Arvostelu","global.reviewsTitle":"Tuotearvostelut","global.saveTitle":"Tallenna","global.search":"Haku","global.searchHistoryTitle":"Viimeisimmät haut","global.searchNoResults":"Ei hakutuloksia","global.searchResultsForTermTitle":"Hakusanan \"{term}\" tulokset","global.searchResultsForTitle":"Hakutulokset {term}","global.searchResultsTitle":"Hakutulokset","global.searchTryAnotherSentence":"Kokeile toista hakusanaa","global.seeCategoriesNavi":"Selaa tuoteryhmiä ja infosivuja","global.selectTitle":"Valitse","global.selectedTitle":"Valittu","global.selectedTitleWithValue":"Valittu: {value}","global.sendTitle":"Lähetä","global.shipping":"Toimitus","global.shippingAddressTitle":"Toimitusosoite","global.shippingCostsTitle":"Toimituskulut","global.shippingMethod":"Toimitustapa","global.shoppingCenterAcceptableTerms":"Klikkaamalla \"{continuePurchase}\" vahvistan, että olen lukenut {storeName} {termsOfUse} ja {privacyStatement}, sekä kauppiaan {merchantName} {deliveryAndPaymentTerms} ja {merchantPrivacyStatement}","global.shoppingCenterProductMerchantDeliveryAndPaymentTerms":"toimitus- ja maksuehdot","global.shoppingCenterProductMerchantPrivacy":"tietosuojalauseke","global.showAllProductsSentence":"Näytä kaikki tuotteet","global.showLessText":"Näytä vähemmän","global.showMoreText":"Näytä enemmän","global.sizeGuideSentence":"Koko-opas","global.soldProductsTitle":"Myydyt tuotteet","global.startDateTitle":"Alkupäivämäärä","global.statusTitle":"Tila","global.stockTemporarilyOutOfSentence":"Tuote tilapäisesti loppu","global.streetAddressTitle":"Katuosoite","global.submitSurvey":"Lähetä","global.suggestionsTitle":"Ehdotukset","global.sumWithVat":"sis. ALV","global.sumWithoutVat":"Summa ALV 0 %","global.surveySubmitError":"Virhe lomakkeen lähettämisessä. Yritä uudelleen.","global.taxExcluded":"(alv 0%)","global.taxIncluded":"(Sis.alv)","global.telephoneTitle":"Puhelinnumero","global.termFilterPlaceholder":"Hae","global.toOrder":"Katso tilaus","global.totalPriceSentence":"Yhteensä","global.unitPriceTitle":"Hinta á","global.update":"Päivitä","global.uploadFileTitle":"Lataa tiedosto","global.userListTitle":"Tilille luodut käyttäjät","global.validUntilFurtherNotice":"Voimassa toistaiseksi.","global.validationMessageInvalidFloor":"Määrän pitää olla jaollinen paketin tuotemäärällä {size}.","global.validationMessageInvalidQuantity":"Määrän täytyy olla välillä {min} ja {max}.","global.vehiclePartSearchTitle":"Varaosahaku ajoneuvon perusteella","global.warrantyLabel":"Takuu: {warranty}","global.weRecommendTitle":"Suosittelemme","global.weightTitle":"Paino","global.wishListPageTitle":"Toive / Tilauslista","global.writeNewReview":"Kirjoita arvostelu","global.yesTitle":"Kyllä","global.youSaveSentence":"Säästä {savings}","global.yourEmail":"Sähköpostisi","global.yourReferenceTitle":"Viite","global.zipCodeTitle":"Postinumero","image.lightboxHelper":"Klikkaa kuvaa suurentaaksesi","klarnaInstantShopping.emptyInstantShoppingCart":"Yhtään tuotetta ei ole valittu.","klarnaInstantShopping.orderProductsInfo":"Tilaa tuotteet tai lisää muita vaihtoehtoja","klarnaInstantShopping.selectProduct":"Valitse tuote","klarnaInstantShoppingForm.addressAcknowledgement":"Annetun osoitteen pitää vastata seuraavassa vaiheessa annettua toimitusosoitetta","klarnaInstantShoppingForm.fillPickupPointInformation":"Kirjoita osoitteesi","klarnaInstantShoppingModal.choosePickupPoint":"Valitse noutopiste:","klarnaInstantShoppingModal.chooseShippingMethod":"Valitse toimitustapa:","klarnaInstantShoppingModal.creatingOrder":"Odota hetki...","klarnaInstantShoppingModal.distance":"Etäisyys: {distance} {distanceUnit}","klarnaInstantShoppingModal.fetchingPickupPoints":"Haetaan noutopisteitä...","klarnaInstantShoppingModal.fetchingShippingOptions":"Haetaan toimitustapoja...","klarnaInstantShoppingModal.noPickupPoints":"Noutopisteitä ei valitettavasti löytynyt. Tarkista että osoite on oikein tai valitse toinen toimitustapa.","klarnaInstantShoppingModal.openingHours":"Aukioloajat: {openingHours}","klarnaInstantShoppingModal.orderProductsButton":"Jatka tilaamaan","klarnaInstantShoppingModal.shippingAndPickup":"{storeName} - tilaus","klarnaInstantShoppingModal.updatingOrder":"Päivitetään tilausta...","localization.doNotRedirect":"Pysy nykyisessä","localization.isSuggestedSite":"Suosittelemme käyttämään tätä verkkokauppaa.","localization.moveToSite":"Siirry verkkokauppaan","localization.noShipping":"Katsothan verkkokauppamme alta, koska emme valitettavasti toimita havaittuun maahan.","localization.noSuggestion":"Emme tunnista missä olet. Katso meidän verkkokauppamme.","localization.shippingPossible":"Toimitus on mahdollinen maahasi.","localization.yourLocation":"Havaitsimme, että olet maassa {country}","manufacturer.browserManufacturerProducts":"Selaa tuotemerkin tuotteita","manufacturer.chooseManufacturerPlaceholder":"Valitse tuotemerkki...","manufacturer.seeAllBrands":"Katso kaikki tuotemerkit","myAccount.balanceUserAccountStatusActive":"Käytössä","myAccount.balanceUserAccountStatusNotActive":"Ei käytössä","myAccount.balanceUserAccountUpdatePassword":"Valinnainen. Anna salasana vain, jos haluat muuttaa salasanan.","myAccount.basicInfo":"Tilin perustiedot","myAccount.billingAddressTitle":"Laskutusosoite","myAccount.billingMethodTitle":"Maksutapa","myAccount.buyBalanceInfoText":"Valitse haluamasi saldo niille käyttäjille, joille haluat siirtää rahaa ja odota hetki.","myAccount.cancelOrder":"Peruuta tilaus","myAccount.companyLabel":"Yritys: {company}","myAccount.customerIdLabel":"Asiakasnumero: {customerId}","myAccount.emailLabel":"Sähköposti: {email}","myAccount.groupNameLabel":"Asiakasryhmä: {group}","myAccount.klarnaCheckoutPaymentInfo":"Anna maksutiedot","myAccount.loginInfo":"Kirjautumalla sisään näet tilaushistoriasi sekä voit muokata tietojasi.","myAccount.nameLabel":"Nimi: {name}","myAccount.orderDate":"Tilauspäivä: {orderDate}","myAccount.orderHistory":"Katso kaikki","myAccount.orderHistoryTitle":"Tilauksen käsittelyvaiheet","myAccount.orderTitle":"Tilaus {orderId}","myAccount.packageTitle":"Paketti {parcelCount}:","myAccount.packageToTracking":"{trackingCode} Siirry lähetysseurantaan","myAccount.paymentDetailsTitle":"Maksutiedot","myAccount.pinExpires":"PIN koodi vanhenee klo {expires}. Kello on nyt {nowTime}","myAccount.previousOrders":"Viimeisimmät tilaukset","myAccount.printReceiptSentence":"Tulosta kuitti","myAccount.shippingAddressTitle":"Toimitusosoite","myAccount.shippingDetailsTitle":"Toimitustiedot","myAccount.shippingMethodTitle":"Toimitustapa","myAccount.telephoneLabel":"Puhelin: {telephone}","myAccount.trackingDescription":"(Mikäli seurantasivulla ei löydy lähetystä, voi olla, että pakettia ei ole vielä toimitettu kuljetusyhtiöön.)","myAccount.trackingTitle":"Pakettien seuranta","myAccount.updateAddress":"Päivitä osoite","myAccount.updateUser":"Päivitä käyttäjä","navigation.backToBegin":"Takaisin alkuun","navigation.backToItem":"Takaisin: {name}","navigation.goBackLink":"Takaisin hakutuloksiin","navigation.navigateToCategoryItem":"Katso kaikki tuotteet tästä","navigation.navigateToInfoItem":"Katso sivun sisältö tästä","navigation.navigateToSectionItem":"Katso osaston etusivu tästä","navigation.shopAllCategory":"Siirry ryhmän etusivulle","navigation.shopAllSection":"Siirry osaston etusivulle","newsletter.isFree":"Uutiskirje on ilmainen","newsletter.popdownTitleWithoutDiscount":"Tilaa ilmainen uutiskirjeemme!","newsletter.status.EMAIL_EXISTS":"Antamasi sähköpostiosoite löytyy jo sähköpostilistaltamme.","newsletter.status.SUCCESS":"Tietonne lisättiin onnistuneesti sähköpostilistallemme. Kiitos tilauksesta!","newsletter.status.VALIDATION_ERROR":"Antamasi tiedot ovat virheelliset. Ole hyvä ja tarkista lomake.","newsletter.subscribe":"Tilaa uutiskirje","newsletter.subscribeCompact":"Tilaa","newsletter.subscriberAgreesTo":"Tilaamalla hyväksyt","order.dateHeader":"Tilauspäivä","order.dateTitle":"Päivämäärä","order.deliveredQuantityTitle":"Toimitettu","order.orderNotFound":"Annettua koodia ei löydy","order.orderNotFoundSentence":"Tilausta ei löydy","order.productAddFailedSentence":"Tuotetta ei voi lisätä tilaukselle","order.productAddedSentence":"Tuote lisätty tilaukseen","order.productNameTitle":"Nimi","order.statusDescriptionTitle":"Kuvaus","order.sumHeader":"Summa","order.totalShortTitle":"Yht.","order.trackingHeader":"Tila","orderStatus.active":"Voimassa","orderStatus.canceled":"Peruutettu","orderStatus.deactivated":"Ei voimassa","orderStatus.onHold":"Tauolla","orderStatus.pending":"Odottaa käsittelyä","orderStatus.processing":"Käsittelyssä","orderStatus.ready":"Valmis","payment.addedAtSentence":"Lisätty {createdAt}","payment.expiredSentence":"Vanhentunut","payment.validSentence":"Voimassa","privacyStatement.readLinkSentence":"Lue tietosuojaseloste tästä","privacyStatement.subscriberAgreesLink":"tietosuojaselosteen","product.AddWishListTitle":"Lisää toive / tilauslistaan","product.ProductAddedToWishlist":"Tuote lisätty tilauslistaan. Voit katsoa sitä {link}.","product.ProductAddedToWishlist_here":"täältä","product.RRP":"Ovh.","product.allProductsFromCategory":"Kaikki {categoryLink}","product.allProductsFromManufacturer":"Kaikki {manufacturerLink} tuotteet","product.alsoPurchasedProducts":"Katso myös, mitä muut asiakkaamme ostivat tämän tuotteen kanssa","product.cartMatrixProductInformation":"Valitse tilattavat tuotteet alla olevasta taulukosta.","product.checkingShippingValidity":"Tuotteen kelpoisuus ostoskoriin.","product.compatibleVehicleParts":"Yhteensopivat","product.currentProductSoldOut":"Valittu tuote on loppuunmyyty.","product.dateAvailable":"Tuotetta on saatavilla {date}","product.deposit":"Tuotteen hintaan lisätään pantti {deposit}","product.depositIncluded":"Sisältää pantin {deposit}","product.descriptionDetails":"Lisätiedot","product.descriptionTitle":"Tuotekuvaus","product.downloadFile":"Lataa","product.enquirySuccess":"Viestisi lähetettiin onnistuneesti asiakaspalveluumme. Pyrimme käsittelemään viestin mahdollisimman nopeasti.","product.fileUploadDeleteFile":"Poista tiedosto {file}","product.fileUploadExistingFilesHeader":"Lataamasi tiedostot","product.fileUploadExplanationSentence":"Lataa tuotteelle haluamasi tiedostot","product.fileUploadLoading":"Ladataan tiedostolistaa...","product.fileUploadTooManyFileUploadsError":"Olet jo ladannut suurimman sallitun määrän tiedostoja.","product.fileUploadWorking":"Ladataan...","product.hasBeenSoldOut":"Tuote on loppuunmyyty.","product.idLabel":"Tuotekoodi: {id}","product.incomingQuantity":"Tulossa: {freeQuantity} {stockUnit} {date}","product.incomingQuantityNoQuantities":"Tulossa: {date}","product.inventoryQuantity":"Varastossa: {inventoryQuantity} {stockUnit}","product.lastVisitedProducts":"Viimeksi selatut tuotteet","product.manufacturerLogoAlt":"{manufacturer} logo","product.manufacturersContentTitle":"Valmistajan sisältö","product.minOrderQuantityError":"Tuotteen minimitilausmäärä {minOrderQuantity} {stockUnit}","product.noDateAvailable":"(päivämäärä ei tiedossa)","product.notAvailable":"(Ei saatavilla)","product.nowOnly":"Nyt vain","product.offer":"Tarjous!","product.onlyInStore":"Tätä tuotetta ei voi ostaa verkkokaupasta. Ota yhteyttä myyntiin","product.onlyInStoreLink":"Katso yhteystiedot","product.packageSizeDescription":"{packageSizeSentence}: 1 {packageUnitName} = {packageSize} {stockUnit} ({packagePrice} / {packageUnitName})","product.packageSizeSentence":"Myyntierä","product.productMatrixInfo":"Valitse tilattavat tuotteet antamalla määrät taulukossa oleviin \"Määrä\"-kenttiin. Voit liikkua solujen välillä käyttämällä sarkainta / tabulaattoria.","product.productsHasBeenOrdered":"(Tuotetta tilattu varastoon)","product.propertyColourVariants":"{count} eri väriä saatavilla","product.quantityInput":"Määrä","product.salesBeginAt":"Tulossa myyntiin {date}","product.seasonEndedOn":"Tuotteen myynti kampanjahintaan päättyi verkkokaupassa {endDate}.","product.seasonIs":"Tuotteen myyntiaika kampanjahintaan verkkokaupassa on {startDate} - {endDate}.","product.seasonStartsOn":"Tuotteen myynti kampanjahintaan alkaa verkkokaupassa {startDate}.","product.selectProductFirst":"Valitse ensin tuote.","product.shoppingCenterAcceptableTerms":"Kauppiaan {merchantName} {deliveryAndPaymentTerms} ja {merchantPrivacyStatement}","product.showAllOfType":"Näytä kaikki {type}","product.showAllOfType.CAMPAIGN_PRODUCTS":"tarjoukset","product.showAllOfType.FALLBACK":"tuotteet","product.showAllOfType.MOST_SOLD_PRODUCTS":"myydyimmät","product.showAllOfType.NEW_PRODUCTS":"uutuudet","product.showAllOfType.RECOMMENDED_PRODUCTS":"suosittelemamme tuotteet","product.sold":"Myyty","product.spareParts":"Varaosat","product.superOffer":"Supertarjous","product.topDiscount":"Huippuedullinen","product.vehiclePartAlternatives":"Vaihtoehtoiset","product.watcherButton":"Ilmoita kun tuotetta on varastossa","product.watcherHeading":"Haluan saada ilmoituksen kun tuotetta on varastossa","product.watcherInfo":"Anna sähköpostiosoitteesi niin lähetämme sinulle viestin kun tuotetta on taas saatavilla varastosta. Tämän jälkeen sähköpostiosoitteesi poistetaan listaltamme.","product.weightLabel":"Paino: {weight}","productBundle.addToCartButton":"Lisää paketti ostoskoriin","productBundle.createYourOwn":"Yhdistä \"{productName}\" tuotteeseen lisävarusteita ja säästä","productBundle.noSelectedProducts":"Et ole vielä valinnut lisävarusteita","productBundle.price":"Pakettihinta","productBundle.selectedProducts":"Olet valinnut {count, plural, one {# lisävarusteen} other {# lisävarustetta}}","productBundle.youSave":"Säästösi","productCollectionMatrix.addSelectedProducts":"Lisää valitut tuotteet","productListFilter.filter":"Suodata","productListFilter.filterList":"Rajaa hakusanalla","productPageContent.productNotValidForCart":"Tuotteella ei ole yhteisiä toimitustapoja ostoskorin tuotteiden kanssa. Esimerkiksi nouto eri varastosta.","productPageContent.productPurchaseGuideTitle":"Katso osto-opas","productPageContent.shoppingCenterBuyProductsInfo":"Jos ostat useita eri tuotteita kerralla, voit siirtyä myös kauppiaan verkkokauppaan. Löydät sieltä myös kauppiaan koko tuotevalikoiman","productPageContent.shoppingCenterBuyingNotAllowed":"Tällä tuotteella on rajoituksia ostoon. Tarkista tarkemmat tiedot kauppiaan verkkokaupasta.","productPageContent.shoppingCenterProductMerchantLink":"Siirry kauppiaan kauppaan","productPageContent.shoppingCenterSiteName":"Ostat kauppiaalta {siteName}","recurringOrder.addToCart":"Lisää uusi kestotilaus koriin","recurringOrder.addToOrder":"Lisää tuote kestotilaukseen","recurringOrder.allowShippingChangeSentence":"Salli toimitustavan muutos mikäli nykyinen ei ole mahdollinen. (Saattaa vaikuttaa toimituskuluihin)","recurringOrder.allowShippingChangeValue":"Salli toimitustavan automaattinen vaihto mikäli nykyinen toimitustapa ei ole mahdollinen: {allowUnder}","recurringOrder.allowUnderDeliveryValue":"Salli osatoimitus mikäli kaikkia tuotteita ei ole saatavilla: {allowUnder}","recurringOrder.changeQuantity":"Muuta tuotteen määrää","recurringOrder.cycleBiMonthly":"Joka toinen kuukausi","recurringOrder.cycleBiWeekly":"Joka toinen viikko","recurringOrder.cycleCustom":"Vapaavalintainen","recurringOrder.cycleMonthly":"Kerran kuukaudessa","recurringOrder.cyclePlaceholder":"Valitse ajankohta","recurringOrder.cycleQuarterly":"Joka kolmas kuukausi","recurringOrder.cycleWeekly":"Kerran viikossa","recurringOrder.days":"päivää","recurringOrder.deliveryAddressSentence":"Toimitusosoite","recurringOrder.onHoldPlaceholder":"Valitse päivämäärä kalenterista","recurringOrder.onHoldSentence":"Tauolla {untilDate} asti.","recurringOrder.onHoldTitle":"Aseta tilaus tauolle (Käytä pudotusvalikkoa tai kalenterin kuvaa)","recurringOrder.onlyForLoggedIn":"Jatkuva tilaus on saatavilla kirjautuneille asiakkaille.","recurringOrder.paymentCardReminder":"Tilaukset veloitetaan automaattisesti. Varmistathan, että olet lisännyt voimassaolevan maksukortin. Voit lisätä useamman maksukortin tarvittaessa.","recurringOrder.readLinkSentence":"Lue lisää kestotilauksista.","recurringOrder.selectCycle":"Valitse ajankohta lähetyksellesi","recurringOrder.selectDays":"Aikaväli. (Minimi {days} päivää)","recurringOrder.selectOrder":"Liitä tuote voimassaolevaan kestotilaukseen","recurringOrder.shippingMethodSentence":"Tilauksen toimitustapa","recurringOrder.subscribe":"Tee kestotilaus","recurringOrder.subscriptionButton":"Säästä rahaa tekemällä kestotilaus","recurringOrder.subscriptionPlaceholder":"Valitse kestotilaus","recurringOrder.titleSentence":"Anna kuvaava nimi","reserveInStore.availableServicesForStorage":"Valitsemasi myymälän tarjoamat lisäpalvelut:","reserveInStore.availableStoragesHint":"Myymälät, joissa tuotetta on saatavilla valittu määrä:","reserveInStore.button":"Varaa ja nouda","reserveInStore.cancellationInfo":"Voit peruuttaa varauksen soittamalla myymälään.","reserveInStore.confirmReservation":"Varaa tuote myymälään","reserveInStore.howItWorks":"Varaa nyt ja nouda myymälästä! Myymälävaraus on voimassa {expiryHours} tuntia, jonka jälkeen se poistetaan automaattisesti. Huomioithan, että alennuskoodeja ei voi käyttää myymälävarauksen yhteydessä.","reserveInStore.outOfStockMultipleStoresHint":"Tuotetta ei tällä hetkellä ole noudettavissa mistään myymälästä.","reserveInStore.outOfStockSingleStoreHint":"Tuotetta ei tällä hetkellä ole saatavissa tästä myymälästä.","reserveInStore.reservationConfirmationTitle":"Varaus #{reservationID}","reserveInStore.reservationSuccessfulMessage":"Kiitos varauksesta! Olet saanut vahvistusviestin osoitteeseen {email}.","reserveInStore.reservationTitle":"Varaa ja nouda","reserveInStore.selectChildProductHint":"Valitse ensin tuote. Tämän jälkeen voit varata tuotteen noudettavaksi myymälästä.","reserveInStore.selectStorageButton":"Valitse myymälä","reserveInStore.selectedServicesSentence":"Valitsemasi lisäpalvelut:","reserveInStore.showAllStoragesButton":"Näytä kaikki myymälät","reserveInStore.stockLoadingHint":"Odota hetki, myymäläsaatavuutta ladataan...","reserveInStore.storageFilterPlaceholder":"Postinumero tai paikkakunta","reserveInStore.unselectStorageButton":"Vaihda myymälää","review.emailAddressForApprovalHint":"Saatte viestin antamaanne osoitteeseen, kun arvostelunne on hyväksytty. Tämän jälkeen poistamme sähköpostiosoitteen rekisteristämme.","review.emailAddressForCouponHint":"Lähetämme etukupongin tiedot tähän osoitteeseen. Tämän jälkeen poistamme sähköpostiosoitteen rekisteristämme.","review.haveYouBoughtSentence":"Oletko ostanut tämän tuotteen?","review.interactiveStarsLabel":"{count, plural, one {# tähti} other {# tähteä}} 5 tähdestä","review.nicknameFieldHint":"Vapaavalintainen nimimerkki, jonka julkaisemme arvostelun yhteydessä.","review.reviewCouponTitle":"Arvostele tuote, niin saat etukupongin!","review.reviewHint":"Lähettämällä arvostelusi annat meille oikeuden julkaista sen sivuillamme sekä muissa kanavissa ja medioissa. {storeName}-verkkokauppa pidättää oikeuden olla julkaisematta arvostelua. Lähettämällä arvostelusi hyväksyt nämä ehdot.","review.sendTitle":"Lähetä arvostelu","review.showAllTitle":"Lue kaikki arvostelut ({count})","review.showDefaultTitle":"Näytä oletusmäärä arvosteluita","review.staffReplySentence":"{name} vastaa:","review.success":"Tuotearvostelunne on lisätty onnistuneesti! Kiitos arvostelustanne.","review.successPending":"Olemme vastaanottaneet arvostelunne. Tarkastamme kaikki arvostelut ja saatte sähköpostiinne viestin kun arvostelunne on julkaistu.","review.typeReviewHereSentence":"Kirjoita tähän arvostelusi","search.search":"Hae","search.searchProducts":"Hae tuotteita","search.termTooShort":"Hakusana on liian lyhyt.","shipping.allCostsTitle":"Toimituskulut","shipping.availableServicesSentence":"Valinnaiset palvelut:","shipping.campaignHeader":"{name}","shipping.fixedPriceSentence":"Alennettu hinta","shipping.freeShippingSentence":"Ilmainen toimitus {endAt}","shipping.noMethodsAvailable":"Tälle tuotteelle ei löydy yhtään toimitustapaa valitulla toimitusmaalla.","shipping.otherMethodsSentence":"Normaalit hinnat","shipping.totalQuantitySentence":"Ilmainen toimitus vähintään {amount} tuotteen tilauksille{endAt}","shipping.totalSumSentence":"Ilmainen toimitus yli {amount} tilauksille{endAt}","shipping.totalVolumeSentence":"Ilmainen toimitus tilavuudeltaan yli {amount} m3 tilauksille{endAt}","shipping.totalWeightSentence":"Ilmainen toimitus painoltaan yli {amount} kg tilauksille{endAt}","shoppingCenterProductMerchantInfo.sellerTitle":"Myyjä","site.reloadPage":"Lataa uudelleen","sort.alphabetical":"Aakkosjärjestys","sort.bestRated":"Parhaiten arvioidut","sort.brand":"Tuotemerkki","sort.category":"Tuoteryhmä","sort.cheapest":"Edullisimmat","sort.default":"Oletus","sort.discount":"Paras alennus","sort.id":"Tuotenumero","sort.latest":"Uusimmat","sort.mostExpensive":"Arvokkaimmat","sort.mostPopular":"Myydyimmät","sort.sortLabel":"Järjestys:","state.networkError":"Yhteysvirhe. Tarkista että olet yhteydessä internetiin ja yritä uudelleen.","state.unexpectedError":"Odottamaton virhe. Ole hyvä ja lataa sivu uudelleen. Jos virhe toistuu, yritä myöhemmin uudelleen.","stock.addressHeading":"Osoite","stock.availabilityHeading":"Saatavuus","stock.availableInStores":"Katso myymäläkohtainen saatavuus tästä","stock.contactHeading":"Yhteystiedot ja aukioloajat","stock.filterByStorage":"Suodata myymälän mukaan","stock.loadingStoreAvailability":"Ladataan myymäläsaatavuutta...","stock.mapLink":"Kartta, ajo-ohje","stock.notAvailable":"Ei saatavilla","stock.shelfLocation":"Hyllypaikka","stock.soldOut":"Loppuunmyyty","stock.storeAvailability":"Myymäläsaatavuus","stock.storeAvailabilityTitle":"Tuotteen saatavuus myymälöissä","stock.storeHeading":"Myymälä","stock.storeOutOfStock":"Loppu myymälästä","stock.storesOutOfStock":"Loppu myymälöistä","stock.temporarilyOutOfStock":"Tilapäisesti loppu","survey.selectOption":"-- Valitse vaihtoehto","termsOfUseStatement.termsOfUse":"{termsOfUse}","termsOfUseStatement.termsOfUseLink":"käyttöehdot","tokens.createFailSentence":"Maksukortin lisääminen epäonnistui.","tokens.createSuccessSentence":"Maksukortti lisätty.","userInfo.active":"Tunnus on käytössä","userInfo.notInUse":"Tunnus ei ole käytössä","validation.additionalService.TEXT_REQUIRED":"Lisäpalvelu vaatii tekstin.","validation.additionalService.TEXT_TOO_LONG":"Liian monta merkkiä.","validation.finnishBusinessId":"Ole hyvä ja tarkista Y-tunnuksen muoto.","validation.isDate":"{field} ei ole oikeassa muodossa.","validation.isEmail":"{field} on oltava sähköpostiosoitteen muodossa.","validation.maxLength":"{field} voi sisältää korkeintaan {maxLength} merkkiä.","validation.minLength":"{field} pitää olla vähintään {minLength} merkkiä pitkä.","validation.mustMatch":"Kenttä ei täsmää.","validation.numberBetween":"{field} täytyy olla väliltä {min} ja {max}.","validation.required":"{field} ei voi olla tyhjä.","vehicle.brand":"Merkki","vehicle.model":"Malli","vehicle.motor":"Moottori","vehicle.years":"Vuosimallit","vehiclePartSearch.clearVehicle":"Nollaa ajoneuvon tiedot","vehiclePartSearch.helpText":"Syötä ajoneuvosi rekisterinumero jotta näet siihen soveltuvat varaosat.","vehiclePartSearch.noSearchResults":"Ei hakua vastaavia tuotteita.","vehiclePartSearch.notFound":"Kyseisellä rekisterinumerolla ei löytynyt ajoneuvoa.","vehiclePartSearch.selectModel":"Valitse tarkempi malli","vehiclePartSearch.severalCarsFound":"Rekisterinumerolla löytyi useampi ajoneuvomalli","wishlist.AmountAndInTotal":"Määrä / Yhteensä","wishlist.DeleteProduct":"Poista","wishlist.EmailMessage":"Viesti","wishlist.EmailTitle":"Otsikko","wishlist.InvalidForm":"Lomake ei ole hyväksyttävää muotoa. Ole hyvä ja tarkista lomake.","wishlist.NotLoggedInBanner":"Et ole vielä kirjautunut sisään. Sinun täytyy {login_link}, jotta voit lähettää listan sähköpostiin tai tallentaa sen pysyvästi.","wishlist.NotLoggedInBanner_Registration_Enabled":"Et ole vielä kirjautunut sisään. Sinun täytyy {login_link} tai {register_link} asiakkaaksemme, jotta voit lähettää listan sähköpostiin tai tallentaa sen pysyvästi.","wishlist.Product":"Tuote","wishlist.ProductListEmailInformation":"Voit lisätä listaan tuotteita ja päättää myöhemmin jos tilaat tuotteet. Voit myös lähettää listan haluamaasi sähköpostiin.","wishlist.SendList":"Lähetä","wishlist.UnitPrice":"Kpl-hinta","wishlist.ValidForm":"Sähköposti on lähetetty onnistuneesti.","wishlist.login":"kirjautua","wishlist.register":"rekisteröityä","wishlist.wishlistIsEmpty":"Tyhjä toivelista.","wishlist.wishlistNotFound":"Toivelistaa ei löytynyt annetulla avaimella."}

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports = {"account.clientSearchButton":"Sök efter klient","account.clientSearchPlaceholder":"Ny sökning med Enter eller sökknapp","account.doYouWantToRegister":"Vill du bli förmånskund?","account.forgotPasswordInstructions":"Om du har glömt ditt lösenord, ange e-postadressen till ditt kundkonto nedan för att återställa ditt lösenord.","account.forgotPasswordLink":"Glömt ditt lösenord? Klicka här.","account.forgotYourPassword":"Glömt ditt lösenord? ","account.loginInformationHint":"Skapa ett användarnamn (du kan t.ex. använda din e-postadress) och ett lösenord för ditt konto.","account.loginStatus.ACCOUNT_DISABLED":"Det här användarkontot har inaktiverats.","account.loginStatus.SHOP_LOGIN_DISABLED":"Det är inte tillåtet att logga in just nu.","account.loginStatus.SUCCESS":"Inloggad.","account.loginStatus.USERNAME_OR_PASSWORD_WRONG":"Ogiltigt användarnamn eller lösenord!","account.loginStatus.USER_ALREADY_LOGGED_IN":"Du är redan inloggad!","account.password.PASSWORDS_DO_NOT_MATCH":"Lösenordskontrolltexten måste matcha ditt valda lösenord.","account.password.PASSWORD_NOT_VALID":"Ditt lösenord matchar inte lösenordet i vår databas. Var god försök igen.","account.password.SUCCESS":"Ditt lösenord har uppdaterats.","account.password.VALIDATION_ERROR":"Informationen du angav är inte giltig. Kontrollera formuläret igen.","account.registrationBenefitsFasterCheckoutItem":"Enkel och snabb kassa - dina uppgifter fylls i automatiskt.","account.registrationBenefitsHeader":"Fördelar med att registrera sig","account.registrationBenefitsNewsletterItem":"Nyhetsbrev - du får information om våra specialerbjudanden och kampanjer","account.registrationBenefitsOrderHistoryItem":"Orderhistorik - du kan se dina tidigare beställningar","account.registrationBenefitsPersistentCartItem":"Din varukorg sparas - artiklar som du lägger till i din varukorg sparas tills du tar bort dem eller bekräftar beställningen.","account.registrationBenefitsWishlistItem":"Du kan skapa en önskelista som du sedan kan dela med dina vänner.","account.resetPassword":"Återställ lösenord","account.resetPasswordSuccessful":"Ett e-postmeddelandet har skickats till dig med en länk för återställning av ditt lösenord. Kom ihåg att kolla din skräppost samt se till att e-postadressen är korrekt om meddelandet inte kommer fram.","account.setNewPassword":"Ställ in nytt lösenord","account.setNewPasswordSuccessful":"Ditt lösenord har ändrats. Du kan nu logga in.","account.setNewPasswordTitle":"Välj ett nytt lösenord","account.userInfo.EMAIL_NOT_VALID":"Din e-postadress verkar ha fel format.","account.userInfo.FIRSTNAME_NOT_VALID":"Förnamnet måste innehålla minst {characterCount} tecken","account.userInfo.LASTNAME_NOT_VALID":"Efternamnet måste innehålla minst {characterCount} tecken.","account.userInfo.SUCCESS":"Din kundkontoinformation uppdaterades framgångsrikt.","account.userInfo.TELEPHONE_NOT_VALID":"Telefonnumret måste innehålla minst {characterCount} -tecken.","account.userInfo.VALIDATION_ERROR":"Informationen du angav är inte giltig. Kontrollera formuläret.","addToCart.selectProductVariant":"Välj produktvariant","addToCartPostalCodeValidation.checkPostalCodeInfo":"Sök efter tjänsternas tillgänglighet med ditt postnummer","addToCartPostalCodeValidation.postalCodePlaceholder":"Ange ditt postnummer","additionalService.availableServices":"Se tillgängliga tjänster här","additionalService.information":"Du kan välja ytterligare tjänster när produkten läggs till i kundvagnen.","additionalService.optionPriceSentence":"Priset för detta alternativ är {price}","additionalService.postalCodeIsInvalid":"Postnummer är ogiltigt för denna tjänsten","additionalService.postalCodeRequired":"Kvalificerat postnummer krävs för denna tjänsten","additionalService.selectService":"Välj tjänst","additionalService.typeTextHereLengthSentence":"Skriv din text här. Maximalt {maxLength} -tecken.","additionalService.typeTextHereSentence":"Skriv din text här.","address.addressFilterPlaceholder":"Sök efter adresser","address.primaryNotice":"Den här adressen används som din standardleverans- och faktureringsadress i dina beställningar.","address.setAsPrimary":"Ange som en primäradress","address.showAllAddressesButton":"Visa alla adresser","balanceUser.pinCodeHeader":"Pinkod","campaign.activateCode":"Aktivera","campaign.activationInProgress":"Aktiverar kod ...","campaign.categoryLimitation":"Med denna rabattkupong får du en rabatt för produkter som tillhör följande produktkategorier","campaign.categoryNotFound":"Angiven kategori {category} hittades inte","campaign.haveYouReceived":"Har du fått en kampanj eller rabattkod?","campaign.isActivated":"Kampanjkoden är aktiverad!","campaign.manufacturerLimitation":"Med denna rabattkupong får du en rabatt för produkter från följande märken:","campaign.manufacturerMultiLimitation":"Tillåtet för begränsade tillverkare","campaign.productLimitation":"Med denna rabattkupong får du en rabatt för följande produkter:","campaign.removalInProgress":"Tar bort kod ...","campaign.removeCouponCode":"Ta bort koden","campaign.setError":"Den angivna kampanjkoden hittades inte.","campaign.setSuccess":"Kampanjkoden aktiverades framgångsrikt!","cart.beingUpdated":"Kundvagnen uppdateras","cart.cartContents":"Varukorgens innehåll","cart.continueShopping":"Fortsätt handla","cart.couponInstructions":"Rabattkoder kan användas på kassasidan.","cart.itemsInCart":"{itemCount} i varukorgen","cart.loadingCartContents":"Laddar varukorgens innehåll","cart.productsTotalLabel":"Produkter totalt:","cart.productsTotalWithExtraLabel":"Totalt","cart.selectShoppingCart":"Välj kundvagn","checkout.backToStore":"Tillbaka till butiken","checkout.buyBalanceSentence":"Köp balans","checkout.cancelPayment":"Avbryt","checkout.orderCompleted":"Din beställning har mottagits","checkout.orderConfirmationThankYou":"Tack för din beställning!","checkout.orderInformationTitle":"Beställningsinformation","checkout.paymentInformation":"Bekräftelsemail har också skickats till e-postadressen {email}. Se till att din e-postadress är korrekt.","checkout.paymentInformation2":"Om du inte ser meddelandet ska du också kontrollera din skräppostmapp.","checkout.shoppingCenterMerchantInfo":"säljarens {merchant}","checkout.successfulPurchaseBreadcrumbName":"Tack","checkout.successfulPurchaseLicensedProductsSentence":"Vissa produkter i din beställning kräver licens. Du kan betala din beställning nu; efter detta måste du skicka relevanta licenser till oss via e-post. Se sidan om leveransvillkor för mer information.","checkout.successfulPurchasePageHeading":"Orderbekräftelse","checkout.successfulPurchasePageTitle":"Din beställning har registrerats!","checkout.successfulPurchaseReceipt":"Kvitto","checkout.successfulTransferPageHeading":"Bekräftelse av pengaröverföring","checkout.trackOrder":"Du kan spåra din beställning genom att klicka på {link}, du kan också komma till {merchantInfo} beställningsspårningssidan från bekräftelsemeddelandet.","contactUs.success":"Ditt meddelande skickades till vår kundtjänst. Vi strävar efter att hantera meddelandet så snart som möjligt.","cookieNotice.content":"För att tjäna våra kunder så bra som möjligt använder vi cookies på vår webbplats. Genom att fortsätta accepterar du att använda cookies.","cookieNotice.readMore":"Läs mer om cookies","coupon.emailError":"Informationen kunde inte skickas till din e-post. Kontakta vår kundtjänst med hjälp av kontaktformuläret.","coupon.emailSubscribeNotice":"Genom att ge oss din e-postadress prenumererar du på vårt nyhetsbrev.","coupon.emailSuccess":"Rabattkuponginformationen har skickats till din e-post.","coupon.fetchDiscountCode":"Hämta rabattkod","coupon.setError":"Kampanjkoden kunde inte aktiveras. Kontakta vår kundtjänst med hjälp av kontaktformuläret.","coupon.setSuccess":"Kampanjkoden aktiverades framgångsrikt!","coupon.showInformation":"Visa kuponginformation","coupon.useLater":"Jag vill använda min kuoponkod senare","coupon.useNow":"Jag vill aktivera min kupongkod nu","creditAccount.accountStatusTitle":"Kreditkonto status","creditAccount.balanceTitle":"Kontobalans","creditAccount.creditUsedTitle":"Kredit används","creditAccount.limitTitle":"Kreditgräns","customerService.isOpen":"Kundtjänst är öppen mån – fre {timespan}","customerUser.fetchPurchases":"Hämta köp","discount.quantityDescription":"Beställ mer och spara pengar!","discount.sale":"Rea","discount.upTo":"Upp till","error.notFoundBackToHome":"Återgå till framsidan","error.notFoundGoToSearch":"eller använd produktsökningen.","error.notFoundHeader":"Sidan du begärde kunde tyvärr inte hittas längre.","error.notFoundHelpText":"Om den fortfarande finns kan adressen ha ändrats. Du kan fortsätta surfa i webbutiken eller försöka hitta det du letade med hjälp av sökfunktionen.","error.notFoundTitle":"Sidan hittas inte","errorModal.content":"Något gick fel. Kontrollera den angivna informationen och försök igen.","errorModal.title":"Ett oväntat fel har inträffat","filter.removeAllFiltersButton":"Rensa filter","filter.removeFilterButtonLabel":"Ta bort filtret","filter.showMore":"Visa fler filter","footer.backToTop":"Till sidans topp","footer.backToTopShort":"Topp","footer.cartExpirationExpired":"Reservation för artiklarna i din kundvagn har gått ut.","footer.cartExpirationPending":"Reservation för artiklarna i din kundvagn löper ut i","form.noFileSelected":"Ingen fil vald","form.selectFileSentence":"Välj fil...","global.acceptTitle":"Spara","global.accountChangeClientSentence":"Logga in som klient","global.accountCreateSentence":"Skapa ett konto","global.accountLogOutSentence":"Logga ut","global.active":"Aktivt abonnemang","global.addNewAddressTitle":"Lägg till ny adress","global.addNewUserTitle":"Lägg till ny användare","global.addToCartButton":"Lägg till i kundvagn","global.additionalLinksTitle":"Genvägar","global.additionalServicesTitle":"Ytterligare tjänster","global.addressBookTitle":"Adressbok","global.allowPartialDeliverySentence":"Tillåt leverans även om alla produkter inte är tillgängliga","global.allowUserCreateAddressLabel":"Tillåt användaren att skapa adresser","global.balanceUser":"Framsida","global.balanceUserAccountBalanceInfo":"Balansera order","global.balanceUserAccountInfo":"Kundinformation","global.balanceUserAccountPaymentWidgetError":"Tyvärr uppstod ett fel med din betalning. Försök att uppdatera sidan och försök igen. Om problemet kvarstår, kontakta vår kundtjänst.","global.balanceUserAccountStatus":"Status","global.balanceUserBalanceValidationError":"Endast jämna siffror accepteras.","global.balanceUserCurrentBalance":"Balans","global.balanceUserNameTitle":"Riktiga namn","global.balanceUserNewBalance":"Lägg till balans","global.balanceUserNoBalancePurchases":"Inga saldoköp","global.balanceUserPageTitle":"Balans","global.balanceUserPaymentHistoryOrderDate":"Datum","global.balanceUserPaymentHistoryOrderNumber":"Ordernummer","global.balanceUserPaymentTotal":"Belopp","global.brandsTitle":"Varumärken","global.businessIdHelp":"Om du har glömt ditt FO-nummer kan du hitta det genom att klicka på {link}","global.businessIdTitle":"FO-numret","global.buttonInfo":"Du kan också boka och hämta produkten från vår butik","global.campaignBoxTitle":"Ange koden här","global.cancelTitle":"Avbryt","global.cartEmptySentence":"Varukorgen är tom","global.categoriesTitle":"Kategorier","global.checkTitle":"Sök","global.checkedTitle":"Söknades","global.checkout":"Kassa","global.chooseTitle":"Välj","global.cityTitle":"Stad","global.clearTitle":"Töm","global.cloneOrder":"Beställ igen","global.closeTitle":"Stäng","global.companyTitle":"Bolag","global.confirmAddToCartTitle":"Vill du lägga till produkter i varukorgen?","global.confirmPasswordTitle":"Bekräfta lösenord","global.confirmRemoveTitle":"Är du säker","global.contactPersonFirstNameTitle":"Kontaktperson Förnamn","global.contactPersonLastNameTitle":"Kontaktperson Efternamn","global.continue":"Fortsätta","global.continueShopping":"Fortsätt shoppa","global.countryTitle":"Land / Ort","global.couponDiscountOfferSentence":"Få en {offer} rabattkupong!","global.couponFreeShippingSentence":"Få gratis leverans!","global.couponLoginFreeDeliverySentence":"Gå med som registrerad kund nu eller logga in så får du direkt en kupong för gratis frakt på ditt köp.","global.couponLoginOfferSentence":"Gå med som registrerad kund nu eller logga in så får du omedelbart en {offer} -kupong.","global.couponMinimumOrderSentence":"Minsta beställning {minimumOrder}.","global.couponRegisterFreeDeliverySentence":"Registrera dig som vår kund nu och få en rabattkupong. Kupongen kan användas för gratis leverans.","global.couponRegisterOfferSentence":"Registrera dig som vår kund nu och få en {offer} rabattkupong.","global.couponReviewValueSentence":"Värde: {value}","global.couponValidUntilSentence":"Erbjudandet gäller till {offerExpiry}.","global.creditAccountTitle":"Kreditkonto","global.currencyLabel":"Valuta: {currency}","global.currentPasswordTitle":"Nuvarande lösenord","global.customerProductsTitle":"Avtalsprodukter","global.dateUpdatedTitle":"Senast uppdaterad","global.deliveryCountryLabel":"Leverans till: {country}","global.deliveryStartingAbridged":"Leverans från","global.deliveryStartingSentence":"Leveranskostnader från {price}","global.discountAmountSentence":"Rabatt: {discount}","global.discountPercentageSentence":"Rabatt: {discount} %","global.eanLabel":"EAN: {ean}","global.editTitle":"Redigera","global.emailOrUsernameTitle":"Användarnamn eller e-post","global.emailTitle":"e-post","global.endDateTitle":"Slutdatum","global.errorContent":"Uppdatera sidan. Om problemet kvarstår vänligen ge en felbeskrivning","global.errorContentFront":"Uppdatera sidan. Om problemet kvarstår vänligen gå till förstasidan","global.errorFrontpage":"Till förstasidan","global.errorHeader":"Vi beklagar att något gick fel","global.errorRefresh":"Uppdatera sida","global.errorReport":"Felbeskrivning","global.exceptionalAvailability":"(Exceptionell tillgänglighet)","global.extraIdLabel":"Produktkod: {extraId}","global.fileTitle":"Fil","global.firstNameTitle":"Förnamn","global.formattedMonths":"{months, plural, one {# månad} other {# månader}}","global.formattedYears":"{years, plural, one {# år} other {# år}}","global.freeDeliverySentence":"Fri leverans","global.freeQuantity":"Fri: {freeQuantity} {stockUnit}","global.fullNameTitle":"Namn","global.hasStartingPriceSentence":"Slutliga fraktkostnader kommer att beräknas på kassasidan","global.here":"Här","global.homeTitle":"Hem","global.imageLoadFailed":"Bilden kunde inte laddas","global.imageTitle":"bild","global.infoCallPhone":"Ring {phone}","global.infoSendEmail":"Skicka epost","global.infoTitle":"Info","global.isActiveLabel":"Aktivt användarnamn","global.isCorporateCustomerSentence":"Jag är företagskund","global.itemCount":"{count, plural, one {# produkt} other {# produkter}}","global.klarnaExpressCheckout":"Klarna. Snabbkassa","global.languageLabel":"Språk: {language}","global.lastNameTitle":"Efternamn","global.loading":"Laddar...","global.logInSentence":"Logga in","global.loginInformationTitle":"Inloggningsinformation","global.lowOrderFeeNoTaxSentence":"Låg orderavgift på {amount} for orders less than {limit}","global.lowOrderFeeSentence":"Låg orderavgift på {amount} ({amountWithoutTax}) för beställningar mindre än {limit} ({limitwithoutTax} utan moms)","global.manufacturerCodeLabel":"Tillverkarens artikelnummer: {manufacturerCode}","global.messageTitle":"Meddelande","global.modifyOrderNotify":"Om du ändrar befintliga beställningar kan fraktkostnaderna ändras.","global.mostPopularTitle":"Populära produkter","global.myAccount":"Översikt","global.myAccountChangePassword":"Ändra lösenordet för ditt konto","global.myAccountInfo":"Personlig information","global.myAccountNoOrders":"Du har inte beställt någonting ännu.","global.myAccountNoPurchases":"Inga köp hittade.","global.myAccountTitle":"Mitt konto","global.myAccountUserTitle":"Mitt konto: {user}","global.myCustomerAccountTitle":"Mitt kundkonto","global.myOrderHistoryTitle":"Min orderhistorik","global.newPasswordTitle":"Nytt lösenord","global.newProductsTitle":"Nya produkter","global.newTitle":"Nyhet","global.newsletterSubscriptionSentence":"Prenumerera på vårt nyhetsbrev","global.newsletterSuccessSentence":"Du har lagts till i nyhetsbrevets adresslista framgångsrikt.","global.nicknameTitle":"Namn","global.noProductsFoundSentence":"Inga produkter hittade.","global.noTitle":"Nej","global.notFoundTitle":"Hittades inte","global.notifyUserLabel":"Skicka automatiskt användarnamn till e-post.","global.ok":"OK","global.onSaleTitle":"På rea!","global.orderDate":"Orderdatum","global.orderInfoHeader":"Beställningsinformation","global.orderListingWeb":"Webbutikorder","global.orderNumber":"Ordernummer","global.ourBrandsTitle":"Våra varumärken","global.passwordTitle":"Lösenord","global.paymentMethod":"Betalningsmetod","global.paymentTokensNewTitle":"Lägg till nytt betalkort","global.paymentTokensTitle":"Betalkort","global.pickupPointTitle":"Hämtpunkt","global.popularSearchesTitle":"Populära sökningar","global.priceFrom":"från","global.priceTitle":"Pris","global.privacyStatementAcceptSentence":"Jag godkänner behandlingen av mina personuppgifter enligt vår integritetspolicy","global.privacyStatementMustApproveSentence":"Godkännande av integritetsförklaring krävs.","global.proceedToCartSentence":"Kundvagn","global.proceedToCheckoutSentence":"Fortsätt till kassan","global.productAddedToCartSentence":"{quantity, plural, one {# produkt} other {# produkter}} tillagd i varukorgen","global.productBundleAddedToCartSentence":"Produkterna tillagda i varukorgen","global.productBundlesTitle":"Produktbuntar","global.productCount":"{count, plural, one {# produkt} other {# produkter}}","global.productEnquiryProposalTitle":"Fråga efter anbud","global.productEnquiryTitle":"Fråga om produkten","global.productOffer":"Produkterbjudande","global.productTitle":"Produkt","global.productsTitle":"Produkter","global.propertyChooseTitle":"Välj {property}","global.purchaseOrderCountHeader":"Orderantal","global.purchaseUserHeader":"Användare","global.purchaseWithVatHeader":"Inklusive moms","global.purchaseWithoutVatHeader":"Utan moms","global.purchasesListTitle":"Användarköp","global.quantityDecrementTitle":"Minska kvantiteten","global.quantityIncrementTitle":"Öka kvantiteten","global.quantityTitle":"Mängd","global.readAboutRecurring":"Prenumeration är en återkommande och automatiskt skickad beställning. Du kan bestämma produkterna och hur ofta du behöver en leverans. Läs mer om prenumerationer.","global.readMoreSentence":"Läs mer","global.recommendedProductsTitle":"Rekommenderade produkter","global.recurringOrdersTitle":"Stående beställning","global.regionalSettingsTitle":"Regionala inställningar","global.registerTitle":"Registrera","global.relatedProductsTitle":"Alternativa produkter","global.removeTitle":"Ta bort","global.retailerTitle":"Återförsäljare","global.reviewCount":"{count, plural, one {# recension} other {# recensioner}}","global.reviewCountCompact":"({count})","global.reviewProductRatingTitle":"Produkt","global.reviewServiceRatingTitle":"Service och leverans","global.reviewTitle":"Recension","global.reviewsTitle":"Recensioner","global.saveTitle":"Spara","global.search":"Sök","global.searchHistoryTitle":"Senaste sökningar","global.searchNoResults":"Inga resultat funna","global.searchResultsForTermTitle":"Resultat för söktermen \"{term}\"","global.searchResultsForTitle":"Sökresultat för {term}","global.searchResultsTitle":"Sökresultat","global.searchTryAnotherSentence":"Prova en annan sökning","global.seeCategoriesNavi":"Se i produktgrupper och informationssidor","global.selectTitle":"Välj","global.selectedTitle":"Vald","global.selectedTitleWithValue":"Vald: {value}","global.sendTitle":"Skicka","global.shipping":"Frakt","global.shippingAddressTitle":"Leveransadress","global.shippingCostsTitle":"Leverans","global.shippingMethod":"Leveransmetod","global.shoppingCenterAcceptableTerms":"Genom att klicka på \"{continuePurchase}\" bekräftar jag att jag har läst {storeName} {termsOfUse} och {privacyStatement}, och säljarens {merchantName} {deliveryAndPaymentTerms} och {merchantPrivacyStatement}","global.shoppingCenterProductMerchantDeliveryAndPaymentTerms":"leverans- och betalningsvillkor","global.shoppingCenterProductMerchantPrivacy":"integritetspolicy","global.showAllProductsSentence":"Visa alla produkter","global.showLessText":"Visa mindre","global.showMoreText":"Visa mer","global.sizeGuideSentence":"Storleksguide","global.soldProductsTitle":"Sålda Produkter","global.startDateTitle":"Start datum","global.statusTitle":"Status","global.stockTemporarilyOutOfSentence":"Produkten är tillfälligt slut","global.streetAddressTitle":"Gatuadress","global.submitSurvey":"Skicka","global.suggestionsTitle":"Förslag","global.sumWithVat":"inklusive moms","global.sumWithoutVat":"Totalt utan moms","global.surveySubmitError":"Det gick inte att skicka enkäten. Var god försök igen.","global.taxExcluded":"(moms exkl.)","global.taxIncluded":"(moms inkl.)","global.telephoneTitle":"Telefon","global.termFilterPlaceholder":"Sök","global.toOrder":"Se info","global.totalPriceSentence":"Totalt","global.unitPriceTitle":"Enhetspris","global.update":"Uppdatera","global.uploadFileTitle":"Ladda upp fil","global.userListTitle":"Användare för konto","global.validUntilFurtherNotice":"Gäller tills vidare.","global.validationMessageInvalidFloor":"Kvantiteten måste delas med förpackningens produktantal {size}.","global.validationMessageInvalidQuantity":"Kvantiteten måste vara mellan {min} och {max}.","global.vehiclePartSearchTitle":"Sök efter fordonsreservdelar","global.warrantyLabel":"Garanti: {warranty}","global.weRecommendTitle":"Vi rekommenderar","global.weightTitle":"Vikt","global.wishListPageTitle":"Önskelista","global.writeNewReview":"Skriv en recension","global.yesTitle":"Ja","global.youSaveSentence":"Du sparar {savings}","global.yourEmail":"Din e-post","global.yourReferenceTitle":"Referens","global.zipCodeTitle":"Postnummer","image.lightboxHelper":"Klicka på bilden för att förstora","klarnaInstantShopping.emptyInstantShoppingCart":"Du har inte valt några produkter.","klarnaInstantShopping.orderProductsInfo":"Beställ dessa produkter eller lägg till andra variationer.","klarnaInstantShopping.selectProduct":"Välj produkten","klarnaInstantShoppingForm.addressAcknowledgement":"Angiven adress måste motsvara leveransadressen som anges i nästa steg","klarnaInstantShoppingForm.fillPickupPointInformation":"Skriv din adress","klarnaInstantShoppingModal.choosePickupPoint":"Välj leveransplats:","klarnaInstantShoppingModal.chooseShippingMethod":"Välj leveransmetod:","klarnaInstantShoppingModal.creatingOrder":"Vänta lite...","klarnaInstantShoppingModal.distance":"Distans: {distance} {distanceUnit}","klarnaInstantShoppingModal.fetchingPickupPoints":"Hämtar leveransplatser...","klarnaInstantShoppingModal.fetchingShippingOptions":"Hämtar frakt alternativ...","klarnaInstantShoppingModal.noPickupPoints":"Tyvärr hittades inga upphämtningsställen. Kontrollera att adressen är korrekt eller välj en annan leveransmetod.","klarnaInstantShoppingModal.openingHours":"Öppettider: {openingHours}","klarnaInstantShoppingModal.orderProductsButton":"Fortsätt beställa","klarnaInstantShoppingModal.shippingAndPickup":"{storeName} - ordning","klarnaInstantShoppingModal.updatingOrder":"Uppdaterar ordningen...","localization.doNotRedirect":"Stanna på nuvarande","localization.isSuggestedSite":"Vi rekommenderar att du använder denna webbutik.","localization.moveToSite":"Gå till webbutiken","localization.noShipping":"Vänligen kolla in våra tillgängliga onlinebutiker eftersom vi tyvärr inte levererar till det upptäckta landet.","localization.noSuggestion":"Vi känner inte igen var du är. Kolla in våra tillgängliga onlinebutiker.","localization.shippingPossible":"Frakt är möjlig till ditt land.","localization.yourLocation":"Vi upptäckte att du är i {country}","manufacturer.browserManufacturerProducts":"Bläddra bland märkesprodukter","manufacturer.chooseManufacturerPlaceholder":"Välj märke ...","manufacturer.seeAllBrands":"Se alla märken","myAccount.balanceUserAccountStatusActive":"Aktiv","myAccount.balanceUserAccountStatusNotActive":"Inaktiv","myAccount.balanceUserAccountUpdatePassword":"Frivillig. Ändra bara om du vill ändra ditt lösenord.","myAccount.basicInfo":"Grundläggande information om kontot","myAccount.billingAddressTitle":"Fakturaadress","myAccount.billingMethodTitle":"Faktureringsmetod","myAccount.buyBalanceInfoText":"Välj det belopp du vill ha för de användare du vill överföra pengar till och vänta ett ögonblick.","myAccount.cancelOrder":"Avbryt beställning","myAccount.companyLabel":"Bolag: {company}","myAccount.customerIdLabel":"Kundnummer: {customerId}","myAccount.emailLabel":"E-post: {email}","myAccount.groupNameLabel":"Kundgrupp: {group}","myAccount.klarnaCheckoutPaymentInfo":"Ange betalningsinformation","myAccount.loginInfo":"Genom att logga in kan du se din orderhistorik och ändra din personliga information.","myAccount.nameLabel":"Namn: {name}","myAccount.orderDate":"Beställt på: {orderDate}","myAccount.orderHistory":"Se allt","myAccount.orderHistoryTitle":"Frakthistorik","myAccount.orderTitle":"Beställning {orderId}","myAccount.packageTitle":"Paket {parcelCount}:","myAccount.packageToTracking":"{trackingCode} (Gå till spårning)","myAccount.paymentDetailsTitle":"Betalningsinformation","myAccount.pinExpires":"PIN-koden löper ut kl {expires}. Tiden är nu {nowTime}","myAccount.previousOrders":"Senaste beställningar","myAccount.printReceiptSentence":"Skriv ut ett kvitto på denna beställning","myAccount.shippingAddressTitle":"Leveransadress","myAccount.shippingDetailsTitle":"Frakt detaljer","myAccount.shippingMethodTitle":"Frakt metod","myAccount.telephoneLabel":"Telefon: {telephone}","myAccount.trackingDescription":"(Om spårningssidan meddelar dig att inga beställningar hittades kan det hända att paketet ännu inte har mottagits hos leveransföretaget)","myAccount.trackingTitle":"Spårning av orderpaket","myAccount.updateAddress":"Uppdatera adress","myAccount.updateUser":"Uppdatera användare","navigation.backToBegin":"Tillbaka till början","navigation.backToItem":"Tillbaka till {name}","navigation.goBackLink":"Tillbaka till sökresultaten","navigation.navigateToCategoryItem":"Se alla produkter här","navigation.navigateToInfoItem":"Se sidinnehåll här","navigation.navigateToSectionItem":"Alla produkter","navigation.shopAllCategory":"Allt inom {category}","navigation.shopAllSection":"Allt inom {section}","newsletter.isFree":"Nyhetsbrevet är gratis","newsletter.popdownTitleWithoutDiscount":"Prenumerera på vårt nyhetsbrev!","newsletter.status.EMAIL_EXISTS":"E-postadressen du angav finns redan i vår e-postlista.","newsletter.status.SUCCESS":"Du har lagts till i vår e-postlista. Tack för att du prenumererar!","newsletter.status.VALIDATION_ERROR":"Informationen du angav är inte giltig. Kontrollera formuläret igen.","newsletter.subscribe":"Prenumerera","newsletter.subscribeCompact":"Prenumerera","newsletter.subscriberAgreesTo":"Genom att prenumerera samtycker du till vår","order.dateHeader":"Orderdatum","order.dateTitle":"Datum","order.deliveredQuantityTitle":"Levererad antal","order.orderNotFound":"Den angivna koden hittas inte","order.orderNotFoundSentence":"Beställningen hittades inte","order.productAddFailedSentence":"Produkten kan inte läggas till för beställning","order.productAddedSentence":"Produkt läggs till beställning","order.productNameTitle":"Namn","order.statusDescriptionTitle":"Beskrivning","order.sumHeader":"Totalt","order.totalShortTitle":"Totalt","order.trackingHeader":"Status","orderStatus.active":"Aktiva","orderStatus.canceled":"Avbruten","orderStatus.deactivated":"Inaktiverad","orderStatus.onHold":"På rast","orderStatus.pending":"Väntar","orderStatus.processing":"Bearbetning","orderStatus.ready":"Färdig","payment.addedAtSentence":"Tillagd på {createdAt}","payment.expiredSentence":"Utgånget","payment.validSentence":"Giltig","privacyStatement.readLinkSentence":"vår integritetspolicy","privacyStatement.subscriberAgreesLink":"Integritetspolicy","product.AddWishListTitle":"Lägg till i önskelistan","product.ProductAddedToWishlist":"Lagt till i önskelistan. Du kan se önskelistan {link}.","product.ProductAddedToWishlist_here":"här","product.RRP":"RRP","product.allProductsFromCategory":"Alla {categoryLink}","product.allProductsFromManufacturer":"Alla {manufacturerLink} produkter","product.alsoPurchasedProducts":"Kunder som köpte den här artikeln köpte också","product.cartMatrixProductInformation":"Välj de produkter som ska beställas från tabellen nedan.","product.checkingShippingValidity":"Produktens giltighet för varukorgen.","product.compatibleVehicleParts":"Kompatibel","product.currentProductSoldOut":"Den valda produkten är slutsåld.","product.dateAvailable":"Produkten är tillgänglig {date}","product.deposit":"Produktpris kommer att inkluderas deposition på {deposit}","product.depositIncluded":"Inkluderar insättning på {deposit}","product.descriptionDetails":"Detaljer","product.descriptionTitle":"Beskrivning","product.downloadFile":"Ladda ner","product.enquirySuccess":"Ditt meddelande skickades till vår kundtjänst. Vi strävar efter att hantera meddelandet så snart som möjligt.","product.fileUploadDeleteFile":"Radera fil {file}","product.fileUploadExistingFilesHeader":"För närvarande uppladdade filer","product.fileUploadExplanationSentence":"Ladda upp dina filer för den här produkten här","product.fileUploadLoading":"Laddar fillista ...","product.fileUploadTooManyFileUploadsError":"Du har nått det maximala antalet uppladdade filer.","product.fileUploadWorking":"Uppladdning ...","product.hasBeenSoldOut":"Denna produkt är slutsåld.","product.idLabel":"Produktkod: {id}","product.incomingQuantity":"Inkommande: {freeQuantity} {stockUnit} {date}","product.incomingQuantityNoQuantities":"Inkommande: {date}","product.inventoryQuantity":"I lager: {inventoryQuantity} {stockUnit}","product.lastVisitedProducts":"Senast besökta produkter","product.manufacturerLogoAlt":"{manufacturer} logo","product.manufacturersContentTitle":"Tillverkarens innehåll","product.minOrderQuantityError":"Den minsta kvantiteten av produkten är {minOrderQuantity} {stockUnit}","product.noDateAvailable":"(inget datum tillgängligt)","product.notAvailable":"(Inte tillgänglig)","product.nowOnly":"Nu bara","product.offer":"Erbjudande!","product.onlyInStore":"Den här produkten kan inte köpas från nätbutiken. Vänligen kontakta försäljning","product.onlyInStoreLink":"Se kontaktinformation","product.packageSizeDescription":"{packageSizeSentence}: 1 {packageUnitName} = {packageSize} {stockUnit} ({packagePrice} / {packageUnitName})","product.packageSizeSentence":"Paketstorlek","product.productMatrixInfo":"Välj de produkter som ska beställas genom att ange kvantiteterna i fältet \"Antal\" i tabellen. Du kan flytta mellan celler med hjälp av fliken.","product.productsHasBeenOrdered":"(Produkter har beställts)","product.propertyColourVariants":"{count} färger tillgängliga","product.quantityInput":"Antal","product.salesBeginAt":"Rea börjar {date}","product.seasonEndedOn":"Produktens rea slutade {endDate}.","product.seasonIs":"Produktens rea försäljningsperiod är {startDate} - {endDate}.","product.seasonStartsOn":"Produktens rea försäljning börjar den {startDate}.","product.selectProductFirst":"Välj först produkten.","product.shoppingCenterAcceptableTerms":"Säljarens {merchantName} {deliveryAndPaymentTerms} och {merchantPrivacyStatement}","product.showAllOfType":"Visa alla {type}","product.showAllOfType.CAMPAIGN_PRODUCTS":"Produkter på rea","product.showAllOfType.FALLBACK":"produkter","product.showAllOfType.MOST_SOLD_PRODUCTS":"populära produkter","product.showAllOfType.NEW_PRODUCTS":"Nya produkter","product.showAllOfType.RECOMMENDED_PRODUCTS":"rekommenderade produkter","product.sold":"Såld","product.spareParts":"Reservdelar","product.superOffer":"Supererbjudande","product.topDiscount":"Top rabatt","product.vehiclePartAlternatives":"Alternativa","product.watcherButton":"Informera mig när produkten finns i lager","product.watcherHeading":"Jag vill få ett meddelande när den här produkten är tillgänglig","product.watcherInfo":"Ange din e-postadress så skickar vi ett meddelande när produkten finns i lager igen. Efter detta kommer din e-post att tas bort från vår lista.","product.weightLabel":"Vikt: {weight}","productBundle.addToCartButton":"Lägg till bunt i kundvagnen","productBundle.createYourOwn":"Pakka \"{produktnamn} \" med ytterligare produkter och spara","productBundle.noSelectedProducts":"Inga ytterligare produkter valda","productBundle.price":"Paketpris","productBundle.selectedProducts":"Du har valt {count, plural, one {# en ytterligare produkt} other {# ytterligare produkter}}","productBundle.youSave":"Du sparar","productCollectionMatrix.addSelectedProducts":"Lägg till valda produkter","productListFilter.filter":"Filtrera","productListFilter.filterList":"Filtrera efter nyckelord","productPageContent.productNotValidForCart":"Denna produkt har inga gemensamt fraktsätt med produkterna i varukorgen. Till exempel avhämtning från olika lager","productPageContent.productPurchaseGuideTitle":"Hur beställer man?","productPageContent.shoppingCenterBuyProductsInfo":"Om du köper flera olika produkter samtidigt kan du också gå till handlarens onlinebutik. Du hittar också hela utbudet av återförsäljaren där","productPageContent.shoppingCenterBuyingNotAllowed":"Denna produkt har begränsningar för inköp. Vänligen kolla handlarens onlinebutik för mer information.","productPageContent.shoppingCenterProductMerchantLink":"Gå till handelsbutiken","productPageContent.shoppingCenterSiteName":"Du köper från en återförsäljare {siteName}","recurringOrder.addToCart":"Lägg till prenumeration i varukorgen","recurringOrder.addToOrder":"Lägg till produkt till prenumerationen","recurringOrder.allowShippingChangeSentence":"Tillåt automatisk ändring av fraktmetod när nuvarande metod inte är möjlig. (Kan ändra fraktkostnaderna)","recurringOrder.allowShippingChangeValue":"Tillåt automatisk ändring av fraktmetod när nuvarande metod inte är möjlig: {allowUnder}","recurringOrder.allowUnderDeliveryValue":"Tillåt delleverans om alla produkter inte är tillgängliga: {allowUnder}","recurringOrder.changeQuantity":"Ändra produktkvantitet","recurringOrder.cycleBiMonthly":"Varannan monad","recurringOrder.cycleBiWeekly":"Varannan vecka","recurringOrder.cycleCustom":"Välj ditt intervall","recurringOrder.cycleMonthly":"Varje månad","recurringOrder.cyclePlaceholder":"Välj din cykel","recurringOrder.cycleQuarterly":"Var tredje månad","recurringOrder.cycleWeekly":"Varje vecka","recurringOrder.days":"dagar","recurringOrder.deliveryAddressSentence":"Leveransadress","recurringOrder.onHoldPlaceholder":"Välj datum från kalendern","recurringOrder.onHoldSentence":"Pausad till: {untilDate}","recurringOrder.onHoldTitle":"Ställ in prenumerationen på is tills (Använd rullgardinsmenyn eller kalenderikonen)","recurringOrder.onlyForLoggedIn":"Prenumerationer är tillgängliga för registrerade användare.","recurringOrder.paymentCardReminder":"Prenumerationer debiteras från ett betalkort. Se till att du har lagt till ett giltigt betalkort. Du kan ha flera betalkort.","recurringOrder.readLinkSentence":"Läs mer om prenumerationer.","recurringOrder.selectCycle":"Välj cykel för ditt abonnemang","recurringOrder.selectDays":"Intervall. (Minst {days} dagar)","recurringOrder.selectOrder":"Välj vilken prenumerationsprodukt som ska läggas till","recurringOrder.shippingMethodSentence":"Leveranssätt för prenumeration","recurringOrder.subscribe":"Prenumerera","recurringOrder.subscriptionButton":"Spara pengar genom att prenumerera","recurringOrder.subscriptionPlaceholder":"Välj ditt abonnemang","recurringOrder.titleSentence":"Ge en beskrivande titel","reserveInStore.availableServicesForStorage":"Följande tjänster är tillgängliga i den butik du valt:","reserveInStore.availableStoragesHint":"Följande butiker har den valda mängden av denna artikel i lager.","reserveInStore.button":"Boka produkten","reserveInStore.cancellationInfo":"Du kan avboka din bokning genom att ringa butiken.","reserveInStore.confirmReservation":"Boka nu","reserveInStore.howItWorks":"Boka produkten nu och hämta den från butiken senare! Bokningen är giltig i {expiryHours} timmar, varefter den tas bort. Observera att rabattkuponger inte kan användas med bokningar i butiken","reserveInStore.outOfStockMultipleStoresHint":"Inga pick-up-butiker har för närvarande den här produkten på lager.","reserveInStore.outOfStockSingleStoreHint":"Den här butiken har för närvarande inte denna produkt i lager.","reserveInStore.reservationConfirmationTitle":"Bokning ID #{reservationID}","reserveInStore.reservationSuccessfulMessage":"Tack för din bokning! Ett bekräftelsemeddelande har skickats till e-postadressen {email}.","reserveInStore.reservationTitle":"Boka i butik","reserveInStore.selectChildProductHint":"Välj först produkten. Efter detta kan du reservera den här produkten från en butik.","reserveInStore.selectStorageButton":"Välj den här butiken","reserveInStore.selectedServicesSentence":"Med följande utvalda tjänster:","reserveInStore.showAllStoragesButton":"Visa alla butiker","reserveInStore.stockLoadingHint":"Vänta, laddning i butikens tillgänglighet ...","reserveInStore.storageFilterPlaceholder":"Postnummer eller stad","reserveInStore.unselectStorageButton":"Välj en annan butik","review.emailAddressForApprovalHint":"Vi meddelar dig via den här adressen efter att din granskning har godkänts. Vi tar bort e-postadressen från vårt register direkt efter.","review.emailAddressForCouponHint":"Kuponginformationen skickas till denna adress. Vi tar bort e-postadressen från vårt register efter att kupongen har skickats.","review.haveYouBoughtSentence":"Recensera produkten","review.interactiveStarsLabel":"{count, plural, one {# stjärna} other {# stjärnor}} av 5","review.nicknameFieldHint":"Ett namn du väljer som vi visar bredvid din recension.","review.reviewCouponTitle":"Recensera denna produkt för en rabattkupong!","review.reviewHint":"Genom att skicka din recension, samtycker du till att ge oss tillstånd att publicera den på denna webbplats samt på andra webbplatser och media. {storeName} förbehåller sig rätten att inte publicera recensionen. Genom att skicka samtycker du till dessa villkor.","review.sendTitle":"Skicka recension","review.showAllTitle":"Visa alla recensioner ({count})","review.showDefaultTitle":"Visa standardantalet för recensioner","review.staffReplySentence":"{name} svarar:","review.success":"Din produkt recension har lagts till!","review.successPending":"Vi har fått din recension. Vi kontrollerar alla recensioner och du får ett meddelande när din publiceras","review.typeReviewHereSentence":"Skriv din recension här","search.search":"Sök","search.searchProducts":"Sök artiklar och varumärken","search.termTooShort":"Söktermen är för kort.","shipping.allCostsTitle":"Leverans","shipping.availableServicesSentence":"Valfria tjänster:","shipping.campaignHeader":"{name}","shipping.fixedPriceSentence":"Sänkt pris","shipping.freeShippingSentence":"Gratis frakt {endAt}","shipping.noMethodsAvailable":"Den här produkten har inga tillgängliga leveransmetoder för det valda leveranslandet","shipping.otherMethodsSentence":"Normala priser","shipping.totalQuantitySentence":"Fri frakt för beställningar med minst {amount} produkter{endAt}","shipping.totalSumSentence":"Fri frakt för beställningar över {amount}{endAt}","shipping.totalVolumeSentence":"Fri frakt för ordervolymen över {amount} m3{endAt}","shipping.totalWeightSentence":"Fri frakt för beställningar totalvikt över {amount}{endAt}","shoppingCenterProductMerchantInfo.sellerTitle":"Säljare","site.reloadPage":"Ladda om sidan","sort.alphabetical":"Alfabetisk","sort.bestRated":"Bäst rankad","sort.brand":"Märke","sort.category":"Produktkategori","sort.cheapest":"Lägst pris","sort.default":"Standard","sort.discount":"Bästa rabatten","sort.id":"Produktnummer","sort.latest":"Senaste","sort.mostExpensive":"Högst pris","sort.mostPopular":"Populära","sort.sortLabel":"Sortera:","state.networkError":"Anslutningsfel. Se till att du är ansluten till Internet.","state.unexpectedError":"Ett oväntat fel inträffade. Försök att ladda om sidan. Om felet kvarstår försök igen senare.","stock.addressHeading":"Adress","stock.availabilityHeading":"Tillgänglighet","stock.availableInStores":"Kontrollera tillgänglighet i butiken här","stock.contactHeading":"Kontaktinformation och öppettider","stock.filterByStorage":"Filtrera efter lagring","stock.loadingStoreAvailability":"Laddar butikens tillgänglighet ..","stock.mapLink":"Karta och vägvisning","stock.notAvailable":"Inte tillgänglig","stock.shelfLocation":"Hyllplats","stock.soldOut":"Utsåld","stock.storeAvailability":"Lagerstatus","stock.storeAvailabilityTitle":"Produkttillgänglighet i butiker","stock.storeHeading":"Butik","stock.storeOutOfStock":"Ej i lager i butik","stock.storesOutOfStock":"Ej i butikslager","stock.temporarilyOutOfStock":"Tillfälligt slut","survey.selectOption":"-- Välj alternativ","termsOfUseStatement.termsOfUse":"{termsOfUse}","termsOfUseStatement.termsOfUseLink":"användarvillkor","tokens.createFailSentence":"Det gick inte att lägga till betalkortet.","tokens.createSuccessSentence":"Kortet har lagts till.","userInfo.active":"Användarnamn är aktivt","userInfo.notInUse":"Användarnamn är inte aktivt","validation.additionalService.TEXT_REQUIRED":"Ytterligare service kräver textinmatning","validation.additionalService.TEXT_TOO_LONG":"För många tecken","validation.finnishBusinessId":"Kontrollera FO-nummer-formatet.","validation.isDate":"{field} format är inte tillåtet.","validation.isEmail":"{field} Måste vara en giltig e-postadress.","validation.maxLength":"{field} får inte ha mer än {maxLength} -tecken.","validation.minLength":"{field} måste ha minst {minLength} -tecken.","validation.mustMatch":"Fältet matchar inte.","validation.numberBetween":"{field} måste vara ett nummer mellan {min} och {max}","validation.required":"{field} kan inte vara tom.","vehicle.brand":"Bilmärke","vehicle.model":"Modell","vehicle.motor":"Motor","vehicle.years":"Årsmodell","vehiclePartSearch.clearVehicle":"Rensa fordonsinformation","vehiclePartSearch.helpText":"Skriv in ditt reg nr.","vehiclePartSearch.noSearchResults":"Inga matchande produkter.","vehiclePartSearch.notFound":"Fordonet hittades inte.","vehiclePartSearch.selectModel":"Välj mer exakt modell","vehiclePartSearch.severalCarsFound":"Flera modeller hittades med registreringsskylten","wishlist.AmountAndInTotal":"Belopp / totalt","wishlist.DeleteProduct":"Radera","wishlist.EmailMessage":"Meddelande","wishlist.EmailTitle":"Titel","wishlist.InvalidForm":"Formuläret är ogiltigt. Kontrollera ditt formulär.","wishlist.NotLoggedInBanner":"Du måste {login_link} eller {register_link} för att skicka önskelistan som e-post eller spara den permanent.","wishlist.NotLoggedInBanner_Registration_Enabled":"Du måste {login_link} eller {register_link} för att skicka önskelistan som e-post eller spara den permanent.","wishlist.Product":"Produkt","wishlist.ProductListEmailInformation":"Du kan lägga till produkter i listan och bestämma senare om du beställer produkterna. Du kan också skicka listan till det e-postmeddelande du vill ha.","wishlist.SendList":"Skicka lista","wishlist.UnitPrice":"Pris per enhet","wishlist.ValidForm":"E-postmeddelandet har skickats.","wishlist.login":"logga in","wishlist.register":"registrera dig","wishlist.wishlistIsEmpty":"Det finns inga produkter i din önskelista.","wishlist.wishlistNotFound":"Önskelista hittades inte med det angivna id."}

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports = {"account.clientSearchButton":"Search for clients","account.clientSearchPlaceholder":"New search with Enter or search button","account.doYouWantToRegister":"Вы хотите стать зарегистрированным клиентом?","account.forgotPasswordInstructions":"Если вы забыли свой пароль, пожалуйста, введите адрес электронной почты вашей учетной записи клиента ниже, чтобы сбросить пароль.","account.forgotPasswordLink":"Забыли пароль? Нажмите здесь.","account.forgotYourPassword":"Забыли пароль?","account.loginInformationHint":"Создайте имя пользователя (вы можете использовать, например, свой адрес электронной почты) и пароль для вашей учетной записи.","account.loginStatus.ACCOUNT_DISABLED":"Эта учетная запись пользователя была отключена.","account.loginStatus.SHOP_LOGIN_DISABLED":"Вход в систему в настоящее время запрещен.","account.loginStatus.SUCCESS":"Вошел в систему.","account.loginStatus.USERNAME_OR_PASSWORD_WRONG":"Неверное имя пользователя или пароль!","account.loginStatus.USER_ALREADY_LOGGED_IN":"Вы уже вошли в систему!","account.password.PASSWORDS_DO_NOT_MATCH":"Текст подтверждения пароля должен совпадать с выбранным вами паролем.","account.password.PASSWORD_NOT_VALID":"Ваш пароль не совпадает с паролем в нашей базе данных. Пожалуйста, попробуйте еще раз.","account.password.SUCCESS":"Ваш пароль был успешно обновлен.","account.password.VALIDATION_ERROR":"Предоставленная вами информация недействительна. Пожалуйста, перепроверьте форму.","account.registrationBenefitsFasterCheckoutItem":"Easy and quick checkout - your personal details will be filled in automatically.","account.registrationBenefitsHeader":"Registration benefits","account.registrationBenefitsNewsletterItem":"Newsletter - you'll be informed of special offers and campaigns available through our store.","account.registrationBenefitsOrderHistoryItem":"Order history - you'll be able to see the orders you've previously done through our store.","account.registrationBenefitsPersistentCartItem":"Persistent cart - the items you add to your cart will stay there until you remove them or confirm the order.","account.registrationBenefitsWishlistItem":"You'll be able to create a wishlist you can then share with your friends.","account.resetPassword":"Сброс пароля","account.resetPasswordSuccessful":"На указанный адрес успешно отправлено письмо о сбросе пароля. Не забудьте также проверить папку спама или убедиться в правильности адреса электронной почты, если сообщение, похоже, не пришло.","account.setNewPassword":"Установите новый пароль","account.setNewPasswordSuccessful":"Ваш пароль был успешно изменен. Теперь вы можете войти в систему.","account.setNewPasswordTitle":"Выберите новый пароль","account.userInfo.EMAIL_NOT_VALID":"Your e-mail address seems to have an incorrect format.","account.userInfo.FIRSTNAME_NOT_VALID":"The first name must contain at least {characterCount} characters.","account.userInfo.LASTNAME_NOT_VALID":"The last name must contain at least {characterCount} characters.","account.userInfo.SUCCESS":"Your customer account information was updated successfully.","account.userInfo.TELEPHONE_NOT_VALID":"The phone number must contain at least {characterCount} characters.","account.userInfo.VALIDATION_ERROR":"The information you entered is not valid. Please check the form.","addToCart.selectProductVariant":"Пожалуйста, выберите вариант продукта","addToCartPostalCodeValidation.checkPostalCodeInfo":"Search the availabilities of the services with your postal code","addToCartPostalCodeValidation.postalCodePlaceholder":"Enter your postal code","additionalService.availableServices":"Check available services here","additionalService.information":"You can select additional services, when the product is being added to the cart.","additionalService.optionPriceSentence":"The price for this option is {price}","additionalService.postalCodeIsInvalid":"Postal code is invalid for this service","additionalService.postalCodeRequired":"Eligible postal code is required for the service","additionalService.selectService":"Select service","additionalService.typeTextHereLengthSentence":"Type your text here. Maximum of {maxLength} characters.","additionalService.typeTextHereSentence":"Type your text here.","address.addressFilterPlaceholder":"Search for addresses","address.primaryNotice":"This address is used as your default delivery and billing address in your orders.","address.setAsPrimary":"Set as a primary address","address.showAllAddressesButton":"Show all addresses","balanceUser.pinCodeHeader":"PIN code","campaign.activateCode":"Активировать","campaign.activationInProgress":"Код активации...","campaign.categoryLimitation":"Используя этот купон на скидку, вы получите скидку на товары, принадлежащие к следующим категориям товаров:","campaign.categoryNotFound":"Данная категория {category} не найден","campaign.haveYouReceived":"Вы получили код кампании или скидки?","campaign.isActivated":"Код кампании активирован!","campaign.manufacturerLimitation":"Используя этот скидочный купон, вы получите скидку на продукцию следующих брендов:","campaign.manufacturerMultiLimitation":"Разрешено для ограниченных производителей","campaign.productLimitation":"Используя этот скидочный купон, вы получите скидку на следующие продукты:","campaign.removalInProgress":"Удаление кода...","campaign.removeCouponCode":"Удалить код","campaign.setError":"Введенный код кампании не найден.","campaign.setSuccess":"Код кампании был успешно активирован!","cart.beingUpdated":"Корзина обновляется","cart.cartContents":"Содержимое корзины","cart.continueShopping":"Назад","cart.couponInstructions":"Купоны на скидку могут быть предоставлены на странице оформления заказа.","cart.itemsInCart":"{itemCount} в корзине.","cart.loadingCartContents":"Загрузка содержимого корзины","cart.productsTotalLabel":"Всего продуктов:","cart.productsTotalWithExtraLabel":"Итого","cart.selectShoppingCart":"Выберите корзину","checkout.backToStore":"Вернуться в магазин","checkout.buyBalanceSentence":"Buy balance","checkout.cancelPayment":"Cancel","checkout.orderCompleted":"Ваш заказ был получен.","checkout.orderConfirmationThankYou":"Спасибо за ваш заказ!","checkout.orderInformationTitle":"Запросить информацию","checkout.paymentInformation":"Электронное письмо с подтверждением также было отправлено на адрес электронной почты {email}. Убедитесь, что адрес электронной почты указан правильно.","checkout.paymentInformation2":"Если вы не видите сообщение, не забудьте также проверить папку со спамом.","checkout.shoppingCenterMerchantInfo":"merchant's {merchant}","checkout.successfulPurchaseBreadcrumbName":"Благодарю вас","checkout.successfulPurchaseLicensedProductsSentence":"Для некоторых продуктов в вашем заказе требуется лицензия. Вы можете оплатить свой заказ сейчас; после этого вы должны отправить нам соответствующие лицензии по электронной почте. Пожалуйста, обратитесь к странице условий доставки для более подробной информации.","checkout.successfulPurchasePageHeading":"Подтверждение заказа","checkout.successfulPurchasePageTitle":"Ваш заказ зарегистрирован!","checkout.successfulPurchaseReceipt":"Чек","checkout.successfulTransferPageHeading":"Money transfer confirmation","checkout.trackOrder":"Вы можете отслеживать свой заказ, нажав {link}, вы также можете добраться до {merchantInfo} страницу отслеживания заказа из электронного письма с подтверждением.","contactUs.success":"Your message was sent to our customer service successfully. We aim to handle the message as soon as possible.","cookieNotice.content":"Чтобы как можно лучше обслуживать наших клиентов, мы используем файлы cookie на нашем сайте. Продолжая, вы соглашаетесь использовать файлы cookie.","cookieNotice.readMore":"Подробнее о файлах cookie","coupon.emailError":"The information could not be sent to your email. Please contact our customer service using the contact form.","coupon.emailSubscribeNotice":"By giving us your email address you subscribe to our newsletter.","coupon.emailSuccess":"The discount coupon information has been sent to your email.","coupon.fetchDiscountCode":"Fetch discount code","coupon.setError":"The campaign code could not be activated. Please contact our customer service using the contact form.","coupon.setSuccess":"The campaign code was activated successfully!","coupon.showInformation":"Show coupon information","coupon.useLater":"I want to use my code later","coupon.useNow":"I want to activate my code now","creditAccount.accountStatusTitle":"Credit account status","creditAccount.balanceTitle":"Balance","creditAccount.creditUsedTitle":"Credit used","creditAccount.limitTitle":"Credit limit","customerService.isOpen":"Служба поддержки клиентов открыта пн - пт {timespan}","customerUser.fetchPurchases":"Fetch purchases","discount.quantityDescription":"Order more and save money!","discount.sale":"Распродажа","discount.upTo":"Вплоть до","error.notFoundBackToHome":"Вернуться на главную страницу","error.notFoundGoToSearch":"или воспользуйтесь поиском по товару.","error.notFoundHeader":"К сожалению, запрошенная вами страница больше не может быть найдена.","error.notFoundHelpText":"Если он все еще существует, возможно, его адрес изменился. Вы можете продолжить просмотр интернет-магазина или попытаться найти то, что искали, используя функцию поиска.","error.notFoundTitle":"Страница не найдена","errorModal.content":"Что-то пошло не так. Проверьте предоставленную информацию и повторите попытку.","errorModal.title":"Произошла непредвиденная ошибка","filter.removeAllFiltersButton":"Очистить фильтры","filter.removeFilterButtonLabel":"Удалить фильтр","filter.showMore":"Показать больше фильтров","footer.backToTop":"Наверх","footer.backToTopShort":"верхний","footer.cartExpirationExpired":"Reservation for the items in your cart has expired.","footer.cartExpirationPending":"Reservation for the items in your cart expires in","form.noFileSelected":"Файл не выбран","form.selectFileSentence":"Выбрать файл...","global.acceptTitle":"Принимать","global.accountChangeClientSentence":"Log in as a client","global.accountCreateSentence":"Create an account","global.accountLogOutSentence":"Выйти","global.active":"Active subscription","global.addNewAddressTitle":"Add New Address","global.addNewUserTitle":"Add New User","global.addToCartButton":"Добавить в корзину","global.additionalLinksTitle":"Quick links","global.additionalServicesTitle":"Additional Services","global.addressBookTitle":"Адресная книга","global.allowPartialDeliverySentence":"Allow delivery even though not every product is available","global.allowUserCreateAddressLabel":"Allow user to create addresses","global.balanceUser":"Client account","global.balanceUserAccountBalanceInfo":"Balance orders","global.balanceUserAccountInfo":"Client information","global.balanceUserAccountPaymentWidgetError":"Sorry, an error occurred with your payment.Try refreshing the page and try again.If the problem persists, please contact our customer service.","global.balanceUserAccountStatus":"Status","global.balanceUserBalanceValidationError":"Only even numbers are accepted.","global.balanceUserCurrentBalance":"Balance","global.balanceUserNameTitle":"User's Name","global.balanceUserNewBalance":"Add balance","global.balanceUserNoBalancePurchases":"No balance purchases","global.balanceUserPageTitle":"Balance","global.balanceUserPaymentHistoryOrderDate":"Date","global.balanceUserPaymentHistoryOrderNumber":"Order number","global.balanceUserPaymentTotal":"Total","global.brandsTitle":"Бренды","global.businessIdHelp":"If you have forgotten your Business ID, you can find it by clicking {link}","global.businessIdTitle":"Business ID","global.buttonInfo":"You can also reserve and pick up the product from our store","global.campaignBoxTitle":"введите код","global.cancelTitle":"Отмена","global.cartEmptySentence":"Ваша корзина пуста","global.categoriesTitle":"Categories","global.checkTitle":"Search","global.checkedTitle":"Searched","global.checkout":"Checkout","global.chooseTitle":"Choose","global.cityTitle":"City","global.clearTitle":"Clear","global.cloneOrder":"Repeat order","global.closeTitle":"Закрывать","global.companyTitle":"Company","global.confirmAddToCartTitle":"Do you want to add products to the cart?","global.confirmPasswordTitle":"Confirm Password","global.confirmRemoveTitle":"Are you sure?","global.contactPersonFirstNameTitle":"Contact Person First Name","global.contactPersonLastNameTitle":"Contact Person Last Name","global.continue":"Продолжать","global.continueShopping":"Продолжить покупки","global.countryTitle":"Country / area","global.couponDiscountOfferSentence":"Receive a {offer} discount coupon!","global.couponFreeShippingSentence":"Receive free delivery!","global.couponLoginFreeDeliverySentence":"Join as a registered customer now or sign in and you will instantly receive a coupon for free shipping of your purchase.","global.couponLoginOfferSentence":"Join as a registered customer now or sign in and you will instantly receive a {offer} coupon.","global.couponMinimumOrderSentence":"Minimum order {minimumOrder}.","global.couponRegisterFreeDeliverySentence":"Register as our customer now and get a discount coupon. The coupon can be used for free delivery.","global.couponRegisterOfferSentence":"Register as our customer now and get a {offer} discount coupon.","global.couponReviewValueSentence":"Value: {value}","global.couponValidUntilSentence":"Offer valid until {offerExpiry}.","global.creditAccountTitle":"Credit account","global.currencyLabel":"Currency: {currency}","global.currentPasswordTitle":"Current Password","global.customerProductsTitle":"Contract Products","global.dateUpdatedTitle":"Last updated","global.deliveryCountryLabel":"Delivery to: {country}","global.deliveryStartingAbridged":"Shipping starting from","global.deliveryStartingSentence":"Стоимость доставки от {price}","global.discountAmountSentence":"Скидка: {discount}","global.discountPercentageSentence":"Скидка: {discount} %","global.eanLabel":"EAN: {ean}","global.editTitle":"Edit","global.emailOrUsernameTitle":"Имя пользователя или же Эл. адрес","global.emailTitle":"Эл. адрес","global.endDateTitle":"End date","global.errorContent":"Пожалуйста, обновите страницу. Если проблема не исчезнет, дайте описание ошибки","global.errorContentFront":"Пожалуйста, обновите страницу. Если проблема не исчезнет, перейти на главную страницу","global.errorFrontpage":"На главную","global.errorHeader":"Приносим свои извинения - что-то пошло не так","global.errorRefresh":"Обновить страницу","global.errorReport":"Описание ошибки","global.exceptionalAvailability":"(Exceptional availability)","global.extraIdLabel":"Extra ID: {extraId}","global.fileTitle":"File","global.firstNameTitle":"First Name","global.formattedMonths":"{months, plural, one {# month} other {# months}}","global.formattedYears":"{years, plural, one {# year} other {# years}}","global.freeDeliverySentence":"Free delivery","global.freeQuantity":"Free Quantity: {freeQuantity} {stockUnit}","global.fullNameTitle":"Name","global.hasStartingPriceSentence":"Final shipping costs will be calculated in the checkout","global.here":"here","global.homeTitle":"Дом","global.imageLoadFailed":"Image failed to load","global.imageTitle":"image","global.infoCallPhone":"Вызов {phone}","global.infoSendEmail":"Отправить письмо","global.infoTitle":"Информация","global.isActiveLabel":"Active username","global.isCorporateCustomerSentence":"I am a corporate customer","global.itemCount":"{count, plural, one {# товар} other {# товары}}","global.klarnaExpressCheckout":"Klarna. Express Checkout","global.languageLabel":"Язык: {language}","global.lastNameTitle":"Фамилия","global.loading":"Загрузка...","global.logInSentence":"Вход","global.loginInformationTitle":"Login Information","global.lowOrderFeeNoTaxSentence":"Low order fee of {amount} for orders less than {limit}","global.lowOrderFeeSentence":"Low order fee of {amount} ({amountWithoutTax}) for orders less than {limit} ({limitwithoutTax} without VAT)","global.manufacturerCodeLabel":"Manufacturer part number: {manufacturerCode}","global.messageTitle":"Message","global.modifyOrderNotify":"Modifying existing orders may change shipping costs.","global.mostPopularTitle":"Самый популярный","global.myAccount":"Overview","global.myAccountChangePassword":"Change password","global.myAccountInfo":"Personal information","global.myAccountNoOrders":"You have not ordered anything yet.","global.myAccountNoPurchases":"No purchases found.","global.myAccountTitle":"Мой счет","global.myAccountUserTitle":"Мой счет: {user}","global.myCustomerAccountTitle":"My Customer Account","global.myOrderHistoryTitle":"Order History","global.newPasswordTitle":"New Password","global.newProductsTitle":"новые продукты","global.newTitle":"Новый","global.newsletterSubscriptionSentence":"Подписывайтесь на нашу новостную рассылку","global.newsletterSuccessSentence":"Вы успешно добавлены в список рассылки.","global.nicknameTitle":"Псевдоним","global.noProductsFoundSentence":"Товары не найдены.","global.noTitle":"Нет","global.notFoundTitle":"Не найден","global.notifyUserLabel":"Automatically send username to email.","global.ok":"ХОРОШО","global.onSaleTitle":"В продаже","global.orderDate":"Order date","global.orderInfoHeader":"Order information","global.orderListingWeb":"Webstore order","global.orderNumber":"Порядковый номер","global.ourBrandsTitle":"Наши бренды","global.passwordTitle":"Пароль","global.paymentMethod":"Payment method","global.paymentTokensNewTitle":"Add new payment card","global.paymentTokensTitle":"Payment cards","global.pickupPointTitle":"Pickup Point","global.popularSearchesTitle":"Популярные запросы","global.priceFrom":"из","global.priceTitle":"Цена","global.privacyStatementAcceptSentence":"I authorize the processing of my personal data according to the Privacy statement","global.privacyStatementMustApproveSentence":"Approval of Privacy statement is required.","global.proceedToCartSentence":"Корзина","global.proceedToCheckoutSentence":"Kacca","global.productAddedToCartSentence":"{quantity, plural, one {# товар} other {# товары}} добавлено в корзину","global.productBundleAddedToCartSentence":"Набор товаров добавлен в корзину","global.productBundlesTitle":"Наборы продуктов","global.productCount":"{count, plural, one {# товар} other {# товары}}","global.productEnquiryProposalTitle":"Ask for a proposal","global.productEnquiryTitle":"Ask about the product","global.productOffer":"Product offer","global.productTitle":"Товар","global.productsTitle":"Товары","global.propertyChooseTitle":"Choose {property}","global.purchaseOrderCountHeader":"Order count","global.purchaseUserHeader":"User","global.purchaseWithVatHeader":"С НДС","global.purchaseWithoutVatHeader":"Без НДС","global.purchasesListTitle":"User purchases","global.quantityDecrementTitle":"Уменьшение количества","global.quantityIncrementTitle":"Количество инкрементов","global.quantityTitle":"Количество","global.readAboutRecurring":"Subscription is a recurring and automatically sent order. You can decide the products and how often you need a delivery.","global.readMoreSentence":"Read more","global.recommendedProductsTitle":"Рекомендуемые продукты","global.recurringOrdersTitle":"Subscriptions","global.regionalSettingsTitle":"Региональные настройки","global.registerTitle":"Подписаться","global.relatedProductsTitle":"сопутствующие товары","global.removeTitle":"Remove","global.retailerTitle":"Retailer","global.reviewCount":"{count, plural, one {# обзор} other {# обзоры}}","global.reviewCountCompact":"({count})","global.reviewProductRatingTitle":"Товар","global.reviewServiceRatingTitle":"Сервис и доставка","global.reviewTitle":"Обзор","global.reviewsTitle":"Обзоры","global.saveTitle":"Сохранять","global.search":"Поиск","global.searchHistoryTitle":"Недавние поиски","global.searchNoResults":"результатов не найдено","global.searchResultsForTermTitle":"Результаты для поискового запроса \"{term}\"","global.searchResultsForTitle":"Результаты поиска для {term}","global.searchResultsTitle":"результаты поиска","global.searchTryAnotherSentence":"Попробуйте другой поиск","global.seeCategoriesNavi":"Просмотр категорий","global.selectTitle":"Выбирать","global.selectedTitle":"Выбрано","global.selectedTitleWithValue":"Выбрано: {value}","global.sendTitle":"Send","global.shipping":"Shipping","global.shippingAddressTitle":"Shipping address","global.shippingCostsTitle":"Shipping costs","global.shippingMethod":"Shipping method","global.shoppingCenterAcceptableTerms":"By clicking \"{continuePurchase}\" I confirm I've read {storeName} {termsOfUse} and {privacyStatement}, and merchant's {merchantName} {deliveryAndPaymentTerms} and {merchantPrivacyStatement}","global.shoppingCenterProductMerchantDeliveryAndPaymentTerms":"delivery and payment terms","global.shoppingCenterProductMerchantPrivacy":"privacy statement","global.showAllProductsSentence":"Показать все продукты","global.showLessText":"Показывай меньше","global.showMoreText":"Показать больше","global.sizeGuideSentence":"Size guide","global.soldProductsTitle":"Проданные продукты","global.startDateTitle":"Start date","global.statusTitle":"Status","global.stockTemporarilyOutOfSentence":"Товар временно отсутствует на складе","global.streetAddressTitle":"Адрес улицы","global.submitSurvey":"Отправлять","global.suggestionsTitle":"Предложения","global.sumWithVat":"Всего с НДС","global.sumWithoutVat":"Итого без НДС","global.surveySubmitError":"Ошибка при отправке формы. Пожалуйста, попробуйте еще раз.","global.taxExcluded":"(без налога)","global.taxIncluded":"(налоги включены.","global.telephoneTitle":"Телефон","global.termFilterPlaceholder":"Поиск","global.toOrder":"См. информацию","global.totalPriceSentence":"Всего","global.unitPriceTitle":"Цена за единицу","global.update":"Обновление","global.uploadFileTitle":"Загрузить файл","global.userListTitle":"Users for account","global.validUntilFurtherNotice":"Действует до дальнейшего уведомления.","global.validationMessageInvalidFloor":"Количество должно быть кратным количеству товара в упаковке {size}.","global.validationMessageInvalidQuantity":"Количество должно быть между {min} и {max}.","global.vehiclePartSearchTitle":"Vehicle part search","global.warrantyLabel":"Гарантия: {warranty}","global.weRecommendTitle":"Мы рекомендуем","global.weightTitle":"Вес","global.wishListPageTitle":"Список желаний","global.writeNewReview":"Написать рецензию","global.yesTitle":"Yes","global.youSaveSentence":"You save {savings}","global.yourEmail":"Your email","global.yourReferenceTitle":"Reference","global.zipCodeTitle":"Zip Code","image.lightboxHelper":"Нажмите на изображение, чтобы увеличить","klarnaInstantShopping.emptyInstantShoppingCart":"You haven't selected any products.","klarnaInstantShopping.orderProductsInfo":"Order these products or add other variations","klarnaInstantShopping.selectProduct":"Select product","klarnaInstantShoppingForm.addressAcknowledgement":"Given address must correspond with the shipping address given in the next step","klarnaInstantShoppingForm.fillPickupPointInformation":"Write your address","klarnaInstantShoppingModal.choosePickupPoint":"Choose pickup point:","klarnaInstantShoppingModal.chooseShippingMethod":"Choose shipping method:","klarnaInstantShoppingModal.creatingOrder":"Please wait...","klarnaInstantShoppingModal.distance":"Distance: {distance} {distanceUnit}","klarnaInstantShoppingModal.fetchingPickupPoints":"Fetching pickup points...","klarnaInstantShoppingModal.fetchingShippingOptions":"Fetching shipping options...","klarnaInstantShoppingModal.noPickupPoints":"Unfortunately, no pickup points were found. Check that the address is correct or choose another delivery method.","klarnaInstantShoppingModal.openingHours":"Opening hours: {openingHours}","klarnaInstantShoppingModal.orderProductsButton":"Continue to order","klarnaInstantShoppingModal.shippingAndPickup":"{storeName} - order","klarnaInstantShoppingModal.updatingOrder":"Updating order...","localization.doNotRedirect":"Stay on this online store","localization.isSuggestedSite":"We recommend using this online store.","localization.moveToSite":"Go to the online store","localization.noShipping":"Please check out our available online stores as unfortunately we do not deliver to the detected country.","localization.noSuggestion":"We do not recognize where you are. Please check out our available online stores.","localization.shippingPossible":"Shipping is possible to your country.","localization.yourLocation":"We detected you are in {country}","manufacturer.browserManufacturerProducts":"Просмотр продуктов брендов","manufacturer.chooseManufacturerPlaceholder":"Выберите марку...","manufacturer.seeAllBrands":"Посмотреть все бренды","myAccount.balanceUserAccountStatusActive":"Active","myAccount.balanceUserAccountStatusNotActive":"Disabled","myAccount.balanceUserAccountUpdatePassword":"Optional. Only change, if you want to change your password.","myAccount.basicInfo":"Account basic info","myAccount.billingAddressTitle":"Billing address","myAccount.billingMethodTitle":"Billing method","myAccount.buyBalanceInfoText":"Select an amount for the users you want to transfer money to and wait a moment.","myAccount.cancelOrder":"Cancel order","myAccount.companyLabel":"Company: {company}","myAccount.customerIdLabel":"Customer ID: {customerId}","myAccount.emailLabel":"Email: {email}","myAccount.groupNameLabel":"Customer group: {group}","myAccount.klarnaCheckoutPaymentInfo":"Please give your payment info.","myAccount.loginInfo":"By logging in you can see your order history and modify your personal information.","myAccount.nameLabel":"Name: {name}","myAccount.orderDate":"Ordered on: {orderDate}","myAccount.orderHistory":"See All","myAccount.orderHistoryTitle":"Shipping history","myAccount.orderTitle":"Order {orderId}","myAccount.packageTitle":"Packet {parcelCount}:","myAccount.packageToTracking":"{trackingCode} (Go to tracking)","myAccount.paymentDetailsTitle":"Payment details","myAccount.pinExpires":"PIN-code expires at {expires}. Time is now {nowTime}","myAccount.previousOrders":"Previous orders","myAccount.printReceiptSentence":"Print a receipt of this order","myAccount.shippingAddressTitle":"Shipping address","myAccount.shippingDetailsTitle":"Shipping details","myAccount.shippingMethodTitle":"Shipping method","myAccount.telephoneLabel":"Telephone: {telephone}","myAccount.trackingDescription":"(If the tracking page notifies you that no orders were found, it may be that the parcel is not yet received at the delivery company)","myAccount.trackingTitle":"Tracking order parcels","myAccount.updateAddress":"Update Address","myAccount.updateUser":"Update User","navigation.backToBegin":"Назад к началу","navigation.backToItem":"Вернуться к {name}","navigation.goBackLink":"Назад к результатам поиска","navigation.navigateToCategoryItem":"Посмотреть все товары здесь","navigation.navigateToInfoItem":"Посмотреть содержимое страницы здесь","navigation.navigateToSectionItem":"См. главную страницу раздела здесь","navigation.shopAllCategory":"Купить все {category}","navigation.shopAllSection":"Купить все {section}","newsletter.isFree":"Newsletter is free","newsletter.popdownTitleWithoutDiscount":"Subscribe to our free newsletter!","newsletter.status.EMAIL_EXISTS":"The e-mail address you entered is already in our e-mail list.","newsletter.status.SUCCESS":"You have been added to our e-mail list. Thank you for subscribing!","newsletter.status.VALIDATION_ERROR":"Information you provided is not valid. Please recheck the form.","newsletter.subscribe":"Subscribe","newsletter.subscribeCompact":"Subscribe","newsletter.subscriberAgreesTo":"By subscribing you agree to","order.dateHeader":"Order date","order.dateTitle":"Date","order.deliveredQuantityTitle":"Delivered qty","order.orderNotFound":"Given code is not found","order.orderNotFoundSentence":"Order is not found","order.productAddFailedSentence":"Product cannot be added for order","order.productAddedSentence":"Product added to order","order.productNameTitle":"Name","order.statusDescriptionTitle":"Description","order.sumHeader":"Total","order.totalShortTitle":"Total","order.trackingHeader":"Status","orderStatus.active":"Active","orderStatus.canceled":"Canceled","orderStatus.deactivated":"Deactivated","orderStatus.onHold":"On hold","orderStatus.pending":"Pending","orderStatus.processing":"Processing","orderStatus.ready":"Ready","payment.addedAtSentence":"Added on {createdAt}","payment.expiredSentence":"Expired","payment.validSentence":"Valid","privacyStatement.readLinkSentence":"Privacy statement here","privacyStatement.subscriberAgreesLink":"the Privacy Statement","product.AddWishListTitle":"Добавить в список желаний","product.ProductAddedToWishlist":"Товар добавлен в список желаний. Вы можете просмотреть его {link}.","product.ProductAddedToWishlist_here":"здесь","product.RRP":"RRP","product.allProductsFromCategory":"Все {categoryLink}","product.allProductsFromManufacturer":"Все {manufacturerLink} товары","product.alsoPurchasedProducts":"Покупатели, которые приобрели этот товар, также купили","product.cartMatrixProductInformation":"Select the products to order from the table below.","product.checkingShippingValidity":"Product validity for the cart.","product.compatibleVehicleParts":"Compatible","product.currentProductSoldOut":"Выбранный продукт был распродан.","product.dateAvailable":"Product will be available {date}","product.deposit":"Цена продукта будет включать депозит в размере {deposit}","product.depositIncluded":"Включает депозит {deposit}","product.descriptionDetails":"Подробности","product.descriptionTitle":"Описание","product.downloadFile":"Скачать","product.enquirySuccess":"Ваше сообщение было успешно отправлено в нашу службу поддержки клиентов. Мы стремимся обработать сообщение как можно быстрее.","product.fileUploadDeleteFile":"Удалить файл {file}","product.fileUploadExistingFilesHeader":"Текущие загруженные файлы","product.fileUploadExplanationSentence":"Загрузите свои файлы для этого продукта здесь","product.fileUploadLoading":"Загрузка списка файлов...","product.fileUploadTooManyFileUploadsError":"Вы достигли максимального количества загруженных файлов.","product.fileUploadWorking":"Загрузка...","product.hasBeenSoldOut":"Этот товар был распродан.","product.idLabel":"Код продукта: {id}","product.incomingQuantity":"Incoming: {freeQuantity} {stockUnit} {date}","product.incomingQuantityNoQuantities":"Incoming: {date}","product.inventoryQuantity":"Inventory Quantity: {inventoryQuantity} {stockUnit}","product.lastVisitedProducts":"Последние посещенные продукты","product.manufacturerLogoAlt":"{manufacturer} логотип","product.manufacturersContentTitle":"Содержание производителей","product.minOrderQuantityError":"Минимальное количество {minOrderQuantity} {stockUnit}","product.noDateAvailable":"(no date available)","product.notAvailable":"(Not available)","product.nowOnly":"Только сейчас","product.offer":"Предлагайте!","product.onlyInStore":"Этот продукт нельзя приобрести в интернет-магазине. Пожалуйста, свяжитесь с отделом продаж","product.onlyInStoreLink":"Пожалуйста, смотрите контактную информацию","product.packageSizeDescription":"{packageSizeSentence}: 1 {packageUnitName} = {packageSize} {stockUnit} ({packagePrice} / {packageUnitName})","product.packageSizeSentence":"Размер упаковки","product.productMatrixInfo":"Select the products to be ordered by entering the quantities in the \"Quantity\" fields in the table. You can move between cells using the tab.","product.productsHasBeenOrdered":"(Products has been ordered)","product.propertyColourVariants":"{count} доступны различные цвета","product.quantityInput":"Количество","product.salesBeginAt":"Продажи начинаются в {date}","product.seasonEndedOn":"Продажа продукта закончилась онлайн на {endDate}.","product.seasonIs":"Период продажи продукции в Интернете составляет {startDate} - {endDate}.","product.seasonStartsOn":"Продажи продукта начинаются онлайн на {startDate}.","product.selectProductFirst":"Сначала выберите продукт.","product.shoppingCenterAcceptableTerms":"Merchant's {merchantName} {deliveryAndPaymentTerms} и {merchantPrivacyStatement}","product.showAllOfType":"Показать все {type}","product.showAllOfType.CAMPAIGN_PRODUCTS":"товары в продаже","product.showAllOfType.FALLBACK":"товары","product.showAllOfType.MOST_SOLD_PRODUCTS":"популярные продукты","product.showAllOfType.NEW_PRODUCTS":"новые продукты","product.showAllOfType.RECOMMENDED_PRODUCTS":"рекомендуемые продукты","product.sold":"Продано","product.spareParts":"Spares","product.superOffer":"Суперпредложение","product.topDiscount":"Максимальная скидка","product.vehiclePartAlternatives":"Alternatives","product.watcherButton":"Информировать меня о наличии товара на складе","product.watcherHeading":"Я хочу получать уведомления о появлении этого продукта в продаже","product.watcherInfo":"Пожалуйста, введите свой адрес электронной почты, и мы вышлем вам уведомление, когда товар снова появится на складе. После этого ваш e-mail будет удален из нашего списка.","product.weightLabel":"Вес: {weight}","productBundle.addToCartButton":"Добавить пакет в корзину","productBundle.createYourOwn":"Объединить \"{productName}\" с дополнительными продуктами и экономить","productBundle.noSelectedProducts":"Дополнительные продукты не выбраны","productBundle.price":"Цена пакета","productBundle.selectedProducts":"Вы выбрали {count, plural, one {# дополнительный продукт} other {# дополнительные продукты}}","productBundle.youSave":"Вы экономите","productCollectionMatrix.addSelectedProducts":"Добавить выбранные продукты","productListFilter.filter":"Фильтр по ключевому слову","productListFilter.filterList":"Список фильтров","productPageContent.productNotValidForCart":"This product does not have any common shipping methods with the products in the cart. For example pickup from different storage.","productPageContent.productPurchaseGuideTitle":"See purchase guide","productPageContent.shoppingCenterBuyProductsInfo":"If you buy several products at once, you can also go to the merchant's online store. There you can also find the merchant's whole selection","productPageContent.shoppingCenterBuyingNotAllowed":"This product has limitations for purchase. Please check the merchants store for more information.","productPageContent.shoppingCenterProductMerchantLink":"Go to the merchant's online store","productPageContent.shoppingCenterSiteName":"You're buying from {siteName}","recurringOrder.addToCart":"Add new subscription to cart","recurringOrder.addToOrder":"Add subscription to order","recurringOrder.allowShippingChangeSentence":"Allow automatic change of shipping method when current method is not possible. (Might change shipping costs)","recurringOrder.allowShippingChangeValue":"Allow automatic change of shipping method when current method is not possible: {allowUnder}","recurringOrder.allowUnderDeliveryValue":"Allow partial delivery when all products are not available: {allowUnder}","recurringOrder.changeQuantity":"Change product quantity","recurringOrder.cycleBiMonthly":"Every other month","recurringOrder.cycleBiWeekly":"Every other week","recurringOrder.cycleCustom":"Choose your interval","recurringOrder.cycleMonthly":"Every month","recurringOrder.cyclePlaceholder":"Choose your cycle","recurringOrder.cycleQuarterly":"Every three months","recurringOrder.cycleWeekly":"Every week","recurringOrder.days":"days","recurringOrder.deliveryAddressSentence":"Delivery address","recurringOrder.onHoldPlaceholder":"Choose date from calendar","recurringOrder.onHoldSentence":"On hold until: {untilDate}","recurringOrder.onHoldTitle":"Set subscription on hold until (Use dropdown or calendar icon)","recurringOrder.onlyForLoggedIn":"Subscriptions are available for registered users.","recurringOrder.paymentCardReminder":"Subscriptions will be charged from a payment card. Please make sure you have added valid payment card. You can have multiple payment cards.","recurringOrder.readLinkSentence":"Read more about subscriptions.","recurringOrder.selectCycle":"Choose cycle for your subscription","recurringOrder.selectDays":"Interval. (Minimum of {days} days)","recurringOrder.selectOrder":"Choose on which subscription product should be added","recurringOrder.shippingMethodSentence":"Subscription shipping method","recurringOrder.subscribe":"Subscribe","recurringOrder.subscriptionButton":"Save money by subscribing","recurringOrder.subscriptionPlaceholder":"Choose your subscription","recurringOrder.titleSentence":"Give descriptive title","reserveInStore.availableServicesForStorage":"В выбранном вами магазине доступны следующие услуги:","reserveInStore.availableStoragesHint":"В следующих магазинах есть выбранное количество этого товара на складе.","reserveInStore.button":"Зарезервировать в магазине","reserveInStore.cancellationInfo":"Вы можете отменить бронирование, позвонив в магазин.","reserveInStore.confirmReservation":"Зарезервировать сейчас","reserveInStore.howItWorks":"Зарезервируйте товар сейчас и заберите его из магазина позже! Бронирование действительно для {expiryHours} часы, после чего он будет удален. Обратите внимание, что купоны на скидку не могут быть использованы при бронировании в магазине.","reserveInStore.outOfStockMultipleStoresHint":"В настоящее время этот товар отсутствует в наличии в магазинах самовывоза.","reserveInStore.outOfStockSingleStoreHint":"В настоящее время в этом магазине нет этого товара в наличии.","reserveInStore.reservationConfirmationTitle":"Бронирование #{reservationID}","reserveInStore.reservationSuccessfulMessage":"Благодарим вас за бронирование! На адрес электронной почты было отправлено подтверждающее сообщение {email}.","reserveInStore.reservationTitle":"Зарезервировать в магазине","reserveInStore.selectChildProductHint":"Сначала выберите продукт. После этого вы можете зарезервировать этот товар в магазине.","reserveInStore.selectStorageButton":"Выберите этот магазин","reserveInStore.selectedServicesSentence":"Со следующими выбранными услугами:","reserveInStore.showAllStoragesButton":"Показать все магазины","reserveInStore.stockLoadingHint":"Пожалуйста, подождите, загружается информация о наличии в магазине...","reserveInStore.storageFilterPlaceholder":"Почтовый индекс или город","reserveInStore.unselectStorageButton":"Выберите другой магазин","review.emailAddressForApprovalHint":"Мы уведомим вас по этому адресу после того, как ваш отзыв будет одобрен. Сразу после этого мы удалим адрес электронной почты из нашего реестра.","review.emailAddressForCouponHint":"Информация о купоне будет отправлена на этот адрес. Мы удалим адрес электронной почты из нашего реестра после отправки купона.","review.haveYouBoughtSentence":"Вы уже покупали этот продукт?","review.interactiveStarsLabel":"{count, plural, one {# звезда} other {# звезды}} из 5","review.nicknameFieldHint":"Псевдоним по вашему выбору, который мы покажем рядом с вашим отзывом.","review.reviewCouponTitle":"Review this product to receive a discount coupon!","review.reviewHint":"Отправляя свой отзыв, вы соглашаетесь дать нам разрешение на его публикацию на этом веб-сайте, а также на других сайтах и ​​в СМИ. {storeName} оставляет за собой право не публиковать отзыв. Отправляя, вы соглашаетесь с этими условиями.","review.sendTitle":"Добавить отзыв","review.showAllTitle":"Показать все отзывы ({count})","review.showDefaultTitle":"Показать количество отзывов по умолчанию","review.staffReplySentence":"{name} отвечает:","review.success":"Ваш отзыв о товаре успешно добавлен!","review.successPending":"Мы получили ваш отзыв. Мы проверяем все отзывы, и вы получите сообщение, когда ваш будет опубликован.","review.typeReviewHereSentence":"Введите свой отзыв здесь","search.search":"Поиск","search.searchProducts":"Поиск продуктов","search.termTooShort":"Критерий поиска слишком короткий.","shipping.allCostsTitle":"Стоимость доставки","shipping.availableServicesSentence":"Дополнительные услуги","shipping.campaignHeader":"{name}","shipping.fixedPriceSentence":"Цена снижена","shipping.freeShippingSentence":"Бесплатная доставка{endAt}","shipping.noMethodsAvailable":"Для этого товара нет доступных способов доставки для выбранной страны доставки.","shipping.otherMethodsSentence":"Нормальные цены","shipping.totalQuantitySentence":"Бесплатная доставка для заказов на сумму не менее {amount} товары{endAt}","shipping.totalSumSentence":"Бесплатная доставка для заказов свыше {amount}{endAt}","shipping.totalVolumeSentence":"Бесплатная доставка при объеме заказов свыше {amount} m3{endAt}","shipping.totalWeightSentence":"Бесплатная доставка для заказов общим весом более {amount}{endAt}","shoppingCenterProductMerchantInfo.sellerTitle":"Seller","site.reloadPage":"Перезагрузить страницу","sort.alphabetical":"Алфавитный","sort.bestRated":"Лучший рейтинг","sort.brand":"Бренд","sort.category":"Категория продукта","sort.cheapest":"Самый дешевый","sort.default":"По умолчанию","sort.discount":"Лучшая скидка","sort.id":"Номер продукта","sort.latest":"Последний","sort.mostExpensive":"Самый дорогой","sort.mostPopular":"Самый популярный","sort.sortLabel":"Сорт:","state.networkError":"Ошибка подключения. Убедитесь, что вы подключены к Интернету.","state.unexpectedError":"Произошла непредвиденная ошибка. Попробуйте перезагрузить страницу. Если ошибка повторяется, попробуйте позже.","stock.addressHeading":"Адрес","stock.availabilityHeading":"Доступность","stock.availableInStores":"Наличие магазина уточняйте здесь","stock.contactHeading":"Контактная информация и часы работы","stock.filterByStorage":"Фильтр по хранилищу","stock.loadingStoreAvailability":"Загрузка наличия в магазине...","stock.mapLink":"Карта и инструкции по вождению","stock.notAvailable":"Нет в наличии","stock.shelfLocation":"Расположение полки","stock.soldOut":"Распроданный","stock.storeAvailability":"Доступность магазина","stock.storeAvailabilityTitle":"Наличие товара в магазинах","stock.storeHeading":"Хранить","stock.storeOutOfStock":"Магазин нет в наличии","stock.storesOutOfStock":"Магазины нет в наличии","stock.temporarilyOutOfStock":"Временно нет в наличии","survey.selectOption":"'-- Select option'","termsOfUseStatement.termsOfUse":"{termsOfUse}","termsOfUseStatement.termsOfUseLink":"условия использования","tokens.createFailSentence":"Failed adding the payment card.","tokens.createSuccessSentence":"Card added successfully.","userInfo.active":"Username is active","userInfo.notInUse":"Username is not active","validation.additionalService.TEXT_REQUIRED":"Дополнительная услуга требует ввода текста.","validation.additionalService.TEXT_TOO_LONG":"Слишком много символы.","validation.finnishBusinessId":"Пожалуйста, проверьте формат идентификатора предприятия.","validation.isDate":"{field} формат не допускается.","validation.isEmail":"{field} должен быть действующий адрес электронной почты.","validation.maxLength":"{field} не должно быть более {maxLength} символы.","validation.minLength":"{field} должен иметь по крайней мере {minLength} символы.","validation.mustMatch":"Поле не совпадает.","validation.numberBetween":"{field} должно быть число между {min} и {max}.","validation.required":"{field} не может быть пустым.","vehicle.brand":"Brand","vehicle.model":"Model","vehicle.motor":"Motor","vehicle.years":"Years","vehiclePartSearch.clearVehicle":"Clear vehicle information","vehiclePartSearch.helpText":"Insert your license plate number to find compatible parts for the vehicle","vehiclePartSearch.noSearchResults":"No search results","vehiclePartSearch.notFound":"No vehicle found with given license plate number","vehiclePartSearch.selectModel":"Select more precise model","vehiclePartSearch.severalCarsFound":"Several models were found with the license plate","wishlist.AmountAndInTotal":"Сумма / Всего","wishlist.DeleteProduct":"Удалить","wishlist.EmailMessage":"Сообщение","wishlist.EmailTitle":"Название","wishlist.InvalidForm":"Форма недействительна. Пожалуйста, проверьте свою форму.","wishlist.NotLoggedInBanner":"Вы еще не вошли в систему. Вы должны {login_link} как клиент, чтобы отправить список в виде электронного письма или сохранить его навсегда.","wishlist.NotLoggedInBanner_Registration_Enabled":"Вы еще не вошли в систему. Вы должны {login_link} или {register_link} как клиент, чтобы отправить список в виде электронного письма или сохранить его навсегда.,","wishlist.Product":"Product","wishlist.ProductListEmailInformation":"Вы можете добавить товары в список и принять решение о заказе позже. Вы также можете отправить список в виде электронного письма по вашему выбору.","wishlist.SendList":"Список отправки","wishlist.UnitPrice":"Цена за единицу","wishlist.ValidForm":"Электронная почта успешно отправлена.","wishlist.login":"вход","wishlist.register":"регистр","wishlist.wishlistIsEmpty":"Список желаний пуст.","wishlist.wishlistNotFound":"Список желаний не существует с заданным id."}

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SectionAwareRoute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Section__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Used to easily set the active section when section specific routes
 * are rendered.
 */var SectionAwareRoute=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SectionAwareRoute,_Component);function SectionAwareRoute(props){_classCallCheck(this,SectionAwareRoute);var _this=_possibleConstructorReturn(this,(SectionAwareRoute.__proto__||Object.getPrototypeOf(SectionAwareRoute)).call(this,props));var _this$props=_this.props,section=_this$props.section,sectionStore=_this$props.sectionStore;sectionStore.setActiveSection(section||null);return _this;}_createClass(SectionAwareRoute,[{key:'render',value:function render(){var _props=this.props,section=_props.section,sectionStore=_props.sectionStore,props=_objectWithoutProperties(_props,['section','sectionStore']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Route */],props);}}]);return SectionAwareRoute;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SectionAwareRoute.propTypes={section:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_2__models_Section__["a" /* default */]),sectionStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_SectionStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('sectionStore')(SectionAwareRoute));

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RouteHistoryKeeper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This component simply watches for location changes and stores them.
 */var RouteHistoryKeeper=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RouteHistoryKeeper,_Component);function RouteHistoryKeeper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RouteHistoryKeeper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RouteHistoryKeeper.__proto__||Object.getPrototypeOf(RouteHistoryKeeper)).call.apply(_ref,[this].concat(args))),_this),_this.unlisten=null,_this.state={loading:__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].NONE},_this.checkLogin=function(){var accountStore=_this.props.accountStore;_this.setState({loading:__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADING});accountStore.loginCheck().then(function(){_this.setState({loading:__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].NONE});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RouteHistoryKeeper,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,history=_props.history,uiStore=_props.uiStore,configStore=_props.configStore;var previousPathname=history.location.pathname;this.unlisten=history.listen(function(location,action){if(action!=='REPLACE'){uiStore.setLastPathname(previousPathname);previousPathname=location.pathname;if(configStore.state===__WEBPACK_IMPORTED_MODULE_5__types_RequestState__["b" /* default */].LOADED&&configStore.store.loginRequired){_this2.checkLogin();}}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.unlisten){this.unlisten();}}},{key:'render',value:function render(){return null;}}]);return RouteHistoryKeeper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RouteHistoryKeeper.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default.a.history.isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_UIStore__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('uiStore','accountStore','configStore')(RouteHistoryKeeper));

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CookieNotice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var COOKIE_KEY='nhcookielaw';var CookieNotice=Object(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CookieNotice,_Component);function CookieNotice(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CookieNotice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CookieNotice.__proto__||Object.getPrototypeOf(CookieNotice)).call.apply(_ref,[this].concat(args))),_this),_this.state={visible:!__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get(COOKIE_KEY)},_this.accept=function(){__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set(COOKIE_KEY,Math.floor(Date.now()/1000),{expires:5*365});_this.setState({visible:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CookieNotice,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,routeService=_props.routeService;if(window.isSSR||!configStore.cookieNotice.enabled||!this.state.visible){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CookieNotice',mode:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CookieNotice__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CookieNotice__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cookieNotice.content',defaultMessage:'In order to serve our customers as well as possible, we use cookies on our site. By continuing, you agree to use the cookies.'}),' ',configStore.cookieNotice.infoPageId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:routeService.getPath('/i/-/'+configStore.cookieNotice.infoPageId)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'cookieNotice.readMore',defaultMessage:'Read more about cookies'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CookieNotice__button-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'CookieNotice__button',size:'lg',onClick:this.accept},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__i18n_globalTranslations__["a" /* default */].ok)))));}}]);return CookieNotice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;CookieNotice.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["c" /* inject */])('configStore','routeService')(CookieNotice));

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TimerCoupons */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_CouponStore__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TimerCoupons=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(TimerCoupons,_Component);function TimerCoupons(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TimerCoupons);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TimerCoupons.__proto__||Object.getPrototypeOf(TimerCoupons)).call.apply(_ref,[this].concat(args))),_this),_this.timerDict={},_this.currentActivation=null,_this.activateCoupon=function(couponId){var _this$props=_this.props,accountStore=_this$props.accountStore,couponStore=_this$props.couponStore;// Only activate a single coupon at a time
if(_this.currentActivation){_this.delayActivation(couponId,500);return;}_this.currentActivation=couponStore.activateCoupon(couponId).then(function(){accountStore.refreshCoupons();_this.currentActivation=null;}).catch(function(e){console.error(e);_this.currentActivation=null;});},_this.delayActivation=function(couponId,delay){_this.timerDict[couponId]=window.setTimeout(function(){_this.activateCoupon(couponId);},delay);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TimerCoupons,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var couponStore=this.props.couponStore;Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["autorun"])(function(){couponStore.timerCoupons.filter(function(coupon){return!_this2.timerDict[coupon.id];}).forEach(function(coupon){var delay=Number(coupon.time_to_activation)*1000;_this2.delayActivation(coupon.id,delay);});});}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this3=this;Object.keys(this.timerDict).forEach(function(key){var timeoutId=_this3.timerDict[key];clearTimeout(timeoutId);});}},{key:'render',value:function render(){return null;}}]);return TimerCoupons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;TimerCoupons.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_AccountStore__["a" /* default */]).isRequired,couponStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_CouponStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','couponStore')(TimerCoupons));

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ActivatedCoupons */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CouponModal__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivatedCoupons=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ActivatedCoupons,_Component);function ActivatedCoupons(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ActivatedCoupons);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ActivatedCoupons.__proto__||Object.getPrototypeOf(ActivatedCoupons)).call.apply(_ref,[this].concat(args))),_this),_this.removeActiveCoupon=function(activatedCoupon){var accountStore=_this.props.accountStore;if(accountStore.session){accountStore.session.removeCoupon(activatedCoupon);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ActivatedCoupons,[{key:'render',value:function render(){var _this2=this;var accountStore=this.props.accountStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ActivatedCoupons'},accountStore.session&&accountStore.session.activated_coupons.slice(0,1).map(function(activatedCoupon){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CouponModal__["a" /* default */],{key:activatedCoupon.code,toggle:function toggle(){return _this2.removeActiveCoupon(activatedCoupon);},isOpen:true,activatedCoupon:activatedCoupon});}));}}]);return ActivatedCoupons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ActivatedCoupons.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_AccountStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore')(ActivatedCoupons));

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CouponModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_CouponStore__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__privacy_statement_PrivacyStatementLink__ = __webpack_require__(181);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VIEWS={DATA:'DATA',EMAIL:'EMAIL'};var CouponModal=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CouponModal,_Component);function CouponModal(props){_classCallCheck(this,CouponModal);var _this=_possibleConstructorReturn(this,(CouponModal.__proto__||Object.getPrototypeOf(CouponModal)).call(this,props));_this.state={view:VIEWS.DATA,successMessage:null,errorMessage:null,sendCouponLoading:false,setCouponLoading:false,showEmailFormForRetrieve:false,retrieveCouponLoading:false,retrievedCode:null};_this.form=null;_this.changeView=function(view){_this.setState({view:view});};_this.retrieveCoupon=function(){var _this$props=_this.props,couponStore=_this$props.couponStore,activatedCoupon=_this$props.activatedCoupon;_this.setState({retrieveCouponLoading:true});couponStore.retrieveCoupon(activatedCoupon.coupon_id,activatedCoupon.activation_id,_this.form.fields.get('email').value).then(function(response){_this.setState({errorMessage:null,retrievedCode:response.data.code,retrieveCouponLoading:false});}).catch(function(error){var messages=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(error,'response.data.messages',[]);var errorMessage=messages.length>0?messages.map(function(message){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:message},message);}):_this.getActivationError();_this.setState({errorMessage:errorMessage,retrieveCouponLoading:false});});};_this.setCoupon=function(){var _this$props2=_this.props,couponStore=_this$props2.couponStore,activatedCoupon=_this$props2.activatedCoupon;_this.setState({setCouponLoading:true});var code=_this.state.retrievedCode||activatedCoupon.code;couponStore.setCoupon(code).then(function(){_this.setState({successMessage:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.setSuccess',defaultMessage:'The campaign code was activated successfully!'}),setCouponLoading:false});}).catch(function(){_this.setState({errorMessage:_this.getActivationError(),setCouponLoading:false});});};_this.sendCoupon=function(){var _this$props3=_this.props,couponStore=_this$props3.couponStore,activatedCoupon=_this$props3.activatedCoupon;_this.setState({sendCouponLoading:true});couponStore.sendCoupon(_this.form.fields.get('email').value,activatedCoupon.code).then(function(){_this.setState({successMessage:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.emailSuccess',defaultMessage:'The discount coupon information has been sent to your email.'}),sendCouponLoading:false});}).catch(function(){_this.setState({errorMessage:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.emailError',defaultMessage:'The information could not be sent to your email. Please contact our customer service using the contact form.'}),sendCouponLoading:false});});};_this.getActivationError=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.setError',defaultMessage:'The campaign code could not be activated. Please contact our customer service using the contact form.'});};_this.showEmailForm=function(){_this.setState({showEmailFormForRetrieve:true});};_this.getEmailForm=function(_onSubmit,buttonMessage){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{className:'CouponModal__email-form',noValidate:true,onSubmit:function onSubmit(e){e.preventDefault();_this.form.validate();if(_this.form.valid){_onSubmit();}}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__form_FormGroupField__["a" /* default */],{field:_this.form.fields.get('email'),label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailTitle),formName:'CouponModal__email-form',fieldName:'email'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary',block:true,disabled:_this.form.valid===false||_this.state.sendCouponLoading},buttonMessage));};_this.getDataView=function(){var activatedCoupon=_this.props.activatedCoupon;if(_this.state.retrievedCode){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'info',className:'CouponModal__retrieved-code'},_this.state.retrievedCode),_this.getSetCouponButton());}else if(activatedCoupon.code){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,_this.getSetCouponButton(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{block:true,color:'secondary',onClick:function onClick(){return _this.changeView(VIEWS.EMAIL);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.useLater',defaultMessage:'I want to use my code later'})));}else if(activatedCoupon.activation_id){var message=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.fetchDiscountCode',defaultMessage:'Fetch discount code'});return _this.state.showEmailFormForRetrieve?_this.getEmailForm(_this.retrieveCoupon,message):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CouponModal__retrieve-privacy-statement'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.emailSubscribeNotice',defaultMessage:'By giving us your email address you subscribe to our newsletter.'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__privacy_statement_PrivacyStatementLink__["a" /* default */],null),'.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{block:true,color:'primary',onClick:_this.showEmailForm},message));}else{return null;}};_this.getEmailView=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,_this.getEmailForm(_this.sendCoupon,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].sendTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{block:true,color:'secondary',onClick:function onClick(){return _this.changeView(VIEWS.DATA);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.showInformation',defaultMessage:'Show coupon information'})));};_this.form=Object(__WEBPACK_IMPORTED_MODULE_13__models_Form__["a" /* createForm */])({email:Object(__WEBPACK_IMPORTED_MODULE_14__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_11__util_formValidators__["d" /* isEmail */])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].emailTitle))])});return _this;}_createClass(CouponModal,[{key:'getSetCouponButton',value:function getSetCouponButton(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{block:true,color:'primary',onClick:this.setCoupon,disabled:this.state.setCouponLoading},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'coupon.useNow',defaultMessage:'I want to activate my code now'}));}},{key:'render',value:function render(){var _props=this.props,accountStore=_props.accountStore,activatedCoupon=_props.activatedCoupon,toggle=_props.toggle,isOpen=_props.isOpen;var _state=this.state,view=_state.view,successMessage=_state.successMessage,errorMessage=_state.errorMessage;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["C" /* Modal */],{className:'CouponModal',size:'lg',toggle:toggle,isOpen:isOpen,backdrop:'static'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["F" /* ModalHeader */],{toggle:toggle}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["D" /* ModalBody */],null,successMessage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'success'},successMessage):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'danger'},errorMessage),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:activatedCoupon.html},className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('CouponModal__contents','CouponModal__contents--'+view)}),!accountStore.loggedIn&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,view===VIEWS.DATA?this.getDataView():this.getEmailView()))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["E" /* ModalFooter */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'secondary',onClick:toggle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].closeTitle))));}}]);return CouponModal;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;CouponModal.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_AccountStore__["a" /* default */]).isRequired,couponStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_CouponStore__["a" /* default */]).isRequired,activatedCoupon:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({coupon_id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,html:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,code:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,activation_id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number}),toggle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,isOpen:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('accountStore','couponStore')(CouponModal));

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MobileRegionalSettingsModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegionalSettingsDropdowns__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RegionalSettings__ = __webpack_require__(448);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MobileRegionalSettingsModal=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MobileRegionalSettingsModal,_Component);function MobileRegionalSettingsModal(){_classCallCheck(this,MobileRegionalSettingsModal);return _possibleConstructorReturn(this,(MobileRegionalSettingsModal.__proto__||Object.getPrototypeOf(MobileRegionalSettingsModal)).apply(this,arguments));}_createClass(MobileRegionalSettingsModal,[{key:'render',value:function render(){var _this2=this;var modal=this.props.uiStore.mobileRegionalSettingsModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RegionalSettings__["a" /* default */],null,function(save,onChange,currentValues,isSaving){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["C" /* Modal */],{isOpen:modal.isOpen,className:'MobileRegionalSettingsModal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["F" /* ModalHeader */],{className:'MobileRegionalSettingsModal__header',toggle:modal.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].regionalSettingsTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RegionalSettingsDropdowns__["a" /* default */],Object.assign({},currentValues,{onChange:onChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["E" /* ModalFooter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{onClick:function onClick(){save().then(_this2.props.uiStore.mobileRegionalSettingsModal.toggle);},color:'primary',disabled:isSaving},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* default */],{name:isSaving?'circle-o-notch':'check',spin:isSaving}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].saveTitle)))));});}}]);return MobileRegionalSettingsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('uiStore')(MobileRegionalSettingsModal));

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner__ = __webpack_require__(300);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UninitializedAppSpinner=function(_Component){_inherits(UninitializedAppSpinner,_Component);function UninitializedAppSpinner(){_classCallCheck(this,UninitializedAppSpinner);return _possibleConstructorReturn(this,(UninitializedAppSpinner.__proto__||Object.getPrototypeOf(UninitializedAppSpinner)).apply(this,arguments));}_createClass(UninitializedAppSpinner,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* IntlProvider */],{locale:'en',messages:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UninitializedAppSpinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Spinner__["a" /* default */],null)));}}]);return UninitializedAppSpinner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UninitializedAppSpinner);

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FatalError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FatalError=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FatalError,_Component);function FatalError(){_classCallCheck(this,FatalError);return _possibleConstructorReturn(this,(FatalError.__proto__||Object.getPrototypeOf(FatalError)).apply(this,arguments));}_createClass(FatalError,[{key:'render',value:function render(){var intl=this.props.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FatalError'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:""+'/img/maintenance.png',alt:'Error'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'FatalError__reload',value:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__["a" /* default */].errorRefresh),onClick:function onClick(){window.location.reload();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__["a" /* default */].errorHeader)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__["a" /* default */].errorContentFront)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'FatalError__secondary',value:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_3__i18n_globalTranslations__["a" /* default */].errorFrontpage),onClick:function onClick(){window.location.assign(window.location.protocol+'//'+window.location.host);}})));}}]);return FatalError;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FatalError.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["e" /* injectIntl */])(FatalError));

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScrollTracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollTracker=function(_Component){_inherits(ScrollTracker,_Component);function ScrollTracker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ScrollTracker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ScrollTracker.__proto__||Object.getPrototypeOf(ScrollTracker)).call.apply(_ref,[this].concat(args))),_this),_this.handleScroll=function(){var uiStore=_this.props.uiStore;uiStore.setDocumentScrollTop(Object(__WEBPACK_IMPORTED_MODULE_2__util_dom__["d" /* getDocumentScrollTop */])());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ScrollTracker,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('scroll',this.handleScroll,true);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('scroll',this.handleScroll,true);}},{key:'render',value:function render(){return null;}}]);return ScrollTracker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ScrollTracker.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_UIStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('uiStore')(ScrollTracker));

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_layout_SidebarLayout__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_my_account_MyAccountNavigation__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_my_account_MyAccountOverview__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_my_account_MyAccountOrderList__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_my_account_MyAccountOrder__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_my_account_MyAccountInfo__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_my_account_MyAccountChangePassword__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_account_AccountModalLink__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_OrderStore__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_my_account_MyAccountAddressList__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_my_account_MyAccountAddressNew__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_my_account_MyAccountAddress__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_my_account_MyAccountUserList__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_my_account_MyAccountUserNew__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_my_account_MyAccountUser__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_my_account_MyAccountPurchasesList__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_my_account_MyAccountCreditAccount__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__CustomerProductsPage__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__MyAccountThankYouPage__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_my_account_BalanceUser_BalanceUserAccountOverview__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_my_account_BalanceUser_BalanceUserBalanceAccount__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_my_account_BalanceUser_BalanceSubUserAccountOverview__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_my_account_MyAccountPaymentTokenList__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__store_PaymentTokenStore__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_my_account_MyAccountRecurringOrderList__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_my_account_MyAccountRecurringOrder__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createRoute=function createRoute(path,component){return{path:path,component:component};};var ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccount,__WEBPACK_IMPORTED_MODULE_16__components_my_account_MyAccountOverview__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountInfo,__WEBPACK_IMPORTED_MODULE_19__components_my_account_MyAccountInfo__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountChangePassword,__WEBPACK_IMPORTED_MODULE_20__components_my_account_MyAccountChangePassword__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountAddressList,__WEBPACK_IMPORTED_MODULE_27__components_my_account_MyAccountAddressList__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountAddressNew,__WEBPACK_IMPORTED_MODULE_28__components_my_account_MyAccountAddressNew__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountAddress,__WEBPACK_IMPORTED_MODULE_29__components_my_account_MyAccountAddress__["a" /* default */])];var TOKEN_ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountPaymentTokenList,__WEBPACK_IMPORTED_MODULE_44__components_my_account_MyAccountPaymentTokenList__["a" /* default */])];var NON_BALANCE_ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountOrderList,__WEBPACK_IMPORTED_MODULE_17__components_my_account_MyAccountOrderList__["a" /* default */])];var BALANCE_ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountBalanceUser,__WEBPACK_IMPORTED_MODULE_41__components_my_account_BalanceUser_BalanceUserAccountOverview__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountBalanceUserAccountInfo,__WEBPACK_IMPORTED_MODULE_19__components_my_account_MyAccountInfo__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountBalanceUserPaymentHistory,__WEBPACK_IMPORTED_MODULE_42__components_my_account_BalanceUser_BalanceUserBalanceAccount__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountChangePassword,__WEBPACK_IMPORTED_MODULE_20__components_my_account_MyAccountChangePassword__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUserNew,__WEBPACK_IMPORTED_MODULE_34__components_my_account_MyAccountUserNew__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUser,__WEBPACK_IMPORTED_MODULE_35__components_my_account_MyAccountUser__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountThankYouPage,__WEBPACK_IMPORTED_MODULE_40__MyAccountThankYouPage__["a" /* default */])];var BALANCE_USER_ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountBalanceSubUser,__WEBPACK_IMPORTED_MODULE_43__components_my_account_BalanceUser_BalanceSubUserAccountOverview__["a" /* default */])];var RETAILER_ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].CustomerProducts,__WEBPACK_IMPORTED_MODULE_39__CustomerProductsPage__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUserList,__WEBPACK_IMPORTED_MODULE_33__components_my_account_MyAccountUserList__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUserNew,__WEBPACK_IMPORTED_MODULE_34__components_my_account_MyAccountUserNew__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUser,__WEBPACK_IMPORTED_MODULE_35__components_my_account_MyAccountUser__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountPurchasesList,__WEBPACK_IMPORTED_MODULE_37__components_my_account_MyAccountPurchasesList__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountThankYouPage,__WEBPACK_IMPORTED_MODULE_40__MyAccountThankYouPage__["a" /* default */])];var CUSTOMER_USER_ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccount,__WEBPACK_IMPORTED_MODULE_16__components_my_account_MyAccountOverview__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountChangePassword,__WEBPACK_IMPORTED_MODULE_20__components_my_account_MyAccountChangePassword__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountOrderList,__WEBPACK_IMPORTED_MODULE_17__components_my_account_MyAccountOrderList__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].CustomerProducts,__WEBPACK_IMPORTED_MODULE_39__CustomerProductsPage__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUser,__WEBPACK_IMPORTED_MODULE_35__components_my_account_MyAccountUser__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountThankYouPage,__WEBPACK_IMPORTED_MODULE_40__MyAccountThankYouPage__["a" /* default */])];var RETAILER_LIMITED_ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountCreditAccount,__WEBPACK_IMPORTED_MODULE_38__components_my_account_MyAccountCreditAccount__["a" /* default */])];var RECURRING_ORDER_ROUTES=[createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountRecurringOrderList,__WEBPACK_IMPORTED_MODULE_46__components_my_account_MyAccountRecurringOrderList__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountRecurringOrder,__WEBPACK_IMPORTED_MODULE_48__components_my_account_MyAccountRecurringOrder__["a" /* default */])];var ORDER_SEARCH_PARAMS={};var MyAccountPage=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountPage,_Component);function MyAccountPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountPage.__proto__||Object.getPrototypeOf(MyAccountPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={creditAccess:false,tokenAccess:false},_this.getCurrentOrderAuthenticationCode=function(){var query=Object(__WEBPACK_IMPORTED_MODULE_31__util_queryString__["b" /* parse */])(_this.props.location.search);return query.code;},_this.hasCreditAccountAccess=function(){return _this.state.creditAccess;},_this.hasTokenAccess=function(){return _this.state.tokenAccess;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,accountStore=_props.accountStore,orderStore=_props.orderStore,customerUserStore=_props.customerUserStore;if(accountStore.loggedIn&&!accountStore.isBalanceBuyer){orderStore.loadOrders(ORDER_SEARCH_PARAMS);}if(accountStore.isRetailer){customerUserStore.loadCreditAccount().then(function(){_this2.setState({creditAccess:true});}).catch(function(){_this2.setState({creditAccess:false});});if(!accountStore.isCustomerUser){customerUserStore.loadUsers();}}// Check Payment card status before creating route
if(accountStore.loggedIn){var paymentTokenStore=this.props.paymentTokenStore;paymentTokenStore.loadTokens().then(function(){_this2.setState({tokenAccess:true});}).catch(function(){_this2.setState({tokenAccess:false});});}}},{key:'getOrderCount',value:function getOrderCount(){var orderStore=this.props.orderStore;var orderList=orderStore.orderQueryResults.get(Object(__WEBPACK_IMPORTED_MODULE_30__util_query__["a" /* paramsToQueryIdentifier */])(ORDER_SEARCH_PARAMS));return orderList?orderList.total:0;}},{key:'getUserCount',value:function getUserCount(){var _props2=this.props,customerUserStore=_props2.customerUserStore,accountStore=_props2.accountStore;return accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_1_lodash_size___default()(customerUserStore.balanceUsers):__WEBPACK_IMPORTED_MODULE_1_lodash_size___default()(customerUserStore.users);}},{key:'getAccountRoutes',value:function getAccountRoutes(){var _props3=this.props,accountStore=_props3.accountStore,configStore=_props3.configStore;var params=Object(__WEBPACK_IMPORTED_MODULE_31__util_queryString__["b" /* parse */])(this.props.location.search);var accountRoutes=ROUTES;if(accountStore.isCustomerUser){accountRoutes=CUSTOMER_USER_ROUTES;if(accountStore.isUserAllowedAddressModification){accountRoutes=accountRoutes.concat([createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountAddressList,__WEBPACK_IMPORTED_MODULE_27__components_my_account_MyAccountAddressList__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountAddressNew,__WEBPACK_IMPORTED_MODULE_28__components_my_account_MyAccountAddressNew__["a" /* default */]),createRoute(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountAddress,__WEBPACK_IMPORTED_MODULE_29__components_my_account_MyAccountAddress__["a" /* default */])]);}}else{accountRoutes=accountRoutes.concat(NON_BALANCE_ROUTES);}if(accountStore.isRetailer){if(!accountStore.isCustomerUser){accountRoutes=accountRoutes.concat(RETAILER_ROUTES);}if(this.hasCreditAccountAccess()){accountRoutes=accountRoutes.concat(RETAILER_LIMITED_ROUTES);}}if(configStore.recurringOrder.enabled){accountRoutes=accountRoutes.concat(RECURRING_ORDER_ROUTES);}if(accountStore.isBalanceBuyer){accountRoutes=BALANCE_ROUTES;}if(accountStore.isBalanceUser){accountRoutes=BALANCE_USER_ROUTES;}if(this.hasTokenAccess()||!!params.tokenizationSuccess){accountRoutes=accountRoutes.concat(TOKEN_ROUTES);}return accountRoutes;}},{key:'render',value:function render(){var _props4=this.props,match=_props4.match,accountStore=_props4.accountStore,routeService=_props4.routeService;var code=this.getCurrentOrderAuthenticationCode();var allowOrderCloning=accountStore.loggedIn;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_49__types_CommonPage__["b" /* default */].MY_ACCOUNT,className:'MyAccountPage'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_ScrollReset__["a" /* default */],{key:match.params.id}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccount)}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["n" /* Container */],{className:'MyAccountPage__container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_layout_SidebarLayout__["a" /* default */],{forceSidebar:true,sidebar:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_my_account_MyAccountNavigation__["a" /* default */],{routes:this.getAccountRoutes(),orderCount:this.getOrderCount(),userCount:this.getUserCount()}),content:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["c" /* Switch */],null,accountStore.loggedIn&&this.getAccountRoutes().map(function(route){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["b" /* Route */],{key:__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(route.path),exact:true,path:routeService.getPath(route.path),component:route.component});}),(accountStore.loggedIn||code)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["b" /* Route */],{exact:true,path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountOrder),render:function render(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_my_account_MyAccountOrder__["a" /* default */],Object.assign({},props,{code:code,allowClone:allowOrderCloning}));}}),!accountStore.loggedIn&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["b" /* Route */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_24__i18n_globalTranslations__["a" /* default */].myAccountTitle}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{className:'MyAccountPage__container-info',color:'warning'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:'myAccount.loginInfo',defaultMessage:'By logging in you can see your order history and modify your personal information.'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_account_AccountModalLink__["a" /* default */],{tab:__WEBPACK_IMPORTED_MODULE_23__types_AccountModalTab__["b" /* default */].LOGIN},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{tag:'span',color:'primary'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_24__i18n_globalTranslations__["a" /* default */].logInSentence))));}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* Redirect */],{to:'/'})))})));}}]);return MyAccountPage;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;MyAccountPage.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10__services_RouteService__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_22__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_47__store_ConfigStore__["a" /* default */]).isRequired,orderStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_26__store_OrderStore__["a" /* default */]).isRequired,customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_36__store_CustomerUserStore__["a" /* default */]).isRequired,paymentTokenStore:Object(__WEBPACK_IMPORTED_MODULE_21__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_45__store_PaymentTokenStore__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.location.isRequired,match:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.match.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('routeService','accountStore','configStore','orderStore','customerUserStore','paymentTokenStore')(MyAccountPage)));

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_NavigationTree__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_CollapseMenu__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_TopLevelNavigationDropdown__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountNavigation=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountNavigation,_Component);function MyAccountNavigation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountNavigation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountNavigation.__proto__||Object.getPrototypeOf(MyAccountNavigation)).call.apply(_ref,[this].concat(args))),_this),_this.state={collapse:false},_this.convertPathsToNavigationEntities=function(){var _labels;var _this$props=_this.props,orderCount=_this$props.orderCount,routes=_this$props.routes,routeService=_this$props.routeService,userCount=_this$props.userCount;var labels=(_labels={},_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccount,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccount)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountBalanceUser,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccount)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountBalanceSubUser,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccount)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountInfo,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccountInfo)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountBalanceUserAccountInfo,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].balanceUserAccountInfo)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountOrderList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myOrderHistoryTitle),orderCount?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["b" /* Badge */],{pill:true,key:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountOrderList+orderCount,className:'MyAccountNavigation__menu-badge'},orderCount):null)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountChangePassword,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccountChangePassword)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountAddressList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].addressBookTitle)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountUserList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].userListTitle),userCount?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["b" /* Badge */],{pill:true,key:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountUserList+userCount,className:'MyAccountNavigation__menu-badge'},userCount):null)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountPurchasesList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchasesListTitle)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountCreditAccount,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].creditAccountTitle)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountBalanceUserPaymentHistory,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].balanceUserAccountBalanceInfo)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].CustomerProducts,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].customerProductsTitle)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountPaymentTokenList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].paymentTokensTitle)),_defineProperty(_labels,__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountRecurringOrderList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].recurringOrdersTitle)),_labels);return routes.filter(function(route){return!!labels[route.path];}).map(function(route){return{id:route.path,label:labels[route.path],path:routeService.getPath(route.path)};});},_this.toggle=function(){_this.setState({collapse:!_this.state.collapse});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountNavigation,[{key:'render',value:function render(){var _props=this.props,uiStore=_props.uiStore,configStore=_props.configStore;var navigation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__navigation_NavigationTree__["a" /* default */],{items:this.convertPathsToNavigationEntities()});if(uiStore.isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'MyAccountNavigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{className:'MyAccountNavigation__toggle-col',xs:'12',onClick:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Icon__["a" /* default */],{name:'bars',className:'fa-2x'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{className:'MyAccountNavigation__sidebar',xs:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_CollapseMenu__["a" /* default */],{collapse:this.state.collapse},navigation)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountNavigation'},uiStore.isDesktop&&configStore.mainNavigation.useSidebar&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_TopLevelNavigationDropdown__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountNavigation__sidebar'},navigation));}}]);return MyAccountNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountNavigation.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_UIStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_ConfigStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__services_RouteService__["a" /* default */]).isRequired,routes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object).isRequired,orderCount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,userCount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('routeService','uiStore','configStore')(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(MyAccountNavigation)));

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CollapseMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CollapseMenu=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CollapseMenu,_Component);function CollapseMenu(){_classCallCheck(this,CollapseMenu);return _possibleConstructorReturn(this,(CollapseMenu.__proto__||Object.getPrototypeOf(CollapseMenu)).apply(this,arguments));}_createClass(CollapseMenu,[{key:'render',value:function render(){var collapse=this.props.collapse;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["m" /* Collapse */],{isOpen:collapse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CollapseMenu'},this.props.children));}}]);return CollapseMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (CollapseMenu);

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom_Link__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_dom_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MyAccountBasicInfo__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__order_MainOrderList__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types_RequestState__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ORDER_PREVIEW_COUNT=3;var MyAccountOverview=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountOverview,_Component);function MyAccountOverview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountOverview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountOverview.__proto__||Object.getPrototypeOf(MyAccountOverview)).call.apply(_ref,[this].concat(args))),_this),_this.orderCount=0,_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccount}]);},_this.maybeLoadAccountInfo=function(){var accountStore=_this.props.accountStore;if(accountStore.state===__WEBPACK_IMPORTED_MODULE_18__types_RequestState__["b" /* default */].NONE){accountStore.loadAccount().catch(function(err){console.error(err);});}},_this.getName=function(){var accountStore=_this.props.accountStore;var _accountStore$account=accountStore.account.personal_info,firstname=_accountStore$account.firstname,lastname=_accountStore$account.lastname;if(firstname&&lastname){return firstname+' '+lastname;}return lastname?lastname:firstname;},_this.getAccountInfo=function(){var _this$props2=_this.props,accountStore=_this$props2.accountStore,configStore=_this$props2.configStore;var name=_this.getName();var accountInfo={customerId:accountStore.customerId,name:name,email:accountStore.account.personal_info.email,telephone:accountStore.account.personal_info.telephone,company:accountStore.account.personal_info.company};if(configStore.account.showCustomerGroupName){accountInfo.group=accountStore.account.group_name;}return accountInfo;},_this.updateOrderCount=function(value){_this.orderCount=value;},_this.getCustomerGroupName=function(){var _this$props3=_this.props,accountStore=_this$props3.accountStore,configStore=_this$props3.configStore;return configStore.account.showCustomerGroupName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'MyAccountOverview__customer-group-name'},'(',accountStore.account.group_name,')');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountOverview,[{key:'componentDidMount',value:function componentDidMount(){this.maybeLoadAccountInfo();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,accountStore=_props.accountStore,routeService=_props.routeService;if(!accountStore.account||!accountStore.account.is_logged){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountOverview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccount),this.getCustomerGroupName()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_ContentForState__["a" /* default */],{state:accountStore.state,error:accountStore.lastError,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MyAccountBasicInfo__["a" /* default */],{myAccountInfo:_this2.getAccountInfo()}),!accountStore.isBalanceBuyer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'myAccount.previousOrders',defaultMessage:'Previous orders'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__order_MainOrderList__["a" /* default */],{resultsPerPage:ORDER_PREVIEW_COUNT,singlePage:true,onOrderCount:_this2.updateOrderCount}),_this2.orderCount>3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom_Link___default.a,{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountOrderList)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* Button */],{color:'primary',className:'MyAccountOverview__my-account-order-history-link-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'myAccount.orderHistory',defaultMessage:'See All'})))));}})));}}]);return MyAccountOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountOverview.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_ConfigStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_12__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','configStore','routeService')(MyAccountOverview)));

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(67);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(_react2.default.Component);

Link.propTypes = {
  onClick: _propTypes2.default.func,
  target: _propTypes2.default.string,
  replace: _propTypes2.default.bool,
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      push: _propTypes2.default.func.isRequired,
      replace: _propTypes2.default.func.isRequired,
      createHref: _propTypes2.default.func.isRequired
    }).isRequired
  }).isRequired
};
exports.default = Link;

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountBasicInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountBasicInfo=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountBasicInfo,_Component);function MyAccountBasicInfo(){_classCallCheck(this,MyAccountBasicInfo);return _possibleConstructorReturn(this,(MyAccountBasicInfo.__proto__||Object.getPrototypeOf(MyAccountBasicInfo)).apply(this,arguments));}_createClass(MyAccountBasicInfo,[{key:'render',value:function render(){var myAccountInfo=this.props.myAccountInfo;var customerIdLabel=myAccountInfo.customerId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'customerId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'myAccount.customerIdLabel',defaultMessage:'Customer ID: {customerId}',values:{customerId:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,myAccountInfo.customerId)}}));var groupNameLabel=myAccountInfo.group&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'groupName'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'myAccount.groupNameLabel',defaultMessage:'Customer group: {group}',values:{group:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,myAccountInfo.group)}}));var nameLabel=myAccountInfo.name&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'myAccount.nameLabel',defaultMessage:'Name: {name}',values:{name:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,myAccountInfo.name)}}));var companyLabel=myAccountInfo.company&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'company'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'myAccount.companyLabel',defaultMessage:'Company: {company}',values:{company:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,myAccountInfo.company)}}));var emailLabel=myAccountInfo.email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'myAccount.emailLabel',defaultMessage:'Email: {email}',values:{email:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,myAccountInfo.email)}}));var telephoneLabel=myAccountInfo.telephone&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'telephone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'myAccount.telephoneLabel',defaultMessage:'Telephone: {telephone}',values:{telephone:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,myAccountInfo.telephone)}}));var myAccountInfoLabels=[customerIdLabel,groupNameLabel,nameLabel,companyLabel,emailLabel,telephoneLabel];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountBasicInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'myAccount.basicInfo',defaultMessage:'Account basic info'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'MyAccountBasicInfo__list_items'},myAccountInfoLabels));}}]);return MyAccountBasicInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountBasicInfo.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_AccountStore__["a" /* default */]).isRequired,myAccountInfo:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({customerId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,telephone:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,company:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,group:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore')(MyAccountBasicInfo));

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrderList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrderPreview__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Order__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_RecurringOrder__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RecurringOrderPreview__ = __webpack_require__(1384);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrderList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(OrderList,_Component);function OrderList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrderList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrderList.__proto__||Object.getPrototypeOf(OrderList)).call.apply(_ref,[this].concat(args))),_this),_this.renderOrderRows=function(){var _this$props=_this.props,orders=_this$props.orders,useRecurringOrders=_this$props.useRecurringOrders,onRemoveClick=_this$props.onRemoveClick;return orders.map(function(order){return useRecurringOrders?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__RecurringOrderPreview__["a" /* default */],{key:order.id,order:order,onRemoveClick:onRemoveClick}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__OrderPreview__["a" /* default */],{key:order.id,order:order});});},_this.renderHeaders=function(){var useRecurringOrders=_this.props.useRecurringOrders;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'OrderList__headers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:useRecurringOrders?5:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].orderInfoHeader)),!useRecurringOrders&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'order.dateHeader',defaultMessage:'Order date'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'order.trackingHeader',defaultMessage:'Status'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:useRecurringOrders?3:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'order.sumHeader',defaultMessage:'Total'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{md:'2'})));},_this.renderOrders=function(){var _this$props2=_this.props,orders=_this$props2.orders,uiStore=_this$props2.uiStore;if(orders.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].myAccountNoOrders);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,!uiStore.isMobile&&_this.renderHeaders(),_this.renderOrderRows());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrderList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'OrderList'},this.renderOrders());}}]);return OrderList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;OrderList.propTypes={orders:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_Order__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__models_RecurringOrder__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array]),uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_UIStore__["a" /* default */]).isRequired,onRemoveClick:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,useRecurringOrders:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('uiStore','recurringOrderStore')(OrderList));

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrderPreview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderLink__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_OrderTotalClass__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_ProductTypeClass__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__product_ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__models_Order__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__OrderStatusLabel__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_MaybeExternalLink__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__OrderCloneButton__ = __webpack_require__(588);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_PRODUCT_IMAGE_COUNT=6;var OrderPreview=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(OrderPreview,_Component);function OrderPreview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrderPreview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrderPreview.__proto__||Object.getPrototypeOf(OrderPreview)).call.apply(_ref,[this].concat(args))),_this),_this.getTotalPrice=function(){var order=_this.props.order;var totalPrice=order.totals.find(function(total){return total.class===__WEBPACK_IMPORTED_MODULE_12__types_OrderTotalClass__["b" /* default */].TOTAL;});return totalPrice.value||null;},_this.getTotalTaxlessPrice=function(){var order=_this.props.order;var totalPrice=order.totals.find(function(total){return total.class===__WEBPACK_IMPORTED_MODULE_12__types_OrderTotalClass__["b" /* default */].TAXLESS_TOTAL;});return totalPrice.value||null;},_this.getOrderStatus=function(){var order=_this.props.order;if(!order.last_status){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__OrderStatusLabel__["a" /* default */],{status:order.last_status});},_this.getProductCount=function(){var physicalProducts=_this.getPhysicalProducts();if(!physicalProducts){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].productCount,{values:{count:physicalProducts.length}}));},_this.getProductReference=function(order){var reference=order.getOrderReference();return order&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,reference&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].yourReferenceTitle),reference&&':',reference);},_this.getPhysicalProducts=function(){return _this.props.order.products.filter(function(orderProduct){return orderProduct.type===__WEBPACK_IMPORTED_MODULE_14__types_ProductTypeClass__["b" /* default */].PHYSICAL;});},_this.getProductImages=function(){var physicalProducts=_this.getPhysicalProducts();if(!physicalProducts||physicalProducts.length===0){return null;}return physicalProducts.filter(function(orderProduct,index){return index<=MAX_PRODUCT_IMAGE_COUNT;}).map(function(orderProduct,index){var productImageModel=orderProduct.image_url?__WEBPACK_IMPORTED_MODULE_16__models_ProductImage__["a" /* default */].create({id:index,product_id:orderProduct.id,sizes:{small:orderProduct.image_url},description:''}):null;var productImage=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__product_ProductImage__["a" /* default */],{product:orderProduct,productImage:productImageModel,size:'small'});var product=orderProduct.product_url?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__common_MaybeExternalLink__["a" /* default */],{to:orderProduct.product_url},productImage):productImage;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(orderProduct.id),className:'OrderPreview__products-image'},product);});},_this.getPath=function(){var _this$props=_this.props,order=_this$props.order,routeService=_this$props.routeService;return routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_10__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__types_Paths__["a" /* default */].MyAccountOrder,{id:order.id}));},_this.getOrderViewButton=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{className:'OrderPreview__button-view',color:'primary',tag:__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */],to:_this.getPath()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].toOrder));},_this.getOrderDate=function(){var order=_this.props.order;return __WEBPACK_IMPORTED_MODULE_7_luxon__["DateTime"].fromISO(order.date_purchased).toLocaleString();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrderPreview,[{key:'render',value:function render(){var _props=this.props,order=_props.order,accountStore=_props.accountStore,cartStore=_props.cartStore;if(!order){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'OrderPreview__row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'4',sm:'12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__order-information'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__OrderLink__["a" /* default */],{id:order.id,link:this.getPath(),date_purchased:order.date_purchased})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__products-images'},this.getProductImages()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__count'},this.getProductCount()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__order-reference'},this.getProductReference(order)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'2',sm:'12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__date'},this.getOrderDate())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'2',sm:'12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__status'},this.getOrderStatus())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'2',sm:'12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__price'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__product_Price__["a" /* default */],{price:this.getTotalPrice()})),accountStore.isRetailer&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__price'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__product_Price__["a" /* default */],{price:this.getTotalTaxlessPrice()}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].taxExcluded))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'2',sm:'12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OrderPreview__button'},this.getOrderViewButton(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__OrderCloneButton__["a" /* default */],{order:order,disabled:!cartStore.state===__WEBPACK_IMPORTED_MODULE_24__types_RequestState__["b" /* default */].LOADING})))));}}]);return OrderPreview;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;OrderPreview.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_13__services_RouteService__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_17__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_AccountStore__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_17__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_23__store_CartStore__["a" /* default */]).isRequired,order:Object(__WEBPACK_IMPORTED_MODULE_17__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__models_Order__["a" /* default */]),intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["c" /* inject */])('routeService','accountStore','cartStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(OrderPreview)));

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrderLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrderLink=function(_Component){_inherits(OrderLink,_Component);function OrderLink(){_classCallCheck(this,OrderLink);return _possibleConstructorReturn(this,(OrderLink.__proto__||Object.getPrototypeOf(OrderLink)).apply(this,arguments));}_createClass(OrderLink,[{key:'render',value:function render(){var _props=this.props,id=_props.id,link=_props.link;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{key:link,className:'OrderLink',to:link},id,' (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].orderListingWeb),')');}}]);return OrderLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrderLink.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,link:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrderLink);

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecurringOrderPreview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_OrderTotalClass__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_ProductTypeClass__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__product_ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__OrderStatusLabel__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_MaybeExternalLink__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__models_RecurringOrder__ = __webpack_require__(161);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_PRODUCT_IMAGE_COUNT=6;var RecurringOrderPreview=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RecurringOrderPreview,_Component);function RecurringOrderPreview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecurringOrderPreview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecurringOrderPreview.__proto__||Object.getPrototypeOf(RecurringOrderPreview)).call.apply(_ref,[this].concat(args))),_this),_this.getTotalPrice=function(){var order=_this.props.order;var priceTotal=order.totals.find(function(total){return total.class===__WEBPACK_IMPORTED_MODULE_10__types_OrderTotalClass__["b" /* default */].TOTAL;});return priceTotal.value||null;},_this.getTotalTaxlessPrice=function(){var order=_this.props.order;var priceTotal=order.totals.find(function(total){return total.class===__WEBPACK_IMPORTED_MODULE_10__types_OrderTotalClass__["b" /* default */].TAXLESS_TOTAL;});return priceTotal.value||null;},_this.getOrderStatus=function(){var order=_this.props.order;if(!order.recurring_status){return null;}var onHoldUntil=order.on_hold_until;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__OrderStatusLabel__["a" /* default */],{status:order.recurring_status}),onHoldUntil&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__order-info-hold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.onHoldSentence',defaultMessage:'On hold until: {untilDate}',values:{untilDate:_this.getOrderDate(onHoldUntil)}})));},_this.getProductCount=function(){var physicalProducts=_this.getPhysicalProducts();if(!physicalProducts){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].productCount,{values:{count:physicalProducts.length}}));},_this.getOrderInfo=function(order){var allowUnderDeliveryValue=order.allow_under_delivery?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].yesTitle):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].noTitle);var allowShippingMethodChangeValue=order.allow_shipping_method_change?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].yesTitle):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].noTitle);return order&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__order-info-partial-delivery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.allowUnderDeliveryValue',defaultMessage:'Allow partial delivery when all products are not available: {allowUnder}',values:{allowUnder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,allowUnderDeliveryValue)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__order-info-shipping-change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.allowShippingChangeValue',defaultMessage:'Allow automatic change of shipping method when current method is not possible: {allowUnder}',values:{allowUnder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,allowShippingMethodChangeValue)}})));},_this.getPhysicalProducts=function(){return _this.props.order.products.filter(function(orderProduct){return orderProduct.type===__WEBPACK_IMPORTED_MODULE_12__types_ProductTypeClass__["b" /* default */].PHYSICAL;});},_this.getProductImages=function(){var physicalProducts=_this.getPhysicalProducts();if(!physicalProducts||physicalProducts.length===0){return null;}return physicalProducts.filter(function(orderProduct,index){return index<=MAX_PRODUCT_IMAGE_COUNT;}).map(function(orderProduct,index){var productImageModel=orderProduct.image_url?__WEBPACK_IMPORTED_MODULE_14__models_ProductImage__["a" /* default */].create({id:index,product_id:orderProduct.id,sizes:{small:orderProduct.image_url},description:''}):null;var productImage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__product_ProductImage__["a" /* default */],{product:orderProduct,productImage:productImageModel,size:'small'});var product=orderProduct.product_url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__common_MaybeExternalLink__["a" /* default */],{to:orderProduct.product_url},productImage):productImage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:orderProduct.id,className:'RecurringOrderPreview__products-image'},product);});},_this.getPath=function(path){var _this$props=_this.props,order=_this$props.order,routeService=_this$props.routeService;return routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_8__util_generatePath__["a" /* default */])(path,{id:order.id}));},_this.renderOrderModifyButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],{to:_this.getPath(__WEBPACK_IMPORTED_MODULE_9__types_Paths__["a" /* default */].MyAccountRecurringOrder)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'RecurringOrderPreview__button-view',color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].toOrder),' / ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].editTitle)));},_this.renderOrderCancelButton=function(id){var onRemoveClick=_this.props.onRemoveClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'RecurringOrderPreview__button-cancel',color:'danger',onClick:function onClick(){return window.confirm(_this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].confirmRemoveTitle))&&onRemoveClick(id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'myAccount.cancelOrder',defaultMessage:'Cancel order'}));},_this.getOrderDate=function(dateString){return __WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(dateString).toLocaleString();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecurringOrderPreview,[{key:'render',value:function render(){var _props=this.props,order=_props.order,accountStore=_props.accountStore;if(!order){return null;}var title=order.title||order.autogenerated_title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{className:'RecurringOrderPreview__row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'5',sm:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__order-information'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__link'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__products-images'},this.getProductImages()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__order-info'},this.getOrderInfo(order)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'2',sm:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__status'},this.getOrderStatus())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'2',sm:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__product_Price__["a" /* default */],{price:this.getTotalPrice()})),accountStore.isRetailer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__product_Price__["a" /* default */],{price:this.getTotalTaxlessPrice()}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].taxExcluded))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'3',sm:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderPreview__buttons'},this.renderOrderModifyButton(),this.renderOrderCancelButton(order.id)))));}}]);return RecurringOrderPreview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RecurringOrderPreview.propTypes={routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_AccountStore__["a" /* default */]).isRequired,onRemoveClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,order:Object(__WEBPACK_IMPORTED_MODULE_15__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__models_RecurringOrder__["a" /* default */]),intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('routeService','accountStore')(Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(RecurringOrderPreview)));

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountOrderList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__order_MainOrderList__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ORDER_COUNT_PER_PAGE=10;var MyAccountOrderList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountOrderList,_Component);function MyAccountOrderList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountOrderList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountOrderList.__proto__||Object.getPrototypeOf(MyAccountOrderList)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myOrderHistoryTitle),url:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountOrderList}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountOrderList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountOrderList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myOrderHistoryTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myOrderHistoryTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__order_MainOrderList__["a" /* default */],{resultsPerPage:ORDER_COUNT_PER_PAGE})));}}]);return MyAccountOrderList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountOrderList.propTypes={intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService')(MyAccountOrderList)));

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountOrder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_OrderStore__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__product_ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__order_OrderStatusLabel__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__types_OrderTotalClass__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__product_ProductWarranty__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common_MaybeExternalLink__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__order_OrderCloneButton__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__types_ProductTypeClass__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* defineMessages */])({'myAccount.orderTitle':{'id':'myAccount.orderTitle','defaultMessage':'Order {orderId}'}});var productTotals=[__WEBPACK_IMPORTED_MODULE_24__types_OrderTotalClass__["b" /* default */].TOTAL];var billingInfoTotals=[__WEBPACK_IMPORTED_MODULE_24__types_OrderTotalClass__["b" /* default */].TAXLESS_TOTAL,__WEBPACK_IMPORTED_MODULE_24__types_OrderTotalClass__["b" /* default */].TAX_TOTAL,__WEBPACK_IMPORTED_MODULE_24__types_OrderTotalClass__["b" /* default */].TOTAL];var OrderHeaders={image:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].productTitle),name:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'order.productNameTitle',defaultMessage:'Name'}),quantity:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].quantityTitle),deliveredQuantity:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'order.deliveredQuantityTitle',defaultMessage:'Delivered qty'}),unitPrice:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'global.unitPriceTitle',defaultMessage:'Unit price'}),totalSum:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'order.totalShortTitle',defaultMessage:'Total'})};var StatusHeaders={date:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'order.dateTitle',defaultMessage:'Date'}),status:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].statusTitle),description:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'order.statusDescriptionTitle',defaultMessage:'Description'})};var QueryStatus={NONE:'NONE',LOADING:'LOADING',LOADED:'LOADED',NOT_FOUND:'NOT_FOUND',UNEXPECTED_ERROR:'UNEXPECTED_ERROR'};var MyAccountOrder=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountOrder,_Component);function MyAccountOrder(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountOrder);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountOrder.__proto__||Object.getPrototypeOf(MyAccountOrder)).call.apply(_ref,[this].concat(args))),_this),_this.state={queryStatus:QueryStatus.NONE},_this.getCurrentOrderId=function(){return _this.props.match.params.id;},_this.loadOrder=function(){var _this$props=_this.props,orderStore=_this$props.orderStore,code=_this$props.code;_this.setState({queryStatus:QueryStatus.LOADING});orderStore.loadOrder(_this.getCurrentOrderId(),code).then(function(){_this.setState({queryStatus:QueryStatus.LOADED});}).catch(function(e){var status=e.response?e.response.status:500;var errorMap={404:QueryStatus.NOT_FOUND,500:QueryStatus.UNEXPECTED_ERROR};_this.setState({queryStatus:errorMap[status]});});},_this.getOrderState=function(){return _this.state.queryStatus;},_this.getOrder=function(){var orderStore=_this.props.orderStore;return orderStore.orders.get(_this.getCurrentOrderId());},_this.getBreadcrumbsPath=function(){var _this$props2=_this.props,intl=_this$props2.intl,routeService=_this$props2.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].myOrderHistoryTitle),url:__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccountOrderList},{text:intl.formatMessage(messages['myAccount.orderTitle'],{orderId:_this.getCurrentOrderId()}),url:__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccountOrderList}]);},_this.createProductImage=function(url,id){return url?__WEBPACK_IMPORTED_MODULE_20__models_ProductImage__["a" /* default */].create({id:0,product_id:id,sizes:{small:url}}):null;},_this.renderPaymentAddressInfo=function(address){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'MyAccountOrder__detail-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.billingAddressTitle',defaultMessage:'Billing address'})),_this.renderAddressInfo(address));},_this.renderAddressInfo=function(address){var countryStore=_this.props.countryStore;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'MyAccountOrder__address-info'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,address.name),address.company&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,address.company),address.care_of&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,address.care_of),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,address.street_address),address.street_address2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,address.street_address2),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,address.postalcode,' ',address.city),address.country_id&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,countryStore.findCountry(address.country_id).name));},_this.renderProductHeaderCol=function(label,sizes){var actualSizes=Object.assign({xs:4},sizes);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],Object.assign({className:'MyAccountOrder__product-header'},actualSizes),label);},_this.renderProductHeaderRow=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{className:'MyAccountOrder__product-headers'},_this.renderProductHeaderCol(OrderHeaders.image,{md:2,xl:1}),_this.renderProductHeaderCol(OrderHeaders.name,{md:6,xl:7}),_this.renderProductHeaderCol(OrderHeaders.quantity,{md:1}),_this.renderProductHeaderCol(OrderHeaders.deliveredQuantity,{md:1}),_this.renderProductHeaderCol(OrderHeaders.unitPrice,{md:1}),_this.renderProductHeaderCol(OrderHeaders.totalSum,{md:1}));},_this.renderStatusHeaderCol=function(label,sizes){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],Object.assign({className:'MyAccountOrder__status-header'},sizes),label);},_this.renderStatusHeaderRow=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{className:'MyAccountOrder__status-headers'},_this.renderStatusHeaderCol(StatusHeaders.date,{md:3,xl:2}),_this.renderStatusHeaderCol(StatusHeaders.status,{md:4,xl:3}),_this.renderStatusHeaderCol(StatusHeaders.description,{md:5}));},_this.renderProductLink=function(product){return product.isPhysicalProduct&&product.product_url?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__common_MaybeExternalLink__["a" /* default */],{to:product.product_url},product.name):product.name;},_this.renderProductCode=function(product){var _this$props3=_this.props,configStore=_this$props3.configStore,accountStore=_this$props3.accountStore;if(configStore.productCard.showProductCode||accountStore.isRetailer){var collectionOrMultiProduct=product.id.includes('{');var index=collectionOrMultiProduct?product.id.indexOf('{'):product.id;var productCode=product.id.substring(0,index);return productCode;}},_this.renderPaymentLogo=function(){var order=_this.getOrder();if(order.payment.method&&order.payment.method.logo){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:order.payment.method.logo,alt:order.payment.method.name,loading:'lazy'});}return null;},_this.renderShippingLogo=function(){var order=_this.getOrder();if(order.shipping.method&&order.shipping.method.logo){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:order.shipping.method.logo,alt:order.shipping.method.name,loading:'lazy'});}return null;},_this.renderProductRow=function(product){var isMobile=_this.props.uiStore.isMobile;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{key:product.id,className:'MyAccountOrder__product-row'},!isMobile&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{className:'MyAccountOrder__products-image',xs:'2',xl:'1'},product.isPhysicalProduct&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__common_MaybeExternalLink__["a" /* default */],{to:product.product_url},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__product_ProductImage__["a" /* default */],{product:product,productImage:_this.createProductImage(product.image_url,product.id),size:'small',forceAspectRatio:false}))),isMobile&&_this.renderProductHeaderCol(OrderHeaders.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'8',md:'6',xl:'7'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__products-name-wrapper'},_this.renderProductLink(product),product&&product.type!==__WEBPACK_IMPORTED_MODULE_31__types_ProductTypeClass__["b" /* default */].SHIPPING_COST&&_this.renderProductCode(product)),product.variations&&product.variations.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,product.variations.map(function(variation,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:index},variation);})),product.reference&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__products-reference'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].yourReferenceTitle),': '+product.reference),product.warranty_in_months>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__products-warranty'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__product_ProductWarranty__["a" /* default */],{warranty:product.warranty_in_months}))),product.isPhysicalProduct?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,isMobile&&_this.renderProductHeaderCol(OrderHeaders.quantity),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'8',md:'1'},product.quantity_ordered,' ',product.stock_unit),isMobile&&_this.renderProductHeaderCol(OrderHeaders.deliveredQuantity),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'8',md:'1'},product.quantity_delivered,' ',product.stock_unit),isMobile&&_this.renderProductHeaderCol(OrderHeaders.unitPrice),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'8',md:'1',dangerouslySetInnerHTML:{__html:product.final_unit_price}})):!isMobile?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{md:'3'}):null,isMobile&&_this.renderProductHeaderCol(OrderHeaders.totalSum),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'8',md:'1',dangerouslySetInnerHTML:{__html:product.total_price}}));},_this.renderTotals=function(visibleTotalClasses){var order=_this.getOrder();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__totals'},order.totals.filter(function(total){return visibleTotalClasses.includes(total.class);}).map(function(totalsItem){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{key:totalsItem.name},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'8',className:'MyAccountOrder__total-item'},totalsItem.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'4',className:'MyAccountOrder__total-value'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__product_Price__["a" /* default */],{price:totalsItem.value})));}));},_this.renderInfoComponent=function(title,content){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'MyAccountOrder__detail-header'},title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,content));},_this.renderPickUpPoint=function(pickUpPoint){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__detail-pickup'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__detail-pickup-name'},pickUpPoint.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__detail-pickup-address'},pickUpPoint.address),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__detail-pickup-contact-info'},pickUpPoint.contact_info));},_this.renderTracking=function(tracking){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'MyAccountOrder__detail-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.trackingTitle',defaultMessage:'Tracking order parcels'})),tracking.map(function(code,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{key:code.code},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.packageTitle',defaultMessage:'Packet {parcelCount}: ',values:{parcelCount:index+1}}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:code.url,target:'_blank',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.packageToTracking',defaultMessage:'{trackingCode} (Go to tracking)',values:{trackingCode:code.code}}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__common_Icon__["a" /* default */],{name:'angle-double-right'})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.trackingDescription',defaultMessage:'(If the tracking page notifies you that no orders were found, it may be that the parcel is not yet received at the delivery company)'}));},_this.shouldRenderPaymentAddress=function(){var order=_this.getOrder();return!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(order.shipping.address,order.payment.address);},_this.renderMessage=function(){var queryStatus=_this.state.queryStatus;var message=null;switch(queryStatus){case QueryStatus.NOT_FOUND:message=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'order.orderNotFound',defaultMessage:'Given code is not found'}));break;case QueryStatus.UNEXPECTED_ERROR:message=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__loader_UnexpectedError__["a" /* default */],null);break;case QueryStatus.NONE:case QueryStatus.LOADING:case QueryStatus.LOADED:default:break;}return message;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountOrder,[{key:'componentDidMount',value:function componentDidMount(){this.loadOrder();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,uiStore=_props.uiStore,allowClone=_props.allowClone;var queryStatus=this.state.queryStatus;var orderId=this.getCurrentOrderId();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__head_SEOTitle__["a" /* default */],{title:Object.assign({},messages['myAccount.orderTitle'],{values:{orderId:orderId}})}),queryStatus&&this.renderMessage(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_ContentForState__["a" /* default */],{state:this.getOrderState(),forLoaded:function forLoaded(){var order=_this2.getOrder();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_PageTitle__["a" /* default */],{className:'MyAccountOrder__page-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},messages['myAccount.orderTitle'],{values:{orderId:orderId}})),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'MyAccountOrder__status'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__order_OrderStatusLabel__["a" /* default */],{status:order.last_status}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["n" /* Container */],{className:'MyAccountOrder__container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xl:'6',md:'12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["j" /* CardHeader */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.shippingDetailsTitle',defaultMessage:'Shipping details'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.orderDate',defaultMessage:'Ordered on: {orderDate}',values:{orderDate:__WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(order.date_purchased).toLocaleString()}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["n" /* Container */],{className:'MyAccountOrder__shipping-details-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'MyAccountOrder__detail-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.shippingAddressTitle',defaultMessage:'Shipping address'})),_this2.renderAddressInfo(order.shipping.address),order.seller_name&&_this2.renderInfoComponent(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].retailerTitle),order.seller_name),order.your_reference&&_this2.renderInfoComponent(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].yourReferenceTitle),order.your_reference)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'MyAccountOrder__detail-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.shippingMethodTitle',defaultMessage:'Shipping method'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__method'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__method-logo'},_this2.renderShippingLogo()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__method-name'},order.shipping.method.name)),order.shipping.pick_up_point&&_this2.renderPickUpPoint(order.shipping.pick_up_point),order.weight&&_this2.renderInfoComponent(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].weightTitle),order.weight))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],null,order.shipping.tracking.length>0&&_this2.renderTracking(order.shipping.tracking))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xl:'6',md:'12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["j" /* CardHeader */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.paymentDetailsTitle',defaultMessage:'Payment details'}),order.receipt_url&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{tag:'a',href:order.receipt_url,color:'primary',className:'MyAccountOrder__payment-receipt-button',target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__common_Icon__["a" /* default */],{name:'print'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.printReceiptSentence',defaultMessage:'Print a receipt of this order'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["n" /* Container */],{className:'MyAccountOrder__payment-details-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'12',md:'6'},_this2.shouldRenderPaymentAddress()&&_this2.renderPaymentAddressInfo(order.payment.address),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'MyAccountOrder__detail-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.billingMethodTitle',defaultMessage:'Billing method'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__method'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__method-logo'},_this2.renderPaymentLogo()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__method-name'},order.payment.method.name))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'12',md:'6'},_this2.renderTotals(billingInfoTotals))),allowClone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{className:'MyAccountOrder__clone-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__order_OrderCloneButton__["a" /* default */],{order:_this2.getOrder()})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["j" /* CardHeader */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_11__i18n_globalTranslations__["a" /* default */].productsTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["n" /* Container */],{className:'MyAccountOrder__products-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountOrder__products'},!uiStore.isMobile&&_this2.renderProductHeaderRow(),order.products.map(function(product){return _this2.renderProductRow(product);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{className:'MyAccountOrder__products-totals-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{md:'9'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],null,_this2.renderTotals(productTotals)))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["j" /* CardHeader */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.orderHistoryTitle',defaultMessage:'Shipping history'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["i" /* CardBody */],null,!uiStore.isMobile&&_this2.renderStatusHeaderRow(),order.status_history.map(function(entry,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{key:entry.date+'_'+entry.status+'_'+index,className:'MyAccountOrder__status-history-entry'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{md:'3',xl:'2'},__WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(entry.date).toLocaleString()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{md:'4',xl:'3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__order_OrderStatusLabel__["a" /* default */],{status:entry.status})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{md:'5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:entry.message}})));})))))));}}));}}]);return MyAccountOrder;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MyAccountOrder.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_32__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_30__store_ConfigStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_CountryStore__["a" /* default */]).isRequired,orderStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_OrderStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_UIStore__["a" /* default */]).isRequired,allowClone:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired,match:__WEBPACK_IMPORTED_MODULE_8_react_router_prop_types___default.a.match.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__services_RouteService__["a" /* default */]).isRequired,code:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('accountStore','configStore','countryStore','orderStore','routeService','uiStore')(MyAccountOrder))));

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MyAccountInfoForm__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountInfo=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountInfo,_Component);function MyAccountInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountInfo.__proto__||Object.getPrototypeOf(MyAccountInfo)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,accountStore=_this$props.accountStore,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccount),url:accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountBalanceUser:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccount},{text:accountStore.isBalanceBuyer?intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].balanceUserAccountInfo):intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccountInfo),url:accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountBalanceUserAccountInfo:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountInfo}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountInfo,[{key:'render',value:function render(){var accountStore=this.props.accountStore;var title=accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].balanceUserAccountInfo:__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccountInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__["a" /* default */],{title:accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].balanceUserAccountInfo:__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccountInfo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MyAccountInfoForm__["a" /* default */],null)));}}]);return MyAccountInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountInfo.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_12__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AccountStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','routeService')(MyAccountInfo)));

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountInfoForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_ContentForState__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateStatus={NONE:'NONE',REQUESTING:'REQUESTING',VALIDATION_ERROR:'VALIDATION_ERROR',SUCCESS:'SUCCESS',FIRSTNAME_NOT_VALID:'FIRSTNAME_NOT_VALID',LASTNAME_NOT_VALID:'LASTNAME_NOT_VALID',EMAIL_NOT_VALID:'EMAIL_NOT_VALID',TELEPHONE_NOT_VALID:'TELEPHONE_NOT_VALID',UNEXPECTED_ERROR:'UNEXPECTED_ERROR'};var MyAccountInfoForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(MyAccountInfoForm,_Component);function MyAccountInfoForm(props){_classCallCheck(this,MyAccountInfoForm);var _this=_possibleConstructorReturn(this,(MyAccountInfoForm.__proto__||Object.getPrototypeOf(MyAccountInfoForm)).call(this,props));_initialiseProps.call(_this);var configStore=_this.props.configStore;var fields={firstname:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["e" /* minLength */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].firstNameTitle),configStore.formValidation.firstName.minLength)]),lastname:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["e" /* minLength */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].lastNameTitle),configStore.formValidation.lastName.minLength)]),email:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].emailTitle)),Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["d" /* isEmail */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].emailTitle))]),telephone:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["e" /* minLength */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].telephoneTitle),configStore.formValidation.telephone.minLength)])};_this.form=Object(__WEBPACK_IMPORTED_MODULE_6__models_Form__["a" /* createForm */])(fields);return _this;}_createClass(MyAccountInfoForm,[{key:'componentDidMount',value:function componentDidMount(){this.maybeLoadAccountInfo();}},{key:'render',value:function render(){var _this2=this;var accountStore=this.props.accountStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_ContentForState__["a" /* default */],{state:accountStore.state,error:accountStore.lastError,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountInfoForm'},_this2.renderStatus(_this2.state.status),_this2.state.status!==null&&_this2.getForm());}});}}]);return MyAccountInfoForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this3=this;this._isMounted=false;this.form=null;this.state={status:UpdateStatus.NONE};this.maybeLoadAccountInfo=function(){var accountStore=_this3.props.accountStore;accountStore.loadAccount().then(function(){_this3.fieldInitialFill();}).catch(function(err){console.error(err);});};this.fieldInitialFill=function(){var accountStore=_this3.props.accountStore;_this3.form.fields.get('firstname').setValue(accountStore.account.personal_info.firstname);_this3.form.fields.get('lastname').setValue(accountStore.account.personal_info.lastname);_this3.form.fields.get('email').setValue(accountStore.account.personal_info.email);_this3.form.fields.get('telephone').setValue(accountStore.account.personal_info.telephone);_this3.form.validate();};this.handleSubmit=function(e){var apiWrapper=_this3.props.apiWrapper;e.preventDefault();_this3.form.validate();if(_this3.form.valid){_this3.setState({status:UpdateStatus.REQUESTING});apiWrapper.apiAxios().put('my-account/info',_this3.form.getFieldValues()).then(function(){_this3.setState({status:UpdateStatus.SUCCESS});}).catch(function(e){var status=e.response?e.response.status:500;var errorMap={400:UpdateStatus.VALIDATION_ERROR,409:UpdateStatus.EMAIL_EXISTS,422:UpdateStatus.VALIDATION_ERROR,500:UpdateStatus.UNEXPECTED_ERROR};_this3.setState({status:errorMap[status]});});}};this.getField=function(name,message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountInfoForm__field MyAccountInfoForm__field--'+name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_FormGroupField__["a" /* default */],{field:_this3.form.fields.get(name),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],message),formName:'MyAccountInfoForm',fieldName:name}));};this.getValue=function(value){if(!value||value.length===0){return'';}return value;};this.getForm=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{noValidate:true,onSubmit:_this3.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountInfoForm__row'},_this3.getField('firstname',__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].firstNameTitle),_this3.getField('lastname',__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].lastNameTitle),_this3.getField('email',__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].emailTitle),_this3.getField('telephone',__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].telephoneTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'MyAccountInfoForm__submit',color:'primary',disabled:_this3.form.valid===false||_this3.state.error===UpdateStatus.REQUESTING},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].update))))));};this.renderStatus=function(status){var configStore=_this3.props.configStore;var message=null;switch(status){case UpdateStatus.NONE:case UpdateStatus.REQUESTING:break;case UpdateStatus.SUCCESS:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.userInfo.SUCCESS',defaultMessage:'Your customer account information was updated successfully.'}));break;case UpdateStatus.VALIDATION_ERROR:// This is just in case, as it should actually never happen, because we validate the fields client side.
message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.userInfo.VALIDATION_ERROR',defaultMessage:'The information you entered is not valid. Please check the form.'}));break;case UpdateStatus.FIRSTNAME_NOT_VALID:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.userInfo.FIRSTNAME_NOT_VALID',defaultMessage:'The first name must contain at least {characterCount} characters.',values:{characterCount:configStore.formValidation.firstName.minLength}}));break;case UpdateStatus.LASTNAME_NOT_VALID:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.userInfo.LASTNAME_NOT_VALID',defaultMessage:'The last name must contain at least {characterCount} characters.',values:{characterCount:configStore.formValidation.lastName.minLength}}));break;case UpdateStatus.EMAIL_NOT_VALID:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.userInfo.EMAIL_NOT_VALID',defaultMessage:'Your e-mail address seems to have an incorrect format.'}));break;case UpdateStatus.TELEPHONE_NOT_VALID:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.userInfo.TELEPHONE_NOT_VALID',defaultMessage:'The phone number must contain at least {characterCount} characters.',values:{characterCount:configStore.formValidation.telephone.minLength}}));break;default:case UpdateStatus.UNEXPECTED_ERROR:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__loader_UnexpectedError__["a" /* default */],null);}return message;};},_temp))||_class;MyAccountInfoForm.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_12__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_12__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_AccountStore__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__services_ApiWrapper__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('apiWrapper','configStore','accountStore')(MyAccountInfoForm));

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountChangePassword */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MyAccountChangePasswordForm__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountChangePassword=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountChangePassword,_Component);function MyAccountChangePassword(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountChangePassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountChangePassword.__proto__||Object.getPrototypeOf(MyAccountChangePassword)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,accountStore=_this$props.accountStore,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccount),url:accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountBalanceUser:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccountChangePassword),url:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountChangePassword}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountChangePassword,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccountChangePassword}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountChangePassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccountChangePassword)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MyAccountChangePasswordForm__["a" /* default */],null)));}}]);return MyAccountChangePassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountChangePassword.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_12__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AccountStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4__services_RouteService__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','routeService')(MyAccountChangePassword)));

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountChangePasswordForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_RequestState__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateStatus={NONE:'NONE',REQUESTING:'REQUESTING',VALIDATION_ERROR:'VALIDATION_ERROR',SUCCESS:'SUCCESS',PASSWORD_NOT_VALID:'PASSWORD_NOT_VALID',PASSWORDS_DO_NOT_MATCH:'PASSWORDS_DO_NOT_MATCH',UNEXPECTED_ERROR:'UNEXPECTED_ERROR'};var MyAccountChangePasswordForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(MyAccountChangePasswordForm,_Component);function MyAccountChangePasswordForm(props){_classCallCheck(this,MyAccountChangePasswordForm);var _this=_possibleConstructorReturn(this,(MyAccountChangePasswordForm.__proto__||Object.getPrototypeOf(MyAccountChangePasswordForm)).call(this,props));_initialiseProps.call(_this);var configStore=_this.props.configStore;var fields={currentPassword:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["e" /* minLength */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].currentPasswordTitle),configStore.formValidation.password.minLength)]),newPassword:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["e" /* minLength */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].newPasswordTitle),configStore.formValidation.password.minLength)]),newPassword_confirmation:Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["f" /* mustMatch */])(function(){return _this.form.fields.get('newPassword').value;})])};_this.form=Object(__WEBPACK_IMPORTED_MODULE_6__models_Form__["a" /* createForm */])(fields);return _this;}_createClass(MyAccountChangePasswordForm,[{key:'render',value:function render(){var status=this.state.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountChangePasswordForm'},this.renderStatus(status),status!==UpdateStatus.SUCCESS&&this.getForm());}}]);return MyAccountChangePasswordForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.state={status:UpdateStatus.NONE,requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].NONE};this.handleSubmit=function(e){var apiWrapper=_this2.props.apiWrapper;e.preventDefault();_this2.form.validate();if(_this2.form.valid){_this2.setState({status:UpdateStatus.NONE,requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADING});apiWrapper.apiAxios().put('my-account/change-password',_this2.form.getFieldValues()).then(function(){_this2.setState({status:UpdateStatus.SUCCESS,requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].LOADED});}).catch(function(e){var status=e.response?e.response.status:500;var errorMap={400:UpdateStatus.VALIDATION_ERROR,422:UpdateStatus.PASSWORD_NOT_VALID,500:UpdateStatus.UNEXPECTED_ERROR};_this2.setState({status:errorMap[status],requestState:__WEBPACK_IMPORTED_MODULE_14__types_RequestState__["b" /* default */].ERROR});});}};this.getField=function(name,message,props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountChangePasswordForm__field MyAccountInfoForm__field--'+name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_FormGroupField__["a" /* default */],Object.assign({field:_this2.form.fields.get(name),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],message),formName:'MyAccountChangePasswordForm',fieldName:name},props)));};this.getForm=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{noValidate:true,onSubmit:_this2.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountChangePasswordForm__row'},_this2.getField('currentPassword',__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].currentPasswordTitle,{type:'password'}),_this2.getField('newPassword',__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].newPasswordTitle,{type:'password',autoComplete:'new-password'}),_this2.getField('newPassword_confirmation',__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].confirmPasswordTitle,{type:'password',autoComplete:'new-password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{className:'MyAccountChangePasswordForm__submit',color:'primary',disabled:_this2.form.valid===false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].update))))));};this.renderStatus=function(status){var message=null;switch(status){case UpdateStatus.NONE:case UpdateStatus.REQUESTING:break;case UpdateStatus.SUCCESS:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.password.SUCCESS',defaultMessage:'Your password was updated successfully.'}));break;case UpdateStatus.VALIDATION_ERROR:// This is just in case, as it should actually never happen, because we validate the fields client side.
message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.password.VALIDATION_ERROR',defaultMessage:'Information you provided is not valid. Please recheck the form.'}));break;case UpdateStatus.PASSWORD_NOT_VALID:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.password.PASSWORD_NOT_VALID',defaultMessage:'Your password does not match the password in our database. Please try again.'}));break;case UpdateStatus.PASSWORDS_DO_NOT_MATCH:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'account.password.PASSWORDS_DO_NOT_MATCH',defaultMessage:'The password confirmation text must match your chosen password.'}));break;default:case UpdateStatus.UNEXPECTED_ERROR:message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__loader_UnexpectedError__["a" /* default */],null);}return message;};},_temp))||_class;MyAccountChangePasswordForm.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_12__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__services_ApiWrapper__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('apiWrapper','configStore')(MyAccountChangePasswordForm));

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountAddressList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_AddressStore__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__address_AddressList__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({addressFilterPlaceholder:{'id':'address.addressFilterPlaceholder','defaultMessage':'Search for addresses'}});var MyAccountAddressList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountAddressList,_Component);function MyAccountAddressList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountAddressList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountAddressList.__proto__||Object.getPrototypeOf(MyAccountAddressList)).call.apply(_ref,[this].concat(args))),_this),_this.state={removeError:null,requestId:0,addressFilterString:''},_this.setAddressFilterString=function(newString){_this.setState(function(){return{addressFilterString:newString};});},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__["a" /* default */].addressBookTitle),url:__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MyAccountAddressList}]);},_this.removeAddress=function(addressId){var addressStore=_this.props.addressStore;addressStore.removeAddress(addressId).then(function(){addressStore.loadAddresses();_this.setState({removeError:null});}).catch(function(error){return _this.setState({removeError:error,requestId:_this.state.requestId+1});});},_this.navigateToAddress=function(addressId){var routeService=_this.props.routeService;var path=routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_15__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MyAccountAddress,{id:addressId}));return _this.props.history.push(path);},_this.renderAddressList=function(){var addressStore=_this.props.addressStore;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__address_AddressList__["a" /* default */],{addresses:addressStore.addressArray,onEditClick:_this.navigateToAddress,onRemoveClick:_this.removeAddress,filterString:_this.state.addressFilterString});},_this.renderError=function(){var _this$state=_this.state,removeError=_this$state.removeError,requestId=_this$state.requestId;var errors=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(removeError,'response.data.errors');return errors?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Alert */],{className:'MyAccountAddressList__errors',color:'danger',key:requestId},Object.values(removeError.response.data.errors).map(function(message){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__loader_UnexpectedError__["a" /* default */],null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountAddressList,[{key:'componentDidMount',value:function componentDidMount(){var addressStore=this.props.addressStore;addressStore.loadAddresses();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,addressStore=_props.addressStore,routeService=_props.routeService,intl=_props.intl,accountStore=_props.accountStore;var removeError=this.state.removeError;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountAddressList'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__["a" /* default */].addressBookTitle}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__["a" /* default */].addressBookTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountAddressList__tools'},(accountStore.isUserAllowedAddressModification||!accountStore.isCustomerUser)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountAddressList__tools-add-new'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Link */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_16__types_Paths__["a" /* default */].MyAccountAddressNew)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["e" /* Button */],{color:'primary',className:'MyAccountAddressList__tools-add-new-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__["a" /* default */].addNewAddressTitle)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountAddressList__tools-filter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["w" /* InputGroup */],{className:'MyAccountAddressList__tools-filter-group btn-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Input */],{value:this.state.addressFilterString,onChange:function onChange(e){return _this2.setAddressFilterString(e.target.value);},placeholder:intl.formatMessage(messages.addressFilterPlaceholder)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["e" /* Button */],{onClick:function onClick(){return _this2.setAddressFilterString('');},className:'MyAccountAddressList__tools-filter-button',block:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_18__i18n_globalTranslations__["a" /* default */].clearTitle))))),removeError&&this.renderError(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_ContentForState__["a" /* default */],{state:addressStore.state,error:addressStore.lastError,forLoaded:function forLoaded(){return _this2.renderAddressList();}}));}}]);return MyAccountAddressList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MyAccountAddressList.propTypes={addressStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_AddressStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.history.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_19__services_RouteService__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_AccountStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('addressStore','routeService','accountStore')(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(MyAccountAddressList))));

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddressList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddressInfo__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Address__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_SHOW_ADDRESSES_COUNT=5;var AddressList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AddressList,_Component);function AddressList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddressList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddressList.__proto__||Object.getPrototypeOf(AddressList)).call.apply(_ref,[this].concat(args))),_this),_this.state={showAllAddresses:false},_this.toggleShowAllAddresses=function(){_this.setState(function(state){return{showAllAddresses:!state.showAllAddresses};});},_this.getFilteredAddresses=function(){var _this$props=_this.props,addresses=_this$props.addresses,filterString=_this$props.filterString;return addresses.filter(function(address){return address.postal_code.includes(filterString)||address.firstname.toLowerCase().includes(filterString)||address.lastname.toLowerCase().includes(filterString)||address.company.toLowerCase().includes(filterString)||address.street_address.toLowerCase().includes(filterString)||address.city.toLowerCase().includes(filterString)||address.telephone.toLowerCase().includes(filterString);});},_this.renderAddressCard=function(address){var _this$props2=_this.props,onRemoveClick=_this$props2.onRemoveClick,onEditClick=_this$props2.onEditClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["h" /* Card */],{className:'AddressList__item',key:address.id,color:address.is_primary?'info':'default',outline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["g" /* ButtonGroup */],{className:'AddressList__item-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{onClick:function onClick(){return onEditClick(address.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].editTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{onClick:function onClick(){return window.confirm(_this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].confirmRemoveTitle))&&onRemoveClick(address.id);},color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].removeTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AddressInfo__["a" /* default */],{address:address}),address.is_primary&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddressList__item-primary-notice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'address.primaryNotice',defaultMessage:'This address is used as your default delivery and billing address in your orders.'}))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddressList,[{key:'render',value:function render(){var _this2=this;var filtered=this.getFilteredAddresses();var visibleAddresses=this.state.showAllAddresses?filtered:filtered.slice(0,DEFAULT_SHOW_ADDRESSES_COUNT);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddressList'},visibleAddresses.map(function(address){return _this2.renderAddressCard(address);}),filtered.length>visibleAddresses.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddressList__show-all-addresses'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{onClick:this.toggleShowAllAddresses,color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'address.showAllAddressesButton',defaultMessage:'Show all addresses'}))));}}]);return AddressList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AddressList.propTypes={addresses:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Address__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_Address__["a" /* default */]))]).isRequired,onRemoveClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onEditClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,filterString:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired};AddressList.defaultProps={filterString:''};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(AddressList));

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddressInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Address__ = __webpack_require__(202);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddressInfo=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(AddressInfo,_Component);function AddressInfo(){_classCallCheck(this,AddressInfo);return _possibleConstructorReturn(this,(AddressInfo.__proto__||Object.getPrototypeOf(AddressInfo)).apply(this,arguments));}_createClass(AddressInfo,[{key:'render',value:function render(){var address=this.props.address;var name=address.company.length>0?address.firstname.length>0||address.lastname.length>0?address.company+', '+address.lastname+' '+address.firstname:''+address.company:address.lastname+' '+address.firstname;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddressInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddressInfo__name'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddressInfo__address'},address.street_address&&address.street_address+', ',address.postal_code,' ',address.city,address.country&&', '+address.country.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddressInfo__phone'},address.telephone));}}]);return AddressInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;AddressInfo.propTypes={address:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__models_Address__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (AddressInfo);

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountAddressNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_AddressStore__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__address_AddressForm__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_HelperNavigation__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountAddressNew=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountAddressNew,_Component);function MyAccountAddressNew(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountAddressNew);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountAddressNew.__proto__||Object.getPrototypeOf(MyAccountAddressNew)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false,error:null,requestId:0},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_17__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].addressBookTitle),url:__WEBPACK_IMPORTED_MODULE_17__types_Paths__["a" /* default */].MyAccountAddressList},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].addNewAddressTitle),url:__WEBPACK_IMPORTED_MODULE_17__types_Paths__["a" /* default */].MyAccountAddressNew}]);},_this.saveAddress=function(address){var addressStore=_this.props.addressStore;_this.setState({loading:true});addressStore.saveAddress(address).then(function(){_this.setState({error:null,loading:false});addressStore.loadAddresses();_this.navigateToAddressList();}).catch(function(error){return _this.setState({error:error,requestId:_this.state.requestId+1,loading:false});});},_this.renderError=function(){var _this$state=_this.state,error=_this$state.error,requestId=_this$state.requestId;var status=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error,'response.status');return status===422?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Alert */],{className:'MyAccountAddressNew__errors',color:'danger',key:requestId},__WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default()(Object.values(error.response.data)).map(function(message){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_UnexpectedError__["a" /* default */],null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountAddressNew,[{key:'navigateToAddressList',value:function navigateToAddressList(){var _props=this.props,history=_props.history,routeService=_props.routeService;history.push(routeService.getPath(__WEBPACK_IMPORTED_MODULE_17__types_Paths__["a" /* default */].MyAccountAddressList));}},{key:'render',value:function render(){var _state=this.state,error=_state.error,loading=_state.loading;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MyAccountAddressNew'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].addNewAddressTitle}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].addNewAddressTitle)),error&&this.renderError(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__address_AddressForm__["a" /* default */],{onSubmit:this.saveAddress,loading:loading,buttonText:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].addNewAddressTitle)}));}}]);return MyAccountAddressNew;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;MyAccountAddressNew.propTypes={addressStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_AddressStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.history.isRequired,intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_16__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('addressStore','routeService')(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(MyAccountAddressNew))));

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountAddress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AddressStore__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__address_AddressForm__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_generatePath__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({updateAddress:{'id':'myAccount.updateAddress','defaultMessage':'Update Address'}});var MyAccountAddress=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountAddress,_Component);function MyAccountAddress(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountAddress);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountAddress.__proto__||Object.getPrototypeOf(MyAccountAddress)).call.apply(_ref,[this].concat(args))),_this),_this.state={updateError:null,requestId:0},_this.maybeLoadAddress=function(){var addressStore=_this.props.addressStore;var address=_this.getActiveAddress();if(!address){addressStore.loadAddress(_this.getActiveAddressId()).catch(function(e){console.error(e);});}},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].addressBookTitle),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountAddressList},{text:intl.formatMessage(messages.updateAddress),url:Object(__WEBPACK_IMPORTED_MODULE_19__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountAddress,{id:_this.getActiveAddressId()})}]);},_this.getActiveAddressId=function(){var match=_this.props.match;return match.params.id;},_this.getActiveAddress=function(){var addressStore=_this.props.addressStore;return addressStore.addresses.get(_this.getActiveAddressId());},_this.updateAddress=function(address){var addressStore=_this.props.addressStore;addressStore.updateAddress(_this.getActiveAddressId(),address).then(function(){_this.setState({updateError:null});addressStore.loadAddresses();_this.navigateToAddressList();}).catch(function(error){return _this.setState({updateError:error,requestId:_this.state.requestId+1});});},_this.renderAddressForm=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__address_AddressForm__["a" /* default */],{address:_this.getActiveAddress(),onSubmit:_this.updateAddress,buttonText:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].update)});},_this.renderError=function(){var _this$state=_this.state,updateError=_this$state.updateError,requestId=_this$state.requestId;var errors=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(updateError,'response.data.errors');return errors?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{className:'MyAccountAddress__errors',color:'danger',key:requestId},Object.values(updateError.response.data.errors).map(function(message){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__loader_UnexpectedError__["a" /* default */],null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountAddress,[{key:'componentDidMount',value:function componentDidMount(){this.maybeLoadAddress();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var match=this.props.match;if(prevProps.match.params.id!==match.params.id){this.maybeLoadAddress();}}},{key:'navigateToAddressList',value:function navigateToAddressList(){var _props=this.props,history=_props.history,routeService=_props.routeService;history.push(routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountAddressList));}},{key:'render',value:function render(){var _this2=this;var addressStore=this.props.addressStore;var updateError=this.state.updateError;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountAddress'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__["a" /* default */],{title:messages.updateAddress}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],messages.updateAddress)),updateError&&this.renderError(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__loader_ContentForState__["a" /* default */],{state:addressStore.addressStates.get(this.getActiveAddressId()),error:addressStore.lastError,forLoaded:function forLoaded(){return _this2.renderAddressForm();}}));}}]);return MyAccountAddress;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MyAccountAddress.propTypes={addressStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AddressStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.history.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,match:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.match.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_17__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('addressStore','routeService')(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(MyAccountAddress))));

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountUserList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__user_UserList__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__types_RequestState__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountUserList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountUserList,_Component);function MyAccountUserList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountUserList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountUserList.__proto__||Object.getPrototypeOf(MyAccountUserList)).call.apply(_ref,[this].concat(args))),_this),_this.state={removeError:null,requestId:0,listState:__WEBPACK_IMPORTED_MODULE_22__types_RequestState__["b" /* default */].NONE,paymentAmount:[],paymentInProgress:false},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].userListTitle),url:__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].MyAccountUserList}]);},_this.removeUser=function(id){var customerUserStore=_this.props.customerUserStore;customerUserStore.removeUser(id).then(function(){customerUserStore.loadUsers();_this.setState({removeError:null});}).catch(function(error){return _this.setState({removeError:error,requestId:_this.state.requestId+1});});},_this.navigateToUser=function(id){var routeService=_this.props.routeService;var path=routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_17__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].MyAccountUser,{id:id}));return _this.props.history.push(path);},_this.renderUserList=function(){var customerUserStore=_this.props.customerUserStore;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__user_UserList__["a" /* default */],{users:customerUserStore.userArray,onEditClick:_this.navigateToUser,onRemoveClick:_this.removeUser,onPayment:function onPayment(){return null;},showBalance:false});},_this.renderError=function(){var _this$state=_this.state,removeError=_this$state.removeError,requestId=_this$state.requestId;var errors=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(removeError,'response.data.errors');return errors?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Alert */],{className:'MyAccountUserList__errors',color:'danger',key:requestId},Object.values(removeError.response.data.errors).map(function(message){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__loader_UnexpectedError__["a" /* default */],null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountUserList,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var customerUserStore=this.props.customerUserStore;this.setState({listState:__WEBPACK_IMPORTED_MODULE_22__types_RequestState__["b" /* default */].LOADING});customerUserStore.loadUsers().then(function(){_this2.setState({listState:__WEBPACK_IMPORTED_MODULE_22__types_RequestState__["b" /* default */].LOADED});}).catch(function(){_this2.setState({listState:__WEBPACK_IMPORTED_MODULE_22__types_RequestState__["b" /* default */].ERROR});});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,customerUserStore=_props.customerUserStore,routeService=_props.routeService;var removeError=this.state.removeError;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountUserList'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].userListTitle}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].userListTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].MyAccountUserNew)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["e" /* Button */],{color:'primary',className:'MyAccountUserList__add-new-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].addNewUserTitle))),removeError&&this.renderError(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__loader_ContentForState__["a" /* default */],{state:this.state.listState,error:customerUserStore.lastError,forLoaded:function forLoaded(){return _this3.renderUserList();}}));}}]);return MyAccountUserList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MyAccountUserList.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_AccountStore__["a" /* default */]).isRequired,customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_CustomerUserStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.history.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('customerUserStore','routeService','accountStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* withRouter */])(MyAccountUserList))));

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_CustomerUser__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserInfo__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_BalanceUser__ = __webpack_require__(174);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(UserList,_Component);function UserList(){_classCallCheck(this,UserList);return _possibleConstructorReturn(this,(UserList.__proto__||Object.getPrototypeOf(UserList)).apply(this,arguments));}_createClass(UserList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,users=_props.users,onRemoveClick=_props.onRemoveClick,onEditClick=_props.onEditClick,showBalance=_props.showBalance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UserList'},users.map(function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Card */],{className:'UserList__item',key:user.id,outline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* ButtonGroup */],{className:'UserList__item-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{onClick:function onClick(){return onEditClick(user.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].editTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{onClick:function onClick(){return window.confirm(_this2.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].confirmRemoveTitle))&&onRemoveClick(user.id);},color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].removeTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__UserInfo__["a" /* default */],{user:user,showBalance:showBalance})));}));}}]);return UserList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;UserList.propTypes={users:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_CustomerUser__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_1_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_BalanceUser__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_CustomerUser__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__models_BalanceUser__["a" /* default */]))]).isRequired,onRemoveClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onEditClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onPayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onQuantityUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,showBalance:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(UserList));

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_CustomerUser__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_BalanceUser__ = __webpack_require__(174);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserInfo=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(UserInfo,_Component);function UserInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserInfo.__proto__||Object.getPrototypeOf(UserInfo)).call.apply(_ref,[this].concat(args))),_this),_this.renderActiveStatus=function(){var user=_this.props.user;return user.is_active?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UserInfo__status-active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'userInfo.active',defaultMessage:'Username is active'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UserInfo__status-passive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'userInfo.notInUse',defaultMessage:'Username is not active'}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserInfo,[{key:'render',value:function render(){var _props=this.props,user=_props.user,showBalance=_props.showBalance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UserInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,user.firstname,' ',user.lastname),user.login_name&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,user.login_name),user.email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,user.email),user.telephone&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,user.telephone),showBalance&&user.account_balance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__product_Price__["a" /* default */],{price:user.account_balance}),this.renderActiveStatus());}}]);return UserInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;UserInfo.propTypes={user:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__models_CustomerUser__["a" /* default */]).isRequired,Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_BalanceUser__["a" /* default */]).isRequired]),showBalance:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (UserInfo);

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountUserNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__user_UserForm__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__user_BalanceUserForm__ = __webpack_require__(591);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customerUserBreadcrumbs=[{text:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccount},{text:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].userListTitle),url:__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUserList},{text:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].addNewUserTitle),url:__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUserNew}];var balanceUserBreadcrumbs=[{text:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountBalanceUser}];var MyAccountUserNew=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountUserNew,_Component);function MyAccountUserNew(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountUserNew);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountUserNew.__proto__||Object.getPrototypeOf(MyAccountUserNew)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false,error:null,requestId:0},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,routeService=_this$props.routeService,accountStore=_this$props.accountStore;var breadcrumbs=accountStore.isBalanceBuyer?balanceUserBreadcrumbs:customerUserBreadcrumbs;return routeService.transformBreadCrumbs(breadcrumbs);},_this.saveCustomerUser=function(user){var customerUserStore=_this.props.customerUserStore;_this.setState({loading:true});user.isActive=!!user.isActive;user.notifyUser=!!user.notifyUser;user.allowUserCreateAddress=!!user.allowUserCreateAddress;customerUserStore.saveUser(user).then(function(){_this.setState({error:null,loading:false});customerUserStore.loadUsers();_this.navigateToCustomerUserList();}).catch(function(error){return _this.setState({error:error,requestId:_this.state.requestId+1,loading:false});});},_this.saveBalanceUser=function(user){var customerUserStore=_this.props.customerUserStore;_this.setState({loading:true});customerUserStore.saveBalanceUser(user).then(function(){_this.setState({error:null,loading:false});customerUserStore.loadBalanceUsers();_this.navigateToBalanceUserList();}).catch(function(error){return _this.setState({error:error,requestId:_this.state.requestId+1,loading:false});});},_this.renderError=function(){var _this$state=_this.state,error=_this$state.error,requestId=_this$state.requestId;var status=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error,'response.status');return status===422?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Alert */],{className:'MyAccountUserNew__errors',color:'danger',key:requestId},__WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default()(Object.values(error.response.data)).map(function(message){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__loader_UnexpectedError__["a" /* default */],null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountUserNew,[{key:'navigateToCustomerUserList',value:function navigateToCustomerUserList(){var _props=this.props,history=_props.history,routeService=_props.routeService;history.push(routeService.getPath(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUserList));}},{key:'navigateToBalanceUserList',value:function navigateToBalanceUserList(){var _props2=this.props,history=_props2.history,routeService=_props2.routeService;history.push(routeService.getPath(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountBalanceUser));}},{key:'render',value:function render(){var accountStore=this.props.accountStore;var _state=this.state,error=_state.error,loading=_state.loading;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MyAccountUserNew'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].addNewUserTitle}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].addNewUserTitle)),error&&this.renderError(),accountStore&&accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__user_BalanceUserForm__["a" /* default */],{loading:loading,buttonText:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].addNewUserTitle),onSubmit:this.saveBalanceUser}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__user_UserForm__["a" /* default */],{loading:loading,buttonText:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].addNewUserTitle),onSubmit:this.saveCustomerUser}));}}]);return MyAccountUserNew;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;MyAccountUserNew.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_CustomerUserStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.history.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14__services_RouteService__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_AccountStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','customerUserStore','routeService','accountStore')(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* withRouter */])(MyAccountUserNew)));

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__user_UserForm__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__user_BalanceUserForm__ = __webpack_require__(591);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({updateUser:{'id':'myAccount.updateUser','defaultMessage':'Update User'}});var MyAccountUser=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountUser,_Component);function MyAccountUser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountUser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountUser.__proto__||Object.getPrototypeOf(MyAccountUser)).call.apply(_ref,[this].concat(args))),_this),_this.state={updateError:null,requestId:0},_this.loadUserAccountType=function(){var accountStore=_this.props.accountStore;if(accountStore.isBalanceBuyer){_this.maybeLoadBalanceUser();}else{_this.maybeLoadUser();}},_this.maybeLoadUser=function(){var customerUserStore=_this.props.customerUserStore;var user=_this.getActiveUser();if(!user){customerUserStore.loadUser(_this.getActiveUserId()).catch(function(e){return console.error(e);});}},_this.maybeLoadBalanceUser=function(){var customerUserStore=_this.props.customerUserStore;var user=_this.getActiveUser();if(!user){customerUserStore.loadBalanceUser(_this.getActiveUserId()).catch(function(e){return console.error(e);});}},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].userListTitle),url:__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccountUserList},{text:intl.formatMessage(messages.updateUser),url:Object(__WEBPACK_IMPORTED_MODULE_17__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccountUser,{id:_this.getActiveUserId()})}]);},_this.getActiveUserId=function(){var match=_this.props.match;return match.params.id;},_this.getActiveUser=function(){var _this$props2=_this.props,customerUserStore=_this$props2.customerUserStore,accountStore=_this$props2.accountStore;return accountStore.isBalanceBuyer?customerUserStore.balanceUsers.get(_this.getActiveUserId()):customerUserStore.users.get(_this.getActiveUserId());},_this.updateCustomerUser=function(user){var customerUserStore=_this.props.customerUserStore;user.isActive=!!user.isActive;user.notifyUser=!!user.notifyUser;user.allowUserCreateAddress=!!user.allowUserCreateAddress;customerUserStore.updateUser(_this.getActiveUserId(),user).then(function(){_this.setState({updateError:null});customerUserStore.loadUsers();_this.navigateToUserList();}).catch(function(error){return _this.setState({updateError:error,requestId:_this.state.requestId+1});});},_this.updateBalanceUser=function(user){var customerUserStore=_this.props.customerUserStore;user.isActive=!!user.isActive;user.notifyUser=!!user.notifyUser;customerUserStore.updateBalanceUser(_this.getActiveUserId(),user).then(function(){_this.setState({updateError:null});customerUserStore.loadBalanceUsers();_this.navigateToBalanceUserList();}).catch(function(error){return _this.setState({updateError:error,requestId:_this.state.requestId+1});});},_this.renderUserForm=function(){var accountStore=_this.props.accountStore;return accountStore.isBalanceBuyer?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__user_BalanceUserForm__["a" /* default */],{user:_this.getActiveUser(),onSubmit:_this.updateBalanceUser,buttonText:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].update)}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__user_UserForm__["a" /* default */],{user:_this.getActiveUser(),onSubmit:_this.updateCustomerUser,buttonText:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].update)});},_this.renderError=function(){var _this$state=_this.state,updateError=_this$state.updateError,requestId=_this$state.requestId;var errors=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(updateError,'response.data');return errors?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{className:'MyAccountUser__errors',color:'danger',key:requestId},Object.values(updateError.response.data).map(function(message){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_UnexpectedError__["a" /* default */],null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountUser,[{key:'componentDidMount',value:function componentDidMount(){this.loadUserAccountType();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var match=this.props.match;if(prevProps.match.params.id!==match.params.id){this.loadUserAccountType();}}},{key:'navigateToUserList',value:function navigateToUserList(){var _props=this.props,history=_props.history,routeService=_props.routeService;history.push(routeService.getPath(__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccountUserList));}},{key:'navigateToBalanceUserList',value:function navigateToBalanceUserList(){var _props2=this.props,history=_props2.history,routeService=_props2.routeService;history.push(routeService.getPath(__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccountBalanceUser));}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,customerUserStore=_props3.customerUserStore,accountStore=_props3.accountStore;var updateError=this.state.updateError;var accountTypeState=accountStore.isBalanceBuyer?customerUserStore.balanceUserStates.get(this.getActiveUserId()):customerUserStore.userStates.get(this.getActiveUserId());return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountUser'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__["a" /* default */],{title:messages.updateUser}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],messages.updateUser)),updateError&&this.renderError(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__loader_ContentForState__["a" /* default */],{state:accountTypeState,error:customerUserStore.lastError,forLoaded:function forLoaded(){return _this2.renderUserForm();}}));}}]);return MyAccountUser;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MyAccountUser.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_AccountStore__["a" /* default */]).isRequired,customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_CustomerUserStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.history.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,match:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.match.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_15__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('customerUserStore','routeService','accountStore')(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(MyAccountUser))));

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountPurchasesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__purchase_MainPurchaseList__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountPurchasesList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountPurchasesList,_Component);function MyAccountPurchasesList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountPurchasesList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountPurchasesList.__proto__||Object.getPrototypeOf(MyAccountPurchasesList)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].purchasesListTitle),url:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountPurchasesList}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountPurchasesList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].purchasesListTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].purchasesListTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountPurchasesList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__purchase_MainPurchaseList__["a" /* default */],null)));}}]);return MyAccountPurchasesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountPurchasesList.propTypes={intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService')(MyAccountPurchasesList)));

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MainPurchaseList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseReportForm__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseList__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_query__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainPurchaseList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MainPurchaseList,_Component);function MainPurchaseList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MainPurchaseList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MainPurchaseList.__proto__||Object.getPrototypeOf(MainPurchaseList)).call.apply(_ref,[this].concat(args))),_this),_this.state={searchParams:{startDate:null,endDate:null}},_this.getQueryParameters=function(){var _this$state$searchPar=_this.state.searchParams,startDate=_this$state$searchPar.startDate,endDate=_this$state$searchPar.endDate;return startDate&&endDate?_this.state.searchParams:null;},_this.getQueryIdentifier=function(){return Object(__WEBPACK_IMPORTED_MODULE_9__util_query__["a" /* paramsToQueryIdentifier */])(_this.getQueryParameters());},_this.handleSubmit=function(searchParams){var customerUserStore=_this.props.customerUserStore;_this.setState({searchParams:searchParams});customerUserStore.loadPurchases(searchParams);},_this.renderPurchaseForm=function(){var customerUserStore=_this.props.customerUserStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PurchaseReportForm__["a" /* default */],{onSubmit:_this.handleSubmit,disableSubmit:customerUserStore.purchaseQueryStates.get(_this.getQueryIdentifier())===__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["b" /* default */].LOADING});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MainPurchaseList,[{key:'render',value:function render(){var _this2=this;var customerUserStore=this.props.customerUserStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MainPurchaseList'},this.renderPurchaseForm(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__["a" /* default */],{state:customerUserStore.purchaseQueryStates.get(this.getQueryIdentifier()),forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PurchaseList__["a" /* default */],{searchParams:_this2.getQueryParameters()});}}));}}]);return MainPurchaseList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MainPurchaseList.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_CustomerUserStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('customerUserStore')(MainPurchaseList)));

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_FormField__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={startDate:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].startDateTitle),endDate:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].endDateTitle)};var PurchaseReportForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PurchaseReportForm,_Component);function PurchaseReportForm(props){_classCallCheck(this,PurchaseReportForm);var _this=_possibleConstructorReturn(this,(PurchaseReportForm.__proto__||Object.getPrototypeOf(PurchaseReportForm)).call(this,props));_this.form=null;_this.formName='PurchaseReportForm';_this.handleSubmit=function(e){e.preventDefault();_this.form.validate();if(_this.form.valid&&_this.props.onSubmit){_this.props.onSubmit(_this.form.getFieldValues());}};_this.date=function(fieldName){var field=_this.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseReportForm__field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_FormGroupField__["a" /* default */],{field:field,type:'date',required:true,formName:_this.formName,fieldName:fieldName,label:labels[fieldName]}));};_this.form=Object(__WEBPACK_IMPORTED_MODULE_6__models_Form__["a" /* createForm */])({startDate:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:props.initialStartDate?props.initialStartDate:__WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].local().startOf('month').toISODate()},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(labels.startDate),Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["c" /* isDate */])(labels.startDate)]),endDate:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({value:props.initialEndDate?props.initialEndDate:__WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].local().endOf('month').toISODate()},[Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["g" /* notBlank */])(labels.endDate),Object(__WEBPACK_IMPORTED_MODULE_8__util_formValidators__["c" /* isDate */])(labels.endDate)])});return _this;}_createClass(PurchaseReportForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{className:this.formName,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseReportForm__row'},this.date('startDate'),this.date('endDate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseReportForm__submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{color:'primary',disabled:this.form.valid===false||this.props.disableSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'customerUser.fetchPurchases',defaultMessage:'Fetch purchases'})))));}}]);return PurchaseReportForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PurchaseReportForm.propTypes={onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disableSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,initialStartDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,initialEndDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PurchaseReportForm);

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PurchaseList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PurchaseTotal__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_HashTabs__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseProductList__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseTabTitle__ = __webpack_require__(1408);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PurchaseList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PurchaseList,_Component);function PurchaseList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseList.__proto__||Object.getPrototypeOf(PurchaseList)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeTabId:null},_this.getQueryIdentifier=function(searchParams){return Object(__WEBPACK_IMPORTED_MODULE_11__util_query__["a" /* paramsToQueryIdentifier */])(searchParams);},_this.renderHeaders=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseList__headers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchaseUserHeader)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchaseOrderCountHeader)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchaseWithVatHeader)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchaseWithoutVatHeader))));},_this.setActiveId=function(id){_this.setState({activeTabId:id});},_this.getActiveId=function(){return _this.state.activeTabId;},_this.toggleTab=function(tabId){if(_this.state.activeTabId!==tabId){_this.setActiveId(tabId);}else{_this.setActiveId(null);}},_this.getTabs=function(){var _this$props=_this.props,customerUserStore=_this$props.customerUserStore,searchParams=_this$props.searchParams;var tabs=[];customerUserStore.purchaseQueryResults.get(_this.getQueryIdentifier(searchParams)).purchases.map(function(purchase){return tabs.push(Object(__WEBPACK_IMPORTED_MODULE_12__common_HashTabs__["a" /* createHashTab */])(purchase.user_id.toString(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PurchaseTabTitle__["a" /* default */],{key:purchase.user_id,purchase:purchase,searchParams:searchParams}),function(){return _this.renderProductList(purchase);}));});return tabs;},_this.renderProductList=function(purchase){var searchParams=_this.props.searchParams;if(_this.getActiveId()!==purchase.user_id.toString()){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PurchaseProductList__["a" /* default */],{searchParams:searchParams,currency:purchase.currency,userId:purchase.user_id.toString()});},_this.renderAccordionRows=function(){var tabs=_this.getTabs();var activeTabId=_this.getActiveId();return tabs.map(function(tab){var isOpen=activeTabId===tab.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('PurchaseList__tab',{'PurchaseList__tab--open':isOpen}),key:tab.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseList__tab-toggle',onClick:function onClick(){return _this.toggleTab(tab.id);}},tab.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["m" /* Collapse */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseList__tab-content'},tab.getContent())));});},_this.renderPurchaseRows=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseList__tabs'},_this.renderAccordionRows());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseList,[{key:'render',value:function render(){var _props=this.props,customerUserStore=_props.customerUserStore,uiStore=_props.uiStore,searchParams=_props.searchParams;var purchaseList=customerUserStore.purchaseQueryResults.get(this.getQueryIdentifier(searchParams));if(!purchaseList||purchaseList.purchases.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseList__no_results'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].myAccountNoPurchases));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseList'},!uiStore.isMobile&&this.renderHeaders(),this.renderPurchaseRows(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PurchaseTotal__["a" /* default */],{total:purchaseList.total}));}}]);return PurchaseList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PurchaseList.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_CustomerUserStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_UIStore__["a" /* default */]).isRequired,searchParams:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('customerUserStore','uiStore')(PurchaseList));

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PurchaseTotal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TotalHeaders={title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].totalPriceSentence),count:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].purchaseOrderCountHeader),withVat:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].purchaseWithVatHeader),withoutVat:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].purchaseWithoutVatHeader)};var PurchaseTotal=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PurchaseTotal,_Component);function PurchaseTotal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseTotal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseTotal.__proto__||Object.getPrototypeOf(PurchaseTotal)).call.apply(_ref,[this].concat(args))),_this),_this.renderValue=function(total,withCurrency){return total.map(function(totalValue){var currency=withCurrency?' '+totalValue.currency:'';return totalValue.value+currency;});},_this.renderTotalHeaderCol=function(label,sizes){var actualSizes=Object.assign({xs:4},sizes);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],Object.assign({className:'PurchaseTotal__total-header'},actualSizes),label);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseTotal,[{key:'render',value:function render(){var total=this.props.total;var isMobile=this.props.uiStore.isMobile;if(total.order_count.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTotal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{className:'PurchaseTotal__row'},isMobile&&this.renderTotalHeaderCol(TotalHeaders.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'8',md:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTotal__total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__i18n_globalTranslations__["a" /* default */].totalPriceSentence))),isMobile&&this.renderTotalHeaderCol(TotalHeaders.count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'8',md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTotal__totalOrderCount'},this.renderValue(total.order_count,false))),isMobile&&this.renderTotalHeaderCol(TotalHeaders.withVat),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'8',md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTotal__totalWithVat'},this.renderValue(total.with_tax,true))),isMobile&&this.renderTotalHeaderCol(TotalHeaders.withoutVat),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'8',md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTotal__totalWithoutVat'},this.renderValue(total.without_tax,true)))));}}]);return PurchaseTotal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PurchaseTotal.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_6__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_UIStore__["a" /* default */]).isRequired,total:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('uiStore')(PurchaseTotal));

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PurchaseProductList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseProductItem__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_UIStore__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PurchaseProductList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PurchaseProductList,_Component);function PurchaseProductList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseProductList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseProductList.__proto__||Object.getPrototypeOf(PurchaseProductList)).call.apply(_ref,[this].concat(args))),_this),_this.loadPurchaseProducts=function(){var _this$props=_this.props,customerUserStore=_this$props.customerUserStore,userId=_this$props.userId;if(userId!==undefined&&!_this.getCurrentResult()&&customerUserStore.productQueryStates.get(_this.getQueryIdentifier())!==__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING){customerUserStore.loadPurchaseProducts(_this.getQueryParameters());}},_this.getQueryParameters=function(){var _this$props2=_this.props,userId=_this$props2.userId,searchParams=_this$props2.searchParams,currency=_this$props2.currency;return{userId:userId,startDate:searchParams.startDate,endDate:searchParams.endDate,currency:currency};},_this.getQueryIdentifier=function(){return Object(__WEBPACK_IMPORTED_MODULE_7__util_query__["a" /* paramsToQueryIdentifier */])(_this.getQueryParameters());},_this.getCurrentResult=function(){return _this.props.customerUserStore.productQueryResults.get(_this.getQueryIdentifier());},_this.renderHeaders=function(){var isMobile=_this.props.uiStore.isMobile;if(isMobile){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'PurchaseProductList__headers'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].productTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{md:'2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].quantityTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{md:'2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].sumWithVat)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{md:'2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].sumWithoutVat))));},_this.renderProducts=function(){var products=_this.getCurrentResult();return products.map(function(product){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PurchaseProductItem__["a" /* default */],{key:product.id,purchaseProduct:product});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseProductList,[{key:'componentDidMount',value:function componentDidMount(){this.loadPurchaseProducts();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.userId,this.props.userId)||!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.currency,this.props.currency)||!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.searchParams,this.getQueryParameters())){this.loadPurchaseProducts();}}},{key:'render',value:function render(){var _this2=this;var customerUserStore=this.props.customerUserStore;var state=customerUserStore.productQueryStates.get(this.getQueryIdentifier());return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'PurchaseProductList'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:state,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,_this2.renderHeaders(),_this2.renderProducts());}}));}}]);return PurchaseProductList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;PurchaseProductList.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_CustomerUserStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_UIStore__["a" /* default */]).isRequired,currency:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,searchParams:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,userId:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('customerUserStore','uiStore')(PurchaseProductList)));

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PurchaseProductItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_PurchaseProduct__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_MaybeExternalLink__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductHeaders={product:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].productTitle),count:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].quantityTitle),withVat:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].sumWithVat),withoutVat:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].sumWithoutVat)};var PurchaseProductItem=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PurchaseProductItem,_Component);function PurchaseProductItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseProductItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseProductItem.__proto__||Object.getPrototypeOf(PurchaseProductItem)).call.apply(_ref,[this].concat(args))),_this),_this.renderProductHeaderCol=function(label,sizes){var actualSizes=Object.assign({xs:4},sizes);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],Object.assign({className:'PurchaseProductItem__product-header'},actualSizes),label);},_this.renderProductLink=function(){var purchaseProduct=_this.props.purchaseProduct;if(purchaseProduct&&purchaseProduct.url){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_MaybeExternalLink__["a" /* default */],{to:purchaseProduct.url},purchaseProduct.name);}else{return purchaseProduct.name;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseProductItem,[{key:'render',value:function render(){var purchaseProduct=this.props.purchaseProduct;var isMobile=this.props.uiStore.isMobile;if(!purchaseProduct){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseProductItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{className:'PurchaseProductItem__row'},isMobile&&this.renderProductHeaderCol(ProductHeaders.product),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'8',md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseProductItem__name'},this.renderProductLink())),isMobile&&this.renderProductHeaderCol(ProductHeaders.count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'8',md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseProductItem__count'},purchaseProduct.total_qty)),isMobile&&this.renderProductHeaderCol(ProductHeaders.withVat),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'8',md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseProductItem__sumWithVat',dangerouslySetInnerHTML:{__html:purchaseProduct.total_sum_with_tax}})),isMobile&&this.renderProductHeaderCol(ProductHeaders.withoutVat),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{xs:'8',md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseProductItem__sumWithoutVat',dangerouslySetInnerHTML:{__html:purchaseProduct.total_sum_without_tax}}))));}}]);return PurchaseProductItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PurchaseProductItem.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_CustomerUserStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ProductStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_UIStore__["a" /* default */]).isRequired,purchaseProduct:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__models_PurchaseProduct__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('customerUserStore','productStore','uiStore')(PurchaseProductItem));

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PurchaseTabTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react_index__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Purchase__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Icon__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={name:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchaseUserHeader),order_count:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchaseOrderCountHeader),total_with_tax:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchaseWithVatHeader),total_without_tax:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].purchaseWithoutVatHeader)};var PurchaseTabTitle=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react_index__["observer"])(_class=function(_Component){_inherits(PurchaseTabTitle,_Component);function PurchaseTabTitle(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseTabTitle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseTabTitle.__proto__||Object.getPrototypeOf(PurchaseTabTitle)).call.apply(_ref,[this].concat(args))),_this),_this.renderMaybeHeader=function(label,value){var uiStore=_this.props.uiStore;if(uiStore.isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTabTitle__header'},label,': '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:value}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:value}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseTabTitle,[{key:'render',value:function render(){var purchase=this.props.purchase;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTabTitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* Row */],{className:'PurchaseTabTitle__row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Icon__["a" /* default */],{className:'PurchaseTabTitle__toggle-icon',name:'angle-up'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTabTitle__user'},this.renderMaybeHeader(labels.name,purchase.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTabTitle__orderCount'},this.renderMaybeHeader(labels.order_count,purchase.order_count))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTabTitle__purchasesWithVat'},this.renderMaybeHeader(labels.total_with_tax,purchase.total_with_tax))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Col */],{md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PurchaseTabTitle__purchasesWithoutVat'},this.renderMaybeHeader(labels.total_without_tax,purchase.total_without_tax)))));}}]);return PurchaseTabTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PurchaseTabTitle.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_UIStore__["a" /* default */]).isRequired,purchase:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__models_Purchase__["a" /* default */]).isRequired,searchParams:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react_index__["inject"])('uiStore')(PurchaseTabTitle));

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? factory(exports, __webpack_require__(59), __webpack_require__(0), __webpack_require__(66)) :
	typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
	(factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
}(this, (function (exports,mobx,React,reactDom) { 'use strict';

var React__default = 'default' in React ? React['default'] : React;

// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
    module.exports = factory();
}(commonjsGlobal, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return mobx.untracked(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return mobx.untracked(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = mobx.isObservableArray;
                    break;
                case "Object":
                    mobxChecker = mobx.isObservableObject;
                    break;
                case "Map":
                    mobxChecker = mobx.isObservableMap;
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return mobx.untracked(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return React.createElement(component, newProps);
            }
        }]);
        return Injector;
    }(React.Component), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

var mobxAdminProperty = mobx.$mobx || "$mobx";

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function createSymbol(name) {
    if (typeof Symbol === "function") {
        return Symbol(name);
    }
    return "$mobxReactProp$" + name + Math.random();
}

var skipRenderKey = createSymbol("skipRender");
var isForcingUpdateKey = createSymbol("isForcingUpdate");

/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */
function setHiddenProp(target, prop, value) {
    if (!Object.hasOwnProperty(target, prop)) {
        Object.defineProperty(target, prop, {
            enumerable: false,
            configurable: true,
            writeable: true,
            value: value
        });
    } else {
        target[prop] = value;
    }
}

function findDOMNode$2(component) {
    if (reactDom.findDOMNode) {
        try {
            return reactDom.findDOMNode(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

function makeComponentReactive(render) {
    var _this2 = this;

    if (isUsingStaticRendering === true) return render.call(this);

    function reactiveRender() {
        var _this = this;

        isRenderingPending = false;
        var exception = undefined;
        var rendering = undefined;
        reaction.track(function () {
            if (isDevtoolsEnabled) {
                _this.__$mobRenderStart = Date.now();
            }
            try {
                rendering = mobx._allowStateChanges(false, baseRender);
            } catch (e) {
                exception = e;
            }
            if (isDevtoolsEnabled) {
                _this.__$mobRenderEnd = Date.now();
            }
        });
        if (exception) {
            errorsReporter.emit(exception);
            throw exception;
        }
        return rendering;
    }

    // Generate friendly name for debugging
    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
    /**
     * If props are shallowly modified, react will render anyway,
     * so atom.reportChanged() should not result in yet another re-render
     */
    setHiddenProp(this, skipRenderKey, false);
    /**
     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
     * so detect these changes
     */
    setHiddenProp(this, isForcingUpdateKey, false);

    // wire up reactive render
    var baseRender = render.bind(this);
    var isRenderingPending = false;

    var reaction = new mobx.Reaction(initialName + "#" + rootNodeID + ".render()", function () {
        if (!isRenderingPending) {
            // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
            // This unidiomatic React usage but React will correctly warn about this so we continue as usual
            // See #85 / Pull #44
            isRenderingPending = true;
            if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?
            if (_this2.__$mobxIsUnmounted !== true) {
                // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                // However, people also claim this migth happen during unit tests..
                var hasError = true;
                try {
                    setHiddenProp(_this2, isForcingUpdateKey, true);
                    if (!_this2[skipRenderKey]) React.Component.prototype.forceUpdate.call(_this2);
                    hasError = false;
                } finally {
                    setHiddenProp(_this2, isForcingUpdateKey, false);
                    if (hasError) reaction.dispose();
                }
            }
        }
    });
    reaction.reactComponent = this;
    reactiveRender[mobxAdminProperty] = reaction;
    this.render = reactiveRender;
    return reactiveRender.call(this);
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistry) {
                componentByNodeRegistry.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }
};

function makeObservableProp(target, propName) {
    var valueHolderKey = createSymbol(propName + " value holder");
    var atomHolderKey = createSymbol(propName + " atom holder");
    function getAtom() {
        if (!this[atomHolderKey]) {
            setHiddenProp(this, atomHolderKey, mobx.createAtom("reactive " + propName));
        }
        return this[atomHolderKey];
    }
    Object.defineProperty(target, propName, {
        configurable: true,
        enumerable: true,
        get: function get$$1() {
            getAtom.call(this).reportObserved();
            return this[valueHolderKey];
        },
        set: function set$$1(v) {
            if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
                setHiddenProp(this, valueHolderKey, v);
                setHiddenProp(this, skipRenderKey, true);
                getAtom.call(this).reportChanged();
                setHiddenProp(this, skipRenderKey, false);
            } else {
                setHiddenProp(this, valueHolderKey, v);
            }
        }
    });
}

/**
 * Observer function / decorator
 */
function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // TODO: remove in next major
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }
    if (componentClass.__proto__ === React.PureComponent) {
        console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
        var _class, _temp;

        var observerComponent = observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
        hoistNonReactStatics(observerComponent, componentClass);
        return observerComponent;
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    makeObservableProp(target, "props");
    makeObservableProp(target, "state");
    var baseRender = target.render;
    target.render = function () {
        return makeComponentReactive.call(this, baseRender);
    };
    return componentClass;
}

function mixinLifecycleEvents(target) {
    ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    } else {
        if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
            // TODO: make throw in next major
            console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
        }
    }
}

var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    // TODO: remove in next major
    console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
    var InjectComponent = inject(observerInject)(component);
    return React__default.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(nextProps, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component$$1;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component$$1.displayName || Component$$1.name;
    var newApiName =
      typeof Component$$1.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component$$1;
}

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider(props, context) {
        classCallCheck(this, Provider);

        var _this = possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props, context));

        _this.state = props || {};
        return _this;
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return React.Children.only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.state) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (!nextProps) return null;
            if (!prevState) return nextProps;

            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(prevState).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }return nextProps;
        }
    }]);
    return Provider;
}(React.Component), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

// TODO: kill in next major

polyfill(Provider);

if (!React.Component) throw new Error("mobx-react requires React to be available");
if (!mobx.spy) throw new Error("mobx-react requires mobx to be available");

if (typeof reactDom.unstable_batchedUpdates === "function") mobx.configure({ reactionScheduler: reactDom.unstable_batchedUpdates });else if (typeof unstable_batchedUpdates$1 === "function") mobx.configure({ reactionScheduler: unstable_batchedUpdates$1 });

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: mobx.spy, extras: { getDebugName: mobx.getDebugName } };
    var mobxReact = {
        renderReporter: renderReporter,
        componentByNodeRegistry: componentByNodeRegistry,
        componentByNodeRegistery: componentByNodeRegistry,
        trackComponents: trackComponents
    };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}

exports.propTypes = propTypes;
exports.PropTypes = propTypes;
exports.onError = onError;
exports.observer = observer;
exports.Observer = Observer;
exports.renderReporter = renderReporter;
exports.componentByNodeRegistery = componentByNodeRegistry;
exports.componentByNodeRegistry = componentByNodeRegistry;
exports.trackComponents = trackComponents;
exports.useStaticRendering = useStaticRendering;
exports.Provider = Provider;
exports.inject = inject;

Object.defineProperty(exports, '__esModule', { value: true });

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountCreditAccount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__product_Price__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({'global.creditAccountTitle':{'id':'global.creditAccountTitle','defaultMessage':'Credit account'}});var labels={creditStatusTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'creditAccount.accountStatusTitle',defaultMessage:'Credit account status'}),limit:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'creditAccount.limitTitle',defaultMessage:'Credit limit'}),balance:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'creditAccount.balanceTitle',defaultMessage:'Balance'}),creditUsed:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'creditAccount.creditUsedTitle',defaultMessage:'Credit used'}),dateUpdated:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].dateUpdatedTitle)};var MyAccountCreditAccount=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountCreditAccount,_Component);function MyAccountCreditAccount(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountCreditAccount);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountCreditAccount.__proto__||Object.getPrototypeOf(MyAccountCreditAccount)).call.apply(_ref,[this].concat(args))),_this),_this.getCreditAccountState=function(){var customerUserStore=_this.props.customerUserStore;return customerUserStore.creditAccountState;},_this.getCreditAccount=function(){var customerUserStore=_this.props.customerUserStore;return customerUserStore.creditAccount;},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].creditAccountTitle),url:__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].MyAccountCreditAccount}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountCreditAccount,[{key:'render',value:function render(){var creditAccount=this.getCreditAccount();if(this.getCreditAccountState()===__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADED&&!creditAccount){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__head_SEOTitle__["a" /* default */],{title:Object.assign({},messages['global.creditAccountTitle'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__loader_ContentForState__["a" /* default */],{state:this.getCreditAccountState(),forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountCreditAccount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],messages['global.creditAccountTitle'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["n" /* Container */],{className:'MyAccountCreditAccount__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["j" /* CardHeader */],null,labels.creditStatusTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["n" /* Container */],{className:'MyAccountCreditAccount__credit-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,labels.limit),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__product_Price__["a" /* default */],{price:creditAccount.limit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,labels.creditUsed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__product_Price__["a" /* default */],{price:creditAccount.credit_used}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,labels.balance),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__product_Price__["a" /* default */],{price:creditAccount.balance}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{className:'MyAccountCreditAccount__date-updated'},labels.dateUpdated,': ',__WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(creditAccount.date_updated).toLocaleString(__WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].DATETIME_MED_WITH_SECONDS))))))))));}}));}}]);return MyAccountCreditAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountCreditAccount.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_CustomerUserStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService','customerUserStore')(MyAccountCreditAccount))));

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountThankYouPageContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ErrorHandler__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__route_Redirect302__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountThankYouPageContent=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountThankYouPageContent,_Component);function MyAccountThankYouPageContent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountThankYouPageContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountThankYouPageContent.__proto__||Object.getPrototypeOf(MyAccountThankYouPageContent)).call.apply(_ref,[this].concat(args))),_this),_this.state={productStoreError:null,renderTrackingPixels:false},_this.loadWidget=function(){_this.props.customerUserStore.loadBalancePostPayment();},_this.getCurrentlyRunningRequestState=function(){var customerUserStore=_this.props.customerUserStore;var currentRequestState=customerUserStore.paymentSuccessState;return currentRequestState||__WEBPACK_IMPORTED_MODULE_6__types_RequestState__["b" /* default */].LOADED;},_this.getError=function(){var customerUserStore=_this.props.customerUserStore;var error=customerUserStore.balancePaymentError;return error||null;},_this.renderHtmlWidget=function(widgetHtml){var doc=document.implementation.createHTMLDocument('');doc.body.innerHTML=widgetHtml;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet_async___default.a,null,[].map.call(doc.getElementsByTagName('script'),function(el){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,el.textContent);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:widgetHtml}}));},_this.renderErrorHandler=function(props){var configStore=_this.props.configStore;var checkout=configStore.checkout;switch(props.error.httpStatusCode){case 401:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__route_Redirect302__["a" /* default */],{to:'/'});case 404:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__route_Redirect302__["a" /* default */],{to:checkout.checkoutPath});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ErrorHandler__["a" /* default */],props);}},_this.renderSuccessPage=function(){var paymentSuccess=_this.props.customerUserStore.paymentSuccess;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountThankYouPageContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'checkout.successfulTransferPageHeading',defaultMessage:'Money transfer confirmation'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'MyAccountThankYouPageContent__klarna-wrapper-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{className:'MyAccountThankYouPageContent__klarna-container'},_this.renderHtmlWidget(paymentSuccess.html_widget))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountThankYouPageContent,[{key:'componentDidMount',value:function componentDidMount(){this.loadWidget();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountThankYouPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__["a" /* default */],{state:this.getCurrentlyRunningRequestState(),forLoaded:this.renderSuccessPage,error:this.getError(),errorHandler:this.renderErrorHandler}));}}]);return MyAccountThankYouPageContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountThankYouPageContent.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_ConfigStore__["a" /* default */]).isRequired,customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_CustomerUserStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','customerUserStore')(MyAccountThankYouPageContent));

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceUserAccountOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__BalanceUserList__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__loader_UnexpectedError__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KLARNA_CHECKOUT_TIMEOUT_MS=1200;var BalanceUserAccountOverview=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BalanceUserAccountOverview,_Component);function BalanceUserAccountOverview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BalanceUserAccountOverview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BalanceUserAccountOverview.__proto__||Object.getPrototypeOf(BalanceUserAccountOverview)).call.apply(_ref,[this].concat(args))),_this),_this.state={listState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].NONE,paymentAmount:[],paymentInProgress:false,showBalance:false,removeError:null,requestId:0,quantityErrors:[]},_this.resetTimeout=function(){_this.timeout&&clearTimeout(_this.timeout);},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountBalanceUser}]);},_this.handleBalance=function(){_this.setState(function(prevState){return{showBalance:!prevState.showBalance};});},_this.cancelPayment=function(){_this.setState({showBalance:false,paymentInProgress:false,paymentAmount:[]});},_this.showBuyBalanceInformationBanner=function(){if(!_this.state.showBalance){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{className:'BalanceUserAccountOverview__buy-balance-info-alert',color:'light'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'myAccount.buyBalanceInfoText',defaultMessage:'Select an amount for the users you want to transfer money to and wait a moment.'}));},_this.renderError=function(){var _this$state=_this.state,requestId=_this$state.requestId,removeError=_this$state.removeError;var errors=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(removeError,'response.data.errors');return errors?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{className:'MyAccountUser__errors',color:'danger',key:requestId},Object.values(removeError.response.data.errors).map(function(message){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__loader_UnexpectedError__["a" /* default */],null);},_this.renderBalanceUserList=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__BalanceUserList__["a" /* default */],{showBalance:_this.state.showBalance,onPayment:function onPayment(){return null;},onBalanceUpdate:_this.onBalanceUpdate,onRemoveUser:_this.removeUser,totalSums:_this.state.paymentAmount,onBalanceError:_this.onBalanceError});},_this.onBalanceUpdate=function(id,value,user){_this.suspendKlarnaCheckout();var newAmounts=_this.updateBalance(id,value,user);_this.updatePaymentAmounts(newAmounts);},_this.onBalanceError=function(id,quantityField){var quantityErrors=quantityField.errors;if(quantityErrors){_this.setState({quantityErrors:quantityErrors});}},_this.updateBalance=function(id,value,user){var newAmounts=_this.state.paymentAmount;if(__WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(newAmounts,function(amount){return amount.id===id;}).length===0&&value!==0){newAmounts.push({id:id,amount:value,sum:user.account_balance+value});}else{newAmounts.forEach(function(amount,i){if(amount.id===id){amount.amount=value;amount.sum=user.account_balance+value;}if(amount.amount===0){newAmounts.splice(i,1);}});}return newAmounts;},_this.updatePaymentAmounts=function(paymentAmount){_this.setState({paymentAmount:paymentAmount},function(){var paymentAmount=_this.state.paymentAmount;if(paymentAmount.length===0){_this.resetPaymentTransaction();}if(paymentAmount.length>0){_this.resetTimeout();_this.timeout=setTimeout(function(){_this.handlePayment(paymentAmount);},KLARNA_CHECKOUT_TIMEOUT_MS);}});},_this.resetPaymentTransaction=function(){_this.setState({paymentInProgress:false,paymentAmount:[]});_this.resetTimeout();},_this.handlePayment=function(paymentAmounts){var _this$props2=_this.props,customerUserStore=_this$props2.customerUserStore,languageStore=_this$props2.languageStore;var _this$state2=_this.state,showBalance=_this$state2.showBalance,quantityErrors=_this$state2.quantityErrors;var userPayments=customerUserStore.convertPaymentAmountsIntoUserPayments(paymentAmounts);if(showBalance&&paymentAmounts&&quantityErrors.length===0){customerUserStore.makePayment(userPayments,languageStore.locale).then(function(){if(paymentAmounts.length>0){_this.setState({paymentInProgress:true},function(){_this.resumeKlarnaCheckout();_this.resetTimeout();});}}).catch(function(){_this.setState({paymentInProgress:false});_this.resetTimeout();});}},_this.removeUser=function(id){var customerUserStore=_this.props.customerUserStore;customerUserStore.removeBalanceUser(id).then(function(){customerUserStore.loadBalanceUsers();_this.setState({removeError:null});}).catch(function(error){return _this.setState({removeError:error,requestId:_this.state.requestId+1});});},_this.renderHtmlWidget=function(widgetHtml){if(!widgetHtml){return _this.paymentWidgetErrorBanner();}var doc=document.implementation.createHTMLDocument('');doc.body.innerHTML=widgetHtml;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_helmet_async___default.a,null,[].map.call(doc.getElementsByTagName('script'),function(el,i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('script',{key:i},el.textContent);})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{className:'BalanceUserAccountOverview__klarna-wrapper-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{className:'BalanceUserAccountOverview__klarna-container-header',sm:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'myAccount.klarnaCheckoutPaymentInfo',defaultMessage:'Please give your payment info.'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{className:'BalanceUserAccountOverview__klarna-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:widgetHtml}}))));},_this.paymentWidgetErrorBanner=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{className:'BalanceUserAccountOverview__payment-widget-error-banner',color:'danger'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].balanceUserAccountPaymentWidgetError));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BalanceUserAccountOverview,[{key:'componentDidMount',value:function componentDidMount(){this.setState({listState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADING});this.maybeLoadBalanceUsers();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.resetTimeout();}},{key:'maybeLoadBalanceUsers',value:function maybeLoadBalanceUsers(){var _this2=this;var customerUserStore=this.props.customerUserStore;customerUserStore.loadBalanceUsers().then(function(){_this2.setState({listState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].LOADED});}).catch(function(){_this2.setState({listState:__WEBPACK_IMPORTED_MODULE_19__types_RequestState__["b" /* default */].ERROR});});}},{key:'getBalanceUserButtonRow',value:function getBalanceUserButtonRow(){var routeService=this.props.routeService;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{className:'BalanceUserAccountOverview__balance-user-button-row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{size:'12'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],{to:routeService.getPath(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].MyAccountUserNew)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'primary',className:'BalanceUserAccountOverview__add-new-user-button',size:'lg'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].addNewUserTitle))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'success',disabled:this.state.paymentInProgress,onClick:this.handleBalance,size:'lg',className:'BalanceUserAccountOverview__add-balance-button'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_Icon__["a" /* default */],{name:'shopping-cart'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'BalanceUserAccountOverview__add-balance-button-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'checkout.buyBalanceSentence',defaultMessage:'Buy balance'}))),(this.state.showBalance||this.state.paymentInProgress)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'secondary',size:'lg',className:'BalanceUserAccountOverview__cancel-payment-button',onClick:this.cancelPayment},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'BalanceUserAccountOverview__cancel-payment-button-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'checkout.cancelPayment',defaultMessage:'Cancel'})))));}},{key:'suspendKlarnaCheckout',value:function suspendKlarnaCheckout(){if(this.state.paymentAmount.length>0&&window._klarnaCheckout){window._klarnaCheckout(function(api){api.suspend();});}}},{key:'resumeKlarnaCheckout',value:function resumeKlarnaCheckout(){if(this.state.paymentAmount.length>0&&window._klarnaCheckout){window._klarnaCheckout(function(api){api.resume();});}}},{key:'render',value:function render(){var _this3=this;var customerUserStore=this.props.customerUserStore;var removeError=this.state.removeError;var inPayment=this.state.paymentInProgress&&customerUserStore.balancePayment!==null;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'BalanceUserAccountOverview'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].myAccount}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].myAccount)),this.getBalanceUserButtonRow(),this.showBuyBalanceInformationBanner(),removeError&&this.renderError(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__loader_ContentForState__["a" /* default */],{state:customerUserStore.state,error:customerUserStore.lastError,forLoaded:function forLoaded(){return _this3.renderBalanceUserList();}}),inPayment&&customerUserStore&&this.renderHtmlWidget(customerUserStore.balancePayment.html_widget));}}]);return BalanceUserAccountOverview;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;BalanceUserAccountOverview.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_CustomerUserStore__["a" /* default */]).isRequired,languageStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_LanguageStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_5_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_16__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('customerUserStore','languageStore','routeService')(BalanceUserAccountOverview)));

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceUserList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Balance__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__user_BalanceForm__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_CustomerUserStore__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_BALANCE=99999;var INCREMENT_STEP=2;var QUANTITY_STEP=0;var BalanceUserList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BalanceUserList,_Component);function BalanceUserList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BalanceUserList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BalanceUserList.__proto__||Object.getPrototypeOf(BalanceUserList)).call.apply(_ref,[this].concat(args))),_this),_this.handlePaymentClick=function(){_this.props.onPayment();},_this.onBalanceUpdate=function(id,value,user){_this.props.onBalanceUpdate(id,value,user);},_this.onBalanceError=function(id,quantityField){_this.props.onBalanceError(id,quantityField);},_this.editUser=function(id){var _this$props=_this.props,routeService=_this$props.routeService,history=_this$props.history;var path=routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_11__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].MyAccountUser,{id:id}));return history.push(path);},_this.removeUser=function(id){_this.props.onRemoveUser(id);},_this.renderBalanceUsers=function(){var _this$props2=_this.props,customerUserStore=_this$props2.customerUserStore,uiStore=_this$props2.uiStore,showBalance=_this$props2.showBalance;var balanceUserArray=customerUserStore.balanceUserArray;return balanceUserArray&&balanceUserArray.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["A" /* ListGroup */],null,!uiStore.isSmallest&&_this.renderListGroupHeaders(showBalance),balanceUserArray.map(function(user,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["B" /* ListGroupItem */],{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],{className:'BalanceUserList__user-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{xs:'12',sm:'6',md:'3',className:'BalanceUserList__user-name'},user.firstname,' ',user.lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{xs:'12',sm:'6',md:'3',className:'BalanceUserList__user-balance'},_this.renderBalanceUserBalance(user)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{xs:'12',sm:'6',md:showBalance?'4':'3',className:showBalance?'BalanceUserList__user-actions-button-group':'BalanceUserList__user-account-status'},showBalance?_this.renderBalanceUserBalanceForm(user):_this.getAccountStatus(user)),_this.renderUserActionButtonGroupForSmallAndUpDevices(user,showBalance)));}));},_this.renderListGroupHeaders=function(showBalance){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["B" /* ListGroupItem */],{className:'BalanceUserList__list-headers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:'6',md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].balanceUserNameTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:'6',md:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].balanceUserCurrentBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:'6',md:showBalance?'4':'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],showBalance?__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].balanceUserNewBalance:__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].balanceUserAccountStatus)),showBalance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{sm:'6',md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].balanceUserPaymentTotal))));},_this.renderBalanceUserBalance=function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Balance__["a" /* default */],{amount:user.account_balance,currencyType:user.account_currency});},_this.renderBalanceUserBalanceForm=function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__user_BalanceForm__["a" /* default */],{user:user,onSubmit:_this.handlePaymentClick,incrementStep:INCREMENT_STEP,quantityStep:QUANTITY_STEP,maxQuantity:MAX_BALANCE,onBalanceUpdate:_this.onBalanceUpdate,onBalanceError:_this.onBalanceError});},_this.renderUserActionButtonGroup=function(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* ButtonGroup */],{className:'BalanceUserList__user-actions-button-group',vertical:_this.props.uiStore.isTablet||_this.props.uiStore.isHD},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:'BalanceUserList__user-actions-button-add-user',onClick:function onClick(){return _this.editUser(user.id);},size:'lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].editTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:'BalanceUserList__user-actions-button-delete-user',onClick:function onClick(){return window.confirm(_this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].confirmRemoveTitle))&&_this.removeUser(user.id);},color:'danger',size:'lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].removeTitle)));},_this.getAccountStatus=function(user){return user.is_active?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'myAccount.balanceUserAccountStatusActive',defaultMessage:'Active'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'myAccount.balanceUserAccountStatusNotActive',defaultMessage:'Disabled'});},_this.renderUserActionButtonGroupForSmallAndUpDevices=function(user,showBalance){var totalSum=_this.findUserTotal(user);var cssClass=showBalance?'BalanceUserList__user-total-balance':'BalanceUserList__user-actions';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{xs:'12',sm:'6',md:showBalance?'2':'3',className:cssClass},showBalance?_this.renderBalance(user,totalSum):_this.renderUserActionButtonGroup(user));},_this.findUserTotal=function(user){var totalSums=_this.props.totalSums;return totalSums.length>0&&totalSums.find(function(totalSum){return totalSum.id===user.id;});},_this.renderBalance=function(user,totalSum){return totalSum?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Balance__["a" /* default */],{amount:totalSum.sum,currencyType:user.account_currency}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Balance__["a" /* default */],{amount:0,currencyType:user.account_currency});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BalanceUserList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserList'},this.renderBalanceUsers());}}]);return BalanceUserList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;BalanceUserList.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_CustomerUserStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_12__services_RouteService__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.history.isRequired,intl:__WEBPACK_IMPORTED_MODULE_6_react_intl__["f" /* intlShape */].isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_UIStore__["a" /* default */]).isRequired,showBalance:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onBalanceUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onRemoveUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,totalSums:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,onBalanceError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService','uiStore','customerUserStore')(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* injectIntl */])(BalanceUserList))));

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_FormValidator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_BalanceUser__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_QuantityFieldGroup__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_VALUE=0;var BalanceForm=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(BalanceForm,_Component);function BalanceForm(props){_classCallCheck(this,BalanceForm);var _this=_possibleConstructorReturn(this,(BalanceForm.__proto__||Object.getPrototypeOf(BalanceForm)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,user=_this$props.user,maxQuantity=_this$props.maxQuantity,quantityStep=_this$props.quantityStep,incrementStep=_this$props.incrementStep;var formFields={};var quantityFieldName='quantity-'+user.id;formFields[quantityFieldName]=Object(__WEBPACK_IMPORTED_MODULE_5__models_FormField__["a" /* createFormField */])({value:user&&user.account_balance},[Object(__WEBPACK_IMPORTED_MODULE_10__util_formValidators__["j" /* quantityValid */])(maxQuantity,quantityStep),// We use incrementStep prop here so we can have zero value as a valid quantity.
Object(__WEBPACK_IMPORTED_MODULE_10__util_formValidators__["i" /* productCountValid */])(incrementStep,__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].balanceUserBalanceValidationError)]);_this.form=Object(__WEBPACK_IMPORTED_MODULE_7__models_Form__["a" /* createForm */])(formFields);return _this;}_createClass(BalanceForm,[{key:'render',value:function render(){var _props=this.props,user=_props.user,maxQuantity=_props.maxQuantity,quantityStep=_props.quantityStep,defaultValue=_props.defaultValue,incrementStep=_props.incrementStep;var quantityField=this.form.fields.get('quantity-'+user.id);quantityField.setValue(defaultValue);this.form.validate();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{className:this.formName,noValidate:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_QuantityFieldGroup__["a" /* default */],{key:user.id,className:'BalanceForm__quantity-group',field:quantityField,maxQuantity:maxQuantity,quantityStep:quantityStep,incrementStep:incrementStep,defaultValue:DEFAULT_VALUE,unit:user.account_currency,onUpdateProductQuantity:this.onBalanceUpdate,balanceUserAccount:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_FieldError__["a" /* default */],{field:quantityField}));}}]);return BalanceForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='BalanceForm';this.handleSubmit=function(e){var onSubmit=_this2.props.onSubmit;e.preventDefault();_this2.form.validate();if(_this2.form.valid){onSubmit();}};this.onBalanceUpdate=function(value){var _props2=_this2.props,user=_props2.user,onBalanceError=_props2.onBalanceError;_this2.form.validate();if(_this2.form.valid){_this2.props.onBalanceUpdate(user.id,value,user);}onBalanceError&&onBalanceError(user.id,_this2.form.fields.get('quantity-'+user.id));};},_temp))||_class;BalanceForm.propTypes={maxQuantity:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,quantityStep:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,incrementStep:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,formValidator:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6__services_FormValidator__["a" /* default */]).isRequired,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,user:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_BalanceUser__["a" /* default */]),onSubmit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onBalanceUpdate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,defaultValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onBalanceError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('formValidator')(BalanceForm));

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceUserBalanceAccount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BalanceUserPaymentHistory__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_RequestState__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BalanceUserBalanceAccount=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BalanceUserBalanceAccount,_Component);function BalanceUserBalanceAccount(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BalanceUserBalanceAccount);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BalanceUserBalanceAccount.__proto__||Object.getPrototypeOf(BalanceUserBalanceAccount)).call.apply(_ref,[this].concat(args))),_this),_this.state={listState:__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].NONE},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountBalanceUser},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].balanceUserAccountBalanceInfo),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountBalanceUserPaymentHistory}]);},_this.getQueryPage=function(search){var queryParams=Object(__WEBPACK_IMPORTED_MODULE_6__util_queryString__["b" /* parse */])(search);return Number(queryParams.page);},_this.getValidPage=function(ifValidSearch,search){if(ifValidSearch){return search;}return'';},_this.maybeLoadBalancePaymentHistory=function(page){var customerUserStore=_this.props.customerUserStore;customerUserStore.loadBalancePaymentHistory(page).then(function(){_this.setState({listState:__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].LOADED});}).catch(function(e){console.error(e);_this.setState({listState:__WEBPACK_IMPORTED_MODULE_17__types_RequestState__["b" /* default */].ERROR});});},_this.renderBalanceUserPaymentHistory=function(){var customerUserStore=_this.props.customerUserStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__BalanceUserPaymentHistory__["a" /* default */],{balancePaymentHistory:customerUserStore.balancePaymentHistory});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BalanceUserBalanceAccount,[{key:'componentDidMount',value:function componentDidMount(){var search=this.props.location.search;var ifValidSearch=this.getQueryPage(search);var page=this.getValidPage(ifValidSearch,search);this.maybeLoadBalancePaymentHistory(page);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props=this.props,match=_props.match,location=_props.location,search=_props.location.search;if(prevProps.match.params.id!==match.params.id||prevProps.location.search!==location.search){var ifValidSearch=this.getQueryPage(search);var page=this.getValidPage(ifValidSearch,search);this.maybeLoadBalancePaymentHistory(page);}}},{key:'render',value:function render(){var _this2=this;var customerUserStore=this.props.customerUserStore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserBalanceAccount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].balanceUserAccountBalanceInfo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].balanceUserAccountBalanceInfo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__loader_ContentForState__["a" /* default */],{state:customerUserStore.balancePaymentHistoryState,error:customerUserStore.lastError,forLoaded:function forLoaded(){return _this2.renderBalanceUserPaymentHistory();}}));}}]);return BalanceUserBalanceAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;BalanceUserBalanceAccount.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_CustomerUserStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.location.isRequired,match:__WEBPACK_IMPORTED_MODULE_5_react_router_prop_types___default.a.match.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService','customerUserStore')(BalanceUserBalanceAccount))));

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceUserPaymentHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Balance__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_date__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Paginator__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_BalancePaymentHistory__ = __webpack_require__(577);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BalanceUserPaymentHistory=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BalanceUserPaymentHistory,_Component);function BalanceUserPaymentHistory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BalanceUserPaymentHistory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BalanceUserPaymentHistory.__proto__||Object.getPrototypeOf(BalanceUserPaymentHistory)).call.apply(_ref,[this].concat(args))),_this),_this.renderBalancePaymentHistory=function(balancePaymentHistory){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* ListGroup */],null,!_this.props.uiStore.isSmallest&&_this.renderListGroupHeaders(),balancePaymentHistory.data.map(function(payment,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["B" /* ListGroupItem */],{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],{className:'BalanceUserPaymentHistory__payment-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:12,sm:3,className:'BalanceUserPaymentHistory__payment-details-payment-order'},payment.orders_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:12,sm:3,className:'BalanceUserPaymentHistory__payment-details-payment-balance'},_this.renderBalanceUserBalance(payment.amount_with_tax)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:12,sm:3,className:'BalanceUserPaymentHistory__payment-details-payment-users'},_this.renderUsersPaymentDetails(payment.users)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:12,sm:3,className:'BalanceUserPaymentHistoryList__payment-details-payment-date'},Object(__WEBPACK_IMPORTED_MODULE_11__util_date__["a" /* formatDate */])(payment.date_purchased))));}));},_this.renderListGroupHeaders=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["B" /* ListGroupItem */],{className:'BalanceUserPaymentHistory__list-headers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].balanceUserPaymentHistoryOrderNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].balanceUserPaymentTotal)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].balanceUserNameTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].balanceUserPaymentHistoryOrderDate))));},_this.renderBalanceUserBalance=function(balance){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Balance__["a" /* default */],{amount:balance});},_this.renderUsersPaymentDetails=function(users){return users.map(function(user,i){return user&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,user.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,user.amount_with_tax));});},_this.getPaginator=function(){var _this$props=_this.props,balancePaymentHistory=_this$props.balancePaymentHistory,location=_this$props.location;var lastPage=balancePaymentHistory.last_page,currentPage=balancePaymentHistory.current_page;var searchTemplate=void 0;var regex=/page=(\d+?)(?=(&|$))/;var pageParameter='page=:page';if(location.search.charAt(0)!=='?'){searchTemplate=location.search+'?'+pageParameter;}else{searchTemplate=location.search.match(regex)?location.search.replace(regex,pageParameter):location.search+'&'+pageParameter;}var pathTemplate=Object(__WEBPACK_IMPORTED_MODULE_13__util_url__["b" /* escapeUrlForPaginatorTemplate */])(location.pathname)+searchTemplate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserPaymentHistory__Paginator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Paginator__["a" /* default */],{pathTemplate:pathTemplate,currentPage:currentPage,lastPage:lastPage,pagesToShow:5}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BalanceUserPaymentHistory,[{key:'render',value:function render(){var balancePaymentHistory=this.props.balancePaymentHistory;if(!balancePaymentHistory||!balancePaymentHistory.data||!balancePaymentHistory.data.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].balanceUserNoBalancePurchases);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserPaymentHistory'},balancePaymentHistory&&this.renderBalancePaymentHistory(balancePaymentHistory),balancePaymentHistory&&this.getPaginator());}}]);return BalanceUserPaymentHistory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;BalanceUserPaymentHistory.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_CustomerUserStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_UIStore__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.location.isRequired,balancePaymentHistory:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__models_BalancePaymentHistory__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('customerUserStore','uiStore')(BalanceUserPaymentHistory)));

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
var initializeDateTimeFromIso=function initializeDateTimeFromIso(dateTime){return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(dateTime);};// format 26/11/2020
function formatDate(dateTime){var date=initializeDateTimeFromIso(dateTime);return date.toLocaleString(__WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].DATE_SHORT);}

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceSubUserAccountOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BalanceUserInfo__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BalanceUserPinCode__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_ApiWrapper__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BalanceSubUserAccountOverview=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BalanceSubUserAccountOverview,_Component);function BalanceSubUserAccountOverview(props){_classCallCheck(this,BalanceSubUserAccountOverview);var _this=_possibleConstructorReturn(this,(BalanceSubUserAccountOverview.__proto__||Object.getPrototypeOf(BalanceSubUserAccountOverview)).call(this,props));_this.handleUserUpdate=function(){_this.maybeLoadBalanceUser();};_this.loadPinCode=function(){var apiWrapper=_this.props.apiWrapper;_this.setState({pinState:__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADING});apiWrapper.request('money-transfer/user/account/pin-code').then(function(data){_this.setState({pinState:__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADED,data:data});});};_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].MyAccountBalanceSubUser}]);};_this.renderBalanceUserInfo=function(){var _this$props2=_this.props,accountStore=_this$props2.accountStore,customerUserStore=_this$props2.customerUserStore;var _this$state=_this.state,infoState=_this$state.infoState,pinState=_this$state.pinState;var user=customerUserStore.balanceUsers.get(accountStore.getUserId);var infoDisabled=infoState===__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADING;var pinDisabled=pinState===__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADING;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'BalanceSubUserAccountOverview__user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12',sm:'6',className:'BalanceSubUserAccountOverview__user-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["j" /* CardHeader */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].balanceUserAccountInfo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{className:'BalanceUserInfo__update',onClick:_this.handleUserUpdate,size:'lg',disabled:infoDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].update))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["i" /* CardBody */],null,user&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__BalanceUserInfo__["a" /* default */],{onInfoUpdate:_this.handleUserUpdate,infoState:_this.state.infoState,user:user})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:'12',sm:'6',className:'BalanceSubUserAccountOverview__pin-code'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["j" /* CardHeader */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'balanceUser.pinCodeHeader',defaultMessage:'PIN code'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{className:'BalanceUserInfo__update',onClick:_this.loadPinCode,size:'lg',disabled:pinDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].update))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__BalanceUserPinCode__["a" /* default */],{pinState:_this.state.pinState,pinData:_this.state.data})))));};_this.state={infoState:__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].NONE,pinState:__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].NONE,data:null};return _this;}_createClass(BalanceSubUserAccountOverview,[{key:'componentDidMount',value:function componentDidMount(){this.maybeLoadBalanceUser();}},{key:'maybeLoadBalanceUser',value:function maybeLoadBalanceUser(){var _this2=this;var _props=this.props,customerUserStore=_props.customerUserStore,accountStore=_props.accountStore;this.setState({infoState:__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADING});customerUserStore.loadBalanceUser(accountStore.getUserId).then(function(){_this2.setState({infoState:__WEBPACK_IMPORTED_MODULE_16__types_RequestState__["b" /* default */].LOADED});}).catch(function(e){return console.error(e);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceSubUserAccountOverview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].myAccount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].myAccount)),this.renderBalanceUserInfo());}}]);return BalanceSubUserAccountOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;BalanceSubUserAccountOverview.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_AccountStore__["a" /* default */]).isRequired,customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_CustomerUserStore__["a" /* default */]).isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_17__services_ApiWrapper__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('apiWrapper','routeService','accountStore','customerUserStore')(BalanceSubUserAccountOverview)));

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceUserInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Balance__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_BalanceUser__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BalanceUserInfo=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BalanceUserInfo,_Component);function BalanceUserInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BalanceUserInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BalanceUserInfo.__proto__||Object.getPrototypeOf(BalanceUserInfo)).call.apply(_ref,[this].concat(args))),_this),_this.handlePaymentClick=function(){_this.props.onPayment();},_this.onInfoUpdate=function(){_this.props.onInfoUpdate();},_this.getInformation=function(){var user=_this.props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserInfo__header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].fullNameTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserInfo__name'},user.firstname,' ',user.lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserInfo__header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].balanceUserCurrentBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserInfo__balance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Balance__["a" /* default */],{amount:user.account_balance,currencyType:user.account_currency})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BalanceUserInfo,[{key:'render',value:function render(){var _this2=this;var _props=this.props,customerUserStore=_props.customerUserStore,infoState=_props.infoState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:infoState,error:customerUserStore.lastError,forLoaded:function forLoaded(){return _this2.getInformation();}});}}]);return BalanceUserInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;BalanceUserInfo.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_CustomerUserStore__["a" /* default */]).isRequired,infoState:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,user:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_BalanceUser__["a" /* default */]).isRequired,onInfoUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('customerUserStore')(BalanceUserInfo));

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BalanceUserPinCode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_CustomerUserStore__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BalanceUserPinCode=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(BalanceUserPinCode,_Component);function BalanceUserPinCode(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BalanceUserPinCode);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BalanceUserPinCode.__proto__||Object.getPrototypeOf(BalanceUserPinCode)).call.apply(_ref,[this].concat(args))),_this),_this.getPinData=function(){var pinData=_this.props.pinData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserPinCode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserPinCode__pin-code'},pinData&&pinData.pin),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BalanceUserPinCode__pin-expiry'},pinData&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'myAccount.pinExpires',defaultMessage:'PIN-code expires at {expires}. Time is now {nowTime} ',values:{expires:__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(pinData.expires).toLocaleString(__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].TIME_24_WITH_SECONDS),nowTime:__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].local().toLocaleString(__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].TIME_24_WITH_SECONDS)}})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BalanceUserPinCode,[{key:'render',value:function render(){var _this2=this;var _props=this.props,customerUserStore=_props.customerUserStore,pinState=_props.pinState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__loader_ContentForState__["a" /* default */],{state:pinState,error:customerUserStore.lastError,forLoaded:function forLoaded(){return _this2.getPinData();}});}}]);return BalanceUserPinCode;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;BalanceUserPinCode.propTypes={customerUserStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_CustomerUserStore__["a" /* default */]).isRequired,pinState:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,pinData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({expires:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,pin:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('apiWrapper','customerUserStore')(BalanceUserPinCode));

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountPaymentTokenList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_PaymentTokenStore__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PaymentTokenList__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__types_RequestState__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyAccountPaymentTokenList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountPaymentTokenList,_Component);function MyAccountPaymentTokenList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountPaymentTokenList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountPaymentTokenList.__proto__||Object.getPrototypeOf(MyAccountPaymentTokenList)).call.apply(_ref,[this].concat(args))),_this),_this.state={removeError:null,requestId:0},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].paymentTokensTitle),url:__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccountPaymentTokenList}]);},_this.removeToken=function(id){var _this$props2=_this.props,paymentTokenStore=_this$props2.paymentTokenStore,routeService=_this$props2.routeService,history=_this$props2.history;paymentTokenStore.removeToken(id).then(function(){paymentTokenStore.loadTokens();_this.setState({removeError:null});var path=routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_20__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].MyAccountPaymentTokenList));history.push(path);}).catch(function(error){return _this.setState({removeError:error,requestId:_this.state.requestId+1});});},_this.renderTokenList=function(){var paymentTokenStore=_this.props.paymentTokenStore;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PaymentTokenList__["a" /* default */],{tokens:paymentTokenStore.tokens,onRemoveClick:_this.removeToken});},_this.renderError=function(){var _this$state=_this.state,removeError=_this$state.removeError,requestId=_this$state.requestId;var errors=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(removeError,'response.data.errors');return errors?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{className:'MyAccountPaymentTokenList__errors',color:'danger',key:requestId},Object.values(removeError.response.data.errors).map(function(message){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_UnexpectedError__["a" /* default */],null);},_this.handleNewToken=function(){var paymentTokenStore=_this.props.paymentTokenStore;var notHandledByReactRouter=Object(__WEBPACK_IMPORTED_MODULE_19__util_url__["e" /* isNotHandledByReactRouter */])(paymentTokenStore.newTokenUrl);if(notHandledByReactRouter){document.location=paymentTokenStore.newTokenUrl;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountPaymentTokenList,[{key:'componentDidMount',value:function componentDidMount(){var paymentTokenStore=this.props.paymentTokenStore;if(paymentTokenStore.state===__WEBPACK_IMPORTED_MODULE_21__types_RequestState__["b" /* default */].NONE){paymentTokenStore.loadTokens();}}},{key:'render',value:function render(){var _this2=this;var paymentTokenStore=this.props.paymentTokenStore;var removeError=this.state.removeError;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountPaymentTokenList'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].paymentTokensTitle}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].paymentTokensTitle)),paymentTokenStore.newTokenUrl&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'MyAccountPaymentTokenList__new-token'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'primary',className:'MyAccountPaymentTokenList__tools-add-new-button',onClick:this.handleNewToken},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_14__i18n_globalTranslations__["a" /* default */].paymentTokensNewTitle))),removeError&&this.renderError(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__loader_ContentForState__["a" /* default */],{state:paymentTokenStore.state,error:paymentTokenStore.lastError,forLoaded:function forLoaded(){return _this2.renderTokenList();}}));}}]);return MyAccountPaymentTokenList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;MyAccountPaymentTokenList.propTypes={paymentTokenStore:Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__store_PaymentTokenStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,history:__WEBPACK_IMPORTED_MODULE_7_react_router_prop_types___default.a.history.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_15__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('paymentTokenStore','routeService')(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* withRouter */])(MyAccountPaymentTokenList))));

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PaymentTokenList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_Token__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentTokenList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PaymentTokenList,_Component);function PaymentTokenList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaymentTokenList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaymentTokenList.__proto__||Object.getPrototypeOf(PaymentTokenList)).call.apply(_ref,[this].concat(args))),_this),_this.getTokenizationMessage=function(){var tokenizationSuccess=Object(__WEBPACK_IMPORTED_MODULE_11__util_queryString__["b" /* parse */])(_this.props.location.search).tokenizationSuccess;if(!tokenizationSuccess){return null;}var success=tokenizationSuccess==='1';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["a" /* Alert */],{color:success?'success':'danger'},success?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'tokens.createSuccessSentence',defaultMessage:'Card added successfully.'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'tokens.createFailSentence',defaultMessage:'Failed adding the payment card.'}));},_this.renderTokenCard=function(token){var _this$props=_this.props,onRemoveClick=_this$props.onRemoveClick,intl=_this$props.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["h" /* Card */],{className:'PaymentTokenList__item',key:token.id,outline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["g" /* ButtonGroup */],{className:'PaymentTokenList__item-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{onClick:function onClick(){return window.confirm(intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].confirmRemoveTitle))&&onRemoveClick(token.id);},color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].removeTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PaymentTokenList__items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PaymentTokenList__item-title'},token.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PaymentTokenList__item-expired'},token.is_expired?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'payment.expiredSentence',defaultMessage:'Expired'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'payment.validSentence',defaultMessage:'Valid'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PaymentTokenList__item-created-at'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'payment.addedAtSentence',defaultMessage:'Added on {createdAt}',values:{createdAt:__WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(token.created_at).toLocaleString()}})))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentTokenList,[{key:'render',value:function render(){var _this2=this;var tokens=this.props.tokens;var tokenizationMessage=this.getTokenizationMessage();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PaymentTokenList'},tokenizationMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PaymentTokenList__tokenization-message'},tokenizationMessage),tokens.map(function(token){return _this2.renderTokenCard(token);}));}}]);return PaymentTokenList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PaymentTokenList.propTypes={onRemoveClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,location:__WEBPACK_IMPORTED_MODULE_6_react_router_prop_types___default.a.location.isRequired,tokens:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__models_Token__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_8__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__models_Token__["a" /* default */]))])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(PaymentTokenList)));

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountRecurringOrderList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__order_MainOrderList__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_RecurringOrderStore__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ORDER_COUNT_PER_PAGE=10;var MyAccountRecurringOrderList=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountRecurringOrderList,_Component);function MyAccountRecurringOrderList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountRecurringOrderList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountRecurringOrderList.__proto__||Object.getPrototypeOf(MyAccountRecurringOrderList)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].recurringOrdersTitle),url:__WEBPACK_IMPORTED_MODULE_7__types_Paths__["a" /* default */].MyAccountRecurringOrderList}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountRecurringOrderList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountRecurringOrderList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].recurringOrdersTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].recurringOrdersTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MyAccountRecurringOrderList__description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MainOrderList__description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].readAboutRecurring)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.paymentCardReminder',defaultMessage:'Subscriptions will be charged from a payment card. Please make sure you have added valid payment card. You can have multiple payment cards.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__order_MainOrderList__["a" /* default */],{resultsPerPage:ORDER_COUNT_PER_PAGE,useRecurringOrders:true})));}}]);return MyAccountRecurringOrderList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MyAccountRecurringOrderList.propTypes={recurringOrderStore:Object(__WEBPACK_IMPORTED_MODULE_11__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_RecurringOrderStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService','recurringOrderStore')(MyAccountRecurringOrderList)));

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyAccountRecurringOrder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_CountryStore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__product_ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__order_OrderStatusLabel__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__types_OrderTotalClass__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__product_ProductWarranty__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_MaybeExternalLink__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__types_ProductTypeClass__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__store_RecurringOrderStore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__order_MainRecurringOrder__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__order_RecurringOrderProductModify__ = __webpack_require__(1427);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* defineMessages */])({'myAccount.orderTitle':{'id':'myAccount.orderTitle','defaultMessage':'Order {orderId}'}});var productTotals=[__WEBPACK_IMPORTED_MODULE_23__types_OrderTotalClass__["b" /* default */].TOTAL,__WEBPACK_IMPORTED_MODULE_23__types_OrderTotalClass__["b" /* default */].EXTRA_TOTAL];var OrderHeaders={image:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].productTitle),name:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'order.productNameTitle',defaultMessage:'Name'}),quantity:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].quantityTitle),deliveredQuantity:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'order.deliveredQuantityTitle',defaultMessage:'Delivered qty'}),unitPrice:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'global.unitPriceTitle',defaultMessage:'Unit price'}),totalSum:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'order.totalShortTitle',defaultMessage:'Total'})};var MyAccountRecurringOrder=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MyAccountRecurringOrder,_Component);function MyAccountRecurringOrder(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MyAccountRecurringOrder);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MyAccountRecurringOrder.__proto__||Object.getPrototypeOf(MyAccountRecurringOrder)).call.apply(_ref,[this].concat(args))),_this),_this.state={updateError:null},_this.getCurrentOrderId=function(){return _this.props.match.params.id;},_this.maybeLoadOrder=function(){var recurringOrderStore=_this.props.recurringOrderStore;if(!recurringOrderStore.orders.get(_this.getCurrentOrderId())&&!recurringOrderStore.orderStates.get(_this.getCurrentOrderId())){recurringOrderStore.loadOrder(_this.getCurrentOrderId());}},_this.onSuccess=function(){var recurringOrderStore=_this.props.recurringOrderStore;_this.setState({updateError:null});recurringOrderStore.loadOrder(_this.getCurrentOrderId());},_this.onError=function(error){_this.setState({updateError:error,requestId:_this.state.requestId+1});},_this.onOrderUpdate=function(order){var recurringOrderStore=_this.props.recurringOrderStore;recurringOrderStore.updateOrder(_this.getCurrentOrderId(),order).then(function(){_this.onSuccess();}).catch(function(error){_this.onError(error);});},_this.onProductUpdate=function(updateProduct){var recurringOrderStore=_this.props.recurringOrderStore;recurringOrderStore.updateProduct(_this.getCurrentOrderId(),updateProduct).then(function(){_this.onSuccess();}).catch(function(error){_this.onError(error);});},_this.onProductRemove=function(id){var recurringOrderStore=_this.props.recurringOrderStore;recurringOrderStore.removeProduct(_this.getCurrentOrderId(),{extendedId:id}).then(function(){recurringOrderStore.loadOrder(_this.getCurrentOrderId());_this.setState({removeError:null});}).catch(function(error){return _this.setState({removeError:error,requestId:_this.state.requestId+1});});},_this.getOrderState=function(){var recurringOrderStore=_this.props.recurringOrderStore;return recurringOrderStore.orderStates.get(_this.getCurrentOrderId());},_this.getOrder=function(){var recurringOrderStore=_this.props.recurringOrderStore;return recurringOrderStore.orders.get(_this.getCurrentOrderId());},_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].myAccount),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccount},{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].recurringOrdersTitle),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountRecurringOrderList},{text:intl.formatMessage(messages['myAccount.orderTitle'],{orderId:_this.getCurrentOrderId()}),url:__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountOrderList}]);},_this.createProductImage=function(url,id){return url?__WEBPACK_IMPORTED_MODULE_20__models_ProductImage__["a" /* default */].create({id:0,product_id:id,sizes:{small:url}}):null;},_this.renderProductHeaderCol=function(label,sizes){var actualSizes=Object.assign({xs:4},sizes);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],Object.assign({className:'MyAccountOrder__product-header'},actualSizes),label);},_this.renderProductHeaderRow=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],{className:'MyAccountOrder__product-headers'},_this.renderProductHeaderCol(OrderHeaders.image,{md:2,xl:1}),_this.renderProductHeaderCol(OrderHeaders.name,{md:6,xl:7}),_this.renderProductHeaderCol(OrderHeaders.quantity,{md:1}),_this.renderProductHeaderCol(OrderHeaders.unitPrice,{md:2}),_this.renderProductHeaderCol(OrderHeaders.totalSum,{md:1}));},_this.renderProductLink=function(product){return product.isPhysicalProduct&&product.product_url?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__common_MaybeExternalLink__["a" /* default */],{to:product.product_url},product.name):product.name;},_this.renderProductCode=function(product){var _this$props2=_this.props,configStore=_this$props2.configStore,accountStore=_this$props2.accountStore;if(configStore.productCard.showProductCode||accountStore.isRetailer){var collectionOrMultiProduct=product.id.includes('{');var index=collectionOrMultiProduct?product.id.indexOf('{'):product.id;return product.id.substring(0,index);}},_this.renderProductRow=function(product){var isMobile=_this.props.uiStore.isMobile;var emptyColumn=!isMobile?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{md:'3'}):null;var order=_this.getOrder();return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],{key:product.id},!isMobile&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{className:'MyAccountOrder__products-image',xs:'2',xl:'1'},product.isPhysicalProduct&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__common_MaybeExternalLink__["a" /* default */],{to:product.product_url},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__product_ProductImage__["a" /* default */],{product:product,productImage:_this.createProductImage(product.image_url,product.id),size:'small',forceAspectRatio:false}))),isMobile&&_this.renderProductHeaderCol(OrderHeaders.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{xs:'8',md:'6',xl:'7'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MyAccountOrder__products-name-wrapper'},_this.renderProductLink(product),product&&product.type!==__WEBPACK_IMPORTED_MODULE_29__types_ProductTypeClass__["b" /* default */].SHIPPING_COST&&_this.renderProductCode(product)),product.variations&&product.variations.length>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',null,product.variations.map(function(variation,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:index},variation);})),product.reference&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MyAccountOrder__products-reference'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].yourReferenceTitle),': '+product.reference),product.warranty_in_months>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MyAccountOrder__products-warranty'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__product_ProductWarranty__["a" /* default */],{warranty:product.warranty_in_months}))),product.isPhysicalProduct?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,isMobile&&_this.renderProductHeaderCol(OrderHeaders.quantity),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{xs:'8',md:'1'},product.quantity_ordered,' ',product.stock_unit),isMobile&&_this.renderProductHeaderCol(OrderHeaders.unitPrice),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{xs:'8',md:'2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:product.final_unit_price}}),product.final_unit_price!==product.starting_unit_price&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{textDecoration:'line-through'},dangerouslySetInnerHTML:{__html:product.starting_unit_price}}))):emptyColumn,isMobile&&_this.renderProductHeaderCol(OrderHeaders.totalSum),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{xs:'8',md:'1',dangerouslySetInnerHTML:{__html:product.total_price}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__order_RecurringOrderProductModify__["a" /* default */],{onUpdate:_this.onProductUpdate,onRemove:_this.onProductRemove,cycles:order.cycles,minCustomDays:order.min_custom_cycle,product:product})));},_this.renderTotals=function(visibleTotalClasses){var order=_this.getOrder();var filtered=order.totals.filter(function(total){return visibleTotalClasses.includes(total.class);});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MyAccountOrder__totals'},__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(filtered,'value').map(function(totalsItem){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],{key:totalsItem.name},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{xs:'8',className:'MyAccountOrder__total-item'},totalsItem.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{xs:'4',className:'MyAccountOrder__total-value'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__product_Price__["a" /* default */],{price:totalsItem.value})));}));},_this.renderError=function(){var _this$state=_this.state,updateError=_this$state.updateError,requestId=_this$state.requestId;var errors=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(updateError,'response.data');var status=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(updateError,'response.status');return errors&&status!==404?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Alert */],{className:'MyAccountOrder__errors',color:'danger',key:requestId},Object.values(updateError.response.data).map(function(message){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__loader_UnexpectedError__["a" /* default */],null);},_this.renderMessage=function(){var recurringOrderStore=_this.props.recurringOrderStore;var message=null;switch(recurringOrderStore.orderStates.get(_this.getCurrentOrderId())){case __WEBPACK_IMPORTED_MODULE_33__types_RequestState__["b" /* default */].ERROR:message=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'order.orderNotFoundSentence',defaultMessage:'Order is not found'}));break;case __WEBPACK_IMPORTED_MODULE_33__types_RequestState__["b" /* default */].NONE:case __WEBPACK_IMPORTED_MODULE_33__types_RequestState__["b" /* default */].LOADING:case __WEBPACK_IMPORTED_MODULE_33__types_RequestState__["b" /* default */].LOADED:default:break;}return message;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MyAccountRecurringOrder,[{key:'componentDidMount',value:function componentDidMount(){this.maybeLoadOrder();}},{key:'navigateToOrderList',value:function navigateToOrderList(){var _props=this.props,history=_props.history,routeService=_props.routeService;history.push(routeService.getPath(__WEBPACK_IMPORTED_MODULE_13__types_Paths__["a" /* default */].MyAccountRecurringOrderList));}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,uiStore=_props2.uiStore,recurringOrderStore=_props2.recurringOrderStore;var updateError=this.state.updateError;var orderId=this.getCurrentOrderId();var queryStatus=recurringOrderStore.orderStates.get(this.getCurrentOrderId());return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__head_SEOTitle__["a" /* default */],{title:Object.assign({},messages['myAccount.orderTitle'],{values:{orderId:orderId}})}),queryStatus&&this.renderMessage(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_ContentForState__["a" /* default */],{state:this.getOrderState(),forLoaded:function forLoaded(){var order=_this2.getOrder();return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MyAccountRecurringOrder'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_PageTitle__["a" /* default */],{className:'MyAccountOrder__page-title'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],Object.assign({},messages['myAccount.orderTitle'],{values:{orderId:orderId}})),' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'MyAccountOrder__status'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__order_OrderStatusLabel__["a" /* default */],{status:order.recurring_status}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["n" /* Container */],{className:'MyAccountOrder__container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["j" /* CardHeader */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].orderInfoHeader),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].dateUpdatedTitle),' ',__WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(order.updated_at).toLocaleString(__WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].DATETIME_MED_WITH_SECONDS))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["n" /* Container */],{className:'MyAccountOrder__information-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],null,order&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__order_MainRecurringOrder__["a" /* default */],{onSubmit:_this2.onOrderUpdate,recurringOrder:order}),updateError&&_this2.renderError()))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Card */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["j" /* CardHeader */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].productsTitle)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["n" /* Container */],{className:'MyAccountOrder__products-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'MyAccountOrder__products'},!uiStore.isMobile&&_this2.renderProductHeaderRow(),order.products.map(function(product){return _this2.renderProductRow(product);})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["O" /* Row */],{className:'MyAccountOrder__products-totals-row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],{md:'6',xl:'8'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["l" /* Col */],null,_this2.renderTotals(productTotals))))))))));}}));}}]);return MyAccountRecurringOrder;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class;MyAccountRecurringOrder.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_30__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_28__store_ConfigStore__["a" /* default */]).isRequired,countryStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_CountryStore__["a" /* default */]).isRequired,recurringOrderStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_31__store_RecurringOrderStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_14__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_UIStore__["a" /* default */]).isRequired,history:__WEBPACK_IMPORTED_MODULE_9_react_router_prop_types___default.a.history.isRequired,intl:__WEBPACK_IMPORTED_MODULE_5_react_intl__["f" /* intlShape */].isRequired,match:__WEBPACK_IMPORTED_MODULE_9_react_router_prop_types___default.a.match.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','routeService','countryStore','recurringOrderStore','uiStore','configStore')(MyAccountRecurringOrder))));

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MainRecurringOrder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_RecurringOrderStore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_RecurringOrder__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RecurringOrderForm__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_AddressStore__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainRecurringOrder=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(MainRecurringOrder,_Component);function MainRecurringOrder(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MainRecurringOrder);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MainRecurringOrder.__proto__||Object.getPrototypeOf(MainRecurringOrder)).call.apply(_ref,[this].concat(args))),_this),_this.state={addressState:__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].NONE,optionsState:__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].NONE},_this.maybeLoadAddresses=function(){var addressStore=_this.props.addressStore;if(addressStore.state===__WEBPACK_IMPORTED_MODULE_8__types_RequestState__["b" /* default */].NONE){addressStore.loadAddresses();}},_this.maybeLoadShippingOptions=function(){var _this$props=_this.props,recurringOrder=_this$props.recurringOrder,recurringOrderStore=_this$props.recurringOrderStore;if(!recurringOrderStore.shippingOptions.get(recurringOrder.id)&&!recurringOrderStore.shippingOptionStates.get(recurringOrder.id)){recurringOrderStore.loadOrderShippingOptions(recurringOrder.id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MainRecurringOrder,[{key:'componentDidMount',value:function componentDidMount(){this.maybeLoadAddresses();this.maybeLoadShippingOptions();}},{key:'render',value:function render(){var _props=this.props,addressStore=_props.addressStore,recurringOrderStore=_props.recurringOrderStore,recurringOrder=_props.recurringOrder,onSubmit=_props.onSubmit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_ContentForState__["a" /* default */],{state:addressStore.state,forLoaded:function forLoaded(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RecurringOrderForm__["a" /* default */],{onSubmit:onSubmit,recurringOrder:recurringOrder,addresses:addressStore.addressArray,shippingOptions:recurringOrderStore.shippingOptions.get(recurringOrder.id)});}});}}]);return MainRecurringOrder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;MainRecurringOrder.propTypes={addressStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_AddressStore__["a" /* default */]).isRequired,recurringOrderStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_RecurringOrderStore__["a" /* default */]).isRequired,recurringOrder:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__models_RecurringOrder__["a" /* default */]).isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('addressStore','recurringOrderStore')(MainRecurringOrder));

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecurringOrderForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__form_CheckboxField__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_SelectField__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_RecurringOrderStore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_CurrencyStore__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__models_RecurringOrder__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__models_Address__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__models_ShippingOption__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__types_OrderStatusClass__ = __webpack_require__(158);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={status:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'global.active',defaultMessage:'Active subscription'}),title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.titleSentence',defaultMessage:'Give descriptive title'}),allowUnderDelivery:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].allowPartialDeliverySentence),allowShippingMethodChange:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].allowShippingChangeSentence),onHoldUntil:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.onHoldTitle',defaultMessage:'Set subscription on hold until (Use dropdown or calendar icon)'}),onHoldUntilPlaceHolder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.onHoldPlaceholder',defaultMessage:'Choose date from calendar'}),deliveryAddressId:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.deliveryAddressSentence',defaultMessage:'Delivery address'}),shippingMethodId:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.shippingMethodSentence',defaultMessage:'Subscription shipping method'})};function createOption(value,label){return{value:value,label:label};}var RecurringOrderForm=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(RecurringOrderForm,_Component);function RecurringOrderForm(props){_classCallCheck(this,RecurringOrderForm);var _this=_possibleConstructorReturn(this,(RecurringOrderForm.__proto__||Object.getPrototypeOf(RecurringOrderForm)).call(this,props));_initialiseProps.call(_this);var recurringOrder=_this.props.recurringOrder;_this.form=Object(__WEBPACK_IMPORTED_MODULE_6__models_Form__["a" /* createForm */])({title:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({value:recurringOrder&&recurringOrder.title}),status:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({value:recurringOrder&&recurringOrder.recurring_status===__WEBPACK_IMPORTED_MODULE_20__types_OrderStatusClass__["b" /* default */].ACTIVE?'1':''}),allowUnderDelivery:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({value:recurringOrder&&recurringOrder.allow_under_delivery?'1':''}),allowShippingMethodChange:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({value:recurringOrder&&recurringOrder.allow_shipping_method_change?'1':''}),onHoldUntil:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({value:recurringOrder.on_hold_until&&__WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(recurringOrder.on_hold_until).toISODate()},[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["c" /* isDate */])(labels.onHoldUntil,true)]),deliveryAddressId:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({value:recurringOrder&&recurringOrder.delivery_address_id},[Object(__WEBPACK_IMPORTED_MODULE_9__util_formValidators__["g" /* notBlank */])(labels.deliveryAddressId)]),shippingMethodId:Object(__WEBPACK_IMPORTED_MODULE_11__models_FormField__["a" /* createFormField */])({value:recurringOrder&&recurringOrder.shipping.method.id},[])});return _this;}_createClass(RecurringOrderForm,[{key:'render',value:function render(){var loading=this.props.loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Form */],{className:this.formName,noValidate:true,onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.formName+'__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.formName+'__title'},this.field('title',{autoComplete:'title'}),this.renderAddressSelect(),this.renderShippingSelect()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.formName+'__settings'},this.date('onHoldUntil'),this.checkbox('status',{options:[createOption('1',labels.status)]}),this.checkbox('allowUnderDelivery',{options:[createOption('1',labels.allowUnderDelivery)]}),this.checkbox('allowShippingMethodChange',{options:[createOption('1',labels.allowShippingMethodChange)]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Button */],{color:'primary',disabled:this.form.valid===false||loading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__i18n_globalTranslations__["a" /* default */].update)));}}]);return RecurringOrderForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='RecurringOrderForm';this.getCheckboxValue=function(value){return value.length>0?'1':'0';};this.getStatusValue=function(value){return value>0?__WEBPACK_IMPORTED_MODULE_20__types_OrderStatusClass__["b" /* default */].ACTIVE:__WEBPACK_IMPORTED_MODULE_20__types_OrderStatusClass__["b" /* default */].DEACTIVATED;};this.getDateValue=function(value){if(value===''){return null;}return value;};this.handleSubmit=function(event){var onSubmit=_this2.props.onSubmit;event.preventDefault();_this2.form.validate();if(_this2.form.valid){var values=_this2.form.getFieldValues();values.allowUnderDelivery=_this2.getCheckboxValue(values.allowUnderDelivery);values.allowShippingMethodChange=_this2.getCheckboxValue(values.allowShippingMethodChange);values.status=_this2.getStatusValue(values.status);values.deliveryAddressId=Number(values.deliveryAddressId);values.onHoldUntil=_this2.getDateValue(values.onHoldUntil);onSubmit(values);}};this.field=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__["a" /* default */],Object.assign({className:'RecurringOrderForm__field',field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.checkbox=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__form_CheckboxField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName},props));};this.date=function(fieldName){var preventDate=_this2.props.preventDate;var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderForm__dateField'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__["a" /* default */],{field:field,type:'date',required:false,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName],min:preventDate||__WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].local().toISODate(),onKeyDown:function onKeyDown(e){return e.preventDefault();}}));};this.getReadableAddress=function(address){var readable=[];if(address.street_address){readable.push(address.street_address);}if(address.postal_code){readable.push(address.postal_code+' '+address.city);}if(address.country){readable.push(address.country.name);}return readable.join(', ');};this.getReadableShippingOption=function(option){var currencyStore=_this2.props.currencyStore;return option.name+' '+Object(__WEBPACK_IMPORTED_MODULE_19__util_number__["d" /* formatPrice */])(option.price.getPrice(true),currencyStore.activeCurrency);};this.renderAddressSelect=function(){var addresses=_this2.props.addresses;if(!addresses||addresses.length<1){return null;}var fieldName='deliveryAddressId';var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_SelectField__["a" /* default */],{className:'RecurringOrderForm__selectField',field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName],options:addresses.map(function(address){return createOption(String(address.id),_this2.getReadableAddress(address));})});};this.renderShippingSelect=function(){var shippingOptions=_this2.props.shippingOptions;if(!shippingOptions){return null;}var fieldName='shippingMethodId';var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_SelectField__["a" /* default */],{className:'RecurringOrderForm__selectField',field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName],options:shippingOptions.map(function(option){return createOption(String(option.id),_this2.getReadableShippingOption(option));})});};},_temp))||_class;RecurringOrderForm.propTypes={recurringOrderStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_RecurringOrderStore__["a" /* default */]).isRequired,currencyStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_CurrencyStore__["a" /* default */]).isRequired,recurringOrder:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__models_RecurringOrder__["a" /* default */]),addresses:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__models_Address__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_17__models_Address__["a" /* default */]))]),shippingOptions:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* PropTypes */].observableArrayOf(Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__models_ShippingOption__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__models_ShippingOption__["a" /* default */]))]),onSubmit:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,preventDate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('currencyStore','recurringOrderStore')(RecurringOrderForm));

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecurringOrderProductModify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_RecurringOrderStore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__recurring_RecurringCycleDropdown__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_RecurringOrderProduct__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__recurring_RecurringDaysDropdown__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_RecurringOrderCycleType__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_QuantityFieldGroup__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_RECURRING_DAYS=365;var MAX_QUANTITY=99999;function createProductUpdate(id,quantity,cycle,days){return{extendedId:id,quantity:quantity,cycleType:cycle,customCycle:days};}var RecurringOrderProductModify=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RecurringOrderProductModify,_Component);function RecurringOrderProductModify(props){_classCallCheck(this,RecurringOrderProductModify);var _this=_possibleConstructorReturn(this,(RecurringOrderProductModify.__proto__||Object.getPrototypeOf(RecurringOrderProductModify)).call(this,props));_this.form=null;_this.handleUpdate=function(event){var _this$props=_this.props,onUpdate=_this$props.onUpdate,product=_this$props.product;var _this$state=_this.state,selectedQuantity=_this$state.selectedQuantity,selectedCycle=_this$state.selectedCycle,selectedDays=_this$state.selectedDays;event.preventDefault();_this.form.validate();if(_this.form.valid){onUpdate(createProductUpdate(product.id,selectedQuantity,selectedCycle,selectedDays));}};_this.handleRemove=function(id){var onRemove=_this.props.onRemove;onRemove(id);};_this.handleQuantityChange=function(quantity){_this.setState({selectedQuantity:quantity});};_this.handleCycleChange=function(event){var _this$props2=_this.props,product=_this$props2.product,minCustomDays=_this$props2.minCustomDays;var value=event.target.value;var selectedDays=product.recurring_order_custom_cycle;if(value===__WEBPACK_IMPORTED_MODULE_10__types_RecurringOrderCycleType__["b" /* default */].CUSTOM&&selectedDays===null){selectedDays=minCustomDays;}_this.setState({selectedCycle:value,selectedDays:selectedDays});};_this.handleDaysChange=function(event){var minCustomDays=_this.props.minCustomDays;var value=event.target.value;if(minCustomDays<=value&&value<=MAX_RECURRING_DAYS){_this.setState({selectedDays:Number(value)});}};_this.state={selectedQuantity:props.product.quantity_ordered,selectedCycle:props.product.recurring_order_cycle_type,selectedDays:props.product.recurring_order_custom_cycle?props.product.recurring_order_custom_cycle:props.minCustomDays};var quantityStep=props.product.getQuantityStep();_this.form=Object(__WEBPACK_IMPORTED_MODULE_12__models_Form__["a" /* createForm */])({quantity:Object(__WEBPACK_IMPORTED_MODULE_13__models_FormField__["a" /* createFormField */])({value:String(quantityStep)},[Object(__WEBPACK_IMPORTED_MODULE_14__util_formValidators__["j" /* quantityValid */])(MAX_QUANTITY,quantityStep),Object(__WEBPACK_IMPORTED_MODULE_14__util_formValidators__["i" /* productCountValid */])(quantityStep)])});_this.form.validate();return _this;}_createClass(RecurringOrderProductModify,[{key:'render',value:function render(){var _this2=this;var _props=this.props,cycles=_props.cycles,product=_props.product,minCustomDays=_props.minCustomDays;var selectedCycle=this.state.selectedCycle;var quantityField=this.form.fields.get('quantity');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderProductModify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderProductModify__quantity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["z" /* Label */],{'for':'RecurringOrderProductModify__quantity-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'recurringOrder.changeQuantity',defaultMessage:'Change product quantity'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_QuantityFieldGroup__["a" /* default */],{key:product.id,className:'RecurringOrderProductModify__quantity-group',field:quantityField,unit:product.stock_unit,quantityStep:product.getQuantityStep(),onUpdateProductQuantity:this.handleQuantityChange,defaultValue:product.quantity_ordered,maxQuantity:MAX_QUANTITY})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderProductModify__cycle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__recurring_RecurringCycleDropdown__["a" /* default */],{cycles:cycles,onChange:this.handleCycleChange,selectedValue:product.recurring_order_cycle_type})),minCustomDays&&selectedCycle===__WEBPACK_IMPORTED_MODULE_10__types_RecurringOrderCycleType__["b" /* default */].CUSTOM&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RecurringOrderProductModify__days'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__recurring_RecurringDaysDropdown__["a" /* default */],{onChange:this.handleDaysChange,selectedValue:this.state.selectedDays})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* ButtonGroup */],{className:'RecurringOrderProductModify__item-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{onClick:this.handleUpdate},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].saveTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{onClick:function onClick(){return window.confirm(_this2.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].confirmRemoveTitle))&&_this2.handleRemove(product.id);},color:'danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].removeTitle))));}}]);return RecurringOrderProductModify;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;RecurringOrderProductModify.propTypes={recurringOrderStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_RecurringOrderStore__["a" /* default */]).isRequired,product:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__models_RecurringOrderProduct__["a" /* default */]).isRequired,onUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired,cycles:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,minCustomDays:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('currencyStore','recurringOrderStore')(RecurringOrderProductModify)));

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_SetNewPasswordForm__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_route_Redirect302__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["d" /* defineMessages */])({setNewPasswordTitle:{'id':'account.setNewPasswordTitle','defaultMessage':'Choose a new password'}});var ResetPasswordPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ResetPasswordPage,_Component);function ResetPasswordPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResetPasswordPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResetPasswordPage.__proto__||Object.getPrototypeOf(ResetPasswordPage)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(messages.setNewPasswordTitle)}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResetPasswordPage,[{key:'render',value:function render(){var _props=this.props,accountStore=_props.accountStore,routeService=_props.routeService,match=_props.match;var token=match.params.token;if(accountStore.loggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_route_Redirect302__["a" /* default */],{to:'/'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_19__types_CommonPage__["b" /* default */].SET_NEW_PASSWORD,className:'ResetPasswordPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_head_SEOTitle__["a" /* default */],{title:messages.setNewPasswordTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_10__types_Paths__["a" /* default */].SetNewPassword)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'ResetPasswordPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],messages.setNewPasswordTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:'12',md:'8',lg:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_account_SetNewPasswordForm__["a" /* default */],{passwordResetToken:token}))))})));}}]);return ResetPasswordPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ResetPasswordPage.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_18__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_AccountStore__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11__services_RouteService__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_6_react_intl__["f" /* intlShape */].isRequired,match:__WEBPACK_IMPORTED_MODULE_4_react_router_prop_types___default.a.match.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','routeService')(ResetPasswordPage))));

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SetNewPasswordForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_FormValidator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__loader_UnexpectedError__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AccountModalLink__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types_AccountModalTab__ = __webpack_require__(74);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={newPassword:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].newPasswordTitle),confirmPassword:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].confirmPasswordTitle)};var SetNewPasswordForm=(_temp=_class=function(_Component){_inherits(SetNewPasswordForm,_Component);function SetNewPasswordForm(props){_classCallCheck(this,SetNewPasswordForm);var _this=_possibleConstructorReturn(this,(SetNewPasswordForm.__proto__||Object.getPrototypeOf(SetNewPasswordForm)).call(this,props));_initialiseProps.call(_this);var formValidator=props.formValidator;_this.form=Object(__WEBPACK_IMPORTED_MODULE_9__models_Form__["a" /* createForm */])({newPassword:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({},formValidator.password(labels.newPassword)),confirmPassword:Object(__WEBPACK_IMPORTED_MODULE_10__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_11__util_formValidators__["f" /* mustMatch */])(function(){return _this.form.fields.get('newPassword').value;})])});return _this;}_createClass(SetNewPasswordForm,[{key:'render',value:function render(){var requestState=this.state.requestState;return requestState===__WEBPACK_IMPORTED_MODULE_15__types_RequestState__["b" /* default */].LOADED?this.renderSuccess():this.renderForm();}}]);return SetNewPasswordForm;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.formName='SetNewPasswordForm';this.state={requestState:__WEBPACK_IMPORTED_MODULE_15__types_RequestState__["b" /* default */].NONE,error:null};this.handleSubmit=function(e){var _props=_this2.props,accountStore=_props.accountStore,passwordResetToken=_props.passwordResetToken;e.preventDefault();_this2.form.validate();if(_this2.form.valid){_this2.setState(function(){return{requestState:__WEBPACK_IMPORTED_MODULE_15__types_RequestState__["b" /* default */].LOADING,error:null};});accountStore.setPasswordWithToken(passwordResetToken,_this2.form.fields.get('newPassword').value,_this2.form.fields.get('confirmPassword').value).then(function(){_this2.setState(function(){return{requestState:__WEBPACK_IMPORTED_MODULE_15__types_RequestState__["b" /* default */].LOADED};});}).catch(function(e){_this2.setState(function(){return{requestState:__WEBPACK_IMPORTED_MODULE_15__types_RequestState__["b" /* default */].ERROR,error:e};});});}};this.field=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};this.renderError=function(){var _state=_this2.state,error=_state.error,requestId=_state.requestId;var status=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error,'response.status');return[409,422].includes(status)?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{className:'SetNewPasswordForm__errors',color:'danger',key:requestId},__WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default()(Object.values(error.response.data.errors||error.response.data)).map(function(message){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:message},message);})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__loader_UnexpectedError__["a" /* default */],null);};this.renderForm=function(){var _state2=_this2.state,requestState=_state2.requestState,error=_state2.error;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["s" /* Form */],{className:_this2.formName,noValidate:true,onSubmit:_this2.handleSubmit},_this2.field('newPassword',{type:'password',autoComplete:'new-password'}),_this2.field('confirmPassword',{type:'password',autoComplete:'new-password'}),error&&_this2.renderError(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{color:'primary',block:true,disabled:_this2.form.valid===false||requestState===__WEBPACK_IMPORTED_MODULE_15__types_RequestState__["b" /* default */].LOADING},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'account.setNewPassword',defaultMessage:'Set new password'})));};this.renderSuccess=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{color:'success'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'account.setNewPasswordSuccessful',defaultMessage:'Your password was changed successfully. You may now log in.'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["O" /* Row */],{className:'SetNewPasswordForm__row-login'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["l" /* Col */],{xs:'12',className:'SetNewPasswordForm__col-login'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__AccountModalLink__["a" /* default */],{tab:__WEBPACK_IMPORTED_MODULE_18__types_AccountModalTab__["b" /* default */].LOGIN,className:'SetNewPasswordForm__login-button'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["e" /* Button */],{tag:'span',color:'primary'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].logInSentence))))));};},_temp);SetNewPasswordForm.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_AccountStore__["a" /* default */]).isRequired,passwordResetToken:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,formValidator:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14__services_FormValidator__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* inject */])('accountStore','formValidator')(SetNewPasswordForm));

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PasswordResetRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_generatePath__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__QueryParamRedirect__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PasswordResetRedirect=function(_Component){_inherits(PasswordResetRedirect,_Component);function PasswordResetRedirect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PasswordResetRedirect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PasswordResetRedirect.__proto__||Object.getPrototypeOf(PasswordResetRedirect)).call.apply(_ref,[this].concat(args))),_this),_this.getRedirectTarget=function(param){return _this.props.routeService.getPath(Object(__WEBPACK_IMPORTED_MODULE_5__util_generatePath__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__types_Paths__["a" /* default */].SetNewPassword,{token:param}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PasswordResetRedirect,[{key:'render',value:function render(){var location=this.props.location;var _parse=Object(__WEBPACK_IMPORTED_MODULE_9__util_queryString__["b" /* parse */])(location.search),prcd=_parse.prcd;var param=prcd?'prcd':'renew_code';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__QueryParamRedirect__["a" /* default */],{paramName:param,to:this.getRedirectTarget});}}]);return PasswordResetRedirect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PasswordResetRedirect.propTypes={location:__WEBPACK_IMPORTED_MODULE_8_react_router_prop_types___default.a.location.isRequired,routeService:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('routeService')(Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* withRouter */])(PasswordResetRedirect)));

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_head_RobotsMeta__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_checkout_ThankYouPageContent__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_TrackingPageType__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_TrackingStore__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({successfulPurchasePageTitle:{'id':'checkout.successfulPurchasePageTitle','defaultMessage':'Your order has been registered!'}});var ThankYouPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ThankYouPage,_Component);function ThankYouPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ThankYouPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ThankYouPage.__proto__||Object.getPrototypeOf(ThankYouPage)).call.apply(_ref,[this].concat(args))),_this),_this.sendTrackingData=function(currentOrder){var _this$props=_this.props,trackingStore=_this$props.trackingStore,configStore=_this$props.configStore;if(!configStore.activateSpotmore.enabled||typeof document==='undefined'||!currentOrder||currentOrder.is_seen){return null;}if(configStore.activateSpotmore.enabled&&window.crmtracker){window.crmtracker.sendData();}trackingStore.setPageView({page:__WEBPACK_IMPORTED_MODULE_9__types_TrackingPageType__["a" /* default */].CHECKOUT_SUCCESS,refererUrl:document.referrer,visitedUrl:window.location.href});trackingStore.postPageView();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ThankYouPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_13__types_CommonPage__["b" /* default */].CHECKOUT_SUCCESS,className:'ThankYouPage',onDefinedTrackingPage:__WEBPACK_IMPORTED_MODULE_9__types_TrackingPageType__["a" /* default */].CHECKOUT_SUCCESS},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'ThankYouPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_head_SEOTitle__["a" /* default */],{title:messages.successfulPurchasePageTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_head_RobotsMeta__["a" /* default */],{noindex:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_checkout_ThankYouPageContent__["a" /* default */],{onOrderSuccess:this.sendTrackingData}))})));}}]);return ThankYouPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ThankYouPage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_ConfigStore__["a" /* default */]).isRequired,trackingStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_TrackingStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','trackingStore')(ThankYouPage));

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckoutOrderConfirmation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_CustomCol__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_OrderTotalClass__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_OrderStore__ = __webpack_require__(117);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* defineMessages */])({orderCompleted:{'id':'checkout.orderCompleted','defaultMessage':'Your order has been received.'},paymentInstructions:{'id':'checkout.paymentInformation','defaultMessage':'Confirmation email has also been sent to the email address {email}. Make sure email address is correct.'},paymentInstructions2:{'id':'checkout.paymentInformation2','defaultMessage':'If you don\'t see the message, be sure to check your spam folder as well.'},shoppingCenterMerchantInfo:{'id':'checkout.shoppingCenterMerchantInfo','defaultMessage':'merchant\'s {merchant}'},trackOrder:{'id':'checkout.trackOrder','defaultMessage':'You can track your order by clicking {link}, you can also get to the {merchantInfo} order tracking page from the confirmation email.'},orderInformationTitle:{'id':'checkout.orderInformationTitle','defaultMessage':'Order information'},orderConfirmationThankYou:{'id':'checkout.orderConfirmationThankYou','defaultMessage':'Thank you for your order!'}});var CheckoutOrderConfirmation=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(CheckoutOrderConfirmation,_Component);function CheckoutOrderConfirmation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CheckoutOrderConfirmation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CheckoutOrderConfirmation.__proto__||Object.getPrototypeOf(CheckoutOrderConfirmation)).call.apply(_ref,[this].concat(args))),_this),_this.renderSuccessPage=function(){var orderStore=_this.props.orderStore;var currentOrder=orderStore.currentOrder;if(!currentOrder){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_CustomCol__["a" /* default */],{xs:12,md:10,xxl:7,className:'CheckoutOrderConfirmation'},_this.renderOrderConfirmation());},_this.renderOrderConfirmation=function(){var _this$props=_this.props,configStore=_this$props.configStore,orderStore=_this$props.orderStore;var currentOrder=orderStore.currentOrder;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,_this.renderOrderSuccessInformation(),configStore.account.enableMyAccount&&_this.renderOrderTrackingInformation(),currentOrder.has_licensed_products&&_this.renderAlert('warning',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'checkout.successfulPurchaseLicensedProductsSentence',defaultMessage:'Some products in your order require a license. You may pay your order now; after this, you are required to send the relevant licenses to us by email. Please refer to the shipping terms page for more details.'})),_this.renderOrderInformation());},_this.renderOrderSuccessInformation=function(){var orderStore=_this.props.orderStore;var currentOrder=orderStore.currentOrder;var email=currentOrder.confirmation_email;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Icon__["a" /* default */],{name:'check'}),{className:'CheckoutOrderConfirmation__order-success-icon'}),_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],messages.orderCompleted),{className:'CheckoutOrderConfirmation__order-completed'}),email&&_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.paymentInstructions,{values:{email:email}})),{className:'CheckoutOrderConfirmation__payment-instructions'}),email&&_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],messages.paymentInstructions2),{className:'CheckoutOrderConfirmation__payment-instructions'}));},_this.renderOrderTrackingInformation=function(){var orderStore=_this.props.orderStore;var currentOrder=orderStore.currentOrder;var paymentMethodMessages=currentOrder.payment_method_messages;var translationValues=_this.getTranslationValues();return _this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-confirmation-message-track-order'},currentOrder.tracking_url&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.trackOrder,{values:translationValues})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__payment-method-messages'},paymentMethodMessages&&paymentMethodMessages.length>0&&paymentMethodMessages.map(function(message,index){return _this.renderAlert('warning',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,message),{key:index});}))),{className:'CheckoutOrderConfirmation__order-confirmation-message'});},_this.getTranslationValues=function(){var _this$props2=_this.props,orderStore=_this$props2.orderStore,configStore=_this$props2.configStore;var currentOrder=orderStore.currentOrder;var merchant=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],Object.assign({},messages.shoppingCenterMerchantInfo,{values:{merchant:currentOrder.merchant_name}}));var translationValues={link:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:currentOrder.tracking_url,target:'_blank',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].hereSentence))};translationValues.merchantInfo=configStore.siteConfig.isShoppingCenter?merchant:'';return translationValues;},_this.renderOrderInformation=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],messages.orderInformationTitle),{className:'CheckoutOrderConfirmation__order-information-title'}),_this.renderContentRow({xs:12},_this.renderOrderInformationContent()),_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-thankyou'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],messages.orderConfirmationThankYou))));},_this.renderOrderInformationContent=function(){var orderStore=_this.props.orderStore;var currentOrder=orderStore.currentOrder;var paymentMethod=currentOrder.paymentMethod;var shippingMethod=currentOrder.shippingMethod;var id=currentOrder.id;var paymentMethodName=paymentMethod.name;var shippingMethodName=shippingMethod.name;var pickupPoint=currentOrder.pickupPoint;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-content'},_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-product-wrapper'},currentOrder.products.map(function(product){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:product.id,className:'CheckoutOrderConfirmation__order-information-product'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,product.name,' x ',product.quantity),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'CheckoutOrderConfirmation__order-information-value'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__product_Price__["a" /* default */],{price:product.final_unit_price})));}))),_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-total-wrapper'},currentOrder.totals.map(function(total){return total.class!==__WEBPACK_IMPORTED_MODULE_9__types_OrderTotalClass__["b" /* default */].EXTRA_TOTAL&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()(total.name),className:'CheckoutOrderConfirmation__order-information-total'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,total.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'CheckoutOrderConfirmation__order-information-value',dangerouslySetInnerHTML:{__html:total.text}}));}))),_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-id'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].orderNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'CheckoutOrderConfirmation__order-information-value'},id))),_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-payment-method'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].paymentMethod),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'CheckoutOrderConfirmation__order-information-value'},paymentMethodName))),_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-shipping-method'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].shippingMethod),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'CheckoutOrderConfirmation__order-information-value'},shippingMethodName))),pickupPoint&&_this.renderContentRow({xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-pickup-point'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__i18n_globalTranslations__["a" /* default */].pickupPointTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-value'},pickupPoint.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'CheckoutOrderConfirmation__order-information-value'},pickupPoint.address)))));},_this.renderContentRow=function(sizes,content,className,rest){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],Object.assign({},rest,className),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_CustomCol__["a" /* default */],sizes,content));},_this.renderAlert=function(type,message,rest){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Alert */],Object.assign({},rest,{color:type}),message);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CheckoutOrderConfirmation,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.renderSuccessPage());}}]);return CheckoutOrderConfirmation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;CheckoutOrderConfirmation.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_ConfigStore__["a" /* default */]).isRequired,orderStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_OrderStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore','orderStore')(CheckoutOrderConfirmation));

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_OrderStore__ = __webpack_require__(117);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TrackingPixels=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(TrackingPixels,_Component);function TrackingPixels(){_classCallCheck(this,TrackingPixels);return _possibleConstructorReturn(this,(TrackingPixels.__proto__||Object.getPrototypeOf(TrackingPixels)).apply(this,arguments));}_createClass(TrackingPixels,[{key:'render',value:function render(){var orderStore=this.props.orderStore;var currentOrder=orderStore.currentOrder;if(!currentOrder||currentOrder.is_seen||currentOrder.tracking_pixels.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,currentOrder.tracking_pixels.map(function(pixel,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,dangerouslySetInnerHTML:{__html:pixel}});}));}}]);return TrackingPixels;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;TrackingPixels.propTypes={orderStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_OrderStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('orderStore')(TrackingPixels));

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_OrderStore__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet_async__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShopAlike=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(ShopAlike,_Component);function ShopAlike(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShopAlike);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShopAlike.__proto__||Object.getPrototypeOf(ShopAlike)).call.apply(_ref,[this].concat(args))),_this),_this.getPIScript=function(){var _this$props=_this.props,configStore=_this$props.configStore,orderStore=_this$props.orderStore;var currentOrder=orderStore.currentOrder;var ids=currentOrder?currentOrder.products.map(function(product){return"'"+product.product_id+"'";}):[];var prices=currentOrder?currentOrder.products.map(function(product){return"'"+product.total_price+"'";}):[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',{type:'text/javascript'},'var vmt_pi = {\n          \'trackingId\': \''+configStore.shopAlike.id+'\',\n          \'version\' : \'a_0.0.1\',\n          \'type\' : \'confirmed\',\n          \'amount\' : '+currentOrder.real_total+',\n          \'skus\' : ['+ids+'],\n          \'prices\' : ['+prices+'],\n          \'currency\' : \''+currentOrder.currency+'\'\n        };');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShopAlike,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,orderStore=_props.orderStore;var currentOrder=orderStore.currentOrder;if(!configStore.shopAlike.enabled){return null;}if(!currentOrder||currentOrder.is_seen){return null;}var mainScript=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',{type:'text/javascript'},'var vmt = {};\n          (function(d, p) {\n            var vmtr = d.createElement(\'script\');\n            vmtr.type = \'text/javascript\';\n            vmtr.async = true;\n            var cachebuster = Math.round(new Date().getTime() / 1000);\n            vmtr.src = (\'https:\' == p ? \'https\' : \'http\') + \'://www.shopalike.fi/controller/visualMetaTrackingJs?cb=\' + cachebuster;\n            var s = d.getElementsByTagName(\'script\')[0];\n            s.parentNode.insertBefore(vmtr, s);\n          })(document, document.location.protocol);');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet_async___default.a,null,this.getPIScript(),mainScript);}}]);return ShopAlike;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;ShopAlike.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_ConfigStore__["a" /* default */]).isRequired,orderStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_OrderStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','orderStore')(ShopAlike));

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotFoundPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_head_RobotsMeta__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_AdZones__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_AdStore__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_query__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* defineMessages */])({notFoundTitle:{'id':'error.notFoundTitle','defaultMessage':'Page not found'}});var NotFoundPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(NotFoundPage,_Component);function NotFoundPage(props){_classCallCheck(this,NotFoundPage);var _this=_possibleConstructorReturn(this,(NotFoundPage.__proto__||Object.getPrototypeOf(NotFoundPage)).call(this,props));_this.loadAds=function(){var adStore=_this.props.adStore;adStore.loadAds(_this.searchParams);};_this.sendAnalyticsEvent=function(){_this.props.analytics.pageNotFound({location:window.location.href,referrer:document.referrer});};_this.renderDefaultPageContent=function(){var adStore=_this.props.adStore;var adQueryState=adStore.getAdQueryStateBySearchParameters(_this.searchParams);var ifLoading=adQueryState===__WEBPACK_IMPORTED_MODULE_20__types_RequestState__["b" /* default */].LOADING;var bannerContent=adStore.getAdsBySearchParameters(_this.searchParams);if(bannerContent&&bannerContent.length>0||ifLoading){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'NotFoundPage__help-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'error.notFoundHelpText',defaultMessage:'If it still exists, its address might have changed. You can continue browsing the web store or attempt to find what you were looking by using the search function.'}));};_this.getContent=function(){var adStore=_this.props.adStore;var ads=adStore.getAdsBySearchParameters(_this.searchParams);if(!ads||ads.length===0){return null;}return ads.map(function(ad){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_WysiwygContent__["a" /* default */],{key:ad.id,html:ad.content});});};_this.renderNavigationButtons=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Button */],{className:'NotFoundPage__back-to-home-button',tag:__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */],to:_this.props.routeService.getPath(__WEBPACK_IMPORTED_MODULE_12__types_Paths__["a" /* default */].FrontPage),color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_Icon__["a" /* default */],{name:'home'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'error.notFoundBackToHome',defaultMessage:'Return to the front page'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'error.notFoundGoToSearch',defaultMessage:'or use the product search.'}));};var staticContext=props.staticContext;_this.searchParams={bannerZone:__WEBPACK_IMPORTED_MODULE_15__types_AdZones__["a" /* default */].NOT_FOUND_CONTENT};if(staticContext){staticContext.is404=true;}return _this;}_createClass(NotFoundPage,[{key:'componentDidMount',value:function componentDidMount(){this.loadAds();this.sendAnalyticsEvent();}},{key:'render',value:function render(){var adStore=this.props.adStore;var adQueryState=adStore.adQueryStates.get(Object(__WEBPACK_IMPORTED_MODULE_21__util_query__["a" /* paramsToQueryIdentifier */])(this.searchParams));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_24__types_CommonPage__["b" /* default */].NOT_FOUND,className:'NotFoundPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_head_SEOTitle__["a" /* default */],{title:Object.assign({},messages.notFoundTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_head_RobotsMeta__["a" /* default */],{noindex:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'NotFoundPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["O" /* Row */],{className:'NotFoundPage__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Col */],{xs:'12',md:{size:10,offset:1},xl:{size:8,offset:2}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:'error.notFoundHeader',defaultMessage:'Unfortunately the page you requested could not be found anymore.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NotFoundPage__text-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_loader_ContentForState__["a" /* default */],{state:adQueryState,error:adStore.adQueryError,forLoaded:this.getContent}),this.renderDefaultPageContent()),this.renderNavigationButtons()))})));}}]);return NotFoundPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;NotFoundPage.propTypes={adStore:Object(__WEBPACK_IMPORTED_MODULE_17__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_18__store_AdStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_17__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_16__store_SectionStore__["a" /* default */]).isRequired,analytics:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_23__analytics_Analytics__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_13__services_RouteService__["a" /* default */]).isRequired,staticContext:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('adStore','analytics','sectionStore','routeService')(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* withRouter */])(NotFoundPage)));

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GclidTracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var COOKIE_KEY='gclid_start_time';var setStoredExpiration=function setStoredExpiration(expireInSeconds){var expiryTimestamp=new Date().getTime()+expireInSeconds*1000;return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set(COOKIE_KEY,expiryTimestamp);};var getStoredExpiration=function getStoredExpiration(){return Number(__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get(COOKIE_KEY)||0);};var removeStoredExpiration=function removeStoredExpiration(){return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove(COOKIE_KEY);};var GclidTracker=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(GclidTracker,_Component);function GclidTracker(props){_classCallCheck(this,GclidTracker);var _this=_possibleConstructorReturn(this,(GclidTracker.__proto__||Object.getPrototypeOf(GclidTracker)).call(this,props));var location=_this.props.location;var _parse=Object(__WEBPACK_IMPORTED_MODULE_5__util_queryString__["b" /* parse */])(location.search),gclid=_parse.gclid,cuad=_parse.cuad;_this.onRouteChanged(true,gclid||cuad);return _this;}_createClass(GclidTracker,[{key:'UNSAFE_componentWillUpdate',value:function UNSAFE_componentWillUpdate(nextProps){// We hook into UNSAFE_componentWillUpdate so that the UI flashes as little as possible.
if(this.props.location!==nextProps.location){this.onRouteChanged(false);}return false;}},{key:'onRouteChanged',value:function onRouteChanged(initial,gclid){var expiration=this.props.expiration;if(window.isSSR){return;}var storedExpiration=getStoredExpiration();var hasExpired=storedExpiration>0&&storedExpiration<new Date().getTime();if(hasExpired&&initial){removeStoredExpiration();}else if(storedExpiration===0&&gclid){setStoredExpiration(expiration);}else if(hasExpired){window.location.reload();}}},{key:'render',value:function render(){return null;}}]);return GclidTracker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;GclidTracker.propTypes={expiration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])(function(store){return{expiration:store.configStore.gclid.expirationSeconds};})(GclidTracker));

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FacebookEventHandler__ = __webpack_require__(1438);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FacebookPixel=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(FacebookPixel,_Component);function FacebookPixel(){_classCallCheck(this,FacebookPixel);return _possibleConstructorReturn(this,(FacebookPixel.__proto__||Object.getPrototypeOf(FacebookPixel)).apply(this,arguments));}_createClass(FacebookPixel,[{key:'componentDidMount',value:function componentDidMount(){var configStore=this.props.configStore;if(configStore.facebookPixel.enabled){new __WEBPACK_IMPORTED_MODULE_6__FacebookEventHandler__["a" /* default */]();}}},{key:'render',value:function render(){var configStore=this.props.configStore;if(!configStore.facebookPixel.enabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,'!function(f,b,e,v,n,t,s)\n            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n            n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';\n            n.queue=[];t=b.createElement(e);t.async=!0;\n            t.src=v;s=b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t,s)}(window, document,\'script\',\n            \'https://connect.facebook.net/en_US/fbevents.js\');\n            fbq(\'init\', \''+configStore.facebookPixel.id+'\');')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:'1',width:'1',style:{display:'none'},alt:'',src:'https://www.facebook.com/tr?id='+configStore.facebookPixel.id+'&ev=PageView&noscript=1'})));}}]);return FacebookPixel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;FacebookPixel.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_AccountStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','accountStore')(FacebookPixel));

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacebookEventHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_OrderTotalClass__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var FacebookEventHandler=function(){function FacebookEventHandler(){var _this=this;_classCallCheck(this,FacebookEventHandler);this.handleEvents=function(event){switch(event.detail.name){case __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__["a" /* default */].setPage:_this.pageView();break;case __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__["a" /* default */].productDetail:_this.viewContent(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__["a" /* default */].addToCart:_this.addToCart(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__["a" /* default */].purchase:_this.purchase(event.detail.payload);break;default:}};document.addEventListener('analytics',this.handleEvents,true);}_createClass(FacebookEventHandler,[{key:'pageView',value:function pageView(){this.pushEvent('PageView');}/**
   * @param {Array} currencyCode
   * @param {Array} productList An array with objects in the format { product, activeProductId }.
   */},{key:'viewContent',value:function viewContent(_ref){var currencyCode=_ref.currencyCode,productList=_ref.productList;var product=productList[0].product;var productType=product.class===__WEBPACK_IMPORTED_MODULE_2__types_ProductClass__["b" /* default */].MULTI?'product_group':'product';var data={content_type:productType,content_ids:[String(product.id)],value:product.price_info?product.price_info.getPrice(true).toFixed(2):0.0,currency:currencyCode};this.pushEvent('ViewContent',data);}/**
   * @param {Array} productList An array with objects in the format { position, product }.
   * @param {string} listName
   */},{key:'addToCart',value:function addToCart(_ref2){var currencyCode=_ref2.currencyCode,productList=_ref2.productList;if(productList.length>0){var contentIds=productList.map(function(productData){return productData.product.id;});var value=productList.reduce(function(sum,productData){var quantity=productData.newQuantity||productData.quantity;return sum+quantity*productData.price;},0);var data={content_type:'product',content_ids:contentIds,value:value.toFixed(2),currency:currencyCode};this.pushEvent('AddToCart',data);}}/**
   * @param {Order} order data.
   */},{key:'purchase',value:function purchase(_ref3){var order=_ref3.order;var orderTotalsByClass=__WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default()(order.totals,'class');var getTotalByClass=function getTotalByClass(totalClass){var total=orderTotalsByClass[totalClass];// The totals we use should always be there, but...
return total?total.value:null;};var orderProducts=order.products.map(function(product){return{id:product.product_id,quantity:product.quantity,item_price:product.final_unit_price};});var data={content_type:'product',contents:orderProducts,value:getTotalByClass(__WEBPACK_IMPORTED_MODULE_3__types_OrderTotalClass__["b" /* default */].TOTAL),currency:order.currency};this.pushEvent('Purchase',data);}/**
   * @param {string} event Event name.
   * @param {object} data Object containing data for the event.
   */},{key:'pushEvent',value:function pushEvent(event){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(window.fbq){window.fbq('track',event,data);}}}]);return FacebookEventHandler;}();

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StyleOverrides */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StyleOverrides=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(StyleOverrides,_Component);function StyleOverrides(){_classCallCheck(this,StyleOverrides);return _possibleConstructorReturn(this,(StyleOverrides.__proto__||Object.getPrototypeOf(StyleOverrides)).apply(this,arguments));}_createClass(StyleOverrides,[{key:'render',value:function render(){var accountStore=this.props.accountStore;if(!accountStore.account||!accountStore.account.styles){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet_async___default.a,{style:[{type:'text/css',cssText:''+accountStore.account.styles}]});}}]);return StyleOverrides;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;StyleOverrides.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_AccountStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('accountStore')(StyleOverrides));

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GiosgEventHandler__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Giosg=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(Giosg,_Component);function Giosg(){_classCallCheck(this,Giosg);return _possibleConstructorReturn(this,(Giosg.__proto__||Object.getPrototypeOf(Giosg)).apply(this,arguments));}_createClass(Giosg,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,configStore=_props.configStore,accountStore=_props.accountStore;if(configStore.giosg.enabled&&configStore.giosg.merchantId.length>0){window.giosgEventHandler=new __WEBPACK_IMPORTED_MODULE_5__GiosgEventHandler__["a" /* default */](accountStore);}}},{key:'render',value:function render(){var configStore=this.props.configStore;if(!configStore.giosg.enabled||!configStore.giosg.merchantId.length>0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,'(function(w, t, f) {\n                var s=\'script\',o=\'_giosg\',h=\'https://service.giosg.com\',e,n;\n                e=t.createElement(s);\n                e.async=1;\n                e.src=h+\'/live/\';\n                w[o]=w[o]||function(){(w[o]._e=w[o]._e||[]).push(arguments)};\n                w[o]._c=f;\n                w[o]._h=h;\n                n=t.getElementsByTagName(s)[0];\n                n.parentNode.insertBefore(e,n);\n              })(window,document,'+configStore.giosg.merchantId+');')));}}]);return Giosg;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;Giosg.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_AccountStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','accountStore')(Giosg));

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GiosgEventHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_UserTokenType__ = __webpack_require__(1442);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var GiosgEventHandler=(_temp=_class=function(){function GiosgEventHandler(accountStore){_classCallCheck(this,GiosgEventHandler);_initialiseProps.call(this);this.accountStore=accountStore;this.registerAnalyticsEventListener();}_createClass(GiosgEventHandler,[{key:'cartStatus',/**
   * @param {Object} cart Cart content data.
   */value:function cartStatus(_ref){var cart=_ref.cart;var cartProducts=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(cart.cart,'products',[]);var products=cartProducts.filter(function(product){return product.name&&product.final_unit_price&&product.quantity;}).map(function(product){var price=product.final_unit_price?product.final_unit_price.toFixed(2):0;return{name:product.name,price:price,quantity:product.quantity,description:product.short_description,category:product.category_name,product_number:product.product_id};});this.maybePushVisitorInfo(this.accountStore);this.pushEvent('shoppingCart','submit',products);}/**
   * Freeze shopping cart information.
   */},{key:'freeze',value:function freeze(){var _this=this;this.pushEvent('shoppingCart','freeze');setTimeout(function(){_this.pushEvent('shoppingCart','submit',[]);},1000);}/**
   * Clear all shopping cart information.
   */},{key:'clearCart',value:function clearCart(){this.pushEvent('shoppingCart','clearCart');}/**
   * @param {string} event Event name.
   * @param {string} method Method name.
   * @param {object} data Object containing data for the event.
   * @param rest
   *//**
   * @param {number} priority
   * Visitor priority controls displayed bubble color in Giosg console.
   */}]);return GiosgEventHandler;}(),_initialiseProps=function _initialiseProps(){var _this2=this;this.registerAnalyticsEventListener=function(){// Bail if we are in SSR.
if(typeof document==='undefined'){return null;}document.addEventListener('analytics',_this2.handleEvents,true);};this.maybePushVisitorInfo=function(accountStore){if(!accountStore||!accountStore.account){return;}accountStore.account.tokens.forEach(function(token){if(token.type===__WEBPACK_IMPORTED_MODULE_2__types_UserTokenType__["a" /* default */].GIOSG&&token.value.length>0){_this2.pushEvent('visitor','submit',token.value,token.algorithm,true);}});};this.handleEvents=function(event){switch(event.detail.name){case __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__["a" /* default */].cartStatus:_this2.cartStatus(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__["a" /* default */].clearCart:_this2.clearCart(event.detail.payload);break;case __WEBPACK_IMPORTED_MODULE_1__AnalyticsEventNames__["a" /* default */].purchase:_this2.freeze(event.detail.payload);break;default:}};this.pushEvent=function(event,method){for(var _len=arguments.length,rest=Array(_len>3?_len-3:0),_key=3;_key<_len;_key++){rest[_key-3]=arguments[_key];}var data=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(window._giosg&&typeof window._giosg==='function'){var _window;(_window=window)._giosg.apply(_window,[event,method,data].concat(rest));}};this.setVisitorPriority=function(priority){var giosgClient=window.GiosgClient;if(giosgClient){giosgClient.setVisitorPriority(priority);}};},_temp);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserTokenTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var UserTokenType={GIOSG:'GIOSG'};/* harmony default export */ __webpack_exports__["a"] = (UserTokenType);var UserTokenTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('UserTokenType',Object.values(UserTokenType));

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_storage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_constants__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_slider_LastVisitedProductsSlider__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__types_AccountModalTab__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_ButtonLink__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_wish_list_WishListEmailForm__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_wish_list_WishListProductRow__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MobileWishlistLabels={name:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.Product',defaultMessage:'Product'}),quantity:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.AmountAndInTotal',defaultMessage:'Amount / In Total'}),unitPrice:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.UnitPrice',defaultMessage:'Price per Unit'})};var WishListPage=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(WishListPage,_Component);function WishListPage(props){_classCallCheck(this,WishListPage);var _this=_possibleConstructorReturn(this,(WishListPage.__proto__||Object.getPrototypeOf(WishListPage)).call(this,props));_this.state={storage:[],notFound:false,alertVisible:true};_this.redirectIfWishlistIsNotEnabled=function(){var _this$props=_this.props,configStore=_this$props.configStore,routeService=_this$props.routeService,history=_this$props.history;if(!configStore.wishlist.enabled){history.push(routeService.getPath(__WEBPACK_IMPORTED_MODULE_8__types_Paths__["a" /* default */].NotFoundPage));}};_this.fetchProductList=function(){var productStore=_this.props.productStore;productStore.getProductList().then(function(response){_this.setState({storage:response.data});}).catch(function(e){console.error(e);});};_this.getSavedProductList=function(productList,localProductList){productList.forEach(function(product){localProductList=localProductList.filter(function(val){return val.product_id!==product.product_id;});});return productList.concat(localProductList);};_this.renderWishListContent=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],{className:'WishListPage__card-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{xs:12,xl:9},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Card */],{className:'WishListPage__product-list-card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* CardBody */],{className:'WishListPage__product-list-card-body'},_this.notLoggedInAlertBanner(),_this.productListInformationAlertBanner(),_this.productListNotFoundAlertBanner(),_this.emptyProductList(),_this.productInfoLabelRow(),_this.renderWishList()))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{xs:12,xl:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Card */],{className:'WishListPage__product-list-card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* CardBody */],{className:'WishListPage__product-list-card-body-email-form'},_this.emailWishlistForm())))));};_this.getBreadcrumbsPath=function(){var _this$props2=_this.props,intl=_this$props2.intl,routeService=_this$props2.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].wishListTitle),url:__WEBPACK_IMPORTED_MODULE_8__types_Paths__["a" /* default */].WishList}]);};_this.renderProductHeaderCol=function(label,sizes){var actualSizes=Object.assign({xs:4},sizes);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],Object.assign({className:'WishListPage__product-list-header'},actualSizes),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'WishListPage__product-list-header-label'},label));};_this.productListNotFoundAlertBanner=function(){if(!_this.state.notFound){return null;}var message=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.wishlistNotFound',defaultMessage:'Wishlist doesn\'t exist with the given id.'});return _this.renderAlertBanner('',message,'warning');};_this.emptyProductList=function(){if(_this.state.storage.length||_this.props.match.params.accessToken){return null;}var message=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.wishlistIsEmpty',defaultMessage:'Wishlist is empty.'});return _this.renderAlertBanner('',message,'secondary');};_this.productInfoLabelRow=function(){var uiStore=_this.props.uiStore;if(!uiStore.isDesktop||!_this.state.storage.length){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],{className:'WishListPage__product-list--headers'},_this.renderProductHeaderCol(MobileWishlistLabels.name,{md:4}),_this.renderProductHeaderCol(MobileWishlistLabels.unitPrice,{sm:2}),_this.renderProductHeaderCol(MobileWishlistLabels.quantity,{sm:2,md:4}));};_this.updateStorage=function(updatedProduct){var localProductList=Object(__WEBPACK_IMPORTED_MODULE_17__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_18__util_constants__["a" /* storageKeys */].wishlist);var productIndex=localProductList.findIndex(function(p){return p.id===updatedProduct.id;});localProductList.splice(productIndex,1,updatedProduct);Object(__WEBPACK_IMPORTED_MODULE_17__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_18__util_constants__["a" /* storageKeys */].wishlist,localProductList);_this.setState({storage:localProductList});};_this.deleteProduct=function(product){if(_this.props.accountStore.loggedIn){_this.fetchProductList();}else{_this.deleteLocalProduct(product);}};_this.renderWishList=function(){var storage=_this.state.storage;var match=_this.props.match;if(storage){return storage.map(function(product){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],{key:_this.getProductIdByProductClass(product)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'WishListPage_WishlistProductRow-divider'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_wish_list_WishListProductRow__["a" /* default */],{product:product,match:match,onStorageUpdate:_this.updateStorage,onProductDelete:_this.deleteProduct}));});}};_this.getProductIdByProductClass=function(product){return product.class===__WEBPACK_IMPORTED_MODULE_28__types_ProductClass__["b" /* default */].MULTI||product.class===__WEBPACK_IMPORTED_MODULE_28__types_ProductClass__["b" /* default */].COLLECTION?product.id:product.product_id;};_this.accountLoginButtonLink=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_common_ButtonLink__["a" /* default */],{onClick:_this.toggle.bind(_this,__WEBPACK_IMPORTED_MODULE_22__types_AccountModalTab__["b" /* default */].LOGIN)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.login',defaultMessage:'login'})));};_this.notLoggedInAlertBanner=function(){var _this$props3=_this.props,accountStore=_this$props3.accountStore,configStore=_this$props3.configStore;if(accountStore.loggedIn||!_this.state.storage.length){return null;}if(configStore.registration.enabled&&!accountStore.loggedIn){return _this.alertWithRegistrationLink();}else{var message=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.NotLoggedInBanner',defaultMessage:'You\'re not yet logged in. You have to {login_link} as a customer to send the list as an email or save it permanently.',values:{login_link:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_common_ButtonLink__["a" /* default */],{onClick:_this.toggle.bind(_this,__WEBPACK_IMPORTED_MODULE_22__types_AccountModalTab__["b" /* default */].LOGIN)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.login',defaultMessage:'login'})))}});return _this.renderAlertBanner('',message,'warning',true);}};_this.alertWithRegistrationLink=function(){var message=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.NotLoggedInBanner_Registration_Enabled',defaultMessage:'\n          You\'re not yet logged in. You have to {login_link} or {register_link} as a customer to send the list as an email or save it permanently.,\n          ',values:{login_link:_this.accountLoginButtonLink(),register_link:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_common_ButtonLink__["a" /* default */],{onClick:_this.toggle.bind(_this,__WEBPACK_IMPORTED_MODULE_22__types_AccountModalTab__["b" /* default */].REGISTER)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.register',defaultMessage:'register'})))}});return _this.renderAlertBanner('',message,'warning',true);};_this.onAlertDismiss=function(){_this.setState({alertVisible:false});};_this.toggle=function(tab){var accountStore=_this.props.accountStore;accountStore.accountModal.setTab(tab);accountStore.accountModal.toggle();};_this.emailWishlistForm=function(){var _this$props4=_this.props,accountStore=_this$props4.accountStore,configStore=_this$props4.configStore,match=_this$props4.match;if(!accountStore.loggedIn||!configStore.wishlist.enableEmailShare||_this.state.notFound||match.params.accessToken){return null;}if(_this.state.storage.length){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_wish_list_WishListEmailForm__["a" /* default */],null);}};_this.productListInformationAlertBanner=function(){var _this$props5=_this.props,accountStore=_this$props5.accountStore,match=_this$props5.match;var _this$state=_this.state,storage=_this$state.storage,notFound=_this$state.notFound;if(!accountStore.loggedIn||!storage.length||notFound||match.params.accessToken){return null;}var message=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'wishlist.ProductListEmailInformation',defaultMessage:'You can add products to the list and make order decision later. You can also send the list as an email of your choosing.'});return _this.renderAlertBanner('WishListPage__product-list-information-alert-banner',message,'secondary');};_this.renderAlertBanner=function(className,formattedMessage,color,dismissable){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className),color:color,isOpen:_this.state.alertVisible,toggle:dismissable&&_this.onAlertDismiss},formattedMessage);};_this.redirectIfWishlistIsNotEnabled();return _this;}_createClass(WishListPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var accessToken=this.props.match.params.accessToken;var localProductList=Object(__WEBPACK_IMPORTED_MODULE_17__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_18__util_constants__["a" /* storageKeys */].wishlist);var _props=this.props,accountStore=_props.accountStore,productStore=_props.productStore;if(accessToken){productStore.getProductByAccessToken({accessToken:accessToken}).then(function(response){var productList=_this2.getSavedProductList(response.data,localProductList);_this2.setState({storage:productList});}).catch(function(){_this2.setState({notFound:true});});}else if(accountStore.loggedIn){this.fetchProductList();}else{this.setState({storage:localProductList});}}},{key:'deleteLocalProduct',value:function deleteLocalProduct(product){var productId=product.id;var localProductList=Object(__WEBPACK_IMPORTED_MODULE_17__util_storage__["b" /* getStorageAndParse */])(__WEBPACK_IMPORTED_MODULE_18__util_constants__["a" /* storageKeys */].wishlist);var productIndex=localProductList.findIndex(function(ProductlistProduct){return ProductlistProduct.id===productId;});localProductList.splice(productIndex,1);Object(__WEBPACK_IMPORTED_MODULE_17__util_storage__["c" /* stringifyAndSetStorage */])(__WEBPACK_IMPORTED_MODULE_18__util_constants__["a" /* storageKeys */].wishlist,localProductList);this.setState({storage:localProductList});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_29__types_CommonPage__["b" /* default */].WISH_LIST,className:'WishListPage'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_head_SEOTitle__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].wishListTitle}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["n" /* Container */],{className:'WishListPage__container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["l" /* Col */],{xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_head_CanonicalLink__["a" /* default */],{path:this.props.routeService.getPath(__WEBPACK_IMPORTED_MODULE_8__types_Paths__["a" /* default */].WishList)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'WishListPage__HelperNavigation'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_15__i18n_globalTranslations__["a" /* default */].wishListTitle)))),this.renderWishListContent(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_slider_LastVisitedProductsSlider__["a" /* default */],null)));}}]);return WishListPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;WishListPage.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_11__store_AccountStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_ProductStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_ConfigStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_7__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_24__store_UIStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_6_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* inject */])('accountStore','routeService','productStore','configStore','uiStore')(WishListPage))));

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WishListEmailForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ProductStore__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var labels={email:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].emailTitle),title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'wishlist.EmailTitle',defaultMessage:'Title'}),message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'wishlist.EmailMessage',defaultMessage:'Message'})};var WishListEmailForm=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(WishListEmailForm,_Component);function WishListEmailForm(props){_classCallCheck(this,WishListEmailForm);var _this=_possibleConstructorReturn(this,(WishListEmailForm.__proto__||Object.getPrototypeOf(WishListEmailForm)).call(this,props));_initialiseProps.call(_this);_this.createEmailFrom();_this.sendEmail=_this.sendEmail.bind(_this);_this.getEmailAddress=_this.getEmailAddress.bind(_this);_this.getMessageTitle=_this.getMessageTitle.bind(_this);_this.getMessageContent=_this.getMessageContent.bind(_this);return _this;}_createClass(WishListEmailForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.state.validForm?this.validForm():'',this.state.invalidForm?this.invalidForm():'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* Form */],{noValidate:true,onSubmit:this.sendEmail},this.formField('email',{type:'email',autoComplete:'email',autoCorrect:'off',autoCapitalize:'none'}),this.formField('title',{type:'text'}),this.formField('message',{type:'textarea'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{className:'mb-3',type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'wishlist.SendList',defaultMessage:'Send List'}))));}}]);return WishListEmailForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.state={alertVisible:true,email:'',title:'',message:'',validForm:false,invalidForm:false};this.form=null;this.formName='ProductListEmailForm';this.createEmailFrom=function(){_this2.form=Object(__WEBPACK_IMPORTED_MODULE_5__models_Form__["a" /* createForm */])({email:Object(__WEBPACK_IMPORTED_MODULE_6__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_7__util_formValidators__["d" /* isEmail */])(labels.email)]),title:Object(__WEBPACK_IMPORTED_MODULE_6__models_FormField__["a" /* createFormField */])({},[Object(__WEBPACK_IMPORTED_MODULE_7__util_formValidators__["g" /* notBlank */])(labels.title)]),message:Object(__WEBPACK_IMPORTED_MODULE_6__models_FormField__["a" /* createFormField */])({},[])});};this.sendEmail=function(e){e.preventDefault();var productStore=_this2.props.productStore;productStore.sendProductListEmail(_this2.form.getFieldValues()).then(function(response){if(response.status===200){_this2.setState({validForm:true,invalidForm:false});}}).catch(function(err){if(err){_this2.setState({validForm:false,invalidForm:true});}});};this.getEmailAddress=function(e){var email=e.target.value;_this2.setState({email:email});};this.getMessageTitle=function(e){var title=e.target.value;_this2.setState({title:title});};this.getMessageContent=function(e){var message=e.target.value;_this2.setState({message:message});};this.invalidForm=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'danger',isOpen:_this2.state.invalidForm,toggle:_this2.onAlertDismiss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'wishlist.InvalidForm',defaultMessage:'Form is invalid. Please check your form.'}));};this.validForm=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'success',isOpen:_this2.state.validForm,toggle:_this2.onAlertDismiss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'wishlist.ValidForm',defaultMessage:'Email has been sent successfully.'}));};this.onAlertDismiss=function(){_this2.setState({alertVisible:false,invalidForm:false,validForm:false});};this.formField=function(fieldName,props){var field=_this2.form.fields.get(fieldName);return field.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__["a" /* default */],Object.assign({field:field,formName:_this2.formName,fieldName:fieldName,label:labels[fieldName]},props));};},_temp))||_class;WishListEmailForm.propTypes={productStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_10__store_ProductStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('productStore')(WishListEmailForm));

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WishListProductRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_MaybeExternalLink__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_formValidators__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_QuantityFieldGroup__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_FieldError__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__product_ProductAvailabilityText__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_number__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__product_ProductImage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__models_ProductImage__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__product_Price__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_ProductStore__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__analytics_Analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__models_ProductListProduct__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__product_ProductPrice__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__models_ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__product_ProductPagePrice__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__types_ProductRecurringOrderType__ = __webpack_require__(500);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CUSTOM_ASPECT_RATIO='120';var WishListProductRow=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(WishListProductRow,_Component);function WishListProductRow(props){_classCallCheck(this,WishListProductRow);var _this=_possibleConstructorReturn(this,(WishListProductRow.__proto__||Object.getPrototypeOf(WishListProductRow)).call(this,props));_this.form=null;_this.maxQuantity=99999;_this.defaultValue=0;_this.accessToken=null;_this.quantityField=null;_this.state={totalPrice:0,product:_this.props.product};_this.getAccessToken=function(){var match=_this.props.match;if(match.params.hasOwnProperty('accessToken')&&match.params.accessToken){_this.accessToken=match.params.accessToken.length;}};_this.createQuantityFormFields=function(product){var formFields={};formFields['quantity'+product.product_id]=Object(__WEBPACK_IMPORTED_MODULE_6__models_FormField__["a" /* createFormField */])({value:String(product.quantity)},[Object(__WEBPACK_IMPORTED_MODULE_7__util_formValidators__["j" /* quantityValid */])(_this.maxQuantity),Object(__WEBPACK_IMPORTED_MODULE_7__util_formValidators__["i" /* productCountValid */])(_this.getQuantityStep(product))]);return formFields;};_this.initializeQuantityFormField=function(formFields){_this.form=null;_this.form=Object(__WEBPACK_IMPORTED_MODULE_8__models_Form__["a" /* createForm */])(formFields);};_this.renderProductHeaderCol=function(label,sizes){var actualSizes=Object.assign({xs:4},sizes);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],Object.assign({className:'WishListProductRow__product-list-header'},actualSizes),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'WishListProductRow__product-list-header-label'},label));};_this.renderProductImageOnLargeDisplays=function(product){var element=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__product_ProductImage__["a" /* default */],{product:product,productImage:_this.createProductImage(product),size:'small',forceAspectRatio:true,overrideConfigStoreAspectRatio:true,customAspectRatio:CUSTOM_ASPECT_RATIO,lazyLoading:false});return product.link?_this.renderElementWithLinkIfExists(element):element;};_this.renderProductName=function(product){var element=_this.renderReadableIdByProductClass(product)+' - '+product.name;return product.link?_this.renderElementWithLinkIfExists(element):element;};_this.renderElementWithLinkIfExists=function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_MaybeExternalLink__["a" /* default */],{to:_this.state.product.link},element);};_this.renderProductAvailabilityText=function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__product_ProductAvailabilityText__["a" /* default */],{availabilityHtml:product.availability_html}));};_this.renderProductVariations=function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'WishListProductRow_product-variations'},product.variations.map(function(variation,i){if(!variation){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i},variation);}));};_this.createProductImage=function(product){var url=product.image;return url?__WEBPACK_IMPORTED_MODULE_17__models_ProductImage__["a" /* default */].create({id:0,product_id:_this.getProductIdByProductClass(product),sizes:{small:url}}):null;};_this.getProductIdByProductClass=function(product){return product.class===__WEBPACK_IMPORTED_MODULE_24__types_ProductClass__["b" /* default */].MULTI||product.class===__WEBPACK_IMPORTED_MODULE_24__types_ProductClass__["b" /* default */].COLLECTION?product.id:product.product_id;};_this.renderReadableIdByProductClass=function(product){return product.class===__WEBPACK_IMPORTED_MODULE_24__types_ProductClass__["b" /* default */].MULTI?product.id:product.product_id;};_this.renderAddToCartQuantity=function(){if(!_this.state.product.price_info){return null;}_this.quantityField=_this.form.fields.get('quantity'+_this.state.product.product_id);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_QuantityFieldGroup__["a" /* default */],{key:_this.state.product.product_id,disabled:!!_this.ifQuantityFieldDisabled(),className:'WishListProductRow__product-list-quantity-group '+_this.state.product.product_id,field:_this.quantityField,quantityStep:_this.getQuantityStep(_this.state.product),defaultValue:_this.defaultValue,maxQuantity:_this.maxQuantity,unit:_this.state.product.stock_unit,onUpdateProductQuantity:_this.updateProductQuantity.bind(_this)});};_this.ifQuantityFieldDisabled=function(){var match=_this.props.match;return match.params.hasOwnProperty('accessToken')&&match.params.accessToken;};_this.getQuantityStep=function(product){return product&&product.package_size>1?product.package_size:1;};_this.showDiscountPriceIfExisting=function(){var price_info=_this.state.product.price_info;if(!price_info){return null;}var product=__WEBPACK_IMPORTED_MODULE_23__models_ProductListProduct__["a" /* default */].create(_this.state.product);var productPriceInfo=__WEBPACK_IMPORTED_MODULE_26__models_ProductPriceInfo__["a" /* default */].create(price_info);var price=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__product_ProductPrice__["a" /* default */],{className:'WishlistProductRow__product-row-product-page-price',priceInfo:productPriceInfo});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__product_ProductPagePrice__["a" /* default */],{className:'WishlistProductRow__product-row-product-page-price',price:price,product:product});};_this.renderTotalPriceAndQuantity=function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'WishListProductRow__product-list-price-and-quantity'},_this.renderAddToCartQuantity(product),_this.showTotalPriceIfExisting(product),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_FieldError__["a" /* default */],{field:_this.form.fields.get('quantity'+_this.state.product.product_id)}));};_this.showTotalPriceIfExisting=function(){var price_info=_this.state.product.price_info;if(!price_info||!_this.quantityField.value||_this.quantityField.value==='0'){return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__product_Price__["a" /* default */],{className:'WishListProductRow__product-row-total-price',price:_this.state.totalPrice});};_this.renderWishListProductRowButtons=function(product){var _this$props=_this.props,accountStore=_this$props.accountStore,configStore=_this$props.configStore;var buyingAllowed=!(configStore.recurringOrder.enabled&&accountStore.loggedIn&&product.recurring_order_type===__WEBPACK_IMPORTED_MODULE_29__types_ProductRecurringOrderType__["b" /* default */].RECURRING_ORDERS_ONLY);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'WishListProductRow__product-list-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["g" /* ButtonGroup */],{vertical:true},buyingAllowed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{color:'success',disabled:_this.validateAddToCartButton(),onClick:_this.productAddToCart.bind(_this,product)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__i18n_globalTranslations__["a" /* default */].addToCartButton)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{disabled:!!_this.accessToken,color:'primary',onClick:_this.deleteProduct.bind(_this,product)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'wishlist.DeleteProduct',defaultMessage:'Delete'}))));};_this.validateAddToCartButton=function(){return _this.form.valid===false||!_this.state.product.price_info||_this.quantityField.value==='0'||!_this.quantityField.value;};_this.updateProductQuantity=function(packageQuantity){var _this$props2=_this.props,accountStore=_this$props2.accountStore,product=_this$props2.product;if(accountStore.account.is_logged){_this.updateProductListIfLoggedIn(product,packageQuantity);}else{_this.updateLocalProductList(product,packageQuantity);}};_this.updateProductListIfLoggedIn=function(product,packageQuantity){var productStore=_this.props.productStore;var quantity=Object(__WEBPACK_IMPORTED_MODULE_15__util_number__["a" /* calculateNearestProductQuantityWithQuantityStep */])(packageQuantity,_this.getQuantityStep(product));productStore.saveProduct({extendedId:product.id,quantity:quantity}).catch(function(err){return console.error(err);});_this.updateLocalPackageQuantity(quantity,packageQuantity);_this.calculateTotalPrice();};_this.updateLocalProductList=function(product,packageQuantity){var newQuantity=Object(__WEBPACK_IMPORTED_MODULE_15__util_number__["a" /* calculateNearestProductQuantityWithQuantityStep */])(packageQuantity,_this.getQuantityStep(product));_this.updateLocalPackageQuantity(newQuantity,packageQuantity);};_this.calculateTotalPrice=function(){var price_info=_this.state.product.price_info;if(!price_info){return;}_this.setState({totalPrice:_this.state.product.quantity*_this.state.product.price_info.price.with_tax});if(_this.state.product.package_size){_this.setState({totalPrice:_this.state.product.quantity*_this.state.product.package_size*_this.state.product.price_info.price.with_tax});}};_this.updateLocalPackageQuantity=function(quantity,packageQuantity){var product=Object.assign({},_this.state.product,{quantity:Math.ceil(quantity)});_this.setState({product:product},function(){_this.props.onStorageUpdate(_this.state.product);_this.calculateTotalPrice();});_this.defaultValue=packageQuantity;};_this.productAddToCart=function(){var _this$props3=_this.props,cartStore=_this$props3.cartStore,analytics=_this$props3.analytics;var product=_this.state.product;var activeProductId=_this.state.product.id;var quantity=_this.state.product.quantity;var price=product.price_info.price.with_tax;product=__WEBPACK_IMPORTED_MODULE_23__models_ProductListProduct__["a" /* default */].create(product);var analyticsList=[{product:product,quantity:quantity,activeProductId:activeProductId,price:price}];_this.form.validate();if(_this.form.valid){cartStore.addToCart(activeProductId,quantity,[],[],product).then(function(){analytics.addToCart(analyticsList);analytics.cartStatus({cart:cartStore.cart});}).catch(function(err){return console.error(err);});}};_this.deleteProduct=function(product){var _this$props4=_this.props,accountStore=_this$props4.accountStore,productStore=_this$props4.productStore;if(accountStore.account.is_logged){var localProduct={extendedId:product.id};productStore.deleteProduct(localProduct).catch(function(err){return console.error(err);});_this.deleteLocalProduct();}else{_this.deleteLocalProduct(product);}};_this.deleteLocalProduct=function(product){_this.props.onProductDelete(product);};_this.defaultValue=Object(__WEBPACK_IMPORTED_MODULE_15__util_number__["b" /* calculateProductPackageSizeWithQuantity */])(_this.getQuantityStep(_this.state.product),_this.state.product.quantity);var formField=_this.createQuantityFormFields(_this.props.product);_this.initializeQuantityFormField(formField);return _this;}_createClass(WishListProductRow,[{key:'componentDidMount',value:function componentDidMount(){this.calculateTotalPrice();}},{key:'render',value:function render(){var _props=this.props,uiStore=_props.uiStore,product=_props.product;this.getAccessToken();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'WishListProductRow WishListProductRow__product-list-row'},uiStore.isDesktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{lg:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'WishListProductRow__product-image'},this.renderProductImageOnLargeDisplays(product))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:12,lg:2,className:'WishListProductRow__product-list-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'WishListProductRow__product-list-product'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'WishListProductRow__product-name'},this.renderProductName(product),this.renderProductAvailabilityText(product),this.renderProductVariations(product),(uiStore.isMobile||uiStore.isTablet)&&this.showDiscountPriceIfExisting(product.price_info),(uiStore.isMobile||uiStore.isTablet)&&this.renderTotalPriceAndQuantity(product)))),uiStore.isDesktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{md:2,className:'WishListProductRow__product-list-col'},this.showDiscountPriceIfExisting(product.price_info)),uiStore.isDesktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{md:4,className:'WishListProductRow__product-list-col'},this.renderTotalPriceAndQuantity(product)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{xs:12,lg:2,className:'WishListProductRow__product-list-col'},this.renderWishListProductRowButtons(product)));}}]);return WishListProductRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;WishListProductRow.propTypes={analytics:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_22__analytics_Analytics__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_14__store_UIStore__["a" /* default */]).isRequired,accountStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_19__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_28__store_ConfigStore__["a" /* default */]).isRequired,productStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_ProductStore__["a" /* default */]).isRequired,cartStore:Object(__WEBPACK_IMPORTED_MODULE_13__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_CartStore__["a" /* default */]).isRequired,match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onStorageUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onProductDelete:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('analytics','accountStore','configStore','uiStore','productStore','cartStore')(WishListProductRow));

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Price__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductPriceInfo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_ProductClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductMatrix__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductMulti__ = __webpack_require__(491);
var ProductListProduct=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].model('ProductListProduct',{id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,multiproduct_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,product_id:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,name:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,quantity:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number,stock_unit:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,package_size:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].number),price_info:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_2__ProductPriceInfo__["a" /* default */]),class:__WEBPACK_IMPORTED_MODULE_3__types_ProductClass__["a" /* ProductClassType */],collection:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_4__ProductMatrix__["a" /* default */]),multi:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_5__ProductMulti__["a" /* default */]),multiproduct_title:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),total_price:__WEBPACK_IMPORTED_MODULE_1__Price__["a" /* default */],link:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,image:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string),availability_html:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string,available_for_purchase:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].boolean,variations:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].maybeNull(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].string))});/* harmony default export */ __webpack_exports__["a"] = (ProductListProduct);

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_head_CanonicalLink__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ad_ContentPopup__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ad_MainBanner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_ScrollReset__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__types_AdPages__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types_CommonPage__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_SectionStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_RouteService__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SoldProductsPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SoldProductsPage,_Component);function SoldProductsPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SoldProductsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SoldProductsPage.__proto__||Object.getPrototypeOf(SoldProductsPage)).call.apply(_ref,[this].concat(args))),_this),_this.getBreadcrumbsPath=function(){var _this$props=_this.props,intl=_this$props.intl,routeService=_this$props.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].soldProductsTitle),url:__WEBPACK_IMPORTED_MODULE_11__types_Paths__["a" /* default */].SoldProducts}]);},_this.getSearchParams=function(){return{bannerPage:__WEBPACK_IMPORTED_MODULE_17__types_AdPages__["a" /* default */].SOLD_PRODUCTS};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SoldProductsPage,[{key:'getConfigSettings',value:function getConfigSettings(){var configStore=this.props.configStore;var settings=[];if(configStore.soldProductsPage.showProductCards){settings.disableLinks=false;}else{settings.disableLinks=true;}return settings;}},{key:'render',value:function render(){var listName='Sold Products List';var _props=this.props,configStore=_props.configStore,sectionStore=_props.sectionStore,routeService=_props.routeService;var fixedParams={purchaseHistory:1,includeFilters:1,inStock:0,excludeContent:1};var cardSettings=Object.assign({hideAddToCartButton:true,hidePrice:true,hideQuantity:true,showAsSold:true},this.getConfigSettings());var productParams={showOutOfStock:1};if(sectionStore.activeSection){fixedParams.sections=[sectionStore.activeSection.id];}var mainBanner=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ad_MainBanner__["a" /* default */],{searchParams:this.getSearchParams()});var mainBannerWithinContent=configStore.mainBanner.withinContent&&!configStore.mainBanner.fullWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_18__types_CommonPage__["b" /* default */].SOLD_PRODUCTS,className:'SoldProductsPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_common_ScrollReset__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_head_SEOTitle__["a" /* default */],{title:Object.assign({},__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].soldProductsTitle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_head_CanonicalLink__["a" /* default */],{path:routeService.getPath(__WEBPACK_IMPORTED_MODULE_11__types_Paths__["a" /* default */].SoldProducts)}),!mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Container */],{className:'SoldProductsPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,mainBannerWithinContent&&mainBanner,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].soldProductsTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_product_list_MainProductList__["b" /* default */],{fixedParams:fixedParams,name:listName,showSort:false,cardSettings:cardSettings,productParams:productParams}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ad_ContentPopup__["a" /* default */],null))})));}}]);return SoldProductsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SoldProductsPage.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_19__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_20__store_ConfigStore__["a" /* default */]).isRequired,sectionStore:Object(__WEBPACK_IMPORTED_MODULE_19__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_21__store_SectionStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["f" /* intlShape */].isRequired,routeService:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_22__services_RouteService__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore','sectionStore','routeService')(SoldProductsPage)));

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SurveyModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_SurveyStore__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SurveyForm__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_QuestionsPlacementType__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QUERYPARAMS=['preview_survey','survey'];var DEFAULT_COLUMN_WIDTH=50;var DEFAULT_MODAL_WIDTH=800;var SurveyModal=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SurveyModal,_Component);function SurveyModal(props){_classCallCheck(this,SurveyModal);var _this=_possibleConstructorReturn(this,(SurveyModal.__proto__||Object.getPrototypeOf(SurveyModal)).call(this,props));_this.initApi=function(){window.SurveysApi={Load:function Load(id){_this.props.surveyStore.loadSurvey(id);_this.setState({pre_question_answered:false});}};};_this.closePreQuestion=function(){_this.setState({pre_question_answered:true});};_this.handleOpen=function(){if(typeof document==='undefined'){return null;}document.body.classList.add('modal-open');};_this.handleParams=function(){var location=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var surveyStore=_this.props.surveyStore;var search=location?location.search:_this.props.location.search;var params=__WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(search);if(params.preview_survey){_this.setState({pre_question_answered:false});return surveyStore.previewSurvey(params.preview_survey);}if(params.survey){_this.setState({pre_question_answered:false});return surveyStore.loadSurvey(params.survey);}return false;};_this.getModalContentBody=function(){var surveyStore=_this.props.surveyStore;var activeSurvey=surveyStore.activeSurvey;switch(activeSurvey.questions_placement){case __WEBPACK_IMPORTED_MODULE_13__types_QuestionsPlacementType__["a" /* default */].TOP:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:activeSurvey.body}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SurveyForm__["a" /* default */],null));case __WEBPACK_IMPORTED_MODULE_13__types_QuestionsPlacementType__["a" /* default */].BOTTOM:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SurveyForm__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:activeSurvey.body}));case __WEBPACK_IMPORTED_MODULE_13__types_QuestionsPlacementType__["a" /* default */].LEFT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{className:'SurveyModal__AnswersColumn',style:{width:_this.getColumnWidth('answers')+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SurveyForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{className:'SurveyModal__BodyColumn',style:{width:_this.getColumnWidth('body')+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:activeSurvey.body})));case __WEBPACK_IMPORTED_MODULE_13__types_QuestionsPlacementType__["a" /* default */].RIGHT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{className:'SurveyModal__BodyColumn',style:{width:_this.getColumnWidth('body')+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:activeSurvey.body})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{className:'SurveyModal__AnswersColumn',style:{width:_this.getColumnWidth('answers')+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SurveyForm__["a" /* default */],null)));default:return null;}};_this.state={pre_question_answered:false};var checkParams=_this.handleParams();if(!checkParams){_this.props.surveyStore.activateTimedSurvey();}_this.props.history.listen(function(location){var match=QUERYPARAMS.some(function(param){return location.search.includes(param);});if(match){_this.handleParams(location);}});_this.initApi();return _this;}_createClass(SurveyModal,[{key:'getColumnWidth',value:function getColumnWidth(name){var surveyStore=this.props.surveyStore;var activeSurvey=surveyStore.activeSurvey;switch(name){case'answers':return activeSurvey.answers_column_width||DEFAULT_COLUMN_WIDTH;case'body':return activeSurvey.body_column_width||DEFAULT_COLUMN_WIDTH;default:return DEFAULT_COLUMN_WIDTH;}}},{key:'render',value:function render(){var _this2=this;var surveyStore=this.props.surveyStore;var pre_question_answered=this.state.pre_question_answered;var survey=surveyStore.activeSurvey;if(window.isSSR||!survey||surveyStore.state===__WEBPACK_IMPORTED_MODULE_12__types_RequestState__["b" /* default */].NONE){return null;}if(survey.has_pre_question&&!pre_question_answered){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["C" /* Modal */],{backdrop:'static',toggle:function toggle(){surveyStore.toggleModal();},style:{maxWidth:survey.survey_modal_width||DEFAULT_MODAL_WIDTH},className:'SurveyModal',size:'lg',onOpened:this.handleOpen,isOpen:surveyStore.modalShouldOpen()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('style',null,survey.styles),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["F" /* ModalHeader */],{className:'SurveyModal__header',toggle:function toggle(){return surveyStore.toggleModal();}},survey.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:survey.pre_question_description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{onClick:function onClick(){_this2.closePreQuestion();},color:'primary',block:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].yesTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Col */],{md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{onClick:function onClick(){surveyStore.toggleModal();},color:'primary',block:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__i18n_globalTranslations__["a" /* default */].noTitle))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["C" /* Modal */],{backdrop:'static',toggle:surveyStore.toggleModal,className:'SurveyModal',size:'lg',onOpened:this.handleOpen,isOpen:surveyStore.modalShouldOpen()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('style',null,survey.styles),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["F" /* ModalHeader */],{className:'SurveyModal__header',toggle:surveyStore.toggleModal},survey.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:survey.header_text})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["O" /* Row */],null,this.getModalContentBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["E" /* ModalFooter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_WysiwygContent__["a" /* default */],{html:survey.footer_text})));}}]);return SurveyModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SurveyModal.propTypes={surveyStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_SurveyStore__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_9_react_router_prop_types___default.a.location.isRequired,history:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('surveyStore')(SurveyModal)));

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNull__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omitBy__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Form__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_FormField__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_RadioField__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_SurveyStore__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_SelectField__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_SurveyFieldValueType__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_AccountStore__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createOption(value,label){return{value:value,label:label};}var SurveyForm=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(SurveyForm,_Component);function SurveyForm(props){_classCallCheck(this,SurveyForm);var _this=_possibleConstructorReturn(this,(SurveyForm.__proto__||Object.getPrototypeOf(SurveyForm)).call(this,props));_initialiseProps.call(_this);var surveyStore=_this.props.surveyStore;var survey=surveyStore.activeSurvey;_this.state={submitError:false};if(survey){var formFields={};survey.questions.forEach(function(question){var field=surveyStore.getUserField(question.field.key);var value=field?field.value_id||field.value||null:null;formFields[question.field.key]=Object(__WEBPACK_IMPORTED_MODULE_7__models_FormField__["a" /* createFormField */])({value:value});});_this.form=Object(__WEBPACK_IMPORTED_MODULE_6__models_Form__["a" /* createForm */])(Object.assign({},formFields));}return _this;}_createClass(SurveyForm,[{key:'render',value:function render(){var surveyStore=this.props.surveyStore;var surveySubmitting=surveyStore.surveySubmitting;var submitError=this.state.submitError;var survey=surveyStore.activeSurvey;if(!survey){return null;}var buttonColor=submitError?'warning':'primary';return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["s" /* Form */],{className:this.formName,onSubmit:this.handleSubmit},this.getQuestions(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["e" /* Button */],{color:buttonColor,block:true,disabled:this.form.valid===false||surveySubmitting},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].submitSurvey)),submitError&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text-danger'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].surveySubmitError)));}}]);return SurveyForm;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.form=null;this.formName='SurveyForm';this.handleSubmit=function(e){var surveyStore=_this2.props.surveyStore;var surveySubmitting=surveyStore.surveySubmitting;if(surveySubmitting){return;}e.preventDefault();_this2.form.validate();if(_this2.form.valid){var values=_this2.form.getFieldValues();values=__WEBPACK_IMPORTED_MODULE_1_lodash_omitBy___default()(values,__WEBPACK_IMPORTED_MODULE_0_lodash_isNull___default.a);values=__WEBPACK_IMPORTED_MODULE_1_lodash_omitBy___default()(values,function(value){return value==='';});surveyStore.submitSurvey(values).then(function(){_this2.setupGiosg(values);}).then(function(){_this2.setState({submitError:false});}).catch(function(error){_this2.setState({submitError:true});console.error(error);});}};this.setupGiosg=function(values){var giosg=window.giosgEventHandler;if(giosg){giosg.maybePushVisitorInfo(_this2.props.accountStore);giosg.pushEvent('visitor','submit',values);giosg.setVisitorPriority(10);}return null;};this.getQuestions=function(){var surveyStore=_this2.props.surveyStore;var survey=surveyStore.activeSurvey;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,survey.questions.map(function(question){var field=void 0;switch(question.field.type){case __WEBPACK_IMPORTED_MODULE_14__types_SurveyFieldValueType__["a" /* default */].BOOLEAN:field=_this2.radioBool(question);break;case __WEBPACK_IMPORTED_MODULE_14__types_SurveyFieldValueType__["a" /* default */].MENU:field=_this2.select(question);break;case __WEBPACK_IMPORTED_MODULE_14__types_SurveyFieldValueType__["a" /* default */].TEXT:field=_this2.field(question);break;default:field=_this2.field(question);break;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],{key:question.id},field);}));};this.radioBool=function(question){var field=_this2.form.fields.get(question.field.key);var values=[createOption('1',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].yesTitle)),createOption('0',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_9__i18n_globalTranslations__["a" /* default */].noTitle))];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_RadioField__["a" /* default */],{field:field,formName:_this2.formName,fieldName:question.field.key,options:values,label:question.text,required:question.is_required,tooltip:question.hint}));};this.select=function(question){var field=_this2.form.fields.get(question.field.key);var values=question.field.values.map(function(value){return createOption(value.value_id.toString(),value.text);});values.unshift({value:'',label:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:'survey.selectOption',defaultMessage:'\'-- Select option\'',children:function children(formattedMessage){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,formattedMessage);}})});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_SelectField__["a" /* default */],{field:field,formName:_this2.formName,fieldName:question.field.key,options:values,label:question.text,required:question.is_required,tooltip:question.hint}));};this.field=function(question){var field=_this2.form.fields.get(question.field.key);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_FormGroupField__["a" /* default */],{field:field,formName:_this2.formName,fieldName:question.field.key,label:question.text,required:question.is_required,tooltip:question.hint}));};},_temp))||_class;SurveyForm.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_15__store_AccountStore__["a" /* default */]).isRequired,surveyStore:Object(__WEBPACK_IMPORTED_MODULE_10__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_SurveyStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* inject */])('accountStore','surveyStore')(SurveyForm));

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(84),
    negate = __webpack_require__(1452),
    pickBy = __webpack_require__(1453);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 1452 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(144),
    baseIteratee = __webpack_require__(84),
    basePickBy = __webpack_require__(1454),
    getAllKeysIn = __webpack_require__(310);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(222),
    baseSet = __webpack_require__(305),
    castPath = __webpack_require__(143);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SurveyFieldValueTypeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var SurveyFieldValueType={BOOLEAN:'BOOLEAN',MENU:'MENU',TEXT:'TEXT'};/* harmony default export */ __webpack_exports__["a"] = (SurveyFieldValueType);var SurveyFieldValueTypeType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('SurveyFieldValueType',Object.values(SurveyFieldValueType));

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var QuestionsPlacement={TOP:'TOP',BOTTOM:'BOTTOM',LEFT:'LEFT',RIGHT:'RIGHT'};/* harmony default export */ __webpack_exports__["a"] = (QuestionsPlacement);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VehiclePartSearchPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_list_MainProductList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vehicle_LicensePlateInput__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_vehicle_VehicleInfo__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_error__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_HelperNavigation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_Paths__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_ApiWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_RouteService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_queryString__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VEHICLE_PRODUCTS_API='vehicles/products';var LIST_NAME='VehiclePartSearchList';var ErrorType={NOT_FOUND:'NOT_FOUND'};var VehiclePartSearchPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(VehiclePartSearchPage,_Component);function VehiclePartSearchPage(props){_classCallCheck(this,VehiclePartSearchPage);var _this=_possibleConstructorReturn(this,(VehiclePartSearchPage.__proto__||Object.getPrototypeOf(VehiclePartSearchPage)).call(this,props));_this.loadData=function(licensePlateNumber,categoryId){var _this$props=_this.props,apiWrapper=_this$props.apiWrapper,routeService=_this$props.routeService,history=_this$props.history;if(!licensePlateNumber){return null;}_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING,selectedSubModel:null,subModelDropdownText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:'vehiclePartSearch.selectModel',defaultMessage:'Select more precise model'})});if(licensePlateNumber){var licensePlateUrl=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["a" /* addParametersToPath */])(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].VehiclePartSearch,{id:licensePlateNumber,categoryId:categoryId,vehicleSearch:true});var url=routeService.getPath(licensePlateUrl);history.push(url);}licensePlateNumber&&categoryId&&_this.scrollToList(__WEBPACK_IMPORTED_MODULE_7__components_product_list_MainProductList__["a" /* ANCHOR_ID */]);apiWrapper.request('vehicles?licensePlateNumber='+licensePlateNumber+' ').then(function(data){var error=null;if(!data){data=null;error=ErrorType.NOT_FOUND;}_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED,vehicleInfo:data,error:error});}).then(_this.findSubModelIfActiveSubModelParamId).catch(function(err){var error=Object(__WEBPACK_IMPORTED_MODULE_11__util_error__["a" /* createErrorModel */])(err);if(error.httpStatusCode===404){_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED,error:ErrorType.NOT_FOUND});_this.clearActiveVehicle();}else{_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR,error:error});}});};_this.getActiveVehicle=function(){var apiWrapper=_this.props.apiWrapper;_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING});apiWrapper.request('vehicles/active').then(function(data){_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED,vehicleInfo:data});}).then(_this.findSubModelIfActiveSubModelParamId).catch(function(err){var error=Object(__WEBPACK_IMPORTED_MODULE_11__util_error__["a" /* createErrorModel */])(err);error.httpStatusCode!==404?_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR,error:error}):_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED});});};_this.findSubModelIfActiveSubModelParamId=function(){var params=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["b" /* parse */])(_this.props.location.search);var subModelId=params.subModelId;var activeSubModel=_this.state.vehicleInfo.sub_models.find(function(sub_model){return sub_model.id===subModelId;});activeSubModel?_this.setState({selectedSubModel:activeSubModel,subModelDropdownText:activeSubModel.name},_this.loadCategoryData):_this.loadCategoryData();};_this.loadCategoryData=function(){var _this$props2=_this.props,apiWrapper=_this$props2.apiWrapper,location=_this$props2.location,uiStore=_this$props2.uiStore;var _this$state=_this.state,vehicleInfo=_this$state.vehicleInfo,selectedSubModel=_this$state.selectedSubModel;if(!vehicleInfo){return null;}if(vehicleInfo.sub_models.length!==0&&!selectedSubModel){_this.setState({categories:[]});return null;}var categoryApi=vehicleInfo.sub_models.length>0&&selectedSubModel?'vehicles/categories?subModelId='+selectedSubModel.id:'vehicles/categories';_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING,categories:[]});apiWrapper.request(''+categoryApi).then(function(data){var params=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["b" /* parse */])(location.search);_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED,categories:data});uiStore.isMobile&&params.categoryId&&_this.scrollToList();}).catch(function(error){_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR,error:Object(__WEBPACK_IMPORTED_MODULE_11__util_error__["a" /* createErrorModel */])(error)});});};_this.scrollToList=function(){var _this$state2=_this.state,vehicleInfo=_this$state2.vehicleInfo,categoryId=_this$state2.categoryId;_this.setHash(__WEBPACK_IMPORTED_MODULE_7__components_product_list_MainProductList__["a" /* ANCHOR_ID */]);vehicleInfo&&categoryId&&Object(__WEBPACK_IMPORTED_MODULE_24__util_dom__["i" /* scrollToElementById */])(__WEBPACK_IMPORTED_MODULE_7__components_product_list_MainProductList__["a" /* ANCHOR_ID */],{behavior:'instant'});};_this.setHash=function(hash){var history=_this.props.history;var hashString=hash?'#'+hash:'';history.replace(history.location.pathname+history.location.search+hashString);};_this.getBreadcrumbsPath=function(){var _this$props3=_this.props,intl=_this$props3.intl,routeService=_this$props3.routeService;return routeService.transformBreadCrumbs([{text:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].vehiclePartSearchTitle),url:__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].VehiclePartSearch}]);};_this.renderInfoText=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'VehicleSearchPage__help-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:'vehiclePartSearch.helpText',defaultMessage:'Insert your license plate number to find compatible parts for the vehicle'}));};_this.renderInfoSection=function(){var _this$state3=_this.state,vehicleInfo=_this$state3.vehicleInfo,error=_this$state3.error;var notFound=error===ErrorType.NOT_FOUND;var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,notFound&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["a" /* Alert */],{color:'warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:'vehiclePartSearch.notFound',defaultMessage:'No vehicle found with given license plate number'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_vehicle_VehicleInfo__["a" /* default */],{vehicleInfo:vehicleInfo}),vehicleInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:_this.clearActiveVehicle.bind(_this),className:'VehilePartSearchPage__clear-selection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:'vehiclePartSearch.clearVehicle',defaultMessage:'Clear vehicle information'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_loader_ContentForState__["a" /* default */],{state:_this.state.requestState,forLoaded:function forLoaded(){return content;}}));};_this.clearActiveVehicle=function(){var _this$props4=_this.props,apiWrapper=_this$props4.apiWrapper,history=_this$props4.history;_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING});apiWrapper.apiAxios().delete('vehicles/clear').then(function(){_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED,categories:[],vehicleInfo:null,categoryId:null,selectedSubModel:null,subModelDropdownText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:'vehiclePartSearch.selectModel',defaultMessage:'Select more precise model'})});history.replace();}).catch(function(error){_this.setState({requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR,error:Object(__WEBPACK_IMPORTED_MODULE_11__util_error__["a" /* createErrorModel */])(error)});});};_this.renderCategorySection=function(){var _this$state4=_this.state,categories=_this$state4.categories,categoryId=_this$state4.categoryId,subModelDropdownOpen=_this$state4.subModelDropdownOpen,subModelDropdownText=_this$state4.subModelDropdownText,vehicleInfo=_this$state4.vehicleInfo,selectedSubModel=_this$state4.selectedSubModel;var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'mb-3'},vehicleInfo.sub_models.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'VehicleSearchPage__vehicle-models-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:'vehiclePartSearch.severalCarsFound',defaultMessage:'Several models were found with the license plate'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["o" /* Dropdown */],{isOpen:subModelDropdownOpen,toggle:_this.toggleSubModelDropdown.bind(_this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["r" /* DropdownToggle */],{caret:true,color:'primary',className:'VehicleSearchPage__select-sub-model'},subModelDropdownText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["q" /* DropdownMenu */],{className:'VehicleSearchPage__sub-model-menu'},vehicleInfo.sub_models.map(function(sub_model,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["p" /* DropdownItem */],{key:index,onClick:_this.selectSubModel.bind(_this,sub_model)},sub_model.name);})))),categories.map(function(parentCategory,parentCategoryIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{className:'mt-2',key:parentCategoryIndex,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'VehicleSearchPage__parent-category-title'},parentCategory.name),parentCategory.children.map(function(childCategory,childCategoryIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:childCategoryIndex,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(['category-item'],{'selected-item':categoryId===childCategory.id}),onClick:_this.setActiveCategory.bind(_this,childCategory)},childCategory.name);}));}),selectedSubModel&&categories.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'VehicleSearchPage__no-search-results'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:'vehiclePartSearch.noSearchResults',defaultMessage:'No search results'}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_loader_ContentForState__["a" /* default */],{state:_this.state.requestState,forLoaded:function forLoaded(){return content;}});};_this.toggleSubModelDropdown=function(){return _this.setState({subModelDropdownOpen:!_this.state.subModelDropdownOpen});};_this.selectSubModel=function(sub_model){_this.setSubModelIdParam(sub_model);_this.setState({selectedSubModel:sub_model,subModelDropdownText:sub_model.name,categoryId:null},_this.loadCategoryData);};_this.setSubModelIdParam=function(sub_model){var _this$props5=_this.props,routeService=_this$props5.routeService,history=_this$props5.history;var subModelId=sub_model.id;var subModelParameter=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["a" /* addParametersToPath */])(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].VehiclePartSearch,{subModelId:subModelId});var url=routeService.getPath(subModelParameter);history.push(url);};_this.setActiveCategory=function(category){_this.setState({categoryId:category.id},function(){var _this$props6=_this.props,history=_this$props6.history,routeService=_this$props6.routeService,location=_this$props6.location,uiStore=_this$props6.uiStore;var params=_this.setUrlParams(location);var categoryUrl=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["a" /* addParametersToPath */])(__WEBPACK_IMPORTED_MODULE_15__types_Paths__["a" /* default */].VehiclePartSearch,params);var url=routeService.getPath(categoryUrl);history.push(url);uiStore.isMobile&&_this.scrollToList();});};_this.setUrlParams=function(location){var params=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["b" /* parse */])(location.search);return params.id?Object.assign({id:params.id},params,{categoryId:Number(_this.state.categoryId)}):Object.assign({},params,{categoryId:Number(_this.state.categoryId)});};_this.state={requestState:__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].NONE,vehicleInfo:null,categories:[],error:null,categoryId:null,subModelDropdownOpen:false,subModelDropdownText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:'vehiclePartSearch.selectModel',defaultMessage:'Select more precise model'}),selectedSubModel:null};return _this;}_createClass(VehiclePartSearchPage,[{key:'componentDidMount',value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["b" /* parse */])(this.props.location.search);if(params.id||params.id&&params.categoryId){this.loadData(params.id,params.categoryId);}else{this.getActiveVehicle();}params.categoryId&&this.setState({categoryId:Number(params.categoryId)});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var params=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["b" /* parse */])(this.props.location.search);var prevParams=Object(__WEBPACK_IMPORTED_MODULE_21__util_queryString__["b" /* parse */])(prevProps.location.search);if(params.id&&!params.vehicleSearch&&params.id!==prevParams.id){this.setState({categoryId:null},this.loadData(params.id));}}},{key:'render',value:function render(){var _state=this.state,vehicleInfo=_state.vehicleInfo,requestState=_state.requestState,categoryId=_state.categoryId;var loading=requestState===__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING;var disabled=vehicleInfo!==null||loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_25__types_CommonPage__["b" /* default */].VEHICLE_PART_SEARCH},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["n" /* Container */],{className:'VehiclePartSearchPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_HelperNavigation__["a" /* default */],{breadcrumbsPath:this.getBreadcrumbsPath()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_PageTitle__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_16__i18n_globalTranslations__["a" /* default */].vehiclePartSearchTitle)),this.renderInfoText(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["O" /* Row */],{className:'mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["l" /* Col */],{md:4,className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_vehicle_LicensePlateInput__["a" /* default */],{handleOnSubmit:this.loadData,disabled:disabled,loading:loading,overrideText:vehicleInfo?vehicleInfo.license_plate_number:null,location:this.props.location})),this.renderInfoSection()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),vehicleInfo&&this.renderCategorySection(),vehicleInfo&&categoryId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_product_list_MainProductList__["b" /* default */],{name:LIST_NAME,fixedParams:{categoryId:categoryId},urlOverride:VEHICLE_PRODUCTS_API})))})));}}]);return VehiclePartSearchPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;VehiclePartSearchPage.propTypes={uiStore:Object(__WEBPACK_IMPORTED_MODULE_22__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_23__store_UIStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_14_react_intl__["f" /* intlShape */].isRequired,apiWrapper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_19__services_ApiWrapper__["a" /* default */]).isRequired,routeService:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_20__services_RouteService__["a" /* default */]).isRequired,match:__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default.a.match.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('apiWrapper','routeService','uiStore')(VehiclePartSearchPage)));

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VehicleInfo=function(_Component){_inherits(VehicleInfo,_Component);function VehicleInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VehicleInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VehicleInfo.__proto__||Object.getPrototypeOf(VehicleInfo)).call.apply(_ref,[this].concat(args))),_this),_this.renderList=function(){var vehicleInfo=_this.props.vehicleInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'VehicleInfo__attribute-list'},vehicleInfo.brand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,vehicleInfo.brand),' '),vehicleInfo.year&&vehicleInfo.use_date&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,vehicleInfo.use_date,'(',vehicleInfo.year,')'),vehicleInfo.commercial_name&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',vehicleInfo.commercial_name),vehicleInfo.fuel_type&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',vehicleInfo.fuel_type,' '),vehicleInfo.cylinder_volume&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',vehicleInfo.cylinder_volume,' cm',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'3')),vehicleInfo.net_power&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',vehicleInfo.net_power,' kW'),vehicleInfo.production_number&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',vehicleInfo.production_number),vehicleInfo.engine_model&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',vehicleInfo.engine_model)));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VehicleInfo,[{key:'render',value:function render(){var vehicleInfo=this.props.vehicleInfo;if(!vehicleInfo){return null;}return this.renderList();}}]);return VehicleInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VehicleInfo);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KlarnaInstantShoppingThankYouPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Page__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_GenericLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_head_SEOTitle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_head_RobotsMeta__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_checkout_ThankYouPageContent__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_CommonPage__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messages=Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* defineMessages */])({successfulPurchasePageTitle:{'id':'checkout.successfulPurchasePageTitle','defaultMessage':'Your order has been registered!'}});var KlarnaInstantShoppingThankYouPage=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(KlarnaInstantShoppingThankYouPage,_Component);function KlarnaInstantShoppingThankYouPage(){_classCallCheck(this,KlarnaInstantShoppingThankYouPage);return _possibleConstructorReturn(this,(KlarnaInstantShoppingThankYouPage.__proto__||Object.getPrototypeOf(KlarnaInstantShoppingThankYouPage)).apply(this,arguments));}_createClass(KlarnaInstantShoppingThankYouPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_layout_Page__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_9__types_CommonPage__["b" /* default */].KLARNA_INSTANT_SHOPPING_THANK_YOU,className:'KlarnaInstantShoppingThankYouPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Container */],{className:'KlarnaInstantShoppingThankYouPage__container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_layout_GenericLayout__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_head_SEOTitle__["a" /* default */],{title:messages.successfulPurchasePageTitle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_head_RobotsMeta__["a" /* default */],{noindex:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_checkout_ThankYouPageContent__["a" /* default */],null))})));}}]);return KlarnaInstantShoppingThankYouPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (KlarnaInstantShoppingThankYouPage);

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet_async__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SpotmoreWidget=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(SpotmoreWidget,_Component);function SpotmoreWidget(){_classCallCheck(this,SpotmoreWidget);return _possibleConstructorReturn(this,(SpotmoreWidget.__proto__||Object.getPrototypeOf(SpotmoreWidget)).apply(this,arguments));}_createClass(SpotmoreWidget,[{key:'render',value:function render(){var configStore=this.props.configStore;// Bail if we are in SSR.
if(typeof document==='undefined'||!configStore.activateSpotmore.enabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',{type:'text/javascript'},'\n          function spotmore_0(){\n          var a=document.createElement(\'script\');\n          var m= document.getElementsByTagName(\'script\')[0];\n          a.async=1;\n          a.src=\'https://client.spotmore.fi/campaigns/crmjs\';\n          m.parentNode.insertBefore(a,m)\n          } setTimeout(\'spotmore_0()\', 500);\n        '));}}]);return SpotmoreWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;SpotmoreWidget.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('configStore')(SpotmoreWidget));

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations_yotpo_YotpoReviewWidget__ = __webpack_require__(1462);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YotpoReviewWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(YotpoReviewWrapper,_Component);function YotpoReviewWrapper(){_classCallCheck(this,YotpoReviewWrapper);return _possibleConstructorReturn(this,(YotpoReviewWrapper.__proto__||Object.getPrototypeOf(YotpoReviewWrapper)).apply(this,arguments));}_createClass(YotpoReviewWrapper,[{key:'render',value:function render(){var configStore=this.props.configStore;// Bail if we are in SSR.
if(typeof document==='undefined'||!configStore.yotpo.enabled){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__integrations_yotpo_YotpoReviewWidget__["a" /* default */],null);}}]);return YotpoReviewWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;YotpoReviewWrapper.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_2__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(YotpoReviewWrapper));

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YotpoReviewWidget=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(YotpoReviewWidget,_Component);function YotpoReviewWidget(){var _ref;var _temp,_this,_ret;_classCallCheck(this,YotpoReviewWidget);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=YotpoReviewWidget.__proto__||Object.getPrototypeOf(YotpoReviewWidget)).call.apply(_ref,[this].concat(args))),_this),_this.createScript=function(){var configStore=_this.props.configStore;var script=document.createElement('script');script.type='text/javascript';script.async=true;script.src='//staticw2.yotpo.com/'+configStore.yotpo.appKey+'/widget.js';script.onerror=function(err){console.error(err);};document.head.appendChild(script);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(YotpoReviewWidget,[{key:'componentDidMount',value:function componentDidMount(){this.createScript();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript',null,'You need to enable javascript');}}]);return YotpoReviewWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;YotpoReviewWidget.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_2__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(YotpoReviewWidget));

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RedirectModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_static_messages_en_countries_json__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_static_messages_en_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__i18n_static_messages_en_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_static_messages_fi_countries_json__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_static_messages_fi_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__i18n_static_messages_fi_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_static_messages_sv_countries_json__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_static_messages_sv_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__i18n_static_messages_sv_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_LocalizationStore__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_url__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_IntlWrapper__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_LanguageStore__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_TranslationStore__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_browser__ = __webpack_require__(595);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SITE_CHOSEN_PARAMETER='?siteChosen=1';var RedirectModal=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(RedirectModal,_Component);function RedirectModal(props){_classCallCheck(this,RedirectModal);var _this=_possibleConstructorReturn(this,(RedirectModal.__proto__||Object.getPrototypeOf(RedirectModal)).call(this,props));_this.translations=null;_this.siteSuggestionEnabled=function(){var localizationStore=_this.props.localizationStore;// Enabled when localStorage has no key set and backend has sent data.
return!localizationStore.getLocalStorage()&&localizationStore.suggestionEnabled;};_this.hasShipping=function(){var sites=_this.props.localizationStore.sites;var hasShipping=false;sites.forEach(function(site){if(site.shipsToCountry===true){hasShipping=true;}});return hasShipping;};_this.handleSuggestionIgnore=function(){var localizationStore=_this.props.localizationStore;localizationStore.setLocalStorage();localizationStore.localizationModal.toggle();Object(__WEBPACK_IMPORTED_MODULE_14__util_dom__["a" /* allowScroll */])();};_this.redirect=function(url){_this.handleSuggestionIgnore();window.location.assign(Object(__WEBPACK_IMPORTED_MODULE_10__util_url__["k" /* transformExternalLink */])(url+SITE_CHOSEN_PARAMETER));};_this.getSites=function(){var sites=_this.props.localizationStore.sites;var currentSite=window&&window.location.origin+'/';if(sites.length===0){return null;}return sites.map(function(site){var isCurrent=Object(__WEBPACK_IMPORTED_MODULE_10__util_url__["a" /* domainMatchesUrl */])(site.domain,currentSite);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["a" /* Alert */],{key:site.domain,className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('RedirectModal__frame',{'RedirectModal__frame-suggested':site.recommendedForCountry})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["O" /* Row */],{key:site.domain},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["l" /* Col */],{key:site.domain,className:'RedirectModal__site',xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__site-name'},site.domain)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["l" /* Col */],{xs:12,sm:7},site.recommendedForCountry&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__site-suggested'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'localization.isSuggestedSite',defaultMessage:'We recommend using this online store.'})),site.shipsToCountry&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__site-shippingPossible'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'localization.shippingPossible',defaultMessage:'Shipping is possible to your country.'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["l" /* Col */],{xs:12,sm:5,className:'RedirectModal__button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__button-div'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["e" /* Button */],{color:site.recommendedForCountry?'primary':'secondary',block:true,className:'RedirectModal__button--accept',role:'link',onClick:function onClick(){return _this.redirect(Object(__WEBPACK_IMPORTED_MODULE_10__util_url__["j" /* transformDomainToUrl */])(site.domain));}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__accept-text'},isCurrent?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'localization.doNotRedirect',defaultMessage:'Stay on this online store'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'localization.moveToSite',defaultMessage:'Go to the online store'})))))));});};if(_this.siteSuggestionEnabled()){props.localizationStore.localizationModal.toggle();Object(__WEBPACK_IMPORTED_MODULE_14__util_dom__["b" /* blockScroll */])();_this.translations={en:__WEBPACK_IMPORTED_MODULE_5__i18n_static_messages_en_countries_json___default.a,fi:__WEBPACK_IMPORTED_MODULE_6__i18n_static_messages_fi_countries_json___default.a,sv:__WEBPACK_IMPORTED_MODULE_7__i18n_static_messages_sv_countries_json___default.a};}return _this;}_createClass(RedirectModal,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.siteSuggestionEnabled()){Object(__WEBPACK_IMPORTED_MODULE_14__util_dom__["a" /* allowScroll */])();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_14__util_dom__["a" /* allowScroll */])();}},{key:'render',value:function render(){var _props=this.props,localizationStore=_props.localizationStore,languageStore=_props.languageStore,translationStore=_props.translationStore;if(!this.siteSuggestionEnabled()){return null;}var modal=localizationStore.localizationModal;var sites=this.getSites();var navigatorLanguage=Object(__WEBPACK_IMPORTED_MODULE_15__util_browser__["a" /* browserLanguage */])();var overrideLocale=navigatorLanguage&&navigatorLanguage.language;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__i18n_IntlWrapper__["a" /* default */],{languageStore:languageStore,translationStore:translationStore,loadableMessages:this.translations,overrideLocale:overrideLocale},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["C" /* Modal */],{className:'RedirectModal',size:'md',isOpen:modal.isOpen,toggle:this.handleSuggestionIgnore,backdrop:'static',keyboard:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["F" /* ModalHeader */],{toggle:this.handleSuggestionIgnore},localizationStore.countryCode&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["O" /* Row */],{className:'RedirectModal__localization-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["l" /* Col */],{xs:12,className:'RedirectModal__localization-phrase'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__localization-phrase-country'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'localization.yourLocation',defaultMessage:'We detected you are in {country}',values:{country:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:localizationStore.countryCode})}})))),!localizationStore.countryCode&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'localization.noSuggestion',defaultMessage:'We do not recognize where you are. Please check out our available online stores.'})),!!sites&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_reactstrap__["D" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__body'},!this.hasShipping()&&!!localizationStore.countryCode&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__noShipping'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'localization.noShipping',defaultMessage:'Please check out our available online stores as unfortunately we do not deliver to the detected country.'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__sites'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'RedirectModal__sites-row'},sites))))));}}]);return RedirectModal;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;RedirectModal.propTypes={LocalizationStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_8__store_LocalizationStore__["a" /* default */]),languageStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_12__store_LanguageStore__["a" /* default */]),translationStore:Object(__WEBPACK_IMPORTED_MODULE_9__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_13__store_TranslationStore__["a" /* default */])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* inject */])('localizationStore','languageStore','translationStore')(RedirectModal));

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports = {"AC":"Ascension Island","AD":"Andorra","AE":"United Arab Emirates","AF":"Afghanistan","AG":"Antigua & Barbuda","AI":"Anguilla","AL":"Albania","AM":"Armenia","AN":"Netherlands Antilles","AO":"Angola","AQ":"Antarctica","AR":"Argentina","AS":"American Samoa","AT":"Austria","AU":"Australia","AW":"Aruba","AX":"Åland Islands","AZ":"Azerbaijan","BA":"Bosnia & Herzegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgium","BF":"Burkina Faso","BG":"Bulgaria","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"St. Barthélemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BQ":"Caribbean Netherlands","BR":"Brazil","BS":"Bahamas","BT":"Bhutan","BV":"Bouvet Island","BW":"Botswana","BY":"Belarus","BZ":"Belize","CA":"Canada","CC":"Cocos (Keeling) Islands","CD":"Congo - Kinshasa","CF":"Central African Republic","CG":"Congo - Brazzaville","CH":"Switzerland","CI":"Côte d’Ivoire","CK":"Cook Islands","CL":"Chile","CM":"Cameroon","CN":"China","CO":"Colombia","CP":"Clipperton Island","CR":"Costa Rica","CU":"Cuba","CV":"Cape Verde","CW":"Curaçao","CX":"Christmas Island","CY":"Cyprus","CZ":"Czech Republic","DE":"Germany","DG":"Diego Garcia","DJ":"Djibouti","DK":"Denmark","DM":"Dominica","DO":"Dominican Republic","DZ":"Algeria","EA":"Ceuta & Melilla","EC":"Ecuador","EE":"Estonia","EG":"Egypt","EH":"Western Sahara","ER":"Eritrea","ES":"Spain","ET":"Ethiopia","EU":"European Union","FI":"Finland","FJ":"Fiji","FK":"Falkland Islands","FM":"Micronesia","FO":"Faroe Islands","FR":"France","GA":"Gabon","GB":"United Kingdom","GD":"Grenada","GE":"Georgia","GF":"French Guiana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Greenland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Equatorial Guinea","GR":"Greece","GS":"South Georgia & South Sandwich Islands","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hong Kong SAR China","HM":"Heard & McDonald Islands","HN":"Honduras","HR":"Croatia","HT":"Haiti","HU":"Hungary","IC":"Canary Islands","ID":"Indonesia","IE":"Ireland","IL":"Israel","IM":"Isle of Man","IN":"India","IO":"British Indian Ocean Territory","IQ":"Iraq","IR":"Iran","IS":"Iceland","IT":"Italy","JE":"Jersey","JM":"Jamaica","JO":"Jordan","JP":"Japan","KE":"Kenya","KG":"Kyrgyzstan","KH":"Cambodia","KI":"Kiribati","KM":"Comoros","KN":"St. Kitts & Nevis","KP":"North Korea","KR":"South Korea","KW":"Kuwait","KY":"Cayman Islands","KZ":"Kazakhstan","LA":"Laos","LB":"Lebanon","LC":"St. Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Lithuania","LU":"Luxembourg","LV":"Latvia","LY":"Libya","MA":"Morocco","MC":"Monaco","MD":"Moldova","ME":"Montenegro","MF":"St. Martin","MG":"Madagascar","MH":"Marshall Islands","MK":"Macedonia","ML":"Mali","MM":"Myanmar (Burma)","MN":"Mongolia","MO":"Macau SAR China","MP":"Northern Mariana Islands","MQ":"Martinique","MR":"Mauritania","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Maldives","MW":"Malawi","MX":"Mexico","MY":"Malaysia","MZ":"Mozambique","NA":"Namibia","NC":"New Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NI":"Nicaragua","NL":"Netherlands","NO":"Norway","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"New Zealand","OM":"Oman","PA":"Panama","PE":"Peru","PF":"French Polynesia","PG":"Papua New Guinea","PH":"Philippines","PK":"Pakistan","PL":"Poland","PM":"St. Pierre & Miquelon","PN":"Pitcairn Islands","PR":"Puerto Rico","PS":"Palestinian Territories","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","QO":"Outlying Oceania","RE":"Réunion","RO":"Romania","RS":"Serbia","RU":"Russia","RW":"Rwanda","SA":"Saudi Arabia","SB":"Solomon Islands","SC":"Seychelles","SD":"Sudan","SE":"Sweden","SG":"Singapore","SH":"St. Helena","SI":"Slovenia","SJ":"Svalbard & Jan Mayen","SK":"Slovakia","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Suriname","SS":"South Sudan","ST":"São Tomé & Príncipe","SV":"El Salvador","SX":"Saint Martin","SY":"Syria","SZ":"Swaziland","TA":"Tristan da Cunha","TC":"Turks & Caicos Islands","TD":"Chad","TF":"French Southern Territories","TG":"Togo","TH":"Thailand","TJ":"Tajikistan","TK":"Tokelau","TL":"Timor-Leste","TM":"Turkmenistan","TN":"Tunisia","TO":"Tonga","TR":"Turkey","TT":"Trinidad & Tobago","TV":"Tuvalu","TW":"Taiwan","TZ":"Tanzania","UA":"Ukraine","UG":"Uganda","UM":"U.S. Outlying Islands","US":"United States","UY":"Uruguay","UZ":"Uzbekistan","VA":"Vatican City","VC":"St. Vincent & Grenadines","VE":"Venezuela","VG":"British Virgin Islands","VI":"U.S. Virgin Islands","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis & Futuna","WS":"Samoa","XK":"Kosovo","YE":"Yemen","YT":"Mayotte","ZA":"South Africa","ZM":"Zambia","ZW":"Zimbabwe"}

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports = {"AC":"Ascension-saari","AD":"Andorra","AE":"Arabiemiirikunnat","AF":"Afganistan","AG":"Antigua ja Barbuda","AI":"Anguilla","AL":"Albania","AM":"Armenia","AN":"Alankomaiden Antillit","AO":"Angola","AQ":"Antarktis","AR":"Argentiina","AS":"Amerikan Samoa","AT":"Itävalta","AU":"Australia","AW":"Aruba","AX":"Ahvenanmaa","AZ":"Azerbaidžan","BA":"Bosnia ja Hertsegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgia","BF":"Burkina Faso","BG":"Bulgaria","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Saint-Barthélemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BQ":"Karibian Alankomaat","BR":"Brasilia","BS":"Bahama","BT":"Bhutan","BV":"Bouvet’nsaari","BW":"Botswana","BY":"Valko-Venäjä","BZ":"Belize","CA":"Kanada","CC":"Kookossaaret (Keelingsaaret)","CD":"Kongon demokraattinen tasavalta","CF":"Keski-Afrikan tasavalta","CG":"Kongon tasavalta","CH":"Sveitsi","CI":"Norsunluurannikko","CK":"Cookinsaaret","CL":"Chile","CM":"Kamerun","CN":"Kiina","CO":"Kolumbia","CP":"Clippertoninsaari","CR":"Costa Rica","CU":"Kuuba","CV":"Kap Verde","CW":"Curaçao","CX":"Joulusaari","CY":"Kypros","CZ":"Tšekki","DE":"Saksa","DG":"Diego Garcia","DJ":"Djibouti","DK":"Tanska","DM":"Dominica","DO":"Dominikaaninen tasavalta","DZ":"Algeria","EA":"Ceuta ja Melilla","EC":"Ecuador","EE":"Viro","EG":"Egypti","EH":"Länsi-Sahara","ER":"Eritrea","ES":"Espanja","ET":"Etiopia","EU":"Euroopan unioni","FI":"Suomi","FJ":"Fidži","FK":"Falklandinsaaret","FM":"Mikronesian liittovaltio","FO":"Färsaaret","FR":"Ranska","GA":"Gabon","GB":"Yhdistynyt kuningaskunta","GD":"Grenada","GE":"Georgia","GF":"Ranskan Guayana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Grönlanti","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Päiväntasaajan Guinea","GR":"Kreikka","GS":"Etelä-Georgia ja Eteläiset Sandwichsaaret","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hongkong – Kiinan e.h.a.","HM":"Heard ja McDonaldinsaaret","HN":"Honduras","HR":"Kroatia","HT":"Haiti","HU":"Unkari","IC":"Kanariansaaret","ID":"Indonesia","IE":"Irlanti","IL":"Israel","IM":"Mansaari","IN":"Intia","IO":"Brittiläinen Intian valtameren alue","IQ":"Irak","IR":"Iran","IS":"Islanti","IT":"Italia","JE":"Jersey","JM":"Jamaika","JO":"Jordania","JP":"Japani","KE":"Kenia","KG":"Kirgisia","KH":"Kambodža","KI":"Kiribati","KM":"Komorit","KN":"Saint Kitts ja Nevis","KP":"Pohjois-Korea","KR":"Etelä-Korea","KW":"Kuwait","KY":"Caymansaaret","KZ":"Kazakstan","LA":"Laos","LB":"Libanon","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Liettua","LU":"Luxemburg","LV":"Latvia","LY":"Libya","MA":"Marokko","MC":"Monaco","MD":"Moldova","ME":"Montenegro","MF":"Saint-Martin","MG":"Madagaskar","MH":"Marshallinsaaret","MK":"Makedonia","ML":"Mali","MM":"Myanmar (Burma)","MN":"Mongolia","MO":"Macao – Kiinan e.h.a.","MP":"Pohjois-Mariaanit","MQ":"Martinique","MR":"Mauritania","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Malediivit","MW":"Malawi","MX":"Meksiko","MY":"Malesia","MZ":"Mosambik","NA":"Namibia","NC":"Uusi-Kaledonia","NE":"Niger","NF":"Norfolkinsaari","NG":"Nigeria","NI":"Nicaragua","NL":"Alankomaat","NO":"Norja","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Uusi-Seelanti","OM":"Oman","PA":"Panama","PE":"Peru","PF":"Ranskan Polynesia","PG":"Papua-Uusi-Guinea","PH":"Filippiinit","PK":"Pakistan","PL":"Puola","PM":"Saint-Pierre ja Miquelon","PN":"Pitcairn","PR":"Puerto Rico","PS":"Palestiinalaisalueet","PT":"Portugali","PW":"Palau","PY":"Paraguay","QA":"Qatar","QO":"ulkomeri","RE":"Réunion","RO":"Romania","RS":"Serbia","RU":"Venäjä","RW":"Ruanda","SA":"Saudi-Arabia","SB":"Salomonsaaret","SC":"Seychellit","SD":"Sudan","SE":"Ruotsi","SG":"Singapore","SH":"Saint Helena","SI":"Slovenia","SJ":"Huippuvuoret ja Jan Mayen","SK":"Slovakia","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Surinam","SS":"Etelä-Sudan","ST":"São Tomé ja Príncipe","SV":"El Salvador","SX":"Sint Maarten","SY":"Syyria","SZ":"Swazimaa","TA":"Tristan da Cunha","TC":"Turks- ja Caicossaaret","TD":"Tšad","TF":"Ranskan ulkopuoliset eteläiset alueet","TG":"Togo","TH":"Thaimaa","TJ":"Tadžikistan","TK":"Tokelau","TL":"Itä-Timor","TM":"Turkmenistan","TN":"Tunisia","TO":"Tonga","TR":"Turkki","TT":"Trinidad ja Tobago","TV":"Tuvalu","TW":"Taiwan","TZ":"Tansania","UA":"Ukraina","UG":"Uganda","UM":"Yhdysvaltain erillissaaret","US":"Yhdysvallat","UY":"Uruguay","UZ":"Uzbekistan","VA":"Vatikaani","VC":"Saint Vincent ja Grenadiinit","VE":"Venezuela","VG":"Brittiläiset Neitsytsaaret","VI":"Yhdysvaltain Neitsytsaaret","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis ja Futuna","WS":"Samoa","XK":"Kosovo","YE":"Jemen","YT":"Mayotte","ZA":"Etelä-Afrikka","ZM":"Sambia","ZW":"Zimbabwe"}

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

module.exports = {"AC":"Ascension","AD":"Andorra","AE":"Förenade Arabemiraten","AF":"Afghanistan","AG":"Antigua och Barbuda","AI":"Anguilla","AL":"Albanien","AM":"Armenien","AN":"Nederländska Antillerna","AO":"Angola","AQ":"Antarktis","AR":"Argentina","AS":"Amerikanska Samoa","AT":"Österrike","AU":"Australien","AW":"Aruba","AX":"Åland","AZ":"Azerbajdzjan","BA":"Bosnien och Hercegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgien","BF":"Burkina Faso","BG":"Bulgarien","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"S:t Barthélemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BQ":"Karibiska Nederländerna","BR":"Brasilien","BS":"Bahamas","BT":"Bhutan","BV":"Bouvetön","BW":"Botswana","BY":"Vitryssland","BZ":"Belize","CA":"Kanada","CC":"Kokosöarna","CD":"Kongo-Kinshasa","CF":"Centralafrikanska republiken","CG":"Kongo-Brazzaville","CH":"Schweiz","CI":"Elfenbenskusten","CK":"Cooköarna","CL":"Chile","CM":"Kamerun","CN":"Kina","CO":"Colombia","CP":"Clippertonön","CR":"Costa Rica","CU":"Kuba","CV":"Kap Verde","CW":"Curaçao","CX":"Julön","CY":"Cypern","CZ":"Tjeckien","DE":"Tyskland","DG":"Diego Garcia","DJ":"Djibouti","DK":"Danmark","DM":"Dominica","DO":"Dominikanska republiken","DZ":"Algeriet","EA":"Ceuta och Melilla","EC":"Ecuador","EE":"Estland","EG":"Egypten","EH":"Västsahara","ER":"Eritrea","ES":"Spanien","ET":"Etiopien","EU":"Europeiska unionen","FI":"Finland","FJ":"Fiji","FK":"Falklandsöarna","FM":"Mikronesien","FO":"Färöarna","FR":"Frankrike","GA":"Gabon","GB":"Storbritannien","GD":"Grenada","GE":"Georgien","GF":"Franska Guyana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Grönland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Ekvatorialguinea","GR":"Grekland","GS":"Sydgeorgien och Sydsandwichöarna","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hongkong (S.A.R. Kina)","HM":"Heardön och McDonaldöarna","HN":"Honduras","HR":"Kroatien","HT":"Haiti","HU":"Ungern","IC":"Kanarieöarna","ID":"Indonesien","IE":"Irland","IL":"Israel","IM":"Isle of Man","IN":"Indien","IO":"Brittiska territoriet i Indiska oceanen","IQ":"Irak","IR":"Iran","IS":"Island","IT":"Italien","JE":"Jersey","JM":"Jamaica","JO":"Jordanien","JP":"Japan","KE":"Kenya","KG":"Kirgizistan","KH":"Kambodja","KI":"Kiribati","KM":"Komorerna","KN":"S:t Kitts och Nevis","KP":"Nordkorea","KR":"Sydkorea","KW":"Kuwait","KY":"Caymanöarna","KZ":"Kazakstan","LA":"Laos","LB":"Libanon","LC":"S:t Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Litauen","LU":"Luxemburg","LV":"Lettland","LY":"Libyen","MA":"Marocko","MC":"Monaco","MD":"Moldavien","ME":"Montenegro","MF":"S:t Martin","MG":"Madagaskar","MH":"Marshallöarna","MK":"Makedonien","ML":"Mali","MM":"Myanmar (Burma)","MN":"Mongoliet","MO":"Macao (S.A.R. Kina)","MP":"Nordmarianerna","MQ":"Martinique","MR":"Mauretanien","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Maldiverna","MW":"Malawi","MX":"Mexiko","MY":"Malaysia","MZ":"Moçambique","NA":"Namibia","NC":"Nya Kaledonien","NE":"Niger","NF":"Norfolkön","NG":"Nigeria","NI":"Nicaragua","NL":"Nederländerna","NO":"Norge","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Nya Zeeland","OM":"Oman","PA":"Panama","PE":"Peru","PF":"Franska Polynesien","PG":"Papua Nya Guinea","PH":"Filippinerna","PK":"Pakistan","PL":"Polen","PM":"S:t Pierre och Miquelon","PN":"Pitcairnöarna","PR":"Puerto Rico","PS":"Palestinska territorierna","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","QO":"yttre öar i Oceanien","RE":"Réunion","RO":"Rumänien","RS":"Serbien","RU":"Ryssland","RW":"Rwanda","SA":"Saudiarabien","SB":"Salomonöarna","SC":"Seychellerna","SD":"Sudan","SE":"Sverige","SG":"Singapore","SH":"S:t Helena","SI":"Slovenien","SJ":"Svalbard och Jan Mayen","SK":"Slovakien","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Surinam","SS":"Sydsudan","ST":"São Tomé och Príncipe","SV":"El Salvador","SX":"Sint Maarten","SY":"Syrien","SZ":"Swaziland","TA":"Tristan da Cunha","TC":"Turks- och Caicosöarna","TD":"Tchad","TF":"Franska sydterritorierna","TG":"Togo","TH":"Thailand","TJ":"Tadzjikistan","TK":"Tokelau","TL":"Östtimor","TM":"Turkmenistan","TN":"Tunisien","TO":"Tonga","TR":"Turkiet","TT":"Trinidad och Tobago","TV":"Tuvalu","TW":"Taiwan","TZ":"Tanzania","UA":"Ukraina","UG":"Uganda","UM":"USA:s yttre öar","US":"USA","UY":"Uruguay","UZ":"Uzbekistan","VA":"Vatikanstaten","VC":"S:t Vincent och Grenadinerna","VE":"Venezuela","VG":"Brittiska Jungfruöarna","VI":"Amerikanska Jungfruöarna","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis- och Futunaöarna","WS":"Samoa","XK":"Kosovo","YE":"Jemen","YT":"Mayotte","ZA":"Sydafrika","ZM":"Zambia","ZW":"Zimbabwe"}

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PostAffiliateWidget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// This identifier is always the same and should not be changed.
var POST_AFFILIATE_IDENTIFIER='pap_x2s6df8d';var PostAffiliateWidget=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(PostAffiliateWidget,_Component);function PostAffiliateWidget(props){_classCallCheck(this,PostAffiliateWidget);var _this=_possibleConstructorReturn(this,(PostAffiliateWidget.__proto__||Object.getPrototypeOf(PostAffiliateWidget)).call(this,props));_this.createScript=function(){if(_this.state.loaded){return null;}var url=_this.props.configStore.integrations.postAffiliate.url;var script=document.createElement('script');script.src='https://'+url+'.postaffiliatepro.com/scripts/trackjs.js';script.id=POST_AFFILIATE_IDENTIFIER;script.type='text/javascript';script.async=true;script.onload=function(){return _this.loadPostAffiliate();};script.onerror=function(err){console.error(err);};document.body.appendChild(script);};_this.loadPostAffiliate=function(){if(!window.PostAffTracker||_this.state.loaded){return null;}var accountId=_this.props.configStore.integrations.postAffiliate.accountId;window.PostAffTracker.setAccountId(accountId);try{window.PostAffTracker.track();}catch(err){console.error(err);}_this.setState(function(){return{loaded:true};});};_this.state={loaded:false};return _this;}_createClass(PostAffiliateWidget,[{key:'componentDidMount',value:function componentDidMount(){this.createScript();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript',null,'You need to enable javascript');}}]);return PostAffiliateWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;PostAffiliateWidget.propTypes={configStore:Object(__WEBPACK_IMPORTED_MODULE_2__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_3__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('configStore')(PostAffiliateWidget));

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoginPageContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_AccountStore__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountModal__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__head_SEOHomePage__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_PageTitle__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginPageContent=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(LoginPageContent,_Component);function LoginPageContent(){_classCallCheck(this,LoginPageContent);return _possibleConstructorReturn(this,(LoginPageContent.__proto__||Object.getPrototypeOf(LoginPageContent)).apply(this,arguments));}_createClass(LoginPageContent,[{key:'render',value:function render(){var _props=this.props,configStore=_props.configStore,intl=_props.intl;var title=configStore.configurationTexts.CONF_SEO_TITLE||intl.formatMessage(__WEBPACK_IMPORTED_MODULE_8__i18n_globalTranslations__["a" /* default */].homeTitle);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LoginPageContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__head_SEOHomePage__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_PageTitle__["a" /* default */],{itemProp:title},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AccountModal__["a" /* default */],{key:'LoginPageContent',useAsModal:false}));}}]);return LoginPageContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;LoginPageContent.propTypes={accountStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_4__store_AccountStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_3__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_ConfigStore__["a" /* default */]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('accountStore','configStore')(LoginPageContent)));

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CartErrorModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_CartStore__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_InfoPageStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_RequestState__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_ContentForState__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Icon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartErrorModal=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["d" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(CartErrorModal,_Component);function CartErrorModal(props){_classCallCheck(this,CartErrorModal);var _this=_possibleConstructorReturn(this,(CartErrorModal.__proto__||Object.getPrototypeOf(CartErrorModal)).call(this,props));_initialiseProps.call(_this);var cartStore=props.cartStore,configStore=props.configStore;if(cartStore.cartErrorModal.isOpen&&configStore.infoPages.cartErroModal){_this.maybeLoadCartErrorInfoPage();}return _this;}_createClass(CartErrorModal,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__util_dom__["b" /* blockScroll */])();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,cartStore=_props.cartStore,configStore=_props.configStore,infoPageStore=_props.infoPageStore;var infoPageId=configStore.infoPages.cartErroModal;if(cartStore.cartErrorModal.isOpen&&infoPageId&&infoPageStore.pageStates.get(infoPageId)!==__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING&&infoPageStore.pageStates.get(infoPageId)!==__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED&&infoPageStore.pageStates.get(infoPageId)!==__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR){this.maybeLoadCartErrorInfoPage();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_8__util_dom__["a" /* allowScroll */])();}},{key:'render',value:function render(){var _props2=this.props,errorTitle=_props2.errorTitle,cartStore=_props2.cartStore,intl=_props2.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["C" /* Modal */],{className:'CartErrorModal',isOpen:cartStore.cartErrorModal.isOpen,toggle:cartStore.cartErrorModal.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["F" /* ModalHeader */],{className:'CartErrorModal__header',toggle:cartStore.cartErrorModal.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartErrorModal__header-error-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartErrorModal__header-error-sign'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Icon__["a" /* default */],{name:'close'})),errorTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["D" /* ModalBody */],{className:'CartErrorModal__body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__loader_ContentForState__["a" /* default */],{state:this.getContentState(),forLoaded:this.getContent})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["E" /* ModalFooter */],{className:'CartErrorModal__footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Button */],{className:'CartErrorModal__close-button','aria-label':intl.formatMessage(__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].closeTitle),color:'secondary',onClick:cartStore.cartErrorModal.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__i18n_globalTranslations__["a" /* default */].closeTitle))));}}]);return CartErrorModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.maybeLoadCartErrorInfoPage=function(){var _props3=_this2.props,cartStore=_props3.cartStore,configStore=_props3.configStore,infoPageStore=_props3.infoPageStore;var infoPageId=configStore.infoPages.cartErroModal;if(cartStore.cartErrorModal.isOpen&&infoPageId&&infoPageStore.pageStates.get(infoPageId)!==__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED&&infoPageStore.pageStates.get(infoPageId)!==__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].ERROR){infoPageStore.loadPage(infoPageId).catch(function(e){if(e.responce&&e.responce.status!==404){console.error(e);}});}};this.getContentState=function(){var _props4=_this2.props,infoPageStore=_props4.infoPageStore,configStore=_props4.configStore;var infoPageId=configStore.infoPages.cartErroModal;if(!infoPageId){return __WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED;}if(infoPageStore.pageStates.get(infoPageId)!==__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADING){return __WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED;}return infoPageStore.pageStates.get(infoPageId);};this.getContent=function(){var infoPage=_this2.getInfoPage();return infoPage&&infoPage.content?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartErrorModal__body-content',dangerouslySetInnerHTML:{__html:infoPage.content}}):_this2.getDefaultContent();};this.getInfoPage=function(){var _props5=_this2.props,configStore=_props5.configStore,infoPageStore=_props5.infoPageStore;var infoPageId=configStore.infoPages.cartErroModal;return infoPageId&&infoPageStore.pageStates.get(infoPageId)===__WEBPACK_IMPORTED_MODULE_10__types_RequestState__["b" /* default */].LOADED?infoPageStore.pages.get(infoPageId):null;};this.getDefaultContent=function(){var errorContent=_this2.props.errorContent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CartErrorModal__body-content'},errorContent);};},_temp))||_class;CartErrorModal.propTypes={cartStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_7__store_CartStore__["a" /* default */]).isRequired,configStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_ConfigStore__["a" /* default */]).isRequired,infoPageStore:Object(__WEBPACK_IMPORTED_MODULE_5__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_9__store_InfoPageStore__["a" /* default */]).isRequired,intl:__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* intlShape */].isRequired,errorTitle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,errorContent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired};CartErrorModal.defaultProps={errorTitle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'errorModal.title',defaultMessage:'Unexpected error has occurred'}),errorContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:'errorModal.content',defaultMessage:'Something went wrong. Please check the provided information and try again.'})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* inject */])('cartStore','infoPageStore','configStore')(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["e" /* injectIntl */])(CartErrorModal)));

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogoutParamRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryParamRedirect__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_CommonQueryParams__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LogoutParamRedirect=function(_Component){_inherits(LogoutParamRedirect,_Component);function LogoutParamRedirect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LogoutParamRedirect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LogoutParamRedirect.__proto__||Object.getPrototypeOf(LogoutParamRedirect)).call.apply(_ref,[this].concat(args))),_this),_this.getPathForRedirect=function(){var location=_this.props.location;var type=__WEBPACK_IMPORTED_MODULE_4__types_CommonQueryParams__["a" /* default */].LOGOUT;var params=Object(__WEBPACK_IMPORTED_MODULE_5__util_queryString__["b" /* parse */])(location.search);delete params[type];params=Object(__WEBPACK_IMPORTED_MODULE_5__util_queryString__["c" /* stringify */])(params);if(params.length>0){params='?'+params;}return location.pathname+params+location.hash;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LogoutParamRedirect,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__QueryParamRedirect__["a" /* default */],{paramName:__WEBPACK_IMPORTED_MODULE_4__types_CommonQueryParams__["a" /* default */].LOGOUT,to:this.getPathForRedirect});}}]);return LogoutParamRedirect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LogoutParamRedirect.propTypes={location:__WEBPACK_IMPORTED_MODULE_2_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* withRouter */])(LogoutParamRedirect));

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommonQueryParamsType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(5);
var CommonQueryParams={LOGOUT:'processLogout'};/* harmony default export */ __webpack_exports__["a"] = (CommonQueryParams);var CommonQueryParamsType=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["l" /* types */].enumeration('CommonQueryParams',Object.values(CommonQueryParams));

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UniversalJavascriptTool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ScriptStore__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_UIStore__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_queryString__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PAGE_LOCATIONS={HEAD:'HEAD',BODY_START:'BODY_START',BODY_END:'BODY_END'};var SCRIPT_STATUSES={ACTIVE:'ACTIVE',TEST_MODE:'TEST_MODE'};var UniversalJavascriptTool=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["d" /* observer */])(_class=function(_Component){_inherits(UniversalJavascriptTool,_Component);function UniversalJavascriptTool(props){_classCallCheck(this,UniversalJavascriptTool);var _this=_possibleConstructorReturn(this,(UniversalJavascriptTool.__proto__||Object.getPrototypeOf(UniversalJavascriptTool)).call(this,props));_this.getHeadScripts=function(){var scripts=_this.getScripts(PAGE_LOCATIONS.HEAD);var headScripts=document.head.getElementsByTagName('meta');scripts.forEach(function(script){var parsedScripts=_this.getParsedScripts({script:script});var element=document.getElementById(script.id);if(parsedScripts.length>0){parsedScripts.forEach(function(parsedScript){var scriptNode=_this.createScript(parsedScript);if(element){element.remove();}document.head.insertBefore(scriptNode,headScripts[0]);});}});};_this.getBodyStartScripts=function(){var scripts=_this.getScripts(PAGE_LOCATIONS.BODY_START);var root=document.getElementById('root');scripts.forEach(function(script){var parsedScripts=_this.getParsedScripts({script:script});var element=document.getElementById(script.id);if(parsedScripts.length>0){parsedScripts.forEach(function(parsedScript){var scriptNode=_this.createScript(parsedScript);if(element){element.remove();}document.body.insertBefore(scriptNode,root);});}});};_this.getBodyEndScripts=function(){var scripts=_this.getScripts(PAGE_LOCATIONS.BODY_END);scripts.forEach(function(script){var parsedScripts=_this.getParsedScripts({script:script});var element=document.getElementById(script.id);if(parsedScripts.length>0){parsedScripts.forEach(function(parsedScript){var scriptNode=_this.createScript(parsedScript);if(element){element.remove();}document.body.appendChild(scriptNode);});}});};_this.getScripts=function(pageLocation){var _this$props=_this.props,scriptStore=_this$props.scriptStore,uiStore=_this$props.uiStore,location=_this$props.location;var queryParams=Object(__WEBPACK_IMPORTED_MODULE_7__util_queryString__["b" /* parse */])(location.search);var status='';if(Number(queryParams.allowTestModeScripts)){status=SCRIPT_STATUSES.TEST_MODE;}else{status=SCRIPT_STATUSES.ACTIVE;}return scriptStore.getScripts({pageType:uiStore.currentPage,location:pageLocation,status:status});};_this.getParsedScripts=function(_ref){var script=_ref.script;var doc=document.implementation.createHTMLDocument('');doc.body.innerHTML=script.code;return[].map.call(doc.getElementsByTagName('script'),function(el){var attributes=_this.getElementAttributes({element:el,script:script});attributes.textContent=el.textContent;return attributes;});};_this.getElementAttributes=function(_ref2){var element=_ref2.element,script=_ref2.script;var attributes={key:_this.key++};Array.from(element.attributes).forEach(function(attr){attributes[attr.name]=attr.value;});attributes.id=script.id;attributes.async=true;return attributes;};_this.createScript=function(parsedScript){var scriptNode=document.createElement('script');scriptNode.id=parsedScript.id;scriptNode.async=true;if(parsedScript.src){scriptNode.src=parsedScript.src;}scriptNode.textContent=parsedScript.textContent;scriptNode.onerror=function(err){return console.log(err);};return scriptNode;};_this.key=0;return _this;}_createClass(UniversalJavascriptTool,[{key:'componentDidMount',value:function componentDidMount(){this.getHeadScripts();this.getBodyStartScripts();this.getBodyEndScripts();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.location.pathname!==this.props.location.pathname){this.getHeadScripts();this.getBodyStartScripts();this.getBodyEndScripts();}}},{key:'render',value:function render(){// Bail if we are in SSR.
if(typeof document==='undefined'){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('noscript',null,'You need to enable JavaScript');}}]);return UniversalJavascriptTool;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class;UniversalJavascriptTool.propTypes={scriptStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_5__store_ScriptStore__["a" /* default */]).isRequired,uiStore:Object(__WEBPACK_IMPORTED_MODULE_4__prop_types__["a" /* modelOf */])(__WEBPACK_IMPORTED_MODULE_6__store_UIStore__["a" /* default */]).isRequired,location:__WEBPACK_IMPORTED_MODULE_3_react_router_prop_types___default.a.location.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* inject */])('scriptStore','uiStore')(UniversalJavascriptTool)));

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MaintenanceHandler=function(_Component){_inherits(MaintenanceHandler,_Component);function MaintenanceHandler(){_classCallCheck(this,MaintenanceHandler);return _possibleConstructorReturn(this,(MaintenanceHandler.__proto__||Object.getPrototypeOf(MaintenanceHandler)).apply(this,arguments));}_createClass(MaintenanceHandler,[{key:'render',value:function render(){var _props=this.props,active=_props.active,message=_props.message,children=_props.children;return active?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MaintenanceHandler'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MaintenanceHandler__message',dangerouslySetInnerHTML:{__html:message}})):children;}}]);return MaintenanceHandler;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MaintenanceHandler.propTypes={message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (MaintenanceHandler);

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Raven=window.Raven;var SentryErrorBoundary=function(_Component){_inherits(SentryErrorBoundary,_Component);function SentryErrorBoundary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SentryErrorBoundary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SentryErrorBoundary.__proto__||Object.getPrototypeOf(SentryErrorBoundary)).call.apply(_ref,[this].concat(args))),_this),_this.state={error:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SentryErrorBoundary,[{key:'componentDidCatch',value:function componentDidCatch(error,errorInfo){this.setState({error:error});if(Raven){Raven.captureException(error,{extra:{site:window&&window.location?window.location.hostname:'',errorInfo:errorInfo}});}}},{key:'render',value:function render(){if(this.state.error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SentryErrorBoundary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:""+'/img/maintenance.png',alt:'Error'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'SentryErrorBoundary__reload',value:'P\xE4ivit\xE4 / Refresh / Uppdatera',onClick:function onClick(){window.location.reload();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Pahoittelut \u2014 jotakin meni pieleen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'P\xE4ivit\xE4 sivu uudelleen. Jos ongelma jatkuu j\xE4t\xE4 virhekuvaus.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'We\'re sorry \u2014 something\'s gone wrong'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please refresh the page. If the problem continues please try again later.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Vi beklagar att n\xE5got gick fel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Uppdatera sidan. Om problemet kvarst\xE5r, f\xF6rs\xF6k igen senare.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'SentryErrorBoundary__secondary',value:'Kuvaus / Description / Beskrivning',onClick:function onClick(){Raven.lastEventId()&&Raven.showReportDialog();}}))));}else{//when there's not an error, render children untouched
return this.props.children;}}}]);return SentryErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SentryErrorBoundary);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.9f83ac01.js